"use strict";
var DracoDecoderModule = (() => {
    var _scriptDir = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : undefined;
    if (typeof __filename !== 'undefined')
        _scriptDir = _scriptDir || __filename;
    return (function (DracoDecoderModule) {
        DracoDecoderModule = DracoDecoderModule || {};
        var Module = typeof DracoDecoderModule !== "undefined" ? DracoDecoderModule : {};
        var objAssign = Object.assign;
        var readyPromiseResolve, readyPromiseReject;
        Module["ready"] = new Promise(function (resolve, reject) { readyPromiseResolve = resolve; readyPromiseReject = reject; });
        var isRuntimeInitialized = false;
        var isModuleParsed = false;
        Module["onRuntimeInitialized"] = function () { isRuntimeInitialized = true; if (isModuleParsed) {
            if (typeof Module["onModuleLoaded"] === "function") {
                Module["onModuleLoaded"](Module);
            }
        } };
        Module["onModuleParsed"] = function () { isModuleParsed = true; if (isRuntimeInitialized) {
            if (typeof Module["onModuleLoaded"] === "function") {
                Module["onModuleLoaded"](Module);
            }
        } };
        function isVersionSupported(versionString) { if (typeof versionString !== "string")
            return false; const version = versionString.split("."); if (version.length < 2 || version.length > 3)
            return false; if (version[0] == 1 && version[1] >= 0 && version[1] <= 5)
            return true; if (version[0] != 0 || version[1] > 10)
            return false; return true; }
        Module["isVersionSupported"] = isVersionSupported;
        var moduleOverrides = objAssign({}, Module);
        var arguments_ = [];
        var thisProgram = "./this.program";
        var quit_ = (status, toThrow) => { throw toThrow; };
        var ENVIRONMENT_IS_WEB = typeof window === "object";
        var ENVIRONMENT_IS_WORKER = typeof importScripts === "function";
        var ENVIRONMENT_IS_NODE = typeof process === "object" && typeof process.versions === "object" && typeof process.versions.node === "string";
        var scriptDirectory = "";
        function locateFile(path) { if (Module["locateFile"]) {
            return Module["locateFile"](path, scriptDirectory);
        } return scriptDirectory + path; }
        var read_, readAsync, readBinary, setWindowTitle;
        function logExceptionOnExit(e) { if (e instanceof ExitStatus)
            return; let toLog = e; err("exiting due to exception: " + toLog); }
        var fs;
        var nodePath;
        var requireNodeFS;
        if (ENVIRONMENT_IS_NODE) {
            if (ENVIRONMENT_IS_WORKER) {
                scriptDirectory = require("path").dirname(scriptDirectory) + "/";
            }
            else {
                scriptDirectory = __dirname + "/";
            }
            requireNodeFS = (() => { if (!nodePath) {
                fs = require("fs");
                nodePath = require("path");
            } });
            read_ = function shell_read(filename, binary) { var ret = tryParseAsDataURI(filename); if (ret) {
                return binary ? ret : ret.toString();
            } requireNodeFS(); filename = nodePath["normalize"](filename); return fs.readFileSync(filename, binary ? null : "utf8"); };
            readBinary = (filename => { var ret = read_(filename, true); if (!ret.buffer) {
                ret = new Uint8Array(ret);
            } return ret; });
            readAsync = ((filename, onload, onerror) => { var ret = tryParseAsDataURI(filename); if (ret) {
                onload(ret);
            } requireNodeFS(); filename = nodePath["normalize"](filename); fs.readFile(filename, function (err, data) { if (err)
                onerror(err);
            else
                onload(data.buffer); }); });
            if (process["argv"].length > 1) {
                thisProgram = process["argv"][1].replace(/\\/g, "/");
            }
            arguments_ = process["argv"].slice(2);
            quit_ = ((status, toThrow) => { if (keepRuntimeAlive()) {
                process["exitCode"] = status;
                throw toThrow;
            } logExceptionOnExit(toThrow); process["exit"](status); });
            Module["inspect"] = function () { return "[Emscripten Module object]"; };
        }
        else if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
            if (ENVIRONMENT_IS_WORKER) {
                scriptDirectory = self.location.href;
            }
            else if (typeof document !== "undefined" && document.currentScript) {
                scriptDirectory = document.currentScript.src;
            }
            if (_scriptDir) {
                scriptDirectory = _scriptDir;
            }
            if (scriptDirectory.indexOf("blob:") !== 0) {
                scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
            }
            else {
                scriptDirectory = "";
            }
            {
                read_ = (url => { try {
                    var xhr = new XMLHttpRequest;
                    xhr.open("GET", url, false);
                    xhr.send(null);
                    return xhr.responseText;
                }
                catch (err) {
                    var data = tryParseAsDataURI(url);
                    if (data) {
                        return intArrayToString(data);
                    }
                    throw err;
                } });
                if (ENVIRONMENT_IS_WORKER) {
                    readBinary = (url => { try {
                        var xhr = new XMLHttpRequest;
                        xhr.open("GET", url, false);
                        xhr.responseType = "arraybuffer";
                        xhr.send(null);
                        return new Uint8Array(xhr.response);
                    }
                    catch (err) {
                        var data = tryParseAsDataURI(url);
                        if (data) {
                            return data;
                        }
                        throw err;
                    } });
                }
                readAsync = ((url, onload, onerror) => { var xhr = new XMLHttpRequest; xhr.open("GET", url, true); xhr.responseType = "arraybuffer"; xhr.onload = (() => { if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                    onload(xhr.response);
                    return;
                } var data = tryParseAsDataURI(url); if (data) {
                    onload(data.buffer);
                    return;
                } onerror(); }); xhr.onerror = onerror; xhr.send(null); });
            }
            setWindowTitle = (title => document.title = title);
        }
        else { }
        var out = Module["print"] || console.log.bind(console);
        var err = Module["printErr"] || console.warn.bind(console);
        objAssign(Module, moduleOverrides);
        moduleOverrides = null;
        if (Module["arguments"])
            arguments_ = Module["arguments"];
        if (Module["thisProgram"])
            thisProgram = Module["thisProgram"];
        if (Module["quit"])
            quit_ = Module["quit"];
        var wasmBinary;
        if (Module["wasmBinary"])
            wasmBinary = Module["wasmBinary"];
        var noExitRuntime = Module["noExitRuntime"] || true;
        var WebAssembly = { Memory: function (opts) { this.buffer = new ArrayBuffer(opts["initial"] * 65536); }, Module: function (binary) { }, Instance: function (module, info) {
                this.exports = (
                // EMSCRIPTEN_START_ASM
                function instantiate(qa) {
                    function c(d) { d.set = function (a, b) { this[a] = b; }; d.get = function (a) { return this[a]; }; return d; }
                    var e;
                    var f = new Uint8Array(123);
                    for (var a = 25; a >= 0; --a) {
                        f[48 + a] = 52 + a;
                        f[65 + a] = a;
                        f[97 + a] = 26 + a;
                    }
                    f[43] = 62;
                    f[47] = 63;
                    function l(m, n, o) { var g, h, a = 0, i = n, j = o.length, k = n + (j * 3 >> 2) - (o[j - 2] == "=") - (o[j - 1] == "="); for (; a < j; a += 4) {
                        g = f[o.charCodeAt(a + 1)];
                        h = f[o.charCodeAt(a + 2)];
                        m[i++] = f[o.charCodeAt(a)] << 2 | g >> 4;
                        if (i < k)
                            m[i++] = g << 4 | h >> 2;
                        if (i < k)
                            m[i++] = h << 6 | f[o.charCodeAt(a + 3)];
                    } }
                    function p(q) { l(e, 1028, "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"); l(e, 12180, "AQAAAAMAAAAFAAAABwAAAAAAAABoMAAASAEAAEkBAABKAQAASwEAAE41ZHJhY28yMk1lc2hUcmF2ZXJzYWxTZXF1ZW5jZXJJTlNfMjhNYXhQcmVkaWN0aW9uRGVncmVlVHJhdmVyc2VySU5TXzExQ29ybmVyVGFibGVFTlNfMzZNZXNoQXR0cmlidXRlSW5kaWNlc0VuY29kaW5nT2JzZXJ2ZXJJUzJfRUVFRUVFAE41ZHJhY28xNVBvaW50c1NlcXVlbmNlckUAAAAAsDoAAEMwAADYOgAAvC8AAGAwAAD/////AAAAAFgxAABMAQAATQEAAE4BAABONWRyYWNvMjhNYXhQcmVkaWN0aW9uRGVncmVlVHJhdmVyc2VySU5TXzExQ29ybmVyVGFibGVFTlNfMzZNZXNoQXR0cmlidXRlSW5kaWNlc0VuY29kaW5nT2JzZXJ2ZXJJUzFfRUVFRQBONWRyYWNvMTNUcmF2ZXJzZXJCYXNlSU5TXzExQ29ybmVyVGFibGVFTlNfMzZNZXNoQXR0cmlidXRlSW5kaWNlc0VuY29kaW5nT2JzZXJ2ZXJJUzFfRUVFRQAAsDoAAPUwAADYOgAAjDAAAFAxAAAAAAAAUDEAAE8BAABQAQAATgEAAAAAAAAQMgAAUQEAAFIBAABTAQAAVAEAAE41ZHJhY28yMk1lc2hUcmF2ZXJzYWxTZXF1ZW5jZXJJTlNfMTlEZXB0aEZpcnN0VHJhdmVyc2VySU5TXzExQ29ybmVyVGFibGVFTlNfMzZNZXNoQXR0cmlidXRlSW5kaWNlc0VuY29kaW5nT2JzZXJ2ZXJJUzJfRUVFRUVFAAAA2DoAAJAxAABgMAAAAAAAAJAyAABVAQAAVgEAAE4BAABONWRyYWNvMTlEZXB0aEZpcnN0VHJhdmVyc2VySU5TXzExQ29ybmVyVGFibGVFTlNfMzZNZXNoQXR0cmlidXRlSW5kaWNlc0VuY29kaW5nT2JzZXJ2ZXJJUzFfRUVFRQDYOgAAMDIAAFAxAAAAAAAAQDMAAFcBAABYAQAAWQEAAFoBAABONWRyYWNvMjJNZXNoVHJhdmVyc2FsU2VxdWVuY2VySU5TXzE5RGVwdGhGaXJzdFRyYXZlcnNlcklOU18yNE1lc2hBdHRyaWJ1dGVDb3JuZXJUYWJsZUVOU18zNk1lc2hBdHRyaWJ1dGVJbmRpY2VzRW5jb2RpbmdPYnNlcnZlcklTMl9FRUVFRUUAANg6AAC0MgAAYDA="); l(e, 13140, "rDMAABEBAABbAQAAEwEAABQBAABcAQAAFQEAABYBAAAXAQAAGAEAABkBAAAaAQAAGwEAAF0BAABONWRyYWNvMjFNZXNoU2VxdWVudGlhbERlY29kZXJFANg6AACMMwAAFCwAAAAAAADsMwAAXgEAAF8BAABgAQAAYQEAAE41ZHJhY28xNUxpbmVhclNlcXVlbmNlckUAAADYOgAA0DMAAGAwAAAAAAAAbDQAABEBAABiAQAAYwEAABQBAAAiAAAAZAEAABYBAAAXAQAAGAE="); l(e, 13360, "RmFpbGVkIHRvIHBhcnNlIERyYWNvIGhlYWRlci4ATjVkcmFjbzE3UG9pbnRDbG91ZERlY29kZXJFAAAAsDoAAE40AAAAAAAAxDQAABEBAABlAQAAYwEAABQBAABmAQAAZwEAABYBAAAXAQAAGAEAAE41ZHJhY28yM1BvaW50Q2xvdWRLZFRyZWVEZWNvZGVyRQAAANg6AACgNAAAbDQAAAAAAAAkNQAAEQEAAGgBAABjAQAAFAEAAGkBAABqAQAAFgEAABcBAAAYAQAATjVkcmFjbzI3UG9pbnRDbG91ZFNlcXVlbnRpYWxEZWNvZGVyRQAAANg6AAD8NAAAbDQAAAEAAAABAAAAAgAAAAIAAAAEAAAABAAAAAgAAAAIAAAABAAAAAgAAAAB"); l(e, 13667, "wAAAAMAAAADAAAAAwP//////////AAAAAKA1AABrAQAAbAEAAG0BAABuAQAATjVkcmFjbzRNZXNoRQAAANg6AACQNQAA5DUAAP////8AAAAAAAAAAOQ1AABvAQAAcAEAAHEBAAByAQAATjVkcmFjbzEwUG9pbnRDbG91ZEUAAAAAsDoAAMw1AADYOwAAGQAKABkZGQAAAAAFAAAAAAAACQAAAAALAAAAAAAAAAAZABEKGRkZAwoHAAEACQsYAAAJBgsAAAsABhkAAAAZGRk="); l(e, 13889, "DgAAAAAAAAAAGQAKDRkZGQANAAACAAkOAAAACQAOAAAO"); l(e, 13947, "DA=="); l(e, 13959, "EwAAAAATAAAAAAkMAAAAAAAMAAAM"); l(e, 14005, "EA=="); l(e, 14017, "DwAAAAQPAAAAAAkQAAAAAAAQAAAQ"); l(e, 14063, "Eg=="); l(e, 14075, "EQAAAAARAAAAAAkSAAAAAAASAAASAAAaAAAAGhoa"); l(e, 14130, "GgAAABoaGgAAAAAAAAk="); l(e, 14179, "FA=="); l(e, 14191, "FwAAAAAXAAAAAAkUAAAAAAAUAAAU"); l(e, 14237, "Fg=="); l(e, 14249, "FQAAAAAVAAAAAAkWAAAAAAAWAAAWAAAwMTIzNDU2Nzg5QUJDREVGAAAAAAIAAAADAAAABQAAAAcAAAALAAAADQAAABEAAAATAAAAFwAAAB0AAAAfAAAAJQAAACkAAAArAAAALwAAADUAAAA7AAAAPQAAAEMAAABHAAAASQAAAE8AAABTAAAAWQAAAGEAAABlAAAAZwAAAGsAAABtAAAAcQAAAH8AAACDAAAAiQAAAIsAAACVAAAAlwAAAJ0AAACjAAAApwAAAK0AAACzAAAAtQAAAL8AAADBAAAAxQAAAMcAAADTAAAAAQAAAAsAAAANAAAAEQAAABMAAAAXAAAAHQAAAB8AAAAlAAAAKQAAACsAAAAvAAAANQAAADsAAAA9AAAAQwAAAEcAAABJAAAATwAAAFMAAABZAAAAYQAAAGUAAABnAAAAawAAAG0AAABxAAAAeQAAAH8AAACDAAAAiQAAAIsAAACPAAAAlQAAAJcAAACdAAAAowAAAKcAAACpAAAArQAAALMAAAC1AAAAuwAAAL8AAADBAAAAxQAAAMcAAADRAAAAMDAwMTAyMDMwNDA1MDYwNzA4MDkxMDExMTIxMzE0MTUxNjE3MTgxOTIwMjEyMjIzMjQyNTI2MjcyODI5MzAzMTMyMzMzNDM1MzYzNzM4Mzk0MDQxNDI0MzQ0NDU0NjQ3NDg0OTUwNTE1MjUzNTQ1NTU2NTc1ODU5NjA2MTYyNjM2NDY1NjY2NzY4Njk3MDcxNzI3Mzc0NzU3Njc3Nzg3OTgwODE4MjgzODQ4NTg2ODc4ODg5OTA5MTkyOTM5NDk1OTY5Nzk4OTk="); l(e, 14884, "CgAAAGQAAADoAwAAECcAAKCGAQBAQg8AgJaYAADh9QUAypo7TjEwX19jeHhhYml2MTE2X19zaGltX3R5cGVfaW5mb0UAAAAA2DoAAEg6AADMOwAATjEwX19jeHhhYml2MTE3X19jbGFzc190eXBlX2luZm9FAAAA2DoAAHg6AABsOgAAAAAAAJw6AAB4AQAAeQEAAHoBAAB7AQAAfAEAAH0BAAB+AQAAfwEAAAAAAAAgOwAAeAEAAIABAAB6AQAAewEAAHwBAACBAQAAggEAAIMBAABOMTBfX2N4eGFiaXYxMjBfX3NpX2NsYXNzX3R5cGVfaW5mb0UAAAAA2DoAAPg6AACcOgAAAAAAAFA7AACEAQAAhQEAAIYBAABTdDlleGNlcHRpb24AAAAAsDoAAEA7AAAAAAAAfDsAAA0AAACHAQAAiAEAAFN0MTFsb2dpY19lcnJvcgDYOgAAbDsAAFA7AAAAAAAAsDsAAA0AAACJAQAAiAEAAFN0MTJsZW5ndGhfZXJyb3IAAAAA2DoAAJw7AAB8OwAAU3Q5dHlwZV9pbmZvAAAAALA6AAC8Ow=="); l(e, 15320, "BQ=="); l(e, 15332, "cwE="); l(e, 15356, "dAEAAHUBAABoPQ=="); l(e, 15380, "Ag=="); l(e, 15396, "//////////8="); l(e, 15464, "BQ=="); l(e, 15476, "dgE="); l(e, 15500, "dAEAAHcBAAB4PQAAAAQ="); l(e, 15524, "AQ=="); l(e, 15540, "/////wo="); l(e, 15608, "IERQ"); }
                    var r = new ArrayBuffer(16);
                    var s = new Int32Array(r);
                    var t = new Float32Array(r);
                    var u = new Float64Array(r);
                    function v(w) { t[2] = w; }
                    function x(y) { return s[y]; }
                    function z(y, w) { s[y] = w; }
                    function A() { return t[2]; }
                    function oa(pa) {
                        var B = pa.a;
                        var C = B.buffer;
                        B.grow = ma;
                        var D = new Int8Array(C);
                        var E = new Int16Array(C);
                        var F = new Int32Array(C);
                        var G = new Uint8Array(C);
                        var H = new Uint16Array(C);
                        var I = new Uint32Array(C);
                        var J = new Float32Array(C);
                        var K = new Float64Array(C);
                        var L = Math.imul;
                        var M = Math.fround;
                        var N = Math.abs;
                        var O = Math.clz32;
                        var P = Math.min;
                        var Q = Math.max;
                        var R = Math.floor;
                        var S = Math.ceil;
                        var T = Math.trunc;
                        var U = Math.sqrt;
                        var V = pa.abort;
                        var W = NaN;
                        var X = Infinity;
                        var Y = pa.b;
                        var Z = pa.c;
                        var _ = pa.d;
                        var $ = pa.e;
                        var aa = pa.f;
                        var ba = pa.g;
                        var ca = pa.h;
                        var da = pa.i;
                        var ea = 5260320;
                        var fa = 0;
                        // EMSCRIPTEN_START_FUNCS
                        function Sd(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0; w = ea - 672 | 0; ea = w; f = F[b + 12 >> 2]; d = F[b + 20 >> 2]; e = F[b + 16 >> 2]; q = e + 4 | 0; d = q >>> 0 < 4 ? d + 1 | 0 : d; a: {
                            b: {
                                c: {
                                    if (q >>> 0 > I[b + 8 >> 2] & (d | 0) >= (f | 0) | (d | 0) > (f | 0)) {
                                        break c;
                                    }
                                    d = e + F[b >> 2] | 0;
                                    F[a >> 2] = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                    d = F[b + 20 >> 2];
                                    f = d;
                                    q = F[b + 16 >> 2];
                                    e = q + 4 | 0;
                                    d = e >>> 0 < 4 ? d + 1 | 0 : d;
                                    t = e;
                                    F[b + 16 >> 2] = e;
                                    F[b + 20 >> 2] = d;
                                    if (I[a >> 2] > 31) {
                                        break c;
                                    }
                                    e = F[b + 12 >> 2];
                                    d = f;
                                    f = q + 8 | 0;
                                    d = f >>> 0 < 8 ? d + 1 | 0 : d;
                                    if (f >>> 0 > I[b + 8 >> 2] & (d | 0) >= (e | 0) | (d | 0) > (e | 0)) {
                                        break c;
                                    }
                                    d = t + F[b >> 2] | 0;
                                    F[a + 4 >> 2] = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                    d = F[b + 20 >> 2];
                                    f = d;
                                    q = F[b + 16 >> 2];
                                    e = q + 4 | 0;
                                    d = e >>> 0 < 4 ? d + 1 | 0 : d;
                                    t = e;
                                    F[b + 16 >> 2] = e;
                                    F[b + 20 >> 2] = d;
                                    e = F[b + 12 >> 2];
                                    d = f;
                                    f = q + 8 | 0;
                                    d = f >>> 0 < 8 ? d + 1 | 0 : d;
                                    if (f >>> 0 > I[b + 8 >> 2] & (d | 0) >= (e | 0) | (d | 0) > (e | 0)) {
                                        break c;
                                    }
                                    d = t + F[b >> 2] | 0;
                                    F[a + 12 >> 2] = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                    d = F[b + 20 >> 2];
                                    f = d;
                                    q = F[b + 16 >> 2];
                                    e = q + 4 | 0;
                                    d = e >>> 0 < 4 ? d + 1 | 0 : d;
                                    p = e;
                                    F[b + 16 >> 2] = e;
                                    F[b + 20 >> 2] = d;
                                    d = F[a + 20 >> 2];
                                    t = F[a + 12 >> 2];
                                    if ((t | 0) != (d | 0) ? d : 0) {
                                        break c;
                                    }
                                    e = F[b + 12 >> 2];
                                    d = f;
                                    f = q + 8 | 0;
                                    d = f >>> 0 < 8 ? d + 1 | 0 : d;
                                    if (f >>> 0 > I[b + 8 >> 2] & (d | 0) >= (e | 0) | (d | 0) > (e | 0)) {
                                        break c;
                                    }
                                    d = p + F[b >> 2] | 0;
                                    f = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                    F[a + 16 >> 2] = f;
                                    d = F[b + 20 >> 2];
                                    e = F[b + 16 >> 2] + 4 | 0;
                                    d = e >>> 0 < 4 ? d + 1 | 0 : d;
                                    F[b + 16 >> 2] = e;
                                    F[b + 20 >> 2] = d;
                                    if (f >>> 0 >= 7) {
                                        F[w >> 2] = f;
                                        Od(1857, w);
                                        break c;
                                    }
                                    F[w + 664 >> 2] = c;
                                    d: {
                                        if (!t) {
                                            break d;
                                        }
                                        e: {
                                            q = F[c >> 2];
                                            if (t >>> 0 <= (F[c + 8 >> 2] - q | 0) / 12 >>> 0) {
                                                break e;
                                            }
                                            if (t >>> 0 < 357913942) {
                                                e = F[c + 4 >> 2];
                                                f = L(t, 12);
                                                d = sa(f);
                                                t = d + f | 0;
                                                f = d + L((e - q | 0) / 12 | 0, 12) | 0;
                                                d = f;
                                                if ((e | 0) != (q | 0)) {
                                                    d = f;
                                                    while (1) {
                                                        d = d - 12 | 0;
                                                        e = e - 12 | 0;
                                                        F[d >> 2] = F[e >> 2];
                                                        F[d + 4 >> 2] = F[e + 4 >> 2];
                                                        F[d + 8 >> 2] = F[e + 8 >> 2];
                                                        if ((e | 0) != (q | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                F[c + 8 >> 2] = t;
                                                F[c + 4 >> 2] = f;
                                                F[c >> 2] = d;
                                                if (!q) {
                                                    break e;
                                                }
                                                ra(q);
                                                break e;
                                            }
                                            break b;
                                        }
                                        f: {
                                            switch (F[a + 16 >> 2]) {
                                                case 0:
                                                    h = zb(w + 8 | 0, 3);
                                                    q = w + 664 | 0;
                                                    f = F[b + 12 >> 2];
                                                    d = F[b + 20 >> 2];
                                                    g = F[b + 16 >> 2];
                                                    e = g + 4 | 0;
                                                    d = e >>> 0 < 4 ? d + 1 | 0 : d;
                                                    g: {
                                                        if (e >>> 0 > I[b + 8 >> 2] & (d | 0) >= (f | 0) | (d | 0) > (f | 0)) {
                                                            break g;
                                                        }
                                                        d = g + F[b >> 2] | 0;
                                                        F[h >> 2] = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                                        d = F[b + 20 >> 2];
                                                        f = d;
                                                        e = F[b + 16 >> 2];
                                                        g = e + 4 | 0;
                                                        d = g >>> 0 < 4 ? d + 1 | 0 : d;
                                                        j = g;
                                                        F[b + 16 >> 2] = g;
                                                        F[b + 20 >> 2] = d;
                                                        if (I[h >> 2] > 32) {
                                                            break g;
                                                        }
                                                        g = F[b + 12 >> 2];
                                                        d = f;
                                                        f = e + 8 | 0;
                                                        d = f >>> 0 < 8 ? d + 1 | 0 : d;
                                                        if (f >>> 0 > I[b + 8 >> 2] & (d | 0) >= (g | 0) | (d | 0) > (g | 0)) {
                                                            break g;
                                                        }
                                                        d = j + F[b >> 2] | 0;
                                                        f = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                                        F[h + 4 >> 2] = f;
                                                        d = F[b + 20 >> 2];
                                                        g = F[b + 16 >> 2] + 4 | 0;
                                                        d = g >>> 0 < 4 ? d + 1 | 0 : d;
                                                        F[b + 16 >> 2] = g;
                                                        F[b + 20 >> 2] = d;
                                                        if (!f) {
                                                            break g;
                                                        }
                                                        F[h + 8 >> 2] = 0;
                                                        if (!ya(h + 16 | 0, b)) {
                                                            break g;
                                                        }
                                                        if (!ya(h + 36 | 0, b)) {
                                                            break g;
                                                        }
                                                        if (!ya(h + 56 | 0, b)) {
                                                            break g;
                                                        }
                                                        if (!ya(h + 76 | 0, b)) {
                                                            break g;
                                                        }
                                                        t = F[h + 4 >> 2];
                                                        f = 0;
                                                        b = 0;
                                                        e = ea - 48 | 0;
                                                        ea = e;
                                                        g = F[h + 12 >> 2];
                                                        F[e + 16 >> 2] = 0;
                                                        F[e + 8 >> 2] = 0;
                                                        F[e + 12 >> 2] = 0;
                                                        if (g) {
                                                            if (g >>> 0 >= 1073741824) {
                                                                break a;
                                                            }
                                                            d = g << 2;
                                                            f = sa(d);
                                                            F[e + 8 >> 2] = f;
                                                            b = d + f | 0;
                                                            F[e + 16 >> 2] = b;
                                                            ua(f, 0, d);
                                                            F[e + 12 >> 2] = b;
                                                        }
                                                        d = F[h + 120 >> 2];
                                                        j = F[d >> 2];
                                                        if (j) {
                                                            F[d + 4 >> 2] = j;
                                                            ra(j);
                                                            F[d + 8 >> 2] = 0;
                                                            F[d >> 2] = 0;
                                                            F[d + 4 >> 2] = 0;
                                                            g = F[h + 12 >> 2];
                                                            f = F[e + 8 >> 2];
                                                            b = F[e + 12 >> 2];
                                                        }
                                                        F[d + 4 >> 2] = b;
                                                        F[d >> 2] = f;
                                                        F[d + 8 >> 2] = F[e + 16 >> 2];
                                                        f = 0;
                                                        F[e + 16 >> 2] = 0;
                                                        F[e + 8 >> 2] = 0;
                                                        F[e + 12 >> 2] = 0;
                                                        h: {
                                                            if (g) {
                                                                if (g >>> 0 >= 1073741824) {
                                                                    break a;
                                                                }
                                                                b = g << 2;
                                                                i = sa(b);
                                                                F[e + 8 >> 2] = i;
                                                                f = b + i | 0;
                                                                F[e + 16 >> 2] = f;
                                                                ua(i, 0, b);
                                                                F[e + 12 >> 2] = f;
                                                            }
                                                            b = F[h + 132 >> 2];
                                                            d = F[b >> 2];
                                                            if (d) {
                                                                F[b + 4 >> 2] = d;
                                                                ra(d);
                                                                F[b + 8 >> 2] = 0;
                                                                F[b >> 2] = 0;
                                                                F[b + 4 >> 2] = 0;
                                                                i = F[e + 8 >> 2];
                                                                f = F[e + 12 >> 2];
                                                            }
                                                            F[b + 4 >> 2] = f;
                                                            F[b >> 2] = i;
                                                            F[b + 8 >> 2] = F[e + 16 >> 2];
                                                            F[e + 24 >> 2] = 0;
                                                            F[e + 28 >> 2] = 0;
                                                            F[e + 16 >> 2] = 0;
                                                            F[e + 20 >> 2] = 0;
                                                            F[e + 8 >> 2] = 0;
                                                            F[e + 12 >> 2] = 0;
                                                            za(e + 8 | 0);
                                                            b = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                            d = (b >>> 0) / 341 | 0;
                                                            b = F[F[e + 12 >> 2] + (d << 2) >> 2] + L(b - L(d, 341) | 0, 12) | 0;
                                                            F[b + 4 >> 2] = 0;
                                                            F[b + 8 >> 2] = 0;
                                                            F[b >> 2] = t;
                                                            b = F[e + 28 >> 2];
                                                            g = b + 1 | 0;
                                                            F[e + 28 >> 2] = g;
                                                            i: {
                                                                if (b >>> 0 > g >>> 0) {
                                                                    break i;
                                                                }
                                                                while (1) {
                                                                    p = F[e + 12 >> 2];
                                                                    f = F[e + 24 >> 2];
                                                                    j = g - 1 | 0;
                                                                    b = f + j | 0;
                                                                    d = (b >>> 0) / 341 | 0;
                                                                    b = F[p + (d << 2) >> 2] + L(b - L(d, 341) | 0, 12) | 0;
                                                                    k = F[b + 8 >> 2];
                                                                    i = F[b + 4 >> 2];
                                                                    d = F[b >> 2];
                                                                    F[e + 28 >> 2] = j;
                                                                    b = F[e + 16 >> 2];
                                                                    j = b - p | 0;
                                                                    if (((j ? L(j >> 2, 341) - 1 | 0 : 0) - (g + f | 0) | 0) + 1 >>> 0 >= 682) {
                                                                        ra(F[b - 4 >> 2]);
                                                                        F[e + 16 >> 2] = F[e + 16 >> 2] - 4;
                                                                    }
                                                                    f = 0;
                                                                    if (d >>> 0 > t >>> 0) {
                                                                        break i;
                                                                    }
                                                                    b = F[h + 12 >> 2];
                                                                    i = (i | 0) == (b - 1 | 0) ? 0 : i + 1 | 0;
                                                                    if (i >>> 0 >= b >>> 0) {
                                                                        break i;
                                                                    }
                                                                    g = L(k, 12);
                                                                    p = g + F[h + 132 >> 2] | 0;
                                                                    j = g + F[h + 120 >> 2] | 0;
                                                                    j: {
                                                                        k: {
                                                                            m = i << 2;
                                                                            o = F[h >> 2] - F[m + F[p >> 2] >> 2] | 0;
                                                                            if (!o) {
                                                                                if (!d) {
                                                                                    break k;
                                                                                }
                                                                                while (1) {
                                                                                    b = F[j >> 2];
                                                                                    p = F[b + 8 >> 2];
                                                                                    m = F[b + 4 >> 2];
                                                                                    o = F[b >> 2];
                                                                                    b = F[q >> 2];
                                                                                    g = F[b + 4 >> 2];
                                                                                    l = F[b + 8 >> 2];
                                                                                    l: {
                                                                                        if (g >>> 0 < l >>> 0) {
                                                                                            F[g + 8 >> 2] = p;
                                                                                            F[g + 4 >> 2] = m;
                                                                                            F[g >> 2] = o;
                                                                                            F[b + 4 >> 2] = g + 12;
                                                                                            break l;
                                                                                        }
                                                                                        k = F[b >> 2];
                                                                                        n = (g - k | 0) / 12 | 0;
                                                                                        i = n + 1 | 0;
                                                                                        if (i >>> 0 >= 357913942) {
                                                                                            break a;
                                                                                        }
                                                                                        l = (l - k | 0) / 12 | 0;
                                                                                        r = l << 1;
                                                                                        i = l >>> 0 < 178956970 ? i >>> 0 > r >>> 0 ? i : r : 357913941;
                                                                                        if (i >>> 0 >= 357913942) {
                                                                                            break b;
                                                                                        }
                                                                                        v = L(n, 12);
                                                                                        l = L(i, 12);
                                                                                        n = sa(l);
                                                                                        i = v + n | 0;
                                                                                        F[i + 8 >> 2] = p;
                                                                                        F[i + 4 >> 2] = m;
                                                                                        F[i >> 2] = o;
                                                                                        p = i + 12 | 0;
                                                                                        if ((g | 0) != (k | 0)) {
                                                                                            while (1) {
                                                                                                i = i - 12 | 0;
                                                                                                g = g - 12 | 0;
                                                                                                F[i >> 2] = F[g >> 2];
                                                                                                F[i + 4 >> 2] = F[g + 4 >> 2];
                                                                                                F[i + 8 >> 2] = F[g + 8 >> 2];
                                                                                                if ((g | 0) != (k | 0)) {
                                                                                                    continue;
                                                                                                }
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        F[b + 8 >> 2] = l + n;
                                                                                        F[b + 4 >> 2] = p;
                                                                                        F[b >> 2] = i;
                                                                                        if (!k) {
                                                                                            break l;
                                                                                        }
                                                                                        ra(k);
                                                                                    }
                                                                                    F[h + 8 >> 2] = F[h + 8 >> 2] + 1;
                                                                                    f = f + 1 | 0;
                                                                                    if ((d | 0) != (f | 0)) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                                break k;
                                                                            }
                                                                            m: {
                                                                                n: {
                                                                                    o: {
                                                                                        p: {
                                                                                            if (d >>> 0 <= 2) {
                                                                                                b = F[h + 108 >> 2];
                                                                                                F[b >> 2] = i;
                                                                                                f = 1;
                                                                                                g = F[h + 12 >> 2];
                                                                                                if (g >>> 0 > 1) {
                                                                                                    break p;
                                                                                                }
                                                                                                break m;
                                                                                            }
                                                                                            if (I[h + 8 >> 2] > I[h + 4 >> 2]) {
                                                                                                break i;
                                                                                            }
                                                                                            b = F[h + 120 >> 2];
                                                                                            l = k + 1 | 0;
                                                                                            p = L(l, 12);
                                                                                            f = b + p | 0;
                                                                                            if ((f | 0) != (j | 0)) {
                                                                                                Ca(f, F[j >> 2], F[j + 4 >> 2]);
                                                                                                b = F[h + 120 >> 2];
                                                                                            }
                                                                                            b = m + F[b + p >> 2] | 0;
                                                                                            F[b >> 2] = F[b >> 2] + (1 << o - 1);
                                                                                            b = O(d) ^ 31;
                                                                                            f = F[h + 32 >> 2];
                                                                                            o = 32 - f | 0;
                                                                                            q: {
                                                                                                if ((b | 0) <= (o | 0)) {
                                                                                                    j = F[h + 28 >> 2];
                                                                                                    if ((j | 0) == F[h + 20 >> 2]) {
                                                                                                        f = 0;
                                                                                                        break q;
                                                                                                    }
                                                                                                    o = F[j >> 2];
                                                                                                    n = b + f | 0;
                                                                                                    F[h + 32 >> 2] = n;
                                                                                                    f = o << f >>> 32 - b | 0;
                                                                                                    if ((n | 0) != 32) {
                                                                                                        break q;
                                                                                                    }
                                                                                                    F[h + 32 >> 2] = 0;
                                                                                                    F[h + 28 >> 2] = j + 4;
                                                                                                    break q;
                                                                                                }
                                                                                                j = F[h + 28 >> 2];
                                                                                                n = j + 4 | 0;
                                                                                                if ((n | 0) == F[h + 20 >> 2]) {
                                                                                                    f = 0;
                                                                                                    break q;
                                                                                                }
                                                                                                r = F[j >> 2];
                                                                                                F[h + 28 >> 2] = n;
                                                                                                o = b - o | 0;
                                                                                                F[h + 32 >> 2] = o;
                                                                                                f = F[j + 4 >> 2] >>> 32 - o | r << f >>> 32 - b;
                                                                                            }
                                                                                            b = (d >>> 1 | 0) - f | 0;
                                                                                            f = d - b | 0;
                                                                                            r: {
                                                                                                if ((f | 0) == (b | 0)) {
                                                                                                    d = b;
                                                                                                    break r;
                                                                                                }
                                                                                                d = F[h + 88 >> 2];
                                                                                                if ((d | 0) == F[h + 80 >> 2]) {
                                                                                                    break o;
                                                                                                }
                                                                                                j = F[d >> 2];
                                                                                                o = F[h + 92 >> 2];
                                                                                                n = o + 1 | 0;
                                                                                                F[h + 92 >> 2] = n;
                                                                                                j = j & -2147483648 >>> o;
                                                                                                s: {
                                                                                                    if ((n | 0) == 32) {
                                                                                                        F[h + 92 >> 2] = 0;
                                                                                                        F[h + 88 >> 2] = d + 4;
                                                                                                        if (j) {
                                                                                                            break s;
                                                                                                        }
                                                                                                        break o;
                                                                                                    }
                                                                                                    if (!j) {
                                                                                                        break o;
                                                                                                    }
                                                                                                }
                                                                                                d = f;
                                                                                            }
                                                                                            f = b;
                                                                                            break n;
                                                                                        }
                                                                                        while (1) {
                                                                                            i = (g - 1 | 0) == (i | 0) ? 0 : i + 1 | 0;
                                                                                            F[b + (f << 2) >> 2] = i;
                                                                                            f = f + 1 | 0;
                                                                                            g = F[h + 12 >> 2];
                                                                                            if (f >>> 0 < g >>> 0) {
                                                                                                continue;
                                                                                            }
                                                                                            break;
                                                                                        }
                                                                                        break m;
                                                                                    }
                                                                                    d = b;
                                                                                }
                                                                                b = F[h + 132 >> 2];
                                                                                g = b + g | 0;
                                                                                j = F[g >> 2];
                                                                                m = j + m | 0;
                                                                                F[m >> 2] = F[m >> 2] + 1;
                                                                                Ca(b + p | 0, j, F[g + 4 >> 2]);
                                                                                if (f) {
                                                                                    g = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                                                    b = F[e + 12 >> 2];
                                                                                    j = F[e + 16 >> 2] - b | 0;
                                                                                    if ((g | 0) == ((j ? L(j >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                                        za(e + 8 | 0);
                                                                                        g = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                                                        j = F[e + 12 >> 2];
                                                                                    }
                                                                                    else {
                                                                                        j = b;
                                                                                    }
                                                                                    b = (g >>> 0) / 341 | 0;
                                                                                    b = F[j + (b << 2) >> 2] + L(g - L(b, 341) | 0, 12) | 0;
                                                                                    F[b + 8 >> 2] = k;
                                                                                    F[b + 4 >> 2] = i;
                                                                                    F[b >> 2] = f;
                                                                                    F[e + 28 >> 2] = F[e + 28 >> 2] + 1;
                                                                                }
                                                                                if (!d) {
                                                                                    break k;
                                                                                }
                                                                                g = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                                                f = F[e + 12 >> 2];
                                                                                b = F[e + 16 >> 2] - f | 0;
                                                                                if ((g | 0) == ((b ? L(b >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                                    za(e + 8 | 0);
                                                                                    g = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                                                    f = F[e + 12 >> 2];
                                                                                }
                                                                                b = (g >>> 0) / 341 | 0;
                                                                                b = F[f + (b << 2) >> 2] + L(g - L(b, 341) | 0, 12) | 0;
                                                                                F[b + 8 >> 2] = l;
                                                                                F[b + 4 >> 2] = i;
                                                                                F[b >> 2] = d;
                                                                                g = F[e + 28 >> 2] + 1 | 0;
                                                                                F[e + 28 >> 2] = g;
                                                                                break j;
                                                                            }
                                                                            i = 0;
                                                                            if (!d) {
                                                                                break k;
                                                                            }
                                                                            while (1) {
                                                                                f = F[h + 96 >> 2];
                                                                                if (g) {
                                                                                    m = F[h + 40 >> 2];
                                                                                    r = F[h + 108 >> 2];
                                                                                    x = F[j >> 2];
                                                                                    z = F[p >> 2];
                                                                                    g = 0;
                                                                                    while (1) {
                                                                                        o = r + (g << 2) | 0;
                                                                                        F[(F[o >> 2] << 2) + f >> 2] = 0;
                                                                                        k = F[o >> 2] << 2;
                                                                                        b = F[h >> 2] - F[k + z >> 2] | 0;
                                                                                        t: {
                                                                                            if (!b) {
                                                                                                break t;
                                                                                            }
                                                                                            k = f + k | 0;
                                                                                            l = F[h + 52 >> 2];
                                                                                            s = 32 - l | 0;
                                                                                            if ((s | 0) >= (b | 0)) {
                                                                                                n = F[h + 48 >> 2];
                                                                                                if ((n | 0) == (m | 0)) {
                                                                                                    F[k >> 2] = 0;
                                                                                                    break t;
                                                                                                }
                                                                                                F[k >> 2] = F[n >> 2] << l >>> 32 - b;
                                                                                                b = b + F[h + 52 >> 2] | 0;
                                                                                                F[h + 52 >> 2] = b;
                                                                                                if ((b | 0) != 32) {
                                                                                                    break t;
                                                                                                }
                                                                                                F[h + 52 >> 2] = 0;
                                                                                                F[h + 48 >> 2] = n + 4;
                                                                                                break t;
                                                                                            }
                                                                                            n = F[h + 48 >> 2];
                                                                                            u = n + 4 | 0;
                                                                                            if ((u | 0) == (m | 0)) {
                                                                                                F[k >> 2] = 0;
                                                                                                break t;
                                                                                            }
                                                                                            y = F[n >> 2];
                                                                                            F[h + 48 >> 2] = u;
                                                                                            s = b - s | 0;
                                                                                            F[h + 52 >> 2] = s;
                                                                                            F[k >> 2] = F[n + 4 >> 2] >>> 32 - s | y << l >>> 32 - b;
                                                                                        }
                                                                                        b = F[o >> 2] << 2;
                                                                                        k = b + f | 0;
                                                                                        F[k >> 2] = F[k >> 2] | F[b + x >> 2];
                                                                                        g = g + 1 | 0;
                                                                                        if (g >>> 0 < I[h + 12 >> 2]) {
                                                                                            continue;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    f = F[h + 96 >> 2];
                                                                                }
                                                                                F[e + 32 >> 2] = F[f >> 2];
                                                                                F[e + 36 >> 2] = F[f + 4 >> 2];
                                                                                F[e + 40 >> 2] = F[f + 8 >> 2];
                                                                                nb(F[q >> 2], e + 32 | 0);
                                                                                F[h + 8 >> 2] = F[h + 8 >> 2] + 1;
                                                                                i = i + 1 | 0;
                                                                                if ((d | 0) == (i | 0)) {
                                                                                    break k;
                                                                                }
                                                                                g = F[h + 12 >> 2];
                                                                                continue;
                                                                            }
                                                                        }
                                                                        g = F[e + 28 >> 2];
                                                                    }
                                                                    if (g) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            F[e + 28 >> 2] = 0;
                                                            g = F[e + 16 >> 2];
                                                            b = F[e + 12 >> 2];
                                                            i = g - b | 0;
                                                            if (i >>> 0 >= 9) {
                                                                while (1) {
                                                                    ra(F[b >> 2]);
                                                                    b = F[e + 12 >> 2] + 4 | 0;
                                                                    F[e + 12 >> 2] = b;
                                                                    g = F[e + 16 >> 2];
                                                                    i = g - b | 0;
                                                                    if (i >>> 0 > 8) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            f = 170;
                                                            u: {
                                                                switch ((i >>> 2 | 0) - 1 | 0) {
                                                                    case 1: f = 341;
                                                                    case 0:
                                                                        F[e + 24 >> 2] = f;
                                                                        break;
                                                                    default: break u;
                                                                }
                                                            }
                                                            v: {
                                                                if ((b | 0) == (g | 0)) {
                                                                    break v;
                                                                }
                                                                while (1) {
                                                                    ra(F[b >> 2]);
                                                                    b = b + 4 | 0;
                                                                    if ((g | 0) != (b | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                b = F[e + 16 >> 2];
                                                                d = F[e + 12 >> 2];
                                                                if ((b | 0) == (d | 0)) {
                                                                    break v;
                                                                }
                                                                F[e + 16 >> 2] = b + (((b - d | 0) - 4 >>> 2 ^ -1) << 2);
                                                            }
                                                            b = F[e + 8 >> 2];
                                                            if (b) {
                                                                ra(b);
                                                            }
                                                            ea = e + 48 | 0;
                                                            break h;
                                                        }
                                                    }
                                                    Ab(h);
                                                    break d;
                                                case 1:
                                                    h = zb(w + 8 | 0, 3);
                                                    t = w + 664 | 0;
                                                    f = F[b + 12 >> 2];
                                                    d = F[b + 20 >> 2];
                                                    g = F[b + 16 >> 2];
                                                    e = g + 4 | 0;
                                                    d = e >>> 0 < 4 ? d + 1 | 0 : d;
                                                    w: {
                                                        if (e >>> 0 > I[b + 8 >> 2] & (d | 0) >= (f | 0) | (d | 0) > (f | 0)) {
                                                            break w;
                                                        }
                                                        d = g + F[b >> 2] | 0;
                                                        F[h >> 2] = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                                        d = F[b + 20 >> 2];
                                                        f = d;
                                                        e = F[b + 16 >> 2];
                                                        g = e + 4 | 0;
                                                        d = g >>> 0 < 4 ? d + 1 | 0 : d;
                                                        k = g;
                                                        F[b + 16 >> 2] = g;
                                                        F[b + 20 >> 2] = d;
                                                        if (I[h >> 2] > 32) {
                                                            break w;
                                                        }
                                                        g = F[b + 12 >> 2];
                                                        d = f;
                                                        f = e + 8 | 0;
                                                        d = f >>> 0 < 8 ? d + 1 | 0 : d;
                                                        if (f >>> 0 > I[b + 8 >> 2] & (d | 0) >= (g | 0) | (d | 0) > (g | 0)) {
                                                            break w;
                                                        }
                                                        d = k + F[b >> 2] | 0;
                                                        f = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                                        F[h + 4 >> 2] = f;
                                                        d = F[b + 20 >> 2];
                                                        g = F[b + 16 >> 2] + 4 | 0;
                                                        d = g >>> 0 < 4 ? d + 1 | 0 : d;
                                                        F[b + 16 >> 2] = g;
                                                        F[b + 20 >> 2] = d;
                                                        if (!f) {
                                                            break w;
                                                        }
                                                        F[h + 8 >> 2] = 0;
                                                        if (!ya(h + 16 | 0, b)) {
                                                            break w;
                                                        }
                                                        if (!ya(h + 36 | 0, b)) {
                                                            break w;
                                                        }
                                                        if (!ya(h + 56 | 0, b)) {
                                                            break w;
                                                        }
                                                        if (!ya(h + 76 | 0, b)) {
                                                            break w;
                                                        }
                                                        p = F[h + 4 >> 2];
                                                        f = 0;
                                                        e = ea - 48 | 0;
                                                        ea = e;
                                                        g = F[h + 12 >> 2];
                                                        F[e + 16 >> 2] = 0;
                                                        F[e + 8 >> 2] = 0;
                                                        F[e + 12 >> 2] = 0;
                                                        if (g) {
                                                            if (g >>> 0 >= 1073741824) {
                                                                break a;
                                                            }
                                                            b = g << 2;
                                                            j = sa(b);
                                                            F[e + 8 >> 2] = j;
                                                            f = b + j | 0;
                                                            F[e + 16 >> 2] = f;
                                                            ua(j, 0, b);
                                                            F[e + 12 >> 2] = f;
                                                        }
                                                        b = F[h + 120 >> 2];
                                                        d = F[b >> 2];
                                                        if (d) {
                                                            F[b + 4 >> 2] = d;
                                                            ra(d);
                                                            F[b + 8 >> 2] = 0;
                                                            F[b >> 2] = 0;
                                                            F[b + 4 >> 2] = 0;
                                                            j = F[e + 8 >> 2];
                                                            g = F[h + 12 >> 2];
                                                            f = F[e + 12 >> 2];
                                                        }
                                                        F[b + 4 >> 2] = f;
                                                        F[b >> 2] = j;
                                                        F[b + 8 >> 2] = F[e + 16 >> 2];
                                                        j = 0;
                                                        F[e + 16 >> 2] = 0;
                                                        F[e + 8 >> 2] = 0;
                                                        F[e + 12 >> 2] = 0;
                                                        x: {
                                                            if (g) {
                                                                if (g >>> 0 >= 1073741824) {
                                                                    break a;
                                                                }
                                                                b = g << 2;
                                                                i = sa(b);
                                                                F[e + 8 >> 2] = i;
                                                                j = b + i | 0;
                                                                F[e + 16 >> 2] = j;
                                                                ua(i, 0, b);
                                                                F[e + 12 >> 2] = j;
                                                            }
                                                            b = F[h + 132 >> 2];
                                                            d = F[b >> 2];
                                                            if (d) {
                                                                F[b + 4 >> 2] = d;
                                                                ra(d);
                                                                F[b + 8 >> 2] = 0;
                                                                F[b >> 2] = 0;
                                                                F[b + 4 >> 2] = 0;
                                                                j = F[e + 12 >> 2];
                                                                i = F[e + 8 >> 2];
                                                            }
                                                            F[b + 4 >> 2] = j;
                                                            F[b >> 2] = i;
                                                            F[b + 8 >> 2] = F[e + 16 >> 2];
                                                            F[e + 24 >> 2] = 0;
                                                            F[e + 28 >> 2] = 0;
                                                            F[e + 16 >> 2] = 0;
                                                            F[e + 20 >> 2] = 0;
                                                            F[e + 8 >> 2] = 0;
                                                            F[e + 12 >> 2] = 0;
                                                            za(e + 8 | 0);
                                                            b = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                            d = (b >>> 0) / 341 | 0;
                                                            b = F[F[e + 12 >> 2] + (d << 2) >> 2] + L(b - L(d, 341) | 0, 12) | 0;
                                                            F[b + 4 >> 2] = 0;
                                                            F[b + 8 >> 2] = 0;
                                                            F[b >> 2] = p;
                                                            b = F[e + 28 >> 2];
                                                            g = b + 1 | 0;
                                                            F[e + 28 >> 2] = g;
                                                            y: {
                                                                if (b >>> 0 > g >>> 0) {
                                                                    break y;
                                                                }
                                                                while (1) {
                                                                    j = F[e + 12 >> 2];
                                                                    f = F[e + 24 >> 2];
                                                                    i = g - 1 | 0;
                                                                    b = f + i | 0;
                                                                    d = (b >>> 0) / 341 | 0;
                                                                    b = F[j + (d << 2) >> 2] + L(b - L(d, 341) | 0, 12) | 0;
                                                                    q = F[b + 8 >> 2];
                                                                    d = F[b + 4 >> 2];
                                                                    b = F[b >> 2];
                                                                    F[e + 28 >> 2] = i;
                                                                    i = F[e + 16 >> 2];
                                                                    j = i - j | 0;
                                                                    if (((j ? L(j >> 2, 341) - 1 | 0 : 0) - (g + f | 0) | 0) + 1 >>> 0 >= 682) {
                                                                        ra(F[i - 4 >> 2]);
                                                                        F[e + 16 >> 2] = F[e + 16 >> 2] - 4;
                                                                    }
                                                                    if (b >>> 0 > p >>> 0) {
                                                                        break y;
                                                                    }
                                                                    f = 0;
                                                                    g = F[h + 12 >> 2];
                                                                    i = (d | 0) == (g - 1 | 0) ? 0 : d + 1 | 0;
                                                                    if (i >>> 0 >= g >>> 0) {
                                                                        break y;
                                                                    }
                                                                    d = F[h + 120 >> 2];
                                                                    g = L(q, 12);
                                                                    k = d + g | 0;
                                                                    z: {
                                                                        A: {
                                                                            j = i << 2;
                                                                            n = g + F[h + 132 >> 2] | 0;
                                                                            m = F[h >> 2] - F[j + F[n >> 2] >> 2] | 0;
                                                                            if (!m) {
                                                                                if (!b) {
                                                                                    break A;
                                                                                }
                                                                                while (1) {
                                                                                    d = F[k >> 2];
                                                                                    q = F[d + 8 >> 2];
                                                                                    m = F[d + 4 >> 2];
                                                                                    o = F[d >> 2];
                                                                                    d = F[t >> 2];
                                                                                    g = F[d + 4 >> 2];
                                                                                    l = F[d + 8 >> 2];
                                                                                    B: {
                                                                                        if (g >>> 0 < l >>> 0) {
                                                                                            F[g + 8 >> 2] = q;
                                                                                            F[g + 4 >> 2] = m;
                                                                                            F[g >> 2] = o;
                                                                                            F[d + 4 >> 2] = g + 12;
                                                                                            break B;
                                                                                        }
                                                                                        j = F[d >> 2];
                                                                                        n = (g - j | 0) / 12 | 0;
                                                                                        i = n + 1 | 0;
                                                                                        if (i >>> 0 >= 357913942) {
                                                                                            break a;
                                                                                        }
                                                                                        l = (l - j | 0) / 12 | 0;
                                                                                        r = l << 1;
                                                                                        i = l >>> 0 < 178956970 ? i >>> 0 > r >>> 0 ? i : r : 357913941;
                                                                                        if (i >>> 0 >= 357913942) {
                                                                                            break b;
                                                                                        }
                                                                                        v = L(n, 12);
                                                                                        l = L(i, 12);
                                                                                        n = sa(l);
                                                                                        i = v + n | 0;
                                                                                        F[i + 8 >> 2] = q;
                                                                                        F[i + 4 >> 2] = m;
                                                                                        F[i >> 2] = o;
                                                                                        q = i + 12 | 0;
                                                                                        if ((g | 0) != (j | 0)) {
                                                                                            while (1) {
                                                                                                i = i - 12 | 0;
                                                                                                g = g - 12 | 0;
                                                                                                F[i >> 2] = F[g >> 2];
                                                                                                F[i + 4 >> 2] = F[g + 4 >> 2];
                                                                                                F[i + 8 >> 2] = F[g + 8 >> 2];
                                                                                                if ((g | 0) != (j | 0)) {
                                                                                                    continue;
                                                                                                }
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        F[d + 8 >> 2] = l + n;
                                                                                        F[d + 4 >> 2] = q;
                                                                                        F[d >> 2] = i;
                                                                                        if (!j) {
                                                                                            break B;
                                                                                        }
                                                                                        ra(j);
                                                                                    }
                                                                                    F[h + 8 >> 2] = F[h + 8 >> 2] + 1;
                                                                                    f = f + 1 | 0;
                                                                                    if ((b | 0) != (f | 0)) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                                break A;
                                                                            }
                                                                            C: {
                                                                                D: {
                                                                                    E: {
                                                                                        F: {
                                                                                            if (b >>> 0 <= 2) {
                                                                                                d = F[h + 108 >> 2];
                                                                                                F[d >> 2] = i;
                                                                                                j = 1;
                                                                                                g = F[h + 12 >> 2];
                                                                                                if (g >>> 0 > 1) {
                                                                                                    break F;
                                                                                                }
                                                                                                break C;
                                                                                            }
                                                                                            if (I[h + 8 >> 2] > I[h + 4 >> 2]) {
                                                                                                break y;
                                                                                            }
                                                                                            f = d;
                                                                                            d = g + 12 | 0;
                                                                                            Ca(f + d | 0, F[k >> 2], F[k + 4 >> 2]);
                                                                                            d = j + F[d + F[h + 120 >> 2] >> 2] | 0;
                                                                                            F[d >> 2] = F[d >> 2] + (1 << m - 1);
                                                                                            d = O(b) ^ 31;
                                                                                            f = F[h + 32 >> 2];
                                                                                            m = 32 - f | 0;
                                                                                            G: {
                                                                                                if ((d | 0) <= (m | 0)) {
                                                                                                    k = F[h + 28 >> 2];
                                                                                                    if ((k | 0) == F[h + 20 >> 2]) {
                                                                                                        f = 0;
                                                                                                        break G;
                                                                                                    }
                                                                                                    m = F[k >> 2];
                                                                                                    o = d + f | 0;
                                                                                                    F[h + 32 >> 2] = o;
                                                                                                    f = m << f >>> 32 - d | 0;
                                                                                                    if ((o | 0) != 32) {
                                                                                                        break G;
                                                                                                    }
                                                                                                    F[h + 32 >> 2] = 0;
                                                                                                    F[h + 28 >> 2] = k + 4;
                                                                                                    break G;
                                                                                                }
                                                                                                k = F[h + 28 >> 2];
                                                                                                o = k + 4 | 0;
                                                                                                if ((o | 0) == F[h + 20 >> 2]) {
                                                                                                    f = 0;
                                                                                                    break G;
                                                                                                }
                                                                                                l = F[k >> 2];
                                                                                                F[h + 28 >> 2] = o;
                                                                                                m = d - m | 0;
                                                                                                F[h + 32 >> 2] = m;
                                                                                                f = F[k + 4 >> 2] >>> 32 - m | l << f >>> 32 - d;
                                                                                            }
                                                                                            k = q + 1 | 0;
                                                                                            d = b;
                                                                                            b = (b >>> 1 | 0) - f | 0;
                                                                                            f = d - b | 0;
                                                                                            H: {
                                                                                                if ((f | 0) == (b | 0)) {
                                                                                                    d = b;
                                                                                                    break H;
                                                                                                }
                                                                                                d = F[h + 88 >> 2];
                                                                                                if ((d | 0) == F[h + 80 >> 2]) {
                                                                                                    break E;
                                                                                                }
                                                                                                m = F[d >> 2];
                                                                                                o = F[h + 92 >> 2];
                                                                                                l = o + 1 | 0;
                                                                                                F[h + 92 >> 2] = l;
                                                                                                m = m & -2147483648 >>> o;
                                                                                                I: {
                                                                                                    if ((l | 0) == 32) {
                                                                                                        F[h + 92 >> 2] = 0;
                                                                                                        F[h + 88 >> 2] = d + 4;
                                                                                                        if (m) {
                                                                                                            break I;
                                                                                                        }
                                                                                                        break E;
                                                                                                    }
                                                                                                    if (!m) {
                                                                                                        break E;
                                                                                                    }
                                                                                                }
                                                                                                d = f;
                                                                                            }
                                                                                            f = b;
                                                                                            break D;
                                                                                        }
                                                                                        while (1) {
                                                                                            i = (g - 1 | 0) == (i | 0) ? 0 : i + 1 | 0;
                                                                                            F[d + (j << 2) >> 2] = i;
                                                                                            g = F[h + 12 >> 2];
                                                                                            j = j + 1 | 0;
                                                                                            if (g >>> 0 > j >>> 0) {
                                                                                                continue;
                                                                                            }
                                                                                            break;
                                                                                        }
                                                                                        break C;
                                                                                    }
                                                                                    d = b;
                                                                                }
                                                                                v = j;
                                                                                b = F[h + 132 >> 2];
                                                                                g = b + g | 0;
                                                                                j = F[g >> 2];
                                                                                m = v + j | 0;
                                                                                F[m >> 2] = F[m >> 2] + 1;
                                                                                Ca(b + L(k, 12) | 0, j, F[g + 4 >> 2]);
                                                                                if (f) {
                                                                                    g = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                                                    j = F[e + 12 >> 2];
                                                                                    b = F[e + 16 >> 2] - j | 0;
                                                                                    if ((g | 0) == ((b ? L(b >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                                        za(e + 8 | 0);
                                                                                        j = F[e + 12 >> 2];
                                                                                        g = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                                                    }
                                                                                    b = (g >>> 0) / 341 | 0;
                                                                                    b = F[(b << 2) + j >> 2] + L(g - L(b, 341) | 0, 12) | 0;
                                                                                    F[b + 8 >> 2] = q;
                                                                                    F[b + 4 >> 2] = i;
                                                                                    F[b >> 2] = f;
                                                                                    F[e + 28 >> 2] = F[e + 28 >> 2] + 1;
                                                                                }
                                                                                if (!d) {
                                                                                    break A;
                                                                                }
                                                                                g = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                                                j = F[e + 12 >> 2];
                                                                                b = F[e + 16 >> 2] - j | 0;
                                                                                if ((g | 0) == ((b ? L(b >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                                    za(e + 8 | 0);
                                                                                    j = F[e + 12 >> 2];
                                                                                    g = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                                                }
                                                                                b = (g >>> 0) / 341 | 0;
                                                                                b = F[(b << 2) + j >> 2] + L(g - L(b, 341) | 0, 12) | 0;
                                                                                F[b + 8 >> 2] = k;
                                                                                F[b + 4 >> 2] = i;
                                                                                F[b >> 2] = d;
                                                                                g = F[e + 28 >> 2] + 1 | 0;
                                                                                F[e + 28 >> 2] = g;
                                                                                break z;
                                                                            }
                                                                            i = 0;
                                                                            if (!b) {
                                                                                break A;
                                                                            }
                                                                            while (1) {
                                                                                j = F[h + 96 >> 2];
                                                                                if (g) {
                                                                                    q = F[h + 40 >> 2];
                                                                                    r = F[h + 108 >> 2];
                                                                                    x = F[k >> 2];
                                                                                    z = F[n >> 2];
                                                                                    g = 0;
                                                                                    while (1) {
                                                                                        m = r + (g << 2) | 0;
                                                                                        F[(F[m >> 2] << 2) + j >> 2] = 0;
                                                                                        f = F[m >> 2] << 2;
                                                                                        d = F[h >> 2] - F[f + z >> 2] | 0;
                                                                                        J: {
                                                                                            if (!d) {
                                                                                                break J;
                                                                                            }
                                                                                            f = f + j | 0;
                                                                                            o = F[h + 52 >> 2];
                                                                                            s = 32 - o | 0;
                                                                                            if ((s | 0) >= (d | 0)) {
                                                                                                l = F[h + 48 >> 2];
                                                                                                if ((l | 0) == (q | 0)) {
                                                                                                    F[f >> 2] = 0;
                                                                                                    break J;
                                                                                                }
                                                                                                F[f >> 2] = F[l >> 2] << o >>> 32 - d;
                                                                                                d = d + F[h + 52 >> 2] | 0;
                                                                                                F[h + 52 >> 2] = d;
                                                                                                if ((d | 0) != 32) {
                                                                                                    break J;
                                                                                                }
                                                                                                F[h + 52 >> 2] = 0;
                                                                                                F[h + 48 >> 2] = l + 4;
                                                                                                break J;
                                                                                            }
                                                                                            l = F[h + 48 >> 2];
                                                                                            u = l + 4 | 0;
                                                                                            if ((u | 0) == (q | 0)) {
                                                                                                F[f >> 2] = 0;
                                                                                                break J;
                                                                                            }
                                                                                            y = F[l >> 2];
                                                                                            F[h + 48 >> 2] = u;
                                                                                            s = d - s | 0;
                                                                                            F[h + 52 >> 2] = s;
                                                                                            F[f >> 2] = F[l + 4 >> 2] >>> 32 - s | y << o >>> 32 - d;
                                                                                        }
                                                                                        d = F[m >> 2] << 2;
                                                                                        f = d + j | 0;
                                                                                        F[f >> 2] = F[f >> 2] | F[d + x >> 2];
                                                                                        g = g + 1 | 0;
                                                                                        if (g >>> 0 < I[h + 12 >> 2]) {
                                                                                            continue;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    j = F[h + 96 >> 2];
                                                                                }
                                                                                F[e + 32 >> 2] = F[j >> 2];
                                                                                F[e + 36 >> 2] = F[j + 4 >> 2];
                                                                                F[e + 40 >> 2] = F[j + 8 >> 2];
                                                                                nb(F[t >> 2], e + 32 | 0);
                                                                                F[h + 8 >> 2] = F[h + 8 >> 2] + 1;
                                                                                i = i + 1 | 0;
                                                                                if ((b | 0) == (i | 0)) {
                                                                                    break A;
                                                                                }
                                                                                g = F[h + 12 >> 2];
                                                                                continue;
                                                                            }
                                                                        }
                                                                        g = F[e + 28 >> 2];
                                                                    }
                                                                    if (g) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            F[e + 28 >> 2] = 0;
                                                            g = F[e + 16 >> 2];
                                                            b = F[e + 12 >> 2];
                                                            i = g - b | 0;
                                                            if (i >>> 0 >= 9) {
                                                                while (1) {
                                                                    ra(F[b >> 2]);
                                                                    b = F[e + 12 >> 2] + 4 | 0;
                                                                    F[e + 12 >> 2] = b;
                                                                    g = F[e + 16 >> 2];
                                                                    i = g - b | 0;
                                                                    if (i >>> 0 > 8) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            j = 170;
                                                            K: {
                                                                switch ((i >>> 2 | 0) - 1 | 0) {
                                                                    case 1: j = 341;
                                                                    case 0:
                                                                        F[e + 24 >> 2] = j;
                                                                        break;
                                                                    default: break K;
                                                                }
                                                            }
                                                            L: {
                                                                if ((b | 0) == (g | 0)) {
                                                                    break L;
                                                                }
                                                                while (1) {
                                                                    ra(F[b >> 2]);
                                                                    b = b + 4 | 0;
                                                                    if ((g | 0) != (b | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                b = F[e + 16 >> 2];
                                                                d = F[e + 12 >> 2];
                                                                if ((b | 0) == (d | 0)) {
                                                                    break L;
                                                                }
                                                                F[e + 16 >> 2] = b + (((b - d | 0) - 4 >>> 2 ^ -1) << 2);
                                                            }
                                                            b = F[e + 8 >> 2];
                                                            if (b) {
                                                                ra(b);
                                                            }
                                                            ea = e + 48 | 0;
                                                            break x;
                                                        }
                                                    }
                                                    Ab(h);
                                                    break d;
                                                case 2:
                                                    i = xb(w + 8 | 0, 3);
                                                    q = w + 664 | 0;
                                                    f = F[b + 12 >> 2];
                                                    d = F[b + 20 >> 2];
                                                    g = F[b + 16 >> 2];
                                                    e = g + 4 | 0;
                                                    d = e >>> 0 < 4 ? d + 1 | 0 : d;
                                                    M: {
                                                        if (e >>> 0 > I[b + 8 >> 2] & (d | 0) >= (f | 0) | (d | 0) > (f | 0)) {
                                                            break M;
                                                        }
                                                        d = g + F[b >> 2] | 0;
                                                        F[i >> 2] = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                                        d = F[b + 20 >> 2];
                                                        f = d;
                                                        e = F[b + 16 >> 2];
                                                        g = e + 4 | 0;
                                                        d = g >>> 0 < 4 ? d + 1 | 0 : d;
                                                        h = g;
                                                        F[b + 16 >> 2] = h;
                                                        F[b + 20 >> 2] = d;
                                                        if (I[i >> 2] > 32) {
                                                            break M;
                                                        }
                                                        g = F[b + 12 >> 2];
                                                        d = f;
                                                        f = e + 8 | 0;
                                                        d = f >>> 0 < 8 ? d + 1 | 0 : d;
                                                        if (f >>> 0 > I[b + 8 >> 2] & (d | 0) >= (g | 0) | (d | 0) > (g | 0)) {
                                                            break M;
                                                        }
                                                        d = h + F[b >> 2] | 0;
                                                        f = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                                        F[i + 4 >> 2] = f;
                                                        d = F[b + 20 >> 2];
                                                        g = F[b + 16 >> 2] + 4 | 0;
                                                        d = g >>> 0 < 4 ? d + 1 | 0 : d;
                                                        F[b + 16 >> 2] = g;
                                                        F[b + 20 >> 2] = d;
                                                        if (!f) {
                                                            break M;
                                                        }
                                                        F[i + 8 >> 2] = 0;
                                                        if (!xa(i + 16 | 0, b)) {
                                                            break M;
                                                        }
                                                        if (!ya(i + 32 | 0, b)) {
                                                            break M;
                                                        }
                                                        if (!ya(i + 52 | 0, b)) {
                                                            break M;
                                                        }
                                                        if (!ya(i + 72 | 0, b)) {
                                                            break M;
                                                        }
                                                        t = F[i + 4 >> 2];
                                                        f = 0;
                                                        b = 0;
                                                        g = ea - 48 | 0;
                                                        ea = g;
                                                        e = F[i + 12 >> 2];
                                                        F[g + 16 >> 2] = 0;
                                                        F[g + 8 >> 2] = 0;
                                                        F[g + 12 >> 2] = 0;
                                                        if (e) {
                                                            if (e >>> 0 >= 1073741824) {
                                                                break a;
                                                            }
                                                            d = e << 2;
                                                            f = sa(d);
                                                            F[g + 8 >> 2] = f;
                                                            b = d + f | 0;
                                                            F[g + 16 >> 2] = b;
                                                            ua(f, 0, d);
                                                            F[g + 12 >> 2] = b;
                                                        }
                                                        d = F[i + 116 >> 2];
                                                        h = F[d >> 2];
                                                        if (h) {
                                                            F[d + 4 >> 2] = h;
                                                            ra(h);
                                                            F[d + 8 >> 2] = 0;
                                                            F[d >> 2] = 0;
                                                            F[d + 4 >> 2] = 0;
                                                            e = F[i + 12 >> 2];
                                                            f = F[g + 8 >> 2];
                                                            b = F[g + 12 >> 2];
                                                        }
                                                        F[d + 4 >> 2] = b;
                                                        F[d >> 2] = f;
                                                        F[d + 8 >> 2] = F[g + 16 >> 2];
                                                        f = 0;
                                                        F[g + 16 >> 2] = 0;
                                                        F[g + 8 >> 2] = 0;
                                                        F[g + 12 >> 2] = 0;
                                                        N: {
                                                            if (e) {
                                                                if (e >>> 0 >= 1073741824) {
                                                                    break a;
                                                                }
                                                                b = e << 2;
                                                                k = sa(b);
                                                                F[g + 8 >> 2] = k;
                                                                f = b + k | 0;
                                                                F[g + 16 >> 2] = f;
                                                                ua(k, 0, b);
                                                                F[g + 12 >> 2] = f;
                                                            }
                                                            b = F[i + 128 >> 2];
                                                            d = F[b >> 2];
                                                            if (d) {
                                                                F[b + 4 >> 2] = d;
                                                                ra(d);
                                                                F[b + 8 >> 2] = 0;
                                                                F[b >> 2] = 0;
                                                                F[b + 4 >> 2] = 0;
                                                                k = F[g + 8 >> 2];
                                                                f = F[g + 12 >> 2];
                                                            }
                                                            F[b + 4 >> 2] = f;
                                                            F[b >> 2] = k;
                                                            F[b + 8 >> 2] = F[g + 16 >> 2];
                                                            F[g + 24 >> 2] = 0;
                                                            F[g + 28 >> 2] = 0;
                                                            F[g + 16 >> 2] = 0;
                                                            F[g + 20 >> 2] = 0;
                                                            F[g + 8 >> 2] = 0;
                                                            F[g + 12 >> 2] = 0;
                                                            za(g + 8 | 0);
                                                            b = F[g + 24 >> 2] + F[g + 28 >> 2] | 0;
                                                            d = (b >>> 0) / 341 | 0;
                                                            b = F[F[g + 12 >> 2] + (d << 2) >> 2] + L(b - L(d, 341) | 0, 12) | 0;
                                                            F[b + 4 >> 2] = 0;
                                                            F[b + 8 >> 2] = 0;
                                                            F[b >> 2] = t;
                                                            b = F[g + 28 >> 2];
                                                            e = b + 1 | 0;
                                                            F[g + 28 >> 2] = e;
                                                            O: {
                                                                if (b >>> 0 > e >>> 0) {
                                                                    break O;
                                                                }
                                                                r = i + 16 | 0;
                                                                while (1) {
                                                                    p = F[g + 12 >> 2];
                                                                    f = F[g + 24 >> 2];
                                                                    k = e - 1 | 0;
                                                                    b = f + k | 0;
                                                                    d = (b >>> 0) / 341 | 0;
                                                                    b = F[p + (d << 2) >> 2] + L(b - L(d, 341) | 0, 12) | 0;
                                                                    j = F[b + 8 >> 2];
                                                                    h = F[b + 4 >> 2];
                                                                    d = F[b >> 2];
                                                                    F[g + 28 >> 2] = k;
                                                                    b = F[g + 16 >> 2];
                                                                    k = b - p | 0;
                                                                    if (((k ? L(k >> 2, 341) - 1 | 0 : 0) - (e + f | 0) | 0) + 1 >>> 0 >= 682) {
                                                                        ra(F[b - 4 >> 2]);
                                                                        F[g + 16 >> 2] = F[g + 16 >> 2] - 4;
                                                                    }
                                                                    f = 0;
                                                                    if (d >>> 0 > t >>> 0) {
                                                                        break O;
                                                                    }
                                                                    b = F[i + 12 >> 2];
                                                                    k = (h | 0) == (b - 1 | 0) ? 0 : h + 1 | 0;
                                                                    if (k >>> 0 >= b >>> 0) {
                                                                        break O;
                                                                    }
                                                                    e = L(j, 12);
                                                                    p = e + F[i + 128 >> 2] | 0;
                                                                    h = e + F[i + 116 >> 2] | 0;
                                                                    P: {
                                                                        m = k << 2;
                                                                        o = F[i >> 2] - F[m + F[p >> 2] >> 2] | 0;
                                                                        if (!o) {
                                                                            if (!d) {
                                                                                break P;
                                                                            }
                                                                            while (1) {
                                                                                b = F[h >> 2];
                                                                                p = F[b + 8 >> 2];
                                                                                m = F[b + 4 >> 2];
                                                                                o = F[b >> 2];
                                                                                b = F[q >> 2];
                                                                                e = F[b + 4 >> 2];
                                                                                l = F[b + 8 >> 2];
                                                                                Q: {
                                                                                    if (e >>> 0 < l >>> 0) {
                                                                                        F[e + 8 >> 2] = p;
                                                                                        F[e + 4 >> 2] = m;
                                                                                        F[e >> 2] = o;
                                                                                        F[b + 4 >> 2] = e + 12;
                                                                                        break Q;
                                                                                    }
                                                                                    j = F[b >> 2];
                                                                                    n = (e - j | 0) / 12 | 0;
                                                                                    k = n + 1 | 0;
                                                                                    if (k >>> 0 >= 357913942) {
                                                                                        break a;
                                                                                    }
                                                                                    l = (l - j | 0) / 12 | 0;
                                                                                    x = l << 1;
                                                                                    k = l >>> 0 < 178956970 ? k >>> 0 > x >>> 0 ? k : x : 357913941;
                                                                                    if (k >>> 0 >= 357913942) {
                                                                                        break b;
                                                                                    }
                                                                                    v = L(n, 12);
                                                                                    l = L(k, 12);
                                                                                    n = sa(l);
                                                                                    k = v + n | 0;
                                                                                    F[k + 8 >> 2] = p;
                                                                                    F[k + 4 >> 2] = m;
                                                                                    F[k >> 2] = o;
                                                                                    p = k + 12 | 0;
                                                                                    if ((e | 0) != (j | 0)) {
                                                                                        while (1) {
                                                                                            k = k - 12 | 0;
                                                                                            e = e - 12 | 0;
                                                                                            F[k >> 2] = F[e >> 2];
                                                                                            F[k + 4 >> 2] = F[e + 4 >> 2];
                                                                                            F[k + 8 >> 2] = F[e + 8 >> 2];
                                                                                            if ((e | 0) != (j | 0)) {
                                                                                                continue;
                                                                                            }
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    F[b + 8 >> 2] = l + n;
                                                                                    F[b + 4 >> 2] = p;
                                                                                    F[b >> 2] = k;
                                                                                    if (!j) {
                                                                                        break Q;
                                                                                    }
                                                                                    ra(j);
                                                                                }
                                                                                F[i + 8 >> 2] = F[i + 8 >> 2] + 1;
                                                                                f = f + 1 | 0;
                                                                                if ((d | 0) != (f | 0)) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                            break P;
                                                                        }
                                                                        R: {
                                                                            S: {
                                                                                T: {
                                                                                    U: {
                                                                                        if (d >>> 0 <= 2) {
                                                                                            b = F[i + 104 >> 2];
                                                                                            F[b >> 2] = k;
                                                                                            f = 1;
                                                                                            e = F[i + 12 >> 2];
                                                                                            if (e >>> 0 > 1) {
                                                                                                break U;
                                                                                            }
                                                                                            break R;
                                                                                        }
                                                                                        if (I[i + 8 >> 2] > I[i + 4 >> 2]) {
                                                                                            break O;
                                                                                        }
                                                                                        b = F[i + 116 >> 2];
                                                                                        l = j + 1 | 0;
                                                                                        p = L(l, 12);
                                                                                        f = b + p | 0;
                                                                                        if ((f | 0) != (h | 0)) {
                                                                                            Ca(f, F[h >> 2], F[h + 4 >> 2]);
                                                                                            b = F[i + 116 >> 2];
                                                                                        }
                                                                                        b = m + F[b + p >> 2] | 0;
                                                                                        F[b >> 2] = F[b >> 2] + (1 << o - 1);
                                                                                        F[g + 32 >> 2] = 0;
                                                                                        qc(r, O(d) ^ 31, g + 32 | 0);
                                                                                        b = (d >>> 1 | 0) - F[g + 32 >> 2] | 0;
                                                                                        f = d - b | 0;
                                                                                        V: {
                                                                                            if ((f | 0) == (b | 0)) {
                                                                                                d = b;
                                                                                                break V;
                                                                                            }
                                                                                            d = F[i + 84 >> 2];
                                                                                            if ((d | 0) == F[i + 76 >> 2]) {
                                                                                                break T;
                                                                                            }
                                                                                            h = F[d >> 2];
                                                                                            o = F[i + 88 >> 2];
                                                                                            n = o + 1 | 0;
                                                                                            F[i + 88 >> 2] = n;
                                                                                            h = h & -2147483648 >>> o;
                                                                                            W: {
                                                                                                if ((n | 0) == 32) {
                                                                                                    F[i + 88 >> 2] = 0;
                                                                                                    F[i + 84 >> 2] = d + 4;
                                                                                                    if (h) {
                                                                                                        break W;
                                                                                                    }
                                                                                                    break T;
                                                                                                }
                                                                                                if (!h) {
                                                                                                    break T;
                                                                                                }
                                                                                            }
                                                                                            d = f;
                                                                                        }
                                                                                        f = b;
                                                                                        break S;
                                                                                    }
                                                                                    while (1) {
                                                                                        k = (e - 1 | 0) == (k | 0) ? 0 : k + 1 | 0;
                                                                                        F[b + (f << 2) >> 2] = k;
                                                                                        e = F[i + 12 >> 2];
                                                                                        f = f + 1 | 0;
                                                                                        if (e >>> 0 > f >>> 0) {
                                                                                            continue;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    break R;
                                                                                }
                                                                                d = b;
                                                                            }
                                                                            b = F[i + 128 >> 2];
                                                                            e = b + e | 0;
                                                                            h = F[e >> 2];
                                                                            m = h + m | 0;
                                                                            F[m >> 2] = F[m >> 2] + 1;
                                                                            Ca(b + p | 0, h, F[e + 4 >> 2]);
                                                                            if (f) {
                                                                                e = F[g + 28 >> 2] + F[g + 24 >> 2] | 0;
                                                                                b = F[g + 12 >> 2];
                                                                                h = F[g + 16 >> 2] - b | 0;
                                                                                if ((e | 0) == ((h ? L(h >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                                    za(g + 8 | 0);
                                                                                    e = F[g + 24 >> 2] + F[g + 28 >> 2] | 0;
                                                                                    v = F[g + 12 >> 2];
                                                                                }
                                                                                else {
                                                                                    v = b;
                                                                                }
                                                                                b = (e >>> 0) / 341 | 0;
                                                                                b = F[v + (b << 2) >> 2] + L(e - L(b, 341) | 0, 12) | 0;
                                                                                F[b + 8 >> 2] = j;
                                                                                F[b + 4 >> 2] = k;
                                                                                F[b >> 2] = f;
                                                                                F[g + 28 >> 2] = F[g + 28 >> 2] + 1;
                                                                            }
                                                                            if (!d) {
                                                                                break P;
                                                                            }
                                                                            e = F[g + 28 >> 2] + F[g + 24 >> 2] | 0;
                                                                            f = F[g + 12 >> 2];
                                                                            b = F[g + 16 >> 2] - f | 0;
                                                                            if ((e | 0) == ((b ? L(b >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                                za(g + 8 | 0);
                                                                                e = F[g + 24 >> 2] + F[g + 28 >> 2] | 0;
                                                                                f = F[g + 12 >> 2];
                                                                            }
                                                                            b = (e >>> 0) / 341 | 0;
                                                                            b = F[f + (b << 2) >> 2] + L(e - L(b, 341) | 0, 12) | 0;
                                                                            F[b + 8 >> 2] = l;
                                                                            F[b + 4 >> 2] = k;
                                                                            F[b >> 2] = d;
                                                                            F[g + 28 >> 2] = F[g + 28 >> 2] + 1;
                                                                            break P;
                                                                        }
                                                                        k = 0;
                                                                        if (!d) {
                                                                            break P;
                                                                        }
                                                                        while (1) {
                                                                            f = F[i + 92 >> 2];
                                                                            if (e) {
                                                                                m = F[i + 36 >> 2];
                                                                                x = F[i + 104 >> 2];
                                                                                z = F[h >> 2];
                                                                                s = F[p >> 2];
                                                                                e = 0;
                                                                                while (1) {
                                                                                    o = x + (e << 2) | 0;
                                                                                    F[(F[o >> 2] << 2) + f >> 2] = 0;
                                                                                    j = F[o >> 2] << 2;
                                                                                    b = F[i >> 2] - F[j + s >> 2] | 0;
                                                                                    X: {
                                                                                        if (!b) {
                                                                                            break X;
                                                                                        }
                                                                                        j = f + j | 0;
                                                                                        l = F[i + 48 >> 2];
                                                                                        u = 32 - l | 0;
                                                                                        if ((u | 0) >= (b | 0)) {
                                                                                            n = F[i + 44 >> 2];
                                                                                            if ((n | 0) == (m | 0)) {
                                                                                                F[j >> 2] = 0;
                                                                                                break X;
                                                                                            }
                                                                                            F[j >> 2] = F[n >> 2] << l >>> 32 - b;
                                                                                            b = b + F[i + 48 >> 2] | 0;
                                                                                            F[i + 48 >> 2] = b;
                                                                                            if ((b | 0) != 32) {
                                                                                                break X;
                                                                                            }
                                                                                            F[i + 48 >> 2] = 0;
                                                                                            F[i + 44 >> 2] = n + 4;
                                                                                            break X;
                                                                                        }
                                                                                        n = F[i + 44 >> 2];
                                                                                        y = n + 4 | 0;
                                                                                        if ((y | 0) == (m | 0)) {
                                                                                            F[j >> 2] = 0;
                                                                                            break X;
                                                                                        }
                                                                                        v = F[n >> 2];
                                                                                        F[i + 44 >> 2] = y;
                                                                                        u = b - u | 0;
                                                                                        F[i + 48 >> 2] = u;
                                                                                        F[j >> 2] = F[n + 4 >> 2] >>> 32 - u | v << l >>> 32 - b;
                                                                                    }
                                                                                    b = F[o >> 2] << 2;
                                                                                    j = b + f | 0;
                                                                                    F[j >> 2] = F[j >> 2] | F[b + z >> 2];
                                                                                    e = e + 1 | 0;
                                                                                    if (e >>> 0 < I[i + 12 >> 2]) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                                f = F[i + 92 >> 2];
                                                                            }
                                                                            F[g + 32 >> 2] = F[f >> 2];
                                                                            F[g + 36 >> 2] = F[f + 4 >> 2];
                                                                            F[g + 40 >> 2] = F[f + 8 >> 2];
                                                                            nb(F[q >> 2], g + 32 | 0);
                                                                            F[i + 8 >> 2] = F[i + 8 >> 2] + 1;
                                                                            k = k + 1 | 0;
                                                                            if ((d | 0) == (k | 0)) {
                                                                                break P;
                                                                            }
                                                                            e = F[i + 12 >> 2];
                                                                            continue;
                                                                        }
                                                                    }
                                                                    e = F[g + 28 >> 2];
                                                                    if (e) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            F[g + 28 >> 2] = 0;
                                                            e = F[g + 16 >> 2];
                                                            b = F[g + 12 >> 2];
                                                            k = e - b | 0;
                                                            if (k >>> 0 >= 9) {
                                                                while (1) {
                                                                    ra(F[b >> 2]);
                                                                    b = F[g + 12 >> 2] + 4 | 0;
                                                                    F[g + 12 >> 2] = b;
                                                                    e = F[g + 16 >> 2];
                                                                    k = e - b | 0;
                                                                    if (k >>> 0 > 8) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            f = 170;
                                                            Y: {
                                                                switch ((k >>> 2 | 0) - 1 | 0) {
                                                                    case 1: f = 341;
                                                                    case 0:
                                                                        F[g + 24 >> 2] = f;
                                                                        break;
                                                                    default: break Y;
                                                                }
                                                            }
                                                            Z: {
                                                                if ((b | 0) == (e | 0)) {
                                                                    break Z;
                                                                }
                                                                while (1) {
                                                                    ra(F[b >> 2]);
                                                                    b = b + 4 | 0;
                                                                    if ((e | 0) != (b | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                b = F[g + 16 >> 2];
                                                                d = F[g + 12 >> 2];
                                                                if ((b | 0) == (d | 0)) {
                                                                    break Z;
                                                                }
                                                                F[g + 16 >> 2] = b + (((b - d | 0) - 4 >>> 2 ^ -1) << 2);
                                                            }
                                                            b = F[g + 8 >> 2];
                                                            if (b) {
                                                                ra(b);
                                                            }
                                                            ea = g + 48 | 0;
                                                            break N;
                                                        }
                                                    }
                                                    yb(i);
                                                    break d;
                                                case 3:
                                                    j = xb(w + 8 | 0, 3);
                                                    t = w + 664 | 0;
                                                    f = F[b + 12 >> 2];
                                                    d = F[b + 20 >> 2];
                                                    e = F[b + 16 >> 2];
                                                    h = e + 4 | 0;
                                                    d = h >>> 0 < 4 ? d + 1 | 0 : d;
                                                    _: {
                                                        if (h >>> 0 > I[b + 8 >> 2] & (d | 0) >= (f | 0) | (d | 0) > (f | 0)) {
                                                            break _;
                                                        }
                                                        d = e + F[b >> 2] | 0;
                                                        F[j >> 2] = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                                        d = F[b + 20 >> 2];
                                                        f = d;
                                                        h = F[b + 16 >> 2];
                                                        e = h + 4 | 0;
                                                        d = e >>> 0 < 4 ? d + 1 | 0 : d;
                                                        k = e;
                                                        F[b + 16 >> 2] = e;
                                                        F[b + 20 >> 2] = d;
                                                        if (I[j >> 2] > 32) {
                                                            break _;
                                                        }
                                                        e = F[b + 12 >> 2];
                                                        d = f;
                                                        f = h + 8 | 0;
                                                        d = f >>> 0 < 8 ? d + 1 | 0 : d;
                                                        if (f >>> 0 > I[b + 8 >> 2] & (d | 0) >= (e | 0) | (d | 0) > (e | 0)) {
                                                            break _;
                                                        }
                                                        d = k + F[b >> 2] | 0;
                                                        f = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                                        F[j + 4 >> 2] = f;
                                                        d = F[b + 20 >> 2];
                                                        e = F[b + 16 >> 2] + 4 | 0;
                                                        d = e >>> 0 < 4 ? d + 1 | 0 : d;
                                                        F[b + 16 >> 2] = e;
                                                        F[b + 20 >> 2] = d;
                                                        if (!f) {
                                                            break _;
                                                        }
                                                        F[j + 8 >> 2] = 0;
                                                        if (!xa(j + 16 | 0, b)) {
                                                            break _;
                                                        }
                                                        if (!ya(j + 32 | 0, b)) {
                                                            break _;
                                                        }
                                                        if (!ya(j + 52 | 0, b)) {
                                                            break _;
                                                        }
                                                        if (!ya(j + 72 | 0, b)) {
                                                            break _;
                                                        }
                                                        p = F[j + 4 >> 2];
                                                        f = 0;
                                                        h = ea - 48 | 0;
                                                        ea = h;
                                                        e = F[j + 12 >> 2];
                                                        F[h + 16 >> 2] = 0;
                                                        F[h + 8 >> 2] = 0;
                                                        F[h + 12 >> 2] = 0;
                                                        if (e) {
                                                            if (e >>> 0 >= 1073741824) {
                                                                break a;
                                                            }
                                                            b = e << 2;
                                                            g = sa(b);
                                                            F[h + 8 >> 2] = g;
                                                            f = b + g | 0;
                                                            F[h + 16 >> 2] = f;
                                                            ua(g, 0, b);
                                                            F[h + 12 >> 2] = f;
                                                        }
                                                        b = F[j + 116 >> 2];
                                                        d = F[b >> 2];
                                                        if (d) {
                                                            F[b + 4 >> 2] = d;
                                                            ra(d);
                                                            F[b + 8 >> 2] = 0;
                                                            F[b >> 2] = 0;
                                                            F[b + 4 >> 2] = 0;
                                                            g = F[h + 8 >> 2];
                                                            e = F[j + 12 >> 2];
                                                            f = F[h + 12 >> 2];
                                                        }
                                                        F[b + 4 >> 2] = f;
                                                        F[b >> 2] = g;
                                                        F[b + 8 >> 2] = F[h + 16 >> 2];
                                                        g = 0;
                                                        F[h + 16 >> 2] = 0;
                                                        F[h + 8 >> 2] = 0;
                                                        F[h + 12 >> 2] = 0;
                                                        $: {
                                                            if (e) {
                                                                if (e >>> 0 >= 1073741824) {
                                                                    break a;
                                                                }
                                                                b = e << 2;
                                                                i = sa(b);
                                                                F[h + 8 >> 2] = i;
                                                                g = b + i | 0;
                                                                F[h + 16 >> 2] = g;
                                                                ua(i, 0, b);
                                                                F[h + 12 >> 2] = g;
                                                            }
                                                            b = F[j + 128 >> 2];
                                                            d = F[b >> 2];
                                                            if (d) {
                                                                F[b + 4 >> 2] = d;
                                                                ra(d);
                                                                F[b + 8 >> 2] = 0;
                                                                F[b >> 2] = 0;
                                                                F[b + 4 >> 2] = 0;
                                                                i = F[h + 8 >> 2];
                                                                g = F[h + 12 >> 2];
                                                            }
                                                            F[b + 4 >> 2] = g;
                                                            F[b >> 2] = i;
                                                            F[b + 8 >> 2] = F[h + 16 >> 2];
                                                            F[h + 24 >> 2] = 0;
                                                            F[h + 28 >> 2] = 0;
                                                            F[h + 16 >> 2] = 0;
                                                            F[h + 20 >> 2] = 0;
                                                            F[h + 8 >> 2] = 0;
                                                            F[h + 12 >> 2] = 0;
                                                            za(h + 8 | 0);
                                                            b = F[h + 24 >> 2] + F[h + 28 >> 2] | 0;
                                                            d = (b >>> 0) / 341 | 0;
                                                            b = F[F[h + 12 >> 2] + (d << 2) >> 2] + L(b - L(d, 341) | 0, 12) | 0;
                                                            F[b + 4 >> 2] = 0;
                                                            F[b + 8 >> 2] = 0;
                                                            F[b >> 2] = p;
                                                            b = F[h + 28 >> 2];
                                                            e = b + 1 | 0;
                                                            F[h + 28 >> 2] = e;
                                                            aa: {
                                                                if (b >>> 0 > e >>> 0) {
                                                                    break aa;
                                                                }
                                                                n = j + 16 | 0;
                                                                while (1) {
                                                                    i = F[h + 12 >> 2];
                                                                    f = F[h + 24 >> 2];
                                                                    g = e - 1 | 0;
                                                                    b = f + g | 0;
                                                                    d = (b >>> 0) / 341 | 0;
                                                                    b = F[i + (d << 2) >> 2] + L(b - L(d, 341) | 0, 12) | 0;
                                                                    k = F[b + 8 >> 2];
                                                                    d = F[b + 4 >> 2];
                                                                    b = F[b >> 2];
                                                                    F[h + 28 >> 2] = g;
                                                                    g = F[h + 16 >> 2];
                                                                    i = g - i | 0;
                                                                    if (((i ? L(i >> 2, 341) - 1 | 0 : 0) - (e + f | 0) | 0) + 1 >>> 0 >= 682) {
                                                                        ra(F[g - 4 >> 2]);
                                                                        F[h + 16 >> 2] = F[h + 16 >> 2] - 4;
                                                                    }
                                                                    if (b >>> 0 > p >>> 0) {
                                                                        break aa;
                                                                    }
                                                                    f = 0;
                                                                    g = F[j + 12 >> 2];
                                                                    i = (d | 0) == (g - 1 | 0) ? 0 : d + 1 | 0;
                                                                    if (i >>> 0 >= g >>> 0) {
                                                                        break aa;
                                                                    }
                                                                    d = F[j + 116 >> 2];
                                                                    g = L(k, 12);
                                                                    q = d + g | 0;
                                                                    ba: {
                                                                        e = i << 2;
                                                                        r = g + F[j + 128 >> 2] | 0;
                                                                        m = F[j >> 2] - F[e + F[r >> 2] >> 2] | 0;
                                                                        if (!m) {
                                                                            if (!b) {
                                                                                break ba;
                                                                            }
                                                                            while (1) {
                                                                                d = F[q >> 2];
                                                                                k = F[d + 8 >> 2];
                                                                                m = F[d + 4 >> 2];
                                                                                o = F[d >> 2];
                                                                                d = F[t >> 2];
                                                                                e = F[d + 4 >> 2];
                                                                                l = F[d + 8 >> 2];
                                                                                ca: {
                                                                                    if (e >>> 0 < l >>> 0) {
                                                                                        F[e + 8 >> 2] = k;
                                                                                        F[e + 4 >> 2] = m;
                                                                                        F[e >> 2] = o;
                                                                                        F[d + 4 >> 2] = e + 12;
                                                                                        break ca;
                                                                                    }
                                                                                    g = F[d >> 2];
                                                                                    r = (e - g | 0) / 12 | 0;
                                                                                    i = r + 1 | 0;
                                                                                    if (i >>> 0 >= 357913942) {
                                                                                        break a;
                                                                                    }
                                                                                    l = (l - g | 0) / 12 | 0;
                                                                                    x = l << 1;
                                                                                    i = l >>> 0 < 178956970 ? i >>> 0 > x >>> 0 ? i : x : 357913941;
                                                                                    if (i >>> 0 >= 357913942) {
                                                                                        break b;
                                                                                    }
                                                                                    v = L(r, 12);
                                                                                    l = L(i, 12);
                                                                                    r = sa(l);
                                                                                    i = v + r | 0;
                                                                                    F[i + 8 >> 2] = k;
                                                                                    F[i + 4 >> 2] = m;
                                                                                    F[i >> 2] = o;
                                                                                    k = i + 12 | 0;
                                                                                    if ((e | 0) != (g | 0)) {
                                                                                        while (1) {
                                                                                            i = i - 12 | 0;
                                                                                            e = e - 12 | 0;
                                                                                            F[i >> 2] = F[e >> 2];
                                                                                            F[i + 4 >> 2] = F[e + 4 >> 2];
                                                                                            F[i + 8 >> 2] = F[e + 8 >> 2];
                                                                                            if ((e | 0) != (g | 0)) {
                                                                                                continue;
                                                                                            }
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    F[d + 8 >> 2] = l + r;
                                                                                    F[d + 4 >> 2] = k;
                                                                                    F[d >> 2] = i;
                                                                                    if (!g) {
                                                                                        break ca;
                                                                                    }
                                                                                    ra(g);
                                                                                }
                                                                                F[j + 8 >> 2] = F[j + 8 >> 2] + 1;
                                                                                f = f + 1 | 0;
                                                                                if ((b | 0) != (f | 0)) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                            break ba;
                                                                        }
                                                                        da: {
                                                                            ea: {
                                                                                fa: {
                                                                                    ga: {
                                                                                        if (b >>> 0 <= 2) {
                                                                                            d = F[j + 104 >> 2];
                                                                                            F[d >> 2] = i;
                                                                                            g = 1;
                                                                                            e = F[j + 12 >> 2];
                                                                                            if (e >>> 0 > 1) {
                                                                                                break ga;
                                                                                            }
                                                                                            break da;
                                                                                        }
                                                                                        if (I[j + 8 >> 2] > I[j + 4 >> 2]) {
                                                                                            break aa;
                                                                                        }
                                                                                        f = d;
                                                                                        d = g + 12 | 0;
                                                                                        Ca(f + d | 0, F[q >> 2], F[q + 4 >> 2]);
                                                                                        d = e + F[d + F[j + 116 >> 2] >> 2] | 0;
                                                                                        F[d >> 2] = F[d >> 2] + (1 << m - 1);
                                                                                        F[h + 32 >> 2] = 0;
                                                                                        qc(n, O(b) ^ 31, h + 32 | 0);
                                                                                        q = k + 1 | 0;
                                                                                        d = b;
                                                                                        b = (b >>> 1 | 0) - F[h + 32 >> 2] | 0;
                                                                                        f = d - b | 0;
                                                                                        ha: {
                                                                                            if ((f | 0) == (b | 0)) {
                                                                                                d = b;
                                                                                                break ha;
                                                                                            }
                                                                                            d = F[j + 84 >> 2];
                                                                                            if ((d | 0) == F[j + 76 >> 2]) {
                                                                                                break fa;
                                                                                            }
                                                                                            m = F[d >> 2];
                                                                                            o = F[j + 88 >> 2];
                                                                                            l = o + 1 | 0;
                                                                                            F[j + 88 >> 2] = l;
                                                                                            m = m & -2147483648 >>> o;
                                                                                            ia: {
                                                                                                if ((l | 0) == 32) {
                                                                                                    F[j + 88 >> 2] = 0;
                                                                                                    F[j + 84 >> 2] = d + 4;
                                                                                                    if (m) {
                                                                                                        break ia;
                                                                                                    }
                                                                                                    break fa;
                                                                                                }
                                                                                                if (!m) {
                                                                                                    break fa;
                                                                                                }
                                                                                            }
                                                                                            d = f;
                                                                                        }
                                                                                        f = b;
                                                                                        break ea;
                                                                                    }
                                                                                    while (1) {
                                                                                        i = (e - 1 | 0) == (i | 0) ? 0 : i + 1 | 0;
                                                                                        F[d + (g << 2) >> 2] = i;
                                                                                        e = F[j + 12 >> 2];
                                                                                        g = g + 1 | 0;
                                                                                        if (e >>> 0 > g >>> 0) {
                                                                                            continue;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    break da;
                                                                                }
                                                                                d = b;
                                                                            }
                                                                            v = e;
                                                                            b = F[j + 128 >> 2];
                                                                            g = b + g | 0;
                                                                            e = F[g >> 2];
                                                                            m = v + e | 0;
                                                                            F[m >> 2] = F[m >> 2] + 1;
                                                                            Ca(b + L(q, 12) | 0, e, F[g + 4 >> 2]);
                                                                            if (f) {
                                                                                e = F[h + 28 >> 2] + F[h + 24 >> 2] | 0;
                                                                                g = F[h + 12 >> 2];
                                                                                b = F[h + 16 >> 2] - g | 0;
                                                                                if ((e | 0) == ((b ? L(b >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                                    za(h + 8 | 0);
                                                                                    e = F[h + 24 >> 2] + F[h + 28 >> 2] | 0;
                                                                                    g = F[h + 12 >> 2];
                                                                                }
                                                                                b = (e >>> 0) / 341 | 0;
                                                                                b = F[g + (b << 2) >> 2] + L(e - L(b, 341) | 0, 12) | 0;
                                                                                F[b + 8 >> 2] = k;
                                                                                F[b + 4 >> 2] = i;
                                                                                F[b >> 2] = f;
                                                                                F[h + 28 >> 2] = F[h + 28 >> 2] + 1;
                                                                            }
                                                                            if (!d) {
                                                                                break ba;
                                                                            }
                                                                            e = F[h + 28 >> 2] + F[h + 24 >> 2] | 0;
                                                                            g = F[h + 12 >> 2];
                                                                            b = F[h + 16 >> 2] - g | 0;
                                                                            if ((e | 0) == ((b ? L(b >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                                za(h + 8 | 0);
                                                                                e = F[h + 24 >> 2] + F[h + 28 >> 2] | 0;
                                                                                g = F[h + 12 >> 2];
                                                                            }
                                                                            b = (e >>> 0) / 341 | 0;
                                                                            b = F[g + (b << 2) >> 2] + L(e - L(b, 341) | 0, 12) | 0;
                                                                            F[b + 8 >> 2] = q;
                                                                            F[b + 4 >> 2] = i;
                                                                            F[b >> 2] = d;
                                                                            F[h + 28 >> 2] = F[h + 28 >> 2] + 1;
                                                                            break ba;
                                                                        }
                                                                        k = 0;
                                                                        if (!b) {
                                                                            break ba;
                                                                        }
                                                                        while (1) {
                                                                            g = F[j + 92 >> 2];
                                                                            if (e) {
                                                                                i = F[j + 36 >> 2];
                                                                                x = F[j + 104 >> 2];
                                                                                z = F[q >> 2];
                                                                                s = F[r >> 2];
                                                                                e = 0;
                                                                                while (1) {
                                                                                    m = x + (e << 2) | 0;
                                                                                    F[(F[m >> 2] << 2) + g >> 2] = 0;
                                                                                    f = F[m >> 2] << 2;
                                                                                    d = F[j >> 2] - F[f + s >> 2] | 0;
                                                                                    ja: {
                                                                                        if (!d) {
                                                                                            break ja;
                                                                                        }
                                                                                        f = g + f | 0;
                                                                                        o = F[j + 48 >> 2];
                                                                                        u = 32 - o | 0;
                                                                                        if ((u | 0) >= (d | 0)) {
                                                                                            l = F[j + 44 >> 2];
                                                                                            if ((l | 0) == (i | 0)) {
                                                                                                F[f >> 2] = 0;
                                                                                                break ja;
                                                                                            }
                                                                                            F[f >> 2] = F[l >> 2] << o >>> 32 - d;
                                                                                            d = d + F[j + 48 >> 2] | 0;
                                                                                            F[j + 48 >> 2] = d;
                                                                                            if ((d | 0) != 32) {
                                                                                                break ja;
                                                                                            }
                                                                                            F[j + 48 >> 2] = 0;
                                                                                            F[j + 44 >> 2] = l + 4;
                                                                                            break ja;
                                                                                        }
                                                                                        l = F[j + 44 >> 2];
                                                                                        y = l + 4 | 0;
                                                                                        if ((y | 0) == (i | 0)) {
                                                                                            F[f >> 2] = 0;
                                                                                            break ja;
                                                                                        }
                                                                                        v = F[l >> 2];
                                                                                        F[j + 44 >> 2] = y;
                                                                                        u = d - u | 0;
                                                                                        F[j + 48 >> 2] = u;
                                                                                        F[f >> 2] = F[l + 4 >> 2] >>> 32 - u | v << o >>> 32 - d;
                                                                                    }
                                                                                    d = F[m >> 2] << 2;
                                                                                    f = d + g | 0;
                                                                                    F[f >> 2] = F[f >> 2] | F[d + z >> 2];
                                                                                    e = e + 1 | 0;
                                                                                    if (e >>> 0 < I[j + 12 >> 2]) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                                g = F[j + 92 >> 2];
                                                                            }
                                                                            F[h + 32 >> 2] = F[g >> 2];
                                                                            F[h + 36 >> 2] = F[g + 4 >> 2];
                                                                            F[h + 40 >> 2] = F[g + 8 >> 2];
                                                                            nb(F[t >> 2], h + 32 | 0);
                                                                            F[j + 8 >> 2] = F[j + 8 >> 2] + 1;
                                                                            k = k + 1 | 0;
                                                                            if ((b | 0) == (k | 0)) {
                                                                                break ba;
                                                                            }
                                                                            e = F[j + 12 >> 2];
                                                                            continue;
                                                                        }
                                                                    }
                                                                    e = F[h + 28 >> 2];
                                                                    if (e) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            F[h + 28 >> 2] = 0;
                                                            e = F[h + 16 >> 2];
                                                            b = F[h + 12 >> 2];
                                                            i = e - b | 0;
                                                            if (i >>> 0 >= 9) {
                                                                while (1) {
                                                                    ra(F[b >> 2]);
                                                                    b = F[h + 12 >> 2] + 4 | 0;
                                                                    F[h + 12 >> 2] = b;
                                                                    e = F[h + 16 >> 2];
                                                                    i = e - b | 0;
                                                                    if (i >>> 0 > 8) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            g = 170;
                                                            ka: {
                                                                switch ((i >>> 2 | 0) - 1 | 0) {
                                                                    case 1: g = 341;
                                                                    case 0:
                                                                        F[h + 24 >> 2] = g;
                                                                        break;
                                                                    default: break ka;
                                                                }
                                                            }
                                                            la: {
                                                                if ((b | 0) == (e | 0)) {
                                                                    break la;
                                                                }
                                                                while (1) {
                                                                    ra(F[b >> 2]);
                                                                    b = b + 4 | 0;
                                                                    if ((e | 0) != (b | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                b = F[h + 16 >> 2];
                                                                d = F[h + 12 >> 2];
                                                                if ((b | 0) == (d | 0)) {
                                                                    break la;
                                                                }
                                                                F[h + 16 >> 2] = b + (((b - d | 0) - 4 >>> 2 ^ -1) << 2);
                                                            }
                                                            b = F[h + 8 >> 2];
                                                            if (b) {
                                                                ra(b);
                                                            }
                                                            ea = h + 48 | 0;
                                                            break $;
                                                        }
                                                    }
                                                    yb(j);
                                                    break d;
                                                case 4:
                                                    i = ab(w + 8 | 0, 3);
                                                    q = w + 664 | 0;
                                                    f = F[b + 12 >> 2];
                                                    d = F[b + 20 >> 2];
                                                    e = F[b + 16 >> 2];
                                                    j = e + 4 | 0;
                                                    d = j >>> 0 < 4 ? d + 1 | 0 : d;
                                                    ma: {
                                                        if (j >>> 0 > I[b + 8 >> 2] & (d | 0) >= (f | 0) | (d | 0) > (f | 0)) {
                                                            break ma;
                                                        }
                                                        d = e + F[b >> 2] | 0;
                                                        F[i >> 2] = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                                        d = F[b + 20 >> 2];
                                                        f = d;
                                                        j = F[b + 16 >> 2];
                                                        e = j + 4 | 0;
                                                        d = e >>> 0 < 4 ? d + 1 | 0 : d;
                                                        k = e;
                                                        F[b + 16 >> 2] = e;
                                                        F[b + 20 >> 2] = d;
                                                        if (I[i >> 2] > 32) {
                                                            break ma;
                                                        }
                                                        e = F[b + 12 >> 2];
                                                        d = f;
                                                        f = j + 8 | 0;
                                                        d = f >>> 0 < 8 ? d + 1 | 0 : d;
                                                        if (f >>> 0 > I[b + 8 >> 2] & (d | 0) >= (e | 0) | (d | 0) > (e | 0)) {
                                                            break ma;
                                                        }
                                                        d = k + F[b >> 2] | 0;
                                                        f = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                                        F[i + 4 >> 2] = f;
                                                        d = F[b + 20 >> 2];
                                                        e = F[b + 16 >> 2] + 4 | 0;
                                                        d = e >>> 0 < 4 ? d + 1 | 0 : d;
                                                        F[b + 16 >> 2] = e;
                                                        F[b + 20 >> 2] = d;
                                                        if (!f) {
                                                            break ma;
                                                        }
                                                        F[i + 8 >> 2] = 0;
                                                        if (!vb(i + 16 | 0, b)) {
                                                            break ma;
                                                        }
                                                        if (!ya(i + 544 | 0, b)) {
                                                            break ma;
                                                        }
                                                        if (!ya(i + 564 | 0, b)) {
                                                            break ma;
                                                        }
                                                        if (!ya(i + 584 | 0, b)) {
                                                            break ma;
                                                        }
                                                        t = F[i + 4 >> 2];
                                                        d = 0;
                                                        e = ea - 48 | 0;
                                                        ea = e;
                                                        f = F[i + 12 >> 2];
                                                        F[e + 16 >> 2] = 0;
                                                        F[e + 8 >> 2] = 0;
                                                        F[e + 12 >> 2] = 0;
                                                        if (f) {
                                                            if (f >>> 0 >= 1073741824) {
                                                                break a;
                                                            }
                                                            b = f << 2;
                                                            g = sa(b);
                                                            F[e + 8 >> 2] = g;
                                                            d = b + g | 0;
                                                            F[e + 16 >> 2] = d;
                                                            ua(g, 0, b);
                                                            F[e + 12 >> 2] = d;
                                                        }
                                                        b = F[i + 628 >> 2];
                                                        j = F[b >> 2];
                                                        if (j) {
                                                            F[b + 4 >> 2] = j;
                                                            ra(j);
                                                            F[b + 8 >> 2] = 0;
                                                            F[b >> 2] = 0;
                                                            F[b + 4 >> 2] = 0;
                                                            f = F[i + 12 >> 2];
                                                            g = F[e + 8 >> 2];
                                                            d = F[e + 12 >> 2];
                                                        }
                                                        F[b + 4 >> 2] = d;
                                                        F[b >> 2] = g;
                                                        F[b + 8 >> 2] = F[e + 16 >> 2];
                                                        g = 0;
                                                        F[e + 16 >> 2] = 0;
                                                        F[e + 8 >> 2] = 0;
                                                        F[e + 12 >> 2] = 0;
                                                        na: {
                                                            if (f) {
                                                                if (f >>> 0 >= 1073741824) {
                                                                    break a;
                                                                }
                                                                b = f << 2;
                                                                h = sa(b);
                                                                F[e + 8 >> 2] = h;
                                                                g = b + h | 0;
                                                                F[e + 16 >> 2] = g;
                                                                ua(h, 0, b);
                                                                F[e + 12 >> 2] = g;
                                                            }
                                                            b = F[i + 640 >> 2];
                                                            d = F[b >> 2];
                                                            if (d) {
                                                                F[b + 4 >> 2] = d;
                                                                ra(d);
                                                                F[b + 8 >> 2] = 0;
                                                                F[b >> 2] = 0;
                                                                F[b + 4 >> 2] = 0;
                                                                h = F[e + 8 >> 2];
                                                                g = F[e + 12 >> 2];
                                                            }
                                                            F[b + 4 >> 2] = g;
                                                            F[b >> 2] = h;
                                                            F[b + 8 >> 2] = F[e + 16 >> 2];
                                                            F[e + 24 >> 2] = 0;
                                                            F[e + 28 >> 2] = 0;
                                                            F[e + 16 >> 2] = 0;
                                                            F[e + 20 >> 2] = 0;
                                                            F[e + 8 >> 2] = 0;
                                                            F[e + 12 >> 2] = 0;
                                                            za(e + 8 | 0);
                                                            b = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                            d = (b >>> 0) / 341 | 0;
                                                            b = F[F[e + 12 >> 2] + (d << 2) >> 2] + L(b - L(d, 341) | 0, 12) | 0;
                                                            F[b + 4 >> 2] = 0;
                                                            F[b + 8 >> 2] = 0;
                                                            F[b >> 2] = t;
                                                            b = F[e + 28 >> 2];
                                                            f = b + 1 | 0;
                                                            F[e + 28 >> 2] = f;
                                                            oa: {
                                                                if (b >>> 0 > f >>> 0) {
                                                                    break oa;
                                                                }
                                                                while (1) {
                                                                    p = F[e + 12 >> 2];
                                                                    h = F[e + 24 >> 2];
                                                                    j = f - 1 | 0;
                                                                    b = h + j | 0;
                                                                    d = (b >>> 0) / 341 | 0;
                                                                    b = F[p + (d << 2) >> 2] + L(b - L(d, 341) | 0, 12) | 0;
                                                                    k = F[b + 8 >> 2];
                                                                    g = F[b + 4 >> 2];
                                                                    d = F[b >> 2];
                                                                    F[e + 28 >> 2] = j;
                                                                    b = F[e + 16 >> 2];
                                                                    j = b - p | 0;
                                                                    if (((j ? L(j >> 2, 341) - 1 | 0 : 0) - (f + h | 0) | 0) + 1 >>> 0 >= 682) {
                                                                        ra(F[b - 4 >> 2]);
                                                                        F[e + 16 >> 2] = F[e + 16 >> 2] - 4;
                                                                    }
                                                                    if (d >>> 0 > t >>> 0) {
                                                                        break oa;
                                                                    }
                                                                    b = F[i + 12 >> 2];
                                                                    h = (g | 0) == (b - 1 | 0) ? 0 : g + 1 | 0;
                                                                    if (h >>> 0 >= b >>> 0) {
                                                                        break oa;
                                                                    }
                                                                    p = L(k, 12);
                                                                    m = p + F[i + 640 >> 2] | 0;
                                                                    j = p + F[i + 628 >> 2] | 0;
                                                                    pa: {
                                                                        qa: {
                                                                            o = h << 2;
                                                                            f = F[i >> 2] - F[o + F[m >> 2] >> 2] | 0;
                                                                            if (!f) {
                                                                                b = 0;
                                                                                if (!d) {
                                                                                    break qa;
                                                                                }
                                                                                while (1) {
                                                                                    f = F[j >> 2];
                                                                                    p = F[f + 8 >> 2];
                                                                                    m = F[f + 4 >> 2];
                                                                                    o = F[f >> 2];
                                                                                    g = F[q >> 2];
                                                                                    f = F[g + 4 >> 2];
                                                                                    l = F[g + 8 >> 2];
                                                                                    ra: {
                                                                                        if (f >>> 0 < l >>> 0) {
                                                                                            F[f + 8 >> 2] = p;
                                                                                            F[f + 4 >> 2] = m;
                                                                                            F[f >> 2] = o;
                                                                                            F[g + 4 >> 2] = f + 12;
                                                                                            break ra;
                                                                                        }
                                                                                        k = F[g >> 2];
                                                                                        n = (f - k | 0) / 12 | 0;
                                                                                        h = n + 1 | 0;
                                                                                        if (h >>> 0 >= 357913942) {
                                                                                            break a;
                                                                                        }
                                                                                        l = (l - k | 0) / 12 | 0;
                                                                                        r = l << 1;
                                                                                        h = l >>> 0 < 178956970 ? h >>> 0 > r >>> 0 ? h : r : 357913941;
                                                                                        if (h >>> 0 >= 357913942) {
                                                                                            break b;
                                                                                        }
                                                                                        v = L(n, 12);
                                                                                        l = L(h, 12);
                                                                                        n = sa(l);
                                                                                        h = v + n | 0;
                                                                                        F[h + 8 >> 2] = p;
                                                                                        F[h + 4 >> 2] = m;
                                                                                        F[h >> 2] = o;
                                                                                        p = h + 12 | 0;
                                                                                        if ((f | 0) != (k | 0)) {
                                                                                            while (1) {
                                                                                                h = h - 12 | 0;
                                                                                                f = f - 12 | 0;
                                                                                                F[h >> 2] = F[f >> 2];
                                                                                                F[h + 4 >> 2] = F[f + 4 >> 2];
                                                                                                F[h + 8 >> 2] = F[f + 8 >> 2];
                                                                                                if ((f | 0) != (k | 0)) {
                                                                                                    continue;
                                                                                                }
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        F[g + 8 >> 2] = l + n;
                                                                                        F[g + 4 >> 2] = p;
                                                                                        F[g >> 2] = h;
                                                                                        if (!k) {
                                                                                            break ra;
                                                                                        }
                                                                                        ra(k);
                                                                                    }
                                                                                    F[i + 8 >> 2] = F[i + 8 >> 2] + 1;
                                                                                    b = b + 1 | 0;
                                                                                    if ((d | 0) != (b | 0)) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                                break qa;
                                                                            }
                                                                            sa: {
                                                                                ta: {
                                                                                    ua: {
                                                                                        va: {
                                                                                            if (d >>> 0 <= 2) {
                                                                                                b = F[i + 616 >> 2];
                                                                                                F[b >> 2] = h;
                                                                                                g = 1;
                                                                                                f = F[i + 12 >> 2];
                                                                                                if (f >>> 0 > 1) {
                                                                                                    break va;
                                                                                                }
                                                                                                break sa;
                                                                                            }
                                                                                            if (I[i + 8 >> 2] > I[i + 4 >> 2]) {
                                                                                                break oa;
                                                                                            }
                                                                                            b = F[i + 628 >> 2];
                                                                                            l = k + 1 | 0;
                                                                                            m = L(l, 12);
                                                                                            g = b + m | 0;
                                                                                            if ((g | 0) != (j | 0)) {
                                                                                                Ca(g, F[j >> 2], F[j + 4 >> 2]);
                                                                                                b = F[i + 628 >> 2];
                                                                                            }
                                                                                            b = o + F[b + m >> 2] | 0;
                                                                                            F[b >> 2] = F[b >> 2] + (1 << f - 1);
                                                                                            g = 0;
                                                                                            f = 0;
                                                                                            b = O(d) ^ 31;
                                                                                            if (b) {
                                                                                                while (1) {
                                                                                                    g = Ga((i + (f << 4) | 0) + 16 | 0) | g << 1;
                                                                                                    f = f + 1 | 0;
                                                                                                    if ((b | 0) != (f | 0)) {
                                                                                                        continue;
                                                                                                    }
                                                                                                    break;
                                                                                                }
                                                                                            }
                                                                                            b = (d >>> 1 | 0) - g | 0;
                                                                                            f = d - b | 0;
                                                                                            wa: {
                                                                                                if ((f | 0) == (b | 0)) {
                                                                                                    d = b;
                                                                                                    break wa;
                                                                                                }
                                                                                                d = F[i + 596 >> 2];
                                                                                                if ((d | 0) == F[i + 588 >> 2]) {
                                                                                                    break ua;
                                                                                                }
                                                                                                g = F[d >> 2];
                                                                                                j = F[i + 600 >> 2];
                                                                                                n = j + 1 | 0;
                                                                                                F[i + 600 >> 2] = n;
                                                                                                g = g & -2147483648 >>> j;
                                                                                                xa: {
                                                                                                    if ((n | 0) == 32) {
                                                                                                        F[i + 600 >> 2] = 0;
                                                                                                        F[i + 596 >> 2] = d + 4;
                                                                                                        if (g) {
                                                                                                            break xa;
                                                                                                        }
                                                                                                        break ua;
                                                                                                    }
                                                                                                    if (!g) {
                                                                                                        break ua;
                                                                                                    }
                                                                                                }
                                                                                                d = f;
                                                                                            }
                                                                                            f = b;
                                                                                            break ta;
                                                                                        }
                                                                                        while (1) {
                                                                                            h = (f - 1 | 0) == (h | 0) ? 0 : h + 1 | 0;
                                                                                            F[b + (g << 2) >> 2] = h;
                                                                                            f = F[i + 12 >> 2];
                                                                                            g = g + 1 | 0;
                                                                                            if (f >>> 0 > g >>> 0) {
                                                                                                continue;
                                                                                            }
                                                                                            break;
                                                                                        }
                                                                                        break sa;
                                                                                    }
                                                                                    d = b;
                                                                                }
                                                                                b = F[i + 640 >> 2];
                                                                                g = b + p | 0;
                                                                                j = F[g >> 2];
                                                                                p = j + o | 0;
                                                                                F[p >> 2] = F[p >> 2] + 1;
                                                                                Ca(b + m | 0, j, F[g + 4 >> 2]);
                                                                                if (f) {
                                                                                    g = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                                                    b = F[e + 12 >> 2];
                                                                                    j = F[e + 16 >> 2] - b | 0;
                                                                                    if ((g | 0) == ((j ? L(j >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                                        za(e + 8 | 0);
                                                                                        g = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                                                        j = F[e + 12 >> 2];
                                                                                    }
                                                                                    else {
                                                                                        j = b;
                                                                                    }
                                                                                    b = (g >>> 0) / 341 | 0;
                                                                                    b = F[j + (b << 2) >> 2] + L(g - L(b, 341) | 0, 12) | 0;
                                                                                    F[b + 8 >> 2] = k;
                                                                                    F[b + 4 >> 2] = h;
                                                                                    F[b >> 2] = f;
                                                                                    F[e + 28 >> 2] = F[e + 28 >> 2] + 1;
                                                                                }
                                                                                if (!d) {
                                                                                    break qa;
                                                                                }
                                                                                f = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                                                g = F[e + 12 >> 2];
                                                                                b = F[e + 16 >> 2] - g | 0;
                                                                                if ((f | 0) == ((b ? L(b >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                                    za(e + 8 | 0);
                                                                                    g = F[e + 12 >> 2];
                                                                                    f = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                                                }
                                                                                b = (f >>> 0) / 341 | 0;
                                                                                b = F[(b << 2) + g >> 2] + L(f - L(b, 341) | 0, 12) | 0;
                                                                                F[b + 8 >> 2] = l;
                                                                                F[b + 4 >> 2] = h;
                                                                                F[b >> 2] = d;
                                                                                f = F[e + 28 >> 2] + 1 | 0;
                                                                                F[e + 28 >> 2] = f;
                                                                                break pa;
                                                                            }
                                                                            b = 0;
                                                                            if (!d) {
                                                                                break qa;
                                                                            }
                                                                            while (1) {
                                                                                g = F[i + 604 >> 2];
                                                                                if (f) {
                                                                                    p = F[i + 548 >> 2];
                                                                                    r = F[i + 616 >> 2];
                                                                                    x = F[j >> 2];
                                                                                    z = F[m >> 2];
                                                                                    f = 0;
                                                                                    while (1) {
                                                                                        o = r + (f << 2) | 0;
                                                                                        F[(F[o >> 2] << 2) + g >> 2] = 0;
                                                                                        k = F[o >> 2] << 2;
                                                                                        h = F[i >> 2] - F[k + z >> 2] | 0;
                                                                                        ya: {
                                                                                            if (!h) {
                                                                                                break ya;
                                                                                            }
                                                                                            k = g + k | 0;
                                                                                            l = F[i + 560 >> 2];
                                                                                            s = 32 - l | 0;
                                                                                            if ((s | 0) >= (h | 0)) {
                                                                                                n = F[i + 556 >> 2];
                                                                                                if ((n | 0) == (p | 0)) {
                                                                                                    F[k >> 2] = 0;
                                                                                                    break ya;
                                                                                                }
                                                                                                F[k >> 2] = F[n >> 2] << l >>> 32 - h;
                                                                                                h = h + F[i + 560 >> 2] | 0;
                                                                                                F[i + 560 >> 2] = h;
                                                                                                if ((h | 0) != 32) {
                                                                                                    break ya;
                                                                                                }
                                                                                                F[i + 560 >> 2] = 0;
                                                                                                F[i + 556 >> 2] = n + 4;
                                                                                                break ya;
                                                                                            }
                                                                                            n = F[i + 556 >> 2];
                                                                                            u = n + 4 | 0;
                                                                                            if ((u | 0) == (p | 0)) {
                                                                                                F[k >> 2] = 0;
                                                                                                break ya;
                                                                                            }
                                                                                            y = F[n >> 2];
                                                                                            F[i + 556 >> 2] = u;
                                                                                            s = h - s | 0;
                                                                                            F[i + 560 >> 2] = s;
                                                                                            F[k >> 2] = F[n + 4 >> 2] >>> 32 - s | y << l >>> 32 - h;
                                                                                        }
                                                                                        h = F[o >> 2] << 2;
                                                                                        k = h + g | 0;
                                                                                        F[k >> 2] = F[k >> 2] | F[h + x >> 2];
                                                                                        f = f + 1 | 0;
                                                                                        if (f >>> 0 < I[i + 12 >> 2]) {
                                                                                            continue;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    g = F[i + 604 >> 2];
                                                                                }
                                                                                F[e + 32 >> 2] = F[g >> 2];
                                                                                F[e + 36 >> 2] = F[g + 4 >> 2];
                                                                                F[e + 40 >> 2] = F[g + 8 >> 2];
                                                                                nb(F[q >> 2], e + 32 | 0);
                                                                                F[i + 8 >> 2] = F[i + 8 >> 2] + 1;
                                                                                b = b + 1 | 0;
                                                                                if ((d | 0) == (b | 0)) {
                                                                                    break qa;
                                                                                }
                                                                                f = F[i + 12 >> 2];
                                                                                continue;
                                                                            }
                                                                        }
                                                                        f = F[e + 28 >> 2];
                                                                    }
                                                                    if (f) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            F[e + 28 >> 2] = 0;
                                                            f = F[e + 16 >> 2];
                                                            b = F[e + 12 >> 2];
                                                            h = f - b | 0;
                                                            if (h >>> 0 >= 9) {
                                                                while (1) {
                                                                    ra(F[b >> 2]);
                                                                    b = F[e + 12 >> 2] + 4 | 0;
                                                                    F[e + 12 >> 2] = b;
                                                                    f = F[e + 16 >> 2];
                                                                    h = f - b | 0;
                                                                    if (h >>> 0 > 8) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            d = 170;
                                                            za: {
                                                                switch ((h >>> 2 | 0) - 1 | 0) {
                                                                    case 1: d = 341;
                                                                    case 0:
                                                                        F[e + 24 >> 2] = d;
                                                                        break;
                                                                    default: break za;
                                                                }
                                                            }
                                                            Aa: {
                                                                if ((b | 0) == (f | 0)) {
                                                                    break Aa;
                                                                }
                                                                while (1) {
                                                                    ra(F[b >> 2]);
                                                                    b = b + 4 | 0;
                                                                    if ((f | 0) != (b | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                b = F[e + 16 >> 2];
                                                                d = F[e + 12 >> 2];
                                                                if ((b | 0) == (d | 0)) {
                                                                    break Aa;
                                                                }
                                                                F[e + 16 >> 2] = b + (((b - d | 0) - 4 >>> 2 ^ -1) << 2);
                                                            }
                                                            b = F[e + 8 >> 2];
                                                            if (b) {
                                                                ra(b);
                                                            }
                                                            ea = e + 48 | 0;
                                                            break na;
                                                        }
                                                    }
                                                    bb(i);
                                                    break d;
                                                case 5:
                                                    h = ab(w + 8 | 0, 3);
                                                    t = w + 664 | 0;
                                                    f = F[b + 12 >> 2];
                                                    d = F[b + 20 >> 2];
                                                    e = F[b + 16 >> 2];
                                                    j = e + 4 | 0;
                                                    d = j >>> 0 < 4 ? d + 1 | 0 : d;
                                                    Ba: {
                                                        if (j >>> 0 > I[b + 8 >> 2] & (d | 0) >= (f | 0) | (d | 0) > (f | 0)) {
                                                            break Ba;
                                                        }
                                                        d = e + F[b >> 2] | 0;
                                                        F[h >> 2] = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                                        d = F[b + 20 >> 2];
                                                        f = d;
                                                        j = F[b + 16 >> 2];
                                                        e = j + 4 | 0;
                                                        d = e >>> 0 < 4 ? d + 1 | 0 : d;
                                                        k = e;
                                                        F[b + 16 >> 2] = e;
                                                        F[b + 20 >> 2] = d;
                                                        if (I[h >> 2] > 32) {
                                                            break Ba;
                                                        }
                                                        e = F[b + 12 >> 2];
                                                        d = f;
                                                        f = j + 8 | 0;
                                                        d = f >>> 0 < 8 ? d + 1 | 0 : d;
                                                        if (f >>> 0 > I[b + 8 >> 2] & (d | 0) >= (e | 0) | (d | 0) > (e | 0)) {
                                                            break Ba;
                                                        }
                                                        d = k + F[b >> 2] | 0;
                                                        f = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                                        F[h + 4 >> 2] = f;
                                                        d = F[b + 20 >> 2];
                                                        e = F[b + 16 >> 2] + 4 | 0;
                                                        d = e >>> 0 < 4 ? d + 1 | 0 : d;
                                                        F[b + 16 >> 2] = e;
                                                        F[b + 20 >> 2] = d;
                                                        if (!f) {
                                                            break Ba;
                                                        }
                                                        F[h + 8 >> 2] = 0;
                                                        if (!vb(h + 16 | 0, b)) {
                                                            break Ba;
                                                        }
                                                        if (!ya(h + 544 | 0, b)) {
                                                            break Ba;
                                                        }
                                                        if (!ya(h + 564 | 0, b)) {
                                                            break Ba;
                                                        }
                                                        if (!ya(h + 584 | 0, b)) {
                                                            break Ba;
                                                        }
                                                        p = F[h + 4 >> 2];
                                                        d = 0;
                                                        e = ea - 48 | 0;
                                                        ea = e;
                                                        f = F[h + 12 >> 2];
                                                        F[e + 16 >> 2] = 0;
                                                        F[e + 8 >> 2] = 0;
                                                        F[e + 12 >> 2] = 0;
                                                        if (f) {
                                                            if (f >>> 0 >= 1073741824) {
                                                                break a;
                                                            }
                                                            b = f << 2;
                                                            g = sa(b);
                                                            F[e + 8 >> 2] = g;
                                                            d = b + g | 0;
                                                            F[e + 16 >> 2] = d;
                                                            ua(g, 0, b);
                                                            F[e + 12 >> 2] = d;
                                                        }
                                                        b = F[h + 628 >> 2];
                                                        j = F[b >> 2];
                                                        if (j) {
                                                            F[b + 4 >> 2] = j;
                                                            ra(j);
                                                            F[b + 8 >> 2] = 0;
                                                            F[b >> 2] = 0;
                                                            F[b + 4 >> 2] = 0;
                                                            f = F[h + 12 >> 2];
                                                            g = F[e + 8 >> 2];
                                                            d = F[e + 12 >> 2];
                                                        }
                                                        F[b + 4 >> 2] = d;
                                                        F[b >> 2] = g;
                                                        F[b + 8 >> 2] = F[e + 16 >> 2];
                                                        g = 0;
                                                        F[e + 16 >> 2] = 0;
                                                        F[e + 8 >> 2] = 0;
                                                        F[e + 12 >> 2] = 0;
                                                        Ca: {
                                                            if (f) {
                                                                if (f >>> 0 >= 1073741824) {
                                                                    break a;
                                                                }
                                                                b = f << 2;
                                                                i = sa(b);
                                                                F[e + 8 >> 2] = i;
                                                                g = b + i | 0;
                                                                F[e + 16 >> 2] = g;
                                                                ua(i, 0, b);
                                                                F[e + 12 >> 2] = g;
                                                            }
                                                            b = F[h + 640 >> 2];
                                                            d = F[b >> 2];
                                                            if (d) {
                                                                F[b + 4 >> 2] = d;
                                                                ra(d);
                                                                F[b + 8 >> 2] = 0;
                                                                F[b >> 2] = 0;
                                                                F[b + 4 >> 2] = 0;
                                                                i = F[e + 8 >> 2];
                                                                g = F[e + 12 >> 2];
                                                            }
                                                            F[b + 4 >> 2] = g;
                                                            F[b >> 2] = i;
                                                            F[b + 8 >> 2] = F[e + 16 >> 2];
                                                            F[e + 24 >> 2] = 0;
                                                            F[e + 28 >> 2] = 0;
                                                            F[e + 16 >> 2] = 0;
                                                            F[e + 20 >> 2] = 0;
                                                            F[e + 8 >> 2] = 0;
                                                            F[e + 12 >> 2] = 0;
                                                            za(e + 8 | 0);
                                                            b = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                            d = (b >>> 0) / 341 | 0;
                                                            b = F[F[e + 12 >> 2] + (d << 2) >> 2] + L(b - L(d, 341) | 0, 12) | 0;
                                                            F[b + 4 >> 2] = 0;
                                                            F[b + 8 >> 2] = 0;
                                                            F[b >> 2] = p;
                                                            b = F[e + 28 >> 2];
                                                            f = b + 1 | 0;
                                                            F[e + 28 >> 2] = f;
                                                            Da: {
                                                                if (b >>> 0 > f >>> 0) {
                                                                    break Da;
                                                                }
                                                                while (1) {
                                                                    j = F[e + 12 >> 2];
                                                                    g = F[e + 24 >> 2];
                                                                    i = f - 1 | 0;
                                                                    b = g + i | 0;
                                                                    d = (b >>> 0) / 341 | 0;
                                                                    b = F[j + (d << 2) >> 2] + L(b - L(d, 341) | 0, 12) | 0;
                                                                    q = F[b + 8 >> 2];
                                                                    d = F[b + 4 >> 2];
                                                                    b = F[b >> 2];
                                                                    F[e + 28 >> 2] = i;
                                                                    i = F[e + 16 >> 2];
                                                                    j = i - j | 0;
                                                                    if (((j ? L(j >> 2, 341) - 1 | 0 : 0) - (g + f | 0) | 0) + 1 >>> 0 >= 682) {
                                                                        ra(F[i - 4 >> 2]);
                                                                        F[e + 16 >> 2] = F[e + 16 >> 2] - 4;
                                                                    }
                                                                    if (b >>> 0 > p >>> 0) {
                                                                        break Da;
                                                                    }
                                                                    f = F[h + 12 >> 2];
                                                                    i = (d | 0) == (f - 1 | 0) ? 0 : d + 1 | 0;
                                                                    if (i >>> 0 >= f >>> 0) {
                                                                        break Da;
                                                                    }
                                                                    d = F[h + 628 >> 2];
                                                                    j = L(q, 12);
                                                                    k = d + j | 0;
                                                                    Ea: {
                                                                        Fa: {
                                                                            m = i << 2;
                                                                            n = j + F[h + 640 >> 2] | 0;
                                                                            f = F[h >> 2] - F[m + F[n >> 2] >> 2] | 0;
                                                                            if (!f) {
                                                                                j = 0;
                                                                                if (!b) {
                                                                                    break Fa;
                                                                                }
                                                                                while (1) {
                                                                                    d = F[k >> 2];
                                                                                    q = F[d + 8 >> 2];
                                                                                    m = F[d + 4 >> 2];
                                                                                    o = F[d >> 2];
                                                                                    d = F[t >> 2];
                                                                                    f = F[d + 4 >> 2];
                                                                                    l = F[d + 8 >> 2];
                                                                                    Ga: {
                                                                                        if (f >>> 0 < l >>> 0) {
                                                                                            F[f + 8 >> 2] = q;
                                                                                            F[f + 4 >> 2] = m;
                                                                                            F[f >> 2] = o;
                                                                                            F[d + 4 >> 2] = f + 12;
                                                                                            break Ga;
                                                                                        }
                                                                                        g = F[d >> 2];
                                                                                        n = (f - g | 0) / 12 | 0;
                                                                                        i = n + 1 | 0;
                                                                                        if (i >>> 0 >= 357913942) {
                                                                                            break a;
                                                                                        }
                                                                                        l = (l - g | 0) / 12 | 0;
                                                                                        r = l << 1;
                                                                                        i = l >>> 0 < 178956970 ? i >>> 0 > r >>> 0 ? i : r : 357913941;
                                                                                        if (i >>> 0 >= 357913942) {
                                                                                            break b;
                                                                                        }
                                                                                        v = L(n, 12);
                                                                                        l = L(i, 12);
                                                                                        n = sa(l);
                                                                                        i = v + n | 0;
                                                                                        F[i + 8 >> 2] = q;
                                                                                        F[i + 4 >> 2] = m;
                                                                                        F[i >> 2] = o;
                                                                                        q = i + 12 | 0;
                                                                                        if ((g | 0) != (f | 0)) {
                                                                                            while (1) {
                                                                                                i = i - 12 | 0;
                                                                                                f = f - 12 | 0;
                                                                                                F[i >> 2] = F[f >> 2];
                                                                                                F[i + 4 >> 2] = F[f + 4 >> 2];
                                                                                                F[i + 8 >> 2] = F[f + 8 >> 2];
                                                                                                if ((g | 0) != (f | 0)) {
                                                                                                    continue;
                                                                                                }
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        F[d + 8 >> 2] = l + n;
                                                                                        F[d + 4 >> 2] = q;
                                                                                        F[d >> 2] = i;
                                                                                        if (!g) {
                                                                                            break Ga;
                                                                                        }
                                                                                        ra(g);
                                                                                    }
                                                                                    F[h + 8 >> 2] = F[h + 8 >> 2] + 1;
                                                                                    j = j + 1 | 0;
                                                                                    if ((b | 0) != (j | 0)) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                                break Fa;
                                                                            }
                                                                            Ha: {
                                                                                Ia: {
                                                                                    Ja: {
                                                                                        Ka: {
                                                                                            if (b >>> 0 <= 2) {
                                                                                                d = F[h + 616 >> 2];
                                                                                                F[d >> 2] = i;
                                                                                                g = 1;
                                                                                                f = F[h + 12 >> 2];
                                                                                                if (f >>> 0 > 1) {
                                                                                                    break Ka;
                                                                                                }
                                                                                                break Ha;
                                                                                            }
                                                                                            if (I[h + 8 >> 2] > I[h + 4 >> 2]) {
                                                                                                break Da;
                                                                                            }
                                                                                            g = d;
                                                                                            d = j + 12 | 0;
                                                                                            Ca(g + d | 0, F[k >> 2], F[k + 4 >> 2]);
                                                                                            d = m + F[d + F[h + 628 >> 2] >> 2] | 0;
                                                                                            F[d >> 2] = F[d >> 2] + (1 << f - 1);
                                                                                            g = 0;
                                                                                            f = 0;
                                                                                            d = O(b) ^ 31;
                                                                                            if (d) {
                                                                                                while (1) {
                                                                                                    g = Ga((h + (f << 4) | 0) + 16 | 0) | g << 1;
                                                                                                    f = f + 1 | 0;
                                                                                                    if ((d | 0) != (f | 0)) {
                                                                                                        continue;
                                                                                                    }
                                                                                                    break;
                                                                                                }
                                                                                            }
                                                                                            k = q + 1 | 0;
                                                                                            d = b;
                                                                                            b = (b >>> 1 | 0) - g | 0;
                                                                                            f = d - b | 0;
                                                                                            La: {
                                                                                                if ((f | 0) == (b | 0)) {
                                                                                                    d = b;
                                                                                                    break La;
                                                                                                }
                                                                                                d = F[h + 596 >> 2];
                                                                                                if ((d | 0) == F[h + 588 >> 2]) {
                                                                                                    break Ja;
                                                                                                }
                                                                                                g = F[d >> 2];
                                                                                                o = F[h + 600 >> 2];
                                                                                                l = o + 1 | 0;
                                                                                                F[h + 600 >> 2] = l;
                                                                                                g = g & -2147483648 >>> o;
                                                                                                Ma: {
                                                                                                    if ((l | 0) == 32) {
                                                                                                        F[h + 600 >> 2] = 0;
                                                                                                        F[h + 596 >> 2] = d + 4;
                                                                                                        if (g) {
                                                                                                            break Ma;
                                                                                                        }
                                                                                                        break Ja;
                                                                                                    }
                                                                                                    if (!g) {
                                                                                                        break Ja;
                                                                                                    }
                                                                                                }
                                                                                                d = f;
                                                                                            }
                                                                                            f = b;
                                                                                            break Ia;
                                                                                        }
                                                                                        while (1) {
                                                                                            i = (f - 1 | 0) == (i | 0) ? 0 : i + 1 | 0;
                                                                                            F[d + (g << 2) >> 2] = i;
                                                                                            f = F[h + 12 >> 2];
                                                                                            g = g + 1 | 0;
                                                                                            if (f >>> 0 > g >>> 0) {
                                                                                                continue;
                                                                                            }
                                                                                            break;
                                                                                        }
                                                                                        break Ha;
                                                                                    }
                                                                                    d = b;
                                                                                }
                                                                                b = F[h + 640 >> 2];
                                                                                g = b + j | 0;
                                                                                j = F[g >> 2];
                                                                                m = j + m | 0;
                                                                                F[m >> 2] = F[m >> 2] + 1;
                                                                                Ca(b + L(k, 12) | 0, j, F[g + 4 >> 2]);
                                                                                if (f) {
                                                                                    g = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                                                    j = F[e + 12 >> 2];
                                                                                    b = F[e + 16 >> 2] - j | 0;
                                                                                    if ((g | 0) == ((b ? L(b >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                                        za(e + 8 | 0);
                                                                                        j = F[e + 12 >> 2];
                                                                                        g = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                                                    }
                                                                                    b = (g >>> 0) / 341 | 0;
                                                                                    b = F[(b << 2) + j >> 2] + L(g - L(b, 341) | 0, 12) | 0;
                                                                                    F[b + 8 >> 2] = q;
                                                                                    F[b + 4 >> 2] = i;
                                                                                    F[b >> 2] = f;
                                                                                    F[e + 28 >> 2] = F[e + 28 >> 2] + 1;
                                                                                }
                                                                                if (!d) {
                                                                                    break Fa;
                                                                                }
                                                                                f = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                                                g = F[e + 12 >> 2];
                                                                                b = F[e + 16 >> 2] - g | 0;
                                                                                if ((f | 0) == ((b ? L(b >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                                    za(e + 8 | 0);
                                                                                    g = F[e + 12 >> 2];
                                                                                    f = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                                                }
                                                                                b = (f >>> 0) / 341 | 0;
                                                                                b = F[(b << 2) + g >> 2] + L(f - L(b, 341) | 0, 12) | 0;
                                                                                F[b + 8 >> 2] = k;
                                                                                F[b + 4 >> 2] = i;
                                                                                F[b >> 2] = d;
                                                                                f = F[e + 28 >> 2] + 1 | 0;
                                                                                F[e + 28 >> 2] = f;
                                                                                break Ea;
                                                                            }
                                                                            j = 0;
                                                                            if (!b) {
                                                                                break Fa;
                                                                            }
                                                                            while (1) {
                                                                                g = F[h + 604 >> 2];
                                                                                if (f) {
                                                                                    q = F[h + 548 >> 2];
                                                                                    r = F[h + 616 >> 2];
                                                                                    x = F[k >> 2];
                                                                                    z = F[n >> 2];
                                                                                    f = 0;
                                                                                    while (1) {
                                                                                        m = r + (f << 2) | 0;
                                                                                        F[(F[m >> 2] << 2) + g >> 2] = 0;
                                                                                        i = F[m >> 2] << 2;
                                                                                        d = F[h >> 2] - F[i + z >> 2] | 0;
                                                                                        Na: {
                                                                                            if (!d) {
                                                                                                break Na;
                                                                                            }
                                                                                            i = g + i | 0;
                                                                                            o = F[h + 560 >> 2];
                                                                                            s = 32 - o | 0;
                                                                                            if ((s | 0) >= (d | 0)) {
                                                                                                l = F[h + 556 >> 2];
                                                                                                if ((l | 0) == (q | 0)) {
                                                                                                    F[i >> 2] = 0;
                                                                                                    break Na;
                                                                                                }
                                                                                                F[i >> 2] = F[l >> 2] << o >>> 32 - d;
                                                                                                d = d + F[h + 560 >> 2] | 0;
                                                                                                F[h + 560 >> 2] = d;
                                                                                                if ((d | 0) != 32) {
                                                                                                    break Na;
                                                                                                }
                                                                                                F[h + 560 >> 2] = 0;
                                                                                                F[h + 556 >> 2] = l + 4;
                                                                                                break Na;
                                                                                            }
                                                                                            l = F[h + 556 >> 2];
                                                                                            u = l + 4 | 0;
                                                                                            if ((u | 0) == (q | 0)) {
                                                                                                F[i >> 2] = 0;
                                                                                                break Na;
                                                                                            }
                                                                                            y = F[l >> 2];
                                                                                            F[h + 556 >> 2] = u;
                                                                                            s = d - s | 0;
                                                                                            F[h + 560 >> 2] = s;
                                                                                            F[i >> 2] = F[l + 4 >> 2] >>> 32 - s | y << o >>> 32 - d;
                                                                                        }
                                                                                        d = F[m >> 2] << 2;
                                                                                        i = d + g | 0;
                                                                                        F[i >> 2] = F[i >> 2] | F[d + x >> 2];
                                                                                        f = f + 1 | 0;
                                                                                        if (f >>> 0 < I[h + 12 >> 2]) {
                                                                                            continue;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    g = F[h + 604 >> 2];
                                                                                }
                                                                                F[e + 32 >> 2] = F[g >> 2];
                                                                                F[e + 36 >> 2] = F[g + 4 >> 2];
                                                                                F[e + 40 >> 2] = F[g + 8 >> 2];
                                                                                nb(F[t >> 2], e + 32 | 0);
                                                                                F[h + 8 >> 2] = F[h + 8 >> 2] + 1;
                                                                                j = j + 1 | 0;
                                                                                if ((b | 0) == (j | 0)) {
                                                                                    break Fa;
                                                                                }
                                                                                f = F[h + 12 >> 2];
                                                                                continue;
                                                                            }
                                                                        }
                                                                        f = F[e + 28 >> 2];
                                                                    }
                                                                    if (f) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            F[e + 28 >> 2] = 0;
                                                            f = F[e + 16 >> 2];
                                                            b = F[e + 12 >> 2];
                                                            i = f - b | 0;
                                                            if (i >>> 0 >= 9) {
                                                                while (1) {
                                                                    ra(F[b >> 2]);
                                                                    b = F[e + 12 >> 2] + 4 | 0;
                                                                    F[e + 12 >> 2] = b;
                                                                    f = F[e + 16 >> 2];
                                                                    i = f - b | 0;
                                                                    if (i >>> 0 > 8) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            g = 170;
                                                            Oa: {
                                                                switch ((i >>> 2 | 0) - 1 | 0) {
                                                                    case 1: g = 341;
                                                                    case 0:
                                                                        F[e + 24 >> 2] = g;
                                                                        break;
                                                                    default: break Oa;
                                                                }
                                                            }
                                                            Pa: {
                                                                if ((b | 0) == (f | 0)) {
                                                                    break Pa;
                                                                }
                                                                while (1) {
                                                                    ra(F[b >> 2]);
                                                                    b = b + 4 | 0;
                                                                    if ((f | 0) != (b | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                b = F[e + 16 >> 2];
                                                                d = F[e + 12 >> 2];
                                                                if ((b | 0) == (d | 0)) {
                                                                    break Pa;
                                                                }
                                                                F[e + 16 >> 2] = b + (((b - d | 0) - 4 >>> 2 ^ -1) << 2);
                                                            }
                                                            b = F[e + 8 >> 2];
                                                            if (b) {
                                                                ra(b);
                                                            }
                                                            ea = e + 48 | 0;
                                                            break Ca;
                                                        }
                                                    }
                                                    bb(h);
                                                    break d;
                                                case 6: break f;
                                                default: break c;
                                            }
                                        }
                                        i = ab(w + 8 | 0, 3);
                                        q = w + 664 | 0;
                                        f = F[b + 12 >> 2];
                                        d = F[b + 20 >> 2];
                                        e = F[b + 16 >> 2];
                                        j = e + 4 | 0;
                                        d = j >>> 0 < 4 ? d + 1 | 0 : d;
                                        Qa: {
                                            if (j >>> 0 > I[b + 8 >> 2] & (d | 0) >= (f | 0) | (d | 0) > (f | 0)) {
                                                break Qa;
                                            }
                                            d = e + F[b >> 2] | 0;
                                            F[i >> 2] = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                            d = F[b + 20 >> 2];
                                            f = d;
                                            j = F[b + 16 >> 2];
                                            e = j + 4 | 0;
                                            d = e >>> 0 < 4 ? d + 1 | 0 : d;
                                            k = e;
                                            F[b + 16 >> 2] = e;
                                            F[b + 20 >> 2] = d;
                                            if (I[i >> 2] > 32) {
                                                break Qa;
                                            }
                                            e = F[b + 12 >> 2];
                                            d = f;
                                            f = j + 8 | 0;
                                            d = f >>> 0 < 8 ? d + 1 | 0 : d;
                                            if (f >>> 0 > I[b + 8 >> 2] & (d | 0) >= (e | 0) | (d | 0) > (e | 0)) {
                                                break Qa;
                                            }
                                            d = k + F[b >> 2] | 0;
                                            f = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                            F[i + 4 >> 2] = f;
                                            d = F[b + 20 >> 2];
                                            e = F[b + 16 >> 2] + 4 | 0;
                                            d = e >>> 0 < 4 ? d + 1 | 0 : d;
                                            F[b + 16 >> 2] = e;
                                            F[b + 20 >> 2] = d;
                                            if (!f) {
                                                break Qa;
                                            }
                                            F[i + 8 >> 2] = 0;
                                            if (!vb(i + 16 | 0, b)) {
                                                break Qa;
                                            }
                                            if (!ya(i + 544 | 0, b)) {
                                                break Qa;
                                            }
                                            if (!ya(i + 564 | 0, b)) {
                                                break Qa;
                                            }
                                            if (!ya(i + 584 | 0, b)) {
                                                break Qa;
                                            }
                                            t = F[i + 4 >> 2];
                                            d = 0;
                                            e = ea - 48 | 0;
                                            ea = e;
                                            f = F[i + 12 >> 2];
                                            F[e + 16 >> 2] = 0;
                                            F[e + 8 >> 2] = 0;
                                            F[e + 12 >> 2] = 0;
                                            if (f) {
                                                if (f >>> 0 >= 1073741824) {
                                                    break a;
                                                }
                                                b = f << 2;
                                                g = sa(b);
                                                F[e + 8 >> 2] = g;
                                                d = b + g | 0;
                                                F[e + 16 >> 2] = d;
                                                ua(g, 0, b);
                                                F[e + 12 >> 2] = d;
                                            }
                                            b = F[i + 628 >> 2];
                                            j = F[b >> 2];
                                            if (j) {
                                                F[b + 4 >> 2] = j;
                                                ra(j);
                                                F[b + 8 >> 2] = 0;
                                                F[b >> 2] = 0;
                                                F[b + 4 >> 2] = 0;
                                                f = F[i + 12 >> 2];
                                                g = F[e + 8 >> 2];
                                                d = F[e + 12 >> 2];
                                            }
                                            F[b + 4 >> 2] = d;
                                            F[b >> 2] = g;
                                            F[b + 8 >> 2] = F[e + 16 >> 2];
                                            g = 0;
                                            F[e + 16 >> 2] = 0;
                                            F[e + 8 >> 2] = 0;
                                            F[e + 12 >> 2] = 0;
                                            Ra: {
                                                if (f) {
                                                    if (f >>> 0 >= 1073741824) {
                                                        break a;
                                                    }
                                                    b = f << 2;
                                                    h = sa(b);
                                                    F[e + 8 >> 2] = h;
                                                    g = b + h | 0;
                                                    F[e + 16 >> 2] = g;
                                                    ua(h, 0, b);
                                                    F[e + 12 >> 2] = g;
                                                }
                                                b = F[i + 640 >> 2];
                                                d = F[b >> 2];
                                                if (d) {
                                                    F[b + 4 >> 2] = d;
                                                    ra(d);
                                                    F[b + 8 >> 2] = 0;
                                                    F[b >> 2] = 0;
                                                    F[b + 4 >> 2] = 0;
                                                    h = F[e + 8 >> 2];
                                                    g = F[e + 12 >> 2];
                                                }
                                                F[b + 4 >> 2] = g;
                                                F[b >> 2] = h;
                                                F[b + 8 >> 2] = F[e + 16 >> 2];
                                                F[e + 24 >> 2] = 0;
                                                F[e + 28 >> 2] = 0;
                                                F[e + 16 >> 2] = 0;
                                                F[e + 20 >> 2] = 0;
                                                F[e + 8 >> 2] = 0;
                                                F[e + 12 >> 2] = 0;
                                                za(e + 8 | 0);
                                                b = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                d = (b >>> 0) / 341 | 0;
                                                b = F[F[e + 12 >> 2] + (d << 2) >> 2] + L(b - L(d, 341) | 0, 12) | 0;
                                                F[b + 4 >> 2] = 0;
                                                F[b + 8 >> 2] = 0;
                                                F[b >> 2] = t;
                                                b = F[e + 28 >> 2];
                                                f = b + 1 | 0;
                                                F[e + 28 >> 2] = f;
                                                Sa: {
                                                    if (b >>> 0 > f >>> 0) {
                                                        break Sa;
                                                    }
                                                    while (1) {
                                                        j = F[e + 12 >> 2];
                                                        b = F[e + 24 >> 2];
                                                        g = f - 1 | 0;
                                                        d = b + g | 0;
                                                        h = (d >>> 0) / 341 | 0;
                                                        d = F[j + (h << 2) >> 2] + L(d - L(h, 341) | 0, 12) | 0;
                                                        k = F[d + 8 >> 2];
                                                        d = F[d >> 2];
                                                        F[e + 28 >> 2] = g;
                                                        g = F[e + 16 >> 2];
                                                        h = g - j | 0;
                                                        if (((h ? L(h >> 2, 341) - 1 | 0 : 0) - (b + f | 0) | 0) + 1 >>> 0 >= 682) {
                                                            ra(F[g - 4 >> 2]);
                                                            F[e + 16 >> 2] = F[e + 16 >> 2] - 4;
                                                        }
                                                        if (d >>> 0 > t >>> 0) {
                                                            break Sa;
                                                        }
                                                        b = F[i + 628 >> 2];
                                                        p = L(k, 12);
                                                        m = p + F[i + 640 >> 2] | 0;
                                                        h = Td(i, d, m);
                                                        if (h >>> 0 >= I[i + 12 >> 2]) {
                                                            break Sa;
                                                        }
                                                        j = b + p | 0;
                                                        Ta: {
                                                            Ua: {
                                                                o = h << 2;
                                                                f = F[i >> 2] - F[o + F[m >> 2] >> 2] | 0;
                                                                if (!f) {
                                                                    b = 0;
                                                                    if (!d) {
                                                                        break Ua;
                                                                    }
                                                                    while (1) {
                                                                        f = F[j >> 2];
                                                                        p = F[f + 8 >> 2];
                                                                        m = F[f + 4 >> 2];
                                                                        o = F[f >> 2];
                                                                        g = F[q >> 2];
                                                                        f = F[g + 4 >> 2];
                                                                        l = F[g + 8 >> 2];
                                                                        Va: {
                                                                            if (f >>> 0 < l >>> 0) {
                                                                                F[f + 8 >> 2] = p;
                                                                                F[f + 4 >> 2] = m;
                                                                                F[f >> 2] = o;
                                                                                F[g + 4 >> 2] = f + 12;
                                                                                break Va;
                                                                            }
                                                                            k = F[g >> 2];
                                                                            n = (f - k | 0) / 12 | 0;
                                                                            h = n + 1 | 0;
                                                                            if (h >>> 0 >= 357913942) {
                                                                                break a;
                                                                            }
                                                                            l = (l - k | 0) / 12 | 0;
                                                                            r = l << 1;
                                                                            h = l >>> 0 < 178956970 ? h >>> 0 > r >>> 0 ? h : r : 357913941;
                                                                            if (h >>> 0 >= 357913942) {
                                                                                break b;
                                                                            }
                                                                            v = L(n, 12);
                                                                            l = L(h, 12);
                                                                            n = sa(l);
                                                                            h = v + n | 0;
                                                                            F[h + 8 >> 2] = p;
                                                                            F[h + 4 >> 2] = m;
                                                                            F[h >> 2] = o;
                                                                            p = h + 12 | 0;
                                                                            if ((f | 0) != (k | 0)) {
                                                                                while (1) {
                                                                                    h = h - 12 | 0;
                                                                                    f = f - 12 | 0;
                                                                                    F[h >> 2] = F[f >> 2];
                                                                                    F[h + 4 >> 2] = F[f + 4 >> 2];
                                                                                    F[h + 8 >> 2] = F[f + 8 >> 2];
                                                                                    if ((f | 0) != (k | 0)) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                            }
                                                                            F[g + 8 >> 2] = l + n;
                                                                            F[g + 4 >> 2] = p;
                                                                            F[g >> 2] = h;
                                                                            if (!k) {
                                                                                break Va;
                                                                            }
                                                                            ra(k);
                                                                        }
                                                                        F[i + 8 >> 2] = F[i + 8 >> 2] + 1;
                                                                        b = b + 1 | 0;
                                                                        if ((d | 0) != (b | 0)) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    break Ua;
                                                                }
                                                                Wa: {
                                                                    Xa: {
                                                                        Ya: {
                                                                            Za: {
                                                                                if (d >>> 0 <= 2) {
                                                                                    b = F[i + 616 >> 2];
                                                                                    F[b >> 2] = h;
                                                                                    g = 1;
                                                                                    f = F[i + 12 >> 2];
                                                                                    if (f >>> 0 > 1) {
                                                                                        break Za;
                                                                                    }
                                                                                    break Wa;
                                                                                }
                                                                                if (I[i + 8 >> 2] > I[i + 4 >> 2]) {
                                                                                    break Sa;
                                                                                }
                                                                                b = F[i + 628 >> 2];
                                                                                l = k + 1 | 0;
                                                                                m = L(l, 12);
                                                                                g = b + m | 0;
                                                                                if ((g | 0) != (j | 0)) {
                                                                                    Ca(g, F[j >> 2], F[j + 4 >> 2]);
                                                                                    b = F[i + 628 >> 2];
                                                                                }
                                                                                b = o + F[b + m >> 2] | 0;
                                                                                F[b >> 2] = F[b >> 2] + (1 << f - 1);
                                                                                g = 0;
                                                                                f = 0;
                                                                                b = O(d) ^ 31;
                                                                                if (b) {
                                                                                    while (1) {
                                                                                        g = Ga((i + (f << 4) | 0) + 16 | 0) | g << 1;
                                                                                        f = f + 1 | 0;
                                                                                        if ((b | 0) != (f | 0)) {
                                                                                            continue;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                }
                                                                                b = (d >>> 1 | 0) - g | 0;
                                                                                f = d - b | 0;
                                                                                _a: {
                                                                                    if ((f | 0) == (b | 0)) {
                                                                                        d = b;
                                                                                        break _a;
                                                                                    }
                                                                                    d = F[i + 596 >> 2];
                                                                                    if ((d | 0) == F[i + 588 >> 2]) {
                                                                                        break Ya;
                                                                                    }
                                                                                    g = F[d >> 2];
                                                                                    j = F[i + 600 >> 2];
                                                                                    n = j + 1 | 0;
                                                                                    F[i + 600 >> 2] = n;
                                                                                    g = g & -2147483648 >>> j;
                                                                                    $a: {
                                                                                        if ((n | 0) == 32) {
                                                                                            F[i + 600 >> 2] = 0;
                                                                                            F[i + 596 >> 2] = d + 4;
                                                                                            if (g) {
                                                                                                break $a;
                                                                                            }
                                                                                            break Ya;
                                                                                        }
                                                                                        if (!g) {
                                                                                            break Ya;
                                                                                        }
                                                                                    }
                                                                                    d = f;
                                                                                }
                                                                                f = b;
                                                                                break Xa;
                                                                            }
                                                                            while (1) {
                                                                                h = (f - 1 | 0) == (h | 0) ? 0 : h + 1 | 0;
                                                                                F[b + (g << 2) >> 2] = h;
                                                                                f = F[i + 12 >> 2];
                                                                                g = g + 1 | 0;
                                                                                if (f >>> 0 > g >>> 0) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                            break Wa;
                                                                        }
                                                                        d = b;
                                                                    }
                                                                    b = F[i + 640 >> 2];
                                                                    g = b + p | 0;
                                                                    j = F[g >> 2];
                                                                    p = j + o | 0;
                                                                    F[p >> 2] = F[p >> 2] + 1;
                                                                    Ca(b + m | 0, j, F[g + 4 >> 2]);
                                                                    if (f) {
                                                                        g = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                                        b = F[e + 12 >> 2];
                                                                        j = F[e + 16 >> 2] - b | 0;
                                                                        if ((g | 0) == ((j ? L(j >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                            za(e + 8 | 0);
                                                                            g = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                                            j = F[e + 12 >> 2];
                                                                        }
                                                                        else {
                                                                            j = b;
                                                                        }
                                                                        b = (g >>> 0) / 341 | 0;
                                                                        b = F[j + (b << 2) >> 2] + L(g - L(b, 341) | 0, 12) | 0;
                                                                        F[b + 8 >> 2] = k;
                                                                        F[b + 4 >> 2] = h;
                                                                        F[b >> 2] = f;
                                                                        F[e + 28 >> 2] = F[e + 28 >> 2] + 1;
                                                                    }
                                                                    if (!d) {
                                                                        break Ua;
                                                                    }
                                                                    f = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                                    g = F[e + 12 >> 2];
                                                                    b = F[e + 16 >> 2] - g | 0;
                                                                    if ((f | 0) == ((b ? L(b >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                        za(e + 8 | 0);
                                                                        g = F[e + 12 >> 2];
                                                                        f = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                                    }
                                                                    b = (f >>> 0) / 341 | 0;
                                                                    b = F[(b << 2) + g >> 2] + L(f - L(b, 341) | 0, 12) | 0;
                                                                    F[b + 8 >> 2] = l;
                                                                    F[b + 4 >> 2] = h;
                                                                    F[b >> 2] = d;
                                                                    f = F[e + 28 >> 2] + 1 | 0;
                                                                    F[e + 28 >> 2] = f;
                                                                    break Ta;
                                                                }
                                                                b = 0;
                                                                if (!d) {
                                                                    break Ua;
                                                                }
                                                                while (1) {
                                                                    g = F[i + 604 >> 2];
                                                                    if (f) {
                                                                        p = F[i + 548 >> 2];
                                                                        r = F[i + 616 >> 2];
                                                                        x = F[j >> 2];
                                                                        z = F[m >> 2];
                                                                        f = 0;
                                                                        while (1) {
                                                                            o = r + (f << 2) | 0;
                                                                            F[(F[o >> 2] << 2) + g >> 2] = 0;
                                                                            k = F[o >> 2] << 2;
                                                                            h = F[i >> 2] - F[k + z >> 2] | 0;
                                                                            ab: {
                                                                                if (!h) {
                                                                                    break ab;
                                                                                }
                                                                                k = g + k | 0;
                                                                                l = F[i + 560 >> 2];
                                                                                s = 32 - l | 0;
                                                                                if ((s | 0) >= (h | 0)) {
                                                                                    n = F[i + 556 >> 2];
                                                                                    if ((n | 0) == (p | 0)) {
                                                                                        F[k >> 2] = 0;
                                                                                        break ab;
                                                                                    }
                                                                                    F[k >> 2] = F[n >> 2] << l >>> 32 - h;
                                                                                    h = h + F[i + 560 >> 2] | 0;
                                                                                    F[i + 560 >> 2] = h;
                                                                                    if ((h | 0) != 32) {
                                                                                        break ab;
                                                                                    }
                                                                                    F[i + 560 >> 2] = 0;
                                                                                    F[i + 556 >> 2] = n + 4;
                                                                                    break ab;
                                                                                }
                                                                                n = F[i + 556 >> 2];
                                                                                u = n + 4 | 0;
                                                                                if ((u | 0) == (p | 0)) {
                                                                                    F[k >> 2] = 0;
                                                                                    break ab;
                                                                                }
                                                                                y = F[n >> 2];
                                                                                F[i + 556 >> 2] = u;
                                                                                s = h - s | 0;
                                                                                F[i + 560 >> 2] = s;
                                                                                F[k >> 2] = F[n + 4 >> 2] >>> 32 - s | y << l >>> 32 - h;
                                                                            }
                                                                            h = F[o >> 2] << 2;
                                                                            k = h + g | 0;
                                                                            F[k >> 2] = F[k >> 2] | F[h + x >> 2];
                                                                            f = f + 1 | 0;
                                                                            if (f >>> 0 < I[i + 12 >> 2]) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        g = F[i + 604 >> 2];
                                                                    }
                                                                    F[e + 32 >> 2] = F[g >> 2];
                                                                    F[e + 36 >> 2] = F[g + 4 >> 2];
                                                                    F[e + 40 >> 2] = F[g + 8 >> 2];
                                                                    nb(F[q >> 2], e + 32 | 0);
                                                                    F[i + 8 >> 2] = F[i + 8 >> 2] + 1;
                                                                    b = b + 1 | 0;
                                                                    if ((d | 0) == (b | 0)) {
                                                                        break Ua;
                                                                    }
                                                                    f = F[i + 12 >> 2];
                                                                    continue;
                                                                }
                                                            }
                                                            f = F[e + 28 >> 2];
                                                        }
                                                        if (f) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                F[e + 28 >> 2] = 0;
                                                f = F[e + 16 >> 2];
                                                b = F[e + 12 >> 2];
                                                h = f - b | 0;
                                                if (h >>> 0 >= 9) {
                                                    while (1) {
                                                        ra(F[b >> 2]);
                                                        b = F[e + 12 >> 2] + 4 | 0;
                                                        F[e + 12 >> 2] = b;
                                                        f = F[e + 16 >> 2];
                                                        h = f - b | 0;
                                                        if (h >>> 0 > 8) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                d = 170;
                                                bb: {
                                                    switch ((h >>> 2 | 0) - 1 | 0) {
                                                        case 1: d = 341;
                                                        case 0:
                                                            F[e + 24 >> 2] = d;
                                                            break;
                                                        default: break bb;
                                                    }
                                                }
                                                cb: {
                                                    if ((b | 0) == (f | 0)) {
                                                        break cb;
                                                    }
                                                    while (1) {
                                                        ra(F[b >> 2]);
                                                        b = b + 4 | 0;
                                                        if ((f | 0) != (b | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    b = F[e + 16 >> 2];
                                                    d = F[e + 12 >> 2];
                                                    if ((b | 0) == (d | 0)) {
                                                        break cb;
                                                    }
                                                    F[e + 16 >> 2] = b + (((b - d | 0) - 4 >>> 2 ^ -1) << 2);
                                                }
                                                b = F[e + 8 >> 2];
                                                if (b) {
                                                    ra(b);
                                                }
                                                ea = e + 48 | 0;
                                                break Ra;
                                            }
                                        }
                                        bb(i);
                                    }
                                    g = F[a + 12 >> 2] == ((F[c + 4 >> 2] - F[c >> 2] | 0) / 12 | 0);
                                }
                                ea = w + 672 | 0;
                                return g;
                            }
                            wa(1336);
                            V();
                        } va(); V(); }
                        function ld(a, b, c, d) { var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0; if (!a) {
                            return 1;
                        } e = F[c + 20 >> 2]; g = F[c + 12 >> 2]; f = F[c + 16 >> 2]; a: {
                            if ((e | 0) >= (g | 0) & f >>> 0 >= I[c + 8 >> 2] | (e | 0) > (g | 0)) {
                                break a;
                            }
                            g = G[f + F[c >> 2] | 0];
                            f = f + 1 | 0;
                            e = f ? e : e + 1 | 0;
                            F[c + 16 >> 2] = f;
                            F[c + 20 >> 2] = e;
                            b: {
                                switch (g | 0) {
                                    case 0:
                                        k = a;
                                        h = b;
                                        f = d;
                                        a = 0;
                                        d = 0;
                                        o = ea + -64 | 0;
                                        ea = o;
                                        F[o + 56 >> 2] = 0;
                                        F[o + 48 >> 2] = 0;
                                        F[o + 52 >> 2] = 0;
                                        F[o + 40 >> 2] = 0;
                                        F[o + 44 >> 2] = 0;
                                        F[o + 32 >> 2] = 0;
                                        F[o + 36 >> 2] = 0;
                                        F[o + 24 >> 2] = 0;
                                        F[o + 28 >> 2] = 0;
                                        F[o + 16 >> 2] = 0;
                                        F[o + 20 >> 2] = 0;
                                        F[o + 8 >> 2] = 0;
                                        F[o + 12 >> 2] = 0;
                                        c: {
                                            if (!Je(o + 8 | 0, c)) {
                                                break c;
                                            }
                                            if (!Ie(o + 8 | 0, c) | (F[o + 20 >> 2] ? 0 : k)) {
                                                break c;
                                            }
                                            Eb(c, 0, 0);
                                            if (k) {
                                                p = h << 2;
                                                q = F[o + 36 >> 2];
                                                s = F[o + 48 >> 2];
                                                t = F[o + 24 >> 2];
                                                while (1) {
                                                    m = F[o + 56 >> 2];
                                                    d: {
                                                        if (m >>> 0 > 16383) {
                                                            break d;
                                                        }
                                                        a = F[o + 52 >> 2];
                                                        while (1) {
                                                            if ((a | 0) <= 0) {
                                                                break d;
                                                            }
                                                            a = a - 1 | 0;
                                                            F[o + 52 >> 2] = a;
                                                            m = G[a + s | 0] | m << 8;
                                                            F[o + 56 >> 2] = m;
                                                            if (m >>> 0 < 16384) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    a = m & 4095;
                                                    n = F[(a << 2) + t >> 2];
                                                    b = q + (n << 3) | 0;
                                                    F[o + 56 >> 2] = (L(F[b >> 2], m >>> 12 | 0) + a | 0) - F[b + 4 >> 2];
                                                    e: {
                                                        if ((h | 0) <= 0) {
                                                            break e;
                                                        }
                                                        a = 0;
                                                        if (!G[c + 36 | 0] | n >>> 0 > 32) {
                                                            break c;
                                                        }
                                                        if (n) {
                                                            w = n & -2;
                                                            x = n & 1;
                                                            g = d + h | 0;
                                                            b = F[c + 32 >> 2];
                                                            while (1) {
                                                                i = F[c + 28 >> 2];
                                                                j = F[c + 24 >> 2];
                                                                m = 0;
                                                                a = b;
                                                                e = 0;
                                                                r = 0;
                                                                if ((n | 0) != 1) {
                                                                    while (1) {
                                                                        l = j + (a >>> 3 | 0) | 0;
                                                                        f: {
                                                                            if (l >>> 0 >= i >>> 0) {
                                                                                l = 0;
                                                                                break f;
                                                                            }
                                                                            l = G[l | 0];
                                                                            b = a + 1 | 0;
                                                                            F[c + 32 >> 2] = b;
                                                                            l = l >>> (a & 7) & 1;
                                                                            a = b;
                                                                        }
                                                                        l = l << m | e;
                                                                        e = 0;
                                                                        u = j + (a >>> 3 | 0) | 0;
                                                                        if (u >>> 0 < i >>> 0) {
                                                                            e = G[u | 0];
                                                                            b = a + 1 | 0;
                                                                            F[c + 32 >> 2] = b;
                                                                            e = e >>> (a & 7) & 1;
                                                                            a = b;
                                                                        }
                                                                        u = m | 1;
                                                                        m = m + 2 | 0;
                                                                        e = l | e << u;
                                                                        r = r + 2 | 0;
                                                                        if ((w | 0) != (r | 0)) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                }
                                                                l = f + (d << 2) | 0;
                                                                if (x) {
                                                                    r = i;
                                                                    i = j + (a >>> 3 | 0) | 0;
                                                                    if (r >>> 0 > i >>> 0) {
                                                                        i = G[i | 0];
                                                                        b = a + 1 | 0;
                                                                        F[c + 32 >> 2] = b;
                                                                        a = i >>> (a & 7) & 1;
                                                                    }
                                                                    else {
                                                                        a = 0;
                                                                    }
                                                                    e = a << m | e;
                                                                }
                                                                F[l >> 2] = e;
                                                                d = d + 1 | 0;
                                                                if ((g | 0) != (d | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                            d = g;
                                                            break e;
                                                        }
                                                        ua(f + (d << 2) | 0, 0, p);
                                                        d = d + h | 0;
                                                    }
                                                    v = h + v | 0;
                                                    if (k >>> 0 > v >>> 0) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            D[c + 36 | 0] = 0;
                                            b = F[c + 20 >> 2];
                                            e = 0;
                                            a = F[c + 32 >> 2] + 7 | 0;
                                            e = a >>> 0 < 7 ? 1 : e;
                                            d = (e & 7) << 29 | a >>> 3;
                                            a = d + F[c + 16 >> 2] | 0;
                                            e = (e >>> 3 | 0) + b | 0;
                                            F[c + 16 >> 2] = a;
                                            F[c + 20 >> 2] = a >>> 0 < d >>> 0 ? e + 1 | 0 : e;
                                            a = 1;
                                        }
                                        b = F[o + 36 >> 2];
                                        if (b) {
                                            F[o + 40 >> 2] = b;
                                            ra(b);
                                        }
                                        b = F[o + 24 >> 2];
                                        if (b) {
                                            F[o + 28 >> 2] = b;
                                            ra(b);
                                        }
                                        b = F[o + 8 >> 2];
                                        if (b) {
                                            F[o + 12 >> 2] = b;
                                            ra(b);
                                        }
                                        ea = o - -64 | 0;
                                        return a;
                                    case 1: break b;
                                    default: break a;
                                }
                            }
                            b = 0;
                            e = F[c + 20 >> 2];
                            g = F[c + 12 >> 2];
                            f = F[c + 16 >> 2];
                            g: {
                                if ((e | 0) >= (g | 0) & f >>> 0 >= I[c + 8 >> 2] | (e | 0) > (g | 0)) {
                                    break g;
                                }
                                g = G[f + F[c >> 2] | 0];
                                f = f + 1 | 0;
                                e = f ? e : e + 1 | 0;
                                F[c + 16 >> 2] = f;
                                F[c + 20 >> 2] = e;
                                h: {
                                    switch (g - 1 | 0) {
                                        case 8:
                                            g = a;
                                            o = d;
                                            f = ea + -64 | 0;
                                            ea = f;
                                            F[f + 56 >> 2] = 0;
                                            F[f + 48 >> 2] = 0;
                                            F[f + 52 >> 2] = 0;
                                            F[f + 40 >> 2] = 0;
                                            F[f + 44 >> 2] = 0;
                                            F[f + 32 >> 2] = 0;
                                            F[f + 36 >> 2] = 0;
                                            F[f + 24 >> 2] = 0;
                                            F[f + 28 >> 2] = 0;
                                            F[f + 16 >> 2] = 0;
                                            F[f + 20 >> 2] = 0;
                                            F[f + 8 >> 2] = 0;
                                            F[f + 12 >> 2] = 0;
                                            n = f + 8 | 0;
                                            a = H[c + 38 >> 1];
                                            i: {
                                                j: {
                                                    if (!a) {
                                                        break j;
                                                    }
                                                    k: {
                                                        if (a >>> 0 <= 511) {
                                                            a = F[c + 12 >> 2];
                                                            e = F[c + 20 >> 2];
                                                            b = F[c + 16 >> 2];
                                                            d = b + 4 | 0;
                                                            e = d >>> 0 < 4 ? e + 1 | 0 : e;
                                                            if ((a | 0) <= (e | 0) & d >>> 0 > I[c + 8 >> 2] | (a | 0) < (e | 0)) {
                                                                break j;
                                                            }
                                                            a = b + F[c >> 2] | 0;
                                                            j = G[a | 0] | G[a + 1 | 0] << 8 | (G[a + 2 | 0] << 16 | G[a + 3 | 0] << 24);
                                                            F[n + 12 >> 2] = j;
                                                            e = F[c + 20 >> 2];
                                                            a = F[c + 16 >> 2] + 4 | 0;
                                                            e = a >>> 0 < 4 ? e + 1 | 0 : e;
                                                            F[c + 16 >> 2] = a;
                                                            F[c + 20 >> 2] = e;
                                                            break k;
                                                        }
                                                        if (!jb(1, n + 12 | 0, c)) {
                                                            break j;
                                                        }
                                                        j = F[n + 12 >> 2];
                                                    }
                                                    b = F[n >> 2];
                                                    a = F[n + 4 >> 2] - b >> 2;
                                                    l: {
                                                        if (a >>> 0 < j >>> 0) {
                                                            Aa(n, j - a | 0);
                                                            j = F[n + 12 >> 2];
                                                            break l;
                                                        }
                                                        if (a >>> 0 <= j >>> 0) {
                                                            break l;
                                                        }
                                                        F[n + 4 >> 2] = b + (j << 2);
                                                    }
                                                    d = 1;
                                                    if (!j) {
                                                        break i;
                                                    }
                                                    q = F[c + 8 >> 2];
                                                    l = F[c + 12 >> 2];
                                                    s = F[n >> 2];
                                                    b = 0;
                                                    while (1) {
                                                        e = F[c + 20 >> 2];
                                                        a = F[c + 16 >> 2];
                                                        d = 0;
                                                        if ((l | 0) <= (e | 0) & q >>> 0 <= a >>> 0 | (e | 0) > (l | 0)) {
                                                            break i;
                                                        }
                                                        d = F[c >> 2];
                                                        p = G[d + a | 0];
                                                        a = a + 1 | 0;
                                                        e = a ? e : e + 1 | 0;
                                                        h = a;
                                                        F[c + 16 >> 2] = a;
                                                        F[c + 20 >> 2] = e;
                                                        a = p >>> 2 | 0;
                                                        i = 0;
                                                        m: {
                                                            n: {
                                                                o: {
                                                                    p: {
                                                                        t = p & 3;
                                                                        switch (t | 0) {
                                                                            case 0: break n;
                                                                            case 3: break p;
                                                                            default: break o;
                                                                        }
                                                                    }
                                                                    a = a + b | 0;
                                                                    d = 0;
                                                                    if (a >>> 0 >= j >>> 0) {
                                                                        break i;
                                                                    }
                                                                    ua(s + (b << 2) | 0, 0, (p & 252) + 4 | 0);
                                                                    b = a;
                                                                    break m;
                                                                }
                                                                while (1) {
                                                                    if ((e | 0) >= (l | 0) & h >>> 0 >= q >>> 0 | (e | 0) > (l | 0)) {
                                                                        break j;
                                                                    }
                                                                    j = G[d + h | 0];
                                                                    h = h + 1 | 0;
                                                                    e = h ? e : e + 1 | 0;
                                                                    F[c + 16 >> 2] = h;
                                                                    F[c + 20 >> 2] = e;
                                                                    a = j << (i << 3 | 6) | a;
                                                                    i = i + 1 | 0;
                                                                    if ((t | 0) != (i | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            F[s + (b << 2) >> 2] = a;
                                                        }
                                                        b = b + 1 | 0;
                                                        j = F[n + 12 >> 2];
                                                        if (b >>> 0 < j >>> 0) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    h = n + 16 | 0;
                                                    p = F[n >> 2];
                                                    b = F[n + 16 >> 2];
                                                    a = F[n + 20 >> 2] - b | 0;
                                                    q: {
                                                        if (a >>> 0 <= 32767) {
                                                            Aa(h, 8192 - (a >>> 2 | 0) | 0);
                                                            break q;
                                                        }
                                                        if ((a | 0) == 32768) {
                                                            break q;
                                                        }
                                                        F[n + 20 >> 2] = b + 32768;
                                                    }
                                                    a = n + 28 | 0;
                                                    b = F[a >> 2];
                                                    d = F[n + 32 >> 2] - b >> 3;
                                                    r: {
                                                        if (d >>> 0 < j >>> 0) {
                                                            tb(a, j - d | 0);
                                                            b = F[a >> 2];
                                                            break r;
                                                        }
                                                        if (d >>> 0 > j >>> 0) {
                                                            F[n + 32 >> 2] = (j << 3) + b;
                                                        }
                                                        if (!j) {
                                                            break j;
                                                        }
                                                    }
                                                    i = 0;
                                                    d = 0;
                                                    while (1) {
                                                        e = p + (i << 2) | 0;
                                                        n = F[e >> 2];
                                                        l = (i << 3) + b | 0;
                                                        a = d;
                                                        F[l + 4 >> 2] = a;
                                                        F[l >> 2] = n;
                                                        e = F[e >> 2];
                                                        d = e + a | 0;
                                                        if (d >>> 0 > 8192) {
                                                            break j;
                                                        }
                                                        s: {
                                                            if (a >>> 0 >= d >>> 0) {
                                                                break s;
                                                            }
                                                            n = F[h >> 2];
                                                            l = 0;
                                                            q = e & 7;
                                                            if (q) {
                                                                while (1) {
                                                                    F[n + (a << 2) >> 2] = i;
                                                                    a = a + 1 | 0;
                                                                    l = l + 1 | 0;
                                                                    if ((q | 0) != (l | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            if (e - 1 >>> 0 <= 6) {
                                                                break s;
                                                            }
                                                            while (1) {
                                                                e = n + (a << 2) | 0;
                                                                F[e >> 2] = i;
                                                                F[e + 28 >> 2] = i;
                                                                F[e + 24 >> 2] = i;
                                                                F[e + 20 >> 2] = i;
                                                                F[e + 16 >> 2] = i;
                                                                F[e + 12 >> 2] = i;
                                                                F[e + 8 >> 2] = i;
                                                                F[e + 4 >> 2] = i;
                                                                a = a + 8 | 0;
                                                                if ((d | 0) != (a | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                        }
                                                        i = i + 1 | 0;
                                                        if ((j | 0) != (i | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    k = (d | 0) == 8192;
                                                }
                                                d = k;
                                            }
                                            t: {
                                                if (!d | (F[f + 20 >> 2] ? 0 : g)) {
                                                    break t;
                                                }
                                                d = 0;
                                                n = ea - 16 | 0;
                                                ea = n;
                                                u: {
                                                    v: {
                                                        if (H[c + 38 >> 1] <= 511) {
                                                            i = F[c + 12 >> 2];
                                                            a = i;
                                                            e = F[c + 20 >> 2];
                                                            k = F[c + 16 >> 2];
                                                            h = k + 8 | 0;
                                                            e = h >>> 0 < 8 ? e + 1 | 0 : e;
                                                            b = F[c + 8 >> 2];
                                                            if (b >>> 0 < h >>> 0 & (a | 0) <= (e | 0) | (a | 0) < (e | 0)) {
                                                                break u;
                                                            }
                                                            k = k + F[c >> 2] | 0;
                                                            a = G[k | 0] | G[k + 1 | 0] << 8 | (G[k + 2 | 0] << 16 | G[k + 3 | 0] << 24);
                                                            k = G[k + 4 | 0] | G[k + 5 | 0] << 8 | (G[k + 6 | 0] << 16 | G[k + 7 | 0] << 24);
                                                            F[c + 16 >> 2] = h;
                                                            F[c + 20 >> 2] = e;
                                                            break v;
                                                        }
                                                        if (!ib(1, n + 8 | 0, c)) {
                                                            break u;
                                                        }
                                                        h = F[c + 16 >> 2];
                                                        e = F[c + 20 >> 2];
                                                        b = F[c + 8 >> 2];
                                                        i = F[c + 12 >> 2];
                                                        a = F[n + 8 >> 2];
                                                        k = F[n + 12 >> 2];
                                                    }
                                                    j = b - h | 0;
                                                    b = i - ((b >>> 0 < h >>> 0) + e | 0) | 0;
                                                    if ((b | 0) == (k | 0) & a >>> 0 > j >>> 0 | b >>> 0 < k >>> 0) {
                                                        break u;
                                                    }
                                                    e = e + k | 0;
                                                    b = a + h | 0;
                                                    e = b >>> 0 < a >>> 0 ? e + 1 | 0 : e;
                                                    F[c + 16 >> 2] = b;
                                                    F[c + 20 >> 2] = e;
                                                    if ((a | 0) <= 0) {
                                                        break u;
                                                    }
                                                    b = h + F[c >> 2] | 0;
                                                    F[f + 48 >> 2] = b;
                                                    c = a - 1 | 0;
                                                    e = c + b | 0;
                                                    h = G[e | 0];
                                                    w: {
                                                        if (h >>> 0 <= 63) {
                                                            F[f + 52 >> 2] = c;
                                                            a = G[e | 0] & 63;
                                                            break w;
                                                        }
                                                        x: {
                                                            switch ((h >>> 6 | 0) - 1 | 0) {
                                                                case 0:
                                                                    if (a >>> 0 < 2) {
                                                                        break u;
                                                                    }
                                                                    F[f + 52 >> 2] = a - 2;
                                                                    a = (a + b | 0) - 2 | 0;
                                                                    a = G[a + 1 | 0] << 8 & 16128 | G[a | 0];
                                                                    break w;
                                                                case 1:
                                                                    if (a >>> 0 < 3) {
                                                                        break u;
                                                                    }
                                                                    F[f + 52 >> 2] = a - 3;
                                                                    a = (a + b | 0) - 3 | 0;
                                                                    a = G[a + 2 | 0] << 16 & 4128768 | G[a + 1 | 0] << 8 | G[a | 0];
                                                                    break w;
                                                                default: break x;
                                                            }
                                                        }
                                                        F[f + 52 >> 2] = a - 4;
                                                        a = (a + b | 0) - 4 | 0;
                                                        a = G[a + 2 | 0] << 16 | G[a + 3 | 0] << 24 & 1056964608 | G[a + 1 | 0] << 8 | G[a | 0];
                                                    }
                                                    a = a + 32768 | 0;
                                                    F[f + 56 >> 2] = a;
                                                    d = a >>> 0 < 8388608;
                                                }
                                                ea = n + 16 | 0;
                                                if (!d) {
                                                    break t;
                                                }
                                                if (!g) {
                                                    m = 1;
                                                    break t;
                                                }
                                                b = F[f + 36 >> 2];
                                                c = F[f + 48 >> 2];
                                                d = F[f + 24 >> 2];
                                                a = F[f + 56 >> 2];
                                                while (1) {
                                                    y: {
                                                        if (a >>> 0 > 32767) {
                                                            break y;
                                                        }
                                                        m = F[f + 52 >> 2];
                                                        while (1) {
                                                            if ((m | 0) <= 0) {
                                                                break y;
                                                            }
                                                            m = m - 1 | 0;
                                                            F[f + 52 >> 2] = m;
                                                            a = G[c + m | 0] | a << 8;
                                                            F[f + 56 >> 2] = a;
                                                            if (a >>> 0 < 32768) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    e = a & 8191;
                                                    h = F[d + (e << 2) >> 2];
                                                    m = b + (h << 3) | 0;
                                                    a = (L(F[m >> 2], a >>> 13 | 0) + e | 0) - F[m + 4 >> 2] | 0;
                                                    F[f + 56 >> 2] = a;
                                                    F[o + (r << 2) >> 2] = h;
                                                    m = 1;
                                                    r = r + 1 | 0;
                                                    if ((g | 0) != (r | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            a = F[f + 36 >> 2];
                                            if (a) {
                                                F[f + 40 >> 2] = a;
                                                ra(a);
                                            }
                                            a = F[f + 24 >> 2];
                                            if (a) {
                                                F[f + 28 >> 2] = a;
                                                ra(a);
                                            }
                                            a = F[f + 8 >> 2];
                                            if (a) {
                                                F[f + 12 >> 2] = a;
                                                ra(a);
                                            }
                                            ea = f - -64 | 0;
                                            b = m;
                                            break g;
                                        case 9:
                                            o = a;
                                            n = d;
                                            g = ea + -64 | 0;
                                            ea = g;
                                            F[g + 56 >> 2] = 0;
                                            F[g + 48 >> 2] = 0;
                                            F[g + 52 >> 2] = 0;
                                            F[g + 40 >> 2] = 0;
                                            F[g + 44 >> 2] = 0;
                                            F[g + 32 >> 2] = 0;
                                            F[g + 36 >> 2] = 0;
                                            F[g + 24 >> 2] = 0;
                                            F[g + 28 >> 2] = 0;
                                            F[g + 16 >> 2] = 0;
                                            F[g + 20 >> 2] = 0;
                                            F[g + 8 >> 2] = 0;
                                            F[g + 12 >> 2] = 0;
                                            f = g + 8 | 0;
                                            a = H[c + 38 >> 1];
                                            z: {
                                                A: {
                                                    if (!a) {
                                                        break A;
                                                    }
                                                    B: {
                                                        if (a >>> 0 <= 511) {
                                                            a = F[c + 12 >> 2];
                                                            e = F[c + 20 >> 2];
                                                            b = F[c + 16 >> 2];
                                                            d = b + 4 | 0;
                                                            e = d >>> 0 < 4 ? e + 1 | 0 : e;
                                                            if ((a | 0) <= (e | 0) & d >>> 0 > I[c + 8 >> 2] | (a | 0) < (e | 0)) {
                                                                break A;
                                                            }
                                                            a = b + F[c >> 2] | 0;
                                                            j = G[a | 0] | G[a + 1 | 0] << 8 | (G[a + 2 | 0] << 16 | G[a + 3 | 0] << 24);
                                                            F[f + 12 >> 2] = j;
                                                            e = F[c + 20 >> 2];
                                                            a = F[c + 16 >> 2] + 4 | 0;
                                                            e = a >>> 0 < 4 ? e + 1 | 0 : e;
                                                            F[c + 16 >> 2] = a;
                                                            F[c + 20 >> 2] = e;
                                                            break B;
                                                        }
                                                        if (!jb(1, f + 12 | 0, c)) {
                                                            break A;
                                                        }
                                                        j = F[f + 12 >> 2];
                                                    }
                                                    b = F[f >> 2];
                                                    a = F[f + 4 >> 2] - b >> 2;
                                                    C: {
                                                        if (a >>> 0 < j >>> 0) {
                                                            Aa(f, j - a | 0);
                                                            j = F[f + 12 >> 2];
                                                            break C;
                                                        }
                                                        if (a >>> 0 <= j >>> 0) {
                                                            break C;
                                                        }
                                                        F[f + 4 >> 2] = b + (j << 2);
                                                    }
                                                    d = 1;
                                                    if (!j) {
                                                        break z;
                                                    }
                                                    q = F[c + 8 >> 2];
                                                    l = F[c + 12 >> 2];
                                                    s = F[f >> 2];
                                                    b = 0;
                                                    while (1) {
                                                        e = F[c + 20 >> 2];
                                                        a = F[c + 16 >> 2];
                                                        d = 0;
                                                        if ((l | 0) <= (e | 0) & q >>> 0 <= a >>> 0 | (e | 0) > (l | 0)) {
                                                            break z;
                                                        }
                                                        d = F[c >> 2];
                                                        p = G[d + a | 0];
                                                        a = a + 1 | 0;
                                                        e = a ? e : e + 1 | 0;
                                                        h = a;
                                                        F[c + 16 >> 2] = a;
                                                        F[c + 20 >> 2] = e;
                                                        a = p >>> 2 | 0;
                                                        i = 0;
                                                        D: {
                                                            E: {
                                                                F: {
                                                                    G: {
                                                                        t = p & 3;
                                                                        switch (t | 0) {
                                                                            case 0: break E;
                                                                            case 3: break G;
                                                                            default: break F;
                                                                        }
                                                                    }
                                                                    a = a + b | 0;
                                                                    d = 0;
                                                                    if (a >>> 0 >= j >>> 0) {
                                                                        break z;
                                                                    }
                                                                    ua(s + (b << 2) | 0, 0, (p & 252) + 4 | 0);
                                                                    b = a;
                                                                    break D;
                                                                }
                                                                while (1) {
                                                                    if ((e | 0) >= (l | 0) & h >>> 0 >= q >>> 0 | (e | 0) > (l | 0)) {
                                                                        break A;
                                                                    }
                                                                    j = G[d + h | 0];
                                                                    h = h + 1 | 0;
                                                                    e = h ? e : e + 1 | 0;
                                                                    F[c + 16 >> 2] = h;
                                                                    F[c + 20 >> 2] = e;
                                                                    a = j << (i << 3 | 6) | a;
                                                                    i = i + 1 | 0;
                                                                    if ((t | 0) != (i | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            F[s + (b << 2) >> 2] = a;
                                                        }
                                                        b = b + 1 | 0;
                                                        j = F[f + 12 >> 2];
                                                        if (b >>> 0 < j >>> 0) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    h = f + 16 | 0;
                                                    p = F[f >> 2];
                                                    b = F[f + 16 >> 2];
                                                    a = F[f + 20 >> 2] - b | 0;
                                                    H: {
                                                        if (a >>> 0 <= 131071) {
                                                            Aa(h, 32768 - (a >>> 2 | 0) | 0);
                                                            break H;
                                                        }
                                                        if ((a | 0) == 131072) {
                                                            break H;
                                                        }
                                                        F[f + 20 >> 2] = b + 131072;
                                                    }
                                                    a = f + 28 | 0;
                                                    b = F[a >> 2];
                                                    d = F[f + 32 >> 2] - b >> 3;
                                                    I: {
                                                        if (d >>> 0 < j >>> 0) {
                                                            tb(a, j - d | 0);
                                                            b = F[a >> 2];
                                                            break I;
                                                        }
                                                        if (d >>> 0 > j >>> 0) {
                                                            F[f + 32 >> 2] = (j << 3) + b;
                                                        }
                                                        if (!j) {
                                                            break A;
                                                        }
                                                    }
                                                    i = 0;
                                                    d = 0;
                                                    while (1) {
                                                        e = p + (i << 2) | 0;
                                                        f = F[e >> 2];
                                                        l = (i << 3) + b | 0;
                                                        a = d;
                                                        F[l + 4 >> 2] = a;
                                                        F[l >> 2] = f;
                                                        e = F[e >> 2];
                                                        d = e + a | 0;
                                                        if (d >>> 0 > 32768) {
                                                            break A;
                                                        }
                                                        J: {
                                                            if (a >>> 0 >= d >>> 0) {
                                                                break J;
                                                            }
                                                            f = F[h >> 2];
                                                            l = 0;
                                                            q = e & 7;
                                                            if (q) {
                                                                while (1) {
                                                                    F[f + (a << 2) >> 2] = i;
                                                                    a = a + 1 | 0;
                                                                    l = l + 1 | 0;
                                                                    if ((q | 0) != (l | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            if (e - 1 >>> 0 <= 6) {
                                                                break J;
                                                            }
                                                            while (1) {
                                                                e = f + (a << 2) | 0;
                                                                F[e >> 2] = i;
                                                                F[e + 28 >> 2] = i;
                                                                F[e + 24 >> 2] = i;
                                                                F[e + 20 >> 2] = i;
                                                                F[e + 16 >> 2] = i;
                                                                F[e + 12 >> 2] = i;
                                                                F[e + 8 >> 2] = i;
                                                                F[e + 4 >> 2] = i;
                                                                a = a + 8 | 0;
                                                                if ((d | 0) != (a | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                        }
                                                        i = i + 1 | 0;
                                                        if ((j | 0) != (i | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    k = (d | 0) == 32768;
                                                }
                                                d = k;
                                            }
                                            K: {
                                                if (!d | (F[g + 20 >> 2] ? 0 : o)) {
                                                    break K;
                                                }
                                                d = 0;
                                                j = ea - 16 | 0;
                                                ea = j;
                                                L: {
                                                    M: {
                                                        if (H[c + 38 >> 1] <= 511) {
                                                            i = F[c + 12 >> 2];
                                                            a = i;
                                                            e = F[c + 20 >> 2];
                                                            k = F[c + 16 >> 2];
                                                            h = k + 8 | 0;
                                                            e = h >>> 0 < 8 ? e + 1 | 0 : e;
                                                            b = F[c + 8 >> 2];
                                                            if (b >>> 0 < h >>> 0 & (a | 0) <= (e | 0) | (a | 0) < (e | 0)) {
                                                                break L;
                                                            }
                                                            k = k + F[c >> 2] | 0;
                                                            a = G[k | 0] | G[k + 1 | 0] << 8 | (G[k + 2 | 0] << 16 | G[k + 3 | 0] << 24);
                                                            k = G[k + 4 | 0] | G[k + 5 | 0] << 8 | (G[k + 6 | 0] << 16 | G[k + 7 | 0] << 24);
                                                            F[c + 16 >> 2] = h;
                                                            F[c + 20 >> 2] = e;
                                                            break M;
                                                        }
                                                        if (!ib(1, j + 8 | 0, c)) {
                                                            break L;
                                                        }
                                                        h = F[c + 16 >> 2];
                                                        e = F[c + 20 >> 2];
                                                        b = F[c + 8 >> 2];
                                                        i = F[c + 12 >> 2];
                                                        a = F[j + 8 >> 2];
                                                        k = F[j + 12 >> 2];
                                                    }
                                                    f = b - h | 0;
                                                    b = i - ((b >>> 0 < h >>> 0) + e | 0) | 0;
                                                    if ((b | 0) == (k | 0) & a >>> 0 > f >>> 0 | b >>> 0 < k >>> 0) {
                                                        break L;
                                                    }
                                                    f = e + k | 0;
                                                    b = a + h | 0;
                                                    f = b >>> 0 < a >>> 0 ? f + 1 | 0 : f;
                                                    F[c + 16 >> 2] = b;
                                                    F[c + 20 >> 2] = f;
                                                    if ((a | 0) <= 0) {
                                                        break L;
                                                    }
                                                    b = h + F[c >> 2] | 0;
                                                    F[g + 48 >> 2] = b;
                                                    c = a - 1 | 0;
                                                    e = c + b | 0;
                                                    h = G[e | 0];
                                                    N: {
                                                        if (h >>> 0 <= 63) {
                                                            F[g + 52 >> 2] = c;
                                                            a = G[e | 0] & 63;
                                                            break N;
                                                        }
                                                        O: {
                                                            switch ((h >>> 6 | 0) - 1 | 0) {
                                                                case 0:
                                                                    if (a >>> 0 < 2) {
                                                                        break L;
                                                                    }
                                                                    F[g + 52 >> 2] = a - 2;
                                                                    a = (a + b | 0) - 2 | 0;
                                                                    a = G[a + 1 | 0] << 8 & 16128 | G[a | 0];
                                                                    break N;
                                                                case 1:
                                                                    if (a >>> 0 < 3) {
                                                                        break L;
                                                                    }
                                                                    F[g + 52 >> 2] = a - 3;
                                                                    a = (a + b | 0) - 3 | 0;
                                                                    a = G[a + 2 | 0] << 16 & 4128768 | G[a + 1 | 0] << 8 | G[a | 0];
                                                                    break N;
                                                                default: break O;
                                                            }
                                                        }
                                                        F[g + 52 >> 2] = a - 4;
                                                        a = (a + b | 0) - 4 | 0;
                                                        a = G[a + 2 | 0] << 16 | G[a + 3 | 0] << 24 & 1056964608 | G[a + 1 | 0] << 8 | G[a | 0];
                                                    }
                                                    a = a + 131072 | 0;
                                                    F[g + 56 >> 2] = a;
                                                    d = a >>> 0 < 33554432;
                                                }
                                                ea = j + 16 | 0;
                                                if (!d) {
                                                    break K;
                                                }
                                                if (!o) {
                                                    m = 1;
                                                    break K;
                                                }
                                                b = F[g + 36 >> 2];
                                                c = F[g + 48 >> 2];
                                                d = F[g + 24 >> 2];
                                                a = F[g + 56 >> 2];
                                                while (1) {
                                                    P: {
                                                        if (a >>> 0 > 131071) {
                                                            break P;
                                                        }
                                                        m = F[g + 52 >> 2];
                                                        while (1) {
                                                            if ((m | 0) <= 0) {
                                                                break P;
                                                            }
                                                            m = m - 1 | 0;
                                                            F[g + 52 >> 2] = m;
                                                            a = G[c + m | 0] | a << 8;
                                                            F[g + 56 >> 2] = a;
                                                            if (a >>> 0 < 131072) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    e = a & 32767;
                                                    h = F[d + (e << 2) >> 2];
                                                    m = b + (h << 3) | 0;
                                                    a = (L(F[m >> 2], a >>> 15 | 0) + e | 0) - F[m + 4 >> 2] | 0;
                                                    F[g + 56 >> 2] = a;
                                                    F[n + (r << 2) >> 2] = h;
                                                    m = 1;
                                                    r = r + 1 | 0;
                                                    if ((o | 0) != (r | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            a = F[g + 36 >> 2];
                                            if (a) {
                                                F[g + 40 >> 2] = a;
                                                ra(a);
                                            }
                                            a = F[g + 24 >> 2];
                                            if (a) {
                                                F[g + 28 >> 2] = a;
                                                ra(a);
                                            }
                                            a = F[g + 8 >> 2];
                                            if (a) {
                                                F[g + 12 >> 2] = a;
                                                ra(a);
                                            }
                                            ea = g - -64 | 0;
                                            b = m;
                                            break g;
                                        case 10:
                                            o = a;
                                            n = d;
                                            g = ea + -64 | 0;
                                            ea = g;
                                            F[g + 56 >> 2] = 0;
                                            F[g + 48 >> 2] = 0;
                                            F[g + 52 >> 2] = 0;
                                            F[g + 40 >> 2] = 0;
                                            F[g + 44 >> 2] = 0;
                                            F[g + 32 >> 2] = 0;
                                            F[g + 36 >> 2] = 0;
                                            F[g + 24 >> 2] = 0;
                                            F[g + 28 >> 2] = 0;
                                            F[g + 16 >> 2] = 0;
                                            F[g + 20 >> 2] = 0;
                                            F[g + 8 >> 2] = 0;
                                            F[g + 12 >> 2] = 0;
                                            l = g + 8 | 0;
                                            a = H[c + 38 >> 1];
                                            Q: {
                                                R: {
                                                    if (!a) {
                                                        break R;
                                                    }
                                                    S: {
                                                        if (a >>> 0 <= 511) {
                                                            a = F[c + 12 >> 2];
                                                            e = F[c + 20 >> 2];
                                                            b = F[c + 16 >> 2];
                                                            d = b + 4 | 0;
                                                            e = d >>> 0 < 4 ? e + 1 | 0 : e;
                                                            if ((a | 0) <= (e | 0) & d >>> 0 > I[c + 8 >> 2] | (a | 0) < (e | 0)) {
                                                                break R;
                                                            }
                                                            a = b + F[c >> 2] | 0;
                                                            j = G[a | 0] | G[a + 1 | 0] << 8 | (G[a + 2 | 0] << 16 | G[a + 3 | 0] << 24);
                                                            F[l + 12 >> 2] = j;
                                                            e = F[c + 20 >> 2];
                                                            a = F[c + 16 >> 2] + 4 | 0;
                                                            e = a >>> 0 < 4 ? e + 1 | 0 : e;
                                                            F[c + 16 >> 2] = a;
                                                            F[c + 20 >> 2] = e;
                                                            break S;
                                                        }
                                                        if (!jb(1, l + 12 | 0, c)) {
                                                            break R;
                                                        }
                                                        j = F[l + 12 >> 2];
                                                    }
                                                    b = F[l >> 2];
                                                    a = F[l + 4 >> 2] - b >> 2;
                                                    T: {
                                                        if (a >>> 0 < j >>> 0) {
                                                            Aa(l, j - a | 0);
                                                            j = F[l + 12 >> 2];
                                                            break T;
                                                        }
                                                        if (a >>> 0 <= j >>> 0) {
                                                            break T;
                                                        }
                                                        F[l + 4 >> 2] = b + (j << 2);
                                                    }
                                                    d = 1;
                                                    if (!j) {
                                                        break Q;
                                                    }
                                                    q = F[c + 8 >> 2];
                                                    p = F[c + 12 >> 2];
                                                    s = F[l >> 2];
                                                    b = 0;
                                                    while (1) {
                                                        e = F[c + 20 >> 2];
                                                        a = F[c + 16 >> 2];
                                                        d = 0;
                                                        if ((p | 0) <= (e | 0) & q >>> 0 <= a >>> 0 | (e | 0) > (p | 0)) {
                                                            break Q;
                                                        }
                                                        d = F[c >> 2];
                                                        f = G[d + a | 0];
                                                        a = a + 1 | 0;
                                                        e = a ? e : e + 1 | 0;
                                                        h = a;
                                                        F[c + 16 >> 2] = a;
                                                        F[c + 20 >> 2] = e;
                                                        a = f >>> 2 | 0;
                                                        i = 0;
                                                        U: {
                                                            V: {
                                                                W: {
                                                                    X: {
                                                                        t = f & 3;
                                                                        switch (t | 0) {
                                                                            case 0: break V;
                                                                            case 3: break X;
                                                                            default: break W;
                                                                        }
                                                                    }
                                                                    a = a + b | 0;
                                                                    d = 0;
                                                                    if (a >>> 0 >= j >>> 0) {
                                                                        break Q;
                                                                    }
                                                                    ua(s + (b << 2) | 0, 0, (f & 252) + 4 | 0);
                                                                    b = a;
                                                                    break U;
                                                                }
                                                                while (1) {
                                                                    if ((e | 0) >= (p | 0) & h >>> 0 >= q >>> 0 | (e | 0) > (p | 0)) {
                                                                        break R;
                                                                    }
                                                                    j = G[d + h | 0];
                                                                    f = e;
                                                                    e = h + 1 | 0;
                                                                    f = e ? f : f + 1 | 0;
                                                                    h = e;
                                                                    F[c + 16 >> 2] = e;
                                                                    e = f;
                                                                    F[c + 20 >> 2] = e;
                                                                    a = j << (i << 3 | 6) | a;
                                                                    i = i + 1 | 0;
                                                                    if ((t | 0) != (i | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            F[s + (b << 2) >> 2] = a;
                                                        }
                                                        b = b + 1 | 0;
                                                        j = F[l + 12 >> 2];
                                                        if (b >>> 0 < j >>> 0) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    h = l + 16 | 0;
                                                    p = F[l >> 2];
                                                    b = F[l + 16 >> 2];
                                                    a = F[l + 20 >> 2] - b | 0;
                                                    Y: {
                                                        if (a >>> 0 <= 262143) {
                                                            Aa(h, 65536 - (a >>> 2 | 0) | 0);
                                                            break Y;
                                                        }
                                                        if ((a | 0) == 262144) {
                                                            break Y;
                                                        }
                                                        F[l + 20 >> 2] = b + 262144;
                                                    }
                                                    a = l + 28 | 0;
                                                    b = F[a >> 2];
                                                    d = F[l + 32 >> 2] - b >> 3;
                                                    Z: {
                                                        if (d >>> 0 < j >>> 0) {
                                                            tb(a, j - d | 0);
                                                            b = F[a >> 2];
                                                            break Z;
                                                        }
                                                        if (d >>> 0 > j >>> 0) {
                                                            F[l + 32 >> 2] = (j << 3) + b;
                                                        }
                                                        if (!j) {
                                                            break R;
                                                        }
                                                    }
                                                    i = 0;
                                                    d = 0;
                                                    while (1) {
                                                        e = p + (i << 2) | 0;
                                                        f = F[e >> 2];
                                                        l = (i << 3) + b | 0;
                                                        a = d;
                                                        F[l + 4 >> 2] = a;
                                                        F[l >> 2] = f;
                                                        e = F[e >> 2];
                                                        d = e + a | 0;
                                                        if (d >>> 0 > 65536) {
                                                            break R;
                                                        }
                                                        _: {
                                                            if (a >>> 0 >= d >>> 0) {
                                                                break _;
                                                            }
                                                            f = F[h >> 2];
                                                            l = 0;
                                                            q = e & 7;
                                                            if (q) {
                                                                while (1) {
                                                                    F[f + (a << 2) >> 2] = i;
                                                                    a = a + 1 | 0;
                                                                    l = l + 1 | 0;
                                                                    if ((q | 0) != (l | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            if (e - 1 >>> 0 <= 6) {
                                                                break _;
                                                            }
                                                            while (1) {
                                                                e = f + (a << 2) | 0;
                                                                F[e >> 2] = i;
                                                                F[e + 28 >> 2] = i;
                                                                F[e + 24 >> 2] = i;
                                                                F[e + 20 >> 2] = i;
                                                                F[e + 16 >> 2] = i;
                                                                F[e + 12 >> 2] = i;
                                                                F[e + 8 >> 2] = i;
                                                                F[e + 4 >> 2] = i;
                                                                a = a + 8 | 0;
                                                                if ((d | 0) != (a | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                        }
                                                        i = i + 1 | 0;
                                                        if ((j | 0) != (i | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    k = (d | 0) == 65536;
                                                }
                                                d = k;
                                            }
                                            $: {
                                                if (!d | (F[g + 20 >> 2] ? 0 : o)) {
                                                    break $;
                                                }
                                                d = 0;
                                                f = ea - 16 | 0;
                                                ea = f;
                                                aa: {
                                                    ba: {
                                                        if (H[c + 38 >> 1] <= 511) {
                                                            i = F[c + 12 >> 2];
                                                            a = i;
                                                            e = F[c + 20 >> 2];
                                                            k = F[c + 16 >> 2];
                                                            h = k + 8 | 0;
                                                            e = h >>> 0 < 8 ? e + 1 | 0 : e;
                                                            b = F[c + 8 >> 2];
                                                            if (b >>> 0 < h >>> 0 & (a | 0) <= (e | 0) | (a | 0) < (e | 0)) {
                                                                break aa;
                                                            }
                                                            k = k + F[c >> 2] | 0;
                                                            a = G[k | 0] | G[k + 1 | 0] << 8 | (G[k + 2 | 0] << 16 | G[k + 3 | 0] << 24);
                                                            k = G[k + 4 | 0] | G[k + 5 | 0] << 8 | (G[k + 6 | 0] << 16 | G[k + 7 | 0] << 24);
                                                            F[c + 16 >> 2] = h;
                                                            F[c + 20 >> 2] = e;
                                                            break ba;
                                                        }
                                                        if (!ib(1, f + 8 | 0, c)) {
                                                            break aa;
                                                        }
                                                        h = F[c + 16 >> 2];
                                                        e = F[c + 20 >> 2];
                                                        b = F[c + 8 >> 2];
                                                        i = F[c + 12 >> 2];
                                                        a = F[f + 8 >> 2];
                                                        k = F[f + 12 >> 2];
                                                    }
                                                    j = b - h | 0;
                                                    b = i - ((b >>> 0 < h >>> 0) + e | 0) | 0;
                                                    if ((b | 0) == (k | 0) & a >>> 0 > j >>> 0 | b >>> 0 < k >>> 0) {
                                                        break aa;
                                                    }
                                                    e = e + k | 0;
                                                    b = a + h | 0;
                                                    e = b >>> 0 < a >>> 0 ? e + 1 | 0 : e;
                                                    F[c + 16 >> 2] = b;
                                                    F[c + 20 >> 2] = e;
                                                    if ((a | 0) <= 0) {
                                                        break aa;
                                                    }
                                                    b = h + F[c >> 2] | 0;
                                                    F[g + 48 >> 2] = b;
                                                    c = a - 1 | 0;
                                                    e = c + b | 0;
                                                    h = G[e | 0];
                                                    ca: {
                                                        if (h >>> 0 <= 63) {
                                                            F[g + 52 >> 2] = c;
                                                            a = G[e | 0] & 63;
                                                            break ca;
                                                        }
                                                        da: {
                                                            switch ((h >>> 6 | 0) - 1 | 0) {
                                                                case 0:
                                                                    if (a >>> 0 < 2) {
                                                                        break aa;
                                                                    }
                                                                    F[g + 52 >> 2] = a - 2;
                                                                    a = (a + b | 0) - 2 | 0;
                                                                    a = G[a + 1 | 0] << 8 & 16128 | G[a | 0];
                                                                    break ca;
                                                                case 1:
                                                                    if (a >>> 0 < 3) {
                                                                        break aa;
                                                                    }
                                                                    F[g + 52 >> 2] = a - 3;
                                                                    a = (a + b | 0) - 3 | 0;
                                                                    a = G[a + 2 | 0] << 16 & 4128768 | G[a + 1 | 0] << 8 | G[a | 0];
                                                                    break ca;
                                                                default: break da;
                                                            }
                                                        }
                                                        F[g + 52 >> 2] = a - 4;
                                                        a = (a + b | 0) - 4 | 0;
                                                        a = G[a + 2 | 0] << 16 | G[a + 3 | 0] << 24 & 1056964608 | G[a + 1 | 0] << 8 | G[a | 0];
                                                    }
                                                    a = a + 262144 | 0;
                                                    F[g + 56 >> 2] = a;
                                                    d = a >>> 0 < 67108864;
                                                }
                                                ea = f + 16 | 0;
                                                if (!d) {
                                                    break $;
                                                }
                                                if (!o) {
                                                    m = 1;
                                                    break $;
                                                }
                                                b = F[g + 36 >> 2];
                                                c = F[g + 48 >> 2];
                                                d = F[g + 24 >> 2];
                                                a = F[g + 56 >> 2];
                                                while (1) {
                                                    ea: {
                                                        if (a >>> 0 > 262143) {
                                                            break ea;
                                                        }
                                                        m = F[g + 52 >> 2];
                                                        while (1) {
                                                            if ((m | 0) <= 0) {
                                                                break ea;
                                                            }
                                                            m = m - 1 | 0;
                                                            F[g + 52 >> 2] = m;
                                                            a = G[c + m | 0] | a << 8;
                                                            F[g + 56 >> 2] = a;
                                                            if (a >>> 0 < 262144) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    e = a & 65535;
                                                    h = F[d + (e << 2) >> 2];
                                                    m = b + (h << 3) | 0;
                                                    a = (L(F[m >> 2], a >>> 16 | 0) + e | 0) - F[m + 4 >> 2] | 0;
                                                    F[g + 56 >> 2] = a;
                                                    F[n + (r << 2) >> 2] = h;
                                                    m = 1;
                                                    r = r + 1 | 0;
                                                    if ((o | 0) != (r | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            a = F[g + 36 >> 2];
                                            if (a) {
                                                F[g + 40 >> 2] = a;
                                                ra(a);
                                            }
                                            a = F[g + 24 >> 2];
                                            if (a) {
                                                F[g + 28 >> 2] = a;
                                                ra(a);
                                            }
                                            a = F[g + 8 >> 2];
                                            if (a) {
                                                F[g + 12 >> 2] = a;
                                                ra(a);
                                            }
                                            ea = g - -64 | 0;
                                            b = m;
                                            break g;
                                        case 11:
                                            g = a;
                                            o = d;
                                            f = ea + -64 | 0;
                                            ea = f;
                                            F[f + 56 >> 2] = 0;
                                            F[f + 48 >> 2] = 0;
                                            F[f + 52 >> 2] = 0;
                                            F[f + 40 >> 2] = 0;
                                            F[f + 44 >> 2] = 0;
                                            F[f + 32 >> 2] = 0;
                                            F[f + 36 >> 2] = 0;
                                            F[f + 24 >> 2] = 0;
                                            F[f + 28 >> 2] = 0;
                                            F[f + 16 >> 2] = 0;
                                            F[f + 20 >> 2] = 0;
                                            F[f + 8 >> 2] = 0;
                                            F[f + 12 >> 2] = 0;
                                            n = f + 8 | 0;
                                            a = H[c + 38 >> 1];
                                            fa: {
                                                ga: {
                                                    if (!a) {
                                                        break ga;
                                                    }
                                                    ha: {
                                                        if (a >>> 0 <= 511) {
                                                            a = F[c + 12 >> 2];
                                                            e = F[c + 20 >> 2];
                                                            b = F[c + 16 >> 2];
                                                            d = b + 4 | 0;
                                                            e = d >>> 0 < 4 ? e + 1 | 0 : e;
                                                            if ((a | 0) <= (e | 0) & d >>> 0 > I[c + 8 >> 2] | (a | 0) < (e | 0)) {
                                                                break ga;
                                                            }
                                                            a = b + F[c >> 2] | 0;
                                                            j = G[a | 0] | G[a + 1 | 0] << 8 | (G[a + 2 | 0] << 16 | G[a + 3 | 0] << 24);
                                                            F[n + 12 >> 2] = j;
                                                            e = F[c + 20 >> 2];
                                                            a = F[c + 16 >> 2] + 4 | 0;
                                                            e = a >>> 0 < 4 ? e + 1 | 0 : e;
                                                            F[c + 16 >> 2] = a;
                                                            F[c + 20 >> 2] = e;
                                                            break ha;
                                                        }
                                                        if (!jb(1, n + 12 | 0, c)) {
                                                            break ga;
                                                        }
                                                        j = F[n + 12 >> 2];
                                                    }
                                                    b = F[n >> 2];
                                                    a = F[n + 4 >> 2] - b >> 2;
                                                    ia: {
                                                        if (a >>> 0 < j >>> 0) {
                                                            Aa(n, j - a | 0);
                                                            j = F[n + 12 >> 2];
                                                            break ia;
                                                        }
                                                        if (a >>> 0 <= j >>> 0) {
                                                            break ia;
                                                        }
                                                        F[n + 4 >> 2] = b + (j << 2);
                                                    }
                                                    d = 1;
                                                    if (!j) {
                                                        break fa;
                                                    }
                                                    q = F[c + 8 >> 2];
                                                    l = F[c + 12 >> 2];
                                                    s = F[n >> 2];
                                                    b = 0;
                                                    while (1) {
                                                        e = F[c + 20 >> 2];
                                                        a = F[c + 16 >> 2];
                                                        d = 0;
                                                        if ((l | 0) <= (e | 0) & q >>> 0 <= a >>> 0 | (e | 0) > (l | 0)) {
                                                            break fa;
                                                        }
                                                        d = F[c >> 2];
                                                        p = G[d + a | 0];
                                                        a = a + 1 | 0;
                                                        e = a ? e : e + 1 | 0;
                                                        h = a;
                                                        F[c + 16 >> 2] = a;
                                                        F[c + 20 >> 2] = e;
                                                        a = p >>> 2 | 0;
                                                        i = 0;
                                                        ja: {
                                                            ka: {
                                                                la: {
                                                                    ma: {
                                                                        t = p & 3;
                                                                        switch (t | 0) {
                                                                            case 0: break ka;
                                                                            case 3: break ma;
                                                                            default: break la;
                                                                        }
                                                                    }
                                                                    a = a + b | 0;
                                                                    d = 0;
                                                                    if (a >>> 0 >= j >>> 0) {
                                                                        break fa;
                                                                    }
                                                                    ua(s + (b << 2) | 0, 0, (p & 252) + 4 | 0);
                                                                    b = a;
                                                                    break ja;
                                                                }
                                                                while (1) {
                                                                    if ((e | 0) >= (l | 0) & h >>> 0 >= q >>> 0 | (e | 0) > (l | 0)) {
                                                                        break ga;
                                                                    }
                                                                    j = G[d + h | 0];
                                                                    h = h + 1 | 0;
                                                                    e = h ? e : e + 1 | 0;
                                                                    F[c + 16 >> 2] = h;
                                                                    F[c + 20 >> 2] = e;
                                                                    a = j << (i << 3 | 6) | a;
                                                                    i = i + 1 | 0;
                                                                    if ((t | 0) != (i | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            F[s + (b << 2) >> 2] = a;
                                                        }
                                                        b = b + 1 | 0;
                                                        j = F[n + 12 >> 2];
                                                        if (b >>> 0 < j >>> 0) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    h = n + 16 | 0;
                                                    p = F[n >> 2];
                                                    b = F[n + 16 >> 2];
                                                    a = F[n + 20 >> 2] - b | 0;
                                                    na: {
                                                        if (a >>> 0 <= 1048575) {
                                                            Aa(h, 262144 - (a >>> 2 | 0) | 0);
                                                            break na;
                                                        }
                                                        if ((a | 0) == 1048576) {
                                                            break na;
                                                        }
                                                        F[n + 20 >> 2] = b - -1048576;
                                                    }
                                                    a = n + 28 | 0;
                                                    b = F[a >> 2];
                                                    d = F[n + 32 >> 2] - b >> 3;
                                                    oa: {
                                                        if (d >>> 0 < j >>> 0) {
                                                            tb(a, j - d | 0);
                                                            b = F[a >> 2];
                                                            break oa;
                                                        }
                                                        if (d >>> 0 > j >>> 0) {
                                                            F[n + 32 >> 2] = (j << 3) + b;
                                                        }
                                                        if (!j) {
                                                            break ga;
                                                        }
                                                    }
                                                    i = 0;
                                                    d = 0;
                                                    while (1) {
                                                        e = p + (i << 2) | 0;
                                                        n = F[e >> 2];
                                                        l = (i << 3) + b | 0;
                                                        a = d;
                                                        F[l + 4 >> 2] = a;
                                                        F[l >> 2] = n;
                                                        e = F[e >> 2];
                                                        d = e + a | 0;
                                                        if (d >>> 0 > 262144) {
                                                            break ga;
                                                        }
                                                        pa: {
                                                            if (a >>> 0 >= d >>> 0) {
                                                                break pa;
                                                            }
                                                            n = F[h >> 2];
                                                            l = 0;
                                                            q = e & 7;
                                                            if (q) {
                                                                while (1) {
                                                                    F[n + (a << 2) >> 2] = i;
                                                                    a = a + 1 | 0;
                                                                    l = l + 1 | 0;
                                                                    if ((q | 0) != (l | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            if (e - 1 >>> 0 <= 6) {
                                                                break pa;
                                                            }
                                                            while (1) {
                                                                e = n + (a << 2) | 0;
                                                                F[e >> 2] = i;
                                                                F[e + 28 >> 2] = i;
                                                                F[e + 24 >> 2] = i;
                                                                F[e + 20 >> 2] = i;
                                                                F[e + 16 >> 2] = i;
                                                                F[e + 12 >> 2] = i;
                                                                F[e + 8 >> 2] = i;
                                                                F[e + 4 >> 2] = i;
                                                                a = a + 8 | 0;
                                                                if ((d | 0) != (a | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                        }
                                                        i = i + 1 | 0;
                                                        if ((j | 0) != (i | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    k = (d | 0) == 262144;
                                                }
                                                d = k;
                                            }
                                            qa: {
                                                if (!d | (F[f + 20 >> 2] ? 0 : g)) {
                                                    break qa;
                                                }
                                                d = 0;
                                                n = ea - 16 | 0;
                                                ea = n;
                                                ra: {
                                                    sa: {
                                                        if (H[c + 38 >> 1] <= 511) {
                                                            i = F[c + 12 >> 2];
                                                            a = i;
                                                            e = F[c + 20 >> 2];
                                                            k = F[c + 16 >> 2];
                                                            h = k + 8 | 0;
                                                            e = h >>> 0 < 8 ? e + 1 | 0 : e;
                                                            b = F[c + 8 >> 2];
                                                            if (b >>> 0 < h >>> 0 & (a | 0) <= (e | 0) | (a | 0) < (e | 0)) {
                                                                break ra;
                                                            }
                                                            k = k + F[c >> 2] | 0;
                                                            a = G[k | 0] | G[k + 1 | 0] << 8 | (G[k + 2 | 0] << 16 | G[k + 3 | 0] << 24);
                                                            k = G[k + 4 | 0] | G[k + 5 | 0] << 8 | (G[k + 6 | 0] << 16 | G[k + 7 | 0] << 24);
                                                            F[c + 16 >> 2] = h;
                                                            F[c + 20 >> 2] = e;
                                                            break sa;
                                                        }
                                                        if (!ib(1, n + 8 | 0, c)) {
                                                            break ra;
                                                        }
                                                        h = F[c + 16 >> 2];
                                                        e = F[c + 20 >> 2];
                                                        b = F[c + 8 >> 2];
                                                        i = F[c + 12 >> 2];
                                                        a = F[n + 8 >> 2];
                                                        k = F[n + 12 >> 2];
                                                    }
                                                    j = b - h | 0;
                                                    b = i - ((b >>> 0 < h >>> 0) + e | 0) | 0;
                                                    if ((b | 0) == (k | 0) & a >>> 0 > j >>> 0 | b >>> 0 < k >>> 0) {
                                                        break ra;
                                                    }
                                                    e = e + k | 0;
                                                    b = a + h | 0;
                                                    e = b >>> 0 < a >>> 0 ? e + 1 | 0 : e;
                                                    F[c + 16 >> 2] = b;
                                                    F[c + 20 >> 2] = e;
                                                    if ((a | 0) <= 0) {
                                                        break ra;
                                                    }
                                                    b = h + F[c >> 2] | 0;
                                                    F[f + 48 >> 2] = b;
                                                    c = a - 1 | 0;
                                                    e = c + b | 0;
                                                    h = G[e | 0];
                                                    ta: {
                                                        if (h >>> 0 <= 63) {
                                                            F[f + 52 >> 2] = c;
                                                            a = G[e | 0] & 63;
                                                            break ta;
                                                        }
                                                        ua: {
                                                            switch ((h >>> 6 | 0) - 1 | 0) {
                                                                case 0:
                                                                    if (a >>> 0 < 2) {
                                                                        break ra;
                                                                    }
                                                                    F[f + 52 >> 2] = a - 2;
                                                                    a = (a + b | 0) - 2 | 0;
                                                                    a = G[a + 1 | 0] << 8 & 16128 | G[a | 0];
                                                                    break ta;
                                                                case 1:
                                                                    if (a >>> 0 < 3) {
                                                                        break ra;
                                                                    }
                                                                    F[f + 52 >> 2] = a - 3;
                                                                    a = (a + b | 0) - 3 | 0;
                                                                    a = G[a + 2 | 0] << 16 & 4128768 | G[a + 1 | 0] << 8 | G[a | 0];
                                                                    break ta;
                                                                default: break ua;
                                                            }
                                                        }
                                                        F[f + 52 >> 2] = a - 4;
                                                        a = (a + b | 0) - 4 | 0;
                                                        a = G[a + 2 | 0] << 16 | G[a + 3 | 0] << 24 & 1056964608 | G[a + 1 | 0] << 8 | G[a | 0];
                                                    }
                                                    a = a - -1048576 | 0;
                                                    F[f + 56 >> 2] = a;
                                                    d = a >>> 0 < 268435456;
                                                }
                                                ea = n + 16 | 0;
                                                if (!d) {
                                                    break qa;
                                                }
                                                if (!g) {
                                                    m = 1;
                                                    break qa;
                                                }
                                                b = F[f + 36 >> 2];
                                                c = F[f + 48 >> 2];
                                                d = F[f + 24 >> 2];
                                                a = F[f + 56 >> 2];
                                                while (1) {
                                                    va: {
                                                        if (a >>> 0 > 1048575) {
                                                            break va;
                                                        }
                                                        m = F[f + 52 >> 2];
                                                        while (1) {
                                                            if ((m | 0) <= 0) {
                                                                break va;
                                                            }
                                                            m = m - 1 | 0;
                                                            F[f + 52 >> 2] = m;
                                                            a = G[c + m | 0] | a << 8;
                                                            F[f + 56 >> 2] = a;
                                                            if (a >>> 0 < 1048576) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    e = a & 262143;
                                                    h = F[d + (e << 2) >> 2];
                                                    m = b + (h << 3) | 0;
                                                    a = (L(F[m >> 2], a >>> 18 | 0) + e | 0) - F[m + 4 >> 2] | 0;
                                                    F[f + 56 >> 2] = a;
                                                    F[o + (r << 2) >> 2] = h;
                                                    m = 1;
                                                    r = r + 1 | 0;
                                                    if ((g | 0) != (r | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            a = F[f + 36 >> 2];
                                            if (a) {
                                                F[f + 40 >> 2] = a;
                                                ra(a);
                                            }
                                            a = F[f + 24 >> 2];
                                            if (a) {
                                                F[f + 28 >> 2] = a;
                                                ra(a);
                                            }
                                            a = F[f + 8 >> 2];
                                            if (a) {
                                                F[f + 12 >> 2] = a;
                                                ra(a);
                                            }
                                            ea = f - -64 | 0;
                                            b = m;
                                            break g;
                                        case 12:
                                            o = a;
                                            n = d;
                                            g = ea + -64 | 0;
                                            ea = g;
                                            F[g + 56 >> 2] = 0;
                                            F[g + 48 >> 2] = 0;
                                            F[g + 52 >> 2] = 0;
                                            F[g + 40 >> 2] = 0;
                                            F[g + 44 >> 2] = 0;
                                            F[g + 32 >> 2] = 0;
                                            F[g + 36 >> 2] = 0;
                                            F[g + 24 >> 2] = 0;
                                            F[g + 28 >> 2] = 0;
                                            F[g + 16 >> 2] = 0;
                                            F[g + 20 >> 2] = 0;
                                            F[g + 8 >> 2] = 0;
                                            F[g + 12 >> 2] = 0;
                                            f = g + 8 | 0;
                                            a = H[c + 38 >> 1];
                                            wa: {
                                                xa: {
                                                    if (!a) {
                                                        break xa;
                                                    }
                                                    ya: {
                                                        if (a >>> 0 <= 511) {
                                                            a = F[c + 12 >> 2];
                                                            e = F[c + 20 >> 2];
                                                            b = F[c + 16 >> 2];
                                                            d = b + 4 | 0;
                                                            e = d >>> 0 < 4 ? e + 1 | 0 : e;
                                                            if ((a | 0) <= (e | 0) & d >>> 0 > I[c + 8 >> 2] | (a | 0) < (e | 0)) {
                                                                break xa;
                                                            }
                                                            a = b + F[c >> 2] | 0;
                                                            j = G[a | 0] | G[a + 1 | 0] << 8 | (G[a + 2 | 0] << 16 | G[a + 3 | 0] << 24);
                                                            F[f + 12 >> 2] = j;
                                                            e = F[c + 20 >> 2];
                                                            a = F[c + 16 >> 2] + 4 | 0;
                                                            e = a >>> 0 < 4 ? e + 1 | 0 : e;
                                                            F[c + 16 >> 2] = a;
                                                            F[c + 20 >> 2] = e;
                                                            break ya;
                                                        }
                                                        if (!jb(1, f + 12 | 0, c)) {
                                                            break xa;
                                                        }
                                                        j = F[f + 12 >> 2];
                                                    }
                                                    b = F[f >> 2];
                                                    a = F[f + 4 >> 2] - b >> 2;
                                                    za: {
                                                        if (a >>> 0 < j >>> 0) {
                                                            Aa(f, j - a | 0);
                                                            j = F[f + 12 >> 2];
                                                            break za;
                                                        }
                                                        if (a >>> 0 <= j >>> 0) {
                                                            break za;
                                                        }
                                                        F[f + 4 >> 2] = b + (j << 2);
                                                    }
                                                    d = 1;
                                                    if (!j) {
                                                        break wa;
                                                    }
                                                    q = F[c + 8 >> 2];
                                                    l = F[c + 12 >> 2];
                                                    s = F[f >> 2];
                                                    b = 0;
                                                    while (1) {
                                                        e = F[c + 20 >> 2];
                                                        a = F[c + 16 >> 2];
                                                        d = 0;
                                                        if ((l | 0) <= (e | 0) & q >>> 0 <= a >>> 0 | (e | 0) > (l | 0)) {
                                                            break wa;
                                                        }
                                                        d = F[c >> 2];
                                                        p = G[d + a | 0];
                                                        a = a + 1 | 0;
                                                        e = a ? e : e + 1 | 0;
                                                        h = a;
                                                        F[c + 16 >> 2] = a;
                                                        F[c + 20 >> 2] = e;
                                                        a = p >>> 2 | 0;
                                                        i = 0;
                                                        Aa: {
                                                            Ba: {
                                                                Ca: {
                                                                    Da: {
                                                                        t = p & 3;
                                                                        switch (t | 0) {
                                                                            case 0: break Ba;
                                                                            case 3: break Da;
                                                                            default: break Ca;
                                                                        }
                                                                    }
                                                                    a = a + b | 0;
                                                                    d = 0;
                                                                    if (a >>> 0 >= j >>> 0) {
                                                                        break wa;
                                                                    }
                                                                    ua(s + (b << 2) | 0, 0, (p & 252) + 4 | 0);
                                                                    b = a;
                                                                    break Aa;
                                                                }
                                                                while (1) {
                                                                    if ((e | 0) >= (l | 0) & h >>> 0 >= q >>> 0 | (e | 0) > (l | 0)) {
                                                                        break xa;
                                                                    }
                                                                    j = G[d + h | 0];
                                                                    h = h + 1 | 0;
                                                                    e = h ? e : e + 1 | 0;
                                                                    F[c + 16 >> 2] = h;
                                                                    F[c + 20 >> 2] = e;
                                                                    a = j << (i << 3 | 6) | a;
                                                                    i = i + 1 | 0;
                                                                    if ((t | 0) != (i | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            F[s + (b << 2) >> 2] = a;
                                                        }
                                                        b = b + 1 | 0;
                                                        j = F[f + 12 >> 2];
                                                        if (b >>> 0 < j >>> 0) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    h = f + 16 | 0;
                                                    p = F[f >> 2];
                                                    b = F[f + 16 >> 2];
                                                    a = F[f + 20 >> 2] - b | 0;
                                                    Ea: {
                                                        if (a >>> 0 <= 2097151) {
                                                            Aa(h, 524288 - (a >>> 2 | 0) | 0);
                                                            break Ea;
                                                        }
                                                        if ((a | 0) == 2097152) {
                                                            break Ea;
                                                        }
                                                        F[f + 20 >> 2] = b + 2097152;
                                                    }
                                                    a = f + 28 | 0;
                                                    b = F[a >> 2];
                                                    d = F[f + 32 >> 2] - b >> 3;
                                                    Fa: {
                                                        if (d >>> 0 < j >>> 0) {
                                                            tb(a, j - d | 0);
                                                            b = F[a >> 2];
                                                            break Fa;
                                                        }
                                                        if (d >>> 0 > j >>> 0) {
                                                            F[f + 32 >> 2] = (j << 3) + b;
                                                        }
                                                        if (!j) {
                                                            break xa;
                                                        }
                                                    }
                                                    i = 0;
                                                    d = 0;
                                                    while (1) {
                                                        e = p + (i << 2) | 0;
                                                        f = F[e >> 2];
                                                        l = (i << 3) + b | 0;
                                                        a = d;
                                                        F[l + 4 >> 2] = a;
                                                        F[l >> 2] = f;
                                                        e = F[e >> 2];
                                                        d = e + a | 0;
                                                        if (d >>> 0 > 524288) {
                                                            break xa;
                                                        }
                                                        Ga: {
                                                            if (a >>> 0 >= d >>> 0) {
                                                                break Ga;
                                                            }
                                                            f = F[h >> 2];
                                                            l = 0;
                                                            q = e & 7;
                                                            if (q) {
                                                                while (1) {
                                                                    F[f + (a << 2) >> 2] = i;
                                                                    a = a + 1 | 0;
                                                                    l = l + 1 | 0;
                                                                    if ((q | 0) != (l | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            if (e - 1 >>> 0 <= 6) {
                                                                break Ga;
                                                            }
                                                            while (1) {
                                                                e = f + (a << 2) | 0;
                                                                F[e >> 2] = i;
                                                                F[e + 28 >> 2] = i;
                                                                F[e + 24 >> 2] = i;
                                                                F[e + 20 >> 2] = i;
                                                                F[e + 16 >> 2] = i;
                                                                F[e + 12 >> 2] = i;
                                                                F[e + 8 >> 2] = i;
                                                                F[e + 4 >> 2] = i;
                                                                a = a + 8 | 0;
                                                                if ((d | 0) != (a | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                        }
                                                        i = i + 1 | 0;
                                                        if ((j | 0) != (i | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    k = (d | 0) == 524288;
                                                }
                                                d = k;
                                            }
                                            Ha: {
                                                if (!d | (F[g + 20 >> 2] ? 0 : o)) {
                                                    break Ha;
                                                }
                                                d = 0;
                                                j = ea - 16 | 0;
                                                ea = j;
                                                Ia: {
                                                    Ja: {
                                                        if (H[c + 38 >> 1] <= 511) {
                                                            i = F[c + 12 >> 2];
                                                            a = i;
                                                            e = F[c + 20 >> 2];
                                                            k = F[c + 16 >> 2];
                                                            h = k + 8 | 0;
                                                            e = h >>> 0 < 8 ? e + 1 | 0 : e;
                                                            b = F[c + 8 >> 2];
                                                            if (b >>> 0 < h >>> 0 & (a | 0) <= (e | 0) | (a | 0) < (e | 0)) {
                                                                break Ia;
                                                            }
                                                            k = k + F[c >> 2] | 0;
                                                            a = G[k | 0] | G[k + 1 | 0] << 8 | (G[k + 2 | 0] << 16 | G[k + 3 | 0] << 24);
                                                            k = G[k + 4 | 0] | G[k + 5 | 0] << 8 | (G[k + 6 | 0] << 16 | G[k + 7 | 0] << 24);
                                                            F[c + 16 >> 2] = h;
                                                            F[c + 20 >> 2] = e;
                                                            break Ja;
                                                        }
                                                        if (!ib(1, j + 8 | 0, c)) {
                                                            break Ia;
                                                        }
                                                        h = F[c + 16 >> 2];
                                                        e = F[c + 20 >> 2];
                                                        b = F[c + 8 >> 2];
                                                        i = F[c + 12 >> 2];
                                                        a = F[j + 8 >> 2];
                                                        k = F[j + 12 >> 2];
                                                    }
                                                    f = b - h | 0;
                                                    b = i - ((b >>> 0 < h >>> 0) + e | 0) | 0;
                                                    if ((b | 0) == (k | 0) & a >>> 0 > f >>> 0 | b >>> 0 < k >>> 0) {
                                                        break Ia;
                                                    }
                                                    f = e + k | 0;
                                                    b = a + h | 0;
                                                    f = b >>> 0 < a >>> 0 ? f + 1 | 0 : f;
                                                    F[c + 16 >> 2] = b;
                                                    F[c + 20 >> 2] = f;
                                                    if ((a | 0) <= 0) {
                                                        break Ia;
                                                    }
                                                    b = h + F[c >> 2] | 0;
                                                    F[g + 48 >> 2] = b;
                                                    c = a - 1 | 0;
                                                    e = c + b | 0;
                                                    h = G[e | 0];
                                                    Ka: {
                                                        if (h >>> 0 <= 63) {
                                                            F[g + 52 >> 2] = c;
                                                            a = G[e | 0] & 63;
                                                            break Ka;
                                                        }
                                                        La: {
                                                            switch ((h >>> 6 | 0) - 1 | 0) {
                                                                case 0:
                                                                    if (a >>> 0 < 2) {
                                                                        break Ia;
                                                                    }
                                                                    F[g + 52 >> 2] = a - 2;
                                                                    a = (a + b | 0) - 2 | 0;
                                                                    a = G[a + 1 | 0] << 8 & 16128 | G[a | 0];
                                                                    break Ka;
                                                                case 1:
                                                                    if (a >>> 0 < 3) {
                                                                        break Ia;
                                                                    }
                                                                    F[g + 52 >> 2] = a - 3;
                                                                    a = (a + b | 0) - 3 | 0;
                                                                    a = G[a + 2 | 0] << 16 & 4128768 | G[a + 1 | 0] << 8 | G[a | 0];
                                                                    break Ka;
                                                                default: break La;
                                                            }
                                                        }
                                                        F[g + 52 >> 2] = a - 4;
                                                        a = (a + b | 0) - 4 | 0;
                                                        a = G[a + 2 | 0] << 16 | G[a + 3 | 0] << 24 & 1056964608 | G[a + 1 | 0] << 8 | G[a | 0];
                                                    }
                                                    a = a + 2097152 | 0;
                                                    F[g + 56 >> 2] = a;
                                                    d = a >>> 0 < 536870912;
                                                }
                                                ea = j + 16 | 0;
                                                if (!d) {
                                                    break Ha;
                                                }
                                                if (!o) {
                                                    m = 1;
                                                    break Ha;
                                                }
                                                b = F[g + 36 >> 2];
                                                c = F[g + 48 >> 2];
                                                d = F[g + 24 >> 2];
                                                a = F[g + 56 >> 2];
                                                while (1) {
                                                    Ma: {
                                                        if (a >>> 0 > 2097151) {
                                                            break Ma;
                                                        }
                                                        m = F[g + 52 >> 2];
                                                        while (1) {
                                                            if ((m | 0) <= 0) {
                                                                break Ma;
                                                            }
                                                            m = m - 1 | 0;
                                                            F[g + 52 >> 2] = m;
                                                            a = G[c + m | 0] | a << 8;
                                                            F[g + 56 >> 2] = a;
                                                            if (a >>> 0 < 2097152) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    e = a & 524287;
                                                    h = F[d + (e << 2) >> 2];
                                                    m = b + (h << 3) | 0;
                                                    a = (L(F[m >> 2], a >>> 19 | 0) + e | 0) - F[m + 4 >> 2] | 0;
                                                    F[g + 56 >> 2] = a;
                                                    F[n + (r << 2) >> 2] = h;
                                                    m = 1;
                                                    r = r + 1 | 0;
                                                    if ((o | 0) != (r | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            a = F[g + 36 >> 2];
                                            if (a) {
                                                F[g + 40 >> 2] = a;
                                                ra(a);
                                            }
                                            a = F[g + 24 >> 2];
                                            if (a) {
                                                F[g + 28 >> 2] = a;
                                                ra(a);
                                            }
                                            a = F[g + 8 >> 2];
                                            if (a) {
                                                F[g + 12 >> 2] = a;
                                                ra(a);
                                            }
                                            ea = g - -64 | 0;
                                            b = m;
                                            break g;
                                        case 17:
                                            b = He(a, c, d);
                                            break g;
                                        case 0:
                                        case 1:
                                        case 2:
                                        case 3:
                                        case 4:
                                        case 5:
                                        case 6:
                                        case 7:
                                            e = ea + -64 | 0;
                                            ea = e;
                                            F[e + 56 >> 2] = 0;
                                            F[e + 48 >> 2] = 0;
                                            F[e + 52 >> 2] = 0;
                                            F[e + 40 >> 2] = 0;
                                            F[e + 44 >> 2] = 0;
                                            F[e + 32 >> 2] = 0;
                                            F[e + 36 >> 2] = 0;
                                            F[e + 24 >> 2] = 0;
                                            F[e + 28 >> 2] = 0;
                                            F[e + 16 >> 2] = 0;
                                            F[e + 20 >> 2] = 0;
                                            F[e + 8 >> 2] = 0;
                                            F[e + 12 >> 2] = 0;
                                            Na: {
                                                if (!Je(e + 8 | 0, c) | (F[e + 20 >> 2] ? 0 : a)) {
                                                    break Na;
                                                }
                                                if (!Ie(e + 8 | 0, c)) {
                                                    break Na;
                                                }
                                                if (!a) {
                                                    b = 1;
                                                    break Na;
                                                }
                                                m = F[e + 36 >> 2];
                                                k = F[e + 48 >> 2];
                                                f = F[e + 24 >> 2];
                                                c = F[e + 56 >> 2];
                                                while (1) {
                                                    Oa: {
                                                        if (c >>> 0 > 16383) {
                                                            break Oa;
                                                        }
                                                        b = F[e + 52 >> 2];
                                                        while (1) {
                                                            if ((b | 0) <= 0) {
                                                                break Oa;
                                                            }
                                                            b = b - 1 | 0;
                                                            F[e + 52 >> 2] = b;
                                                            c = G[b + k | 0] | c << 8;
                                                            F[e + 56 >> 2] = c;
                                                            if (c >>> 0 < 16384) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    b = c & 4095;
                                                    g = F[f + (b << 2) >> 2];
                                                    o = m + (g << 3) | 0;
                                                    c = (L(F[o >> 2], c >>> 12 | 0) + b | 0) - F[o + 4 >> 2] | 0;
                                                    F[e + 56 >> 2] = c;
                                                    F[(h << 2) + d >> 2] = g;
                                                    b = 1;
                                                    h = h + 1 | 0;
                                                    if ((h | 0) != (a | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            a = F[e + 36 >> 2];
                                            if (a) {
                                                F[e + 40 >> 2] = a;
                                                ra(a);
                                            }
                                            a = F[e + 24 >> 2];
                                            if (a) {
                                                F[e + 28 >> 2] = a;
                                                ra(a);
                                            }
                                            a = F[e + 8 >> 2];
                                            if (a) {
                                                F[e + 12 >> 2] = a;
                                                ra(a);
                                            }
                                            ea = e - -64 | 0;
                                            break g;
                                        case 13:
                                        case 14:
                                        case 15:
                                        case 16: break h;
                                        default: break g;
                                    }
                                }
                                b = He(a, c, d);
                            }
                            h = b;
                        } return h; }
                        function ci(a) { a = a | 0; var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, J = 0, K = 0, M = 0, N = 0, O = 0, P = 0, Q = 0; k = ea + -64 | 0; ea = k; F[a + 132 >> 2] = 0; if (F[a + 148 >> 2]) {
                            b = F[a + 144 >> 2];
                            if (b) {
                                while (1) {
                                    e = F[b >> 2];
                                    ra(b);
                                    b = e;
                                    if (b) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            b = 0;
                            F[a + 144 >> 2] = 0;
                            e = F[a + 140 >> 2];
                            a: {
                                if (!e) {
                                    break a;
                                }
                                if (e - 1 >>> 0 >= 3) {
                                    d = e & -4;
                                    while (1) {
                                        g = b << 2;
                                        F[g + F[a + 136 >> 2] >> 2] = 0;
                                        F[F[a + 136 >> 2] + (g | 4) >> 2] = 0;
                                        F[F[a + 136 >> 2] + (g | 8) >> 2] = 0;
                                        F[F[a + 136 >> 2] + (g | 12) >> 2] = 0;
                                        b = b + 4 | 0;
                                        h = h + 4 | 0;
                                        if ((d | 0) != (h | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                e = e & 3;
                                if (!e) {
                                    break a;
                                }
                                while (1) {
                                    F[F[a + 136 >> 2] + (b << 2) >> 2] = 0;
                                    b = b + 1 | 0;
                                    v = v + 1 | 0;
                                    if ((e | 0) != (v | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            F[a + 148 >> 2] = 0;
                        } b: {
                            c: {
                                b = F[a + 4 >> 2];
                                v = G[b + 36 | 0];
                                h = v << 8 | G[b + 37 | 0];
                                d: {
                                    if (h >>> 0 > 513) {
                                        break d;
                                    }
                                    e = F[b + 32 >> 2];
                                    if (h >>> 0 <= 511) {
                                        h = F[e + 20 >> 2];
                                        g = F[e + 16 >> 2];
                                        d = g + 4 | 0;
                                        h = d >>> 0 < 4 ? h + 1 | 0 : h;
                                        c = F[e + 12 >> 2];
                                        if ((c | 0) <= (h | 0) & d >>> 0 > I[e + 8 >> 2] | (c | 0) < (h | 0)) {
                                            break c;
                                        }
                                        g = g + F[e >> 2] | 0;
                                        g = G[g | 0] | G[g + 1 | 0] << 8 | (G[g + 2 | 0] << 16 | G[g + 3 | 0] << 24);
                                        F[e + 16 >> 2] = d;
                                        F[e + 20 >> 2] = h;
                                        F[a + 132 >> 2] = g;
                                        break d;
                                    }
                                    if (!Fa(1, k, e)) {
                                        break c;
                                    }
                                    b = F[a + 4 >> 2];
                                    v = G[b + 36 | 0];
                                    F[a + 132 >> 2] = F[k >> 2];
                                }
                                h = F[b + 32 >> 2];
                                e: {
                                    f: {
                                        g: {
                                            if ((v & 255) >>> 0 <= 1) {
                                                v = 0;
                                                e = F[h + 20 >> 2];
                                                g = F[h + 16 >> 2];
                                                d = g + 4 | 0;
                                                e = d >>> 0 < 4 ? e + 1 | 0 : e;
                                                c = F[h + 12 >> 2];
                                                if ((c | 0) <= (e | 0) & d >>> 0 > I[h + 8 >> 2] | (c | 0) < (e | 0)) {
                                                    break b;
                                                }
                                                g = g + F[h >> 2] | 0;
                                                g = G[g | 0] | G[g + 1 | 0] << 8 | (G[g + 2 | 0] << 16 | G[g + 3 | 0] << 24);
                                                F[k + 60 >> 2] = g;
                                                F[h + 16 >> 2] = d;
                                                F[h + 20 >> 2] = e;
                                                F[a + 156 >> 2] = g;
                                                d = a + 156 | 0;
                                                break g;
                                            }
                                            v = 0;
                                            if (!Fa(1, k + 60 | 0, h)) {
                                                break b;
                                            }
                                            b = F[a + 4 >> 2];
                                            e = G[b + 36 | 0];
                                            F[a + 156 >> 2] = F[k + 60 >> 2];
                                            d = a + 156 | 0;
                                            if (e >>> 0 > 1) {
                                                break f;
                                            }
                                        }
                                        e = F[b + 32 >> 2];
                                        b = F[e + 8 >> 2];
                                        h = F[e + 12 >> 2];
                                        i = b;
                                        b = F[e + 20 >> 2];
                                        g = F[e + 16 >> 2];
                                        c = g + 4 | 0;
                                        b = c >>> 0 < 4 ? b + 1 | 0 : b;
                                        if (i >>> 0 < c >>> 0 & (b | 0) >= (h | 0) | (b | 0) > (h | 0)) {
                                            break b;
                                        }
                                        h = g + F[e >> 2] | 0;
                                        h = G[h | 0] | G[h + 1 | 0] << 8 | (G[h + 2 | 0] << 16 | G[h + 3 | 0] << 24);
                                        F[k + 56 >> 2] = h;
                                        F[e + 16 >> 2] = c;
                                        F[e + 20 >> 2] = b;
                                        break e;
                                    }
                                    if (!Fa(1, k + 56 | 0, F[b + 32 >> 2])) {
                                        break b;
                                    }
                                    h = F[k + 56 >> 2];
                                }
                                if (h >>> 0 > 1431655765 | I[d >> 2] > L(h, 3) >>> 0) {
                                    break b;
                                }
                                f = F[a + 4 >> 2];
                                g = F[f + 32 >> 2];
                                b = g;
                                j = F[b + 8 >> 2];
                                d = F[b + 12 >> 2];
                                e = F[b + 20 >> 2];
                                c = F[b + 16 >> 2];
                                if ((d | 0) <= (e | 0) & j >>> 0 <= c >>> 0 | (e | 0) > (d | 0)) {
                                    break b;
                                }
                                m = F[g >> 2];
                                i = G[m + c | 0];
                                b = e;
                                y = c + 1 | 0;
                                b = y ? b : b + 1 | 0;
                                F[g + 16 >> 2] = y;
                                F[g + 20 >> 2] = b;
                                h: {
                                    if (G[f + 36 | 0] <= 1) {
                                        b = d;
                                        d = c + 5 | 0;
                                        e = d >>> 0 < 5 ? e + 1 | 0 : e;
                                        c = d;
                                        if ((b | 0) <= (e | 0) & c >>> 0 > j >>> 0 | (b | 0) < (e | 0)) {
                                            break b;
                                        }
                                        b = m + y | 0;
                                        d = G[b | 0] | G[b + 1 | 0] << 8 | (G[b + 2 | 0] << 16 | G[b + 3 | 0] << 24);
                                        F[k + 52 >> 2] = d;
                                        F[g + 16 >> 2] = c;
                                        F[g + 20 >> 2] = e;
                                        break h;
                                    }
                                    if (!Fa(1, k + 52 | 0, g)) {
                                        break b;
                                    }
                                    d = F[k + 52 >> 2];
                                }
                                if (((d >>> 0) / 3 | 0) + d >>> 0 < h >>> 0 | d >>> 0 > h >>> 0) {
                                    break b;
                                }
                                b = F[a + 4 >> 2];
                                g = F[b + 32 >> 2];
                                i: {
                                    if (G[b + 36 | 0] <= 1) {
                                        b = F[g + 20 >> 2];
                                        e = F[g + 16 >> 2];
                                        c = e + 4 | 0;
                                        b = c >>> 0 < 4 ? b + 1 | 0 : b;
                                        f = F[g + 12 >> 2];
                                        if ((f | 0) <= (b | 0) & c >>> 0 > I[g + 8 >> 2] | (b | 0) > (f | 0)) {
                                            break b;
                                        }
                                        e = e + F[g >> 2] | 0;
                                        e = G[e | 0] | G[e + 1 | 0] << 8 | (G[e + 2 | 0] << 16 | G[e + 3 | 0] << 24);
                                        F[k + 48 >> 2] = e;
                                        F[g + 16 >> 2] = c;
                                        F[g + 20 >> 2] = b;
                                        break i;
                                    }
                                    if (!Fa(1, k + 48 | 0, g)) {
                                        break b;
                                    }
                                    e = F[k + 48 >> 2];
                                }
                                if (e >>> 0 > d >>> 0) {
                                    break b;
                                }
                                F[a + 28 >> 2] = F[a + 24 >> 2];
                                g = sa(88);
                                Lc(g);
                                b = F[a + 8 >> 2];
                                F[a + 8 >> 2] = g;
                                if (b) {
                                    cb(b);
                                    if (!F[a + 8 >> 2]) {
                                        break b;
                                    }
                                }
                                F[a + 164 >> 2] = F[a + 160 >> 2];
                                Ib(a + 160 | 0, h);
                                F[a + 176 >> 2] = F[a + 172 >> 2];
                                Ib(a + 172 | 0, h);
                                F[a - -64 >> 2] = 0;
                                F[a + 92 >> 2] = -1;
                                F[a + 84 >> 2] = -1;
                                F[a + 88 >> 2] = -1;
                                F[a + 40 >> 2] = F[a + 36 >> 2];
                                F[a + 52 >> 2] = F[a + 48 >> 2];
                                F[a + 76 >> 2] = F[a + 72 >> 2];
                                M = a + 216 | 0;
                                fd(M);
                                ed(M, i);
                                if (!Kc(F[a + 8 >> 2], h, F[a + 156 >> 2] + e | 0)) {
                                    break b;
                                }
                                b = F[a + 156 >> 2];
                                D[k | 0] = 1;
                                Na(a + 120 | 0, b + e | 0, k);
                                b = F[a + 4 >> 2];
                                h = H[b + 36 >> 1];
                                h = (h << 8 | h >>> 8) & 65535;
                                j: {
                                    if (h >>> 0 <= 513) {
                                        g = F[b + 32 >> 2];
                                        k: {
                                            if (h >>> 0 <= 511) {
                                                h = F[g + 20 >> 2];
                                                c = F[g + 16 >> 2];
                                                b = c + 4 | 0;
                                                h = b >>> 0 < 4 ? h + 1 | 0 : h;
                                                f = b;
                                                b = h;
                                                j = F[g + 12 >> 2];
                                                if (f >>> 0 > I[g + 8 >> 2] & (b | 0) >= (j | 0) | (b | 0) > (j | 0)) {
                                                    break b;
                                                }
                                                h = c + F[g >> 2] | 0;
                                                h = G[h | 0] | G[h + 1 | 0] << 8 | (G[h + 2 | 0] << 16 | G[h + 3 | 0] << 24);
                                                F[g + 16 >> 2] = f;
                                                F[g + 20 >> 2] = b;
                                                break k;
                                            }
                                            if (!Fa(1, k + 44 | 0, g)) {
                                                break b;
                                            }
                                            h = F[k + 44 >> 2];
                                        }
                                        if (!h) {
                                            break b;
                                        }
                                        b = F[F[a + 4 >> 2] + 32 >> 2];
                                        g = F[b + 8 >> 2];
                                        c = F[b + 16 >> 2];
                                        f = g - c | 0;
                                        b = F[b + 12 >> 2] - (F[b + 20 >> 2] + (c >>> 0 > g >>> 0) | 0) | 0;
                                        if (f >>> 0 < h >>> 0 & (b | 0) <= 0 | (b | 0) < 0) {
                                            break b;
                                        }
                                        E[k + 38 >> 1] = 0;
                                        F[k >> 2] = 0;
                                        F[k + 8 >> 2] = 0;
                                        F[k + 12 >> 2] = 0;
                                        F[k + 16 >> 2] = 0;
                                        F[k + 20 >> 2] = 0;
                                        F[k + 24 >> 2] = 0;
                                        F[k + 28 >> 2] = 0;
                                        D[k + 29 | 0] = 0;
                                        D[k + 30 | 0] = 0;
                                        D[k + 31 | 0] = 0;
                                        D[k + 32 | 0] = 0;
                                        D[k + 33 | 0] = 0;
                                        D[k + 34 | 0] = 0;
                                        D[k + 35 | 0] = 0;
                                        D[k + 36 | 0] = 0;
                                        g = F[F[a + 4 >> 2] + 32 >> 2];
                                        b = F[g + 16 >> 2];
                                        c = (b + F[g >> 2] | 0) + h | 0;
                                        f = F[g + 8 >> 2];
                                        b = (f - b | 0) - h | 0;
                                        E[k + 38 >> 1] = H[g + 38 >> 1];
                                        F[k >> 2] = c;
                                        F[k + 16 >> 2] = 0;
                                        F[k + 20 >> 2] = 0;
                                        F[k + 8 >> 2] = b;
                                        F[k + 12 >> 2] = 0;
                                        y = Hb(a, k);
                                        if ((y | 0) == -1) {
                                            break b;
                                        }
                                        N = y >> 31;
                                        break j;
                                    }
                                    y = -1;
                                    N = -1;
                                    if ((Hb(a, F[b + 32 >> 2]) | 0) == -1) {
                                        break b;
                                    }
                                }
                                f = a + 232 | 0;
                                Ae(f, a);
                                F[a + 372 >> 2] = i;
                                F[a + 384 >> 2] = F[a + 156 >> 2] + e;
                                E[k + 38 >> 1] = 0;
                                F[k >> 2] = 0;
                                F[k + 8 >> 2] = 0;
                                F[k + 12 >> 2] = 0;
                                F[k + 16 >> 2] = 0;
                                F[k + 20 >> 2] = 0;
                                F[k + 24 >> 2] = 0;
                                F[k + 28 >> 2] = 0;
                                D[k + 29 | 0] = 0;
                                D[k + 30 | 0] = 0;
                                D[k + 31 | 0] = 0;
                                D[k + 32 | 0] = 0;
                                D[k + 33 | 0] = 0;
                                D[k + 34 | 0] = 0;
                                D[k + 35 | 0] = 0;
                                D[k + 36 | 0] = 0;
                                h = 0;
                                i = ea - 16 | 0;
                                ea = i;
                                l: {
                                    m: {
                                        b = F[f + 144 >> 2];
                                        b = H[(ga[F[F[b >> 2] + 32 >> 2]](b) | 0) + 36 >> 1];
                                        if (((b << 8 | b >>> 8) & 65535) >>> 0 <= 513) {
                                            b = F[f + 4 >> 2];
                                            F[f + 40 >> 2] = F[f >> 2];
                                            F[f + 44 >> 2] = b;
                                            b = F[f + 36 >> 2];
                                            F[f + 72 >> 2] = F[f + 32 >> 2];
                                            F[f + 76 >> 2] = b;
                                            e = F[f + 28 >> 2];
                                            b = f - -64 | 0;
                                            F[b >> 2] = F[f + 24 >> 2];
                                            F[b + 4 >> 2] = e;
                                            b = F[f + 20 >> 2];
                                            F[f + 56 >> 2] = F[f + 16 >> 2];
                                            F[f + 60 >> 2] = b;
                                            b = F[f + 12 >> 2];
                                            F[f + 48 >> 2] = F[f + 8 >> 2];
                                            F[f + 52 >> 2] = b;
                                            if (!Eb(f + 40 | 0, 1, i + 8 | 0)) {
                                                break m;
                                            }
                                            b = F[f + 44 >> 2];
                                            F[f >> 2] = F[f + 40 >> 2];
                                            F[f + 4 >> 2] = b;
                                            b = F[f + 76 >> 2];
                                            F[f + 32 >> 2] = F[f + 72 >> 2];
                                            F[f + 36 >> 2] = b;
                                            b = F[f + 68 >> 2];
                                            F[f + 24 >> 2] = F[f + 64 >> 2];
                                            F[f + 28 >> 2] = b;
                                            e = F[f + 60 >> 2];
                                            g = e;
                                            b = F[f + 56 >> 2];
                                            F[f + 16 >> 2] = b;
                                            F[f + 20 >> 2] = e;
                                            c = F[f + 52 >> 2];
                                            e = F[f + 48 >> 2];
                                            F[f + 8 >> 2] = e;
                                            F[f + 12 >> 2] = c;
                                            j = e - b | 0;
                                            m = F[i + 12 >> 2];
                                            e = c - ((b >>> 0 > e >>> 0) + g | 0) | 0;
                                            c = F[i + 8 >> 2];
                                            if ((m | 0) == (e | 0) & j >>> 0 < c >>> 0 | e >>> 0 < m >>> 0) {
                                                break m;
                                            }
                                            e = b;
                                            c = b + c | 0;
                                            b = g + m | 0;
                                            F[f + 16 >> 2] = c;
                                            F[f + 20 >> 2] = c >>> 0 < e >>> 0 ? b + 1 | 0 : b;
                                        }
                                        n: {
                                            if (H[f + 38 >> 1] <= 513) {
                                                b = F[f + 4 >> 2];
                                                F[f + 96 >> 2] = F[f >> 2];
                                                F[f + 100 >> 2] = b;
                                                b = F[f + 36 >> 2];
                                                F[f + 128 >> 2] = F[f + 32 >> 2];
                                                F[f + 132 >> 2] = b;
                                                b = F[f + 28 >> 2];
                                                F[f + 120 >> 2] = F[f + 24 >> 2];
                                                F[f + 124 >> 2] = b;
                                                b = F[f + 20 >> 2];
                                                F[f + 112 >> 2] = F[f + 16 >> 2];
                                                F[f + 116 >> 2] = b;
                                                b = F[f + 12 >> 2];
                                                F[f + 104 >> 2] = F[f + 8 >> 2];
                                                F[f + 108 >> 2] = b;
                                                if (!Eb(f + 96 | 0, 1, i + 8 | 0)) {
                                                    break m;
                                                }
                                                b = F[f + 100 >> 2];
                                                F[f >> 2] = F[f + 96 >> 2];
                                                F[f + 4 >> 2] = b;
                                                b = F[f + 132 >> 2];
                                                F[f + 32 >> 2] = F[f + 128 >> 2];
                                                F[f + 36 >> 2] = b;
                                                b = F[f + 124 >> 2];
                                                F[f + 24 >> 2] = F[f + 120 >> 2];
                                                F[f + 28 >> 2] = b;
                                                e = F[f + 116 >> 2];
                                                g = e;
                                                b = F[f + 112 >> 2];
                                                F[f + 16 >> 2] = b;
                                                F[f + 20 >> 2] = e;
                                                c = F[f + 108 >> 2];
                                                e = F[f + 104 >> 2];
                                                F[f + 8 >> 2] = e;
                                                F[f + 12 >> 2] = c;
                                                j = e - b | 0;
                                                m = F[i + 12 >> 2];
                                                e = c - ((b >>> 0 > e >>> 0) + g | 0) | 0;
                                                c = F[i + 8 >> 2];
                                                if ((m | 0) == (e | 0) & j >>> 0 < c >>> 0 | e >>> 0 < m >>> 0) {
                                                    break m;
                                                }
                                                e = g + m | 0;
                                                c = b + c | 0;
                                                e = c >>> 0 < b >>> 0 ? e + 1 | 0 : e;
                                                F[f + 16 >> 2] = c;
                                                F[f + 20 >> 2] = e;
                                                break n;
                                            }
                                            if (!xa(f + 80 | 0, f)) {
                                                break l;
                                            }
                                        }
                                        if (!Be(f)) {
                                            break l;
                                        }
                                        b = F[f + 4 >> 2];
                                        F[k >> 2] = F[f >> 2];
                                        F[k + 4 >> 2] = b;
                                        b = F[f + 36 >> 2];
                                        F[k + 32 >> 2] = F[f + 32 >> 2];
                                        F[k + 36 >> 2] = b;
                                        b = F[f + 28 >> 2];
                                        F[k + 24 >> 2] = F[f + 24 >> 2];
                                        F[k + 28 >> 2] = b;
                                        b = F[f + 20 >> 2];
                                        F[k + 16 >> 2] = F[f + 16 >> 2];
                                        F[k + 20 >> 2] = b;
                                        b = F[f + 12 >> 2];
                                        F[k + 8 >> 2] = F[f + 8 >> 2];
                                        F[k + 12 >> 2] = b;
                                        b = F[f + 144 >> 2];
                                        b = H[(ga[F[F[b >> 2] + 32 >> 2]](b) | 0) + 36 >> 1];
                                        o: {
                                            if (((b << 8 | b >>> 8) & 65535) >>> 0 <= 513) {
                                                b = F[f + 144 >> 2];
                                                p: {
                                                    if (G[(ga[F[F[b >> 2] + 32 >> 2]](b) | 0) + 36 | 0] <= 1) {
                                                        b = F[k + 20 >> 2];
                                                        e = F[k + 16 >> 2];
                                                        g = e + 4 | 0;
                                                        b = g >>> 0 < 4 ? b + 1 | 0 : b;
                                                        c = F[k + 12 >> 2];
                                                        if ((c | 0) <= (b | 0) & g >>> 0 > I[k + 8 >> 2] | (b | 0) > (c | 0)) {
                                                            break l;
                                                        }
                                                        e = e + F[k >> 2] | 0;
                                                        e = G[e | 0] | G[e + 1 | 0] << 8 | (G[e + 2 | 0] << 16 | G[e + 3 | 0] << 24);
                                                        F[k + 16 >> 2] = g;
                                                        F[k + 20 >> 2] = b;
                                                        break p;
                                                    }
                                                    if (!Fa(1, i + 8 | 0, k)) {
                                                        break l;
                                                    }
                                                    e = F[i + 8 >> 2];
                                                }
                                                b = F[f + 152 >> 2];
                                                if (e >>> 0 >= b >>> 0) {
                                                    break l;
                                                }
                                                e = F[k + 20 >> 2];
                                                c = F[k + 12 >> 2];
                                                g = F[k + 16 >> 2];
                                                if ((e | 0) >= (c | 0) & g >>> 0 >= I[k + 8 >> 2] | (c | 0) < (e | 0)) {
                                                    break l;
                                                }
                                                c = G[g + F[k >> 2] | 0];
                                                g = g + 1 | 0;
                                                e = g ? e : e + 1 | 0;
                                                F[k + 16 >> 2] = g;
                                                F[k + 20 >> 2] = e;
                                                if (c) {
                                                    break l;
                                                }
                                                F[f + 176 >> 2] = 2;
                                                F[f + 180 >> 2] = 7;
                                                break o;
                                            }
                                            F[f + 176 >> 2] = 2;
                                            F[f + 180 >> 2] = 7;
                                            b = F[f + 152 >> 2];
                                        }
                                        if ((b | 0) < 0) {
                                            break l;
                                        }
                                        F[i + 8 >> 2] = 0;
                                        h = 2;
                                        c = F[f + 156 >> 2];
                                        g = F[f + 160 >> 2] - c >> 2;
                                        q: {
                                            if (g >>> 0 < b >>> 0) {
                                                Ia(f + 156 | 0, b - g | 0, i + 8 | 0);
                                                h = F[f + 176 >> 2];
                                                e = F[f + 180 >> 2];
                                                break q;
                                            }
                                            e = 7;
                                            if (b >>> 0 >= g >>> 0) {
                                                break q;
                                            }
                                            F[f + 160 >> 2] = c + (b << 2);
                                        }
                                        g = f + 184 | 0;
                                        e = (e - h | 0) + 1 | 0;
                                        b = F[f + 188 >> 2];
                                        c = F[f + 184 >> 2];
                                        h = (b - c | 0) / 12 | 0;
                                        r: {
                                            if (e >>> 0 > h >>> 0) {
                                                e = e - h | 0;
                                                j = F[g + 8 >> 2];
                                                b = F[g + 4 >> 2];
                                                s: {
                                                    if (e >>> 0 <= (j - b | 0) / 12 >>> 0) {
                                                        if (e) {
                                                            h = b;
                                                            b = L((L(e, 12) - 12 >>> 0) / 12 | 0, 12) + 12 | 0;
                                                            b = ua(h, 0, b) + b | 0;
                                                        }
                                                        F[g + 4 >> 2] = b;
                                                        break s;
                                                    }
                                                    t: {
                                                        u: {
                                                            v: {
                                                                h = F[g >> 2];
                                                                m = (b - h | 0) / 12 | 0;
                                                                c = m + e | 0;
                                                                if (c >>> 0 < 357913942) {
                                                                    j = (j - h | 0) / 12 | 0;
                                                                    l = j << 1;
                                                                    j = j >>> 0 < 178956970 ? c >>> 0 > l >>> 0 ? c : l : 357913941;
                                                                    if (j) {
                                                                        if (j >>> 0 >= 357913942) {
                                                                            break v;
                                                                        }
                                                                        s = sa(L(j, 12));
                                                                    }
                                                                    c = L(m, 12) + s | 0;
                                                                    m = L((L(e, 12) - 12 >>> 0) / 12 | 0, 12) + 12 | 0;
                                                                    e = ua(c, 0, m);
                                                                    m = e + m | 0;
                                                                    j = L(j, 12) + s | 0;
                                                                    if ((b | 0) == (h | 0)) {
                                                                        break u;
                                                                    }
                                                                    while (1) {
                                                                        c = c - 12 | 0;
                                                                        b = b - 12 | 0;
                                                                        F[c >> 2] = F[b >> 2];
                                                                        F[c + 4 >> 2] = F[b + 4 >> 2];
                                                                        F[c + 8 >> 2] = F[b + 8 >> 2];
                                                                        F[b + 8 >> 2] = 0;
                                                                        F[b >> 2] = 0;
                                                                        F[b + 4 >> 2] = 0;
                                                                        if ((b | 0) != (h | 0)) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    F[g + 8 >> 2] = j;
                                                                    e = F[g + 4 >> 2];
                                                                    F[g + 4 >> 2] = m;
                                                                    b = F[g >> 2];
                                                                    F[g >> 2] = c;
                                                                    if ((b | 0) == (e | 0)) {
                                                                        break t;
                                                                    }
                                                                    while (1) {
                                                                        h = e - 12 | 0;
                                                                        c = F[h >> 2];
                                                                        if (c) {
                                                                            F[e - 8 >> 2] = c;
                                                                            ra(c);
                                                                        }
                                                                        e = h;
                                                                        if ((e | 0) != (b | 0)) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    break t;
                                                                }
                                                                va();
                                                                V();
                                                            }
                                                            wa(1336);
                                                            V();
                                                        }
                                                        F[g + 8 >> 2] = j;
                                                        F[g + 4 >> 2] = m;
                                                        F[g >> 2] = e;
                                                    }
                                                    if (b) {
                                                        ra(b);
                                                    }
                                                }
                                                e = F[f + 188 >> 2];
                                                break r;
                                            }
                                            if (e >>> 0 >= h >>> 0) {
                                                e = b;
                                                break r;
                                            }
                                            e = c + L(e, 12) | 0;
                                            if ((e | 0) != (b | 0)) {
                                                while (1) {
                                                    h = b - 12 | 0;
                                                    c = F[h >> 2];
                                                    if (c) {
                                                        F[b - 8 >> 2] = c;
                                                        ra(c);
                                                    }
                                                    b = h;
                                                    if ((e | 0) != (b | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            F[f + 188 >> 2] = e;
                                        }
                                        j = f + 196 | 0;
                                        h = F[f + 184 >> 2];
                                        b = (e - h | 0) / 12 | 0;
                                        s = F[f + 196 >> 2];
                                        c = F[f + 200 >> 2] - s >> 2;
                                        w: {
                                            if (b >>> 0 > c >>> 0) {
                                                Aa(j, b - c | 0);
                                                h = F[f + 184 >> 2];
                                                e = F[f + 188 >> 2];
                                                break w;
                                            }
                                            if (b >>> 0 >= c >>> 0) {
                                                break w;
                                            }
                                            F[f + 200 >> 2] = s + (b << 2);
                                        }
                                        if ((e | 0) == (h | 0)) {
                                            h = 1;
                                            break l;
                                        }
                                        b = 0;
                                        while (1) {
                                            if (!Fa(1, i + 8 | 0, k)) {
                                                break m;
                                            }
                                            h = F[i + 8 >> 2];
                                            e = F[f + 148 >> 2];
                                            if (h >>> 0 > (F[e + 4 >> 2] - F[e >> 2] >> 2 >>> 0) / 3 >>> 0) {
                                                break m;
                                            }
                                            if (h) {
                                                e = F[g >> 2];
                                                l = L(b, 12);
                                                c = e + l | 0;
                                                s = F[c >> 2];
                                                m = F[c + 4 >> 2] - s >> 2;
                                                x: {
                                                    if (m >>> 0 < h >>> 0) {
                                                        Aa(c, h - m | 0);
                                                        e = F[g >> 2];
                                                        break x;
                                                    }
                                                    if (h >>> 0 >= m >>> 0) {
                                                        break x;
                                                    }
                                                    F[c + 4 >> 2] = s + (h << 2);
                                                }
                                                ld(h, 1, k, F[e + l >> 2]);
                                                F[F[j >> 2] + (b << 2) >> 2] = h;
                                            }
                                            h = 1;
                                            b = b + 1 | 0;
                                            if (b >>> 0 < (F[f + 188 >> 2] - F[f + 184 >> 2] | 0) / 12 >>> 0) {
                                                continue;
                                            }
                                            break;
                                        }
                                        break l;
                                    }
                                    h = 0;
                                }
                                ea = i + 16 | 0;
                                y: {
                                    if (!h) {
                                        break y;
                                    }
                                    b = 0;
                                    i = 0;
                                    e = 0;
                                    g = 0;
                                    s = 0;
                                    h = 0;
                                    o = ea - 96 | 0;
                                    ea = o;
                                    F[o + 72 >> 2] = 0;
                                    F[o + 64 >> 2] = 0;
                                    F[o + 68 >> 2] = 0;
                                    F[o + 48 >> 2] = 0;
                                    F[o + 52 >> 2] = 0;
                                    F[o + 40 >> 2] = 0;
                                    F[o + 44 >> 2] = 0;
                                    F[o + 56 >> 2] = 1065353216;
                                    F[o + 32 >> 2] = 0;
                                    F[o + 24 >> 2] = 0;
                                    F[o + 28 >> 2] = 0;
                                    t = 1;
                                    l = a;
                                    B = F[a + 124 >> 2];
                                    z: {
                                        A: {
                                            B: {
                                                C: {
                                                    m = d;
                                                    D: {
                                                        E: {
                                                            if ((d | 0) <= 0) {
                                                                break E;
                                                            }
                                                            r = l + 232 | 0;
                                                            O = F[l + 216 >> 2] != F[l + 220 >> 2];
                                                            while (1) {
                                                                a = s;
                                                                s = a + 1 | 0;
                                                                d = F[r + 172 >> 2];
                                                                F: {
                                                                    if ((d | 0) != -1) {
                                                                        c = F[r + 196 >> 2] + (d << 2) | 0;
                                                                        j = F[c >> 2];
                                                                        d = j - 1 | 0;
                                                                        F[c >> 2] = d;
                                                                        c = 9;
                                                                        if ((j | 0) <= 0) {
                                                                            break F;
                                                                        }
                                                                        c = F[(F[F[F[r + 184 >> 2] + L(F[r + 172 >> 2], 12) >> 2] + (d << 2) >> 2] << 2) + 12176 >> 2];
                                                                        F[r + 168 >> 2] = c;
                                                                        break F;
                                                                    }
                                                                    c = 7;
                                                                    d = F[r + 144 >> 2];
                                                                    d = H[(ga[F[F[d >> 2] + 32 >> 2]](d) | 0) + 36 >> 1];
                                                                    G: {
                                                                        if (((d << 8 | d >>> 8) & 65535) >>> 0 > 513) {
                                                                            break G;
                                                                        }
                                                                        if (!G[r + 76 | 0]) {
                                                                            F[r + 168 >> 2] = 1;
                                                                            c = 1;
                                                                            break F;
                                                                        }
                                                                        c = 0;
                                                                        n = F[r - -64 >> 2];
                                                                        j = F[r + 72 >> 2];
                                                                        d = n + (j >>> 3 | 0) | 0;
                                                                        q = F[r + 68 >> 2];
                                                                        if (d >>> 0 >= q >>> 0) {
                                                                            break G;
                                                                        }
                                                                        p = G[d | 0];
                                                                        d = j + 1 | 0;
                                                                        F[r + 72 >> 2] = d;
                                                                        if (!(p >>> (j & 7) & 1)) {
                                                                            break G;
                                                                        }
                                                                        p = d >>> 3 | 0;
                                                                        c = n + p | 0;
                                                                        H: {
                                                                            if (c >>> 0 >= q >>> 0) {
                                                                                c = d;
                                                                                d = 0;
                                                                                break H;
                                                                            }
                                                                            w = G[c | 0];
                                                                            c = j + 2 | 0;
                                                                            F[r + 72 >> 2] = c;
                                                                            p = c >>> 3 | 0;
                                                                            d = w >>> (d & 7) & 1;
                                                                        }
                                                                        j = n + p | 0;
                                                                        if (j >>> 0 < q >>> 0) {
                                                                            j = G[j | 0];
                                                                            F[r + 72 >> 2] = c + 1;
                                                                            c = j >>> (c & 7) << 1 & 2;
                                                                        }
                                                                        else {
                                                                            c = 0;
                                                                        }
                                                                        c = (d | c) << 1 | 1;
                                                                    }
                                                                    F[r + 168 >> 2] = c;
                                                                }
                                                                I: {
                                                                    J: {
                                                                        if (!c) {
                                                                            if ((e | 0) == (g | 0)) {
                                                                                j = -1;
                                                                                break D;
                                                                            }
                                                                            c = -1;
                                                                            n = F[l + 8 >> 2];
                                                                            p = F[n + 24 >> 2];
                                                                            b = p;
                                                                            q = e - 4 | 0;
                                                                            j = F[q >> 2];
                                                                            d = -1;
                                                                            K: {
                                                                                if ((j | 0) == -1) {
                                                                                    break K;
                                                                                }
                                                                                i = j + 1 | 0;
                                                                                i = (i >>> 0) % 3 | 0 ? i : j - 2 | 0;
                                                                                d = -1;
                                                                                if ((i | 0) == -1) {
                                                                                    break K;
                                                                                }
                                                                                d = F[F[n >> 2] + (i << 2) >> 2];
                                                                            }
                                                                            b = F[b + (d << 2) >> 2];
                                                                            if ((b | 0) != -1) {
                                                                                c = b + 1 | 0;
                                                                                c = (c >>> 0) % 3 | 0 ? c : b - 2 | 0;
                                                                            }
                                                                            i = F[n + 12 >> 2];
                                                                            b = L(a, 3);
                                                                            a = b + 1 | 0;
                                                                            F[i + (j << 2) >> 2] = a;
                                                                            w = a << 2;
                                                                            F[w + i >> 2] = j;
                                                                            t = b + 2 | 0;
                                                                            F[i + (c << 2) >> 2] = t;
                                                                            x = t << 2;
                                                                            F[x + i >> 2] = c;
                                                                            i = -1;
                                                                            a = -1;
                                                                            L: {
                                                                                if ((j | 0) == -1) {
                                                                                    break L;
                                                                                }
                                                                                M: {
                                                                                    if ((j >>> 0) % 3 | 0) {
                                                                                        j = j - 1 | 0;
                                                                                        break M;
                                                                                    }
                                                                                    j = j + 2 | 0;
                                                                                    a = -1;
                                                                                    if ((j | 0) == -1) {
                                                                                        break L;
                                                                                    }
                                                                                }
                                                                                a = F[F[n >> 2] + (j << 2) >> 2];
                                                                            }
                                                                            N: {
                                                                                if ((c | 0) == -1) {
                                                                                    break N;
                                                                                }
                                                                                j = c + 1 | 0;
                                                                                c = (j >>> 0) % 3 | 0 ? j : c - 2 | 0;
                                                                                if ((c | 0) == -1) {
                                                                                    break N;
                                                                                }
                                                                                i = F[F[n >> 2] + (c << 2) >> 2];
                                                                            }
                                                                            j = -1;
                                                                            if ((a | 0) == (d | 0) | (d | 0) == (i | 0)) {
                                                                                break D;
                                                                            }
                                                                            c = F[n >> 2];
                                                                            F[c + (b << 2) >> 2] = d;
                                                                            F[c + w >> 2] = i;
                                                                            F[c + x >> 2] = a;
                                                                            if ((a | 0) != -1) {
                                                                                F[p + (a << 2) >> 2] = t;
                                                                            }
                                                                            a = F[l + 120 >> 2] + (d >>> 3 & 536870908) | 0;
                                                                            c = F[a >> 2];
                                                                            P = a, Q = Lj(d) & c, F[P >> 2] = Q;
                                                                            F[q >> 2] = b;
                                                                            break J;
                                                                        }
                                                                        j = -1;
                                                                        O: {
                                                                            P: {
                                                                                Q: {
                                                                                    R: {
                                                                                        S: {
                                                                                            T: {
                                                                                                U: {
                                                                                                    V: {
                                                                                                        W: {
                                                                                                            X: {
                                                                                                                switch (c - 1 | 0) {
                                                                                                                    case 2:
                                                                                                                    case 4:
                                                                                                                        if ((b | 0) == (g | 0)) {
                                                                                                                            break D;
                                                                                                                        }
                                                                                                                        d = F[l + 8 >> 2];
                                                                                                                        i = F[d + 12 >> 2];
                                                                                                                        n = L(a, 3);
                                                                                                                        w = (c | 0) == 5;
                                                                                                                        p = n + (w ? 2 : 1) | 0;
                                                                                                                        x = p << 2;
                                                                                                                        J = b - 4 | 0;
                                                                                                                        c = F[J >> 2];
                                                                                                                        F[i + x >> 2] = c;
                                                                                                                        F[i + (c << 2) >> 2] = p;
                                                                                                                        Sa(d + 24 | 0);
                                                                                                                        i = F[l + 8 >> 2];
                                                                                                                        q = F[i + 24 >> 2];
                                                                                                                        if (F[i + 28 >> 2] - q >> 2 > (B | 0)) {
                                                                                                                            break D;
                                                                                                                        }
                                                                                                                        i = F[i >> 2];
                                                                                                                        K = i + x | 0;
                                                                                                                        d = F[d + 28 >> 2] - F[d + 24 >> 2] | 0;
                                                                                                                        x = (d >> 2) - 1 | 0;
                                                                                                                        F[K >> 2] = x;
                                                                                                                        if (d) {
                                                                                                                            F[q + (x << 2) >> 2] = p;
                                                                                                                        }
                                                                                                                        p = w ? n : n + 2 | 0;
                                                                                                                        K = i + (n + w << 2) | 0;
                                                                                                                        Y: {
                                                                                                                            if ((c | 0) == -1) {
                                                                                                                                F[i + (p << 2) >> 2] = -1;
                                                                                                                                d = -1;
                                                                                                                                break Y;
                                                                                                                            }
                                                                                                                            Z: {
                                                                                                                                _: {
                                                                                                                                    $: {
                                                                                                                                        if ((c >>> 0) % 3 | 0) {
                                                                                                                                            d = c - 1 | 0;
                                                                                                                                            break $;
                                                                                                                                        }
                                                                                                                                        d = c + 2 | 0;
                                                                                                                                        if ((d | 0) == -1) {
                                                                                                                                            break _;
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                    d = F[i + (d << 2) >> 2];
                                                                                                                                    F[i + (p << 2) >> 2] = d;
                                                                                                                                    if ((d | 0) == -1) {
                                                                                                                                        break Z;
                                                                                                                                    }
                                                                                                                                    F[q + (d << 2) >> 2] = p;
                                                                                                                                    break Z;
                                                                                                                                }
                                                                                                                                F[i + (p << 2) >> 2] = -1;
                                                                                                                            }
                                                                                                                            p = c + 1 | 0;
                                                                                                                            c = (p >>> 0) % 3 | 0 ? p : c - 2 | 0;
                                                                                                                            d = -1;
                                                                                                                            if ((c | 0) == -1) {
                                                                                                                                break Y;
                                                                                                                            }
                                                                                                                            d = F[i + (c << 2) >> 2];
                                                                                                                        }
                                                                                                                        F[K >> 2] = d;
                                                                                                                        F[J >> 2] = n;
                                                                                                                        break W;
                                                                                                                    case 0:
                                                                                                                        if ((b | 0) == (i | 0)) {
                                                                                                                            break D;
                                                                                                                        }
                                                                                                                        e = b - 4 | 0;
                                                                                                                        p = F[e >> 2];
                                                                                                                        F[o + 68 >> 2] = e;
                                                                                                                        q = F[o + 44 >> 2];
                                                                                                                        aa: {
                                                                                                                            if (!q) {
                                                                                                                                break aa;
                                                                                                                            }
                                                                                                                            c = F[o + 40 >> 2];
                                                                                                                            w = Kj(q) >>> 0 > 1;
                                                                                                                            d = a & q + 2147483647;
                                                                                                                            ba: {
                                                                                                                                if (!w) {
                                                                                                                                    break ba;
                                                                                                                                }
                                                                                                                                d = a;
                                                                                                                                if (a >>> 0 < q >>> 0) {
                                                                                                                                    break ba;
                                                                                                                                }
                                                                                                                                d = (a >>> 0) % (q >>> 0) | 0;
                                                                                                                            }
                                                                                                                            n = d;
                                                                                                                            d = F[c + (n << 2) >> 2];
                                                                                                                            if (!d) {
                                                                                                                                break aa;
                                                                                                                            }
                                                                                                                            d = F[d >> 2];
                                                                                                                            if (!d) {
                                                                                                                                break aa;
                                                                                                                            }
                                                                                                                            ca: {
                                                                                                                                if (!w) {
                                                                                                                                    c = q - 1 | 0;
                                                                                                                                    while (1) {
                                                                                                                                        q = F[d + 4 >> 2];
                                                                                                                                        da: {
                                                                                                                                            if ((q | 0) != (a | 0)) {
                                                                                                                                                if ((n | 0) == (c & q)) {
                                                                                                                                                    break da;
                                                                                                                                                }
                                                                                                                                                break aa;
                                                                                                                                            }
                                                                                                                                            if ((a | 0) == F[d + 8 >> 2]) {
                                                                                                                                                break ca;
                                                                                                                                            }
                                                                                                                                        }
                                                                                                                                        d = F[d >> 2];
                                                                                                                                        if (d) {
                                                                                                                                            continue;
                                                                                                                                        }
                                                                                                                                        break;
                                                                                                                                    }
                                                                                                                                    break aa;
                                                                                                                                }
                                                                                                                                while (1) {
                                                                                                                                    c = F[d + 4 >> 2];
                                                                                                                                    ea: {
                                                                                                                                        if ((c | 0) != (a | 0)) {
                                                                                                                                            if (c >>> 0 >= q >>> 0) {
                                                                                                                                                c = (c >>> 0) % (q >>> 0) | 0;
                                                                                                                                            }
                                                                                                                                            if ((c | 0) == (n | 0)) {
                                                                                                                                                break ea;
                                                                                                                                            }
                                                                                                                                            break aa;
                                                                                                                                        }
                                                                                                                                        if ((a | 0) == F[d + 8 >> 2]) {
                                                                                                                                            break ca;
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                    d = F[d >> 2];
                                                                                                                                    if (d) {
                                                                                                                                        continue;
                                                                                                                                    }
                                                                                                                                    break;
                                                                                                                                }
                                                                                                                                break aa;
                                                                                                                            }
                                                                                                                            if ((e | 0) != (A | 0)) {
                                                                                                                                F[e >> 2] = F[d + 12 >> 2];
                                                                                                                                F[o + 68 >> 2] = b;
                                                                                                                                e = b;
                                                                                                                                break aa;
                                                                                                                            }
                                                                                                                            b = A - i | 0;
                                                                                                                            c = b >> 2;
                                                                                                                            e = c + 1 | 0;
                                                                                                                            if (e >>> 0 >= 1073741824) {
                                                                                                                                break T;
                                                                                                                            }
                                                                                                                            g = b >> 1;
                                                                                                                            e = b >>> 0 < 2147483644 ? e >>> 0 > g >>> 0 ? e : g : 1073741823;
                                                                                                                            if (e) {
                                                                                                                                if (e >>> 0 >= 1073741824) {
                                                                                                                                    break A;
                                                                                                                                }
                                                                                                                                g = sa(e << 2);
                                                                                                                            }
                                                                                                                            else {
                                                                                                                                g = 0;
                                                                                                                            }
                                                                                                                            c = g + (c << 2) | 0;
                                                                                                                            F[c >> 2] = F[d + 12 >> 2];
                                                                                                                            A = (e << 2) + g | 0;
                                                                                                                            e = c + 4 | 0;
                                                                                                                            if ((b | 0) > 0) {
                                                                                                                                ta(g, i, b);
                                                                                                                            }
                                                                                                                            F[o + 72 >> 2] = A;
                                                                                                                            F[o + 68 >> 2] = e;
                                                                                                                            F[o + 64 >> 2] = g;
                                                                                                                            if (!i) {
                                                                                                                                break aa;
                                                                                                                            }
                                                                                                                            ra(i);
                                                                                                                        }
                                                                                                                        if ((e | 0) == (g | 0)) {
                                                                                                                            break U;
                                                                                                                        }
                                                                                                                        w = e - 4 | 0;
                                                                                                                        c = F[w >> 2];
                                                                                                                        d = (c | 0) == -1;
                                                                                                                        n = F[l + 8 >> 2];
                                                                                                                        if (!d & F[F[n + 12 >> 2] + (c << 2) >> 2] != -1) {
                                                                                                                            break U;
                                                                                                                        }
                                                                                                                        q = F[n + 12 >> 2];
                                                                                                                        if ((p | 0) != -1 & F[q + (p << 2) >> 2] != -1) {
                                                                                                                            break U;
                                                                                                                        }
                                                                                                                        b = L(a, 3);
                                                                                                                        t = b + 2 | 0;
                                                                                                                        F[q + (c << 2) >> 2] = t;
                                                                                                                        a = t << 2;
                                                                                                                        F[a + q >> 2] = c;
                                                                                                                        i = b + 1 | 0;
                                                                                                                        F[q + (p << 2) >> 2] = i;
                                                                                                                        x = i << 2;
                                                                                                                        F[x + q >> 2] = p;
                                                                                                                        if (d) {
                                                                                                                            break S;
                                                                                                                        }
                                                                                                                        if ((c >>> 0) % 3 | 0) {
                                                                                                                            j = c - 1 | 0;
                                                                                                                            break Q;
                                                                                                                        }
                                                                                                                        j = c + 2 | 0;
                                                                                                                        if ((j | 0) != -1) {
                                                                                                                            break Q;
                                                                                                                        }
                                                                                                                        i = F[n >> 2];
                                                                                                                        d = -1;
                                                                                                                        break P;
                                                                                                                    case 6: break X;
                                                                                                                    default: break D;
                                                                                                                }
                                                                                                            }
                                                                                                            c = F[l + 8 >> 2];
                                                                                                            Sa(c + 24 | 0);
                                                                                                            d = F[l + 8 >> 2];
                                                                                                            e = L(a, 3);
                                                                                                            p = F[c + 28 >> 2] - F[c + 24 >> 2] | 0;
                                                                                                            n = p >> 2;
                                                                                                            w = n - 1 | 0;
                                                                                                            F[F[d >> 2] + (e << 2) >> 2] = w;
                                                                                                            Sa(d + 24 | 0);
                                                                                                            q = e + 1 | 0;
                                                                                                            F[F[d >> 2] + (q << 2) >> 2] = (F[d + 28 >> 2] - F[d + 24 >> 2] >> 2) - 1;
                                                                                                            d = F[l + 8 >> 2];
                                                                                                            Sa(d + 24 | 0);
                                                                                                            x = e + 2 | 0;
                                                                                                            F[F[d >> 2] + (x << 2) >> 2] = (F[d + 28 >> 2] - F[d + 24 >> 2] >> 2) - 1;
                                                                                                            d = F[l + 8 >> 2];
                                                                                                            c = F[d + 24 >> 2];
                                                                                                            if (F[d + 28 >> 2] - c >> 2 > (B | 0)) {
                                                                                                                break D;
                                                                                                            }
                                                                                                            fa: {
                                                                                                                ga: {
                                                                                                                    if (!p) {
                                                                                                                        F[c + (n << 2) >> 2] = q;
                                                                                                                        d = 1;
                                                                                                                        break ga;
                                                                                                                    }
                                                                                                                    F[c + (w << 2) >> 2] = e;
                                                                                                                    d = 0;
                                                                                                                    if ((p | 0) == -4) {
                                                                                                                        break ga;
                                                                                                                    }
                                                                                                                    F[c + (n << 2) >> 2] = q;
                                                                                                                    d = n + 1 | 0;
                                                                                                                    if ((d | 0) == -1) {
                                                                                                                        break fa;
                                                                                                                    }
                                                                                                                }
                                                                                                                F[c + (d << 2) >> 2] = x;
                                                                                                            }
                                                                                                            if ((b | 0) != (A | 0)) {
                                                                                                                F[b >> 2] = e;
                                                                                                                e = b + 4 | 0;
                                                                                                                F[o + 68 >> 2] = e;
                                                                                                                b = e;
                                                                                                                break V;
                                                                                                            }
                                                                                                            b = b - i | 0;
                                                                                                            c = b >> 2;
                                                                                                            g = c + 1 | 0;
                                                                                                            if (g >>> 0 >= 1073741824) {
                                                                                                                break R;
                                                                                                            }
                                                                                                            d = b >> 1;
                                                                                                            d = b >>> 0 < 2147483644 ? d >>> 0 < g >>> 0 ? g : d : 1073741823;
                                                                                                            if (d) {
                                                                                                                if (d >>> 0 >= 1073741824) {
                                                                                                                    break A;
                                                                                                                }
                                                                                                                g = sa(d << 2);
                                                                                                            }
                                                                                                            else {
                                                                                                                g = 0;
                                                                                                            }
                                                                                                            c = g + (c << 2) | 0;
                                                                                                            F[c >> 2] = e;
                                                                                                            A = (d << 2) + g | 0;
                                                                                                            e = c + 4 | 0;
                                                                                                            if ((b | 0) > 0) {
                                                                                                                ta(g, i, b);
                                                                                                            }
                                                                                                            F[o + 72 >> 2] = A;
                                                                                                            F[o + 68 >> 2] = e;
                                                                                                            F[o + 64 >> 2] = g;
                                                                                                            if (i) {
                                                                                                                ra(i);
                                                                                                            }
                                                                                                            b = e;
                                                                                                        }
                                                                                                        i = g;
                                                                                                    }
                                                                                                    ze(r, F[b - 4 >> 2]);
                                                                                                    d = F[l + 40 >> 2];
                                                                                                    if ((d | 0) == F[l + 36 >> 2]) {
                                                                                                        break I;
                                                                                                    }
                                                                                                    c = m + (a ^ -1) | 0;
                                                                                                    n = e - 4 | 0;
                                                                                                    while (1) {
                                                                                                        a = F[d - 8 >> 2];
                                                                                                        if (a >>> 0 > c >>> 0) {
                                                                                                            break U;
                                                                                                        }
                                                                                                        if ((a | 0) != (c | 0)) {
                                                                                                            break I;
                                                                                                        }
                                                                                                        p = G[d - 4 | 0];
                                                                                                        a = d - 12 | 0;
                                                                                                        b = F[a >> 2];
                                                                                                        F[l + 40 >> 2] = a;
                                                                                                        if ((b | 0) < 0) {
                                                                                                            break U;
                                                                                                        }
                                                                                                        a = F[n >> 2];
                                                                                                        F[o + 20 >> 2] = m + (b ^ -1);
                                                                                                        b = o + 20 | 0;
                                                                                                        F[o + 88 >> 2] = b;
                                                                                                        $c(o, o + 40 | 0, b, o + 88 | 0);
                                                                                                        d = F[o >> 2];
                                                                                                        ha: {
                                                                                                            if (p & 1) {
                                                                                                                b = -1;
                                                                                                                if ((a | 0) == -1) {
                                                                                                                    break ha;
                                                                                                                }
                                                                                                                b = a + 1 | 0;
                                                                                                                b = (b >>> 0) % 3 | 0 ? b : a - 2 | 0;
                                                                                                                break ha;
                                                                                                            }
                                                                                                            b = -1;
                                                                                                            if ((a | 0) == -1) {
                                                                                                                break ha;
                                                                                                            }
                                                                                                            b = a - 1 | 0;
                                                                                                            if ((a >>> 0) % 3 | 0) {
                                                                                                                break ha;
                                                                                                            }
                                                                                                            b = a + 2 | 0;
                                                                                                        }
                                                                                                        F[d + 12 >> 2] = b;
                                                                                                        b = e;
                                                                                                        d = F[l + 40 >> 2];
                                                                                                        if ((d | 0) != F[l + 36 >> 2]) {
                                                                                                            continue;
                                                                                                        }
                                                                                                        break;
                                                                                                    }
                                                                                                    break I;
                                                                                                }
                                                                                                if (t & 1) {
                                                                                                    break D;
                                                                                                }
                                                                                                break E;
                                                                                            }
                                                                                            va();
                                                                                            V();
                                                                                        }
                                                                                        d = -1;
                                                                                        i = F[n >> 2];
                                                                                        F[i + (b << 2) >> 2] = -1;
                                                                                        j = -1;
                                                                                        break O;
                                                                                    }
                                                                                    va();
                                                                                    V();
                                                                                }
                                                                                i = F[n >> 2];
                                                                                d = F[i + (j << 2) >> 2];
                                                                            }
                                                                            F[(b << 2) + i >> 2] = d;
                                                                            J = c + 1 | 0;
                                                                            c = (J >>> 0) % 3 | 0 ? J : c - 2 | 0;
                                                                            j = -1;
                                                                            if ((c | 0) == -1) {
                                                                                break O;
                                                                            }
                                                                            j = F[(c << 2) + i >> 2];
                                                                        }
                                                                        F[i + x >> 2] = j;
                                                                        ia: {
                                                                            if ((p | 0) == -1) {
                                                                                F[a + i >> 2] = -1;
                                                                                t = -1;
                                                                                j = -1;
                                                                                break ia;
                                                                            }
                                                                            ja: {
                                                                                ka: {
                                                                                    la: {
                                                                                        if ((p >>> 0) % 3 | 0) {
                                                                                            j = p - 1 | 0;
                                                                                            break la;
                                                                                        }
                                                                                        j = p + 2 | 0;
                                                                                        if ((j | 0) == -1) {
                                                                                            break ka;
                                                                                        }
                                                                                    }
                                                                                    c = a + i | 0;
                                                                                    a = F[(j << 2) + i >> 2];
                                                                                    F[c >> 2] = a;
                                                                                    if ((a | 0) == -1) {
                                                                                        break ja;
                                                                                    }
                                                                                    F[F[n + 24 >> 2] + (a << 2) >> 2] = t;
                                                                                    break ja;
                                                                                }
                                                                                F[a + i >> 2] = -1;
                                                                            }
                                                                            t = -1;
                                                                            a = p + 1 | 0;
                                                                            a = (a >>> 0) % 3 | 0 ? a : p - 2 | 0;
                                                                            j = -1;
                                                                            if ((a | 0) == -1) {
                                                                                break ia;
                                                                            }
                                                                            t = F[(a << 2) + i >> 2];
                                                                            j = a;
                                                                        }
                                                                        a = F[l + 388 >> 2];
                                                                        c = d << 2;
                                                                        p = a + c | 0;
                                                                        K = a;
                                                                        a = t << 2;
                                                                        F[p >> 2] = F[p >> 2] + F[K + a >> 2];
                                                                        n = F[n + 24 >> 2];
                                                                        a = n + a | 0;
                                                                        if ((d | 0) != -1) {
                                                                            F[c + n >> 2] = F[a >> 2];
                                                                        }
                                                                        ma: {
                                                                            if ((j | 0) == -1) {
                                                                                break ma;
                                                                            }
                                                                            while (1) {
                                                                                F[(j << 2) + i >> 2] = d;
                                                                                c = j + 1 | 0;
                                                                                c = (c >>> 0) % 3 | 0 ? c : j - 2 | 0;
                                                                                if ((c | 0) == -1) {
                                                                                    break ma;
                                                                                }
                                                                                c = F[q + (c << 2) >> 2];
                                                                                if ((c | 0) == -1) {
                                                                                    break ma;
                                                                                }
                                                                                j = c + 1 | 0;
                                                                                j = (j >>> 0) % 3 | 0 ? j : c - 2 | 0;
                                                                                if ((j | 0) != -1) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                        }
                                                                        F[a >> 2] = -1;
                                                                        na: {
                                                                            if (O) {
                                                                                break na;
                                                                            }
                                                                            if ((z | 0) != (C | 0)) {
                                                                                F[z >> 2] = t;
                                                                                z = z + 4 | 0;
                                                                                F[o + 28 >> 2] = z;
                                                                                break na;
                                                                            }
                                                                            oa: {
                                                                                a = C - u | 0;
                                                                                c = a >> 2;
                                                                                h = c + 1 | 0;
                                                                                if (h >>> 0 < 1073741824) {
                                                                                    d = a >> 1;
                                                                                    d = a >>> 0 < 2147483644 ? d >>> 0 < h >>> 0 ? h : d : 1073741823;
                                                                                    if (d) {
                                                                                        if (d >>> 0 >= 1073741824) {
                                                                                            break oa;
                                                                                        }
                                                                                        h = sa(d << 2);
                                                                                    }
                                                                                    else {
                                                                                        h = 0;
                                                                                    }
                                                                                    c = h + (c << 2) | 0;
                                                                                    F[c >> 2] = t;
                                                                                    C = (d << 2) + h | 0;
                                                                                    z = c + 4 | 0;
                                                                                    if ((a | 0) > 0) {
                                                                                        ta(h, u, a);
                                                                                    }
                                                                                    F[o + 32 >> 2] = C;
                                                                                    F[o + 28 >> 2] = z;
                                                                                    F[o + 24 >> 2] = h;
                                                                                    if (u) {
                                                                                        ra(u);
                                                                                    }
                                                                                    u = h;
                                                                                    break na;
                                                                                }
                                                                                va();
                                                                                V();
                                                                            }
                                                                            break A;
                                                                        }
                                                                        F[w >> 2] = b;
                                                                    }
                                                                    ze(r, b);
                                                                    b = e;
                                                                    i = g;
                                                                }
                                                                t = (m | 0) > (s | 0);
                                                                if ((m | 0) != (s | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                            s = m;
                                                        }
                                                        j = -1;
                                                        b = F[l + 8 >> 2];
                                                        if (F[b + 28 >> 2] - F[b + 24 >> 2] >> 2 > (B | 0)) {
                                                            break D;
                                                        }
                                                        if ((e | 0) != (g | 0)) {
                                                            a = l + 60 | 0;
                                                            A = l + 312 | 0;
                                                            while (1) {
                                                                e = e - 4 | 0;
                                                                u = F[e >> 2];
                                                                F[o + 68 >> 2] = e;
                                                                pa: {
                                                                    qa: {
                                                                        ra: {
                                                                            sa: {
                                                                                if (H[l + 270 >> 1] <= 513) {
                                                                                    if (!G[l + 364 | 0]) {
                                                                                        break ra;
                                                                                    }
                                                                                    b = F[l + 360 >> 2];
                                                                                    d = F[l + 352 >> 2] + (b >>> 3 | 0) | 0;
                                                                                    if (d >>> 0 >= I[l + 356 >> 2]) {
                                                                                        break qa;
                                                                                    }
                                                                                    d = G[d | 0];
                                                                                    F[l + 360 >> 2] = b + 1;
                                                                                    b = d >>> (b & 7) & 1;
                                                                                    break sa;
                                                                                }
                                                                                b = Ga(A);
                                                                            }
                                                                            if (!b) {
                                                                                break qa;
                                                                            }
                                                                        }
                                                                        r = F[l + 8 >> 2];
                                                                        n = F[r >> 2];
                                                                        if (((F[r + 4 >> 2] - n >> 2 >>> 0) / 3 | 0) <= (s | 0)) {
                                                                            break D;
                                                                        }
                                                                        d = -1;
                                                                        c = -1;
                                                                        i = F[r + 24 >> 2];
                                                                        b = -1;
                                                                        ta: {
                                                                            if ((u | 0) == -1) {
                                                                                break ta;
                                                                            }
                                                                            m = u + 1 | 0;
                                                                            m = (m >>> 0) % 3 | 0 ? m : u - 2 | 0;
                                                                            b = -1;
                                                                            if ((m | 0) == -1) {
                                                                                break ta;
                                                                            }
                                                                            b = F[n + (m << 2) >> 2];
                                                                        }
                                                                        m = b;
                                                                        b = F[i + (m << 2) >> 2];
                                                                        ua: {
                                                                            if ((b | 0) == -1) {
                                                                                break ua;
                                                                            }
                                                                            t = b + 1 | 0;
                                                                            b = (t >>> 0) % 3 | 0 ? t : b - 2 | 0;
                                                                            if ((b | 0) == -1) {
                                                                                break ua;
                                                                            }
                                                                            d = b + 1 | 0;
                                                                            d = (d >>> 0) % 3 | 0 ? d : b - 2 | 0;
                                                                            if ((d | 0) != -1) {
                                                                                c = F[n + (d << 2) >> 2];
                                                                            }
                                                                            d = b;
                                                                        }
                                                                        t = -1;
                                                                        p = -1;
                                                                        i = F[i + (c << 2) >> 2];
                                                                        b = -1;
                                                                        va: {
                                                                            if ((i | 0) == -1) {
                                                                                break va;
                                                                            }
                                                                            q = i + 1 | 0;
                                                                            i = (q >>> 0) % 3 | 0 ? q : i - 2 | 0;
                                                                            b = -1;
                                                                            if ((i | 0) == -1) {
                                                                                break va;
                                                                            }
                                                                            b = i + 1 | 0;
                                                                            b = (b >>> 0) % 3 | 0 ? b : i - 2 | 0;
                                                                            if ((b | 0) != -1) {
                                                                                p = F[n + (b << 2) >> 2];
                                                                            }
                                                                            b = i;
                                                                        }
                                                                        r = F[r + 12 >> 2];
                                                                        i = L(s, 3);
                                                                        B = i << 2;
                                                                        F[r + B >> 2] = u;
                                                                        F[r + (u << 2) >> 2] = i;
                                                                        u = i + 1 | 0;
                                                                        C = u << 2;
                                                                        F[C + r >> 2] = d;
                                                                        F[r + (d << 2) >> 2] = u;
                                                                        q = i + 2 | 0;
                                                                        d = q << 2;
                                                                        F[d + r >> 2] = b;
                                                                        F[r + (b << 2) >> 2] = q;
                                                                        F[n + B >> 2] = c;
                                                                        r = n + C | 0;
                                                                        F[r >> 2] = p;
                                                                        n = d + n | 0;
                                                                        F[n >> 2] = m;
                                                                        b = F[l + 120 >> 2];
                                                                        d = i >>> 0 > u >>> 0 ? -1 : c;
                                                                        c = b + (d >>> 3 & 536870908) | 0;
                                                                        m = F[c >> 2];
                                                                        P = c, Q = Lj(d) & m, F[P >> 2] = Q;
                                                                        t = (u | 0) != -1 ? F[r >> 2] : t;
                                                                        d = b + (t >>> 3 & 536870908) | 0;
                                                                        c = F[d >> 2];
                                                                        P = d, Q = Lj(t) & c, F[P >> 2] = Q;
                                                                        d = -1;
                                                                        d = (q | 0) != -1 ? F[n >> 2] : d;
                                                                        b = b + (d >>> 3 & 536870908) | 0;
                                                                        c = F[b >> 2];
                                                                        P = b, Q = Lj(d) & c, F[P >> 2] = Q;
                                                                        d = F[l + 64 >> 2];
                                                                        b = F[l + 68 >> 2];
                                                                        if ((d | 0) == b << 5) {
                                                                            if ((d + 1 | 0) < 0) {
                                                                                break C;
                                                                            }
                                                                            if (d >>> 0 <= 1073741822) {
                                                                                d = d + 32 & -32;
                                                                                b = b << 6;
                                                                                b = b >>> 0 < d >>> 0 ? d : b;
                                                                            }
                                                                            else {
                                                                                b = 2147483647;
                                                                            }
                                                                            db(a, b);
                                                                            d = F[l + 64 >> 2];
                                                                        }
                                                                        s = s + 1 | 0;
                                                                        F[l + 64 >> 2] = d + 1;
                                                                        b = F[l + 60 >> 2] + (d >>> 3 & 536870908) | 0;
                                                                        F[b >> 2] = F[b >> 2] | 1 << d;
                                                                        b = F[l + 76 >> 2];
                                                                        if ((b | 0) != F[l + 80 >> 2]) {
                                                                            F[b >> 2] = i;
                                                                            F[l + 76 >> 2] = b + 4;
                                                                            break pa;
                                                                        }
                                                                        c = F[l + 72 >> 2];
                                                                        d = b - c | 0;
                                                                        u = d >> 2;
                                                                        b = u + 1 | 0;
                                                                        if (b >>> 0 >= 1073741824) {
                                                                            break B;
                                                                        }
                                                                        m = d >> 1;
                                                                        m = d >>> 0 < 2147483644 ? b >>> 0 > m >>> 0 ? b : m : 1073741823;
                                                                        if (m) {
                                                                            if (m >>> 0 >= 1073741824) {
                                                                                break A;
                                                                            }
                                                                            b = sa(m << 2);
                                                                        }
                                                                        else {
                                                                            b = 0;
                                                                        }
                                                                        u = b + (u << 2) | 0;
                                                                        F[u >> 2] = i;
                                                                        if ((d | 0) > 0) {
                                                                            ta(b, c, d);
                                                                        }
                                                                        F[l + 80 >> 2] = b + (m << 2);
                                                                        F[l + 76 >> 2] = u + 4;
                                                                        F[l + 72 >> 2] = b;
                                                                        if (!c) {
                                                                            break pa;
                                                                        }
                                                                        ra(c);
                                                                        break pa;
                                                                    }
                                                                    b = F[l + 64 >> 2];
                                                                    d = F[l + 68 >> 2];
                                                                    if ((b | 0) == d << 5) {
                                                                        if ((b + 1 | 0) < 0) {
                                                                            break C;
                                                                        }
                                                                        if (b >>> 0 <= 1073741822) {
                                                                            b = b + 32 & -32;
                                                                            d = d << 6;
                                                                            b = b >>> 0 > d >>> 0 ? b : d;
                                                                        }
                                                                        else {
                                                                            b = 2147483647;
                                                                        }
                                                                        db(a, b);
                                                                        b = F[l + 64 >> 2];
                                                                    }
                                                                    F[l + 64 >> 2] = b + 1;
                                                                    d = F[l + 60 >> 2] + (b >>> 3 & 536870908) | 0;
                                                                    c = F[d >> 2];
                                                                    P = d, Q = Lj(b) & c, F[P >> 2] = Q;
                                                                    b = F[l + 76 >> 2];
                                                                    if ((b | 0) != F[l + 80 >> 2]) {
                                                                        F[b >> 2] = u;
                                                                        F[l + 76 >> 2] = b + 4;
                                                                        break pa;
                                                                    }
                                                                    c = F[l + 72 >> 2];
                                                                    d = b - c | 0;
                                                                    m = d >> 2;
                                                                    b = m + 1 | 0;
                                                                    if (b >>> 0 >= 1073741824) {
                                                                        break B;
                                                                    }
                                                                    i = d >> 1;
                                                                    i = d >>> 0 < 2147483644 ? b >>> 0 > i >>> 0 ? b : i : 1073741823;
                                                                    if (i) {
                                                                        if (i >>> 0 >= 1073741824) {
                                                                            break A;
                                                                        }
                                                                        b = sa(i << 2);
                                                                    }
                                                                    else {
                                                                        b = 0;
                                                                    }
                                                                    m = b + (m << 2) | 0;
                                                                    F[m >> 2] = u;
                                                                    if ((d | 0) > 0) {
                                                                        ta(b, c, d);
                                                                    }
                                                                    F[l + 80 >> 2] = b + (i << 2);
                                                                    F[l + 76 >> 2] = m + 4;
                                                                    F[l + 72 >> 2] = b;
                                                                    if (!c) {
                                                                        break pa;
                                                                    }
                                                                    ra(c);
                                                                }
                                                                if ((e | 0) != (g | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                            b = F[l + 8 >> 2];
                                                        }
                                                        if (((F[b + 4 >> 2] - F[b >> 2] >> 2 >>> 0) / 3 | 0) != (s | 0)) {
                                                            break D;
                                                        }
                                                        d = F[b + 24 >> 2];
                                                        j = F[b + 28 >> 2] - d >> 2;
                                                        if ((h | 0) == (z | 0)) {
                                                            h = z;
                                                            break D;
                                                        }
                                                        c = h;
                                                        while (1) {
                                                            a = F[c >> 2];
                                                            e = j - 1 | 0;
                                                            i = (e << 2) + d | 0;
                                                            if (F[i >> 2] == -1) {
                                                                while (1) {
                                                                    e = j - 2 | 0;
                                                                    j = j - 1 | 0;
                                                                    i = (e << 2) + d | 0;
                                                                    if (F[i >> 2] == -1) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            if (a >>> 0 <= e >>> 0) {
                                                                F[o >> 2] = b;
                                                                d = F[i >> 2];
                                                                D[o + 12 | 0] = 1;
                                                                F[o + 8 >> 2] = d;
                                                                F[o + 4 >> 2] = d;
                                                                if ((d | 0) != -1) {
                                                                    while (1) {
                                                                        F[F[b >> 2] + (d << 2) >> 2] = a;
                                                                        vc(o);
                                                                        b = F[l + 8 >> 2];
                                                                        d = F[o + 8 >> 2];
                                                                        if ((d | 0) != -1) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                }
                                                                d = F[b + 24 >> 2];
                                                                i = d + (e << 2) | 0;
                                                                if ((a | 0) != -1) {
                                                                    F[(a << 2) + d >> 2] = F[i >> 2];
                                                                }
                                                                F[i >> 2] = -1;
                                                                i = 1 << a;
                                                                s = F[l + 120 >> 2];
                                                                a = s + (a >>> 3 & 536870908) | 0;
                                                                s = s + (e >>> 3 & 536870908) | 0;
                                                                e = 1 << e;
                                                                if (F[s >> 2] & e) {
                                                                    i = i | F[a >> 2];
                                                                }
                                                                else {
                                                                    i = F[a >> 2] & (i ^ -1);
                                                                }
                                                                F[a >> 2] = i;
                                                                F[s >> 2] = F[s >> 2] & (e ^ -1);
                                                                j = j - 1 | 0;
                                                            }
                                                            c = c + 4 | 0;
                                                            if ((z | 0) != (c | 0)) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    if (h) {
                                                        ra(h);
                                                    }
                                                    a = F[o + 48 >> 2];
                                                    if (a) {
                                                        while (1) {
                                                            b = F[a >> 2];
                                                            ra(a);
                                                            a = b;
                                                            if (b) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    a = F[o + 40 >> 2];
                                                    F[o + 40 >> 2] = 0;
                                                    if (a) {
                                                        ra(a);
                                                    }
                                                    if (g) {
                                                        F[o + 68 >> 2] = g;
                                                        ra(g);
                                                    }
                                                    ea = o + 96 | 0;
                                                    break z;
                                                }
                                                Oa();
                                                V();
                                            }
                                            va();
                                            V();
                                        }
                                        wa(1336);
                                        V();
                                    }
                                    if ((j | 0) == -1) {
                                        break y;
                                    }
                                    a = F[k + 16 >> 2];
                                    b = a + F[k >> 2] | 0;
                                    e = F[k + 8 >> 2];
                                    e = e - a | 0;
                                    a = F[F[l + 4 >> 2] + 32 >> 2];
                                    E[a + 38 >> 1] = H[a + 38 >> 1];
                                    F[a >> 2] = b;
                                    F[a + 16 >> 2] = 0;
                                    F[a + 20 >> 2] = 0;
                                    F[a + 8 >> 2] = e;
                                    F[a + 12 >> 2] = 0;
                                    a = F[l + 4 >> 2];
                                    b = H[a + 36 >> 1];
                                    h = b << 8 | b >>> 8;
                                    if ((h & 65535) >>> 0 <= 513) {
                                        a = F[a + 32 >> 2];
                                        e = N + F[a + 20 >> 2] | 0;
                                        b = y + F[a + 16 >> 2] | 0;
                                        e = b >>> 0 < y >>> 0 ? e + 1 | 0 : e;
                                        F[a + 16 >> 2] = b;
                                        F[a + 20 >> 2] = e;
                                    }
                                    wa: {
                                        if (F[l + 216 >> 2] == F[l + 220 >> 2]) {
                                            break wa;
                                        }
                                        b = F[l + 8 >> 2];
                                        a = F[b >> 2];
                                        b = F[b + 4 >> 2];
                                        xa: {
                                            if ((h & 65535) >>> 0 >= 513) {
                                                if ((a | 0) == (b | 0)) {
                                                    break wa;
                                                }
                                                b = 0;
                                                break xa;
                                            }
                                            if ((a | 0) == (b | 0)) {
                                                break wa;
                                            }
                                            b = 0;
                                            while (1) {
                                                if (dd(l, b)) {
                                                    b = b + 3 | 0;
                                                    a = F[l + 8 >> 2];
                                                    if (b >>> 0 < F[a + 4 >> 2] - F[a >> 2] >> 2 >>> 0) {
                                                        continue;
                                                    }
                                                    break wa;
                                                }
                                                break;
                                            }
                                            break y;
                                        }
                                        while (1) {
                                            if (cd(l, b)) {
                                                b = b + 3 | 0;
                                                a = F[l + 8 >> 2];
                                                if (b >>> 0 < F[a + 4 >> 2] - F[a >> 2] >> 2 >>> 0) {
                                                    continue;
                                                }
                                                break wa;
                                            }
                                            break;
                                        }
                                        break y;
                                    }
                                    bd(f);
                                    b = F[l + 216 >> 2];
                                    if ((b | 0) != F[l + 220 >> 2]) {
                                        h = 0;
                                        while (1) {
                                            a = L(h, 144);
                                            Ic((a + b | 0) + 4 | 0, F[l + 8 >> 2]);
                                            v = F[M >> 2];
                                            e = a + v | 0;
                                            b = F[e + 132 >> 2];
                                            e = F[e + 136 >> 2];
                                            if ((b | 0) != (e | 0)) {
                                                while (1) {
                                                    Gc((a + v | 0) + 4 | 0, F[b >> 2]);
                                                    v = F[M >> 2];
                                                    b = b + 4 | 0;
                                                    if ((e | 0) != (b | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            Hc((a + v | 0) + 4 | 0);
                                            h = h + 1 | 0;
                                            b = F[l + 216 >> 2];
                                            if (h >>> 0 < (F[l + 220 >> 2] - b | 0) / 144 >>> 0) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    a = F[l + 8 >> 2];
                                    Gb(l + 184 | 0, F[a + 28 >> 2] - F[a + 24 >> 2] >> 2);
                                    v = F[l + 216 >> 2];
                                    if ((v | 0) != F[l + 220 >> 2]) {
                                        b = 0;
                                        while (1) {
                                            a = L(b, 144) + v | 0;
                                            e = F[a + 60 >> 2] - F[a + 56 >> 2] >> 2;
                                            h = a + 104 | 0;
                                            a = F[l + 8 >> 2];
                                            a = F[a + 28 >> 2] - F[a + 24 >> 2] >> 2;
                                            Gb(h, (a | 0) > (e | 0) ? a : e);
                                            b = b + 1 | 0;
                                            v = F[l + 216 >> 2];
                                            if (b >>> 0 < (F[l + 220 >> 2] - v | 0) / 144 >>> 0) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    v = ad(l, j);
                                }
                                break b;
                            }
                            v = 0;
                        } ea = k - -64 | 0; return v | 0; }
                        function di(a) { a = a | 0; var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, J = 0, K = 0, M = 0, N = 0, O = 0, P = 0, Q = 0, R = 0, S = 0; m = ea + -64 | 0; ea = m; F[a + 132 >> 2] = 0; if (F[a + 148 >> 2]) {
                            e = F[a + 144 >> 2];
                            if (e) {
                                while (1) {
                                    d = F[e >> 2];
                                    ra(e);
                                    e = d;
                                    if (d) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            e = 0;
                            F[a + 144 >> 2] = 0;
                            f = F[a + 140 >> 2];
                            a: {
                                if (!f) {
                                    break a;
                                }
                                if (f - 1 >>> 0 >= 3) {
                                    d = f & -4;
                                    while (1) {
                                        b = e << 2;
                                        F[b + F[a + 136 >> 2] >> 2] = 0;
                                        F[F[a + 136 >> 2] + (b | 4) >> 2] = 0;
                                        F[F[a + 136 >> 2] + (b | 8) >> 2] = 0;
                                        F[F[a + 136 >> 2] + (b | 12) >> 2] = 0;
                                        e = e + 4 | 0;
                                        g = g + 4 | 0;
                                        if ((d | 0) != (g | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                d = f & 3;
                                if (!d) {
                                    break a;
                                }
                                while (1) {
                                    F[F[a + 136 >> 2] + (e << 2) >> 2] = 0;
                                    e = e + 1 | 0;
                                    v = v + 1 | 0;
                                    if ((d | 0) != (v | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            F[a + 148 >> 2] = 0;
                        } b: {
                            c: {
                                e = F[a + 4 >> 2];
                                v = G[e + 36 | 0];
                                d = v << 8 | G[e + 37 | 0];
                                d: {
                                    if (d >>> 0 > 513) {
                                        break d;
                                    }
                                    c = F[e + 32 >> 2];
                                    if (d >>> 0 <= 511) {
                                        d = F[c + 20 >> 2];
                                        f = F[c + 16 >> 2];
                                        g = f + 4 | 0;
                                        d = g >>> 0 < 4 ? d + 1 | 0 : d;
                                        b = g;
                                        g = F[c + 12 >> 2];
                                        if (b >>> 0 > I[c + 8 >> 2] & (g | 0) <= (d | 0) | (d | 0) > (g | 0)) {
                                            break c;
                                        }
                                        g = f + F[c >> 2] | 0;
                                        g = G[g | 0] | G[g + 1 | 0] << 8 | (G[g + 2 | 0] << 16 | G[g + 3 | 0] << 24);
                                        F[c + 16 >> 2] = b;
                                        F[c + 20 >> 2] = d;
                                        F[a + 132 >> 2] = g;
                                        break d;
                                    }
                                    if (!Fa(1, m, c)) {
                                        break c;
                                    }
                                    e = F[a + 4 >> 2];
                                    v = G[e + 36 | 0];
                                    F[a + 132 >> 2] = F[m >> 2];
                                }
                                c = F[e + 32 >> 2];
                                e: {
                                    f: {
                                        g: {
                                            if ((v & 255) >>> 0 <= 1) {
                                                v = 0;
                                                d = F[c + 20 >> 2];
                                                f = F[c + 16 >> 2];
                                                g = f + 4 | 0;
                                                d = g >>> 0 < 4 ? d + 1 | 0 : d;
                                                b = g;
                                                g = F[c + 12 >> 2];
                                                if (b >>> 0 > I[c + 8 >> 2] & (g | 0) <= (d | 0) | (d | 0) > (g | 0)) {
                                                    break b;
                                                }
                                                g = f + F[c >> 2] | 0;
                                                g = G[g | 0] | G[g + 1 | 0] << 8 | (G[g + 2 | 0] << 16 | G[g + 3 | 0] << 24);
                                                F[m + 60 >> 2] = g;
                                                F[c + 16 >> 2] = b;
                                                F[c + 20 >> 2] = d;
                                                F[a + 156 >> 2] = g;
                                                c = a + 156 | 0;
                                                break g;
                                            }
                                            v = 0;
                                            if (!Fa(1, m + 60 | 0, c)) {
                                                break b;
                                            }
                                            e = F[a + 4 >> 2];
                                            d = G[e + 36 | 0];
                                            F[a + 156 >> 2] = F[m + 60 >> 2];
                                            c = a + 156 | 0;
                                            if (d >>> 0 > 1) {
                                                break f;
                                            }
                                        }
                                        o = F[e + 32 >> 2];
                                        d = F[o + 8 >> 2];
                                        f = F[o + 12 >> 2];
                                        j = d;
                                        d = F[o + 20 >> 2];
                                        b = F[o + 16 >> 2];
                                        g = b + 4 | 0;
                                        d = g >>> 0 < 4 ? d + 1 | 0 : d;
                                        e = g;
                                        if (j >>> 0 < e >>> 0 & (d | 0) >= (f | 0) | (d | 0) > (f | 0)) {
                                            break b;
                                        }
                                        g = b + F[o >> 2] | 0;
                                        g = G[g | 0] | G[g + 1 | 0] << 8 | (G[g + 2 | 0] << 16 | G[g + 3 | 0] << 24);
                                        F[m + 56 >> 2] = g;
                                        F[o + 16 >> 2] = e;
                                        F[o + 20 >> 2] = d;
                                        break e;
                                    }
                                    if (!Fa(1, m + 56 | 0, F[e + 32 >> 2])) {
                                        break b;
                                    }
                                    g = F[m + 56 >> 2];
                                }
                                if (g >>> 0 > 1431655765 | I[c >> 2] > L(g, 3) >>> 0) {
                                    break b;
                                }
                                x = F[a + 4 >> 2];
                                e = F[x + 32 >> 2];
                                j = F[e + 8 >> 2];
                                f = j;
                                b = F[e + 12 >> 2];
                                d = F[e + 20 >> 2];
                                l = F[e + 16 >> 2];
                                if ((b | 0) <= (d | 0) & l >>> 0 >= f >>> 0 | (d | 0) > (b | 0)) {
                                    break b;
                                }
                                o = F[e >> 2];
                                i = G[o + l | 0];
                                c = l + 1 | 0;
                                f = c ? d : d + 1 | 0;
                                F[e + 16 >> 2] = c;
                                F[e + 20 >> 2] = f;
                                h: {
                                    if (G[x + 36 | 0] <= 1) {
                                        f = l + 5 | 0;
                                        d = f >>> 0 < 5 ? d + 1 | 0 : d;
                                        if (f >>> 0 > j >>> 0 & (d | 0) >= (b | 0) | (d | 0) > (b | 0)) {
                                            break b;
                                        }
                                        b = c + o | 0;
                                        c = G[b | 0] | G[b + 1 | 0] << 8 | (G[b + 2 | 0] << 16 | G[b + 3 | 0] << 24);
                                        F[m + 52 >> 2] = c;
                                        F[e + 16 >> 2] = f;
                                        F[e + 20 >> 2] = d;
                                        break h;
                                    }
                                    if (!Fa(1, m + 52 | 0, e)) {
                                        break b;
                                    }
                                    c = F[m + 52 >> 2];
                                }
                                if (((c >>> 0) / 3 | 0) + c >>> 0 < g >>> 0 | c >>> 0 > g >>> 0) {
                                    break b;
                                }
                                d = F[a + 4 >> 2];
                                o = F[d + 32 >> 2];
                                i: {
                                    if (G[d + 36 | 0] <= 1) {
                                        d = F[o + 20 >> 2];
                                        b = F[o + 16 >> 2];
                                        e = b + 4 | 0;
                                        d = e >>> 0 < 4 ? d + 1 | 0 : d;
                                        f = e;
                                        e = F[o + 12 >> 2];
                                        if (f >>> 0 > I[o + 8 >> 2] & (e | 0) <= (d | 0) | (d | 0) > (e | 0)) {
                                            break b;
                                        }
                                        e = b + F[o >> 2] | 0;
                                        b = G[e | 0] | G[e + 1 | 0] << 8 | (G[e + 2 | 0] << 16 | G[e + 3 | 0] << 24);
                                        F[m + 48 >> 2] = b;
                                        F[o + 16 >> 2] = f;
                                        F[o + 20 >> 2] = d;
                                        break i;
                                    }
                                    if (!Fa(1, m + 48 | 0, o)) {
                                        break b;
                                    }
                                    b = F[m + 48 >> 2];
                                }
                                if (c >>> 0 < b >>> 0) {
                                    break b;
                                }
                                F[a + 28 >> 2] = F[a + 24 >> 2];
                                d = sa(88);
                                Lc(d);
                                e = F[a + 8 >> 2];
                                F[a + 8 >> 2] = d;
                                if (e) {
                                    cb(e);
                                    if (!F[a + 8 >> 2]) {
                                        break b;
                                    }
                                }
                                F[a + 164 >> 2] = F[a + 160 >> 2];
                                Ib(a + 160 | 0, g);
                                F[a + 176 >> 2] = F[a + 172 >> 2];
                                Ib(a + 172 | 0, g);
                                F[a - -64 >> 2] = 0;
                                F[a + 92 >> 2] = -1;
                                F[a + 84 >> 2] = -1;
                                F[a + 88 >> 2] = -1;
                                F[a + 40 >> 2] = F[a + 36 >> 2];
                                F[a + 52 >> 2] = F[a + 48 >> 2];
                                F[a + 76 >> 2] = F[a + 72 >> 2];
                                N = a + 216 | 0;
                                fd(N);
                                ed(N, i);
                                if (!Kc(F[a + 8 >> 2], g, F[a + 156 >> 2] + b | 0)) {
                                    break b;
                                }
                                d = F[a + 156 >> 2];
                                D[m | 0] = 1;
                                Na(a + 120 | 0, d + b | 0, m);
                                g = F[a + 4 >> 2];
                                d = H[g + 36 >> 1];
                                d = (d << 8 | d >>> 8) & 65535;
                                j: {
                                    if (d >>> 0 <= 513) {
                                        o = F[g + 32 >> 2];
                                        k: {
                                            if (d >>> 0 <= 511) {
                                                d = F[o + 20 >> 2];
                                                f = F[o + 16 >> 2];
                                                g = f + 4 | 0;
                                                d = g >>> 0 < 4 ? d + 1 | 0 : d;
                                                e = g;
                                                g = F[o + 12 >> 2];
                                                if (e >>> 0 > I[o + 8 >> 2] & (g | 0) <= (d | 0) | (d | 0) > (g | 0)) {
                                                    break b;
                                                }
                                                g = f + F[o >> 2] | 0;
                                                g = G[g | 0] | G[g + 1 | 0] << 8 | (G[g + 2 | 0] << 16 | G[g + 3 | 0] << 24);
                                                F[o + 16 >> 2] = e;
                                                F[o + 20 >> 2] = d;
                                                break k;
                                            }
                                            if (!Fa(1, m + 44 | 0, o)) {
                                                break b;
                                            }
                                            g = F[m + 44 >> 2];
                                        }
                                        if (!g) {
                                            break b;
                                        }
                                        o = F[F[a + 4 >> 2] + 32 >> 2];
                                        f = F[o + 8 >> 2];
                                        d = F[o + 16 >> 2];
                                        e = f - d | 0;
                                        d = F[o + 12 >> 2] - (F[o + 20 >> 2] + (d >>> 0 > f >>> 0) | 0) | 0;
                                        if (e >>> 0 < g >>> 0 & (d | 0) <= 0 | (d | 0) < 0) {
                                            break b;
                                        }
                                        E[m + 38 >> 1] = 0;
                                        F[m >> 2] = 0;
                                        F[m + 8 >> 2] = 0;
                                        F[m + 12 >> 2] = 0;
                                        F[m + 16 >> 2] = 0;
                                        F[m + 20 >> 2] = 0;
                                        F[m + 24 >> 2] = 0;
                                        F[m + 28 >> 2] = 0;
                                        D[m + 29 | 0] = 0;
                                        D[m + 30 | 0] = 0;
                                        D[m + 31 | 0] = 0;
                                        D[m + 32 | 0] = 0;
                                        D[m + 33 | 0] = 0;
                                        D[m + 34 | 0] = 0;
                                        D[m + 35 | 0] = 0;
                                        D[m + 36 | 0] = 0;
                                        o = F[F[a + 4 >> 2] + 32 >> 2];
                                        e = o;
                                        d = F[e + 16 >> 2];
                                        f = (d + F[e >> 2] | 0) + g | 0;
                                        e = F[e + 8 >> 2];
                                        d = (e - d | 0) - g | 0;
                                        E[m + 38 >> 1] = H[o + 38 >> 1];
                                        F[m >> 2] = f;
                                        F[m + 16 >> 2] = 0;
                                        F[m + 20 >> 2] = 0;
                                        F[m + 8 >> 2] = d;
                                        F[m + 12 >> 2] = 0;
                                        o = Hb(a, m);
                                        if ((o | 0) == -1) {
                                            break b;
                                        }
                                        Q = o >> 31;
                                        break j;
                                    }
                                    o = -1;
                                    Q = -1;
                                    if ((Hb(a, F[g + 32 >> 2]) | 0) == -1) {
                                        break b;
                                    }
                                }
                                C = a + 232 | 0;
                                Ae(C, a);
                                F[a + 372 >> 2] = i;
                                F[a + 384 >> 2] = F[a + 156 >> 2] + b;
                                E[m + 38 >> 1] = 0;
                                F[m >> 2] = 0;
                                d = m;
                                F[d + 8 >> 2] = 0;
                                F[d + 12 >> 2] = 0;
                                F[d + 16 >> 2] = 0;
                                F[d + 20 >> 2] = 0;
                                F[d + 24 >> 2] = 0;
                                F[d + 28 >> 2] = 0;
                                D[d + 29 | 0] = 0;
                                D[d + 30 | 0] = 0;
                                D[d + 31 | 0] = 0;
                                D[d + 32 | 0] = 0;
                                D[d + 33 | 0] = 0;
                                D[d + 34 | 0] = 0;
                                D[d + 35 | 0] = 0;
                                D[d + 36 | 0] = 0;
                                l = 0;
                                j = ea - 16 | 0;
                                ea = j;
                                l: {
                                    if (!Ce(C, d)) {
                                        break l;
                                    }
                                    g = d;
                                    d = F[d + 20 >> 2];
                                    f = F[g + 16 >> 2];
                                    e = f + 4 | 0;
                                    d = e >>> 0 < 4 ? d + 1 | 0 : d;
                                    b = e;
                                    e = F[g + 12 >> 2];
                                    if (b >>> 0 > I[g + 8 >> 2] & (e | 0) <= (d | 0) | (d | 0) > (e | 0)) {
                                        break l;
                                    }
                                    e = f + F[g >> 2] | 0;
                                    e = G[e | 0] | G[e + 1 | 0] << 8 | (G[e + 2 | 0] << 16 | G[e + 3 | 0] << 24);
                                    F[g + 16 >> 2] = b;
                                    F[g + 20 >> 2] = d;
                                    if ((e | 0) < 0) {
                                        break l;
                                    }
                                    b = F[C + 152 >> 2];
                                    if ((b | 0) <= (e | 0)) {
                                        break l;
                                    }
                                    F[j + 12 >> 2] = 0;
                                    d = F[C + 156 >> 2];
                                    e = F[C + 160 >> 2] - d >> 2;
                                    m: {
                                        if (e >>> 0 < b >>> 0) {
                                            Ia(C + 156 | 0, b - e | 0, j + 12 | 0);
                                            break m;
                                        }
                                        if (b >>> 0 >= e >>> 0) {
                                            break m;
                                        }
                                        F[C + 160 >> 2] = d + (b << 2);
                                    }
                                    l = xa(C + 168 | 0, g);
                                }
                                ea = j + 16 | 0;
                                n: {
                                    if (!l) {
                                        break n;
                                    }
                                    b = 0;
                                    l = 0;
                                    e = 0;
                                    d = 0;
                                    g = 0;
                                    x = 0;
                                    n = ea - 96 | 0;
                                    ea = n;
                                    F[n + 72 >> 2] = 0;
                                    F[n + 64 >> 2] = 0;
                                    F[n + 68 >> 2] = 0;
                                    F[n + 48 >> 2] = 0;
                                    F[n + 52 >> 2] = 0;
                                    F[n + 40 >> 2] = 0;
                                    F[n + 44 >> 2] = 0;
                                    F[n + 56 >> 2] = 1065353216;
                                    F[n + 32 >> 2] = 0;
                                    F[n + 24 >> 2] = 0;
                                    F[n + 28 >> 2] = 0;
                                    p = 1;
                                    h = a;
                                    O = F[a + 124 >> 2];
                                    o: {
                                        p: {
                                            q: {
                                                r: {
                                                    j = c;
                                                    s: {
                                                        t: {
                                                            if ((c | 0) <= 0) {
                                                                break t;
                                                            }
                                                            K = h + 400 | 0;
                                                            P = h + 232 | 0;
                                                            z = F[h + 216 >> 2] != F[h + 220 >> 2];
                                                            while (1) {
                                                                i = x;
                                                                x = i + 1 | 0;
                                                                u: {
                                                                    v: {
                                                                        w: {
                                                                            x: {
                                                                                y: {
                                                                                    if (F[h + 420 >> 2] != -1) {
                                                                                        if (Ga(K)) {
                                                                                            break y;
                                                                                        }
                                                                                    }
                                                                                    if (G[h + 308 | 0]) {
                                                                                        q = F[h + 296 >> 2];
                                                                                        r = F[h + 304 >> 2];
                                                                                        a = q + (r >>> 3 | 0) | 0;
                                                                                        s = F[h + 300 >> 2];
                                                                                        if (a >>> 0 >= s >>> 0) {
                                                                                            break x;
                                                                                        }
                                                                                        f = G[a | 0];
                                                                                        a = r + 1 | 0;
                                                                                        F[h + 304 >> 2] = a;
                                                                                        if (!(f >>> (r & 7) & 1)) {
                                                                                            break x;
                                                                                        }
                                                                                        k = a >>> 3 | 0;
                                                                                        f = q + k | 0;
                                                                                        z: {
                                                                                            if (f >>> 0 >= s >>> 0) {
                                                                                                f = a;
                                                                                                a = 0;
                                                                                                break z;
                                                                                            }
                                                                                            c = G[f | 0];
                                                                                            f = r + 2 | 0;
                                                                                            F[h + 304 >> 2] = f;
                                                                                            k = f >>> 3 | 0;
                                                                                            a = c >>> (a & 7) & 1;
                                                                                        }
                                                                                        c = k + q | 0;
                                                                                        if (c >>> 0 < s >>> 0) {
                                                                                            c = G[c | 0];
                                                                                            F[h + 304 >> 2] = f + 1;
                                                                                            f = c >>> (f & 7) << 1 & 2;
                                                                                        }
                                                                                        else {
                                                                                            f = 0;
                                                                                        }
                                                                                        c = (a | f) << 1 | 1;
                                                                                    }
                                                                                    else {
                                                                                        c = 1;
                                                                                    }
                                                                                    F[h + 416 >> 2] = c;
                                                                                    break v;
                                                                                }
                                                                                c = F[h + 420 >> 2];
                                                                                F[h + 416 >> 2] = c;
                                                                                if (c) {
                                                                                    break v;
                                                                                }
                                                                                break w;
                                                                            }
                                                                            F[h + 416 >> 2] = 0;
                                                                        }
                                                                        if ((b | 0) == (l | 0)) {
                                                                            f = -1;
                                                                            break s;
                                                                        }
                                                                        s = -1;
                                                                        y = F[h + 8 >> 2];
                                                                        r = F[y + 24 >> 2];
                                                                        a = r;
                                                                        q = b - 4 | 0;
                                                                        A = F[q >> 2];
                                                                        c = -1;
                                                                        A: {
                                                                            if ((A | 0) == -1) {
                                                                                break A;
                                                                            }
                                                                            f = A + 1 | 0;
                                                                            f = (f >>> 0) % 3 | 0 ? f : A - 2 | 0;
                                                                            c = -1;
                                                                            if ((f | 0) == -1) {
                                                                                break A;
                                                                            }
                                                                            c = F[F[y >> 2] + (f << 2) >> 2];
                                                                        }
                                                                        f = F[a + (c << 2) >> 2];
                                                                        if ((f | 0) != -1) {
                                                                            a = f + 1 | 0;
                                                                            s = (a >>> 0) % 3 | 0 ? a : f - 2 | 0;
                                                                        }
                                                                        f = F[y + 12 >> 2];
                                                                        u = L(i, 3);
                                                                        a = u + 1 | 0;
                                                                        F[f + (A << 2) >> 2] = a;
                                                                        k = a << 2;
                                                                        F[k + f >> 2] = A;
                                                                        t = u + 2 | 0;
                                                                        F[f + (s << 2) >> 2] = t;
                                                                        i = t << 2;
                                                                        F[i + f >> 2] = s;
                                                                        p = -1;
                                                                        a = -1;
                                                                        B: {
                                                                            if ((A | 0) == -1) {
                                                                                break B;
                                                                            }
                                                                            C: {
                                                                                if ((A >>> 0) % 3 | 0) {
                                                                                    f = A - 1 | 0;
                                                                                    break C;
                                                                                }
                                                                                f = A + 2 | 0;
                                                                                a = -1;
                                                                                if ((f | 0) == -1) {
                                                                                    break B;
                                                                                }
                                                                            }
                                                                            a = F[F[y >> 2] + (f << 2) >> 2];
                                                                        }
                                                                        D: {
                                                                            if ((s | 0) == -1) {
                                                                                break D;
                                                                            }
                                                                            f = s + 1 | 0;
                                                                            f = (f >>> 0) % 3 | 0 ? f : s - 2 | 0;
                                                                            if ((f | 0) == -1) {
                                                                                break D;
                                                                            }
                                                                            p = F[F[y >> 2] + (f << 2) >> 2];
                                                                        }
                                                                        f = -1;
                                                                        if ((a | 0) == (c | 0) | (c | 0) == (p | 0)) {
                                                                            break s;
                                                                        }
                                                                        f = F[y >> 2];
                                                                        F[f + (u << 2) >> 2] = c;
                                                                        F[f + k >> 2] = p;
                                                                        F[f + i >> 2] = a;
                                                                        if ((a | 0) != -1) {
                                                                            F[r + (a << 2) >> 2] = t;
                                                                        }
                                                                        f = F[h + 120 >> 2] + (c >>> 3 & 536870908) | 0;
                                                                        a = F[f >> 2];
                                                                        R = f, S = Lj(c) & a, F[R >> 2] = S;
                                                                        F[q >> 2] = u;
                                                                        Yc(P, u);
                                                                        break u;
                                                                    }
                                                                    f = -1;
                                                                    E: {
                                                                        F: {
                                                                            G: {
                                                                                H: {
                                                                                    I: {
                                                                                        J: {
                                                                                            K: {
                                                                                                L: {
                                                                                                    M: {
                                                                                                        N: {
                                                                                                            switch (c - 1 | 0) {
                                                                                                                case 2:
                                                                                                                case 4:
                                                                                                                    if ((d | 0) == (b | 0)) {
                                                                                                                        break s;
                                                                                                                    }
                                                                                                                    q = F[h + 8 >> 2];
                                                                                                                    k = F[q + 12 >> 2];
                                                                                                                    r = L(i, 3);
                                                                                                                    s = (c | 0) == 5;
                                                                                                                    c = r + (s ? 2 : 1) | 0;
                                                                                                                    a = c << 2;
                                                                                                                    l = b - 4 | 0;
                                                                                                                    u = F[l >> 2];
                                                                                                                    F[k + a >> 2] = u;
                                                                                                                    F[k + (u << 2) >> 2] = c;
                                                                                                                    Sa(q + 24 | 0);
                                                                                                                    b = F[h + 8 >> 2];
                                                                                                                    k = F[b + 24 >> 2];
                                                                                                                    if (F[b + 28 >> 2] - k >> 2 > (O | 0)) {
                                                                                                                        break s;
                                                                                                                    }
                                                                                                                    t = F[b >> 2];
                                                                                                                    A = t + a | 0;
                                                                                                                    b = F[q + 28 >> 2] - F[q + 24 >> 2] | 0;
                                                                                                                    a = (b >> 2) - 1 | 0;
                                                                                                                    F[A >> 2] = a;
                                                                                                                    if (b) {
                                                                                                                        F[k + (a << 2) >> 2] = c;
                                                                                                                    }
                                                                                                                    q = s ? r : r + 2 | 0;
                                                                                                                    b = t + (s + r << 2) | 0;
                                                                                                                    O: {
                                                                                                                        if ((u | 0) == -1) {
                                                                                                                            F[t + (q << 2) >> 2] = -1;
                                                                                                                            c = -1;
                                                                                                                            break O;
                                                                                                                        }
                                                                                                                        P: {
                                                                                                                            Q: {
                                                                                                                                R: {
                                                                                                                                    if ((u >>> 0) % 3 | 0) {
                                                                                                                                        c = u - 1 | 0;
                                                                                                                                        break R;
                                                                                                                                    }
                                                                                                                                    c = u + 2 | 0;
                                                                                                                                    if ((c | 0) == -1) {
                                                                                                                                        break Q;
                                                                                                                                    }
                                                                                                                                }
                                                                                                                                a = F[t + (c << 2) >> 2];
                                                                                                                                F[t + (q << 2) >> 2] = a;
                                                                                                                                if ((a | 0) == -1) {
                                                                                                                                    break P;
                                                                                                                                }
                                                                                                                                F[k + (a << 2) >> 2] = q;
                                                                                                                                break P;
                                                                                                                            }
                                                                                                                            F[t + (q << 2) >> 2] = -1;
                                                                                                                        }
                                                                                                                        a = u + 1 | 0;
                                                                                                                        a = (a >>> 0) % 3 | 0 ? a : u - 2 | 0;
                                                                                                                        c = -1;
                                                                                                                        if ((a | 0) == -1) {
                                                                                                                            break O;
                                                                                                                        }
                                                                                                                        c = F[t + (a << 2) >> 2];
                                                                                                                    }
                                                                                                                    F[b >> 2] = c;
                                                                                                                    F[l >> 2] = r;
                                                                                                                    break M;
                                                                                                                case 0:
                                                                                                                    if ((b | 0) == (l | 0)) {
                                                                                                                        break s;
                                                                                                                    }
                                                                                                                    e = b - 4 | 0;
                                                                                                                    y = F[e >> 2];
                                                                                                                    F[n + 68 >> 2] = e;
                                                                                                                    q = F[n + 44 >> 2];
                                                                                                                    S: {
                                                                                                                        if (!q) {
                                                                                                                            break S;
                                                                                                                        }
                                                                                                                        c = F[n + 40 >> 2];
                                                                                                                        s = Kj(q) >>> 0 > 1;
                                                                                                                        a = i & q + 2147483647;
                                                                                                                        T: {
                                                                                                                            if (!s) {
                                                                                                                                break T;
                                                                                                                            }
                                                                                                                            a = i;
                                                                                                                            if (a >>> 0 < q >>> 0) {
                                                                                                                                break T;
                                                                                                                            }
                                                                                                                            a = (i >>> 0) % (q >>> 0) | 0;
                                                                                                                        }
                                                                                                                        k = a;
                                                                                                                        a = F[c + (k << 2) >> 2];
                                                                                                                        if (!a) {
                                                                                                                            break S;
                                                                                                                        }
                                                                                                                        c = F[a >> 2];
                                                                                                                        if (!c) {
                                                                                                                            break S;
                                                                                                                        }
                                                                                                                        U: {
                                                                                                                            if (!s) {
                                                                                                                                s = q - 1 | 0;
                                                                                                                                while (1) {
                                                                                                                                    a = F[c + 4 >> 2];
                                                                                                                                    V: {
                                                                                                                                        if ((a | 0) != (i | 0)) {
                                                                                                                                            if ((k | 0) == (a & s)) {
                                                                                                                                                break V;
                                                                                                                                            }
                                                                                                                                            break S;
                                                                                                                                        }
                                                                                                                                        if ((i | 0) == F[c + 8 >> 2]) {
                                                                                                                                            break U;
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                    c = F[c >> 2];
                                                                                                                                    if (c) {
                                                                                                                                        continue;
                                                                                                                                    }
                                                                                                                                    break;
                                                                                                                                }
                                                                                                                                break S;
                                                                                                                            }
                                                                                                                            while (1) {
                                                                                                                                a = F[c + 4 >> 2];
                                                                                                                                W: {
                                                                                                                                    if ((a | 0) != (i | 0)) {
                                                                                                                                        if (a >>> 0 >= q >>> 0) {
                                                                                                                                            a = (a >>> 0) % (q >>> 0) | 0;
                                                                                                                                        }
                                                                                                                                        if ((a | 0) == (k | 0)) {
                                                                                                                                            break W;
                                                                                                                                        }
                                                                                                                                        break S;
                                                                                                                                    }
                                                                                                                                    if ((i | 0) == F[c + 8 >> 2]) {
                                                                                                                                        break U;
                                                                                                                                    }
                                                                                                                                }
                                                                                                                                c = F[c >> 2];
                                                                                                                                if (c) {
                                                                                                                                    continue;
                                                                                                                                }
                                                                                                                                break;
                                                                                                                            }
                                                                                                                            break S;
                                                                                                                        }
                                                                                                                        if ((e | 0) != (M | 0)) {
                                                                                                                            F[e >> 2] = F[c + 12 >> 2];
                                                                                                                            F[n + 68 >> 2] = b;
                                                                                                                            e = b;
                                                                                                                            break S;
                                                                                                                        }
                                                                                                                        k = M - l | 0;
                                                                                                                        e = k >> 2;
                                                                                                                        d = e + 1 | 0;
                                                                                                                        if (d >>> 0 >= 1073741824) {
                                                                                                                            break J;
                                                                                                                        }
                                                                                                                        a = k >> 1;
                                                                                                                        b = k >>> 0 < 2147483644 ? a >>> 0 < d >>> 0 ? d : a : 1073741823;
                                                                                                                        if (b) {
                                                                                                                            if (b >>> 0 >= 1073741824) {
                                                                                                                                break p;
                                                                                                                            }
                                                                                                                            d = sa(b << 2);
                                                                                                                        }
                                                                                                                        else {
                                                                                                                            d = 0;
                                                                                                                        }
                                                                                                                        a = d + (e << 2) | 0;
                                                                                                                        F[a >> 2] = F[c + 12 >> 2];
                                                                                                                        M = (b << 2) + d | 0;
                                                                                                                        e = a + 4 | 0;
                                                                                                                        if ((k | 0) > 0) {
                                                                                                                            ta(d, l, k);
                                                                                                                        }
                                                                                                                        F[n + 72 >> 2] = M;
                                                                                                                        F[n + 68 >> 2] = e;
                                                                                                                        F[n + 64 >> 2] = d;
                                                                                                                        if (!l) {
                                                                                                                            break S;
                                                                                                                        }
                                                                                                                        ra(l);
                                                                                                                    }
                                                                                                                    if ((d | 0) == (e | 0)) {
                                                                                                                        break K;
                                                                                                                    }
                                                                                                                    k = e - 4 | 0;
                                                                                                                    u = F[k >> 2];
                                                                                                                    c = (u | 0) == -1;
                                                                                                                    t = F[h + 8 >> 2];
                                                                                                                    if (!c & F[F[t + 12 >> 2] + (u << 2) >> 2] != -1) {
                                                                                                                        break K;
                                                                                                                    }
                                                                                                                    r = F[t + 12 >> 2];
                                                                                                                    if ((y | 0) != -1 & F[r + (y << 2) >> 2] != -1) {
                                                                                                                        break K;
                                                                                                                    }
                                                                                                                    q = L(i, 3);
                                                                                                                    i = q + 2 | 0;
                                                                                                                    F[r + (u << 2) >> 2] = i;
                                                                                                                    l = i << 2;
                                                                                                                    F[l + r >> 2] = u;
                                                                                                                    a = q + 1 | 0;
                                                                                                                    F[r + (y << 2) >> 2] = a;
                                                                                                                    b = a << 2;
                                                                                                                    F[b + r >> 2] = y;
                                                                                                                    if (c) {
                                                                                                                        break I;
                                                                                                                    }
                                                                                                                    if ((u >>> 0) % 3 | 0) {
                                                                                                                        f = u - 1 | 0;
                                                                                                                        break G;
                                                                                                                    }
                                                                                                                    f = u + 2 | 0;
                                                                                                                    if ((f | 0) != -1) {
                                                                                                                        break G;
                                                                                                                    }
                                                                                                                    p = F[t >> 2];
                                                                                                                    a = -1;
                                                                                                                    break F;
                                                                                                                case 6: break N;
                                                                                                                default: break s;
                                                                                                            }
                                                                                                        }
                                                                                                        a = F[h + 8 >> 2];
                                                                                                        Sa(a + 24 | 0);
                                                                                                        e = F[h + 8 >> 2];
                                                                                                        t = L(i, 3);
                                                                                                        s = F[a + 28 >> 2] - F[a + 24 >> 2] | 0;
                                                                                                        q = s >> 2;
                                                                                                        c = q - 1 | 0;
                                                                                                        F[F[e >> 2] + (t << 2) >> 2] = c;
                                                                                                        Sa(e + 24 | 0);
                                                                                                        k = t + 1 | 0;
                                                                                                        F[F[e >> 2] + (k << 2) >> 2] = (F[e + 28 >> 2] - F[e + 24 >> 2] >> 2) - 1;
                                                                                                        a = F[h + 8 >> 2];
                                                                                                        Sa(a + 24 | 0);
                                                                                                        e = t + 2 | 0;
                                                                                                        F[F[a >> 2] + (e << 2) >> 2] = (F[a + 28 >> 2] - F[a + 24 >> 2] >> 2) - 1;
                                                                                                        a = F[h + 8 >> 2];
                                                                                                        r = F[a + 24 >> 2];
                                                                                                        if (F[a + 28 >> 2] - r >> 2 > (O | 0)) {
                                                                                                            break s;
                                                                                                        }
                                                                                                        X: {
                                                                                                            Y: {
                                                                                                                if (!s) {
                                                                                                                    F[r + (q << 2) >> 2] = k;
                                                                                                                    c = 1;
                                                                                                                    break Y;
                                                                                                                }
                                                                                                                F[r + (c << 2) >> 2] = t;
                                                                                                                c = 0;
                                                                                                                if ((s | 0) == -4) {
                                                                                                                    break Y;
                                                                                                                }
                                                                                                                F[r + (q << 2) >> 2] = k;
                                                                                                                c = q + 1 | 0;
                                                                                                                if ((c | 0) == -1) {
                                                                                                                    break X;
                                                                                                                }
                                                                                                            }
                                                                                                            F[r + (c << 2) >> 2] = e;
                                                                                                        }
                                                                                                        if ((b | 0) != (M | 0)) {
                                                                                                            F[b >> 2] = t;
                                                                                                            e = b + 4 | 0;
                                                                                                            F[n + 68 >> 2] = e;
                                                                                                            break L;
                                                                                                        }
                                                                                                        c = M - l | 0;
                                                                                                        e = c >> 2;
                                                                                                        d = e + 1 | 0;
                                                                                                        if (d >>> 0 >= 1073741824) {
                                                                                                            break H;
                                                                                                        }
                                                                                                        a = c >> 1;
                                                                                                        b = c >>> 0 < 2147483644 ? a >>> 0 < d >>> 0 ? d : a : 1073741823;
                                                                                                        if (b) {
                                                                                                            if (b >>> 0 >= 1073741824) {
                                                                                                                break p;
                                                                                                            }
                                                                                                            d = sa(b << 2);
                                                                                                        }
                                                                                                        else {
                                                                                                            d = 0;
                                                                                                        }
                                                                                                        a = d + (e << 2) | 0;
                                                                                                        F[a >> 2] = t;
                                                                                                        M = (b << 2) + d | 0;
                                                                                                        e = a + 4 | 0;
                                                                                                        if ((c | 0) > 0) {
                                                                                                            ta(d, l, c);
                                                                                                        }
                                                                                                        F[n + 72 >> 2] = M;
                                                                                                        F[n + 68 >> 2] = e;
                                                                                                        F[n + 64 >> 2] = d;
                                                                                                        if (!l) {
                                                                                                            break M;
                                                                                                        }
                                                                                                        ra(l);
                                                                                                    }
                                                                                                    l = d;
                                                                                                }
                                                                                                Yc(P, F[e - 4 >> 2]);
                                                                                                c = F[h + 40 >> 2];
                                                                                                Z: {
                                                                                                    if ((c | 0) == F[h + 36 >> 2]) {
                                                                                                        break Z;
                                                                                                    }
                                                                                                    s = j + (i ^ -1) | 0;
                                                                                                    k = e - 4 | 0;
                                                                                                    while (1) {
                                                                                                        a = F[c - 8 >> 2];
                                                                                                        if (a >>> 0 > s >>> 0) {
                                                                                                            break K;
                                                                                                        }
                                                                                                        if ((a | 0) != (s | 0)) {
                                                                                                            break Z;
                                                                                                        }
                                                                                                        i = G[c - 4 | 0];
                                                                                                        a = c - 12 | 0;
                                                                                                        b = F[a >> 2];
                                                                                                        F[h + 40 >> 2] = a;
                                                                                                        if ((b | 0) < 0) {
                                                                                                            break K;
                                                                                                        }
                                                                                                        c = F[k >> 2];
                                                                                                        F[n + 20 >> 2] = j + (b ^ -1);
                                                                                                        a = n + 20 | 0;
                                                                                                        F[n + 88 >> 2] = a;
                                                                                                        $c(n, n + 40 | 0, a, n + 88 | 0);
                                                                                                        b = F[n >> 2];
                                                                                                        _: {
                                                                                                            if (i & 1) {
                                                                                                                a = -1;
                                                                                                                if ((c | 0) == -1) {
                                                                                                                    break _;
                                                                                                                }
                                                                                                                a = c + 1 | 0;
                                                                                                                a = (a >>> 0) % 3 | 0 ? a : c - 2 | 0;
                                                                                                                break _;
                                                                                                            }
                                                                                                            a = -1;
                                                                                                            if ((c | 0) == -1) {
                                                                                                                break _;
                                                                                                            }
                                                                                                            a = c - 1 | 0;
                                                                                                            if ((c >>> 0) % 3 | 0) {
                                                                                                                break _;
                                                                                                            }
                                                                                                            a = c + 2 | 0;
                                                                                                        }
                                                                                                        F[b + 12 >> 2] = a;
                                                                                                        c = F[h + 40 >> 2];
                                                                                                        if ((c | 0) != F[h + 36 >> 2]) {
                                                                                                            continue;
                                                                                                        }
                                                                                                        break;
                                                                                                    }
                                                                                                }
                                                                                                b = e;
                                                                                                break u;
                                                                                            }
                                                                                            if (p) {
                                                                                                break s;
                                                                                            }
                                                                                            break t;
                                                                                        }
                                                                                        va();
                                                                                        V();
                                                                                    }
                                                                                    s = -1;
                                                                                    p = F[t >> 2];
                                                                                    F[p + (q << 2) >> 2] = -1;
                                                                                    f = -1;
                                                                                    break E;
                                                                                }
                                                                                va();
                                                                                V();
                                                                            }
                                                                            p = F[t >> 2];
                                                                            a = F[p + (f << 2) >> 2];
                                                                        }
                                                                        s = a;
                                                                        F[(q << 2) + p >> 2] = a;
                                                                        a = u + 1 | 0;
                                                                        a = (a >>> 0) % 3 | 0 ? a : u - 2 | 0;
                                                                        f = -1;
                                                                        if ((a | 0) == -1) {
                                                                            break E;
                                                                        }
                                                                        f = F[(a << 2) + p >> 2];
                                                                    }
                                                                    F[b + p >> 2] = f;
                                                                    $: {
                                                                        if ((y | 0) == -1) {
                                                                            F[l + p >> 2] = -1;
                                                                            l = -1;
                                                                            f = -1;
                                                                            break $;
                                                                        }
                                                                        aa: {
                                                                            ba: {
                                                                                ca: {
                                                                                    if ((y >>> 0) % 3 | 0) {
                                                                                        f = y - 1 | 0;
                                                                                        break ca;
                                                                                    }
                                                                                    f = y + 2 | 0;
                                                                                    if ((f | 0) == -1) {
                                                                                        break ba;
                                                                                    }
                                                                                }
                                                                                a = F[(f << 2) + p >> 2];
                                                                                F[l + p >> 2] = a;
                                                                                if ((a | 0) == -1) {
                                                                                    break aa;
                                                                                }
                                                                                F[F[t + 24 >> 2] + (a << 2) >> 2] = i;
                                                                                break aa;
                                                                            }
                                                                            F[l + p >> 2] = -1;
                                                                        }
                                                                        l = -1;
                                                                        a = y + 1 | 0;
                                                                        a = (a >>> 0) % 3 | 0 ? a : y - 2 | 0;
                                                                        f = -1;
                                                                        if ((a | 0) == -1) {
                                                                            break $;
                                                                        }
                                                                        l = F[(a << 2) + p >> 2];
                                                                        f = a;
                                                                    }
                                                                    c = F[h + 388 >> 2];
                                                                    b = s << 2;
                                                                    a = c + b | 0;
                                                                    i = a;
                                                                    A = F[a >> 2];
                                                                    a = l << 2;
                                                                    F[i >> 2] = A + F[a + c >> 2];
                                                                    i = a;
                                                                    a = F[t + 24 >> 2];
                                                                    c = i + a | 0;
                                                                    if ((s | 0) != -1) {
                                                                        F[a + b >> 2] = F[c >> 2];
                                                                    }
                                                                    da: {
                                                                        if ((f | 0) == -1) {
                                                                            break da;
                                                                        }
                                                                        while (1) {
                                                                            F[(f << 2) + p >> 2] = s;
                                                                            a = f + 1 | 0;
                                                                            a = (a >>> 0) % 3 | 0 ? a : f - 2 | 0;
                                                                            if ((a | 0) == -1) {
                                                                                break da;
                                                                            }
                                                                            b = F[r + (a << 2) >> 2];
                                                                            if ((b | 0) == -1) {
                                                                                break da;
                                                                            }
                                                                            a = b + 1 | 0;
                                                                            f = (a >>> 0) % 3 | 0 ? a : b - 2 | 0;
                                                                            if ((f | 0) != -1) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    F[c >> 2] = -1;
                                                                    ea: {
                                                                        if (z) {
                                                                            break ea;
                                                                        }
                                                                        if ((B | 0) != (J | 0)) {
                                                                            F[J >> 2] = l;
                                                                            J = J + 4 | 0;
                                                                            F[n + 28 >> 2] = J;
                                                                            break ea;
                                                                        }
                                                                        fa: {
                                                                            c = B - w | 0;
                                                                            b = c >> 2;
                                                                            g = b + 1 | 0;
                                                                            if (g >>> 0 < 1073741824) {
                                                                                a = c >> 1;
                                                                                f = c >>> 0 < 2147483644 ? a >>> 0 < g >>> 0 ? g : a : 1073741823;
                                                                                if (f) {
                                                                                    if (f >>> 0 >= 1073741824) {
                                                                                        break fa;
                                                                                    }
                                                                                    g = sa(f << 2);
                                                                                }
                                                                                else {
                                                                                    g = 0;
                                                                                }
                                                                                a = g + (b << 2) | 0;
                                                                                F[a >> 2] = l;
                                                                                B = (f << 2) + g | 0;
                                                                                J = a + 4 | 0;
                                                                                if ((c | 0) > 0) {
                                                                                    ta(g, w, c);
                                                                                }
                                                                                F[n + 32 >> 2] = B;
                                                                                F[n + 28 >> 2] = J;
                                                                                F[n + 24 >> 2] = g;
                                                                                if (w) {
                                                                                    ra(w);
                                                                                }
                                                                                w = g;
                                                                                break ea;
                                                                            }
                                                                            va();
                                                                            V();
                                                                        }
                                                                        break p;
                                                                    }
                                                                    F[k >> 2] = q;
                                                                    b = e;
                                                                    l = d;
                                                                    Yc(P, q);
                                                                }
                                                                p = (j | 0) > (x | 0);
                                                                if ((j | 0) != (x | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                            x = j;
                                                        }
                                                        f = -1;
                                                        p = F[h + 8 >> 2];
                                                        if (F[p + 28 >> 2] - F[p + 24 >> 2] >> 2 > (O | 0)) {
                                                            break s;
                                                        }
                                                        if ((d | 0) != (e | 0)) {
                                                            a = h + 60 | 0;
                                                            q = h + 312 | 0;
                                                            while (1) {
                                                                e = e - 4 | 0;
                                                                z = F[e >> 2];
                                                                F[n + 68 >> 2] = e;
                                                                ga: {
                                                                    ha: {
                                                                        ia: {
                                                                            ja: {
                                                                                if (H[h + 270 >> 1] <= 513) {
                                                                                    if (!G[h + 364 | 0]) {
                                                                                        break ia;
                                                                                    }
                                                                                    c = F[h + 360 >> 2];
                                                                                    b = F[h + 352 >> 2] + (c >>> 3 | 0) | 0;
                                                                                    if (b >>> 0 >= I[h + 356 >> 2]) {
                                                                                        break ha;
                                                                                    }
                                                                                    b = G[b | 0];
                                                                                    F[h + 360 >> 2] = c + 1;
                                                                                    b = b >>> (c & 7) & 1;
                                                                                    break ja;
                                                                                }
                                                                                b = Ga(q);
                                                                            }
                                                                            if (!b) {
                                                                                break ha;
                                                                            }
                                                                        }
                                                                        r = F[h + 8 >> 2];
                                                                        B = F[r >> 2];
                                                                        if (((F[r + 4 >> 2] - B >> 2 >>> 0) / 3 | 0) <= (x | 0)) {
                                                                            break s;
                                                                        }
                                                                        c = -1;
                                                                        l = -1;
                                                                        s = -1;
                                                                        w = F[r + 24 >> 2];
                                                                        i = w;
                                                                        j = -1;
                                                                        ka: {
                                                                            if ((z | 0) == -1) {
                                                                                break ka;
                                                                            }
                                                                            b = z + 1 | 0;
                                                                            b = (b >>> 0) % 3 | 0 ? b : z - 2 | 0;
                                                                            j = -1;
                                                                            if ((b | 0) == -1) {
                                                                                break ka;
                                                                            }
                                                                            j = F[B + (b << 2) >> 2];
                                                                        }
                                                                        k = F[(j << 2) + i >> 2];
                                                                        b = -1;
                                                                        la: {
                                                                            if ((k | 0) == -1) {
                                                                                break la;
                                                                            }
                                                                            i = k + 1 | 0;
                                                                            i = (i >>> 0) % 3 | 0 ? i : k - 2 | 0;
                                                                            b = -1;
                                                                            if ((i | 0) == -1) {
                                                                                break la;
                                                                            }
                                                                            b = i + 1 | 0;
                                                                            c = i;
                                                                            b = (b >>> 0) % 3 | 0 ? b : c - 2 | 0;
                                                                            if ((b | 0) != -1) {
                                                                                b = F[B + (b << 2) >> 2];
                                                                            }
                                                                            else {
                                                                                b = -1;
                                                                            }
                                                                        }
                                                                        w = F[w + (b << 2) >> 2];
                                                                        k = -1;
                                                                        ma: {
                                                                            if ((w | 0) == -1) {
                                                                                break ma;
                                                                            }
                                                                            i = w + 1 | 0;
                                                                            i = (i >>> 0) % 3 | 0 ? i : w - 2 | 0;
                                                                            k = -1;
                                                                            if ((i | 0) == -1) {
                                                                                break ma;
                                                                            }
                                                                            k = i + 1 | 0;
                                                                            k = (k >>> 0) % 3 | 0 ? k : i - 2 | 0;
                                                                            if ((k | 0) != -1) {
                                                                                s = F[B + (k << 2) >> 2];
                                                                            }
                                                                            k = i;
                                                                        }
                                                                        K = F[r + 12 >> 2];
                                                                        t = L(x, 3);
                                                                        w = t << 2;
                                                                        F[K + w >> 2] = z;
                                                                        F[K + (z << 2) >> 2] = t;
                                                                        z = t + 1 | 0;
                                                                        i = z << 2;
                                                                        F[i + K >> 2] = c;
                                                                        F[K + (c << 2) >> 2] = z;
                                                                        r = t + 2 | 0;
                                                                        c = r << 2;
                                                                        F[c + K >> 2] = k;
                                                                        F[K + (k << 2) >> 2] = r;
                                                                        F[w + B >> 2] = b;
                                                                        k = i + B | 0;
                                                                        F[k >> 2] = s;
                                                                        i = c + B | 0;
                                                                        F[i >> 2] = j;
                                                                        w = F[h + 120 >> 2];
                                                                        j = t >>> 0 > z >>> 0 ? -1 : b;
                                                                        c = w + (j >>> 3 & 536870908) | 0;
                                                                        b = F[c >> 2];
                                                                        R = c, S = Lj(j) & b, F[R >> 2] = S;
                                                                        l = (z | 0) != -1 ? F[k >> 2] : l;
                                                                        c = w + (l >>> 3 & 536870908) | 0;
                                                                        b = F[c >> 2];
                                                                        R = c, S = Lj(l) & b, F[R >> 2] = S;
                                                                        c = -1;
                                                                        c = (r | 0) != -1 ? F[i >> 2] : c;
                                                                        j = w + (c >>> 3 & 536870908) | 0;
                                                                        b = F[j >> 2];
                                                                        R = j, S = Lj(c) & b, F[R >> 2] = S;
                                                                        c = F[h + 64 >> 2];
                                                                        b = F[h + 68 >> 2];
                                                                        if ((c | 0) == b << 5) {
                                                                            if ((c + 1 | 0) < 0) {
                                                                                break r;
                                                                            }
                                                                            if (c >>> 0 <= 1073741822) {
                                                                                c = c + 32 & -32;
                                                                                b = b << 6;
                                                                                b = c >>> 0 > b >>> 0 ? c : b;
                                                                            }
                                                                            else {
                                                                                b = 2147483647;
                                                                            }
                                                                            db(a, b);
                                                                            c = F[h + 64 >> 2];
                                                                        }
                                                                        x = x + 1 | 0;
                                                                        F[h + 64 >> 2] = c + 1;
                                                                        b = F[h + 60 >> 2] + (c >>> 3 & 536870908) | 0;
                                                                        F[b >> 2] = F[b >> 2] | 1 << c;
                                                                        b = F[h + 76 >> 2];
                                                                        if ((b | 0) != F[h + 80 >> 2]) {
                                                                            F[b >> 2] = t;
                                                                            F[h + 76 >> 2] = b + 4;
                                                                            break ga;
                                                                        }
                                                                        i = F[h + 72 >> 2];
                                                                        l = b - i | 0;
                                                                        c = l >> 2;
                                                                        j = c + 1 | 0;
                                                                        if (j >>> 0 >= 1073741824) {
                                                                            break q;
                                                                        }
                                                                        b = l >> 1;
                                                                        j = l >>> 0 < 2147483644 ? b >>> 0 < j >>> 0 ? j : b : 1073741823;
                                                                        if (j) {
                                                                            if (j >>> 0 >= 1073741824) {
                                                                                break p;
                                                                            }
                                                                            b = sa(j << 2);
                                                                        }
                                                                        else {
                                                                            b = 0;
                                                                        }
                                                                        c = b + (c << 2) | 0;
                                                                        F[c >> 2] = t;
                                                                        if ((l | 0) > 0) {
                                                                            ta(b, i, l);
                                                                        }
                                                                        F[h + 80 >> 2] = b + (j << 2);
                                                                        F[h + 76 >> 2] = c + 4;
                                                                        F[h + 72 >> 2] = b;
                                                                        if (!i) {
                                                                            break ga;
                                                                        }
                                                                        ra(i);
                                                                        break ga;
                                                                    }
                                                                    p = F[h + 64 >> 2];
                                                                    b = F[h + 68 >> 2];
                                                                    if ((p | 0) == b << 5) {
                                                                        if ((p + 1 | 0) < 0) {
                                                                            break r;
                                                                        }
                                                                        if (p >>> 0 <= 1073741822) {
                                                                            c = p + 32 & -32;
                                                                            b = b << 6;
                                                                            b = c >>> 0 > b >>> 0 ? c : b;
                                                                        }
                                                                        else {
                                                                            b = 2147483647;
                                                                        }
                                                                        db(a, b);
                                                                        p = F[h + 64 >> 2];
                                                                    }
                                                                    F[h + 64 >> 2] = p + 1;
                                                                    c = F[h + 60 >> 2] + (p >>> 3 & 536870908) | 0;
                                                                    b = F[c >> 2];
                                                                    R = c, S = Lj(p) & b, F[R >> 2] = S;
                                                                    b = F[h + 76 >> 2];
                                                                    if ((b | 0) != F[h + 80 >> 2]) {
                                                                        F[b >> 2] = z;
                                                                        F[h + 76 >> 2] = b + 4;
                                                                        break ga;
                                                                    }
                                                                    i = F[h + 72 >> 2];
                                                                    l = b - i | 0;
                                                                    c = l >> 2;
                                                                    j = c + 1 | 0;
                                                                    if (j >>> 0 >= 1073741824) {
                                                                        break q;
                                                                    }
                                                                    b = l >> 1;
                                                                    j = l >>> 0 < 2147483644 ? b >>> 0 < j >>> 0 ? j : b : 1073741823;
                                                                    if (j) {
                                                                        if (j >>> 0 >= 1073741824) {
                                                                            break p;
                                                                        }
                                                                        b = sa(j << 2);
                                                                    }
                                                                    else {
                                                                        b = 0;
                                                                    }
                                                                    c = b + (c << 2) | 0;
                                                                    F[c >> 2] = z;
                                                                    if ((l | 0) > 0) {
                                                                        ta(b, i, l);
                                                                    }
                                                                    F[h + 80 >> 2] = b + (j << 2);
                                                                    F[h + 76 >> 2] = c + 4;
                                                                    F[h + 72 >> 2] = b;
                                                                    if (!i) {
                                                                        break ga;
                                                                    }
                                                                    ra(i);
                                                                }
                                                                if ((d | 0) != (e | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                            p = F[h + 8 >> 2];
                                                        }
                                                        if (((F[p + 4 >> 2] - F[p >> 2] >> 2 >>> 0) / 3 | 0) != (x | 0)) {
                                                            break s;
                                                        }
                                                        e = F[p + 24 >> 2];
                                                        f = F[p + 28 >> 2] - e >> 2;
                                                        if ((g | 0) == (J | 0)) {
                                                            g = J;
                                                            break s;
                                                        }
                                                        a = g;
                                                        while (1) {
                                                            j = F[a >> 2];
                                                            c = f - 1 | 0;
                                                            b = (c << 2) + e | 0;
                                                            if (F[b >> 2] == -1) {
                                                                while (1) {
                                                                    c = f - 2 | 0;
                                                                    f = f - 1 | 0;
                                                                    b = (c << 2) + e | 0;
                                                                    if (F[b >> 2] == -1) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            if (c >>> 0 >= j >>> 0) {
                                                                F[n >> 2] = p;
                                                                e = F[b >> 2];
                                                                D[n + 12 | 0] = 1;
                                                                F[n + 8 >> 2] = e;
                                                                F[n + 4 >> 2] = e;
                                                                if ((e | 0) != -1) {
                                                                    while (1) {
                                                                        F[F[p >> 2] + (e << 2) >> 2] = j;
                                                                        vc(n);
                                                                        p = F[h + 8 >> 2];
                                                                        e = F[n + 8 >> 2];
                                                                        if ((e | 0) != -1) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                }
                                                                e = F[p + 24 >> 2];
                                                                b = e + (c << 2) | 0;
                                                                if ((j | 0) != -1) {
                                                                    F[(j << 2) + e >> 2] = F[b >> 2];
                                                                }
                                                                F[b >> 2] = -1;
                                                                i = 1 << j;
                                                                b = F[h + 120 >> 2];
                                                                j = b + (j >>> 3 & 536870908) | 0;
                                                                x = b + (c >>> 3 & 536870908) | 0;
                                                                b = 1 << c;
                                                                if (F[x >> 2] & b) {
                                                                    i = i | F[j >> 2];
                                                                }
                                                                else {
                                                                    i = F[j >> 2] & (i ^ -1);
                                                                }
                                                                F[j >> 2] = i;
                                                                F[x >> 2] = F[x >> 2] & (b ^ -1);
                                                                f = f - 1 | 0;
                                                            }
                                                            a = a + 4 | 0;
                                                            if ((J | 0) != (a | 0)) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    if (g) {
                                                        ra(g);
                                                    }
                                                    a = F[n + 48 >> 2];
                                                    if (a) {
                                                        while (1) {
                                                            g = F[a >> 2];
                                                            ra(a);
                                                            a = g;
                                                            if (a) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    a = F[n + 40 >> 2];
                                                    F[n + 40 >> 2] = 0;
                                                    if (a) {
                                                        ra(a);
                                                    }
                                                    if (d) {
                                                        F[n + 68 >> 2] = d;
                                                        ra(d);
                                                    }
                                                    ea = n + 96 | 0;
                                                    break o;
                                                }
                                                Oa();
                                                V();
                                            }
                                            va();
                                            V();
                                        }
                                        wa(1336);
                                        V();
                                    }
                                    if ((f | 0) == -1) {
                                        break n;
                                    }
                                    a = F[m + 16 >> 2];
                                    g = a + F[m >> 2] | 0;
                                    d = F[m + 8 >> 2];
                                    a = d - a | 0;
                                    d = F[F[h + 4 >> 2] + 32 >> 2];
                                    E[d + 38 >> 1] = H[d + 38 >> 1];
                                    F[d >> 2] = g;
                                    F[d + 16 >> 2] = 0;
                                    F[d + 20 >> 2] = 0;
                                    F[d + 8 >> 2] = a;
                                    F[d + 12 >> 2] = 0;
                                    d = F[h + 4 >> 2];
                                    a = H[d + 36 >> 1];
                                    g = a << 8 | a >>> 8;
                                    if ((g & 65535) >>> 0 <= 513) {
                                        a = F[d + 32 >> 2];
                                        d = Q + F[a + 20 >> 2] | 0;
                                        e = o + F[a + 16 >> 2] | 0;
                                        d = e >>> 0 < o >>> 0 ? d + 1 | 0 : d;
                                        F[a + 16 >> 2] = e;
                                        F[a + 20 >> 2] = d;
                                    }
                                    na: {
                                        if (F[h + 216 >> 2] == F[h + 220 >> 2]) {
                                            break na;
                                        }
                                        a = F[h + 8 >> 2];
                                        d = F[a >> 2];
                                        a = F[a + 4 >> 2];
                                        oa: {
                                            if ((g & 65535) >>> 0 >= 513) {
                                                if ((a | 0) == (d | 0)) {
                                                    break na;
                                                }
                                                e = 0;
                                                break oa;
                                            }
                                            if ((a | 0) == (d | 0)) {
                                                break na;
                                            }
                                            e = 0;
                                            while (1) {
                                                if (dd(h, e)) {
                                                    e = e + 3 | 0;
                                                    a = F[h + 8 >> 2];
                                                    if (e >>> 0 < F[a + 4 >> 2] - F[a >> 2] >> 2 >>> 0) {
                                                        continue;
                                                    }
                                                    break na;
                                                }
                                                break;
                                            }
                                            break n;
                                        }
                                        while (1) {
                                            if (cd(h, e)) {
                                                e = e + 3 | 0;
                                                a = F[h + 8 >> 2];
                                                if (e >>> 0 < F[a + 4 >> 2] - F[a >> 2] >> 2 >>> 0) {
                                                    continue;
                                                }
                                                break na;
                                            }
                                            break;
                                        }
                                        break n;
                                    }
                                    bd(C);
                                    e = F[h + 216 >> 2];
                                    if ((e | 0) != F[h + 220 >> 2]) {
                                        g = 0;
                                        while (1) {
                                            d = L(g, 144);
                                            Ic((d + e | 0) + 4 | 0, F[h + 8 >> 2]);
                                            v = F[N >> 2];
                                            a = d + v | 0;
                                            e = F[a + 132 >> 2];
                                            a = F[a + 136 >> 2];
                                            if ((e | 0) != (a | 0)) {
                                                while (1) {
                                                    Gc((d + v | 0) + 4 | 0, F[e >> 2]);
                                                    v = F[N >> 2];
                                                    e = e + 4 | 0;
                                                    if ((a | 0) != (e | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            Hc((d + v | 0) + 4 | 0);
                                            g = g + 1 | 0;
                                            e = F[h + 216 >> 2];
                                            if (g >>> 0 < (F[h + 220 >> 2] - e | 0) / 144 >>> 0) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    a = F[h + 8 >> 2];
                                    Gb(h + 184 | 0, F[a + 28 >> 2] - F[a + 24 >> 2] >> 2);
                                    v = F[h + 216 >> 2];
                                    if ((v | 0) != F[h + 220 >> 2]) {
                                        e = 0;
                                        while (1) {
                                            a = L(e, 144) + v | 0;
                                            d = F[a + 60 >> 2] - F[a + 56 >> 2] >> 2;
                                            g = a + 104 | 0;
                                            a = F[h + 8 >> 2];
                                            a = F[a + 28 >> 2] - F[a + 24 >> 2] >> 2;
                                            Gb(g, (a | 0) > (d | 0) ? a : d);
                                            e = e + 1 | 0;
                                            v = F[h + 216 >> 2];
                                            if (e >>> 0 < (F[h + 220 >> 2] - v | 0) / 144 >>> 0) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    v = ad(h, f);
                                }
                                break b;
                            }
                            v = 0;
                        } ea = m - -64 | 0; return v | 0; }
                        function fi(a) { a = a | 0; var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, J = 0, K = 0, M = 0, N = 0, O = 0, P = 0; i = ea + -64 | 0; ea = i; F[a + 132 >> 2] = 0; if (F[a + 148 >> 2]) {
                            c = F[a + 144 >> 2];
                            if (c) {
                                while (1) {
                                    b = F[c >> 2];
                                    ra(c);
                                    c = b;
                                    if (b) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            c = 0;
                            F[a + 144 >> 2] = 0;
                            d = F[a + 140 >> 2];
                            a: {
                                if (!d) {
                                    break a;
                                }
                                if (d - 1 >>> 0 >= 3) {
                                    b = d & -4;
                                    while (1) {
                                        j = c << 2;
                                        F[j + F[a + 136 >> 2] >> 2] = 0;
                                        F[F[a + 136 >> 2] + (j | 4) >> 2] = 0;
                                        F[F[a + 136 >> 2] + (j | 8) >> 2] = 0;
                                        F[F[a + 136 >> 2] + (j | 12) >> 2] = 0;
                                        c = c + 4 | 0;
                                        e = e + 4 | 0;
                                        if ((b | 0) != (e | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                b = d & 3;
                                if (!b) {
                                    break a;
                                }
                                while (1) {
                                    F[F[a + 136 >> 2] + (c << 2) >> 2] = 0;
                                    c = c + 1 | 0;
                                    x = x + 1 | 0;
                                    if ((b | 0) != (x | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            F[a + 148 >> 2] = 0;
                        } b: {
                            c: {
                                c = F[a + 4 >> 2];
                                x = G[c + 36 | 0];
                                b = x << 8 | G[c + 37 | 0];
                                d: {
                                    if (b >>> 0 > 513) {
                                        break d;
                                    }
                                    o = F[c + 32 >> 2];
                                    if (b >>> 0 <= 511) {
                                        b = F[o + 20 >> 2];
                                        d = F[o + 16 >> 2];
                                        e = d + 4 | 0;
                                        b = e >>> 0 < 4 ? b + 1 | 0 : b;
                                        j = e;
                                        e = F[o + 12 >> 2];
                                        if (j >>> 0 > I[o + 8 >> 2] & (e | 0) <= (b | 0) | (b | 0) > (e | 0)) {
                                            break c;
                                        }
                                        e = d + F[o >> 2] | 0;
                                        e = G[e | 0] | G[e + 1 | 0] << 8 | (G[e + 2 | 0] << 16 | G[e + 3 | 0] << 24);
                                        F[o + 16 >> 2] = j;
                                        F[o + 20 >> 2] = b;
                                        F[a + 132 >> 2] = e;
                                        break d;
                                    }
                                    if (!Fa(1, i, o)) {
                                        break c;
                                    }
                                    c = F[a + 4 >> 2];
                                    x = G[c + 36 | 0];
                                    F[a + 132 >> 2] = F[i >> 2];
                                }
                                o = F[c + 32 >> 2];
                                e: {
                                    f: {
                                        g: {
                                            if ((x & 255) >>> 0 <= 1) {
                                                x = 0;
                                                b = F[o + 20 >> 2];
                                                d = F[o + 16 >> 2];
                                                e = d + 4 | 0;
                                                b = e >>> 0 < 4 ? b + 1 | 0 : b;
                                                j = e;
                                                e = F[o + 12 >> 2];
                                                if (j >>> 0 > I[o + 8 >> 2] & (e | 0) <= (b | 0) | (b | 0) > (e | 0)) {
                                                    break b;
                                                }
                                                e = d + F[o >> 2] | 0;
                                                e = G[e | 0] | G[e + 1 | 0] << 8 | (G[e + 2 | 0] << 16 | G[e + 3 | 0] << 24);
                                                F[i + 60 >> 2] = e;
                                                F[o + 16 >> 2] = j;
                                                F[o + 20 >> 2] = b;
                                                F[a + 156 >> 2] = e;
                                                k = a + 156 | 0;
                                                break g;
                                            }
                                            x = 0;
                                            if (!Fa(1, i + 60 | 0, o)) {
                                                break b;
                                            }
                                            c = F[a + 4 >> 2];
                                            b = G[c + 36 | 0];
                                            F[a + 156 >> 2] = F[i + 60 >> 2];
                                            k = a + 156 | 0;
                                            if (b >>> 0 > 1) {
                                                break f;
                                            }
                                        }
                                        d = F[c + 32 >> 2];
                                        c = F[d + 8 >> 2];
                                        j = F[d + 12 >> 2];
                                        h = c;
                                        c = F[d + 20 >> 2];
                                        e = F[d + 16 >> 2];
                                        b = e + 4 | 0;
                                        c = b >>> 0 < 4 ? c + 1 | 0 : c;
                                        if (h >>> 0 < b >>> 0 & (c | 0) >= (j | 0) | (c | 0) > (j | 0)) {
                                            break b;
                                        }
                                        e = e + F[d >> 2] | 0;
                                        e = G[e | 0] | G[e + 1 | 0] << 8 | (G[e + 2 | 0] << 16 | G[e + 3 | 0] << 24);
                                        F[i + 56 >> 2] = e;
                                        F[d + 16 >> 2] = b;
                                        F[d + 20 >> 2] = c;
                                        break e;
                                    }
                                    if (!Fa(1, i + 56 | 0, F[c + 32 >> 2])) {
                                        break b;
                                    }
                                    e = F[i + 56 >> 2];
                                }
                                if (e >>> 0 > 1431655765 | I[k >> 2] > L(e, 3) >>> 0) {
                                    break b;
                                }
                                f = F[a + 4 >> 2];
                                b = F[f + 32 >> 2];
                                v = F[b + 8 >> 2];
                                d = v;
                                j = F[b + 12 >> 2];
                                c = F[b + 20 >> 2];
                                k = F[b + 16 >> 2];
                                if ((j | 0) <= (c | 0) & k >>> 0 >= d >>> 0 | (c | 0) > (j | 0)) {
                                    break b;
                                }
                                h = F[b >> 2];
                                g = G[h + k | 0];
                                o = k + 1 | 0;
                                d = o ? c : c + 1 | 0;
                                F[b + 16 >> 2] = o;
                                F[b + 20 >> 2] = d;
                                h: {
                                    if (G[f + 36 | 0] <= 1) {
                                        d = k + 5 | 0;
                                        c = d >>> 0 < 5 ? c + 1 | 0 : c;
                                        if (d >>> 0 > v >>> 0 & (c | 0) >= (j | 0) | (c | 0) > (j | 0)) {
                                            break b;
                                        }
                                        j = h + o | 0;
                                        k = G[j | 0] | G[j + 1 | 0] << 8 | (G[j + 2 | 0] << 16 | G[j + 3 | 0] << 24);
                                        F[i + 52 >> 2] = k;
                                        F[b + 16 >> 2] = d;
                                        F[b + 20 >> 2] = c;
                                        break h;
                                    }
                                    if (!Fa(1, i + 52 | 0, b)) {
                                        break b;
                                    }
                                    k = F[i + 52 >> 2];
                                }
                                if (e >>> 0 < k >>> 0 | ((k >>> 0) / 3 | 0) + k >>> 0 < e >>> 0) {
                                    break b;
                                }
                                c = F[a + 4 >> 2];
                                o = F[c + 32 >> 2];
                                i: {
                                    if (G[c + 36 | 0] <= 1) {
                                        c = F[o + 20 >> 2];
                                        d = F[o + 16 >> 2];
                                        b = d + 4 | 0;
                                        c = b >>> 0 < 4 ? c + 1 | 0 : c;
                                        j = b;
                                        b = F[o + 12 >> 2];
                                        if (j >>> 0 > I[o + 8 >> 2] & (b | 0) <= (c | 0) | (b | 0) < (c | 0)) {
                                            break b;
                                        }
                                        b = d + F[o >> 2] | 0;
                                        b = G[b | 0] | G[b + 1 | 0] << 8 | (G[b + 2 | 0] << 16 | G[b + 3 | 0] << 24);
                                        F[i + 48 >> 2] = b;
                                        F[o + 16 >> 2] = j;
                                        F[o + 20 >> 2] = c;
                                        break i;
                                    }
                                    if (!Fa(1, i + 48 | 0, o)) {
                                        break b;
                                    }
                                    b = F[i + 48 >> 2];
                                }
                                if (b >>> 0 > k >>> 0) {
                                    break b;
                                }
                                F[a + 28 >> 2] = F[a + 24 >> 2];
                                c = sa(88);
                                Lc(c);
                                j = F[a + 8 >> 2];
                                F[a + 8 >> 2] = c;
                                if (j) {
                                    cb(j);
                                    if (!F[a + 8 >> 2]) {
                                        break b;
                                    }
                                }
                                F[a + 164 >> 2] = F[a + 160 >> 2];
                                Ib(a + 160 | 0, e);
                                F[a + 176 >> 2] = F[a + 172 >> 2];
                                Ib(a + 172 | 0, e);
                                F[a - -64 >> 2] = 0;
                                F[a + 92 >> 2] = -1;
                                F[a + 84 >> 2] = -1;
                                F[a + 88 >> 2] = -1;
                                F[a + 40 >> 2] = F[a + 36 >> 2];
                                F[a + 52 >> 2] = F[a + 48 >> 2];
                                F[a + 76 >> 2] = F[a + 72 >> 2];
                                J = a + 216 | 0;
                                fd(J);
                                ed(J, g);
                                if (!Kc(F[a + 8 >> 2], e, F[a + 156 >> 2] + b | 0)) {
                                    break b;
                                }
                                c = F[a + 156 >> 2];
                                D[i | 0] = 1;
                                Na(a + 120 | 0, b + c | 0, i);
                                b = F[a + 4 >> 2];
                                c = H[b + 36 >> 1];
                                c = (c << 8 | c >>> 8) & 65535;
                                j: {
                                    if (c >>> 0 <= 513) {
                                        d = F[b + 32 >> 2];
                                        k: {
                                            if (c >>> 0 <= 511) {
                                                b = F[d + 20 >> 2];
                                                e = F[d + 16 >> 2];
                                                c = e + 4 | 0;
                                                b = c >>> 0 < 4 ? b + 1 | 0 : b;
                                                j = c;
                                                c = F[d + 12 >> 2];
                                                if (j >>> 0 > I[d + 8 >> 2] & (c | 0) <= (b | 0) | (b | 0) > (c | 0)) {
                                                    break b;
                                                }
                                                c = e + F[d >> 2] | 0;
                                                e = G[c | 0] | G[c + 1 | 0] << 8 | (G[c + 2 | 0] << 16 | G[c + 3 | 0] << 24);
                                                F[d + 16 >> 2] = j;
                                                F[d + 20 >> 2] = b;
                                                break k;
                                            }
                                            if (!Fa(1, i + 44 | 0, d)) {
                                                break b;
                                            }
                                            e = F[i + 44 >> 2];
                                        }
                                        if (!e) {
                                            break b;
                                        }
                                        d = F[F[a + 4 >> 2] + 32 >> 2];
                                        j = F[d + 8 >> 2];
                                        c = F[d + 16 >> 2];
                                        b = j - c | 0;
                                        c = F[d + 12 >> 2] - (F[d + 20 >> 2] + (c >>> 0 > j >>> 0) | 0) | 0;
                                        if (b >>> 0 < e >>> 0 & (c | 0) <= 0 | (c | 0) < 0) {
                                            break b;
                                        }
                                        E[i + 38 >> 1] = 0;
                                        F[i >> 2] = 0;
                                        F[i + 8 >> 2] = 0;
                                        F[i + 12 >> 2] = 0;
                                        F[i + 16 >> 2] = 0;
                                        F[i + 20 >> 2] = 0;
                                        F[i + 24 >> 2] = 0;
                                        F[i + 28 >> 2] = 0;
                                        D[i + 29 | 0] = 0;
                                        D[i + 30 | 0] = 0;
                                        D[i + 31 | 0] = 0;
                                        D[i + 32 | 0] = 0;
                                        D[i + 33 | 0] = 0;
                                        D[i + 34 | 0] = 0;
                                        D[i + 35 | 0] = 0;
                                        D[i + 36 | 0] = 0;
                                        d = F[F[a + 4 >> 2] + 32 >> 2];
                                        c = F[d + 16 >> 2];
                                        j = (c + F[d >> 2] | 0) + e | 0;
                                        b = F[d + 8 >> 2];
                                        c = (b - c | 0) - e | 0;
                                        E[i + 38 >> 1] = H[d + 38 >> 1];
                                        F[i >> 2] = j;
                                        F[i + 16 >> 2] = 0;
                                        F[i + 20 >> 2] = 0;
                                        F[i + 8 >> 2] = c;
                                        F[i + 12 >> 2] = 0;
                                        o = Hb(a, i);
                                        if ((o | 0) == -1) {
                                            break b;
                                        }
                                        M = o >> 31;
                                        break j;
                                    }
                                    o = -1;
                                    M = -1;
                                    if ((Hb(a, F[b + 32 >> 2]) | 0) == -1) {
                                        break b;
                                    }
                                }
                                N = a + 232 | 0;
                                j = N;
                                F[j + 144 >> 2] = a;
                                c = F[(ga[F[F[a >> 2] + 32 >> 2]](a) | 0) + 32 >> 2];
                                e = F[c >> 2] + F[c + 16 >> 2] | 0;
                                b = F[(ga[F[F[a >> 2] + 32 >> 2]](a) | 0) + 32 >> 2];
                                c = F[b + 8 >> 2];
                                b = F[b + 16 >> 2];
                                c = c - b | 0;
                                O = j, P = H[F[(ga[F[F[a >> 2] + 32 >> 2]](a) | 0) + 32 >> 2] + 38 >> 1], E[O + 38 >> 1] = P;
                                F[j >> 2] = e;
                                F[j + 16 >> 2] = 0;
                                F[j + 20 >> 2] = 0;
                                F[j + 8 >> 2] = c;
                                F[j + 12 >> 2] = 0;
                                F[a + 372 >> 2] = g;
                                E[i + 38 >> 1] = 0;
                                F[i >> 2] = 0;
                                F[i + 8 >> 2] = 0;
                                F[i + 12 >> 2] = 0;
                                F[i + 16 >> 2] = 0;
                                F[i + 20 >> 2] = 0;
                                F[i + 24 >> 2] = 0;
                                F[i + 28 >> 2] = 0;
                                D[i + 29 | 0] = 0;
                                D[i + 30 | 0] = 0;
                                D[i + 31 | 0] = 0;
                                D[i + 32 | 0] = 0;
                                D[i + 33 | 0] = 0;
                                D[i + 34 | 0] = 0;
                                D[i + 35 | 0] = 0;
                                D[i + 36 | 0] = 0;
                                l: {
                                    if (!Ce(j, i)) {
                                        break l;
                                    }
                                    b = 0;
                                    e = 0;
                                    c = 0;
                                    v = 0;
                                    j = 0;
                                    m = ea - 96 | 0;
                                    ea = m;
                                    F[m + 72 >> 2] = 0;
                                    F[m + 64 >> 2] = 0;
                                    F[m + 68 >> 2] = 0;
                                    F[m + 48 >> 2] = 0;
                                    F[m + 52 >> 2] = 0;
                                    F[m + 40 >> 2] = 0;
                                    F[m + 44 >> 2] = 0;
                                    F[m + 56 >> 2] = 1065353216;
                                    F[m + 32 >> 2] = 0;
                                    F[m + 24 >> 2] = 0;
                                    F[m + 28 >> 2] = 0;
                                    n = 1;
                                    g = a;
                                    K = F[a + 124 >> 2];
                                    m: {
                                        n: {
                                            o: {
                                                p: {
                                                    q: {
                                                        r: {
                                                            s: {
                                                                t: {
                                                                    if ((k | 0) <= 0) {
                                                                        break t;
                                                                    }
                                                                    z = F[g + 216 >> 2] != F[g + 220 >> 2];
                                                                    while (1) {
                                                                        h = v;
                                                                        v = h + 1 | 0;
                                                                        u: {
                                                                            v: {
                                                                                w: {
                                                                                    x: {
                                                                                        y: {
                                                                                            z: {
                                                                                                A: {
                                                                                                    B: {
                                                                                                        C: {
                                                                                                            D: {
                                                                                                                E: {
                                                                                                                    if (!G[g + 308 | 0]) {
                                                                                                                        break E;
                                                                                                                    }
                                                                                                                    F: {
                                                                                                                        G: {
                                                                                                                            t = F[g + 296 >> 2];
                                                                                                                            p = F[g + 304 >> 2];
                                                                                                                            a = t + (p >>> 3 | 0) | 0;
                                                                                                                            l = F[g + 300 >> 2];
                                                                                                                            if (a >>> 0 >= l >>> 0) {
                                                                                                                                break G;
                                                                                                                            }
                                                                                                                            d = G[a | 0];
                                                                                                                            a = p + 1 | 0;
                                                                                                                            F[g + 304 >> 2] = a;
                                                                                                                            if (!(d >>> (p & 7) & 1)) {
                                                                                                                                break G;
                                                                                                                            }
                                                                                                                            r = a >>> 3 | 0;
                                                                                                                            d = t + r | 0;
                                                                                                                            H: {
                                                                                                                                if (d >>> 0 >= l >>> 0) {
                                                                                                                                    d = a;
                                                                                                                                    a = 0;
                                                                                                                                    break H;
                                                                                                                                }
                                                                                                                                f = G[d | 0];
                                                                                                                                d = p + 2 | 0;
                                                                                                                                F[g + 304 >> 2] = d;
                                                                                                                                r = d >>> 3 | 0;
                                                                                                                                a = f >>> (a & 7) & 1;
                                                                                                                            }
                                                                                                                            f = r + t | 0;
                                                                                                                            if (f >>> 0 < l >>> 0) {
                                                                                                                                f = G[f | 0];
                                                                                                                                F[g + 304 >> 2] = d + 1;
                                                                                                                                d = f >>> (d & 7) << 1 & 2;
                                                                                                                            }
                                                                                                                            else {
                                                                                                                                d = 0;
                                                                                                                            }
                                                                                                                            a = (a | d) << 1;
                                                                                                                            switch (a - 1 | 0) {
                                                                                                                                case 0:
                                                                                                                                case 2:
                                                                                                                                case 4: break o;
                                                                                                                                case 5: break D;
                                                                                                                                case 1:
                                                                                                                                case 3: break F;
                                                                                                                                default: break E;
                                                                                                                            }
                                                                                                                        }
                                                                                                                        if ((c | 0) == (e | 0)) {
                                                                                                                            d = -1;
                                                                                                                            break s;
                                                                                                                        }
                                                                                                                        r = -1;
                                                                                                                        s = F[g + 8 >> 2];
                                                                                                                        t = F[s + 24 >> 2];
                                                                                                                        l = c - 4 | 0;
                                                                                                                        y = F[l >> 2];
                                                                                                                        a = -1;
                                                                                                                        I: {
                                                                                                                            if ((y | 0) == -1) {
                                                                                                                                break I;
                                                                                                                            }
                                                                                                                            b = y + 1 | 0;
                                                                                                                            b = (b >>> 0) % 3 | 0 ? b : y - 2 | 0;
                                                                                                                            a = -1;
                                                                                                                            if ((b | 0) == -1) {
                                                                                                                                break I;
                                                                                                                            }
                                                                                                                            a = F[F[s >> 2] + (b << 2) >> 2];
                                                                                                                        }
                                                                                                                        b = a;
                                                                                                                        d = F[t + (b << 2) >> 2];
                                                                                                                        if ((d | 0) != -1) {
                                                                                                                            a = d + 1 | 0;
                                                                                                                            r = (a >>> 0) % 3 | 0 ? a : d - 2 | 0;
                                                                                                                        }
                                                                                                                        d = F[s + 12 >> 2];
                                                                                                                        q = L(h, 3);
                                                                                                                        a = q + 1 | 0;
                                                                                                                        F[d + (y << 2) >> 2] = a;
                                                                                                                        f = a << 2;
                                                                                                                        F[f + d >> 2] = y;
                                                                                                                        p = q + 2 | 0;
                                                                                                                        F[d + (r << 2) >> 2] = p;
                                                                                                                        h = p << 2;
                                                                                                                        F[h + d >> 2] = r;
                                                                                                                        u = -1;
                                                                                                                        a = -1;
                                                                                                                        J: {
                                                                                                                            if ((y | 0) == -1) {
                                                                                                                                break J;
                                                                                                                            }
                                                                                                                            K: {
                                                                                                                                if ((y >>> 0) % 3 | 0) {
                                                                                                                                    d = y - 1 | 0;
                                                                                                                                    break K;
                                                                                                                                }
                                                                                                                                d = y + 2 | 0;
                                                                                                                                a = -1;
                                                                                                                                if ((d | 0) == -1) {
                                                                                                                                    break J;
                                                                                                                                }
                                                                                                                            }
                                                                                                                            a = F[F[s >> 2] + (d << 2) >> 2];
                                                                                                                        }
                                                                                                                        L: {
                                                                                                                            if ((r | 0) == -1) {
                                                                                                                                break L;
                                                                                                                            }
                                                                                                                            d = r + 1 | 0;
                                                                                                                            d = (d >>> 0) % 3 | 0 ? d : r - 2 | 0;
                                                                                                                            if ((d | 0) == -1) {
                                                                                                                                break L;
                                                                                                                            }
                                                                                                                            u = F[F[s >> 2] + (d << 2) >> 2];
                                                                                                                        }
                                                                                                                        d = -1;
                                                                                                                        if ((a | 0) == (b | 0) | (b | 0) == (u | 0)) {
                                                                                                                            break s;
                                                                                                                        }
                                                                                                                        d = F[s >> 2];
                                                                                                                        F[d + (q << 2) >> 2] = b;
                                                                                                                        F[d + f >> 2] = u;
                                                                                                                        F[d + h >> 2] = a;
                                                                                                                        if ((a | 0) != -1) {
                                                                                                                            F[t + (a << 2) >> 2] = p;
                                                                                                                        }
                                                                                                                        d = F[g + 120 >> 2] + (b >>> 3 & 536870908) | 0;
                                                                                                                        a = F[d >> 2];
                                                                                                                        O = d, P = Lj(b) & a, F[O >> 2] = P;
                                                                                                                        F[l >> 2] = q;
                                                                                                                        b = e;
                                                                                                                        break u;
                                                                                                                    }
                                                                                                                    if ((c | 0) == (e | 0)) {
                                                                                                                        d = -1;
                                                                                                                        break s;
                                                                                                                    }
                                                                                                                    u = F[g + 8 >> 2];
                                                                                                                    b = F[u + 12 >> 2];
                                                                                                                    q = L(h, 3);
                                                                                                                    t = (a | 1) == 5;
                                                                                                                    l = q + (t ? 2 : 1) | 0;
                                                                                                                    a = l << 2;
                                                                                                                    f = c - 4 | 0;
                                                                                                                    y = F[f >> 2];
                                                                                                                    F[b + a >> 2] = y;
                                                                                                                    F[b + (y << 2) >> 2] = l;
                                                                                                                    Sa(u + 24 | 0);
                                                                                                                    d = -1;
                                                                                                                    b = F[g + 8 >> 2];
                                                                                                                    p = F[b + 24 >> 2];
                                                                                                                    if ((K | 0) < F[b + 28 >> 2] - p >> 2) {
                                                                                                                        break s;
                                                                                                                    }
                                                                                                                    s = F[b >> 2];
                                                                                                                    d = s + a | 0;
                                                                                                                    b = F[u + 28 >> 2] - F[u + 24 >> 2] | 0;
                                                                                                                    a = (b >> 2) - 1 | 0;
                                                                                                                    F[d >> 2] = a;
                                                                                                                    if (b) {
                                                                                                                        F[p + (a << 2) >> 2] = l;
                                                                                                                    }
                                                                                                                    l = t ? q : q + 2 | 0;
                                                                                                                    d = s + (q + t << 2) | 0;
                                                                                                                    M: {
                                                                                                                        if ((y | 0) == -1) {
                                                                                                                            F[s + (l << 2) >> 2] = -1;
                                                                                                                            b = -1;
                                                                                                                            break M;
                                                                                                                        }
                                                                                                                        N: {
                                                                                                                            O: {
                                                                                                                                P: {
                                                                                                                                    if ((y >>> 0) % 3 | 0) {
                                                                                                                                        b = y - 1 | 0;
                                                                                                                                        break P;
                                                                                                                                    }
                                                                                                                                    b = y + 2 | 0;
                                                                                                                                    if ((b | 0) == -1) {
                                                                                                                                        break O;
                                                                                                                                    }
                                                                                                                                }
                                                                                                                                a = F[s + (b << 2) >> 2];
                                                                                                                                F[s + (l << 2) >> 2] = a;
                                                                                                                                if ((a | 0) == -1) {
                                                                                                                                    break N;
                                                                                                                                }
                                                                                                                                F[p + (a << 2) >> 2] = l;
                                                                                                                                break N;
                                                                                                                            }
                                                                                                                            F[s + (l << 2) >> 2] = -1;
                                                                                                                        }
                                                                                                                        a = y + 1 | 0;
                                                                                                                        a = (a >>> 0) % 3 | 0 ? a : y - 2 | 0;
                                                                                                                        b = -1;
                                                                                                                        if ((a | 0) == -1) {
                                                                                                                            break M;
                                                                                                                        }
                                                                                                                        b = F[s + (a << 2) >> 2];
                                                                                                                    }
                                                                                                                    F[d >> 2] = b;
                                                                                                                    F[f >> 2] = q;
                                                                                                                    b = e;
                                                                                                                    break C;
                                                                                                                }
                                                                                                                if ((c | 0) == (e | 0)) {
                                                                                                                    d = -1;
                                                                                                                    break s;
                                                                                                                }
                                                                                                                a = c - 4 | 0;
                                                                                                                s = F[a >> 2];
                                                                                                                F[m + 68 >> 2] = a;
                                                                                                                l = F[m + 44 >> 2];
                                                                                                                Q: {
                                                                                                                    if (!l) {
                                                                                                                        c = a;
                                                                                                                        break Q;
                                                                                                                    }
                                                                                                                    f = Kj(l) >>> 0 > 1;
                                                                                                                    R: {
                                                                                                                        if (!f) {
                                                                                                                            b = h & l + 2147483647;
                                                                                                                            break R;
                                                                                                                        }
                                                                                                                        b = h;
                                                                                                                        if (l >>> 0 > b >>> 0) {
                                                                                                                            break R;
                                                                                                                        }
                                                                                                                        b = (h >>> 0) % (l >>> 0) | 0;
                                                                                                                    }
                                                                                                                    d = F[F[m + 40 >> 2] + (b << 2) >> 2];
                                                                                                                    if (!d) {
                                                                                                                        c = a;
                                                                                                                        break Q;
                                                                                                                    }
                                                                                                                    d = F[d >> 2];
                                                                                                                    if (!d) {
                                                                                                                        c = a;
                                                                                                                        break Q;
                                                                                                                    }
                                                                                                                    S: {
                                                                                                                        if (!f) {
                                                                                                                            l = l - 1 | 0;
                                                                                                                            while (1) {
                                                                                                                                f = F[d + 4 >> 2];
                                                                                                                                T: {
                                                                                                                                    if ((f | 0) != (h | 0)) {
                                                                                                                                        if ((f & l) == (b | 0)) {
                                                                                                                                            break T;
                                                                                                                                        }
                                                                                                                                        c = a;
                                                                                                                                        break Q;
                                                                                                                                    }
                                                                                                                                    if ((h | 0) == F[d + 8 >> 2]) {
                                                                                                                                        break S;
                                                                                                                                    }
                                                                                                                                }
                                                                                                                                d = F[d >> 2];
                                                                                                                                if (d) {
                                                                                                                                    continue;
                                                                                                                                }
                                                                                                                                break;
                                                                                                                            }
                                                                                                                            c = a;
                                                                                                                            break Q;
                                                                                                                        }
                                                                                                                        while (1) {
                                                                                                                            f = F[d + 4 >> 2];
                                                                                                                            U: {
                                                                                                                                if ((f | 0) != (h | 0)) {
                                                                                                                                    if (f >>> 0 >= l >>> 0) {
                                                                                                                                        f = (f >>> 0) % (l >>> 0) | 0;
                                                                                                                                    }
                                                                                                                                    if ((b | 0) == (f | 0)) {
                                                                                                                                        break U;
                                                                                                                                    }
                                                                                                                                    c = a;
                                                                                                                                    break Q;
                                                                                                                                }
                                                                                                                                if ((h | 0) == F[d + 8 >> 2]) {
                                                                                                                                    break S;
                                                                                                                                }
                                                                                                                            }
                                                                                                                            d = F[d >> 2];
                                                                                                                            if (d) {
                                                                                                                                continue;
                                                                                                                            }
                                                                                                                            break;
                                                                                                                        }
                                                                                                                        c = a;
                                                                                                                        break Q;
                                                                                                                    }
                                                                                                                    if ((a | 0) != (C | 0)) {
                                                                                                                        F[a >> 2] = F[d + 12 >> 2];
                                                                                                                        F[m + 68 >> 2] = c;
                                                                                                                        break Q;
                                                                                                                    }
                                                                                                                    f = C - e | 0;
                                                                                                                    c = f >> 2;
                                                                                                                    b = c + 1 | 0;
                                                                                                                    if (b >>> 0 >= 1073741824) {
                                                                                                                        break A;
                                                                                                                    }
                                                                                                                    a = f >> 1;
                                                                                                                    b = f >>> 0 < 2147483644 ? a >>> 0 < b >>> 0 ? b : a : 1073741823;
                                                                                                                    if (b) {
                                                                                                                        if (b >>> 0 >= 1073741824) {
                                                                                                                            break n;
                                                                                                                        }
                                                                                                                        w = sa(b << 2);
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        w = 0;
                                                                                                                    }
                                                                                                                    a = w + (c << 2) | 0;
                                                                                                                    F[a >> 2] = F[d + 12 >> 2];
                                                                                                                    C = (b << 2) + w | 0;
                                                                                                                    c = a + 4 | 0;
                                                                                                                    if ((f | 0) > 0) {
                                                                                                                        ta(w, e, f);
                                                                                                                    }
                                                                                                                    F[m + 72 >> 2] = C;
                                                                                                                    F[m + 68 >> 2] = c;
                                                                                                                    F[m + 64 >> 2] = w;
                                                                                                                    if (!e) {
                                                                                                                        break Q;
                                                                                                                    }
                                                                                                                    ra(e);
                                                                                                                }
                                                                                                                if ((c | 0) == (w | 0)) {
                                                                                                                    break B;
                                                                                                                }
                                                                                                                f = c - 4 | 0;
                                                                                                                q = F[f >> 2];
                                                                                                                b = (q | 0) == -1;
                                                                                                                u = F[g + 8 >> 2];
                                                                                                                if (!b & F[F[u + 12 >> 2] + (q << 2) >> 2] != -1) {
                                                                                                                    break B;
                                                                                                                }
                                                                                                                p = F[u + 12 >> 2];
                                                                                                                if ((s | 0) != -1 & F[p + (s << 2) >> 2] != -1) {
                                                                                                                    break B;
                                                                                                                }
                                                                                                                t = L(h, 3);
                                                                                                                h = t + 2 | 0;
                                                                                                                F[p + (q << 2) >> 2] = h;
                                                                                                                l = h << 2;
                                                                                                                F[l + p >> 2] = q;
                                                                                                                a = t + 1 | 0;
                                                                                                                F[p + (s << 2) >> 2] = a;
                                                                                                                e = a << 2;
                                                                                                                F[e + p >> 2] = s;
                                                                                                                if (b) {
                                                                                                                    break z;
                                                                                                                }
                                                                                                                if ((q >>> 0) % 3 | 0) {
                                                                                                                    n = q - 1 | 0;
                                                                                                                    break x;
                                                                                                                }
                                                                                                                n = q + 2 | 0;
                                                                                                                if ((n | 0) != -1) {
                                                                                                                    break x;
                                                                                                                }
                                                                                                                r = F[u >> 2];
                                                                                                                b = -1;
                                                                                                                break w;
                                                                                                            }
                                                                                                            a = F[g + 8 >> 2];
                                                                                                            Sa(a + 24 | 0);
                                                                                                            d = -1;
                                                                                                            f = F[g + 8 >> 2];
                                                                                                            s = L(h, 3);
                                                                                                            p = F[a + 28 >> 2] - F[a + 24 >> 2] | 0;
                                                                                                            u = p >> 2;
                                                                                                            l = u - 1 | 0;
                                                                                                            F[F[f >> 2] + (s << 2) >> 2] = l;
                                                                                                            Sa(f + 24 | 0);
                                                                                                            t = s + 1 | 0;
                                                                                                            F[F[f >> 2] + (t << 2) >> 2] = (F[f + 28 >> 2] - F[f + 24 >> 2] >> 2) - 1;
                                                                                                            a = F[g + 8 >> 2];
                                                                                                            Sa(a + 24 | 0);
                                                                                                            f = s + 2 | 0;
                                                                                                            F[F[a >> 2] + (f << 2) >> 2] = (F[a + 28 >> 2] - F[a + 24 >> 2] >> 2) - 1;
                                                                                                            a = F[g + 8 >> 2];
                                                                                                            q = F[a + 24 >> 2];
                                                                                                            if ((K | 0) < F[a + 28 >> 2] - q >> 2) {
                                                                                                                break s;
                                                                                                            }
                                                                                                            V: {
                                                                                                                W: {
                                                                                                                    if (!p) {
                                                                                                                        F[q + (u << 2) >> 2] = t;
                                                                                                                        d = 1;
                                                                                                                        break W;
                                                                                                                    }
                                                                                                                    F[q + (l << 2) >> 2] = s;
                                                                                                                    d = 0;
                                                                                                                    if ((p | 0) == -4) {
                                                                                                                        break W;
                                                                                                                    }
                                                                                                                    F[q + (u << 2) >> 2] = t;
                                                                                                                    d = u + 1 | 0;
                                                                                                                    if ((d | 0) == -1) {
                                                                                                                        break V;
                                                                                                                    }
                                                                                                                }
                                                                                                                F[q + (d << 2) >> 2] = f;
                                                                                                            }
                                                                                                            if ((c | 0) != (C | 0)) {
                                                                                                                F[c >> 2] = s;
                                                                                                                c = c + 4 | 0;
                                                                                                                F[m + 68 >> 2] = c;
                                                                                                                break C;
                                                                                                            }
                                                                                                            d = c - b | 0;
                                                                                                            c = d >> 2;
                                                                                                            w = c + 1 | 0;
                                                                                                            if (w >>> 0 >= 1073741824) {
                                                                                                                break y;
                                                                                                            }
                                                                                                            a = d >> 1;
                                                                                                            e = d >>> 0 < 2147483644 ? a >>> 0 < w >>> 0 ? w : a : 1073741823;
                                                                                                            if (e) {
                                                                                                                if (e >>> 0 >= 1073741824) {
                                                                                                                    break n;
                                                                                                                }
                                                                                                                w = sa(e << 2);
                                                                                                            }
                                                                                                            else {
                                                                                                                w = 0;
                                                                                                            }
                                                                                                            a = w + (c << 2) | 0;
                                                                                                            F[a >> 2] = s;
                                                                                                            C = (e << 2) + w | 0;
                                                                                                            c = a + 4 | 0;
                                                                                                            if ((d | 0) > 0) {
                                                                                                                ta(w, b, d);
                                                                                                            }
                                                                                                            F[m + 72 >> 2] = C;
                                                                                                            F[m + 68 >> 2] = c;
                                                                                                            F[m + 64 >> 2] = w;
                                                                                                            if (b) {
                                                                                                                ra(b);
                                                                                                            }
                                                                                                            e = w;
                                                                                                            b = e;
                                                                                                        }
                                                                                                        d = F[g + 40 >> 2];
                                                                                                        if ((d | 0) == F[g + 36 >> 2]) {
                                                                                                            break u;
                                                                                                        }
                                                                                                        l = (h ^ -1) + k | 0;
                                                                                                        f = c - 4 | 0;
                                                                                                        while (1) {
                                                                                                            a = F[d - 8 >> 2];
                                                                                                            if (a >>> 0 > l >>> 0) {
                                                                                                                break B;
                                                                                                            }
                                                                                                            if ((a | 0) != (l | 0)) {
                                                                                                                break u;
                                                                                                            }
                                                                                                            h = G[d - 4 | 0];
                                                                                                            a = d - 12 | 0;
                                                                                                            d = F[a >> 2];
                                                                                                            F[g + 40 >> 2] = a;
                                                                                                            if ((d | 0) < 0) {
                                                                                                                break B;
                                                                                                            }
                                                                                                            t = F[f >> 2];
                                                                                                            F[m + 20 >> 2] = (d ^ -1) + k;
                                                                                                            a = m + 20 | 0;
                                                                                                            F[m + 88 >> 2] = a;
                                                                                                            $c(m, m + 40 | 0, a, m + 88 | 0);
                                                                                                            d = F[m >> 2];
                                                                                                            X: {
                                                                                                                if (h & 1) {
                                                                                                                    a = -1;
                                                                                                                    if ((t | 0) == -1) {
                                                                                                                        break X;
                                                                                                                    }
                                                                                                                    a = t + 1 | 0;
                                                                                                                    a = (a >>> 0) % 3 | 0 ? a : t - 2 | 0;
                                                                                                                    break X;
                                                                                                                }
                                                                                                                a = -1;
                                                                                                                if ((t | 0) == -1) {
                                                                                                                    break X;
                                                                                                                }
                                                                                                                a = t - 1 | 0;
                                                                                                                if ((t >>> 0) % 3 | 0) {
                                                                                                                    break X;
                                                                                                                }
                                                                                                                a = t + 2 | 0;
                                                                                                            }
                                                                                                            F[d + 12 >> 2] = a;
                                                                                                            d = F[g + 40 >> 2];
                                                                                                            if ((d | 0) != F[g + 36 >> 2]) {
                                                                                                                continue;
                                                                                                            }
                                                                                                            break;
                                                                                                        }
                                                                                                        break u;
                                                                                                    }
                                                                                                    d = -1;
                                                                                                    if (n & 1) {
                                                                                                        break s;
                                                                                                    }
                                                                                                    break t;
                                                                                                }
                                                                                                va();
                                                                                                V();
                                                                                            }
                                                                                            b = -1;
                                                                                            r = F[u >> 2];
                                                                                            F[r + (t << 2) >> 2] = -1;
                                                                                            d = -1;
                                                                                            break v;
                                                                                        }
                                                                                        va();
                                                                                        V();
                                                                                    }
                                                                                    r = F[u >> 2];
                                                                                    b = F[r + (n << 2) >> 2];
                                                                                }
                                                                                F[(t << 2) + r >> 2] = b;
                                                                                a = q + 1 | 0;
                                                                                a = (a >>> 0) % 3 | 0 ? a : q - 2 | 0;
                                                                                d = -1;
                                                                                if ((a | 0) == -1) {
                                                                                    break v;
                                                                                }
                                                                                d = F[(a << 2) + r >> 2];
                                                                            }
                                                                            F[e + r >> 2] = d;
                                                                            Y: {
                                                                                if ((s | 0) == -1) {
                                                                                    F[l + r >> 2] = -1;
                                                                                    n = -1;
                                                                                    d = -1;
                                                                                    break Y;
                                                                                }
                                                                                Z: {
                                                                                    _: {
                                                                                        $: {
                                                                                            if ((s >>> 0) % 3 | 0) {
                                                                                                d = s - 1 | 0;
                                                                                                break $;
                                                                                            }
                                                                                            d = s + 2 | 0;
                                                                                            if ((d | 0) == -1) {
                                                                                                break _;
                                                                                            }
                                                                                        }
                                                                                        a = F[(d << 2) + r >> 2];
                                                                                        F[l + r >> 2] = a;
                                                                                        if ((a | 0) == -1) {
                                                                                            break Z;
                                                                                        }
                                                                                        F[F[u + 24 >> 2] + (a << 2) >> 2] = h;
                                                                                        break Z;
                                                                                    }
                                                                                    F[l + r >> 2] = -1;
                                                                                }
                                                                                n = -1;
                                                                                a = s + 1 | 0;
                                                                                a = (a >>> 0) % 3 | 0 ? a : s - 2 | 0;
                                                                                d = -1;
                                                                                if ((a | 0) == -1) {
                                                                                    break Y;
                                                                                }
                                                                                n = F[(a << 2) + r >> 2];
                                                                                d = a;
                                                                            }
                                                                            a = F[u + 24 >> 2];
                                                                            h = a + (n << 2) | 0;
                                                                            if ((b | 0) != -1) {
                                                                                F[a + (b << 2) >> 2] = F[h >> 2];
                                                                            }
                                                                            aa: {
                                                                                if ((d | 0) == -1) {
                                                                                    break aa;
                                                                                }
                                                                                while (1) {
                                                                                    F[(d << 2) + r >> 2] = b;
                                                                                    a = d + 1 | 0;
                                                                                    a = (a >>> 0) % 3 | 0 ? a : d - 2 | 0;
                                                                                    if ((a | 0) == -1) {
                                                                                        break aa;
                                                                                    }
                                                                                    e = F[p + (a << 2) >> 2];
                                                                                    if ((e | 0) == -1) {
                                                                                        break aa;
                                                                                    }
                                                                                    a = e + 1 | 0;
                                                                                    d = (a >>> 0) % 3 | 0 ? a : e - 2 | 0;
                                                                                    if ((d | 0) != -1) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                            }
                                                                            F[h >> 2] = -1;
                                                                            ba: {
                                                                                if (z) {
                                                                                    break ba;
                                                                                }
                                                                                if ((A | 0) != (B | 0)) {
                                                                                    F[B >> 2] = n;
                                                                                    B = B + 4 | 0;
                                                                                    F[m + 28 >> 2] = B;
                                                                                    break ba;
                                                                                }
                                                                                ca: {
                                                                                    d = A - j | 0;
                                                                                    b = d >> 2;
                                                                                    e = b + 1 | 0;
                                                                                    if (e >>> 0 < 1073741824) {
                                                                                        a = d >> 1;
                                                                                        e = d >>> 0 < 2147483644 ? a >>> 0 < e >>> 0 ? e : a : 1073741823;
                                                                                        if (e) {
                                                                                            if (e >>> 0 >= 1073741824) {
                                                                                                break ca;
                                                                                            }
                                                                                            a = sa(e << 2);
                                                                                        }
                                                                                        else {
                                                                                            a = 0;
                                                                                        }
                                                                                        b = a + (b << 2) | 0;
                                                                                        F[b >> 2] = n;
                                                                                        A = a + (e << 2) | 0;
                                                                                        B = b + 4 | 0;
                                                                                        if ((d | 0) > 0) {
                                                                                            ta(a, j, d);
                                                                                        }
                                                                                        F[m + 32 >> 2] = A;
                                                                                        F[m + 28 >> 2] = B;
                                                                                        F[m + 24 >> 2] = a;
                                                                                        if (j) {
                                                                                            ra(j);
                                                                                        }
                                                                                        j = a;
                                                                                        break ba;
                                                                                    }
                                                                                    va();
                                                                                    V();
                                                                                }
                                                                                break n;
                                                                            }
                                                                            F[f >> 2] = t;
                                                                            e = w;
                                                                            b = e;
                                                                        }
                                                                        n = (k | 0) > (v | 0);
                                                                        if ((k | 0) != (v | 0)) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    v = k;
                                                                }
                                                                d = -1;
                                                                n = F[g + 8 >> 2];
                                                                if ((K | 0) < F[n + 28 >> 2] - F[n + 24 >> 2] >> 2) {
                                                                    break s;
                                                                }
                                                                if ((c | 0) != (w | 0)) {
                                                                    e = g + 60 | 0;
                                                                    t = g + 312 | 0;
                                                                    while (1) {
                                                                        c = c - 4 | 0;
                                                                        p = F[c >> 2];
                                                                        F[m + 68 >> 2] = c;
                                                                        da: {
                                                                            ea: {
                                                                                fa: {
                                                                                    ga: {
                                                                                        if (H[g + 270 >> 1] <= 513) {
                                                                                            if (!G[g + 364 | 0]) {
                                                                                                break fa;
                                                                                            }
                                                                                            b = F[g + 360 >> 2];
                                                                                            a = F[g + 352 >> 2] + (b >>> 3 | 0) | 0;
                                                                                            if (a >>> 0 >= I[g + 356 >> 2]) {
                                                                                                break ea;
                                                                                            }
                                                                                            a = G[a | 0];
                                                                                            F[g + 360 >> 2] = b + 1;
                                                                                            a = a >>> (b & 7) & 1;
                                                                                            break ga;
                                                                                        }
                                                                                        a = Ga(t);
                                                                                    }
                                                                                    if (!a) {
                                                                                        break ea;
                                                                                    }
                                                                                }
                                                                                z = F[g + 8 >> 2];
                                                                                q = F[z >> 2];
                                                                                if (((F[z + 4 >> 2] - q >> 2 >>> 0) / 3 | 0) <= (v | 0)) {
                                                                                    break s;
                                                                                }
                                                                                a = -1;
                                                                                b = -1;
                                                                                l = F[z + 24 >> 2];
                                                                                h = -1;
                                                                                ha: {
                                                                                    if ((p | 0) == -1) {
                                                                                        break ha;
                                                                                    }
                                                                                    f = p + 1 | 0;
                                                                                    f = (f >>> 0) % 3 | 0 ? f : p - 2 | 0;
                                                                                    h = -1;
                                                                                    if ((f | 0) == -1) {
                                                                                        break ha;
                                                                                    }
                                                                                    h = F[q + (f << 2) >> 2];
                                                                                }
                                                                                k = F[l + (h << 2) >> 2];
                                                                                ia: {
                                                                                    if ((k | 0) == -1) {
                                                                                        break ia;
                                                                                    }
                                                                                    f = k + 1 | 0;
                                                                                    f = (f >>> 0) % 3 | 0 ? f : k - 2 | 0;
                                                                                    if ((f | 0) == -1) {
                                                                                        break ia;
                                                                                    }
                                                                                    a = f + 1 | 0;
                                                                                    a = (a >>> 0) % 3 | 0 ? a : f - 2 | 0;
                                                                                    if ((a | 0) != -1) {
                                                                                        b = F[q + (a << 2) >> 2];
                                                                                    }
                                                                                    a = f;
                                                                                }
                                                                                n = -1;
                                                                                r = -1;
                                                                                l = F[l + (b << 2) >> 2];
                                                                                k = -1;
                                                                                ja: {
                                                                                    if ((l | 0) == -1) {
                                                                                        break ja;
                                                                                    }
                                                                                    f = l + 1 | 0;
                                                                                    f = (f >>> 0) % 3 | 0 ? f : l - 2 | 0;
                                                                                    k = -1;
                                                                                    if ((f | 0) == -1) {
                                                                                        break ja;
                                                                                    }
                                                                                    k = f + 1 | 0;
                                                                                    k = (k >>> 0) % 3 | 0 ? k : f - 2 | 0;
                                                                                    if ((k | 0) != -1) {
                                                                                        r = F[q + (k << 2) >> 2];
                                                                                    }
                                                                                    k = f;
                                                                                }
                                                                                A = F[z + 12 >> 2];
                                                                                u = L(v, 3);
                                                                                l = u << 2;
                                                                                F[A + l >> 2] = p;
                                                                                F[A + (p << 2) >> 2] = u;
                                                                                p = u + 1 | 0;
                                                                                f = p << 2;
                                                                                F[f + A >> 2] = a;
                                                                                F[A + (a << 2) >> 2] = p;
                                                                                z = u + 2 | 0;
                                                                                a = z << 2;
                                                                                F[a + A >> 2] = k;
                                                                                F[A + (k << 2) >> 2] = z;
                                                                                F[l + q >> 2] = b;
                                                                                k = f + q | 0;
                                                                                F[k >> 2] = r;
                                                                                f = a + q | 0;
                                                                                F[f >> 2] = h;
                                                                                l = F[g + 120 >> 2];
                                                                                h = p >>> 0 < u >>> 0 ? -1 : b;
                                                                                b = l + (h >>> 3 & 536870908) | 0;
                                                                                a = F[b >> 2];
                                                                                O = b, P = Lj(h) & a, F[O >> 2] = P;
                                                                                n = (p | 0) != -1 ? F[k >> 2] : n;
                                                                                b = l + (n >>> 3 & 536870908) | 0;
                                                                                a = F[b >> 2];
                                                                                O = b, P = Lj(n) & a, F[O >> 2] = P;
                                                                                n = -1;
                                                                                n = (z | 0) != -1 ? F[f >> 2] : n;
                                                                                b = l + (n >>> 3 & 536870908) | 0;
                                                                                a = F[b >> 2];
                                                                                O = b, P = Lj(n) & a, F[O >> 2] = P;
                                                                                n = F[g + 64 >> 2];
                                                                                a = F[g + 68 >> 2];
                                                                                if ((n | 0) == a << 5) {
                                                                                    if ((n + 1 | 0) < 0) {
                                                                                        break r;
                                                                                    }
                                                                                    if (n >>> 0 <= 1073741822) {
                                                                                        b = n + 32 & -32;
                                                                                        a = a << 6;
                                                                                        a = a >>> 0 < b >>> 0 ? b : a;
                                                                                    }
                                                                                    else {
                                                                                        a = 2147483647;
                                                                                    }
                                                                                    db(e, a);
                                                                                    n = F[g + 64 >> 2];
                                                                                }
                                                                                v = v + 1 | 0;
                                                                                F[g + 64 >> 2] = n + 1;
                                                                                a = F[g + 60 >> 2] + (n >>> 3 & 536870908) | 0;
                                                                                F[a >> 2] = F[a >> 2] | 1 << n;
                                                                                a = F[g + 76 >> 2];
                                                                                if ((a | 0) != F[g + 80 >> 2]) {
                                                                                    F[a >> 2] = u;
                                                                                    F[g + 76 >> 2] = a + 4;
                                                                                    break da;
                                                                                }
                                                                                f = F[g + 72 >> 2];
                                                                                k = a - f | 0;
                                                                                b = k >> 2;
                                                                                h = b + 1 | 0;
                                                                                if (h >>> 0 >= 1073741824) {
                                                                                    break q;
                                                                                }
                                                                                a = k >> 1;
                                                                                h = k >>> 0 < 2147483644 ? a >>> 0 < h >>> 0 ? h : a : 1073741823;
                                                                                if (h) {
                                                                                    if (h >>> 0 >= 1073741824) {
                                                                                        break n;
                                                                                    }
                                                                                    a = sa(h << 2);
                                                                                }
                                                                                else {
                                                                                    a = 0;
                                                                                }
                                                                                b = a + (b << 2) | 0;
                                                                                F[b >> 2] = u;
                                                                                if ((k | 0) > 0) {
                                                                                    ta(a, f, k);
                                                                                }
                                                                                F[g + 80 >> 2] = a + (h << 2);
                                                                                F[g + 76 >> 2] = b + 4;
                                                                                F[g + 72 >> 2] = a;
                                                                                if (!f) {
                                                                                    break da;
                                                                                }
                                                                                ra(f);
                                                                                break da;
                                                                            }
                                                                            a = F[g + 64 >> 2];
                                                                            h = F[g + 68 >> 2];
                                                                            if ((a | 0) == h << 5) {
                                                                                if ((a + 1 | 0) < 0) {
                                                                                    break r;
                                                                                }
                                                                                if (a >>> 0 <= 1073741822) {
                                                                                    b = a + 32 & -32;
                                                                                    a = h << 6;
                                                                                    a = a >>> 0 < b >>> 0 ? b : a;
                                                                                }
                                                                                else {
                                                                                    a = 2147483647;
                                                                                }
                                                                                db(e, a);
                                                                                a = F[g + 64 >> 2];
                                                                            }
                                                                            F[g + 64 >> 2] = a + 1;
                                                                            h = F[g + 60 >> 2] + (a >>> 3 & 536870908) | 0;
                                                                            b = F[h >> 2];
                                                                            O = h, P = Lj(a) & b, F[O >> 2] = P;
                                                                            a = F[g + 76 >> 2];
                                                                            if ((a | 0) != F[g + 80 >> 2]) {
                                                                                F[a >> 2] = p;
                                                                                F[g + 76 >> 2] = a + 4;
                                                                                break da;
                                                                            }
                                                                            f = F[g + 72 >> 2];
                                                                            k = a - f | 0;
                                                                            b = k >> 2;
                                                                            h = b + 1 | 0;
                                                                            if (h >>> 0 >= 1073741824) {
                                                                                break q;
                                                                            }
                                                                            a = k >> 1;
                                                                            h = k >>> 0 < 2147483644 ? a >>> 0 < h >>> 0 ? h : a : 1073741823;
                                                                            if (h) {
                                                                                if (h >>> 0 >= 1073741824) {
                                                                                    break p;
                                                                                }
                                                                                a = sa(h << 2);
                                                                            }
                                                                            else {
                                                                                a = 0;
                                                                            }
                                                                            b = a + (b << 2) | 0;
                                                                            F[b >> 2] = p;
                                                                            if ((k | 0) > 0) {
                                                                                ta(a, f, k);
                                                                            }
                                                                            F[g + 80 >> 2] = a + (h << 2);
                                                                            F[g + 76 >> 2] = b + 4;
                                                                            F[g + 72 >> 2] = a;
                                                                            if (!f) {
                                                                                break da;
                                                                            }
                                                                            ra(f);
                                                                        }
                                                                        if ((c | 0) != (w | 0)) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    n = F[g + 8 >> 2];
                                                                }
                                                                if (((F[n + 4 >> 2] - F[n >> 2] >> 2 >>> 0) / 3 | 0) != (v | 0)) {
                                                                    break s;
                                                                }
                                                                v = F[n + 24 >> 2];
                                                                d = F[n + 28 >> 2] - v >> 2;
                                                                if ((j | 0) == (B | 0)) {
                                                                    j = B;
                                                                    break s;
                                                                }
                                                                b = j;
                                                                while (1) {
                                                                    e = F[b >> 2];
                                                                    c = d - 1 | 0;
                                                                    r = (c << 2) + v | 0;
                                                                    if (F[r >> 2] == -1) {
                                                                        while (1) {
                                                                            c = d - 2 | 0;
                                                                            d = d - 1 | 0;
                                                                            r = (c << 2) + v | 0;
                                                                            if (F[r >> 2] == -1) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    if (c >>> 0 >= e >>> 0) {
                                                                        F[m >> 2] = n;
                                                                        v = F[r >> 2];
                                                                        D[m + 12 | 0] = 1;
                                                                        F[m + 8 >> 2] = v;
                                                                        F[m + 4 >> 2] = v;
                                                                        if ((v | 0) != -1) {
                                                                            while (1) {
                                                                                F[F[n >> 2] + (v << 2) >> 2] = e;
                                                                                vc(m);
                                                                                n = F[g + 8 >> 2];
                                                                                v = F[m + 8 >> 2];
                                                                                if ((v | 0) != -1) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                        }
                                                                        v = F[n + 24 >> 2];
                                                                        a = v + (c << 2) | 0;
                                                                        if ((e | 0) != -1) {
                                                                            F[(e << 2) + v >> 2] = F[a >> 2];
                                                                        }
                                                                        F[a >> 2] = -1;
                                                                        f = 1 << e;
                                                                        a = F[g + 120 >> 2];
                                                                        e = a + (e >>> 3 & 536870908) | 0;
                                                                        h = a + (c >>> 3 & 536870908) | 0;
                                                                        a = 1 << c;
                                                                        if (F[h >> 2] & a) {
                                                                            c = f | F[e >> 2];
                                                                        }
                                                                        else {
                                                                            c = F[e >> 2] & (f ^ -1);
                                                                        }
                                                                        F[e >> 2] = c;
                                                                        F[h >> 2] = F[h >> 2] & (a ^ -1);
                                                                        d = d - 1 | 0;
                                                                    }
                                                                    b = b + 4 | 0;
                                                                    if ((B | 0) != (b | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            if (j) {
                                                                ra(j);
                                                            }
                                                            a = F[m + 48 >> 2];
                                                            if (a) {
                                                                while (1) {
                                                                    c = F[a >> 2];
                                                                    ra(a);
                                                                    a = c;
                                                                    if (a) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            a = F[m + 40 >> 2];
                                                            F[m + 40 >> 2] = 0;
                                                            if (a) {
                                                                ra(a);
                                                            }
                                                            if (w) {
                                                                F[m + 68 >> 2] = w;
                                                                ra(w);
                                                            }
                                                            ea = m + 96 | 0;
                                                            break m;
                                                        }
                                                        Oa();
                                                        V();
                                                    }
                                                    va();
                                                    V();
                                                }
                                                wa(1336);
                                            }
                                            V();
                                        }
                                        wa(1336);
                                        V();
                                    }
                                    if ((d | 0) == -1) {
                                        break l;
                                    }
                                    a = F[i + 16 >> 2];
                                    b = a + F[i >> 2] | 0;
                                    c = F[i + 8 >> 2];
                                    a = c - a | 0;
                                    c = F[F[g + 4 >> 2] + 32 >> 2];
                                    E[c + 38 >> 1] = H[c + 38 >> 1];
                                    F[c >> 2] = b;
                                    F[c + 16 >> 2] = 0;
                                    F[c + 20 >> 2] = 0;
                                    F[c + 8 >> 2] = a;
                                    F[c + 12 >> 2] = 0;
                                    b = F[g + 4 >> 2];
                                    a = H[b + 36 >> 1];
                                    c = a << 8 | a >>> 8;
                                    if ((c & 65535) >>> 0 <= 513) {
                                        a = F[b + 32 >> 2];
                                        b = M + F[a + 20 >> 2] | 0;
                                        w = o + F[a + 16 >> 2] | 0;
                                        b = w >>> 0 < o >>> 0 ? b + 1 | 0 : b;
                                        F[a + 16 >> 2] = w;
                                        F[a + 20 >> 2] = b;
                                    }
                                    ka: {
                                        if (F[g + 216 >> 2] == F[g + 220 >> 2]) {
                                            break ka;
                                        }
                                        a = F[g + 8 >> 2];
                                        b = F[a >> 2];
                                        a = F[a + 4 >> 2];
                                        la: {
                                            if ((c & 65535) >>> 0 >= 513) {
                                                if ((a | 0) == (b | 0)) {
                                                    break ka;
                                                }
                                                c = 0;
                                                break la;
                                            }
                                            if ((a | 0) == (b | 0)) {
                                                break ka;
                                            }
                                            c = 0;
                                            while (1) {
                                                if (dd(g, c)) {
                                                    c = c + 3 | 0;
                                                    a = F[g + 8 >> 2];
                                                    if (c >>> 0 < F[a + 4 >> 2] - F[a >> 2] >> 2 >>> 0) {
                                                        continue;
                                                    }
                                                    break ka;
                                                }
                                                break;
                                            }
                                            break l;
                                        }
                                        while (1) {
                                            if (cd(g, c)) {
                                                c = c + 3 | 0;
                                                a = F[g + 8 >> 2];
                                                if (c >>> 0 < F[a + 4 >> 2] - F[a >> 2] >> 2 >>> 0) {
                                                    continue;
                                                }
                                                break ka;
                                            }
                                            break;
                                        }
                                        break l;
                                    }
                                    bd(N);
                                    c = F[g + 216 >> 2];
                                    if ((c | 0) != F[g + 220 >> 2]) {
                                        e = 0;
                                        while (1) {
                                            b = L(e, 144);
                                            Ic((b + c | 0) + 4 | 0, F[g + 8 >> 2]);
                                            x = F[J >> 2];
                                            a = b + x | 0;
                                            c = F[a + 132 >> 2];
                                            a = F[a + 136 >> 2];
                                            if ((c | 0) != (a | 0)) {
                                                while (1) {
                                                    Gc((b + x | 0) + 4 | 0, F[c >> 2]);
                                                    x = F[J >> 2];
                                                    c = c + 4 | 0;
                                                    if ((a | 0) != (c | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            Hc((b + x | 0) + 4 | 0);
                                            e = e + 1 | 0;
                                            c = F[g + 216 >> 2];
                                            if (e >>> 0 < (F[g + 220 >> 2] - c | 0) / 144 >>> 0) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    a = F[g + 8 >> 2];
                                    Gb(g + 184 | 0, F[a + 28 >> 2] - F[a + 24 >> 2] >> 2);
                                    x = F[g + 216 >> 2];
                                    if ((x | 0) != F[g + 220 >> 2]) {
                                        c = 0;
                                        while (1) {
                                            a = L(c, 144) + x | 0;
                                            b = F[a + 60 >> 2] - F[a + 56 >> 2] >> 2;
                                            e = a + 104 | 0;
                                            a = F[g + 8 >> 2];
                                            a = F[a + 28 >> 2] - F[a + 24 >> 2] >> 2;
                                            Gb(e, (a | 0) > (b | 0) ? a : b);
                                            c = c + 1 | 0;
                                            x = F[g + 216 >> 2];
                                            if (c >>> 0 < (F[g + 220 >> 2] - x | 0) / 144 >>> 0) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    x = ad(g, d);
                                }
                                break b;
                            }
                            x = 0;
                        } ea = i - -64 | 0; return x | 0; }
                        function lg(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0; a: {
                            b: {
                                c: {
                                    d: {
                                        e: {
                                            switch (d - 1 | 0) {
                                                case 0:
                                                    a = 0;
                                                    m = ea - 16 | 0;
                                                    ea = m;
                                                    j = F[b + 80 >> 2];
                                                    g = D[c + 24 | 0];
                                                    f: {
                                                        if ((L(j, g) | 0) != (e | 0)) {
                                                            break f;
                                                        }
                                                        b = F[c + 28 >> 2] != 1;
                                                        a = G[c + 84 | 0];
                                                        if (!(b | !a)) {
                                                            ta(f, F[F[c >> 2] >> 2] + F[c + 48 >> 2] | 0, e);
                                                            a = 1;
                                                            break f;
                                                        }
                                                        d = 0;
                                                        F[m + 8 >> 2] = 0;
                                                        F[m >> 2] = 0;
                                                        F[m + 4 >> 2] = 0;
                                                        if (g) {
                                                            if ((g | 0) < 0) {
                                                                break d;
                                                            }
                                                            h = sa(g);
                                                            F[m >> 2] = h;
                                                            ua(h, 0, g);
                                                        }
                                                        g: {
                                                            h: {
                                                                if (!j) {
                                                                    break h;
                                                                }
                                                                if (!b) {
                                                                    if (g) {
                                                                        n = g & -4;
                                                                        l = g & 3;
                                                                        b = 0;
                                                                        o = g - 1 >>> 0 < 3;
                                                                        while (1) {
                                                                            e = F[F[c >> 2] >> 2];
                                                                            p = F[c + 40 >> 2];
                                                                            a = F[c + 48 >> 2] + Hj(p, F[c + 44 >> 2], a & 255 ? d : F[F[c + 68 >> 2] + (d << 2) >> 2], 0) | 0;
                                                                            g = ta(h, e + a | 0, p);
                                                                            e = 0;
                                                                            a = 0;
                                                                            i = 0;
                                                                            if (!o) {
                                                                                while (1) {
                                                                                    k = b + f | 0;
                                                                                    D[k | 0] = G[a + g | 0];
                                                                                    D[k + 1 | 0] = G[g + (a | 1) | 0];
                                                                                    D[k + 2 | 0] = G[g + (a | 2) | 0];
                                                                                    D[k + 3 | 0] = G[g + (a | 3) | 0];
                                                                                    a = a + 4 | 0;
                                                                                    b = b + 4 | 0;
                                                                                    i = i + 4 | 0;
                                                                                    if ((n | 0) != (i | 0)) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                            }
                                                                            if (l) {
                                                                                while (1) {
                                                                                    D[b + f | 0] = G[a + g | 0];
                                                                                    a = a + 1 | 0;
                                                                                    b = b + 1 | 0;
                                                                                    e = e + 1 | 0;
                                                                                    if ((l | 0) != (e | 0)) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                            }
                                                                            a = 1;
                                                                            d = d + 1 | 0;
                                                                            if ((j | 0) == (d | 0)) {
                                                                                break g;
                                                                            }
                                                                            a = G[c + 84 | 0];
                                                                            continue;
                                                                        }
                                                                    }
                                                                    l = F[c >> 2];
                                                                    e = F[c + 48 >> 2];
                                                                    o = F[c + 68 >> 2];
                                                                    f = F[c + 44 >> 2];
                                                                    c = F[c + 40 >> 2];
                                                                    p = c;
                                                                    b = 0;
                                                                    if ((j | 0) != 1) {
                                                                        q = j & -2;
                                                                        s = a & 255;
                                                                        while (1) {
                                                                            g = b | 1;
                                                                            n = F[l >> 2];
                                                                            k = Hj(c, f, s ? b : F[o + (b << 2) >> 2], 0) + e | 0;
                                                                            k = ta(h, n + k | 0, p);
                                                                            r = F[l >> 2];
                                                                            if (!s) {
                                                                                g = F[o + (g << 2) >> 2];
                                                                            }
                                                                            g = Hj(c, f, g, 0) + e | 0;
                                                                            ta(k, g + r | 0, p);
                                                                            b = b + 2 | 0;
                                                                            i = i + 2 | 0;
                                                                            if ((q | 0) != (i | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    if (!(j & 1)) {
                                                                        break h;
                                                                    }
                                                                    i = F[l >> 2];
                                                                    if (!(a & 255)) {
                                                                        b = F[o + (b << 2) >> 2];
                                                                    }
                                                                    a = Hj(c, f, b, 0) + e | 0;
                                                                    ta(h, a + i | 0, p);
                                                                    break h;
                                                                }
                                                                if (!g) {
                                                                    b = 0;
                                                                    d = 1;
                                                                    while (1) {
                                                                        if (!jc(c, a & 255 ? b : F[F[c + 68 >> 2] + (b << 2) >> 2], D[c + 24 | 0], h)) {
                                                                            break h;
                                                                        }
                                                                        b = b + 1 | 0;
                                                                        d = j >>> 0 > b >>> 0;
                                                                        if ((b | 0) == (j | 0)) {
                                                                            break h;
                                                                        }
                                                                        a = G[c + 84 | 0];
                                                                        continue;
                                                                    }
                                                                }
                                                                l = g & -4;
                                                                k = g & 3;
                                                                b = 0;
                                                                n = g - 1 >>> 0 < 3;
                                                                d = 1;
                                                                while (1) {
                                                                    if (!jc(c, a & 255 ? i : F[F[c + 68 >> 2] + (i << 2) >> 2], D[c + 24 | 0], h)) {
                                                                        break h;
                                                                    }
                                                                    d = 0;
                                                                    a = 0;
                                                                    e = 0;
                                                                    if (!n) {
                                                                        while (1) {
                                                                            g = b + f | 0;
                                                                            D[g | 0] = G[a + h | 0];
                                                                            D[g + 1 | 0] = G[(a | 1) + h | 0];
                                                                            D[g + 2 | 0] = G[(a | 2) + h | 0];
                                                                            D[g + 3 | 0] = G[(a | 3) + h | 0];
                                                                            a = a + 4 | 0;
                                                                            b = b + 4 | 0;
                                                                            e = e + 4 | 0;
                                                                            if ((l | 0) != (e | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    if (k) {
                                                                        while (1) {
                                                                            D[b + f | 0] = G[a + h | 0];
                                                                            a = a + 1 | 0;
                                                                            b = b + 1 | 0;
                                                                            d = d + 1 | 0;
                                                                            if ((k | 0) != (d | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    i = i + 1 | 0;
                                                                    if ((j | 0) != (i | 0)) {
                                                                        d = i >>> 0 < j >>> 0;
                                                                        a = G[c + 84 | 0];
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                a = i >>> 0 >= j >>> 0;
                                                                break g;
                                                            }
                                                            a = d ^ 1;
                                                            if (!h) {
                                                                break f;
                                                            }
                                                        }
                                                        ra(h);
                                                    }
                                                    break c;
                                                case 2:
                                                    a = 0;
                                                    m = ea - 16 | 0;
                                                    ea = m;
                                                    d = D[c + 24 | 0];
                                                    g = d << 1;
                                                    j = F[b + 80 >> 2];
                                                    i: {
                                                        if ((L(g, j) | 0) != (e | 0)) {
                                                            break i;
                                                        }
                                                        b = F[c + 28 >> 2] != 3;
                                                        a = G[c + 84 | 0];
                                                        if (!(b | !a)) {
                                                            ta(f, F[F[c >> 2] >> 2] + F[c + 48 >> 2] | 0, e);
                                                            a = 1;
                                                            break i;
                                                        }
                                                        F[m + 8 >> 2] = 0;
                                                        F[m >> 2] = 0;
                                                        F[m + 4 >> 2] = 0;
                                                        if (d) {
                                                            if ((d | 0) < 0) {
                                                                break d;
                                                            }
                                                            h = sa(g);
                                                            F[m >> 2] = h;
                                                            ua(h, 0, d << 1);
                                                        }
                                                        j: {
                                                            k: {
                                                                if (!j) {
                                                                    break k;
                                                                }
                                                                if (!b) {
                                                                    n = F[c >> 2];
                                                                    e = F[c + 48 >> 2];
                                                                    p = F[c + 68 >> 2];
                                                                    g = F[c + 44 >> 2];
                                                                    k = F[c + 40 >> 2];
                                                                    s = k;
                                                                    if (d) {
                                                                        t = d & -4;
                                                                        o = d & 3;
                                                                        b = 0;
                                                                        u = a & 255;
                                                                        v = d - 1 >>> 0 < 3;
                                                                        d = 0;
                                                                        while (1) {
                                                                            c = F[n >> 2];
                                                                            a = Hj(k, g, u ? d : F[p + (d << 2) >> 2], 0) + e | 0;
                                                                            l = ta(h, c + a | 0, s);
                                                                            i = 0;
                                                                            a = 0;
                                                                            c = 0;
                                                                            if (!v) {
                                                                                while (1) {
                                                                                    q = (b << 1) + f | 0;
                                                                                    r = a << 1;
                                                                                    E[q >> 1] = H[r + l >> 1];
                                                                                    E[q + 2 >> 1] = H[l + (r | 2) >> 1];
                                                                                    E[q + 4 >> 1] = H[l + (r | 4) >> 1];
                                                                                    E[q + 6 >> 1] = H[l + (r | 6) >> 1];
                                                                                    a = a + 4 | 0;
                                                                                    b = b + 4 | 0;
                                                                                    c = c + 4 | 0;
                                                                                    if ((t | 0) != (c | 0)) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                            }
                                                                            if (o) {
                                                                                while (1) {
                                                                                    E[(b << 1) + f >> 1] = H[l + (a << 1) >> 1];
                                                                                    a = a + 1 | 0;
                                                                                    b = b + 1 | 0;
                                                                                    i = i + 1 | 0;
                                                                                    if ((o | 0) != (i | 0)) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                            }
                                                                            a = 1;
                                                                            d = d + 1 | 0;
                                                                            if ((j | 0) != (d | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        break j;
                                                                    }
                                                                    b = 0;
                                                                    if ((j | 0) != 1) {
                                                                        q = j & -2;
                                                                        l = a & 255;
                                                                        d = 0;
                                                                        while (1) {
                                                                            c = b | 1;
                                                                            o = F[n >> 2];
                                                                            f = Hj(k, g, l ? b : F[p + (b << 2) >> 2], 0) + e | 0;
                                                                            f = ta(h, o + f | 0, s);
                                                                            r = F[n >> 2];
                                                                            if (!l) {
                                                                                c = F[p + (c << 2) >> 2];
                                                                            }
                                                                            c = Hj(k, g, c, 0) + e | 0;
                                                                            ta(f, c + r | 0, s);
                                                                            b = b + 2 | 0;
                                                                            d = d + 2 | 0;
                                                                            if ((q | 0) != (d | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    if (!(j & 1)) {
                                                                        break k;
                                                                    }
                                                                    c = F[n >> 2];
                                                                    if (!(a & 255)) {
                                                                        b = F[p + (b << 2) >> 2];
                                                                    }
                                                                    a = Hj(k, g, b, 0) + e | 0;
                                                                    ta(h, a + c | 0, s);
                                                                    break k;
                                                                }
                                                                if (!d) {
                                                                    b = 0;
                                                                    i = 1;
                                                                    while (1) {
                                                                        if (!hc(c, a & 255 ? b : F[F[c + 68 >> 2] + (b << 2) >> 2], D[c + 24 | 0], h)) {
                                                                            break k;
                                                                        }
                                                                        b = b + 1 | 0;
                                                                        i = j >>> 0 > b >>> 0;
                                                                        if ((b | 0) == (j | 0)) {
                                                                            break k;
                                                                        }
                                                                        a = G[c + 84 | 0];
                                                                        continue;
                                                                    }
                                                                }
                                                                n = d & -4;
                                                                l = d & 3;
                                                                b = 0;
                                                                o = d - 1 >>> 0 < 3;
                                                                i = 1;
                                                                d = 0;
                                                                while (1) {
                                                                    if (!hc(c, a & 255 ? d : F[F[c + 68 >> 2] + (d << 2) >> 2], D[c + 24 | 0], h)) {
                                                                        break k;
                                                                    }
                                                                    e = 0;
                                                                    a = 0;
                                                                    i = 0;
                                                                    if (!o) {
                                                                        while (1) {
                                                                            g = (b << 1) + f | 0;
                                                                            k = a << 1;
                                                                            E[g >> 1] = H[k + h >> 1];
                                                                            E[g + 2 >> 1] = H[(k | 2) + h >> 1];
                                                                            E[g + 4 >> 1] = H[(k | 4) + h >> 1];
                                                                            E[g + 6 >> 1] = H[(k | 6) + h >> 1];
                                                                            a = a + 4 | 0;
                                                                            b = b + 4 | 0;
                                                                            i = i + 4 | 0;
                                                                            if ((n | 0) != (i | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    if (l) {
                                                                        while (1) {
                                                                            E[(b << 1) + f >> 1] = H[(a << 1) + h >> 1];
                                                                            a = a + 1 | 0;
                                                                            b = b + 1 | 0;
                                                                            e = e + 1 | 0;
                                                                            if ((l | 0) != (e | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    d = d + 1 | 0;
                                                                    if ((j | 0) != (d | 0)) {
                                                                        i = d >>> 0 < j >>> 0;
                                                                        a = G[c + 84 | 0];
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                a = d >>> 0 >= j >>> 0;
                                                                break j;
                                                            }
                                                            a = !i;
                                                            if (!h) {
                                                                break i;
                                                            }
                                                        }
                                                        ra(h);
                                                    }
                                                    break b;
                                                case 4:
                                                    a = 0;
                                                    m = ea - 16 | 0;
                                                    ea = m;
                                                    d = D[c + 24 | 0];
                                                    g = d << 2;
                                                    j = F[b + 80 >> 2];
                                                    l: {
                                                        if ((L(g, j) | 0) != (e | 0)) {
                                                            break l;
                                                        }
                                                        b = F[c + 28 >> 2] != 5;
                                                        a = G[c + 84 | 0];
                                                        if (!(b | !a)) {
                                                            ta(f, F[F[c >> 2] >> 2] + F[c + 48 >> 2] | 0, e);
                                                            a = 1;
                                                            break l;
                                                        }
                                                        F[m + 8 >> 2] = 0;
                                                        F[m >> 2] = 0;
                                                        F[m + 4 >> 2] = 0;
                                                        if (d) {
                                                            if ((d | 0) < 0) {
                                                                break d;
                                                            }
                                                            h = sa(g);
                                                            F[m >> 2] = h;
                                                            ua(h, 0, d << 2);
                                                        }
                                                        m: {
                                                            n: {
                                                                if (!j) {
                                                                    break n;
                                                                }
                                                                if (!b) {
                                                                    n = F[c >> 2];
                                                                    e = F[c + 48 >> 2];
                                                                    p = F[c + 68 >> 2];
                                                                    g = F[c + 44 >> 2];
                                                                    k = F[c + 40 >> 2];
                                                                    s = k;
                                                                    if (d) {
                                                                        t = d & -4;
                                                                        o = d & 3;
                                                                        b = 0;
                                                                        u = a & 255;
                                                                        v = d - 1 >>> 0 < 3;
                                                                        d = 0;
                                                                        while (1) {
                                                                            c = F[n >> 2];
                                                                            a = Hj(k, g, u ? d : F[p + (d << 2) >> 2], 0) + e | 0;
                                                                            l = ta(h, c + a | 0, s);
                                                                            i = 0;
                                                                            a = 0;
                                                                            c = 0;
                                                                            if (!v) {
                                                                                while (1) {
                                                                                    q = (b << 2) + f | 0;
                                                                                    r = a << 2;
                                                                                    F[q >> 2] = F[r + l >> 2];
                                                                                    F[q + 4 >> 2] = F[l + (r | 4) >> 2];
                                                                                    F[q + 8 >> 2] = F[l + (r | 8) >> 2];
                                                                                    F[q + 12 >> 2] = F[l + (r | 12) >> 2];
                                                                                    a = a + 4 | 0;
                                                                                    b = b + 4 | 0;
                                                                                    c = c + 4 | 0;
                                                                                    if ((t | 0) != (c | 0)) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                            }
                                                                            if (o) {
                                                                                while (1) {
                                                                                    F[(b << 2) + f >> 2] = F[l + (a << 2) >> 2];
                                                                                    a = a + 1 | 0;
                                                                                    b = b + 1 | 0;
                                                                                    i = i + 1 | 0;
                                                                                    if ((o | 0) != (i | 0)) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                            }
                                                                            a = 1;
                                                                            d = d + 1 | 0;
                                                                            if ((j | 0) != (d | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        break m;
                                                                    }
                                                                    b = 0;
                                                                    if ((j | 0) != 1) {
                                                                        q = j & -2;
                                                                        l = a & 255;
                                                                        d = 0;
                                                                        while (1) {
                                                                            c = b | 1;
                                                                            o = F[n >> 2];
                                                                            f = Hj(k, g, l ? b : F[p + (b << 2) >> 2], 0) + e | 0;
                                                                            f = ta(h, o + f | 0, s);
                                                                            r = F[n >> 2];
                                                                            if (!l) {
                                                                                c = F[p + (c << 2) >> 2];
                                                                            }
                                                                            c = Hj(k, g, c, 0) + e | 0;
                                                                            ta(f, c + r | 0, s);
                                                                            b = b + 2 | 0;
                                                                            d = d + 2 | 0;
                                                                            if ((q | 0) != (d | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    if (!(j & 1)) {
                                                                        break n;
                                                                    }
                                                                    c = F[n >> 2];
                                                                    if (!(a & 255)) {
                                                                        b = F[p + (b << 2) >> 2];
                                                                    }
                                                                    a = Hj(k, g, b, 0) + e | 0;
                                                                    ta(h, a + c | 0, s);
                                                                    break n;
                                                                }
                                                                if (!d) {
                                                                    b = 0;
                                                                    i = 1;
                                                                    while (1) {
                                                                        if (!fc(c, a & 255 ? b : F[F[c + 68 >> 2] + (b << 2) >> 2], D[c + 24 | 0], h)) {
                                                                            break n;
                                                                        }
                                                                        b = b + 1 | 0;
                                                                        i = j >>> 0 > b >>> 0;
                                                                        if ((b | 0) == (j | 0)) {
                                                                            break n;
                                                                        }
                                                                        a = G[c + 84 | 0];
                                                                        continue;
                                                                    }
                                                                }
                                                                n = d & -4;
                                                                l = d & 3;
                                                                b = 0;
                                                                o = d - 1 >>> 0 < 3;
                                                                i = 1;
                                                                d = 0;
                                                                while (1) {
                                                                    if (!fc(c, a & 255 ? d : F[F[c + 68 >> 2] + (d << 2) >> 2], D[c + 24 | 0], h)) {
                                                                        break n;
                                                                    }
                                                                    e = 0;
                                                                    a = 0;
                                                                    i = 0;
                                                                    if (!o) {
                                                                        while (1) {
                                                                            g = (b << 2) + f | 0;
                                                                            k = a << 2;
                                                                            F[g >> 2] = F[k + h >> 2];
                                                                            F[g + 4 >> 2] = F[(k | 4) + h >> 2];
                                                                            F[g + 8 >> 2] = F[(k | 8) + h >> 2];
                                                                            F[g + 12 >> 2] = F[(k | 12) + h >> 2];
                                                                            a = a + 4 | 0;
                                                                            b = b + 4 | 0;
                                                                            i = i + 4 | 0;
                                                                            if ((n | 0) != (i | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    if (l) {
                                                                        while (1) {
                                                                            F[(b << 2) + f >> 2] = F[(a << 2) + h >> 2];
                                                                            a = a + 1 | 0;
                                                                            b = b + 1 | 0;
                                                                            e = e + 1 | 0;
                                                                            if ((l | 0) != (e | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    d = d + 1 | 0;
                                                                    if ((j | 0) != (d | 0)) {
                                                                        i = d >>> 0 < j >>> 0;
                                                                        a = G[c + 84 | 0];
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                a = d >>> 0 >= j >>> 0;
                                                                break m;
                                                            }
                                                            a = !i;
                                                            if (!h) {
                                                                break l;
                                                            }
                                                        }
                                                        ra(h);
                                                    }
                                                    break b;
                                                case 1:
                                                    a = 0;
                                                    m = ea - 16 | 0;
                                                    ea = m;
                                                    j = F[b + 80 >> 2];
                                                    g = D[c + 24 | 0];
                                                    o: {
                                                        if ((L(j, g) | 0) != (e | 0)) {
                                                            break o;
                                                        }
                                                        b = F[c + 28 >> 2] != 2;
                                                        a = G[c + 84 | 0];
                                                        if (!(b | !a)) {
                                                            ta(f, F[F[c >> 2] >> 2] + F[c + 48 >> 2] | 0, e);
                                                            a = 1;
                                                            break o;
                                                        }
                                                        d = 0;
                                                        F[m + 8 >> 2] = 0;
                                                        F[m >> 2] = 0;
                                                        F[m + 4 >> 2] = 0;
                                                        if (g) {
                                                            if ((g | 0) < 0) {
                                                                break d;
                                                            }
                                                            h = sa(g);
                                                            F[m >> 2] = h;
                                                            ua(h, 0, g);
                                                        }
                                                        p: {
                                                            q: {
                                                                if (!j) {
                                                                    break q;
                                                                }
                                                                if (!b) {
                                                                    if (g) {
                                                                        n = g & -4;
                                                                        l = g & 3;
                                                                        b = 0;
                                                                        o = g - 1 >>> 0 < 3;
                                                                        while (1) {
                                                                            e = F[F[c >> 2] >> 2];
                                                                            p = F[c + 40 >> 2];
                                                                            a = F[c + 48 >> 2] + Hj(p, F[c + 44 >> 2], a & 255 ? d : F[F[c + 68 >> 2] + (d << 2) >> 2], 0) | 0;
                                                                            g = ta(h, e + a | 0, p);
                                                                            e = 0;
                                                                            a = 0;
                                                                            i = 0;
                                                                            if (!o) {
                                                                                while (1) {
                                                                                    k = b + f | 0;
                                                                                    D[k | 0] = G[a + g | 0];
                                                                                    D[k + 1 | 0] = G[g + (a | 1) | 0];
                                                                                    D[k + 2 | 0] = G[g + (a | 2) | 0];
                                                                                    D[k + 3 | 0] = G[g + (a | 3) | 0];
                                                                                    a = a + 4 | 0;
                                                                                    b = b + 4 | 0;
                                                                                    i = i + 4 | 0;
                                                                                    if ((n | 0) != (i | 0)) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                            }
                                                                            if (l) {
                                                                                while (1) {
                                                                                    D[b + f | 0] = G[a + g | 0];
                                                                                    a = a + 1 | 0;
                                                                                    b = b + 1 | 0;
                                                                                    e = e + 1 | 0;
                                                                                    if ((l | 0) != (e | 0)) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                            }
                                                                            a = 1;
                                                                            d = d + 1 | 0;
                                                                            if ((j | 0) == (d | 0)) {
                                                                                break p;
                                                                            }
                                                                            a = G[c + 84 | 0];
                                                                            continue;
                                                                        }
                                                                    }
                                                                    l = F[c >> 2];
                                                                    e = F[c + 48 >> 2];
                                                                    o = F[c + 68 >> 2];
                                                                    f = F[c + 44 >> 2];
                                                                    c = F[c + 40 >> 2];
                                                                    p = c;
                                                                    b = 0;
                                                                    if ((j | 0) != 1) {
                                                                        q = j & -2;
                                                                        s = a & 255;
                                                                        while (1) {
                                                                            g = b | 1;
                                                                            n = F[l >> 2];
                                                                            k = Hj(c, f, s ? b : F[o + (b << 2) >> 2], 0) + e | 0;
                                                                            k = ta(h, n + k | 0, p);
                                                                            r = F[l >> 2];
                                                                            if (!s) {
                                                                                g = F[o + (g << 2) >> 2];
                                                                            }
                                                                            g = Hj(c, f, g, 0) + e | 0;
                                                                            ta(k, g + r | 0, p);
                                                                            b = b + 2 | 0;
                                                                            i = i + 2 | 0;
                                                                            if ((q | 0) != (i | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    if (!(j & 1)) {
                                                                        break q;
                                                                    }
                                                                    i = F[l >> 2];
                                                                    if (!(a & 255)) {
                                                                        b = F[o + (b << 2) >> 2];
                                                                    }
                                                                    a = Hj(c, f, b, 0) + e | 0;
                                                                    ta(h, a + i | 0, p);
                                                                    break q;
                                                                }
                                                                if (!g) {
                                                                    b = 0;
                                                                    d = 1;
                                                                    while (1) {
                                                                        if (!ic(c, a & 255 ? b : F[F[c + 68 >> 2] + (b << 2) >> 2], D[c + 24 | 0], h)) {
                                                                            break q;
                                                                        }
                                                                        b = b + 1 | 0;
                                                                        d = j >>> 0 > b >>> 0;
                                                                        if ((b | 0) == (j | 0)) {
                                                                            break q;
                                                                        }
                                                                        a = G[c + 84 | 0];
                                                                        continue;
                                                                    }
                                                                }
                                                                l = g & -4;
                                                                k = g & 3;
                                                                b = 0;
                                                                n = g - 1 >>> 0 < 3;
                                                                d = 1;
                                                                while (1) {
                                                                    if (!ic(c, a & 255 ? i : F[F[c + 68 >> 2] + (i << 2) >> 2], D[c + 24 | 0], h)) {
                                                                        break q;
                                                                    }
                                                                    d = 0;
                                                                    a = 0;
                                                                    e = 0;
                                                                    if (!n) {
                                                                        while (1) {
                                                                            g = b + f | 0;
                                                                            D[g | 0] = G[a + h | 0];
                                                                            D[g + 1 | 0] = G[(a | 1) + h | 0];
                                                                            D[g + 2 | 0] = G[(a | 2) + h | 0];
                                                                            D[g + 3 | 0] = G[(a | 3) + h | 0];
                                                                            a = a + 4 | 0;
                                                                            b = b + 4 | 0;
                                                                            e = e + 4 | 0;
                                                                            if ((l | 0) != (e | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    if (k) {
                                                                        while (1) {
                                                                            D[b + f | 0] = G[a + h | 0];
                                                                            a = a + 1 | 0;
                                                                            b = b + 1 | 0;
                                                                            d = d + 1 | 0;
                                                                            if ((k | 0) != (d | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    i = i + 1 | 0;
                                                                    if ((j | 0) != (i | 0)) {
                                                                        d = i >>> 0 < j >>> 0;
                                                                        a = G[c + 84 | 0];
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                a = i >>> 0 >= j >>> 0;
                                                                break p;
                                                            }
                                                            a = d ^ 1;
                                                            if (!h) {
                                                                break o;
                                                            }
                                                        }
                                                        ra(h);
                                                    }
                                                    break c;
                                                case 3:
                                                    a = 0;
                                                    m = ea - 16 | 0;
                                                    ea = m;
                                                    d = D[c + 24 | 0];
                                                    g = d << 1;
                                                    j = F[b + 80 >> 2];
                                                    r: {
                                                        if ((L(g, j) | 0) != (e | 0)) {
                                                            break r;
                                                        }
                                                        b = F[c + 28 >> 2] != 4;
                                                        a = G[c + 84 | 0];
                                                        if (!(b | !a)) {
                                                            ta(f, F[F[c >> 2] >> 2] + F[c + 48 >> 2] | 0, e);
                                                            a = 1;
                                                            break r;
                                                        }
                                                        F[m + 8 >> 2] = 0;
                                                        F[m >> 2] = 0;
                                                        F[m + 4 >> 2] = 0;
                                                        if (d) {
                                                            if ((d | 0) < 0) {
                                                                break d;
                                                            }
                                                            h = sa(g);
                                                            F[m >> 2] = h;
                                                            ua(h, 0, d << 1);
                                                        }
                                                        s: {
                                                            t: {
                                                                if (!j) {
                                                                    break t;
                                                                }
                                                                if (!b) {
                                                                    n = F[c >> 2];
                                                                    e = F[c + 48 >> 2];
                                                                    p = F[c + 68 >> 2];
                                                                    g = F[c + 44 >> 2];
                                                                    k = F[c + 40 >> 2];
                                                                    s = k;
                                                                    if (d) {
                                                                        t = d & -4;
                                                                        o = d & 3;
                                                                        b = 0;
                                                                        u = a & 255;
                                                                        v = d - 1 >>> 0 < 3;
                                                                        d = 0;
                                                                        while (1) {
                                                                            c = F[n >> 2];
                                                                            a = Hj(k, g, u ? d : F[p + (d << 2) >> 2], 0) + e | 0;
                                                                            l = ta(h, c + a | 0, s);
                                                                            i = 0;
                                                                            a = 0;
                                                                            c = 0;
                                                                            if (!v) {
                                                                                while (1) {
                                                                                    q = (b << 1) + f | 0;
                                                                                    r = a << 1;
                                                                                    E[q >> 1] = H[r + l >> 1];
                                                                                    E[q + 2 >> 1] = H[l + (r | 2) >> 1];
                                                                                    E[q + 4 >> 1] = H[l + (r | 4) >> 1];
                                                                                    E[q + 6 >> 1] = H[l + (r | 6) >> 1];
                                                                                    a = a + 4 | 0;
                                                                                    b = b + 4 | 0;
                                                                                    c = c + 4 | 0;
                                                                                    if ((t | 0) != (c | 0)) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                            }
                                                                            if (o) {
                                                                                while (1) {
                                                                                    E[(b << 1) + f >> 1] = H[l + (a << 1) >> 1];
                                                                                    a = a + 1 | 0;
                                                                                    b = b + 1 | 0;
                                                                                    i = i + 1 | 0;
                                                                                    if ((o | 0) != (i | 0)) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                            }
                                                                            a = 1;
                                                                            d = d + 1 | 0;
                                                                            if ((j | 0) != (d | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        break s;
                                                                    }
                                                                    b = 0;
                                                                    if ((j | 0) != 1) {
                                                                        q = j & -2;
                                                                        l = a & 255;
                                                                        d = 0;
                                                                        while (1) {
                                                                            c = b | 1;
                                                                            o = F[n >> 2];
                                                                            f = Hj(k, g, l ? b : F[p + (b << 2) >> 2], 0) + e | 0;
                                                                            f = ta(h, o + f | 0, s);
                                                                            r = F[n >> 2];
                                                                            if (!l) {
                                                                                c = F[p + (c << 2) >> 2];
                                                                            }
                                                                            c = Hj(k, g, c, 0) + e | 0;
                                                                            ta(f, c + r | 0, s);
                                                                            b = b + 2 | 0;
                                                                            d = d + 2 | 0;
                                                                            if ((q | 0) != (d | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    if (!(j & 1)) {
                                                                        break t;
                                                                    }
                                                                    c = F[n >> 2];
                                                                    if (!(a & 255)) {
                                                                        b = F[p + (b << 2) >> 2];
                                                                    }
                                                                    a = Hj(k, g, b, 0) + e | 0;
                                                                    ta(h, a + c | 0, s);
                                                                    break t;
                                                                }
                                                                if (!d) {
                                                                    b = 0;
                                                                    i = 1;
                                                                    while (1) {
                                                                        if (!gc(c, a & 255 ? b : F[F[c + 68 >> 2] + (b << 2) >> 2], D[c + 24 | 0], h)) {
                                                                            break t;
                                                                        }
                                                                        b = b + 1 | 0;
                                                                        i = j >>> 0 > b >>> 0;
                                                                        if ((b | 0) == (j | 0)) {
                                                                            break t;
                                                                        }
                                                                        a = G[c + 84 | 0];
                                                                        continue;
                                                                    }
                                                                }
                                                                n = d & -4;
                                                                l = d & 3;
                                                                b = 0;
                                                                o = d - 1 >>> 0 < 3;
                                                                i = 1;
                                                                d = 0;
                                                                while (1) {
                                                                    if (!gc(c, a & 255 ? d : F[F[c + 68 >> 2] + (d << 2) >> 2], D[c + 24 | 0], h)) {
                                                                        break t;
                                                                    }
                                                                    e = 0;
                                                                    a = 0;
                                                                    i = 0;
                                                                    if (!o) {
                                                                        while (1) {
                                                                            g = (b << 1) + f | 0;
                                                                            k = a << 1;
                                                                            E[g >> 1] = H[k + h >> 1];
                                                                            E[g + 2 >> 1] = H[(k | 2) + h >> 1];
                                                                            E[g + 4 >> 1] = H[(k | 4) + h >> 1];
                                                                            E[g + 6 >> 1] = H[(k | 6) + h >> 1];
                                                                            a = a + 4 | 0;
                                                                            b = b + 4 | 0;
                                                                            i = i + 4 | 0;
                                                                            if ((n | 0) != (i | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    if (l) {
                                                                        while (1) {
                                                                            E[(b << 1) + f >> 1] = H[(a << 1) + h >> 1];
                                                                            a = a + 1 | 0;
                                                                            b = b + 1 | 0;
                                                                            e = e + 1 | 0;
                                                                            if ((l | 0) != (e | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    d = d + 1 | 0;
                                                                    if ((j | 0) != (d | 0)) {
                                                                        i = d >>> 0 < j >>> 0;
                                                                        a = G[c + 84 | 0];
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                a = d >>> 0 >= j >>> 0;
                                                                break s;
                                                            }
                                                            a = !i;
                                                            if (!h) {
                                                                break r;
                                                            }
                                                        }
                                                        ra(h);
                                                    }
                                                    break b;
                                                case 5:
                                                    a = 0;
                                                    m = ea - 16 | 0;
                                                    ea = m;
                                                    d = D[c + 24 | 0];
                                                    g = d << 2;
                                                    j = F[b + 80 >> 2];
                                                    u: {
                                                        if ((L(g, j) | 0) != (e | 0)) {
                                                            break u;
                                                        }
                                                        b = F[c + 28 >> 2] != 6;
                                                        a = G[c + 84 | 0];
                                                        if (!(b | !a)) {
                                                            ta(f, F[F[c >> 2] >> 2] + F[c + 48 >> 2] | 0, e);
                                                            a = 1;
                                                            break u;
                                                        }
                                                        F[m + 8 >> 2] = 0;
                                                        F[m >> 2] = 0;
                                                        F[m + 4 >> 2] = 0;
                                                        if (d) {
                                                            if ((d | 0) < 0) {
                                                                break d;
                                                            }
                                                            h = sa(g);
                                                            F[m >> 2] = h;
                                                            ua(h, 0, d << 2);
                                                        }
                                                        v: {
                                                            w: {
                                                                if (!j) {
                                                                    break w;
                                                                }
                                                                if (!b) {
                                                                    n = F[c >> 2];
                                                                    e = F[c + 48 >> 2];
                                                                    p = F[c + 68 >> 2];
                                                                    g = F[c + 44 >> 2];
                                                                    k = F[c + 40 >> 2];
                                                                    s = k;
                                                                    if (d) {
                                                                        t = d & -4;
                                                                        o = d & 3;
                                                                        b = 0;
                                                                        u = a & 255;
                                                                        v = d - 1 >>> 0 < 3;
                                                                        d = 0;
                                                                        while (1) {
                                                                            c = F[n >> 2];
                                                                            a = Hj(k, g, u ? d : F[p + (d << 2) >> 2], 0) + e | 0;
                                                                            l = ta(h, c + a | 0, s);
                                                                            i = 0;
                                                                            a = 0;
                                                                            c = 0;
                                                                            if (!v) {
                                                                                while (1) {
                                                                                    q = (b << 2) + f | 0;
                                                                                    r = a << 2;
                                                                                    F[q >> 2] = F[r + l >> 2];
                                                                                    F[q + 4 >> 2] = F[l + (r | 4) >> 2];
                                                                                    F[q + 8 >> 2] = F[l + (r | 8) >> 2];
                                                                                    F[q + 12 >> 2] = F[l + (r | 12) >> 2];
                                                                                    a = a + 4 | 0;
                                                                                    b = b + 4 | 0;
                                                                                    c = c + 4 | 0;
                                                                                    if ((t | 0) != (c | 0)) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                            }
                                                                            if (o) {
                                                                                while (1) {
                                                                                    F[(b << 2) + f >> 2] = F[l + (a << 2) >> 2];
                                                                                    a = a + 1 | 0;
                                                                                    b = b + 1 | 0;
                                                                                    i = i + 1 | 0;
                                                                                    if ((o | 0) != (i | 0)) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                            }
                                                                            a = 1;
                                                                            d = d + 1 | 0;
                                                                            if ((j | 0) != (d | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        break v;
                                                                    }
                                                                    b = 0;
                                                                    if ((j | 0) != 1) {
                                                                        q = j & -2;
                                                                        l = a & 255;
                                                                        d = 0;
                                                                        while (1) {
                                                                            c = b | 1;
                                                                            o = F[n >> 2];
                                                                            f = Hj(k, g, l ? b : F[p + (b << 2) >> 2], 0) + e | 0;
                                                                            f = ta(h, o + f | 0, s);
                                                                            r = F[n >> 2];
                                                                            if (!l) {
                                                                                c = F[p + (c << 2) >> 2];
                                                                            }
                                                                            c = Hj(k, g, c, 0) + e | 0;
                                                                            ta(f, c + r | 0, s);
                                                                            b = b + 2 | 0;
                                                                            d = d + 2 | 0;
                                                                            if ((q | 0) != (d | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    if (!(j & 1)) {
                                                                        break w;
                                                                    }
                                                                    c = F[n >> 2];
                                                                    if (!(a & 255)) {
                                                                        b = F[p + (b << 2) >> 2];
                                                                    }
                                                                    a = Hj(k, g, b, 0) + e | 0;
                                                                    ta(h, a + c | 0, s);
                                                                    break w;
                                                                }
                                                                if (!d) {
                                                                    b = 0;
                                                                    i = 1;
                                                                    while (1) {
                                                                        if (!ec(c, a & 255 ? b : F[F[c + 68 >> 2] + (b << 2) >> 2], D[c + 24 | 0], h)) {
                                                                            break w;
                                                                        }
                                                                        b = b + 1 | 0;
                                                                        i = j >>> 0 > b >>> 0;
                                                                        if ((b | 0) == (j | 0)) {
                                                                            break w;
                                                                        }
                                                                        a = G[c + 84 | 0];
                                                                        continue;
                                                                    }
                                                                }
                                                                n = d & -4;
                                                                l = d & 3;
                                                                b = 0;
                                                                o = d - 1 >>> 0 < 3;
                                                                i = 1;
                                                                d = 0;
                                                                while (1) {
                                                                    if (!ec(c, a & 255 ? d : F[F[c + 68 >> 2] + (d << 2) >> 2], D[c + 24 | 0], h)) {
                                                                        break w;
                                                                    }
                                                                    e = 0;
                                                                    a = 0;
                                                                    i = 0;
                                                                    if (!o) {
                                                                        while (1) {
                                                                            g = (b << 2) + f | 0;
                                                                            k = a << 2;
                                                                            F[g >> 2] = F[k + h >> 2];
                                                                            F[g + 4 >> 2] = F[(k | 4) + h >> 2];
                                                                            F[g + 8 >> 2] = F[(k | 8) + h >> 2];
                                                                            F[g + 12 >> 2] = F[(k | 12) + h >> 2];
                                                                            a = a + 4 | 0;
                                                                            b = b + 4 | 0;
                                                                            i = i + 4 | 0;
                                                                            if ((n | 0) != (i | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    if (l) {
                                                                        while (1) {
                                                                            F[(b << 2) + f >> 2] = F[(a << 2) + h >> 2];
                                                                            a = a + 1 | 0;
                                                                            b = b + 1 | 0;
                                                                            e = e + 1 | 0;
                                                                            if ((l | 0) != (e | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    d = d + 1 | 0;
                                                                    if ((j | 0) != (d | 0)) {
                                                                        i = d >>> 0 < j >>> 0;
                                                                        a = G[c + 84 | 0];
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                a = d >>> 0 >= j >>> 0;
                                                                break v;
                                                            }
                                                            a = !i;
                                                            if (!h) {
                                                                break u;
                                                            }
                                                        }
                                                        ra(h);
                                                    }
                                                    break b;
                                                case 8: break e;
                                                default: break a;
                                            }
                                        }
                                        a = 0;
                                        j = ea - 16 | 0;
                                        ea = j;
                                        i = D[c + 24 | 0];
                                        d = i << 2;
                                        k = F[b + 80 >> 2];
                                        x: {
                                            if ((L(d, k) | 0) != (e | 0)) {
                                                break x;
                                            }
                                            e = F[c + 28 >> 2];
                                            F[j + 8 >> 2] = 0;
                                            F[j >> 2] = 0;
                                            F[j + 4 >> 2] = 0;
                                            b = 0;
                                            y: {
                                                z: {
                                                    A: {
                                                        B: {
                                                            if (!i) {
                                                                break B;
                                                            }
                                                            if ((i | 0) < 0) {
                                                                break A;
                                                            }
                                                            b = sa(d);
                                                            F[j >> 2] = b;
                                                            g = (i << 2) + b | 0;
                                                            F[j + 8 >> 2] = g;
                                                            d = d - 4 | 0;
                                                            m = (d >>> 2 | 0) + 1 & 7;
                                                            C: {
                                                                if (!m) {
                                                                    a = b;
                                                                    break C;
                                                                }
                                                                a = b;
                                                                while (1) {
                                                                    F[a >> 2] = -1073741824;
                                                                    a = a + 4 | 0;
                                                                    h = h + 1 | 0;
                                                                    if ((m | 0) != (h | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            if (d >>> 0 < 28) {
                                                                break B;
                                                            }
                                                            while (1) {
                                                                F[a + 24 >> 2] = -1073741824;
                                                                F[a + 28 >> 2] = -1073741824;
                                                                F[a + 16 >> 2] = -1073741824;
                                                                F[a + 20 >> 2] = -1073741824;
                                                                F[a + 8 >> 2] = -1073741824;
                                                                F[a + 12 >> 2] = -1073741824;
                                                                F[a >> 2] = -1073741824;
                                                                F[a + 4 >> 2] = -1073741824;
                                                                a = a + 32 | 0;
                                                                if ((g | 0) != (a | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                        }
                                                        if (!k) {
                                                            break z;
                                                        }
                                                        if ((e | 0) == 9) {
                                                            a = 0;
                                                            n = F[c >> 2];
                                                            d = F[c + 48 >> 2];
                                                            p = F[c + 68 >> 2];
                                                            s = G[c + 84 | 0];
                                                            e = F[c + 44 >> 2];
                                                            g = F[c + 40 >> 2];
                                                            q = g;
                                                            if ((i | 0) <= 0) {
                                                                if ((k | 0) != 1) {
                                                                    i = k & -2;
                                                                    c = 0;
                                                                    while (1) {
                                                                        f = a | 1;
                                                                        m = F[n >> 2];
                                                                        h = Hj(g, e, s ? a : F[p + (a << 2) >> 2], 0) + d | 0;
                                                                        h = ta(b, m + h | 0, q);
                                                                        m = F[n >> 2];
                                                                        if (!s) {
                                                                            f = F[p + (f << 2) >> 2];
                                                                        }
                                                                        f = Hj(g, e, f, 0) + d | 0;
                                                                        ta(h, f + m | 0, q);
                                                                        a = a + 2 | 0;
                                                                        c = c + 2 | 0;
                                                                        if ((i | 0) != (c | 0)) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                }
                                                                if (!(k & 1)) {
                                                                    break z;
                                                                }
                                                                c = F[n >> 2];
                                                                if (!s) {
                                                                    a = F[p + (a << 2) >> 2];
                                                                }
                                                                a = Hj(g, e, a, 0) + d | 0;
                                                                ta(b, a + c | 0, q);
                                                                break z;
                                                            }
                                                            u = i & -4;
                                                            o = i & 3;
                                                            h = 0;
                                                            v = i - 1 >>> 0 < 3;
                                                            i = 0;
                                                            while (1) {
                                                                c = F[n >> 2];
                                                                a = Hj(g, e, s ? i : F[p + (i << 2) >> 2], 0) + d | 0;
                                                                c = ta(b, c + a | 0, q);
                                                                m = 0;
                                                                a = 0;
                                                                t = 0;
                                                                if (!v) {
                                                                    while (1) {
                                                                        l = (h << 2) + f | 0;
                                                                        r = a << 2;
                                                                        J[l >> 2] = J[r + c >> 2];
                                                                        J[l + 4 >> 2] = J[c + (r | 4) >> 2];
                                                                        J[l + 8 >> 2] = J[c + (r | 8) >> 2];
                                                                        J[l + 12 >> 2] = J[c + (r | 12) >> 2];
                                                                        a = a + 4 | 0;
                                                                        h = h + 4 | 0;
                                                                        t = t + 4 | 0;
                                                                        if ((u | 0) != (t | 0)) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                }
                                                                if (o) {
                                                                    while (1) {
                                                                        J[(h << 2) + f >> 2] = J[c + (a << 2) >> 2];
                                                                        a = a + 1 | 0;
                                                                        h = h + 1 | 0;
                                                                        m = m + 1 | 0;
                                                                        if ((o | 0) != (m | 0)) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                }
                                                                a = 1;
                                                                i = i + 1 | 0;
                                                                if ((k | 0) != (i | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                            break y;
                                                        }
                                                        l = 1;
                                                        if ((i | 0) <= 0) {
                                                            a = 0;
                                                            while (1) {
                                                                if (!Ya(c, G[c + 84 | 0] ? a : F[F[c + 68 >> 2] + (a << 2) >> 2], D[c + 24 | 0], b)) {
                                                                    break z;
                                                                }
                                                                a = a + 1 | 0;
                                                                l = k >>> 0 > a >>> 0;
                                                                if ((a | 0) != (k | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                            break z;
                                                        }
                                                        n = i & -4;
                                                        g = i & 3;
                                                        h = 0;
                                                        o = i - 1 >>> 0 < 3;
                                                        i = 0;
                                                        while (1) {
                                                            if (!Ya(c, G[c + 84 | 0] ? i : F[F[c + 68 >> 2] + (i << 2) >> 2], D[c + 24 | 0], b)) {
                                                                break z;
                                                            }
                                                            l = 0;
                                                            a = 0;
                                                            m = 0;
                                                            if (!o) {
                                                                while (1) {
                                                                    d = (h << 2) + f | 0;
                                                                    e = a << 2;
                                                                    J[d >> 2] = J[e + b >> 2];
                                                                    J[d + 4 >> 2] = J[(e | 4) + b >> 2];
                                                                    J[d + 8 >> 2] = J[(e | 8) + b >> 2];
                                                                    J[d + 12 >> 2] = J[(e | 12) + b >> 2];
                                                                    a = a + 4 | 0;
                                                                    h = h + 4 | 0;
                                                                    m = m + 4 | 0;
                                                                    if ((n | 0) != (m | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            if (g) {
                                                                while (1) {
                                                                    J[(h << 2) + f >> 2] = J[(a << 2) + b >> 2];
                                                                    a = a + 1 | 0;
                                                                    h = h + 1 | 0;
                                                                    l = l + 1 | 0;
                                                                    if ((g | 0) != (l | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            i = i + 1 | 0;
                                                            l = k >>> 0 > i >>> 0;
                                                            if ((i | 0) != (k | 0)) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        a = i >>> 0 >= k >>> 0;
                                                        break y;
                                                    }
                                                    va();
                                                    V();
                                                }
                                                a = l ^ 1;
                                                if (!b) {
                                                    break x;
                                                }
                                            }
                                            ra(b);
                                        }
                                        ea = j + 16 | 0;
                                        h = a & 1;
                                        break a;
                                    }
                                    va();
                                    V();
                                }
                                ea = m + 16 | 0;
                                h = a & 1;
                                break a;
                            }
                            ea = m + 16 | 0;
                            h = a & 1;
                        } return h | 0; }
                        function wg(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, E = 0, H = 0, I = 0, J = 0, K = 0, M = 0, N = 0; z = c; c = 0; m = ea - 96 | 0; ea = m; k = m + 16 | 0; ua(k, 0, 76); F[m + 92 >> 2] = -1; F[m + 8 >> 2] = 0; F[m >> 2] = 0; F[m + 4 >> 2] = 0; s = ea - 16 | 0; ea = s; F[k + 68 >> 2] = 0; F[k + 72 >> 2] = 0; F[k >> 2] = b; t = ea - 16 | 0; ea = t; x = b; a = F[b + 20 >> 2]; a: {
                            if ((F[b + 24 >> 2] - a | 0) <= 0) {
                                break a;
                            }
                            a = F[a >> 2];
                            if ((a | 0) == -1) {
                                break a;
                            }
                            c = F[F[x + 8 >> 2] + (a << 2) >> 2];
                        } b: {
                            c: {
                                d: {
                                    e: {
                                        if (!c) {
                                            a = 0;
                                            break e;
                                        }
                                        a = F[x + 100 >> 2];
                                        e = F[x + 96 >> 2];
                                        F[t + 8 >> 2] = 0;
                                        F[t >> 2] = 0;
                                        F[t + 4 >> 2] = 0;
                                        d = a - e | 0;
                                        b = (d | 0) / 12 | 0;
                                        f: {
                                            if (!d) {
                                                break f;
                                            }
                                            if (b >>> 0 >= 357913942) {
                                                break c;
                                            }
                                            f = sa(d);
                                            F[t >> 2] = f;
                                            F[t + 8 >> 2] = f + L(b, 12);
                                            a = 0;
                                            g = f;
                                            f = L((d - 12 >>> 0) / 12 | 0, 12) + 12 | 0;
                                            d = ua(g, 0, f);
                                            F[t + 4 >> 2] = d + f;
                                            if (G[c + 84 | 0]) {
                                                c = b >>> 0 > 1 ? b : 1;
                                                g = c & 1;
                                                if (b >>> 0 >= 2) {
                                                    j = c & -2;
                                                    c = 0;
                                                    while (1) {
                                                        f = L(a, 12);
                                                        b = f + e | 0;
                                                        n = F[b + 4 >> 2];
                                                        o = F[b >> 2];
                                                        f = d + f | 0;
                                                        F[f + 8 >> 2] = F[b + 8 >> 2];
                                                        F[f >> 2] = o;
                                                        F[f + 4 >> 2] = n;
                                                        f = L(a | 1, 12);
                                                        b = f + e | 0;
                                                        n = F[b + 8 >> 2];
                                                        o = F[b + 4 >> 2];
                                                        f = d + f | 0;
                                                        F[f >> 2] = F[b >> 2];
                                                        F[f + 4 >> 2] = o;
                                                        F[f + 8 >> 2] = n;
                                                        a = a + 2 | 0;
                                                        c = c + 2 | 0;
                                                        if ((j | 0) != (c | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if (!g) {
                                                    break f;
                                                }
                                                b = L(a, 12);
                                                a = b + e | 0;
                                                c = F[a + 4 >> 2];
                                                e = F[a >> 2];
                                                b = b + d | 0;
                                                F[b + 8 >> 2] = F[a + 8 >> 2];
                                                F[b >> 2] = e;
                                                F[b + 4 >> 2] = c;
                                                break f;
                                            }
                                            g = b >>> 0 > 1 ? b : 1;
                                            a = F[c + 68 >> 2];
                                            c = 0;
                                            while (1) {
                                                f = L(c, 12);
                                                b = f + e | 0;
                                                j = F[a + (F[b >> 2] << 2) >> 2];
                                                n = F[a + (F[b + 4 >> 2] << 2) >> 2];
                                                f = d + f | 0;
                                                F[f + 8 >> 2] = F[a + (F[b + 8 >> 2] << 2) >> 2];
                                                F[f + 4 >> 2] = n;
                                                F[f >> 2] = j;
                                                c = c + 1 | 0;
                                                if ((g | 0) != (c | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        C = ea - 16 | 0;
                                        ea = C;
                                        g = sa(88);
                                        F[g >> 2] = 0;
                                        F[g + 4 >> 2] = 0;
                                        F[g + 56 >> 2] = 0;
                                        F[g + 48 >> 2] = 0;
                                        F[g + 52 >> 2] = 0;
                                        F[g + 40 >> 2] = 0;
                                        F[g + 44 >> 2] = 0;
                                        F[g + 32 >> 2] = 0;
                                        F[g + 36 >> 2] = 0;
                                        F[g + 24 >> 2] = 0;
                                        F[g + 28 >> 2] = 0;
                                        F[g + 16 >> 2] = 0;
                                        F[g + 20 >> 2] = 0;
                                        F[g + 8 >> 2] = 0;
                                        F[g + 12 >> 2] = 0;
                                        a = g - -64 | 0;
                                        F[a >> 2] = 0;
                                        F[a + 4 >> 2] = 0;
                                        F[g + 72 >> 2] = 0;
                                        F[g + 76 >> 2] = 0;
                                        F[g + 80 >> 2] = 0;
                                        F[g + 84 >> 2] = 0;
                                        F[g + 60 >> 2] = g;
                                        A = ea - 16 | 0;
                                        ea = A;
                                        F[g + 80 >> 2] = 0;
                                        F[g + 84 >> 2] = 0;
                                        a = F[g + 76 >> 2];
                                        F[g + 76 >> 2] = 0;
                                        if (a) {
                                            ra(a);
                                        }
                                        F[g + 68 >> 2] = 0;
                                        F[g + 72 >> 2] = 0;
                                        b = g - -64 | 0;
                                        a = F[b >> 2];
                                        F[b >> 2] = 0;
                                        if (a) {
                                            ra(a);
                                        }
                                        b = F[t >> 2];
                                        c = F[t + 4 >> 2] - b | 0;
                                        j = (c | 0) / 12 | 0;
                                        a = L(j, 3);
                                        d = F[g >> 2];
                                        e = F[g + 4 >> 2] - d >> 2;
                                        g: {
                                            if (a >>> 0 > e >>> 0) {
                                                Aa(g, a - e | 0);
                                                b = F[t >> 2];
                                                c = F[t + 4 >> 2] - b | 0;
                                                j = (c | 0) / 12 | 0;
                                                d = F[g >> 2];
                                                break g;
                                            }
                                            if (a >>> 0 >= e >>> 0) {
                                                break g;
                                            }
                                            F[g + 4 >> 2] = (a << 2) + d;
                                        }
                                        if (c) {
                                            f = j >>> 0 > 1 ? j : 1;
                                            a = 0;
                                            while (1) {
                                                e = L(a, 12);
                                                c = e + d | 0;
                                                e = b + e | 0;
                                                F[c >> 2] = F[e >> 2];
                                                F[c + 4 >> 2] = F[e + 4 >> 2];
                                                F[c + 8 >> 2] = F[e + 8 >> 2];
                                                a = a + 1 | 0;
                                                if ((f | 0) != (a | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        F[A + 12 >> 2] = -1;
                                        f = ea - 48 | 0;
                                        ea = f;
                                        h: {
                                            i: {
                                                w = A + 12 | 0;
                                                j: {
                                                    if (!w) {
                                                        break j;
                                                    }
                                                    d = F[g + 4 >> 2];
                                                    n = F[g >> 2];
                                                    c = d - n | 0;
                                                    o = c >> 2;
                                                    b = F[g + 12 >> 2];
                                                    a = F[g + 16 >> 2] - b >> 2;
                                                    k: {
                                                        if (o >>> 0 > a >>> 0) {
                                                            Ia(g + 12 | 0, o - a | 0, 13684);
                                                            d = F[g + 4 >> 2];
                                                            n = F[g >> 2];
                                                            c = d - n | 0;
                                                            o = c >> 2;
                                                            break k;
                                                        }
                                                        if (a >>> 0 <= o >>> 0) {
                                                            break k;
                                                        }
                                                        F[g + 16 >> 2] = b + (o << 2);
                                                    }
                                                    b = 0;
                                                    F[f + 40 >> 2] = 0;
                                                    F[f + 32 >> 2] = 0;
                                                    F[f + 36 >> 2] = 0;
                                                    l: {
                                                        if (!c) {
                                                            F[f + 24 >> 2] = 0;
                                                            F[f + 16 >> 2] = 0;
                                                            F[f + 20 >> 2] = 0;
                                                            break l;
                                                        }
                                                        m: {
                                                            if ((c | 0) >= 0) {
                                                                b = sa(c);
                                                                F[f + 36 >> 2] = b;
                                                                F[f + 32 >> 2] = b;
                                                                F[f + 40 >> 2] = (o << 2) + b;
                                                                a = b;
                                                                c = 0;
                                                                while (1) {
                                                                    j = F[(c << 2) + n >> 2];
                                                                    a = a - b >> 2;
                                                                    n: {
                                                                        if (j >>> 0 < a >>> 0) {
                                                                            break n;
                                                                        }
                                                                        F[f + 16 >> 2] = 0;
                                                                        e = j + 1 | 0;
                                                                        if (e >>> 0 > a >>> 0) {
                                                                            Ia(f + 32 | 0, e - a | 0, f + 16 | 0);
                                                                            n = F[g >> 2];
                                                                            d = F[g + 4 >> 2];
                                                                            b = F[f + 32 >> 2];
                                                                            break n;
                                                                        }
                                                                        if (a >>> 0 <= e >>> 0) {
                                                                            break n;
                                                                        }
                                                                        F[f + 36 >> 2] = (e << 2) + b;
                                                                    }
                                                                    a = (j << 2) + b | 0;
                                                                    F[a >> 2] = F[a >> 2] + 1;
                                                                    c = c + 1 | 0;
                                                                    a = d - n | 0;
                                                                    o = a >> 2;
                                                                    if (c >>> 0 >= o >>> 0) {
                                                                        break m;
                                                                    }
                                                                    a = F[f + 36 >> 2];
                                                                    continue;
                                                                }
                                                            }
                                                            break i;
                                                        }
                                                        F[f + 24 >> 2] = 0;
                                                        F[f + 16 >> 2] = 0;
                                                        F[f + 20 >> 2] = 0;
                                                        if (!a) {
                                                            break l;
                                                        }
                                                        if (a >>> 0 >= 2147483645) {
                                                            break c;
                                                        }
                                                        c = a << 1;
                                                        a = sa(c);
                                                        F[f + 16 >> 2] = a;
                                                        e = a + (o << 3) | 0;
                                                        F[f + 24 >> 2] = e;
                                                        ua(a, 255, c);
                                                        F[f + 20 >> 2] = e;
                                                    }
                                                    d = 0;
                                                    F[f + 8 >> 2] = 0;
                                                    F[f >> 2] = 0;
                                                    F[f + 4 >> 2] = 0;
                                                    a = F[f + 36 >> 2] - b | 0;
                                                    j = a >> 2;
                                                    o: {
                                                        if (!a) {
                                                            break o;
                                                        }
                                                        if ((a | 0) < 0) {
                                                            break c;
                                                        }
                                                        l = sa(a);
                                                        F[f >> 2] = l;
                                                        a = j << 2;
                                                        c = a + l | 0;
                                                        F[f + 8 >> 2] = c;
                                                        a = ua(l, 0, a);
                                                        F[f + 4 >> 2] = c;
                                                        e = j >>> 0 > 1 ? j : 1;
                                                        q = e & 3;
                                                        c = 0;
                                                        if (e - 1 >>> 0 >= 3) {
                                                            r = e & -4;
                                                            while (1) {
                                                                e = i << 2;
                                                                F[e + a >> 2] = c;
                                                                y = e | 4;
                                                                c = F[b + e >> 2] + c | 0;
                                                                F[y + a >> 2] = c;
                                                                v = e | 8;
                                                                c = c + F[b + y >> 2] | 0;
                                                                F[v + a >> 2] = c;
                                                                e = e | 12;
                                                                c = c + F[b + v >> 2] | 0;
                                                                F[e + a >> 2] = c;
                                                                c = c + F[b + e >> 2] | 0;
                                                                i = i + 4 | 0;
                                                                h = h + 4 | 0;
                                                                if ((r | 0) != (h | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                        }
                                                        if (!q) {
                                                            break o;
                                                        }
                                                        while (1) {
                                                            e = i << 2;
                                                            F[e + a >> 2] = c;
                                                            i = i + 1 | 0;
                                                            c = F[b + e >> 2] + c | 0;
                                                            p = p + 1 | 0;
                                                            if ((q | 0) != (p | 0)) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    if (o) {
                                                        y = F[g + 12 >> 2];
                                                        while (1) {
                                                            E = d << 2;
                                                            c = E + n | 0;
                                                            h = -1;
                                                            e = d + 1 | 0;
                                                            a = (e >>> 0) % 3 | 0 ? e : d - 2 | 0;
                                                            if ((a | 0) != -1) {
                                                                h = F[(a << 2) + n >> 2];
                                                            }
                                                            a = F[c >> 2];
                                                            p: {
                                                                q: {
                                                                    if (!((d >>> 0) % 3 | 0)) {
                                                                        p = -1;
                                                                        c = d + 2 | 0;
                                                                        if ((c | 0) != -1) {
                                                                            p = F[(c << 2) + n >> 2];
                                                                        }
                                                                        if (!((a | 0) == (h | 0) | (a | 0) == (p | 0)) & (h | 0) != (p | 0)) {
                                                                            break q;
                                                                        }
                                                                        F[g + 40 >> 2] = F[g + 40 >> 2] + 1;
                                                                        e = d + 3 | 0;
                                                                        break p;
                                                                    }
                                                                    p = F[c - 4 >> 2];
                                                                }
                                                                c = p << 2;
                                                                v = F[c + b >> 2];
                                                                r: {
                                                                    s: {
                                                                        if ((v | 0) <= 0) {
                                                                            break s;
                                                                        }
                                                                        q = F[f + 16 >> 2];
                                                                        c = F[c + l >> 2];
                                                                        i = 0;
                                                                        while (1) {
                                                                            r = q + (c << 3) | 0;
                                                                            u = F[r >> 2];
                                                                            if ((u | 0) == -1) {
                                                                                break s;
                                                                            }
                                                                            t: {
                                                                                if ((h | 0) != (u | 0)) {
                                                                                    break t;
                                                                                }
                                                                                r = F[r + 4 >> 2];
                                                                                if ((r | 0) != -1) {
                                                                                    u = F[(r << 2) + n >> 2];
                                                                                }
                                                                                else {
                                                                                    u = -1;
                                                                                }
                                                                                if ((u | 0) == (a | 0)) {
                                                                                    break t;
                                                                                }
                                                                                while (1) {
                                                                                    u: {
                                                                                        a = c;
                                                                                        i = i + 1 | 0;
                                                                                        if ((v | 0) <= (i | 0)) {
                                                                                            break u;
                                                                                        }
                                                                                        u = q + (a << 3) | 0;
                                                                                        c = a + 1 | 0;
                                                                                        H = q + (c << 3) | 0;
                                                                                        I = F[H >> 2];
                                                                                        F[u >> 2] = I;
                                                                                        F[u + 4 >> 2] = F[H + 4 >> 2];
                                                                                        if ((I | 0) != -1) {
                                                                                            continue;
                                                                                        }
                                                                                    }
                                                                                    break;
                                                                                }
                                                                                F[q + (a << 3) >> 2] = -1;
                                                                                if ((r | 0) == -1) {
                                                                                    break s;
                                                                                }
                                                                                F[y + E >> 2] = r;
                                                                                F[y + (r << 2) >> 2] = d;
                                                                                break r;
                                                                            }
                                                                            c = c + 1 | 0;
                                                                            i = i + 1 | 0;
                                                                            if ((v | 0) != (i | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    a = h << 2;
                                                                    h = F[a + b >> 2];
                                                                    if ((h | 0) <= 0) {
                                                                        break r;
                                                                    }
                                                                    q = F[f + 16 >> 2];
                                                                    c = F[a + l >> 2];
                                                                    i = 0;
                                                                    while (1) {
                                                                        a = q + (c << 3) | 0;
                                                                        if (F[a >> 2] == -1) {
                                                                            F[a >> 2] = p;
                                                                            F[a + 4 >> 2] = d;
                                                                            break r;
                                                                        }
                                                                        c = c + 1 | 0;
                                                                        i = i + 1 | 0;
                                                                        if ((h | 0) != (i | 0)) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                }
                                                            }
                                                            d = e;
                                                            if (o >>> 0 > d >>> 0) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    F[w >> 2] = j;
                                                    if (l) {
                                                        ra(l);
                                                    }
                                                    a = F[f + 16 >> 2];
                                                    if (a) {
                                                        F[f + 20 >> 2] = a;
                                                        ra(a);
                                                    }
                                                    a = F[f + 32 >> 2];
                                                    if (!a) {
                                                        break j;
                                                    }
                                                    F[f + 36 >> 2] = a;
                                                    ra(a);
                                                }
                                                ea = f + 48 | 0;
                                                y = (w | 0) != 0;
                                                if (y) {
                                                    h = ea - 32 | 0;
                                                    ea = h;
                                                    o = F[g >> 2];
                                                    a = F[g + 4 >> 2];
                                                    F[h + 24 >> 2] = 0;
                                                    F[h + 16 >> 2] = 0;
                                                    F[h + 20 >> 2] = 0;
                                                    v: {
                                                        w: {
                                                            b = a - o | 0;
                                                            x: {
                                                                if (!b) {
                                                                    break x;
                                                                }
                                                                if ((b | 0) < 0) {
                                                                    break w;
                                                                }
                                                                c = b >> 2;
                                                                d = c - 1 >>> 5 | 0;
                                                                f = d + 1 | 0;
                                                                e = sa(f << 2);
                                                                F[h + 24 >> 2] = f;
                                                                F[h + 16 >> 2] = e;
                                                                F[h + 20 >> 2] = c;
                                                                F[e + ((b >>> 0 < 132 ? 0 : d) << 2) >> 2] = 0;
                                                                b = c >>> 5 << 2;
                                                                e = ua(e, 0, b);
                                                                c = c & 31;
                                                                if (!c) {
                                                                    break x;
                                                                }
                                                                b = b + e | 0;
                                                                F[b >> 2] = F[b >> 2] & (-1 >>> 32 - c ^ -1);
                                                            }
                                                            F[h + 8 >> 2] = 0;
                                                            F[h >> 2] = 0;
                                                            while (1) {
                                                                y: {
                                                                    q = 0;
                                                                    b = 0;
                                                                    if ((a | 0) == (o | 0)) {
                                                                        break y;
                                                                    }
                                                                    while (1) {
                                                                        d = F[h + 16 >> 2];
                                                                        z: {
                                                                            if (F[d + (b >>> 3 & 536870908) >> 2] >>> b & 1) {
                                                                                break z;
                                                                            }
                                                                            e = F[h >> 2];
                                                                            F[h + 4 >> 2] = e;
                                                                            c = F[g + 12 >> 2];
                                                                            a = b;
                                                                            while (1) {
                                                                                A: {
                                                                                    f = a + 1 | 0;
                                                                                    i = a;
                                                                                    a = (f >>> 0) % 3 | 0 ? f : a - 2 | 0;
                                                                                    if ((a | 0) == -1) {
                                                                                        break A;
                                                                                    }
                                                                                    a = F[c + (a << 2) >> 2];
                                                                                    if ((a | 0) == -1) {
                                                                                        break A;
                                                                                    }
                                                                                    f = a + 1 | 0;
                                                                                    a = (f >>> 0) % 3 | 0 ? f : a - 2 | 0;
                                                                                    if ((b | 0) == (a | 0) | (a | 0) == -1) {
                                                                                        break A;
                                                                                    }
                                                                                    if (!(F[(a >>> 3 & 536870908) + d >> 2] >>> a & 1)) {
                                                                                        continue;
                                                                                    }
                                                                                }
                                                                                break;
                                                                            }
                                                                            c = e;
                                                                            j = i;
                                                                            B: {
                                                                                C: {
                                                                                    while (1) {
                                                                                        a = (j >>> 3 & 536870908) + d | 0;
                                                                                        F[a >> 2] = F[a >> 2] | 1 << j;
                                                                                        a = j + 1 | 0;
                                                                                        f = (a >>> 0) % 3 | 0 ? a : j - 2 | 0;
                                                                                        v = (j >>> 0) % 3 | 0;
                                                                                        n = (v ? -1 : 2) + j | 0;
                                                                                        r = n << 2;
                                                                                        D: {
                                                                                            if ((c | 0) == (e | 0)) {
                                                                                                break D;
                                                                                            }
                                                                                            w = F[(f << 2) + o >> 2];
                                                                                            l = F[g + 12 >> 2];
                                                                                            a = c;
                                                                                            if ((n | 0) != -1) {
                                                                                                u = l + r | 0;
                                                                                                while (1) {
                                                                                                    E: {
                                                                                                        if ((w | 0) != F[a >> 2]) {
                                                                                                            break E;
                                                                                                        }
                                                                                                        d = F[a + 4 >> 2];
                                                                                                        p = F[u >> 2];
                                                                                                        if ((d | 0) == (p | 0)) {
                                                                                                            break E;
                                                                                                        }
                                                                                                        e = -1;
                                                                                                        a = -1;
                                                                                                        if ((d | 0) == -1) {
                                                                                                            break B;
                                                                                                        }
                                                                                                        break C;
                                                                                                    }
                                                                                                    a = a + 8 | 0;
                                                                                                    if ((e | 0) != (a | 0)) {
                                                                                                        continue;
                                                                                                    }
                                                                                                    break;
                                                                                                }
                                                                                                break D;
                                                                                            }
                                                                                            while (1) {
                                                                                                if ((w | 0) == F[a >> 2]) {
                                                                                                    p = -1;
                                                                                                    n = -1;
                                                                                                    d = F[a + 4 >> 2];
                                                                                                    if ((d | 0) != -1) {
                                                                                                        break C;
                                                                                                    }
                                                                                                }
                                                                                                a = a + 8 | 0;
                                                                                                if ((e | 0) != (a | 0)) {
                                                                                                    continue;
                                                                                                }
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        n = F[o + r >> 2];
                                                                                        F: {
                                                                                            if (F[h + 8 >> 2] != (e | 0)) {
                                                                                                F[e >> 2] = n;
                                                                                                F[e + 4 >> 2] = f;
                                                                                                e = e + 8 | 0;
                                                                                                F[h + 4 >> 2] = e;
                                                                                                break F;
                                                                                            }
                                                                                            d = e - c | 0;
                                                                                            e = d >> 3;
                                                                                            a = e + 1 | 0;
                                                                                            if (a >>> 0 >= 536870912) {
                                                                                                break c;
                                                                                            }
                                                                                            l = d >> 2;
                                                                                            l = d >>> 0 < 2147483640 ? a >>> 0 > l >>> 0 ? a : l : 536870911;
                                                                                            if (l) {
                                                                                                if (l >>> 0 >= 536870912) {
                                                                                                    break i;
                                                                                                }
                                                                                                a = sa(l << 3);
                                                                                            }
                                                                                            else {
                                                                                                a = 0;
                                                                                            }
                                                                                            e = a + (e << 3) | 0;
                                                                                            F[e >> 2] = n;
                                                                                            F[e + 4 >> 2] = f;
                                                                                            e = e + 8 | 0;
                                                                                            if ((d | 0) > 0) {
                                                                                                ta(a, c, d);
                                                                                            }
                                                                                            F[h + 8 >> 2] = a + (l << 3);
                                                                                            F[h + 4 >> 2] = e;
                                                                                            F[h >> 2] = a;
                                                                                            if (!c) {
                                                                                                break F;
                                                                                            }
                                                                                            ra(c);
                                                                                        }
                                                                                        G: {
                                                                                            H: {
                                                                                                if (v) {
                                                                                                    a = j - 1 | 0;
                                                                                                    break H;
                                                                                                }
                                                                                                a = j + 2 | 0;
                                                                                                if ((a | 0) == -1) {
                                                                                                    break G;
                                                                                                }
                                                                                            }
                                                                                            a = F[F[g + 12 >> 2] + (a << 2) >> 2];
                                                                                            if ((a | 0) == -1) {
                                                                                                break G;
                                                                                            }
                                                                                            j = a + ((a >>> 0) % 3 | 0 ? -1 : 2) | 0;
                                                                                            if ((i | 0) == (j | 0) | (j | 0) == -1) {
                                                                                                break G;
                                                                                            }
                                                                                            o = F[g >> 2];
                                                                                            c = F[h >> 2];
                                                                                            d = F[h + 16 >> 2];
                                                                                            continue;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    o = F[g >> 2];
                                                                                    break z;
                                                                                }
                                                                                e = d;
                                                                                a = F[l + (e << 2) >> 2];
                                                                            }
                                                                            if ((p | 0) != -1) {
                                                                                F[l + (p << 2) >> 2] = -1;
                                                                            }
                                                                            if ((a | 0) != -1) {
                                                                                F[F[g + 12 >> 2] + (a << 2) >> 2] = -1;
                                                                            }
                                                                            a = F[g + 12 >> 2];
                                                                            F[a + (n << 2) >> 2] = -1;
                                                                            F[a + (e << 2) >> 2] = -1;
                                                                            q = 1;
                                                                        }
                                                                        b = b + 1 | 0;
                                                                        a = F[g + 4 >> 2];
                                                                        if (b >>> 0 < a - o >> 2 >>> 0) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    if (q) {
                                                                        continue;
                                                                    }
                                                                }
                                                                break;
                                                            }
                                                            a = F[h >> 2];
                                                            if (a) {
                                                                ra(a);
                                                            }
                                                            a = F[h + 16 >> 2];
                                                            if (a) {
                                                                ra(a);
                                                            }
                                                            ea = h + 32 | 0;
                                                            break v;
                                                        }
                                                        Oa();
                                                        V();
                                                    }
                                                    n = 0;
                                                    i = ea - 32 | 0;
                                                    ea = i;
                                                    a = F[A + 12 >> 2];
                                                    F[g + 36 >> 2] = a;
                                                    o = g + 24 | 0;
                                                    I: {
                                                        J: {
                                                            K: {
                                                                L: {
                                                                    M: {
                                                                        c = F[g + 24 >> 2];
                                                                        b = F[g + 28 >> 2] - c >> 2;
                                                                        N: {
                                                                            O: {
                                                                                if (b >>> 0 < a >>> 0) {
                                                                                    Ia(o, a - b | 0, 13684);
                                                                                    F[i + 24 >> 2] = 0;
                                                                                    F[i + 16 >> 2] = 0;
                                                                                    F[i + 20 >> 2] = 0;
                                                                                    break O;
                                                                                }
                                                                                if (a >>> 0 < b >>> 0) {
                                                                                    F[g + 28 >> 2] = c + (a << 2);
                                                                                }
                                                                                b = 0;
                                                                                F[i + 24 >> 2] = 0;
                                                                                F[i + 16 >> 2] = 0;
                                                                                F[i + 20 >> 2] = 0;
                                                                                if (!a) {
                                                                                    break N;
                                                                                }
                                                                            }
                                                                            if ((a | 0) < 0) {
                                                                                break M;
                                                                            }
                                                                            c = a - 1 >>> 5 | 0;
                                                                            e = c + 1 | 0;
                                                                            b = sa(e << 2);
                                                                            F[i + 24 >> 2] = e;
                                                                            F[i + 16 >> 2] = b;
                                                                            F[i + 20 >> 2] = a;
                                                                            F[((a >>> 0 < 33 ? 0 : c) << 2) + b >> 2] = 0;
                                                                            c = a >>> 5 << 2;
                                                                            e = ua(b, 0, c);
                                                                            d = a & 31;
                                                                            if (!d) {
                                                                                break N;
                                                                            }
                                                                            c = c + e | 0;
                                                                            F[c >> 2] = F[c >> 2] & (-1 >>> 32 - d ^ -1);
                                                                        }
                                                                        l = F[g >> 2];
                                                                        j = F[g + 4 >> 2];
                                                                        F[i + 8 >> 2] = 0;
                                                                        F[i >> 2] = 0;
                                                                        F[i + 4 >> 2] = 0;
                                                                        c = j - l | 0;
                                                                        if (!c) {
                                                                            break I;
                                                                        }
                                                                        if ((c | 0) < 0) {
                                                                            break L;
                                                                        }
                                                                        e = c >> 2;
                                                                        d = e - 1 >>> 5 | 0;
                                                                        f = d + 1 | 0;
                                                                        h = sa(f << 2);
                                                                        F[i + 8 >> 2] = f;
                                                                        F[i >> 2] = h;
                                                                        F[i + 4 >> 2] = e;
                                                                        p = 0;
                                                                        F[((c >>> 0 < 132 ? 0 : d) << 2) + h >> 2] = 0;
                                                                        d = e >>> 5 << 2;
                                                                        f = ua(h, 0, d);
                                                                        e = e & 31;
                                                                        if (e) {
                                                                            d = d + f | 0;
                                                                            F[d >> 2] = F[d >> 2] & (-1 >>> 32 - e ^ -1);
                                                                        }
                                                                        if (c >>> 0 < 12) {
                                                                            break I;
                                                                        }
                                                                        while (1) {
                                                                            r = L(p, 3);
                                                                            e = (r << 2) + l | 0;
                                                                            c = F[e >> 2];
                                                                            d = -1;
                                                                            f = r + 1 | 0;
                                                                            if ((f | 0) != -1) {
                                                                                d = F[(f << 2) + l >> 2];
                                                                            }
                                                                            P: {
                                                                                if ((c | 0) == (d | 0)) {
                                                                                    break P;
                                                                                }
                                                                                f = c;
                                                                                c = F[e + 8 >> 2];
                                                                                if ((f | 0) == (c | 0)) {
                                                                                    break P;
                                                                                }
                                                                                q = 0;
                                                                                if ((c | 0) == (d | 0)) {
                                                                                    break P;
                                                                                }
                                                                                while (1) {
                                                                                    e = q + r | 0;
                                                                                    if (!(F[(e >>> 3 & 536870908) + h >> 2] >>> e & 1)) {
                                                                                        c = F[(e << 2) + l >> 2];
                                                                                        d = 1 << c;
                                                                                        h = c >>> 5 | 0;
                                                                                        w = d & F[(h << 2) + b >> 2];
                                                                                        if (w) {
                                                                                            b = F[g + 28 >> 2];
                                                                                            Q: {
                                                                                                if ((b | 0) != F[g + 32 >> 2]) {
                                                                                                    F[b >> 2] = -1;
                                                                                                    F[g + 28 >> 2] = b + 4;
                                                                                                    break Q;
                                                                                                }
                                                                                                f = F[o >> 2];
                                                                                                d = b - f | 0;
                                                                                                h = d >> 2;
                                                                                                b = h + 1 | 0;
                                                                                                if (b >>> 0 >= 1073741824) {
                                                                                                    break c;
                                                                                                }
                                                                                                j = d >> 1;
                                                                                                j = d >>> 0 < 2147483644 ? b >>> 0 > j >>> 0 ? b : j : 1073741823;
                                                                                                if (j) {
                                                                                                    if (j >>> 0 >= 1073741824) {
                                                                                                        break i;
                                                                                                    }
                                                                                                    b = sa(j << 2);
                                                                                                }
                                                                                                else {
                                                                                                    b = 0;
                                                                                                }
                                                                                                h = b + (h << 2) | 0;
                                                                                                F[h >> 2] = -1;
                                                                                                if ((d | 0) > 0) {
                                                                                                    ta(b, f, d);
                                                                                                }
                                                                                                F[g + 32 >> 2] = b + (j << 2);
                                                                                                F[g + 28 >> 2] = h + 4;
                                                                                                F[g + 24 >> 2] = b;
                                                                                                if (!f) {
                                                                                                    break Q;
                                                                                                }
                                                                                                ra(f);
                                                                                            }
                                                                                            b = F[g + 52 >> 2];
                                                                                            R: {
                                                                                                if ((b | 0) != F[g + 56 >> 2]) {
                                                                                                    F[b >> 2] = c;
                                                                                                    F[g + 52 >> 2] = b + 4;
                                                                                                    break R;
                                                                                                }
                                                                                                f = F[g + 48 >> 2];
                                                                                                d = b - f | 0;
                                                                                                h = d >> 2;
                                                                                                b = h + 1 | 0;
                                                                                                if (b >>> 0 >= 1073741824) {
                                                                                                    break c;
                                                                                                }
                                                                                                j = d >> 1;
                                                                                                j = d >>> 0 < 2147483644 ? b >>> 0 > j >>> 0 ? b : j : 1073741823;
                                                                                                if (j) {
                                                                                                    if (j >>> 0 >= 1073741824) {
                                                                                                        break i;
                                                                                                    }
                                                                                                    b = sa(j << 2);
                                                                                                }
                                                                                                else {
                                                                                                    b = 0;
                                                                                                }
                                                                                                h = b + (h << 2) | 0;
                                                                                                F[h >> 2] = c;
                                                                                                if ((d | 0) > 0) {
                                                                                                    ta(b, f, d);
                                                                                                }
                                                                                                F[g + 56 >> 2] = b + (j << 2);
                                                                                                F[g + 52 >> 2] = h + 4;
                                                                                                F[g + 48 >> 2] = b;
                                                                                                if (!f) {
                                                                                                    break R;
                                                                                                }
                                                                                                ra(f);
                                                                                            }
                                                                                            d = F[i + 20 >> 2];
                                                                                            b = F[i + 24 >> 2];
                                                                                            if ((d | 0) == b << 5) {
                                                                                                if ((d + 1 | 0) < 0) {
                                                                                                    break K;
                                                                                                }
                                                                                                c = i + 16 | 0;
                                                                                                if (d >>> 0 <= 1073741822) {
                                                                                                    d = d + 32 & -32;
                                                                                                    b = b << 6;
                                                                                                    b = b >>> 0 < d >>> 0 ? d : b;
                                                                                                }
                                                                                                else {
                                                                                                    b = 2147483647;
                                                                                                }
                                                                                                db(c, b);
                                                                                                d = F[i + 20 >> 2];
                                                                                            }
                                                                                            F[i + 20 >> 2] = d + 1;
                                                                                            b = F[i + 16 >> 2] + (d >>> 3 & 536870908) | 0;
                                                                                            c = F[b >> 2];
                                                                                            M = b, N = Lj(d) & c, F[M >> 2] = N;
                                                                                            d = 1 << a;
                                                                                            h = a >>> 5 | 0;
                                                                                            c = a;
                                                                                            a = a + 1 | 0;
                                                                                        }
                                                                                        f = a;
                                                                                        b = F[i + 16 >> 2];
                                                                                        a = b + (h << 2) | 0;
                                                                                        F[a >> 2] = F[a >> 2] | d;
                                                                                        v = F[g + 24 >> 2] + (c << 2) | 0;
                                                                                        j = F[g + 12 >> 2];
                                                                                        l = F[g >> 2];
                                                                                        h = F[i >> 2];
                                                                                        a = e;
                                                                                        S: {
                                                                                            T: {
                                                                                                U: {
                                                                                                    V: {
                                                                                                        W: {
                                                                                                            X: {
                                                                                                                while (1) {
                                                                                                                    if ((a | 0) == -1) {
                                                                                                                        break X;
                                                                                                                    }
                                                                                                                    d = (a >>> 3 & 536870908) + h | 0;
                                                                                                                    F[d >> 2] = F[d >> 2] | 1 << a;
                                                                                                                    F[v >> 2] = a;
                                                                                                                    if (w) {
                                                                                                                        F[(a << 2) + l >> 2] = c;
                                                                                                                    }
                                                                                                                    u = a + 1 | 0;
                                                                                                                    a = (u >>> 0) % 3 | 0 ? u : a - 2 | 0;
                                                                                                                    d = -1;
                                                                                                                    Y: {
                                                                                                                        if ((a | 0) == -1) {
                                                                                                                            break Y;
                                                                                                                        }
                                                                                                                        a = F[j + (a << 2) >> 2];
                                                                                                                        d = -1;
                                                                                                                        if ((a | 0) == -1) {
                                                                                                                            break Y;
                                                                                                                        }
                                                                                                                        d = a + 1 | 0;
                                                                                                                        d = (d >>> 0) % 3 | 0 ? d : a - 2 | 0;
                                                                                                                    }
                                                                                                                    a = d;
                                                                                                                    if ((e | 0) != (a | 0)) {
                                                                                                                        continue;
                                                                                                                    }
                                                                                                                    break;
                                                                                                                }
                                                                                                                if ((e | 0) != -1) {
                                                                                                                    break S;
                                                                                                                }
                                                                                                                a = 1;
                                                                                                                break W;
                                                                                                            }
                                                                                                            if ((e >>> 0) % 3 | 0) {
                                                                                                                a = e - 1 | 0;
                                                                                                                break W;
                                                                                                            }
                                                                                                            a = e + 2 | 0;
                                                                                                            if ((a | 0) == -1) {
                                                                                                                break V;
                                                                                                            }
                                                                                                        }
                                                                                                        a = F[j + (a << 2) >> 2];
                                                                                                        if ((a | 0) == -1) {
                                                                                                            break V;
                                                                                                        }
                                                                                                        if (!((a >>> 0) % 3 | 0)) {
                                                                                                            break U;
                                                                                                        }
                                                                                                        a = a - 1 | 0;
                                                                                                        l = F[g >> 2];
                                                                                                        h = F[i >> 2];
                                                                                                        break T;
                                                                                                    }
                                                                                                    l = F[g >> 2];
                                                                                                    h = F[i >> 2];
                                                                                                    break S;
                                                                                                }
                                                                                                l = F[g >> 2];
                                                                                                h = F[i >> 2];
                                                                                                a = a + 2 | 0;
                                                                                                if ((a | 0) == -1) {
                                                                                                    break S;
                                                                                                }
                                                                                            }
                                                                                            e = F[g + 12 >> 2];
                                                                                            while (1) {
                                                                                                d = (a >>> 3 & 536870908) + h | 0;
                                                                                                F[d >> 2] = F[d >> 2] | 1 << a;
                                                                                                if (w) {
                                                                                                    F[(a << 2) + l >> 2] = c;
                                                                                                }
                                                                                                Z: {
                                                                                                    if ((a >>> 0) % 3 | 0) {
                                                                                                        a = a - 1 | 0;
                                                                                                        break Z;
                                                                                                    }
                                                                                                    a = a + 2 | 0;
                                                                                                    if ((a | 0) == -1) {
                                                                                                        break S;
                                                                                                    }
                                                                                                }
                                                                                                a = F[e + (a << 2) >> 2];
                                                                                                if ((a | 0) == -1) {
                                                                                                    break S;
                                                                                                }
                                                                                                a = a + ((a >>> 0) % 3 | 0 ? -1 : 2) | 0;
                                                                                                if ((a | 0) != -1) {
                                                                                                    continue;
                                                                                                }
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        a = f;
                                                                                    }
                                                                                    q = q + 1 | 0;
                                                                                    if ((q | 0) != 3) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                                l = F[g >> 2];
                                                                                j = F[g + 4 >> 2];
                                                                            }
                                                                            p = p + 1 | 0;
                                                                            if (p >>> 0 < (j - l >> 2 >>> 0) / 3 >>> 0) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        break J;
                                                                    }
                                                                    Oa();
                                                                    V();
                                                                }
                                                                Oa();
                                                                V();
                                                            }
                                                            Oa();
                                                            V();
                                                        }
                                                        b = F[i + 16 >> 2];
                                                    }
                                                    F[g + 44 >> 2] = 0;
                                                    a = F[i + 20 >> 2];
                                                    if (a) {
                                                        c = a & 31;
                                                        e = (a >>> 3 & 536870908) + b | 0;
                                                        a = b;
                                                        h = 0;
                                                        while (1) {
                                                            if (!(F[a >> 2] >>> n & 1)) {
                                                                h = h + 1 | 0;
                                                                F[g + 44 >> 2] = h;
                                                            }
                                                            d = (n | 0) == 31;
                                                            n = d ? 0 : n + 1 | 0;
                                                            a = (d << 2) + a | 0;
                                                            if ((e | 0) != (a | 0) | (c | 0) != (n | 0)) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    a = F[i >> 2];
                                                    if (a) {
                                                        ra(a);
                                                        b = F[i + 16 >> 2];
                                                    }
                                                    if (b) {
                                                        ra(b);
                                                    }
                                                    ea = i + 32 | 0;
                                                }
                                                ea = A + 16 | 0;
                                                if (!y) {
                                                    F[C + 8 >> 2] = 0;
                                                    cb(g);
                                                    g = 0;
                                                }
                                                ea = C + 16 | 0;
                                                a = g;
                                                break h;
                                            }
                                            wa(1336);
                                            V();
                                        }
                                        b = F[t >> 2];
                                        if (!b) {
                                            break e;
                                        }
                                        F[t + 4 >> 2] = b;
                                        ra(b);
                                    }
                                    ea = t + 16 | 0;
                                    break d;
                                }
                                b = F[k + 4 >> 2];
                                F[k + 4 >> 2] = a;
                                if (b) {
                                    cb(b);
                                    a = F[k + 4 >> 2];
                                }
                                _: {
                                    if (!a) {
                                        break _;
                                    }
                                    a = F[x + 100 >> 2];
                                    b = F[x + 96 >> 2];
                                    D[s + 12 | 0] = 0;
                                    Na(k + 56 | 0, (a - b | 0) / 12 | 0, s + 12 | 0);
                                    a = F[x + 100 >> 2];
                                    c = F[x + 96 >> 2];
                                    if ((a | 0) == (c | 0)) {
                                        J = 1;
                                        break _;
                                    }
                                    while (1) {
                                        if (!(F[F[k + 56 >> 2] + (B >>> 3 & 536870908) >> 2] >>> B & 1)) {
                                            a = L(B, 3);
                                            Fc(k, 0, a);
                                            b = F[k + 8 >> 2];
                                            c = F[k + 12 >> 2];
                                            Fc(k, 1, a + 1 | 0);
                                            e = F[k + 20 >> 2];
                                            d = F[k + 24 >> 2];
                                            Fc(k, 2, a + 2 | 0);
                                            e = d - e >> 2;
                                            b = c - b | 0;
                                            c = b >> 2;
                                            a = e >>> 0 > c >>> 0;
                                            c = F[k + 36 >> 2] - F[k + 32 >> 2] >> 2 >>> 0 > (a ? e : c) >>> 0 ? 2 : a ? 1 : b ? 0 : -1;
                                            $: {
                                                if (F[k + 68 >> 2] <= 0) {
                                                    break $;
                                                }
                                                F[s + 12 >> 2] = F[k + 76 >> 2];
                                                F[s + 8 >> 2] = m;
                                                hb(s + 8 | 0, s + 12 | 0);
                                                a = F[((c << 2) + k | 0) + 44 >> 2];
                                                if ((a | 0) < 0) {
                                                    a = -1;
                                                }
                                                else {
                                                    b = (a >>> 0) / 3 | 0;
                                                    a = F[(F[F[k >> 2] + 96 >> 2] + L(b, 12) | 0) + (a - L(b, 3) << 2) >> 2];
                                                }
                                                F[s + 12 >> 2] = a;
                                                F[s + 8 >> 2] = m;
                                                hb(s + 8 | 0, s + 12 | 0);
                                                b = F[k + 72 >> 2];
                                                F[k + 72 >> 2] = b + 2;
                                                if (!(b & 1)) {
                                                    break $;
                                                }
                                                F[s + 12 >> 2] = a;
                                                F[s + 8 >> 2] = m;
                                                hb(s + 8 | 0, s + 12 | 0);
                                                F[k + 72 >> 2] = F[k + 72 >> 2] + 1;
                                            }
                                            b = ea - 16 | 0;
                                            ea = b;
                                            F[k + 68 >> 2] = F[k + 68 >> 2] + 1;
                                            a = L(c, 12) + k | 0;
                                            e = F[a + 12 >> 2] - F[a + 8 >> 2] | 0;
                                            aa: {
                                                if ((e | 0) <= 0) {
                                                    break aa;
                                                }
                                                a = -1;
                                                c = F[((c << 2) + k | 0) + 44 >> 2];
                                                d = (c >>> 0) / 3 | 0;
                                                i = (c | 0) == -1;
                                                f = i ? -1 : d;
                                                g = F[k + 56 >> 2] + (f >>> 3 & 536870908) | 0;
                                                F[g >> 2] = F[g >> 2] | 1 << f;
                                                F[k + 72 >> 2] = F[k + 72 >> 2] + 1;
                                                F[b + 12 >> 2] = (c | 0) >= 0 ? F[(F[F[k >> 2] + 96 >> 2] + L(d, 12) | 0) + ((c >>> 0) % 3 << 2) >> 2] : -1;
                                                F[b + 8 >> 2] = m;
                                                hb(b + 8 | 0, b + 12 | 0);
                                                ba: {
                                                    if (!i) {
                                                        f = c + 1 | 0;
                                                        f = (f >>> 0) % 3 | 0 ? f : c - 2 | 0;
                                                        if ((f | 0) >= 0) {
                                                            i = (f >>> 0) / 3 | 0;
                                                            f = F[(F[F[k >> 2] + 96 >> 2] + L(i, 12) | 0) + (f - L(i, 3) << 2) >> 2];
                                                        }
                                                        else {
                                                            f = -1;
                                                        }
                                                        F[b + 12 >> 2] = f;
                                                        F[b + 8 >> 2] = m;
                                                        hb(b + 8 | 0, b + 12 | 0);
                                                        d = c + (c - L(d, 3) | 0 ? -1 : 2) | 0;
                                                        if ((d | 0) < 0) {
                                                            break ba;
                                                        }
                                                        a = (d >>> 0) / 3 | 0;
                                                        a = F[(F[F[k >> 2] + 96 >> 2] + L(a, 12) | 0) + (d - L(a, 3) << 2) >> 2];
                                                        break ba;
                                                    }
                                                    F[b + 12 >> 2] = -1;
                                                    F[b + 8 >> 2] = m;
                                                    hb(b + 8 | 0, b + 12 | 0);
                                                }
                                                F[k + 76 >> 2] = a;
                                                F[b + 12 >> 2] = a;
                                                F[b + 8 >> 2] = m;
                                                a = -1;
                                                hb(b + 8 | 0, b + 12 | 0);
                                                a = (c | 0) != -1 ? F[F[F[k + 4 >> 2] + 12 >> 2] + (c << 2) >> 2] : a;
                                                if (e >>> 0 <= 7) {
                                                    break aa;
                                                }
                                                c = e >>> 2 | 0;
                                                i = c >>> 0 > 1 ? c : 1;
                                                e = 1;
                                                while (1) {
                                                    c = a;
                                                    f = (a >>> 0) / 3 | 0;
                                                    a = (a | 0) == -1 ? -1 : f;
                                                    d = F[k + 56 >> 2] + (a >>> 3 & 536870908) | 0;
                                                    F[d >> 2] = F[d >> 2] | 1 << a;
                                                    F[k + 72 >> 2] = F[k + 72 >> 2] + 1;
                                                    a = -1;
                                                    a = (c | 0) >= 0 ? F[(F[F[k >> 2] + 96 >> 2] + L(f, 12) | 0) + ((c >>> 0) % 3 << 2) >> 2] : a;
                                                    F[k + 76 >> 2] = a;
                                                    F[b + 12 >> 2] = a;
                                                    F[b + 8 >> 2] = m;
                                                    hb(b + 8 | 0, b + 12 | 0);
                                                    ca: {
                                                        da: {
                                                            ea: {
                                                                if (e & 1) {
                                                                    d = -1;
                                                                    if ((c | 0) == -1) {
                                                                        break ca;
                                                                    }
                                                                    if ((c | 0) != (L(f, 3) | 0)) {
                                                                        a = c - 1 | 0;
                                                                        break da;
                                                                    }
                                                                    a = c + 2 | 0;
                                                                    break ea;
                                                                }
                                                                d = -1;
                                                                if ((c | 0) == -1) {
                                                                    break ca;
                                                                }
                                                                a = c + 1 | 0;
                                                                a = (a >>> 0) % 3 | 0 ? a : c - 2 | 0;
                                                            }
                                                            d = -1;
                                                            if ((a | 0) == -1) {
                                                                break ca;
                                                            }
                                                        }
                                                        d = F[F[F[k + 4 >> 2] + 12 >> 2] + (a << 2) >> 2];
                                                    }
                                                    a = d;
                                                    e = e + 1 | 0;
                                                    if ((i | 0) != (e | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            ea = b + 16 | 0;
                                            c = F[x + 96 >> 2];
                                            a = F[x + 100 >> 2];
                                        }
                                        J = 1;
                                        B = B + 1 | 0;
                                        if (B >>> 0 < (a - c | 0) / 12 >>> 0) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                ea = s + 16 | 0;
                                fa: {
                                    if (J) {
                                        a = F[z >> 2];
                                        if (a) {
                                            F[z + 4 >> 2] = a;
                                            ra(a);
                                        }
                                        F[z >> 2] = F[m >> 2];
                                        F[z + 4 >> 2] = F[m + 4 >> 2];
                                        F[z + 8 >> 2] = F[m + 8 >> 2];
                                        K = F[m + 84 >> 2];
                                        break fa;
                                    }
                                    a = F[m >> 2];
                                    if (!a) {
                                        break fa;
                                    }
                                    F[m + 4 >> 2] = a;
                                    ra(a);
                                }
                                a = F[m + 72 >> 2];
                                if (a) {
                                    ra(a);
                                }
                                a = F[m + 48 >> 2];
                                if (a) {
                                    F[m + 52 >> 2] = a;
                                    ra(a);
                                }
                                a = F[m + 36 >> 2];
                                if (a) {
                                    F[m + 40 >> 2] = a;
                                    ra(a);
                                }
                                a = F[m + 24 >> 2];
                                if (a) {
                                    F[m + 28 >> 2] = a;
                                    ra(a);
                                }
                                a = F[m + 20 >> 2];
                                F[m + 20 >> 2] = 0;
                                if (a) {
                                    cb(a);
                                }
                                ea = m + 96 | 0;
                                break b;
                            }
                            va();
                            V();
                        } return K | 0; }
                        function Gd(a) { a = a | 0; var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0; l = ea - 16 | 0; ea = l; a: {
                            b: {
                                c: {
                                    d: {
                                        e: {
                                            f: {
                                                g: {
                                                    h: {
                                                        i: {
                                                            j: {
                                                                k: {
                                                                    if (a >>> 0 <= 244) {
                                                                        e = F[4233];
                                                                        h = a >>> 0 < 11 ? 16 : a + 11 & -8;
                                                                        c = h >>> 3 | 0;
                                                                        b = e >>> c | 0;
                                                                        if (b & 3) {
                                                                            d = c + ((b ^ -1) & 1) | 0;
                                                                            b = d << 3;
                                                                            f = F[b + 16980 >> 2];
                                                                            a = f + 8 | 0;
                                                                            c = F[f + 8 >> 2];
                                                                            b = b + 16972 | 0;
                                                                            l: {
                                                                                if ((c | 0) == (b | 0)) {
                                                                                    m = 16932, n = Lj(d) & e, F[m >> 2] = n;
                                                                                    break l;
                                                                                }
                                                                                F[c + 12 >> 2] = b;
                                                                                F[b + 8 >> 2] = c;
                                                                            }
                                                                            b = d << 3;
                                                                            F[f + 4 >> 2] = b | 3;
                                                                            b = b + f | 0;
                                                                            F[b + 4 >> 2] = F[b + 4 >> 2] | 1;
                                                                            break a;
                                                                        }
                                                                        k = F[4235];
                                                                        if (k >>> 0 >= h >>> 0) {
                                                                            break k;
                                                                        }
                                                                        if (b) {
                                                                            a = 2 << c;
                                                                            a = (0 - a | a) & b << c;
                                                                            b = (0 - a & a) - 1 | 0;
                                                                            a = b >>> 12 & 16;
                                                                            c = a;
                                                                            b = b >>> a | 0;
                                                                            a = b >>> 5 & 8;
                                                                            c = c | a;
                                                                            b = b >>> a | 0;
                                                                            a = b >>> 2 & 4;
                                                                            c = c | a;
                                                                            b = b >>> a | 0;
                                                                            a = b >>> 1 & 2;
                                                                            c = c | a;
                                                                            b = b >>> a | 0;
                                                                            a = b >>> 1 & 1;
                                                                            c = (c | a) + (b >>> a | 0) | 0;
                                                                            a = c << 3;
                                                                            g = F[a + 16980 >> 2];
                                                                            b = F[g + 8 >> 2];
                                                                            a = a + 16972 | 0;
                                                                            m: {
                                                                                if ((b | 0) == (a | 0)) {
                                                                                    e = Lj(c) & e;
                                                                                    F[4233] = e;
                                                                                    break m;
                                                                                }
                                                                                F[b + 12 >> 2] = a;
                                                                                F[a + 8 >> 2] = b;
                                                                            }
                                                                            a = g + 8 | 0;
                                                                            F[g + 4 >> 2] = h | 3;
                                                                            d = g + h | 0;
                                                                            b = c << 3;
                                                                            f = b - h | 0;
                                                                            F[d + 4 >> 2] = f | 1;
                                                                            F[b + g >> 2] = f;
                                                                            if (k) {
                                                                                b = k >>> 3 | 0;
                                                                                c = (b << 3) + 16972 | 0;
                                                                                g = F[4238];
                                                                                b = 1 << b;
                                                                                n: {
                                                                                    if (!(b & e)) {
                                                                                        F[4233] = b | e;
                                                                                        b = c;
                                                                                        break n;
                                                                                    }
                                                                                    b = F[c + 8 >> 2];
                                                                                }
                                                                                F[c + 8 >> 2] = g;
                                                                                F[b + 12 >> 2] = g;
                                                                                F[g + 12 >> 2] = c;
                                                                                F[g + 8 >> 2] = b;
                                                                            }
                                                                            F[4238] = d;
                                                                            F[4235] = f;
                                                                            break a;
                                                                        }
                                                                        j = F[4234];
                                                                        if (!j) {
                                                                            break k;
                                                                        }
                                                                        b = (j & 0 - j) - 1 | 0;
                                                                        a = b >>> 12 & 16;
                                                                        c = a;
                                                                        b = b >>> a | 0;
                                                                        a = b >>> 5 & 8;
                                                                        c = c | a;
                                                                        b = b >>> a | 0;
                                                                        a = b >>> 2 & 4;
                                                                        c = c | a;
                                                                        b = b >>> a | 0;
                                                                        a = b >>> 1 & 2;
                                                                        c = c | a;
                                                                        b = b >>> a | 0;
                                                                        a = b >>> 1 & 1;
                                                                        b = F[((c | a) + (b >>> a | 0) << 2) + 17236 >> 2];
                                                                        d = (F[b + 4 >> 2] & -8) - h | 0;
                                                                        c = b;
                                                                        while (1) {
                                                                            o: {
                                                                                a = F[c + 16 >> 2];
                                                                                if (!a) {
                                                                                    a = F[c + 20 >> 2];
                                                                                    if (!a) {
                                                                                        break o;
                                                                                    }
                                                                                }
                                                                                c = (F[a + 4 >> 2] & -8) - h | 0;
                                                                                f = c >>> 0 < d >>> 0;
                                                                                d = f ? c : d;
                                                                                b = f ? a : b;
                                                                                c = a;
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        i = F[b + 24 >> 2];
                                                                        f = F[b + 12 >> 2];
                                                                        if ((f | 0) != (b | 0)) {
                                                                            a = F[b + 8 >> 2];
                                                                            F[a + 12 >> 2] = f;
                                                                            F[f + 8 >> 2] = a;
                                                                            break b;
                                                                        }
                                                                        c = b + 20 | 0;
                                                                        a = F[c >> 2];
                                                                        if (!a) {
                                                                            a = F[b + 16 >> 2];
                                                                            if (!a) {
                                                                                break j;
                                                                            }
                                                                            c = b + 16 | 0;
                                                                        }
                                                                        while (1) {
                                                                            g = c;
                                                                            f = a;
                                                                            c = a + 20 | 0;
                                                                            a = F[c >> 2];
                                                                            if (a) {
                                                                                continue;
                                                                            }
                                                                            c = f + 16 | 0;
                                                                            a = F[f + 16 >> 2];
                                                                            if (a) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        F[g >> 2] = 0;
                                                                        break b;
                                                                    }
                                                                    h = -1;
                                                                    if (a >>> 0 > 4294967231) {
                                                                        break k;
                                                                    }
                                                                    a = a + 11 | 0;
                                                                    h = a & -8;
                                                                    j = F[4234];
                                                                    if (!j) {
                                                                        break k;
                                                                    }
                                                                    d = 0 - h | 0;
                                                                    e = 0;
                                                                    p: {
                                                                        if (h >>> 0 < 256) {
                                                                            break p;
                                                                        }
                                                                        e = 31;
                                                                        if (h >>> 0 > 16777215) {
                                                                            break p;
                                                                        }
                                                                        a = a >>> 8 | 0;
                                                                        g = a + 1048320 >>> 16 & 8;
                                                                        a = a << g;
                                                                        c = a + 520192 >>> 16 & 4;
                                                                        a = a << c;
                                                                        b = a + 245760 >>> 16 & 2;
                                                                        a = (a << b >>> 15 | 0) - (b | (c | g)) | 0;
                                                                        e = (a << 1 | h >>> a + 21 & 1) + 28 | 0;
                                                                    }
                                                                    c = F[(e << 2) + 17236 >> 2];
                                                                    q: {
                                                                        r: {
                                                                            s: {
                                                                                if (!c) {
                                                                                    a = 0;
                                                                                    break s;
                                                                                }
                                                                                a = 0;
                                                                                b = h << ((e | 0) == 31 ? 0 : 25 - (e >>> 1 | 0) | 0);
                                                                                while (1) {
                                                                                    t: {
                                                                                        g = (F[c + 4 >> 2] & -8) - h | 0;
                                                                                        if (g >>> 0 >= d >>> 0) {
                                                                                            break t;
                                                                                        }
                                                                                        f = c;
                                                                                        d = g;
                                                                                        if (d) {
                                                                                            break t;
                                                                                        }
                                                                                        d = 0;
                                                                                        a = c;
                                                                                        break r;
                                                                                    }
                                                                                    g = F[c + 20 >> 2];
                                                                                    c = F[((b >>> 29 & 4) + c | 0) + 16 >> 2];
                                                                                    a = g ? (g | 0) == (c | 0) ? a : g : a;
                                                                                    b = b << 1;
                                                                                    if (c) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                            }
                                                                            if (!(a | f)) {
                                                                                f = 0;
                                                                                a = 2 << e;
                                                                                a = (0 - a | a) & j;
                                                                                if (!a) {
                                                                                    break k;
                                                                                }
                                                                                b = (a & 0 - a) - 1 | 0;
                                                                                a = b >>> 12 & 16;
                                                                                c = a;
                                                                                b = b >>> a | 0;
                                                                                a = b >>> 5 & 8;
                                                                                c = c | a;
                                                                                b = b >>> a | 0;
                                                                                a = b >>> 2 & 4;
                                                                                c = c | a;
                                                                                b = b >>> a | 0;
                                                                                a = b >>> 1 & 2;
                                                                                c = c | a;
                                                                                b = b >>> a | 0;
                                                                                a = b >>> 1 & 1;
                                                                                a = F[((c | a) + (b >>> a | 0) << 2) + 17236 >> 2];
                                                                            }
                                                                            if (!a) {
                                                                                break q;
                                                                            }
                                                                        }
                                                                        while (1) {
                                                                            b = (F[a + 4 >> 2] & -8) - h | 0;
                                                                            c = b >>> 0 < d >>> 0;
                                                                            d = c ? b : d;
                                                                            f = c ? a : f;
                                                                            b = F[a + 16 >> 2];
                                                                            if (b) {
                                                                                a = b;
                                                                            }
                                                                            else {
                                                                                a = F[a + 20 >> 2];
                                                                            }
                                                                            if (a) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    if (!f | F[4235] - h >>> 0 <= d >>> 0) {
                                                                        break k;
                                                                    }
                                                                    e = F[f + 24 >> 2];
                                                                    b = F[f + 12 >> 2];
                                                                    if ((f | 0) != (b | 0)) {
                                                                        a = F[f + 8 >> 2];
                                                                        F[a + 12 >> 2] = b;
                                                                        F[b + 8 >> 2] = a;
                                                                        break c;
                                                                    }
                                                                    c = f + 20 | 0;
                                                                    a = F[c >> 2];
                                                                    if (!a) {
                                                                        a = F[f + 16 >> 2];
                                                                        if (!a) {
                                                                            break i;
                                                                        }
                                                                        c = f + 16 | 0;
                                                                    }
                                                                    while (1) {
                                                                        g = c;
                                                                        b = a;
                                                                        c = a + 20 | 0;
                                                                        a = F[c >> 2];
                                                                        if (a) {
                                                                            continue;
                                                                        }
                                                                        c = b + 16 | 0;
                                                                        a = F[b + 16 >> 2];
                                                                        if (a) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    F[g >> 2] = 0;
                                                                    break c;
                                                                }
                                                                c = F[4235];
                                                                if (c >>> 0 >= h >>> 0) {
                                                                    d = F[4238];
                                                                    b = c - h | 0;
                                                                    u: {
                                                                        if (b >>> 0 >= 16) {
                                                                            F[4235] = b;
                                                                            a = d + h | 0;
                                                                            F[4238] = a;
                                                                            F[a + 4 >> 2] = b | 1;
                                                                            F[c + d >> 2] = b;
                                                                            F[d + 4 >> 2] = h | 3;
                                                                            break u;
                                                                        }
                                                                        F[4238] = 0;
                                                                        F[4235] = 0;
                                                                        F[d + 4 >> 2] = c | 3;
                                                                        a = c + d | 0;
                                                                        F[a + 4 >> 2] = F[a + 4 >> 2] | 1;
                                                                    }
                                                                    a = d + 8 | 0;
                                                                    break a;
                                                                }
                                                                i = F[4236];
                                                                if (i >>> 0 > h >>> 0) {
                                                                    b = i - h | 0;
                                                                    F[4236] = b;
                                                                    c = F[4239];
                                                                    a = c + h | 0;
                                                                    F[4239] = a;
                                                                    F[a + 4 >> 2] = b | 1;
                                                                    F[c + 4 >> 2] = h | 3;
                                                                    a = c + 8 | 0;
                                                                    break a;
                                                                }
                                                                a = 0;
                                                                j = h + 47 | 0;
                                                                if (F[4351]) {
                                                                    c = F[4353];
                                                                }
                                                                else {
                                                                    F[4354] = -1;
                                                                    F[4355] = -1;
                                                                    F[4352] = 4096;
                                                                    F[4353] = 4096;
                                                                    F[4351] = l + 12 & -16 ^ 1431655768;
                                                                    F[4356] = 0;
                                                                    F[4344] = 0;
                                                                    c = 4096;
                                                                }
                                                                g = j + c | 0;
                                                                f = 0 - c | 0;
                                                                c = g & f;
                                                                if (c >>> 0 <= h >>> 0) {
                                                                    break a;
                                                                }
                                                                d = F[4343];
                                                                if (d) {
                                                                    b = F[4341];
                                                                    e = b + c | 0;
                                                                    if (d >>> 0 < e >>> 0 | b >>> 0 >= e >>> 0) {
                                                                        break a;
                                                                    }
                                                                }
                                                                if (G[17376] & 4) {
                                                                    break f;
                                                                }
                                                                v: {
                                                                    w: {
                                                                        d = F[4239];
                                                                        if (d) {
                                                                            a = 17380;
                                                                            while (1) {
                                                                                b = F[a >> 2];
                                                                                if (b >>> 0 <= d >>> 0 & d >>> 0 < b + F[a + 4 >> 2] >>> 0) {
                                                                                    break w;
                                                                                }
                                                                                a = F[a + 8 >> 2];
                                                                                if (a) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                        }
                                                                        b = lb(0);
                                                                        if ((b | 0) == -1) {
                                                                            break g;
                                                                        }
                                                                        e = c;
                                                                        d = F[4352];
                                                                        a = d - 1 | 0;
                                                                        if (a & b) {
                                                                            e = (c - b | 0) + (a + b & 0 - d) | 0;
                                                                        }
                                                                        if (e >>> 0 <= h >>> 0 | e >>> 0 > 2147483646) {
                                                                            break g;
                                                                        }
                                                                        d = F[4343];
                                                                        if (d) {
                                                                            a = F[4341];
                                                                            f = a + e | 0;
                                                                            if (d >>> 0 < f >>> 0 | a >>> 0 >= f >>> 0) {
                                                                                break g;
                                                                            }
                                                                        }
                                                                        a = lb(e);
                                                                        if ((b | 0) != (a | 0)) {
                                                                            break v;
                                                                        }
                                                                        break e;
                                                                    }
                                                                    e = f & g - i;
                                                                    if (e >>> 0 > 2147483646) {
                                                                        break g;
                                                                    }
                                                                    b = lb(e);
                                                                    if ((b | 0) == (F[a >> 2] + F[a + 4 >> 2] | 0)) {
                                                                        break h;
                                                                    }
                                                                    a = b;
                                                                }
                                                                if (!((a | 0) == -1 | h + 48 >>> 0 <= e >>> 0)) {
                                                                    b = F[4353];
                                                                    b = b + (j - e | 0) & 0 - b;
                                                                    if (b >>> 0 > 2147483646) {
                                                                        b = a;
                                                                        break e;
                                                                    }
                                                                    if ((lb(b) | 0) != -1) {
                                                                        e = b + e | 0;
                                                                        b = a;
                                                                        break e;
                                                                    }
                                                                    lb(0 - e | 0);
                                                                    break g;
                                                                }
                                                                b = a;
                                                                if ((a | 0) != -1) {
                                                                    break e;
                                                                }
                                                                break g;
                                                            }
                                                            f = 0;
                                                            break b;
                                                        }
                                                        b = 0;
                                                        break c;
                                                    }
                                                    if ((b | 0) != -1) {
                                                        break e;
                                                    }
                                                }
                                                F[4344] = F[4344] | 4;
                                            }
                                            if (c >>> 0 > 2147483646) {
                                                break d;
                                            }
                                            b = lb(c);
                                            a = lb(0);
                                            if ((b | 0) == -1 | (a | 0) == -1 | a >>> 0 <= b >>> 0) {
                                                break d;
                                            }
                                            e = a - b | 0;
                                            if (e >>> 0 <= h + 40 >>> 0) {
                                                break d;
                                            }
                                        }
                                        a = F[4341] + e | 0;
                                        F[4341] = a;
                                        if (a >>> 0 > I[4342]) {
                                            F[4342] = a;
                                        }
                                        x: {
                                            y: {
                                                z: {
                                                    g = F[4239];
                                                    if (g) {
                                                        a = 17380;
                                                        while (1) {
                                                            d = F[a >> 2];
                                                            c = F[a + 4 >> 2];
                                                            if ((d + c | 0) == (b | 0)) {
                                                                break z;
                                                            }
                                                            a = F[a + 8 >> 2];
                                                            if (a) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        break y;
                                                    }
                                                    a = F[4237];
                                                    if (!(a >>> 0 <= b >>> 0 ? a : 0)) {
                                                        F[4237] = b;
                                                    }
                                                    a = 0;
                                                    F[4346] = e;
                                                    F[4345] = b;
                                                    F[4241] = -1;
                                                    F[4242] = F[4351];
                                                    F[4348] = 0;
                                                    while (1) {
                                                        d = a << 3;
                                                        c = d + 16972 | 0;
                                                        F[d + 16980 >> 2] = c;
                                                        F[d + 16984 >> 2] = c;
                                                        a = a + 1 | 0;
                                                        if ((a | 0) != 32) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    d = e - 40 | 0;
                                                    a = b + 8 & 7 ? -8 - b & 7 : 0;
                                                    c = d - a | 0;
                                                    F[4236] = c;
                                                    a = a + b | 0;
                                                    F[4239] = a;
                                                    F[a + 4 >> 2] = c | 1;
                                                    F[(b + d | 0) + 4 >> 2] = 40;
                                                    F[4240] = F[4355];
                                                    break x;
                                                }
                                                if (G[a + 12 | 0] & 8 | d >>> 0 > g >>> 0 | b >>> 0 <= g >>> 0) {
                                                    break y;
                                                }
                                                F[a + 4 >> 2] = c + e;
                                                a = g + 8 & 7 ? -8 - g & 7 : 0;
                                                c = a + g | 0;
                                                F[4239] = c;
                                                b = F[4236] + e | 0;
                                                a = b - a | 0;
                                                F[4236] = a;
                                                F[c + 4 >> 2] = a | 1;
                                                F[(b + g | 0) + 4 >> 2] = 40;
                                                F[4240] = F[4355];
                                                break x;
                                            }
                                            if (I[4237] > b >>> 0) {
                                                F[4237] = b;
                                            }
                                            c = b + e | 0;
                                            a = 17380;
                                            A: {
                                                B: {
                                                    C: {
                                                        D: {
                                                            E: {
                                                                F: {
                                                                    while (1) {
                                                                        if ((c | 0) != F[a >> 2]) {
                                                                            a = F[a + 8 >> 2];
                                                                            if (a) {
                                                                                continue;
                                                                            }
                                                                            break F;
                                                                        }
                                                                        break;
                                                                    }
                                                                    if (!(G[a + 12 | 0] & 8)) {
                                                                        break E;
                                                                    }
                                                                }
                                                                a = 17380;
                                                                while (1) {
                                                                    c = F[a >> 2];
                                                                    if (c >>> 0 <= g >>> 0) {
                                                                        f = c + F[a + 4 >> 2] | 0;
                                                                        if (f >>> 0 > g >>> 0) {
                                                                            break D;
                                                                        }
                                                                    }
                                                                    a = F[a + 8 >> 2];
                                                                    continue;
                                                                }
                                                            }
                                                            F[a >> 2] = b;
                                                            F[a + 4 >> 2] = F[a + 4 >> 2] + e;
                                                            j = (b + 8 & 7 ? -8 - b & 7 : 0) + b | 0;
                                                            F[j + 4 >> 2] = h | 3;
                                                            e = c + (c + 8 & 7 ? -8 - c & 7 : 0) | 0;
                                                            i = h + j | 0;
                                                            c = e - i | 0;
                                                            if ((e | 0) == (g | 0)) {
                                                                F[4239] = i;
                                                                a = F[4236] + c | 0;
                                                                F[4236] = a;
                                                                F[i + 4 >> 2] = a | 1;
                                                                break B;
                                                            }
                                                            if (F[4238] == (e | 0)) {
                                                                F[4238] = i;
                                                                a = F[4235] + c | 0;
                                                                F[4235] = a;
                                                                F[i + 4 >> 2] = a | 1;
                                                                F[a + i >> 2] = a;
                                                                break B;
                                                            }
                                                            a = F[e + 4 >> 2];
                                                            if ((a & 3) == 1) {
                                                                g = a & -8;
                                                                G: {
                                                                    if (a >>> 0 <= 255) {
                                                                        d = F[e + 8 >> 2];
                                                                        a = a >>> 3 | 0;
                                                                        b = F[e + 12 >> 2];
                                                                        if ((b | 0) == (d | 0)) {
                                                                            m = 16932, n = F[4233] & Lj(a), F[m >> 2] = n;
                                                                            break G;
                                                                        }
                                                                        F[d + 12 >> 2] = b;
                                                                        F[b + 8 >> 2] = d;
                                                                        break G;
                                                                    }
                                                                    h = F[e + 24 >> 2];
                                                                    b = F[e + 12 >> 2];
                                                                    H: {
                                                                        if ((e | 0) != (b | 0)) {
                                                                            a = F[e + 8 >> 2];
                                                                            F[a + 12 >> 2] = b;
                                                                            F[b + 8 >> 2] = a;
                                                                            break H;
                                                                        }
                                                                        I: {
                                                                            a = e + 20 | 0;
                                                                            d = F[a >> 2];
                                                                            if (d) {
                                                                                break I;
                                                                            }
                                                                            a = e + 16 | 0;
                                                                            d = F[a >> 2];
                                                                            if (d) {
                                                                                break I;
                                                                            }
                                                                            b = 0;
                                                                            break H;
                                                                        }
                                                                        while (1) {
                                                                            f = a;
                                                                            b = d;
                                                                            a = b + 20 | 0;
                                                                            d = F[a >> 2];
                                                                            if (d) {
                                                                                continue;
                                                                            }
                                                                            a = b + 16 | 0;
                                                                            d = F[b + 16 >> 2];
                                                                            if (d) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        F[f >> 2] = 0;
                                                                    }
                                                                    if (!h) {
                                                                        break G;
                                                                    }
                                                                    d = F[e + 28 >> 2];
                                                                    a = (d << 2) + 17236 | 0;
                                                                    J: {
                                                                        if (F[a >> 2] == (e | 0)) {
                                                                            F[a >> 2] = b;
                                                                            if (b) {
                                                                                break J;
                                                                            }
                                                                            m = 16936, n = F[4234] & Lj(d), F[m >> 2] = n;
                                                                            break G;
                                                                        }
                                                                        F[h + (F[h + 16 >> 2] == (e | 0) ? 16 : 20) >> 2] = b;
                                                                        if (!b) {
                                                                            break G;
                                                                        }
                                                                    }
                                                                    F[b + 24 >> 2] = h;
                                                                    a = F[e + 16 >> 2];
                                                                    if (a) {
                                                                        F[b + 16 >> 2] = a;
                                                                        F[a + 24 >> 2] = b;
                                                                    }
                                                                    a = F[e + 20 >> 2];
                                                                    if (!a) {
                                                                        break G;
                                                                    }
                                                                    F[b + 20 >> 2] = a;
                                                                    F[a + 24 >> 2] = b;
                                                                }
                                                                e = e + g | 0;
                                                                c = c + g | 0;
                                                            }
                                                            F[e + 4 >> 2] = F[e + 4 >> 2] & -2;
                                                            F[i + 4 >> 2] = c | 1;
                                                            F[c + i >> 2] = c;
                                                            if (c >>> 0 <= 255) {
                                                                a = c >>> 3 | 0;
                                                                b = (a << 3) + 16972 | 0;
                                                                c = F[4233];
                                                                a = 1 << a;
                                                                K: {
                                                                    if (!(c & a)) {
                                                                        F[4233] = a | c;
                                                                        a = b;
                                                                        break K;
                                                                    }
                                                                    a = F[b + 8 >> 2];
                                                                }
                                                                F[b + 8 >> 2] = i;
                                                                F[a + 12 >> 2] = i;
                                                                F[i + 12 >> 2] = b;
                                                                F[i + 8 >> 2] = a;
                                                                break B;
                                                            }
                                                            a = 31;
                                                            if (c >>> 0 <= 16777215) {
                                                                a = c >>> 8 | 0;
                                                                f = a + 1048320 >>> 16 & 8;
                                                                a = a << f;
                                                                d = a + 520192 >>> 16 & 4;
                                                                a = a << d;
                                                                b = a + 245760 >>> 16 & 2;
                                                                a = (a << b >>> 15 | 0) - (b | (d | f)) | 0;
                                                                a = (a << 1 | c >>> a + 21 & 1) + 28 | 0;
                                                            }
                                                            F[i + 28 >> 2] = a;
                                                            F[i + 16 >> 2] = 0;
                                                            F[i + 20 >> 2] = 0;
                                                            f = (a << 2) + 17236 | 0;
                                                            d = F[4234];
                                                            b = 1 << a;
                                                            L: {
                                                                if (!(d & b)) {
                                                                    F[4234] = b | d;
                                                                    F[f >> 2] = i;
                                                                    F[i + 24 >> 2] = f;
                                                                    break L;
                                                                }
                                                                a = c << ((a | 0) == 31 ? 0 : 25 - (a >>> 1 | 0) | 0);
                                                                b = F[f >> 2];
                                                                while (1) {
                                                                    d = b;
                                                                    if ((F[b + 4 >> 2] & -8) == (c | 0)) {
                                                                        break C;
                                                                    }
                                                                    b = a >>> 29 | 0;
                                                                    a = a << 1;
                                                                    f = d + (b & 4) | 0;
                                                                    b = F[f + 16 >> 2];
                                                                    if (b) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                F[f + 16 >> 2] = i;
                                                                F[i + 24 >> 2] = d;
                                                            }
                                                            F[i + 12 >> 2] = i;
                                                            F[i + 8 >> 2] = i;
                                                            break B;
                                                        }
                                                        d = e - 40 | 0;
                                                        a = b + 8 & 7 ? -8 - b & 7 : 0;
                                                        c = d - a | 0;
                                                        F[4236] = c;
                                                        a = a + b | 0;
                                                        F[4239] = a;
                                                        F[a + 4 >> 2] = c | 1;
                                                        F[(b + d | 0) + 4 >> 2] = 40;
                                                        F[4240] = F[4355];
                                                        a = (f + (f - 39 & 7 ? 39 - f & 7 : 0) | 0) - 47 | 0;
                                                        c = a >>> 0 < g + 16 >>> 0 ? g : a;
                                                        F[c + 4 >> 2] = 27;
                                                        a = F[4348];
                                                        F[c + 16 >> 2] = F[4347];
                                                        F[c + 20 >> 2] = a;
                                                        a = F[4346];
                                                        F[c + 8 >> 2] = F[4345];
                                                        F[c + 12 >> 2] = a;
                                                        F[4347] = c + 8;
                                                        F[4346] = e;
                                                        F[4345] = b;
                                                        F[4348] = 0;
                                                        a = c + 24 | 0;
                                                        while (1) {
                                                            F[a + 4 >> 2] = 7;
                                                            b = a + 8 | 0;
                                                            a = a + 4 | 0;
                                                            if (b >>> 0 < f >>> 0) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        if ((c | 0) == (g | 0)) {
                                                            break x;
                                                        }
                                                        F[c + 4 >> 2] = F[c + 4 >> 2] & -2;
                                                        f = c - g | 0;
                                                        F[g + 4 >> 2] = f | 1;
                                                        F[c >> 2] = f;
                                                        if (f >>> 0 <= 255) {
                                                            a = f >>> 3 | 0;
                                                            b = (a << 3) + 16972 | 0;
                                                            c = F[4233];
                                                            a = 1 << a;
                                                            M: {
                                                                if (!(c & a)) {
                                                                    F[4233] = a | c;
                                                                    a = b;
                                                                    break M;
                                                                }
                                                                a = F[b + 8 >> 2];
                                                            }
                                                            F[b + 8 >> 2] = g;
                                                            F[a + 12 >> 2] = g;
                                                            F[g + 12 >> 2] = b;
                                                            F[g + 8 >> 2] = a;
                                                            break x;
                                                        }
                                                        a = 31;
                                                        F[g + 16 >> 2] = 0;
                                                        F[g + 20 >> 2] = 0;
                                                        if (f >>> 0 <= 16777215) {
                                                            a = f >>> 8 | 0;
                                                            d = a + 1048320 >>> 16 & 8;
                                                            a = a << d;
                                                            c = a + 520192 >>> 16 & 4;
                                                            a = a << c;
                                                            b = a + 245760 >>> 16 & 2;
                                                            a = (a << b >>> 15 | 0) - (b | (c | d)) | 0;
                                                            a = (a << 1 | f >>> a + 21 & 1) + 28 | 0;
                                                        }
                                                        F[g + 28 >> 2] = a;
                                                        d = (a << 2) + 17236 | 0;
                                                        c = F[4234];
                                                        b = 1 << a;
                                                        N: {
                                                            if (!(c & b)) {
                                                                F[4234] = b | c;
                                                                F[d >> 2] = g;
                                                                F[g + 24 >> 2] = d;
                                                                break N;
                                                            }
                                                            a = f << ((a | 0) == 31 ? 0 : 25 - (a >>> 1 | 0) | 0);
                                                            b = F[d >> 2];
                                                            while (1) {
                                                                c = b;
                                                                if ((f | 0) == (F[b + 4 >> 2] & -8)) {
                                                                    break A;
                                                                }
                                                                b = a >>> 29 | 0;
                                                                a = a << 1;
                                                                d = c + (b & 4) | 0;
                                                                b = F[d + 16 >> 2];
                                                                if (b) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                            F[d + 16 >> 2] = g;
                                                            F[g + 24 >> 2] = c;
                                                        }
                                                        F[g + 12 >> 2] = g;
                                                        F[g + 8 >> 2] = g;
                                                        break x;
                                                    }
                                                    a = F[d + 8 >> 2];
                                                    F[a + 12 >> 2] = i;
                                                    F[d + 8 >> 2] = i;
                                                    F[i + 24 >> 2] = 0;
                                                    F[i + 12 >> 2] = d;
                                                    F[i + 8 >> 2] = a;
                                                }
                                                a = j + 8 | 0;
                                                break a;
                                            }
                                            a = F[c + 8 >> 2];
                                            F[a + 12 >> 2] = g;
                                            F[c + 8 >> 2] = g;
                                            F[g + 24 >> 2] = 0;
                                            F[g + 12 >> 2] = c;
                                            F[g + 8 >> 2] = a;
                                        }
                                        a = F[4236];
                                        if (a >>> 0 <= h >>> 0) {
                                            break d;
                                        }
                                        b = a - h | 0;
                                        F[4236] = b;
                                        c = F[4239];
                                        a = c + h | 0;
                                        F[4239] = a;
                                        F[a + 4 >> 2] = b | 1;
                                        F[c + 4 >> 2] = h | 3;
                                        a = c + 8 | 0;
                                        break a;
                                    }
                                    F[4190] = 48;
                                    a = 0;
                                    break a;
                                }
                                O: {
                                    if (!e) {
                                        break O;
                                    }
                                    c = F[f + 28 >> 2];
                                    a = (c << 2) + 17236 | 0;
                                    P: {
                                        if (F[a >> 2] == (f | 0)) {
                                            F[a >> 2] = b;
                                            if (b) {
                                                break P;
                                            }
                                            j = Lj(c) & j;
                                            F[4234] = j;
                                            break O;
                                        }
                                        F[e + (F[e + 16 >> 2] == (f | 0) ? 16 : 20) >> 2] = b;
                                        if (!b) {
                                            break O;
                                        }
                                    }
                                    F[b + 24 >> 2] = e;
                                    a = F[f + 16 >> 2];
                                    if (a) {
                                        F[b + 16 >> 2] = a;
                                        F[a + 24 >> 2] = b;
                                    }
                                    a = F[f + 20 >> 2];
                                    if (!a) {
                                        break O;
                                    }
                                    F[b + 20 >> 2] = a;
                                    F[a + 24 >> 2] = b;
                                }
                                Q: {
                                    if (d >>> 0 <= 15) {
                                        a = d + h | 0;
                                        F[f + 4 >> 2] = a | 3;
                                        a = a + f | 0;
                                        F[a + 4 >> 2] = F[a + 4 >> 2] | 1;
                                        break Q;
                                    }
                                    F[f + 4 >> 2] = h | 3;
                                    e = f + h | 0;
                                    F[e + 4 >> 2] = d | 1;
                                    F[d + e >> 2] = d;
                                    if (d >>> 0 <= 255) {
                                        a = d >>> 3 | 0;
                                        b = (a << 3) + 16972 | 0;
                                        c = F[4233];
                                        a = 1 << a;
                                        R: {
                                            if (!(c & a)) {
                                                F[4233] = a | c;
                                                a = b;
                                                break R;
                                            }
                                            a = F[b + 8 >> 2];
                                        }
                                        F[b + 8 >> 2] = e;
                                        F[a + 12 >> 2] = e;
                                        F[e + 12 >> 2] = b;
                                        F[e + 8 >> 2] = a;
                                        break Q;
                                    }
                                    a = 31;
                                    if (d >>> 0 <= 16777215) {
                                        a = d >>> 8 | 0;
                                        g = a + 1048320 >>> 16 & 8;
                                        a = a << g;
                                        c = a + 520192 >>> 16 & 4;
                                        a = a << c;
                                        b = a + 245760 >>> 16 & 2;
                                        a = (a << b >>> 15 | 0) - (b | (c | g)) | 0;
                                        a = (a << 1 | d >>> a + 21 & 1) + 28 | 0;
                                    }
                                    F[e + 28 >> 2] = a;
                                    F[e + 16 >> 2] = 0;
                                    F[e + 20 >> 2] = 0;
                                    b = (a << 2) + 17236 | 0;
                                    S: {
                                        c = 1 << a;
                                        T: {
                                            if (!(c & j)) {
                                                F[4234] = c | j;
                                                F[b >> 2] = e;
                                                break T;
                                            }
                                            a = d << ((a | 0) == 31 ? 0 : 25 - (a >>> 1 | 0) | 0);
                                            h = F[b >> 2];
                                            while (1) {
                                                b = h;
                                                if ((F[b + 4 >> 2] & -8) == (d | 0)) {
                                                    break S;
                                                }
                                                c = a >>> 29 | 0;
                                                a = a << 1;
                                                c = (c & 4) + b | 0;
                                                h = F[c + 16 >> 2];
                                                if (h) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            F[c + 16 >> 2] = e;
                                        }
                                        F[e + 24 >> 2] = b;
                                        F[e + 12 >> 2] = e;
                                        F[e + 8 >> 2] = e;
                                        break Q;
                                    }
                                    a = F[b + 8 >> 2];
                                    F[a + 12 >> 2] = e;
                                    F[b + 8 >> 2] = e;
                                    F[e + 24 >> 2] = 0;
                                    F[e + 12 >> 2] = b;
                                    F[e + 8 >> 2] = a;
                                }
                                a = f + 8 | 0;
                                break a;
                            }
                            U: {
                                if (!i) {
                                    break U;
                                }
                                c = F[b + 28 >> 2];
                                a = (c << 2) + 17236 | 0;
                                V: {
                                    if (F[a >> 2] == (b | 0)) {
                                        F[a >> 2] = f;
                                        if (f) {
                                            break V;
                                        }
                                        m = 16936, n = Lj(c) & j, F[m >> 2] = n;
                                        break U;
                                    }
                                    F[i + (F[i + 16 >> 2] == (b | 0) ? 16 : 20) >> 2] = f;
                                    if (!f) {
                                        break U;
                                    }
                                }
                                F[f + 24 >> 2] = i;
                                a = F[b + 16 >> 2];
                                if (a) {
                                    F[f + 16 >> 2] = a;
                                    F[a + 24 >> 2] = f;
                                }
                                a = F[b + 20 >> 2];
                                if (!a) {
                                    break U;
                                }
                                F[f + 20 >> 2] = a;
                                F[a + 24 >> 2] = f;
                            }
                            W: {
                                if (d >>> 0 <= 15) {
                                    a = d + h | 0;
                                    F[b + 4 >> 2] = a | 3;
                                    a = a + b | 0;
                                    F[a + 4 >> 2] = F[a + 4 >> 2] | 1;
                                    break W;
                                }
                                F[b + 4 >> 2] = h | 3;
                                f = b + h | 0;
                                F[f + 4 >> 2] = d | 1;
                                F[d + f >> 2] = d;
                                if (k) {
                                    a = k >>> 3 | 0;
                                    c = (a << 3) + 16972 | 0;
                                    g = F[4238];
                                    a = 1 << a;
                                    X: {
                                        if (!(a & e)) {
                                            F[4233] = a | e;
                                            a = c;
                                            break X;
                                        }
                                        a = F[c + 8 >> 2];
                                    }
                                    F[c + 8 >> 2] = g;
                                    F[a + 12 >> 2] = g;
                                    F[g + 12 >> 2] = c;
                                    F[g + 8 >> 2] = a;
                                }
                                F[4238] = f;
                                F[4235] = d;
                            }
                            a = b + 8 | 0;
                        } ea = l + 16 | 0; return a | 0; }
                        function bf(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0; j = ea - 48 | 0; ea = j; a: {
                            if ((c | 0) != 1) {
                                break a;
                            }
                            f = F[a + 4 >> 2];
                            i = F[a + 12 >> 2];
                            F[j + 40 >> 2] = 0;
                            F[j + 32 >> 2] = 0;
                            F[j + 36 >> 2] = 0;
                            F[j + 24 >> 2] = 0;
                            F[j + 28 >> 2] = 0;
                            F[j + 16 >> 2] = 0;
                            F[j + 20 >> 2] = 0;
                            F[j + 8 >> 2] = 0;
                            F[j + 12 >> 2] = 0;
                            e = j + 8 | 0;
                            b: {
                                if ((b | 0) == -2) {
                                    break b;
                                }
                                m = F[F[F[f + 4 >> 2] + 8 >> 2] + (i << 2) >> 2];
                                if ((ga[F[F[f >> 2] + 8 >> 2]](f) | 0) == 1) {
                                    a = H[f + 36 >> 1];
                                    l = (a << 8 | a >>> 8) & 65535;
                                    a = 0;
                                    k = ea - 32 | 0;
                                    ea = k;
                                    g = F[F[F[f + 4 >> 2] + 8 >> 2] + (i << 2) >> 2];
                                    c: {
                                        if ((ga[F[F[f >> 2] + 8 >> 2]](f) | 0) != 1 | b - 1 >>> 0 > 5) {
                                            break c;
                                        }
                                        d = ga[F[F[f >> 2] + 36 >> 2]](f) | 0;
                                        h = ga[F[F[f >> 2] + 44 >> 2]](f, i) | 0;
                                        if (!d | !h) {
                                            break c;
                                        }
                                        c = ga[F[F[f >> 2] + 40 >> 2]](f, i) | 0;
                                        if (c) {
                                            a = F[f + 44 >> 2];
                                            F[k + 12 >> 2] = c;
                                            F[k + 8 >> 2] = a;
                                            F[k + 20 >> 2] = h;
                                            F[k + 16 >> 2] = h + 12;
                                            f = k + 8 | 0;
                                            a = 0;
                                            d: {
                                                e: {
                                                    f: {
                                                        switch (b - 1 | 0) {
                                                            case 0:
                                                                a = sa(60);
                                                                F[a + 4 >> 2] = g;
                                                                F[a >> 2] = 3300;
                                                                g = F[e + 8 >> 2];
                                                                h = F[e + 12 >> 2];
                                                                i = F[e + 16 >> 2];
                                                                d = F[e + 20 >> 2];
                                                                c = F[e >> 2];
                                                                b = F[e + 4 >> 2];
                                                                F[a + 40 >> 2] = 0;
                                                                F[a + 32 >> 2] = 0;
                                                                F[a + 36 >> 2] = 0;
                                                                F[a + 24 >> 2] = i;
                                                                F[a + 28 >> 2] = d;
                                                                F[a + 16 >> 2] = g;
                                                                F[a + 20 >> 2] = h;
                                                                F[a + 8 >> 2] = c;
                                                                F[a + 12 >> 2] = b;
                                                                b = F[e + 24 >> 2];
                                                                d = F[e + 28 >> 2] - b | 0;
                                                                if (d) {
                                                                    if ((d | 0) < 0) {
                                                                        break e;
                                                                    }
                                                                    c = sa(d);
                                                                    F[a + 32 >> 2] = c;
                                                                    F[a + 40 >> 2] = c + (d >> 2 << 2);
                                                                    n = a, o = ta(c, b, d) + d | 0, F[n + 36 >> 2] = o;
                                                                }
                                                                b = F[f + 4 >> 2];
                                                                F[a + 44 >> 2] = F[f >> 2];
                                                                F[a + 48 >> 2] = b;
                                                                b = F[f + 12 >> 2];
                                                                F[a + 52 >> 2] = F[f + 8 >> 2];
                                                                F[a + 56 >> 2] = b;
                                                                F[a >> 2] = 2592;
                                                                break d;
                                                            case 1:
                                                                a = sa(60);
                                                                F[a + 4 >> 2] = g;
                                                                F[a >> 2] = 3300;
                                                                g = F[e + 8 >> 2];
                                                                h = F[e + 12 >> 2];
                                                                i = F[e + 16 >> 2];
                                                                d = F[e + 20 >> 2];
                                                                c = F[e >> 2];
                                                                b = F[e + 4 >> 2];
                                                                F[a + 40 >> 2] = 0;
                                                                F[a + 32 >> 2] = 0;
                                                                F[a + 36 >> 2] = 0;
                                                                F[a + 24 >> 2] = i;
                                                                F[a + 28 >> 2] = d;
                                                                F[a + 16 >> 2] = g;
                                                                F[a + 20 >> 2] = h;
                                                                F[a + 8 >> 2] = c;
                                                                F[a + 12 >> 2] = b;
                                                                b = F[e + 24 >> 2];
                                                                d = F[e + 28 >> 2] - b | 0;
                                                                if (d) {
                                                                    if ((d | 0) < 0) {
                                                                        break e;
                                                                    }
                                                                    c = sa(d);
                                                                    F[a + 32 >> 2] = c;
                                                                    F[a + 40 >> 2] = c + (d >> 2 << 2);
                                                                    n = a, o = ta(c, b, d) + d | 0, F[n + 36 >> 2] = o;
                                                                }
                                                                b = F[f + 4 >> 2];
                                                                F[a + 44 >> 2] = F[f >> 2];
                                                                F[a + 48 >> 2] = b;
                                                                b = F[f + 12 >> 2];
                                                                F[a + 52 >> 2] = F[f + 8 >> 2];
                                                                F[a + 56 >> 2] = b;
                                                                F[a >> 2] = 3356;
                                                                break d;
                                                            case 3:
                                                                a = sa(112);
                                                                F[a + 4 >> 2] = g;
                                                                F[a >> 2] = 3300;
                                                                g = F[e + 8 >> 2];
                                                                h = F[e + 12 >> 2];
                                                                i = F[e + 16 >> 2];
                                                                d = F[e + 20 >> 2];
                                                                c = F[e >> 2];
                                                                b = F[e + 4 >> 2];
                                                                F[a + 40 >> 2] = 0;
                                                                F[a + 32 >> 2] = 0;
                                                                F[a + 36 >> 2] = 0;
                                                                F[a + 24 >> 2] = i;
                                                                F[a + 28 >> 2] = d;
                                                                F[a + 16 >> 2] = g;
                                                                F[a + 20 >> 2] = h;
                                                                F[a + 8 >> 2] = c;
                                                                F[a + 12 >> 2] = b;
                                                                b = F[e + 24 >> 2];
                                                                d = F[e + 28 >> 2] - b | 0;
                                                                if (d) {
                                                                    if ((d | 0) < 0) {
                                                                        break e;
                                                                    }
                                                                    c = sa(d);
                                                                    F[a + 32 >> 2] = c;
                                                                    F[a + 40 >> 2] = c + (d >> 2 << 2);
                                                                    n = a, o = ta(c, b, d) + d | 0, F[n + 36 >> 2] = o;
                                                                }
                                                                b = F[f + 4 >> 2];
                                                                F[a + 44 >> 2] = F[f >> 2];
                                                                F[a + 48 >> 2] = b;
                                                                b = F[f + 12 >> 2];
                                                                F[a + 52 >> 2] = F[f + 8 >> 2];
                                                                F[a + 56 >> 2] = b;
                                                                F[a + 60 >> 2] = 0;
                                                                F[a + 64 >> 2] = 0;
                                                                F[a >> 2] = 3592;
                                                                F[a + 68 >> 2] = 0;
                                                                F[a + 72 >> 2] = 0;
                                                                F[a + 76 >> 2] = 0;
                                                                F[a + 80 >> 2] = 0;
                                                                F[a + 84 >> 2] = 0;
                                                                F[a + 88 >> 2] = 0;
                                                                F[a + 92 >> 2] = 0;
                                                                F[a + 96 >> 2] = 0;
                                                                F[a + 100 >> 2] = 0;
                                                                F[a + 104 >> 2] = 0;
                                                                F[a + 108 >> 2] = 0;
                                                                break d;
                                                            case 2:
                                                                a = sa(92);
                                                                F[a + 4 >> 2] = g;
                                                                F[a >> 2] = 3300;
                                                                g = F[e + 8 >> 2];
                                                                h = F[e + 12 >> 2];
                                                                i = F[e + 16 >> 2];
                                                                d = F[e + 20 >> 2];
                                                                c = F[e >> 2];
                                                                b = F[e + 4 >> 2];
                                                                F[a + 40 >> 2] = 0;
                                                                F[a + 32 >> 2] = 0;
                                                                F[a + 36 >> 2] = 0;
                                                                F[a + 24 >> 2] = i;
                                                                F[a + 28 >> 2] = d;
                                                                F[a + 16 >> 2] = g;
                                                                F[a + 20 >> 2] = h;
                                                                F[a + 8 >> 2] = c;
                                                                F[a + 12 >> 2] = b;
                                                                b = F[e + 24 >> 2];
                                                                d = F[e + 28 >> 2] - b | 0;
                                                                if (d) {
                                                                    if ((d | 0) < 0) {
                                                                        break e;
                                                                    }
                                                                    c = sa(d);
                                                                    F[a + 32 >> 2] = c;
                                                                    F[a + 40 >> 2] = c + (d >> 2 << 2);
                                                                    n = a, o = ta(c, b, d) + d | 0, F[n + 36 >> 2] = o;
                                                                }
                                                                b = F[f + 4 >> 2];
                                                                F[a + 44 >> 2] = F[f >> 2];
                                                                F[a + 48 >> 2] = b;
                                                                b = F[f + 12 >> 2];
                                                                F[a + 52 >> 2] = F[f + 8 >> 2];
                                                                F[a + 56 >> 2] = b;
                                                                F[a + 60 >> 2] = 0;
                                                                F[a + 64 >> 2] = 0;
                                                                F[a >> 2] = 3840;
                                                                F[a + 68 >> 2] = 0;
                                                                F[a + 72 >> 2] = 0;
                                                                F[a + 76 >> 2] = 0;
                                                                F[a + 80 >> 2] = 0;
                                                                F[a + 84 >> 2] = 0;
                                                                F[a + 88 >> 2] = l;
                                                                break d;
                                                            case 4:
                                                                a = sa(104);
                                                                F[a + 4 >> 2] = g;
                                                                F[a >> 2] = 3300;
                                                                g = F[e + 8 >> 2];
                                                                h = F[e + 12 >> 2];
                                                                i = F[e + 16 >> 2];
                                                                d = F[e + 20 >> 2];
                                                                c = F[e >> 2];
                                                                b = F[e + 4 >> 2];
                                                                F[a + 40 >> 2] = 0;
                                                                F[a + 32 >> 2] = 0;
                                                                F[a + 36 >> 2] = 0;
                                                                F[a + 24 >> 2] = i;
                                                                F[a + 28 >> 2] = d;
                                                                F[a + 16 >> 2] = g;
                                                                F[a + 20 >> 2] = h;
                                                                F[a + 8 >> 2] = c;
                                                                F[a + 12 >> 2] = b;
                                                                b = F[e + 24 >> 2];
                                                                d = F[e + 28 >> 2] - b | 0;
                                                                if (d) {
                                                                    if ((d | 0) < 0) {
                                                                        break e;
                                                                    }
                                                                    c = sa(d);
                                                                    F[a + 32 >> 2] = c;
                                                                    F[a + 40 >> 2] = c + (d >> 2 << 2);
                                                                    n = a, o = ta(c, b, d) + d | 0, F[n + 36 >> 2] = o;
                                                                }
                                                                b = F[f + 4 >> 2];
                                                                F[a + 44 >> 2] = F[f >> 2];
                                                                F[a + 48 >> 2] = b;
                                                                c = F[f + 8 >> 2];
                                                                b = F[f + 12 >> 2];
                                                                F[a + 84 >> 2] = 0;
                                                                F[a + 76 >> 2] = 0;
                                                                F[a + 80 >> 2] = 0;
                                                                F[a + 60 >> 2] = 0;
                                                                F[a + 64 >> 2] = 0;
                                                                F[a >> 2] = 4068;
                                                                F[a + 52 >> 2] = c;
                                                                F[a + 56 >> 2] = b;
                                                                b = F[f + 4 >> 2];
                                                                F[a + 88 >> 2] = F[f >> 2];
                                                                F[a + 92 >> 2] = b;
                                                                b = F[f + 12 >> 2];
                                                                F[a + 96 >> 2] = F[f + 8 >> 2];
                                                                F[a + 100 >> 2] = b;
                                                                break d;
                                                            case 5: break f;
                                                            default: break d;
                                                        }
                                                    }
                                                    a = sa(128);
                                                    F[a + 4 >> 2] = g;
                                                    F[a >> 2] = 3300;
                                                    g = F[e + 8 >> 2];
                                                    h = F[e + 12 >> 2];
                                                    i = F[e + 16 >> 2];
                                                    d = F[e + 20 >> 2];
                                                    c = F[e >> 2];
                                                    b = F[e + 4 >> 2];
                                                    F[a + 40 >> 2] = 0;
                                                    F[a + 32 >> 2] = 0;
                                                    F[a + 36 >> 2] = 0;
                                                    F[a + 24 >> 2] = i;
                                                    F[a + 28 >> 2] = d;
                                                    F[a + 16 >> 2] = g;
                                                    F[a + 20 >> 2] = h;
                                                    F[a + 8 >> 2] = c;
                                                    F[a + 12 >> 2] = b;
                                                    g: {
                                                        h: {
                                                            c = F[e + 28 >> 2] - F[e + 24 >> 2] | 0;
                                                            if (c) {
                                                                if ((c | 0) < 0) {
                                                                    break h;
                                                                }
                                                                b = sa(c);
                                                                F[a + 32 >> 2] = b;
                                                                F[a + 36 >> 2] = b;
                                                                F[a + 40 >> 2] = b + (c >> 2 << 2);
                                                                c = F[e + 24 >> 2];
                                                                d = F[e + 28 >> 2] - c | 0;
                                                                if ((d | 0) > 0) {
                                                                    b = ta(b, c, d) + d | 0;
                                                                }
                                                                F[a + 36 >> 2] = b;
                                                            }
                                                            F[a >> 2] = 3244;
                                                            b = F[f + 4 >> 2];
                                                            F[a + 44 >> 2] = F[f >> 2];
                                                            F[a + 48 >> 2] = b;
                                                            b = F[f + 12 >> 2];
                                                            F[a + 52 >> 2] = F[f + 8 >> 2];
                                                            F[a + 56 >> 2] = b;
                                                            b = a - -64 | 0;
                                                            F[b >> 2] = 0;
                                                            F[b + 4 >> 2] = 0;
                                                            F[a + 60 >> 2] = 4932;
                                                            F[a >> 2] = 4304;
                                                            b = F[f + 4 >> 2];
                                                            F[a + 72 >> 2] = F[f >> 2];
                                                            F[a + 76 >> 2] = b;
                                                            b = F[f + 12 >> 2];
                                                            F[a + 80 >> 2] = F[f + 8 >> 2];
                                                            F[a + 84 >> 2] = b;
                                                            F[a + 104 >> 2] = 1065353216;
                                                            F[a + 108 >> 2] = -1;
                                                            F[a + 96 >> 2] = -1;
                                                            F[a + 100 >> 2] = -1;
                                                            F[a + 88 >> 2] = 1;
                                                            F[a + 92 >> 2] = -1;
                                                            F[a + 60 >> 2] = 4540;
                                                            F[a + 112 >> 2] = 0;
                                                            F[a + 116 >> 2] = 0;
                                                            D[a + 117 | 0] = 0;
                                                            D[a + 118 | 0] = 0;
                                                            D[a + 119 | 0] = 0;
                                                            D[a + 120 | 0] = 0;
                                                            D[a + 121 | 0] = 0;
                                                            D[a + 122 | 0] = 0;
                                                            D[a + 123 | 0] = 0;
                                                            D[a + 124 | 0] = 0;
                                                            break g;
                                                        }
                                                        va();
                                                        V();
                                                    }
                                                    break d;
                                                }
                                                va();
                                                V();
                                            }
                                            break c;
                                        }
                                        a = F[f + 44 >> 2];
                                        F[k + 12 >> 2] = d;
                                        F[k + 8 >> 2] = a;
                                        F[k + 20 >> 2] = h;
                                        F[k + 16 >> 2] = h + 12;
                                        f = k + 8 | 0;
                                        a = 0;
                                        i: {
                                            j: {
                                                k: {
                                                    switch (b - 1 | 0) {
                                                        case 0:
                                                            a = sa(60);
                                                            F[a + 4 >> 2] = g;
                                                            F[a >> 2] = 3300;
                                                            g = F[e + 8 >> 2];
                                                            h = F[e + 12 >> 2];
                                                            i = F[e + 16 >> 2];
                                                            d = F[e + 20 >> 2];
                                                            c = F[e >> 2];
                                                            b = F[e + 4 >> 2];
                                                            F[a + 40 >> 2] = 0;
                                                            F[a + 32 >> 2] = 0;
                                                            F[a + 36 >> 2] = 0;
                                                            F[a + 24 >> 2] = i;
                                                            F[a + 28 >> 2] = d;
                                                            F[a + 16 >> 2] = g;
                                                            F[a + 20 >> 2] = h;
                                                            F[a + 8 >> 2] = c;
                                                            F[a + 12 >> 2] = b;
                                                            b = F[e + 24 >> 2];
                                                            d = F[e + 28 >> 2] - b | 0;
                                                            if (d) {
                                                                if ((d | 0) < 0) {
                                                                    break j;
                                                                }
                                                                c = sa(d);
                                                                F[a + 32 >> 2] = c;
                                                                F[a + 40 >> 2] = c + (d >> 2 << 2);
                                                                n = a, o = ta(c, b, d) + d | 0, F[n + 36 >> 2] = o;
                                                            }
                                                            b = F[f + 4 >> 2];
                                                            F[a + 44 >> 2] = F[f >> 2];
                                                            F[a + 48 >> 2] = b;
                                                            b = F[f + 12 >> 2];
                                                            F[a + 52 >> 2] = F[f + 8 >> 2];
                                                            F[a + 56 >> 2] = b;
                                                            F[a >> 2] = 4960;
                                                            break i;
                                                        case 1:
                                                            a = sa(60);
                                                            F[a + 4 >> 2] = g;
                                                            F[a >> 2] = 3300;
                                                            g = F[e + 8 >> 2];
                                                            h = F[e + 12 >> 2];
                                                            i = F[e + 16 >> 2];
                                                            d = F[e + 20 >> 2];
                                                            c = F[e >> 2];
                                                            b = F[e + 4 >> 2];
                                                            F[a + 40 >> 2] = 0;
                                                            F[a + 32 >> 2] = 0;
                                                            F[a + 36 >> 2] = 0;
                                                            F[a + 24 >> 2] = i;
                                                            F[a + 28 >> 2] = d;
                                                            F[a + 16 >> 2] = g;
                                                            F[a + 20 >> 2] = h;
                                                            F[a + 8 >> 2] = c;
                                                            F[a + 12 >> 2] = b;
                                                            b = F[e + 24 >> 2];
                                                            d = F[e + 28 >> 2] - b | 0;
                                                            if (d) {
                                                                if ((d | 0) < 0) {
                                                                    break j;
                                                                }
                                                                c = sa(d);
                                                                F[a + 32 >> 2] = c;
                                                                F[a + 40 >> 2] = c + (d >> 2 << 2);
                                                                n = a, o = ta(c, b, d) + d | 0, F[n + 36 >> 2] = o;
                                                            }
                                                            b = F[f + 4 >> 2];
                                                            F[a + 44 >> 2] = F[f >> 2];
                                                            F[a + 48 >> 2] = b;
                                                            b = F[f + 12 >> 2];
                                                            F[a + 52 >> 2] = F[f + 8 >> 2];
                                                            F[a + 56 >> 2] = b;
                                                            F[a >> 2] = 5384;
                                                            break i;
                                                        case 3:
                                                            a = sa(112);
                                                            F[a + 4 >> 2] = g;
                                                            F[a >> 2] = 3300;
                                                            g = F[e + 8 >> 2];
                                                            h = F[e + 12 >> 2];
                                                            i = F[e + 16 >> 2];
                                                            d = F[e + 20 >> 2];
                                                            c = F[e >> 2];
                                                            b = F[e + 4 >> 2];
                                                            F[a + 40 >> 2] = 0;
                                                            F[a + 32 >> 2] = 0;
                                                            F[a + 36 >> 2] = 0;
                                                            F[a + 24 >> 2] = i;
                                                            F[a + 28 >> 2] = d;
                                                            F[a + 16 >> 2] = g;
                                                            F[a + 20 >> 2] = h;
                                                            F[a + 8 >> 2] = c;
                                                            F[a + 12 >> 2] = b;
                                                            b = F[e + 24 >> 2];
                                                            d = F[e + 28 >> 2] - b | 0;
                                                            if (d) {
                                                                if ((d | 0) < 0) {
                                                                    break j;
                                                                }
                                                                c = sa(d);
                                                                F[a + 32 >> 2] = c;
                                                                F[a + 40 >> 2] = c + (d >> 2 << 2);
                                                                n = a, o = ta(c, b, d) + d | 0, F[n + 36 >> 2] = o;
                                                            }
                                                            b = F[f + 4 >> 2];
                                                            F[a + 44 >> 2] = F[f >> 2];
                                                            F[a + 48 >> 2] = b;
                                                            b = F[f + 12 >> 2];
                                                            F[a + 52 >> 2] = F[f + 8 >> 2];
                                                            F[a + 56 >> 2] = b;
                                                            F[a + 60 >> 2] = 0;
                                                            F[a + 64 >> 2] = 0;
                                                            F[a >> 2] = 5608;
                                                            F[a + 68 >> 2] = 0;
                                                            F[a + 72 >> 2] = 0;
                                                            F[a + 76 >> 2] = 0;
                                                            F[a + 80 >> 2] = 0;
                                                            F[a + 84 >> 2] = 0;
                                                            F[a + 88 >> 2] = 0;
                                                            F[a + 92 >> 2] = 0;
                                                            F[a + 96 >> 2] = 0;
                                                            F[a + 100 >> 2] = 0;
                                                            F[a + 104 >> 2] = 0;
                                                            F[a + 108 >> 2] = 0;
                                                            break i;
                                                        case 2:
                                                            a = sa(92);
                                                            F[a + 4 >> 2] = g;
                                                            F[a >> 2] = 3300;
                                                            g = F[e + 8 >> 2];
                                                            h = F[e + 12 >> 2];
                                                            i = F[e + 16 >> 2];
                                                            d = F[e + 20 >> 2];
                                                            c = F[e >> 2];
                                                            b = F[e + 4 >> 2];
                                                            F[a + 40 >> 2] = 0;
                                                            F[a + 32 >> 2] = 0;
                                                            F[a + 36 >> 2] = 0;
                                                            F[a + 24 >> 2] = i;
                                                            F[a + 28 >> 2] = d;
                                                            F[a + 16 >> 2] = g;
                                                            F[a + 20 >> 2] = h;
                                                            F[a + 8 >> 2] = c;
                                                            F[a + 12 >> 2] = b;
                                                            b = F[e + 24 >> 2];
                                                            d = F[e + 28 >> 2] - b | 0;
                                                            if (d) {
                                                                if ((d | 0) < 0) {
                                                                    break j;
                                                                }
                                                                c = sa(d);
                                                                F[a + 32 >> 2] = c;
                                                                F[a + 40 >> 2] = c + (d >> 2 << 2);
                                                                n = a, o = ta(c, b, d) + d | 0, F[n + 36 >> 2] = o;
                                                            }
                                                            b = F[f + 4 >> 2];
                                                            F[a + 44 >> 2] = F[f >> 2];
                                                            F[a + 48 >> 2] = b;
                                                            b = F[f + 12 >> 2];
                                                            F[a + 52 >> 2] = F[f + 8 >> 2];
                                                            F[a + 56 >> 2] = b;
                                                            F[a + 60 >> 2] = 0;
                                                            F[a + 64 >> 2] = 0;
                                                            F[a >> 2] = 5844;
                                                            F[a + 68 >> 2] = 0;
                                                            F[a + 72 >> 2] = 0;
                                                            F[a + 76 >> 2] = 0;
                                                            F[a + 80 >> 2] = 0;
                                                            F[a + 84 >> 2] = 0;
                                                            F[a + 88 >> 2] = l;
                                                            break i;
                                                        case 4:
                                                            a = sa(104);
                                                            F[a + 4 >> 2] = g;
                                                            F[a >> 2] = 3300;
                                                            g = F[e + 8 >> 2];
                                                            h = F[e + 12 >> 2];
                                                            i = F[e + 16 >> 2];
                                                            d = F[e + 20 >> 2];
                                                            c = F[e >> 2];
                                                            b = F[e + 4 >> 2];
                                                            F[a + 40 >> 2] = 0;
                                                            F[a + 32 >> 2] = 0;
                                                            F[a + 36 >> 2] = 0;
                                                            F[a + 24 >> 2] = i;
                                                            F[a + 28 >> 2] = d;
                                                            F[a + 16 >> 2] = g;
                                                            F[a + 20 >> 2] = h;
                                                            F[a + 8 >> 2] = c;
                                                            F[a + 12 >> 2] = b;
                                                            b = F[e + 24 >> 2];
                                                            d = F[e + 28 >> 2] - b | 0;
                                                            if (d) {
                                                                if ((d | 0) < 0) {
                                                                    break j;
                                                                }
                                                                c = sa(d);
                                                                F[a + 32 >> 2] = c;
                                                                F[a + 40 >> 2] = c + (d >> 2 << 2);
                                                                n = a, o = ta(c, b, d) + d | 0, F[n + 36 >> 2] = o;
                                                            }
                                                            b = F[f + 4 >> 2];
                                                            F[a + 44 >> 2] = F[f >> 2];
                                                            F[a + 48 >> 2] = b;
                                                            c = F[f + 8 >> 2];
                                                            b = F[f + 12 >> 2];
                                                            F[a + 84 >> 2] = 0;
                                                            F[a + 76 >> 2] = 0;
                                                            F[a + 80 >> 2] = 0;
                                                            F[a + 60 >> 2] = 0;
                                                            F[a + 64 >> 2] = 0;
                                                            F[a >> 2] = 6060;
                                                            F[a + 52 >> 2] = c;
                                                            F[a + 56 >> 2] = b;
                                                            b = F[f + 4 >> 2];
                                                            F[a + 88 >> 2] = F[f >> 2];
                                                            F[a + 92 >> 2] = b;
                                                            b = F[f + 12 >> 2];
                                                            F[a + 96 >> 2] = F[f + 8 >> 2];
                                                            F[a + 100 >> 2] = b;
                                                            break i;
                                                        case 5: break k;
                                                        default: break i;
                                                    }
                                                }
                                                a = sa(128);
                                                F[a + 4 >> 2] = g;
                                                F[a >> 2] = 3300;
                                                g = F[e + 8 >> 2];
                                                h = F[e + 12 >> 2];
                                                i = F[e + 16 >> 2];
                                                d = F[e + 20 >> 2];
                                                c = F[e >> 2];
                                                b = F[e + 4 >> 2];
                                                F[a + 40 >> 2] = 0;
                                                F[a + 32 >> 2] = 0;
                                                F[a + 36 >> 2] = 0;
                                                F[a + 24 >> 2] = i;
                                                F[a + 28 >> 2] = d;
                                                F[a + 16 >> 2] = g;
                                                F[a + 20 >> 2] = h;
                                                F[a + 8 >> 2] = c;
                                                F[a + 12 >> 2] = b;
                                                l: {
                                                    m: {
                                                        c = F[e + 28 >> 2] - F[e + 24 >> 2] | 0;
                                                        if (c) {
                                                            if ((c | 0) < 0) {
                                                                break m;
                                                            }
                                                            b = sa(c);
                                                            F[a + 32 >> 2] = b;
                                                            F[a + 36 >> 2] = b;
                                                            F[a + 40 >> 2] = b + (c >> 2 << 2);
                                                            c = F[e + 24 >> 2];
                                                            d = F[e + 28 >> 2] - c | 0;
                                                            if ((d | 0) > 0) {
                                                                b = ta(b, c, d) + d | 0;
                                                            }
                                                            F[a + 36 >> 2] = b;
                                                        }
                                                        F[a >> 2] = 5328;
                                                        b = F[f + 4 >> 2];
                                                        F[a + 44 >> 2] = F[f >> 2];
                                                        F[a + 48 >> 2] = b;
                                                        b = F[f + 12 >> 2];
                                                        F[a + 52 >> 2] = F[f + 8 >> 2];
                                                        F[a + 56 >> 2] = b;
                                                        b = a - -64 | 0;
                                                        F[b >> 2] = 0;
                                                        F[b + 4 >> 2] = 0;
                                                        F[a + 60 >> 2] = 6868;
                                                        F[a >> 2] = 6284;
                                                        b = F[f + 4 >> 2];
                                                        F[a + 72 >> 2] = F[f >> 2];
                                                        F[a + 76 >> 2] = b;
                                                        b = F[f + 12 >> 2];
                                                        F[a + 80 >> 2] = F[f + 8 >> 2];
                                                        F[a + 84 >> 2] = b;
                                                        F[a + 104 >> 2] = 1065353216;
                                                        F[a + 108 >> 2] = -1;
                                                        F[a + 96 >> 2] = -1;
                                                        F[a + 100 >> 2] = -1;
                                                        F[a + 88 >> 2] = 1;
                                                        F[a + 92 >> 2] = -1;
                                                        F[a + 60 >> 2] = 6504;
                                                        F[a + 112 >> 2] = 0;
                                                        F[a + 116 >> 2] = 0;
                                                        D[a + 117 | 0] = 0;
                                                        D[a + 118 | 0] = 0;
                                                        D[a + 119 | 0] = 0;
                                                        D[a + 120 | 0] = 0;
                                                        D[a + 121 | 0] = 0;
                                                        D[a + 122 | 0] = 0;
                                                        D[a + 123 | 0] = 0;
                                                        D[a + 124 | 0] = 0;
                                                        break l;
                                                    }
                                                    va();
                                                    V();
                                                }
                                                break i;
                                            }
                                            va();
                                            V();
                                        }
                                    }
                                    ea = k + 32 | 0;
                                    d = a;
                                    if (a) {
                                        break b;
                                    }
                                }
                                d = sa(44);
                                F[d + 4 >> 2] = m;
                                F[d >> 2] = 3300;
                                g = F[e + 8 >> 2];
                                h = F[e + 12 >> 2];
                                i = F[e + 16 >> 2];
                                c = F[e + 20 >> 2];
                                b = F[e >> 2];
                                a = F[e + 4 >> 2];
                                F[d + 40 >> 2] = 0;
                                F[d + 32 >> 2] = 0;
                                F[d + 36 >> 2] = 0;
                                F[d + 24 >> 2] = i;
                                F[d + 28 >> 2] = c;
                                F[d + 16 >> 2] = g;
                                F[d + 20 >> 2] = h;
                                F[d + 8 >> 2] = b;
                                F[d + 12 >> 2] = a;
                                n: {
                                    a = F[e + 24 >> 2];
                                    c = F[e + 28 >> 2] - a | 0;
                                    if (c) {
                                        if ((c | 0) < 0) {
                                            break n;
                                        }
                                        b = sa(c);
                                        F[d + 32 >> 2] = b;
                                        F[d + 40 >> 2] = b + (c >> 2 << 2);
                                        n = d, o = ta(b, a, c) + c | 0, F[n + 36 >> 2] = o;
                                    }
                                    F[d >> 2] = 6896;
                                    break b;
                                }
                                va();
                                V();
                            }
                            a = F[j + 32 >> 2];
                            if (!a) {
                                break a;
                            }
                            F[j + 36 >> 2] = a;
                            ra(a);
                        } ea = j + 48 | 0; return d | 0; }
                        function $d(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0; k = ea - 48 | 0; ea = k; c = sa(8); F[c + 4 >> 2] = b; F[c >> 2] = 0; b = c + 8 | 0; F[k + 40 >> 2] = b; F[k + 36 >> 2] = b; F[k + 32 >> 2] = c; a: {
                            b: {
                                c: {
                                    d: {
                                        while (1) {
                                            b = b - 8 | 0;
                                            j = F[b + 4 >> 2];
                                            g = F[b >> 2];
                                            F[k + 36 >> 2] = b;
                                            if (g) {
                                                F[k + 24 >> 2] = 0;
                                                F[k + 16 >> 2] = 0;
                                                F[k + 20 >> 2] = 0;
                                                c = 1;
                                                b = F[a >> 2];
                                                e = F[b + 8 >> 2];
                                                h = F[b + 12 >> 2];
                                                d = F[b + 20 >> 2];
                                                f = F[b + 16 >> 2];
                                                e: {
                                                    if ((h | 0) <= (d | 0) & f >>> 0 >= e >>> 0 | (d | 0) > (h | 0)) {
                                                        break e;
                                                    }
                                                    e = G[f + F[b >> 2] | 0];
                                                    f = f + 1 | 0;
                                                    d = f ? d : d + 1 | 0;
                                                    F[b + 16 >> 2] = f;
                                                    F[b + 20 >> 2] = d;
                                                    Cc(k + 16 | 0, e);
                                                    if (e) {
                                                        d = F[a >> 2];
                                                        m = Dc(k + 16 | 0);
                                                        f = F[d + 20 >> 2];
                                                        i = F[d + 16 >> 2];
                                                        b = e;
                                                        n = i + e | 0;
                                                        h = F[d + 12 >> 2];
                                                        f = e >>> 0 > n >>> 0 ? f + 1 | 0 : f;
                                                        if (n >>> 0 > I[d + 8 >> 2] & (h | 0) <= (f | 0) | (f | 0) > (h | 0)) {
                                                            break e;
                                                        }
                                                        ta(m, i + F[d >> 2] | 0, e);
                                                        c = F[d + 20 >> 2];
                                                        e = b + F[d + 16 >> 2] | 0;
                                                        c = e >>> 0 < b >>> 0 ? c + 1 | 0 : c;
                                                        F[d + 16 >> 2] = e;
                                                        F[d + 20 >> 2] = c;
                                                    }
                                                    j = sa(24);
                                                    b = j;
                                                    F[b + 4 >> 2] = 0;
                                                    F[b + 8 >> 2] = 0;
                                                    b = b + 16 | 0;
                                                    F[b >> 2] = 0;
                                                    F[b + 4 >> 2] = 0;
                                                    F[j >> 2] = j + 4;
                                                    F[j + 12 >> 2] = b;
                                                    e = ea - 32 | 0;
                                                    ea = e;
                                                    f = g + 12 | 0;
                                                    c = k + 16 | 0;
                                                    l = rb(f, c);
                                                    p = g + 16 | 0;
                                                    f: {
                                                        if ((l | 0) == (p | 0)) {
                                                            F[e + 16 >> 2] = c;
                                                            b = F[f + 4 >> 2];
                                                            g: {
                                                                h: {
                                                                    if (b) {
                                                                        d = G[c + 11 | 0];
                                                                        g = d << 24 >> 24 < 0;
                                                                        h = g ? F[c >> 2] : c;
                                                                        g = g ? F[c + 4 >> 2] : d;
                                                                        c = f + 4 | 0;
                                                                        while (1) {
                                                                            d = G[b + 27 | 0];
                                                                            n = d << 24 >> 24 < 0;
                                                                            d = n ? F[b + 20 >> 2] : d;
                                                                            m = d >>> 0 < g >>> 0;
                                                                            i: {
                                                                                j: {
                                                                                    k: {
                                                                                        l: {
                                                                                            m: {
                                                                                                i = m ? d : g;
                                                                                                n: {
                                                                                                    if (i) {
                                                                                                        o = b + 16 | 0;
                                                                                                        n = n ? F[o >> 2] : o;
                                                                                                        o = Ha(h, n, i);
                                                                                                        if (!o) {
                                                                                                            if (d >>> 0 > g >>> 0) {
                                                                                                                break n;
                                                                                                            }
                                                                                                            break m;
                                                                                                        }
                                                                                                        if ((o | 0) >= 0) {
                                                                                                            break m;
                                                                                                        }
                                                                                                        break n;
                                                                                                    }
                                                                                                    if (d >>> 0 <= g >>> 0) {
                                                                                                        break l;
                                                                                                    }
                                                                                                }
                                                                                                d = F[b >> 2];
                                                                                                if (d) {
                                                                                                    break i;
                                                                                                }
                                                                                                break h;
                                                                                            }
                                                                                            d = Ha(n, h, i);
                                                                                            if (d) {
                                                                                                break k;
                                                                                            }
                                                                                        }
                                                                                        if (m) {
                                                                                            break j;
                                                                                        }
                                                                                        break g;
                                                                                    }
                                                                                    if ((d | 0) >= 0) {
                                                                                        break g;
                                                                                    }
                                                                                }
                                                                                c = b + 4 | 0;
                                                                                d = F[b + 4 >> 2];
                                                                                if (!d) {
                                                                                    break g;
                                                                                }
                                                                                b = c;
                                                                            }
                                                                            c = b;
                                                                            b = d;
                                                                            continue;
                                                                        }
                                                                    }
                                                                    b = f + 4 | 0;
                                                                }
                                                                c = b;
                                                            }
                                                            d = F[c >> 2];
                                                            if (d) {
                                                                b = 0;
                                                            }
                                                            else {
                                                                d = sa(32);
                                                                h = d + 16 | 0;
                                                                g = F[e + 16 >> 2];
                                                                o: {
                                                                    if (D[g + 11 | 0] >= 0) {
                                                                        n = F[g + 4 >> 2];
                                                                        F[h >> 2] = F[g >> 2];
                                                                        F[h + 4 >> 2] = n;
                                                                        F[h + 8 >> 2] = F[g + 8 >> 2];
                                                                        break o;
                                                                    }
                                                                    Ba(h, F[g >> 2], F[g + 4 >> 2]);
                                                                }
                                                                F[d + 8 >> 2] = b;
                                                                F[d >> 2] = 0;
                                                                F[d + 4 >> 2] = 0;
                                                                F[d + 28 >> 2] = 0;
                                                                F[c >> 2] = d;
                                                                b = F[F[f >> 2] >> 2];
                                                                if (b) {
                                                                    F[f >> 2] = b;
                                                                    b = F[c >> 2];
                                                                }
                                                                else {
                                                                    b = d;
                                                                }
                                                                Tb(F[f + 4 >> 2], b);
                                                                F[f + 8 >> 2] = F[f + 8 >> 2] + 1;
                                                                b = 1;
                                                            }
                                                            D[e + 28 | 0] = b;
                                                            F[e + 24 >> 2] = d;
                                                            c = F[e + 24 >> 2];
                                                            b = F[c + 28 >> 2];
                                                            F[c + 28 >> 2] = j;
                                                            if (!b) {
                                                                break f;
                                                            }
                                                            Qa(b + 12 | 0, F[b + 16 >> 2]);
                                                            Pa(b, F[b + 4 >> 2]);
                                                            ra(b);
                                                            break f;
                                                        }
                                                        if (!j) {
                                                            break f;
                                                        }
                                                        Qa(j + 12 | 0, F[j + 16 >> 2]);
                                                        Pa(j, F[j + 4 >> 2]);
                                                        ra(j);
                                                    }
                                                    ea = e + 32 | 0;
                                                    c = (l | 0) != (p | 0);
                                                }
                                                if (D[k + 27 | 0] < 0) {
                                                    ra(F[k + 16 >> 2]);
                                                }
                                                if (c) {
                                                    break b;
                                                }
                                            }
                                            if (!j) {
                                                break b;
                                            }
                                            F[k + 16 >> 2] = 0;
                                            if (!Cb(1, k + 16 | 0, F[a >> 2])) {
                                                break b;
                                            }
                                            b = 0;
                                            r = F[k + 16 >> 2];
                                            if (r) {
                                                while (1) {
                                                    n = 0;
                                                    i = ea - 32 | 0;
                                                    ea = i;
                                                    F[i + 24 >> 2] = 0;
                                                    F[i + 16 >> 2] = 0;
                                                    F[i + 20 >> 2] = 0;
                                                    c = F[a >> 2];
                                                    e = F[c + 8 >> 2];
                                                    p: {
                                                        q: {
                                                            f = F[c + 12 >> 2];
                                                            d = F[c + 20 >> 2];
                                                            g = F[c + 16 >> 2];
                                                            r: {
                                                                if ((f | 0) <= (d | 0) & g >>> 0 >= e >>> 0 | (d | 0) > (f | 0)) {
                                                                    break r;
                                                                }
                                                                f = G[g + F[c >> 2] | 0];
                                                                e = c;
                                                                c = d;
                                                                d = g + 1 | 0;
                                                                c = d ? c : c + 1 | 0;
                                                                F[e + 16 >> 2] = d;
                                                                F[e + 20 >> 2] = c;
                                                                Cc(i + 16 | 0, f);
                                                                if (f) {
                                                                    e = F[a >> 2];
                                                                    m = Dc(i + 16 | 0);
                                                                    d = F[e + 20 >> 2];
                                                                    l = F[e + 16 >> 2];
                                                                    c = f;
                                                                    h = l + c | 0;
                                                                    g = F[e + 12 >> 2];
                                                                    d = c >>> 0 > h >>> 0 ? d + 1 | 0 : d;
                                                                    if (h >>> 0 > I[e + 8 >> 2] & (g | 0) <= (d | 0) | (d | 0) > (g | 0)) {
                                                                        break r;
                                                                    }
                                                                    ta(m, l + F[e >> 2] | 0, f);
                                                                    d = F[e + 20 >> 2];
                                                                    f = c + F[e + 16 >> 2] | 0;
                                                                    d = f >>> 0 < c >>> 0 ? d + 1 | 0 : d;
                                                                    F[e + 16 >> 2] = f;
                                                                    F[e + 20 >> 2] = d;
                                                                }
                                                                F[i + 12 >> 2] = 0;
                                                                if (!Cb(1, i + 12 | 0, F[a >> 2])) {
                                                                    break r;
                                                                }
                                                                c = F[i + 12 >> 2];
                                                                if (!c) {
                                                                    break r;
                                                                }
                                                                F[i + 8 >> 2] = 0;
                                                                F[i >> 2] = 0;
                                                                F[i + 4 >> 2] = 0;
                                                                if ((c | 0) < 0) {
                                                                    break q;
                                                                }
                                                                d = sa(c);
                                                                F[i >> 2] = d;
                                                                e = c + d | 0;
                                                                F[i + 8 >> 2] = e;
                                                                m = ua(d, 0, c);
                                                                F[i + 4 >> 2] = e;
                                                                e = F[a >> 2];
                                                                n = F[e + 8 >> 2];
                                                                g = F[e + 12 >> 2];
                                                                f = F[e + 20 >> 2];
                                                                l = F[e + 16 >> 2];
                                                                h = c + l | 0;
                                                                f = h >>> 0 < c >>> 0 ? f + 1 | 0 : f;
                                                                n = (f | 0) <= (g | 0) & h >>> 0 <= n >>> 0 | (f | 0) < (g | 0);
                                                                if (n) {
                                                                    ta(m, l + F[e >> 2] | 0, c);
                                                                    d = c;
                                                                    f = c + F[e + 16 >> 2] | 0;
                                                                    c = F[e + 20 >> 2];
                                                                    F[e + 16 >> 2] = f;
                                                                    F[e + 20 >> 2] = d >>> 0 > f >>> 0 ? c + 1 | 0 : c;
                                                                    g = ea - 48 | 0;
                                                                    ea = g;
                                                                    d = rb(j, i + 16 | 0);
                                                                    if ((d | 0) != (j + 4 | 0)) {
                                                                        e = F[d + 4 >> 2];
                                                                        s: {
                                                                            if (!e) {
                                                                                f = F[d + 8 >> 2];
                                                                                if (F[f >> 2] == (d | 0)) {
                                                                                    break s;
                                                                                }
                                                                                c = d + 8 | 0;
                                                                                while (1) {
                                                                                    e = F[c >> 2];
                                                                                    c = e + 8 | 0;
                                                                                    f = F[e + 8 >> 2];
                                                                                    if ((e | 0) != F[f >> 2]) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                                break s;
                                                                            }
                                                                            while (1) {
                                                                                f = e;
                                                                                e = F[e >> 2];
                                                                                if (e) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                        }
                                                                        if (F[j >> 2] == (d | 0)) {
                                                                            F[j >> 2] = f;
                                                                        }
                                                                        F[j + 8 >> 2] = F[j + 8 >> 2] - 1;
                                                                        f = F[j + 4 >> 2];
                                                                        h = d;
                                                                        t: {
                                                                            u: {
                                                                                e = F[d >> 2];
                                                                                if (e) {
                                                                                    c = F[h + 4 >> 2];
                                                                                    if (!c) {
                                                                                        break u;
                                                                                    }
                                                                                    while (1) {
                                                                                        d = c;
                                                                                        c = F[c >> 2];
                                                                                        if (c) {
                                                                                            continue;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                }
                                                                                e = F[d + 4 >> 2];
                                                                                if (e) {
                                                                                    break u;
                                                                                }
                                                                                e = 0;
                                                                                m = 1;
                                                                                break t;
                                                                            }
                                                                            F[e + 8 >> 2] = F[d + 8 >> 2];
                                                                            m = 0;
                                                                        }
                                                                        l = F[d + 8 >> 2];
                                                                        c = F[l >> 2];
                                                                        v: {
                                                                            if ((d | 0) == (c | 0)) {
                                                                                F[l >> 2] = e;
                                                                                if ((d | 0) == (f | 0)) {
                                                                                    c = 0;
                                                                                    f = e;
                                                                                    break v;
                                                                                }
                                                                                c = F[l + 4 >> 2];
                                                                                break v;
                                                                            }
                                                                            F[l + 4 >> 2] = e;
                                                                        }
                                                                        o = !G[d + 12 | 0];
                                                                        if ((d | 0) != (h | 0)) {
                                                                            l = F[h + 8 >> 2];
                                                                            F[d + 8 >> 2] = l;
                                                                            F[l + (((h | 0) != F[F[h + 8 >> 2] >> 2]) << 2) >> 2] = d;
                                                                            l = F[h >> 2];
                                                                            F[d >> 2] = l;
                                                                            F[l + 8 >> 2] = d;
                                                                            l = F[h + 4 >> 2];
                                                                            F[d + 4 >> 2] = l;
                                                                            if (l) {
                                                                                F[l + 8 >> 2] = d;
                                                                            }
                                                                            D[d + 12 | 0] = G[h + 12 | 0];
                                                                            f = (f | 0) == (h | 0) ? d : f;
                                                                        }
                                                                        w: {
                                                                            if (o | !f) {
                                                                                break w;
                                                                            }
                                                                            if (m) {
                                                                                while (1) {
                                                                                    e = G[c + 12 | 0];
                                                                                    x: {
                                                                                        d = F[c + 8 >> 2];
                                                                                        if (F[d >> 2] != (c | 0)) {
                                                                                            if (!e) {
                                                                                                D[c + 12 | 0] = 1;
                                                                                                D[d + 12 | 0] = 0;
                                                                                                e = F[d + 4 >> 2];
                                                                                                m = F[e >> 2];
                                                                                                F[d + 4 >> 2] = m;
                                                                                                if (m) {
                                                                                                    F[m + 8 >> 2] = d;
                                                                                                }
                                                                                                F[e + 8 >> 2] = F[d + 8 >> 2];
                                                                                                m = F[d + 8 >> 2];
                                                                                                F[(((d | 0) != F[m >> 2]) << 2) + m >> 2] = e;
                                                                                                F[e >> 2] = d;
                                                                                                F[d + 8 >> 2] = e;
                                                                                                d = c;
                                                                                                c = F[c >> 2];
                                                                                                f = (c | 0) == (f | 0) ? d : f;
                                                                                                c = F[c + 4 >> 2];
                                                                                            }
                                                                                            y: {
                                                                                                z: {
                                                                                                    d = F[c >> 2];
                                                                                                    A: {
                                                                                                        if (!(G[d + 12 | 0] ? 0 : d)) {
                                                                                                            e = F[c + 4 >> 2];
                                                                                                            if (G[e + 12 | 0] ? 0 : e) {
                                                                                                                break A;
                                                                                                            }
                                                                                                            D[c + 12 | 0] = 0;
                                                                                                            c = F[c + 8 >> 2];
                                                                                                            B: {
                                                                                                                if ((f | 0) == (c | 0)) {
                                                                                                                    c = f;
                                                                                                                    break B;
                                                                                                                }
                                                                                                                if (G[c + 12 | 0]) {
                                                                                                                    break x;
                                                                                                                }
                                                                                                            }
                                                                                                            D[c + 12 | 0] = 1;
                                                                                                            break w;
                                                                                                        }
                                                                                                        e = F[c + 4 >> 2];
                                                                                                        if (!e) {
                                                                                                            break z;
                                                                                                        }
                                                                                                    }
                                                                                                    if (G[e + 12 | 0]) {
                                                                                                        break z;
                                                                                                    }
                                                                                                    d = c;
                                                                                                    break y;
                                                                                                }
                                                                                                D[d + 12 | 0] = 1;
                                                                                                D[c + 12 | 0] = 0;
                                                                                                e = F[d + 4 >> 2];
                                                                                                F[c >> 2] = e;
                                                                                                if (e) {
                                                                                                    F[e + 8 >> 2] = c;
                                                                                                }
                                                                                                F[d + 8 >> 2] = F[c + 8 >> 2];
                                                                                                e = F[c + 8 >> 2];
                                                                                                F[((F[e >> 2] != (c | 0)) << 2) + e >> 2] = d;
                                                                                                F[d + 4 >> 2] = c;
                                                                                                F[c + 8 >> 2] = d;
                                                                                                e = c;
                                                                                            }
                                                                                            c = F[d + 8 >> 2];
                                                                                            D[d + 12 | 0] = G[c + 12 | 0];
                                                                                            D[c + 12 | 0] = 1;
                                                                                            D[e + 12 | 0] = 1;
                                                                                            d = F[c + 4 >> 2];
                                                                                            e = F[d >> 2];
                                                                                            F[c + 4 >> 2] = e;
                                                                                            if (e) {
                                                                                                F[e + 8 >> 2] = c;
                                                                                            }
                                                                                            F[d + 8 >> 2] = F[c + 8 >> 2];
                                                                                            e = F[c + 8 >> 2];
                                                                                            F[(((c | 0) != F[e >> 2]) << 2) + e >> 2] = d;
                                                                                            F[d >> 2] = c;
                                                                                            F[c + 8 >> 2] = d;
                                                                                            break w;
                                                                                        }
                                                                                        if (!e) {
                                                                                            D[c + 12 | 0] = 1;
                                                                                            D[d + 12 | 0] = 0;
                                                                                            e = F[c + 4 >> 2];
                                                                                            F[d >> 2] = e;
                                                                                            if (e) {
                                                                                                F[e + 8 >> 2] = d;
                                                                                            }
                                                                                            F[c + 8 >> 2] = F[d + 8 >> 2];
                                                                                            e = F[d + 8 >> 2];
                                                                                            F[(((d | 0) != F[e >> 2]) << 2) + e >> 2] = c;
                                                                                            F[c + 4 >> 2] = d;
                                                                                            F[d + 8 >> 2] = c;
                                                                                            f = (d | 0) == (f | 0) ? c : f;
                                                                                            c = F[d >> 2];
                                                                                        }
                                                                                        e = F[c >> 2];
                                                                                        C: {
                                                                                            if (!(!e | G[e + 12 | 0])) {
                                                                                                d = c;
                                                                                                break C;
                                                                                            }
                                                                                            d = F[c + 4 >> 2];
                                                                                            if (!(G[d + 12 | 0] ? 0 : d)) {
                                                                                                D[c + 12 | 0] = 0;
                                                                                                c = F[c + 8 >> 2];
                                                                                                if ((c | 0) != (f | 0) ? G[c + 12 | 0] : 0) {
                                                                                                    break x;
                                                                                                }
                                                                                                D[c + 12 | 0] = 1;
                                                                                                break w;
                                                                                            }
                                                                                            if (e) {
                                                                                                if (!G[e + 12 | 0]) {
                                                                                                    d = c;
                                                                                                    break C;
                                                                                                }
                                                                                                d = F[c + 4 >> 2];
                                                                                            }
                                                                                            D[d + 12 | 0] = 1;
                                                                                            D[c + 12 | 0] = 0;
                                                                                            e = F[d >> 2];
                                                                                            F[c + 4 >> 2] = e;
                                                                                            if (e) {
                                                                                                F[e + 8 >> 2] = c;
                                                                                            }
                                                                                            F[d + 8 >> 2] = F[c + 8 >> 2];
                                                                                            e = F[c + 8 >> 2];
                                                                                            F[((F[e >> 2] != (c | 0)) << 2) + e >> 2] = d;
                                                                                            F[d >> 2] = c;
                                                                                            F[c + 8 >> 2] = d;
                                                                                            e = c;
                                                                                        }
                                                                                        c = F[d + 8 >> 2];
                                                                                        D[d + 12 | 0] = G[c + 12 | 0];
                                                                                        D[c + 12 | 0] = 1;
                                                                                        D[e + 12 | 0] = 1;
                                                                                        d = F[c >> 2];
                                                                                        e = F[d + 4 >> 2];
                                                                                        F[c >> 2] = e;
                                                                                        if (e) {
                                                                                            F[e + 8 >> 2] = c;
                                                                                        }
                                                                                        F[d + 8 >> 2] = F[c + 8 >> 2];
                                                                                        e = F[c + 8 >> 2];
                                                                                        F[(((c | 0) != F[e >> 2]) << 2) + e >> 2] = d;
                                                                                        F[d + 4 >> 2] = c;
                                                                                        F[c + 8 >> 2] = d;
                                                                                        break w;
                                                                                    }
                                                                                    d = c;
                                                                                    c = F[c + 8 >> 2];
                                                                                    c = F[(((d | 0) == F[c >> 2]) << 2) + c >> 2];
                                                                                    continue;
                                                                                }
                                                                            }
                                                                            D[e + 12 | 0] = 1;
                                                                        }
                                                                        c = F[h + 28 >> 2];
                                                                        if (c) {
                                                                            F[h + 32 >> 2] = c;
                                                                            ra(c);
                                                                        }
                                                                        if (D[h + 27 | 0] < 0) {
                                                                            ra(F[h + 16 >> 2]);
                                                                        }
                                                                        ra(h);
                                                                    }
                                                                    F[g >> 2] = 0;
                                                                    F[g + 4 >> 2] = 0;
                                                                    F[g + 8 >> 2] = 0;
                                                                    c = F[i + 4 >> 2] - F[i >> 2] | 0;
                                                                    Va(g, c);
                                                                    ta(F[g >> 2], F[i >> 2], c);
                                                                    D: {
                                                                        if (D[i + 27 | 0] >= 0) {
                                                                            F[g + 24 >> 2] = F[i + 24 >> 2];
                                                                            c = F[i + 20 >> 2];
                                                                            F[g + 16 >> 2] = F[i + 16 >> 2];
                                                                            F[g + 20 >> 2] = c;
                                                                            break D;
                                                                        }
                                                                        Ba(g + 16 | 0, F[i + 16 >> 2], F[i + 20 >> 2]);
                                                                    }
                                                                    F[g + 36 >> 2] = 0;
                                                                    F[g + 28 >> 2] = 0;
                                                                    F[g + 32 >> 2] = 0;
                                                                    Va(g + 28 | 0, F[g + 4 >> 2] - F[g >> 2] | 0);
                                                                    c = F[g >> 2];
                                                                    ta(F[g + 28 >> 2], c, F[g + 4 >> 2] - c | 0);
                                                                    f = g + 16 | 0;
                                                                    d = f;
                                                                    c = F[j + 4 >> 2];
                                                                    E: {
                                                                        F: {
                                                                            if (c) {
                                                                                e = G[d + 11 | 0];
                                                                                h = e << 24 >> 24 < 0;
                                                                                m = h ? F[d >> 2] : d;
                                                                                h = h ? F[d + 4 >> 2] : e;
                                                                                d = j + 4 | 0;
                                                                                while (1) {
                                                                                    e = G[c + 27 | 0];
                                                                                    l = e << 24 >> 24 < 0;
                                                                                    e = l ? F[c + 20 >> 2] : e;
                                                                                    p = e >>> 0 < h >>> 0;
                                                                                    G: {
                                                                                        H: {
                                                                                            I: {
                                                                                                J: {
                                                                                                    K: {
                                                                                                        o = p ? e : h;
                                                                                                        L: {
                                                                                                            if (o) {
                                                                                                                q = c + 16 | 0;
                                                                                                                l = l ? F[q >> 2] : q;
                                                                                                                q = Ha(m, l, o);
                                                                                                                if (!q) {
                                                                                                                    if (e >>> 0 > h >>> 0) {
                                                                                                                        break L;
                                                                                                                    }
                                                                                                                    break K;
                                                                                                                }
                                                                                                                if ((q | 0) >= 0) {
                                                                                                                    break K;
                                                                                                                }
                                                                                                                break L;
                                                                                                            }
                                                                                                            if (e >>> 0 <= h >>> 0) {
                                                                                                                break J;
                                                                                                            }
                                                                                                        }
                                                                                                        e = F[c >> 2];
                                                                                                        if (e) {
                                                                                                            break G;
                                                                                                        }
                                                                                                        break F;
                                                                                                    }
                                                                                                    e = Ha(l, m, o);
                                                                                                    if (e) {
                                                                                                        break I;
                                                                                                    }
                                                                                                }
                                                                                                if (p) {
                                                                                                    break H;
                                                                                                }
                                                                                                break E;
                                                                                            }
                                                                                            if ((e | 0) >= 0) {
                                                                                                break E;
                                                                                            }
                                                                                        }
                                                                                        d = c + 4 | 0;
                                                                                        e = F[c + 4 >> 2];
                                                                                        if (!e) {
                                                                                            break E;
                                                                                        }
                                                                                        c = d;
                                                                                    }
                                                                                    d = c;
                                                                                    c = e;
                                                                                    continue;
                                                                                }
                                                                            }
                                                                            c = j + 4 | 0;
                                                                        }
                                                                        d = c;
                                                                    }
                                                                    e = F[d >> 2];
                                                                    if (e) {
                                                                        c = 0;
                                                                    }
                                                                    else {
                                                                        e = sa(40);
                                                                        F[e + 24 >> 2] = F[f + 8 >> 2];
                                                                        h = F[f + 4 >> 2];
                                                                        F[e + 16 >> 2] = F[f >> 2];
                                                                        F[e + 20 >> 2] = h;
                                                                        F[f >> 2] = 0;
                                                                        F[f + 4 >> 2] = 0;
                                                                        F[f + 8 >> 2] = 0;
                                                                        F[e + 36 >> 2] = 0;
                                                                        h = e + 28 | 0;
                                                                        F[h >> 2] = 0;
                                                                        F[h + 4 >> 2] = 0;
                                                                        Va(h, F[f + 16 >> 2] - F[f + 12 >> 2] | 0);
                                                                        m = F[h >> 2];
                                                                        h = F[f + 12 >> 2];
                                                                        ta(m, h, F[f + 16 >> 2] - h | 0);
                                                                        F[e + 8 >> 2] = c;
                                                                        F[e >> 2] = 0;
                                                                        F[e + 4 >> 2] = 0;
                                                                        F[d >> 2] = e;
                                                                        c = F[F[j >> 2] >> 2];
                                                                        if (c) {
                                                                            F[j >> 2] = c;
                                                                            c = F[d >> 2];
                                                                        }
                                                                        else {
                                                                            c = e;
                                                                        }
                                                                        Tb(F[j + 4 >> 2], c);
                                                                        F[j + 8 >> 2] = F[j + 8 >> 2] + 1;
                                                                        c = 1;
                                                                    }
                                                                    D[g + 44 | 0] = c;
                                                                    F[g + 40 >> 2] = e;
                                                                    c = F[g + 28 >> 2];
                                                                    if (c) {
                                                                        F[g + 32 >> 2] = c;
                                                                        ra(c);
                                                                    }
                                                                    if (D[g + 27 | 0] < 0) {
                                                                        ra(F[g + 16 >> 2]);
                                                                    }
                                                                    c = F[g >> 2];
                                                                    if (c) {
                                                                        F[g + 4 >> 2] = c;
                                                                        ra(c);
                                                                    }
                                                                    ea = g + 48 | 0;
                                                                    d = F[i >> 2];
                                                                    if (!d) {
                                                                        break r;
                                                                    }
                                                                }
                                                                F[i + 4 >> 2] = d;
                                                                ra(d);
                                                            }
                                                            if (D[i + 27 | 0] < 0) {
                                                                ra(F[i + 16 >> 2]);
                                                            }
                                                            ea = i + 32 | 0;
                                                            break p;
                                                        }
                                                        va();
                                                        V();
                                                    }
                                                    if (!n) {
                                                        break b;
                                                    }
                                                    b = b + 1 | 0;
                                                    if ((r | 0) != (b | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            F[k + 12 >> 2] = 0;
                                            if (!Cb(1, k + 12 | 0, F[a >> 2])) {
                                                break b;
                                            }
                                            b = F[a >> 2];
                                            c = F[b + 8 >> 2];
                                            d = F[b + 16 >> 2];
                                            e = c - d | 0;
                                            f = F[k + 12 >> 2];
                                            b = F[b + 12 >> 2] - (F[b + 20 >> 2] + (c >>> 0 < d >>> 0) | 0) | 0;
                                            if (e >>> 0 < f >>> 0 & (b | 0) <= 0 | (b | 0) < 0) {
                                                break b;
                                            }
                                            c = 0;
                                            b = F[k + 36 >> 2];
                                            if (f) {
                                                while (1) {
                                                    e = F[k + 40 >> 2];
                                                    M: {
                                                        if (e >>> 0 > b >>> 0) {
                                                            F[b + 4 >> 2] = 0;
                                                            F[b >> 2] = j;
                                                            b = b + 8 | 0;
                                                            F[k + 36 >> 2] = b;
                                                            break M;
                                                        }
                                                        d = F[k + 32 >> 2];
                                                        g = b - d | 0;
                                                        h = g >> 3;
                                                        b = h + 1 | 0;
                                                        if (b >>> 0 >= 536870912) {
                                                            break d;
                                                        }
                                                        e = e - d | 0;
                                                        n = e >> 2;
                                                        b = e >>> 0 < 2147483640 ? b >>> 0 > n >>> 0 ? b : n : 536870911;
                                                        if (b >>> 0 >= 536870912) {
                                                            break c;
                                                        }
                                                        m = h << 3;
                                                        h = b << 3;
                                                        e = sa(h);
                                                        b = m + e | 0;
                                                        F[b + 4 >> 2] = 0;
                                                        F[b >> 2] = j;
                                                        b = b + 8 | 0;
                                                        if ((g | 0) > 0) {
                                                            ta(e, d, g);
                                                        }
                                                        F[k + 40 >> 2] = e + h;
                                                        F[k + 36 >> 2] = b;
                                                        F[k + 32 >> 2] = e;
                                                        if (!d) {
                                                            break M;
                                                        }
                                                        ra(d);
                                                    }
                                                    c = c + 1 | 0;
                                                    if ((f | 0) != (c | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            if (F[k + 32 >> 2] != (b | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                        a = 1;
                                        break a;
                                    }
                                    va();
                                    V();
                                }
                                wa(1336);
                                V();
                            }
                            b = F[k + 32 >> 2];
                            a = 0;
                        } if (b) {
                            ra(b);
                        } ea = k + 48 | 0; return a; }
                        function re(a, b, c, d, e) { var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0; h = ea - 32 | 0; ea = h; F[b + 32 >> 2] = d; F[b + 40 >> 2] = c; F[b + 4 >> 2] = e; oc(a, d, h + 16 | 0); a: {
                            if (F[a >> 2]) {
                                break a;
                            }
                            i = a + 4 | 0;
                            if (D[a + 15 | 0] < 0) {
                                ra(F[i >> 2]);
                            }
                            d = G[h + 23 | 0];
                            if ((ga[F[F[b >> 2] + 8 >> 2]](b) | 0) != (d | 0)) {
                                b = sa(64);
                                c = G[1458] | G[1459] << 8;
                                D[b + 48 | 0] = c;
                                D[b + 49 | 0] = c >>> 8;
                                c = G[1454] | G[1455] << 8 | (G[1456] << 16 | G[1457] << 24);
                                d = G[1450] | G[1451] << 8 | (G[1452] << 16 | G[1453] << 24);
                                D[b + 40 | 0] = d;
                                D[b + 41 | 0] = d >>> 8;
                                D[b + 42 | 0] = d >>> 16;
                                D[b + 43 | 0] = d >>> 24;
                                D[b + 44 | 0] = c;
                                D[b + 45 | 0] = c >>> 8;
                                D[b + 46 | 0] = c >>> 16;
                                D[b + 47 | 0] = c >>> 24;
                                c = G[1446] | G[1447] << 8 | (G[1448] << 16 | G[1449] << 24);
                                d = G[1442] | G[1443] << 8 | (G[1444] << 16 | G[1445] << 24);
                                D[b + 32 | 0] = d;
                                D[b + 33 | 0] = d >>> 8;
                                D[b + 34 | 0] = d >>> 16;
                                D[b + 35 | 0] = d >>> 24;
                                D[b + 36 | 0] = c;
                                D[b + 37 | 0] = c >>> 8;
                                D[b + 38 | 0] = c >>> 16;
                                D[b + 39 | 0] = c >>> 24;
                                c = G[1438] | G[1439] << 8 | (G[1440] << 16 | G[1441] << 24);
                                d = G[1434] | G[1435] << 8 | (G[1436] << 16 | G[1437] << 24);
                                D[b + 24 | 0] = d;
                                D[b + 25 | 0] = d >>> 8;
                                D[b + 26 | 0] = d >>> 16;
                                D[b + 27 | 0] = d >>> 24;
                                D[b + 28 | 0] = c;
                                D[b + 29 | 0] = c >>> 8;
                                D[b + 30 | 0] = c >>> 16;
                                D[b + 31 | 0] = c >>> 24;
                                c = G[1430] | G[1431] << 8 | (G[1432] << 16 | G[1433] << 24);
                                d = G[1426] | G[1427] << 8 | (G[1428] << 16 | G[1429] << 24);
                                D[b + 16 | 0] = d;
                                D[b + 17 | 0] = d >>> 8;
                                D[b + 18 | 0] = d >>> 16;
                                D[b + 19 | 0] = d >>> 24;
                                D[b + 20 | 0] = c;
                                D[b + 21 | 0] = c >>> 8;
                                D[b + 22 | 0] = c >>> 16;
                                D[b + 23 | 0] = c >>> 24;
                                c = G[1422] | G[1423] << 8 | (G[1424] << 16 | G[1425] << 24);
                                d = G[1418] | G[1419] << 8 | (G[1420] << 16 | G[1421] << 24);
                                D[b + 8 | 0] = d;
                                D[b + 9 | 0] = d >>> 8;
                                D[b + 10 | 0] = d >>> 16;
                                D[b + 11 | 0] = d >>> 24;
                                D[b + 12 | 0] = c;
                                D[b + 13 | 0] = c >>> 8;
                                D[b + 14 | 0] = c >>> 16;
                                D[b + 15 | 0] = c >>> 24;
                                c = G[1414] | G[1415] << 8 | (G[1416] << 16 | G[1417] << 24);
                                d = G[1410] | G[1411] << 8 | (G[1412] << 16 | G[1413] << 24);
                                D[b | 0] = d;
                                D[b + 1 | 0] = d >>> 8;
                                D[b + 2 | 0] = d >>> 16;
                                D[b + 3 | 0] = d >>> 24;
                                D[b + 4 | 0] = c;
                                D[b + 5 | 0] = c >>> 8;
                                D[b + 6 | 0] = c >>> 16;
                                D[b + 7 | 0] = c >>> 24;
                                D[b + 50 | 0] = 0;
                                F[a >> 2] = -1;
                                Ba(i, b, 50);
                                ra(b);
                                break a;
                            }
                            c = G[h + 21 | 0];
                            D[b + 36 | 0] = c;
                            e = G[h + 22 | 0];
                            D[b + 37 | 0] = e;
                            if ((c - 3 & 255) >>> 0 <= 253) {
                                b = sa(32);
                                c = G[1571] | G[1572] << 8 | (G[1573] << 16 | G[1574] << 24);
                                d = G[1567] | G[1568] << 8 | (G[1569] << 16 | G[1570] << 24);
                                D[b + 14 | 0] = d;
                                D[b + 15 | 0] = d >>> 8;
                                D[b + 16 | 0] = d >>> 16;
                                D[b + 17 | 0] = d >>> 24;
                                D[b + 18 | 0] = c;
                                D[b + 19 | 0] = c >>> 8;
                                D[b + 20 | 0] = c >>> 16;
                                D[b + 21 | 0] = c >>> 24;
                                c = G[1565] | G[1566] << 8 | (G[1567] << 16 | G[1568] << 24);
                                d = G[1561] | G[1562] << 8 | (G[1563] << 16 | G[1564] << 24);
                                D[b + 8 | 0] = d;
                                D[b + 9 | 0] = d >>> 8;
                                D[b + 10 | 0] = d >>> 16;
                                D[b + 11 | 0] = d >>> 24;
                                D[b + 12 | 0] = c;
                                D[b + 13 | 0] = c >>> 8;
                                D[b + 14 | 0] = c >>> 16;
                                D[b + 15 | 0] = c >>> 24;
                                c = G[1557] | G[1558] << 8 | (G[1559] << 16 | G[1560] << 24);
                                d = G[1553] | G[1554] << 8 | (G[1555] << 16 | G[1556] << 24);
                                D[b | 0] = d;
                                D[b + 1 | 0] = d >>> 8;
                                D[b + 2 | 0] = d >>> 16;
                                D[b + 3 | 0] = d >>> 24;
                                D[b + 4 | 0] = c;
                                D[b + 5 | 0] = c >>> 8;
                                D[b + 6 | 0] = c >>> 16;
                                D[b + 7 | 0] = c >>> 24;
                                D[b + 22 | 0] = 0;
                                F[a >> 2] = -5;
                                Ba(i, b, 22);
                                ra(b);
                                break a;
                            }
                            if (!((c | 0) != 2 | e >>> 0 <= (d ? 2 : 3) >>> 0)) {
                                b = sa(32);
                                c = G[1548] | G[1549] << 8 | (G[1550] << 16 | G[1551] << 24);
                                d = G[1544] | G[1545] << 8 | (G[1546] << 16 | G[1547] << 24);
                                D[b + 14 | 0] = d;
                                D[b + 15 | 0] = d >>> 8;
                                D[b + 16 | 0] = d >>> 16;
                                D[b + 17 | 0] = d >>> 24;
                                D[b + 18 | 0] = c;
                                D[b + 19 | 0] = c >>> 8;
                                D[b + 20 | 0] = c >>> 16;
                                D[b + 21 | 0] = c >>> 24;
                                c = G[1542] | G[1543] << 8 | (G[1544] << 16 | G[1545] << 24);
                                d = G[1538] | G[1539] << 8 | (G[1540] << 16 | G[1541] << 24);
                                D[b + 8 | 0] = d;
                                D[b + 9 | 0] = d >>> 8;
                                D[b + 10 | 0] = d >>> 16;
                                D[b + 11 | 0] = d >>> 24;
                                D[b + 12 | 0] = c;
                                D[b + 13 | 0] = c >>> 8;
                                D[b + 14 | 0] = c >>> 16;
                                D[b + 15 | 0] = c >>> 24;
                                c = G[1534] | G[1535] << 8 | (G[1536] << 16 | G[1537] << 24);
                                d = G[1530] | G[1531] << 8 | (G[1532] << 16 | G[1533] << 24);
                                D[b | 0] = d;
                                D[b + 1 | 0] = d >>> 8;
                                D[b + 2 | 0] = d >>> 16;
                                D[b + 3 | 0] = d >>> 24;
                                D[b + 4 | 0] = c;
                                D[b + 5 | 0] = c >>> 8;
                                D[b + 6 | 0] = c >>> 16;
                                D[b + 7 | 0] = c >>> 24;
                                D[b + 22 | 0] = 0;
                                F[a >> 2] = -5;
                                Ba(i, b, 22);
                                ra(b);
                                break a;
                            }
                            c = e | c << 8;
                            E[F[b + 32 >> 2] + 38 >> 1] = c;
                            b: {
                                if ((c & 65535) >>> 0 < 259 | E[h + 26 >> 1] >= 0) {
                                    break b;
                                }
                                j = ea - 16 | 0;
                                ea = j;
                                e = sa(36);
                                c = e;
                                F[c + 4 >> 2] = 0;
                                F[c + 8 >> 2] = 0;
                                F[c + 24 >> 2] = 0;
                                F[c + 28 >> 2] = 0;
                                c = c + 16 | 0;
                                F[c >> 2] = 0;
                                F[c + 4 >> 2] = 0;
                                F[e >> 2] = e + 4;
                                F[e + 32 >> 2] = 0;
                                F[e + 12 >> 2] = c;
                                F[j >> 2] = 0;
                                d = F[b + 32 >> 2];
                                k = ea - 16 | 0;
                                ea = k;
                                c = 0;
                                c: {
                                    if (!e) {
                                        break c;
                                    }
                                    F[j >> 2] = d;
                                    F[k + 12 >> 2] = 0;
                                    c = 0;
                                    if (!Cb(1, k + 12 | 0, d)) {
                                        break c;
                                    }
                                    n = F[k + 12 >> 2];
                                    if (n) {
                                        while (1) {
                                            d: {
                                                if (Cb(1, k + 8 | 0, F[j >> 2])) {
                                                    c = sa(28);
                                                    F[c + 4 >> 2] = 0;
                                                    F[c + 8 >> 2] = 0;
                                                    d = c + 16 | 0;
                                                    F[d >> 2] = 0;
                                                    F[d + 4 >> 2] = 0;
                                                    F[c >> 2] = c + 4;
                                                    F[c + 12 >> 2] = d;
                                                    F[c + 24 >> 2] = F[k + 8 >> 2];
                                                    if ($d(j, c)) {
                                                        break d;
                                                    }
                                                    Qa(c + 12 | 0, F[c + 16 >> 2]);
                                                    Pa(c, F[c + 4 >> 2]);
                                                    ra(c);
                                                }
                                                c = 0;
                                                break c;
                                            }
                                            f = ea - 16 | 0;
                                            ea = f;
                                            F[f + 8 >> 2] = c;
                                            e: {
                                                if (!c) {
                                                    F[f + 8 >> 2] = 0;
                                                    break e;
                                                }
                                                d = F[e + 28 >> 2];
                                                f: {
                                                    if (d >>> 0 < I[e + 32 >> 2]) {
                                                        F[f + 8 >> 2] = 0;
                                                        F[d >> 2] = c;
                                                        F[e + 28 >> 2] = d + 4;
                                                        break f;
                                                    }
                                                    d = 0;
                                                    g: {
                                                        h: {
                                                            i: {
                                                                g = F[e + 24 >> 2];
                                                                m = F[e + 28 >> 2] - g >> 2;
                                                                c = m + 1 | 0;
                                                                if (c >>> 0 < 1073741824) {
                                                                    g = F[e + 32 >> 2] - g | 0;
                                                                    l = g >> 1;
                                                                    c = g >>> 0 < 2147483644 ? c >>> 0 > l >>> 0 ? c : l : 1073741823;
                                                                    if (c) {
                                                                        if (c >>> 0 >= 1073741824) {
                                                                            break i;
                                                                        }
                                                                        d = sa(c << 2);
                                                                    }
                                                                    l = F[f + 8 >> 2];
                                                                    F[f + 8 >> 2] = 0;
                                                                    g = (m << 2) + d | 0;
                                                                    F[g >> 2] = l;
                                                                    m = (c << 2) + d | 0;
                                                                    l = g + 4 | 0;
                                                                    d = F[e + 28 >> 2];
                                                                    c = F[e + 24 >> 2];
                                                                    if ((d | 0) == (c | 0)) {
                                                                        break h;
                                                                    }
                                                                    while (1) {
                                                                        d = d - 4 | 0;
                                                                        p = F[d >> 2];
                                                                        F[d >> 2] = 0;
                                                                        g = g - 4 | 0;
                                                                        F[g >> 2] = p;
                                                                        if ((c | 0) != (d | 0)) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    F[e + 32 >> 2] = m;
                                                                    d = F[e + 28 >> 2];
                                                                    F[e + 28 >> 2] = l;
                                                                    c = F[e + 24 >> 2];
                                                                    F[e + 24 >> 2] = g;
                                                                    if ((c | 0) == (d | 0)) {
                                                                        break g;
                                                                    }
                                                                    while (1) {
                                                                        d = d - 4 | 0;
                                                                        g = F[d >> 2];
                                                                        F[d >> 2] = 0;
                                                                        if (g) {
                                                                            Qa(g + 12 | 0, F[g + 16 >> 2]);
                                                                            Pa(g, F[g + 4 >> 2]);
                                                                            ra(g);
                                                                        }
                                                                        if ((c | 0) != (d | 0)) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    break g;
                                                                }
                                                                va();
                                                                V();
                                                            }
                                                            wa(1336);
                                                            V();
                                                        }
                                                        F[e + 32 >> 2] = m;
                                                        F[e + 28 >> 2] = l;
                                                        F[e + 24 >> 2] = g;
                                                    }
                                                    if (c) {
                                                        ra(c);
                                                    }
                                                }
                                                c = F[f + 8 >> 2];
                                                F[f + 8 >> 2] = 0;
                                                if (!c) {
                                                    break e;
                                                }
                                                Qa(c + 12 | 0, F[c + 16 >> 2]);
                                                Pa(c, F[c + 4 >> 2]);
                                                ra(c);
                                            }
                                            ea = f + 16 | 0;
                                            o = o + 1 | 0;
                                            if ((n | 0) != (o | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    c = $d(j, e);
                                }
                                ea = k + 16 | 0;
                                j: {
                                    if (c) {
                                        d = F[b + 4 >> 2];
                                        c = F[d + 4 >> 2];
                                        F[d + 4 >> 2] = e;
                                        if (c) {
                                            Tc(c);
                                        }
                                        F[a >> 2] = 0;
                                        F[a + 4 >> 2] = 0;
                                        F[a + 8 >> 2] = 0;
                                        F[a + 12 >> 2] = 0;
                                        break j;
                                    }
                                    c = sa(32);
                                    d = G[1723] | G[1724] << 8;
                                    D[c + 24 | 0] = d;
                                    D[c + 25 | 0] = d >>> 8;
                                    d = G[1719] | G[1720] << 8 | (G[1721] << 16 | G[1722] << 24);
                                    f = G[1715] | G[1716] << 8 | (G[1717] << 16 | G[1718] << 24);
                                    D[c + 16 | 0] = f;
                                    D[c + 17 | 0] = f >>> 8;
                                    D[c + 18 | 0] = f >>> 16;
                                    D[c + 19 | 0] = f >>> 24;
                                    D[c + 20 | 0] = d;
                                    D[c + 21 | 0] = d >>> 8;
                                    D[c + 22 | 0] = d >>> 16;
                                    D[c + 23 | 0] = d >>> 24;
                                    d = G[1711] | G[1712] << 8 | (G[1713] << 16 | G[1714] << 24);
                                    f = G[1707] | G[1708] << 8 | (G[1709] << 16 | G[1710] << 24);
                                    D[c + 8 | 0] = f;
                                    D[c + 9 | 0] = f >>> 8;
                                    D[c + 10 | 0] = f >>> 16;
                                    D[c + 11 | 0] = f >>> 24;
                                    D[c + 12 | 0] = d;
                                    D[c + 13 | 0] = d >>> 8;
                                    D[c + 14 | 0] = d >>> 16;
                                    D[c + 15 | 0] = d >>> 24;
                                    d = G[1703] | G[1704] << 8 | (G[1705] << 16 | G[1706] << 24);
                                    f = G[1699] | G[1700] << 8 | (G[1701] << 16 | G[1702] << 24);
                                    D[c | 0] = f;
                                    D[c + 1 | 0] = f >>> 8;
                                    D[c + 2 | 0] = f >>> 16;
                                    D[c + 3 | 0] = f >>> 24;
                                    D[c + 4 | 0] = d;
                                    D[c + 5 | 0] = d >>> 8;
                                    D[c + 6 | 0] = d >>> 16;
                                    D[c + 7 | 0] = d >>> 24;
                                    D[c + 26 | 0] = 0;
                                    F[a >> 2] = -1;
                                    Ba(a + 4 | 0, c, 26);
                                    ra(c);
                                    F[j + 8 >> 2] = 0;
                                    Tc(e);
                                }
                                ea = j + 16 | 0;
                                if (F[a >> 2]) {
                                    break a;
                                }
                                if (D[i + 11 | 0] >= 0) {
                                    break b;
                                }
                                ra(F[i >> 2]);
                            }
                            if (!(ga[F[F[b >> 2] + 12 >> 2]](b) | 0)) {
                                b = sa(48);
                                D[b + 32 | 0] = G[1528];
                                c = G[1524] | G[1525] << 8 | (G[1526] << 16 | G[1527] << 24);
                                d = G[1520] | G[1521] << 8 | (G[1522] << 16 | G[1523] << 24);
                                D[b + 24 | 0] = d;
                                D[b + 25 | 0] = d >>> 8;
                                D[b + 26 | 0] = d >>> 16;
                                D[b + 27 | 0] = d >>> 24;
                                D[b + 28 | 0] = c;
                                D[b + 29 | 0] = c >>> 8;
                                D[b + 30 | 0] = c >>> 16;
                                D[b + 31 | 0] = c >>> 24;
                                c = G[1516] | G[1517] << 8 | (G[1518] << 16 | G[1519] << 24);
                                d = G[1512] | G[1513] << 8 | (G[1514] << 16 | G[1515] << 24);
                                D[b + 16 | 0] = d;
                                D[b + 17 | 0] = d >>> 8;
                                D[b + 18 | 0] = d >>> 16;
                                D[b + 19 | 0] = d >>> 24;
                                D[b + 20 | 0] = c;
                                D[b + 21 | 0] = c >>> 8;
                                D[b + 22 | 0] = c >>> 16;
                                D[b + 23 | 0] = c >>> 24;
                                c = G[1508] | G[1509] << 8 | (G[1510] << 16 | G[1511] << 24);
                                d = G[1504] | G[1505] << 8 | (G[1506] << 16 | G[1507] << 24);
                                D[b + 8 | 0] = d;
                                D[b + 9 | 0] = d >>> 8;
                                D[b + 10 | 0] = d >>> 16;
                                D[b + 11 | 0] = d >>> 24;
                                D[b + 12 | 0] = c;
                                D[b + 13 | 0] = c >>> 8;
                                D[b + 14 | 0] = c >>> 16;
                                D[b + 15 | 0] = c >>> 24;
                                c = G[1500] | G[1501] << 8 | (G[1502] << 16 | G[1503] << 24);
                                d = G[1496] | G[1497] << 8 | (G[1498] << 16 | G[1499] << 24);
                                D[b | 0] = d;
                                D[b + 1 | 0] = d >>> 8;
                                D[b + 2 | 0] = d >>> 16;
                                D[b + 3 | 0] = d >>> 24;
                                D[b + 4 | 0] = c;
                                D[b + 5 | 0] = c >>> 8;
                                D[b + 6 | 0] = c >>> 16;
                                D[b + 7 | 0] = c >>> 24;
                                D[b + 33 | 0] = 0;
                                F[a >> 2] = -1;
                                Ba(i, b, 33);
                                ra(b);
                                break a;
                            }
                            if (!(ga[F[F[b >> 2] + 20 >> 2]](b) | 0)) {
                                b = nc(h, 1726);
                                F[a >> 2] = -1;
                                if (D[b + 11 | 0] >= 0) {
                                    a = F[h + 4 >> 2];
                                    F[i >> 2] = F[h >> 2];
                                    F[i + 4 >> 2] = a;
                                    F[i + 8 >> 2] = F[h + 8 >> 2];
                                    break a;
                                }
                                Ba(i, F[b >> 2], F[b + 4 >> 2]);
                                if (D[b + 11 | 0] >= 0) {
                                    break a;
                                }
                                ra(F[b >> 2]);
                                break a;
                            }
                            if (!(ga[F[F[b >> 2] + 24 >> 2]](b) | 0)) {
                                b = nc(h, 1461);
                                F[a >> 2] = -1;
                                if (D[b + 11 | 0] >= 0) {
                                    a = F[h + 4 >> 2];
                                    F[i >> 2] = F[h >> 2];
                                    F[i + 4 >> 2] = a;
                                    F[i + 8 >> 2] = F[h + 8 >> 2];
                                    break a;
                                }
                                Ba(i, F[b >> 2], F[b + 4 >> 2]);
                                if (D[b + 11 | 0] >= 0) {
                                    break a;
                                }
                                ra(F[b >> 2]);
                                break a;
                            }
                            F[a >> 2] = 0;
                            F[a + 4 >> 2] = 0;
                            F[a + 8 >> 2] = 0;
                            F[a + 12 >> 2] = 0;
                        } ea = h + 32 | 0; }
                        function xf(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = M(0), p = 0, q = 0, r = 0; f = ea - 720 | 0; ea = f; a: {
                            b: {
                                c: {
                                    d: {
                                        e: {
                                            f: {
                                                g: {
                                                    h: {
                                                        if (H[b + 38 >> 1] >= 515) {
                                                            F[f + 680 >> 2] = 0;
                                                            F[f + 672 >> 2] = 0;
                                                            F[f + 676 >> 2] = 0;
                                                            if ((ga[F[F[a >> 2] + 24 >> 2]](a) | 0) <= 0) {
                                                                break d;
                                                            }
                                                            while (1) {
                                                                c = ga[F[F[a >> 2] + 20 >> 2]](a, k) | 0;
                                                                d = F[F[F[(ga[F[F[a >> 2] + 28 >> 2]](a) | 0) + 4 >> 2] + 8 >> 2] + (c << 2) >> 2];
                                                                if (F[d + 28 >> 2] == 9) {
                                                                    e = F[f + 672 >> 2];
                                                                    c = F[f + 676 >> 2] - e >> 2;
                                                                    g = D[d + 24 | 0];
                                                                    i: {
                                                                        if (c >>> 0 < g >>> 0) {
                                                                            Aa(f + 672 | 0, g - c | 0);
                                                                            break i;
                                                                        }
                                                                        if (c >>> 0 <= g >>> 0) {
                                                                            break i;
                                                                        }
                                                                        F[f + 676 >> 2] = e + (g << 2);
                                                                    }
                                                                    h = 0;
                                                                    c = F[b + 20 >> 2];
                                                                    j = F[b + 16 >> 2];
                                                                    d = g << 2;
                                                                    i = j + d | 0;
                                                                    e = F[b + 12 >> 2];
                                                                    c = d >>> 0 > i >>> 0 ? c + 1 | 0 : c;
                                                                    if (i >>> 0 > I[b + 8 >> 2] & (e | 0) <= (c | 0) | (c | 0) > (e | 0)) {
                                                                        break b;
                                                                    }
                                                                    ta(F[f + 672 >> 2], j + F[b >> 2] | 0, d);
                                                                    c = F[b + 20 >> 2];
                                                                    e = d + F[b + 16 >> 2] | 0;
                                                                    c = e >>> 0 < d >>> 0 ? c + 1 | 0 : c;
                                                                    F[b + 16 >> 2] = e;
                                                                    F[b + 20 >> 2] = c;
                                                                    l = F[b + 12 >> 2];
                                                                    j = l;
                                                                    i = e + 4 | 0;
                                                                    d = i >>> 0 < 4 ? c + 1 | 0 : c;
                                                                    m = F[b + 8 >> 2];
                                                                    if (m >>> 0 < i >>> 0 & (d | 0) >= (j | 0) | (d | 0) > (j | 0)) {
                                                                        break b;
                                                                    }
                                                                    n = F[b >> 2];
                                                                    j = n + e | 0;
                                                                    j = G[j | 0] | G[j + 1 | 0] << 8 | (G[j + 2 | 0] << 16 | G[j + 3 | 0] << 24);
                                                                    F[b + 16 >> 2] = i;
                                                                    F[b + 20 >> 2] = d;
                                                                    if ((d | 0) >= (l | 0) & i >>> 0 >= m >>> 0 | (d | 0) > (l | 0)) {
                                                                        break b;
                                                                    }
                                                                    d = G[i + n | 0];
                                                                    e = e + 5 | 0;
                                                                    c = e >>> 0 < 5 ? c + 1 | 0 : c;
                                                                    F[b + 16 >> 2] = e;
                                                                    F[b + 20 >> 2] = c;
                                                                    if (d >>> 0 > 31) {
                                                                        break b;
                                                                    }
                                                                    o = (z(2, j), A());
                                                                    F[f + 20 >> 2] = -1;
                                                                    F[f + 16 >> 2] = 1140;
                                                                    F[f + 32 >> 2] = 0;
                                                                    F[f + 36 >> 2] = 0;
                                                                    F[f + 24 >> 2] = 0;
                                                                    F[f + 28 >> 2] = 0;
                                                                    c = f + 16 | 0;
                                                                    e = F[f + 672 >> 2];
                                                                    i = d - 1 | 0;
                                                                    if (i >>> 0 <= 29) {
                                                                        F[c + 4 >> 2] = d;
                                                                        Ca(c + 8 | 0, e, e + (g << 2) | 0);
                                                                        J[c + 20 >> 2] = o;
                                                                    }
                                                                    j: {
                                                                        if (i >>> 0 >= 30) {
                                                                            break j;
                                                                        }
                                                                        if (!Wc(f + 16 | 0, F[F[a + 60 >> 2] + ((F[a + 40 >> 2] - F[a + 36 >> 2] | 0) / 24 << 2) >> 2])) {
                                                                            break j;
                                                                        }
                                                                        c = F[a + 40 >> 2];
                                                                        k: {
                                                                            if ((c | 0) != F[a + 44 >> 2]) {
                                                                                F[c >> 2] = 1140;
                                                                                d = F[f + 20 >> 2];
                                                                                F[c + 16 >> 2] = 0;
                                                                                F[c + 8 >> 2] = 0;
                                                                                F[c + 12 >> 2] = 0;
                                                                                F[c + 4 >> 2] = d;
                                                                                g = F[f + 28 >> 2] - F[f + 24 >> 2] | 0;
                                                                                if (g) {
                                                                                    if ((g | 0) < 0) {
                                                                                        break h;
                                                                                    }
                                                                                    d = sa(g);
                                                                                    F[c + 8 >> 2] = d;
                                                                                    F[c + 12 >> 2] = d;
                                                                                    F[c + 16 >> 2] = d + (g >> 2 << 2);
                                                                                    e = F[f + 24 >> 2];
                                                                                    g = F[f + 28 >> 2] - e | 0;
                                                                                    if ((g | 0) > 0) {
                                                                                        d = ta(d, e, g) + g | 0;
                                                                                    }
                                                                                    F[c + 12 >> 2] = d;
                                                                                }
                                                                                J[c + 20 >> 2] = J[f + 36 >> 2];
                                                                                F[a + 40 >> 2] = c + 24;
                                                                                break k;
                                                                            }
                                                                            c = 0;
                                                                            l: {
                                                                                m: {
                                                                                    n: {
                                                                                        o: {
                                                                                            g = F[a + 40 >> 2];
                                                                                            h = F[a + 36 >> 2];
                                                                                            e = (g - h | 0) / 24 | 0;
                                                                                            d = e + 1 | 0;
                                                                                            if (d >>> 0 < 178956971) {
                                                                                                i = (F[a + 44 >> 2] - h | 0) / 24 | 0;
                                                                                                j = i << 1;
                                                                                                i = i >>> 0 < 89478485 ? d >>> 0 > j >>> 0 ? d : j : 178956970;
                                                                                                if (i) {
                                                                                                    if (i >>> 0 >= 178956971) {
                                                                                                        break o;
                                                                                                    }
                                                                                                    c = sa(L(i, 24));
                                                                                                }
                                                                                                e = L(e, 24) + c | 0;
                                                                                                F[e >> 2] = 1140;
                                                                                                d = F[f + 20 >> 2];
                                                                                                F[e + 16 >> 2] = 0;
                                                                                                F[e + 8 >> 2] = 0;
                                                                                                F[e + 12 >> 2] = 0;
                                                                                                F[e + 4 >> 2] = d;
                                                                                                l = F[f + 24 >> 2];
                                                                                                d = F[f + 28 >> 2] - l | 0;
                                                                                                if (d) {
                                                                                                    if ((d | 0) < 0) {
                                                                                                        break n;
                                                                                                    }
                                                                                                    j = sa(d);
                                                                                                    F[e + 8 >> 2] = j;
                                                                                                    F[e + 16 >> 2] = j + (d >> 2 << 2);
                                                                                                    q = e, r = ta(j, l, d) + d | 0, F[q + 12 >> 2] = r;
                                                                                                }
                                                                                                c = L(i, 24) + c | 0;
                                                                                                J[e + 20 >> 2] = J[f + 36 >> 2];
                                                                                                d = e + 24 | 0;
                                                                                                if ((g | 0) == (h | 0)) {
                                                                                                    break m;
                                                                                                }
                                                                                                while (1) {
                                                                                                    e = e - 24 | 0;
                                                                                                    F[e >> 2] = 1140;
                                                                                                    F[e + 4 >> 2] = F[g - 20 >> 2];
                                                                                                    i = g - 16 | 0;
                                                                                                    F[e + 8 >> 2] = F[i >> 2];
                                                                                                    F[e + 12 >> 2] = F[g - 12 >> 2];
                                                                                                    j = g - 8 | 0;
                                                                                                    F[e + 16 >> 2] = F[j >> 2];
                                                                                                    F[j >> 2] = 0;
                                                                                                    F[i >> 2] = 0;
                                                                                                    F[i + 4 >> 2] = 0;
                                                                                                    J[e + 20 >> 2] = J[g - 4 >> 2];
                                                                                                    g = g - 24 | 0;
                                                                                                    if ((h | 0) != (g | 0)) {
                                                                                                        continue;
                                                                                                    }
                                                                                                    break;
                                                                                                }
                                                                                                F[a + 44 >> 2] = c;
                                                                                                h = F[a + 40 >> 2];
                                                                                                F[a + 40 >> 2] = d;
                                                                                                g = F[a + 36 >> 2];
                                                                                                F[a + 36 >> 2] = e;
                                                                                                if ((g | 0) == (h | 0)) {
                                                                                                    break l;
                                                                                                }
                                                                                                while (1) {
                                                                                                    h = h - 24 | 0;
                                                                                                    ga[F[F[h >> 2] >> 2]](h) | 0;
                                                                                                    if ((g | 0) != (h | 0)) {
                                                                                                        continue;
                                                                                                    }
                                                                                                    break;
                                                                                                }
                                                                                                break l;
                                                                                            }
                                                                                            va();
                                                                                            V();
                                                                                        }
                                                                                        wa(1336);
                                                                                        V();
                                                                                    }
                                                                                    va();
                                                                                    V();
                                                                                }
                                                                                F[a + 44 >> 2] = c;
                                                                                F[a + 40 >> 2] = d;
                                                                                F[a + 36 >> 2] = e;
                                                                            }
                                                                            if (g) {
                                                                                ra(g);
                                                                            }
                                                                        }
                                                                        h = 1;
                                                                    }
                                                                    F[f + 16 >> 2] = 1140;
                                                                    c = F[f + 24 >> 2];
                                                                    if (c) {
                                                                        F[f + 28 >> 2] = c;
                                                                        ra(c);
                                                                    }
                                                                    if (!h) {
                                                                        break c;
                                                                    }
                                                                }
                                                                k = k + 1 | 0;
                                                                if ((ga[F[F[a >> 2] + 24 >> 2]](a) | 0) > (k | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                            break d;
                                                        }
                                                        i = ga[F[F[a >> 2] + 24 >> 2]](a) | 0;
                                                        F[f + 712 >> 2] = 0;
                                                        F[f + 704 >> 2] = 0;
                                                        F[f + 708 >> 2] = 0;
                                                        if (i) {
                                                            if (i >>> 0 >= 214748365) {
                                                                break g;
                                                            }
                                                            c = L(i, 20);
                                                            d = sa(c);
                                                            F[f + 704 >> 2] = d;
                                                            F[f + 712 >> 2] = c + d;
                                                            c = L((c - 20 >>> 0) / 20 | 0, 20) + 20 | 0;
                                                            q = f, r = ua(d, 0, c) + c | 0, F[q + 708 >> 2] = r;
                                                            while (1) {
                                                                c = ga[F[F[a >> 2] + 20 >> 2]](a, k) | 0;
                                                                d = F[F[F[(ga[F[F[a >> 2] + 28 >> 2]](a) | 0) + 4 >> 2] + 8 >> 2] + (c << 2) >> 2];
                                                                g = F[d + 28 >> 2];
                                                                c = g - 1 | 0;
                                                                if (c >>> 0 <= 10) {
                                                                    c = F[(c << 2) + 13616 >> 2];
                                                                }
                                                                else {
                                                                    c = -1;
                                                                }
                                                                j = (c | 0) > 0 ? c : 0;
                                                                if (j >>> 0 > 4) {
                                                                    break e;
                                                                }
                                                                c = F[f + 704 >> 2] + L(k, 20) | 0;
                                                                l = D[d + 24 | 0];
                                                                F[c + 16 >> 2] = l;
                                                                F[c + 12 >> 2] = j;
                                                                F[c + 8 >> 2] = g;
                                                                F[c + 4 >> 2] = e;
                                                                F[c >> 2] = d;
                                                                e = e + l | 0;
                                                                k = k + 1 | 0;
                                                                if ((i | 0) != (k | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                        }
                                                        c = ga[F[F[a >> 2] + 20 >> 2]](a, 0) | 0;
                                                        m = F[F[F[(ga[F[F[a >> 2] + 28 >> 2]](a) | 0) + 4 >> 2] + 8 >> 2] + (c << 2) >> 2];
                                                        D[m + 84 | 0] = 1;
                                                        F[m + 72 >> 2] = F[m + 68 >> 2];
                                                        g = F[b + 12 >> 2];
                                                        c = g;
                                                        d = F[b + 20 >> 2];
                                                        j = F[b + 8 >> 2];
                                                        k = F[b + 16 >> 2];
                                                        if ((c | 0) <= (d | 0) & j >>> 0 <= k >>> 0 | (c | 0) < (d | 0)) {
                                                            break e;
                                                        }
                                                        n = F[b >> 2];
                                                        p = G[n + k | 0];
                                                        c = d;
                                                        l = k + 1 | 0;
                                                        c = l ? c : c + 1 | 0;
                                                        F[b + 16 >> 2] = l;
                                                        F[b + 20 >> 2] = c;
                                                        p: {
                                                            switch (p | 0) {
                                                                case 0:
                                                                    q: {
                                                                        if (j >>> 0 <= l >>> 0 & (c | 0) >= (g | 0) | (c | 0) > (g | 0)) {
                                                                            break q;
                                                                        }
                                                                        c = d;
                                                                        a = k + 2 | 0;
                                                                        c = a >>> 0 < 2 ? c + 1 | 0 : c;
                                                                        F[b + 16 >> 2] = a;
                                                                        F[b + 20 >> 2] = c;
                                                                        c = d;
                                                                        d = k + 6 | 0;
                                                                        c = d >>> 0 < 6 ? c + 1 | 0 : c;
                                                                        if (d >>> 0 > j >>> 0 & (c | 0) >= (g | 0) | (c | 0) > (g | 0)) {
                                                                            break q;
                                                                        }
                                                                        a = a + n | 0;
                                                                        a = G[a | 0] | G[a + 1 | 0] << 8 | (G[a + 2 | 0] << 16 | G[a + 3 | 0] << 24);
                                                                        F[b + 16 >> 2] = d;
                                                                        F[b + 20 >> 2] = c;
                                                                        qb(m, a);
                                                                        h = f + 672 | 0;
                                                                        F[h + 20 >> 2] = 0;
                                                                        F[h + 12 >> 2] = 0;
                                                                        F[h + 16 >> 2] = 0;
                                                                        F[h >> 2] = 0;
                                                                        F[h + 4 >> 2] = 0;
                                                                        F[h + 20 >> 2] = a;
                                                                        k = Bc(f + 16 | 0, f + 704 | 0);
                                                                        g = 0;
                                                                        e = ea - 32 | 0;
                                                                        ea = e;
                                                                        F[e + 24 >> 2] = 0;
                                                                        F[e + 16 >> 2] = 0;
                                                                        F[e + 20 >> 2] = 0;
                                                                        a = F[b + 12 >> 2];
                                                                        j = a;
                                                                        c = F[b + 20 >> 2];
                                                                        d = c;
                                                                        l = F[b + 16 >> 2];
                                                                        i = l + 4 | 0;
                                                                        c = i >>> 0 < 4 ? c + 1 | 0 : c;
                                                                        m = F[b + 8 >> 2];
                                                                        r: {
                                                                            if (m >>> 0 < i >>> 0 & (a | 0) <= (c | 0) | (a | 0) < (c | 0)) {
                                                                                break r;
                                                                            }
                                                                            n = F[b >> 2];
                                                                            a = n + l | 0;
                                                                            a = G[a | 0] | G[a + 1 | 0] << 8 | (G[a + 2 | 0] << 16 | G[a + 3 | 0] << 24);
                                                                            F[b + 16 >> 2] = i;
                                                                            F[b + 20 >> 2] = c;
                                                                            s: {
                                                                                t: {
                                                                                    switch (a - 2 | 0) {
                                                                                        case 1:
                                                                                            if ((c | 0) >= (j | 0) & i >>> 0 >= m >>> 0 | (c | 0) > (j | 0)) {
                                                                                                break r;
                                                                                            }
                                                                                            a = D[i + n | 0];
                                                                                            c = d;
                                                                                            d = l + 5 | 0;
                                                                                            c = d >>> 0 < 5 ? c + 1 | 0 : c;
                                                                                            F[b + 16 >> 2] = d;
                                                                                            F[b + 20 >> 2] = c;
                                                                                            F[h + 8 >> 2] = a;
                                                                                            if ((a | 0) == 1) {
                                                                                                if (Sd(h, b, e + 16 | 0)) {
                                                                                                    break s;
                                                                                                }
                                                                                                break r;
                                                                                            }
                                                                                            Pd(1943, 23, F[3451]);
                                                                                            break r;
                                                                                        default:
                                                                                            Pd(1918, 24, F[3451]);
                                                                                            break r;
                                                                                        case 0: break t;
                                                                                    }
                                                                                }
                                                                                if (!Sd(h, b, e + 16 | 0)) {
                                                                                    break r;
                                                                                }
                                                                            }
                                                                            F[e + 8 >> 2] = F[e + 16 >> 2];
                                                                            F[e >> 2] = F[e + 20 >> 2];
                                                                            a = ea - 32 | 0;
                                                                            ea = a;
                                                                            b = F[h >> 2];
                                                                            o = J[h + 4 >> 2];
                                                                            g = a + 24 | 0;
                                                                            F[g >> 2] = 1065353216;
                                                                            b = -1 << b ^ -1;
                                                                            if ((b | 0) > 0) {
                                                                                J[g >> 2] = o / M(b | 0);
                                                                            }
                                                                            h = F[e + 8 >> 2];
                                                                            if ((h | 0) != F[e >> 2]) {
                                                                                c = F[k + 28 >> 2];
                                                                                while (1) {
                                                                                    d = F[h >> 2];
                                                                                    i = F[h + 4 >> 2];
                                                                                    o = J[g >> 2];
                                                                                    J[a + 16 >> 2] = o * M(F[h + 8 >> 2] - b | 0);
                                                                                    J[a + 12 >> 2] = o * M(i - b | 0);
                                                                                    J[a + 8 >> 2] = o * M(d - b | 0);
                                                                                    i = F[k + 16 >> 2];
                                                                                    d = F[i >> 2];
                                                                                    if (!G[d + 84 | 0]) {
                                                                                        c = F[F[d + 68 >> 2] + (c << 2) >> 2];
                                                                                    }
                                                                                    j = c;
                                                                                    c = F[d + 40 >> 2];
                                                                                    ta(F[F[d >> 2] >> 2] + L(j, c) | 0, (a + 8 | 0) + (F[i + 4 >> 2] << 2) | 0, c);
                                                                                    c = F[k + 28 >> 2] + 1 | 0;
                                                                                    F[k + 28 >> 2] = c;
                                                                                    h = h + 12 | 0;
                                                                                    if ((h | 0) != F[e >> 2]) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                            }
                                                                            ea = a + 32 | 0;
                                                                            g = 1;
                                                                        }
                                                                        a = F[e + 16 >> 2];
                                                                        if (a) {
                                                                            F[e + 20 >> 2] = a;
                                                                            ra(a);
                                                                        }
                                                                        ea = e + 32 | 0;
                                                                        zc(k);
                                                                        h = 1;
                                                                        if (g) {
                                                                            break e;
                                                                        }
                                                                    }
                                                                    h = 0;
                                                                    break e;
                                                                case 1: break p;
                                                                default: break e;
                                                            }
                                                        }
                                                        if (j >>> 0 <= l >>> 0 & (c | 0) >= (g | 0) | (c | 0) > (g | 0)) {
                                                            break e;
                                                        }
                                                        l = G[l + n | 0];
                                                        c = d;
                                                        m = k + 2 | 0;
                                                        c = m >>> 0 < 2 ? c + 1 | 0 : c;
                                                        F[b + 16 >> 2] = m;
                                                        F[b + 20 >> 2] = c;
                                                        if (l >>> 0 >= 7) {
                                                            F[f >> 2] = l;
                                                            Od(1795, f);
                                                            break e;
                                                        }
                                                        c = d;
                                                        d = k + 6 | 0;
                                                        c = d >>> 0 < 6 ? c + 1 | 0 : c;
                                                        k = d;
                                                        if (d >>> 0 > j >>> 0 & (c | 0) >= (g | 0) | (c | 0) > (g | 0)) {
                                                            break e;
                                                        }
                                                        d = m + n | 0;
                                                        d = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                                        F[b + 16 >> 2] = k;
                                                        F[b + 20 >> 2] = c;
                                                        if (i) {
                                                            k = 0;
                                                            while (1) {
                                                                c = ga[F[F[a >> 2] + 20 >> 2]](a, k) | 0;
                                                                c = F[F[F[(ga[F[F[a >> 2] + 28 >> 2]](a) | 0) + 4 >> 2] + 8 >> 2] + (c << 2) >> 2];
                                                                qb(c, d);
                                                                D[c + 84 | 0] = 1;
                                                                F[c + 72 >> 2] = F[c + 68 >> 2];
                                                                k = k + 1 | 0;
                                                                if ((i | 0) != (k | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                        }
                                                        a = Bc(f + 672 | 0, f + 704 | 0);
                                                        u: {
                                                            v: {
                                                                switch (l | 0) {
                                                                    case 1:
                                                                        c = zb(f + 16 | 0, e);
                                                                        b = Ad(c, b, a);
                                                                        Ab(c);
                                                                        if (!b) {
                                                                            break f;
                                                                        }
                                                                        break u;
                                                                    case 2:
                                                                        c = xb(f + 16 | 0, e);
                                                                        b = zd(c, b, a);
                                                                        yb(c);
                                                                        if (!b) {
                                                                            break f;
                                                                        }
                                                                        break u;
                                                                    case 3:
                                                                        c = xb(f + 16 | 0, e);
                                                                        b = yd(c, b, a);
                                                                        yb(c);
                                                                        if (!b) {
                                                                            break f;
                                                                        }
                                                                        break u;
                                                                    case 4:
                                                                        c = ab(f + 16 | 0, e);
                                                                        b = xd(c, b, a);
                                                                        bb(c);
                                                                        if (!b) {
                                                                            break f;
                                                                        }
                                                                        break u;
                                                                    case 5:
                                                                        c = ab(f + 16 | 0, e);
                                                                        b = wd(c, b, a);
                                                                        bb(c);
                                                                        if (!b) {
                                                                            break f;
                                                                        }
                                                                        break u;
                                                                    case 6:
                                                                        c = ab(f + 16 | 0, e);
                                                                        b = vd(c, b, a);
                                                                        bb(c);
                                                                        if (b) {
                                                                            break u;
                                                                        }
                                                                        break f;
                                                                    case 0: break v;
                                                                    default: break f;
                                                                }
                                                            }
                                                            c = zb(f + 16 | 0, e);
                                                            b = Bd(c, b, a);
                                                            Ab(c);
                                                            if (!b) {
                                                                break f;
                                                            }
                                                        }
                                                        zc(a);
                                                        h = 1;
                                                        break e;
                                                    }
                                                    va();
                                                    V();
                                                }
                                                va();
                                                V();
                                            }
                                            zc(a);
                                        }
                                        a = F[f + 704 >> 2];
                                        if (!a) {
                                            break a;
                                        }
                                        F[f + 708 >> 2] = a;
                                        ra(a);
                                        break a;
                                    }
                                    if (F[a + 52 >> 2] == F[a + 48 >> 2]) {
                                        h = 1;
                                        break b;
                                    }
                                    k = 0;
                                    while (1) {
                                        if (!ud(1, f + 16 | 0, b)) {
                                            break c;
                                        }
                                        h = 1;
                                        c = F[a + 48 >> 2];
                                        d = F[f + 16 >> 2];
                                        F[c + (k << 2) >> 2] = d >>> 1 ^ 0 - (d & 1);
                                        k = k + 1 | 0;
                                        if (k >>> 0 < F[a + 52 >> 2] - c >> 2 >>> 0) {
                                            continue;
                                        }
                                        break;
                                    }
                                    break b;
                                }
                                h = 0;
                            }
                            a = F[f + 672 >> 2];
                            if (!a) {
                                break a;
                            }
                            F[f + 676 >> 2] = a;
                            ra(a);
                        } ea = f + 720 | 0; return h | 0; }
                        function Bd(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0; f = F[b + 12 >> 2]; d = F[b + 20 >> 2]; i = F[b + 16 >> 2]; e = i + 4 | 0; d = e >>> 0 < 4 ? d + 1 | 0 : d; a: {
                            if (e >>> 0 > I[b + 8 >> 2] & (d | 0) >= (f | 0) | (d | 0) > (f | 0)) {
                                break a;
                            }
                            d = i + F[b >> 2] | 0;
                            F[a >> 2] = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                            d = F[b + 20 >> 2];
                            f = d;
                            e = F[b + 16 >> 2];
                            i = e + 4 | 0;
                            d = i >>> 0 < 4 ? d + 1 | 0 : d;
                            j = i;
                            F[b + 16 >> 2] = i;
                            F[b + 20 >> 2] = d;
                            if (I[a >> 2] > 32) {
                                break a;
                            }
                            i = F[b + 12 >> 2];
                            d = f;
                            f = e + 8 | 0;
                            d = f >>> 0 < 8 ? d + 1 | 0 : d;
                            if (f >>> 0 > I[b + 8 >> 2] & (d | 0) >= (i | 0) | (d | 0) > (i | 0)) {
                                break a;
                            }
                            d = j + F[b >> 2] | 0;
                            h = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                            F[a + 4 >> 2] = h;
                            d = F[b + 20 >> 2];
                            f = F[b + 16 >> 2] + 4 | 0;
                            d = f >>> 0 < 4 ? d + 1 | 0 : d;
                            F[b + 16 >> 2] = f;
                            F[b + 20 >> 2] = d;
                            if (!h) {
                                return 1;
                            }
                            h = 0;
                            F[a + 8 >> 2] = 0;
                            if (!ya(a + 16 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 36 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 56 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 76 | 0, b)) {
                                break a;
                            }
                            r = F[a + 4 >> 2];
                            i = c;
                            b = 0;
                            c = 0;
                            e = ea - 32 | 0;
                            ea = e;
                            f = a;
                            a = F[a + 12 >> 2];
                            F[e + 16 >> 2] = 0;
                            F[e + 8 >> 2] = 0;
                            F[e + 12 >> 2] = 0;
                            b: {
                                c: {
                                    if (a) {
                                        if (a >>> 0 >= 1073741824) {
                                            break c;
                                        }
                                        d = a << 2;
                                        b = sa(d);
                                        F[e + 8 >> 2] = b;
                                        c = b + d | 0;
                                        F[e + 16 >> 2] = c;
                                        ua(b, 0, d);
                                        F[e + 12 >> 2] = c;
                                    }
                                    d = F[f + 120 >> 2];
                                    h = F[d >> 2];
                                    if (h) {
                                        F[d + 4 >> 2] = h;
                                        ra(h);
                                        F[d + 8 >> 2] = 0;
                                        F[d >> 2] = 0;
                                        F[d + 4 >> 2] = 0;
                                        c = F[e + 12 >> 2];
                                        b = F[e + 8 >> 2];
                                        a = F[f + 12 >> 2];
                                    }
                                    F[d + 4 >> 2] = c;
                                    F[d >> 2] = b;
                                    F[d + 8 >> 2] = F[e + 16 >> 2];
                                    b = 0;
                                    F[e + 16 >> 2] = 0;
                                    F[e + 8 >> 2] = 0;
                                    F[e + 12 >> 2] = 0;
                                    d: {
                                        if (a) {
                                            if (a >>> 0 >= 1073741824) {
                                                break d;
                                            }
                                            a = a << 2;
                                            g = sa(a);
                                            F[e + 8 >> 2] = g;
                                            b = a + g | 0;
                                            F[e + 16 >> 2] = b;
                                            ua(g, 0, a);
                                            F[e + 12 >> 2] = b;
                                        }
                                        a = F[f + 132 >> 2];
                                        c = F[a >> 2];
                                        if (c) {
                                            F[a + 4 >> 2] = c;
                                            ra(c);
                                            F[a + 8 >> 2] = 0;
                                            F[a >> 2] = 0;
                                            F[a + 4 >> 2] = 0;
                                            g = F[e + 8 >> 2];
                                            b = F[e + 12 >> 2];
                                        }
                                        F[a + 4 >> 2] = b;
                                        F[a >> 2] = g;
                                        F[a + 8 >> 2] = F[e + 16 >> 2];
                                        F[e + 24 >> 2] = 0;
                                        F[e + 28 >> 2] = 0;
                                        F[e + 16 >> 2] = 0;
                                        F[e + 20 >> 2] = 0;
                                        F[e + 8 >> 2] = 0;
                                        F[e + 12 >> 2] = 0;
                                        za(e + 8 | 0);
                                        a = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                        b = (a >>> 0) / 341 | 0;
                                        a = F[F[e + 12 >> 2] + (b << 2) >> 2] + L(a - L(b, 341) | 0, 12) | 0;
                                        F[a + 4 >> 2] = 0;
                                        F[a + 8 >> 2] = 0;
                                        F[a >> 2] = r;
                                        d = 1;
                                        b = F[e + 28 >> 2];
                                        a = b + 1 | 0;
                                        F[e + 28 >> 2] = a;
                                        e: {
                                            if (a >>> 0 < b >>> 0) {
                                                break e;
                                            }
                                            while (1) {
                                                k = F[e + 12 >> 2];
                                                d = F[e + 24 >> 2];
                                                g = a - 1 | 0;
                                                b = d + g | 0;
                                                c = (b >>> 0) / 341 | 0;
                                                c = F[k + (c << 2) >> 2] + L(b - L(c, 341) | 0, 12) | 0;
                                                b = F[c + 8 >> 2];
                                                h = F[c + 4 >> 2];
                                                j = F[c >> 2];
                                                F[e + 28 >> 2] = g;
                                                c = F[e + 16 >> 2];
                                                g = c - k | 0;
                                                if (((g ? L(g >> 2, 341) - 1 | 0 : 0) - (a + d | 0) | 0) + 1 >>> 0 >= 682) {
                                                    ra(F[c - 4 >> 2]);
                                                    F[e + 16 >> 2] = F[e + 16 >> 2] - 4;
                                                }
                                                d = 0;
                                                if (j >>> 0 > r >>> 0) {
                                                    break e;
                                                }
                                                a = F[f + 12 >> 2];
                                                g = (h | 0) == (a - 1 | 0) ? 0 : h + 1 | 0;
                                                if (g >>> 0 >= a >>> 0) {
                                                    break e;
                                                }
                                                l = L(b, 12);
                                                m = l + F[f + 132 >> 2] | 0;
                                                k = l + F[f + 120 >> 2] | 0;
                                                f: {
                                                    g: {
                                                        o = g << 2;
                                                        c = F[f >> 2] - F[o + F[m >> 2] >> 2] | 0;
                                                        if (!c) {
                                                            if (!j) {
                                                                break g;
                                                            }
                                                            m = 0;
                                                            a = F[i + 16 >> 2];
                                                            g = F[i + 20 >> 2];
                                                            if ((a | 0) == (g | 0)) {
                                                                a = F[f + 8 >> 2];
                                                                F[i + 28 >> 2] = j + F[i + 28 >> 2];
                                                                F[f + 8 >> 2] = a + j;
                                                                break g;
                                                            }
                                                            while (1) {
                                                                h = 0;
                                                                h: {
                                                                    if ((a | 0) == (g | 0)) {
                                                                        break h;
                                                                    }
                                                                    while (1) {
                                                                        d = L(h, 20) + a | 0;
                                                                        c = F[k >> 2] + (F[d + 4 >> 2] << 2) | 0;
                                                                        l = F[d >> 2];
                                                                        g = F[d + 12 >> 2];
                                                                        i: {
                                                                            if (g >>> 0 > 3) {
                                                                                break i;
                                                                            }
                                                                            b = F[i + 12 >> 2];
                                                                            if (!F[d + 16 >> 2]) {
                                                                                c = b;
                                                                                break i;
                                                                            }
                                                                            a = 0;
                                                                            while (1) {
                                                                                b = ta(b, (a << 2) + c | 0, g);
                                                                                g = F[d + 12 >> 2];
                                                                                b = b + g | 0;
                                                                                a = a + 1 | 0;
                                                                                if (a >>> 0 < I[d + 16 >> 2]) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                            c = F[i + 12 >> 2];
                                                                        }
                                                                        a = F[i + 28 >> 2];
                                                                        a = G[l + 84 | 0] ? a : F[F[l + 68 >> 2] + (a << 2) >> 2];
                                                                        if (a >>> 0 >= I[l + 80 >> 2]) {
                                                                            break h;
                                                                        }
                                                                        b = a;
                                                                        a = F[l + 40 >> 2];
                                                                        ta(F[F[l >> 2] >> 2] + L(b, a) | 0, c, a);
                                                                        h = h + 1 | 0;
                                                                        a = F[i + 16 >> 2];
                                                                        if (h >>> 0 < (F[i + 20 >> 2] - a | 0) / 20 >>> 0) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                }
                                                                F[i + 28 >> 2] = F[i + 28 >> 2] + 1;
                                                                F[f + 8 >> 2] = F[f + 8 >> 2] + 1;
                                                                m = m + 1 | 0;
                                                                if ((j | 0) == (m | 0)) {
                                                                    break g;
                                                                }
                                                                a = F[i + 16 >> 2];
                                                                g = F[i + 20 >> 2];
                                                                continue;
                                                            }
                                                        }
                                                        j: {
                                                            k: {
                                                                l: {
                                                                    m: {
                                                                        if (j >>> 0 <= 2) {
                                                                            c = F[f + 108 >> 2];
                                                                            F[c >> 2] = g;
                                                                            b = 1;
                                                                            a = F[f + 12 >> 2];
                                                                            if (a >>> 0 > 1) {
                                                                                break m;
                                                                            }
                                                                            break j;
                                                                        }
                                                                        if (I[f + 8 >> 2] > I[f + 4 >> 2]) {
                                                                            break e;
                                                                        }
                                                                        a = F[f + 120 >> 2];
                                                                        n = b + 1 | 0;
                                                                        m = L(n, 12);
                                                                        d = a + m | 0;
                                                                        if ((d | 0) != (k | 0)) {
                                                                            Ca(d, F[k >> 2], F[k + 4 >> 2]);
                                                                            a = F[f + 120 >> 2];
                                                                        }
                                                                        a = o + F[a + m >> 2] | 0;
                                                                        F[a >> 2] = F[a >> 2] + (1 << c - 1);
                                                                        a = O(j) ^ 31;
                                                                        c = F[f + 32 >> 2];
                                                                        h = 32 - c | 0;
                                                                        n: {
                                                                            if ((a | 0) <= (h | 0)) {
                                                                                h = F[f + 28 >> 2];
                                                                                if ((h | 0) == F[f + 20 >> 2]) {
                                                                                    d = 0;
                                                                                    break n;
                                                                                }
                                                                                d = F[h >> 2];
                                                                                k = a + c | 0;
                                                                                F[f + 32 >> 2] = k;
                                                                                d = d << c >>> 32 - a | 0;
                                                                                if ((k | 0) != 32) {
                                                                                    break n;
                                                                                }
                                                                                F[f + 32 >> 2] = 0;
                                                                                F[f + 28 >> 2] = h + 4;
                                                                                break n;
                                                                            }
                                                                            d = F[f + 28 >> 2];
                                                                            k = d + 4 | 0;
                                                                            if ((k | 0) == F[f + 20 >> 2]) {
                                                                                d = 0;
                                                                                break n;
                                                                            }
                                                                            q = F[d >> 2];
                                                                            F[f + 28 >> 2] = k;
                                                                            h = a - h | 0;
                                                                            F[f + 32 >> 2] = h;
                                                                            d = F[d + 4 >> 2] >>> 32 - h | q << c >>> 32 - a;
                                                                        }
                                                                        a = (j >>> 1 | 0) - d | 0;
                                                                        d = j - a | 0;
                                                                        o: {
                                                                            if ((d | 0) == (a | 0)) {
                                                                                d = a;
                                                                                break o;
                                                                            }
                                                                            c = F[f + 88 >> 2];
                                                                            if ((c | 0) == F[f + 80 >> 2]) {
                                                                                break l;
                                                                            }
                                                                            h = F[c >> 2];
                                                                            j = F[f + 92 >> 2];
                                                                            k = j + 1 | 0;
                                                                            F[f + 92 >> 2] = k;
                                                                            h = h & -2147483648 >>> j;
                                                                            p: {
                                                                                if ((k | 0) == 32) {
                                                                                    F[f + 92 >> 2] = 0;
                                                                                    F[f + 88 >> 2] = c + 4;
                                                                                    if (h) {
                                                                                        break p;
                                                                                    }
                                                                                    break l;
                                                                                }
                                                                                if (!h) {
                                                                                    break l;
                                                                                }
                                                                            }
                                                                        }
                                                                        h = d;
                                                                        d = a;
                                                                        break k;
                                                                    }
                                                                    while (1) {
                                                                        g = (a - 1 | 0) == (g | 0) ? 0 : g + 1 | 0;
                                                                        F[c + (b << 2) >> 2] = g;
                                                                        a = F[f + 12 >> 2];
                                                                        b = b + 1 | 0;
                                                                        if (a >>> 0 > b >>> 0) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    break j;
                                                                }
                                                                h = a;
                                                            }
                                                            a = F[f + 132 >> 2];
                                                            c = a + l | 0;
                                                            j = F[c >> 2];
                                                            k = j + o | 0;
                                                            F[k >> 2] = F[k >> 2] + 1;
                                                            Ca(a + m | 0, j, F[c + 4 >> 2]);
                                                            if (d) {
                                                                a = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                                c = F[e + 12 >> 2];
                                                                j = F[e + 16 >> 2] - c | 0;
                                                                if ((a | 0) == ((j ? L(j >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                    za(e + 8 | 0);
                                                                    c = F[e + 12 >> 2];
                                                                    a = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                                }
                                                                j = c;
                                                                c = (a >>> 0) / 341 | 0;
                                                                a = F[j + (c << 2) >> 2] + L(a - L(c, 341) | 0, 12) | 0;
                                                                F[a + 8 >> 2] = b;
                                                                F[a + 4 >> 2] = g;
                                                                F[a >> 2] = d;
                                                                F[e + 28 >> 2] = F[e + 28 >> 2] + 1;
                                                            }
                                                            if (!h) {
                                                                break g;
                                                            }
                                                            a = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                            b = F[e + 12 >> 2];
                                                            c = F[e + 16 >> 2] - b | 0;
                                                            if ((a | 0) == ((c ? L(c >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                za(e + 8 | 0);
                                                                b = F[e + 12 >> 2];
                                                                a = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                            }
                                                            c = b;
                                                            b = (a >>> 0) / 341 | 0;
                                                            a = F[c + (b << 2) >> 2] + L(a - L(b, 341) | 0, 12) | 0;
                                                            F[a + 8 >> 2] = n;
                                                            F[a + 4 >> 2] = g;
                                                            F[a >> 2] = h;
                                                            a = F[e + 28 >> 2] + 1 | 0;
                                                            F[e + 28 >> 2] = a;
                                                            break f;
                                                        }
                                                        o = 0;
                                                        if (!j) {
                                                            break g;
                                                        }
                                                        while (1) {
                                                            if (a) {
                                                                h = F[f + 40 >> 2];
                                                                d = F[f + 96 >> 2];
                                                                q = F[f + 108 >> 2];
                                                                t = F[k >> 2];
                                                                u = F[m >> 2];
                                                                a = 0;
                                                                while (1) {
                                                                    g = q + (a << 2) | 0;
                                                                    F[d + (F[g >> 2] << 2) >> 2] = 0;
                                                                    c = F[g >> 2] << 2;
                                                                    b = F[f >> 2] - F[c + u >> 2] | 0;
                                                                    q: {
                                                                        if (!b) {
                                                                            break q;
                                                                        }
                                                                        c = c + d | 0;
                                                                        l = F[f + 52 >> 2];
                                                                        p = 32 - l | 0;
                                                                        if ((p | 0) >= (b | 0)) {
                                                                            n = F[f + 48 >> 2];
                                                                            if ((n | 0) == (h | 0)) {
                                                                                F[c >> 2] = 0;
                                                                                break q;
                                                                            }
                                                                            F[c >> 2] = F[n >> 2] << l >>> 32 - b;
                                                                            b = b + F[f + 52 >> 2] | 0;
                                                                            F[f + 52 >> 2] = b;
                                                                            if ((b | 0) != 32) {
                                                                                break q;
                                                                            }
                                                                            F[f + 52 >> 2] = 0;
                                                                            F[f + 48 >> 2] = n + 4;
                                                                            break q;
                                                                        }
                                                                        n = F[f + 48 >> 2];
                                                                        s = n + 4 | 0;
                                                                        if ((h | 0) == (s | 0)) {
                                                                            F[c >> 2] = 0;
                                                                            break q;
                                                                        }
                                                                        v = F[n >> 2];
                                                                        F[f + 48 >> 2] = s;
                                                                        p = b - p | 0;
                                                                        F[f + 52 >> 2] = p;
                                                                        F[c >> 2] = F[n + 4 >> 2] >>> 32 - p | v << l >>> 32 - b;
                                                                    }
                                                                    b = F[g >> 2] << 2;
                                                                    c = b + d | 0;
                                                                    F[c >> 2] = F[c >> 2] | F[b + t >> 2];
                                                                    a = a + 1 | 0;
                                                                    if (a >>> 0 < I[f + 12 >> 2]) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            h = 0;
                                                            a = F[i + 16 >> 2];
                                                            r: {
                                                                if ((a | 0) == F[i + 20 >> 2]) {
                                                                    break r;
                                                                }
                                                                while (1) {
                                                                    d = L(h, 20) + a | 0;
                                                                    c = F[f + 96 >> 2] + (F[d + 4 >> 2] << 2) | 0;
                                                                    l = F[d >> 2];
                                                                    g = F[d + 12 >> 2];
                                                                    s: {
                                                                        if (g >>> 0 > 3) {
                                                                            break s;
                                                                        }
                                                                        b = F[i + 12 >> 2];
                                                                        if (!F[d + 16 >> 2]) {
                                                                            c = b;
                                                                            break s;
                                                                        }
                                                                        a = 0;
                                                                        while (1) {
                                                                            b = ta(b, (a << 2) + c | 0, g);
                                                                            g = F[d + 12 >> 2];
                                                                            b = b + g | 0;
                                                                            a = a + 1 | 0;
                                                                            if (a >>> 0 < I[d + 16 >> 2]) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        c = F[i + 12 >> 2];
                                                                    }
                                                                    a = F[i + 28 >> 2];
                                                                    a = G[l + 84 | 0] ? a : F[F[l + 68 >> 2] + (a << 2) >> 2];
                                                                    if (a >>> 0 >= I[l + 80 >> 2]) {
                                                                        break r;
                                                                    }
                                                                    b = a;
                                                                    a = F[l + 40 >> 2];
                                                                    ta(F[F[l >> 2] >> 2] + L(b, a) | 0, c, a);
                                                                    h = h + 1 | 0;
                                                                    a = F[i + 16 >> 2];
                                                                    if (h >>> 0 < (F[i + 20 >> 2] - a | 0) / 20 >>> 0) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            F[i + 28 >> 2] = F[i + 28 >> 2] + 1;
                                                            F[f + 8 >> 2] = F[f + 8 >> 2] + 1;
                                                            o = o + 1 | 0;
                                                            if ((j | 0) == (o | 0)) {
                                                                break g;
                                                            }
                                                            a = F[f + 12 >> 2];
                                                            continue;
                                                        }
                                                    }
                                                    a = F[e + 28 >> 2];
                                                }
                                                if (a) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            d = 1;
                                        }
                                        F[e + 28 >> 2] = 0;
                                        g = F[e + 16 >> 2];
                                        a = F[e + 12 >> 2];
                                        b = g - a | 0;
                                        if (b >>> 0 >= 9) {
                                            while (1) {
                                                ra(F[a >> 2]);
                                                a = F[e + 12 >> 2] + 4 | 0;
                                                F[e + 12 >> 2] = a;
                                                g = F[e + 16 >> 2];
                                                b = g - a | 0;
                                                if (b >>> 0 > 8) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        c = 170;
                                        t: {
                                            switch ((b >>> 2 | 0) - 1 | 0) {
                                                case 1: c = 341;
                                                case 0:
                                                    F[e + 24 >> 2] = c;
                                                    break;
                                                default: break t;
                                            }
                                        }
                                        u: {
                                            if ((a | 0) == (g | 0)) {
                                                break u;
                                            }
                                            while (1) {
                                                ra(F[a >> 2]);
                                                a = a + 4 | 0;
                                                if ((g | 0) != (a | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            a = F[e + 16 >> 2];
                                            b = F[e + 12 >> 2];
                                            if ((a | 0) == (b | 0)) {
                                                break u;
                                            }
                                            F[e + 16 >> 2] = a + (((a - b | 0) - 4 >>> 2 ^ -1) << 2);
                                        }
                                        a = F[e + 8 >> 2];
                                        if (a) {
                                            ra(a);
                                        }
                                        ea = e + 32 | 0;
                                        break b;
                                    }
                                    va();
                                    V();
                                }
                                va();
                                V();
                            }
                            h = d;
                        } return h; }
                        function Ad(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0; f = F[b + 12 >> 2]; d = F[b + 20 >> 2]; i = F[b + 16 >> 2]; e = i + 4 | 0; d = e >>> 0 < 4 ? d + 1 | 0 : d; a: {
                            if (e >>> 0 > I[b + 8 >> 2] & (d | 0) >= (f | 0) | (d | 0) > (f | 0)) {
                                break a;
                            }
                            d = i + F[b >> 2] | 0;
                            F[a >> 2] = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                            d = F[b + 20 >> 2];
                            f = d;
                            e = F[b + 16 >> 2];
                            i = e + 4 | 0;
                            d = i >>> 0 < 4 ? f + 1 | 0 : f;
                            k = i;
                            F[b + 16 >> 2] = i;
                            F[b + 20 >> 2] = d;
                            if (I[a >> 2] > 32) {
                                break a;
                            }
                            i = F[b + 12 >> 2];
                            d = f;
                            f = e + 8 | 0;
                            d = f >>> 0 < 8 ? d + 1 | 0 : d;
                            if (f >>> 0 > I[b + 8 >> 2] & (d | 0) >= (i | 0) | (d | 0) > (i | 0)) {
                                break a;
                            }
                            d = k + F[b >> 2] | 0;
                            g = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                            F[a + 4 >> 2] = g;
                            d = F[b + 20 >> 2];
                            f = F[b + 16 >> 2] + 4 | 0;
                            d = f >>> 0 < 4 ? d + 1 | 0 : d;
                            F[b + 16 >> 2] = f;
                            F[b + 20 >> 2] = d;
                            if (!g) {
                                return 1;
                            }
                            g = 0;
                            F[a + 8 >> 2] = 0;
                            if (!ya(a + 16 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 36 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 56 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 76 | 0, b)) {
                                break a;
                            }
                            p = F[a + 4 >> 2];
                            i = c;
                            b = 0;
                            c = 0;
                            e = ea - 32 | 0;
                            ea = e;
                            f = a;
                            a = F[a + 12 >> 2];
                            F[e + 16 >> 2] = 0;
                            F[e + 8 >> 2] = 0;
                            F[e + 12 >> 2] = 0;
                            b: {
                                c: {
                                    if (a) {
                                        if (a >>> 0 >= 1073741824) {
                                            break c;
                                        }
                                        d = a << 2;
                                        b = sa(d);
                                        F[e + 8 >> 2] = b;
                                        c = b + d | 0;
                                        F[e + 16 >> 2] = c;
                                        ua(b, 0, d);
                                        F[e + 12 >> 2] = c;
                                    }
                                    d = F[f + 120 >> 2];
                                    g = F[d >> 2];
                                    if (g) {
                                        F[d + 4 >> 2] = g;
                                        ra(g);
                                        F[d + 8 >> 2] = 0;
                                        F[d >> 2] = 0;
                                        F[d + 4 >> 2] = 0;
                                        c = F[e + 12 >> 2];
                                        b = F[e + 8 >> 2];
                                        a = F[f + 12 >> 2];
                                    }
                                    F[d + 4 >> 2] = c;
                                    F[d >> 2] = b;
                                    F[d + 8 >> 2] = F[e + 16 >> 2];
                                    b = 0;
                                    F[e + 16 >> 2] = 0;
                                    F[e + 8 >> 2] = 0;
                                    F[e + 12 >> 2] = 0;
                                    d: {
                                        if (a) {
                                            if (a >>> 0 >= 1073741824) {
                                                break d;
                                            }
                                            a = a << 2;
                                            h = sa(a);
                                            F[e + 8 >> 2] = h;
                                            b = a + h | 0;
                                            F[e + 16 >> 2] = b;
                                            ua(h, 0, a);
                                            F[e + 12 >> 2] = b;
                                        }
                                        a = F[f + 132 >> 2];
                                        c = F[a >> 2];
                                        if (c) {
                                            F[a + 4 >> 2] = c;
                                            ra(c);
                                            F[a + 8 >> 2] = 0;
                                            F[a >> 2] = 0;
                                            F[a + 4 >> 2] = 0;
                                            h = F[e + 8 >> 2];
                                            b = F[e + 12 >> 2];
                                        }
                                        F[a + 4 >> 2] = b;
                                        F[a >> 2] = h;
                                        F[a + 8 >> 2] = F[e + 16 >> 2];
                                        F[e + 24 >> 2] = 0;
                                        F[e + 28 >> 2] = 0;
                                        F[e + 16 >> 2] = 0;
                                        F[e + 20 >> 2] = 0;
                                        F[e + 8 >> 2] = 0;
                                        F[e + 12 >> 2] = 0;
                                        za(e + 8 | 0);
                                        a = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                        b = (a >>> 0) / 341 | 0;
                                        a = F[F[e + 12 >> 2] + (b << 2) >> 2] + L(a - L(b, 341) | 0, 12) | 0;
                                        F[a + 4 >> 2] = 0;
                                        F[a + 8 >> 2] = 0;
                                        F[a >> 2] = p;
                                        d = 1;
                                        b = F[e + 28 >> 2];
                                        a = b + 1 | 0;
                                        F[e + 28 >> 2] = a;
                                        e: {
                                            if (a >>> 0 < b >>> 0) {
                                                break e;
                                            }
                                            while (1) {
                                                j = F[e + 12 >> 2];
                                                d = F[e + 24 >> 2];
                                                h = a - 1 | 0;
                                                b = d + h | 0;
                                                c = (b >>> 0) / 341 | 0;
                                                b = F[j + (c << 2) >> 2] + L(b - L(c, 341) | 0, 12) | 0;
                                                c = F[b + 8 >> 2];
                                                g = F[b + 4 >> 2];
                                                k = F[b >> 2];
                                                F[e + 28 >> 2] = h;
                                                b = F[e + 16 >> 2];
                                                h = b - j | 0;
                                                if (((h ? L(h >> 2, 341) - 1 | 0 : 0) - (a + d | 0) | 0) + 1 >>> 0 >= 682) {
                                                    ra(F[b - 4 >> 2]);
                                                    F[e + 16 >> 2] = F[e + 16 >> 2] - 4;
                                                }
                                                if (k >>> 0 > p >>> 0) {
                                                    d = 0;
                                                    break e;
                                                }
                                                d = 0;
                                                a = F[f + 12 >> 2];
                                                h = (g | 0) == (a - 1 | 0) ? 0 : g + 1 | 0;
                                                if (h >>> 0 >= a >>> 0) {
                                                    break e;
                                                }
                                                a = F[f + 120 >> 2];
                                                b = L(c, 12);
                                                m = a + b | 0;
                                                f: {
                                                    g: {
                                                        j = h << 2;
                                                        q = b + F[f + 132 >> 2] | 0;
                                                        g = F[f >> 2] - F[j + F[q >> 2] >> 2] | 0;
                                                        if (!g) {
                                                            if (!k) {
                                                                break g;
                                                            }
                                                            a = F[i + 16 >> 2];
                                                            h = F[i + 20 >> 2];
                                                            if ((a | 0) == (h | 0)) {
                                                                a = F[f + 8 >> 2];
                                                                F[i + 28 >> 2] = k + F[i + 28 >> 2];
                                                                F[f + 8 >> 2] = a + k;
                                                                break g;
                                                            }
                                                            while (1) {
                                                                g = 0;
                                                                h: {
                                                                    if ((a | 0) == (h | 0)) {
                                                                        break h;
                                                                    }
                                                                    while (1) {
                                                                        j = L(g, 20) + a | 0;
                                                                        c = F[m >> 2] + (F[j + 4 >> 2] << 2) | 0;
                                                                        l = F[j >> 2];
                                                                        h = F[j + 12 >> 2];
                                                                        i: {
                                                                            if (h >>> 0 > 3) {
                                                                                break i;
                                                                            }
                                                                            b = F[i + 12 >> 2];
                                                                            if (!F[j + 16 >> 2]) {
                                                                                c = b;
                                                                                break i;
                                                                            }
                                                                            a = 0;
                                                                            while (1) {
                                                                                b = ta(b, (a << 2) + c | 0, h);
                                                                                h = F[j + 12 >> 2];
                                                                                b = b + h | 0;
                                                                                a = a + 1 | 0;
                                                                                if (a >>> 0 < I[j + 16 >> 2]) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                            c = F[i + 12 >> 2];
                                                                        }
                                                                        a = F[i + 28 >> 2];
                                                                        a = G[l + 84 | 0] ? a : F[F[l + 68 >> 2] + (a << 2) >> 2];
                                                                        if (a >>> 0 >= I[l + 80 >> 2]) {
                                                                            break h;
                                                                        }
                                                                        b = a;
                                                                        a = F[l + 40 >> 2];
                                                                        ta(F[F[l >> 2] >> 2] + L(b, a) | 0, c, a);
                                                                        g = g + 1 | 0;
                                                                        a = F[i + 16 >> 2];
                                                                        if (g >>> 0 < (F[i + 20 >> 2] - a | 0) / 20 >>> 0) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                }
                                                                F[i + 28 >> 2] = F[i + 28 >> 2] + 1;
                                                                F[f + 8 >> 2] = F[f + 8 >> 2] + 1;
                                                                d = d + 1 | 0;
                                                                if ((k | 0) == (d | 0)) {
                                                                    break g;
                                                                }
                                                                a = F[i + 16 >> 2];
                                                                h = F[i + 20 >> 2];
                                                                continue;
                                                            }
                                                        }
                                                        j: {
                                                            k: {
                                                                l: {
                                                                    m: {
                                                                        if (k >>> 0 <= 2) {
                                                                            c = F[f + 108 >> 2];
                                                                            F[c >> 2] = h;
                                                                            b = 1;
                                                                            a = F[f + 12 >> 2];
                                                                            if (a >>> 0 > 1) {
                                                                                break m;
                                                                            }
                                                                            break j;
                                                                        }
                                                                        if (I[f + 8 >> 2] > I[f + 4 >> 2]) {
                                                                            break e;
                                                                        }
                                                                        d = a;
                                                                        a = b + 12 | 0;
                                                                        Ca(d + a | 0, F[m >> 2], F[m + 4 >> 2]);
                                                                        a = j + F[a + F[f + 120 >> 2] >> 2] | 0;
                                                                        F[a >> 2] = F[a >> 2] + (1 << g - 1);
                                                                        a = O(k) ^ 31;
                                                                        d = F[f + 32 >> 2];
                                                                        l = 32 - d | 0;
                                                                        n: {
                                                                            if ((a | 0) <= (l | 0)) {
                                                                                g = F[f + 28 >> 2];
                                                                                if ((g | 0) == F[f + 20 >> 2]) {
                                                                                    d = 0;
                                                                                    break n;
                                                                                }
                                                                                l = F[g >> 2];
                                                                                m = a + d | 0;
                                                                                F[f + 32 >> 2] = m;
                                                                                d = l << d >>> 32 - a | 0;
                                                                                if ((m | 0) != 32) {
                                                                                    break n;
                                                                                }
                                                                                F[f + 32 >> 2] = 0;
                                                                                F[f + 28 >> 2] = g + 4;
                                                                                break n;
                                                                            }
                                                                            g = F[f + 28 >> 2];
                                                                            m = g + 4 | 0;
                                                                            if ((m | 0) == F[f + 20 >> 2]) {
                                                                                d = 0;
                                                                                break n;
                                                                            }
                                                                            n = F[g >> 2];
                                                                            F[f + 28 >> 2] = m;
                                                                            l = a - l | 0;
                                                                            F[f + 32 >> 2] = l;
                                                                            d = F[g + 4 >> 2] >>> 32 - l | n << d >>> 32 - a;
                                                                        }
                                                                        l = c + 1 | 0;
                                                                        a = (k >>> 1 | 0) - d | 0;
                                                                        d = k - a | 0;
                                                                        o: {
                                                                            if ((d | 0) == (a | 0)) {
                                                                                d = a;
                                                                                break o;
                                                                            }
                                                                            g = F[f + 88 >> 2];
                                                                            if ((g | 0) == F[f + 80 >> 2]) {
                                                                                break l;
                                                                            }
                                                                            k = F[g >> 2];
                                                                            m = F[f + 92 >> 2];
                                                                            n = m + 1 | 0;
                                                                            F[f + 92 >> 2] = n;
                                                                            k = k & -2147483648 >>> m;
                                                                            p: {
                                                                                if ((n | 0) == 32) {
                                                                                    F[f + 92 >> 2] = 0;
                                                                                    F[f + 88 >> 2] = g + 4;
                                                                                    if (k) {
                                                                                        break p;
                                                                                    }
                                                                                    break l;
                                                                                }
                                                                                if (!k) {
                                                                                    break l;
                                                                                }
                                                                            }
                                                                        }
                                                                        g = d;
                                                                        d = a;
                                                                        break k;
                                                                    }
                                                                    while (1) {
                                                                        h = (a - 1 | 0) == (h | 0) ? 0 : h + 1 | 0;
                                                                        F[c + (b << 2) >> 2] = h;
                                                                        a = F[f + 12 >> 2];
                                                                        b = b + 1 | 0;
                                                                        if (a >>> 0 > b >>> 0) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    break j;
                                                                }
                                                                g = a;
                                                            }
                                                            a = F[f + 132 >> 2];
                                                            b = a + b | 0;
                                                            k = F[b >> 2];
                                                            j = k + j | 0;
                                                            F[j >> 2] = F[j >> 2] + 1;
                                                            Ca(a + L(l, 12) | 0, k, F[b + 4 >> 2]);
                                                            if (d) {
                                                                a = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                                b = F[e + 12 >> 2];
                                                                k = F[e + 16 >> 2] - b | 0;
                                                                if ((a | 0) == ((k ? L(k >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                    za(e + 8 | 0);
                                                                    b = F[e + 12 >> 2];
                                                                    a = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                                }
                                                                k = b;
                                                                b = (a >>> 0) / 341 | 0;
                                                                a = F[k + (b << 2) >> 2] + L(a - L(b, 341) | 0, 12) | 0;
                                                                F[a + 8 >> 2] = c;
                                                                F[a + 4 >> 2] = h;
                                                                F[a >> 2] = d;
                                                                F[e + 28 >> 2] = F[e + 28 >> 2] + 1;
                                                            }
                                                            if (!g) {
                                                                break g;
                                                            }
                                                            a = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                            b = F[e + 12 >> 2];
                                                            c = F[e + 16 >> 2] - b | 0;
                                                            if ((a | 0) == ((c ? L(c >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                za(e + 8 | 0);
                                                                b = F[e + 12 >> 2];
                                                                a = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                            }
                                                            c = b;
                                                            b = (a >>> 0) / 341 | 0;
                                                            a = F[c + (b << 2) >> 2] + L(a - L(b, 341) | 0, 12) | 0;
                                                            F[a + 8 >> 2] = l;
                                                            F[a + 4 >> 2] = h;
                                                            F[a >> 2] = g;
                                                            a = F[e + 28 >> 2] + 1 | 0;
                                                            F[e + 28 >> 2] = a;
                                                            break f;
                                                        }
                                                        if (!k) {
                                                            break g;
                                                        }
                                                        while (1) {
                                                            if (a) {
                                                                h = F[f + 40 >> 2];
                                                                g = F[f + 96 >> 2];
                                                                s = F[f + 108 >> 2];
                                                                t = F[m >> 2];
                                                                u = F[q >> 2];
                                                                a = 0;
                                                                while (1) {
                                                                    j = (a << 2) + s | 0;
                                                                    F[g + (F[j >> 2] << 2) >> 2] = 0;
                                                                    c = F[j >> 2] << 2;
                                                                    b = F[f >> 2] - F[c + u >> 2] | 0;
                                                                    q: {
                                                                        if (!b) {
                                                                            break q;
                                                                        }
                                                                        c = c + g | 0;
                                                                        l = F[f + 52 >> 2];
                                                                        o = 32 - l | 0;
                                                                        if ((o | 0) >= (b | 0)) {
                                                                            n = F[f + 48 >> 2];
                                                                            if ((n | 0) == (h | 0)) {
                                                                                F[c >> 2] = 0;
                                                                                break q;
                                                                            }
                                                                            F[c >> 2] = F[n >> 2] << l >>> 32 - b;
                                                                            b = b + F[f + 52 >> 2] | 0;
                                                                            F[f + 52 >> 2] = b;
                                                                            if ((b | 0) != 32) {
                                                                                break q;
                                                                            }
                                                                            F[f + 52 >> 2] = 0;
                                                                            F[f + 48 >> 2] = n + 4;
                                                                            break q;
                                                                        }
                                                                        n = F[f + 48 >> 2];
                                                                        r = n + 4 | 0;
                                                                        if ((h | 0) == (r | 0)) {
                                                                            F[c >> 2] = 0;
                                                                            break q;
                                                                        }
                                                                        v = F[n >> 2];
                                                                        F[f + 48 >> 2] = r;
                                                                        o = b - o | 0;
                                                                        F[f + 52 >> 2] = o;
                                                                        F[c >> 2] = F[n + 4 >> 2] >>> 32 - o | v << l >>> 32 - b;
                                                                    }
                                                                    b = F[j >> 2] << 2;
                                                                    c = b + g | 0;
                                                                    F[c >> 2] = F[c >> 2] | F[b + t >> 2];
                                                                    a = a + 1 | 0;
                                                                    if (a >>> 0 < I[f + 12 >> 2]) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            g = 0;
                                                            a = F[i + 16 >> 2];
                                                            r: {
                                                                if ((a | 0) == F[i + 20 >> 2]) {
                                                                    break r;
                                                                }
                                                                while (1) {
                                                                    j = L(g, 20) + a | 0;
                                                                    c = F[f + 96 >> 2] + (F[j + 4 >> 2] << 2) | 0;
                                                                    l = F[j >> 2];
                                                                    h = F[j + 12 >> 2];
                                                                    s: {
                                                                        if (h >>> 0 > 3) {
                                                                            break s;
                                                                        }
                                                                        b = F[i + 12 >> 2];
                                                                        if (!F[j + 16 >> 2]) {
                                                                            c = b;
                                                                            break s;
                                                                        }
                                                                        a = 0;
                                                                        while (1) {
                                                                            b = ta(b, (a << 2) + c | 0, h);
                                                                            h = F[j + 12 >> 2];
                                                                            b = b + h | 0;
                                                                            a = a + 1 | 0;
                                                                            if (a >>> 0 < I[j + 16 >> 2]) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        c = F[i + 12 >> 2];
                                                                    }
                                                                    a = F[i + 28 >> 2];
                                                                    a = G[l + 84 | 0] ? a : F[F[l + 68 >> 2] + (a << 2) >> 2];
                                                                    if (a >>> 0 >= I[l + 80 >> 2]) {
                                                                        break r;
                                                                    }
                                                                    b = a;
                                                                    a = F[l + 40 >> 2];
                                                                    ta(F[F[l >> 2] >> 2] + L(b, a) | 0, c, a);
                                                                    g = g + 1 | 0;
                                                                    a = F[i + 16 >> 2];
                                                                    if (g >>> 0 < (F[i + 20 >> 2] - a | 0) / 20 >>> 0) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            F[i + 28 >> 2] = F[i + 28 >> 2] + 1;
                                                            F[f + 8 >> 2] = F[f + 8 >> 2] + 1;
                                                            d = d + 1 | 0;
                                                            if ((k | 0) == (d | 0)) {
                                                                break g;
                                                            }
                                                            a = F[f + 12 >> 2];
                                                            continue;
                                                        }
                                                    }
                                                    a = F[e + 28 >> 2];
                                                }
                                                if (a) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            d = 1;
                                        }
                                        F[e + 28 >> 2] = 0;
                                        h = F[e + 16 >> 2];
                                        a = F[e + 12 >> 2];
                                        b = h - a | 0;
                                        if (b >>> 0 >= 9) {
                                            while (1) {
                                                ra(F[a >> 2]);
                                                a = F[e + 12 >> 2] + 4 | 0;
                                                F[e + 12 >> 2] = a;
                                                h = F[e + 16 >> 2];
                                                b = h - a | 0;
                                                if (b >>> 0 > 8) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        c = 170;
                                        t: {
                                            switch ((b >>> 2 | 0) - 1 | 0) {
                                                case 1: c = 341;
                                                case 0:
                                                    F[e + 24 >> 2] = c;
                                                    break;
                                                default: break t;
                                            }
                                        }
                                        u: {
                                            if ((a | 0) == (h | 0)) {
                                                break u;
                                            }
                                            while (1) {
                                                ra(F[a >> 2]);
                                                a = a + 4 | 0;
                                                if ((h | 0) != (a | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            a = F[e + 16 >> 2];
                                            b = F[e + 12 >> 2];
                                            if ((a | 0) == (b | 0)) {
                                                break u;
                                            }
                                            F[e + 16 >> 2] = a + (((a - b | 0) - 4 >>> 2 ^ -1) << 2);
                                        }
                                        a = F[e + 8 >> 2];
                                        if (a) {
                                            ra(a);
                                        }
                                        ea = e + 32 | 0;
                                        break b;
                                    }
                                    va();
                                    V();
                                }
                                va();
                                V();
                            }
                            g = d;
                        } return g; }
                        function zd(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0; f = F[b + 12 >> 2]; d = F[b + 20 >> 2]; i = F[b + 16 >> 2]; e = i + 4 | 0; d = e >>> 0 < 4 ? d + 1 | 0 : d; a: {
                            if (e >>> 0 > I[b + 8 >> 2] & (d | 0) >= (f | 0) | (d | 0) > (f | 0)) {
                                break a;
                            }
                            d = i + F[b >> 2] | 0;
                            F[a >> 2] = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                            d = F[b + 20 >> 2];
                            f = d;
                            e = F[b + 16 >> 2];
                            i = e + 4 | 0;
                            d = i >>> 0 < 4 ? d + 1 | 0 : d;
                            j = i;
                            F[b + 16 >> 2] = i;
                            F[b + 20 >> 2] = d;
                            if (I[a >> 2] > 32) {
                                break a;
                            }
                            i = F[b + 12 >> 2];
                            d = f;
                            f = e + 8 | 0;
                            d = f >>> 0 < 8 ? d + 1 | 0 : d;
                            if (f >>> 0 > I[b + 8 >> 2] & (d | 0) >= (i | 0) | (d | 0) > (i | 0)) {
                                break a;
                            }
                            d = j + F[b >> 2] | 0;
                            h = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                            F[a + 4 >> 2] = h;
                            d = F[b + 20 >> 2];
                            f = F[b + 16 >> 2] + 4 | 0;
                            d = f >>> 0 < 4 ? d + 1 | 0 : d;
                            F[b + 16 >> 2] = f;
                            F[b + 20 >> 2] = d;
                            if (!h) {
                                return 1;
                            }
                            h = 0;
                            F[a + 8 >> 2] = 0;
                            if (!xa(a + 16 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 32 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 52 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 72 | 0, b)) {
                                break a;
                            }
                            q = F[a + 4 >> 2];
                            i = c;
                            b = 0;
                            c = 0;
                            e = ea - 32 | 0;
                            ea = e;
                            f = a;
                            a = F[a + 12 >> 2];
                            F[e + 16 >> 2] = 0;
                            F[e + 8 >> 2] = 0;
                            F[e + 12 >> 2] = 0;
                            b: {
                                c: {
                                    if (a) {
                                        if (a >>> 0 >= 1073741824) {
                                            break c;
                                        }
                                        d = a << 2;
                                        b = sa(d);
                                        F[e + 8 >> 2] = b;
                                        c = b + d | 0;
                                        F[e + 16 >> 2] = c;
                                        ua(b, 0, d);
                                        F[e + 12 >> 2] = c;
                                    }
                                    d = F[f + 116 >> 2];
                                    h = F[d >> 2];
                                    if (h) {
                                        F[d + 4 >> 2] = h;
                                        ra(h);
                                        F[d + 8 >> 2] = 0;
                                        F[d >> 2] = 0;
                                        F[d + 4 >> 2] = 0;
                                        c = F[e + 12 >> 2];
                                        b = F[e + 8 >> 2];
                                        a = F[f + 12 >> 2];
                                    }
                                    F[d + 4 >> 2] = c;
                                    F[d >> 2] = b;
                                    F[d + 8 >> 2] = F[e + 16 >> 2];
                                    b = 0;
                                    F[e + 16 >> 2] = 0;
                                    F[e + 8 >> 2] = 0;
                                    F[e + 12 >> 2] = 0;
                                    d: {
                                        if (a) {
                                            if (a >>> 0 >= 1073741824) {
                                                break d;
                                            }
                                            a = a << 2;
                                            g = sa(a);
                                            F[e + 8 >> 2] = g;
                                            b = a + g | 0;
                                            F[e + 16 >> 2] = b;
                                            ua(g, 0, a);
                                            F[e + 12 >> 2] = b;
                                        }
                                        a = F[f + 128 >> 2];
                                        c = F[a >> 2];
                                        if (c) {
                                            F[a + 4 >> 2] = c;
                                            ra(c);
                                            F[a + 8 >> 2] = 0;
                                            F[a >> 2] = 0;
                                            F[a + 4 >> 2] = 0;
                                            g = F[e + 8 >> 2];
                                            b = F[e + 12 >> 2];
                                        }
                                        F[a + 4 >> 2] = b;
                                        F[a >> 2] = g;
                                        F[a + 8 >> 2] = F[e + 16 >> 2];
                                        F[e + 24 >> 2] = 0;
                                        F[e + 28 >> 2] = 0;
                                        F[e + 16 >> 2] = 0;
                                        F[e + 20 >> 2] = 0;
                                        F[e + 8 >> 2] = 0;
                                        F[e + 12 >> 2] = 0;
                                        za(e + 8 | 0);
                                        a = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                        b = (a >>> 0) / 341 | 0;
                                        a = F[F[e + 12 >> 2] + (b << 2) >> 2] + L(a - L(b, 341) | 0, 12) | 0;
                                        F[a + 4 >> 2] = 0;
                                        F[a + 8 >> 2] = 0;
                                        F[a >> 2] = q;
                                        d = 1;
                                        b = F[e + 28 >> 2];
                                        a = b + 1 | 0;
                                        F[e + 28 >> 2] = a;
                                        e: {
                                            if (a >>> 0 < b >>> 0) {
                                                break e;
                                            }
                                            s = f + 16 | 0;
                                            while (1) {
                                                l = F[e + 12 >> 2];
                                                d = F[e + 24 >> 2];
                                                g = a - 1 | 0;
                                                b = d + g | 0;
                                                c = (b >>> 0) / 341 | 0;
                                                c = F[l + (c << 2) >> 2] + L(b - L(c, 341) | 0, 12) | 0;
                                                b = F[c + 8 >> 2];
                                                h = F[c + 4 >> 2];
                                                j = F[c >> 2];
                                                F[e + 28 >> 2] = g;
                                                c = F[e + 16 >> 2];
                                                g = c - l | 0;
                                                if (((g ? L(g >> 2, 341) - 1 | 0 : 0) - (a + d | 0) | 0) + 1 >>> 0 >= 682) {
                                                    ra(F[c - 4 >> 2]);
                                                    F[e + 16 >> 2] = F[e + 16 >> 2] - 4;
                                                }
                                                d = 0;
                                                if (j >>> 0 > q >>> 0) {
                                                    break e;
                                                }
                                                a = F[f + 12 >> 2];
                                                g = (a - 1 | 0) == (h | 0) ? 0 : h + 1 | 0;
                                                if (g >>> 0 >= a >>> 0) {
                                                    break e;
                                                }
                                                c = L(b, 12);
                                                m = c + F[f + 128 >> 2] | 0;
                                                l = c + F[f + 116 >> 2] | 0;
                                                f: {
                                                    k = g << 2;
                                                    h = F[f >> 2] - F[k + F[m >> 2] >> 2] | 0;
                                                    if (!h) {
                                                        if (!j) {
                                                            break f;
                                                        }
                                                        m = 0;
                                                        a = F[i + 16 >> 2];
                                                        g = F[i + 20 >> 2];
                                                        if ((a | 0) == (g | 0)) {
                                                            a = F[f + 8 >> 2];
                                                            F[i + 28 >> 2] = j + F[i + 28 >> 2];
                                                            F[f + 8 >> 2] = a + j;
                                                            break f;
                                                        }
                                                        while (1) {
                                                            h = 0;
                                                            g: {
                                                                if ((a | 0) == (g | 0)) {
                                                                    break g;
                                                                }
                                                                while (1) {
                                                                    d = L(h, 20) + a | 0;
                                                                    c = F[l >> 2] + (F[d + 4 >> 2] << 2) | 0;
                                                                    k = F[d >> 2];
                                                                    g = F[d + 12 >> 2];
                                                                    h: {
                                                                        if (g >>> 0 > 3) {
                                                                            break h;
                                                                        }
                                                                        b = F[i + 12 >> 2];
                                                                        if (!F[d + 16 >> 2]) {
                                                                            c = b;
                                                                            break h;
                                                                        }
                                                                        a = 0;
                                                                        while (1) {
                                                                            b = ta(b, (a << 2) + c | 0, g);
                                                                            g = F[d + 12 >> 2];
                                                                            b = b + g | 0;
                                                                            a = a + 1 | 0;
                                                                            if (a >>> 0 < I[d + 16 >> 2]) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        c = F[i + 12 >> 2];
                                                                    }
                                                                    a = F[i + 28 >> 2];
                                                                    a = G[k + 84 | 0] ? a : F[F[k + 68 >> 2] + (a << 2) >> 2];
                                                                    if (a >>> 0 >= I[k + 80 >> 2]) {
                                                                        break g;
                                                                    }
                                                                    b = a;
                                                                    a = F[k + 40 >> 2];
                                                                    ta(F[F[k >> 2] >> 2] + L(b, a) | 0, c, a);
                                                                    h = h + 1 | 0;
                                                                    a = F[i + 16 >> 2];
                                                                    if (h >>> 0 < (F[i + 20 >> 2] - a | 0) / 20 >>> 0) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            F[i + 28 >> 2] = F[i + 28 >> 2] + 1;
                                                            F[f + 8 >> 2] = F[f + 8 >> 2] + 1;
                                                            m = m + 1 | 0;
                                                            if ((j | 0) == (m | 0)) {
                                                                break f;
                                                            }
                                                            a = F[i + 16 >> 2];
                                                            g = F[i + 20 >> 2];
                                                            continue;
                                                        }
                                                    }
                                                    i: {
                                                        j: {
                                                            k: {
                                                                l: {
                                                                    if (j >>> 0 <= 2) {
                                                                        c = F[f + 104 >> 2];
                                                                        F[c >> 2] = g;
                                                                        b = 1;
                                                                        a = F[f + 12 >> 2];
                                                                        if (a >>> 0 > 1) {
                                                                            break l;
                                                                        }
                                                                        break i;
                                                                    }
                                                                    if (I[f + 8 >> 2] > I[f + 4 >> 2]) {
                                                                        break e;
                                                                    }
                                                                    a = F[f + 116 >> 2];
                                                                    o = b + 1 | 0;
                                                                    m = L(o, 12);
                                                                    d = a + m | 0;
                                                                    if ((d | 0) != (l | 0)) {
                                                                        Ca(d, F[l >> 2], F[l + 4 >> 2]);
                                                                        a = F[f + 116 >> 2];
                                                                    }
                                                                    a = k + F[a + m >> 2] | 0;
                                                                    F[a >> 2] = F[a >> 2] + (1 << h - 1);
                                                                    F[e + 4 >> 2] = 0;
                                                                    qc(s, O(j) ^ 31, e + 4 | 0);
                                                                    a = (j >>> 1 | 0) - F[e + 4 >> 2] | 0;
                                                                    d = j - a | 0;
                                                                    m: {
                                                                        if ((d | 0) == (a | 0)) {
                                                                            d = a;
                                                                            break m;
                                                                        }
                                                                        h = F[f + 84 >> 2];
                                                                        if ((h | 0) == F[f + 76 >> 2]) {
                                                                            break k;
                                                                        }
                                                                        j = F[h >> 2];
                                                                        l = F[f + 88 >> 2];
                                                                        n = l + 1 | 0;
                                                                        F[f + 88 >> 2] = n;
                                                                        j = j & -2147483648 >>> l;
                                                                        n: {
                                                                            if ((n | 0) == 32) {
                                                                                F[f + 88 >> 2] = 0;
                                                                                F[f + 84 >> 2] = h + 4;
                                                                                if (j) {
                                                                                    break n;
                                                                                }
                                                                                break k;
                                                                            }
                                                                            if (!j) {
                                                                                break k;
                                                                            }
                                                                        }
                                                                    }
                                                                    h = d;
                                                                    d = a;
                                                                    break j;
                                                                }
                                                                while (1) {
                                                                    g = (a - 1 | 0) == (g | 0) ? 0 : g + 1 | 0;
                                                                    F[c + (b << 2) >> 2] = g;
                                                                    a = F[f + 12 >> 2];
                                                                    b = b + 1 | 0;
                                                                    if (a >>> 0 > b >>> 0) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                break i;
                                                            }
                                                            h = a;
                                                        }
                                                        a = F[f + 128 >> 2];
                                                        c = a + c | 0;
                                                        j = F[c >> 2];
                                                        l = j + k | 0;
                                                        F[l >> 2] = F[l >> 2] + 1;
                                                        Ca(a + m | 0, j, F[c + 4 >> 2]);
                                                        if (d) {
                                                            a = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                            c = F[e + 12 >> 2];
                                                            j = F[e + 16 >> 2] - c | 0;
                                                            if ((a | 0) == ((j ? L(j >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                za(e + 8 | 0);
                                                                c = F[e + 12 >> 2];
                                                                a = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                            }
                                                            j = c;
                                                            c = (a >>> 0) / 341 | 0;
                                                            a = F[j + (c << 2) >> 2] + L(a - L(c, 341) | 0, 12) | 0;
                                                            F[a + 8 >> 2] = b;
                                                            F[a + 4 >> 2] = g;
                                                            F[a >> 2] = d;
                                                            F[e + 28 >> 2] = F[e + 28 >> 2] + 1;
                                                        }
                                                        if (!h) {
                                                            break f;
                                                        }
                                                        a = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                        b = F[e + 12 >> 2];
                                                        c = F[e + 16 >> 2] - b | 0;
                                                        if ((a | 0) == ((c ? L(c >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                            za(e + 8 | 0);
                                                            b = F[e + 12 >> 2];
                                                            a = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                        }
                                                        c = b;
                                                        b = (a >>> 0) / 341 | 0;
                                                        a = F[c + (b << 2) >> 2] + L(a - L(b, 341) | 0, 12) | 0;
                                                        F[a + 8 >> 2] = o;
                                                        F[a + 4 >> 2] = g;
                                                        F[a >> 2] = h;
                                                        F[e + 28 >> 2] = F[e + 28 >> 2] + 1;
                                                        break f;
                                                    }
                                                    o = 0;
                                                    if (!j) {
                                                        break f;
                                                    }
                                                    while (1) {
                                                        if (a) {
                                                            h = F[f + 36 >> 2];
                                                            d = F[f + 92 >> 2];
                                                            t = F[f + 104 >> 2];
                                                            u = F[l >> 2];
                                                            v = F[m >> 2];
                                                            a = 0;
                                                            while (1) {
                                                                g = (a << 2) + t | 0;
                                                                F[d + (F[g >> 2] << 2) >> 2] = 0;
                                                                c = F[g >> 2] << 2;
                                                                b = F[f >> 2] - F[c + v >> 2] | 0;
                                                                o: {
                                                                    if (!b) {
                                                                        break o;
                                                                    }
                                                                    c = c + d | 0;
                                                                    k = F[f + 48 >> 2];
                                                                    p = 32 - k | 0;
                                                                    if ((p | 0) >= (b | 0)) {
                                                                        n = F[f + 44 >> 2];
                                                                        if ((n | 0) == (h | 0)) {
                                                                            F[c >> 2] = 0;
                                                                            break o;
                                                                        }
                                                                        F[c >> 2] = F[n >> 2] << k >>> 32 - b;
                                                                        b = b + F[f + 48 >> 2] | 0;
                                                                        F[f + 48 >> 2] = b;
                                                                        if ((b | 0) != 32) {
                                                                            break o;
                                                                        }
                                                                        F[f + 48 >> 2] = 0;
                                                                        F[f + 44 >> 2] = n + 4;
                                                                        break o;
                                                                    }
                                                                    n = F[f + 44 >> 2];
                                                                    r = n + 4 | 0;
                                                                    if ((h | 0) == (r | 0)) {
                                                                        F[c >> 2] = 0;
                                                                        break o;
                                                                    }
                                                                    w = F[n >> 2];
                                                                    F[f + 44 >> 2] = r;
                                                                    p = b - p | 0;
                                                                    F[f + 48 >> 2] = p;
                                                                    F[c >> 2] = F[n + 4 >> 2] >>> 32 - p | w << k >>> 32 - b;
                                                                }
                                                                b = F[g >> 2] << 2;
                                                                c = b + d | 0;
                                                                F[c >> 2] = F[c >> 2] | F[b + u >> 2];
                                                                a = a + 1 | 0;
                                                                if (a >>> 0 < I[f + 12 >> 2]) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                        }
                                                        h = 0;
                                                        a = F[i + 16 >> 2];
                                                        p: {
                                                            if ((a | 0) == F[i + 20 >> 2]) {
                                                                break p;
                                                            }
                                                            while (1) {
                                                                d = L(h, 20) + a | 0;
                                                                c = F[f + 92 >> 2] + (F[d + 4 >> 2] << 2) | 0;
                                                                k = F[d >> 2];
                                                                g = F[d + 12 >> 2];
                                                                q: {
                                                                    if (g >>> 0 > 3) {
                                                                        break q;
                                                                    }
                                                                    b = F[i + 12 >> 2];
                                                                    if (!F[d + 16 >> 2]) {
                                                                        c = b;
                                                                        break q;
                                                                    }
                                                                    a = 0;
                                                                    while (1) {
                                                                        b = ta(b, (a << 2) + c | 0, g);
                                                                        g = F[d + 12 >> 2];
                                                                        b = b + g | 0;
                                                                        a = a + 1 | 0;
                                                                        if (a >>> 0 < I[d + 16 >> 2]) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    c = F[i + 12 >> 2];
                                                                }
                                                                a = F[i + 28 >> 2];
                                                                a = G[k + 84 | 0] ? a : F[F[k + 68 >> 2] + (a << 2) >> 2];
                                                                if (a >>> 0 >= I[k + 80 >> 2]) {
                                                                    break p;
                                                                }
                                                                b = a;
                                                                a = F[k + 40 >> 2];
                                                                ta(F[F[k >> 2] >> 2] + L(b, a) | 0, c, a);
                                                                h = h + 1 | 0;
                                                                a = F[i + 16 >> 2];
                                                                if (h >>> 0 < (F[i + 20 >> 2] - a | 0) / 20 >>> 0) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                        }
                                                        F[i + 28 >> 2] = F[i + 28 >> 2] + 1;
                                                        F[f + 8 >> 2] = F[f + 8 >> 2] + 1;
                                                        o = o + 1 | 0;
                                                        if ((j | 0) == (o | 0)) {
                                                            break f;
                                                        }
                                                        a = F[f + 12 >> 2];
                                                        continue;
                                                    }
                                                }
                                                a = F[e + 28 >> 2];
                                                if (a) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            d = 1;
                                        }
                                        F[e + 28 >> 2] = 0;
                                        g = F[e + 16 >> 2];
                                        a = F[e + 12 >> 2];
                                        b = g - a | 0;
                                        if (b >>> 0 >= 9) {
                                            while (1) {
                                                ra(F[a >> 2]);
                                                a = F[e + 12 >> 2] + 4 | 0;
                                                F[e + 12 >> 2] = a;
                                                g = F[e + 16 >> 2];
                                                b = g - a | 0;
                                                if (b >>> 0 > 8) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        c = 170;
                                        r: {
                                            switch ((b >>> 2 | 0) - 1 | 0) {
                                                case 1: c = 341;
                                                case 0:
                                                    F[e + 24 >> 2] = c;
                                                    break;
                                                default: break r;
                                            }
                                        }
                                        s: {
                                            if ((a | 0) == (g | 0)) {
                                                break s;
                                            }
                                            while (1) {
                                                ra(F[a >> 2]);
                                                a = a + 4 | 0;
                                                if ((g | 0) != (a | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            a = F[e + 16 >> 2];
                                            b = F[e + 12 >> 2];
                                            if ((a | 0) == (b | 0)) {
                                                break s;
                                            }
                                            F[e + 16 >> 2] = a + (((a - b | 0) - 4 >>> 2 ^ -1) << 2);
                                        }
                                        a = F[e + 8 >> 2];
                                        if (a) {
                                            ra(a);
                                        }
                                        ea = e + 32 | 0;
                                        break b;
                                    }
                                    va();
                                    V();
                                }
                                va();
                                V();
                            }
                            h = d;
                        } return h; }
                        function xd(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0; h = F[b + 12 >> 2]; f = F[b + 20 >> 2]; e = F[b + 16 >> 2]; g = e + 4 | 0; f = g >>> 0 < 4 ? f + 1 | 0 : f; a: {
                            if (g >>> 0 > I[b + 8 >> 2] & (f | 0) >= (h | 0) | (f | 0) > (h | 0)) {
                                break a;
                            }
                            f = e + F[b >> 2] | 0;
                            F[a >> 2] = G[f | 0] | G[f + 1 | 0] << 8 | (G[f + 2 | 0] << 16 | G[f + 3 | 0] << 24);
                            f = F[b + 20 >> 2];
                            h = f;
                            g = F[b + 16 >> 2];
                            e = g + 4 | 0;
                            f = e >>> 0 < 4 ? f + 1 | 0 : f;
                            i = e;
                            F[b + 16 >> 2] = e;
                            F[b + 20 >> 2] = f;
                            if (I[a >> 2] > 32) {
                                break a;
                            }
                            e = F[b + 12 >> 2];
                            f = h;
                            h = g + 8 | 0;
                            f = h >>> 0 < 8 ? f + 1 | 0 : f;
                            if ((e | 0) <= (f | 0) & h >>> 0 > I[b + 8 >> 2] | (e | 0) < (f | 0)) {
                                break a;
                            }
                            d = i + F[b >> 2] | 0;
                            f = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                            F[a + 4 >> 2] = f;
                            d = F[b + 20 >> 2];
                            h = F[b + 16 >> 2] + 4 | 0;
                            d = h >>> 0 < 4 ? d + 1 | 0 : d;
                            F[b + 16 >> 2] = h;
                            F[b + 20 >> 2] = d;
                            if (!f) {
                                return 1;
                            }
                            d = 0;
                            F[a + 8 >> 2] = 0;
                            if (!vb(a + 16 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 544 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 564 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 584 | 0, b)) {
                                break a;
                            }
                            q = F[a + 4 >> 2];
                            h = c;
                            c = 0;
                            b = 0;
                            e = ea - 32 | 0;
                            ea = e;
                            f = a;
                            d = F[a + 12 >> 2];
                            F[e + 16 >> 2] = 0;
                            F[e + 8 >> 2] = 0;
                            F[e + 12 >> 2] = 0;
                            b: {
                                c: {
                                    if (d) {
                                        if (d >>> 0 >= 1073741824) {
                                            break c;
                                        }
                                        a = d << 2;
                                        c = sa(a);
                                        F[e + 8 >> 2] = c;
                                        b = a + c | 0;
                                        F[e + 16 >> 2] = b;
                                        ua(c, 0, a);
                                        F[e + 12 >> 2] = b;
                                    }
                                    a = F[f + 628 >> 2];
                                    g = F[a >> 2];
                                    if (g) {
                                        F[a + 4 >> 2] = g;
                                        ra(g);
                                        F[a + 8 >> 2] = 0;
                                        F[a >> 2] = 0;
                                        F[a + 4 >> 2] = 0;
                                        d = F[f + 12 >> 2];
                                        c = F[e + 8 >> 2];
                                        b = F[e + 12 >> 2];
                                    }
                                    F[a + 4 >> 2] = b;
                                    F[a >> 2] = c;
                                    F[a + 8 >> 2] = F[e + 16 >> 2];
                                    c = 0;
                                    F[e + 16 >> 2] = 0;
                                    F[e + 8 >> 2] = 0;
                                    F[e + 12 >> 2] = 0;
                                    g = 0;
                                    d: {
                                        if (d) {
                                            if (d >>> 0 >= 1073741824) {
                                                break d;
                                            }
                                            a = d << 2;
                                            g = sa(a);
                                            F[e + 8 >> 2] = g;
                                            c = a + g | 0;
                                            F[e + 16 >> 2] = c;
                                            ua(g, 0, a);
                                            F[e + 12 >> 2] = c;
                                        }
                                        a = F[f + 640 >> 2];
                                        b = F[a >> 2];
                                        if (b) {
                                            F[a + 4 >> 2] = b;
                                            ra(b);
                                            F[a + 8 >> 2] = 0;
                                            F[a >> 2] = 0;
                                            F[a + 4 >> 2] = 0;
                                            g = F[e + 8 >> 2];
                                            c = F[e + 12 >> 2];
                                        }
                                        F[a + 4 >> 2] = c;
                                        F[a >> 2] = g;
                                        F[a + 8 >> 2] = F[e + 16 >> 2];
                                        F[e + 24 >> 2] = 0;
                                        F[e + 28 >> 2] = 0;
                                        F[e + 16 >> 2] = 0;
                                        F[e + 20 >> 2] = 0;
                                        F[e + 8 >> 2] = 0;
                                        F[e + 12 >> 2] = 0;
                                        za(e + 8 | 0);
                                        a = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                        b = (a >>> 0) / 341 | 0;
                                        a = F[F[e + 12 >> 2] + (b << 2) >> 2] + L(a - L(b, 341) | 0, 12) | 0;
                                        F[a + 4 >> 2] = 0;
                                        F[a + 8 >> 2] = 0;
                                        F[a >> 2] = q;
                                        b = 1;
                                        a = F[e + 28 >> 2];
                                        d = a + 1 | 0;
                                        F[e + 28 >> 2] = d;
                                        e: {
                                            if (a >>> 0 > d >>> 0) {
                                                break e;
                                            }
                                            while (1) {
                                                l = F[e + 12 >> 2];
                                                b = F[e + 24 >> 2];
                                                g = d - 1 | 0;
                                                a = b + g | 0;
                                                c = (a >>> 0) / 341 | 0;
                                                a = F[l + (c << 2) >> 2] + L(a - L(c, 341) | 0, 12) | 0;
                                                j = F[a + 8 >> 2];
                                                c = F[a + 4 >> 2];
                                                i = F[a >> 2];
                                                F[e + 28 >> 2] = g;
                                                a = F[e + 16 >> 2];
                                                g = a - l | 0;
                                                if (((g ? L(g >> 2, 341) - 1 | 0 : 0) - (b + d | 0) | 0) + 1 >>> 0 >= 682) {
                                                    ra(F[a - 4 >> 2]);
                                                    F[e + 16 >> 2] = F[e + 16 >> 2] - 4;
                                                }
                                                b = 0;
                                                if (i >>> 0 > q >>> 0) {
                                                    break e;
                                                }
                                                a = F[f + 12 >> 2];
                                                g = (a - 1 | 0) == (c | 0) ? 0 : c + 1 | 0;
                                                if (g >>> 0 >= a >>> 0) {
                                                    break e;
                                                }
                                                k = L(j, 12);
                                                m = k + F[f + 640 >> 2] | 0;
                                                l = k + F[f + 628 >> 2] | 0;
                                                f: {
                                                    g: {
                                                        o = g << 2;
                                                        c = F[f >> 2] - F[o + F[m >> 2] >> 2] | 0;
                                                        if (!c) {
                                                            m = 0;
                                                            if (!i) {
                                                                break g;
                                                            }
                                                            while (1) {
                                                                a = 0;
                                                                d = F[h + 16 >> 2];
                                                                h: {
                                                                    if ((d | 0) == F[h + 20 >> 2]) {
                                                                        break h;
                                                                    }
                                                                    while (1) {
                                                                        j = L(a, 20) + d | 0;
                                                                        b = F[l >> 2] + (F[j + 4 >> 2] << 2) | 0;
                                                                        k = F[j >> 2];
                                                                        g = F[j + 12 >> 2];
                                                                        i: {
                                                                            if (g >>> 0 > 3) {
                                                                                break i;
                                                                            }
                                                                            c = F[h + 12 >> 2];
                                                                            if (!F[j + 16 >> 2]) {
                                                                                b = c;
                                                                                break i;
                                                                            }
                                                                            d = 0;
                                                                            while (1) {
                                                                                c = ta(c, (d << 2) + b | 0, g);
                                                                                g = F[j + 12 >> 2];
                                                                                c = c + g | 0;
                                                                                d = d + 1 | 0;
                                                                                if (d >>> 0 < I[j + 16 >> 2]) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                            b = F[h + 12 >> 2];
                                                                        }
                                                                        d = F[h + 28 >> 2];
                                                                        d = G[k + 84 | 0] ? d : F[F[k + 68 >> 2] + (d << 2) >> 2];
                                                                        if (d >>> 0 >= I[k + 80 >> 2]) {
                                                                            break h;
                                                                        }
                                                                        c = F[k + 40 >> 2];
                                                                        ta(F[F[k >> 2] >> 2] + L(c, d) | 0, b, c);
                                                                        a = a + 1 | 0;
                                                                        d = F[h + 16 >> 2];
                                                                        if (a >>> 0 < (F[h + 20 >> 2] - d | 0) / 20 >>> 0) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                }
                                                                F[h + 28 >> 2] = F[h + 28 >> 2] + 1;
                                                                F[f + 8 >> 2] = F[f + 8 >> 2] + 1;
                                                                m = m + 1 | 0;
                                                                if ((i | 0) != (m | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                            break g;
                                                        }
                                                        j: {
                                                            k: {
                                                                l: {
                                                                    m: {
                                                                        if (i >>> 0 <= 2) {
                                                                            a = F[f + 616 >> 2];
                                                                            F[a >> 2] = g;
                                                                            c = 1;
                                                                            d = F[f + 12 >> 2];
                                                                            if (d >>> 0 > 1) {
                                                                                break m;
                                                                            }
                                                                            break j;
                                                                        }
                                                                        if (I[f + 8 >> 2] > I[f + 4 >> 2]) {
                                                                            break e;
                                                                        }
                                                                        a = F[f + 628 >> 2];
                                                                        n = j + 1 | 0;
                                                                        m = L(n, 12);
                                                                        b = a + m | 0;
                                                                        if ((b | 0) != (l | 0)) {
                                                                            Ca(b, F[l >> 2], F[l + 4 >> 2]);
                                                                            a = F[f + 628 >> 2];
                                                                        }
                                                                        a = o + F[a + m >> 2] | 0;
                                                                        F[a >> 2] = F[a >> 2] + (1 << c - 1);
                                                                        c = 0;
                                                                        d = 0;
                                                                        a = O(i) ^ 31;
                                                                        if (a) {
                                                                            while (1) {
                                                                                c = Ga(((d << 4) + f | 0) + 16 | 0) | c << 1;
                                                                                d = d + 1 | 0;
                                                                                if ((a | 0) != (d | 0)) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                        }
                                                                        a = (i >>> 1 | 0) - c | 0;
                                                                        d = i - a | 0;
                                                                        n: {
                                                                            if ((d | 0) == (a | 0)) {
                                                                                b = a;
                                                                                break n;
                                                                            }
                                                                            b = F[f + 596 >> 2];
                                                                            if ((b | 0) == F[f + 588 >> 2]) {
                                                                                break l;
                                                                            }
                                                                            c = F[b >> 2];
                                                                            i = F[f + 600 >> 2];
                                                                            l = i + 1 | 0;
                                                                            F[f + 600 >> 2] = l;
                                                                            c = c & -2147483648 >>> i;
                                                                            o: {
                                                                                if ((l | 0) == 32) {
                                                                                    F[f + 600 >> 2] = 0;
                                                                                    F[f + 596 >> 2] = b + 4;
                                                                                    if (c) {
                                                                                        break o;
                                                                                    }
                                                                                    break l;
                                                                                }
                                                                                if (!c) {
                                                                                    break l;
                                                                                }
                                                                            }
                                                                            b = d;
                                                                        }
                                                                        d = a;
                                                                        break k;
                                                                    }
                                                                    while (1) {
                                                                        g = (d - 1 | 0) == (g | 0) ? 0 : g + 1 | 0;
                                                                        F[a + (c << 2) >> 2] = g;
                                                                        c = c + 1 | 0;
                                                                        d = F[f + 12 >> 2];
                                                                        if (c >>> 0 < d >>> 0) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    break j;
                                                                }
                                                                b = a;
                                                            }
                                                            a = F[f + 640 >> 2];
                                                            c = a + k | 0;
                                                            i = F[c >> 2];
                                                            l = i + o | 0;
                                                            F[l >> 2] = F[l >> 2] + 1;
                                                            Ca(a + m | 0, i, F[c + 4 >> 2]);
                                                            if (d) {
                                                                c = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                                a = F[e + 12 >> 2];
                                                                i = F[e + 16 >> 2] - a | 0;
                                                                if ((c | 0) == ((i ? L(i >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                    za(e + 8 | 0);
                                                                    c = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                                    i = F[e + 12 >> 2];
                                                                }
                                                                else {
                                                                    i = a;
                                                                }
                                                                a = (c >>> 0) / 341 | 0;
                                                                a = F[i + (a << 2) >> 2] + L(c - L(a, 341) | 0, 12) | 0;
                                                                F[a + 8 >> 2] = j;
                                                                F[a + 4 >> 2] = g;
                                                                F[a >> 2] = d;
                                                                F[e + 28 >> 2] = F[e + 28 >> 2] + 1;
                                                            }
                                                            if (!b) {
                                                                break g;
                                                            }
                                                            d = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                            c = F[e + 12 >> 2];
                                                            a = F[e + 16 >> 2] - c | 0;
                                                            if ((d | 0) == ((a ? L(a >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                za(e + 8 | 0);
                                                                d = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                                c = F[e + 12 >> 2];
                                                            }
                                                            a = (d >>> 0) / 341 | 0;
                                                            a = F[c + (a << 2) >> 2] + L(d - L(a, 341) | 0, 12) | 0;
                                                            F[a + 8 >> 2] = n;
                                                            F[a + 4 >> 2] = g;
                                                            F[a >> 2] = b;
                                                            d = F[e + 28 >> 2] + 1 | 0;
                                                            F[e + 28 >> 2] = d;
                                                            break f;
                                                        }
                                                        o = 0;
                                                        if (!i) {
                                                            break g;
                                                        }
                                                        while (1) {
                                                            if (d) {
                                                                g = F[f + 548 >> 2];
                                                                c = F[f + 604 >> 2];
                                                                s = F[f + 616 >> 2];
                                                                t = F[l >> 2];
                                                                u = F[m >> 2];
                                                                d = 0;
                                                                while (1) {
                                                                    j = (d << 2) + s | 0;
                                                                    F[c + (F[j >> 2] << 2) >> 2] = 0;
                                                                    b = F[j >> 2] << 2;
                                                                    a = F[f >> 2] - F[b + u >> 2] | 0;
                                                                    p: {
                                                                        if (!a) {
                                                                            break p;
                                                                        }
                                                                        b = b + c | 0;
                                                                        k = F[f + 560 >> 2];
                                                                        p = 32 - k | 0;
                                                                        if ((p | 0) >= (a | 0)) {
                                                                            n = F[f + 556 >> 2];
                                                                            if ((n | 0) == (g | 0)) {
                                                                                F[b >> 2] = 0;
                                                                                break p;
                                                                            }
                                                                            F[b >> 2] = F[n >> 2] << k >>> 32 - a;
                                                                            a = a + F[f + 560 >> 2] | 0;
                                                                            F[f + 560 >> 2] = a;
                                                                            if ((a | 0) != 32) {
                                                                                break p;
                                                                            }
                                                                            F[f + 560 >> 2] = 0;
                                                                            F[f + 556 >> 2] = n + 4;
                                                                            break p;
                                                                        }
                                                                        n = F[f + 556 >> 2];
                                                                        r = n + 4 | 0;
                                                                        if ((g | 0) == (r | 0)) {
                                                                            F[b >> 2] = 0;
                                                                            break p;
                                                                        }
                                                                        v = F[n >> 2];
                                                                        F[f + 556 >> 2] = r;
                                                                        p = a - p | 0;
                                                                        F[f + 560 >> 2] = p;
                                                                        F[b >> 2] = F[n + 4 >> 2] >>> 32 - p | v << k >>> 32 - a;
                                                                    }
                                                                    a = F[j >> 2] << 2;
                                                                    b = a + c | 0;
                                                                    F[b >> 2] = F[b >> 2] | F[a + t >> 2];
                                                                    d = d + 1 | 0;
                                                                    if (d >>> 0 < I[f + 12 >> 2]) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            a = 0;
                                                            d = F[h + 16 >> 2];
                                                            q: {
                                                                if ((d | 0) == F[h + 20 >> 2]) {
                                                                    break q;
                                                                }
                                                                while (1) {
                                                                    j = L(a, 20) + d | 0;
                                                                    b = F[f + 604 >> 2] + (F[j + 4 >> 2] << 2) | 0;
                                                                    k = F[j >> 2];
                                                                    g = F[j + 12 >> 2];
                                                                    r: {
                                                                        if (g >>> 0 > 3) {
                                                                            break r;
                                                                        }
                                                                        c = F[h + 12 >> 2];
                                                                        if (!F[j + 16 >> 2]) {
                                                                            b = c;
                                                                            break r;
                                                                        }
                                                                        d = 0;
                                                                        while (1) {
                                                                            c = ta(c, (d << 2) + b | 0, g);
                                                                            g = F[j + 12 >> 2];
                                                                            c = c + g | 0;
                                                                            d = d + 1 | 0;
                                                                            if (d >>> 0 < I[j + 16 >> 2]) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        b = F[h + 12 >> 2];
                                                                    }
                                                                    d = F[h + 28 >> 2];
                                                                    d = G[k + 84 | 0] ? d : F[F[k + 68 >> 2] + (d << 2) >> 2];
                                                                    if (d >>> 0 >= I[k + 80 >> 2]) {
                                                                        break q;
                                                                    }
                                                                    c = F[k + 40 >> 2];
                                                                    ta(F[F[k >> 2] >> 2] + L(c, d) | 0, b, c);
                                                                    a = a + 1 | 0;
                                                                    d = F[h + 16 >> 2];
                                                                    if (a >>> 0 < (F[h + 20 >> 2] - d | 0) / 20 >>> 0) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            F[h + 28 >> 2] = F[h + 28 >> 2] + 1;
                                                            F[f + 8 >> 2] = F[f + 8 >> 2] + 1;
                                                            o = o + 1 | 0;
                                                            if ((i | 0) == (o | 0)) {
                                                                break g;
                                                            }
                                                            d = F[f + 12 >> 2];
                                                            continue;
                                                        }
                                                    }
                                                    d = F[e + 28 >> 2];
                                                }
                                                if (d) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            b = 1;
                                        }
                                        F[e + 28 >> 2] = 0;
                                        g = F[e + 16 >> 2];
                                        d = F[e + 12 >> 2];
                                        c = g - d | 0;
                                        if (c >>> 0 >= 9) {
                                            while (1) {
                                                ra(F[d >> 2]);
                                                d = F[e + 12 >> 2] + 4 | 0;
                                                F[e + 12 >> 2] = d;
                                                g = F[e + 16 >> 2];
                                                c = g - d | 0;
                                                if (c >>> 0 > 8) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        a = 170;
                                        s: {
                                            switch ((c >>> 2 | 0) - 1 | 0) {
                                                case 1: a = 341;
                                                case 0:
                                                    F[e + 24 >> 2] = a;
                                                    break;
                                                default: break s;
                                            }
                                        }
                                        t: {
                                            if ((d | 0) == (g | 0)) {
                                                break t;
                                            }
                                            while (1) {
                                                ra(F[d >> 2]);
                                                d = d + 4 | 0;
                                                if ((g | 0) != (d | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            a = F[e + 16 >> 2];
                                            c = F[e + 12 >> 2];
                                            if ((a | 0) == (c | 0)) {
                                                break t;
                                            }
                                            F[e + 16 >> 2] = a + (((a - c | 0) - 4 >>> 2 ^ -1) << 2);
                                        }
                                        a = F[e + 8 >> 2];
                                        if (a) {
                                            ra(a);
                                        }
                                        ea = e + 32 | 0;
                                        break b;
                                    }
                                    va();
                                    V();
                                }
                                va();
                                V();
                            }
                            d = b;
                        } return d; }
                        function yd(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0; f = F[b + 12 >> 2]; e = F[b + 20 >> 2]; i = F[b + 16 >> 2]; d = i + 4 | 0; e = d >>> 0 < 4 ? e + 1 | 0 : e; a: {
                            if (d >>> 0 > I[b + 8 >> 2] & (e | 0) >= (f | 0) | (e | 0) > (f | 0)) {
                                break a;
                            }
                            e = i + F[b >> 2] | 0;
                            F[a >> 2] = G[e | 0] | G[e + 1 | 0] << 8 | (G[e + 2 | 0] << 16 | G[e + 3 | 0] << 24);
                            e = F[b + 20 >> 2];
                            f = e;
                            d = F[b + 16 >> 2];
                            i = d + 4 | 0;
                            e = i >>> 0 < 4 ? f + 1 | 0 : f;
                            k = i;
                            F[b + 16 >> 2] = i;
                            F[b + 20 >> 2] = e;
                            if (I[a >> 2] > 32) {
                                break a;
                            }
                            i = F[b + 12 >> 2];
                            e = f;
                            f = d + 8 | 0;
                            e = f >>> 0 < 8 ? e + 1 | 0 : e;
                            if (f >>> 0 > I[b + 8 >> 2] & (e | 0) >= (i | 0) | (e | 0) > (i | 0)) {
                                break a;
                            }
                            e = k + F[b >> 2] | 0;
                            h = G[e | 0] | G[e + 1 | 0] << 8 | (G[e + 2 | 0] << 16 | G[e + 3 | 0] << 24);
                            F[a + 4 >> 2] = h;
                            e = F[b + 20 >> 2];
                            f = F[b + 16 >> 2] + 4 | 0;
                            e = f >>> 0 < 4 ? e + 1 | 0 : e;
                            F[b + 16 >> 2] = f;
                            F[b + 20 >> 2] = e;
                            if (!h) {
                                return 1;
                            }
                            h = 0;
                            F[a + 8 >> 2] = 0;
                            if (!xa(a + 16 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 32 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 52 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 72 | 0, b)) {
                                break a;
                            }
                            p = F[a + 4 >> 2];
                            i = c;
                            b = 0;
                            c = 0;
                            d = ea - 32 | 0;
                            ea = d;
                            f = a;
                            a = F[a + 12 >> 2];
                            F[d + 16 >> 2] = 0;
                            F[d + 8 >> 2] = 0;
                            F[d + 12 >> 2] = 0;
                            b: {
                                c: {
                                    if (a) {
                                        if (a >>> 0 >= 1073741824) {
                                            break c;
                                        }
                                        e = a << 2;
                                        b = sa(e);
                                        F[d + 8 >> 2] = b;
                                        c = b + e | 0;
                                        F[d + 16 >> 2] = c;
                                        ua(b, 0, e);
                                        F[d + 12 >> 2] = c;
                                    }
                                    e = F[f + 116 >> 2];
                                    h = F[e >> 2];
                                    if (h) {
                                        F[e + 4 >> 2] = h;
                                        ra(h);
                                        F[e + 8 >> 2] = 0;
                                        F[e >> 2] = 0;
                                        F[e + 4 >> 2] = 0;
                                        c = F[d + 12 >> 2];
                                        b = F[d + 8 >> 2];
                                        a = F[f + 12 >> 2];
                                    }
                                    F[e + 4 >> 2] = c;
                                    F[e >> 2] = b;
                                    F[e + 8 >> 2] = F[d + 16 >> 2];
                                    b = 0;
                                    F[d + 16 >> 2] = 0;
                                    F[d + 8 >> 2] = 0;
                                    F[d + 12 >> 2] = 0;
                                    d: {
                                        if (a) {
                                            if (a >>> 0 >= 1073741824) {
                                                break d;
                                            }
                                            a = a << 2;
                                            g = sa(a);
                                            F[d + 8 >> 2] = g;
                                            b = a + g | 0;
                                            F[d + 16 >> 2] = b;
                                            ua(g, 0, a);
                                            F[d + 12 >> 2] = b;
                                        }
                                        a = F[f + 128 >> 2];
                                        c = F[a >> 2];
                                        if (c) {
                                            F[a + 4 >> 2] = c;
                                            ra(c);
                                            F[a + 8 >> 2] = 0;
                                            F[a >> 2] = 0;
                                            F[a + 4 >> 2] = 0;
                                            g = F[d + 8 >> 2];
                                            b = F[d + 12 >> 2];
                                        }
                                        F[a + 4 >> 2] = b;
                                        F[a >> 2] = g;
                                        F[a + 8 >> 2] = F[d + 16 >> 2];
                                        F[d + 24 >> 2] = 0;
                                        F[d + 28 >> 2] = 0;
                                        F[d + 16 >> 2] = 0;
                                        F[d + 20 >> 2] = 0;
                                        F[d + 8 >> 2] = 0;
                                        F[d + 12 >> 2] = 0;
                                        za(d + 8 | 0);
                                        a = F[d + 24 >> 2] + F[d + 28 >> 2] | 0;
                                        b = (a >>> 0) / 341 | 0;
                                        a = F[F[d + 12 >> 2] + (b << 2) >> 2] + L(a - L(b, 341) | 0, 12) | 0;
                                        F[a + 4 >> 2] = 0;
                                        F[a + 8 >> 2] = 0;
                                        F[a >> 2] = p;
                                        e = 1;
                                        b = F[d + 28 >> 2];
                                        a = b + 1 | 0;
                                        F[d + 28 >> 2] = a;
                                        e: {
                                            if (a >>> 0 < b >>> 0) {
                                                break e;
                                            }
                                            s = f + 16 | 0;
                                            while (1) {
                                                j = F[d + 12 >> 2];
                                                e = F[d + 24 >> 2];
                                                g = a - 1 | 0;
                                                b = e + g | 0;
                                                c = (b >>> 0) / 341 | 0;
                                                b = F[j + (c << 2) >> 2] + L(b - L(c, 341) | 0, 12) | 0;
                                                c = F[b + 8 >> 2];
                                                h = F[b + 4 >> 2];
                                                k = F[b >> 2];
                                                F[d + 28 >> 2] = g;
                                                b = F[d + 16 >> 2];
                                                g = b - j | 0;
                                                if (((g ? L(g >> 2, 341) - 1 | 0 : 0) - (a + e | 0) | 0) + 1 >>> 0 >= 682) {
                                                    ra(F[b - 4 >> 2]);
                                                    F[d + 16 >> 2] = F[d + 16 >> 2] - 4;
                                                }
                                                if (k >>> 0 > p >>> 0) {
                                                    e = 0;
                                                    break e;
                                                }
                                                e = 0;
                                                a = F[f + 12 >> 2];
                                                g = (h | 0) == (a - 1 | 0) ? 0 : h + 1 | 0;
                                                if (g >>> 0 >= a >>> 0) {
                                                    break e;
                                                }
                                                a = F[f + 116 >> 2];
                                                b = L(c, 12);
                                                n = a + b | 0;
                                                f: {
                                                    j = g << 2;
                                                    q = b + F[f + 128 >> 2] | 0;
                                                    h = F[f >> 2] - F[j + F[q >> 2] >> 2] | 0;
                                                    if (!h) {
                                                        if (!k) {
                                                            break f;
                                                        }
                                                        a = F[i + 16 >> 2];
                                                        g = F[i + 20 >> 2];
                                                        if ((a | 0) == (g | 0)) {
                                                            a = F[f + 8 >> 2];
                                                            F[i + 28 >> 2] = k + F[i + 28 >> 2];
                                                            F[f + 8 >> 2] = a + k;
                                                            break f;
                                                        }
                                                        while (1) {
                                                            h = 0;
                                                            g: {
                                                                if ((a | 0) == (g | 0)) {
                                                                    break g;
                                                                }
                                                                while (1) {
                                                                    j = L(h, 20) + a | 0;
                                                                    c = F[n >> 2] + (F[j + 4 >> 2] << 2) | 0;
                                                                    l = F[j >> 2];
                                                                    g = F[j + 12 >> 2];
                                                                    h: {
                                                                        if (g >>> 0 > 3) {
                                                                            break h;
                                                                        }
                                                                        b = F[i + 12 >> 2];
                                                                        if (!F[j + 16 >> 2]) {
                                                                            c = b;
                                                                            break h;
                                                                        }
                                                                        a = 0;
                                                                        while (1) {
                                                                            b = ta(b, (a << 2) + c | 0, g);
                                                                            g = F[j + 12 >> 2];
                                                                            b = b + g | 0;
                                                                            a = a + 1 | 0;
                                                                            if (a >>> 0 < I[j + 16 >> 2]) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        c = F[i + 12 >> 2];
                                                                    }
                                                                    a = F[i + 28 >> 2];
                                                                    a = G[l + 84 | 0] ? a : F[F[l + 68 >> 2] + (a << 2) >> 2];
                                                                    if (a >>> 0 >= I[l + 80 >> 2]) {
                                                                        break g;
                                                                    }
                                                                    b = a;
                                                                    a = F[l + 40 >> 2];
                                                                    ta(F[F[l >> 2] >> 2] + L(b, a) | 0, c, a);
                                                                    h = h + 1 | 0;
                                                                    a = F[i + 16 >> 2];
                                                                    if (h >>> 0 < (F[i + 20 >> 2] - a | 0) / 20 >>> 0) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            F[i + 28 >> 2] = F[i + 28 >> 2] + 1;
                                                            F[f + 8 >> 2] = F[f + 8 >> 2] + 1;
                                                            e = e + 1 | 0;
                                                            if ((k | 0) == (e | 0)) {
                                                                break f;
                                                            }
                                                            a = F[i + 16 >> 2];
                                                            g = F[i + 20 >> 2];
                                                            continue;
                                                        }
                                                    }
                                                    i: {
                                                        j: {
                                                            k: {
                                                                l: {
                                                                    if (k >>> 0 <= 2) {
                                                                        c = F[f + 104 >> 2];
                                                                        F[c >> 2] = g;
                                                                        b = 1;
                                                                        a = F[f + 12 >> 2];
                                                                        if (a >>> 0 > 1) {
                                                                            break l;
                                                                        }
                                                                        break i;
                                                                    }
                                                                    if (I[f + 8 >> 2] > I[f + 4 >> 2]) {
                                                                        break e;
                                                                    }
                                                                    e = a;
                                                                    a = b + 12 | 0;
                                                                    Ca(e + a | 0, F[n >> 2], F[n + 4 >> 2]);
                                                                    a = j + F[a + F[f + 116 >> 2] >> 2] | 0;
                                                                    F[a >> 2] = F[a >> 2] + (1 << h - 1);
                                                                    F[d + 4 >> 2] = 0;
                                                                    qc(s, O(k) ^ 31, d + 4 | 0);
                                                                    l = c + 1 | 0;
                                                                    a = (k >>> 1 | 0) - F[d + 4 >> 2] | 0;
                                                                    e = k - a | 0;
                                                                    m: {
                                                                        if ((e | 0) == (a | 0)) {
                                                                            e = a;
                                                                            break m;
                                                                        }
                                                                        h = F[f + 84 >> 2];
                                                                        if ((h | 0) == F[f + 76 >> 2]) {
                                                                            break k;
                                                                        }
                                                                        k = F[h >> 2];
                                                                        n = F[f + 88 >> 2];
                                                                        m = n + 1 | 0;
                                                                        F[f + 88 >> 2] = m;
                                                                        k = k & -2147483648 >>> n;
                                                                        n: {
                                                                            if ((m | 0) == 32) {
                                                                                F[f + 88 >> 2] = 0;
                                                                                F[f + 84 >> 2] = h + 4;
                                                                                if (k) {
                                                                                    break n;
                                                                                }
                                                                                break k;
                                                                            }
                                                                            if (!k) {
                                                                                break k;
                                                                            }
                                                                        }
                                                                    }
                                                                    h = e;
                                                                    e = a;
                                                                    break j;
                                                                }
                                                                while (1) {
                                                                    g = (a - 1 | 0) == (g | 0) ? 0 : g + 1 | 0;
                                                                    F[c + (b << 2) >> 2] = g;
                                                                    a = F[f + 12 >> 2];
                                                                    b = b + 1 | 0;
                                                                    if (a >>> 0 > b >>> 0) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                break i;
                                                            }
                                                            h = a;
                                                        }
                                                        a = F[f + 128 >> 2];
                                                        b = a + b | 0;
                                                        k = F[b >> 2];
                                                        j = k + j | 0;
                                                        F[j >> 2] = F[j >> 2] + 1;
                                                        Ca(a + L(l, 12) | 0, k, F[b + 4 >> 2]);
                                                        if (e) {
                                                            a = F[d + 28 >> 2] + F[d + 24 >> 2] | 0;
                                                            b = F[d + 12 >> 2];
                                                            k = F[d + 16 >> 2] - b | 0;
                                                            if ((a | 0) == ((k ? L(k >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                za(d + 8 | 0);
                                                                b = F[d + 12 >> 2];
                                                                a = F[d + 24 >> 2] + F[d + 28 >> 2] | 0;
                                                            }
                                                            k = b;
                                                            b = (a >>> 0) / 341 | 0;
                                                            a = F[k + (b << 2) >> 2] + L(a - L(b, 341) | 0, 12) | 0;
                                                            F[a + 8 >> 2] = c;
                                                            F[a + 4 >> 2] = g;
                                                            F[a >> 2] = e;
                                                            F[d + 28 >> 2] = F[d + 28 >> 2] + 1;
                                                        }
                                                        if (!h) {
                                                            break f;
                                                        }
                                                        a = F[d + 28 >> 2] + F[d + 24 >> 2] | 0;
                                                        b = F[d + 12 >> 2];
                                                        c = F[d + 16 >> 2] - b | 0;
                                                        if ((a | 0) == ((c ? L(c >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                            za(d + 8 | 0);
                                                            b = F[d + 12 >> 2];
                                                            a = F[d + 24 >> 2] + F[d + 28 >> 2] | 0;
                                                        }
                                                        c = b;
                                                        b = (a >>> 0) / 341 | 0;
                                                        a = F[c + (b << 2) >> 2] + L(a - L(b, 341) | 0, 12) | 0;
                                                        F[a + 8 >> 2] = l;
                                                        F[a + 4 >> 2] = g;
                                                        F[a >> 2] = h;
                                                        F[d + 28 >> 2] = F[d + 28 >> 2] + 1;
                                                        break f;
                                                    }
                                                    if (!k) {
                                                        break f;
                                                    }
                                                    while (1) {
                                                        if (a) {
                                                            g = F[f + 36 >> 2];
                                                            h = F[f + 92 >> 2];
                                                            t = F[f + 104 >> 2];
                                                            u = F[n >> 2];
                                                            v = F[q >> 2];
                                                            a = 0;
                                                            while (1) {
                                                                j = (a << 2) + t | 0;
                                                                F[h + (F[j >> 2] << 2) >> 2] = 0;
                                                                c = F[j >> 2] << 2;
                                                                b = F[f >> 2] - F[c + v >> 2] | 0;
                                                                o: {
                                                                    if (!b) {
                                                                        break o;
                                                                    }
                                                                    c = c + h | 0;
                                                                    l = F[f + 48 >> 2];
                                                                    o = 32 - l | 0;
                                                                    if ((o | 0) >= (b | 0)) {
                                                                        m = F[f + 44 >> 2];
                                                                        if ((m | 0) == (g | 0)) {
                                                                            F[c >> 2] = 0;
                                                                            break o;
                                                                        }
                                                                        F[c >> 2] = F[m >> 2] << l >>> 32 - b;
                                                                        b = b + F[f + 48 >> 2] | 0;
                                                                        F[f + 48 >> 2] = b;
                                                                        if ((b | 0) != 32) {
                                                                            break o;
                                                                        }
                                                                        F[f + 48 >> 2] = 0;
                                                                        F[f + 44 >> 2] = m + 4;
                                                                        break o;
                                                                    }
                                                                    m = F[f + 44 >> 2];
                                                                    r = m + 4 | 0;
                                                                    if ((g | 0) == (r | 0)) {
                                                                        F[c >> 2] = 0;
                                                                        break o;
                                                                    }
                                                                    w = F[m >> 2];
                                                                    F[f + 44 >> 2] = r;
                                                                    o = b - o | 0;
                                                                    F[f + 48 >> 2] = o;
                                                                    F[c >> 2] = F[m + 4 >> 2] >>> 32 - o | w << l >>> 32 - b;
                                                                }
                                                                b = F[j >> 2] << 2;
                                                                c = b + h | 0;
                                                                F[c >> 2] = F[c >> 2] | F[b + u >> 2];
                                                                a = a + 1 | 0;
                                                                if (a >>> 0 < I[f + 12 >> 2]) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                        }
                                                        h = 0;
                                                        a = F[i + 16 >> 2];
                                                        p: {
                                                            if ((a | 0) == F[i + 20 >> 2]) {
                                                                break p;
                                                            }
                                                            while (1) {
                                                                j = L(h, 20) + a | 0;
                                                                c = F[f + 92 >> 2] + (F[j + 4 >> 2] << 2) | 0;
                                                                l = F[j >> 2];
                                                                g = F[j + 12 >> 2];
                                                                q: {
                                                                    if (g >>> 0 > 3) {
                                                                        break q;
                                                                    }
                                                                    b = F[i + 12 >> 2];
                                                                    if (!F[j + 16 >> 2]) {
                                                                        c = b;
                                                                        break q;
                                                                    }
                                                                    a = 0;
                                                                    while (1) {
                                                                        b = ta(b, (a << 2) + c | 0, g);
                                                                        g = F[j + 12 >> 2];
                                                                        b = b + g | 0;
                                                                        a = a + 1 | 0;
                                                                        if (a >>> 0 < I[j + 16 >> 2]) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    c = F[i + 12 >> 2];
                                                                }
                                                                a = F[i + 28 >> 2];
                                                                a = G[l + 84 | 0] ? a : F[F[l + 68 >> 2] + (a << 2) >> 2];
                                                                if (a >>> 0 >= I[l + 80 >> 2]) {
                                                                    break p;
                                                                }
                                                                b = a;
                                                                a = F[l + 40 >> 2];
                                                                ta(F[F[l >> 2] >> 2] + L(b, a) | 0, c, a);
                                                                h = h + 1 | 0;
                                                                a = F[i + 16 >> 2];
                                                                if (h >>> 0 < (F[i + 20 >> 2] - a | 0) / 20 >>> 0) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                        }
                                                        F[i + 28 >> 2] = F[i + 28 >> 2] + 1;
                                                        F[f + 8 >> 2] = F[f + 8 >> 2] + 1;
                                                        e = e + 1 | 0;
                                                        if ((k | 0) == (e | 0)) {
                                                            break f;
                                                        }
                                                        a = F[f + 12 >> 2];
                                                        continue;
                                                    }
                                                }
                                                a = F[d + 28 >> 2];
                                                if (a) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            e = 1;
                                        }
                                        F[d + 28 >> 2] = 0;
                                        g = F[d + 16 >> 2];
                                        a = F[d + 12 >> 2];
                                        b = g - a | 0;
                                        if (b >>> 0 >= 9) {
                                            while (1) {
                                                ra(F[a >> 2]);
                                                a = F[d + 12 >> 2] + 4 | 0;
                                                F[d + 12 >> 2] = a;
                                                g = F[d + 16 >> 2];
                                                b = g - a | 0;
                                                if (b >>> 0 > 8) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        c = 170;
                                        r: {
                                            switch ((b >>> 2 | 0) - 1 | 0) {
                                                case 1: c = 341;
                                                case 0:
                                                    F[d + 24 >> 2] = c;
                                                    break;
                                                default: break r;
                                            }
                                        }
                                        s: {
                                            if ((a | 0) == (g | 0)) {
                                                break s;
                                            }
                                            while (1) {
                                                ra(F[a >> 2]);
                                                a = a + 4 | 0;
                                                if ((g | 0) != (a | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            a = F[d + 16 >> 2];
                                            b = F[d + 12 >> 2];
                                            if ((a | 0) == (b | 0)) {
                                                break s;
                                            }
                                            F[d + 16 >> 2] = a + (((a - b | 0) - 4 >>> 2 ^ -1) << 2);
                                        }
                                        a = F[d + 8 >> 2];
                                        if (a) {
                                            ra(a);
                                        }
                                        ea = d + 32 | 0;
                                        break b;
                                    }
                                    va();
                                    V();
                                }
                                va();
                                V();
                            }
                            h = e;
                        } return h; }
                        function wd(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0; g = F[b + 12 >> 2]; f = F[b + 20 >> 2]; i = F[b + 16 >> 2]; e = i + 4 | 0; f = e >>> 0 < 4 ? f + 1 | 0 : f; a: {
                            if ((g | 0) <= (f | 0) & e >>> 0 > I[b + 8 >> 2] | (g | 0) < (f | 0)) {
                                break a;
                            }
                            f = i + F[b >> 2] | 0;
                            F[a >> 2] = G[f | 0] | G[f + 1 | 0] << 8 | (G[f + 2 | 0] << 16 | G[f + 3 | 0] << 24);
                            f = F[b + 20 >> 2];
                            g = f;
                            e = F[b + 16 >> 2];
                            i = e + 4 | 0;
                            f = i >>> 0 < 4 ? g + 1 | 0 : g;
                            j = i;
                            F[b + 16 >> 2] = i;
                            F[b + 20 >> 2] = f;
                            if (I[a >> 2] > 32) {
                                break a;
                            }
                            i = F[b + 12 >> 2];
                            f = g;
                            g = e + 8 | 0;
                            f = g >>> 0 < 8 ? f + 1 | 0 : f;
                            if (g >>> 0 > I[b + 8 >> 2] & (f | 0) >= (i | 0) | (f | 0) > (i | 0)) {
                                break a;
                            }
                            d = j + F[b >> 2] | 0;
                            f = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                            F[a + 4 >> 2] = f;
                            d = F[b + 20 >> 2];
                            g = F[b + 16 >> 2] + 4 | 0;
                            d = g >>> 0 < 4 ? d + 1 | 0 : d;
                            F[b + 16 >> 2] = g;
                            F[b + 20 >> 2] = d;
                            if (!f) {
                                return 1;
                            }
                            d = 0;
                            F[a + 8 >> 2] = 0;
                            if (!vb(a + 16 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 544 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 564 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 584 | 0, b)) {
                                break a;
                            }
                            p = F[a + 4 >> 2];
                            i = c;
                            b = 0;
                            c = 0;
                            e = ea - 32 | 0;
                            ea = e;
                            g = a;
                            d = F[a + 12 >> 2];
                            F[e + 16 >> 2] = 0;
                            F[e + 8 >> 2] = 0;
                            F[e + 12 >> 2] = 0;
                            b: {
                                c: {
                                    if (d) {
                                        if (d >>> 0 >= 1073741824) {
                                            break c;
                                        }
                                        a = d << 2;
                                        b = sa(a);
                                        F[e + 8 >> 2] = b;
                                        c = a + b | 0;
                                        F[e + 16 >> 2] = c;
                                        ua(b, 0, a);
                                        F[e + 12 >> 2] = c;
                                    }
                                    a = F[g + 628 >> 2];
                                    f = F[a >> 2];
                                    if (f) {
                                        F[a + 4 >> 2] = f;
                                        ra(f);
                                        F[a + 8 >> 2] = 0;
                                        F[a >> 2] = 0;
                                        F[a + 4 >> 2] = 0;
                                        d = F[g + 12 >> 2];
                                        c = F[e + 12 >> 2];
                                        b = F[e + 8 >> 2];
                                    }
                                    F[a + 4 >> 2] = c;
                                    F[a >> 2] = b;
                                    F[a + 8 >> 2] = F[e + 16 >> 2];
                                    b = 0;
                                    F[e + 16 >> 2] = 0;
                                    F[e + 8 >> 2] = 0;
                                    F[e + 12 >> 2] = 0;
                                    d: {
                                        if (d) {
                                            if (d >>> 0 >= 1073741824) {
                                                break d;
                                            }
                                            a = d << 2;
                                            h = sa(a);
                                            F[e + 8 >> 2] = h;
                                            b = a + h | 0;
                                            F[e + 16 >> 2] = b;
                                            ua(h, 0, a);
                                            F[e + 12 >> 2] = b;
                                        }
                                        a = F[g + 640 >> 2];
                                        c = F[a >> 2];
                                        if (c) {
                                            F[a + 4 >> 2] = c;
                                            ra(c);
                                            F[a + 8 >> 2] = 0;
                                            F[a >> 2] = 0;
                                            F[a + 4 >> 2] = 0;
                                            h = F[e + 8 >> 2];
                                            b = F[e + 12 >> 2];
                                        }
                                        F[a + 4 >> 2] = b;
                                        F[a >> 2] = h;
                                        F[a + 8 >> 2] = F[e + 16 >> 2];
                                        F[e + 24 >> 2] = 0;
                                        F[e + 28 >> 2] = 0;
                                        F[e + 16 >> 2] = 0;
                                        F[e + 20 >> 2] = 0;
                                        F[e + 8 >> 2] = 0;
                                        F[e + 12 >> 2] = 0;
                                        za(e + 8 | 0);
                                        a = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                        b = (a >>> 0) / 341 | 0;
                                        a = F[F[e + 12 >> 2] + (b << 2) >> 2] + L(a - L(b, 341) | 0, 12) | 0;
                                        F[a + 4 >> 2] = 0;
                                        F[a + 8 >> 2] = 0;
                                        F[a >> 2] = p;
                                        c = 1;
                                        a = F[e + 28 >> 2];
                                        d = a + 1 | 0;
                                        F[e + 28 >> 2] = d;
                                        e: {
                                            if (a >>> 0 > d >>> 0) {
                                                break e;
                                            }
                                            while (1) {
                                                h = F[e + 12 >> 2];
                                                c = F[e + 24 >> 2];
                                                f = d - 1 | 0;
                                                a = c + f | 0;
                                                b = (a >>> 0) / 341 | 0;
                                                a = F[h + (b << 2) >> 2] + L(a - L(b, 341) | 0, 12) | 0;
                                                l = F[a + 8 >> 2];
                                                b = F[a + 4 >> 2];
                                                j = F[a >> 2];
                                                F[e + 28 >> 2] = f;
                                                a = F[e + 16 >> 2];
                                                f = a - h | 0;
                                                if (((f ? L(f >> 2, 341) - 1 | 0 : 0) - (c + d | 0) | 0) + 1 >>> 0 >= 682) {
                                                    ra(F[a - 4 >> 2]);
                                                    F[e + 16 >> 2] = F[e + 16 >> 2] - 4;
                                                }
                                                if (j >>> 0 > p >>> 0) {
                                                    c = 0;
                                                    break e;
                                                }
                                                c = 0;
                                                a = F[g + 12 >> 2];
                                                h = (b | 0) == (a - 1 | 0) ? 0 : b + 1 | 0;
                                                if (h >>> 0 >= a >>> 0) {
                                                    break e;
                                                }
                                                a = F[g + 628 >> 2];
                                                k = L(l, 12);
                                                n = a + k | 0;
                                                f: {
                                                    g: {
                                                        m = h << 2;
                                                        q = k + F[g + 640 >> 2] | 0;
                                                        b = F[g >> 2] - F[m + F[q >> 2] >> 2] | 0;
                                                        if (!b) {
                                                            a = 0;
                                                            if (!j) {
                                                                break g;
                                                            }
                                                            while (1) {
                                                                f = 0;
                                                                d = F[i + 16 >> 2];
                                                                h: {
                                                                    if ((d | 0) == F[i + 20 >> 2]) {
                                                                        break h;
                                                                    }
                                                                    while (1) {
                                                                        l = L(f, 20) + d | 0;
                                                                        c = F[n >> 2] + (F[l + 4 >> 2] << 2) | 0;
                                                                        k = F[l >> 2];
                                                                        h = F[l + 12 >> 2];
                                                                        i: {
                                                                            if (h >>> 0 > 3) {
                                                                                break i;
                                                                            }
                                                                            b = F[i + 12 >> 2];
                                                                            if (!F[l + 16 >> 2]) {
                                                                                c = b;
                                                                                break i;
                                                                            }
                                                                            d = 0;
                                                                            while (1) {
                                                                                b = ta(b, (d << 2) + c | 0, h);
                                                                                h = F[l + 12 >> 2];
                                                                                b = b + h | 0;
                                                                                d = d + 1 | 0;
                                                                                if (d >>> 0 < I[l + 16 >> 2]) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                            c = F[i + 12 >> 2];
                                                                        }
                                                                        d = F[i + 28 >> 2];
                                                                        d = G[k + 84 | 0] ? d : F[F[k + 68 >> 2] + (d << 2) >> 2];
                                                                        if (d >>> 0 >= I[k + 80 >> 2]) {
                                                                            break h;
                                                                        }
                                                                        b = F[k + 40 >> 2];
                                                                        ta(F[F[k >> 2] >> 2] + L(b, d) | 0, c, b);
                                                                        f = f + 1 | 0;
                                                                        d = F[i + 16 >> 2];
                                                                        if (f >>> 0 < (F[i + 20 >> 2] - d | 0) / 20 >>> 0) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                }
                                                                F[i + 28 >> 2] = F[i + 28 >> 2] + 1;
                                                                F[g + 8 >> 2] = F[g + 8 >> 2] + 1;
                                                                a = a + 1 | 0;
                                                                if ((j | 0) != (a | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                            break g;
                                                        }
                                                        j: {
                                                            k: {
                                                                l: {
                                                                    m: {
                                                                        if (j >>> 0 <= 2) {
                                                                            a = F[g + 616 >> 2];
                                                                            F[a >> 2] = h;
                                                                            b = 1;
                                                                            d = F[g + 12 >> 2];
                                                                            if (d >>> 0 > 1) {
                                                                                break m;
                                                                            }
                                                                            break j;
                                                                        }
                                                                        if (I[g + 8 >> 2] > I[g + 4 >> 2]) {
                                                                            break e;
                                                                        }
                                                                        c = a;
                                                                        a = k + 12 | 0;
                                                                        Ca(c + a | 0, F[n >> 2], F[n + 4 >> 2]);
                                                                        a = m + F[a + F[g + 628 >> 2] >> 2] | 0;
                                                                        F[a >> 2] = F[a >> 2] + (1 << b - 1);
                                                                        b = 0;
                                                                        d = 0;
                                                                        a = O(j) ^ 31;
                                                                        if (a) {
                                                                            while (1) {
                                                                                b = Ga(((d << 4) + g | 0) + 16 | 0) | b << 1;
                                                                                d = d + 1 | 0;
                                                                                if ((a | 0) != (d | 0)) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                        }
                                                                        c = l + 1 | 0;
                                                                        a = (j >>> 1 | 0) - b | 0;
                                                                        d = j - a | 0;
                                                                        n: {
                                                                            if ((d | 0) == (a | 0)) {
                                                                                d = a;
                                                                                break n;
                                                                            }
                                                                            b = F[g + 596 >> 2];
                                                                            if ((b | 0) == F[g + 588 >> 2]) {
                                                                                break l;
                                                                            }
                                                                            f = F[b >> 2];
                                                                            j = F[g + 600 >> 2];
                                                                            n = j + 1 | 0;
                                                                            F[g + 600 >> 2] = n;
                                                                            f = f & -2147483648 >>> j;
                                                                            o: {
                                                                                if ((n | 0) == 32) {
                                                                                    F[g + 600 >> 2] = 0;
                                                                                    F[g + 596 >> 2] = b + 4;
                                                                                    if (f) {
                                                                                        break o;
                                                                                    }
                                                                                    break l;
                                                                                }
                                                                                if (!f) {
                                                                                    break l;
                                                                                }
                                                                            }
                                                                        }
                                                                        f = d;
                                                                        d = a;
                                                                        break k;
                                                                    }
                                                                    while (1) {
                                                                        h = (d - 1 | 0) == (h | 0) ? 0 : h + 1 | 0;
                                                                        F[a + (b << 2) >> 2] = h;
                                                                        b = b + 1 | 0;
                                                                        d = F[g + 12 >> 2];
                                                                        if (b >>> 0 < d >>> 0) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    break j;
                                                                }
                                                                f = a;
                                                            }
                                                            a = F[g + 640 >> 2];
                                                            b = a + k | 0;
                                                            j = F[b >> 2];
                                                            k = j + m | 0;
                                                            F[k >> 2] = F[k >> 2] + 1;
                                                            Ca(a + L(c, 12) | 0, j, F[b + 4 >> 2]);
                                                            if (d) {
                                                                b = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                                a = F[e + 12 >> 2];
                                                                j = F[e + 16 >> 2] - a | 0;
                                                                if ((b | 0) == ((j ? L(j >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                    za(e + 8 | 0);
                                                                    b = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                                    j = F[e + 12 >> 2];
                                                                }
                                                                else {
                                                                    j = a;
                                                                }
                                                                a = (b >>> 0) / 341 | 0;
                                                                a = F[j + (a << 2) >> 2] + L(b - L(a, 341) | 0, 12) | 0;
                                                                F[a + 8 >> 2] = l;
                                                                F[a + 4 >> 2] = h;
                                                                F[a >> 2] = d;
                                                                F[e + 28 >> 2] = F[e + 28 >> 2] + 1;
                                                            }
                                                            if (!f) {
                                                                break g;
                                                            }
                                                            d = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                            b = F[e + 12 >> 2];
                                                            a = F[e + 16 >> 2] - b | 0;
                                                            if ((d | 0) == ((a ? L(a >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                za(e + 8 | 0);
                                                                d = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                                b = F[e + 12 >> 2];
                                                            }
                                                            a = (d >>> 0) / 341 | 0;
                                                            a = F[b + (a << 2) >> 2] + L(d - L(a, 341) | 0, 12) | 0;
                                                            F[a + 8 >> 2] = c;
                                                            F[a + 4 >> 2] = h;
                                                            F[a >> 2] = f;
                                                            d = F[e + 28 >> 2] + 1 | 0;
                                                            F[e + 28 >> 2] = d;
                                                            break f;
                                                        }
                                                        a = 0;
                                                        if (!j) {
                                                            break g;
                                                        }
                                                        while (1) {
                                                            if (d) {
                                                                h = F[g + 548 >> 2];
                                                                f = F[g + 604 >> 2];
                                                                s = F[g + 616 >> 2];
                                                                t = F[n >> 2];
                                                                u = F[q >> 2];
                                                                d = 0;
                                                                while (1) {
                                                                    l = (d << 2) + s | 0;
                                                                    F[f + (F[l >> 2] << 2) >> 2] = 0;
                                                                    c = F[l >> 2] << 2;
                                                                    b = F[g >> 2] - F[c + u >> 2] | 0;
                                                                    p: {
                                                                        if (!b) {
                                                                            break p;
                                                                        }
                                                                        c = c + f | 0;
                                                                        k = F[g + 560 >> 2];
                                                                        o = 32 - k | 0;
                                                                        if ((o | 0) >= (b | 0)) {
                                                                            m = F[g + 556 >> 2];
                                                                            if ((m | 0) == (h | 0)) {
                                                                                F[c >> 2] = 0;
                                                                                break p;
                                                                            }
                                                                            F[c >> 2] = F[m >> 2] << k >>> 32 - b;
                                                                            b = b + F[g + 560 >> 2] | 0;
                                                                            F[g + 560 >> 2] = b;
                                                                            if ((b | 0) != 32) {
                                                                                break p;
                                                                            }
                                                                            F[g + 560 >> 2] = 0;
                                                                            F[g + 556 >> 2] = m + 4;
                                                                            break p;
                                                                        }
                                                                        m = F[g + 556 >> 2];
                                                                        r = m + 4 | 0;
                                                                        if ((h | 0) == (r | 0)) {
                                                                            F[c >> 2] = 0;
                                                                            break p;
                                                                        }
                                                                        v = F[m >> 2];
                                                                        F[g + 556 >> 2] = r;
                                                                        o = b - o | 0;
                                                                        F[g + 560 >> 2] = o;
                                                                        F[c >> 2] = F[m + 4 >> 2] >>> 32 - o | v << k >>> 32 - b;
                                                                    }
                                                                    b = F[l >> 2] << 2;
                                                                    c = b + f | 0;
                                                                    F[c >> 2] = F[c >> 2] | F[b + t >> 2];
                                                                    d = d + 1 | 0;
                                                                    if (d >>> 0 < I[g + 12 >> 2]) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            f = 0;
                                                            d = F[i + 16 >> 2];
                                                            q: {
                                                                if ((d | 0) == F[i + 20 >> 2]) {
                                                                    break q;
                                                                }
                                                                while (1) {
                                                                    l = L(f, 20) + d | 0;
                                                                    c = F[g + 604 >> 2] + (F[l + 4 >> 2] << 2) | 0;
                                                                    k = F[l >> 2];
                                                                    h = F[l + 12 >> 2];
                                                                    r: {
                                                                        if (h >>> 0 > 3) {
                                                                            break r;
                                                                        }
                                                                        b = F[i + 12 >> 2];
                                                                        if (!F[l + 16 >> 2]) {
                                                                            c = b;
                                                                            break r;
                                                                        }
                                                                        d = 0;
                                                                        while (1) {
                                                                            b = ta(b, (d << 2) + c | 0, h);
                                                                            h = F[l + 12 >> 2];
                                                                            b = b + h | 0;
                                                                            d = d + 1 | 0;
                                                                            if (d >>> 0 < I[l + 16 >> 2]) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        c = F[i + 12 >> 2];
                                                                    }
                                                                    d = F[i + 28 >> 2];
                                                                    d = G[k + 84 | 0] ? d : F[F[k + 68 >> 2] + (d << 2) >> 2];
                                                                    if (d >>> 0 >= I[k + 80 >> 2]) {
                                                                        break q;
                                                                    }
                                                                    b = F[k + 40 >> 2];
                                                                    ta(F[F[k >> 2] >> 2] + L(b, d) | 0, c, b);
                                                                    f = f + 1 | 0;
                                                                    d = F[i + 16 >> 2];
                                                                    if (f >>> 0 < (F[i + 20 >> 2] - d | 0) / 20 >>> 0) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            F[i + 28 >> 2] = F[i + 28 >> 2] + 1;
                                                            F[g + 8 >> 2] = F[g + 8 >> 2] + 1;
                                                            a = a + 1 | 0;
                                                            if ((j | 0) == (a | 0)) {
                                                                break g;
                                                            }
                                                            d = F[g + 12 >> 2];
                                                            continue;
                                                        }
                                                    }
                                                    d = F[e + 28 >> 2];
                                                }
                                                if (d) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            c = 1;
                                        }
                                        F[e + 28 >> 2] = 0;
                                        h = F[e + 16 >> 2];
                                        d = F[e + 12 >> 2];
                                        b = h - d | 0;
                                        if (b >>> 0 >= 9) {
                                            while (1) {
                                                ra(F[d >> 2]);
                                                d = F[e + 12 >> 2] + 4 | 0;
                                                F[e + 12 >> 2] = d;
                                                h = F[e + 16 >> 2];
                                                b = h - d | 0;
                                                if (b >>> 0 > 8) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        a = 170;
                                        s: {
                                            switch ((b >>> 2 | 0) - 1 | 0) {
                                                case 1: a = 341;
                                                case 0:
                                                    F[e + 24 >> 2] = a;
                                                    break;
                                                default: break s;
                                            }
                                        }
                                        t: {
                                            if ((d | 0) == (h | 0)) {
                                                break t;
                                            }
                                            while (1) {
                                                ra(F[d >> 2]);
                                                d = d + 4 | 0;
                                                if ((h | 0) != (d | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            a = F[e + 16 >> 2];
                                            b = F[e + 12 >> 2];
                                            if ((a | 0) == (b | 0)) {
                                                break t;
                                            }
                                            F[e + 16 >> 2] = a + (((a - b | 0) - 4 >>> 2 ^ -1) << 2);
                                        }
                                        a = F[e + 8 >> 2];
                                        if (a) {
                                            ra(a);
                                        }
                                        ea = e + 32 | 0;
                                        break b;
                                    }
                                    va();
                                    V();
                                }
                                va();
                                V();
                            }
                            d = c;
                        } return d; }
                        function vd(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0; h = F[b + 12 >> 2]; f = F[b + 20 >> 2]; e = F[b + 16 >> 2]; g = e + 4 | 0; f = g >>> 0 < 4 ? f + 1 | 0 : f; a: {
                            if (g >>> 0 > I[b + 8 >> 2] & (f | 0) >= (h | 0) | (f | 0) > (h | 0)) {
                                break a;
                            }
                            f = e + F[b >> 2] | 0;
                            F[a >> 2] = G[f | 0] | G[f + 1 | 0] << 8 | (G[f + 2 | 0] << 16 | G[f + 3 | 0] << 24);
                            f = F[b + 20 >> 2];
                            h = f;
                            g = F[b + 16 >> 2];
                            e = g + 4 | 0;
                            f = e >>> 0 < 4 ? f + 1 | 0 : f;
                            i = e;
                            F[b + 16 >> 2] = e;
                            F[b + 20 >> 2] = f;
                            if (I[a >> 2] > 32) {
                                break a;
                            }
                            e = F[b + 12 >> 2];
                            f = h;
                            h = g + 8 | 0;
                            f = h >>> 0 < 8 ? f + 1 | 0 : f;
                            if ((e | 0) <= (f | 0) & h >>> 0 > I[b + 8 >> 2] | (e | 0) < (f | 0)) {
                                break a;
                            }
                            d = i + F[b >> 2] | 0;
                            f = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                            F[a + 4 >> 2] = f;
                            d = F[b + 20 >> 2];
                            h = F[b + 16 >> 2] + 4 | 0;
                            d = h >>> 0 < 4 ? d + 1 | 0 : d;
                            F[b + 16 >> 2] = h;
                            F[b + 20 >> 2] = d;
                            if (!f) {
                                return 1;
                            }
                            d = 0;
                            F[a + 8 >> 2] = 0;
                            if (!vb(a + 16 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 544 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 564 | 0, b)) {
                                break a;
                            }
                            if (!ya(a + 584 | 0, b)) {
                                break a;
                            }
                            q = F[a + 4 >> 2];
                            h = c;
                            c = 0;
                            b = 0;
                            e = ea - 32 | 0;
                            ea = e;
                            f = a;
                            d = F[a + 12 >> 2];
                            F[e + 16 >> 2] = 0;
                            F[e + 8 >> 2] = 0;
                            F[e + 12 >> 2] = 0;
                            b: {
                                c: {
                                    if (d) {
                                        if (d >>> 0 >= 1073741824) {
                                            break c;
                                        }
                                        a = d << 2;
                                        c = sa(a);
                                        F[e + 8 >> 2] = c;
                                        b = a + c | 0;
                                        F[e + 16 >> 2] = b;
                                        ua(c, 0, a);
                                        F[e + 12 >> 2] = b;
                                    }
                                    a = F[f + 628 >> 2];
                                    g = F[a >> 2];
                                    if (g) {
                                        F[a + 4 >> 2] = g;
                                        ra(g);
                                        F[a + 8 >> 2] = 0;
                                        F[a >> 2] = 0;
                                        F[a + 4 >> 2] = 0;
                                        d = F[f + 12 >> 2];
                                        c = F[e + 8 >> 2];
                                        b = F[e + 12 >> 2];
                                    }
                                    F[a + 4 >> 2] = b;
                                    F[a >> 2] = c;
                                    F[a + 8 >> 2] = F[e + 16 >> 2];
                                    c = 0;
                                    F[e + 16 >> 2] = 0;
                                    F[e + 8 >> 2] = 0;
                                    F[e + 12 >> 2] = 0;
                                    g = 0;
                                    d: {
                                        if (d) {
                                            if (d >>> 0 >= 1073741824) {
                                                break d;
                                            }
                                            a = d << 2;
                                            g = sa(a);
                                            F[e + 8 >> 2] = g;
                                            c = a + g | 0;
                                            F[e + 16 >> 2] = c;
                                            ua(g, 0, a);
                                            F[e + 12 >> 2] = c;
                                        }
                                        a = F[f + 640 >> 2];
                                        b = F[a >> 2];
                                        if (b) {
                                            F[a + 4 >> 2] = b;
                                            ra(b);
                                            F[a + 8 >> 2] = 0;
                                            F[a >> 2] = 0;
                                            F[a + 4 >> 2] = 0;
                                            g = F[e + 8 >> 2];
                                            c = F[e + 12 >> 2];
                                        }
                                        F[a + 4 >> 2] = c;
                                        F[a >> 2] = g;
                                        F[a + 8 >> 2] = F[e + 16 >> 2];
                                        F[e + 24 >> 2] = 0;
                                        F[e + 28 >> 2] = 0;
                                        F[e + 16 >> 2] = 0;
                                        F[e + 20 >> 2] = 0;
                                        F[e + 8 >> 2] = 0;
                                        F[e + 12 >> 2] = 0;
                                        za(e + 8 | 0);
                                        a = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                        b = (a >>> 0) / 341 | 0;
                                        a = F[F[e + 12 >> 2] + (b << 2) >> 2] + L(a - L(b, 341) | 0, 12) | 0;
                                        F[a + 4 >> 2] = 0;
                                        F[a + 8 >> 2] = 0;
                                        F[a >> 2] = q;
                                        b = 1;
                                        a = F[e + 28 >> 2];
                                        d = a + 1 | 0;
                                        F[e + 28 >> 2] = d;
                                        e: {
                                            if (a >>> 0 > d >>> 0) {
                                                break e;
                                            }
                                            while (1) {
                                                l = F[e + 12 >> 2];
                                                a = F[e + 24 >> 2];
                                                b = d - 1 | 0;
                                                c = a + b | 0;
                                                g = (c >>> 0) / 341 | 0;
                                                c = F[l + (g << 2) >> 2] + L(c - L(g, 341) | 0, 12) | 0;
                                                j = F[c + 8 >> 2];
                                                i = F[c >> 2];
                                                F[e + 28 >> 2] = b;
                                                b = F[e + 16 >> 2];
                                                c = b - l | 0;
                                                if (((c ? L(c >> 2, 341) - 1 | 0 : 0) - (a + d | 0) | 0) + 1 >>> 0 >= 682) {
                                                    ra(F[b - 4 >> 2]);
                                                    F[e + 16 >> 2] = F[e + 16 >> 2] - 4;
                                                }
                                                b = 0;
                                                if (i >>> 0 > q >>> 0) {
                                                    break e;
                                                }
                                                a = F[f + 628 >> 2];
                                                k = L(j, 12);
                                                m = k + F[f + 640 >> 2] | 0;
                                                g = Td(f, i, m);
                                                if (g >>> 0 >= I[f + 12 >> 2]) {
                                                    break e;
                                                }
                                                l = a + k | 0;
                                                f: {
                                                    g: {
                                                        o = g << 2;
                                                        c = F[f >> 2] - F[o + F[m >> 2] >> 2] | 0;
                                                        if (!c) {
                                                            m = 0;
                                                            if (!i) {
                                                                break g;
                                                            }
                                                            while (1) {
                                                                a = 0;
                                                                d = F[h + 16 >> 2];
                                                                h: {
                                                                    if ((d | 0) == F[h + 20 >> 2]) {
                                                                        break h;
                                                                    }
                                                                    while (1) {
                                                                        j = L(a, 20) + d | 0;
                                                                        b = F[l >> 2] + (F[j + 4 >> 2] << 2) | 0;
                                                                        k = F[j >> 2];
                                                                        g = F[j + 12 >> 2];
                                                                        i: {
                                                                            if (g >>> 0 > 3) {
                                                                                break i;
                                                                            }
                                                                            c = F[h + 12 >> 2];
                                                                            if (!F[j + 16 >> 2]) {
                                                                                b = c;
                                                                                break i;
                                                                            }
                                                                            d = 0;
                                                                            while (1) {
                                                                                c = ta(c, (d << 2) + b | 0, g);
                                                                                g = F[j + 12 >> 2];
                                                                                c = c + g | 0;
                                                                                d = d + 1 | 0;
                                                                                if (d >>> 0 < I[j + 16 >> 2]) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                            b = F[h + 12 >> 2];
                                                                        }
                                                                        d = F[h + 28 >> 2];
                                                                        d = G[k + 84 | 0] ? d : F[F[k + 68 >> 2] + (d << 2) >> 2];
                                                                        if (d >>> 0 >= I[k + 80 >> 2]) {
                                                                            break h;
                                                                        }
                                                                        c = F[k + 40 >> 2];
                                                                        ta(F[F[k >> 2] >> 2] + L(c, d) | 0, b, c);
                                                                        a = a + 1 | 0;
                                                                        d = F[h + 16 >> 2];
                                                                        if (a >>> 0 < (F[h + 20 >> 2] - d | 0) / 20 >>> 0) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                }
                                                                F[h + 28 >> 2] = F[h + 28 >> 2] + 1;
                                                                F[f + 8 >> 2] = F[f + 8 >> 2] + 1;
                                                                m = m + 1 | 0;
                                                                if ((i | 0) != (m | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                            break g;
                                                        }
                                                        j: {
                                                            k: {
                                                                l: {
                                                                    m: {
                                                                        if (i >>> 0 <= 2) {
                                                                            a = F[f + 616 >> 2];
                                                                            F[a >> 2] = g;
                                                                            c = 1;
                                                                            d = F[f + 12 >> 2];
                                                                            if (d >>> 0 > 1) {
                                                                                break m;
                                                                            }
                                                                            break j;
                                                                        }
                                                                        if (I[f + 8 >> 2] > I[f + 4 >> 2]) {
                                                                            break e;
                                                                        }
                                                                        a = F[f + 628 >> 2];
                                                                        n = j + 1 | 0;
                                                                        m = L(n, 12);
                                                                        b = a + m | 0;
                                                                        if ((b | 0) != (l | 0)) {
                                                                            Ca(b, F[l >> 2], F[l + 4 >> 2]);
                                                                            a = F[f + 628 >> 2];
                                                                        }
                                                                        a = o + F[a + m >> 2] | 0;
                                                                        F[a >> 2] = F[a >> 2] + (1 << c - 1);
                                                                        c = 0;
                                                                        d = 0;
                                                                        a = O(i) ^ 31;
                                                                        if (a) {
                                                                            while (1) {
                                                                                c = Ga(((d << 4) + f | 0) + 16 | 0) | c << 1;
                                                                                d = d + 1 | 0;
                                                                                if ((a | 0) != (d | 0)) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                        }
                                                                        a = (i >>> 1 | 0) - c | 0;
                                                                        d = i - a | 0;
                                                                        n: {
                                                                            if ((d | 0) == (a | 0)) {
                                                                                b = a;
                                                                                break n;
                                                                            }
                                                                            b = F[f + 596 >> 2];
                                                                            if ((b | 0) == F[f + 588 >> 2]) {
                                                                                break l;
                                                                            }
                                                                            c = F[b >> 2];
                                                                            i = F[f + 600 >> 2];
                                                                            l = i + 1 | 0;
                                                                            F[f + 600 >> 2] = l;
                                                                            c = c & -2147483648 >>> i;
                                                                            o: {
                                                                                if ((l | 0) == 32) {
                                                                                    F[f + 600 >> 2] = 0;
                                                                                    F[f + 596 >> 2] = b + 4;
                                                                                    if (c) {
                                                                                        break o;
                                                                                    }
                                                                                    break l;
                                                                                }
                                                                                if (!c) {
                                                                                    break l;
                                                                                }
                                                                            }
                                                                            b = d;
                                                                        }
                                                                        d = a;
                                                                        break k;
                                                                    }
                                                                    while (1) {
                                                                        g = (d - 1 | 0) == (g | 0) ? 0 : g + 1 | 0;
                                                                        F[a + (c << 2) >> 2] = g;
                                                                        c = c + 1 | 0;
                                                                        d = F[f + 12 >> 2];
                                                                        if (c >>> 0 < d >>> 0) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    break j;
                                                                }
                                                                b = a;
                                                            }
                                                            a = F[f + 640 >> 2];
                                                            c = a + k | 0;
                                                            i = F[c >> 2];
                                                            l = i + o | 0;
                                                            F[l >> 2] = F[l >> 2] + 1;
                                                            Ca(a + m | 0, i, F[c + 4 >> 2]);
                                                            if (d) {
                                                                c = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                                a = F[e + 12 >> 2];
                                                                i = F[e + 16 >> 2] - a | 0;
                                                                if ((c | 0) == ((i ? L(i >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                    za(e + 8 | 0);
                                                                    c = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                                    i = F[e + 12 >> 2];
                                                                }
                                                                else {
                                                                    i = a;
                                                                }
                                                                a = (c >>> 0) / 341 | 0;
                                                                a = F[i + (a << 2) >> 2] + L(c - L(a, 341) | 0, 12) | 0;
                                                                F[a + 8 >> 2] = j;
                                                                F[a + 4 >> 2] = g;
                                                                F[a >> 2] = d;
                                                                F[e + 28 >> 2] = F[e + 28 >> 2] + 1;
                                                            }
                                                            if (!b) {
                                                                break g;
                                                            }
                                                            d = F[e + 28 >> 2] + F[e + 24 >> 2] | 0;
                                                            c = F[e + 12 >> 2];
                                                            a = F[e + 16 >> 2] - c | 0;
                                                            if ((d | 0) == ((a ? L(a >> 2, 341) - 1 | 0 : 0) | 0)) {
                                                                za(e + 8 | 0);
                                                                d = F[e + 24 >> 2] + F[e + 28 >> 2] | 0;
                                                                c = F[e + 12 >> 2];
                                                            }
                                                            a = (d >>> 0) / 341 | 0;
                                                            a = F[c + (a << 2) >> 2] + L(d - L(a, 341) | 0, 12) | 0;
                                                            F[a + 8 >> 2] = n;
                                                            F[a + 4 >> 2] = g;
                                                            F[a >> 2] = b;
                                                            d = F[e + 28 >> 2] + 1 | 0;
                                                            F[e + 28 >> 2] = d;
                                                            break f;
                                                        }
                                                        o = 0;
                                                        if (!i) {
                                                            break g;
                                                        }
                                                        while (1) {
                                                            if (d) {
                                                                g = F[f + 548 >> 2];
                                                                c = F[f + 604 >> 2];
                                                                s = F[f + 616 >> 2];
                                                                t = F[l >> 2];
                                                                u = F[m >> 2];
                                                                d = 0;
                                                                while (1) {
                                                                    j = (d << 2) + s | 0;
                                                                    F[c + (F[j >> 2] << 2) >> 2] = 0;
                                                                    b = F[j >> 2] << 2;
                                                                    a = F[f >> 2] - F[b + u >> 2] | 0;
                                                                    p: {
                                                                        if (!a) {
                                                                            break p;
                                                                        }
                                                                        b = b + c | 0;
                                                                        k = F[f + 560 >> 2];
                                                                        p = 32 - k | 0;
                                                                        if ((p | 0) >= (a | 0)) {
                                                                            n = F[f + 556 >> 2];
                                                                            if ((n | 0) == (g | 0)) {
                                                                                F[b >> 2] = 0;
                                                                                break p;
                                                                            }
                                                                            F[b >> 2] = F[n >> 2] << k >>> 32 - a;
                                                                            a = a + F[f + 560 >> 2] | 0;
                                                                            F[f + 560 >> 2] = a;
                                                                            if ((a | 0) != 32) {
                                                                                break p;
                                                                            }
                                                                            F[f + 560 >> 2] = 0;
                                                                            F[f + 556 >> 2] = n + 4;
                                                                            break p;
                                                                        }
                                                                        n = F[f + 556 >> 2];
                                                                        r = n + 4 | 0;
                                                                        if ((g | 0) == (r | 0)) {
                                                                            F[b >> 2] = 0;
                                                                            break p;
                                                                        }
                                                                        v = F[n >> 2];
                                                                        F[f + 556 >> 2] = r;
                                                                        p = a - p | 0;
                                                                        F[f + 560 >> 2] = p;
                                                                        F[b >> 2] = F[n + 4 >> 2] >>> 32 - p | v << k >>> 32 - a;
                                                                    }
                                                                    a = F[j >> 2] << 2;
                                                                    b = a + c | 0;
                                                                    F[b >> 2] = F[b >> 2] | F[a + t >> 2];
                                                                    d = d + 1 | 0;
                                                                    if (d >>> 0 < I[f + 12 >> 2]) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            a = 0;
                                                            d = F[h + 16 >> 2];
                                                            q: {
                                                                if ((d | 0) == F[h + 20 >> 2]) {
                                                                    break q;
                                                                }
                                                                while (1) {
                                                                    j = L(a, 20) + d | 0;
                                                                    b = F[f + 604 >> 2] + (F[j + 4 >> 2] << 2) | 0;
                                                                    k = F[j >> 2];
                                                                    g = F[j + 12 >> 2];
                                                                    r: {
                                                                        if (g >>> 0 > 3) {
                                                                            break r;
                                                                        }
                                                                        c = F[h + 12 >> 2];
                                                                        if (!F[j + 16 >> 2]) {
                                                                            b = c;
                                                                            break r;
                                                                        }
                                                                        d = 0;
                                                                        while (1) {
                                                                            c = ta(c, (d << 2) + b | 0, g);
                                                                            g = F[j + 12 >> 2];
                                                                            c = c + g | 0;
                                                                            d = d + 1 | 0;
                                                                            if (d >>> 0 < I[j + 16 >> 2]) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        b = F[h + 12 >> 2];
                                                                    }
                                                                    d = F[h + 28 >> 2];
                                                                    d = G[k + 84 | 0] ? d : F[F[k + 68 >> 2] + (d << 2) >> 2];
                                                                    if (d >>> 0 >= I[k + 80 >> 2]) {
                                                                        break q;
                                                                    }
                                                                    c = F[k + 40 >> 2];
                                                                    ta(F[F[k >> 2] >> 2] + L(c, d) | 0, b, c);
                                                                    a = a + 1 | 0;
                                                                    d = F[h + 16 >> 2];
                                                                    if (a >>> 0 < (F[h + 20 >> 2] - d | 0) / 20 >>> 0) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            F[h + 28 >> 2] = F[h + 28 >> 2] + 1;
                                                            F[f + 8 >> 2] = F[f + 8 >> 2] + 1;
                                                            o = o + 1 | 0;
                                                            if ((i | 0) == (o | 0)) {
                                                                break g;
                                                            }
                                                            d = F[f + 12 >> 2];
                                                            continue;
                                                        }
                                                    }
                                                    d = F[e + 28 >> 2];
                                                }
                                                if (d) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            b = 1;
                                        }
                                        F[e + 28 >> 2] = 0;
                                        g = F[e + 16 >> 2];
                                        d = F[e + 12 >> 2];
                                        c = g - d | 0;
                                        if (c >>> 0 >= 9) {
                                            while (1) {
                                                ra(F[d >> 2]);
                                                d = F[e + 12 >> 2] + 4 | 0;
                                                F[e + 12 >> 2] = d;
                                                g = F[e + 16 >> 2];
                                                c = g - d | 0;
                                                if (c >>> 0 > 8) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        a = 170;
                                        s: {
                                            switch ((c >>> 2 | 0) - 1 | 0) {
                                                case 1: a = 341;
                                                case 0:
                                                    F[e + 24 >> 2] = a;
                                                    break;
                                                default: break s;
                                            }
                                        }
                                        t: {
                                            if ((d | 0) == (g | 0)) {
                                                break t;
                                            }
                                            while (1) {
                                                ra(F[d >> 2]);
                                                d = d + 4 | 0;
                                                if ((g | 0) != (d | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            a = F[e + 16 >> 2];
                                            c = F[e + 12 >> 2];
                                            if ((a | 0) == (c | 0)) {
                                                break t;
                                            }
                                            F[e + 16 >> 2] = a + (((a - c | 0) - 4 >>> 2 ^ -1) << 2);
                                        }
                                        a = F[e + 8 >> 2];
                                        if (a) {
                                            ra(a);
                                        }
                                        ea = e + 32 | 0;
                                        break b;
                                    }
                                    va();
                                    V();
                                }
                                va();
                                V();
                            }
                            d = b;
                        } return d; }
                        function Nd(a, b, c, d, e) { var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0; h = ea - 80 | 0; ea = h; F[h + 76 >> 2] = b; w = h + 55 | 0; r = h + 56 | 0; b = 0; a: {
                            b: {
                                c: {
                                    d: {
                                        e: while (1) {
                                            if ((2147483647 - n | 0) < (b | 0)) {
                                                break d;
                                            }
                                            n = b + n | 0;
                                            f: {
                                                g: {
                                                    h: {
                                                        l = F[h + 76 >> 2];
                                                        b = l;
                                                        k = G[b | 0];
                                                        if (k) {
                                                            while (1) {
                                                                i: {
                                                                    f = k & 255;
                                                                    j: {
                                                                        if (!f) {
                                                                            k = b;
                                                                            break j;
                                                                        }
                                                                        if ((f | 0) != 37) {
                                                                            break i;
                                                                        }
                                                                        k = b;
                                                                        while (1) {
                                                                            if (G[b + 1 | 0] != 37) {
                                                                                break j;
                                                                            }
                                                                            f = b + 2 | 0;
                                                                            F[h + 76 >> 2] = f;
                                                                            k = k + 1 | 0;
                                                                            g = G[b + 2 | 0];
                                                                            b = f;
                                                                            if ((g | 0) == 37) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    b = k - l | 0;
                                                                    v = 2147483647 - n | 0;
                                                                    if ((b | 0) > (v | 0)) {
                                                                        break d;
                                                                    }
                                                                    if (a) {
                                                                        Bb(a, l, b);
                                                                    }
                                                                    if (b) {
                                                                        continue e;
                                                                    }
                                                                    q = -1;
                                                                    f = 1;
                                                                    b = F[h + 76 >> 2];
                                                                    if (!(D[b + 1 | 0] - 48 >>> 0 >= 10 | G[b + 2 | 0] != 36)) {
                                                                        q = D[b + 1 | 0] - 48 | 0;
                                                                        s = 1;
                                                                        f = 3;
                                                                    }
                                                                    b = f + b | 0;
                                                                    F[h + 76 >> 2] = b;
                                                                    o = 0;
                                                                    j = D[b | 0];
                                                                    g = j - 32 | 0;
                                                                    k: {
                                                                        if (g >>> 0 > 31) {
                                                                            f = b;
                                                                            break k;
                                                                        }
                                                                        f = b;
                                                                        i = 1 << g;
                                                                        if (!(i & 75913)) {
                                                                            break k;
                                                                        }
                                                                        while (1) {
                                                                            f = b + 1 | 0;
                                                                            F[h + 76 >> 2] = f;
                                                                            o = i | o;
                                                                            j = D[b + 1 | 0];
                                                                            g = j - 32 | 0;
                                                                            if (g >>> 0 >= 32) {
                                                                                break k;
                                                                            }
                                                                            b = f;
                                                                            i = 1 << g;
                                                                            if (i & 75913) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    l: {
                                                                        if ((j | 0) == 42) {
                                                                            m: {
                                                                                n: {
                                                                                    if (D[f + 1 | 0] - 48 >>> 0 >= 10) {
                                                                                        break n;
                                                                                    }
                                                                                    b = F[h + 76 >> 2];
                                                                                    if (G[b + 2 | 0] != 36) {
                                                                                        break n;
                                                                                    }
                                                                                    F[((D[b + 1 | 0] << 2) + e | 0) - 192 >> 2] = 10;
                                                                                    p = F[((D[b + 1 | 0] << 3) + d | 0) - 384 >> 2];
                                                                                    s = 1;
                                                                                    b = b + 3 | 0;
                                                                                    break m;
                                                                                }
                                                                                if (s) {
                                                                                    break h;
                                                                                }
                                                                                s = 0;
                                                                                p = 0;
                                                                                if (a) {
                                                                                    b = F[c >> 2];
                                                                                    F[c >> 2] = b + 4;
                                                                                    p = F[b >> 2];
                                                                                }
                                                                                b = F[h + 76 >> 2] + 1 | 0;
                                                                            }
                                                                            F[h + 76 >> 2] = b;
                                                                            if ((p | 0) >= 0) {
                                                                                break l;
                                                                            }
                                                                            p = 0 - p | 0;
                                                                            o = o | 8192;
                                                                            break l;
                                                                        }
                                                                        p = Ld(h + 76 | 0);
                                                                        if ((p | 0) < 0) {
                                                                            break d;
                                                                        }
                                                                        b = F[h + 76 >> 2];
                                                                    }
                                                                    f = 0;
                                                                    i = -1;
                                                                    g = 0;
                                                                    o: {
                                                                        if (G[b | 0] != 46) {
                                                                            break o;
                                                                        }
                                                                        if (G[b + 1 | 0] == 42) {
                                                                            p: {
                                                                                q: {
                                                                                    if (D[b + 2 | 0] - 48 >>> 0 >= 10) {
                                                                                        break q;
                                                                                    }
                                                                                    b = F[h + 76 >> 2];
                                                                                    if (G[b + 3 | 0] != 36) {
                                                                                        break q;
                                                                                    }
                                                                                    F[((D[b + 2 | 0] << 2) + e | 0) - 192 >> 2] = 10;
                                                                                    i = F[((D[b + 2 | 0] << 3) + d | 0) - 384 >> 2];
                                                                                    b = b + 4 | 0;
                                                                                    break p;
                                                                                }
                                                                                if (s) {
                                                                                    break h;
                                                                                }
                                                                                if (a) {
                                                                                    b = F[c >> 2];
                                                                                    F[c >> 2] = b + 4;
                                                                                    i = F[b >> 2];
                                                                                }
                                                                                else {
                                                                                    i = 0;
                                                                                }
                                                                                b = F[h + 76 >> 2] + 2 | 0;
                                                                            }
                                                                            F[h + 76 >> 2] = b;
                                                                            g = (i ^ -1) >>> 31 | 0;
                                                                            break o;
                                                                        }
                                                                        F[h + 76 >> 2] = b + 1;
                                                                        i = Ld(h + 76 | 0);
                                                                        b = F[h + 76 >> 2];
                                                                        g = 1;
                                                                    }
                                                                    t = g;
                                                                    while (1) {
                                                                        m = f;
                                                                        k = 28;
                                                                        if (D[b | 0] - 123 >>> 0 < 4294967238) {
                                                                            break c;
                                                                        }
                                                                        j = b + 1 | 0;
                                                                        F[h + 76 >> 2] = j;
                                                                        f = D[b | 0];
                                                                        b = j;
                                                                        f = G[(f + L(m, 58) | 0) + 13743 | 0];
                                                                        if (f - 1 >>> 0 < 8) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    r: {
                                                                        s: {
                                                                            if ((f | 0) != 27) {
                                                                                if (!f) {
                                                                                    break c;
                                                                                }
                                                                                if ((q | 0) >= 0) {
                                                                                    F[(q << 2) + e >> 2] = f;
                                                                                    b = (q << 3) + d | 0;
                                                                                    f = F[b + 4 >> 2];
                                                                                    F[h + 64 >> 2] = F[b >> 2];
                                                                                    F[h + 68 >> 2] = f;
                                                                                    break s;
                                                                                }
                                                                                if (!a) {
                                                                                    break f;
                                                                                }
                                                                                Kd(h - -64 | 0, f, c);
                                                                                j = F[h + 76 >> 2];
                                                                                break r;
                                                                            }
                                                                            if ((q | 0) >= 0) {
                                                                                break c;
                                                                            }
                                                                        }
                                                                        b = 0;
                                                                        if (!a) {
                                                                            continue e;
                                                                        }
                                                                    }
                                                                    g = o & -65537;
                                                                    f = o & 8192 ? g : o;
                                                                    o = 0;
                                                                    q = 1244;
                                                                    k = r;
                                                                    t: {
                                                                        u: {
                                                                            v: {
                                                                                w: {
                                                                                    x: {
                                                                                        y: {
                                                                                            z: {
                                                                                                A: {
                                                                                                    B: {
                                                                                                        C: {
                                                                                                            D: {
                                                                                                                E: {
                                                                                                                    F: {
                                                                                                                        G: {
                                                                                                                            H: {
                                                                                                                                I: {
                                                                                                                                    b = D[j - 1 | 0];
                                                                                                                                    b = m ? (b & 15) == 3 ? b & -33 : b : b;
                                                                                                                                    switch (b - 88 | 0) {
                                                                                                                                        case 11: break t;
                                                                                                                                        case 9:
                                                                                                                                        case 13:
                                                                                                                                        case 14:
                                                                                                                                        case 15: break u;
                                                                                                                                        case 27: break z;
                                                                                                                                        case 12:
                                                                                                                                        case 17: break C;
                                                                                                                                        case 23: break D;
                                                                                                                                        case 0:
                                                                                                                                        case 32: break E;
                                                                                                                                        case 24: break F;
                                                                                                                                        case 22: break G;
                                                                                                                                        case 29: break H;
                                                                                                                                        case 1:
                                                                                                                                        case 2:
                                                                                                                                        case 3:
                                                                                                                                        case 4:
                                                                                                                                        case 5:
                                                                                                                                        case 6:
                                                                                                                                        case 7:
                                                                                                                                        case 8:
                                                                                                                                        case 10:
                                                                                                                                        case 16:
                                                                                                                                        case 18:
                                                                                                                                        case 19:
                                                                                                                                        case 20:
                                                                                                                                        case 21:
                                                                                                                                        case 25:
                                                                                                                                        case 26:
                                                                                                                                        case 28:
                                                                                                                                        case 30:
                                                                                                                                        case 31: break g;
                                                                                                                                        default: break I;
                                                                                                                                    }
                                                                                                                                }
                                                                                                                                J: {
                                                                                                                                    switch (b - 65 | 0) {
                                                                                                                                        case 0:
                                                                                                                                        case 4:
                                                                                                                                        case 5:
                                                                                                                                        case 6: break u;
                                                                                                                                        case 2: break x;
                                                                                                                                        case 1:
                                                                                                                                        case 3: break g;
                                                                                                                                        default: break J;
                                                                                                                                    }
                                                                                                                                }
                                                                                                                                if ((b | 0) == 83) {
                                                                                                                                    break y;
                                                                                                                                }
                                                                                                                                break g;
                                                                                                                            }
                                                                                                                            j = F[h + 64 >> 2];
                                                                                                                            g = F[h + 68 >> 2];
                                                                                                                            q = 1244;
                                                                                                                            break B;
                                                                                                                        }
                                                                                                                        b = 0;
                                                                                                                        K: {
                                                                                                                            switch (m & 255) {
                                                                                                                                case 0:
                                                                                                                                    F[F[h + 64 >> 2] >> 2] = n;
                                                                                                                                    continue e;
                                                                                                                                case 1:
                                                                                                                                    F[F[h + 64 >> 2] >> 2] = n;
                                                                                                                                    continue e;
                                                                                                                                case 2:
                                                                                                                                    f = F[h + 64 >> 2];
                                                                                                                                    F[f >> 2] = n;
                                                                                                                                    F[f + 4 >> 2] = n >> 31;
                                                                                                                                    continue e;
                                                                                                                                case 3:
                                                                                                                                    E[F[h + 64 >> 2] >> 1] = n;
                                                                                                                                    continue e;
                                                                                                                                case 4:
                                                                                                                                    D[F[h + 64 >> 2]] = n;
                                                                                                                                    continue e;
                                                                                                                                case 6:
                                                                                                                                    F[F[h + 64 >> 2] >> 2] = n;
                                                                                                                                    continue e;
                                                                                                                                case 7: break K;
                                                                                                                                default: continue e;
                                                                                                                            }
                                                                                                                        }
                                                                                                                        f = F[h + 64 >> 2];
                                                                                                                        F[f >> 2] = n;
                                                                                                                        F[f + 4 >> 2] = n >> 31;
                                                                                                                        continue e;
                                                                                                                    }
                                                                                                                    i = i >>> 0 > 8 ? i : 8;
                                                                                                                    f = f | 8;
                                                                                                                    b = 120;
                                                                                                                }
                                                                                                                m = r;
                                                                                                                u = b & 32;
                                                                                                                j = F[h + 64 >> 2];
                                                                                                                g = F[h + 68 >> 2];
                                                                                                                if (j | g) {
                                                                                                                    while (1) {
                                                                                                                        m = m - 1 | 0;
                                                                                                                        D[m | 0] = u | G[(j & 15) + 14272 | 0];
                                                                                                                        x = !g & j >>> 0 > 15 | (g | 0) != 0;
                                                                                                                        l = g;
                                                                                                                        g = g >>> 4 | 0;
                                                                                                                        j = (l & 15) << 28 | j >>> 4;
                                                                                                                        if (x) {
                                                                                                                            continue;
                                                                                                                        }
                                                                                                                        break;
                                                                                                                    }
                                                                                                                }
                                                                                                                l = m;
                                                                                                                if (!(F[h + 64 >> 2] | F[h + 68 >> 2]) | !(f & 8)) {
                                                                                                                    break A;
                                                                                                                }
                                                                                                                q = (b >>> 4 | 0) + 1244 | 0;
                                                                                                                o = 2;
                                                                                                                break A;
                                                                                                            }
                                                                                                            b = r;
                                                                                                            j = F[h + 64 >> 2];
                                                                                                            g = F[h + 68 >> 2];
                                                                                                            if (j | g) {
                                                                                                                while (1) {
                                                                                                                    b = b - 1 | 0;
                                                                                                                    D[b | 0] = j & 7 | 48;
                                                                                                                    m = !g & j >>> 0 > 7 | (g | 0) != 0;
                                                                                                                    l = g;
                                                                                                                    g = g >>> 3 | 0;
                                                                                                                    j = (l & 7) << 29 | j >>> 3;
                                                                                                                    if (m) {
                                                                                                                        continue;
                                                                                                                    }
                                                                                                                    break;
                                                                                                                }
                                                                                                            }
                                                                                                            l = b;
                                                                                                            if (!(f & 8)) {
                                                                                                                break A;
                                                                                                            }
                                                                                                            b = r - l | 0;
                                                                                                            i = (b | 0) < (i | 0) ? i : b + 1 | 0;
                                                                                                            break A;
                                                                                                        }
                                                                                                        b = F[h + 68 >> 2];
                                                                                                        g = b;
                                                                                                        j = F[h + 64 >> 2];
                                                                                                        if ((b | 0) < 0) {
                                                                                                            g = 0 - (((j | 0) != 0) + g | 0) | 0;
                                                                                                            j = 0 - j | 0;
                                                                                                            F[h + 64 >> 2] = j;
                                                                                                            F[h + 68 >> 2] = g;
                                                                                                            o = 1;
                                                                                                            q = 1244;
                                                                                                            break B;
                                                                                                        }
                                                                                                        if (f & 2048) {
                                                                                                            o = 1;
                                                                                                            q = 1245;
                                                                                                            break B;
                                                                                                        }
                                                                                                        o = f & 1;
                                                                                                        q = o ? 1246 : 1244;
                                                                                                    }
                                                                                                    l = r;
                                                                                                    L: {
                                                                                                        if (!g) {
                                                                                                            m = j;
                                                                                                            break L;
                                                                                                        }
                                                                                                        while (1) {
                                                                                                            l = l - 1 | 0;
                                                                                                            m = Jj(j, g, 10, 0);
                                                                                                            b = fa;
                                                                                                            y = l, z = j - Hj(m, b, 10, 0) | 48, D[y | 0] = z;
                                                                                                            u = g >>> 0 > 9;
                                                                                                            j = m;
                                                                                                            g = b;
                                                                                                            if (u) {
                                                                                                                continue;
                                                                                                            }
                                                                                                            break;
                                                                                                        }
                                                                                                    }
                                                                                                    if (m) {
                                                                                                        while (1) {
                                                                                                            l = l - 1 | 0;
                                                                                                            b = (m >>> 0) / 10 | 0;
                                                                                                            D[l | 0] = m - L(b, 10) | 48;
                                                                                                            g = m >>> 0 > 9;
                                                                                                            m = b;
                                                                                                            if (g) {
                                                                                                                continue;
                                                                                                            }
                                                                                                            break;
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                if ((i | 0) < 0 ? t : 0) {
                                                                                                    break d;
                                                                                                }
                                                                                                f = t ? f & -65537 : f;
                                                                                                g = F[h + 64 >> 2];
                                                                                                b = F[h + 68 >> 2];
                                                                                                if (!(i | (g | b) != 0)) {
                                                                                                    l = r;
                                                                                                    k = l;
                                                                                                    i = 0;
                                                                                                    break g;
                                                                                                }
                                                                                                b = !(b | g) + (r - l | 0) | 0;
                                                                                                i = (b | 0) < (i | 0) ? i : b;
                                                                                                break g;
                                                                                            }
                                                                                            j = (i | 0) < 0 ? 2147483647 : i;
                                                                                            f = j;
                                                                                            k = (f | 0) != 0;
                                                                                            b = F[h + 64 >> 2];
                                                                                            l = b ? b : 1758;
                                                                                            b = l;
                                                                                            M: {
                                                                                                N: {
                                                                                                    O: {
                                                                                                        P: {
                                                                                                            if (!(b & 3) | !f) {
                                                                                                                break P;
                                                                                                            }
                                                                                                            while (1) {
                                                                                                                if (!G[b | 0]) {
                                                                                                                    break O;
                                                                                                                }
                                                                                                                f = f - 1 | 0;
                                                                                                                k = (f | 0) != 0;
                                                                                                                b = b + 1 | 0;
                                                                                                                if (!(b & 3)) {
                                                                                                                    break P;
                                                                                                                }
                                                                                                                if (f) {
                                                                                                                    continue;
                                                                                                                }
                                                                                                                break;
                                                                                                            }
                                                                                                        }
                                                                                                        if (!k) {
                                                                                                            break N;
                                                                                                        }
                                                                                                    }
                                                                                                    Q: {
                                                                                                        if (!G[b | 0] | f >>> 0 < 4) {
                                                                                                            break Q;
                                                                                                        }
                                                                                                        while (1) {
                                                                                                            k = F[b >> 2];
                                                                                                            if ((k ^ -1) & k - 16843009 & -2139062144) {
                                                                                                                break Q;
                                                                                                            }
                                                                                                            b = b + 4 | 0;
                                                                                                            f = f - 4 | 0;
                                                                                                            if (f >>> 0 > 3) {
                                                                                                                continue;
                                                                                                            }
                                                                                                            break;
                                                                                                        }
                                                                                                    }
                                                                                                    if (!f) {
                                                                                                        break N;
                                                                                                    }
                                                                                                    while (1) {
                                                                                                        if (!G[b | 0]) {
                                                                                                            break M;
                                                                                                        }
                                                                                                        b = b + 1 | 0;
                                                                                                        f = f - 1 | 0;
                                                                                                        if (f) {
                                                                                                            continue;
                                                                                                        }
                                                                                                        break;
                                                                                                    }
                                                                                                }
                                                                                                b = 0;
                                                                                            }
                                                                                            b = b ? b - l | 0 : j;
                                                                                            k = b + l | 0;
                                                                                            if ((i | 0) >= 0) {
                                                                                                f = g;
                                                                                                i = b;
                                                                                                break g;
                                                                                            }
                                                                                            f = g;
                                                                                            i = b;
                                                                                            if (G[k | 0]) {
                                                                                                break d;
                                                                                            }
                                                                                            break g;
                                                                                        }
                                                                                        if (i) {
                                                                                            k = F[h + 64 >> 2];
                                                                                            break w;
                                                                                        }
                                                                                        b = 0;
                                                                                        mb(a, 32, p, 0, f);
                                                                                        break v;
                                                                                    }
                                                                                    F[h + 12 >> 2] = 0;
                                                                                    F[h + 8 >> 2] = F[h + 64 >> 2];
                                                                                    k = h + 8 | 0;
                                                                                    F[h + 64 >> 2] = k;
                                                                                    i = -1;
                                                                                }
                                                                                b = 0;
                                                                                R: {
                                                                                    while (1) {
                                                                                        g = F[k >> 2];
                                                                                        if (!g) {
                                                                                            break R;
                                                                                        }
                                                                                        g = Jd(h + 4 | 0, g);
                                                                                        l = (g | 0) < 0;
                                                                                        if (!(l | g >>> 0 > i - b >>> 0)) {
                                                                                            k = k + 4 | 0;
                                                                                            b = b + g | 0;
                                                                                            if (i >>> 0 > b >>> 0) {
                                                                                                continue;
                                                                                            }
                                                                                            break R;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    if (l) {
                                                                                        break b;
                                                                                    }
                                                                                }
                                                                                k = 61;
                                                                                if ((b | 0) < 0) {
                                                                                    break c;
                                                                                }
                                                                                mb(a, 32, p, b, f);
                                                                                if (!b) {
                                                                                    b = 0;
                                                                                    break v;
                                                                                }
                                                                                i = 0;
                                                                                k = F[h + 64 >> 2];
                                                                                while (1) {
                                                                                    g = F[k >> 2];
                                                                                    if (!g) {
                                                                                        break v;
                                                                                    }
                                                                                    g = Jd(h + 4 | 0, g);
                                                                                    i = g + i | 0;
                                                                                    if (i >>> 0 > b >>> 0) {
                                                                                        break v;
                                                                                    }
                                                                                    Bb(a, h + 4 | 0, g);
                                                                                    k = k + 4 | 0;
                                                                                    if (b >>> 0 > i >>> 0) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                            }
                                                                            mb(a, 32, p, b, f ^ 8192);
                                                                            b = (b | 0) < (p | 0) ? p : b;
                                                                            continue e;
                                                                        }
                                                                        if ((i | 0) < 0 ? t : 0) {
                                                                            break d;
                                                                        }
                                                                        k = 61;
                                                                        b = ga[0](a, K[h + 64 >> 3], p, i, f, b) | 0;
                                                                        if ((b | 0) >= 0) {
                                                                            continue e;
                                                                        }
                                                                        break c;
                                                                    }
                                                                    D[h + 55 | 0] = F[h + 64 >> 2];
                                                                    i = 1;
                                                                    l = w;
                                                                    f = g;
                                                                    break g;
                                                                }
                                                                f = b + 1 | 0;
                                                                F[h + 76 >> 2] = f;
                                                                k = G[b + 1 | 0];
                                                                b = f;
                                                                continue;
                                                            }
                                                        }
                                                        if (a) {
                                                            break a;
                                                        }
                                                        if (!s) {
                                                            break f;
                                                        }
                                                        b = 1;
                                                        while (1) {
                                                            a = F[(b << 2) + e >> 2];
                                                            if (a) {
                                                                Kd((b << 3) + d | 0, a, c);
                                                                n = 1;
                                                                b = b + 1 | 0;
                                                                if ((b | 0) != 10) {
                                                                    continue;
                                                                }
                                                                break a;
                                                            }
                                                            break;
                                                        }
                                                        n = 1;
                                                        if (b >>> 0 >= 10) {
                                                            break a;
                                                        }
                                                        while (1) {
                                                            if (F[(b << 2) + e >> 2]) {
                                                                break h;
                                                            }
                                                            b = b + 1 | 0;
                                                            if ((b | 0) != 10) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        break a;
                                                    }
                                                    k = 28;
                                                    break c;
                                                }
                                                j = k - l | 0;
                                                m = (i | 0) < (j | 0) ? j : i;
                                                if ((m | 0) > (2147483647 - o | 0)) {
                                                    break d;
                                                }
                                                k = 61;
                                                g = m + o | 0;
                                                b = (g | 0) > (p | 0) ? g : p;
                                                if ((v | 0) < (b | 0)) {
                                                    break c;
                                                }
                                                mb(a, 32, b, g, f);
                                                Bb(a, q, o);
                                                mb(a, 48, b, g, f ^ 65536);
                                                mb(a, 48, m, j, 0);
                                                Bb(a, l, j);
                                                mb(a, 32, b, g, f ^ 8192);
                                                continue;
                                            }
                                            break;
                                        }
                                        n = 0;
                                        break a;
                                    }
                                    k = 61;
                                }
                                F[4190] = k;
                            }
                            n = -1;
                        } ea = h + 80 | 0; return n; }
                        function xj(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0, E = 0, G = 0, H = 0, I = 0, J = 0; h = ea + -64 | 0; ea = h; F[a + 8 >> 2] = e; f = a + 32 | 0; g = F[f >> 2]; d = F[a + 36 >> 2] - g >> 2; a: {
                            b: {
                                if (d >>> 0 < e >>> 0) {
                                    Aa(f, e - d | 0);
                                    F[h + 56 >> 2] = 0;
                                    F[h + 60 >> 2] = 0;
                                    F[h + 48 >> 2] = 0;
                                    F[h + 52 >> 2] = 0;
                                    F[h + 40 >> 2] = 0;
                                    F[h + 44 >> 2] = 0;
                                    F[h + 32 >> 2] = 0;
                                    F[h + 36 >> 2] = 0;
                                    F[h + 24 >> 2] = 0;
                                    F[h + 28 >> 2] = 0;
                                    F[h + 16 >> 2] = 0;
                                    F[h + 20 >> 2] = 0;
                                    F[h >> 2] = 0;
                                    break b;
                                }
                                if (d >>> 0 > e >>> 0) {
                                    F[a + 36 >> 2] = g + (e << 2);
                                }
                                F[h + 56 >> 2] = 0;
                                F[h + 60 >> 2] = 0;
                                F[h + 48 >> 2] = 0;
                                F[h + 52 >> 2] = 0;
                                F[h + 40 >> 2] = 0;
                                F[h + 44 >> 2] = 0;
                                F[h + 32 >> 2] = 0;
                                F[h + 36 >> 2] = 0;
                                F[h + 24 >> 2] = 0;
                                F[h + 28 >> 2] = 0;
                                F[h + 16 >> 2] = 0;
                                F[h + 20 >> 2] = 0;
                                F[h >> 2] = 0;
                                d = 0;
                                if (!e) {
                                    break a;
                                }
                            }
                            Ia(h + 16 | 0, e, h);
                            i = F[h + 28 >> 2];
                            d = F[h + 32 >> 2];
                        } F[h >> 2] = 0; d = d - i >> 2; c: {
                            if (d >>> 0 >= e >>> 0) {
                                if (d >>> 0 <= e >>> 0) {
                                    break c;
                                }
                                F[h + 32 >> 2] = (e << 2) + i;
                                break c;
                            }
                            Ia(h + 16 | 12, e - d | 0, h);
                        } F[h >> 2] = 0; f = F[h + 40 >> 2]; d = F[h + 44 >> 2] - f >> 2; d: {
                            if (d >>> 0 >= e >>> 0) {
                                if (d >>> 0 <= e >>> 0) {
                                    break d;
                                }
                                F[h + 44 >> 2] = f + (e << 2);
                                break d;
                            }
                            Ia(h + 40 | 0, e - d | 0, h);
                        } F[h >> 2] = 0; f = F[h + 52 >> 2]; d = F[h + 56 >> 2] - f >> 2; e: {
                            if (d >>> 0 >= e >>> 0) {
                                if (d >>> 0 <= e >>> 0) {
                                    break e;
                                }
                                F[h + 56 >> 2] = f + (e << 2);
                                break e;
                            }
                            Ia(h + 52 | 0, e - d | 0, h);
                        } i = 0; f: {
                            if (F[a + 8 >> 2] <= 0) {
                                break f;
                            }
                            j = F[a + 32 >> 2];
                            g = F[h + 16 >> 2];
                            while (1) {
                                d = i << 2;
                                f = F[d + g >> 2];
                                m = F[a + 16 >> 2];
                                g: {
                                    if ((f | 0) > (m | 0)) {
                                        F[d + j >> 2] = m;
                                        break g;
                                    }
                                    d = d + j | 0;
                                    m = F[a + 12 >> 2];
                                    if ((m | 0) > (f | 0)) {
                                        F[d >> 2] = m;
                                        break g;
                                    }
                                    F[d >> 2] = f;
                                }
                                i = i + 1 | 0;
                                d = F[a + 8 >> 2];
                                if ((i | 0) < (d | 0)) {
                                    continue;
                                }
                                break;
                            }
                            if ((d | 0) <= 0) {
                                break f;
                            }
                            d = 0;
                            while (1) {
                                g = d << 2;
                                f = g + c | 0;
                                g = F[b + g >> 2] + F[g + j >> 2] | 0;
                                F[f >> 2] = g;
                                h: {
                                    if ((g | 0) > F[a + 16 >> 2]) {
                                        g = g - F[a + 20 >> 2] | 0;
                                    }
                                    else {
                                        if ((g | 0) >= F[a + 12 >> 2]) {
                                            break h;
                                        }
                                        g = g + F[a + 20 >> 2] | 0;
                                    }
                                    F[f >> 2] = g;
                                }
                                d = d + 1 | 0;
                                if ((d | 0) < F[a + 8 >> 2]) {
                                    continue;
                                }
                                break;
                            }
                        } D = F[a + 52 >> 2]; q = F[a + 48 >> 2]; w = sa(16); d = w; F[d >> 2] = 0; F[d + 4 >> 2] = 0; F[d + 8 >> 2] = 0; F[d + 12 >> 2] = 0; F[h + 8 >> 2] = 0; F[h >> 2] = 0; F[h + 4 >> 2] = 0; i: {
                            if (e) {
                                if (e >>> 0 >= 1073741824) {
                                    break i;
                                }
                                d = e << 2;
                                v = sa(d);
                                F[h >> 2] = v;
                                F[h + 8 >> 2] = d + v;
                                ua(v, 0, d);
                            }
                            p = 1;
                            d = F[a + 56 >> 2];
                            z = F[d >> 2];
                            d = F[d + 4 >> 2] - z | 0;
                            j: {
                                if ((d | 0) < 5) {
                                    break j;
                                }
                                d = d >> 2;
                                E = (d | 0) > 2 ? d : 2;
                                G = d >>> 0 > 1 ? d : 1;
                                A = e & -2;
                                B = e & 1;
                                H = e & -4;
                                C = e & 3;
                                x = e - 1 | 0;
                                I = e << 2;
                                m = 1;
                                while (1) {
                                    k: {
                                        l: {
                                            m: {
                                                n: {
                                                    if ((m | 0) != (G | 0)) {
                                                        f = F[(m << 2) + z >> 2];
                                                        d = (f >>> 0) % 3 | 0;
                                                        o: {
                                                            p: {
                                                                if ((f | 0) == -1) {
                                                                    break p;
                                                                }
                                                                j = 0;
                                                                g = f + 2 | 0;
                                                                y = (d | 0) != 0 | (g | 0) != -1;
                                                                n = 1;
                                                                r = d ? f - 1 | 0 : g;
                                                                o = 1 << r;
                                                                s = r >>> 5 | 0;
                                                                J = F[q >> 2];
                                                                d = f;
                                                                q: {
                                                                    while (1) {
                                                                        r: {
                                                                            if (F[(d >>> 3 & 536870908) + J >> 2] >>> d & 1) {
                                                                                break r;
                                                                            }
                                                                            g = F[F[F[q + 64 >> 2] + 12 >> 2] + (d << 2) >> 2];
                                                                            if ((g | 0) == -1) {
                                                                                break r;
                                                                            }
                                                                            k = F[D >> 2];
                                                                            i = F[q + 28 >> 2];
                                                                            p = F[k + (F[i + (g << 2) >> 2] << 2) >> 2];
                                                                            if ((p | 0) >= (m | 0)) {
                                                                                break r;
                                                                            }
                                                                            l = g + 1 | 0;
                                                                            l = F[k + (F[i + (((l >>> 0) % 3 | 0 ? l : g - 2 | 0) << 2) >> 2] << 2) >> 2];
                                                                            if ((l | 0) >= (m | 0)) {
                                                                                break r;
                                                                            }
                                                                            i = F[k + (F[i + (g + ((g >>> 0) % 3 | 0 ? -1 : 2) << 2) >> 2] << 2) >> 2];
                                                                            if ((i | 0) >= (m | 0)) {
                                                                                break r;
                                                                            }
                                                                            s: {
                                                                                if (!e) {
                                                                                    break s;
                                                                                }
                                                                                g = F[(h + 16 | 0) + L(j, 12) >> 2];
                                                                                k = L(e, i);
                                                                                l = L(e, l);
                                                                                p = L(e, p);
                                                                                i = 0;
                                                                                u = 0;
                                                                                if (x) {
                                                                                    while (1) {
                                                                                        F[g + (i << 2) >> 2] = (F[(i + k << 2) + c >> 2] + F[(i + l << 2) + c >> 2] | 0) - F[(i + p << 2) + c >> 2];
                                                                                        t = i | 1;
                                                                                        F[g + (t << 2) >> 2] = (F[(k + t << 2) + c >> 2] + F[(l + t << 2) + c >> 2] | 0) - F[(p + t << 2) + c >> 2];
                                                                                        i = i + 2 | 0;
                                                                                        u = u + 2 | 0;
                                                                                        if ((A | 0) != (u | 0)) {
                                                                                            continue;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                }
                                                                                if (!B) {
                                                                                    break s;
                                                                                }
                                                                                F[g + (i << 2) >> 2] = (F[(i + k << 2) + c >> 2] + F[(i + l << 2) + c >> 2] | 0) - F[(i + p << 2) + c >> 2];
                                                                            }
                                                                            g = 4;
                                                                            j = j + 1 | 0;
                                                                            if ((j | 0) == 4) {
                                                                                break q;
                                                                            }
                                                                        }
                                                                        t: {
                                                                            if (n & 1) {
                                                                                i = d - 2 | 0;
                                                                                g = d + 1 | 0;
                                                                                d = -1;
                                                                                g = (g >>> 0) % 3 | 0 ? g : i;
                                                                                if ((g | 0) == -1 | F[F[q >> 2] + (g >>> 3 & 536870908) >> 2] >>> g & 1) {
                                                                                    break t;
                                                                                }
                                                                                g = F[F[F[q + 64 >> 2] + 12 >> 2] + (g << 2) >> 2];
                                                                                if ((g | 0) == -1) {
                                                                                    break t;
                                                                                }
                                                                                d = g + 1 | 0;
                                                                                d = (d >>> 0) % 3 | 0 ? d : g - 2 | 0;
                                                                                break t;
                                                                            }
                                                                            u: {
                                                                                if ((d >>> 0) % 3 | 0) {
                                                                                    i = d - 1 | 0;
                                                                                    break u;
                                                                                }
                                                                                i = d + 2 | 0;
                                                                                d = -1;
                                                                                if ((i | 0) == -1) {
                                                                                    break t;
                                                                                }
                                                                            }
                                                                            d = -1;
                                                                            if (F[F[q >> 2] + (i >>> 3 & 536870908) >> 2] >>> i & 1) {
                                                                                break t;
                                                                            }
                                                                            g = F[F[F[q + 64 >> 2] + 12 >> 2] + (i << 2) >> 2];
                                                                            if ((g | 0) == -1) {
                                                                                break t;
                                                                            }
                                                                            if ((g >>> 0) % 3 | 0) {
                                                                                d = g - 1 | 0;
                                                                                break t;
                                                                            }
                                                                            d = g + 2 | 0;
                                                                        }
                                                                        v: {
                                                                            if ((d | 0) == (f | 0)) {
                                                                                break v;
                                                                            }
                                                                            if (!((n ^ 1) & 1 | (d | 0) != -1)) {
                                                                                if (!y | o & F[F[q >> 2] + (s << 2) >> 2]) {
                                                                                    break v;
                                                                                }
                                                                                d = F[F[F[q + 64 >> 2] + 12 >> 2] + (r << 2) >> 2];
                                                                                if ((d | 0) == -1) {
                                                                                    break v;
                                                                                }
                                                                                n = 0;
                                                                                d = (d >>> 0) % 3 | 0 ? d - 1 | 0 : d + 2 | 0;
                                                                            }
                                                                            if ((d | 0) != -1) {
                                                                                continue;
                                                                            }
                                                                        }
                                                                        break;
                                                                    }
                                                                    g = j;
                                                                    if ((g | 0) <= 0) {
                                                                        break p;
                                                                    }
                                                                }
                                                                if (e) {
                                                                    ua(F[h >> 2], 0, I);
                                                                }
                                                                d = g - 1 | 0;
                                                                t = (d << 2) + w | 0;
                                                                d = L(d, 12) + a | 0;
                                                                u = d;
                                                                y = F[d - -64 >> 2];
                                                                p = 0;
                                                                n = 0;
                                                                d = 0;
                                                                while (1) {
                                                                    f = F[t >> 2];
                                                                    F[t >> 2] = f + 1;
                                                                    if (f >>> 0 >= y >>> 0) {
                                                                        break j;
                                                                    }
                                                                    w: {
                                                                        if (F[F[u + 60 >> 2] + (f >>> 3 & 536870908) >> 2] >>> f & 1) {
                                                                            break w;
                                                                        }
                                                                        d = d + 1 | 0;
                                                                        if (!e) {
                                                                            break w;
                                                                        }
                                                                        j = F[h >> 2];
                                                                        k = F[(h + 16 | 0) + L(n, 12) >> 2];
                                                                        r = 0;
                                                                        i = 0;
                                                                        f = 0;
                                                                        if (x >>> 0 >= 3) {
                                                                            while (1) {
                                                                                l = i << 2;
                                                                                o = l + j | 0;
                                                                                F[o >> 2] = F[o >> 2] + F[k + l >> 2];
                                                                                o = l | 4;
                                                                                s = o + j | 0;
                                                                                F[s >> 2] = F[s >> 2] + F[k + o >> 2];
                                                                                o = l | 8;
                                                                                s = o + j | 0;
                                                                                F[s >> 2] = F[s >> 2] + F[k + o >> 2];
                                                                                l = l | 12;
                                                                                o = l + j | 0;
                                                                                F[o >> 2] = F[o >> 2] + F[k + l >> 2];
                                                                                i = i + 4 | 0;
                                                                                f = f + 4 | 0;
                                                                                if ((H | 0) != (f | 0)) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                        }
                                                                        if (!C) {
                                                                            break w;
                                                                        }
                                                                        while (1) {
                                                                            f = i << 2;
                                                                            l = f + j | 0;
                                                                            F[l >> 2] = F[l >> 2] + F[f + k >> 2];
                                                                            i = i + 1 | 0;
                                                                            r = r + 1 | 0;
                                                                            if ((C | 0) != (r | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    n = n + 1 | 0;
                                                                    if ((n | 0) != (g | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                n = L(e, m);
                                                                f = n;
                                                                if (!d) {
                                                                    break o;
                                                                }
                                                                if (!e) {
                                                                    break l;
                                                                }
                                                                f = F[h >> 2];
                                                                i = 0;
                                                                g = 0;
                                                                if (x) {
                                                                    break n;
                                                                }
                                                                break m;
                                                            }
                                                            f = L(e, m);
                                                        }
                                                        if (F[a + 8 >> 2] <= 0) {
                                                            break k;
                                                        }
                                                        n = (L(m - 1 | 0, e) << 2) + c | 0;
                                                        j = F[a + 32 >> 2];
                                                        i = 0;
                                                        while (1) {
                                                            d = i << 2;
                                                            g = F[d + n >> 2];
                                                            k = F[a + 16 >> 2];
                                                            x: {
                                                                if ((g | 0) > (k | 0)) {
                                                                    F[d + j >> 2] = k;
                                                                    break x;
                                                                }
                                                                d = d + j | 0;
                                                                k = F[a + 12 >> 2];
                                                                if ((k | 0) > (g | 0)) {
                                                                    F[d >> 2] = k;
                                                                    break x;
                                                                }
                                                                F[d >> 2] = g;
                                                            }
                                                            i = i + 1 | 0;
                                                            g = F[a + 8 >> 2];
                                                            if ((i | 0) < (g | 0)) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        d = 0;
                                                        if ((g | 0) <= 0) {
                                                            break k;
                                                        }
                                                        f = f << 2;
                                                        i = f + c | 0;
                                                        n = b + f | 0;
                                                        while (1) {
                                                            g = d << 2;
                                                            f = g + i | 0;
                                                            g = F[g + n >> 2] + F[g + j >> 2] | 0;
                                                            F[f >> 2] = g;
                                                            y: {
                                                                if ((g | 0) > F[a + 16 >> 2]) {
                                                                    g = g - F[a + 20 >> 2] | 0;
                                                                }
                                                                else {
                                                                    if ((g | 0) >= F[a + 12 >> 2]) {
                                                                        break y;
                                                                    }
                                                                    g = g + F[a + 20 >> 2] | 0;
                                                                }
                                                                F[f >> 2] = g;
                                                            }
                                                            d = d + 1 | 0;
                                                            if ((d | 0) < F[a + 8 >> 2]) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        break k;
                                                    }
                                                    Da();
                                                    V();
                                                }
                                                while (1) {
                                                    j = i << 2;
                                                    k = j + f | 0;
                                                    F[k >> 2] = F[k >> 2] / (d | 0);
                                                    j = f + (j | 4) | 0;
                                                    F[j >> 2] = F[j >> 2] / (d | 0);
                                                    i = i + 2 | 0;
                                                    g = g + 2 | 0;
                                                    if ((A | 0) != (g | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            if (!B) {
                                                break l;
                                            }
                                            f = f + (i << 2) | 0;
                                            F[f >> 2] = F[f >> 2] / (d | 0);
                                        }
                                        if (F[a + 8 >> 2] <= 0) {
                                            break k;
                                        }
                                        j = F[a + 32 >> 2];
                                        i = 0;
                                        while (1) {
                                            d = i << 2;
                                            f = F[d + v >> 2];
                                            g = F[a + 16 >> 2];
                                            z: {
                                                if ((f | 0) > (g | 0)) {
                                                    F[d + j >> 2] = g;
                                                    break z;
                                                }
                                                d = d + j | 0;
                                                g = F[a + 12 >> 2];
                                                if ((g | 0) > (f | 0)) {
                                                    F[d >> 2] = g;
                                                    break z;
                                                }
                                                F[d >> 2] = f;
                                            }
                                            i = i + 1 | 0;
                                            f = F[a + 8 >> 2];
                                            if ((i | 0) < (f | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                        d = 0;
                                        if ((f | 0) <= 0) {
                                            break k;
                                        }
                                        f = n << 2;
                                        i = f + c | 0;
                                        n = b + f | 0;
                                        while (1) {
                                            g = d << 2;
                                            f = g + i | 0;
                                            g = F[g + n >> 2] + F[g + j >> 2] | 0;
                                            F[f >> 2] = g;
                                            A: {
                                                if ((g | 0) > F[a + 16 >> 2]) {
                                                    g = g - F[a + 20 >> 2] | 0;
                                                }
                                                else {
                                                    if ((g | 0) >= F[a + 12 >> 2]) {
                                                        break A;
                                                    }
                                                    g = g + F[a + 20 >> 2] | 0;
                                                }
                                                F[f >> 2] = g;
                                            }
                                            d = d + 1 | 0;
                                            if ((d | 0) < F[a + 8 >> 2]) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    p = 1;
                                    m = m + 1 | 0;
                                    if ((E | 0) != (m | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            a = F[h >> 2];
                            if (a) {
                                ra(a);
                            }
                            ra(w);
                            a = F[h + 52 >> 2];
                            if (a) {
                                F[h + 56 >> 2] = a;
                                ra(a);
                            }
                            a = F[h + 40 >> 2];
                            if (a) {
                                F[h + 44 >> 2] = a;
                                ra(a);
                            }
                            a = F[h + 28 >> 2];
                            if (a) {
                                F[h + 32 >> 2] = a;
                                ra(a);
                            }
                            a = F[h + 16 >> 2];
                            if (a) {
                                F[h + 20 >> 2] = a;
                                ra(a);
                            }
                            ea = h - -64 | 0;
                            return p | 0;
                        } va(); V(); }
                        function Ya(a, b, c, d) { var e = 0, f = 0, g = 0, h = 0, i = 0; a: {
                            b: {
                                if (!d) {
                                    break b;
                                }
                                c: {
                                    d: {
                                        switch (F[a + 28 >> 2] - 1 | 0) {
                                            case 0:
                                                i = 1;
                                                e: {
                                                    e = D[a + 24 | 0];
                                                    if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                        break e;
                                                    }
                                                    e = F[a >> 2];
                                                    h = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    f = b;
                                                    b = h + b | 0;
                                                    g = F[e + 4 >> 2];
                                                    e = g - h | 0;
                                                    if (!G[a + 32 | 0]) {
                                                        if ((e | 0) <= (f | 0)) {
                                                            break a;
                                                        }
                                                        f = 0;
                                                        while (1) {
                                                            J[(f << 2) + d >> 2] = D[b | 0];
                                                            f = f + 1 | 0;
                                                            e = D[a + 24 | 0];
                                                            if ((f | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                                break e;
                                                            }
                                                            b = b + 1 | 0;
                                                            if (g >>> 0 > b >>> 0) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        break a;
                                                    }
                                                    if ((e | 0) <= (f | 0)) {
                                                        break a;
                                                    }
                                                    f = 0;
                                                    while (1) {
                                                        J[(f << 2) + d >> 2] = M(D[b | 0]) / M(127);
                                                        f = f + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((f | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            break e;
                                                        }
                                                        b = b + 1 | 0;
                                                        if (g >>> 0 > b >>> 0) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    break a;
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 1:
                                                i = 1;
                                                f: {
                                                    e = D[a + 24 | 0];
                                                    if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                        break f;
                                                    }
                                                    e = F[a >> 2];
                                                    h = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    f = b;
                                                    b = h + b | 0;
                                                    g = F[e + 4 >> 2];
                                                    e = g - h | 0;
                                                    if (!G[a + 32 | 0]) {
                                                        if ((e | 0) <= (f | 0)) {
                                                            break a;
                                                        }
                                                        f = 0;
                                                        while (1) {
                                                            J[(f << 2) + d >> 2] = G[b | 0];
                                                            f = f + 1 | 0;
                                                            e = D[a + 24 | 0];
                                                            if ((f | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                                break f;
                                                            }
                                                            b = b + 1 | 0;
                                                            if (g >>> 0 > b >>> 0) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        break a;
                                                    }
                                                    if ((e | 0) <= (f | 0)) {
                                                        break a;
                                                    }
                                                    f = 0;
                                                    while (1) {
                                                        J[(f << 2) + d >> 2] = M(G[b | 0]) / M(255);
                                                        f = f + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((f | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            break f;
                                                        }
                                                        b = b + 1 | 0;
                                                        if (g >>> 0 > b >>> 0) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    break a;
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 2:
                                                i = 1;
                                                g: {
                                                    e = D[a + 24 | 0];
                                                    if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                        break g;
                                                    }
                                                    e = F[a >> 2];
                                                    h = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    f = b;
                                                    b = h + b | 0;
                                                    g = F[e + 4 >> 2];
                                                    e = g - h | 0;
                                                    if (!G[a + 32 | 0]) {
                                                        if ((e | 0) <= (f | 0)) {
                                                            break a;
                                                        }
                                                        f = 0;
                                                        while (1) {
                                                            J[(f << 2) + d >> 2] = E[b >> 1];
                                                            f = f + 1 | 0;
                                                            e = D[a + 24 | 0];
                                                            if ((f | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                                break g;
                                                            }
                                                            b = b + 2 | 0;
                                                            if (g >>> 0 > b >>> 0) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        break a;
                                                    }
                                                    if ((e | 0) <= (f | 0)) {
                                                        break a;
                                                    }
                                                    f = 0;
                                                    while (1) {
                                                        J[(f << 2) + d >> 2] = M(E[b >> 1]) / M(32767);
                                                        f = f + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((f | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            break g;
                                                        }
                                                        b = b + 2 | 0;
                                                        if (g >>> 0 > b >>> 0) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    break a;
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 3:
                                                i = 1;
                                                h: {
                                                    e = D[a + 24 | 0];
                                                    if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                        break h;
                                                    }
                                                    e = F[a >> 2];
                                                    h = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    f = b;
                                                    b = h + b | 0;
                                                    g = F[e + 4 >> 2];
                                                    e = g - h | 0;
                                                    if (!G[a + 32 | 0]) {
                                                        if ((e | 0) <= (f | 0)) {
                                                            break a;
                                                        }
                                                        f = 0;
                                                        while (1) {
                                                            J[(f << 2) + d >> 2] = H[b >> 1];
                                                            f = f + 1 | 0;
                                                            e = D[a + 24 | 0];
                                                            if ((f | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                                break h;
                                                            }
                                                            b = b + 2 | 0;
                                                            if (g >>> 0 > b >>> 0) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        break a;
                                                    }
                                                    if ((e | 0) <= (f | 0)) {
                                                        break a;
                                                    }
                                                    f = 0;
                                                    while (1) {
                                                        J[(f << 2) + d >> 2] = M(H[b >> 1]) / M(65535);
                                                        f = f + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((f | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            break h;
                                                        }
                                                        b = b + 2 | 0;
                                                        if (g >>> 0 > b >>> 0) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    break a;
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 4:
                                                i = 1;
                                                i: {
                                                    e = D[a + 24 | 0];
                                                    if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                        break i;
                                                    }
                                                    e = F[a >> 2];
                                                    h = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    f = b;
                                                    b = h + b | 0;
                                                    g = F[e + 4 >> 2];
                                                    e = g - h | 0;
                                                    if (!G[a + 32 | 0]) {
                                                        if ((e | 0) <= (f | 0)) {
                                                            break a;
                                                        }
                                                        f = 0;
                                                        while (1) {
                                                            J[(f << 2) + d >> 2] = F[b >> 2];
                                                            f = f + 1 | 0;
                                                            e = D[a + 24 | 0];
                                                            if ((f | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                                break i;
                                                            }
                                                            b = b + 4 | 0;
                                                            if (g >>> 0 > b >>> 0) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        break a;
                                                    }
                                                    if ((e | 0) <= (f | 0)) {
                                                        break a;
                                                    }
                                                    f = 0;
                                                    while (1) {
                                                        J[(f << 2) + d >> 2] = M(F[b >> 2]) * M(4.656612873077393e-10);
                                                        f = f + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((f | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            break i;
                                                        }
                                                        b = b + 4 | 0;
                                                        if (g >>> 0 > b >>> 0) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    break a;
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 5:
                                                i = 1;
                                                j: {
                                                    e = D[a + 24 | 0];
                                                    if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                        break j;
                                                    }
                                                    e = F[a >> 2];
                                                    h = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    f = b;
                                                    b = h + b | 0;
                                                    g = F[e + 4 >> 2];
                                                    e = g - h | 0;
                                                    if (!G[a + 32 | 0]) {
                                                        if ((e | 0) <= (f | 0)) {
                                                            break a;
                                                        }
                                                        f = 0;
                                                        while (1) {
                                                            J[(f << 2) + d >> 2] = I[b >> 2];
                                                            f = f + 1 | 0;
                                                            e = D[a + 24 | 0];
                                                            if ((f | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                                break j;
                                                            }
                                                            b = b + 4 | 0;
                                                            if (g >>> 0 > b >>> 0) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        break a;
                                                    }
                                                    if ((e | 0) <= (f | 0)) {
                                                        break a;
                                                    }
                                                    f = 0;
                                                    while (1) {
                                                        J[(f << 2) + d >> 2] = M(I[b >> 2]) * M(2.3283064365386963e-10);
                                                        f = f + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((f | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            break j;
                                                        }
                                                        b = b + 4 | 0;
                                                        if (g >>> 0 > b >>> 0) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    break a;
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 6:
                                                i = 1;
                                                k: {
                                                    e = D[a + 24 | 0];
                                                    if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                        break k;
                                                    }
                                                    e = F[a >> 2];
                                                    h = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    f = b;
                                                    b = h + b | 0;
                                                    g = F[e + 4 >> 2];
                                                    e = g - h | 0;
                                                    if (!G[a + 32 | 0]) {
                                                        if ((e | 0) <= (f | 0)) {
                                                            break a;
                                                        }
                                                        f = 0;
                                                        while (1) {
                                                            J[(f << 2) + d >> 2] = +I[b >> 2] + +F[b + 4 >> 2] * 4294967296;
                                                            f = f + 1 | 0;
                                                            e = D[a + 24 | 0];
                                                            if ((f | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                                break k;
                                                            }
                                                            b = b + 8 | 0;
                                                            if (g >>> 0 > b >>> 0) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        break a;
                                                    }
                                                    if ((e | 0) <= (f | 0)) {
                                                        break a;
                                                    }
                                                    f = 0;
                                                    while (1) {
                                                        J[(f << 2) + d >> 2] = M(+I[b >> 2] + +F[b + 4 >> 2] * 4294967296) * M(1.0842021724855044e-19);
                                                        f = f + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((f | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            break k;
                                                        }
                                                        b = b + 8 | 0;
                                                        if (g >>> 0 > b >>> 0) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    break a;
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 7:
                                                i = 1;
                                                l: {
                                                    e = D[a + 24 | 0];
                                                    if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                        break l;
                                                    }
                                                    e = F[a >> 2];
                                                    h = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    f = b;
                                                    b = h + b | 0;
                                                    g = F[e + 4 >> 2];
                                                    e = g - h | 0;
                                                    if (!G[a + 32 | 0]) {
                                                        if ((e | 0) <= (f | 0)) {
                                                            break a;
                                                        }
                                                        f = 0;
                                                        while (1) {
                                                            J[(f << 2) + d >> 2] = +I[b >> 2] + +I[b + 4 >> 2] * 4294967296;
                                                            f = f + 1 | 0;
                                                            e = D[a + 24 | 0];
                                                            if ((f | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                                break l;
                                                            }
                                                            b = b + 8 | 0;
                                                            if (g >>> 0 > b >>> 0) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        break a;
                                                    }
                                                    if ((e | 0) <= (f | 0)) {
                                                        break a;
                                                    }
                                                    f = 0;
                                                    while (1) {
                                                        J[(f << 2) + d >> 2] = M(+I[b >> 2] + +I[b + 4 >> 2] * 4294967296) * M(5.421010862427522e-20);
                                                        f = f + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((f | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            break l;
                                                        }
                                                        b = b + 8 | 0;
                                                        if (g >>> 0 > b >>> 0) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    break a;
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 8:
                                                i = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    g = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = g + b | 0;
                                                    g = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= g >>> 0) {
                                                            break a;
                                                        }
                                                        J[(f << 2) + d >> 2] = J[b >> 2];
                                                        b = b + 4 | 0;
                                                        f = f + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((f | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 9:
                                                i = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    g = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = g + b | 0;
                                                    g = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= g >>> 0) {
                                                            break a;
                                                        }
                                                        J[(f << 2) + d >> 2] = K[b >> 3];
                                                        b = b + 8 | 0;
                                                        f = f + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((f | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 10: break d;
                                            default: break b;
                                        }
                                    }
                                    i = 1;
                                    e = D[a + 24 | 0];
                                    if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                        g = F[a >> 2];
                                        e = F[g >> 2];
                                        b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                        b = e + b | 0;
                                        while (1) {
                                            if (I[g + 4 >> 2] <= b >>> 0) {
                                                break a;
                                            }
                                            J[(f << 2) + d >> 2] = G[b | 0] ? M(1) : M(0);
                                            b = b + 1 | 0;
                                            f = f + 1 | 0;
                                            e = D[a + 24 | 0];
                                            if ((f | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    if ((c | 0) <= (e | 0)) {
                                        break b;
                                    }
                                }
                                ua((e << 2) + d | 0, 0, c - e << 2);
                            }
                            return i;
                        } return 0; }
                        function kg(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0; m = ea - 16 | 0; ea = m; F[m + 12 >> 2] = b; b = sa(32); F[m >> 2] = b; F[m + 4 >> 2] = 24; F[m + 8 >> 2] = -2147483616; D[b + 24 | 0] = 0; c = G[1318] | G[1319] << 8 | (G[1320] << 16 | G[1321] << 24); d = G[1314] | G[1315] << 8 | (G[1316] << 16 | G[1317] << 24); D[b + 16 | 0] = d; D[b + 17 | 0] = d >>> 8; D[b + 18 | 0] = d >>> 16; D[b + 19 | 0] = d >>> 24; D[b + 20 | 0] = c; D[b + 21 | 0] = c >>> 8; D[b + 22 | 0] = c >>> 16; D[b + 23 | 0] = c >>> 24; c = G[1310] | G[1311] << 8 | (G[1312] << 16 | G[1313] << 24); d = G[1306] | G[1307] << 8 | (G[1308] << 16 | G[1309] << 24); D[b + 8 | 0] = d; D[b + 9 | 0] = d >>> 8; D[b + 10 | 0] = d >>> 16; D[b + 11 | 0] = d >>> 24; D[b + 12 | 0] = c; D[b + 13 | 0] = c >>> 8; D[b + 14 | 0] = c >>> 16; D[b + 15 | 0] = c >>> 24; c = G[1302] | G[1303] << 8 | (G[1304] << 16 | G[1305] << 24); d = G[1298] | G[1299] << 8 | (G[1300] << 16 | G[1301] << 24); D[b | 0] = d; D[b + 1 | 0] = d >>> 8; D[b + 2 | 0] = d >>> 16; D[b + 3 | 0] = d >>> 24; D[b + 4 | 0] = c; D[b + 5 | 0] = c >>> 8; D[b + 6 | 0] = c >>> 16; D[b + 7 | 0] = c >>> 24; h = ea - 48 | 0; ea = h; k = a; c = a + 16 | 0; a = F[c >> 2]; a: {
                            b: {
                                if (!a) {
                                    break b;
                                }
                                d = F[m + 12 >> 2];
                                b = c;
                                while (1) {
                                    f = (d | 0) > F[a + 16 >> 2];
                                    b = f ? b : a;
                                    a = F[(f << 2) + a >> 2];
                                    if (a) {
                                        continue;
                                    }
                                    break;
                                }
                                if ((b | 0) == (c | 0)) {
                                    break b;
                                }
                                if ((d | 0) >= F[b + 16 >> 2]) {
                                    break a;
                                }
                            }
                            t = h + 24 | 0;
                            a = t;
                            F[a + 4 >> 2] = 0;
                            F[a + 8 >> 2] = 0;
                            u = a + 4 | 0;
                            F[a >> 2] = u;
                            a = F[m + 12 >> 2];
                            d = h + 16 | 0;
                            F[d >> 2] = 0;
                            F[d + 4 >> 2] = 0;
                            F[h + 8 >> 2] = a;
                            F[h + 12 >> 2] = d;
                            b = F[t >> 2];
                            if ((u | 0) != (b | 0)) {
                                l = h + 8 | 4;
                                while (1) {
                                    f = b;
                                    g = b + 16 | 0;
                                    q = ea - 16 | 0;
                                    ea = q;
                                    i = q + 12 | 0;
                                    a = q + 8 | 0;
                                    c: {
                                        d: {
                                            e: {
                                                f: {
                                                    g: {
                                                        h: {
                                                            r = l + 4 | 0;
                                                            i: {
                                                                if ((r | 0) == (d | 0)) {
                                                                    break i;
                                                                }
                                                                b = G[d + 27 | 0];
                                                                e = b << 24 >> 24 < 0;
                                                                n = G[g + 11 | 0];
                                                                v = n << 24 >> 24;
                                                                j = (v | 0) < 0;
                                                                b = e ? F[d + 20 >> 2] : b;
                                                                n = j ? F[g + 4 >> 2] : n;
                                                                o = b >>> 0 < n >>> 0;
                                                                p = o ? b : n;
                                                                if (p) {
                                                                    j = j ? F[g >> 2] : g;
                                                                    s = d + 16 | 0;
                                                                    e = e ? F[s >> 2] : s;
                                                                    s = Ha(j, e, p);
                                                                    if (!s) {
                                                                        if (b >>> 0 > n >>> 0) {
                                                                            break i;
                                                                        }
                                                                        break h;
                                                                    }
                                                                    if ((s | 0) >= 0) {
                                                                        break h;
                                                                    }
                                                                    break i;
                                                                }
                                                                if (b >>> 0 <= n >>> 0) {
                                                                    break g;
                                                                }
                                                            }
                                                            e = F[d >> 2];
                                                            j: {
                                                                a = d;
                                                                k: {
                                                                    if ((a | 0) == F[l >> 2]) {
                                                                        break k;
                                                                    }
                                                                    l: {
                                                                        if (e) {
                                                                            b = e;
                                                                            while (1) {
                                                                                a = b;
                                                                                b = F[b + 4 >> 2];
                                                                                if (b) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                            break l;
                                                                        }
                                                                        a = d + 8 | 0;
                                                                        if ((d | 0) == F[F[d + 8 >> 2] >> 2]) {
                                                                            while (1) {
                                                                                b = F[a >> 2];
                                                                                a = b + 8 | 0;
                                                                                if ((b | 0) == F[F[b + 8 >> 2] >> 2]) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                        }
                                                                        a = F[a >> 2];
                                                                    }
                                                                    j = G[g + 11 | 0];
                                                                    b = j << 24 >> 24 < 0;
                                                                    o = G[a + 27 | 0];
                                                                    n = o << 24 >> 24 < 0;
                                                                    m: {
                                                                        j = b ? F[g + 4 >> 2] : j;
                                                                        o = n ? F[a + 20 >> 2] : o;
                                                                        p = j >>> 0 < o >>> 0 ? j : o;
                                                                        if (p) {
                                                                            r = a + 16 | 0;
                                                                            b = Ha(n ? F[r >> 2] : r, b ? F[g >> 2] : g, p);
                                                                            if (b) {
                                                                                break m;
                                                                            }
                                                                        }
                                                                        if (j >>> 0 > o >>> 0) {
                                                                            break k;
                                                                        }
                                                                        break j;
                                                                    }
                                                                    if ((b | 0) >= 0) {
                                                                        break j;
                                                                    }
                                                                }
                                                                if (!e) {
                                                                    F[i >> 2] = d;
                                                                    a = d;
                                                                    break c;
                                                                }
                                                                F[i >> 2] = a;
                                                                a = a + 4 | 0;
                                                                break c;
                                                            }
                                                            a = Ke(l, i, g);
                                                            break c;
                                                        }
                                                        b = Ha(e, j, p);
                                                        if (b) {
                                                            break f;
                                                        }
                                                    }
                                                    if (o) {
                                                        break e;
                                                    }
                                                    break d;
                                                }
                                                if ((b | 0) >= 0) {
                                                    break d;
                                                }
                                            }
                                            e = F[d + 4 >> 2];
                                            n: {
                                                if (e) {
                                                    b = e;
                                                    while (1) {
                                                        a = b;
                                                        b = F[b >> 2];
                                                        if (b) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    break n;
                                                }
                                                a = F[d + 8 >> 2];
                                                if ((d | 0) == F[a >> 2]) {
                                                    break n;
                                                }
                                                b = d + 8 | 0;
                                                while (1) {
                                                    j = F[b >> 2];
                                                    b = j + 8 | 0;
                                                    a = F[j + 8 >> 2];
                                                    if ((j | 0) != F[a >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            o: {
                                                p: {
                                                    if ((a | 0) == (r | 0)) {
                                                        break p;
                                                    }
                                                    j = G[a + 27 | 0];
                                                    b = j << 24 >> 24 < 0;
                                                    q: {
                                                        j = b ? F[a + 20 >> 2] : j;
                                                        o = j >>> 0 < n >>> 0 ? j : n;
                                                        if (o) {
                                                            p = a + 16 | 0;
                                                            b = Ha((v | 0) < 0 ? F[g >> 2] : g, b ? F[p >> 2] : p, o);
                                                            if (b) {
                                                                break q;
                                                            }
                                                        }
                                                        if (j >>> 0 > n >>> 0) {
                                                            break p;
                                                        }
                                                        break o;
                                                    }
                                                    if ((b | 0) >= 0) {
                                                        break o;
                                                    }
                                                }
                                                if (!e) {
                                                    F[i >> 2] = d;
                                                    a = d + 4 | 0;
                                                    break c;
                                                }
                                                F[i >> 2] = a;
                                                break c;
                                            }
                                            a = Ke(l, i, g);
                                            break c;
                                        }
                                        F[i >> 2] = d;
                                        F[a >> 2] = d;
                                    }
                                    b = a;
                                    a = F[b >> 2];
                                    if (a) {
                                        b = 0;
                                    }
                                    else {
                                        a = sa(40);
                                        e = a + 16 | 0;
                                        r: {
                                            if (D[g + 11 | 0] >= 0) {
                                                i = F[g + 4 >> 2];
                                                F[e >> 2] = F[g >> 2];
                                                F[e + 4 >> 2] = i;
                                                F[e + 8 >> 2] = F[g + 8 >> 2];
                                                break r;
                                            }
                                            Ba(e, F[g >> 2], F[g + 4 >> 2]);
                                        }
                                        e = a + 28 | 0;
                                        s: {
                                            if (D[g + 23 | 0] >= 0) {
                                                i = F[g + 16 >> 2];
                                                F[e >> 2] = F[g + 12 >> 2];
                                                F[e + 4 >> 2] = i;
                                                F[e + 8 >> 2] = F[g + 20 >> 2];
                                                break s;
                                            }
                                            Ba(e, F[g + 12 >> 2], F[g + 16 >> 2]);
                                        }
                                        F[a + 8 >> 2] = F[q + 12 >> 2];
                                        F[a >> 2] = 0;
                                        F[a + 4 >> 2] = 0;
                                        F[b >> 2] = a;
                                        e = F[F[l >> 2] >> 2];
                                        if (e) {
                                            F[l >> 2] = e;
                                            b = F[b >> 2];
                                        }
                                        else {
                                            b = a;
                                        }
                                        Tb(F[l + 4 >> 2], b);
                                        F[l + 8 >> 2] = F[l + 8 >> 2] + 1;
                                        b = 1;
                                    }
                                    D[h + 44 | 0] = b;
                                    F[h + 40 >> 2] = a;
                                    ea = q + 16 | 0;
                                    a = F[f + 4 >> 2];
                                    t: {
                                        if (!a) {
                                            b = F[f + 8 >> 2];
                                            if ((f | 0) == F[b >> 2]) {
                                                break t;
                                            }
                                            a = f + 8 | 0;
                                            while (1) {
                                                f = F[a >> 2];
                                                a = f + 8 | 0;
                                                b = F[f + 8 >> 2];
                                                if ((f | 0) != F[b >> 2]) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            break t;
                                        }
                                        while (1) {
                                            b = a;
                                            a = F[b >> 2];
                                            if (a) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    if ((b | 0) != (u | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            a = F[c >> 2];
                            u: {
                                if (a) {
                                    c = k + 16 | 0;
                                    f = F[h + 8 >> 2];
                                    while (1) {
                                        b = F[a + 16 >> 2];
                                        v: {
                                            if ((b | 0) > (f | 0)) {
                                                b = F[a >> 2];
                                                if (b) {
                                                    break v;
                                                }
                                                c = a;
                                                break u;
                                            }
                                            if ((b | 0) >= (f | 0)) {
                                                break u;
                                            }
                                            c = a + 4 | 0;
                                            b = F[a + 4 >> 2];
                                            if (!b) {
                                                break u;
                                            }
                                            a = c;
                                        }
                                        c = a;
                                        a = b;
                                        continue;
                                    }
                                }
                                a = c;
                            }
                            b = F[c >> 2];
                            if (!b) {
                                b = sa(32);
                                F[b + 16 >> 2] = F[h + 8 >> 2];
                                F[b + 20 >> 2] = F[h + 12 >> 2];
                                f = b + 24 | 0;
                                e = F[h + 16 >> 2];
                                F[f >> 2] = e;
                                g = F[h + 20 >> 2];
                                F[b + 28 >> 2] = g;
                                w: {
                                    if (!g) {
                                        F[b + 20 >> 2] = f;
                                        break w;
                                    }
                                    F[e + 8 >> 2] = f;
                                    F[h + 16 >> 2] = 0;
                                    F[h + 20 >> 2] = 0;
                                    F[h + 12 >> 2] = d;
                                }
                                F[b + 8 >> 2] = a;
                                F[b >> 2] = 0;
                                F[b + 4 >> 2] = 0;
                                F[c >> 2] = b;
                                a = F[F[k + 12 >> 2] >> 2];
                                if (a) {
                                    F[k + 12 >> 2] = a;
                                    a = F[c >> 2];
                                }
                                else {
                                    a = b;
                                }
                                Tb(F[k + 16 >> 2], a);
                                F[k + 20 >> 2] = F[k + 20 >> 2] + 1;
                            }
                            Jb(h + 8 | 4, F[h + 16 >> 2]);
                            Jb(t, F[t + 4 >> 2]);
                        } ea = h + 48 | 0; k = ea - 48 | 0; ea = k; d = ea - 32 | 0; ea = d; a = d + 21 | 0; g = d + 32 | 0; c = g; x: {
                            if ((a | 0) == (c | 0)) {
                                break x;
                            }
                        } f = c - a | 0; y: {
                            if (!((f | 0) <= 9 & (f | 0) < (1 - (I[3720] > 1) | 0))) {
                                D[a | 0] = 49;
                                F[d + 8 >> 2] = a + 1;
                                c = 0;
                                break y;
                            }
                            F[d + 8 >> 2] = c;
                            c = 61;
                        } F[d + 12 >> 2] = c; h = ea - 16 | 0; ea = h; c = k + 8 | 0; e = ea - 16 | 0; ea = e; z: {
                            l = F[d + 8 >> 2];
                            f = l - a | 0;
                            if (f >>> 0 <= 4294967279) {
                                A: {
                                    if (f >>> 0 <= 10) {
                                        D[c + 11 | 0] = f;
                                        d = c;
                                        break A;
                                    }
                                    if (f >>> 0 >= 11) {
                                        i = f + 16 & -16;
                                        d = i - 1 | 0;
                                        d = (d | 0) == 11 ? i : d;
                                    }
                                    else {
                                        d = 10;
                                    }
                                    i = d + 1 | 0;
                                    d = sa(i);
                                    F[c >> 2] = d;
                                    F[c + 8 >> 2] = i | -2147483648;
                                    F[c + 4 >> 2] = f;
                                }
                                while (1) {
                                    if ((a | 0) != (l | 0)) {
                                        D[d | 0] = G[a | 0];
                                        d = d + 1 | 0;
                                        a = a + 1 | 0;
                                        continue;
                                    }
                                    break;
                                }
                                D[e + 15 | 0] = 0;
                                D[d | 0] = G[e + 15 | 0];
                                ea = e + 16 | 0;
                                break z;
                            }
                            Ma();
                            V();
                        } ea = h + 16 | 0; ea = g; F[k + 32 >> 2] = m; d = b + 20 | 0; a = F[d + 4 >> 2]; B: {
                            C: {
                                if (a) {
                                    b = G[m + 11 | 0];
                                    c = b << 24 >> 24 < 0;
                                    e = c ? F[m >> 2] : m;
                                    f = c ? F[m + 4 >> 2] : b;
                                    b = d + 4 | 0;
                                    while (1) {
                                        c = G[a + 27 | 0];
                                        g = c << 24 >> 24 < 0;
                                        c = g ? F[a + 20 >> 2] : c;
                                        h = c >>> 0 < f >>> 0;
                                        D: {
                                            E: {
                                                F: {
                                                    G: {
                                                        H: {
                                                            l = h ? c : f;
                                                            I: {
                                                                if (l) {
                                                                    i = a + 16 | 0;
                                                                    g = g ? F[i >> 2] : i;
                                                                    i = Ha(e, g, l);
                                                                    if (!i) {
                                                                        if (c >>> 0 > f >>> 0) {
                                                                            break I;
                                                                        }
                                                                        break H;
                                                                    }
                                                                    if ((i | 0) >= 0) {
                                                                        break H;
                                                                    }
                                                                    break I;
                                                                }
                                                                if (c >>> 0 <= f >>> 0) {
                                                                    break G;
                                                                }
                                                            }
                                                            c = F[a >> 2];
                                                            if (c) {
                                                                break D;
                                                            }
                                                            break C;
                                                        }
                                                        c = Ha(g, e, l);
                                                        if (c) {
                                                            break F;
                                                        }
                                                    }
                                                    if (h) {
                                                        break E;
                                                    }
                                                    break B;
                                                }
                                                if ((c | 0) >= 0) {
                                                    break B;
                                                }
                                            }
                                            b = a + 4 | 0;
                                            c = F[a + 4 >> 2];
                                            if (!c) {
                                                break B;
                                            }
                                            a = b;
                                        }
                                        b = a;
                                        a = c;
                                        continue;
                                    }
                                }
                                a = d + 4 | 0;
                            }
                            b = a;
                        } c = F[b >> 2]; if (c) {
                            a = 0;
                        }
                        else {
                            c = sa(40);
                            e = c + 16 | 0;
                            f = F[k + 32 >> 2];
                            J: {
                                if (D[f + 11 | 0] >= 0) {
                                    g = F[f + 4 >> 2];
                                    F[e >> 2] = F[f >> 2];
                                    F[e + 4 >> 2] = g;
                                    F[e + 8 >> 2] = F[f + 8 >> 2];
                                    break J;
                                }
                                Ba(e, F[f >> 2], F[f + 4 >> 2]);
                            }
                            F[c + 8 >> 2] = a;
                            F[c >> 2] = 0;
                            F[c + 4 >> 2] = 0;
                            F[c + 36 >> 2] = 0;
                            F[c + 28 >> 2] = 0;
                            F[c + 32 >> 2] = 0;
                            F[b >> 2] = c;
                            a = F[F[d >> 2] >> 2];
                            if (a) {
                                F[d >> 2] = a;
                                a = F[b >> 2];
                            }
                            else {
                                a = c;
                            }
                            Tb(F[d + 4 >> 2], a);
                            F[d + 8 >> 2] = F[d + 8 >> 2] + 1;
                            a = 1;
                        } D[k + 44 | 0] = a; F[k + 40 >> 2] = c; a = F[k + 40 >> 2]; if (D[a + 39 | 0] < 0) {
                            ra(F[a + 28 >> 2]);
                        } b = F[k + 12 >> 2]; F[a + 28 >> 2] = F[k + 8 >> 2]; F[a + 32 >> 2] = b; F[a + 36 >> 2] = F[k + 16 >> 2]; ea = k + 48 | 0; if (D[m + 11 | 0] < 0) {
                            ra(F[m >> 2]);
                        } ea = m + 16 | 0; }
                        function hj(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0, E = 0, G = 0, H = 0, I = 0; h = ea + -64 | 0; ea = h; F[a + 8 >> 2] = e; f = a + 32 | 0; g = F[f >> 2]; d = F[a + 36 >> 2] - g >> 2; a: {
                            b: {
                                if (d >>> 0 < e >>> 0) {
                                    Aa(f, e - d | 0);
                                    F[h + 56 >> 2] = 0;
                                    F[h + 60 >> 2] = 0;
                                    F[h + 48 >> 2] = 0;
                                    F[h + 52 >> 2] = 0;
                                    F[h + 40 >> 2] = 0;
                                    F[h + 44 >> 2] = 0;
                                    F[h + 32 >> 2] = 0;
                                    F[h + 36 >> 2] = 0;
                                    F[h + 24 >> 2] = 0;
                                    F[h + 28 >> 2] = 0;
                                    F[h + 16 >> 2] = 0;
                                    F[h + 20 >> 2] = 0;
                                    F[h >> 2] = 0;
                                    break b;
                                }
                                if (d >>> 0 > e >>> 0) {
                                    F[a + 36 >> 2] = g + (e << 2);
                                }
                                F[h + 56 >> 2] = 0;
                                F[h + 60 >> 2] = 0;
                                F[h + 48 >> 2] = 0;
                                F[h + 52 >> 2] = 0;
                                F[h + 40 >> 2] = 0;
                                F[h + 44 >> 2] = 0;
                                F[h + 32 >> 2] = 0;
                                F[h + 36 >> 2] = 0;
                                F[h + 24 >> 2] = 0;
                                F[h + 28 >> 2] = 0;
                                F[h + 16 >> 2] = 0;
                                F[h + 20 >> 2] = 0;
                                F[h >> 2] = 0;
                                d = 0;
                                if (!e) {
                                    break a;
                                }
                            }
                            Ia(h + 16 | 0, e, h);
                            i = F[h + 28 >> 2];
                            d = F[h + 32 >> 2];
                        } F[h >> 2] = 0; d = d - i >> 2; c: {
                            if (d >>> 0 >= e >>> 0) {
                                if (d >>> 0 <= e >>> 0) {
                                    break c;
                                }
                                F[h + 32 >> 2] = (e << 2) + i;
                                break c;
                            }
                            Ia(h + 16 | 12, e - d | 0, h);
                        } F[h >> 2] = 0; f = F[h + 40 >> 2]; d = F[h + 44 >> 2] - f >> 2; d: {
                            if (d >>> 0 >= e >>> 0) {
                                if (d >>> 0 <= e >>> 0) {
                                    break d;
                                }
                                F[h + 44 >> 2] = f + (e << 2);
                                break d;
                            }
                            Ia(h + 40 | 0, e - d | 0, h);
                        } F[h >> 2] = 0; f = F[h + 52 >> 2]; d = F[h + 56 >> 2] - f >> 2; e: {
                            if (d >>> 0 >= e >>> 0) {
                                if (d >>> 0 <= e >>> 0) {
                                    break e;
                                }
                                F[h + 56 >> 2] = f + (e << 2);
                                break e;
                            }
                            Ia(h + 52 | 0, e - d | 0, h);
                        } i = 0; f: {
                            if (F[a + 8 >> 2] <= 0) {
                                break f;
                            }
                            k = F[a + 32 >> 2];
                            g = F[h + 16 >> 2];
                            while (1) {
                                d = i << 2;
                                f = F[d + g >> 2];
                                n = F[a + 16 >> 2];
                                g: {
                                    if ((f | 0) > (n | 0)) {
                                        F[d + k >> 2] = n;
                                        break g;
                                    }
                                    d = d + k | 0;
                                    n = F[a + 12 >> 2];
                                    if ((n | 0) > (f | 0)) {
                                        F[d >> 2] = n;
                                        break g;
                                    }
                                    F[d >> 2] = f;
                                }
                                i = i + 1 | 0;
                                d = F[a + 8 >> 2];
                                if ((i | 0) < (d | 0)) {
                                    continue;
                                }
                                break;
                            }
                            if ((d | 0) <= 0) {
                                break f;
                            }
                            d = 0;
                            while (1) {
                                g = d << 2;
                                f = g + c | 0;
                                g = F[b + g >> 2] + F[g + k >> 2] | 0;
                                F[f >> 2] = g;
                                h: {
                                    if ((g | 0) > F[a + 16 >> 2]) {
                                        j = g - F[a + 20 >> 2] | 0;
                                    }
                                    else {
                                        if ((g | 0) >= F[a + 12 >> 2]) {
                                            break h;
                                        }
                                        j = g + F[a + 20 >> 2] | 0;
                                    }
                                    F[f >> 2] = j;
                                }
                                d = d + 1 | 0;
                                if ((d | 0) < F[a + 8 >> 2]) {
                                    continue;
                                }
                                break;
                            }
                        } D = F[a + 52 >> 2]; y = F[a + 48 >> 2]; v = sa(16); d = v; F[d >> 2] = 0; F[d + 4 >> 2] = 0; F[d + 8 >> 2] = 0; F[d + 12 >> 2] = 0; F[h + 8 >> 2] = 0; F[h >> 2] = 0; F[h + 4 >> 2] = 0; i: {
                            if (e) {
                                if (e >>> 0 >= 1073741824) {
                                    break i;
                                }
                                d = e << 2;
                                u = sa(d);
                                F[h >> 2] = u;
                                F[h + 8 >> 2] = d + u;
                                ua(u, 0, d);
                            }
                            r = 1;
                            d = F[a + 56 >> 2];
                            z = F[d >> 2];
                            d = F[d + 4 >> 2] - z | 0;
                            j: {
                                if ((d | 0) < 5) {
                                    break j;
                                }
                                d = d >> 2;
                                E = (d | 0) > 2 ? d : 2;
                                G = d >>> 0 > 1 ? d : 1;
                                A = e & -2;
                                B = e & 1;
                                H = e & -4;
                                C = e & 3;
                                w = e - 1 | 0;
                                I = e << 2;
                                n = 1;
                                while (1) {
                                    k: {
                                        l: {
                                            m: {
                                                n: {
                                                    if ((n | 0) != (G | 0)) {
                                                        f = F[(n << 2) + z >> 2];
                                                        d = (f >>> 0) % 3 | 0;
                                                        o: {
                                                            p: {
                                                                if ((f | 0) == -1) {
                                                                    break p;
                                                                }
                                                                k = 0;
                                                                g = f + 2 | 0;
                                                                x = (d | 0) != 0 | (g | 0) != -1;
                                                                s = F[y + 12 >> 2];
                                                                q = s + ((d ? f - 1 | 0 : g) << 2) | 0;
                                                                o = 1;
                                                                d = f;
                                                                q: {
                                                                    while (1) {
                                                                        g = F[s + (d << 2) >> 2];
                                                                        r: {
                                                                            if ((g | 0) == -1) {
                                                                                break r;
                                                                            }
                                                                            l = -1;
                                                                            r = F[D >> 2];
                                                                            m = F[y >> 2];
                                                                            i = r + (F[m + (g << 2) >> 2] << 2) | 0;
                                                                            p = g + 1 | 0;
                                                                            p = (p >>> 0) % 3 | 0 ? p : g - 2 | 0;
                                                                            if ((p | 0) != -1) {
                                                                                l = F[m + (p << 2) >> 2];
                                                                            }
                                                                            p = F[i >> 2];
                                                                            s: {
                                                                                t: {
                                                                                    if ((g >>> 0) % 3 | 0) {
                                                                                        i = g - 1 | 0;
                                                                                        break t;
                                                                                    }
                                                                                    i = g + 2 | 0;
                                                                                    j = -1;
                                                                                    if ((i | 0) == -1) {
                                                                                        break s;
                                                                                    }
                                                                                }
                                                                                j = F[m + (i << 2) >> 2];
                                                                            }
                                                                            if ((n | 0) <= (p | 0)) {
                                                                                break r;
                                                                            }
                                                                            i = F[r + (l << 2) >> 2];
                                                                            if ((i | 0) >= (n | 0)) {
                                                                                break r;
                                                                            }
                                                                            l = F[r + (j << 2) >> 2];
                                                                            if ((l | 0) >= (n | 0)) {
                                                                                break r;
                                                                            }
                                                                            g = F[(h + 16 | 0) + L(k, 12) >> 2];
                                                                            u: {
                                                                                if (!e) {
                                                                                    break u;
                                                                                }
                                                                                l = L(e, l);
                                                                                m = L(e, i);
                                                                                r = L(e, p);
                                                                                i = 0;
                                                                                j = 0;
                                                                                if (w) {
                                                                                    while (1) {
                                                                                        F[g + (i << 2) >> 2] = (F[(i + l << 2) + c >> 2] + F[(i + m << 2) + c >> 2] | 0) - F[(i + r << 2) + c >> 2];
                                                                                        p = i | 1;
                                                                                        F[g + (p << 2) >> 2] = (F[(l + p << 2) + c >> 2] + F[(m + p << 2) + c >> 2] | 0) - F[(p + r << 2) + c >> 2];
                                                                                        i = i + 2 | 0;
                                                                                        j = j + 2 | 0;
                                                                                        if ((A | 0) != (j | 0)) {
                                                                                            continue;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                }
                                                                                if (!B) {
                                                                                    break u;
                                                                                }
                                                                                F[g + (i << 2) >> 2] = (F[(i + l << 2) + c >> 2] + F[(i + m << 2) + c >> 2] | 0) - F[(i + r << 2) + c >> 2];
                                                                            }
                                                                            g = 4;
                                                                            k = k + 1 | 0;
                                                                            if ((k | 0) == 4) {
                                                                                break q;
                                                                            }
                                                                        }
                                                                        v: {
                                                                            if (o & 1) {
                                                                                i = d + 1 | 0;
                                                                                d = (i >>> 0) % 3 | 0 ? i : d - 2 | 0;
                                                                                j = -1;
                                                                                if ((d | 0) == -1) {
                                                                                    break v;
                                                                                }
                                                                                d = F[s + (d << 2) >> 2];
                                                                                j = -1;
                                                                                if ((d | 0) == -1) {
                                                                                    break v;
                                                                                }
                                                                                g = d + 1 | 0;
                                                                                j = (g >>> 0) % 3 | 0 ? g : d - 2 | 0;
                                                                                break v;
                                                                            }
                                                                            w: {
                                                                                if ((d >>> 0) % 3 | 0) {
                                                                                    i = d - 1 | 0;
                                                                                    break w;
                                                                                }
                                                                                i = d + 2 | 0;
                                                                                j = -1;
                                                                                if ((i | 0) == -1) {
                                                                                    break v;
                                                                                }
                                                                            }
                                                                            d = F[s + (i << 2) >> 2];
                                                                            j = -1;
                                                                            if ((d | 0) == -1) {
                                                                                break v;
                                                                            }
                                                                            j = d - 1 | 0;
                                                                            if ((d >>> 0) % 3 | 0) {
                                                                                break v;
                                                                            }
                                                                            j = d + 2 | 0;
                                                                        }
                                                                        d = j;
                                                                        x: {
                                                                            if ((f | 0) == (d | 0)) {
                                                                                break x;
                                                                            }
                                                                            if (!((o ^ 1) & 1 | (d | 0) != -1)) {
                                                                                if (!x) {
                                                                                    break x;
                                                                                }
                                                                                d = F[q >> 2];
                                                                                if ((d | 0) == -1) {
                                                                                    break x;
                                                                                }
                                                                                o = 0;
                                                                                d = (d >>> 0) % 3 | 0 ? d - 1 | 0 : d + 2 | 0;
                                                                            }
                                                                            if ((d | 0) != -1) {
                                                                                continue;
                                                                            }
                                                                        }
                                                                        break;
                                                                    }
                                                                    g = k;
                                                                    if ((g | 0) <= 0) {
                                                                        break p;
                                                                    }
                                                                }
                                                                if (e) {
                                                                    ua(F[h >> 2], 0, I);
                                                                }
                                                                d = g - 1 | 0;
                                                                p = (d << 2) + v | 0;
                                                                d = L(d, 12) + a | 0;
                                                                j = d;
                                                                x = F[d - -64 >> 2];
                                                                r = 0;
                                                                o = 0;
                                                                d = 0;
                                                                while (1) {
                                                                    f = F[p >> 2];
                                                                    F[p >> 2] = f + 1;
                                                                    if (f >>> 0 >= x >>> 0) {
                                                                        break j;
                                                                    }
                                                                    y: {
                                                                        if (F[F[j + 60 >> 2] + (f >>> 3 & 536870908) >> 2] >>> f & 1) {
                                                                            break y;
                                                                        }
                                                                        d = d + 1 | 0;
                                                                        if (!e) {
                                                                            break y;
                                                                        }
                                                                        k = F[h >> 2];
                                                                        s = F[(h + 16 | 0) + L(o, 12) >> 2];
                                                                        l = 0;
                                                                        i = 0;
                                                                        f = 0;
                                                                        if (w >>> 0 >= 3) {
                                                                            while (1) {
                                                                                m = i << 2;
                                                                                q = m + k | 0;
                                                                                F[q >> 2] = F[q >> 2] + F[m + s >> 2];
                                                                                q = m | 4;
                                                                                t = q + k | 0;
                                                                                F[t >> 2] = F[t >> 2] + F[s + q >> 2];
                                                                                q = m | 8;
                                                                                t = q + k | 0;
                                                                                F[t >> 2] = F[t >> 2] + F[s + q >> 2];
                                                                                m = m | 12;
                                                                                q = m + k | 0;
                                                                                F[q >> 2] = F[q >> 2] + F[m + s >> 2];
                                                                                i = i + 4 | 0;
                                                                                f = f + 4 | 0;
                                                                                if ((H | 0) != (f | 0)) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                        }
                                                                        if (!C) {
                                                                            break y;
                                                                        }
                                                                        while (1) {
                                                                            f = i << 2;
                                                                            m = f + k | 0;
                                                                            F[m >> 2] = F[m >> 2] + F[f + s >> 2];
                                                                            i = i + 1 | 0;
                                                                            l = l + 1 | 0;
                                                                            if ((C | 0) != (l | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                    }
                                                                    o = o + 1 | 0;
                                                                    if ((o | 0) != (g | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                o = L(e, n);
                                                                f = o;
                                                                if (!d) {
                                                                    break o;
                                                                }
                                                                if (!e) {
                                                                    break l;
                                                                }
                                                                f = F[h >> 2];
                                                                i = 0;
                                                                g = 0;
                                                                if (w) {
                                                                    break n;
                                                                }
                                                                break m;
                                                            }
                                                            f = L(e, n);
                                                        }
                                                        if (F[a + 8 >> 2] <= 0) {
                                                            break k;
                                                        }
                                                        o = (L(n - 1 | 0, e) << 2) + c | 0;
                                                        k = F[a + 32 >> 2];
                                                        i = 0;
                                                        while (1) {
                                                            d = i << 2;
                                                            g = F[d + o >> 2];
                                                            l = F[a + 16 >> 2];
                                                            z: {
                                                                if ((g | 0) > (l | 0)) {
                                                                    F[d + k >> 2] = l;
                                                                    break z;
                                                                }
                                                                d = d + k | 0;
                                                                l = F[a + 12 >> 2];
                                                                if ((l | 0) > (g | 0)) {
                                                                    F[d >> 2] = l;
                                                                    break z;
                                                                }
                                                                F[d >> 2] = g;
                                                            }
                                                            i = i + 1 | 0;
                                                            g = F[a + 8 >> 2];
                                                            if ((i | 0) < (g | 0)) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        d = 0;
                                                        if ((g | 0) <= 0) {
                                                            break k;
                                                        }
                                                        f = f << 2;
                                                        i = f + c | 0;
                                                        o = b + f | 0;
                                                        while (1) {
                                                            g = d << 2;
                                                            f = g + i | 0;
                                                            g = F[g + o >> 2] + F[g + k >> 2] | 0;
                                                            F[f >> 2] = g;
                                                            A: {
                                                                if ((g | 0) > F[a + 16 >> 2]) {
                                                                    j = g - F[a + 20 >> 2] | 0;
                                                                }
                                                                else {
                                                                    if ((g | 0) >= F[a + 12 >> 2]) {
                                                                        break A;
                                                                    }
                                                                    j = g + F[a + 20 >> 2] | 0;
                                                                }
                                                                F[f >> 2] = j;
                                                            }
                                                            d = d + 1 | 0;
                                                            if ((d | 0) < F[a + 8 >> 2]) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        break k;
                                                    }
                                                    Da();
                                                    V();
                                                }
                                                while (1) {
                                                    k = i << 2;
                                                    l = k + f | 0;
                                                    F[l >> 2] = F[l >> 2] / (d | 0);
                                                    k = f + (k | 4) | 0;
                                                    F[k >> 2] = F[k >> 2] / (d | 0);
                                                    i = i + 2 | 0;
                                                    g = g + 2 | 0;
                                                    if ((A | 0) != (g | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            if (!B) {
                                                break l;
                                            }
                                            f = f + (i << 2) | 0;
                                            F[f >> 2] = F[f >> 2] / (d | 0);
                                        }
                                        if (F[a + 8 >> 2] <= 0) {
                                            break k;
                                        }
                                        k = F[a + 32 >> 2];
                                        i = 0;
                                        while (1) {
                                            d = i << 2;
                                            f = F[d + u >> 2];
                                            g = F[a + 16 >> 2];
                                            B: {
                                                if ((f | 0) > (g | 0)) {
                                                    F[d + k >> 2] = g;
                                                    break B;
                                                }
                                                d = d + k | 0;
                                                g = F[a + 12 >> 2];
                                                if ((g | 0) > (f | 0)) {
                                                    F[d >> 2] = g;
                                                    break B;
                                                }
                                                F[d >> 2] = f;
                                            }
                                            i = i + 1 | 0;
                                            f = F[a + 8 >> 2];
                                            if ((i | 0) < (f | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                        d = 0;
                                        if ((f | 0) <= 0) {
                                            break k;
                                        }
                                        f = o << 2;
                                        i = f + c | 0;
                                        o = b + f | 0;
                                        while (1) {
                                            g = d << 2;
                                            f = g + i | 0;
                                            g = F[g + o >> 2] + F[g + k >> 2] | 0;
                                            F[f >> 2] = g;
                                            C: {
                                                if ((g | 0) > F[a + 16 >> 2]) {
                                                    j = g - F[a + 20 >> 2] | 0;
                                                }
                                                else {
                                                    if ((g | 0) >= F[a + 12 >> 2]) {
                                                        break C;
                                                    }
                                                    j = g + F[a + 20 >> 2] | 0;
                                                }
                                                F[f >> 2] = j;
                                            }
                                            d = d + 1 | 0;
                                            if ((d | 0) < F[a + 8 >> 2]) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    r = 1;
                                    n = n + 1 | 0;
                                    if ((E | 0) != (n | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            a = F[h >> 2];
                            if (a) {
                                ra(a);
                            }
                            ra(v);
                            a = F[h + 52 >> 2];
                            if (a) {
                                F[h + 56 >> 2] = a;
                                ra(a);
                            }
                            a = F[h + 40 >> 2];
                            if (a) {
                                F[h + 44 >> 2] = a;
                                ra(a);
                            }
                            a = F[h + 28 >> 2];
                            if (a) {
                                F[h + 32 >> 2] = a;
                                ra(a);
                            }
                            a = F[h + 16 >> 2];
                            if (a) {
                                F[h + 20 >> 2] = a;
                                ra(a);
                            }
                            ea = h - -64 | 0;
                            return r | 0;
                        } va(); V(); }
                        function Fj(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0; i = a; a: {
                            b: {
                                c: {
                                    d: {
                                        e: {
                                            f: {
                                                g: {
                                                    h: {
                                                        k = F[a + 8 >> 2];
                                                        switch (F[k + 28 >> 2] - 1 | 0) {
                                                            case 4: break c;
                                                            case 5: break d;
                                                            case 2: break e;
                                                            case 3: break f;
                                                            case 0: break g;
                                                            case 1: break h;
                                                            default: break a;
                                                        }
                                                    }
                                                    c = D[k + 24 | 0];
                                                    d = sa((c | 0) >= 0 ? c : -1);
                                                    a = F[i + 16 >> 2];
                                                    if (F[a + 80 >> 2]) {
                                                        h = F[F[a >> 2] >> 2] + F[a + 48 >> 2] | 0;
                                                    }
                                                    else {
                                                        h = 0;
                                                    }
                                                    if (!b) {
                                                        break b;
                                                    }
                                                    if ((c | 0) > 0) {
                                                        k = c & -4;
                                                        m = c & 3;
                                                        e = c - 1 >>> 0 < 3;
                                                        while (1) {
                                                            a = 0;
                                                            g = 0;
                                                            if (!e) {
                                                                while (1) {
                                                                    j = h + (f << 2) | 0;
                                                                    D[a + d | 0] = F[j >> 2];
                                                                    D[(a | 1) + d | 0] = F[j + 4 >> 2];
                                                                    D[(a | 2) + d | 0] = F[j + 8 >> 2];
                                                                    D[(a | 3) + d | 0] = F[j + 12 >> 2];
                                                                    a = a + 4 | 0;
                                                                    f = f + 4 | 0;
                                                                    g = g + 4 | 0;
                                                                    if ((k | 0) != (g | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            g = 0;
                                                            if (m) {
                                                                while (1) {
                                                                    D[a + d | 0] = F[h + (f << 2) >> 2];
                                                                    a = a + 1 | 0;
                                                                    f = f + 1 | 0;
                                                                    g = g + 1 | 0;
                                                                    if ((m | 0) != (g | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            ta(F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] + n | 0, d, c);
                                                            n = c + n | 0;
                                                            l = l + 1 | 0;
                                                            if ((l | 0) != (b | 0)) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        break b;
                                                    }
                                                    ta(F[F[k + 64 >> 2] >> 2], d, c);
                                                    if ((b | 0) == 1) {
                                                        break b;
                                                    }
                                                    e = b - 1 | 0;
                                                    h = e & 1;
                                                    a = 0;
                                                    if ((b | 0) != 2) {
                                                        b = e & -2;
                                                        while (1) {
                                                            a = a + c | 0;
                                                            ta(a + F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] | 0, d, c);
                                                            a = a + c | 0;
                                                            ta(a + F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] | 0, d, c);
                                                            f = f + 2 | 0;
                                                            if ((b | 0) != (f | 0)) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    if (!h) {
                                                        break b;
                                                    }
                                                    ta(F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] + (a + c | 0) | 0, d, c);
                                                    break b;
                                                }
                                                c = D[k + 24 | 0];
                                                d = sa((c | 0) >= 0 ? c : -1);
                                                a = F[i + 16 >> 2];
                                                if (F[a + 80 >> 2]) {
                                                    h = F[F[a >> 2] >> 2] + F[a + 48 >> 2] | 0;
                                                }
                                                else {
                                                    h = 0;
                                                }
                                                if (!b) {
                                                    break b;
                                                }
                                                if ((c | 0) > 0) {
                                                    k = c & -4;
                                                    m = c & 3;
                                                    e = c - 1 >>> 0 < 3;
                                                    while (1) {
                                                        a = 0;
                                                        g = 0;
                                                        if (!e) {
                                                            while (1) {
                                                                j = h + (f << 2) | 0;
                                                                D[a + d | 0] = F[j >> 2];
                                                                D[(a | 1) + d | 0] = F[j + 4 >> 2];
                                                                D[(a | 2) + d | 0] = F[j + 8 >> 2];
                                                                D[(a | 3) + d | 0] = F[j + 12 >> 2];
                                                                a = a + 4 | 0;
                                                                f = f + 4 | 0;
                                                                g = g + 4 | 0;
                                                                if ((k | 0) != (g | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                        }
                                                        g = 0;
                                                        if (m) {
                                                            while (1) {
                                                                D[a + d | 0] = F[h + (f << 2) >> 2];
                                                                a = a + 1 | 0;
                                                                f = f + 1 | 0;
                                                                g = g + 1 | 0;
                                                                if ((m | 0) != (g | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                        }
                                                        ta(F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] + n | 0, d, c);
                                                        n = c + n | 0;
                                                        l = l + 1 | 0;
                                                        if ((l | 0) != (b | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    break b;
                                                }
                                                ta(F[F[k + 64 >> 2] >> 2], d, c);
                                                if ((b | 0) == 1) {
                                                    break b;
                                                }
                                                e = b - 1 | 0;
                                                h = e & 1;
                                                a = 0;
                                                if ((b | 0) != 2) {
                                                    b = e & -2;
                                                    while (1) {
                                                        a = a + c | 0;
                                                        ta(a + F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] | 0, d, c);
                                                        a = a + c | 0;
                                                        ta(a + F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] | 0, d, c);
                                                        f = f + 2 | 0;
                                                        if ((b | 0) != (f | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if (!h) {
                                                    break b;
                                                }
                                                ta(F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] + (a + c | 0) | 0, d, c);
                                                break b;
                                            }
                                            e = D[k + 24 | 0];
                                            a = e + e | 0;
                                            d = sa(a >>> 0 < e >>> 0 ? -1 : a);
                                            a = F[i + 16 >> 2];
                                            if (F[a + 80 >> 2]) {
                                                h = F[F[a >> 2] >> 2] + F[a + 48 >> 2] | 0;
                                            }
                                            else {
                                                h = 0;
                                            }
                                            if (!b) {
                                                break b;
                                            }
                                            c = e << 1;
                                            if ((e | 0) > 0) {
                                                k = e & -4;
                                                m = e & 3;
                                                e = e - 1 >>> 0 < 3;
                                                while (1) {
                                                    a = 0;
                                                    g = 0;
                                                    if (!e) {
                                                        while (1) {
                                                            l = a << 1;
                                                            j = h + (f << 2) | 0;
                                                            E[l + d >> 1] = F[j >> 2];
                                                            E[(l | 2) + d >> 1] = F[j + 4 >> 2];
                                                            E[(l | 4) + d >> 1] = F[j + 8 >> 2];
                                                            E[(l | 6) + d >> 1] = F[j + 12 >> 2];
                                                            a = a + 4 | 0;
                                                            f = f + 4 | 0;
                                                            g = g + 4 | 0;
                                                            if ((k | 0) != (g | 0)) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    g = 0;
                                                    if (m) {
                                                        while (1) {
                                                            E[(a << 1) + d >> 1] = F[h + (f << 2) >> 2];
                                                            a = a + 1 | 0;
                                                            f = f + 1 | 0;
                                                            g = g + 1 | 0;
                                                            if ((m | 0) != (g | 0)) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    ta(F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] + o | 0, d, c);
                                                    o = c + o | 0;
                                                    n = n + 1 | 0;
                                                    if ((n | 0) != (b | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break b;
                                            }
                                            ta(F[F[k + 64 >> 2] >> 2], d, c);
                                            if ((b | 0) == 1) {
                                                break b;
                                            }
                                            e = b - 1 | 0;
                                            h = e & 1;
                                            a = 0;
                                            if ((b | 0) != 2) {
                                                b = e & -2;
                                                while (1) {
                                                    a = a + c | 0;
                                                    ta(a + F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] | 0, d, c);
                                                    a = a + c | 0;
                                                    ta(a + F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] | 0, d, c);
                                                    f = f + 2 | 0;
                                                    if ((b | 0) != (f | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            if (!h) {
                                                break b;
                                            }
                                            ta(F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] + (a + c | 0) | 0, d, c);
                                            break b;
                                        }
                                        e = D[k + 24 | 0];
                                        a = e + e | 0;
                                        d = sa(a >>> 0 < e >>> 0 ? -1 : a);
                                        a = F[i + 16 >> 2];
                                        if (F[a + 80 >> 2]) {
                                            h = F[F[a >> 2] >> 2] + F[a + 48 >> 2] | 0;
                                        }
                                        else {
                                            h = 0;
                                        }
                                        if (!b) {
                                            break b;
                                        }
                                        c = e << 1;
                                        if ((e | 0) > 0) {
                                            k = e & -4;
                                            m = e & 3;
                                            e = e - 1 >>> 0 < 3;
                                            while (1) {
                                                a = 0;
                                                g = 0;
                                                if (!e) {
                                                    while (1) {
                                                        l = a << 1;
                                                        j = h + (f << 2) | 0;
                                                        E[l + d >> 1] = F[j >> 2];
                                                        E[(l | 2) + d >> 1] = F[j + 4 >> 2];
                                                        E[(l | 4) + d >> 1] = F[j + 8 >> 2];
                                                        E[(l | 6) + d >> 1] = F[j + 12 >> 2];
                                                        a = a + 4 | 0;
                                                        f = f + 4 | 0;
                                                        g = g + 4 | 0;
                                                        if ((k | 0) != (g | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                g = 0;
                                                if (m) {
                                                    while (1) {
                                                        E[(a << 1) + d >> 1] = F[h + (f << 2) >> 2];
                                                        a = a + 1 | 0;
                                                        f = f + 1 | 0;
                                                        g = g + 1 | 0;
                                                        if ((m | 0) != (g | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                ta(F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] + o | 0, d, c);
                                                o = c + o | 0;
                                                n = n + 1 | 0;
                                                if ((n | 0) != (b | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            break b;
                                        }
                                        ta(F[F[k + 64 >> 2] >> 2], d, c);
                                        if ((b | 0) == 1) {
                                            break b;
                                        }
                                        e = b - 1 | 0;
                                        h = e & 1;
                                        a = 0;
                                        if ((b | 0) != 2) {
                                            b = e & -2;
                                            while (1) {
                                                a = a + c | 0;
                                                ta(a + F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] | 0, d, c);
                                                a = a + c | 0;
                                                ta(a + F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] | 0, d, c);
                                                f = f + 2 | 0;
                                                if ((b | 0) != (f | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        if (!h) {
                                            break b;
                                        }
                                        ta(F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] + (a + c | 0) | 0, d, c);
                                        break b;
                                    }
                                    e = D[k + 24 | 0];
                                    c = e << 2;
                                    d = sa((e | 0) != (e & 1073741823) ? -1 : c);
                                    a = F[i + 16 >> 2];
                                    if (F[a + 80 >> 2]) {
                                        h = F[F[a >> 2] >> 2] + F[a + 48 >> 2] | 0;
                                    }
                                    else {
                                        h = 0;
                                    }
                                    if (!b) {
                                        break b;
                                    }
                                    if ((e | 0) > 0) {
                                        k = e & -4;
                                        m = e & 3;
                                        e = e - 1 >>> 0 < 3;
                                        while (1) {
                                            a = 0;
                                            g = 0;
                                            if (!e) {
                                                while (1) {
                                                    l = a << 2;
                                                    j = h + (f << 2) | 0;
                                                    F[l + d >> 2] = F[j >> 2];
                                                    F[(l | 4) + d >> 2] = F[j + 4 >> 2];
                                                    F[(l | 8) + d >> 2] = F[j + 8 >> 2];
                                                    F[(l | 12) + d >> 2] = F[j + 12 >> 2];
                                                    a = a + 4 | 0;
                                                    f = f + 4 | 0;
                                                    g = g + 4 | 0;
                                                    if ((k | 0) != (g | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            g = 0;
                                            if (m) {
                                                while (1) {
                                                    F[(a << 2) + d >> 2] = F[h + (f << 2) >> 2];
                                                    a = a + 1 | 0;
                                                    f = f + 1 | 0;
                                                    g = g + 1 | 0;
                                                    if ((m | 0) != (g | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            ta(F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] + o | 0, d, c);
                                            o = c + o | 0;
                                            n = n + 1 | 0;
                                            if ((n | 0) != (b | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                        break b;
                                    }
                                    ta(F[F[k + 64 >> 2] >> 2], d, c);
                                    if ((b | 0) == 1) {
                                        break b;
                                    }
                                    e = b - 1 | 0;
                                    h = e & 1;
                                    a = 0;
                                    if ((b | 0) != 2) {
                                        b = e & -2;
                                        while (1) {
                                            a = a + c | 0;
                                            ta(a + F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] | 0, d, c);
                                            a = a + c | 0;
                                            ta(a + F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] | 0, d, c);
                                            f = f + 2 | 0;
                                            if ((b | 0) != (f | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    if (!h) {
                                        break b;
                                    }
                                    ta(F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] + (a + c | 0) | 0, d, c);
                                    break b;
                                }
                                e = D[k + 24 | 0];
                                c = e << 2;
                                d = sa((e | 0) != (e & 1073741823) ? -1 : c);
                                a = F[i + 16 >> 2];
                                if (F[a + 80 >> 2]) {
                                    h = F[F[a >> 2] >> 2] + F[a + 48 >> 2] | 0;
                                }
                                else {
                                    h = 0;
                                }
                                if (!b) {
                                    break b;
                                }
                                if ((e | 0) > 0) {
                                    k = e & -4;
                                    m = e & 3;
                                    e = e - 1 >>> 0 < 3;
                                    while (1) {
                                        a = 0;
                                        g = 0;
                                        if (!e) {
                                            while (1) {
                                                l = a << 2;
                                                j = h + (f << 2) | 0;
                                                F[l + d >> 2] = F[j >> 2];
                                                F[(l | 4) + d >> 2] = F[j + 4 >> 2];
                                                F[(l | 8) + d >> 2] = F[j + 8 >> 2];
                                                F[(l | 12) + d >> 2] = F[j + 12 >> 2];
                                                a = a + 4 | 0;
                                                f = f + 4 | 0;
                                                g = g + 4 | 0;
                                                if ((k | 0) != (g | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        g = 0;
                                        if (m) {
                                            while (1) {
                                                F[(a << 2) + d >> 2] = F[h + (f << 2) >> 2];
                                                a = a + 1 | 0;
                                                f = f + 1 | 0;
                                                g = g + 1 | 0;
                                                if ((m | 0) != (g | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        ta(F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] + o | 0, d, c);
                                        o = c + o | 0;
                                        n = n + 1 | 0;
                                        if ((n | 0) != (b | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                    break b;
                                }
                                ta(F[F[k + 64 >> 2] >> 2], d, c);
                                if ((b | 0) == 1) {
                                    break b;
                                }
                                e = b - 1 | 0;
                                h = e & 1;
                                a = 0;
                                if ((b | 0) != 2) {
                                    b = e & -2;
                                    while (1) {
                                        a = a + c | 0;
                                        ta(a + F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] | 0, d, c);
                                        a = a + c | 0;
                                        ta(a + F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] | 0, d, c);
                                        f = f + 2 | 0;
                                        if ((b | 0) != (f | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                if (!h) {
                                    break b;
                                }
                                ta(F[F[F[i + 8 >> 2] + 64 >> 2] >> 2] + (a + c | 0) | 0, d, c);
                            }
                            ra(d);
                            d = 1;
                        } return d | 0; }
                        function ab(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0; e = ea - 16 | 0; ea = e; F[a + 12 >> 2] = b; F[a + 8 >> 2] = 0; F[a >> 2] = 0; F[a + 4 >> 2] = 0; d = a + 16 | 0; F[d >> 2] = 0; F[d + 4 >> 2] = 0; D[d + 5 | 0] = 0; D[d + 6 | 0] = 0; D[d + 7 | 0] = 0; D[d + 8 | 0] = 0; D[d + 9 | 0] = 0; D[d + 10 | 0] = 0; D[d + 11 | 0] = 0; D[d + 12 | 0] = 0; c = d + 16 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 32 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 48 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d - -64 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 80 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 96 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 112 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 128 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 144 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 160 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 176 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 192 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 208 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 224 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 240 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 256 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 272 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 288 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 304 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 320 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 336 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 352 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 368 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 384 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 400 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 416 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 432 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 448 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 464 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; c = d + 480 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; d = d + 496 | 0; F[d >> 2] = 0; F[d + 4 >> 2] = 0; D[d + 5 | 0] = 0; D[d + 6 | 0] = 0; D[d + 7 | 0] = 0; D[d + 8 | 0] = 0; D[d + 9 | 0] = 0; D[d + 10 | 0] = 0; D[d + 11 | 0] = 0; D[d + 12 | 0] = 0; F[a + 528 >> 2] = 0; F[a + 532 >> 2] = 0; D[a + 533 | 0] = 0; D[a + 534 | 0] = 0; D[a + 535 | 0] = 0; D[a + 536 | 0] = 0; D[a + 537 | 0] = 0; D[a + 538 | 0] = 0; D[a + 539 | 0] = 0; D[a + 540 | 0] = 0; F[a + 544 >> 2] = 0; F[a + 548 >> 2] = 0; F[a + 560 >> 2] = 0; F[a + 552 >> 2] = 0; F[a + 556 >> 2] = 0; F[a + 564 >> 2] = 0; F[a + 568 >> 2] = 0; F[a + 580 >> 2] = 0; F[a + 572 >> 2] = 0; F[a + 576 >> 2] = 0; F[a + 584 >> 2] = 0; F[a + 588 >> 2] = 0; F[a + 600 >> 2] = 0; F[a + 592 >> 2] = 0; F[a + 596 >> 2] = 0; F[a + 612 >> 2] = 0; F[a + 604 >> 2] = 0; F[a + 608 >> 2] = 0; g = a + 628 | 0; a: {
                            b: {
                                if (b) {
                                    if (b >>> 0 < 1073741824) {
                                        break b;
                                    }
                                    va();
                                    V();
                                }
                                F[a + 616 >> 2] = 0;
                                F[a + 620 >> 2] = 0;
                                F[a + 624 >> 2] = 0;
                                F[e + 8 >> 2] = 0;
                                F[e >> 2] = 0;
                                F[e + 4 >> 2] = 0;
                                d = 1;
                                break a;
                            }
                            d = b << 2;
                            c = sa(d);
                            F[a + 604 >> 2] = c;
                            f = c + d | 0;
                            F[a + 612 >> 2] = f;
                            ua(c, 0, d);
                            F[a + 624 >> 2] = 0;
                            F[a + 616 >> 2] = 0;
                            F[a + 620 >> 2] = 0;
                            F[a + 608 >> 2] = f;
                            c = sa(d);
                            F[a + 616 >> 2] = c;
                            f = c + d | 0;
                            F[a + 624 >> 2] = f;
                            ua(c, 0, d);
                            F[a + 620 >> 2] = f;
                            c = sa(d);
                            F[e >> 2] = c;
                            f = c + d | 0;
                            F[e + 8 >> 2] = f;
                            ua(c, 0, d);
                            F[e + 4 >> 2] = f;
                            d = b << 5 | 1;
                        } wb(g, d, e); c = F[e >> 2]; if (c) {
                            F[e + 4 >> 2] = c;
                            ra(c);
                        } F[e + 8 >> 2] = 0; F[e >> 2] = 0; F[e + 4 >> 2] = 0; if (b) {
                            b = b << 2;
                            c = sa(b);
                            F[e >> 2] = c;
                            f = b + c | 0;
                            F[e + 8 >> 2] = f;
                            ua(c, 0, b);
                            F[e + 4 >> 2] = f;
                        } wb(a + 640 | 0, d, e); b = F[e >> 2]; if (b) {
                            F[e + 4 >> 2] = b;
                            ra(b);
                        } ea = e + 16 | 0; return a; }
                        function oi(a) { a = a | 0; var b = 0, c = 0, d = 0, e = 0, f = 0; c = F[a + 32 >> 2]; e = F[c + 16 >> 2]; d = F[c + 12 >> 2]; b = F[c + 20 >> 2]; if (I[c + 8 >> 2] > e >>> 0 & (d | 0) >= (b | 0) | (b | 0) < (d | 0)) {
                            f = G[e + F[c >> 2] | 0];
                            d = e + 1 | 0;
                            b = d ? b : b + 1 | 0;
                            F[c + 16 >> 2] = d;
                            F[c + 20 >> 2] = b;
                            c = F[a + 48 >> 2];
                            F[a + 48 >> 2] = 0;
                            if (c) {
                                ga[F[F[c >> 2] + 4 >> 2]](c);
                            }
                            a: {
                                b: {
                                    c: {
                                        d: {
                                            switch (f | 0) {
                                                case 0:
                                                    c = sa(384);
                                                    F[c >> 2] = 11412;
                                                    ua(c + 4 | 0, 0, 80);
                                                    F[c + 96 >> 2] = 0;
                                                    F[c + 100 >> 2] = 0;
                                                    F[c + 92 >> 2] = -1;
                                                    F[c + 84 >> 2] = -1;
                                                    F[c + 88 >> 2] = -1;
                                                    F[c + 104 >> 2] = 0;
                                                    F[c + 108 >> 2] = 0;
                                                    F[c + 112 >> 2] = 0;
                                                    F[c + 116 >> 2] = 0;
                                                    F[c + 120 >> 2] = 0;
                                                    F[c + 124 >> 2] = 0;
                                                    F[c + 128 >> 2] = 0;
                                                    F[c + 132 >> 2] = 0;
                                                    F[c + 136 >> 2] = 0;
                                                    F[c + 140 >> 2] = 0;
                                                    F[c + 144 >> 2] = 0;
                                                    F[c + 148 >> 2] = 0;
                                                    F[c + 156 >> 2] = 0;
                                                    F[c + 160 >> 2] = 0;
                                                    F[c + 152 >> 2] = 1065353216;
                                                    F[c + 164 >> 2] = 0;
                                                    F[c + 168 >> 2] = 0;
                                                    F[c + 172 >> 2] = 0;
                                                    F[c + 176 >> 2] = 0;
                                                    F[c + 180 >> 2] = 0;
                                                    F[c + 184 >> 2] = 0;
                                                    F[c + 188 >> 2] = 0;
                                                    F[c + 192 >> 2] = 0;
                                                    F[c + 196 >> 2] = 0;
                                                    F[c + 200 >> 2] = 0;
                                                    F[c + 204 >> 2] = 0;
                                                    F[c + 208 >> 2] = 0;
                                                    F[c + 212 >> 2] = -1;
                                                    F[c + 216 >> 2] = 0;
                                                    F[c + 220 >> 2] = 0;
                                                    F[c + 224 >> 2] = 0;
                                                    b = c + 232 | 0;
                                                    E[b + 38 >> 1] = 0;
                                                    F[b >> 2] = 0;
                                                    F[b + 8 >> 2] = 0;
                                                    F[b + 12 >> 2] = 0;
                                                    F[b + 16 >> 2] = 0;
                                                    F[b + 20 >> 2] = 0;
                                                    F[b + 24 >> 2] = 0;
                                                    F[b + 28 >> 2] = 0;
                                                    D[b + 29 | 0] = 0;
                                                    D[b + 30 | 0] = 0;
                                                    D[b + 31 | 0] = 0;
                                                    D[b + 32 | 0] = 0;
                                                    D[b + 33 | 0] = 0;
                                                    D[b + 34 | 0] = 0;
                                                    D[b + 35 | 0] = 0;
                                                    D[b + 36 | 0] = 0;
                                                    b = c + 272 | 0;
                                                    E[b + 38 >> 1] = 0;
                                                    F[b >> 2] = 0;
                                                    F[b + 8 >> 2] = 0;
                                                    F[b + 12 >> 2] = 0;
                                                    F[b + 16 >> 2] = 0;
                                                    F[b + 20 >> 2] = 0;
                                                    F[b + 24 >> 2] = 0;
                                                    F[b + 28 >> 2] = 0;
                                                    D[b + 29 | 0] = 0;
                                                    D[b + 30 | 0] = 0;
                                                    D[b + 31 | 0] = 0;
                                                    D[b + 32 | 0] = 0;
                                                    D[b + 33 | 0] = 0;
                                                    D[b + 34 | 0] = 0;
                                                    D[b + 35 | 0] = 0;
                                                    D[b + 36 | 0] = 0;
                                                    b = c + 312 | 0;
                                                    F[b >> 2] = 0;
                                                    F[b + 4 >> 2] = 0;
                                                    D[b + 5 | 0] = 0;
                                                    D[b + 6 | 0] = 0;
                                                    D[b + 7 | 0] = 0;
                                                    D[b + 8 | 0] = 0;
                                                    D[b + 9 | 0] = 0;
                                                    D[b + 10 | 0] = 0;
                                                    D[b + 11 | 0] = 0;
                                                    D[b + 12 | 0] = 0;
                                                    b = c + 328 | 0;
                                                    E[b + 38 >> 1] = 0;
                                                    F[b >> 2] = 0;
                                                    F[b + 8 >> 2] = 0;
                                                    F[b + 12 >> 2] = 0;
                                                    F[b + 16 >> 2] = 0;
                                                    F[b + 20 >> 2] = 0;
                                                    F[b + 24 >> 2] = 0;
                                                    F[b + 28 >> 2] = 0;
                                                    D[b + 29 | 0] = 0;
                                                    D[b + 30 | 0] = 0;
                                                    D[b + 31 | 0] = 0;
                                                    D[b + 32 | 0] = 0;
                                                    D[b + 33 | 0] = 0;
                                                    D[b + 34 | 0] = 0;
                                                    D[b + 35 | 0] = 0;
                                                    D[b + 36 | 0] = 0;
                                                    F[c + 376 >> 2] = 0;
                                                    F[c + 368 >> 2] = 0;
                                                    F[c + 372 >> 2] = 0;
                                                    break c;
                                                case 1:
                                                    c = sa(424);
                                                    F[c >> 2] = 11464;
                                                    ua(c + 4 | 0, 0, 80);
                                                    F[c + 96 >> 2] = 0;
                                                    F[c + 100 >> 2] = 0;
                                                    F[c + 92 >> 2] = -1;
                                                    F[c + 84 >> 2] = -1;
                                                    F[c + 88 >> 2] = -1;
                                                    F[c + 104 >> 2] = 0;
                                                    F[c + 108 >> 2] = 0;
                                                    F[c + 112 >> 2] = 0;
                                                    F[c + 116 >> 2] = 0;
                                                    F[c + 120 >> 2] = 0;
                                                    F[c + 124 >> 2] = 0;
                                                    F[c + 128 >> 2] = 0;
                                                    F[c + 132 >> 2] = 0;
                                                    F[c + 136 >> 2] = 0;
                                                    F[c + 140 >> 2] = 0;
                                                    F[c + 144 >> 2] = 0;
                                                    F[c + 148 >> 2] = 0;
                                                    F[c + 156 >> 2] = 0;
                                                    F[c + 160 >> 2] = 0;
                                                    F[c + 152 >> 2] = 1065353216;
                                                    F[c + 164 >> 2] = 0;
                                                    F[c + 168 >> 2] = 0;
                                                    F[c + 172 >> 2] = 0;
                                                    F[c + 176 >> 2] = 0;
                                                    F[c + 180 >> 2] = 0;
                                                    F[c + 184 >> 2] = 0;
                                                    F[c + 188 >> 2] = 0;
                                                    F[c + 192 >> 2] = 0;
                                                    F[c + 196 >> 2] = 0;
                                                    F[c + 200 >> 2] = 0;
                                                    F[c + 204 >> 2] = 0;
                                                    F[c + 208 >> 2] = 0;
                                                    F[c + 212 >> 2] = -1;
                                                    F[c + 216 >> 2] = 0;
                                                    F[c + 220 >> 2] = 0;
                                                    F[c + 224 >> 2] = 0;
                                                    b = c + 232 | 0;
                                                    E[b + 38 >> 1] = 0;
                                                    F[b >> 2] = 0;
                                                    F[b + 8 >> 2] = 0;
                                                    F[b + 12 >> 2] = 0;
                                                    F[b + 16 >> 2] = 0;
                                                    F[b + 20 >> 2] = 0;
                                                    F[b + 24 >> 2] = 0;
                                                    F[b + 28 >> 2] = 0;
                                                    D[b + 29 | 0] = 0;
                                                    D[b + 30 | 0] = 0;
                                                    D[b + 31 | 0] = 0;
                                                    D[b + 32 | 0] = 0;
                                                    D[b + 33 | 0] = 0;
                                                    D[b + 34 | 0] = 0;
                                                    D[b + 35 | 0] = 0;
                                                    D[b + 36 | 0] = 0;
                                                    b = c + 272 | 0;
                                                    E[b + 38 >> 1] = 0;
                                                    F[b >> 2] = 0;
                                                    F[b + 8 >> 2] = 0;
                                                    F[b + 12 >> 2] = 0;
                                                    F[b + 16 >> 2] = 0;
                                                    F[b + 20 >> 2] = 0;
                                                    F[b + 24 >> 2] = 0;
                                                    F[b + 28 >> 2] = 0;
                                                    D[b + 29 | 0] = 0;
                                                    D[b + 30 | 0] = 0;
                                                    D[b + 31 | 0] = 0;
                                                    D[b + 32 | 0] = 0;
                                                    D[b + 33 | 0] = 0;
                                                    D[b + 34 | 0] = 0;
                                                    D[b + 35 | 0] = 0;
                                                    D[b + 36 | 0] = 0;
                                                    b = c + 312 | 0;
                                                    F[b >> 2] = 0;
                                                    F[b + 4 >> 2] = 0;
                                                    D[b + 5 | 0] = 0;
                                                    D[b + 6 | 0] = 0;
                                                    D[b + 7 | 0] = 0;
                                                    D[b + 8 | 0] = 0;
                                                    D[b + 9 | 0] = 0;
                                                    D[b + 10 | 0] = 0;
                                                    D[b + 11 | 0] = 0;
                                                    D[b + 12 | 0] = 0;
                                                    b = c + 328 | 0;
                                                    E[b + 38 >> 1] = 0;
                                                    F[b >> 2] = 0;
                                                    F[b + 8 >> 2] = 0;
                                                    F[b + 12 >> 2] = 0;
                                                    F[b + 16 >> 2] = 0;
                                                    F[b + 20 >> 2] = 0;
                                                    F[b + 24 >> 2] = 0;
                                                    F[b + 28 >> 2] = 0;
                                                    D[b + 29 | 0] = 0;
                                                    D[b + 30 | 0] = 0;
                                                    D[b + 31 | 0] = 0;
                                                    D[b + 32 | 0] = 0;
                                                    D[b + 33 | 0] = 0;
                                                    D[b + 34 | 0] = 0;
                                                    D[b + 35 | 0] = 0;
                                                    D[b + 36 | 0] = 0;
                                                    F[c + 392 >> 2] = 0;
                                                    F[c + 396 >> 2] = 0;
                                                    F[c + 384 >> 2] = 0;
                                                    F[c + 388 >> 2] = 0;
                                                    F[c + 376 >> 2] = 0;
                                                    F[c + 380 >> 2] = 0;
                                                    F[c + 368 >> 2] = 0;
                                                    F[c + 372 >> 2] = 0;
                                                    b = c + 400 | 0;
                                                    F[b >> 2] = 0;
                                                    F[b + 4 >> 2] = 0;
                                                    D[b + 5 | 0] = 0;
                                                    D[b + 6 | 0] = 0;
                                                    D[b + 7 | 0] = 0;
                                                    D[b + 8 | 0] = 0;
                                                    D[b + 9 | 0] = 0;
                                                    D[b + 10 | 0] = 0;
                                                    D[b + 11 | 0] = 0;
                                                    D[b + 12 | 0] = 0;
                                                    F[c + 416 >> 2] = -1;
                                                    F[c + 420 >> 2] = -1;
                                                    break c;
                                                case 2: break d;
                                                default: break b;
                                            }
                                        }
                                        c = sa(440);
                                        F[c >> 2] = 11512;
                                        ua(c + 4 | 0, 0, 80);
                                        F[c + 96 >> 2] = 0;
                                        F[c + 100 >> 2] = 0;
                                        F[c + 92 >> 2] = -1;
                                        F[c + 84 >> 2] = -1;
                                        F[c + 88 >> 2] = -1;
                                        F[c + 104 >> 2] = 0;
                                        F[c + 108 >> 2] = 0;
                                        F[c + 112 >> 2] = 0;
                                        F[c + 116 >> 2] = 0;
                                        F[c + 120 >> 2] = 0;
                                        F[c + 124 >> 2] = 0;
                                        F[c + 128 >> 2] = 0;
                                        F[c + 132 >> 2] = 0;
                                        F[c + 136 >> 2] = 0;
                                        F[c + 140 >> 2] = 0;
                                        F[c + 144 >> 2] = 0;
                                        F[c + 148 >> 2] = 0;
                                        F[c + 156 >> 2] = 0;
                                        F[c + 160 >> 2] = 0;
                                        F[c + 152 >> 2] = 1065353216;
                                        F[c + 164 >> 2] = 0;
                                        F[c + 168 >> 2] = 0;
                                        F[c + 172 >> 2] = 0;
                                        F[c + 176 >> 2] = 0;
                                        F[c + 180 >> 2] = 0;
                                        F[c + 184 >> 2] = 0;
                                        F[c + 188 >> 2] = 0;
                                        F[c + 192 >> 2] = 0;
                                        F[c + 196 >> 2] = 0;
                                        F[c + 200 >> 2] = 0;
                                        F[c + 204 >> 2] = 0;
                                        F[c + 208 >> 2] = 0;
                                        F[c + 212 >> 2] = -1;
                                        F[c + 216 >> 2] = 0;
                                        F[c + 220 >> 2] = 0;
                                        F[c + 224 >> 2] = 0;
                                        b = c + 232 | 0;
                                        E[b + 38 >> 1] = 0;
                                        F[b >> 2] = 0;
                                        F[b + 8 >> 2] = 0;
                                        F[b + 12 >> 2] = 0;
                                        F[b + 16 >> 2] = 0;
                                        F[b + 20 >> 2] = 0;
                                        F[b + 24 >> 2] = 0;
                                        F[b + 28 >> 2] = 0;
                                        D[b + 29 | 0] = 0;
                                        D[b + 30 | 0] = 0;
                                        D[b + 31 | 0] = 0;
                                        D[b + 32 | 0] = 0;
                                        D[b + 33 | 0] = 0;
                                        D[b + 34 | 0] = 0;
                                        D[b + 35 | 0] = 0;
                                        D[b + 36 | 0] = 0;
                                        b = c + 272 | 0;
                                        E[b + 38 >> 1] = 0;
                                        F[b >> 2] = 0;
                                        F[b + 8 >> 2] = 0;
                                        F[b + 12 >> 2] = 0;
                                        F[b + 16 >> 2] = 0;
                                        F[b + 20 >> 2] = 0;
                                        F[b + 24 >> 2] = 0;
                                        F[b + 28 >> 2] = 0;
                                        D[b + 29 | 0] = 0;
                                        D[b + 30 | 0] = 0;
                                        D[b + 31 | 0] = 0;
                                        D[b + 32 | 0] = 0;
                                        D[b + 33 | 0] = 0;
                                        D[b + 34 | 0] = 0;
                                        D[b + 35 | 0] = 0;
                                        D[b + 36 | 0] = 0;
                                        b = c + 312 | 0;
                                        F[b >> 2] = 0;
                                        F[b + 4 >> 2] = 0;
                                        D[b + 5 | 0] = 0;
                                        D[b + 6 | 0] = 0;
                                        D[b + 7 | 0] = 0;
                                        D[b + 8 | 0] = 0;
                                        D[b + 9 | 0] = 0;
                                        D[b + 10 | 0] = 0;
                                        D[b + 11 | 0] = 0;
                                        D[b + 12 | 0] = 0;
                                        b = c + 328 | 0;
                                        E[b + 38 >> 1] = 0;
                                        F[b >> 2] = 0;
                                        F[b + 8 >> 2] = 0;
                                        F[b + 12 >> 2] = 0;
                                        F[b + 16 >> 2] = 0;
                                        F[b + 20 >> 2] = 0;
                                        F[b + 24 >> 2] = 0;
                                        F[b + 28 >> 2] = 0;
                                        D[b + 29 | 0] = 0;
                                        D[b + 30 | 0] = 0;
                                        D[b + 31 | 0] = 0;
                                        D[b + 32 | 0] = 0;
                                        D[b + 33 | 0] = 0;
                                        D[b + 34 | 0] = 0;
                                        D[b + 35 | 0] = 0;
                                        D[b + 36 | 0] = 0;
                                        F[c + 392 >> 2] = 0;
                                        F[c + 396 >> 2] = 0;
                                        F[c + 384 >> 2] = 0;
                                        F[c + 388 >> 2] = 0;
                                        F[c + 376 >> 2] = 0;
                                        F[c + 380 >> 2] = 0;
                                        F[c + 368 >> 2] = 0;
                                        F[c + 372 >> 2] = 0;
                                        F[c + 416 >> 2] = 0;
                                        F[c + 420 >> 2] = 0;
                                        F[c + 408 >> 2] = 2;
                                        F[c + 412 >> 2] = 7;
                                        F[c + 400 >> 2] = -1;
                                        F[c + 404 >> 2] = -1;
                                        F[c + 424 >> 2] = 0;
                                        F[c + 428 >> 2] = 0;
                                        F[c + 432 >> 2] = 0;
                                        F[c + 436 >> 2] = 0;
                                    }
                                    b = F[a + 48 >> 2];
                                    F[a + 48 >> 2] = c;
                                    if (!b) {
                                        break a;
                                    }
                                    ga[F[F[b >> 2] + 4 >> 2]](b);
                                }
                                c = F[a + 48 >> 2];
                                if (c) {
                                    break a;
                                }
                                return 0;
                            }
                            a = ga[F[F[c >> 2] + 8 >> 2]](c, a) | 0;
                        }
                        else {
                            a = 0;
                        } return a | 0; }
                        function qj(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, E = 0, H = 0, I = 0, J = 0, K = 0, L = 0, M = 0, N = 0, O = 0, P = 0, Q = 0, R = 0, S = 0, T = 0, U = 0, W = 0, X = 0; if ((e | 0) == 2) {
                            F[a + 8 >> 2] = 2;
                            F[a - -64 >> 2] = f;
                            e = a + 32 | 0;
                            f = F[e >> 2];
                            d = F[a + 36 >> 2] - f | 0;
                            a: {
                                if (d >>> 0 <= 7) {
                                    Aa(e, 2 - (d >>> 2 | 0) | 0);
                                    break a;
                                }
                                if ((d | 0) == 8) {
                                    break a;
                                }
                                F[a + 36 >> 2] = f + 8;
                            }
                            b: {
                                d = F[a + 56 >> 2];
                                e = F[d + 4 >> 2];
                                d = F[d >> 2];
                                f = e - d | 0;
                                if ((f | 0) <= 0) {
                                    f = 0;
                                    break b;
                                }
                                if ((d | 0) != (e | 0)) {
                                    m = a + 60 | 0;
                                    J = f >> 2;
                                    T = (J | 0) > 1 ? J : 1;
                                    f = 1;
                                    while (1) {
                                        j = ea - 80 | 0;
                                        ea = j;
                                        e = -1;
                                        d = F[(q << 2) + d >> 2];
                                        g = -1;
                                        c: {
                                            if ((d | 0) == -1) {
                                                break c;
                                            }
                                            e = d + 1 | 0;
                                            e = (e >>> 0) % 3 | 0 ? e : d - 2 | 0;
                                            g = d - 1 | 0;
                                            if ((d >>> 0) % 3 | 0) {
                                                break c;
                                            }
                                            g = d + 2 | 0;
                                        }
                                        i = F[m + 36 >> 2];
                                        d = F[i >> 2];
                                        d: {
                                            e: {
                                                f: {
                                                    g: {
                                                        h: {
                                                            i = F[i + 4 >> 2] - d >> 2;
                                                            h = e << 2;
                                                            e = F[F[m + 32 >> 2] + 28 >> 2];
                                                            k = F[h + e >> 2];
                                                            if (i >>> 0 <= k >>> 0) {
                                                                break h;
                                                            }
                                                            e = F[e + (g << 2) >> 2];
                                                            if (e >>> 0 >= i >>> 0) {
                                                                break h;
                                                            }
                                                            i: {
                                                                j: {
                                                                    g = F[d + (e << 2) >> 2];
                                                                    i = F[d + (k << 2) >> 2];
                                                                    if ((g | 0) >= (q | 0) | (i | 0) >= (q | 0)) {
                                                                        break j;
                                                                    }
                                                                    d = (g << 3) + c | 0;
                                                                    v = F[d + 4 >> 2];
                                                                    e = (i << 3) + c | 0;
                                                                    s = F[e + 4 >> 2];
                                                                    x = F[d >> 2];
                                                                    C = F[e >> 2];
                                                                    if (!((x | 0) != (C | 0) | (s | 0) != (v | 0))) {
                                                                        F[m + 8 >> 2] = C;
                                                                        F[m + 12 >> 2] = s;
                                                                        break i;
                                                                    }
                                                                    d = F[F[m + 4 >> 2] + (q << 2) >> 2];
                                                                    F[j + 72 >> 2] = 0;
                                                                    F[j + 76 >> 2] = 0;
                                                                    e = j - -64 | 0;
                                                                    F[e >> 2] = 0;
                                                                    F[e + 4 >> 2] = 0;
                                                                    F[j + 56 >> 2] = 0;
                                                                    F[j + 60 >> 2] = 0;
                                                                    e = F[m >> 2];
                                                                    if (!G[e + 84 | 0]) {
                                                                        d = F[F[e + 68 >> 2] + (d << 2) >> 2];
                                                                    }
                                                                    Ta(e, d, D[e + 24 | 0], j + 56 | 0);
                                                                    d = F[F[m + 4 >> 2] + (i << 2) >> 2];
                                                                    F[j + 48 >> 2] = 0;
                                                                    F[j + 52 >> 2] = 0;
                                                                    F[j + 40 >> 2] = 0;
                                                                    F[j + 44 >> 2] = 0;
                                                                    F[j + 32 >> 2] = 0;
                                                                    F[j + 36 >> 2] = 0;
                                                                    e = F[m >> 2];
                                                                    if (!G[e + 84 | 0]) {
                                                                        d = F[F[e + 68 >> 2] + (d << 2) >> 2];
                                                                    }
                                                                    Ta(e, d, D[e + 24 | 0], j + 32 | 0);
                                                                    d = F[F[m + 4 >> 2] + (g << 2) >> 2];
                                                                    F[j + 24 >> 2] = 0;
                                                                    F[j + 28 >> 2] = 0;
                                                                    F[j + 16 >> 2] = 0;
                                                                    F[j + 20 >> 2] = 0;
                                                                    F[j + 8 >> 2] = 0;
                                                                    F[j + 12 >> 2] = 0;
                                                                    e = F[m >> 2];
                                                                    if (!G[e + 84 | 0]) {
                                                                        d = F[F[e + 68 >> 2] + (d << 2) >> 2];
                                                                    }
                                                                    Ta(e, d, D[e + 24 | 0], j + 8 | 0);
                                                                    K = F[j + 44 >> 2];
                                                                    d = F[j + 16 >> 2];
                                                                    E = F[j + 40 >> 2];
                                                                    e = E;
                                                                    k = F[j + 20 >> 2] - (K + (d >>> 0 < e >>> 0) | 0) | 0;
                                                                    o = d - e | 0;
                                                                    d = Hj(o, k, o, k);
                                                                    e = fa;
                                                                    n = d;
                                                                    L = F[j + 36 >> 2];
                                                                    d = F[j + 8 >> 2];
                                                                    H = F[j + 32 >> 2];
                                                                    g = H;
                                                                    h = F[j + 12 >> 2] - (L + (d >>> 0 < g >>> 0) | 0) | 0;
                                                                    t = d - g | 0;
                                                                    g = Hj(t, h, t, h);
                                                                    d = n + g | 0;
                                                                    e = fa + e | 0;
                                                                    e = d >>> 0 < g >>> 0 ? e + 1 | 0 : e;
                                                                    n = d;
                                                                    M = F[j + 52 >> 2];
                                                                    d = F[j + 24 >> 2];
                                                                    I = F[j + 48 >> 2];
                                                                    g = I;
                                                                    l = F[j + 28 >> 2] - (M + (d >>> 0 < g >>> 0) | 0) | 0;
                                                                    p = d - g | 0;
                                                                    r = Hj(p, l, p, l);
                                                                    d = n + r | 0;
                                                                    g = fa + e | 0;
                                                                    u = d;
                                                                    r = d >>> 0 < r >>> 0 ? g + 1 | 0 : g;
                                                                    if (!(d | r)) {
                                                                        break j;
                                                                    }
                                                                    n = F[j + 64 >> 2];
                                                                    d = n;
                                                                    O = F[j + 68 >> 2];
                                                                    d = Hj(d - E | 0, O - ((d >>> 0 < E >>> 0) + K | 0) | 0, o, k);
                                                                    e = fa;
                                                                    g = d;
                                                                    P = F[j + 56 >> 2];
                                                                    d = P;
                                                                    Q = F[j + 60 >> 2];
                                                                    i = Hj(d - H | 0, Q - ((d >>> 0 < H >>> 0) + L | 0) | 0, t, h);
                                                                    d = g + i | 0;
                                                                    g = fa + e | 0;
                                                                    g = d >>> 0 < i >>> 0 ? g + 1 | 0 : g;
                                                                    e = d;
                                                                    R = F[j + 72 >> 2];
                                                                    d = R;
                                                                    S = F[j + 76 >> 2];
                                                                    i = Hj(d - I | 0, S - ((d >>> 0 < I >>> 0) + M | 0) | 0, p, l);
                                                                    d = e + i | 0;
                                                                    e = fa + g | 0;
                                                                    y = d;
                                                                    w = d >>> 0 < i >>> 0 ? e + 1 | 0 : e;
                                                                    d = l >> 31;
                                                                    e = d + p | 0;
                                                                    g = d + l | 0;
                                                                    g = e >>> 0 < d >>> 0 ? g + 1 | 0 : g;
                                                                    e = e ^ d;
                                                                    d = d ^ g;
                                                                    i = d;
                                                                    d = k >> 31;
                                                                    z = d + o | 0;
                                                                    g = d + k | 0;
                                                                    A = d ^ z;
                                                                    d = d ^ (d >>> 0 > z >>> 0 ? g + 1 | 0 : g);
                                                                    z = d;
                                                                    N = 0;
                                                                    d = h >> 31;
                                                                    B = d + t | 0;
                                                                    g = d + h | 0;
                                                                    g = B >>> 0 < d >>> 0 ? g + 1 | 0 : g;
                                                                    U = e;
                                                                    B = B ^ d;
                                                                    d = d ^ g;
                                                                    g = (z | 0) == (d | 0) & A >>> 0 > B >>> 0 | d >>> 0 < z >>> 0;
                                                                    A = g ? A : B;
                                                                    d = g ? z : d;
                                                                    e = (i | 0) == (d | 0) & e >>> 0 > A >>> 0 | d >>> 0 < i >>> 0;
                                                                    e = Jj(-1, 2147483647, e ? U : A, e ? i : d) >>> 0 < y >>> 0;
                                                                    d = fa;
                                                                    if (e & (d | 0) <= (w | 0) | (d | 0) < (w | 0)) {
                                                                        break d;
                                                                    }
                                                                    i = 1;
                                                                    d = 0;
                                                                    e = n;
                                                                    o = Ij(Hj(o, k, y, w), fa, u, r);
                                                                    k = o + E | 0;
                                                                    g = fa + K | 0;
                                                                    g = k >>> 0 < o >>> 0 ? g + 1 | 0 : g;
                                                                    g = O - ((e >>> 0 < k >>> 0) + g | 0) | 0;
                                                                    e = e - k | 0;
                                                                    g = Hj(e, g, e, g);
                                                                    o = fa;
                                                                    e = P;
                                                                    n = g;
                                                                    h = Ij(Hj(t, h, y, w), fa, u, r);
                                                                    k = h + H | 0;
                                                                    g = fa + L | 0;
                                                                    g = h >>> 0 > k >>> 0 ? g + 1 | 0 : g;
                                                                    g = Q - ((e >>> 0 < k >>> 0) + g | 0) | 0;
                                                                    e = e - k | 0;
                                                                    k = Hj(e, g, e, g);
                                                                    g = n + k | 0;
                                                                    e = fa + o | 0;
                                                                    e = g >>> 0 < k >>> 0 ? e + 1 | 0 : e;
                                                                    k = e;
                                                                    e = R;
                                                                    n = g;
                                                                    l = Ij(Hj(p, l, y, w), fa, u, r);
                                                                    h = l + I | 0;
                                                                    g = fa + M | 0;
                                                                    g = h >>> 0 < l >>> 0 ? g + 1 | 0 : g;
                                                                    g = S - ((e >>> 0 < h >>> 0) + g | 0) | 0;
                                                                    e = e - h | 0;
                                                                    h = Hj(e, g, e, g);
                                                                    e = n + h | 0;
                                                                    g = fa + k | 0;
                                                                    k = Hj(e, e >>> 0 < h >>> 0 ? g + 1 | 0 : g, u, r);
                                                                    e = fa;
                                                                    h = e;
                                                                    if (!e & k >>> 0 <= 1) {
                                                                        break g;
                                                                    }
                                                                    l = k;
                                                                    e = h;
                                                                    while (1) {
                                                                        g = d << 1 | i >>> 31;
                                                                        i = i << 1;
                                                                        d = g;
                                                                        o = !e & l >>> 0 > 7 | (e | 0) != 0;
                                                                        l = (e & 3) << 30 | l >>> 2;
                                                                        e = e >>> 2 | 0;
                                                                        if (o) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    break f;
                                                                }
                                                                if ((i | 0) < (q | 0)) {
                                                                    d = i << 1;
                                                                }
                                                                else {
                                                                    if ((q | 0) <= 0) {
                                                                        F[m + 8 >> 2] = 0;
                                                                        F[m + 12 >> 2] = 0;
                                                                        break i;
                                                                    }
                                                                    d = (q << 1) - 2 | 0;
                                                                }
                                                                d = (d << 2) + c | 0;
                                                                F[m + 8 >> 2] = F[d >> 2];
                                                                F[m + 12 >> 2] = F[d + 4 >> 2];
                                                            }
                                                            N = 1;
                                                            break d;
                                                        }
                                                        Da();
                                                        V();
                                                    }
                                                    d = h;
                                                    i = k;
                                                    if (i - 1 | 0) {
                                                        break e;
                                                    }
                                                }
                                                while (1) {
                                                    e = Jj(k, h, i, d) + i | 0;
                                                    g = d + fa | 0;
                                                    g = e >>> 0 < i >>> 0 ? g + 1 | 0 : g;
                                                    i = (g & 1) << 31 | e >>> 1;
                                                    d = g >>> 1 | 0;
                                                    e = Hj(i, d, i, d);
                                                    g = fa;
                                                    if ((h | 0) == (g | 0) & e >>> 0 > k >>> 0 | g >>> 0 > h >>> 0) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            k = F[m + 20 >> 2];
                                            if (k) {
                                                e = k - 1 | 0;
                                                l = F[F[m + 16 >> 2] + (e >>> 3 & 536870908) >> 2];
                                                F[m + 20 >> 2] = e;
                                                g = s;
                                                o = v - g | 0;
                                                h = g >> 31;
                                                t = (v >> 31) - (h + (g >>> 0 > v >>> 0) | 0) | 0;
                                                g = Hj(y, w, o, t);
                                                p = fa;
                                                s = Hj(s, h, u, r);
                                                h = s + g | 0;
                                                g = fa + p | 0;
                                                g = h >>> 0 < s >>> 0 ? g + 1 | 0 : g;
                                                n = h;
                                                h = C;
                                                p = x - h | 0;
                                                s = h >> 31;
                                                v = (x >> 31) - (s + (h >>> 0 > x >>> 0) | 0) | 0;
                                                h = Hj(i, d, p, v);
                                                x = h;
                                                e = l >>> e & 1;
                                                l = e ? 0 - h | 0 : h;
                                                h = n + l | 0;
                                                n = g;
                                                g = fa;
                                                g = n + (e ? 0 - (g + ((x | 0) != 0) | 0) | 0 : g) | 0;
                                                W = m, X = Ij(h, h >>> 0 < l >>> 0 ? g + 1 | 0 : g, u, r), F[W + 12 >> 2] = X;
                                                g = Hj(p, v, y, w);
                                                l = fa;
                                                p = Hj(u, r, C, s);
                                                h = p + g | 0;
                                                g = fa + l | 0;
                                                g = h >>> 0 < p >>> 0 ? g + 1 | 0 : g;
                                                n = h;
                                                d = Hj(i, d, o, t);
                                                h = e ? d : 0 - d | 0;
                                                i = n + h | 0;
                                                n = g;
                                                g = fa;
                                                e = n + (e ? g : 0 - (((d | 0) != 0) + g | 0) | 0) | 0;
                                                W = m, X = Ij(i, i >>> 0 < h >>> 0 ? e + 1 | 0 : e, u, r), F[W + 8 >> 2] = X;
                                            }
                                            N = (k | 0) != 0;
                                        }
                                        ea = j + 80 | 0;
                                        if (!N) {
                                            break b;
                                        }
                                        k: {
                                            if (F[a + 8 >> 2] <= 0) {
                                                break k;
                                            }
                                            g = F[a + 32 >> 2];
                                            d = 0;
                                            while (1) {
                                                e = d << 2;
                                                f = F[(e + a | 0) + 68 >> 2];
                                                i = F[a + 16 >> 2];
                                                l: {
                                                    if ((f | 0) > (i | 0)) {
                                                        F[e + g >> 2] = i;
                                                        break l;
                                                    }
                                                    e = e + g | 0;
                                                    i = F[a + 12 >> 2];
                                                    if ((i | 0) > (f | 0)) {
                                                        F[e >> 2] = i;
                                                        break l;
                                                    }
                                                    F[e >> 2] = f;
                                                }
                                                d = d + 1 | 0;
                                                f = F[a + 8 >> 2];
                                                if ((d | 0) < (f | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            e = 0;
                                            if ((f | 0) <= 0) {
                                                break k;
                                            }
                                            d = q << 3;
                                            i = d + c | 0;
                                            k = b + d | 0;
                                            while (1) {
                                                f = e << 2;
                                                d = f + i | 0;
                                                f = F[f + k >> 2] + F[f + g >> 2] | 0;
                                                F[d >> 2] = f;
                                                m: {
                                                    if ((f | 0) > F[a + 16 >> 2]) {
                                                        f = f - F[a + 20 >> 2] | 0;
                                                    }
                                                    else {
                                                        if ((f | 0) >= F[a + 12 >> 2]) {
                                                            break m;
                                                        }
                                                        f = f + F[a + 20 >> 2] | 0;
                                                    }
                                                    F[d >> 2] = f;
                                                }
                                                e = e + 1 | 0;
                                                if ((e | 0) < F[a + 8 >> 2]) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        q = q + 1 | 0;
                                        f = (J | 0) > (q | 0);
                                        if ((q | 0) == (T | 0)) {
                                            break b;
                                        }
                                        e = F[a + 56 >> 2];
                                        d = F[e >> 2];
                                        if (F[e + 4 >> 2] - d >> 2 >>> 0 > q >>> 0) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                Da();
                                V();
                            }
                            a = f ^ 1;
                        }
                        else {
                            a = 0;
                        } return a & 1; }
                        function bj(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, E = 0, H = 0, I = 0, J = 0, K = 0, L = 0, M = 0, N = 0, O = 0, P = 0, Q = 0, R = 0, S = 0, T = 0, U = 0, W = 0; if ((e | 0) == 2) {
                            F[a + 8 >> 2] = 2;
                            F[a - -64 >> 2] = f;
                            e = a + 32 | 0;
                            f = F[e >> 2];
                            d = F[a + 36 >> 2] - f | 0;
                            a: {
                                if (d >>> 0 <= 7) {
                                    Aa(e, 2 - (d >>> 2 | 0) | 0);
                                    break a;
                                }
                                if ((d | 0) == 8) {
                                    break a;
                                }
                                F[a + 36 >> 2] = f + 8;
                            }
                            b: {
                                d = F[a + 56 >> 2];
                                e = F[d + 4 >> 2];
                                d = F[d >> 2];
                                f = e - d | 0;
                                if ((f | 0) <= 0) {
                                    f = 0;
                                    break b;
                                }
                                if ((d | 0) != (e | 0)) {
                                    m = a + 60 | 0;
                                    I = f >> 2;
                                    T = (I | 0) > 1 ? I : 1;
                                    f = 1;
                                    while (1) {
                                        i = ea - 80 | 0;
                                        ea = i;
                                        e = -1;
                                        c: {
                                            d: {
                                                g = F[(p << 2) + d >> 2];
                                                if ((g | 0) == -1) {
                                                    break d;
                                                }
                                                h = F[m + 32 >> 2];
                                                d = g + 1 | 0;
                                                d = (d >>> 0) % 3 | 0 ? d : g - 2 | 0;
                                                if ((d | 0) != -1) {
                                                    e = F[F[h >> 2] + (d << 2) >> 2];
                                                }
                                                d = -1;
                                                g = g + ((g >>> 0) % 3 | 0 ? -1 : 2) | 0;
                                                if ((g | 0) != -1) {
                                                    d = F[F[h >> 2] + (g << 2) >> 2];
                                                }
                                                h = F[m + 36 >> 2];
                                                g = F[h >> 2];
                                                h = F[h + 4 >> 2] - g >> 2;
                                                if (h >>> 0 <= e >>> 0 | d >>> 0 >= h >>> 0) {
                                                    break d;
                                                }
                                                h = F[g + (e << 2) >> 2];
                                                e: {
                                                    f: {
                                                        g: {
                                                            h: {
                                                                i: {
                                                                    j: {
                                                                        g = F[g + (d << 2) >> 2];
                                                                        if ((g | 0) >= (p | 0) | (h | 0) >= (p | 0)) {
                                                                            break j;
                                                                        }
                                                                        d = (g << 3) + c | 0;
                                                                        w = F[d + 4 >> 2];
                                                                        e = (h << 3) + c | 0;
                                                                        r = F[e + 4 >> 2];
                                                                        t = F[d >> 2];
                                                                        C = F[e >> 2];
                                                                        if (!((t | 0) != (C | 0) | (r | 0) != (w | 0))) {
                                                                            F[m + 8 >> 2] = C;
                                                                            F[m + 12 >> 2] = r;
                                                                            break i;
                                                                        }
                                                                        d = F[F[m + 4 >> 2] + (p << 2) >> 2];
                                                                        F[i + 72 >> 2] = 0;
                                                                        F[i + 76 >> 2] = 0;
                                                                        e = i - -64 | 0;
                                                                        F[e >> 2] = 0;
                                                                        F[e + 4 >> 2] = 0;
                                                                        F[i + 56 >> 2] = 0;
                                                                        F[i + 60 >> 2] = 0;
                                                                        e = F[m >> 2];
                                                                        if (!G[e + 84 | 0]) {
                                                                            d = F[F[e + 68 >> 2] + (d << 2) >> 2];
                                                                        }
                                                                        Ta(e, d, D[e + 24 | 0], i + 56 | 0);
                                                                        d = F[F[m + 4 >> 2] + (h << 2) >> 2];
                                                                        F[i + 48 >> 2] = 0;
                                                                        F[i + 52 >> 2] = 0;
                                                                        F[i + 40 >> 2] = 0;
                                                                        F[i + 44 >> 2] = 0;
                                                                        F[i + 32 >> 2] = 0;
                                                                        F[i + 36 >> 2] = 0;
                                                                        e = F[m >> 2];
                                                                        if (!G[e + 84 | 0]) {
                                                                            d = F[F[e + 68 >> 2] + (d << 2) >> 2];
                                                                        }
                                                                        Ta(e, d, D[e + 24 | 0], i + 32 | 0);
                                                                        e = F[F[m + 4 >> 2] + (g << 2) >> 2];
                                                                        F[i + 24 >> 2] = 0;
                                                                        F[i + 28 >> 2] = 0;
                                                                        F[i + 16 >> 2] = 0;
                                                                        F[i + 20 >> 2] = 0;
                                                                        F[i + 8 >> 2] = 0;
                                                                        F[i + 12 >> 2] = 0;
                                                                        d = F[m >> 2];
                                                                        if (!G[d + 84 | 0]) {
                                                                            e = F[F[d + 68 >> 2] + (e << 2) >> 2];
                                                                        }
                                                                        Ta(d, e, D[d + 24 | 0], i + 8 | 0);
                                                                        J = F[i + 44 >> 2];
                                                                        d = F[i + 16 >> 2];
                                                                        x = F[i + 40 >> 2];
                                                                        e = x;
                                                                        k = F[i + 20 >> 2] - (J + (d >>> 0 < e >>> 0) | 0) | 0;
                                                                        n = d - e | 0;
                                                                        d = Hj(n, k, n, k);
                                                                        e = fa;
                                                                        o = d;
                                                                        K = F[i + 36 >> 2];
                                                                        d = F[i + 8 >> 2];
                                                                        E = F[i + 32 >> 2];
                                                                        g = E;
                                                                        j = F[i + 12 >> 2] - (K + (d >>> 0 < g >>> 0) | 0) | 0;
                                                                        u = d - g | 0;
                                                                        g = Hj(u, j, u, j);
                                                                        d = o + g | 0;
                                                                        e = fa + e | 0;
                                                                        e = d >>> 0 < g >>> 0 ? e + 1 | 0 : e;
                                                                        o = d;
                                                                        L = F[i + 52 >> 2];
                                                                        d = F[i + 24 >> 2];
                                                                        H = F[i + 48 >> 2];
                                                                        g = H;
                                                                        l = F[i + 28 >> 2] - (L + (d >>> 0 < g >>> 0) | 0) | 0;
                                                                        s = d - g | 0;
                                                                        q = Hj(s, l, s, l);
                                                                        d = o + q | 0;
                                                                        g = fa + e | 0;
                                                                        v = d;
                                                                        q = d >>> 0 < q >>> 0 ? g + 1 | 0 : g;
                                                                        if (!(d | q)) {
                                                                            break j;
                                                                        }
                                                                        N = F[i + 64 >> 2];
                                                                        d = N;
                                                                        O = F[i + 68 >> 2];
                                                                        d = Hj(d - x | 0, O - ((d >>> 0 < x >>> 0) + J | 0) | 0, n, k);
                                                                        e = fa;
                                                                        g = d;
                                                                        P = F[i + 56 >> 2];
                                                                        d = P;
                                                                        Q = F[i + 60 >> 2];
                                                                        h = Hj(d - E | 0, Q - ((d >>> 0 < E >>> 0) + K | 0) | 0, u, j);
                                                                        d = g + h | 0;
                                                                        g = fa + e | 0;
                                                                        g = d >>> 0 < h >>> 0 ? g + 1 | 0 : g;
                                                                        e = d;
                                                                        R = F[i + 72 >> 2];
                                                                        d = R;
                                                                        S = F[i + 76 >> 2];
                                                                        h = Hj(d - H | 0, S - ((d >>> 0 < H >>> 0) + L | 0) | 0, s, l);
                                                                        d = e + h | 0;
                                                                        e = fa + g | 0;
                                                                        z = d;
                                                                        y = d >>> 0 < h >>> 0 ? e + 1 | 0 : e;
                                                                        d = l >> 31;
                                                                        e = d + s | 0;
                                                                        g = d + l | 0;
                                                                        g = e >>> 0 < d >>> 0 ? g + 1 | 0 : g;
                                                                        h = e ^ d;
                                                                        d = d ^ g;
                                                                        M = d;
                                                                        d = k >> 31;
                                                                        g = d + n | 0;
                                                                        e = d + k | 0;
                                                                        A = g ^ d;
                                                                        d = d ^ (g >>> 0 < d >>> 0 ? e + 1 | 0 : e);
                                                                        o = d;
                                                                        e = 0;
                                                                        d = j >> 31;
                                                                        B = d + u | 0;
                                                                        g = d + j | 0;
                                                                        g = B >>> 0 < d >>> 0 ? g + 1 | 0 : g;
                                                                        B = B ^ d;
                                                                        d = d ^ g;
                                                                        g = (o | 0) == (d | 0) & A >>> 0 > B >>> 0 | d >>> 0 < o >>> 0;
                                                                        A = g ? A : B;
                                                                        d = g ? o : d;
                                                                        g = (M | 0) == (d | 0) & h >>> 0 > A >>> 0 | d >>> 0 < M >>> 0;
                                                                        g = Jj(-1, 2147483647, g ? h : A, g ? M : d) >>> 0 < z >>> 0;
                                                                        d = fa;
                                                                        if (g & (d | 0) <= (y | 0) | (d | 0) < (y | 0)) {
                                                                            break e;
                                                                        }
                                                                        h = 1;
                                                                        d = 0;
                                                                        e = N;
                                                                        n = Ij(Hj(n, k, z, y), fa, v, q);
                                                                        k = n + x | 0;
                                                                        g = fa + J | 0;
                                                                        g = k >>> 0 < n >>> 0 ? g + 1 | 0 : g;
                                                                        g = O - ((e >>> 0 < k >>> 0) + g | 0) | 0;
                                                                        e = e - k | 0;
                                                                        g = Hj(e, g, e, g);
                                                                        n = fa;
                                                                        e = P;
                                                                        o = g;
                                                                        j = Ij(Hj(u, j, z, y), fa, v, q);
                                                                        k = j + E | 0;
                                                                        g = fa + K | 0;
                                                                        g = j >>> 0 > k >>> 0 ? g + 1 | 0 : g;
                                                                        g = Q - ((e >>> 0 < k >>> 0) + g | 0) | 0;
                                                                        e = e - k | 0;
                                                                        k = Hj(e, g, e, g);
                                                                        g = o + k | 0;
                                                                        e = fa + n | 0;
                                                                        e = g >>> 0 < k >>> 0 ? e + 1 | 0 : e;
                                                                        k = e;
                                                                        e = R;
                                                                        o = g;
                                                                        l = Ij(Hj(s, l, z, y), fa, v, q);
                                                                        j = l + H | 0;
                                                                        g = fa + L | 0;
                                                                        g = j >>> 0 < l >>> 0 ? g + 1 | 0 : g;
                                                                        g = S - ((e >>> 0 < j >>> 0) + g | 0) | 0;
                                                                        e = e - j | 0;
                                                                        j = Hj(e, g, e, g);
                                                                        e = o + j | 0;
                                                                        g = fa + k | 0;
                                                                        k = Hj(e, e >>> 0 < j >>> 0 ? g + 1 | 0 : g, v, q);
                                                                        e = fa;
                                                                        j = e;
                                                                        if (!e & k >>> 0 <= 1) {
                                                                            break h;
                                                                        }
                                                                        l = k;
                                                                        e = j;
                                                                        while (1) {
                                                                            g = d << 1 | h >>> 31;
                                                                            h = h << 1;
                                                                            d = g;
                                                                            n = !e & l >>> 0 > 7 | (e | 0) != 0;
                                                                            l = (e & 3) << 30 | l >>> 2;
                                                                            e = e >>> 2 | 0;
                                                                            if (n) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        break g;
                                                                    }
                                                                    if ((h | 0) < (p | 0)) {
                                                                        d = h << 1;
                                                                    }
                                                                    else {
                                                                        if ((p | 0) <= 0) {
                                                                            F[m + 8 >> 2] = 0;
                                                                            F[m + 12 >> 2] = 0;
                                                                            break i;
                                                                        }
                                                                        d = (p << 1) - 2 | 0;
                                                                    }
                                                                    d = (d << 2) + c | 0;
                                                                    F[m + 8 >> 2] = F[d >> 2];
                                                                    F[m + 12 >> 2] = F[d + 4 >> 2];
                                                                }
                                                                e = 1;
                                                                break e;
                                                            }
                                                            d = j;
                                                            h = k;
                                                            if (h - 1 | 0) {
                                                                break f;
                                                            }
                                                        }
                                                        while (1) {
                                                            g = Jj(k, j, h, d) + h | 0;
                                                            e = d + fa | 0;
                                                            e = g >>> 0 < h >>> 0 ? e + 1 | 0 : e;
                                                            h = (e & 1) << 31 | g >>> 1;
                                                            d = e >>> 1 | 0;
                                                            e = Hj(h, d, h, d);
                                                            g = fa;
                                                            if ((j | 0) == (g | 0) & e >>> 0 > k >>> 0 | g >>> 0 > j >>> 0) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    k = F[m + 20 >> 2];
                                                    if (k) {
                                                        e = k - 1 | 0;
                                                        l = F[F[m + 16 >> 2] + (e >>> 3 & 536870908) >> 2];
                                                        F[m + 20 >> 2] = e;
                                                        g = r;
                                                        n = w - g | 0;
                                                        j = g >> 31;
                                                        u = (w >> 31) - (j + (g >>> 0 > w >>> 0) | 0) | 0;
                                                        g = Hj(z, y, n, u);
                                                        s = fa;
                                                        r = Hj(r, j, v, q);
                                                        j = r + g | 0;
                                                        g = fa + s | 0;
                                                        g = j >>> 0 < r >>> 0 ? g + 1 | 0 : g;
                                                        o = j;
                                                        j = C;
                                                        s = t - j | 0;
                                                        r = j >> 31;
                                                        w = (t >> 31) - (r + (j >>> 0 > t >>> 0) | 0) | 0;
                                                        j = Hj(h, d, s, w);
                                                        t = j;
                                                        j = l >>> e & 1;
                                                        e = j;
                                                        x = e ? 0 - t | 0 : t;
                                                        l = o + x | 0;
                                                        o = g;
                                                        g = fa;
                                                        e = o + (e ? 0 - (g + ((t | 0) != 0) | 0) | 0 : g) | 0;
                                                        U = m, W = Ij(l, l >>> 0 < x >>> 0 ? e + 1 | 0 : e, v, q), F[U + 12 >> 2] = W;
                                                        e = Hj(s, w, z, y);
                                                        g = fa;
                                                        l = Hj(v, q, C, r);
                                                        e = l + e | 0;
                                                        g = fa + g | 0;
                                                        g = e >>> 0 < l >>> 0 ? g + 1 | 0 : g;
                                                        d = Hj(h, d, n, u);
                                                        l = j ? d : 0 - d | 0;
                                                        h = l + e | 0;
                                                        e = fa;
                                                        e = (j ? e : 0 - (((d | 0) != 0) + e | 0) | 0) + g | 0;
                                                        U = m, W = Ij(h, h >>> 0 < l >>> 0 ? e + 1 | 0 : e, v, q), F[U + 8 >> 2] = W;
                                                    }
                                                    e = (k | 0) != 0;
                                                }
                                                ea = i + 80 | 0;
                                                break c;
                                            }
                                            Da();
                                            V();
                                        }
                                        if (!e) {
                                            break b;
                                        }
                                        k: {
                                            if (F[a + 8 >> 2] <= 0) {
                                                break k;
                                            }
                                            g = F[a + 32 >> 2];
                                            d = 0;
                                            while (1) {
                                                e = d << 2;
                                                f = F[(e + a | 0) + 68 >> 2];
                                                h = F[a + 16 >> 2];
                                                l: {
                                                    if ((f | 0) > (h | 0)) {
                                                        F[e + g >> 2] = h;
                                                        break l;
                                                    }
                                                    e = e + g | 0;
                                                    h = F[a + 12 >> 2];
                                                    if ((h | 0) > (f | 0)) {
                                                        F[e >> 2] = h;
                                                        break l;
                                                    }
                                                    F[e >> 2] = f;
                                                }
                                                d = d + 1 | 0;
                                                f = F[a + 8 >> 2];
                                                if ((d | 0) < (f | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            e = 0;
                                            if ((f | 0) <= 0) {
                                                break k;
                                            }
                                            d = p << 3;
                                            h = d + c | 0;
                                            k = b + d | 0;
                                            while (1) {
                                                f = e << 2;
                                                d = f + h | 0;
                                                f = F[f + k >> 2] + F[f + g >> 2] | 0;
                                                F[d >> 2] = f;
                                                m: {
                                                    if ((f | 0) > F[a + 16 >> 2]) {
                                                        f = f - F[a + 20 >> 2] | 0;
                                                    }
                                                    else {
                                                        if ((f | 0) >= F[a + 12 >> 2]) {
                                                            break m;
                                                        }
                                                        f = f + F[a + 20 >> 2] | 0;
                                                    }
                                                    F[d >> 2] = f;
                                                }
                                                e = e + 1 | 0;
                                                if ((e | 0) < F[a + 8 >> 2]) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        p = p + 1 | 0;
                                        f = (I | 0) > (p | 0);
                                        if ((p | 0) == (T | 0)) {
                                            break b;
                                        }
                                        e = F[a + 56 >> 2];
                                        d = F[e >> 2];
                                        if (F[e + 4 >> 2] - d >> 2 >>> 0 > p >>> 0) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                Da();
                                V();
                            }
                            a = f ^ 1;
                        }
                        else {
                            a = 0;
                        } return a & 1; }
                        function wf(a) { a = a | 0; var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = M(0), x = 0; k = ea - 32 | 0; ea = k; a: {
                            if (!(F[a + 60 >> 2] != F[a - -64 >> 2] | F[a + 48 >> 2] != F[a + 52 >> 2])) {
                                j = 1;
                                break a;
                            }
                            j = 1;
                            if ((ga[F[F[a >> 2] + 24 >> 2]](a) | 0) <= 0) {
                                break a;
                            }
                            b: {
                                c: {
                                    while (1) {
                                        d: {
                                            c = ga[F[F[a >> 2] + 20 >> 2]](a, x) | 0;
                                            e: {
                                                f: {
                                                    g: {
                                                        f = F[F[F[(ga[F[F[a >> 2] + 28 >> 2]](a) | 0) + 4 >> 2] + 8 >> 2] + (c << 2) >> 2];
                                                        switch (F[f + 28 >> 2] - 1 | 0) {
                                                            case 8: break f;
                                                            case 0:
                                                            case 2:
                                                            case 4: break g;
                                                            default: break e;
                                                        }
                                                    }
                                                    c = D[f + 24 | 0];
                                                    F[k + 24 >> 2] = 0;
                                                    F[k + 16 >> 2] = 0;
                                                    F[k + 20 >> 2] = 0;
                                                    h: {
                                                        if (!c) {
                                                            j = 0;
                                                            F[k >> 2] = 0;
                                                            m = 0;
                                                            break h;
                                                        }
                                                        if ((c | 0) < 0) {
                                                            break d;
                                                        }
                                                        c = c << 2;
                                                        j = sa(c);
                                                        F[k + 16 >> 2] = j;
                                                        b = c + j | 0;
                                                        F[k + 24 >> 2] = b;
                                                        m = 0;
                                                        ua(j, 0, c);
                                                        F[k + 20 >> 2] = b;
                                                        c = D[f + 24 | 0];
                                                        F[k + 8 >> 2] = 0;
                                                        F[k >> 2] = 0;
                                                        F[k + 4 >> 2] = 0;
                                                        if (!c) {
                                                            break h;
                                                        }
                                                        if ((c | 0) < 0) {
                                                            break c;
                                                        }
                                                        c = c << 2;
                                                        m = sa(c);
                                                        F[k >> 2] = m;
                                                        ua(m, 0, c);
                                                    }
                                                    i: {
                                                        j: {
                                                            switch (F[f + 28 >> 2] - 1 | 0) {
                                                                case 4:
                                                                    e = 0;
                                                                    h = 0;
                                                                    n = 0;
                                                                    c = 0;
                                                                    i = ea - 16 | 0;
                                                                    ea = i;
                                                                    d = D[f + 24 | 0];
                                                                    F[i + 8 >> 2] = 0;
                                                                    F[i >> 2] = 0;
                                                                    F[i + 4 >> 2] = 0;
                                                                    k: {
                                                                        l: {
                                                                            if (d) {
                                                                                if ((d | 0) < 0) {
                                                                                    break l;
                                                                                }
                                                                                b = d << 2;
                                                                                h = sa(b);
                                                                                F[i >> 2] = h;
                                                                                F[i + 8 >> 2] = b + h;
                                                                                ua(h, 0, b);
                                                                                e = sa(b);
                                                                                ua(e, 0, b);
                                                                            }
                                                                            if (!F[f + 80 >> 2]) {
                                                                                break k;
                                                                            }
                                                                            while (1) {
                                                                                u = F[f >> 2];
                                                                                r = F[u >> 2];
                                                                                b = F[f + 40 >> 2];
                                                                                l = F[f + 48 >> 2] + Hj(b, F[f + 44 >> 2], n, c) | 0;
                                                                                l = ta(h, r + l | 0, b);
                                                                                o = d << 24 >> 24;
                                                                                m: {
                                                                                    if ((o | 0) <= 0) {
                                                                                        break m;
                                                                                    }
                                                                                    p = F[a + 48 >> 2];
                                                                                    g = 0;
                                                                                    if ((d & 255) != 1) {
                                                                                        v = o & -2;
                                                                                        d = 0;
                                                                                        while (1) {
                                                                                            q = g << 2;
                                                                                            F[q + e >> 2] = F[p + (g + t << 2) >> 2] + F[l + q >> 2];
                                                                                            q = g | 1;
                                                                                            r = q << 2;
                                                                                            F[r + e >> 2] = F[p + (t + q << 2) >> 2] + F[l + r >> 2];
                                                                                            g = g + 2 | 0;
                                                                                            d = d + 2 | 0;
                                                                                            if ((v | 0) != (d | 0)) {
                                                                                                continue;
                                                                                            }
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    if (!(o & 1)) {
                                                                                        break m;
                                                                                    }
                                                                                    d = g << 2;
                                                                                    F[d + e >> 2] = F[p + (g + t << 2) >> 2] + F[d + l >> 2];
                                                                                }
                                                                                ta(F[u >> 2] + L(b, n) | 0, e, b);
                                                                                b = n + 1 | 0;
                                                                                c = b ? c : c + 1 | 0;
                                                                                n = b;
                                                                                if (!c & I[f + 80 >> 2] <= b >>> 0 | c) {
                                                                                    break k;
                                                                                }
                                                                                d = G[f + 24 | 0];
                                                                                continue;
                                                                            }
                                                                        }
                                                                        va();
                                                                        V();
                                                                    }
                                                                    if (e) {
                                                                        ra(e);
                                                                    }
                                                                    if (h) {
                                                                        ra(h);
                                                                    }
                                                                    ea = i + 16 | 0;
                                                                    break i;
                                                                case 2:
                                                                    e = 0;
                                                                    h = 0;
                                                                    n = 0;
                                                                    c = 0;
                                                                    i = ea - 16 | 0;
                                                                    ea = i;
                                                                    d = D[f + 24 | 0];
                                                                    F[i + 8 >> 2] = 0;
                                                                    F[i >> 2] = 0;
                                                                    F[i + 4 >> 2] = 0;
                                                                    n: {
                                                                        o: {
                                                                            if (d) {
                                                                                if ((d | 0) < 0) {
                                                                                    break o;
                                                                                }
                                                                                b = d << 1;
                                                                                h = sa(b);
                                                                                F[i >> 2] = h;
                                                                                F[i + 8 >> 2] = b + h;
                                                                                ua(h, 0, b);
                                                                                e = sa(b);
                                                                                ua(e, 0, b);
                                                                            }
                                                                            if (!F[f + 80 >> 2]) {
                                                                                break n;
                                                                            }
                                                                            while (1) {
                                                                                u = F[f >> 2];
                                                                                r = F[u >> 2];
                                                                                b = F[f + 40 >> 2];
                                                                                l = F[f + 48 >> 2] + Hj(b, F[f + 44 >> 2], n, c) | 0;
                                                                                l = ta(h, r + l | 0, b);
                                                                                o = d << 24 >> 24;
                                                                                p: {
                                                                                    if ((o | 0) <= 0) {
                                                                                        break p;
                                                                                    }
                                                                                    p = F[a + 48 >> 2];
                                                                                    g = 0;
                                                                                    if ((d & 255) != 1) {
                                                                                        v = o & -2;
                                                                                        d = 0;
                                                                                        while (1) {
                                                                                            q = g << 1;
                                                                                            E[q + e >> 1] = H[l + q >> 1] + H[p + (g + t << 2) >> 1];
                                                                                            q = g | 1;
                                                                                            r = q << 1;
                                                                                            E[r + e >> 1] = H[l + r >> 1] + H[p + (t + q << 2) >> 1];
                                                                                            g = g + 2 | 0;
                                                                                            d = d + 2 | 0;
                                                                                            if ((v | 0) != (d | 0)) {
                                                                                                continue;
                                                                                            }
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    if (!(o & 1)) {
                                                                                        break p;
                                                                                    }
                                                                                    d = g << 1;
                                                                                    E[d + e >> 1] = H[d + l >> 1] + H[p + (g + t << 2) >> 1];
                                                                                }
                                                                                ta(F[u >> 2] + L(b, n) | 0, e, b);
                                                                                b = n + 1 | 0;
                                                                                c = b ? c : c + 1 | 0;
                                                                                n = b;
                                                                                if (!c & I[f + 80 >> 2] <= b >>> 0 | c) {
                                                                                    break n;
                                                                                }
                                                                                d = G[f + 24 | 0];
                                                                                continue;
                                                                            }
                                                                        }
                                                                        va();
                                                                        V();
                                                                    }
                                                                    if (e) {
                                                                        ra(e);
                                                                    }
                                                                    if (h) {
                                                                        ra(h);
                                                                    }
                                                                    ea = i + 16 | 0;
                                                                    break i;
                                                                case 0: break j;
                                                                default: break i;
                                                            }
                                                        }
                                                        e = 0;
                                                        g = 0;
                                                        n = 0;
                                                        c = 0;
                                                        h = ea - 16 | 0;
                                                        ea = h;
                                                        b = D[f + 24 | 0];
                                                        F[h + 8 >> 2] = 0;
                                                        F[h >> 2] = 0;
                                                        F[h + 4 >> 2] = 0;
                                                        q: {
                                                            r: {
                                                                if (b) {
                                                                    if ((b | 0) < 0) {
                                                                        break r;
                                                                    }
                                                                    g = sa(b);
                                                                    F[h >> 2] = g;
                                                                    F[h + 8 >> 2] = b + g;
                                                                    ua(g, 0, b);
                                                                    e = sa(b);
                                                                    ua(e, 0, b);
                                                                }
                                                                if (F[f + 80 >> 2]) {
                                                                    while (1) {
                                                                        r = F[F[f >> 2] >> 2];
                                                                        i = F[f + 40 >> 2];
                                                                        b = F[f + 48 >> 2] + Hj(i, F[f + 44 >> 2], n, c) | 0;
                                                                        b = ta(g, r + b | 0, i);
                                                                        l = D[f + 24 | 0];
                                                                        s: {
                                                                            if ((l | 0) <= 0) {
                                                                                break s;
                                                                            }
                                                                            p = F[a + 48 >> 2];
                                                                            d = 0;
                                                                            if ((l | 0) != 1) {
                                                                                u = l & -2;
                                                                                i = 0;
                                                                                while (1) {
                                                                                    D[d + e | 0] = G[b + d | 0] + G[p + (d + t << 2) | 0];
                                                                                    o = d | 1;
                                                                                    D[o + e | 0] = G[b + o | 0] + G[p + (o + t << 2) | 0];
                                                                                    d = d + 2 | 0;
                                                                                    i = i + 2 | 0;
                                                                                    if ((u | 0) != (i | 0)) {
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                            }
                                                                            if (!(l & 1)) {
                                                                                break s;
                                                                            }
                                                                            D[d + e | 0] = G[b + d | 0] + G[p + (d + t << 2) | 0];
                                                                        }
                                                                        b = F[f + 40 >> 2];
                                                                        ta(F[F[f >> 2] >> 2] + L(b, n) | 0, e, b);
                                                                        b = n + 1 | 0;
                                                                        c = b ? c : c + 1 | 0;
                                                                        n = b;
                                                                        if (!c & I[f + 80 >> 2] > b >>> 0) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                }
                                                                if (e) {
                                                                    ra(e);
                                                                }
                                                                if (g) {
                                                                    ra(g);
                                                                }
                                                                ea = h + 16 | 0;
                                                                break q;
                                                            }
                                                            va();
                                                            V();
                                                        }
                                                    }
                                                    t = D[f + 24 | 0] + t | 0;
                                                    c = 1;
                                                    if (m) {
                                                        ra(m);
                                                    }
                                                    if (j) {
                                                        ra(j);
                                                    }
                                                    if (c) {
                                                        break e;
                                                    }
                                                    j = 0;
                                                    break a;
                                                }
                                                g = F[F[a + 60 >> 2] + (s << 2) >> 2];
                                                e = F[a + 36 >> 2];
                                                j = F[(ga[F[F[a >> 2] + 28 >> 2]](a) | 0) + 40 >> 2];
                                                F[k >> 2] = F[f + 56 >> 2];
                                                c = sa(32);
                                                F[k + 16 >> 2] = c;
                                                F[k + 20 >> 2] = 24;
                                                F[k + 24 >> 2] = -2147483616;
                                                D[c + 24 | 0] = 0;
                                                b = G[1318] | G[1319] << 8 | (G[1320] << 16 | G[1321] << 24);
                                                d = G[1314] | G[1315] << 8 | (G[1316] << 16 | G[1317] << 24);
                                                D[c + 16 | 0] = d;
                                                D[c + 17 | 0] = d >>> 8;
                                                D[c + 18 | 0] = d >>> 16;
                                                D[c + 19 | 0] = d >>> 24;
                                                D[c + 20 | 0] = b;
                                                D[c + 21 | 0] = b >>> 8;
                                                D[c + 22 | 0] = b >>> 16;
                                                D[c + 23 | 0] = b >>> 24;
                                                b = G[1310] | G[1311] << 8 | (G[1312] << 16 | G[1313] << 24);
                                                d = G[1306] | G[1307] << 8 | (G[1308] << 16 | G[1309] << 24);
                                                D[c + 8 | 0] = d;
                                                D[c + 9 | 0] = d >>> 8;
                                                D[c + 10 | 0] = d >>> 16;
                                                D[c + 11 | 0] = d >>> 24;
                                                D[c + 12 | 0] = b;
                                                D[c + 13 | 0] = b >>> 8;
                                                D[c + 14 | 0] = b >>> 16;
                                                D[c + 15 | 0] = b >>> 24;
                                                b = G[1302] | G[1303] << 8 | (G[1304] << 16 | G[1305] << 24);
                                                d = G[1298] | G[1299] << 8 | (G[1300] << 16 | G[1301] << 24);
                                                D[c | 0] = d;
                                                D[c + 1 | 0] = d >>> 8;
                                                D[c + 2 | 0] = d >>> 16;
                                                D[c + 3 | 0] = d >>> 24;
                                                D[c + 4 | 0] = b;
                                                D[c + 5 | 0] = b >>> 8;
                                                D[c + 6 | 0] = b >>> 16;
                                                D[c + 7 | 0] = b >>> 24;
                                                b = td(j, k, k + 16 | 0);
                                                if (D[k + 27 | 0] < 0) {
                                                    ra(F[k + 16 >> 2]);
                                                }
                                                c = s + 1 | 0;
                                                t: {
                                                    if (b) {
                                                        me(f, g);
                                                        break t;
                                                    }
                                                    h = e + L(s, 24) | 0;
                                                    e = F[h + 4 >> 2];
                                                    s = D[f + 24 | 0];
                                                    d = s << 2;
                                                    b = sa((s | 0) != (s & 1073741823) ? -1 : d);
                                                    F[k + 16 >> 2] = 1065353216;
                                                    w = J[h + 20 >> 2];
                                                    e = -1 << e ^ -1;
                                                    if ((e | 0) > 0) {
                                                        J[k + 16 >> 2] = w / M(e | 0);
                                                    }
                                                    if ((e | 0) <= 0) {
                                                        break b;
                                                    }
                                                    u: {
                                                        if (!F[g + 80 >> 2]) {
                                                            break u;
                                                        }
                                                        if ((s | 0) <= 0) {
                                                            m = 0;
                                                            j = 0;
                                                            while (1) {
                                                                ta(F[F[f + 64 >> 2] >> 2] + j | 0, b, d);
                                                                j = d + j | 0;
                                                                m = m + 1 | 0;
                                                                if (m >>> 0 < I[g + 80 >> 2]) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                            break u;
                                                        }
                                                        l = F[F[g >> 2] >> 2] + F[g + 48 >> 2] | 0;
                                                        u = s & -2;
                                                        v = s & 1;
                                                        i = 0;
                                                        e = 0;
                                                        j = 0;
                                                        while (1) {
                                                            n = F[h + 8 >> 2];
                                                            w = J[k + 16 >> 2];
                                                            m = 0;
                                                            p = 0;
                                                            if ((s | 0) != 1) {
                                                                while (1) {
                                                                    o = m << 2;
                                                                    q = l + (j << 2) | 0;
                                                                    J[o + b >> 2] = M(w * M(F[q >> 2])) + J[n + o >> 2];
                                                                    o = o | 4;
                                                                    J[o + b >> 2] = M(w * M(F[q + 4 >> 2])) + J[n + o >> 2];
                                                                    m = m + 2 | 0;
                                                                    j = j + 2 | 0;
                                                                    p = p + 2 | 0;
                                                                    if ((u | 0) != (p | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            if (v) {
                                                                m = m << 2;
                                                                J[m + b >> 2] = M(w * M(F[l + (j << 2) >> 2])) + J[n + m >> 2];
                                                                j = j + 1 | 0;
                                                            }
                                                            ta(F[F[f + 64 >> 2] >> 2] + e | 0, b, d);
                                                            e = d + e | 0;
                                                            i = i + 1 | 0;
                                                            if (i >>> 0 < I[g + 80 >> 2]) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    ra(b);
                                                }
                                                s = c;
                                            }
                                            j = 1;
                                            x = x + 1 | 0;
                                            if ((ga[F[F[a >> 2] + 24 >> 2]](a) | 0) > (x | 0)) {
                                                continue;
                                            }
                                            break a;
                                        }
                                        break;
                                    }
                                    va();
                                    V();
                                }
                                va();
                                V();
                            }
                            ra(b);
                            j = 0;
                        } ea = k + 32 | 0; return j | 0; }
                        function hd(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0; h = ea - 96 | 0; ea = h; q = F[a + 4 >> 2]; e = F[q + 32 >> 2]; l = F[e + 8 >> 2]; g = l; n = F[e + 12 >> 2]; d = n; c = F[e + 20 >> 2]; o = F[e + 16 >> 2]; a: {
                            if ((d | 0) <= (c | 0) & o >>> 0 >= g >>> 0 | (c | 0) > (d | 0)) {
                                break a;
                            }
                            f = F[e >> 2];
                            p = G[f + o | 0];
                            g = o + 1 | 0;
                            d = g ? c : c + 1 | 0;
                            F[e + 16 >> 2] = g;
                            F[e + 20 >> 2] = d;
                            if ((d | 0) >= (n | 0) & g >>> 0 >= l >>> 0 | (d | 0) > (n | 0)) {
                                break a;
                            }
                            m = G[f + g | 0];
                            g = o + 2 | 0;
                            d = g >>> 0 < 2 ? c + 1 | 0 : c;
                            k = g;
                            F[e + 16 >> 2] = g;
                            F[e + 20 >> 2] = d;
                            j = p << 24 >> 24;
                            b: {
                                if ((j | 0) >= 0) {
                                    g = F[a + 216 >> 2];
                                    if (p >>> 0 >= (F[a + 220 >> 2] - g | 0) / 144 >>> 0) {
                                        break a;
                                    }
                                    g = g + L(p, 144) | 0;
                                    if (F[g >> 2] < 0) {
                                        break b;
                                    }
                                    break a;
                                }
                                if (F[a + 212 >> 2] >= 0) {
                                    break a;
                                }
                                g = a + 212 | 0;
                            }
                            F[g >> 2] = b;
                            c: {
                                d: {
                                    g = H[q + 36 >> 1];
                                    e: {
                                        if (((g << 8 | g >>> 8) & 65535) >>> 0 >= 258) {
                                            if ((d | 0) >= (n | 0) & k >>> 0 >= l >>> 0 | (d | 0) > (n | 0)) {
                                                break a;
                                            }
                                            g = G[f + k | 0];
                                            d = o + 3 | 0;
                                            c = d >>> 0 < 3 ? c + 1 | 0 : c;
                                            F[e + 16 >> 2] = d;
                                            F[e + 20 >> 2] = c;
                                            c = g >>> 0 > 1;
                                            if (c) {
                                                break a;
                                            }
                                            c = c ? 0 : g;
                                            if (!m) {
                                                break e;
                                            }
                                            if (c) {
                                                break a;
                                            }
                                            break d;
                                        }
                                        if (m) {
                                            break d;
                                        }
                                        c = 0;
                                    }
                                    if ((j | 0) < 0) {
                                        e = a + 184 | 0;
                                    }
                                    else {
                                        e = F[a + 216 >> 2] + L(p, 144) | 0;
                                        D[e + 100 | 0] = 0;
                                        e = e + 104 | 0;
                                    }
                                    f: {
                                        if ((c | 0) == 1) {
                                            f = ea - 112 | 0;
                                            ea = f;
                                            k = F[F[a + 4 >> 2] + 44 >> 2];
                                            c = sa(120);
                                            F[c >> 2] = 12204;
                                            F[c + 4 >> 2] = 0;
                                            F[c + 116 >> 2] = 0;
                                            F[c + 112 >> 2] = e;
                                            F[c + 108 >> 2] = k;
                                            F[c + 12 >> 2] = 0;
                                            F[c + 16 >> 2] = 0;
                                            F[c + 20 >> 2] = 0;
                                            F[c + 24 >> 2] = 0;
                                            F[c + 28 >> 2] = 0;
                                            F[c + 32 >> 2] = 0;
                                            F[c + 36 >> 2] = 0;
                                            F[c + 40 >> 2] = 0;
                                            F[c + 44 >> 2] = 0;
                                            F[c + 48 >> 2] = 0;
                                            F[c + 52 >> 2] = 0;
                                            F[c + 56 >> 2] = 0;
                                            F[c + 60 >> 2] = 0;
                                            F[c + 8 >> 2] = 12416;
                                            d = c - -64 | 0;
                                            F[d >> 2] = 0;
                                            F[d + 4 >> 2] = 0;
                                            F[c + 72 >> 2] = 0;
                                            F[c + 76 >> 2] = 0;
                                            F[c + 80 >> 2] = 0;
                                            F[c + 84 >> 2] = 0;
                                            F[c + 88 >> 2] = 0;
                                            F[c + 104 >> 2] = 0;
                                            F[c + 96 >> 2] = 0;
                                            F[c + 100 >> 2] = 0;
                                            m = F[a + 8 >> 2];
                                            F[f + 48 >> 2] = 0;
                                            F[f + 52 >> 2] = 0;
                                            F[f + 40 >> 2] = 0;
                                            F[f + 44 >> 2] = 0;
                                            j = f + 32 | 0;
                                            d = j;
                                            F[d >> 2] = 0;
                                            F[d + 4 >> 2] = 0;
                                            F[f + 24 >> 2] = 0;
                                            F[f + 28 >> 2] = 0;
                                            F[f + 16 >> 2] = 0;
                                            F[f + 20 >> 2] = 0;
                                            d = f - -64 | 0;
                                            F[d >> 2] = 0;
                                            F[d + 4 >> 2] = 0;
                                            F[f + 72 >> 2] = 0;
                                            F[f + 76 >> 2] = 0;
                                            F[f + 80 >> 2] = 0;
                                            F[f + 84 >> 2] = 0;
                                            F[f + 88 >> 2] = 0;
                                            F[f + 104 >> 2] = 0;
                                            F[f + 56 >> 2] = 0;
                                            F[f + 60 >> 2] = 0;
                                            F[f + 8 >> 2] = 12416;
                                            F[f + 96 >> 2] = 0;
                                            F[f + 100 >> 2] = 0;
                                            F[f + 12 >> 2] = m;
                                            g = F[m >> 2];
                                            d = F[m + 4 >> 2];
                                            D[f + 111 | 0] = 0;
                                            l = j;
                                            j = f + 111 | 0;
                                            Na(l, (d - g >> 2 >>> 0) / 3 | 0, j);
                                            d = F[f + 12 >> 2];
                                            g = F[d + 28 >> 2];
                                            d = F[d + 24 >> 2];
                                            D[f + 111 | 0] = 0;
                                            Na(f + 44 | 0, g - d >> 2, j);
                                            F[f + 28 >> 2] = c;
                                            F[f + 24 >> 2] = k;
                                            F[f + 20 >> 2] = e;
                                            F[f + 16 >> 2] = m;
                                            e = c + 8 | 0;
                                            d = f + 8 | 0;
                                            gd(e, d);
                                            g: {
                                                if ((d | 0) == (e | 0)) {
                                                    F[c + 92 >> 2] = F[d + 84 >> 2];
                                                    break g;
                                                }
                                                Db(c + 56 | 0, F[d + 48 >> 2], F[d + 52 >> 2]);
                                                Db(c + 68 | 0, F[d + 60 >> 2], F[d - -64 >> 2]);
                                                Db(c + 80 | 0, F[d + 72 >> 2], F[d + 76 >> 2]);
                                                F[c + 92 >> 2] = F[d + 84 >> 2];
                                                Ca(c + 96 | 0, F[d + 88 >> 2], F[d + 92 >> 2]);
                                            }
                                            F[f + 8 >> 2] = 12416;
                                            e = F[f + 96 >> 2];
                                            if (e) {
                                                F[f + 100 >> 2] = e;
                                                ra(e);
                                            }
                                            e = F[f + 80 >> 2];
                                            if (e) {
                                                F[f + 84 >> 2] = e;
                                                ra(e);
                                            }
                                            e = F[f + 68 >> 2];
                                            if (e) {
                                                F[f + 72 >> 2] = e;
                                                ra(e);
                                            }
                                            e = F[f + 56 >> 2];
                                            if (e) {
                                                F[f + 60 >> 2] = e;
                                                ra(e);
                                            }
                                            F[f + 8 >> 2] = 12652;
                                            e = F[f + 44 >> 2];
                                            if (e) {
                                                ra(e);
                                            }
                                            e = F[f + 32 >> 2];
                                            if (e) {
                                                ra(e);
                                            }
                                            ea = f + 112 | 0;
                                            break f;
                                        }
                                        d = ea + -64 | 0;
                                        ea = d;
                                        f = F[F[a + 4 >> 2] + 44 >> 2];
                                        c = sa(80);
                                        F[c >> 2] = 12672;
                                        F[c + 4 >> 2] = 0;
                                        F[c + 76 >> 2] = 0;
                                        F[c + 72 >> 2] = e;
                                        F[c + 68 >> 2] = f;
                                        F[c + 8 >> 2] = 12836;
                                        F[c + 12 >> 2] = 0;
                                        F[c + 16 >> 2] = 0;
                                        F[c + 20 >> 2] = 0;
                                        F[c + 24 >> 2] = 0;
                                        F[c + 28 >> 2] = 0;
                                        F[c + 32 >> 2] = 0;
                                        F[c + 36 >> 2] = 0;
                                        F[c + 40 >> 2] = 0;
                                        F[c + 44 >> 2] = 0;
                                        F[c + 48 >> 2] = 0;
                                        F[c + 52 >> 2] = 0;
                                        F[c - -64 >> 2] = 0;
                                        m = c + 56 | 0;
                                        g = m;
                                        F[g >> 2] = 0;
                                        F[g + 4 >> 2] = 0;
                                        l = F[a + 8 >> 2];
                                        F[d + 40 >> 2] = 0;
                                        F[d + 44 >> 2] = 0;
                                        F[d + 32 >> 2] = 0;
                                        F[d + 36 >> 2] = 0;
                                        k = d + 24 | 0;
                                        g = k;
                                        F[g >> 2] = 0;
                                        F[g + 4 >> 2] = 0;
                                        F[d + 16 >> 2] = 0;
                                        F[d + 20 >> 2] = 0;
                                        F[d + 8 >> 2] = 0;
                                        F[d + 12 >> 2] = 0;
                                        F[d + 56 >> 2] = 0;
                                        F[d + 48 >> 2] = 0;
                                        F[d + 52 >> 2] = 0;
                                        F[d >> 2] = 12836;
                                        F[d + 4 >> 2] = l;
                                        j = F[l >> 2];
                                        g = F[l + 4 >> 2];
                                        D[d + 63 | 0] = 0;
                                        n = k;
                                        k = d + 63 | 0;
                                        Na(n, (g - j >> 2 >>> 0) / 3 | 0, k);
                                        g = F[d + 4 >> 2];
                                        j = F[g + 28 >> 2];
                                        g = F[g + 24 >> 2];
                                        D[d + 63 | 0] = 0;
                                        Na(d + 36 | 0, j - g >> 2, k);
                                        F[d + 20 >> 2] = c;
                                        F[d + 16 >> 2] = f;
                                        F[d + 12 >> 2] = e;
                                        F[d + 8 >> 2] = l;
                                        gd(c + 8 | 0, d);
                                        Db(m, F[d + 48 >> 2], F[d + 52 >> 2]);
                                        F[d >> 2] = 12836;
                                        e = F[d + 48 >> 2];
                                        if (e) {
                                            F[d + 52 >> 2] = e;
                                            ra(e);
                                        }
                                        F[d >> 2] = 12652;
                                        e = F[d + 36 >> 2];
                                        if (e) {
                                            ra(e);
                                        }
                                        e = F[d + 24 >> 2];
                                        if (e) {
                                            ra(e);
                                        }
                                        ea = d - -64 | 0;
                                    }
                                    if (!c) {
                                        break a;
                                    }
                                    break c;
                                }
                                if ((j | 0) < 0) {
                                    break a;
                                }
                                g = F[q + 44 >> 2];
                                e = F[a + 216 >> 2];
                                c = sa(80);
                                F[c + 76 >> 2] = 0;
                                F[c + 68 >> 2] = g;
                                F[c + 8 >> 2] = 11900;
                                F[c >> 2] = 12964;
                                F[c + 4 >> 2] = 0;
                                d = e + L(p, 144) | 0;
                                i = d + 104 | 0;
                                F[c + 72 >> 2] = i;
                                F[c - -64 >> 2] = 0;
                                F[c + 56 >> 2] = 0;
                                F[c + 60 >> 2] = 0;
                                F[c + 52 >> 2] = 0;
                                F[c + 44 >> 2] = 0;
                                F[c + 48 >> 2] = 0;
                                F[c + 36 >> 2] = 0;
                                F[c + 40 >> 2] = 0;
                                F[c + 28 >> 2] = 0;
                                F[c + 32 >> 2] = 0;
                                F[c + 20 >> 2] = 0;
                                F[c + 24 >> 2] = 0;
                                F[c + 12 >> 2] = 0;
                                F[c + 16 >> 2] = 0;
                                F[h + 24 >> 2] = g;
                                F[h + 68 >> 2] = 0;
                                F[h + 72 >> 2] = 0;
                                F[h + 60 >> 2] = 0;
                                F[h + 64 >> 2] = 0;
                                F[h + 52 >> 2] = 0;
                                F[h + 56 >> 2] = 0;
                                F[h + 44 >> 2] = 0;
                                F[h + 48 >> 2] = 0;
                                F[h + 84 >> 2] = 0;
                                F[h + 88 >> 2] = 0;
                                F[h + 76 >> 2] = 0;
                                F[h + 80 >> 2] = 0;
                                F[h + 28 >> 2] = c;
                                e = F[h + 28 >> 2];
                                F[h + 8 >> 2] = F[h + 24 >> 2];
                                F[h + 12 >> 2] = e;
                                d = d + 4 | 0;
                                F[h + 16 >> 2] = d;
                                F[h + 20 >> 2] = i;
                                F[h + 36 >> 2] = 0;
                                F[h + 40 >> 2] = 0;
                                F[h + 32 >> 2] = 11900;
                                e = F[h + 20 >> 2];
                                F[h >> 2] = F[h + 16 >> 2];
                                F[h + 4 >> 2] = e;
                                i = h + 32 | 0;
                                Ee(i, d, h);
                                e = c + 8 | 0;
                                gd(e, i);
                                if ((e | 0) != (i | 0)) {
                                    Db(c + 56 | 0, F[i + 48 >> 2], F[i + 52 >> 2]);
                                }
                                De(i);
                            }
                            c = pd(sa(64), c);
                            j = F[a + 4 >> 2];
                            a = c;
                            c = b;
                            h: {
                                i: {
                                    if ((c | 0) >= 0) {
                                        d = j + 8 | 0;
                                        b = F[j + 12 >> 2];
                                        e = F[j + 8 >> 2];
                                        g = b - e >> 2;
                                        j: {
                                            if ((g | 0) > (c | 0)) {
                                                break j;
                                            }
                                            i = c + 1 | 0;
                                            if (c >>> 0 >= g >>> 0) {
                                                Wb(d, i - g | 0);
                                                break j;
                                            }
                                            if (g >>> 0 <= i >>> 0) {
                                                break j;
                                            }
                                            e = e + (i << 2) | 0;
                                            if ((e | 0) != (b | 0)) {
                                                while (1) {
                                                    b = b - 4 | 0;
                                                    i = F[b >> 2];
                                                    F[b >> 2] = 0;
                                                    if (i) {
                                                        ga[F[F[i >> 2] + 4 >> 2]](i);
                                                    }
                                                    if ((b | 0) != (e | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            F[j + 12 >> 2] = e;
                                        }
                                        e = F[d >> 2] + (c << 2) | 0;
                                        b = F[e >> 2];
                                        F[e >> 2] = a;
                                        if (b) {
                                            break i;
                                        }
                                        break h;
                                    }
                                    b = a;
                                    if (!a) {
                                        break h;
                                    }
                                }
                                ga[F[F[b >> 2] + 4 >> 2]](b);
                            }
                            i = (c ^ -1) >>> 31 | 0;
                        } ea = h + 96 | 0; return i | 0; }
                        function Id(a) { var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0; e = ea - 16 | 0; ea = e; F[e + 12 >> 2] = a; a: {
                            if (a >>> 0 <= 211) {
                                d = F[Hd(14288, 14480, e + 12 | 0) >> 2];
                                break a;
                            }
                            if (a >>> 0 >= 4294967292) {
                                $b();
                                V();
                            }
                            f = (a >>> 0) / 210 | 0;
                            d = L(f, 210);
                            F[e + 8 >> 2] = a - d;
                            g = Hd(14480, 14672, e + 8 | 0) - 14480 >> 2;
                            while (1) {
                                d = F[(g << 2) + 14480 >> 2] + d | 0;
                                a = 5;
                                b: {
                                    while (1) {
                                        c: {
                                            if ((a | 0) == 47) {
                                                a = 211;
                                                while (1) {
                                                    b = (d >>> 0) / (a >>> 0) | 0;
                                                    if (b >>> 0 < a >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(a, b) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 10 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 12 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 16 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 18 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 22 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 28 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 30 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 36 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 40 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 42 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 46 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 52 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 58 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 60 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 66 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 70 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 72 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 78 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 82 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 88 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 96 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 100 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 102 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 106 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 108 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 112 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 120 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 126 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 130 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 136 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 138 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 142 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 148 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 150 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 156 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 162 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 166 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 168 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 172 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 178 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 180 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 186 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 190 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 192 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 196 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 198 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    if ((L(b, c) | 0) == (d | 0)) {
                                                        break c;
                                                    }
                                                    b = a + 208 | 0;
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) {
                                                        break b;
                                                    }
                                                    a = a + 210 | 0;
                                                    if ((L(b, c) | 0) != (d | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break c;
                                            }
                                            b = F[(a << 2) + 14288 >> 2];
                                            c = (d >>> 0) / (b >>> 0) | 0;
                                            if (b >>> 0 > c >>> 0) {
                                                break b;
                                            }
                                            a = a + 1 | 0;
                                            if ((L(b, c) | 0) != (d | 0)) {
                                                continue;
                                            }
                                        }
                                        break;
                                    }
                                    d = g + 1 | 0;
                                    a = (d | 0) == 48;
                                    g = a ? 0 : d;
                                    f = a + f | 0;
                                    d = L(f, 210);
                                    continue;
                                }
                                break;
                            }
                            F[e + 12 >> 2] = d;
                        } ea = e + 16 | 0; return d; }
                        function Ch(a) { a = a | 0; var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0; e = ea - 32 | 0; ea = e; c = F[a + 32 >> 2]; d = H[a + 36 >> 1]; a: {
                            b: {
                                if (((d << 8 | d >>> 8) & 65535) >>> 0 <= 513) {
                                    b = F[c + 12 >> 2];
                                    d = F[c + 20 >> 2];
                                    f = d;
                                    i = F[c + 16 >> 2];
                                    g = i + 4 | 0;
                                    d = g >>> 0 < 4 ? d + 1 | 0 : d;
                                    j = F[c + 8 >> 2];
                                    h = g;
                                    if (j >>> 0 < g >>> 0 & (b | 0) <= (d | 0) | (b | 0) < (d | 0)) {
                                        break a;
                                    }
                                    n = F[c >> 2];
                                    g = n + i | 0;
                                    l = G[g | 0] | G[g + 1 | 0] << 8 | (G[g + 2 | 0] << 16 | G[g + 3 | 0] << 24);
                                    F[c + 16 >> 2] = h;
                                    F[c + 20 >> 2] = d;
                                    d = b;
                                    b = f;
                                    f = i + 8 | 0;
                                    b = f >>> 0 < 8 ? b + 1 | 0 : b;
                                    if (f >>> 0 > j >>> 0 & (b | 0) >= (d | 0) | (b | 0) > (d | 0)) {
                                        break a;
                                    }
                                    d = h + n | 0;
                                    n = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                    F[e + 24 >> 2] = n;
                                    F[c + 16 >> 2] = f;
                                    F[c + 20 >> 2] = b;
                                    break b;
                                }
                                if (!sb(1, e + 28 | 0, c)) {
                                    break a;
                                }
                                if (!sb(1, e + 24 | 0, F[a + 32 >> 2])) {
                                    break a;
                                }
                                l = F[e + 28 >> 2];
                                n = F[e + 24 >> 2];
                            }
                            if (l >>> 0 > 1431655765) {
                                break a;
                            }
                            f = F[a + 32 >> 2];
                            d = f;
                            i = F[d + 8 >> 2];
                            b = i;
                            c = F[d + 16 >> 2];
                            h = b - c | 0;
                            g = F[d + 12 >> 2];
                            o = b >>> 0 < c >>> 0;
                            b = F[d + 20 >> 2];
                            d = Ij(h, g - (o + b | 0) | 0, 3, 0);
                            if (!fa & d >>> 0 < l >>> 0) {
                                break a;
                            }
                            d = Hj(l, 0, 3, 0);
                            if (!fa & d >>> 0 < n >>> 0 | ((b | 0) >= (g | 0) & c >>> 0 >= i >>> 0 | (b | 0) > (g | 0))) {
                                break a;
                            }
                            g = G[c + F[f >> 2] | 0];
                            i = c + 1 | 0;
                            d = i ? b : b + 1 | 0;
                            F[f + 16 >> 2] = i;
                            F[f + 20 >> 2] = d;
                            c: {
                                if (!g) {
                                    f = 0;
                                    b = ea - 32 | 0;
                                    ea = b;
                                    F[b + 24 >> 2] = 0;
                                    F[b + 16 >> 2] = 0;
                                    F[b + 20 >> 2] = 0;
                                    d: {
                                        e: {
                                            d = L(l, 3);
                                            if (d) {
                                                if (d >>> 0 >= 1073741824) {
                                                    break e;
                                                }
                                                c = L(l, 12);
                                                f = sa(c);
                                                F[b + 16 >> 2] = f;
                                                ua(f, 0, c);
                                            }
                                            d = ld(d, 1, F[a + 32 >> 2], f);
                                            f: {
                                                g: {
                                                    if (!(!d | !l)) {
                                                        g = 0;
                                                        c = 0;
                                                        while (1) {
                                                            i = (c << 2) + f | 0;
                                                            h = F[i >> 2];
                                                            j = h >>> 1 | 0;
                                                            h = (h & 1 ? 0 - j | 0 : j) + k | 0;
                                                            F[b >> 2] = h;
                                                            j = F[i + 4 >> 2];
                                                            k = j >>> 1 | 0;
                                                            h = h + (j & 1 ? 0 - k | 0 : k) | 0;
                                                            F[b + 4 >> 2] = h;
                                                            i = F[i + 8 >> 2];
                                                            j = i >>> 1 | 0;
                                                            k = h + (i & 1 ? 0 - j | 0 : j) | 0;
                                                            F[b + 8 >> 2] = k;
                                                            Sb(F[a + 44 >> 2] + 96 | 0, b);
                                                            c = c + 3 | 0;
                                                            g = g + 1 | 0;
                                                            if ((g | 0) != (l | 0)) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        break g;
                                                    }
                                                    if (!f) {
                                                        break f;
                                                    }
                                                }
                                                ra(f);
                                            }
                                            ea = b + 32 | 0;
                                            break d;
                                        }
                                        va();
                                        V();
                                    }
                                    if (!d) {
                                        break a;
                                    }
                                    break c;
                                }
                                h: {
                                    if (n >>> 0 <= 255) {
                                        if (!l) {
                                            break c;
                                        }
                                        F[e + 16 >> 2] = 0;
                                        F[e + 8 >> 2] = 0;
                                        F[e + 12 >> 2] = 0;
                                        c = F[f + 12 >> 2];
                                        b = c;
                                        h = F[f + 8 >> 2];
                                        if ((d | 0) >= (b | 0) & i >>> 0 >= h >>> 0 | (b | 0) < (d | 0)) {
                                            break h;
                                        }
                                        while (1) {
                                            g = F[f >> 2];
                                            k = G[g + i | 0];
                                            b = d;
                                            j = i + 1 | 0;
                                            b = j ? b : b + 1 | 0;
                                            F[f + 16 >> 2] = j;
                                            F[f + 20 >> 2] = b;
                                            F[e + 8 >> 2] = k;
                                            if ((b | 0) >= (c | 0) & j >>> 0 >= h >>> 0 | (b | 0) > (c | 0)) {
                                                break h;
                                            }
                                            k = G[g + j | 0];
                                            b = d;
                                            j = i + 2 | 0;
                                            b = j >>> 0 < 2 ? b + 1 | 0 : b;
                                            F[f + 16 >> 2] = j;
                                            F[f + 20 >> 2] = b;
                                            F[e + 12 >> 2] = k;
                                            if ((b | 0) >= (c | 0) & j >>> 0 >= h >>> 0 | (b | 0) > (c | 0)) {
                                                break h;
                                            }
                                            b = G[g + j | 0];
                                            c = i + 3 | 0;
                                            d = c >>> 0 < 3 ? d + 1 | 0 : d;
                                            F[f + 16 >> 2] = c;
                                            F[f + 20 >> 2] = d;
                                            F[e + 16 >> 2] = b;
                                            Sb(F[a + 44 >> 2] + 96 | 0, e + 8 | 0);
                                            m = m + 1 | 0;
                                            if ((m | 0) == (l | 0)) {
                                                break c;
                                            }
                                            f = F[a + 32 >> 2];
                                            b = f;
                                            i = F[b + 16 >> 2];
                                            d = F[b + 20 >> 2];
                                            F[e + 16 >> 2] = 0;
                                            F[e + 8 >> 2] = 0;
                                            F[e + 12 >> 2] = 0;
                                            h = F[b + 8 >> 2];
                                            c = F[b + 12 >> 2];
                                            b = c;
                                            if (i >>> 0 < h >>> 0 & (d | 0) <= (b | 0) | (b | 0) > (d | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                        break h;
                                    }
                                    if (n >>> 0 <= 65535) {
                                        if (!l) {
                                            break c;
                                        }
                                        F[e + 16 >> 2] = 0;
                                        F[e + 8 >> 2] = 0;
                                        F[e + 12 >> 2] = 0;
                                        g = F[f + 12 >> 2];
                                        c = c + 3 | 0;
                                        b = c >>> 0 < 3 ? b + 1 | 0 : b;
                                        j = F[f + 8 >> 2];
                                        h = c;
                                        c = b;
                                        if (j >>> 0 < h >>> 0 & (b | 0) >= (g | 0) | (b | 0) > (g | 0)) {
                                            break h;
                                        }
                                        while (1) {
                                            k = F[f >> 2];
                                            b = k + i | 0;
                                            b = G[b | 0] | G[b + 1 | 0] << 8;
                                            F[f + 16 >> 2] = h;
                                            F[f + 20 >> 2] = c;
                                            F[e + 8 >> 2] = b;
                                            b = d;
                                            c = i + 4 | 0;
                                            b = c >>> 0 < 4 ? b + 1 | 0 : b;
                                            if (c >>> 0 > j >>> 0 & (b | 0) >= (g | 0) | (b | 0) > (g | 0)) {
                                                break h;
                                            }
                                            h = h + k | 0;
                                            h = G[h | 0] | G[h + 1 | 0] << 8;
                                            F[f + 16 >> 2] = c;
                                            F[f + 20 >> 2] = b;
                                            F[e + 12 >> 2] = h;
                                            b = d;
                                            d = i + 6 | 0;
                                            b = d >>> 0 < 6 ? b + 1 | 0 : b;
                                            if (d >>> 0 > j >>> 0 & (b | 0) >= (g | 0) | (b | 0) > (g | 0)) {
                                                break h;
                                            }
                                            c = c + k | 0;
                                            c = G[c | 0] | G[c + 1 | 0] << 8;
                                            F[f + 16 >> 2] = d;
                                            F[f + 20 >> 2] = b;
                                            F[e + 16 >> 2] = c;
                                            Sb(F[a + 44 >> 2] + 96 | 0, e + 8 | 0);
                                            m = m + 1 | 0;
                                            if ((m | 0) == (l | 0)) {
                                                break c;
                                            }
                                            f = F[a + 32 >> 2];
                                            b = f;
                                            i = F[b + 16 >> 2];
                                            d = F[b + 20 >> 2];
                                            F[e + 16 >> 2] = 0;
                                            F[e + 8 >> 2] = 0;
                                            F[e + 12 >> 2] = 0;
                                            g = F[b + 12 >> 2];
                                            j = F[b + 8 >> 2];
                                            b = d;
                                            c = i + 2 | 0;
                                            b = c >>> 0 < 2 ? b + 1 | 0 : b;
                                            h = c;
                                            c = b;
                                            if ((b | 0) <= (g | 0) & j >>> 0 >= h >>> 0 | (b | 0) < (g | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                        break h;
                                    }
                                    i: {
                                        if (n >>> 0 > 2097151) {
                                            break i;
                                        }
                                        g = H[a + 36 >> 1];
                                        if (((g << 8 | g >>> 8) & 65535) >>> 0 < 514) {
                                            break i;
                                        }
                                        if (!l) {
                                            break c;
                                        }
                                        F[e + 16 >> 2] = 0;
                                        F[e + 8 >> 2] = 0;
                                        F[e + 12 >> 2] = 0;
                                        if (!sb(1, e + 4 | 0, f)) {
                                            break h;
                                        }
                                        while (1) {
                                            F[e + 8 >> 2] = F[e + 4 >> 2];
                                            if (!sb(1, e + 4 | 0, F[a + 32 >> 2])) {
                                                break h;
                                            }
                                            F[e + 12 >> 2] = F[e + 4 >> 2];
                                            if (!sb(1, e + 4 | 0, F[a + 32 >> 2])) {
                                                break h;
                                            }
                                            F[e + 16 >> 2] = F[e + 4 >> 2];
                                            Sb(F[a + 44 >> 2] + 96 | 0, e + 8 | 0);
                                            m = m + 1 | 0;
                                            if ((m | 0) == (l | 0)) {
                                                break c;
                                            }
                                            d = F[a + 32 >> 2];
                                            F[e + 16 >> 2] = 0;
                                            F[e + 8 >> 2] = 0;
                                            F[e + 12 >> 2] = 0;
                                            if (sb(1, e + 4 | 0, d)) {
                                                continue;
                                            }
                                            break;
                                        }
                                        break h;
                                    }
                                    if (!l) {
                                        break c;
                                    }
                                    F[e + 16 >> 2] = 0;
                                    F[e + 8 >> 2] = 0;
                                    F[e + 12 >> 2] = 0;
                                    g = F[f + 12 >> 2];
                                    c = c + 5 | 0;
                                    b = c >>> 0 < 5 ? b + 1 | 0 : b;
                                    j = F[f + 8 >> 2];
                                    h = c;
                                    c = b;
                                    if (j >>> 0 < h >>> 0 & (b | 0) >= (g | 0) | (b | 0) > (g | 0)) {
                                        break h;
                                    }
                                    while (1) {
                                        k = F[f >> 2];
                                        b = k + i | 0;
                                        b = G[b | 0] | G[b + 1 | 0] << 8 | (G[b + 2 | 0] << 16 | G[b + 3 | 0] << 24);
                                        F[f + 16 >> 2] = h;
                                        F[f + 20 >> 2] = c;
                                        F[e + 8 >> 2] = b;
                                        b = d;
                                        c = i + 8 | 0;
                                        b = c >>> 0 < 8 ? b + 1 | 0 : b;
                                        o = c;
                                        if (c >>> 0 > j >>> 0 & (b | 0) >= (g | 0) | (b | 0) > (g | 0)) {
                                            break h;
                                        }
                                        c = h + k | 0;
                                        c = G[c | 0] | G[c + 1 | 0] << 8 | (G[c + 2 | 0] << 16 | G[c + 3 | 0] << 24);
                                        F[f + 16 >> 2] = o;
                                        F[f + 20 >> 2] = b;
                                        F[e + 12 >> 2] = c;
                                        b = i + 12 | 0;
                                        d = b >>> 0 < 12 ? d + 1 | 0 : d;
                                        c = b;
                                        if (b >>> 0 > j >>> 0 & (d | 0) >= (g | 0) | (d | 0) > (g | 0)) {
                                            break h;
                                        }
                                        b = k + o | 0;
                                        b = G[b | 0] | G[b + 1 | 0] << 8 | (G[b + 2 | 0] << 16 | G[b + 3 | 0] << 24);
                                        F[f + 16 >> 2] = c;
                                        F[f + 20 >> 2] = d;
                                        F[e + 16 >> 2] = b;
                                        Sb(F[a + 44 >> 2] + 96 | 0, e + 8 | 0);
                                        m = m + 1 | 0;
                                        if ((m | 0) == (l | 0)) {
                                            break c;
                                        }
                                        f = F[a + 32 >> 2];
                                        b = f;
                                        i = F[b + 16 >> 2];
                                        d = F[b + 20 >> 2];
                                        F[e + 16 >> 2] = 0;
                                        F[e + 8 >> 2] = 0;
                                        F[e + 12 >> 2] = 0;
                                        g = F[b + 12 >> 2];
                                        j = F[b + 8 >> 2];
                                        b = d;
                                        c = i + 4 | 0;
                                        b = c >>> 0 < 4 ? b + 1 | 0 : b;
                                        h = c;
                                        c = b;
                                        if ((b | 0) <= (g | 0) & j >>> 0 >= h >>> 0 | (b | 0) < (g | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                m = 0;
                                break a;
                            }
                            F[F[a + 4 >> 2] + 80 >> 2] = n;
                            m = 1;
                        } ea = e + 32 | 0; return m | 0; }
                        function Hb(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0; m = ea - 16 | 0; ea = m; a: {
                            b: {
                                c: {
                                    d: {
                                        if (G[F[a + 4 >> 2] + 36 | 0] <= 1) {
                                            j = -1;
                                            c = F[b + 20 >> 2];
                                            e = F[b + 16 >> 2];
                                            d = e + 4 | 0;
                                            c = d >>> 0 < 4 ? c + 1 | 0 : c;
                                            k = F[b + 12 >> 2];
                                            if ((k | 0) <= (c | 0) & d >>> 0 > I[b + 8 >> 2] | (c | 0) > (k | 0)) {
                                                break c;
                                            }
                                            e = e + F[b >> 2] | 0;
                                            e = G[e | 0] | G[e + 1 | 0] << 8 | (G[e + 2 | 0] << 16 | G[e + 3 | 0] << 24);
                                            F[m + 12 >> 2] = e;
                                            F[b + 16 >> 2] = d;
                                            F[b + 20 >> 2] = c;
                                            break d;
                                        }
                                        j = -1;
                                        if (!Fa(1, m + 12 | 0, b)) {
                                            break c;
                                        }
                                        e = F[m + 12 >> 2];
                                    }
                                    e: {
                                        f: {
                                            g: {
                                                h: {
                                                    i: {
                                                        j: {
                                                            if (!e) {
                                                                break j;
                                                            }
                                                            c = F[a + 8 >> 2];
                                                            if ((F[c + 4 >> 2] - F[c >> 2] >> 2 >>> 0) / 3 >>> 0 < e >>> 0) {
                                                                break c;
                                                            }
                                                            c = H[F[a + 4 >> 2] + 36 >> 1];
                                                            if (((c << 8 | c >>> 8) & 65535) >>> 0 >= 258) {
                                                                k = 0;
                                                                k: {
                                                                    l: {
                                                                        while (1) {
                                                                            if (!Fa(1, m + 8 | 0, b)) {
                                                                                break c;
                                                                            }
                                                                            c = F[m + 8 >> 2];
                                                                            if (!Fa(1, m + 8 | 0, b)) {
                                                                                break c;
                                                                            }
                                                                            f = c + f | 0;
                                                                            c = F[m + 8 >> 2];
                                                                            if (f >>> 0 < c >>> 0) {
                                                                                break c;
                                                                            }
                                                                            h = f - c | 0;
                                                                            g = F[a + 40 >> 2];
                                                                            m: {
                                                                                if ((g | 0) != F[a + 44 >> 2]) {
                                                                                    F[g + 4 >> 2] = f;
                                                                                    F[g >> 2] = h;
                                                                                    F[a + 40 >> 2] = g + 12;
                                                                                    break m;
                                                                                }
                                                                                c = F[a + 36 >> 2];
                                                                                d = g - c | 0;
                                                                                g = (d | 0) / 12 | 0;
                                                                                i = g + 1 | 0;
                                                                                if (i >>> 0 >= 357913942) {
                                                                                    break l;
                                                                                }
                                                                                l = g << 1;
                                                                                i = g >>> 0 < 178956970 ? i >>> 0 > l >>> 0 ? i : l : 357913941;
                                                                                if (i >>> 0 >= 357913942) {
                                                                                    break k;
                                                                                }
                                                                                i = L(i, 12);
                                                                                l = sa(i);
                                                                                g = l + L(g, 12) | 0;
                                                                                F[g + 4 >> 2] = f;
                                                                                F[g >> 2] = h;
                                                                                h = g + L((d | 0) / -12 | 0, 12) | 0;
                                                                                g = g + 12 | 0;
                                                                                if ((d | 0) > 0) {
                                                                                    ta(h, c, d);
                                                                                }
                                                                                F[a + 44 >> 2] = i + l;
                                                                                F[a + 40 >> 2] = g;
                                                                                F[a + 36 >> 2] = h;
                                                                                if (!c) {
                                                                                    break m;
                                                                                }
                                                                                ra(c);
                                                                            }
                                                                            k = k + 1 | 0;
                                                                            if ((k | 0) != (e | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        j = 0;
                                                                        Eb(b, 0, 0);
                                                                        d = e >>> 0 > 1 ? e : 1;
                                                                        while (1) {
                                                                            c = G[b + 36 | 0];
                                                                            f = H[F[a + 4 >> 2] + 36 >> 1];
                                                                            n: {
                                                                                o: {
                                                                                    if (((f << 8 | f >>> 8) & 65535) >>> 0 <= 513) {
                                                                                        if (!c) {
                                                                                            break n;
                                                                                        }
                                                                                        g = 0;
                                                                                        c = F[b + 32 >> 2];
                                                                                        f = c >>> 3 | 0;
                                                                                        k = F[b + 24 >> 2];
                                                                                        e = f + k | 0;
                                                                                        h = F[b + 28 >> 2];
                                                                                        p: {
                                                                                            if (e >>> 0 >= h >>> 0) {
                                                                                                e = c;
                                                                                                break p;
                                                                                            }
                                                                                            g = G[e | 0];
                                                                                            e = c + 1 | 0;
                                                                                            F[b + 32 >> 2] = e;
                                                                                            f = e >>> 3 | 0;
                                                                                            g = g >>> (c & 7) & 1;
                                                                                        }
                                                                                        if (h >>> 0 > f + k >>> 0) {
                                                                                            break o;
                                                                                        }
                                                                                        break n;
                                                                                    }
                                                                                    if (!c) {
                                                                                        break n;
                                                                                    }
                                                                                    g = 0;
                                                                                    e = F[b + 32 >> 2];
                                                                                    c = F[b + 24 >> 2] + (e >>> 3 | 0) | 0;
                                                                                    if (c >>> 0 >= I[b + 28 >> 2]) {
                                                                                        break n;
                                                                                    }
                                                                                    g = G[c | 0] >>> (e & 7) & 1;
                                                                                }
                                                                                F[b + 32 >> 2] = e + 1;
                                                                            }
                                                                            c = F[a + 36 >> 2] + L(j, 12) | 0;
                                                                            D[c + 8 | 0] = G[c + 8 | 0] & 254 | g & 1;
                                                                            j = j + 1 | 0;
                                                                            if ((d | 0) != (j | 0)) {
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        D[b + 36 | 0] = 0;
                                                                        c = F[b + 20 >> 2];
                                                                        f = 0;
                                                                        e = F[b + 32 >> 2] + 7 | 0;
                                                                        f = e >>> 0 < 7 ? 1 : f;
                                                                        d = f >>> 3 | 0;
                                                                        e = (f & 7) << 29 | e >>> 3;
                                                                        f = e + F[b + 16 >> 2] | 0;
                                                                        c = c + d | 0;
                                                                        F[b + 16 >> 2] = f;
                                                                        F[b + 20 >> 2] = e >>> 0 > f >>> 0 ? c + 1 | 0 : c;
                                                                        break j;
                                                                    }
                                                                    va();
                                                                    V();
                                                                }
                                                                break a;
                                                            }
                                                            k = 0;
                                                            while (1) {
                                                                d = F[b + 12 >> 2];
                                                                c = F[b + 20 >> 2];
                                                                f = c;
                                                                h = F[b + 16 >> 2];
                                                                i = h + 4 | 0;
                                                                c = i >>> 0 < 4 ? c + 1 | 0 : c;
                                                                n = F[b + 8 >> 2];
                                                                l = i;
                                                                if (n >>> 0 < i >>> 0 & (c | 0) >= (d | 0) | (c | 0) > (d | 0)) {
                                                                    break c;
                                                                }
                                                                o = F[b >> 2];
                                                                i = o + h | 0;
                                                                p = G[i | 0] | G[i + 1 | 0] << 8 | (G[i + 2 | 0] << 16 | G[i + 3 | 0] << 24);
                                                                F[b + 16 >> 2] = l;
                                                                F[b + 20 >> 2] = c;
                                                                c = f;
                                                                i = h + 8 | 0;
                                                                c = i >>> 0 < 8 ? c + 1 | 0 : c;
                                                                if (i >>> 0 > n >>> 0 & (c | 0) >= (d | 0) | (c | 0) > (d | 0)) {
                                                                    break c;
                                                                }
                                                                l = l + o | 0;
                                                                l = G[l | 0] | G[l + 1 | 0] << 8 | (G[l + 2 | 0] << 16 | G[l + 3 | 0] << 24);
                                                                F[b + 16 >> 2] = i;
                                                                F[b + 20 >> 2] = c;
                                                                if ((c | 0) >= (d | 0) & i >>> 0 >= n >>> 0 | (c | 0) > (d | 0)) {
                                                                    break c;
                                                                }
                                                                c = G[i + o | 0];
                                                                d = h + 9 | 0;
                                                                f = d >>> 0 < 9 ? f + 1 | 0 : f;
                                                                F[b + 16 >> 2] = d;
                                                                F[b + 20 >> 2] = f;
                                                                g = c & 1 | g & -2;
                                                                c = F[a + 40 >> 2];
                                                                q: {
                                                                    if ((c | 0) != F[a + 44 >> 2]) {
                                                                        D[c + 8 | 0] = g;
                                                                        F[c + 4 >> 2] = l;
                                                                        F[c >> 2] = p;
                                                                        F[a + 40 >> 2] = c + 12;
                                                                        break q;
                                                                    }
                                                                    f = F[a + 36 >> 2];
                                                                    d = c - f | 0;
                                                                    c = (d | 0) / 12 | 0;
                                                                    h = c + 1 | 0;
                                                                    if (h >>> 0 >= 357913942) {
                                                                        break i;
                                                                    }
                                                                    i = c << 1;
                                                                    h = c >>> 0 < 178956970 ? h >>> 0 > i >>> 0 ? h : i : 357913941;
                                                                    if (h >>> 0 >= 357913942) {
                                                                        break a;
                                                                    }
                                                                    i = L(h, 12);
                                                                    n = sa(i);
                                                                    c = n + L(c, 12) | 0;
                                                                    D[c + 8 | 0] = g;
                                                                    F[c + 4 >> 2] = l;
                                                                    F[c >> 2] = p;
                                                                    h = c + L((d | 0) / -12 | 0, 12) | 0;
                                                                    if ((d | 0) > 0) {
                                                                        ta(h, f, d);
                                                                    }
                                                                    F[a + 44 >> 2] = i + n;
                                                                    F[a + 40 >> 2] = c + 12;
                                                                    F[a + 36 >> 2] = h;
                                                                    if (!f) {
                                                                        break q;
                                                                    }
                                                                    ra(f);
                                                                }
                                                                k = k + 1 | 0;
                                                                if ((k | 0) != (e | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                        }
                                                        F[m + 8 >> 2] = 0;
                                                        c = H[F[a + 4 >> 2] + 36 >> 1];
                                                        c = (c << 8 | c >>> 8) & 65535;
                                                        r: {
                                                            if (c >>> 0 <= 511) {
                                                                j = -1;
                                                                c = F[b + 20 >> 2];
                                                                f = F[b + 16 >> 2];
                                                                e = f + 4 | 0;
                                                                c = e >>> 0 < 4 ? c + 1 | 0 : c;
                                                                d = F[b + 12 >> 2];
                                                                if ((d | 0) <= (c | 0) & e >>> 0 > I[b + 8 >> 2] | (c | 0) > (d | 0)) {
                                                                    break c;
                                                                }
                                                                f = f + F[b >> 2] | 0;
                                                                f = G[f | 0] | G[f + 1 | 0] << 8 | (G[f + 2 | 0] << 16 | G[f + 3 | 0] << 24);
                                                                F[b + 16 >> 2] = e;
                                                                F[b + 20 >> 2] = c;
                                                                break r;
                                                            }
                                                            if ((c | 0) != 512) {
                                                                break e;
                                                            }
                                                            j = -1;
                                                            if (!Fa(1, m + 8 | 0, b)) {
                                                                break c;
                                                            }
                                                            f = F[m + 8 >> 2];
                                                        }
                                                        if (!f) {
                                                            break e;
                                                        }
                                                        c = H[F[a + 4 >> 2] + 36 >> 1];
                                                        if (((c << 8 | c >>> 8) & 65535) >>> 0 < 258) {
                                                            break f;
                                                        }
                                                        g = 0;
                                                        j = 0;
                                                        while (1) {
                                                            if (!Fa(1, m + 4 | 0, b)) {
                                                                break g;
                                                            }
                                                            j = F[m + 4 >> 2] + j | 0;
                                                            c = F[a + 52 >> 2];
                                                            s: {
                                                                if ((c | 0) != F[a + 56 >> 2]) {
                                                                    F[c >> 2] = j;
                                                                    F[a + 52 >> 2] = c + 4;
                                                                    break s;
                                                                }
                                                                d = F[a + 48 >> 2];
                                                                e = c - d | 0;
                                                                h = e >> 2;
                                                                c = h + 1 | 0;
                                                                if (c >>> 0 >= 1073741824) {
                                                                    break h;
                                                                }
                                                                k = e >> 1;
                                                                k = e >>> 0 < 2147483644 ? c >>> 0 > k >>> 0 ? c : k : 1073741823;
                                                                if (k) {
                                                                    if (k >>> 0 >= 1073741824) {
                                                                        break a;
                                                                    }
                                                                    c = sa(k << 2);
                                                                }
                                                                else {
                                                                    c = 0;
                                                                }
                                                                h = c + (h << 2) | 0;
                                                                F[h >> 2] = j;
                                                                if ((e | 0) > 0) {
                                                                    ta(c, d, e);
                                                                }
                                                                F[a + 56 >> 2] = c + (k << 2);
                                                                F[a + 52 >> 2] = h + 4;
                                                                F[a + 48 >> 2] = c;
                                                                if (!d) {
                                                                    break s;
                                                                }
                                                                ra(d);
                                                            }
                                                            g = g + 1 | 0;
                                                            if ((f | 0) != (g | 0)) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        break e;
                                                    }
                                                    va();
                                                    V();
                                                }
                                                va();
                                                V();
                                            }
                                            j = -1;
                                            break c;
                                        }
                                        e = 0;
                                        while (1) {
                                            c = F[b + 20 >> 2];
                                            d = F[b + 16 >> 2];
                                            g = d + 4 | 0;
                                            c = g >>> 0 < 4 ? c + 1 | 0 : c;
                                            j = F[b + 12 >> 2];
                                            if ((j | 0) <= (c | 0) & g >>> 0 > I[b + 8 >> 2] | (c | 0) > (j | 0)) {
                                                j = -1;
                                                break c;
                                            }
                                            d = d + F[b >> 2] | 0;
                                            k = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                            F[b + 16 >> 2] = g;
                                            F[b + 20 >> 2] = c;
                                            c = F[a + 52 >> 2];
                                            t: {
                                                if ((c | 0) != F[a + 56 >> 2]) {
                                                    F[c >> 2] = k;
                                                    F[a + 52 >> 2] = c + 4;
                                                    break t;
                                                }
                                                g = F[a + 48 >> 2];
                                                d = c - g | 0;
                                                h = d >> 2;
                                                c = h + 1 | 0;
                                                if (c >>> 0 >= 1073741824) {
                                                    break b;
                                                }
                                                j = d >> 1;
                                                j = d >>> 0 < 2147483644 ? c >>> 0 > j >>> 0 ? c : j : 1073741823;
                                                if (j) {
                                                    if (j >>> 0 >= 1073741824) {
                                                        break a;
                                                    }
                                                    c = sa(j << 2);
                                                }
                                                else {
                                                    c = 0;
                                                }
                                                h = c + (h << 2) | 0;
                                                F[h >> 2] = k;
                                                if ((d | 0) > 0) {
                                                    ta(c, g, d);
                                                }
                                                F[a + 56 >> 2] = c + (j << 2);
                                                F[a + 52 >> 2] = h + 4;
                                                F[a + 48 >> 2] = c;
                                                if (!g) {
                                                    break t;
                                                }
                                                ra(g);
                                            }
                                            e = e + 1 | 0;
                                            if ((f | 0) != (e | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    j = F[b + 16 >> 2];
                                }
                                ea = m + 16 | 0;
                                return j;
                            }
                            va();
                            V();
                        } wa(1336); V(); }
                        function jc(a, b, c, d) { var e = 0, f = 0, g = 0, h = 0, i = M(0), j = 0; a: {
                            if (!d) {
                                break a;
                            }
                            b: {
                                c: {
                                    switch (F[a + 28 >> 2] - 1 | 0) {
                                        case 0:
                                            d: {
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                    break d;
                                                }
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                f = F[a >> 2];
                                                e = F[f >> 2];
                                                if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                                    break a;
                                                }
                                                f = b + e | 0;
                                                b = 0;
                                                while (1) {
                                                    D[b + d | 0] = G[f | 0];
                                                    b = b + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        break d;
                                                    }
                                                    f = f + 1 | 0;
                                                    if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break a;
                                            }
                                            g = 1;
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 1:
                                            e: {
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                    break e;
                                                }
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                f = F[a >> 2];
                                                e = F[f >> 2];
                                                if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                                    break a;
                                                }
                                                f = b + e | 0;
                                                b = 0;
                                                while (1) {
                                                    e = D[f | 0];
                                                    if ((e | 0) < 0) {
                                                        break a;
                                                    }
                                                    D[b + d | 0] = e;
                                                    b = b + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        break e;
                                                    }
                                                    f = f + 1 | 0;
                                                    if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break a;
                                            }
                                            g = 1;
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 2:
                                            f: {
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                    break f;
                                                }
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                f = F[a >> 2];
                                                e = F[f >> 2];
                                                if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                                    break a;
                                                }
                                                f = b + e | 0;
                                                b = 0;
                                                while (1) {
                                                    e = H[f >> 1];
                                                    if ((e - 128 & 65535) >>> 0 < 65280) {
                                                        break a;
                                                    }
                                                    D[b + d | 0] = e;
                                                    b = b + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        break f;
                                                    }
                                                    f = f + 2 | 0;
                                                    if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break a;
                                            }
                                            g = 1;
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 3:
                                            g: {
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                    break g;
                                                }
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                f = F[a >> 2];
                                                e = F[f >> 2];
                                                if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                                    break a;
                                                }
                                                f = b + e | 0;
                                                b = 0;
                                                while (1) {
                                                    e = H[f >> 1];
                                                    if (e >>> 0 > 127) {
                                                        break a;
                                                    }
                                                    D[b + d | 0] = e;
                                                    b = b + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        break g;
                                                    }
                                                    f = f + 2 | 0;
                                                    if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break a;
                                            }
                                            g = 1;
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 4:
                                            h: {
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                    break h;
                                                }
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                f = F[a >> 2];
                                                e = F[f >> 2];
                                                if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                                    break a;
                                                }
                                                f = b + e | 0;
                                                b = 0;
                                                while (1) {
                                                    e = F[f >> 2];
                                                    if (e - 128 >>> 0 < 4294967040) {
                                                        break a;
                                                    }
                                                    D[b + d | 0] = e;
                                                    b = b + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        break h;
                                                    }
                                                    f = f + 4 | 0;
                                                    if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break a;
                                            }
                                            g = 1;
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 5:
                                            i: {
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                    break i;
                                                }
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                f = F[a >> 2];
                                                e = F[f >> 2];
                                                if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                                    break a;
                                                }
                                                f = b + e | 0;
                                                b = 0;
                                                while (1) {
                                                    e = F[f >> 2];
                                                    if (e >>> 0 > 127) {
                                                        break a;
                                                    }
                                                    D[b + d | 0] = e;
                                                    b = b + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        break i;
                                                    }
                                                    f = f + 4 | 0;
                                                    if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break a;
                                            }
                                            g = 1;
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 6:
                                            j: {
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                    break j;
                                                }
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                f = F[a >> 2];
                                                e = F[f >> 2];
                                                if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                                    break a;
                                                }
                                                f = b + e | 0;
                                                b = 0;
                                                while (1) {
                                                    h = F[f >> 2];
                                                    e = F[f + 4 >> 2] - (h >>> 0 < 128) | 0;
                                                    if ((e | 0) == -1 & h - 128 >>> 0 < 4294967040 | (e | 0) != -1) {
                                                        break a;
                                                    }
                                                    D[b + d | 0] = h;
                                                    b = b + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        break j;
                                                    }
                                                    f = f + 8 | 0;
                                                    if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break a;
                                            }
                                            g = 1;
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 7:
                                            k: {
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                    break k;
                                                }
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                f = F[a >> 2];
                                                e = F[f >> 2];
                                                if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                                    break a;
                                                }
                                                f = b + e | 0;
                                                b = 0;
                                                while (1) {
                                                    e = F[f + 4 >> 2];
                                                    h = F[f >> 2];
                                                    if (!e & h >>> 0 > 127 | e) {
                                                        break a;
                                                    }
                                                    D[b + d | 0] = h;
                                                    b = b + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        break k;
                                                    }
                                                    f = f + 8 | 0;
                                                    if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break a;
                                            }
                                            g = 1;
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 8:
                                            l: {
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                    break l;
                                                }
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                f = F[a >> 2];
                                                e = F[f >> 2];
                                                if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                                    break a;
                                                }
                                                f = b + e | 0;
                                                b = 0;
                                                while (1) {
                                                    h = b + d | 0;
                                                    i = J[f >> 2];
                                                    m: {
                                                        if (M(N(i)) < M(2147483648)) {
                                                            e = ~~i;
                                                            break m;
                                                        }
                                                        e = -2147483648;
                                                    }
                                                    D[h | 0] = e;
                                                    b = b + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        break l;
                                                    }
                                                    f = f + 4 | 0;
                                                    if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break a;
                                            }
                                            g = 1;
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 9:
                                            n: {
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                    break n;
                                                }
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                f = F[a >> 2];
                                                e = F[f >> 2];
                                                if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                                    break a;
                                                }
                                                f = b + e | 0;
                                                b = 0;
                                                while (1) {
                                                    h = b + d | 0;
                                                    j = K[f >> 3];
                                                    o: {
                                                        if (N(j) < 2147483648) {
                                                            e = ~~j;
                                                            break o;
                                                        }
                                                        e = -2147483648;
                                                    }
                                                    D[h | 0] = e;
                                                    b = b + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        break n;
                                                    }
                                                    f = f + 8 | 0;
                                                    if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break a;
                                            }
                                            g = 1;
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 10: break c;
                                        default: break a;
                                    }
                                }
                                p: {
                                    e = D[a + 24 | 0];
                                    if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                        break p;
                                    }
                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                    f = F[a >> 2];
                                    e = F[f >> 2];
                                    if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                        break a;
                                    }
                                    f = b + e | 0;
                                    b = 0;
                                    while (1) {
                                        D[b + d | 0] = G[f | 0];
                                        b = b + 1 | 0;
                                        e = D[a + 24 | 0];
                                        if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                            break p;
                                        }
                                        f = f + 1 | 0;
                                        if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                            continue;
                                        }
                                        break;
                                    }
                                    break a;
                                }
                                g = 1;
                                if ((c | 0) <= (e | 0)) {
                                    break a;
                                }
                            }
                            ua(d + e | 0, 0, c - e | 0);
                        } return g; }
                        function ic(a, b, c, d) { var e = 0, f = 0, g = 0, h = 0, i = M(0), j = 0; a: {
                            if (!d) {
                                break a;
                            }
                            b: {
                                c: {
                                    switch (F[a + 28 >> 2] - 1 | 0) {
                                        case 0:
                                            d: {
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                    break d;
                                                }
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                f = F[a >> 2];
                                                e = F[f >> 2];
                                                if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                                    break a;
                                                }
                                                f = b + e | 0;
                                                b = 0;
                                                while (1) {
                                                    e = D[f | 0];
                                                    if ((e | 0) < 0) {
                                                        break a;
                                                    }
                                                    D[b + d | 0] = e;
                                                    b = b + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        break d;
                                                    }
                                                    f = f + 1 | 0;
                                                    if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break a;
                                            }
                                            g = 1;
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 1:
                                            e: {
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                    break e;
                                                }
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                f = F[a >> 2];
                                                e = F[f >> 2];
                                                if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                                    break a;
                                                }
                                                f = b + e | 0;
                                                b = 0;
                                                while (1) {
                                                    D[b + d | 0] = G[f | 0];
                                                    b = b + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        break e;
                                                    }
                                                    f = f + 1 | 0;
                                                    if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break a;
                                            }
                                            g = 1;
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 2:
                                            f: {
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                    break f;
                                                }
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                f = F[a >> 2];
                                                e = F[f >> 2];
                                                if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                                    break a;
                                                }
                                                f = b + e | 0;
                                                b = 0;
                                                while (1) {
                                                    e = H[f >> 1];
                                                    if (e >>> 0 > 255) {
                                                        break a;
                                                    }
                                                    D[b + d | 0] = e;
                                                    b = b + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        break f;
                                                    }
                                                    f = f + 2 | 0;
                                                    if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break a;
                                            }
                                            g = 1;
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 3:
                                            g: {
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                    break g;
                                                }
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                f = F[a >> 2];
                                                e = F[f >> 2];
                                                if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                                    break a;
                                                }
                                                f = b + e | 0;
                                                b = 0;
                                                while (1) {
                                                    e = H[f >> 1];
                                                    if (e >>> 0 > 255) {
                                                        break a;
                                                    }
                                                    D[b + d | 0] = e;
                                                    b = b + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        break g;
                                                    }
                                                    f = f + 2 | 0;
                                                    if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break a;
                                            }
                                            g = 1;
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 4:
                                            h: {
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                    break h;
                                                }
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                f = F[a >> 2];
                                                e = F[f >> 2];
                                                if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                                    break a;
                                                }
                                                f = b + e | 0;
                                                b = 0;
                                                while (1) {
                                                    e = F[f >> 2];
                                                    if (e >>> 0 > 255) {
                                                        break a;
                                                    }
                                                    D[b + d | 0] = e;
                                                    b = b + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        break h;
                                                    }
                                                    f = f + 4 | 0;
                                                    if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break a;
                                            }
                                            g = 1;
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 5:
                                            i: {
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                    break i;
                                                }
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                f = F[a >> 2];
                                                e = F[f >> 2];
                                                if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                                    break a;
                                                }
                                                f = b + e | 0;
                                                b = 0;
                                                while (1) {
                                                    e = F[f >> 2];
                                                    if (e >>> 0 > 255) {
                                                        break a;
                                                    }
                                                    D[b + d | 0] = e;
                                                    b = b + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        break i;
                                                    }
                                                    f = f + 4 | 0;
                                                    if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break a;
                                            }
                                            g = 1;
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 6:
                                            j: {
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                    break j;
                                                }
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                f = F[a >> 2];
                                                e = F[f >> 2];
                                                if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                                    break a;
                                                }
                                                f = b + e | 0;
                                                b = 0;
                                                while (1) {
                                                    e = F[f + 4 >> 2];
                                                    h = F[f >> 2];
                                                    if (!e & h >>> 0 > 255 | e) {
                                                        break a;
                                                    }
                                                    D[b + d | 0] = h;
                                                    b = b + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        break j;
                                                    }
                                                    f = f + 8 | 0;
                                                    if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break a;
                                            }
                                            g = 1;
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 7:
                                            k: {
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                    break k;
                                                }
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                f = F[a >> 2];
                                                e = F[f >> 2];
                                                if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                                    break a;
                                                }
                                                f = b + e | 0;
                                                b = 0;
                                                while (1) {
                                                    e = F[f + 4 >> 2];
                                                    h = F[f >> 2];
                                                    if (!e & h >>> 0 > 255 | e) {
                                                        break a;
                                                    }
                                                    D[b + d | 0] = h;
                                                    b = b + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        break k;
                                                    }
                                                    f = f + 8 | 0;
                                                    if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break a;
                                            }
                                            g = 1;
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 8:
                                            l: {
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                    break l;
                                                }
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                f = F[a >> 2];
                                                e = F[f >> 2];
                                                if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                                    break a;
                                                }
                                                f = b + e | 0;
                                                b = 0;
                                                while (1) {
                                                    h = b + d | 0;
                                                    i = J[f >> 2];
                                                    m: {
                                                        if (i < M(4294967296) & i >= M(0)) {
                                                            e = ~~i >>> 0;
                                                            break m;
                                                        }
                                                        e = 0;
                                                    }
                                                    D[h | 0] = e;
                                                    b = b + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        break l;
                                                    }
                                                    f = f + 4 | 0;
                                                    if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break a;
                                            }
                                            g = 1;
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 9:
                                            n: {
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                                    break n;
                                                }
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                f = F[a >> 2];
                                                e = F[f >> 2];
                                                if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                                    break a;
                                                }
                                                f = b + e | 0;
                                                b = 0;
                                                while (1) {
                                                    h = b + d | 0;
                                                    j = K[f >> 3];
                                                    o: {
                                                        if (j < 4294967296 & j >= 0) {
                                                            e = ~~j >>> 0;
                                                            break o;
                                                        }
                                                        e = 0;
                                                    }
                                                    D[h | 0] = e;
                                                    b = b + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        break n;
                                                    }
                                                    f = f + 8 | 0;
                                                    if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break a;
                                            }
                                            g = 1;
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 10: break c;
                                        default: break a;
                                    }
                                }
                                p: {
                                    e = D[a + 24 | 0];
                                    if ((((c | 0) < (e | 0) ? c : e) | 0) <= 0) {
                                        break p;
                                    }
                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                    f = F[a >> 2];
                                    e = F[f >> 2];
                                    if ((b | 0) >= (F[f + 4 >> 2] - e | 0)) {
                                        break a;
                                    }
                                    f = b + e | 0;
                                    b = 0;
                                    while (1) {
                                        D[b + d | 0] = G[f | 0];
                                        b = b + 1 | 0;
                                        e = D[a + 24 | 0];
                                        if ((b | 0) >= (((c | 0) < (e | 0) ? c : e) | 0)) {
                                            break p;
                                        }
                                        f = f + 1 | 0;
                                        if (f >>> 0 < I[F[a >> 2] + 4 >> 2]) {
                                            continue;
                                        }
                                        break;
                                    }
                                    break a;
                                }
                                g = 1;
                                if ((c | 0) <= (e | 0)) {
                                    break a;
                                }
                            }
                            ua(d + e | 0, 0, c - e | 0);
                        } return g; }
                        function ve(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0; a: {
                            b: {
                                c: {
                                    d: {
                                        e: {
                                            if (F[a + 92 >> 2] == F[a + 88 >> 2]) {
                                                break e;
                                            }
                                            c = F[a + 52 >> 2];
                                            f: {
                                                if ((c | 0) != F[a + 56 >> 2]) {
                                                    F[c >> 2] = b;
                                                    F[a + 52 >> 2] = c + 4;
                                                    break f;
                                                }
                                                d = F[a + 48 >> 2];
                                                i = c - d | 0;
                                                f = i >> 2;
                                                e = f + 1 | 0;
                                                if (e >>> 0 >= 1073741824) {
                                                    break b;
                                                }
                                                c = i >> 1;
                                                e = i >>> 0 < 2147483644 ? c >>> 0 < e >>> 0 ? e : c : 1073741823;
                                                if (e) {
                                                    if (e >>> 0 >= 1073741824) {
                                                        break a;
                                                    }
                                                    c = sa(e << 2);
                                                }
                                                else {
                                                    c = 0;
                                                }
                                                f = c + (f << 2) | 0;
                                                F[f >> 2] = b;
                                                if ((i | 0) > 0) {
                                                    ta(c, d, i);
                                                }
                                                F[a + 56 >> 2] = c + (e << 2);
                                                F[a + 52 >> 2] = f + 4;
                                                F[a + 48 >> 2] = c;
                                                if (!d) {
                                                    break f;
                                                }
                                                ra(d);
                                            }
                                            F[a + 84 >> 2] = 0;
                                            f = -1;
                                            c = -1;
                                            g: {
                                                if ((b | 0) == -1) {
                                                    break g;
                                                }
                                                e = F[a + 4 >> 2];
                                                c = b + 1 | 0;
                                                c = (c >>> 0) % 3 | 0 ? c : b - 2 | 0;
                                                if ((c | 0) != -1) {
                                                    f = F[F[e >> 2] + (c << 2) >> 2];
                                                }
                                                h: {
                                                    if ((b >>> 0) % 3 | 0) {
                                                        d = b - 1 | 0;
                                                        break h;
                                                    }
                                                    d = b + 2 | 0;
                                                    c = -1;
                                                    if ((d | 0) == -1) {
                                                        break g;
                                                    }
                                                }
                                                c = F[F[e >> 2] + (d << 2) >> 2];
                                            }
                                            h = c >>> 3 & 536870908;
                                            e = F[a + 36 >> 2];
                                            g = e + (f >>> 3 & 536870908) | 0;
                                            i = F[g >> 2];
                                            d = 1 << f;
                                            if (!(i & d)) {
                                                F[g >> 2] = d | i;
                                                g = a + 8 | 0;
                                                if ((b | 0) != -1) {
                                                    e = b + 1 | 0;
                                                    d = (e >>> 0) % 3 | 0 ? e : b - 2 | 0;
                                                }
                                                else {
                                                    d = -1;
                                                }
                                                Xa(g, f, d);
                                                e = F[a + 36 >> 2];
                                            }
                                            d = e + h | 0;
                                            e = F[d >> 2];
                                            f = 1 << c;
                                            if (!(e & f)) {
                                                F[d >> 2] = e | f;
                                                d = a + 8 | 0;
                                                f = -1;
                                                i: {
                                                    if ((b | 0) == -1) {
                                                        break i;
                                                    }
                                                    f = b - 1 | 0;
                                                    if ((b >>> 0) % 3 | 0) {
                                                        break i;
                                                    }
                                                    f = b + 2 | 0;
                                                }
                                                Xa(d, c, f);
                                            }
                                            f = -1;
                                            f = (b | 0) != -1 ? F[F[F[a + 4 >> 2] >> 2] + (b << 2) >> 2] : f;
                                            d = F[a + 36 >> 2] + (f >>> 3 & 536870908) | 0;
                                            e = F[d >> 2];
                                            c = 1 << f;
                                            if (!(e & c)) {
                                                F[d >> 2] = c | e;
                                                Xa(a + 8 | 0, f, b);
                                            }
                                            d = F[a + 84 >> 2];
                                            if ((d | 0) > 2) {
                                                break e;
                                            }
                                            while (1) {
                                                f = L(d, 12) + a | 0;
                                                b = F[f + 52 >> 2];
                                                if ((b | 0) == F[f + 48 >> 2]) {
                                                    d = d + 1 | 0;
                                                    if ((d | 0) != 3) {
                                                        continue;
                                                    }
                                                    break e;
                                                }
                                                c = b - 4 | 0;
                                                b = F[c >> 2];
                                                F[f + 52 >> 2] = c;
                                                F[a + 84 >> 2] = d;
                                                if ((b | 0) == -1) {
                                                    break e;
                                                }
                                                f = F[a + 24 >> 2];
                                                c = (b >>> 0) / 3 | 0;
                                                j: {
                                                    if (F[f + (c >>> 3 & 268435452) >> 2] >>> c & 1) {
                                                        break j;
                                                    }
                                                    k: {
                                                        while (1) {
                                                            k = (b >>> 0) / 3 | 0;
                                                            c = (k >>> 3 & 268435452) + f | 0;
                                                            F[c >> 2] = F[c >> 2] | 1 << k;
                                                            f = -1;
                                                            l: {
                                                                m: {
                                                                    n: {
                                                                        o: {
                                                                            p: {
                                                                                q: {
                                                                                    r: {
                                                                                        s: {
                                                                                            f = (b | 0) != -1 ? F[F[F[a + 4 >> 2] >> 2] + (b << 2) >> 2] : f;
                                                                                            d = F[a + 36 >> 2] + (f >>> 3 & 536870908) | 0;
                                                                                            e = F[d >> 2];
                                                                                            c = 1 << f;
                                                                                            if (!(e & c)) {
                                                                                                F[d >> 2] = c | e;
                                                                                                i = F[(F[F[a + 16 >> 2] + 96 >> 2] + L(k, 12) | 0) + ((b >>> 0) % 3 << 2) >> 2];
                                                                                                j = F[F[a + 20 >> 2] + 4 >> 2];
                                                                                                c = F[j + 4 >> 2];
                                                                                                t: {
                                                                                                    if ((c | 0) != F[j + 8 >> 2]) {
                                                                                                        F[c >> 2] = i;
                                                                                                        F[j + 4 >> 2] = c + 4;
                                                                                                        break t;
                                                                                                    }
                                                                                                    g = F[j >> 2];
                                                                                                    h = c - g | 0;
                                                                                                    e = h >> 2;
                                                                                                    d = e + 1 | 0;
                                                                                                    if (d >>> 0 >= 1073741824) {
                                                                                                        break s;
                                                                                                    }
                                                                                                    c = h >> 1;
                                                                                                    d = h >>> 0 < 2147483644 ? c >>> 0 < d >>> 0 ? d : c : 1073741823;
                                                                                                    if (d) {
                                                                                                        if (d >>> 0 >= 1073741824) {
                                                                                                            break a;
                                                                                                        }
                                                                                                        c = sa(d << 2);
                                                                                                    }
                                                                                                    else {
                                                                                                        c = 0;
                                                                                                    }
                                                                                                    e = c + (e << 2) | 0;
                                                                                                    F[e >> 2] = i;
                                                                                                    if ((h | 0) > 0) {
                                                                                                        ta(c, g, h);
                                                                                                    }
                                                                                                    F[j + 8 >> 2] = c + (d << 2);
                                                                                                    F[j + 4 >> 2] = e + 4;
                                                                                                    F[j >> 2] = c;
                                                                                                    if (!g) {
                                                                                                        break t;
                                                                                                    }
                                                                                                    ra(g);
                                                                                                }
                                                                                                h = F[a + 12 >> 2];
                                                                                                c = F[h + 4 >> 2];
                                                                                                u: {
                                                                                                    if ((c | 0) != F[h + 8 >> 2]) {
                                                                                                        F[c >> 2] = b;
                                                                                                        F[h + 4 >> 2] = c + 4;
                                                                                                        break u;
                                                                                                    }
                                                                                                    i = F[h >> 2];
                                                                                                    g = c - i | 0;
                                                                                                    e = g >> 2;
                                                                                                    d = e + 1 | 0;
                                                                                                    if (d >>> 0 >= 1073741824) {
                                                                                                        break r;
                                                                                                    }
                                                                                                    c = g >> 1;
                                                                                                    d = g >>> 0 < 2147483644 ? c >>> 0 < d >>> 0 ? d : c : 1073741823;
                                                                                                    if (d) {
                                                                                                        if (d >>> 0 >= 1073741824) {
                                                                                                            break a;
                                                                                                        }
                                                                                                        c = sa(d << 2);
                                                                                                    }
                                                                                                    else {
                                                                                                        c = 0;
                                                                                                    }
                                                                                                    e = c + (e << 2) | 0;
                                                                                                    F[e >> 2] = b;
                                                                                                    if ((g | 0) > 0) {
                                                                                                        ta(c, i, g);
                                                                                                    }
                                                                                                    F[h + 8 >> 2] = c + (d << 2);
                                                                                                    F[h + 4 >> 2] = e + 4;
                                                                                                    F[h >> 2] = c;
                                                                                                    if (!i) {
                                                                                                        break u;
                                                                                                    }
                                                                                                    ra(i);
                                                                                                }
                                                                                                c = F[a + 12 >> 2];
                                                                                                F[F[c + 12 >> 2] + (f << 2) >> 2] = F[c + 24 >> 2];
                                                                                                F[c + 24 >> 2] = F[c + 24 >> 2] + 1;
                                                                                            }
                                                                                            if ((b | 0) == -1) {
                                                                                                break k;
                                                                                            }
                                                                                            h = F[a + 4 >> 2];
                                                                                            f = -1;
                                                                                            c = b + 1 | 0;
                                                                                            c = (c >>> 0) % 3 | 0 ? c : b - 2 | 0;
                                                                                            if ((c | 0) != -1) {
                                                                                                f = F[F[h + 12 >> 2] + (c << 2) >> 2];
                                                                                            }
                                                                                            v: {
                                                                                                w: {
                                                                                                    if ((L(k, 3) | 0) != (b | 0)) {
                                                                                                        e = b - 1 | 0;
                                                                                                        break w;
                                                                                                    }
                                                                                                    e = b + 2 | 0;
                                                                                                    b = -1;
                                                                                                    if ((e | 0) == -1) {
                                                                                                        break v;
                                                                                                    }
                                                                                                }
                                                                                                b = F[F[h + 12 >> 2] + (e << 2) >> 2];
                                                                                            }
                                                                                            g = (b | 0) == -1;
                                                                                            i = (b >>> 0) / 3 | 0;
                                                                                            e = (f >>> 0) / 3 | 0;
                                                                                            c = (f | 0) == -1;
                                                                                            if (!c) {
                                                                                                c = c ? -1 : e;
                                                                                                c = F[F[a + 24 >> 2] + (c >>> 3 & 536870908) >> 2] & 1 << c;
                                                                                                if (g) {
                                                                                                    break q;
                                                                                                }
                                                                                                d = (c | 0) != 0;
                                                                                                break p;
                                                                                            }
                                                                                            d = 1;
                                                                                            if (!g) {
                                                                                                break p;
                                                                                            }
                                                                                            break k;
                                                                                        }
                                                                                        va();
                                                                                        V();
                                                                                    }
                                                                                    va();
                                                                                    V();
                                                                                }
                                                                                if (!c) {
                                                                                    break o;
                                                                                }
                                                                                break k;
                                                                            }
                                                                            c = g ? -1 : i;
                                                                            x: {
                                                                                if (F[F[a + 24 >> 2] + (c >>> 3 & 536870908) >> 2] >>> c & 1) {
                                                                                    break x;
                                                                                }
                                                                                e = 0;
                                                                                c = F[F[h >> 2] + (b << 2) >> 2];
                                                                                if (!(F[F[a + 36 >> 2] + (c >>> 3 & 536870908) >> 2] >>> c & 1)) {
                                                                                    c = F[a + 88 >> 2] + (c << 2) | 0;
                                                                                    e = F[c >> 2];
                                                                                    F[c >> 2] = e + 1;
                                                                                    e = (e | 0) <= 0 ? 2 : 1;
                                                                                }
                                                                                if (F[a + 84 >> 2] >= (e | 0) ? d : 0) {
                                                                                    break m;
                                                                                }
                                                                                j = L(e, 12) + a | 0;
                                                                                c = F[j + 52 >> 2];
                                                                                y: {
                                                                                    if ((c | 0) != F[j + 56 >> 2]) {
                                                                                        F[c >> 2] = b;
                                                                                        F[j + 52 >> 2] = c + 4;
                                                                                        break y;
                                                                                    }
                                                                                    h = F[j + 48 >> 2];
                                                                                    k = c - h | 0;
                                                                                    i = k >> 2;
                                                                                    g = i + 1 | 0;
                                                                                    if (g >>> 0 >= 1073741824) {
                                                                                        break d;
                                                                                    }
                                                                                    c = k >> 1;
                                                                                    g = k >>> 0 < 2147483644 ? c >>> 0 < g >>> 0 ? g : c : 1073741823;
                                                                                    if (g) {
                                                                                        if (g >>> 0 >= 1073741824) {
                                                                                            break a;
                                                                                        }
                                                                                        c = sa(g << 2);
                                                                                    }
                                                                                    else {
                                                                                        c = 0;
                                                                                    }
                                                                                    i = c + (i << 2) | 0;
                                                                                    F[i >> 2] = b;
                                                                                    if ((k | 0) > 0) {
                                                                                        ta(c, h, k);
                                                                                    }
                                                                                    F[j + 48 >> 2] = c;
                                                                                    F[j + 52 >> 2] = i + 4;
                                                                                    F[j + 56 >> 2] = c + (g << 2);
                                                                                    if (!h) {
                                                                                        break y;
                                                                                    }
                                                                                    ra(h);
                                                                                }
                                                                                if (F[a + 84 >> 2] <= (e | 0)) {
                                                                                    break x;
                                                                                }
                                                                                F[a + 84 >> 2] = e;
                                                                            }
                                                                            if (d) {
                                                                                break k;
                                                                            }
                                                                            b = -1;
                                                                            if ((f | 0) == -1) {
                                                                                break n;
                                                                            }
                                                                        }
                                                                        b = F[F[F[a + 4 >> 2] >> 2] + (f << 2) >> 2];
                                                                    }
                                                                    e = 0;
                                                                    if (!(F[F[a + 36 >> 2] + (b >>> 3 & 536870908) >> 2] >>> b & 1)) {
                                                                        b = F[a + 88 >> 2] + (b << 2) | 0;
                                                                        c = F[b >> 2];
                                                                        F[b >> 2] = c + 1;
                                                                        e = (c | 0) <= 0 ? 2 : 1;
                                                                    }
                                                                    if (F[a + 84 >> 2] < (e | 0)) {
                                                                        break l;
                                                                    }
                                                                    b = f;
                                                                }
                                                                f = F[a + 24 >> 2];
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        h = L(e, 12) + a | 0;
                                                        b = F[h + 52 >> 2];
                                                        z: {
                                                            if ((b | 0) != F[h + 56 >> 2]) {
                                                                F[b >> 2] = f;
                                                                F[h + 52 >> 2] = b + 4;
                                                                break z;
                                                            }
                                                            i = F[h + 48 >> 2];
                                                            g = b - i | 0;
                                                            c = g >> 2;
                                                            d = c + 1 | 0;
                                                            if (d >>> 0 >= 1073741824) {
                                                                break c;
                                                            }
                                                            b = g >> 1;
                                                            d = g >>> 0 < 2147483644 ? b >>> 0 < d >>> 0 ? d : b : 1073741823;
                                                            if (d) {
                                                                if (d >>> 0 >= 1073741824) {
                                                                    break a;
                                                                }
                                                                b = sa(d << 2);
                                                            }
                                                            else {
                                                                b = 0;
                                                            }
                                                            c = b + (c << 2) | 0;
                                                            F[c >> 2] = f;
                                                            if ((g | 0) > 0) {
                                                                ta(b, i, g);
                                                            }
                                                            F[h + 48 >> 2] = b;
                                                            F[h + 52 >> 2] = c + 4;
                                                            F[h + 56 >> 2] = b + (d << 2);
                                                            if (!i) {
                                                                break z;
                                                            }
                                                            ra(i);
                                                        }
                                                        d = F[a + 84 >> 2];
                                                        if ((e | 0) >= (d | 0)) {
                                                            break j;
                                                        }
                                                        F[a + 84 >> 2] = e;
                                                        d = e;
                                                        break j;
                                                    }
                                                    d = F[a + 84 >> 2];
                                                }
                                                if ((d | 0) < 3) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        return 1;
                                    }
                                    va();
                                    V();
                                }
                                va();
                                V();
                            }
                            va();
                            V();
                        } wa(1336); V(); }
                        function ad(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0; h = ea - 48 | 0; ea = h; c = F[F[a + 4 >> 2] + 44 >> 2]; d = F[a + 8 >> 2]; f = F[d >> 2]; d = F[d + 4 >> 2]; F[h + 40 >> 2] = 0; F[h + 32 >> 2] = 0; F[h + 36 >> 2] = 0; d = (d - f >> 2 >>> 0) / 3 | 0; j = F[c + 96 >> 2]; f = (F[c + 100 >> 2] - j | 0) / 12 | 0; a: {
                            if (d >>> 0 > f >>> 0) {
                                _c(c + 96 | 0, d - f | 0, h + 32 | 0);
                                break a;
                            }
                            if (d >>> 0 >= f >>> 0) {
                                break a;
                            }
                            F[c + 100 >> 2] = j + L(d, 12);
                        } b: {
                            if (F[a + 216 >> 2] == F[a + 220 >> 2]) {
                                k = F[a + 4 >> 2];
                                i = F[k + 44 >> 2];
                                d = F[i + 100 >> 2];
                                if ((d | 0) != F[i + 96 >> 2]) {
                                    c = 0;
                                    while (1) {
                                        g = F[a + 8 >> 2];
                                        e = L(c, 3);
                                        c: {
                                            d: {
                                                if ((e | 0) == -1) {
                                                    l = F[(F[g >> 2] + (e << 2) | 0) + 4 >> 2];
                                                    j = -1;
                                                    e = 1;
                                                    break d;
                                                }
                                                l = -1;
                                                j = F[F[g >> 2] + (e << 2) >> 2];
                                                f = e + 1 | 0;
                                                if ((f | 0) == -1) {
                                                    e = 0;
                                                    break d;
                                                }
                                                l = F[F[g >> 2] + (f << 2) >> 2];
                                                e = e + 2 | 0;
                                                f = -1;
                                                if ((e | 0) == -1) {
                                                    break c;
                                                }
                                            }
                                            f = F[F[g >> 2] + (e << 2) >> 2];
                                        }
                                        g = f;
                                        f = c + 1 | 0;
                                        e = d;
                                        d = F[i + 96 >> 2];
                                        e = (e - d | 0) / 12 | 0;
                                        if (e >>> 0 <= c >>> 0) {
                                            F[h + 40 >> 2] = 0;
                                            F[h + 32 >> 2] = 0;
                                            F[h + 36 >> 2] = 0;
                                            _c(i + 96 | 0, f - e | 0, h + 32 | 0);
                                            k = F[a + 4 >> 2];
                                            d = F[i + 96 >> 2];
                                        }
                                        c = L(c, 12) + d | 0;
                                        F[c + 8 >> 2] = g;
                                        F[c + 4 >> 2] = l;
                                        F[c >> 2] = j;
                                        c = f;
                                        i = F[k + 44 >> 2];
                                        d = F[i + 100 >> 2];
                                        if (c >>> 0 < (d - F[i + 96 >> 2] | 0) / 12 >>> 0) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                F[F[k + 4 >> 2] + 80 >> 2] = b;
                                c = 1;
                                break b;
                            }
                            F[h + 24 >> 2] = 0;
                            F[h + 16 >> 2] = 0;
                            F[h + 20 >> 2] = 0;
                            k = F[a + 8 >> 2];
                            b = F[k >> 2];
                            c = F[k + 4 >> 2];
                            F[h + 8 >> 2] = 0;
                            F[h >> 2] = 0;
                            F[h + 4 >> 2] = 0;
                            e: {
                                f: {
                                    g: {
                                        h: {
                                            i: {
                                                j: {
                                                    k: {
                                                        b = c - b | 0;
                                                        if (b) {
                                                            if ((b | 0) < 0) {
                                                                break k;
                                                            }
                                                            n = sa(b);
                                                            F[h >> 2] = n;
                                                            b = b >> 2 << 2;
                                                            c = b + n | 0;
                                                            F[h + 8 >> 2] = c;
                                                            ua(n, 0, b);
                                                            F[h + 4 >> 2] = c;
                                                        }
                                                        c = F[k + 24 >> 2];
                                                        if ((F[k + 28 >> 2] - c | 0) <= 0) {
                                                            d = 0;
                                                            b = 0;
                                                            break f;
                                                        }
                                                        d = 0;
                                                        f = 0;
                                                        b = 0;
                                                        while (1) {
                                                            j = F[(o << 2) + c >> 2];
                                                            l: {
                                                                if ((j | 0) == -1) {
                                                                    break l;
                                                                }
                                                                m: {
                                                                    if (F[F[a + 120 >> 2] + (o >>> 3 & 536870908) >> 2] >>> o & 1) {
                                                                        break m;
                                                                    }
                                                                    q = F[a + 216 >> 2];
                                                                    c = F[a + 220 >> 2] - q | 0;
                                                                    if (!c) {
                                                                        break m;
                                                                    }
                                                                    c = (c | 0) / 144 | 0;
                                                                    r = c >>> 0 > 1 ? c : 1;
                                                                    l = 0;
                                                                    c = (j >>> 0) % 3 | 0;
                                                                    g = j + 2 | 0;
                                                                    s = (c | 0) != 0 | (g | 0) != -1;
                                                                    t = c ? j - 1 | 0 : g;
                                                                    while (1) {
                                                                        i = j << 2;
                                                                        e = q + L(l, 144) | 0;
                                                                        c = F[i + F[F[e + 68 >> 2] >> 2] >> 2];
                                                                        n: {
                                                                            if (!(F[F[e + 16 >> 2] + (c >>> 3 & 536870908) >> 2] >>> c & 1)) {
                                                                                break n;
                                                                            }
                                                                            c = -1;
                                                                            o: {
                                                                                if (!s) {
                                                                                    break o;
                                                                                }
                                                                                g = F[F[k + 12 >> 2] + (t << 2) >> 2];
                                                                                c = -1;
                                                                                if ((g | 0) == -1) {
                                                                                    break o;
                                                                                }
                                                                                c = g - 1 | 0;
                                                                                if ((g >>> 0) % 3 | 0) {
                                                                                    break o;
                                                                                }
                                                                                c = g + 2 | 0;
                                                                            }
                                                                            if ((j | 0) == (c | 0)) {
                                                                                break n;
                                                                            }
                                                                            e = F[e + 32 >> 2];
                                                                            g = F[e + i >> 2];
                                                                            while (1) {
                                                                                m = 0;
                                                                                if ((c | 0) == -1) {
                                                                                    break e;
                                                                                }
                                                                                if (F[e + (c << 2) >> 2] != (g | 0)) {
                                                                                    j = c;
                                                                                    break m;
                                                                                }
                                                                                p: {
                                                                                    q: {
                                                                                        if ((c >>> 0) % 3 | 0) {
                                                                                            i = c - 1 | 0;
                                                                                            break q;
                                                                                        }
                                                                                        i = c + 2 | 0;
                                                                                        m = -1;
                                                                                        if ((i | 0) == -1) {
                                                                                            break p;
                                                                                        }
                                                                                    }
                                                                                    c = F[F[k + 12 >> 2] + (i << 2) >> 2];
                                                                                    m = -1;
                                                                                    if ((c | 0) == -1) {
                                                                                        break p;
                                                                                    }
                                                                                    m = c - 1 | 0;
                                                                                    if ((c >>> 0) % 3 | 0) {
                                                                                        break p;
                                                                                    }
                                                                                    m = c + 2 | 0;
                                                                                }
                                                                                c = m;
                                                                                if ((j | 0) != (c | 0)) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                        }
                                                                        l = l + 1 | 0;
                                                                        if ((r | 0) != (l | 0)) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                }
                                                                c = b - f | 0;
                                                                g = c >> 2;
                                                                F[(j << 2) + n >> 2] = g;
                                                                r: {
                                                                    if (b >>> 0 < p >>> 0) {
                                                                        F[b >> 2] = j;
                                                                        b = b + 4 | 0;
                                                                        F[h + 20 >> 2] = b;
                                                                        break r;
                                                                    }
                                                                    b = g + 1 | 0;
                                                                    if (b >>> 0 >= 1073741824) {
                                                                        break j;
                                                                    }
                                                                    d = p - f | 0;
                                                                    e = d >> 1;
                                                                    b = d >>> 0 < 2147483644 ? b >>> 0 > e >>> 0 ? b : e : 1073741823;
                                                                    if (b) {
                                                                        if (b >>> 0 >= 1073741824) {
                                                                            break i;
                                                                        }
                                                                        d = sa(b << 2);
                                                                    }
                                                                    else {
                                                                        d = 0;
                                                                    }
                                                                    g = d + (g << 2) | 0;
                                                                    F[g >> 2] = j;
                                                                    p = (b << 2) + d | 0;
                                                                    b = g + 4 | 0;
                                                                    if ((c | 0) > 0) {
                                                                        ta(d, f, c);
                                                                    }
                                                                    F[h + 24 >> 2] = p;
                                                                    F[h + 20 >> 2] = b;
                                                                    F[h + 16 >> 2] = d;
                                                                    if (f) {
                                                                        ra(f);
                                                                        k = F[a + 8 >> 2];
                                                                    }
                                                                    f = d;
                                                                }
                                                                if ((j | 0) == -1) {
                                                                    break l;
                                                                }
                                                                s: {
                                                                    if ((j >>> 0) % 3 | 0) {
                                                                        c = j - 1 | 0;
                                                                        break s;
                                                                    }
                                                                    c = j + 2 | 0;
                                                                    if ((c | 0) == -1) {
                                                                        break l;
                                                                    }
                                                                }
                                                                c = F[F[k + 12 >> 2] + (c << 2) >> 2];
                                                                if ((c | 0) == -1) {
                                                                    break l;
                                                                }
                                                                c = c + ((c >>> 0) % 3 | 0 ? -1 : 2) | 0;
                                                                if ((c | 0) == -1) {
                                                                    break l;
                                                                }
                                                                e = j;
                                                                if ((c | 0) == (e | 0)) {
                                                                    break l;
                                                                }
                                                                while (1) {
                                                                    g = c;
                                                                    t: {
                                                                        u: {
                                                                            i = F[a + 216 >> 2];
                                                                            c = F[a + 220 >> 2] - i | 0;
                                                                            if (!c) {
                                                                                break u;
                                                                            }
                                                                            c = (c | 0) / 144 | 0;
                                                                            l = c >>> 0 > 1 ? c : 1;
                                                                            c = 0;
                                                                            while (1) {
                                                                                q = F[(i + L(c, 144) | 0) + 32 >> 2];
                                                                                r = g << 2;
                                                                                if (F[q + r >> 2] == F[q + (e << 2) >> 2]) {
                                                                                    c = c + 1 | 0;
                                                                                    if ((l | 0) != (c | 0)) {
                                                                                        continue;
                                                                                    }
                                                                                    break u;
                                                                                }
                                                                                break;
                                                                            }
                                                                            c = b - d | 0;
                                                                            e = c >> 2;
                                                                            F[n + r >> 2] = e;
                                                                            if (b >>> 0 < p >>> 0) {
                                                                                F[b >> 2] = g;
                                                                                b = b + 4 | 0;
                                                                                F[h + 20 >> 2] = b;
                                                                                f = d;
                                                                                break t;
                                                                            }
                                                                            b = e + 1 | 0;
                                                                            if (b >>> 0 >= 1073741824) {
                                                                                break h;
                                                                            }
                                                                            f = p - d | 0;
                                                                            i = f >> 1;
                                                                            b = f >>> 0 < 2147483644 ? b >>> 0 > i >>> 0 ? b : i : 1073741823;
                                                                            if (b) {
                                                                                if (b >>> 0 >= 1073741824) {
                                                                                    break g;
                                                                                }
                                                                                f = sa(b << 2);
                                                                            }
                                                                            else {
                                                                                f = 0;
                                                                            }
                                                                            e = f + (e << 2) | 0;
                                                                            F[e >> 2] = g;
                                                                            p = (b << 2) + f | 0;
                                                                            b = e + 4 | 0;
                                                                            if ((c | 0) > 0) {
                                                                                ta(f, d, c);
                                                                            }
                                                                            F[h + 24 >> 2] = p;
                                                                            F[h + 20 >> 2] = b;
                                                                            F[h + 16 >> 2] = f;
                                                                            if (!d) {
                                                                                d = f;
                                                                                break t;
                                                                            }
                                                                            ra(d);
                                                                            k = F[a + 8 >> 2];
                                                                            d = f;
                                                                            break t;
                                                                        }
                                                                        F[(g << 2) + n >> 2] = F[(e << 2) + n >> 2];
                                                                    }
                                                                    if ((g | 0) == -1) {
                                                                        break l;
                                                                    }
                                                                    v: {
                                                                        if ((g >>> 0) % 3 | 0) {
                                                                            c = g - 1 | 0;
                                                                            break v;
                                                                        }
                                                                        c = g + 2 | 0;
                                                                        if ((c | 0) == -1) {
                                                                            break l;
                                                                        }
                                                                    }
                                                                    c = F[F[k + 12 >> 2] + (c << 2) >> 2];
                                                                    if ((c | 0) == -1) {
                                                                        break l;
                                                                    }
                                                                    c = c + ((c >>> 0) % 3 | 0 ? -1 : 2) | 0;
                                                                    if ((c | 0) == -1) {
                                                                        break l;
                                                                    }
                                                                    e = g;
                                                                    if ((c | 0) != (j | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            o = o + 1 | 0;
                                                            c = F[k + 24 >> 2];
                                                            if ((o | 0) < F[k + 28 >> 2] - c >> 2) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        break f;
                                                    }
                                                    va();
                                                    V();
                                                }
                                                va();
                                                V();
                                            }
                                            wa(1336);
                                            V();
                                        }
                                        va();
                                        V();
                                    }
                                    wa(1336);
                                    V();
                                }
                                o = F[a + 4 >> 2];
                                i = F[o + 44 >> 2];
                                l = F[i + 100 >> 2];
                                if ((l | 0) != F[i + 96 >> 2]) {
                                    c = 0;
                                    while (1) {
                                        f = c + 1 | 0;
                                        g = L(c, 12);
                                        j = g + n | 0;
                                        e = F[j + 8 >> 2];
                                        k = F[j + 4 >> 2];
                                        j = F[j >> 2];
                                        m = c;
                                        c = F[i + 96 >> 2];
                                        l = (l - c | 0) / 12 | 0;
                                        if (m >>> 0 >= l >>> 0) {
                                            F[h + 40 >> 2] = 0;
                                            F[h + 32 >> 2] = 0;
                                            F[h + 36 >> 2] = 0;
                                            _c(i + 96 | 0, f - l | 0, h + 32 | 0);
                                            o = F[a + 4 >> 2];
                                            c = F[i + 96 >> 2];
                                        }
                                        c = c + g | 0;
                                        F[c + 8 >> 2] = e;
                                        F[c + 4 >> 2] = k;
                                        F[c >> 2] = j;
                                        c = f;
                                        i = F[o + 44 >> 2];
                                        l = F[i + 100 >> 2];
                                        if (c >>> 0 < (l - F[i + 96 >> 2] | 0) / 12 >>> 0) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                F[F[o + 4 >> 2] + 80 >> 2] = b - d >> 2;
                                m = 1;
                            }
                            c = m;
                            if (n) {
                                ra(n);
                            }
                            if (!d) {
                                break b;
                            }
                            F[h + 20 >> 2] = d;
                            ra(d);
                        } ea = h + 48 | 0; return c; }
                        function Ta(a, b, c, d) { var e = 0, f = 0, g = 0, h = 0, i = M(0), j = 0, k = 0; a: {
                            if (!d) {
                                break a;
                            }
                            b: {
                                c: {
                                    switch (F[a + 28 >> 2] - 1 | 0) {
                                        case 0:
                                            e = D[a + 24 | 0];
                                            if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                e = F[a >> 2];
                                                g = F[e >> 2];
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                b = g + b | 0;
                                                h = F[e + 4 >> 2];
                                                while (1) {
                                                    if (b >>> 0 >= h >>> 0) {
                                                        break a;
                                                    }
                                                    e = (f << 3) + d | 0;
                                                    g = D[b | 0];
                                                    F[e >> 2] = g;
                                                    F[e + 4 >> 2] = g >> 31;
                                                    b = b + 1 | 0;
                                                    f = f + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((f | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 1:
                                            e = D[a + 24 | 0];
                                            if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                e = F[a >> 2];
                                                g = F[e >> 2];
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                b = g + b | 0;
                                                h = F[e + 4 >> 2];
                                                while (1) {
                                                    if (b >>> 0 >= h >>> 0) {
                                                        break a;
                                                    }
                                                    e = (f << 3) + d | 0;
                                                    F[e >> 2] = G[b | 0];
                                                    F[e + 4 >> 2] = 0;
                                                    b = b + 1 | 0;
                                                    f = f + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((f | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 2:
                                            e = D[a + 24 | 0];
                                            if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                e = F[a >> 2];
                                                g = F[e >> 2];
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                b = g + b | 0;
                                                h = F[e + 4 >> 2];
                                                while (1) {
                                                    if (b >>> 0 >= h >>> 0) {
                                                        break a;
                                                    }
                                                    e = (f << 3) + d | 0;
                                                    g = E[b >> 1];
                                                    F[e >> 2] = g;
                                                    F[e + 4 >> 2] = g >> 31;
                                                    b = b + 2 | 0;
                                                    f = f + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((f | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 3:
                                            e = D[a + 24 | 0];
                                            if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                e = F[a >> 2];
                                                g = F[e >> 2];
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                b = g + b | 0;
                                                h = F[e + 4 >> 2];
                                                while (1) {
                                                    if (b >>> 0 >= h >>> 0) {
                                                        break a;
                                                    }
                                                    e = (f << 3) + d | 0;
                                                    F[e >> 2] = H[b >> 1];
                                                    F[e + 4 >> 2] = 0;
                                                    b = b + 2 | 0;
                                                    f = f + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((f | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 4:
                                            e = D[a + 24 | 0];
                                            if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                e = F[a >> 2];
                                                g = F[e >> 2];
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                b = g + b | 0;
                                                h = F[e + 4 >> 2];
                                                while (1) {
                                                    if (b >>> 0 >= h >>> 0) {
                                                        break a;
                                                    }
                                                    e = (f << 3) + d | 0;
                                                    g = F[b >> 2];
                                                    F[e >> 2] = g;
                                                    F[e + 4 >> 2] = g >> 31;
                                                    b = b + 4 | 0;
                                                    f = f + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((f | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 5:
                                            e = D[a + 24 | 0];
                                            if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                e = F[a >> 2];
                                                g = F[e >> 2];
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                b = g + b | 0;
                                                h = F[e + 4 >> 2];
                                                while (1) {
                                                    if (b >>> 0 >= h >>> 0) {
                                                        break a;
                                                    }
                                                    e = (f << 3) + d | 0;
                                                    F[e >> 2] = F[b >> 2];
                                                    F[e + 4 >> 2] = 0;
                                                    b = b + 4 | 0;
                                                    f = f + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((f | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 6:
                                            e = D[a + 24 | 0];
                                            if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                e = F[a >> 2];
                                                g = F[e >> 2];
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                b = g + b | 0;
                                                h = F[e + 4 >> 2];
                                                while (1) {
                                                    if (b >>> 0 >= h >>> 0) {
                                                        break a;
                                                    }
                                                    g = F[b + 4 >> 2];
                                                    e = (f << 3) + d | 0;
                                                    F[e >> 2] = F[b >> 2];
                                                    F[e + 4 >> 2] = g;
                                                    b = b + 8 | 0;
                                                    f = f + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((f | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 7:
                                            e = D[a + 24 | 0];
                                            if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                e = F[a >> 2];
                                                g = F[e >> 2];
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                b = g + b | 0;
                                                h = F[e + 4 >> 2];
                                                while (1) {
                                                    if (b >>> 0 >= h >>> 0) {
                                                        break a;
                                                    }
                                                    e = F[b >> 2];
                                                    g = F[b + 4 >> 2];
                                                    if ((g | 0) < 0) {
                                                        break a;
                                                    }
                                                    k = (f << 3) + d | 0;
                                                    F[k >> 2] = e;
                                                    F[k + 4 >> 2] = g;
                                                    b = b + 8 | 0;
                                                    f = f + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((f | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 8:
                                            e = D[a + 24 | 0];
                                            if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                e = F[a >> 2];
                                                g = F[e >> 2];
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                b = g + b | 0;
                                                k = F[e + 4 >> 2];
                                                while (1) {
                                                    if (b >>> 0 >= k >>> 0) {
                                                        break a;
                                                    }
                                                    e = (f << 3) + d | 0;
                                                    i = J[b >> 2];
                                                    d: {
                                                        if (M(N(i)) < M(0x8000000000000000)) {
                                                            g = M(N(i)) >= M(1) ? ~~(i > M(0) ? M(P(M(R(M(i * M(2.3283064365386963e-10)))), M(4294967296))) : M(S(M(M(i - M(~~i >>> 0 >>> 0)) * M(2.3283064365386963e-10))))) >>> 0 : 0;
                                                            h = ~~i >>> 0;
                                                            break d;
                                                        }
                                                        g = -2147483648;
                                                        h = 0;
                                                    }
                                                    F[e >> 2] = h;
                                                    F[e + 4 >> 2] = g;
                                                    b = b + 4 | 0;
                                                    f = f + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((f | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 9:
                                            e = D[a + 24 | 0];
                                            if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                e = F[a >> 2];
                                                g = F[e >> 2];
                                                b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                b = g + b | 0;
                                                k = F[e + 4 >> 2];
                                                while (1) {
                                                    if (b >>> 0 >= k >>> 0) {
                                                        break a;
                                                    }
                                                    e = (f << 3) + d | 0;
                                                    j = K[b >> 3];
                                                    e: {
                                                        if (N(j) < 0x8000000000000000) {
                                                            g = N(j) >= 1 ? ~~(j > 0 ? P(R(j * 2.3283064365386963e-10), 4294967295) : S((j - +(~~j >>> 0 >>> 0)) * 2.3283064365386963e-10)) >>> 0 : 0;
                                                            h = ~~j >>> 0;
                                                            break e;
                                                        }
                                                        g = -2147483648;
                                                        h = 0;
                                                    }
                                                    F[e >> 2] = h;
                                                    F[e + 4 >> 2] = g;
                                                    b = b + 8 | 0;
                                                    f = f + 1 | 0;
                                                    e = D[a + 24 | 0];
                                                    if ((f | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            if ((c | 0) > (e | 0)) {
                                                break b;
                                            }
                                            break a;
                                        case 10: break c;
                                        default: break a;
                                    }
                                }
                                e = D[a + 24 | 0];
                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                    e = F[a >> 2];
                                    g = F[e >> 2];
                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                    b = g + b | 0;
                                    h = F[e + 4 >> 2];
                                    while (1) {
                                        if (b >>> 0 >= h >>> 0) {
                                            break a;
                                        }
                                        e = (f << 3) + d | 0;
                                        F[e >> 2] = G[b | 0];
                                        F[e + 4 >> 2] = 0;
                                        b = b + 1 | 0;
                                        f = f + 1 | 0;
                                        e = D[a + 24 | 0];
                                        if ((f | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                if ((c | 0) <= (e | 0)) {
                                    break a;
                                }
                            }
                            ua((e << 3) + d | 0, 0, c - e << 3);
                        } }
                        function Mb(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0; f = ea - 96 | 0; ea = f; e = F[a + 16 >> 2]; D[f + 92 | 0] = 1; F[f + 88 >> 2] = b; F[f + 84 >> 2] = b; F[f + 80 >> 2] = e; m = F[a + 20 >> 2]; d = F[m >> 2]; a: {
                            b: {
                                e = F[F[e + 28 >> 2] + (b << 2) >> 2];
                                if (e >>> 0 < F[m + 4 >> 2] - d >> 2 >>> 0) {
                                    d = F[F[a + 8 >> 2] + (F[d + (e << 2) >> 2] << 2) >> 2];
                                    e = F[a + 4 >> 2];
                                    if (!G[e + 84 | 0]) {
                                        d = F[F[e + 68 >> 2] + (d << 2) >> 2];
                                    }
                                    F[f + 72 >> 2] = 0;
                                    F[f + 76 >> 2] = 0;
                                    m = f - -64 | 0;
                                    F[m >> 2] = 0;
                                    F[m + 4 >> 2] = 0;
                                    F[f + 56 >> 2] = 0;
                                    F[f + 60 >> 2] = 0;
                                    Ta(e, d, D[e + 24 | 0], f + 56 | 0);
                                    e = b + 1 | 0;
                                    d = (e >>> 0) % 3 | 0;
                                    if (b >>> 0 <= e >>> 0) {
                                        m = d ? e : b - 2 | 0;
                                        h = ((b >>> 0) % 3 | 0 ? -1 : 2) + b | 0;
                                        while (1) {
                                            d = m;
                                            e = h;
                                            c: {
                                                if (!F[a + 28 >> 2]) {
                                                    break c;
                                                }
                                                e = b + 1 | 0;
                                                d = (e >>> 0) % 3 | 0 ? e : b - 2 | 0;
                                                e = b - 1 | 0;
                                                if ((b >>> 0) % 3 | 0) {
                                                    break c;
                                                }
                                                e = b + 2 | 0;
                                            }
                                            k = F[a + 20 >> 2];
                                            b = F[k >> 2];
                                            d = F[F[F[a + 16 >> 2] + 28 >> 2] + (d << 2) >> 2];
                                            if (d >>> 0 >= F[k + 4 >> 2] - b >> 2 >>> 0) {
                                                break b;
                                            }
                                            d = F[F[a + 8 >> 2] + (F[b + (d << 2) >> 2] << 2) >> 2];
                                            b = F[a + 4 >> 2];
                                            if (!G[b + 84 | 0]) {
                                                d = F[F[b + 68 >> 2] + (d << 2) >> 2];
                                            }
                                            F[f + 48 >> 2] = 0;
                                            F[f + 52 >> 2] = 0;
                                            F[f + 40 >> 2] = 0;
                                            F[f + 44 >> 2] = 0;
                                            F[f + 32 >> 2] = 0;
                                            F[f + 36 >> 2] = 0;
                                            Ta(b, d, D[b + 24 | 0], f + 32 | 0);
                                            d = F[a + 20 >> 2];
                                            b = F[d >> 2];
                                            e = F[F[F[a + 16 >> 2] + 28 >> 2] + (e << 2) >> 2];
                                            if (e >>> 0 >= F[d + 4 >> 2] - b >> 2 >>> 0) {
                                                break a;
                                            }
                                            d = F[F[a + 8 >> 2] + (F[b + (e << 2) >> 2] << 2) >> 2];
                                            b = F[a + 4 >> 2];
                                            if (!G[b + 84 | 0]) {
                                                d = F[F[b + 68 >> 2] + (d << 2) >> 2];
                                            }
                                            F[f + 24 >> 2] = 0;
                                            F[f + 28 >> 2] = 0;
                                            F[f + 16 >> 2] = 0;
                                            F[f + 20 >> 2] = 0;
                                            F[f + 8 >> 2] = 0;
                                            F[f + 12 >> 2] = 0;
                                            Ta(b, d, D[b + 24 | 0], f + 8 | 0);
                                            e = F[f + 8 >> 2];
                                            b = F[f + 56 >> 2];
                                            d = e - b | 0;
                                            k = F[f + 60 >> 2];
                                            n = F[f + 12 >> 2] - (k + (b >>> 0 > e >>> 0) | 0) | 0;
                                            i = F[f + 40 >> 2];
                                            e = F[f + 64 >> 2];
                                            s = i - e | 0;
                                            t = F[f + 68 >> 2];
                                            i = F[f + 44 >> 2] - (t + (e >>> 0 > i >>> 0) | 0) | 0;
                                            u = Hj(d, n, s, i);
                                            v = j - u | 0;
                                            g = g - (fa + (j >>> 0 < u >>> 0) | 0) | 0;
                                            w = v;
                                            j = F[f + 16 >> 2];
                                            u = j - e | 0;
                                            t = F[f + 20 >> 2] - ((e >>> 0 > j >>> 0) + t | 0) | 0;
                                            j = F[f + 32 >> 2];
                                            v = j - b | 0;
                                            k = F[f + 36 >> 2] - ((b >>> 0 > j >>> 0) + k | 0) | 0;
                                            e = Hj(u, t, v, k);
                                            j = w + e | 0;
                                            b = fa + g | 0;
                                            b = e >>> 0 > j >>> 0 ? b + 1 | 0 : b;
                                            g = b;
                                            w = o;
                                            p = n;
                                            b = F[f + 48 >> 2];
                                            e = F[f + 72 >> 2];
                                            n = b - e | 0;
                                            o = F[f + 76 >> 2];
                                            x = F[f + 52 >> 2] - (o + (b >>> 0 < e >>> 0) | 0) | 0;
                                            p = Hj(d, p, n, x);
                                            d = w + p | 0;
                                            b = fa + l | 0;
                                            b = d >>> 0 < p >>> 0 ? b + 1 | 0 : b;
                                            l = F[f + 24 >> 2];
                                            p = l - e | 0;
                                            e = F[f + 28 >> 2] - ((e >>> 0 > l >>> 0) + o | 0) | 0;
                                            l = Hj(p, e, v, k);
                                            o = d - l | 0;
                                            l = b - (fa + (d >>> 0 < l >>> 0) | 0) | 0;
                                            b = Hj(u, t, n, x);
                                            d = q - b | 0;
                                            b = r - (fa + (b >>> 0 > q >>> 0) | 0) | 0;
                                            r = Hj(p, e, s, i);
                                            q = r + d | 0;
                                            b = fa + b | 0;
                                            b = q >>> 0 < r >>> 0 ? b + 1 | 0 : b;
                                            r = b;
                                            b = F[f + 88 >> 2];
                                            e = F[f + 80 >> 2];
                                            d: {
                                                if (G[f + 92 | 0]) {
                                                    e: {
                                                        f: {
                                                            g: {
                                                                h: {
                                                                    if ((b | 0) == -1) {
                                                                        break h;
                                                                    }
                                                                    d = b + 1 | 0;
                                                                    b = (d >>> 0) % 3 | 0 ? d : b - 2 | 0;
                                                                    if ((b | 0) == -1 | F[F[e >> 2] + (b >>> 3 & 536870908) >> 2] >>> b & 1) {
                                                                        break h;
                                                                    }
                                                                    b = F[F[F[e + 64 >> 2] + 12 >> 2] + (b << 2) >> 2];
                                                                    if ((b | 0) != -1) {
                                                                        break g;
                                                                    }
                                                                }
                                                                F[f + 88 >> 2] = -1;
                                                                break f;
                                                            }
                                                            d = b + 1 | 0;
                                                            b = (d >>> 0) % 3 | 0 ? d : b - 2 | 0;
                                                            F[f + 88 >> 2] = b;
                                                            if ((b | 0) != -1) {
                                                                break e;
                                                            }
                                                        }
                                                        b = F[f + 84 >> 2];
                                                        d = -1;
                                                        i: {
                                                            if ((b | 0) == -1) {
                                                                break i;
                                                            }
                                                            j: {
                                                                if ((b >>> 0) % 3 | 0) {
                                                                    b = b - 1 | 0;
                                                                    break j;
                                                                }
                                                                b = b + 2 | 0;
                                                                d = -1;
                                                                if ((b | 0) == -1) {
                                                                    break i;
                                                                }
                                                            }
                                                            d = -1;
                                                            if (F[F[e >> 2] + (b >>> 3 & 536870908) >> 2] >>> b & 1) {
                                                                break i;
                                                            }
                                                            b = F[F[F[e + 64 >> 2] + 12 >> 2] + (b << 2) >> 2];
                                                            d = -1;
                                                            if ((b | 0) == -1) {
                                                                break i;
                                                            }
                                                            d = b - 1 | 0;
                                                            if ((b >>> 0) % 3 | 0) {
                                                                break i;
                                                            }
                                                            d = b + 2 | 0;
                                                        }
                                                        D[f + 92 | 0] = 0;
                                                        F[f + 88 >> 2] = d;
                                                        break d;
                                                    }
                                                    if ((b | 0) != F[f + 84 >> 2]) {
                                                        break d;
                                                    }
                                                    F[f + 88 >> 2] = -1;
                                                    break d;
                                                }
                                                d = -1;
                                                k: {
                                                    if ((b | 0) == -1) {
                                                        break k;
                                                    }
                                                    l: {
                                                        if ((b >>> 0) % 3 | 0) {
                                                            b = b - 1 | 0;
                                                            break l;
                                                        }
                                                        b = b + 2 | 0;
                                                        d = -1;
                                                        if ((b | 0) == -1) {
                                                            break k;
                                                        }
                                                    }
                                                    d = -1;
                                                    if (F[F[e >> 2] + (b >>> 3 & 536870908) >> 2] >>> b & 1) {
                                                        break k;
                                                    }
                                                    b = F[F[F[e + 64 >> 2] + 12 >> 2] + (b << 2) >> 2];
                                                    d = -1;
                                                    if ((b | 0) == -1) {
                                                        break k;
                                                    }
                                                    d = b - 1 | 0;
                                                    if ((b >>> 0) % 3 | 0) {
                                                        break k;
                                                    }
                                                    d = b + 2 | 0;
                                                }
                                                F[f + 88 >> 2] = d;
                                            }
                                            b = F[f + 88 >> 2];
                                            if ((b | 0) != -1) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    b = r >> 31;
                                    d = b + q | 0;
                                    e = b;
                                    b = b + r | 0;
                                    k = d ^ e;
                                    h = e ^ (d >>> 0 < e >>> 0 ? b + 1 | 0 : b);
                                    n = -1;
                                    d = 2147483647;
                                    b = l >> 31;
                                    i = b;
                                    e = b + o | 0;
                                    b = b + l | 0;
                                    b = e >>> 0 < i >>> 0 ? b + 1 | 0 : b;
                                    e = e ^ i;
                                    b = b ^ i;
                                    i = b;
                                    s = e ^ -1;
                                    b = b ^ 2147483647;
                                    m = g;
                                    m: {
                                        n: {
                                            if (!F[a + 28 >> 2]) {
                                                if ((b | 0) == (h | 0) & k >>> 0 > s >>> 0 | b >>> 0 < h >>> 0) {
                                                    break m;
                                                }
                                                b = h + i | 0;
                                                a = e + k | 0;
                                                b = a >>> 0 < e >>> 0 ? b + 1 | 0 : b;
                                                e = a;
                                                a = b;
                                                b = g >> 31;
                                                d = b + j | 0;
                                                h = g;
                                                g = b;
                                                b = h + b | 0;
                                                b = d >>> 0 < g >>> 0 ? b + 1 | 0 : b;
                                                h = d ^ g;
                                                d = h + e | 0;
                                                g = b ^ g;
                                                b = d;
                                                g = g ^ 2147483647;
                                                a = (g | 0) == (a | 0) & (h ^ -1) >>> 0 < e >>> 0 | a >>> 0 > g >>> 0;
                                                g = !(a & 0);
                                                a = a ? -1 : b;
                                                if (g & (a | 0) <= 536870912 | (a | 0) < 536870912) {
                                                    break m;
                                                }
                                                b = 0;
                                                a = a >>> 29 | 0;
                                                break n;
                                            }
                                            o: {
                                                if ((b | 0) == (h | 0) & k >>> 0 > s >>> 0 | b >>> 0 < h >>> 0) {
                                                    break o;
                                                }
                                                b = h + i | 0;
                                                a = e + k | 0;
                                                b = a >>> 0 < e >>> 0 ? b + 1 | 0 : b;
                                                e = b;
                                                h = g;
                                                b = g >> 31;
                                                g = b + j | 0;
                                                i = h;
                                                h = b;
                                                b = i + b | 0;
                                                b = g >>> 0 < h >>> 0 ? b + 1 | 0 : b;
                                                g = g ^ h;
                                                b = b ^ h;
                                                h = b ^ 2147483647;
                                                if ((h | 0) == (e | 0) & (g ^ -1) >>> 0 < a >>> 0 | e >>> 0 > h >>> 0) {
                                                    break o;
                                                }
                                                b = b + e | 0;
                                                a = a + g | 0;
                                                b = a >>> 0 < g >>> 0 ? b + 1 | 0 : b;
                                                n = a;
                                                d = b;
                                                if (!b & a >>> 0 < 536870913) {
                                                    break m;
                                                }
                                            }
                                            b = d >>> 29 | 0;
                                            a = (d & 536870911) << 3 | n >>> 29;
                                        }
                                        j = Ij(j, m, a, b);
                                        o = Ij(o, l, a, b);
                                        q = Ij(q, r, a, b);
                                    }
                                    F[c + 8 >> 2] = j;
                                    F[c + 4 >> 2] = o;
                                    F[c >> 2] = q;
                                    ea = f + 96 | 0;
                                    return;
                                }
                                Da();
                                V();
                            }
                            Da();
                            V();
                        } Da(); V(); }
                        function He(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0; f = ea + -64 | 0; ea = f; F[f + 56 >> 2] = 0; F[f + 48 >> 2] = 0; F[f + 52 >> 2] = 0; F[f + 40 >> 2] = 0; F[f + 44 >> 2] = 0; F[f + 32 >> 2] = 0; F[f + 36 >> 2] = 0; F[f + 24 >> 2] = 0; F[f + 28 >> 2] = 0; F[f + 16 >> 2] = 0; F[f + 20 >> 2] = 0; F[f + 8 >> 2] = 0; F[f + 12 >> 2] = 0; g = f + 8 | 0; d = H[b + 38 >> 1]; a: {
                            b: {
                                if (!d) {
                                    break b;
                                }
                                c: {
                                    if (d >>> 0 <= 511) {
                                        e = F[b + 12 >> 2];
                                        d = F[b + 20 >> 2];
                                        h = F[b + 16 >> 2];
                                        i = h + 4 | 0;
                                        d = i >>> 0 < 4 ? d + 1 | 0 : d;
                                        if (i >>> 0 > I[b + 8 >> 2] & (d | 0) >= (e | 0) | (d | 0) > (e | 0)) {
                                            break b;
                                        }
                                        d = h + F[b >> 2] | 0;
                                        k = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                        F[g + 12 >> 2] = k;
                                        d = F[b + 20 >> 2];
                                        e = F[b + 16 >> 2] + 4 | 0;
                                        d = e >>> 0 < 4 ? d + 1 | 0 : d;
                                        F[b + 16 >> 2] = e;
                                        F[b + 20 >> 2] = d;
                                        break c;
                                    }
                                    if (!jb(1, g + 12 | 0, b)) {
                                        break b;
                                    }
                                    k = F[g + 12 >> 2];
                                }
                                e = F[g >> 2];
                                d = F[g + 4 >> 2] - e >> 2;
                                d: {
                                    if (d >>> 0 < k >>> 0) {
                                        Aa(g, k - d | 0);
                                        k = F[g + 12 >> 2];
                                        break d;
                                    }
                                    if (d >>> 0 <= k >>> 0) {
                                        break d;
                                    }
                                    F[g + 4 >> 2] = e + (k << 2);
                                }
                                d = 1;
                                if (!k) {
                                    break a;
                                }
                                q = F[b + 8 >> 2];
                                m = F[b + 12 >> 2];
                                p = F[g >> 2];
                                h = 0;
                                while (1) {
                                    e = F[b + 20 >> 2];
                                    i = F[b + 16 >> 2];
                                    d = 0;
                                    if ((m | 0) <= (e | 0) & q >>> 0 <= i >>> 0 | (e | 0) > (m | 0)) {
                                        break a;
                                    }
                                    s = F[b >> 2];
                                    n = G[s + i | 0];
                                    d = e;
                                    e = i + 1 | 0;
                                    d = e ? d : d + 1 | 0;
                                    i = e;
                                    F[b + 16 >> 2] = e;
                                    F[b + 20 >> 2] = d;
                                    e = n >>> 2 | 0;
                                    j = 0;
                                    e: {
                                        f: {
                                            g: {
                                                h: {
                                                    t = n & 3;
                                                    switch (t | 0) {
                                                        case 0: break f;
                                                        case 3: break h;
                                                        default: break g;
                                                    }
                                                }
                                                e = e + h | 0;
                                                d = 0;
                                                if (e >>> 0 >= k >>> 0) {
                                                    break a;
                                                }
                                                ua(p + (h << 2) | 0, 0, (n & 252) + 4 | 0);
                                                h = e;
                                                break e;
                                            }
                                            while (1) {
                                                if ((d | 0) >= (m | 0) & i >>> 0 >= q >>> 0 | (d | 0) > (m | 0)) {
                                                    break b;
                                                }
                                                k = G[i + s | 0];
                                                i = i + 1 | 0;
                                                d = i ? d : d + 1 | 0;
                                                F[b + 16 >> 2] = i;
                                                F[b + 20 >> 2] = d;
                                                e = k << (j << 3 | 6) | e;
                                                j = j + 1 | 0;
                                                if ((t | 0) != (j | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        F[p + (h << 2) >> 2] = e;
                                    }
                                    k = F[g + 12 >> 2];
                                    h = h + 1 | 0;
                                    if (k >>> 0 > h >>> 0) {
                                        continue;
                                    }
                                    break;
                                }
                                i = g + 16 | 0;
                                q = F[g >> 2];
                                e = F[g + 16 >> 2];
                                d = F[g + 20 >> 2] - e | 0;
                                i: {
                                    if (d >>> 0 <= 4194303) {
                                        Aa(i, 1048576 - (d >>> 2 | 0) | 0);
                                        break i;
                                    }
                                    if ((d | 0) == 4194304) {
                                        break i;
                                    }
                                    F[g + 20 >> 2] = e + 4194304;
                                }
                                d = g + 28 | 0;
                                h = F[d >> 2];
                                e = F[g + 32 >> 2] - h >> 3;
                                j: {
                                    if (e >>> 0 < k >>> 0) {
                                        tb(d, k - e | 0);
                                        h = F[d >> 2];
                                        break j;
                                    }
                                    if (e >>> 0 > k >>> 0) {
                                        F[g + 32 >> 2] = (k << 3) + h;
                                    }
                                    if (!k) {
                                        break b;
                                    }
                                }
                                j = 0;
                                g = 0;
                                while (1) {
                                    d = (j << 2) + q | 0;
                                    m = F[d >> 2];
                                    n = (j << 3) + h | 0;
                                    e = g;
                                    F[n + 4 >> 2] = e;
                                    F[n >> 2] = m;
                                    d = F[d >> 2];
                                    g = d + e | 0;
                                    if (g >>> 0 > 1048576) {
                                        break b;
                                    }
                                    k: {
                                        if (e >>> 0 >= g >>> 0) {
                                            break k;
                                        }
                                        m = F[i >> 2];
                                        n = 0;
                                        p = d & 7;
                                        if (p) {
                                            while (1) {
                                                F[m + (e << 2) >> 2] = j;
                                                e = e + 1 | 0;
                                                n = n + 1 | 0;
                                                if ((p | 0) != (n | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        if (d - 1 >>> 0 <= 6) {
                                            break k;
                                        }
                                        while (1) {
                                            d = m + (e << 2) | 0;
                                            F[d >> 2] = j;
                                            F[d + 28 >> 2] = j;
                                            F[d + 24 >> 2] = j;
                                            F[d + 20 >> 2] = j;
                                            F[d + 16 >> 2] = j;
                                            F[d + 12 >> 2] = j;
                                            F[d + 8 >> 2] = j;
                                            F[d + 4 >> 2] = j;
                                            e = e + 8 | 0;
                                            if ((g | 0) != (e | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    j = j + 1 | 0;
                                    if ((k | 0) != (j | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                l = (g | 0) == 1048576;
                            }
                            d = l;
                        } l: {
                            if (!d | (F[f + 20 >> 2] ? 0 : a)) {
                                break l;
                            }
                            g = 0;
                            j = ea - 16 | 0;
                            ea = j;
                            m: {
                                n: {
                                    if (H[b + 38 >> 1] <= 511) {
                                        e = F[b + 12 >> 2];
                                        k = e;
                                        d = F[b + 20 >> 2];
                                        l = F[b + 16 >> 2];
                                        i = l + 8 | 0;
                                        d = i >>> 0 < 8 ? d + 1 | 0 : d;
                                        h = F[b + 8 >> 2];
                                        if (h >>> 0 < i >>> 0 & (d | 0) >= (e | 0) | (d | 0) > (e | 0)) {
                                            break m;
                                        }
                                        l = l + F[b >> 2] | 0;
                                        e = G[l | 0] | G[l + 1 | 0] << 8 | (G[l + 2 | 0] << 16 | G[l + 3 | 0] << 24);
                                        l = G[l + 4 | 0] | G[l + 5 | 0] << 8 | (G[l + 6 | 0] << 16 | G[l + 7 | 0] << 24);
                                        F[b + 16 >> 2] = i;
                                        F[b + 20 >> 2] = d;
                                        break n;
                                    }
                                    if (!ib(1, j + 8 | 0, b)) {
                                        break m;
                                    }
                                    i = F[b + 16 >> 2];
                                    d = F[b + 20 >> 2];
                                    h = F[b + 8 >> 2];
                                    k = F[b + 12 >> 2];
                                    e = F[j + 8 >> 2];
                                    l = F[j + 12 >> 2];
                                }
                                m = h - i | 0;
                                h = k - (d + (i >>> 0 > h >>> 0) | 0) | 0;
                                if ((h | 0) == (l | 0) & e >>> 0 > m >>> 0 | h >>> 0 < l >>> 0) {
                                    break m;
                                }
                                d = d + l | 0;
                                h = e + i | 0;
                                d = h >>> 0 < e >>> 0 ? d + 1 | 0 : d;
                                F[b + 16 >> 2] = h;
                                F[b + 20 >> 2] = d;
                                if ((e | 0) <= 0) {
                                    break m;
                                }
                                b = i + F[b >> 2] | 0;
                                F[f + 48 >> 2] = b;
                                d = e - 1 | 0;
                                h = d + b | 0;
                                i = G[h | 0];
                                o: {
                                    if (i >>> 0 <= 63) {
                                        F[f + 52 >> 2] = d;
                                        b = G[h | 0] & 63;
                                        break o;
                                    }
                                    p: {
                                        switch ((i >>> 6 | 0) - 1 | 0) {
                                            case 0:
                                                if (e >>> 0 < 2) {
                                                    break m;
                                                }
                                                F[f + 52 >> 2] = e - 2;
                                                b = (b + e | 0) - 2 | 0;
                                                b = G[b + 1 | 0] << 8 & 16128 | G[b | 0];
                                                break o;
                                            case 1:
                                                if (e >>> 0 < 3) {
                                                    break m;
                                                }
                                                F[f + 52 >> 2] = e - 3;
                                                b = (b + e | 0) - 3 | 0;
                                                b = G[b + 2 | 0] << 16 & 4128768 | G[b + 1 | 0] << 8 | G[b | 0];
                                                break o;
                                            default: break p;
                                        }
                                    }
                                    F[f + 52 >> 2] = e - 4;
                                    b = (b + e | 0) - 4 | 0;
                                    b = G[b + 2 | 0] << 16 | G[b + 3 | 0] << 24 & 1056964608 | G[b + 1 | 0] << 8 | G[b | 0];
                                }
                                b = b + 4194304 | 0;
                                F[f + 56 >> 2] = b;
                                g = b >>> 0 < 1073741824;
                            }
                            ea = j + 16 | 0;
                            if (!g) {
                                break l;
                            }
                            if (!a) {
                                o = 1;
                                break l;
                            }
                            d = F[f + 36 >> 2];
                            e = F[f + 48 >> 2];
                            h = F[f + 24 >> 2];
                            b = F[f + 56 >> 2];
                            while (1) {
                                q: {
                                    if (b >>> 0 > 4194303) {
                                        break q;
                                    }
                                    o = F[f + 52 >> 2];
                                    while (1) {
                                        if ((o | 0) <= 0) {
                                            break q;
                                        }
                                        o = o - 1 | 0;
                                        F[f + 52 >> 2] = o;
                                        b = G[e + o | 0] | b << 8;
                                        F[f + 56 >> 2] = b;
                                        if (b >>> 0 < 4194304) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                i = b & 1048575;
                                g = F[h + (i << 2) >> 2];
                                l = d + (g << 3) | 0;
                                b = (L(F[l >> 2], b >>> 20 | 0) + i | 0) - F[l + 4 >> 2] | 0;
                                F[f + 56 >> 2] = b;
                                F[(r << 2) + c >> 2] = g;
                                o = 1;
                                r = r + 1 | 0;
                                if ((r | 0) != (a | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } a = F[f + 36 >> 2]; if (a) {
                            F[f + 40 >> 2] = a;
                            ra(a);
                        } a = F[f + 24 >> 2]; if (a) {
                            F[f + 28 >> 2] = a;
                            ra(a);
                        } a = F[f + 8 >> 2]; if (a) {
                            F[f + 12 >> 2] = a;
                            ra(a);
                        } ea = f - -64 | 0; return o; }
                        function hc(a, b, c, d) { var e = 0, f = 0, g = 0, h = 0, i = 0, j = M(0), k = 0; a: {
                            b: {
                                if (!d) {
                                    break b;
                                }
                                c: {
                                    d: {
                                        switch (F[a + 28 >> 2] - 1 | 0) {
                                            case 0:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        E[(g << 1) + d >> 1] = D[b | 0];
                                                        b = b + 1 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 1:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        E[(g << 1) + d >> 1] = G[b | 0];
                                                        b = b + 1 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 2:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        E[(g << 1) + d >> 1] = H[b >> 1];
                                                        b = b + 2 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 3:
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        e = E[b >> 1];
                                                        if ((e | 0) < 0) {
                                                            break b;
                                                        }
                                                        E[(g << 1) + d >> 1] = e;
                                                        b = b + 2 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                h = 1;
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 4:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        e = F[b >> 2];
                                                        if (e - 32768 >>> 0 < 4294901760) {
                                                            break a;
                                                        }
                                                        E[(g << 1) + d >> 1] = e;
                                                        b = b + 4 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 5:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        e = F[b >> 2];
                                                        if (e >>> 0 > 32767) {
                                                            break a;
                                                        }
                                                        E[(g << 1) + d >> 1] = e;
                                                        b = b + 4 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 6:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        i = F[b >> 2];
                                                        e = F[b + 4 >> 2] - (i >>> 0 < 32768) | 0;
                                                        if ((e | 0) == -1 & i - 32768 >>> 0 < 4294901760 | (e | 0) != -1) {
                                                            break a;
                                                        }
                                                        E[(g << 1) + d >> 1] = i;
                                                        b = b + 8 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 7:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        e = F[b + 4 >> 2];
                                                        i = F[b >> 2];
                                                        if (!e & i >>> 0 > 32767 | e) {
                                                            break a;
                                                        }
                                                        E[(g << 1) + d >> 1] = i;
                                                        b = b + 8 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 8:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        i = (g << 1) + d | 0;
                                                        j = J[b >> 2];
                                                        e: {
                                                            if (M(N(j)) < M(2147483648)) {
                                                                e = ~~j;
                                                                break e;
                                                            }
                                                            e = -2147483648;
                                                        }
                                                        E[i >> 1] = e;
                                                        b = b + 4 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 9:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        i = (g << 1) + d | 0;
                                                        k = K[b >> 3];
                                                        f: {
                                                            if (N(k) < 2147483648) {
                                                                e = ~~k;
                                                                break f;
                                                            }
                                                            e = -2147483648;
                                                        }
                                                        E[i >> 1] = e;
                                                        b = b + 8 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 10: break d;
                                            default: break b;
                                        }
                                    }
                                    h = 1;
                                    e = D[a + 24 | 0];
                                    if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                        e = F[a >> 2];
                                        f = F[e >> 2];
                                        b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                        b = f + b | 0;
                                        f = F[e + 4 >> 2];
                                        while (1) {
                                            if (b >>> 0 >= f >>> 0) {
                                                break a;
                                            }
                                            E[(g << 1) + d >> 1] = G[b | 0];
                                            b = b + 1 | 0;
                                            g = g + 1 | 0;
                                            e = D[a + 24 | 0];
                                            if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    if ((c | 0) <= (e | 0)) {
                                        break b;
                                    }
                                }
                                ua((e << 1) + d | 0, 0, c - e << 1);
                            }
                            return h;
                        } return 0; }
                        function Aj(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0; F[a + 8 >> 2] = e; d = a + 32 | 0; i = F[d >> 2]; f = F[a + 36 >> 2] - i >> 2; a: {
                            if (f >>> 0 < e >>> 0) {
                                Aa(d, e - f | 0);
                                i = F[d >> 2];
                                d = F[a + 8 >> 2];
                                break a;
                            }
                            if (e >>> 0 < f >>> 0) {
                                F[a + 36 >> 2] = (e << 2) + i;
                            }
                            d = e;
                        } f = (e & 1073741823) != (e | 0) ? -1 : e << 2; m = ua(sa(f), 0, f); p = ua(sa(f), 0, f); b: {
                            if ((d | 0) <= 0) {
                                break b;
                            }
                            while (1) {
                                d = g << 2;
                                f = F[d + m >> 2];
                                h = F[a + 16 >> 2];
                                c: {
                                    if ((f | 0) > (h | 0)) {
                                        F[d + i >> 2] = h;
                                        break c;
                                    }
                                    d = d + i | 0;
                                    h = F[a + 12 >> 2];
                                    if ((h | 0) > (f | 0)) {
                                        F[d >> 2] = h;
                                        break c;
                                    }
                                    F[d >> 2] = f;
                                }
                                d = F[a + 8 >> 2];
                                g = g + 1 | 0;
                                if ((d | 0) > (g | 0)) {
                                    continue;
                                }
                                break;
                            }
                            if ((d | 0) <= 0) {
                                break b;
                            }
                            f = 0;
                            while (1) {
                                h = f << 2;
                                d = h + c | 0;
                                h = F[b + h >> 2] + F[h + i >> 2] | 0;
                                F[d >> 2] = h;
                                d: {
                                    if ((h | 0) > F[a + 16 >> 2]) {
                                        g = h - F[a + 20 >> 2] | 0;
                                    }
                                    else {
                                        if ((h | 0) >= F[a + 12 >> 2]) {
                                            break d;
                                        }
                                        g = h + F[a + 20 >> 2] | 0;
                                    }
                                    F[d >> 2] = g;
                                }
                                d = F[a + 8 >> 2];
                                f = f + 1 | 0;
                                if ((d | 0) > (f | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } f = F[a + 56 >> 2]; u = F[f >> 2]; f = F[f + 4 >> 2] - u | 0; if ((f | 0) >= 5) {
                            y = F[a + 52 >> 2];
                            r = F[a + 48 >> 2];
                            f = f >> 2;
                            z = (f | 0) > 2 ? f : 2;
                            A = f >>> 0 > 1 ? f : 1;
                            v = e & -2;
                            w = e & 1;
                            B = e & -4;
                            x = e & 3;
                            t = e - 1 | 0;
                            C = e << 2;
                            o = 1;
                            while (1) {
                                e: {
                                    f: {
                                        g: {
                                            h: {
                                                if ((o | 0) != (A | 0)) {
                                                    h = F[(o << 2) + u >> 2];
                                                    s = (e | 0) <= 0;
                                                    if (!s) {
                                                        ua(m, 0, C);
                                                    }
                                                    if ((h | 0) == -1) {
                                                        j = L(e, o);
                                                        break f;
                                                    }
                                                    D = F[r >> 2];
                                                    n = 0;
                                                    f = h;
                                                    while (1) {
                                                        i: {
                                                            if (F[(f >>> 3 & 536870908) + D >> 2] >>> f & 1) {
                                                                break i;
                                                            }
                                                            g = F[F[F[r + 64 >> 2] + 12 >> 2] + (f << 2) >> 2];
                                                            if ((g | 0) == -1) {
                                                                break i;
                                                            }
                                                            j = F[y >> 2];
                                                            i = F[r + 28 >> 2];
                                                            l = F[j + (F[i + (g << 2) >> 2] << 2) >> 2];
                                                            if ((l | 0) >= (o | 0)) {
                                                                break i;
                                                            }
                                                            k = g + 1 | 0;
                                                            k = F[j + (F[i + (((k >>> 0) % 3 | 0 ? k : g - 2 | 0) << 2) >> 2] << 2) >> 2];
                                                            if ((k | 0) >= (o | 0)) {
                                                                break i;
                                                            }
                                                            g = F[j + (F[i + (g + ((g >>> 0) % 3 | 0 ? -1 : 2) << 2) >> 2] << 2) >> 2];
                                                            if ((g | 0) >= (o | 0)) {
                                                                break i;
                                                            }
                                                            j: {
                                                                if (s) {
                                                                    break j;
                                                                }
                                                                i = L(e, g);
                                                                j = L(e, k);
                                                                l = L(e, l);
                                                                g = 0;
                                                                q = 0;
                                                                if (t) {
                                                                    while (1) {
                                                                        F[(g << 2) + p >> 2] = (F[(g + i << 2) + c >> 2] + F[(g + j << 2) + c >> 2] | 0) - F[(g + l << 2) + c >> 2];
                                                                        k = g | 1;
                                                                        F[(k << 2) + p >> 2] = (F[(i + k << 2) + c >> 2] + F[(j + k << 2) + c >> 2] | 0) - F[(k + l << 2) + c >> 2];
                                                                        g = g + 2 | 0;
                                                                        q = q + 2 | 0;
                                                                        if ((v | 0) != (q | 0)) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                }
                                                                if (w) {
                                                                    F[(g << 2) + p >> 2] = (F[(g + i << 2) + c >> 2] + F[(g + j << 2) + c >> 2] | 0) - F[(g + l << 2) + c >> 2];
                                                                }
                                                                if (s) {
                                                                    break j;
                                                                }
                                                                i = 0;
                                                                g = 0;
                                                                j = 0;
                                                                if (t >>> 0 > 2) {
                                                                    while (1) {
                                                                        l = g << 2;
                                                                        k = l + m | 0;
                                                                        F[k >> 2] = F[k >> 2] + F[l + p >> 2];
                                                                        k = l | 4;
                                                                        q = k + m | 0;
                                                                        F[q >> 2] = F[q >> 2] + F[k + p >> 2];
                                                                        k = l | 8;
                                                                        q = k + m | 0;
                                                                        F[q >> 2] = F[q >> 2] + F[k + p >> 2];
                                                                        l = l | 12;
                                                                        k = l + m | 0;
                                                                        F[k >> 2] = F[k >> 2] + F[l + p >> 2];
                                                                        g = g + 4 | 0;
                                                                        j = j + 4 | 0;
                                                                        if ((B | 0) != (j | 0)) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                }
                                                                if (!x) {
                                                                    break j;
                                                                }
                                                                while (1) {
                                                                    j = g << 2;
                                                                    l = j + m | 0;
                                                                    F[l >> 2] = F[l >> 2] + F[j + p >> 2];
                                                                    g = g + 1 | 0;
                                                                    i = i + 1 | 0;
                                                                    if ((x | 0) != (i | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            n = n + 1 | 0;
                                                        }
                                                        k: {
                                                            l: {
                                                                if ((f >>> 0) % 3 | 0) {
                                                                    f = f - 1 | 0;
                                                                    break l;
                                                                }
                                                                f = f + 2 | 0;
                                                                g = -1;
                                                                if ((f | 0) == -1) {
                                                                    break k;
                                                                }
                                                            }
                                                            g = -1;
                                                            if (F[F[r >> 2] + (f >>> 3 & 536870908) >> 2] >>> f & 1) {
                                                                break k;
                                                            }
                                                            f = F[F[F[r + 64 >> 2] + 12 >> 2] + (f << 2) >> 2];
                                                            g = -1;
                                                            if ((f | 0) == -1) {
                                                                break k;
                                                            }
                                                            g = f - 1 | 0;
                                                            if ((f >>> 0) % 3 | 0) {
                                                                break k;
                                                            }
                                                            g = f + 2 | 0;
                                                        }
                                                        f = (g | 0) == (h | 0) ? -1 : g;
                                                        if ((f | 0) != -1) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    j = L(e, o);
                                                    if (!n) {
                                                        break f;
                                                    }
                                                    if (s) {
                                                        break g;
                                                    }
                                                    g = 0;
                                                    f = 0;
                                                    if (!t) {
                                                        break h;
                                                    }
                                                    while (1) {
                                                        h = g << 2;
                                                        i = h + m | 0;
                                                        F[i >> 2] = F[i >> 2] / (n | 0);
                                                        h = (h | 4) + m | 0;
                                                        F[h >> 2] = F[h >> 2] / (n | 0);
                                                        g = g + 2 | 0;
                                                        f = f + 2 | 0;
                                                        if ((v | 0) != (f | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    break h;
                                                }
                                                Da();
                                                V();
                                            }
                                            if (!w) {
                                                break g;
                                            }
                                            f = (g << 2) + m | 0;
                                            F[f >> 2] = F[f >> 2] / (n | 0);
                                        }
                                        if ((d | 0) <= 0) {
                                            break e;
                                        }
                                        i = F[a + 32 >> 2];
                                        g = 0;
                                        while (1) {
                                            d = g << 2;
                                            f = F[d + m >> 2];
                                            h = F[a + 16 >> 2];
                                            m: {
                                                if ((f | 0) > (h | 0)) {
                                                    F[d + i >> 2] = h;
                                                    break m;
                                                }
                                                d = d + i | 0;
                                                h = F[a + 12 >> 2];
                                                if ((h | 0) > (f | 0)) {
                                                    F[d >> 2] = h;
                                                    break m;
                                                }
                                                F[d >> 2] = f;
                                            }
                                            d = F[a + 8 >> 2];
                                            g = g + 1 | 0;
                                            if ((d | 0) > (g | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                        f = 0;
                                        if ((d | 0) <= 0) {
                                            break e;
                                        }
                                        d = j << 2;
                                        g = d + c | 0;
                                        j = b + d | 0;
                                        while (1) {
                                            h = f << 2;
                                            d = h + g | 0;
                                            h = F[h + j >> 2] + F[h + i >> 2] | 0;
                                            F[d >> 2] = h;
                                            n: {
                                                if ((h | 0) > F[a + 16 >> 2]) {
                                                    h = h - F[a + 20 >> 2] | 0;
                                                }
                                                else {
                                                    if ((h | 0) >= F[a + 12 >> 2]) {
                                                        break n;
                                                    }
                                                    h = h + F[a + 20 >> 2] | 0;
                                                }
                                                F[d >> 2] = h;
                                            }
                                            d = F[a + 8 >> 2];
                                            f = f + 1 | 0;
                                            if ((d | 0) > (f | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                        break e;
                                    }
                                    if ((d | 0) <= 0) {
                                        break e;
                                    }
                                    h = (L(o - 1 | 0, e) << 2) + c | 0;
                                    i = F[a + 32 >> 2];
                                    g = 0;
                                    while (1) {
                                        d = g << 2;
                                        f = F[d + h >> 2];
                                        n = F[a + 16 >> 2];
                                        o: {
                                            if ((f | 0) > (n | 0)) {
                                                F[d + i >> 2] = n;
                                                break o;
                                            }
                                            d = d + i | 0;
                                            n = F[a + 12 >> 2];
                                            if ((n | 0) > (f | 0)) {
                                                F[d >> 2] = n;
                                                break o;
                                            }
                                            F[d >> 2] = f;
                                        }
                                        d = F[a + 8 >> 2];
                                        g = g + 1 | 0;
                                        if ((d | 0) > (g | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                    f = 0;
                                    if ((d | 0) <= 0) {
                                        break e;
                                    }
                                    d = j << 2;
                                    g = d + c | 0;
                                    j = b + d | 0;
                                    while (1) {
                                        h = f << 2;
                                        d = h + g | 0;
                                        h = F[h + j >> 2] + F[h + i >> 2] | 0;
                                        F[d >> 2] = h;
                                        p: {
                                            if ((h | 0) > F[a + 16 >> 2]) {
                                                h = h - F[a + 20 >> 2] | 0;
                                            }
                                            else {
                                                if ((h | 0) >= F[a + 12 >> 2]) {
                                                    break p;
                                                }
                                                h = h + F[a + 20 >> 2] | 0;
                                            }
                                            F[d >> 2] = h;
                                        }
                                        d = F[a + 8 >> 2];
                                        f = f + 1 | 0;
                                        if ((d | 0) > (f | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                o = o + 1 | 0;
                                if ((z | 0) != (o | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } ra(p); ra(m); return 1; }
                        function gc(a, b, c, d) { var e = 0, f = 0, g = 0, h = 0, i = 0, j = M(0), k = 0; a: {
                            b: {
                                if (!d) {
                                    break b;
                                }
                                c: {
                                    d: {
                                        switch (F[a + 28 >> 2] - 1 | 0) {
                                            case 0:
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        e = D[b | 0];
                                                        if ((e | 0) < 0) {
                                                            break b;
                                                        }
                                                        E[(g << 1) + d >> 1] = e & 255;
                                                        b = b + 1 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                h = 1;
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 1:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        E[(g << 1) + d >> 1] = G[b | 0];
                                                        b = b + 1 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 2:
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        e = E[b >> 1];
                                                        if ((e | 0) < 0) {
                                                            break b;
                                                        }
                                                        E[(g << 1) + d >> 1] = e;
                                                        b = b + 2 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                h = 1;
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 3:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        E[(g << 1) + d >> 1] = H[b >> 1];
                                                        b = b + 2 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 4:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        e = F[b >> 2];
                                                        if (e >>> 0 > 65535) {
                                                            break a;
                                                        }
                                                        E[(g << 1) + d >> 1] = e;
                                                        b = b + 4 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 5:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        e = F[b >> 2];
                                                        if (e >>> 0 > 65535) {
                                                            break a;
                                                        }
                                                        E[(g << 1) + d >> 1] = e;
                                                        b = b + 4 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 6:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        e = F[b + 4 >> 2];
                                                        i = F[b >> 2];
                                                        if (!e & i >>> 0 > 65535 | e) {
                                                            break a;
                                                        }
                                                        E[(g << 1) + d >> 1] = i;
                                                        b = b + 8 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 7:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        e = F[b + 4 >> 2];
                                                        i = F[b >> 2];
                                                        if (!e & i >>> 0 > 65535 | e) {
                                                            break a;
                                                        }
                                                        E[(g << 1) + d >> 1] = i;
                                                        b = b + 8 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 8:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        i = (g << 1) + d | 0;
                                                        j = J[b >> 2];
                                                        e: {
                                                            if (j < M(4294967296) & j >= M(0)) {
                                                                e = ~~j >>> 0;
                                                                break e;
                                                            }
                                                            e = 0;
                                                        }
                                                        E[i >> 1] = e;
                                                        b = b + 4 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 9:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        i = (g << 1) + d | 0;
                                                        k = K[b >> 3];
                                                        f: {
                                                            if (k < 4294967296 & k >= 0) {
                                                                e = ~~k >>> 0;
                                                                break f;
                                                            }
                                                            e = 0;
                                                        }
                                                        E[i >> 1] = e;
                                                        b = b + 8 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 10: break d;
                                            default: break b;
                                        }
                                    }
                                    h = 1;
                                    e = D[a + 24 | 0];
                                    if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                        e = F[a >> 2];
                                        f = F[e >> 2];
                                        b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                        b = f + b | 0;
                                        f = F[e + 4 >> 2];
                                        while (1) {
                                            if (b >>> 0 >= f >>> 0) {
                                                break a;
                                            }
                                            E[(g << 1) + d >> 1] = G[b | 0];
                                            b = b + 1 | 0;
                                            g = g + 1 | 0;
                                            e = D[a + 24 | 0];
                                            if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    if ((c | 0) <= (e | 0)) {
                                        break b;
                                    }
                                }
                                ua((e << 1) + d | 0, 0, c - e << 1);
                            }
                            return h;
                        } return 0; }
                        function oc(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0; e = ea - 48 | 0; ea = e; d = H[6693] | H[6694] << 16; f = H[6691] | H[6692] << 16; E[e + 38 >> 1] = f; E[e + 40 >> 1] = f >>> 16; E[e + 42 >> 1] = d; E[e + 44 >> 1] = d >>> 16; d = F[3345]; F[e + 32 >> 2] = F[3344]; F[e + 36 >> 2] = d; d = F[3343]; F[e + 24 >> 2] = F[3342]; F[e + 28 >> 2] = d; d = F[3341]; F[e + 16 >> 2] = F[3340]; F[e + 20 >> 2] = d; f = F[b + 12 >> 2]; d = F[b + 20 >> 2]; g = F[b + 16 >> 2]; h = g + 5 | 0; d = h >>> 0 < 5 ? d + 1 | 0 : d; a: {
                            b: {
                                if (h >>> 0 > I[b + 8 >> 2] & (d | 0) >= (f | 0) | (d | 0) > (f | 0)) {
                                    b = La(e + 16 | 0);
                                    if (b >>> 0 >= 4294967280) {
                                        break a;
                                    }
                                    c: {
                                        d: {
                                            if (b >>> 0 >= 11) {
                                                d = b + 16 & -16;
                                                c = sa(d);
                                                F[e + 8 >> 2] = d | -2147483648;
                                                F[e >> 2] = c;
                                                F[e + 4 >> 2] = b;
                                                break d;
                                            }
                                            D[e + 11 | 0] = b;
                                            c = e;
                                            if (!b) {
                                                break c;
                                            }
                                        }
                                        ta(c, e + 16 | 0, b);
                                    }
                                    D[b + c | 0] = 0;
                                    F[a >> 2] = -2;
                                    a = a + 4 | 0;
                                    if (D[e + 11 | 0] >= 0) {
                                        b = F[e + 4 >> 2];
                                        F[a >> 2] = F[e >> 2];
                                        F[a + 4 >> 2] = b;
                                        F[a + 8 >> 2] = F[e + 8 >> 2];
                                        break b;
                                    }
                                    b = a;
                                    a = F[e >> 2];
                                    Ba(b, a, F[e + 4 >> 2]);
                                    ra(a);
                                    break b;
                                }
                                d = g + F[b >> 2] | 0;
                                f = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                D[c | 0] = f;
                                D[c + 1 | 0] = f >>> 8;
                                D[c + 2 | 0] = f >>> 16;
                                D[c + 3 | 0] = f >>> 24;
                                D[c + 4 | 0] = G[d + 4 | 0];
                                d = F[b + 20 >> 2];
                                f = F[b + 16 >> 2] + 5 | 0;
                                d = f >>> 0 < 5 ? d + 1 | 0 : d;
                                F[b + 16 >> 2] = f;
                                F[b + 20 >> 2] = d;
                                if (Ha(c, 1404, 5)) {
                                    b = sa(32);
                                    D[b + 16 | 0] = G[1640];
                                    c = G[1636] | G[1637] << 8 | (G[1638] << 16 | G[1639] << 24);
                                    d = G[1632] | G[1633] << 8 | (G[1634] << 16 | G[1635] << 24);
                                    D[b + 8 | 0] = d;
                                    D[b + 9 | 0] = d >>> 8;
                                    D[b + 10 | 0] = d >>> 16;
                                    D[b + 11 | 0] = d >>> 24;
                                    D[b + 12 | 0] = c;
                                    D[b + 13 | 0] = c >>> 8;
                                    D[b + 14 | 0] = c >>> 16;
                                    D[b + 15 | 0] = c >>> 24;
                                    c = G[1628] | G[1629] << 8 | (G[1630] << 16 | G[1631] << 24);
                                    d = G[1624] | G[1625] << 8 | (G[1626] << 16 | G[1627] << 24);
                                    D[b | 0] = d;
                                    D[b + 1 | 0] = d >>> 8;
                                    D[b + 2 | 0] = d >>> 16;
                                    D[b + 3 | 0] = d >>> 24;
                                    D[b + 4 | 0] = c;
                                    D[b + 5 | 0] = c >>> 8;
                                    D[b + 6 | 0] = c >>> 16;
                                    D[b + 7 | 0] = c >>> 24;
                                    D[b + 17 | 0] = 0;
                                    F[a >> 2] = -1;
                                    Ba(a + 4 | 0, b, 17);
                                    ra(b);
                                    break b;
                                }
                                g = F[b + 12 >> 2];
                                if ((g | 0) <= (d | 0) & I[b + 8 >> 2] <= f >>> 0 | (d | 0) > (g | 0)) {
                                    b = La(e + 16 | 0);
                                    if (b >>> 0 >= 4294967280) {
                                        break a;
                                    }
                                    e: {
                                        f: {
                                            if (b >>> 0 >= 11) {
                                                d = b + 16 & -16;
                                                c = sa(d);
                                                F[e + 8 >> 2] = d | -2147483648;
                                                F[e >> 2] = c;
                                                F[e + 4 >> 2] = b;
                                                break f;
                                            }
                                            D[e + 11 | 0] = b;
                                            c = e;
                                            if (!b) {
                                                break e;
                                            }
                                        }
                                        ta(c, e + 16 | 0, b);
                                    }
                                    D[b + c | 0] = 0;
                                    F[a >> 2] = -2;
                                    a = a + 4 | 0;
                                    if (D[e + 11 | 0] >= 0) {
                                        b = F[e + 4 >> 2];
                                        F[a >> 2] = F[e >> 2];
                                        F[a + 4 >> 2] = b;
                                        F[a + 8 >> 2] = F[e + 8 >> 2];
                                        break b;
                                    }
                                    b = a;
                                    a = F[e >> 2];
                                    Ba(b, a, F[e + 4 >> 2]);
                                    ra(a);
                                    break b;
                                }
                                D[c + 5 | 0] = G[f + F[b >> 2] | 0];
                                d = F[b + 20 >> 2];
                                f = F[b + 16 >> 2] + 1 | 0;
                                d = f ? d : d + 1 | 0;
                                F[b + 16 >> 2] = f;
                                F[b + 20 >> 2] = d;
                                g = F[b + 12 >> 2];
                                if ((g | 0) <= (d | 0) & I[b + 8 >> 2] <= f >>> 0 | (d | 0) > (g | 0)) {
                                    b = La(e + 16 | 0);
                                    if (b >>> 0 >= 4294967280) {
                                        break a;
                                    }
                                    g: {
                                        h: {
                                            if (b >>> 0 >= 11) {
                                                d = b + 16 & -16;
                                                c = sa(d);
                                                F[e + 8 >> 2] = d | -2147483648;
                                                F[e >> 2] = c;
                                                F[e + 4 >> 2] = b;
                                                break h;
                                            }
                                            D[e + 11 | 0] = b;
                                            c = e;
                                            if (!b) {
                                                break g;
                                            }
                                        }
                                        ta(c, e + 16 | 0, b);
                                    }
                                    D[b + c | 0] = 0;
                                    F[a >> 2] = -2;
                                    a = a + 4 | 0;
                                    if (D[e + 11 | 0] >= 0) {
                                        b = F[e + 4 >> 2];
                                        F[a >> 2] = F[e >> 2];
                                        F[a + 4 >> 2] = b;
                                        F[a + 8 >> 2] = F[e + 8 >> 2];
                                        break b;
                                    }
                                    b = a;
                                    a = F[e >> 2];
                                    Ba(b, a, F[e + 4 >> 2]);
                                    ra(a);
                                    break b;
                                }
                                D[c + 6 | 0] = G[f + F[b >> 2] | 0];
                                d = F[b + 20 >> 2];
                                f = F[b + 16 >> 2] + 1 | 0;
                                d = f ? d : d + 1 | 0;
                                F[b + 16 >> 2] = f;
                                F[b + 20 >> 2] = d;
                                g = F[b + 12 >> 2];
                                if ((g | 0) <= (d | 0) & I[b + 8 >> 2] <= f >>> 0 | (d | 0) > (g | 0)) {
                                    b = La(e + 16 | 0);
                                    if (b >>> 0 >= 4294967280) {
                                        break a;
                                    }
                                    i: {
                                        j: {
                                            if (b >>> 0 >= 11) {
                                                d = b + 16 & -16;
                                                c = sa(d);
                                                F[e + 8 >> 2] = d | -2147483648;
                                                F[e >> 2] = c;
                                                F[e + 4 >> 2] = b;
                                                break j;
                                            }
                                            D[e + 11 | 0] = b;
                                            c = e;
                                            if (!b) {
                                                break i;
                                            }
                                        }
                                        ta(c, e + 16 | 0, b);
                                    }
                                    D[b + c | 0] = 0;
                                    F[a >> 2] = -2;
                                    a = a + 4 | 0;
                                    if (D[e + 11 | 0] >= 0) {
                                        b = F[e + 4 >> 2];
                                        F[a >> 2] = F[e >> 2];
                                        F[a + 4 >> 2] = b;
                                        F[a + 8 >> 2] = F[e + 8 >> 2];
                                        break b;
                                    }
                                    b = a;
                                    a = F[e >> 2];
                                    Ba(b, a, F[e + 4 >> 2]);
                                    ra(a);
                                    break b;
                                }
                                D[c + 7 | 0] = G[f + F[b >> 2] | 0];
                                d = F[b + 20 >> 2];
                                f = F[b + 16 >> 2] + 1 | 0;
                                d = f ? d : d + 1 | 0;
                                F[b + 16 >> 2] = f;
                                F[b + 20 >> 2] = d;
                                g = F[b + 12 >> 2];
                                if ((g | 0) <= (d | 0) & I[b + 8 >> 2] <= f >>> 0 | (d | 0) > (g | 0)) {
                                    b = nc(e, e + 16 | 0);
                                    F[a >> 2] = -2;
                                    a = a + 4 | 0;
                                    if (D[b + 11 | 0] >= 0) {
                                        b = F[e + 4 >> 2];
                                        F[a >> 2] = F[e >> 2];
                                        F[a + 4 >> 2] = b;
                                        F[a + 8 >> 2] = F[e + 8 >> 2];
                                        break b;
                                    }
                                    Ba(a, F[b >> 2], F[b + 4 >> 2]);
                                    if (D[b + 11 | 0] >= 0) {
                                        break b;
                                    }
                                    ra(F[b >> 2]);
                                    break b;
                                }
                                D[c + 8 | 0] = G[f + F[b >> 2] | 0];
                                d = F[b + 20 >> 2];
                                f = d;
                                i = F[b + 16 >> 2];
                                g = i + 1 | 0;
                                d = g ? d : d + 1 | 0;
                                F[b + 16 >> 2] = g;
                                F[b + 20 >> 2] = d;
                                h = F[b + 12 >> 2];
                                d = f;
                                f = i + 3 | 0;
                                d = f >>> 0 < 3 ? d + 1 | 0 : d;
                                if (f >>> 0 > I[b + 8 >> 2] & (d | 0) >= (h | 0) | (d | 0) > (h | 0)) {
                                    b = nc(e, e + 16 | 0);
                                    F[a >> 2] = -2;
                                    a = a + 4 | 0;
                                    if (D[b + 11 | 0] >= 0) {
                                        b = F[e + 4 >> 2];
                                        F[a >> 2] = F[e >> 2];
                                        F[a + 4 >> 2] = b;
                                        F[a + 8 >> 2] = F[e + 8 >> 2];
                                        break b;
                                    }
                                    Ba(a, F[b >> 2], F[b + 4 >> 2]);
                                    if (D[b + 11 | 0] >= 0) {
                                        break b;
                                    }
                                    ra(F[b >> 2]);
                                    break b;
                                }
                                f = c;
                                c = g + F[b >> 2] | 0;
                                E[f + 10 >> 1] = G[c | 0] | G[c + 1 | 0] << 8;
                                d = F[b + 20 >> 2];
                                c = F[b + 16 >> 2] + 2 | 0;
                                d = c >>> 0 < 2 ? d + 1 | 0 : d;
                                F[b + 16 >> 2] = c;
                                F[b + 20 >> 2] = d;
                                F[a + 8 >> 2] = 0;
                                F[a + 12 >> 2] = 0;
                                F[a >> 2] = 0;
                                F[a + 4 >> 2] = 0;
                            }
                            ea = e + 48 | 0;
                            return;
                        } Ma(); V(); }
                        function lj(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0; F[a + 8 >> 2] = e; d = a + 32 | 0; i = F[d >> 2]; f = F[a + 36 >> 2] - i >> 2; a: {
                            if (f >>> 0 < e >>> 0) {
                                Aa(d, e - f | 0);
                                i = F[d >> 2];
                                d = F[a + 8 >> 2];
                                break a;
                            }
                            if (e >>> 0 < f >>> 0) {
                                F[a + 36 >> 2] = (e << 2) + i;
                            }
                            d = e;
                        } f = (e & 1073741823) != (e | 0) ? -1 : e << 2; n = ua(sa(f), 0, f); q = ua(sa(f), 0, f); b: {
                            if ((d | 0) <= 0) {
                                break b;
                            }
                            while (1) {
                                d = g << 2;
                                f = F[d + n >> 2];
                                h = F[a + 16 >> 2];
                                c: {
                                    if ((f | 0) > (h | 0)) {
                                        F[d + i >> 2] = h;
                                        break c;
                                    }
                                    d = d + i | 0;
                                    h = F[a + 12 >> 2];
                                    if ((h | 0) > (f | 0)) {
                                        F[d >> 2] = h;
                                        break c;
                                    }
                                    F[d >> 2] = f;
                                }
                                d = F[a + 8 >> 2];
                                g = g + 1 | 0;
                                if ((d | 0) > (g | 0)) {
                                    continue;
                                }
                                break;
                            }
                            if ((d | 0) <= 0) {
                                break b;
                            }
                            f = 0;
                            while (1) {
                                h = f << 2;
                                d = h + c | 0;
                                h = F[b + h >> 2] + F[h + i >> 2] | 0;
                                F[d >> 2] = h;
                                d: {
                                    if ((h | 0) > F[a + 16 >> 2]) {
                                        g = h - F[a + 20 >> 2] | 0;
                                    }
                                    else {
                                        if ((h | 0) >= F[a + 12 >> 2]) {
                                            break d;
                                        }
                                        g = h + F[a + 20 >> 2] | 0;
                                    }
                                    F[d >> 2] = g;
                                }
                                d = F[a + 8 >> 2];
                                f = f + 1 | 0;
                                if ((d | 0) > (f | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } f = F[a + 56 >> 2]; t = F[f >> 2]; f = F[f + 4 >> 2] - t | 0; if ((f | 0) >= 5) {
                            z = F[a + 52 >> 2];
                            u = F[a + 48 >> 2];
                            f = f >> 2;
                            A = (f | 0) > 2 ? f : 2;
                            B = f >>> 0 > 1 ? f : 1;
                            v = e & -2;
                            w = e & 1;
                            C = e & -4;
                            x = e & 3;
                            s = e - 1 | 0;
                            D = e << 2;
                            o = 1;
                            while (1) {
                                e: {
                                    f: {
                                        g: {
                                            h: {
                                                if ((o | 0) != (B | 0)) {
                                                    h = F[(o << 2) + t >> 2];
                                                    r = (e | 0) <= 0;
                                                    if (!r) {
                                                        ua(n, 0, D);
                                                    }
                                                    if ((h | 0) == -1) {
                                                        h = L(e, o);
                                                        break f;
                                                    }
                                                    y = F[u + 12 >> 2];
                                                    l = 0;
                                                    f = h;
                                                    while (1) {
                                                        g = F[(f << 2) + y >> 2];
                                                        i: {
                                                            if ((g | 0) == -1) {
                                                                break i;
                                                            }
                                                            j = F[z >> 2];
                                                            i = F[u >> 2];
                                                            p = F[j + (F[i + (g << 2) >> 2] << 2) >> 2];
                                                            k = g + 1 | 0;
                                                            k = (k >>> 0) % 3 | 0 ? k : g - 2 | 0;
                                                            if ((k | 0) != -1) {
                                                                k = F[i + (k << 2) >> 2];
                                                            }
                                                            else {
                                                                k = -1;
                                                            }
                                                            j: {
                                                                k: {
                                                                    if ((g >>> 0) % 3 | 0) {
                                                                        g = g - 1 | 0;
                                                                        break k;
                                                                    }
                                                                    g = g + 2 | 0;
                                                                    m = -1;
                                                                    if ((g | 0) == -1) {
                                                                        break j;
                                                                    }
                                                                }
                                                                m = F[i + (g << 2) >> 2];
                                                            }
                                                            if ((o | 0) <= (p | 0)) {
                                                                break i;
                                                            }
                                                            g = F[(k << 2) + j >> 2];
                                                            if ((g | 0) >= (o | 0)) {
                                                                break i;
                                                            }
                                                            i = F[j + (m << 2) >> 2];
                                                            if ((i | 0) >= (o | 0)) {
                                                                break i;
                                                            }
                                                            l: {
                                                                if (r) {
                                                                    break l;
                                                                }
                                                                i = L(e, i);
                                                                j = L(e, g);
                                                                p = L(e, p);
                                                                g = 0;
                                                                m = 0;
                                                                if (s) {
                                                                    while (1) {
                                                                        F[(g << 2) + q >> 2] = (F[(g + i << 2) + c >> 2] + F[(g + j << 2) + c >> 2] | 0) - F[(g + p << 2) + c >> 2];
                                                                        k = g | 1;
                                                                        F[(k << 2) + q >> 2] = (F[(i + k << 2) + c >> 2] + F[(j + k << 2) + c >> 2] | 0) - F[(k + p << 2) + c >> 2];
                                                                        g = g + 2 | 0;
                                                                        m = m + 2 | 0;
                                                                        if ((v | 0) != (m | 0)) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                }
                                                                if (w) {
                                                                    F[(g << 2) + q >> 2] = (F[(g + i << 2) + c >> 2] + F[(g + j << 2) + c >> 2] | 0) - F[(g + p << 2) + c >> 2];
                                                                }
                                                                if (r) {
                                                                    break l;
                                                                }
                                                                p = 0;
                                                                g = 0;
                                                                i = 0;
                                                                if (s >>> 0 > 2) {
                                                                    while (1) {
                                                                        j = g << 2;
                                                                        k = j + n | 0;
                                                                        F[k >> 2] = F[k >> 2] + F[j + q >> 2];
                                                                        k = j | 4;
                                                                        m = k + n | 0;
                                                                        F[m >> 2] = F[m >> 2] + F[k + q >> 2];
                                                                        k = j | 8;
                                                                        m = k + n | 0;
                                                                        F[m >> 2] = F[m >> 2] + F[k + q >> 2];
                                                                        j = j | 12;
                                                                        k = j + n | 0;
                                                                        F[k >> 2] = F[k >> 2] + F[j + q >> 2];
                                                                        g = g + 4 | 0;
                                                                        i = i + 4 | 0;
                                                                        if ((C | 0) != (i | 0)) {
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                }
                                                                if (!x) {
                                                                    break l;
                                                                }
                                                                while (1) {
                                                                    i = g << 2;
                                                                    j = i + n | 0;
                                                                    F[j >> 2] = F[j >> 2] + F[i + q >> 2];
                                                                    g = g + 1 | 0;
                                                                    p = p + 1 | 0;
                                                                    if ((x | 0) != (p | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            l = l + 1 | 0;
                                                        }
                                                        m: {
                                                            n: {
                                                                if ((f >>> 0) % 3 | 0) {
                                                                    f = f - 1 | 0;
                                                                    break n;
                                                                }
                                                                f = f + 2 | 0;
                                                                g = -1;
                                                                if ((f | 0) == -1) {
                                                                    break m;
                                                                }
                                                            }
                                                            f = F[(f << 2) + y >> 2];
                                                            g = -1;
                                                            if ((f | 0) == -1) {
                                                                break m;
                                                            }
                                                            g = f - 1 | 0;
                                                            if ((f >>> 0) % 3 | 0) {
                                                                break m;
                                                            }
                                                            g = f + 2 | 0;
                                                        }
                                                        f = (g | 0) == (h | 0) ? -1 : g;
                                                        if ((f | 0) != -1) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    h = L(e, o);
                                                    if (!l) {
                                                        break f;
                                                    }
                                                    if (r) {
                                                        break g;
                                                    }
                                                    g = 0;
                                                    f = 0;
                                                    if (!s) {
                                                        break h;
                                                    }
                                                    while (1) {
                                                        i = g << 2;
                                                        j = i + n | 0;
                                                        F[j >> 2] = F[j >> 2] / (l | 0);
                                                        i = (i | 4) + n | 0;
                                                        F[i >> 2] = F[i >> 2] / (l | 0);
                                                        g = g + 2 | 0;
                                                        f = f + 2 | 0;
                                                        if ((v | 0) != (f | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    break h;
                                                }
                                                Da();
                                                V();
                                            }
                                            if (!w) {
                                                break g;
                                            }
                                            f = (g << 2) + n | 0;
                                            F[f >> 2] = F[f >> 2] / (l | 0);
                                        }
                                        if ((d | 0) <= 0) {
                                            break e;
                                        }
                                        i = F[a + 32 >> 2];
                                        g = 0;
                                        while (1) {
                                            d = g << 2;
                                            f = F[d + n >> 2];
                                            l = F[a + 16 >> 2];
                                            o: {
                                                if ((f | 0) > (l | 0)) {
                                                    F[d + i >> 2] = l;
                                                    break o;
                                                }
                                                d = d + i | 0;
                                                l = F[a + 12 >> 2];
                                                if ((l | 0) > (f | 0)) {
                                                    F[d >> 2] = l;
                                                    break o;
                                                }
                                                F[d >> 2] = f;
                                            }
                                            d = F[a + 8 >> 2];
                                            g = g + 1 | 0;
                                            if ((d | 0) > (g | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                        f = 0;
                                        if ((d | 0) <= 0) {
                                            break e;
                                        }
                                        d = h << 2;
                                        g = d + c | 0;
                                        l = b + d | 0;
                                        while (1) {
                                            h = f << 2;
                                            d = h + g | 0;
                                            h = F[h + l >> 2] + F[h + i >> 2] | 0;
                                            F[d >> 2] = h;
                                            p: {
                                                if ((h | 0) > F[a + 16 >> 2]) {
                                                    h = h - F[a + 20 >> 2] | 0;
                                                }
                                                else {
                                                    if ((h | 0) >= F[a + 12 >> 2]) {
                                                        break p;
                                                    }
                                                    h = h + F[a + 20 >> 2] | 0;
                                                }
                                                F[d >> 2] = h;
                                            }
                                            d = F[a + 8 >> 2];
                                            f = f + 1 | 0;
                                            if ((d | 0) > (f | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                        break e;
                                    }
                                    if ((d | 0) <= 0) {
                                        break e;
                                    }
                                    l = (L(o - 1 | 0, e) << 2) + c | 0;
                                    i = F[a + 32 >> 2];
                                    g = 0;
                                    while (1) {
                                        d = g << 2;
                                        f = F[d + l >> 2];
                                        j = F[a + 16 >> 2];
                                        q: {
                                            if ((f | 0) > (j | 0)) {
                                                F[d + i >> 2] = j;
                                                break q;
                                            }
                                            d = d + i | 0;
                                            j = F[a + 12 >> 2];
                                            if ((j | 0) > (f | 0)) {
                                                F[d >> 2] = j;
                                                break q;
                                            }
                                            F[d >> 2] = f;
                                        }
                                        d = F[a + 8 >> 2];
                                        g = g + 1 | 0;
                                        if ((d | 0) > (g | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                    f = 0;
                                    if ((d | 0) <= 0) {
                                        break e;
                                    }
                                    d = h << 2;
                                    g = d + c | 0;
                                    l = b + d | 0;
                                    while (1) {
                                        h = f << 2;
                                        d = h + g | 0;
                                        h = F[h + l >> 2] + F[h + i >> 2] | 0;
                                        F[d >> 2] = h;
                                        r: {
                                            if ((h | 0) > F[a + 16 >> 2]) {
                                                h = h - F[a + 20 >> 2] | 0;
                                            }
                                            else {
                                                if ((h | 0) >= F[a + 12 >> 2]) {
                                                    break r;
                                                }
                                                h = h + F[a + 20 >> 2] | 0;
                                            }
                                            F[d >> 2] = h;
                                        }
                                        d = F[a + 8 >> 2];
                                        f = f + 1 | 0;
                                        if ((d | 0) > (f | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                o = o + 1 | 0;
                                if ((A | 0) != (o | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } ra(q); ra(n); return 1; }
                        function fc(a, b, c, d) { var e = 0, f = 0, g = 0, h = 0, i = 0, j = M(0), k = 0; a: {
                            b: {
                                if (!d) {
                                    break b;
                                }
                                c: {
                                    d: {
                                        switch (F[a + 28 >> 2] - 1 | 0) {
                                            case 0:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        F[(g << 2) + d >> 2] = D[b | 0];
                                                        b = b + 1 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 1:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        F[(g << 2) + d >> 2] = G[b | 0];
                                                        b = b + 1 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 2:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        F[(g << 2) + d >> 2] = E[b >> 1];
                                                        b = b + 2 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 3:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        F[(g << 2) + d >> 2] = H[b >> 1];
                                                        b = b + 2 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 4:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        F[(g << 2) + d >> 2] = F[b >> 2];
                                                        b = b + 4 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 5:
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        e = F[b >> 2];
                                                        if ((e | 0) < 0) {
                                                            break b;
                                                        }
                                                        F[(g << 2) + d >> 2] = e;
                                                        b = b + 4 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                h = 1;
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 6:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        e = F[b >> 2];
                                                        if ((F[b + 4 >> 2] - (e >>> 0 < 2147483648) | 0) != -1) {
                                                            break a;
                                                        }
                                                        F[(g << 2) + d >> 2] = e;
                                                        b = b + 8 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 7:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        e = F[b + 4 >> 2];
                                                        i = F[b >> 2];
                                                        if (!e & i >>> 0 > 2147483647 | e) {
                                                            break a;
                                                        }
                                                        F[(g << 2) + d >> 2] = i;
                                                        b = b + 8 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 8:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        i = (g << 2) + d | 0;
                                                        j = J[b >> 2];
                                                        e: {
                                                            if (M(N(j)) < M(2147483648)) {
                                                                e = ~~j;
                                                                break e;
                                                            }
                                                            e = -2147483648;
                                                        }
                                                        F[i >> 2] = e;
                                                        b = b + 4 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 9:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        i = (g << 2) + d | 0;
                                                        k = K[b >> 3];
                                                        f: {
                                                            if (N(k) < 2147483648) {
                                                                e = ~~k;
                                                                break f;
                                                            }
                                                            e = -2147483648;
                                                        }
                                                        F[i >> 2] = e;
                                                        b = b + 8 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 10: break d;
                                            default: break b;
                                        }
                                    }
                                    h = 1;
                                    e = D[a + 24 | 0];
                                    if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                        e = F[a >> 2];
                                        f = F[e >> 2];
                                        b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                        b = f + b | 0;
                                        f = F[e + 4 >> 2];
                                        while (1) {
                                            if (b >>> 0 >= f >>> 0) {
                                                break a;
                                            }
                                            F[(g << 2) + d >> 2] = G[b | 0];
                                            b = b + 1 | 0;
                                            g = g + 1 | 0;
                                            e = D[a + 24 | 0];
                                            if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    if ((c | 0) <= (e | 0)) {
                                        break b;
                                    }
                                }
                                ua((e << 2) + d | 0, 0, c - e << 2);
                            }
                            return h;
                        } return 0; }
                        function ec(a, b, c, d) { var e = 0, f = 0, g = 0, h = 0, i = 0, j = M(0), k = 0; a: {
                            b: {
                                if (!d) {
                                    break b;
                                }
                                c: {
                                    d: {
                                        switch (F[a + 28 >> 2] - 1 | 0) {
                                            case 0:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        F[(g << 2) + d >> 2] = D[b | 0];
                                                        b = b + 1 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 1:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        F[(g << 2) + d >> 2] = G[b | 0];
                                                        b = b + 1 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 2:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        F[(g << 2) + d >> 2] = E[b >> 1];
                                                        b = b + 2 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 3:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        F[(g << 2) + d >> 2] = H[b >> 1];
                                                        b = b + 2 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 4:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        F[(g << 2) + d >> 2] = F[b >> 2];
                                                        b = b + 4 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 5:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        F[(g << 2) + d >> 2] = F[b >> 2];
                                                        b = b + 4 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 6:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        e = F[b >> 2];
                                                        if (F[b + 4 >> 2]) {
                                                            break a;
                                                        }
                                                        F[(g << 2) + d >> 2] = e;
                                                        b = b + 8 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 7:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        e = F[b >> 2];
                                                        if (F[b + 4 >> 2]) {
                                                            break a;
                                                        }
                                                        F[(g << 2) + d >> 2] = e;
                                                        b = b + 8 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 8:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        i = (g << 2) + d | 0;
                                                        j = J[b >> 2];
                                                        e: {
                                                            if (j < M(4294967296) & j >= M(0)) {
                                                                e = ~~j >>> 0;
                                                                break e;
                                                            }
                                                            e = 0;
                                                        }
                                                        F[i >> 2] = e;
                                                        b = b + 4 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 9:
                                                h = 1;
                                                e = D[a + 24 | 0];
                                                if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                                    e = F[a >> 2];
                                                    f = F[e >> 2];
                                                    b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                                    b = f + b | 0;
                                                    f = F[e + 4 >> 2];
                                                    while (1) {
                                                        if (b >>> 0 >= f >>> 0) {
                                                            break a;
                                                        }
                                                        i = (g << 2) + d | 0;
                                                        k = K[b >> 3];
                                                        f: {
                                                            if (k < 4294967296 & k >= 0) {
                                                                e = ~~k >>> 0;
                                                                break f;
                                                            }
                                                            e = 0;
                                                        }
                                                        F[i >> 2] = e;
                                                        b = b + 8 | 0;
                                                        g = g + 1 | 0;
                                                        e = D[a + 24 | 0];
                                                        if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if ((c | 0) > (e | 0)) {
                                                    break c;
                                                }
                                                break b;
                                            case 10: break d;
                                            default: break b;
                                        }
                                    }
                                    h = 1;
                                    e = D[a + 24 | 0];
                                    if ((((c | 0) < (e | 0) ? c : e) | 0) > 0) {
                                        e = F[a >> 2];
                                        f = F[e >> 2];
                                        b = F[a + 48 >> 2] + Hj(F[a + 40 >> 2], F[a + 44 >> 2], b, 0) | 0;
                                        b = f + b | 0;
                                        f = F[e + 4 >> 2];
                                        while (1) {
                                            if (b >>> 0 >= f >>> 0) {
                                                break a;
                                            }
                                            F[(g << 2) + d >> 2] = G[b | 0];
                                            b = b + 1 | 0;
                                            g = g + 1 | 0;
                                            e = D[a + 24 | 0];
                                            if ((g | 0) < (((c | 0) < (e | 0) ? c : e) | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    if ((c | 0) <= (e | 0)) {
                                        break b;
                                    }
                                }
                                ua((e << 2) + d | 0, 0, c - e << 2);
                            }
                            return h;
                        } return 0; }
                        function Ui(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0; e = ea - 32 | 0; ea = e; a: {
                            b: {
                                switch (c - 2 | 0) {
                                    case 0:
                                        c = F[a + 4 >> 2];
                                        f = F[a + 12 >> 2];
                                        F[e + 24 >> 2] = -1;
                                        F[e + 16 >> 2] = -1;
                                        F[e + 20 >> 2] = 1065353216;
                                        F[e + 8 >> 2] = -1;
                                        F[e + 12 >> 2] = -1;
                                        if ((b | 0) == -2) {
                                            break a;
                                        }
                                        j = F[F[F[c + 4 >> 2] + 8 >> 2] + (f << 2) >> 2];
                                        if ((ga[F[F[c >> 2] + 8 >> 2]](c) | 0) == 1) {
                                            i = F[F[F[c + 4 >> 2] + 8 >> 2] + (f << 2) >> 2];
                                            c: {
                                                if ((ga[F[F[c >> 2] + 8 >> 2]](c) | 0) != 1 | b - 1 >>> 0 > 5) {
                                                    break c;
                                                }
                                                h = ga[F[F[c >> 2] + 36 >> 2]](c) | 0;
                                                a = ga[F[F[c >> 2] + 44 >> 2]](c, f) | 0;
                                                if (!h | !a) {
                                                    break c;
                                                }
                                                g = a + 12 | 0;
                                                f = ga[F[F[c >> 2] + 40 >> 2]](c, f) | 0;
                                                c = F[c + 44 >> 2];
                                                if (f) {
                                                    if ((b | 0) != 6) {
                                                        break c;
                                                    }
                                                    d = sa(112);
                                                    F[d + 4 >> 2] = i;
                                                    b = F[e + 12 >> 2];
                                                    F[d + 8 >> 2] = F[e + 8 >> 2];
                                                    F[d + 12 >> 2] = b;
                                                    b = F[e + 20 >> 2];
                                                    F[d + 16 >> 2] = F[e + 16 >> 2];
                                                    F[d + 20 >> 2] = b;
                                                    F[d + 24 >> 2] = F[e + 24 >> 2];
                                                    F[d + 40 >> 2] = a;
                                                    F[d + 36 >> 2] = g;
                                                    F[d + 32 >> 2] = f;
                                                    F[d + 28 >> 2] = c;
                                                    F[d + 68 >> 2] = a;
                                                    F[d - -64 >> 2] = g;
                                                    F[d + 60 >> 2] = f;
                                                    F[d + 56 >> 2] = c;
                                                    F[d + 48 >> 2] = 0;
                                                    F[d + 52 >> 2] = 0;
                                                    F[d >> 2] = 7172;
                                                    F[d + 88 >> 2] = 1065353216;
                                                    F[d + 92 >> 2] = -1;
                                                    F[d + 80 >> 2] = -1;
                                                    F[d + 84 >> 2] = -1;
                                                    F[d + 72 >> 2] = 1;
                                                    F[d + 76 >> 2] = -1;
                                                    F[d + 44 >> 2] = 7696;
                                                    a = d + 96 | 0;
                                                    F[a >> 2] = 0;
                                                    F[a + 4 >> 2] = 0;
                                                    D[a + 5 | 0] = 0;
                                                    D[a + 6 | 0] = 0;
                                                    D[a + 7 | 0] = 0;
                                                    D[a + 8 | 0] = 0;
                                                    D[a + 9 | 0] = 0;
                                                    D[a + 10 | 0] = 0;
                                                    D[a + 11 | 0] = 0;
                                                    D[a + 12 | 0] = 0;
                                                    break c;
                                                }
                                                if ((b | 0) != 6) {
                                                    break c;
                                                }
                                                d = sa(112);
                                                F[d + 4 >> 2] = i;
                                                b = F[e + 12 >> 2];
                                                F[d + 8 >> 2] = F[e + 8 >> 2];
                                                F[d + 12 >> 2] = b;
                                                b = F[e + 20 >> 2];
                                                F[d + 16 >> 2] = F[e + 16 >> 2];
                                                F[d + 20 >> 2] = b;
                                                F[d + 24 >> 2] = F[e + 24 >> 2];
                                                F[d + 40 >> 2] = a;
                                                F[d + 36 >> 2] = g;
                                                F[d + 32 >> 2] = h;
                                                F[d + 28 >> 2] = c;
                                                F[d + 68 >> 2] = a;
                                                F[d - -64 >> 2] = g;
                                                F[d + 60 >> 2] = h;
                                                F[d + 56 >> 2] = c;
                                                F[d + 48 >> 2] = 0;
                                                F[d + 52 >> 2] = 0;
                                                F[d >> 2] = 8108;
                                                F[d + 88 >> 2] = 1065353216;
                                                F[d + 92 >> 2] = -1;
                                                F[d + 80 >> 2] = -1;
                                                F[d + 84 >> 2] = -1;
                                                F[d + 72 >> 2] = 1;
                                                F[d + 76 >> 2] = -1;
                                                F[d + 44 >> 2] = 8500;
                                                a = d + 96 | 0;
                                                F[a >> 2] = 0;
                                                F[a + 4 >> 2] = 0;
                                                D[a + 5 | 0] = 0;
                                                D[a + 6 | 0] = 0;
                                                D[a + 7 | 0] = 0;
                                                D[a + 8 | 0] = 0;
                                                D[a + 9 | 0] = 0;
                                                D[a + 10 | 0] = 0;
                                                D[a + 11 | 0] = 0;
                                                D[a + 12 | 0] = 0;
                                            }
                                            if (d) {
                                                break a;
                                            }
                                        }
                                        d = sa(28);
                                        F[d + 4 >> 2] = j;
                                        a = F[e + 12 >> 2];
                                        F[d + 8 >> 2] = F[e + 8 >> 2];
                                        F[d + 12 >> 2] = a;
                                        a = F[e + 20 >> 2];
                                        F[d + 16 >> 2] = F[e + 16 >> 2];
                                        F[d + 20 >> 2] = a;
                                        F[d + 24 >> 2] = F[e + 24 >> 2];
                                        F[d >> 2] = 8888;
                                        break a;
                                    case 1: break b;
                                    default: break a;
                                }
                            }
                            c = F[a + 4 >> 2];
                            f = F[a + 12 >> 2];
                            F[e + 24 >> 2] = -1;
                            F[e + 16 >> 2] = -1;
                            F[e + 20 >> 2] = 1065353216;
                            F[e + 8 >> 2] = -1;
                            F[e + 12 >> 2] = -1;
                            if ((b | 0) == -2) {
                                break a;
                            }
                            j = F[F[F[c + 4 >> 2] + 8 >> 2] + (f << 2) >> 2];
                            if ((ga[F[F[c >> 2] + 8 >> 2]](c) | 0) == 1) {
                                i = F[F[F[c + 4 >> 2] + 8 >> 2] + (f << 2) >> 2];
                                d: {
                                    if ((ga[F[F[c >> 2] + 8 >> 2]](c) | 0) != 1 | b - 1 >>> 0 > 5) {
                                        break d;
                                    }
                                    h = ga[F[F[c >> 2] + 36 >> 2]](c) | 0;
                                    a = ga[F[F[c >> 2] + 44 >> 2]](c, f) | 0;
                                    if (!h | !a) {
                                        break d;
                                    }
                                    g = a + 12 | 0;
                                    f = ga[F[F[c >> 2] + 40 >> 2]](c, f) | 0;
                                    c = F[c + 44 >> 2];
                                    if (f) {
                                        if ((b | 0) != 6) {
                                            break d;
                                        }
                                        d = sa(112);
                                        F[d + 4 >> 2] = i;
                                        b = F[e + 12 >> 2];
                                        F[d + 8 >> 2] = F[e + 8 >> 2];
                                        F[d + 12 >> 2] = b;
                                        b = F[e + 20 >> 2];
                                        F[d + 16 >> 2] = F[e + 16 >> 2];
                                        F[d + 20 >> 2] = b;
                                        F[d + 24 >> 2] = F[e + 24 >> 2];
                                        F[d + 40 >> 2] = a;
                                        F[d + 36 >> 2] = g;
                                        F[d + 32 >> 2] = f;
                                        F[d + 28 >> 2] = c;
                                        F[d + 68 >> 2] = a;
                                        F[d - -64 >> 2] = g;
                                        F[d + 60 >> 2] = f;
                                        F[d + 56 >> 2] = c;
                                        F[d + 48 >> 2] = 0;
                                        F[d + 52 >> 2] = 0;
                                        F[d >> 2] = 9056;
                                        F[d + 88 >> 2] = 1065353216;
                                        F[d + 92 >> 2] = -1;
                                        F[d + 80 >> 2] = -1;
                                        F[d + 84 >> 2] = -1;
                                        F[d + 72 >> 2] = 1;
                                        F[d + 76 >> 2] = -1;
                                        F[d + 44 >> 2] = 9620;
                                        a = d + 96 | 0;
                                        F[a >> 2] = 0;
                                        F[a + 4 >> 2] = 0;
                                        D[a + 5 | 0] = 0;
                                        D[a + 6 | 0] = 0;
                                        D[a + 7 | 0] = 0;
                                        D[a + 8 | 0] = 0;
                                        D[a + 9 | 0] = 0;
                                        D[a + 10 | 0] = 0;
                                        D[a + 11 | 0] = 0;
                                        D[a + 12 | 0] = 0;
                                        break d;
                                    }
                                    if ((b | 0) != 6) {
                                        break d;
                                    }
                                    d = sa(112);
                                    F[d + 4 >> 2] = i;
                                    b = F[e + 12 >> 2];
                                    F[d + 8 >> 2] = F[e + 8 >> 2];
                                    F[d + 12 >> 2] = b;
                                    b = F[e + 20 >> 2];
                                    F[d + 16 >> 2] = F[e + 16 >> 2];
                                    F[d + 20 >> 2] = b;
                                    F[d + 24 >> 2] = F[e + 24 >> 2];
                                    F[d + 40 >> 2] = a;
                                    F[d + 36 >> 2] = g;
                                    F[d + 32 >> 2] = h;
                                    F[d + 28 >> 2] = c;
                                    F[d + 68 >> 2] = a;
                                    F[d - -64 >> 2] = g;
                                    F[d + 60 >> 2] = h;
                                    F[d + 56 >> 2] = c;
                                    F[d + 48 >> 2] = 0;
                                    F[d + 52 >> 2] = 0;
                                    F[d >> 2] = 10060;
                                    F[d + 88 >> 2] = 1065353216;
                                    F[d + 92 >> 2] = -1;
                                    F[d + 80 >> 2] = -1;
                                    F[d + 84 >> 2] = -1;
                                    F[d + 72 >> 2] = 1;
                                    F[d + 76 >> 2] = -1;
                                    F[d + 44 >> 2] = 10480;
                                    a = d + 96 | 0;
                                    F[a >> 2] = 0;
                                    F[a + 4 >> 2] = 0;
                                    D[a + 5 | 0] = 0;
                                    D[a + 6 | 0] = 0;
                                    D[a + 7 | 0] = 0;
                                    D[a + 8 | 0] = 0;
                                    D[a + 9 | 0] = 0;
                                    D[a + 10 | 0] = 0;
                                    D[a + 11 | 0] = 0;
                                    D[a + 12 | 0] = 0;
                                }
                                if (d) {
                                    break a;
                                }
                            }
                            d = sa(28);
                            F[d + 4 >> 2] = j;
                            a = F[e + 12 >> 2];
                            F[d + 8 >> 2] = F[e + 8 >> 2];
                            F[d + 12 >> 2] = a;
                            a = F[e + 20 >> 2];
                            F[d + 16 >> 2] = F[e + 16 >> 2];
                            F[d + 20 >> 2] = a;
                            F[d + 24 >> 2] = F[e + 24 >> 2];
                            F[d >> 2] = 10892;
                        } ea = e + 32 | 0; return d | 0; }
                        function uj(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; var g = 0, h = 0, i = M(0), j = M(0), k = 0, l = 0, m = 0, n = M(0), o = M(0), p = M(0), q = M(0), r = 0, s = M(0), t = M(0), u = M(0), v = M(0), w = M(0), x = M(0), y = M(0), z = M(0), A = M(0), B = 0, C = M(0); F[a + 64 >> 2] = f; F[a + 72 >> 2] = e; f = sa((e & 1073741823) != (e | 0) ? -1 : e << 2); d = F[a + 68 >> 2]; F[a + 68 >> 2] = f; if (d) {
                            ra(d);
                        } F[a + 8 >> 2] = e; f = a + 32 | 0; g = F[f >> 2]; d = F[a + 36 >> 2] - g >> 2; a: {
                            if (d >>> 0 < e >>> 0) {
                                Aa(f, e - d | 0);
                                break a;
                            }
                            if (d >>> 0 <= e >>> 0) {
                                break a;
                            }
                            F[a + 36 >> 2] = g + (e << 2);
                        } b: {
                            d = F[a + 56 >> 2];
                            g = F[d + 4 >> 2];
                            f = F[d >> 2];
                            d = g - f | 0;
                            if ((d | 0) <= 0) {
                                break b;
                            }
                            if ((f | 0) != (g | 0)) {
                                d = d >>> 2 | 0;
                                B = d >>> 0 > 1 ? d : 1;
                                while (1) {
                                    h = F[(m << 2) + f >> 2];
                                    j = M(0);
                                    g = ea - 48 | 0;
                                    ea = g;
                                    f = -1;
                                    d = -1;
                                    c: {
                                        if ((h | 0) == -1) {
                                            break c;
                                        }
                                        d = h + 1 | 0;
                                        f = (d >>> 0) % 3 | 0 ? d : h - 2 | 0;
                                        d = h - 1 | 0;
                                        if ((h >>> 0) % 3 | 0) {
                                            break c;
                                        }
                                        d = h + 2 | 0;
                                    }
                                    k = F[a + 52 >> 2];
                                    h = F[k >> 2];
                                    d: {
                                        e: {
                                            k = F[k + 4 >> 2] - h >> 2;
                                            l = f << 2;
                                            f = F[F[a + 48 >> 2] + 28 >> 2];
                                            l = F[l + f >> 2];
                                            if (k >>> 0 <= l >>> 0) {
                                                break e;
                                            }
                                            f = F[f + (d << 2) >> 2];
                                            if (f >>> 0 >= k >>> 0) {
                                                break e;
                                            }
                                            k = F[h + (f << 2) >> 2];
                                            d = F[h + (l << 2) >> 2];
                                            f: {
                                                if (!((k | 0) >= (m | 0) | (d | 0) >= (m | 0))) {
                                                    f = F[a + 72 >> 2];
                                                    h = (L(f, k) << 2) + c | 0;
                                                    n = M(F[h + 4 >> 2]);
                                                    f = (L(d, f) << 2) + c | 0;
                                                    q = M(F[f + 4 >> 2]);
                                                    s = M(F[h >> 2]);
                                                    x = M(F[f >> 2]);
                                                    if (!(s != x | n != q)) {
                                                        d = F[a + 68 >> 2];
                                                        if (M(N(n)) < M(2147483648)) {
                                                            f = ~~n;
                                                        }
                                                        else {
                                                            f = -2147483648;
                                                        }
                                                        F[d + 4 >> 2] = f;
                                                        if (M(N(s)) < M(2147483648)) {
                                                            F[d >> 2] = ~~s;
                                                            break f;
                                                        }
                                                        F[d >> 2] = -2147483648;
                                                        break f;
                                                    }
                                                    f = F[F[a + 64 >> 2] + (m << 2) >> 2];
                                                    F[g + 40 >> 2] = 0;
                                                    F[g + 32 >> 2] = 0;
                                                    F[g + 36 >> 2] = 0;
                                                    h = F[a + 60 >> 2];
                                                    if (!G[h + 84 | 0]) {
                                                        f = F[F[h + 68 >> 2] + (f << 2) >> 2];
                                                    }
                                                    Ya(h, f, D[h + 24 | 0], g + 32 | 0);
                                                    f = F[F[a + 64 >> 2] + (d << 2) >> 2];
                                                    F[g + 24 >> 2] = 0;
                                                    F[g + 16 >> 2] = 0;
                                                    F[g + 20 >> 2] = 0;
                                                    d = F[a + 60 >> 2];
                                                    if (!G[d + 84 | 0]) {
                                                        f = F[F[d + 68 >> 2] + (f << 2) >> 2];
                                                    }
                                                    Ya(d, f, D[d + 24 | 0], g + 16 | 0);
                                                    f = F[F[a + 64 >> 2] + (k << 2) >> 2];
                                                    F[g + 8 >> 2] = 0;
                                                    F[g >> 2] = 0;
                                                    F[g + 4 >> 2] = 0;
                                                    d = F[a + 60 >> 2];
                                                    if (!G[d + 84 | 0]) {
                                                        f = F[F[d + 68 >> 2] + (f << 2) >> 2];
                                                    }
                                                    Ya(d, f, D[d + 24 | 0], g);
                                                    t = J[g + 40 >> 2];
                                                    u = J[g + 36 >> 2];
                                                    C = J[g + 32 >> 2];
                                                    o = J[g + 24 >> 2];
                                                    i = M(J[g + 8 >> 2] - o);
                                                    z = J[g + 20 >> 2];
                                                    v = M(J[g + 4 >> 2] - z);
                                                    A = J[g + 16 >> 2];
                                                    w = M(J[g >> 2] - A);
                                                    y = M(M(i * i) + M(M(v * v) + M(M(w * w) + M(0))));
                                                    g: {
                                                        if (!(y > M(0))) {
                                                            p = M(0);
                                                            if (F[a + 88 >> 2] > 257) {
                                                                break g;
                                                            }
                                                        }
                                                        o = M(t - o);
                                                        t = M(u - z);
                                                        u = M(C - A);
                                                        j = M(M(M(i * o) + M(M(v * t) + M(M(w * u) + M(0)))) / y);
                                                        i = M(o - M(i * j));
                                                        o = M(i * i);
                                                        i = M(t - M(v * j));
                                                        p = M(i * i);
                                                        i = M(u - M(w * j));
                                                        p = M(U(M(M(o + M(p + M(M(i * i) + M(0)))) / y)));
                                                    }
                                                    o = p;
                                                    d = F[a + 80 >> 2] - 1 | 0;
                                                    f = F[F[a + 76 >> 2] + (d >>> 3 & 536870908) >> 2];
                                                    F[a + 80 >> 2] = d;
                                                    i = M(n - q);
                                                    p = M(M(i * j) + q);
                                                    q = M(s - x);
                                                    n = M(q * o);
                                                    d = f >>> d & 1;
                                                    n = M(p + (d ? n : M(-n)));
                                                    p = M(M(q * j) + x);
                                                    j = M(i * o);
                                                    j = M(p + (d ? M(-j) : j));
                                                    h: {
                                                        if (j != j) {
                                                            f = F[a + 68 >> 2];
                                                            F[f >> 2] = -2147483648;
                                                            break h;
                                                        }
                                                        f = F[a + 68 >> 2];
                                                        r = R(+j + .5);
                                                        i: {
                                                            if (N(r) < 2147483648) {
                                                                d = ~~r;
                                                                break i;
                                                            }
                                                            d = -2147483648;
                                                        }
                                                        F[f >> 2] = d;
                                                    }
                                                    r = R(+n + .5);
                                                    j: {
                                                        if (N(r) < 2147483648) {
                                                            d = ~~r;
                                                            break j;
                                                        }
                                                        d = -2147483648;
                                                    }
                                                    F[f + 4 >> 2] = n != n ? -2147483648 : d;
                                                    break f;
                                                }
                                                k: {
                                                    if ((d | 0) < (m | 0)) {
                                                        f = F[a + 72 >> 2];
                                                        d = L(d, f);
                                                        break k;
                                                    }
                                                    f = 0;
                                                    if ((m | 0) <= 0) {
                                                        if (F[a + 72 >> 2] <= 0) {
                                                            break f;
                                                        }
                                                        d = F[a + 68 >> 2];
                                                        while (1) {
                                                            F[d + (f << 2) >> 2] = 0;
                                                            f = f + 1 | 0;
                                                            if ((f | 0) < F[a + 72 >> 2]) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        break f;
                                                    }
                                                    f = F[a + 72 >> 2];
                                                    d = L(f, m - 1 | 0);
                                                }
                                                if ((f | 0) <= 0) {
                                                    break f;
                                                }
                                                h = F[a + 68 >> 2];
                                                f = 0;
                                                while (1) {
                                                    F[h + (f << 2) >> 2] = F[(d + f << 2) + c >> 2];
                                                    f = f + 1 | 0;
                                                    if ((f | 0) < F[a + 72 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            ea = g + 48 | 0;
                                            break d;
                                        }
                                        Da();
                                        V();
                                    }
                                    l: {
                                        if (F[a + 8 >> 2] <= 0) {
                                            break l;
                                        }
                                        h = F[a + 32 >> 2];
                                        k = F[a + 68 >> 2];
                                        f = 0;
                                        while (1) {
                                            d = f << 2;
                                            g = F[d + k >> 2];
                                            l = F[a + 16 >> 2];
                                            m: {
                                                if ((g | 0) > (l | 0)) {
                                                    F[d + h >> 2] = l;
                                                    break m;
                                                }
                                                d = d + h | 0;
                                                l = F[a + 12 >> 2];
                                                if ((l | 0) > (g | 0)) {
                                                    F[d >> 2] = l;
                                                    break m;
                                                }
                                                F[d >> 2] = g;
                                            }
                                            f = f + 1 | 0;
                                            g = F[a + 8 >> 2];
                                            if ((f | 0) < (g | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                        d = 0;
                                        if ((g | 0) <= 0) {
                                            break l;
                                        }
                                        f = L(e, m) << 2;
                                        k = f + c | 0;
                                        l = b + f | 0;
                                        while (1) {
                                            g = d << 2;
                                            f = g + k | 0;
                                            g = F[g + l >> 2] + F[g + h >> 2] | 0;
                                            F[f >> 2] = g;
                                            n: {
                                                if ((g | 0) > F[a + 16 >> 2]) {
                                                    g = g - F[a + 20 >> 2] | 0;
                                                }
                                                else {
                                                    if ((g | 0) >= F[a + 12 >> 2]) {
                                                        break n;
                                                    }
                                                    g = g + F[a + 20 >> 2] | 0;
                                                }
                                                F[f >> 2] = g;
                                            }
                                            d = d + 1 | 0;
                                            if ((d | 0) < F[a + 8 >> 2]) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    m = m + 1 | 0;
                                    if ((B | 0) == (m | 0)) {
                                        break b;
                                    }
                                    d = F[a + 56 >> 2];
                                    f = F[d >> 2];
                                    if (F[d + 4 >> 2] - f >> 2 >>> 0 > m >>> 0) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            Da();
                            V();
                        } return 1; }
                        function ej(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; var g = 0, h = 0, i = M(0), j = 0, k = M(0), l = 0, m = M(0), n = M(0), o = M(0), p = 0, q = M(0), r = 0, s = M(0), t = M(0), u = M(0), v = M(0), w = M(0), x = M(0), y = M(0), z = M(0), A = M(0), B = 0, C = M(0); F[a + 64 >> 2] = f; F[a + 72 >> 2] = e; f = sa((e & 1073741823) != (e | 0) ? -1 : e << 2); d = F[a + 68 >> 2]; F[a + 68 >> 2] = f; if (d) {
                            ra(d);
                        } F[a + 8 >> 2] = e; f = a + 32 | 0; g = F[f >> 2]; d = F[a + 36 >> 2] - g >> 2; a: {
                            if (d >>> 0 < e >>> 0) {
                                Aa(f, e - d | 0);
                                break a;
                            }
                            if (d >>> 0 <= e >>> 0) {
                                break a;
                            }
                            F[a + 36 >> 2] = g + (e << 2);
                        } b: {
                            d = F[a + 56 >> 2];
                            g = F[d + 4 >> 2];
                            f = F[d >> 2];
                            d = g - f | 0;
                            if ((d | 0) <= 0) {
                                break b;
                            }
                            if ((f | 0) != (g | 0)) {
                                d = d >>> 2 | 0;
                                B = d >>> 0 > 1 ? d : 1;
                                while (1) {
                                    k = M(0);
                                    g = ea - 48 | 0;
                                    ea = g;
                                    h = -1;
                                    c: {
                                        d: {
                                            d = F[(l << 2) + f >> 2];
                                            if ((d | 0) == -1) {
                                                break d;
                                            }
                                            j = F[a + 48 >> 2];
                                            f = d + 1 | 0;
                                            f = (f >>> 0) % 3 | 0 ? f : d - 2 | 0;
                                            if ((f | 0) != -1) {
                                                h = F[F[j >> 2] + (f << 2) >> 2];
                                            }
                                            f = -1;
                                            d = d + ((d >>> 0) % 3 | 0 ? -1 : 2) | 0;
                                            if ((d | 0) != -1) {
                                                f = F[F[j >> 2] + (d << 2) >> 2];
                                            }
                                            d = F[a + 52 >> 2];
                                            j = F[d >> 2];
                                            d = F[d + 4 >> 2] - j >> 2;
                                            if (d >>> 0 <= h >>> 0 | d >>> 0 <= f >>> 0) {
                                                break d;
                                            }
                                            d = F[j + (h << 2) >> 2];
                                            j = F[j + (f << 2) >> 2];
                                            e: {
                                                if (!((j | 0) >= (l | 0) | (d | 0) >= (l | 0))) {
                                                    f = F[a + 72 >> 2];
                                                    h = (L(f, j) << 2) + c | 0;
                                                    m = M(F[h + 4 >> 2]);
                                                    f = (L(d, f) << 2) + c | 0;
                                                    q = M(F[f + 4 >> 2]);
                                                    s = M(F[h >> 2]);
                                                    x = M(F[f >> 2]);
                                                    if (!(s != x | m != q)) {
                                                        d = F[a + 68 >> 2];
                                                        if (M(N(m)) < M(2147483648)) {
                                                            f = ~~m;
                                                        }
                                                        else {
                                                            f = -2147483648;
                                                        }
                                                        F[d + 4 >> 2] = f;
                                                        if (M(N(s)) < M(2147483648)) {
                                                            F[d >> 2] = ~~s;
                                                            break e;
                                                        }
                                                        F[d >> 2] = -2147483648;
                                                        break e;
                                                    }
                                                    f = F[F[a + 64 >> 2] + (l << 2) >> 2];
                                                    F[g + 40 >> 2] = 0;
                                                    F[g + 32 >> 2] = 0;
                                                    F[g + 36 >> 2] = 0;
                                                    h = F[a + 60 >> 2];
                                                    if (!G[h + 84 | 0]) {
                                                        f = F[F[h + 68 >> 2] + (f << 2) >> 2];
                                                    }
                                                    Ya(h, f, D[h + 24 | 0], g + 32 | 0);
                                                    f = F[F[a + 64 >> 2] + (d << 2) >> 2];
                                                    F[g + 24 >> 2] = 0;
                                                    F[g + 16 >> 2] = 0;
                                                    F[g + 20 >> 2] = 0;
                                                    d = F[a + 60 >> 2];
                                                    if (!G[d + 84 | 0]) {
                                                        f = F[F[d + 68 >> 2] + (f << 2) >> 2];
                                                    }
                                                    Ya(d, f, D[d + 24 | 0], g + 16 | 0);
                                                    f = F[F[a + 64 >> 2] + (j << 2) >> 2];
                                                    F[g + 8 >> 2] = 0;
                                                    F[g >> 2] = 0;
                                                    F[g + 4 >> 2] = 0;
                                                    d = F[a + 60 >> 2];
                                                    if (!G[d + 84 | 0]) {
                                                        f = F[F[d + 68 >> 2] + (f << 2) >> 2];
                                                    }
                                                    Ya(d, f, D[d + 24 | 0], g);
                                                    t = J[g + 40 >> 2];
                                                    u = J[g + 36 >> 2];
                                                    C = J[g + 32 >> 2];
                                                    n = J[g + 24 >> 2];
                                                    i = M(J[g + 8 >> 2] - n);
                                                    z = J[g + 20 >> 2];
                                                    v = M(J[g + 4 >> 2] - z);
                                                    A = J[g + 16 >> 2];
                                                    w = M(J[g >> 2] - A);
                                                    y = M(M(i * i) + M(M(v * v) + M(M(w * w) + M(0))));
                                                    f: {
                                                        if (!(y > M(0))) {
                                                            o = M(0);
                                                            if (F[a + 88 >> 2] > 257) {
                                                                break f;
                                                            }
                                                        }
                                                        n = M(t - n);
                                                        t = M(u - z);
                                                        u = M(C - A);
                                                        k = M(M(M(i * n) + M(M(v * t) + M(M(w * u) + M(0)))) / y);
                                                        i = M(n - M(i * k));
                                                        n = M(i * i);
                                                        i = M(t - M(v * k));
                                                        o = M(i * i);
                                                        i = M(u - M(w * k));
                                                        o = M(U(M(M(n + M(o + M(M(i * i) + M(0)))) / y)));
                                                    }
                                                    n = o;
                                                    d = F[a + 80 >> 2] - 1 | 0;
                                                    f = F[F[a + 76 >> 2] + (d >>> 3 & 536870908) >> 2];
                                                    F[a + 80 >> 2] = d;
                                                    i = M(m - q);
                                                    o = M(M(i * k) + q);
                                                    q = M(s - x);
                                                    m = M(q * n);
                                                    d = f >>> d & 1;
                                                    m = M(o + (d ? m : M(-m)));
                                                    o = M(M(q * k) + x);
                                                    k = M(i * n);
                                                    k = M(o + (d ? M(-k) : k));
                                                    g: {
                                                        if (k != k) {
                                                            f = F[a + 68 >> 2];
                                                            F[f >> 2] = -2147483648;
                                                            break g;
                                                        }
                                                        f = F[a + 68 >> 2];
                                                        r = R(+k + .5);
                                                        h: {
                                                            if (N(r) < 2147483648) {
                                                                d = ~~r;
                                                                break h;
                                                            }
                                                            d = -2147483648;
                                                        }
                                                        F[f >> 2] = d;
                                                    }
                                                    r = R(+m + .5);
                                                    i: {
                                                        if (N(r) < 2147483648) {
                                                            d = ~~r;
                                                            break i;
                                                        }
                                                        d = -2147483648;
                                                    }
                                                    F[f + 4 >> 2] = m != m ? -2147483648 : d;
                                                    break e;
                                                }
                                                j: {
                                                    if ((d | 0) < (l | 0)) {
                                                        f = F[a + 72 >> 2];
                                                        d = L(d, f);
                                                        break j;
                                                    }
                                                    f = 0;
                                                    if ((l | 0) <= 0) {
                                                        if (F[a + 72 >> 2] <= 0) {
                                                            break e;
                                                        }
                                                        d = F[a + 68 >> 2];
                                                        while (1) {
                                                            F[d + (f << 2) >> 2] = 0;
                                                            f = f + 1 | 0;
                                                            if ((f | 0) < F[a + 72 >> 2]) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        break e;
                                                    }
                                                    f = F[a + 72 >> 2];
                                                    d = L(f, l - 1 | 0);
                                                }
                                                if ((f | 0) <= 0) {
                                                    break e;
                                                }
                                                h = F[a + 68 >> 2];
                                                f = 0;
                                                while (1) {
                                                    F[h + (f << 2) >> 2] = F[(d + f << 2) + c >> 2];
                                                    f = f + 1 | 0;
                                                    if ((f | 0) < F[a + 72 >> 2]) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            ea = g + 48 | 0;
                                            break c;
                                        }
                                        Da();
                                        V();
                                    }
                                    k: {
                                        if (F[a + 8 >> 2] <= 0) {
                                            break k;
                                        }
                                        h = F[a + 32 >> 2];
                                        j = F[a + 68 >> 2];
                                        f = 0;
                                        while (1) {
                                            d = f << 2;
                                            g = F[d + j >> 2];
                                            p = F[a + 16 >> 2];
                                            l: {
                                                if ((g | 0) > (p | 0)) {
                                                    F[d + h >> 2] = p;
                                                    break l;
                                                }
                                                d = d + h | 0;
                                                p = F[a + 12 >> 2];
                                                if ((p | 0) > (g | 0)) {
                                                    F[d >> 2] = p;
                                                    break l;
                                                }
                                                F[d >> 2] = g;
                                            }
                                            f = f + 1 | 0;
                                            g = F[a + 8 >> 2];
                                            if ((f | 0) < (g | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                        d = 0;
                                        if ((g | 0) <= 0) {
                                            break k;
                                        }
                                        f = L(e, l) << 2;
                                        j = f + c | 0;
                                        p = b + f | 0;
                                        while (1) {
                                            g = d << 2;
                                            f = g + j | 0;
                                            g = F[g + p >> 2] + F[g + h >> 2] | 0;
                                            F[f >> 2] = g;
                                            m: {
                                                if ((g | 0) > F[a + 16 >> 2]) {
                                                    g = g - F[a + 20 >> 2] | 0;
                                                }
                                                else {
                                                    if ((g | 0) >= F[a + 12 >> 2]) {
                                                        break m;
                                                    }
                                                    g = g + F[a + 20 >> 2] | 0;
                                                }
                                                F[f >> 2] = g;
                                            }
                                            d = d + 1 | 0;
                                            if ((d | 0) < F[a + 8 >> 2]) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    l = l + 1 | 0;
                                    if ((B | 0) == (l | 0)) {
                                        break b;
                                    }
                                    d = F[a + 56 >> 2];
                                    f = F[d >> 2];
                                    if (F[d + 4 >> 2] - f >> 2 >>> 0 > l >>> 0) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            Da();
                            V();
                        } return 1; }
                        function Ki(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; var e = M(0), f = 0, g = 0, h = 0, i = 0, j = 0, k = M(0), l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0; if (F[c >> 2] == F[c + 4 >> 2]) {
                            g = F[d + 80 >> 2];
                            v = ea - 16 | 0;
                            ea = v;
                            j = F[a + 4 >> 2];
                            h = F[d + 48 >> 2];
                            d = F[F[d >> 2] >> 2];
                            i = D[b + 24 | 0];
                            c = v + 8 | 0;
                            F[c >> 2] = 1065353216;
                            u = c;
                            J[c >> 2] = M(-1 << j ^ -1) / J[a + 20 >> 2];
                            w = sa((i | 0) != (i & 1073741823) ? -1 : i << 2);
                            a: {
                                if (!g | (i | 0) <= 0) {
                                    break a;
                                }
                                s = d + h | 0;
                                y = F[b >> 2];
                                c = F[b + 48 >> 2];
                                z = F[b + 44 >> 2];
                                x = F[b + 40 >> 2];
                                if (!G[b + 84 | 0]) {
                                    n = F[b + 68 >> 2];
                                    t = i & -2;
                                    j = i & 1;
                                    b = 0;
                                    while (1) {
                                        f = F[y >> 2];
                                        d = Hj(x, z, F[n + (o << 2) >> 2], 0) + c | 0;
                                        p = ta(w, f + d | 0, x);
                                        k = J[u >> 2];
                                        l = F[a + 8 >> 2];
                                        d = 0;
                                        m = 0;
                                        if ((i | 0) != 1) {
                                            while (1) {
                                                f = s + (b << 2) | 0;
                                                q = d << 2;
                                                e = M(R(M(M(k * M(J[q + p >> 2] - J[l + q >> 2])) + M(.5))));
                                                b: {
                                                    if (M(N(e)) < M(2147483648)) {
                                                        h = ~~e;
                                                        break b;
                                                    }
                                                    h = -2147483648;
                                                }
                                                F[f >> 2] = h;
                                                h = q | 4;
                                                e = M(R(M(M(k * M(J[h + p >> 2] - J[l + h >> 2])) + M(.5))));
                                                c: {
                                                    if (M(N(e)) < M(2147483648)) {
                                                        h = ~~e;
                                                        break c;
                                                    }
                                                    h = -2147483648;
                                                }
                                                F[f + 4 >> 2] = h;
                                                d = d + 2 | 0;
                                                b = b + 2 | 0;
                                                m = m + 2 | 0;
                                                if ((t | 0) != (m | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        if (j) {
                                            f = s + (b << 2) | 0;
                                            d = d << 2;
                                            e = M(R(M(M(k * M(J[d + p >> 2] - J[d + l >> 2])) + M(.5))));
                                            d: {
                                                if (M(N(e)) < M(2147483648)) {
                                                    d = ~~e;
                                                    break d;
                                                }
                                                d = -2147483648;
                                            }
                                            F[f >> 2] = d;
                                            b = b + 1 | 0;
                                        }
                                        o = o + 1 | 0;
                                        if ((g | 0) != (o | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                    break a;
                                }
                                n = i & -2;
                                t = i & 1;
                                b = 0;
                                while (1) {
                                    h = F[y >> 2];
                                    d = Hj(x, z, o, f) + c | 0;
                                    p = ta(w, h + d | 0, x);
                                    k = J[u >> 2];
                                    l = F[a + 8 >> 2];
                                    d = 0;
                                    m = 0;
                                    if ((i | 0) != 1) {
                                        while (1) {
                                            h = s + (b << 2) | 0;
                                            q = d << 2;
                                            e = M(R(M(M(k * M(J[q + p >> 2] - J[l + q >> 2])) + M(.5))));
                                            e: {
                                                if (M(N(e)) < M(2147483648)) {
                                                    j = ~~e;
                                                    break e;
                                                }
                                                j = -2147483648;
                                            }
                                            F[h >> 2] = j;
                                            j = q | 4;
                                            e = M(R(M(M(k * M(J[j + p >> 2] - J[l + j >> 2])) + M(.5))));
                                            f: {
                                                if (M(N(e)) < M(2147483648)) {
                                                    j = ~~e;
                                                    break f;
                                                }
                                                j = -2147483648;
                                            }
                                            F[h + 4 >> 2] = j;
                                            d = d + 2 | 0;
                                            b = b + 2 | 0;
                                            m = m + 2 | 0;
                                            if ((n | 0) != (m | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    if (t) {
                                        h = s + (b << 2) | 0;
                                        d = d << 2;
                                        e = M(R(M(M(k * M(J[d + p >> 2] - J[d + l >> 2])) + M(.5))));
                                        g: {
                                            if (M(N(e)) < M(2147483648)) {
                                                d = ~~e;
                                                break g;
                                            }
                                            d = -2147483648;
                                        }
                                        F[h >> 2] = d;
                                        b = b + 1 | 0;
                                    }
                                    d = o + 1 | 0;
                                    f = d ? f : f + 1 | 0;
                                    o = d;
                                    if ((g | 0) != (d | 0) | f) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            ra(w);
                            ea = v + 16 | 0;
                            return 1;
                        } v = ea - 16 | 0; ea = v; u = F[a + 4 >> 2]; g = F[d + 48 >> 2]; f = F[F[d >> 2] >> 2]; r = D[b + 24 | 0]; d = v + 8 | 0; F[d >> 2] = 1065353216; h = d; J[d >> 2] = M(-1 << u ^ -1) / J[a + 20 >> 2]; w = sa((r | 0) != (r & 1073741823) ? -1 : r << 2); y = F[c >> 2]; c = F[c + 4 >> 2] - y | 0; h: {
                            if (!c | (r | 0) <= 0) {
                                break h;
                            }
                            s = f + g | 0;
                            z = F[b >> 2];
                            d = F[b + 48 >> 2];
                            x = F[b + 44 >> 2];
                            o = F[b + 40 >> 2];
                            c = c >> 2;
                            q = c >>> 0 > 1 ? c : 1;
                            if (G[b + 84 | 0]) {
                                j = r & -2;
                                u = r & 1;
                                b = 0;
                                while (1) {
                                    f = F[z >> 2];
                                    c = Hj(o, x, F[y + (m << 2) >> 2], 0) + d | 0;
                                    l = ta(w, f + c | 0, o);
                                    k = J[h >> 2];
                                    n = F[a + 8 >> 2];
                                    c = 0;
                                    i = 0;
                                    if ((r | 0) != 1) {
                                        while (1) {
                                            f = s + (b << 2) | 0;
                                            t = c << 2;
                                            e = M(R(M(M(k * M(J[t + l >> 2] - J[n + t >> 2])) + M(.5))));
                                            i: {
                                                if (M(N(e)) < M(2147483648)) {
                                                    g = ~~e;
                                                    break i;
                                                }
                                                g = -2147483648;
                                            }
                                            F[f >> 2] = g;
                                            g = t | 4;
                                            e = M(R(M(M(k * M(J[g + l >> 2] - J[n + g >> 2])) + M(.5))));
                                            j: {
                                                if (M(N(e)) < M(2147483648)) {
                                                    g = ~~e;
                                                    break j;
                                                }
                                                g = -2147483648;
                                            }
                                            F[f + 4 >> 2] = g;
                                            c = c + 2 | 0;
                                            b = b + 2 | 0;
                                            i = i + 2 | 0;
                                            if ((j | 0) != (i | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    if (u) {
                                        f = s + (b << 2) | 0;
                                        c = c << 2;
                                        e = M(R(M(M(k * M(J[c + l >> 2] - J[c + n >> 2])) + M(.5))));
                                        k: {
                                            if (M(N(e)) < M(2147483648)) {
                                                c = ~~e;
                                                break k;
                                            }
                                            c = -2147483648;
                                        }
                                        F[f >> 2] = c;
                                        b = b + 1 | 0;
                                    }
                                    m = m + 1 | 0;
                                    if ((q | 0) != (m | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                break h;
                            }
                            t = F[b + 68 >> 2];
                            j = r & -2;
                            u = r & 1;
                            b = 0;
                            while (1) {
                                f = F[z >> 2];
                                c = Hj(o, x, F[t + (F[y + (m << 2) >> 2] << 2) >> 2], 0) + d | 0;
                                p = ta(w, f + c | 0, o);
                                k = J[h >> 2];
                                l = F[a + 8 >> 2];
                                c = 0;
                                i = 0;
                                if ((r | 0) != 1) {
                                    while (1) {
                                        f = s + (b << 2) | 0;
                                        n = c << 2;
                                        e = M(R(M(M(k * M(J[n + p >> 2] - J[l + n >> 2])) + M(.5))));
                                        l: {
                                            if (M(N(e)) < M(2147483648)) {
                                                g = ~~e;
                                                break l;
                                            }
                                            g = -2147483648;
                                        }
                                        F[f >> 2] = g;
                                        g = n | 4;
                                        e = M(R(M(M(k * M(J[g + p >> 2] - J[l + g >> 2])) + M(.5))));
                                        m: {
                                            if (M(N(e)) < M(2147483648)) {
                                                g = ~~e;
                                                break m;
                                            }
                                            g = -2147483648;
                                        }
                                        F[f + 4 >> 2] = g;
                                        c = c + 2 | 0;
                                        b = b + 2 | 0;
                                        i = i + 2 | 0;
                                        if ((j | 0) != (i | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                if (u) {
                                    f = s + (b << 2) | 0;
                                    c = c << 2;
                                    e = M(R(M(M(k * M(J[c + p >> 2] - J[c + l >> 2])) + M(.5))));
                                    n: {
                                        if (M(N(e)) < M(2147483648)) {
                                            c = ~~e;
                                            break n;
                                        }
                                        c = -2147483648;
                                    }
                                    F[f >> 2] = c;
                                    b = b + 1 | 0;
                                }
                                m = m + 1 | 0;
                                if ((q | 0) != (m | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } ra(w); ea = v + 16 | 0; return 1; }
                        function Jf(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0; f = ea - 704 | 0; ea = f; m = 1; a: {
                            b: {
                                c: {
                                    d: {
                                        if (H[b + 38 >> 1] < 515) {
                                            break d;
                                        }
                                        m = 0;
                                        c = F[b + 20 >> 2];
                                        e = F[b + 12 >> 2];
                                        d = F[b + 16 >> 2];
                                        if ((c | 0) >= (e | 0) & d >>> 0 >= I[b + 8 >> 2] | (c | 0) > (e | 0)) {
                                            break d;
                                        }
                                        o = G[d + F[b >> 2] | 0];
                                        d = d + 1 | 0;
                                        c = d ? c : c + 1 | 0;
                                        F[b + 16 >> 2] = d;
                                        F[b + 20 >> 2] = c;
                                        n = F[F[(ga[F[F[a >> 2] + 28 >> 2]](a) | 0) + 4 >> 2] + 80 >> 2];
                                        c = ga[F[F[a >> 2] + 24 >> 2]](a) | 0;
                                        F[f + 696 >> 2] = 0;
                                        F[f + 688 >> 2] = 0;
                                        F[f + 692 >> 2] = 0;
                                        if (c) {
                                            if (c >>> 0 >= 214748365) {
                                                break c;
                                            }
                                            c = L(c, 20);
                                            d = sa(c);
                                            F[f + 688 >> 2] = d;
                                            F[f + 696 >> 2] = c + d;
                                            c = L((c - 20 >>> 0) / 20 | 0, 20) + 20 | 0;
                                            q = f, r = ua(d, 0, c) + c | 0, F[q + 692 >> 2] = r;
                                        }
                                        e: {
                                            if ((ga[F[F[a >> 2] + 24 >> 2]](a) | 0) > 0) {
                                                while (1) {
                                                    c = ga[F[F[a >> 2] + 20 >> 2]](a, l) | 0;
                                                    e = F[F[F[(ga[F[F[a >> 2] + 28 >> 2]](a) | 0) + 4 >> 2] + 8 >> 2] + (c << 2) >> 2];
                                                    qb(e, n);
                                                    D[e + 84 | 0] = 1;
                                                    F[e + 72 >> 2] = F[e + 68 >> 2];
                                                    c = F[e + 28 >> 2];
                                                    if (c >>> 0 > 9) {
                                                        break e;
                                                    }
                                                    f: {
                                                        g: {
                                                            h: {
                                                                d = 1 << c;
                                                                if (!(d & 42)) {
                                                                    if (d & 84) {
                                                                        break f;
                                                                    }
                                                                    if ((c | 0) != 9) {
                                                                        break e;
                                                                    }
                                                                    c = D[e + 24 | 0];
                                                                    d = Fb(f);
                                                                    g = c;
                                                                    c = L(c, F[3409]);
                                                                    mc(d, F[e + 56 >> 2], g, 6, 0, c, c >> 31);
                                                                    e = sa(96);
                                                                    c = kc(e, d);
                                                                    F[f + 656 >> 2] = e;
                                                                    D[c + 84 | 0] = 1;
                                                                    F[c + 72 >> 2] = F[c + 68 >> 2];
                                                                    qb(c, n);
                                                                    c = F[a + 64 >> 2];
                                                                    if (c >>> 0 >= I[a + 68 >> 2]) {
                                                                        break h;
                                                                    }
                                                                    d = F[f + 656 >> 2];
                                                                    F[f + 656 >> 2] = 0;
                                                                    F[c >> 2] = d;
                                                                    d = c + 4 | 0;
                                                                    F[a + 64 >> 2] = d;
                                                                    break g;
                                                                }
                                                                d = 0;
                                                                if (D[e + 24 | 0] <= 0) {
                                                                    break f;
                                                                }
                                                                while (1) {
                                                                    c = F[a + 52 >> 2];
                                                                    g = F[a + 56 >> 2];
                                                                    i: {
                                                                        if (c >>> 0 < g >>> 0) {
                                                                            F[c >> 2] = 0;
                                                                            F[a + 52 >> 2] = c + 4;
                                                                            break i;
                                                                        }
                                                                        h = F[a + 48 >> 2];
                                                                        k = c - h | 0;
                                                                        j = k >> 2;
                                                                        c = j + 1 | 0;
                                                                        if (c >>> 0 >= 1073741824) {
                                                                            break b;
                                                                        }
                                                                        p = j << 2;
                                                                        g = g - h | 0;
                                                                        j = g >> 1;
                                                                        g = g >>> 0 < 2147483644 ? c >>> 0 > j >>> 0 ? c : j : 1073741823;
                                                                        if (g) {
                                                                            if (g >>> 0 >= 1073741824) {
                                                                                break a;
                                                                            }
                                                                            c = sa(g << 2);
                                                                        }
                                                                        else {
                                                                            c = 0;
                                                                        }
                                                                        j = p + c | 0;
                                                                        F[j >> 2] = 0;
                                                                        if ((k | 0) > 0) {
                                                                            ta(c, h, k);
                                                                        }
                                                                        F[a + 56 >> 2] = c + (g << 2);
                                                                        F[a + 52 >> 2] = j + 4;
                                                                        F[a + 48 >> 2] = c;
                                                                        if (!h) {
                                                                            break i;
                                                                        }
                                                                        ra(h);
                                                                    }
                                                                    d = d + 1 | 0;
                                                                    if ((d | 0) < D[e + 24 | 0]) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                break f;
                                                            }
                                                            d = 0;
                                                            j: {
                                                                k: {
                                                                    l: {
                                                                        e = F[a + 60 >> 2];
                                                                        h = F[a + 64 >> 2] - e >> 2;
                                                                        c = h + 1 | 0;
                                                                        if (c >>> 0 < 1073741824) {
                                                                            e = F[a + 68 >> 2] - e | 0;
                                                                            g = e >> 1;
                                                                            e = e >>> 0 < 2147483644 ? c >>> 0 > g >>> 0 ? c : g : 1073741823;
                                                                            if (e) {
                                                                                if (e >>> 0 >= 1073741824) {
                                                                                    break l;
                                                                                }
                                                                                d = sa(e << 2);
                                                                            }
                                                                            g = F[f + 656 >> 2];
                                                                            F[f + 656 >> 2] = 0;
                                                                            c = (h << 2) + d | 0;
                                                                            F[c >> 2] = g;
                                                                            h = (e << 2) + d | 0;
                                                                            g = c + 4 | 0;
                                                                            d = F[a + 64 >> 2];
                                                                            e = F[a + 60 >> 2];
                                                                            if ((d | 0) == (e | 0)) {
                                                                                break k;
                                                                            }
                                                                            while (1) {
                                                                                d = d - 4 | 0;
                                                                                k = F[d >> 2];
                                                                                F[d >> 2] = 0;
                                                                                c = c - 4 | 0;
                                                                                F[c >> 2] = k;
                                                                                if ((d | 0) != (e | 0)) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                            F[a + 68 >> 2] = h;
                                                                            d = F[a + 64 >> 2];
                                                                            F[a + 64 >> 2] = g;
                                                                            e = F[a + 60 >> 2];
                                                                            F[a + 60 >> 2] = c;
                                                                            if ((d | 0) == (e | 0)) {
                                                                                break j;
                                                                            }
                                                                            while (1) {
                                                                                d = d - 4 | 0;
                                                                                c = F[d >> 2];
                                                                                F[d >> 2] = 0;
                                                                                if (c) {
                                                                                    Ja(c);
                                                                                }
                                                                                if ((d | 0) != (e | 0)) {
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                            break j;
                                                                        }
                                                                        va();
                                                                        V();
                                                                    }
                                                                    wa(1336);
                                                                    V();
                                                                }
                                                                F[a + 68 >> 2] = h;
                                                                F[a + 64 >> 2] = g;
                                                                F[a + 60 >> 2] = c;
                                                            }
                                                            if (e) {
                                                                ra(e);
                                                            }
                                                            d = F[a + 64 >> 2];
                                                        }
                                                        e = F[d - 4 >> 2];
                                                        c = F[f + 656 >> 2];
                                                        F[f + 656 >> 2] = 0;
                                                        if (!c) {
                                                            break f;
                                                        }
                                                        Ja(c);
                                                    }
                                                    h = F[e + 28 >> 2];
                                                    c = h - 1 | 0;
                                                    if (c >>> 0 <= 10) {
                                                        d = F[(c << 2) + 13616 >> 2];
                                                    }
                                                    else {
                                                        d = -1;
                                                    }
                                                    c = F[f + 688 >> 2] + L(l, 20) | 0;
                                                    g = D[e + 24 | 0];
                                                    F[c + 16 >> 2] = g;
                                                    F[c + 12 >> 2] = (d | 0) > 0 ? d : 0;
                                                    F[c + 8 >> 2] = h;
                                                    F[c + 4 >> 2] = i;
                                                    F[c >> 2] = e;
                                                    i = g + i | 0;
                                                    l = l + 1 | 0;
                                                    if ((ga[F[F[a >> 2] + 24 >> 2]](a) | 0) > (l | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            a = Bc(f + 656 | 0, f + 688 | 0);
                                            m: {
                                                n: {
                                                    o: {
                                                        switch (o | 0) {
                                                            case 0:
                                                                c = zb(f, i);
                                                                b = Bd(c, b, a);
                                                                Ab(c);
                                                                if (b) {
                                                                    break n;
                                                                }
                                                                break m;
                                                            case 1:
                                                                c = zb(f, i);
                                                                b = Ad(c, b, a);
                                                                Ab(c);
                                                                if (b) {
                                                                    break n;
                                                                }
                                                                break m;
                                                            case 2:
                                                                c = xb(f, i);
                                                                b = zd(c, b, a);
                                                                yb(c);
                                                                if (b) {
                                                                    break n;
                                                                }
                                                                break m;
                                                            case 3:
                                                                c = xb(f, i);
                                                                b = yd(c, b, a);
                                                                yb(c);
                                                                if (b) {
                                                                    break n;
                                                                }
                                                                break m;
                                                            case 4:
                                                                c = ab(f, i);
                                                                b = xd(c, b, a);
                                                                bb(c);
                                                                if (b) {
                                                                    break n;
                                                                }
                                                                break m;
                                                            case 5:
                                                                c = ab(f, i);
                                                                b = wd(c, b, a);
                                                                bb(c);
                                                                if (b) {
                                                                    break n;
                                                                }
                                                                break m;
                                                            case 6: break o;
                                                            default: break m;
                                                        }
                                                    }
                                                    c = ab(f, i);
                                                    b = vd(c, b, a);
                                                    bb(c);
                                                    if (!b) {
                                                        break m;
                                                    }
                                                }
                                                m = 1;
                                            }
                                            b = F[a + 16 >> 2];
                                            if (b) {
                                                F[a + 20 >> 2] = b;
                                                ra(b);
                                            }
                                            b = F[a >> 2];
                                            if (!b) {
                                                break e;
                                            }
                                            F[a + 4 >> 2] = b;
                                            ra(b);
                                        }
                                        a = F[f + 688 >> 2];
                                        if (!a) {
                                            break d;
                                        }
                                        F[f + 692 >> 2] = a;
                                        ra(a);
                                    }
                                    ea = f + 704 | 0;
                                    return m | 0;
                                }
                                va();
                                V();
                            }
                            va();
                            V();
                        } wa(1336); V(); }
                        function Me(a, b, c, d) { var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0; f = ea - 80 | 0; ea = f; e = F[c + 36 >> 2]; F[f + 72 >> 2] = F[c + 32 >> 2]; F[f + 76 >> 2] = e; g = F[c + 28 >> 2]; e = f - -64 | 0; F[e >> 2] = F[c + 24 >> 2]; F[e + 4 >> 2] = g; e = F[c + 20 >> 2]; F[f + 56 >> 2] = F[c + 16 >> 2]; F[f + 60 >> 2] = e; e = F[c + 12 >> 2]; F[f + 48 >> 2] = F[c + 8 >> 2]; F[f + 52 >> 2] = e; e = F[c + 4 >> 2]; F[f + 40 >> 2] = F[c >> 2]; F[f + 44 >> 2] = e; oc(a, f + 40 | 0, f + 24 | 0); a: {
                            if (F[a >> 2]) {
                                break a;
                            }
                            j = a + 4 | 0;
                            if (D[a + 15 | 0] < 0) {
                                ra(F[j >> 2]);
                            }
                            if (G[f + 31 | 0]) {
                                b = sa(32);
                                c = G[1665] | G[1666] << 8 | (G[1667] << 16 | G[1668] << 24);
                                D[b + 23 | 0] = c;
                                D[b + 24 | 0] = c >>> 8;
                                D[b + 25 | 0] = c >>> 16;
                                D[b + 26 | 0] = c >>> 24;
                                c = G[1662] | G[1663] << 8 | (G[1664] << 16 | G[1665] << 24);
                                d = G[1658] | G[1659] << 8 | (G[1660] << 16 | G[1661] << 24);
                                D[b + 16 | 0] = d;
                                D[b + 17 | 0] = d >>> 8;
                                D[b + 18 | 0] = d >>> 16;
                                D[b + 19 | 0] = d >>> 24;
                                D[b + 20 | 0] = c;
                                D[b + 21 | 0] = c >>> 8;
                                D[b + 22 | 0] = c >>> 16;
                                D[b + 23 | 0] = c >>> 24;
                                c = G[1654] | G[1655] << 8 | (G[1656] << 16 | G[1657] << 24);
                                d = G[1650] | G[1651] << 8 | (G[1652] << 16 | G[1653] << 24);
                                D[b + 8 | 0] = d;
                                D[b + 9 | 0] = d >>> 8;
                                D[b + 10 | 0] = d >>> 16;
                                D[b + 11 | 0] = d >>> 24;
                                D[b + 12 | 0] = c;
                                D[b + 13 | 0] = c >>> 8;
                                D[b + 14 | 0] = c >>> 16;
                                D[b + 15 | 0] = c >>> 24;
                                c = G[1646] | G[1647] << 8 | (G[1648] << 16 | G[1649] << 24);
                                d = G[1642] | G[1643] << 8 | (G[1644] << 16 | G[1645] << 24);
                                D[b | 0] = d;
                                D[b + 1 | 0] = d >>> 8;
                                D[b + 2 | 0] = d >>> 16;
                                D[b + 3 | 0] = d >>> 24;
                                D[b + 4 | 0] = c;
                                D[b + 5 | 0] = c >>> 8;
                                D[b + 6 | 0] = c >>> 16;
                                D[b + 7 | 0] = c >>> 24;
                                D[b + 27 | 0] = 0;
                                F[a >> 2] = -1;
                                Ba(j, b, 27);
                                ra(b);
                                break a;
                            }
                            i = ea - 16 | 0;
                            ea = i;
                            b: {
                                c: {
                                    switch (D[f + 32 | 0]) {
                                        case 0:
                                            e = sa(44);
                                            F[e >> 2] = 0;
                                            F[e + 4 >> 2] = 0;
                                            F[e + 40 >> 2] = 0;
                                            F[e + 32 >> 2] = 0;
                                            F[e + 36 >> 2] = 0;
                                            F[e + 24 >> 2] = 0;
                                            F[e + 28 >> 2] = 0;
                                            F[e + 16 >> 2] = 0;
                                            F[e + 20 >> 2] = 0;
                                            F[e + 8 >> 2] = 0;
                                            F[e + 12 >> 2] = 0;
                                            g = Uc(e);
                                            F[e >> 2] = 13528;
                                            F[f + 8 >> 2] = 0;
                                            F[f + 12 >> 2] = 0;
                                            F[f >> 2] = 0;
                                            F[f + 4 >> 2] = 0;
                                            F[f + 16 >> 2] = g;
                                            break b;
                                        case 1:
                                            e = sa(44);
                                            F[e >> 2] = 0;
                                            F[e + 4 >> 2] = 0;
                                            F[e + 40 >> 2] = 0;
                                            F[e + 32 >> 2] = 0;
                                            F[e + 36 >> 2] = 0;
                                            F[e + 24 >> 2] = 0;
                                            F[e + 28 >> 2] = 0;
                                            F[e + 16 >> 2] = 0;
                                            F[e + 20 >> 2] = 0;
                                            F[e + 8 >> 2] = 0;
                                            F[e + 12 >> 2] = 0;
                                            g = Uc(e);
                                            F[e >> 2] = 13436;
                                            F[f + 8 >> 2] = 0;
                                            F[f + 12 >> 2] = 0;
                                            F[f >> 2] = 0;
                                            F[f + 4 >> 2] = 0;
                                            F[f + 16 >> 2] = g;
                                            break b;
                                        default: break c;
                                    }
                                }
                                g = sa(32);
                                e = G[1694] | G[1695] << 8 | (G[1696] << 16 | G[1697] << 24);
                                D[g + 24 | 0] = e;
                                D[g + 25 | 0] = e >>> 8;
                                D[g + 26 | 0] = e >>> 16;
                                D[g + 27 | 0] = e >>> 24;
                                e = G[1690] | G[1691] << 8 | (G[1692] << 16 | G[1693] << 24);
                                h = G[1686] | G[1687] << 8 | (G[1688] << 16 | G[1689] << 24);
                                D[g + 16 | 0] = h;
                                D[g + 17 | 0] = h >>> 8;
                                D[g + 18 | 0] = h >>> 16;
                                D[g + 19 | 0] = h >>> 24;
                                D[g + 20 | 0] = e;
                                D[g + 21 | 0] = e >>> 8;
                                D[g + 22 | 0] = e >>> 16;
                                D[g + 23 | 0] = e >>> 24;
                                e = G[1682] | G[1683] << 8 | (G[1684] << 16 | G[1685] << 24);
                                h = G[1678] | G[1679] << 8 | (G[1680] << 16 | G[1681] << 24);
                                D[g + 8 | 0] = h;
                                D[g + 9 | 0] = h >>> 8;
                                D[g + 10 | 0] = h >>> 16;
                                D[g + 11 | 0] = h >>> 24;
                                D[g + 12 | 0] = e;
                                D[g + 13 | 0] = e >>> 8;
                                D[g + 14 | 0] = e >>> 16;
                                D[g + 15 | 0] = e >>> 24;
                                e = G[1674] | G[1675] << 8 | (G[1676] << 16 | G[1677] << 24);
                                h = G[1670] | G[1671] << 8 | (G[1672] << 16 | G[1673] << 24);
                                D[g | 0] = h;
                                D[g + 1 | 0] = h >>> 8;
                                D[g + 2 | 0] = h >>> 16;
                                D[g + 3 | 0] = h >>> 24;
                                D[g + 4 | 0] = e;
                                D[g + 5 | 0] = e >>> 8;
                                D[g + 6 | 0] = e >>> 16;
                                D[g + 7 | 0] = e >>> 24;
                                D[g + 28 | 0] = 0;
                                F[i >> 2] = -1;
                                e = i | 4;
                                Ba(e, g, 28);
                                k = D[i + 15 | 0];
                                F[f >> 2] = F[i >> 2];
                                h = f + 4 | 0;
                                d: {
                                    if ((k | 0) >= 0) {
                                        k = F[e + 4 >> 2];
                                        F[h >> 2] = F[e >> 2];
                                        F[h + 4 >> 2] = k;
                                        F[h + 8 >> 2] = F[e + 8 >> 2];
                                        break d;
                                    }
                                    Ba(h, F[i + 4 >> 2], F[i + 8 >> 2]);
                                }
                                F[f + 16 >> 2] = 0;
                                if (D[i + 15 | 0] < 0) {
                                    ra(F[i + 4 >> 2]);
                                }
                                ra(g);
                            }
                            ea = i + 16 | 0;
                            e = F[f >> 2];
                            e: {
                                if (e) {
                                    F[a >> 2] = e;
                                    if (D[f + 15 | 0] >= 0) {
                                        a = f | 4;
                                        b = F[a + 4 >> 2];
                                        F[j >> 2] = F[a >> 2];
                                        F[j + 4 >> 2] = b;
                                        F[j + 8 >> 2] = F[a + 8 >> 2];
                                        break e;
                                    }
                                    Ba(j, F[f + 4 >> 2], F[f + 8 >> 2]);
                                    break e;
                                }
                                e = F[f + 16 >> 2];
                                F[f + 16 >> 2] = 0;
                                re(a, e, b, c, d);
                                if (!F[a >> 2]) {
                                    if (D[j + 11 | 0] < 0) {
                                        ra(F[j >> 2]);
                                    }
                                    F[a >> 2] = 0;
                                    F[a + 4 >> 2] = 0;
                                    F[a + 8 >> 2] = 0;
                                    F[a + 12 >> 2] = 0;
                                }
                                ga[F[F[e >> 2] + 4 >> 2]](e);
                            }
                            a = F[f + 16 >> 2];
                            F[f + 16 >> 2] = 0;
                            if (a) {
                                ga[F[F[a >> 2] + 4 >> 2]](a);
                            }
                            if (D[f + 15 | 0] >= 0) {
                                break a;
                            }
                            ra(F[f + 4 >> 2]);
                        } ea = f + 80 | 0; }
                        function ed(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0; c = F[a + 4 >> 2]; d = F[a >> 2]; f = (c - d | 0) / 144 | 0; if (f >>> 0 < b >>> 0) {
                            d = a;
                            g = b - f | 0;
                            c = F[a + 8 >> 2];
                            a = F[a + 4 >> 2];
                            a: {
                                if (g >>> 0 <= (c - a | 0) / 144 >>> 0) {
                                    if (g) {
                                        b = L(g, 144) + a | 0;
                                        while (1) {
                                            F[a >> 2] = -1;
                                            be(a + 4 | 0);
                                            F[a + 104 >> 2] = 0;
                                            F[a + 108 >> 2] = 0;
                                            D[a + 100 | 0] = 1;
                                            F[a + 112 >> 2] = 0;
                                            F[a + 116 >> 2] = 0;
                                            F[a + 120 >> 2] = 0;
                                            F[a + 124 >> 2] = 0;
                                            F[a + 128 >> 2] = 0;
                                            F[a + 132 >> 2] = 0;
                                            F[a + 136 >> 2] = 0;
                                            F[a + 140 >> 2] = 0;
                                            a = a + 144 | 0;
                                            if ((b | 0) != (a | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                        a = b;
                                    }
                                    F[d + 4 >> 2] = a;
                                    break a;
                                }
                                b: {
                                    c: {
                                        d: {
                                            b = a;
                                            a = F[d >> 2];
                                            f = (b - a | 0) / 144 | 0;
                                            h = f + g | 0;
                                            if (h >>> 0 < 29826162) {
                                                b = (c - a | 0) / 144 | 0;
                                                a = b << 1;
                                                e = b >>> 0 < 14913080 ? a >>> 0 < h >>> 0 ? h : a : 29826161;
                                                if (e) {
                                                    if (e >>> 0 >= 29826162) {
                                                        break d;
                                                    }
                                                    c = sa(L(e, 144));
                                                }
                                                else {
                                                    c = 0;
                                                }
                                                b = c + L(f, 144) | 0;
                                                h = b + L(g, 144) | 0;
                                                a = b;
                                                while (1) {
                                                    F[a >> 2] = -1;
                                                    be(a + 4 | 0);
                                                    F[a + 104 >> 2] = 0;
                                                    F[a + 108 >> 2] = 0;
                                                    D[a + 100 | 0] = 1;
                                                    F[a + 112 >> 2] = 0;
                                                    F[a + 116 >> 2] = 0;
                                                    F[a + 120 >> 2] = 0;
                                                    F[a + 124 >> 2] = 0;
                                                    F[a + 128 >> 2] = 0;
                                                    F[a + 132 >> 2] = 0;
                                                    F[a + 136 >> 2] = 0;
                                                    F[a + 140 >> 2] = 0;
                                                    a = a + 144 | 0;
                                                    if ((h | 0) != (a | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                f = c + L(e, 144) | 0;
                                                a = F[d + 4 >> 2];
                                                e = F[d >> 2];
                                                if ((a | 0) == (e | 0)) {
                                                    break c;
                                                }
                                                while (1) {
                                                    b = b - 144 | 0;
                                                    a = a - 144 | 0;
                                                    F[b >> 2] = F[a >> 2];
                                                    F[b + 4 >> 2] = F[a + 4 >> 2];
                                                    F[b + 8 >> 2] = F[a + 8 >> 2];
                                                    F[b + 12 >> 2] = F[a + 12 >> 2];
                                                    F[a + 12 >> 2] = 0;
                                                    F[a + 4 >> 2] = 0;
                                                    F[a + 8 >> 2] = 0;
                                                    F[b + 16 >> 2] = F[a + 16 >> 2];
                                                    F[b + 20 >> 2] = F[a + 20 >> 2];
                                                    F[b + 24 >> 2] = F[a + 24 >> 2];
                                                    F[a + 24 >> 2] = 0;
                                                    F[a + 16 >> 2] = 0;
                                                    F[a + 20 >> 2] = 0;
                                                    c = G[a + 28 | 0];
                                                    F[b + 40 >> 2] = 0;
                                                    F[b + 32 >> 2] = 0;
                                                    F[b + 36 >> 2] = 0;
                                                    D[b + 28 | 0] = c;
                                                    F[b + 32 >> 2] = F[a + 32 >> 2];
                                                    F[b + 36 >> 2] = F[a + 36 >> 2];
                                                    F[b + 40 >> 2] = F[a + 40 >> 2];
                                                    F[a + 40 >> 2] = 0;
                                                    F[a + 32 >> 2] = 0;
                                                    F[a + 36 >> 2] = 0;
                                                    F[b + 52 >> 2] = 0;
                                                    F[b + 44 >> 2] = 0;
                                                    F[b + 48 >> 2] = 0;
                                                    F[b + 44 >> 2] = F[a + 44 >> 2];
                                                    F[b + 48 >> 2] = F[a + 48 >> 2];
                                                    F[b + 52 >> 2] = F[a + 52 >> 2];
                                                    F[a + 52 >> 2] = 0;
                                                    F[a + 44 >> 2] = 0;
                                                    F[a + 48 >> 2] = 0;
                                                    c = b - -64 | 0;
                                                    F[c >> 2] = 0;
                                                    F[b + 56 >> 2] = 0;
                                                    F[b + 60 >> 2] = 0;
                                                    F[b + 56 >> 2] = F[a + 56 >> 2];
                                                    F[b + 60 >> 2] = F[a + 60 >> 2];
                                                    g = c;
                                                    c = a - -64 | 0;
                                                    F[g >> 2] = F[c >> 2];
                                                    F[c >> 2] = 0;
                                                    F[a + 56 >> 2] = 0;
                                                    F[a + 60 >> 2] = 0;
                                                    F[b + 68 >> 2] = F[a + 68 >> 2];
                                                    c = F[a + 72 >> 2];
                                                    F[b + 84 >> 2] = 0;
                                                    F[b + 76 >> 2] = 0;
                                                    F[b + 80 >> 2] = 0;
                                                    F[b + 72 >> 2] = c;
                                                    F[b + 76 >> 2] = F[a + 76 >> 2];
                                                    F[b + 80 >> 2] = F[a + 80 >> 2];
                                                    F[b + 84 >> 2] = F[a + 84 >> 2];
                                                    F[a + 84 >> 2] = 0;
                                                    F[a + 76 >> 2] = 0;
                                                    F[a + 80 >> 2] = 0;
                                                    F[b + 96 >> 2] = 0;
                                                    F[b + 88 >> 2] = 0;
                                                    F[b + 92 >> 2] = 0;
                                                    F[b + 88 >> 2] = F[a + 88 >> 2];
                                                    F[b + 92 >> 2] = F[a + 92 >> 2];
                                                    F[b + 96 >> 2] = F[a + 96 >> 2];
                                                    F[a + 96 >> 2] = 0;
                                                    F[a + 88 >> 2] = 0;
                                                    F[a + 92 >> 2] = 0;
                                                    c = G[a + 100 | 0];
                                                    F[b + 112 >> 2] = 0;
                                                    F[b + 104 >> 2] = 0;
                                                    F[b + 108 >> 2] = 0;
                                                    D[b + 100 | 0] = c;
                                                    F[b + 104 >> 2] = F[a + 104 >> 2];
                                                    F[b + 108 >> 2] = F[a + 108 >> 2];
                                                    F[b + 112 >> 2] = F[a + 112 >> 2];
                                                    F[a + 112 >> 2] = 0;
                                                    F[a + 104 >> 2] = 0;
                                                    F[a + 108 >> 2] = 0;
                                                    F[b + 124 >> 2] = 0;
                                                    F[b + 116 >> 2] = 0;
                                                    F[b + 120 >> 2] = 0;
                                                    F[b + 116 >> 2] = F[a + 116 >> 2];
                                                    F[b + 120 >> 2] = F[a + 120 >> 2];
                                                    F[b + 124 >> 2] = F[a + 124 >> 2];
                                                    F[a + 124 >> 2] = 0;
                                                    F[a + 116 >> 2] = 0;
                                                    F[a + 120 >> 2] = 0;
                                                    c = F[a + 128 >> 2];
                                                    F[b + 140 >> 2] = 0;
                                                    F[b + 132 >> 2] = 0;
                                                    F[b + 136 >> 2] = 0;
                                                    F[b + 128 >> 2] = c;
                                                    F[b + 132 >> 2] = F[a + 132 >> 2];
                                                    F[b + 136 >> 2] = F[a + 136 >> 2];
                                                    F[b + 140 >> 2] = F[a + 140 >> 2];
                                                    F[a + 140 >> 2] = 0;
                                                    F[a + 132 >> 2] = 0;
                                                    F[a + 136 >> 2] = 0;
                                                    if ((a | 0) != (e | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                F[d + 8 >> 2] = f;
                                                a = F[d + 4 >> 2];
                                                F[d + 4 >> 2] = h;
                                                e = F[d >> 2];
                                                F[d >> 2] = b;
                                                if ((a | 0) == (e | 0)) {
                                                    break b;
                                                }
                                                while (1) {
                                                    b = F[a - 12 >> 2];
                                                    if (b) {
                                                        F[a - 8 >> 2] = b;
                                                        ra(b);
                                                    }
                                                    b = F[a - 28 >> 2];
                                                    if (b) {
                                                        F[a - 24 >> 2] = b;
                                                        ra(b);
                                                    }
                                                    b = F[a - 40 >> 2];
                                                    if (b) {
                                                        F[a - 36 >> 2] = b;
                                                        ra(b);
                                                    }
                                                    pc(a - 140 | 0);
                                                    a = a - 144 | 0;
                                                    if ((e | 0) != (a | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break b;
                                            }
                                            va();
                                            V();
                                        }
                                        wa(1336);
                                        V();
                                    }
                                    F[d + 8 >> 2] = f;
                                    F[d + 4 >> 2] = h;
                                    F[d >> 2] = b;
                                }
                                if (e) {
                                    ra(e);
                                }
                            }
                            return;
                        } if (b >>> 0 < f >>> 0) {
                            d = d + L(b, 144) | 0;
                            if ((d | 0) != (c | 0)) {
                                while (1) {
                                    b = F[c - 12 >> 2];
                                    if (b) {
                                        F[c - 8 >> 2] = b;
                                        ra(b);
                                    }
                                    b = F[c - 28 >> 2];
                                    if (b) {
                                        F[c - 24 >> 2] = b;
                                        ra(b);
                                    }
                                    b = F[c - 40 >> 2];
                                    if (b) {
                                        F[c - 36 >> 2] = b;
                                        ra(b);
                                    }
                                    pc(c - 140 | 0);
                                    c = c - 144 | 0;
                                    if ((d | 0) != (c | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            F[a + 4 >> 2] = d;
                        } }
                        function Kb(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0; e = ea - 96 | 0; ea = e; d = F[a + 16 >> 2]; D[e + 92 | 0] = 1; F[e + 88 >> 2] = b; F[e + 84 >> 2] = b; F[e + 80 >> 2] = d; a: {
                            if ((b | 0) == -1) {
                                break a;
                            }
                            m = F[a + 20 >> 2];
                            f = F[m >> 2];
                            d = F[F[d >> 2] + (b << 2) >> 2];
                            if (d >>> 0 >= F[m + 4 >> 2] - f >> 2 >>> 0) {
                                break a;
                            }
                            d = F[F[a + 8 >> 2] + (F[f + (d << 2) >> 2] << 2) >> 2];
                            f = F[a + 4 >> 2];
                            if (!G[f + 84 | 0]) {
                                d = F[F[f + 68 >> 2] + (d << 2) >> 2];
                            }
                            F[e + 72 >> 2] = 0;
                            F[e + 76 >> 2] = 0;
                            m = e - -64 | 0;
                            F[m >> 2] = 0;
                            F[m + 4 >> 2] = 0;
                            F[e + 56 >> 2] = 0;
                            F[e + 60 >> 2] = 0;
                            Ta(f, d, D[f + 24 | 0], e + 56 | 0);
                            d = b + 1 | 0;
                            m = (d >>> 0) % 3 | 0 ? d : b - 2 | 0;
                            h = ((b >>> 0) % 3 | 0 ? -1 : 2) + b | 0;
                            b: {
                                c: {
                                    while (1) {
                                        f = m;
                                        d = h;
                                        d: {
                                            if (!F[a + 28 >> 2]) {
                                                break d;
                                            }
                                            d = b + 1 | 0;
                                            f = (d >>> 0) % 3 | 0 ? d : b - 2 | 0;
                                            d = b - 1 | 0;
                                            if ((b >>> 0) % 3 | 0) {
                                                break d;
                                            }
                                            d = b + 2 | 0;
                                        }
                                        if ((f | 0) == -1) {
                                            break b;
                                        }
                                        k = F[a + 20 >> 2];
                                        b = F[k >> 2];
                                        f = F[F[F[a + 16 >> 2] >> 2] + (f << 2) >> 2];
                                        if (f >>> 0 >= F[k + 4 >> 2] - b >> 2 >>> 0) {
                                            break b;
                                        }
                                        f = F[F[a + 8 >> 2] + (F[(f << 2) + b >> 2] << 2) >> 2];
                                        b = F[a + 4 >> 2];
                                        if (!G[b + 84 | 0]) {
                                            f = F[F[b + 68 >> 2] + (f << 2) >> 2];
                                        }
                                        F[e + 48 >> 2] = 0;
                                        F[e + 52 >> 2] = 0;
                                        F[e + 40 >> 2] = 0;
                                        F[e + 44 >> 2] = 0;
                                        F[e + 32 >> 2] = 0;
                                        F[e + 36 >> 2] = 0;
                                        Ta(b, f, D[b + 24 | 0], e + 32 | 0);
                                        if ((d | 0) == -1) {
                                            break c;
                                        }
                                        f = F[a + 20 >> 2];
                                        b = F[f >> 2];
                                        d = F[F[F[a + 16 >> 2] >> 2] + (d << 2) >> 2];
                                        if (d >>> 0 >= F[f + 4 >> 2] - b >> 2 >>> 0) {
                                            break c;
                                        }
                                        f = F[F[a + 8 >> 2] + (F[b + (d << 2) >> 2] << 2) >> 2];
                                        b = F[a + 4 >> 2];
                                        if (!G[b + 84 | 0]) {
                                            f = F[F[b + 68 >> 2] + (f << 2) >> 2];
                                        }
                                        F[e + 24 >> 2] = 0;
                                        F[e + 28 >> 2] = 0;
                                        F[e + 16 >> 2] = 0;
                                        F[e + 20 >> 2] = 0;
                                        F[e + 8 >> 2] = 0;
                                        F[e + 12 >> 2] = 0;
                                        Ta(b, f, D[b + 24 | 0], e + 8 | 0);
                                        d = F[e + 8 >> 2];
                                        b = F[e + 56 >> 2];
                                        f = d - b | 0;
                                        k = F[e + 60 >> 2];
                                        n = F[e + 12 >> 2] - (k + (b >>> 0 > d >>> 0) | 0) | 0;
                                        i = F[e + 40 >> 2];
                                        d = F[e + 64 >> 2];
                                        s = i - d | 0;
                                        t = F[e + 68 >> 2];
                                        i = F[e + 44 >> 2] - (t + (d >>> 0 > i >>> 0) | 0) | 0;
                                        u = Hj(f, n, s, i);
                                        v = j - u | 0;
                                        g = g - (fa + (j >>> 0 < u >>> 0) | 0) | 0;
                                        w = v;
                                        j = F[e + 16 >> 2];
                                        u = j - d | 0;
                                        t = F[e + 20 >> 2] - ((d >>> 0 > j >>> 0) + t | 0) | 0;
                                        j = F[e + 32 >> 2];
                                        v = j - b | 0;
                                        k = F[e + 36 >> 2] - ((b >>> 0 > j >>> 0) + k | 0) | 0;
                                        d = Hj(u, t, v, k);
                                        j = w + d | 0;
                                        b = fa + g | 0;
                                        b = d >>> 0 > j >>> 0 ? b + 1 | 0 : b;
                                        g = b;
                                        w = o;
                                        p = n;
                                        b = F[e + 48 >> 2];
                                        d = F[e + 72 >> 2];
                                        n = b - d | 0;
                                        o = F[e + 76 >> 2];
                                        x = F[e + 52 >> 2] - (o + (b >>> 0 < d >>> 0) | 0) | 0;
                                        p = Hj(f, p, n, x);
                                        f = w + p | 0;
                                        b = fa + l | 0;
                                        b = f >>> 0 < p >>> 0 ? b + 1 | 0 : b;
                                        l = F[e + 24 >> 2];
                                        p = l - d | 0;
                                        d = F[e + 28 >> 2] - ((d >>> 0 > l >>> 0) + o | 0) | 0;
                                        l = Hj(p, d, v, k);
                                        o = f - l | 0;
                                        l = b - (fa + (f >>> 0 < l >>> 0) | 0) | 0;
                                        b = Hj(u, t, n, x);
                                        f = q - b | 0;
                                        b = r - (fa + (b >>> 0 > q >>> 0) | 0) | 0;
                                        r = Hj(p, d, s, i);
                                        q = r + f | 0;
                                        b = fa + b | 0;
                                        b = q >>> 0 < r >>> 0 ? b + 1 | 0 : b;
                                        r = b;
                                        vc(e + 80 | 0);
                                        b = F[e + 88 >> 2];
                                        if ((b | 0) != -1) {
                                            continue;
                                        }
                                        break;
                                    }
                                    b = r >> 31;
                                    f = b + q | 0;
                                    d = b;
                                    b = b + r | 0;
                                    k = f ^ d;
                                    h = d ^ (f >>> 0 < d >>> 0 ? b + 1 | 0 : b);
                                    n = -1;
                                    f = 2147483647;
                                    b = l >> 31;
                                    i = b;
                                    d = b + o | 0;
                                    b = b + l | 0;
                                    b = d >>> 0 < i >>> 0 ? b + 1 | 0 : b;
                                    d = d ^ i;
                                    b = b ^ i;
                                    i = b;
                                    s = d ^ -1;
                                    b = b ^ 2147483647;
                                    m = g;
                                    e: {
                                        f: {
                                            if (!F[a + 28 >> 2]) {
                                                if ((b | 0) == (h | 0) & k >>> 0 > s >>> 0 | b >>> 0 < h >>> 0) {
                                                    break e;
                                                }
                                                b = h + i | 0;
                                                a = d + k | 0;
                                                b = a >>> 0 < d >>> 0 ? b + 1 | 0 : b;
                                                d = a;
                                                a = b;
                                                b = g >> 31;
                                                f = b + j | 0;
                                                h = g;
                                                g = b;
                                                b = h + b | 0;
                                                b = f >>> 0 < g >>> 0 ? b + 1 | 0 : b;
                                                h = f ^ g;
                                                f = h + d | 0;
                                                g = b ^ g;
                                                b = f;
                                                g = g ^ 2147483647;
                                                a = (g | 0) == (a | 0) & (h ^ -1) >>> 0 < d >>> 0 | a >>> 0 > g >>> 0;
                                                g = !(a & 0);
                                                a = a ? -1 : b;
                                                if (g & (a | 0) <= 536870912 | (a | 0) < 536870912) {
                                                    break e;
                                                }
                                                b = 0;
                                                a = a >>> 29 | 0;
                                                break f;
                                            }
                                            g: {
                                                if ((b | 0) == (h | 0) & k >>> 0 > s >>> 0 | b >>> 0 < h >>> 0) {
                                                    break g;
                                                }
                                                b = h + i | 0;
                                                a = d + k | 0;
                                                b = a >>> 0 < d >>> 0 ? b + 1 | 0 : b;
                                                d = b;
                                                h = g;
                                                b = g >> 31;
                                                g = b + j | 0;
                                                i = h;
                                                h = b;
                                                b = i + b | 0;
                                                b = g >>> 0 < h >>> 0 ? b + 1 | 0 : b;
                                                g = g ^ h;
                                                b = b ^ h;
                                                h = b ^ 2147483647;
                                                if ((h | 0) == (d | 0) & (g ^ -1) >>> 0 < a >>> 0 | d >>> 0 > h >>> 0) {
                                                    break g;
                                                }
                                                b = b + d | 0;
                                                a = a + g | 0;
                                                b = a >>> 0 < g >>> 0 ? b + 1 | 0 : b;
                                                n = a;
                                                f = b;
                                                if (!b & a >>> 0 < 536870913) {
                                                    break e;
                                                }
                                            }
                                            b = f >>> 29 | 0;
                                            a = (f & 536870911) << 3 | n >>> 29;
                                        }
                                        j = Ij(j, m, a, b);
                                        o = Ij(o, l, a, b);
                                        q = Ij(q, r, a, b);
                                    }
                                    F[c + 8 >> 2] = j;
                                    F[c + 4 >> 2] = o;
                                    F[c >> 2] = q;
                                    ea = e + 96 | 0;
                                    return;
                                }
                                Da();
                                V();
                            }
                            Da();
                            V();
                        } Da(); V(); }
                        function Ud(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0; a: {
                            if ((b | 0) < 0) {
                                break a;
                            }
                            d = F[a + 12 >> 2];
                            c = F[a + 8 >> 2];
                            if (d - c >> 2 >>> 0 <= b >>> 0) {
                                break a;
                            }
                            e = c + (b << 2) | 0;
                            f = F[e >> 2];
                            i = F[f + 60 >> 2];
                            g = F[f + 56 >> 2];
                            c = e + 4 | 0;
                            b: {
                                if ((c | 0) != (d | 0)) {
                                    while (1) {
                                        h = F[c >> 2];
                                        F[c >> 2] = 0;
                                        F[e >> 2] = h;
                                        if (f) {
                                            Ja(f);
                                        }
                                        e = e + 4 | 0;
                                        c = c + 4 | 0;
                                        if ((c | 0) != (d | 0)) {
                                            f = F[e >> 2];
                                            continue;
                                        }
                                        break;
                                    }
                                    d = F[a + 12 >> 2];
                                    if ((e | 0) == (d | 0)) {
                                        break b;
                                    }
                                }
                                while (1) {
                                    d = d - 4 | 0;
                                    c = F[d >> 2];
                                    F[d >> 2] = 0;
                                    if (c) {
                                        Ja(c);
                                    }
                                    if ((d | 0) != (e | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            F[a + 12 >> 2] = e;
                            f = F[a + 4 >> 2];
                            c: {
                                if (!f | (i | 0) < 0) {
                                    break c;
                                }
                                d = F[f + 24 >> 2];
                                c = F[f + 28 >> 2];
                                if ((d | 0) == (c | 0)) {
                                    break c;
                                }
                                while (1) {
                                    if ((i | 0) == F[F[d >> 2] + 24 >> 2]) {
                                        e = d + 4 | 0;
                                        i = F[f + 28 >> 2];
                                        d: {
                                            if ((e | 0) != (i | 0)) {
                                                while (1) {
                                                    h = F[e >> 2];
                                                    F[e >> 2] = 0;
                                                    c = F[d >> 2];
                                                    F[d >> 2] = h;
                                                    if (c) {
                                                        Qa(c + 12 | 0, F[c + 16 >> 2]);
                                                        Pa(c, F[c + 4 >> 2]);
                                                        ra(c);
                                                    }
                                                    d = d + 4 | 0;
                                                    e = e + 4 | 0;
                                                    if ((i | 0) != (e | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                e = F[f + 28 >> 2];
                                                if ((e | 0) == (d | 0)) {
                                                    break d;
                                                }
                                            }
                                            while (1) {
                                                e = e - 4 | 0;
                                                c = F[e >> 2];
                                                F[e >> 2] = 0;
                                                if (c) {
                                                    Qa(c + 12 | 0, F[c + 16 >> 2]);
                                                    Pa(c, F[c + 4 >> 2]);
                                                    ra(c);
                                                }
                                                if ((d | 0) != (e | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        F[f + 28 >> 2] = d;
                                        break c;
                                    }
                                    d = d + 4 | 0;
                                    if ((c | 0) != (d | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            e: {
                                if ((g | 0) > 4) {
                                    break e;
                                }
                                f: {
                                    e = L(g, 12) + a | 0;
                                    d = F[e + 20 >> 2];
                                    c = F[e + 24 >> 2];
                                    if ((d | 0) == (c | 0)) {
                                        break f;
                                    }
                                    while (1) {
                                        if (F[d >> 2] == (b | 0)) {
                                            break f;
                                        }
                                        d = d + 4 | 0;
                                        if ((c | 0) != (d | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                    break e;
                                }
                                if ((d | 0) == (c | 0)) {
                                    break e;
                                }
                                f = d + 4 | 0;
                                c = c - f | 0;
                                if (c) {
                                    Wa(d, f, c);
                                }
                                F[e + 24 >> 2] = d + c;
                            }
                            e = F[a + 20 >> 2];
                            c = F[a + 24 >> 2] - e | 0;
                            g: {
                                if (!c) {
                                    break g;
                                }
                                d = c >> 2;
                                f = d >>> 0 > 1 ? d : 1;
                                i = f & 1;
                                d = 0;
                                if (c >>> 0 >= 8) {
                                    f = f & -2;
                                    c = 0;
                                    while (1) {
                                        g = d << 2;
                                        h = g + e | 0;
                                        j = F[h >> 2];
                                        if ((j | 0) > (b | 0)) {
                                            F[h >> 2] = j - 1;
                                        }
                                        g = e + (g | 4) | 0;
                                        h = F[g >> 2];
                                        if ((h | 0) > (b | 0)) {
                                            F[g >> 2] = h - 1;
                                        }
                                        d = d + 2 | 0;
                                        c = c + 2 | 0;
                                        if ((f | 0) != (c | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                if (!i) {
                                    break g;
                                }
                                d = e + (d << 2) | 0;
                                c = F[d >> 2];
                                if ((c | 0) <= (b | 0)) {
                                    break g;
                                }
                                F[d >> 2] = c - 1;
                            }
                            e = F[a + 32 >> 2];
                            c = F[a + 36 >> 2] - e | 0;
                            h: {
                                if (!c) {
                                    break h;
                                }
                                d = c >> 2;
                                f = d >>> 0 > 1 ? d : 1;
                                i = f & 1;
                                d = 0;
                                if (c >>> 0 >= 8) {
                                    f = f & -2;
                                    c = 0;
                                    while (1) {
                                        g = d << 2;
                                        h = g + e | 0;
                                        j = F[h >> 2];
                                        if ((j | 0) > (b | 0)) {
                                            F[h >> 2] = j - 1;
                                        }
                                        g = e + (g | 4) | 0;
                                        h = F[g >> 2];
                                        if ((h | 0) > (b | 0)) {
                                            F[g >> 2] = h - 1;
                                        }
                                        d = d + 2 | 0;
                                        c = c + 2 | 0;
                                        if ((f | 0) != (c | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                if (!i) {
                                    break h;
                                }
                                d = e + (d << 2) | 0;
                                c = F[d >> 2];
                                if ((c | 0) <= (b | 0)) {
                                    break h;
                                }
                                F[d >> 2] = c - 1;
                            }
                            e = F[a + 44 >> 2];
                            c = F[a + 48 >> 2] - e | 0;
                            i: {
                                if (!c) {
                                    break i;
                                }
                                d = c >> 2;
                                f = d >>> 0 > 1 ? d : 1;
                                i = f & 1;
                                d = 0;
                                if (c >>> 0 >= 8) {
                                    f = f & -2;
                                    c = 0;
                                    while (1) {
                                        g = d << 2;
                                        h = g + e | 0;
                                        j = F[h >> 2];
                                        if ((j | 0) > (b | 0)) {
                                            F[h >> 2] = j - 1;
                                        }
                                        g = e + (g | 4) | 0;
                                        h = F[g >> 2];
                                        if ((h | 0) > (b | 0)) {
                                            F[g >> 2] = h - 1;
                                        }
                                        d = d + 2 | 0;
                                        c = c + 2 | 0;
                                        if ((f | 0) != (c | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                if (!i) {
                                    break i;
                                }
                                d = e + (d << 2) | 0;
                                c = F[d >> 2];
                                if ((c | 0) <= (b | 0)) {
                                    break i;
                                }
                                F[d >> 2] = c - 1;
                            }
                            e = F[a + 56 >> 2];
                            c = F[a + 60 >> 2] - e | 0;
                            j: {
                                if (!c) {
                                    break j;
                                }
                                d = c >> 2;
                                f = d >>> 0 > 1 ? d : 1;
                                i = f & 1;
                                d = 0;
                                if (c >>> 0 >= 8) {
                                    f = f & -2;
                                    c = 0;
                                    while (1) {
                                        g = d << 2;
                                        h = g + e | 0;
                                        j = F[h >> 2];
                                        if ((j | 0) > (b | 0)) {
                                            F[h >> 2] = j - 1;
                                        }
                                        g = e + (g | 4) | 0;
                                        h = F[g >> 2];
                                        if ((h | 0) > (b | 0)) {
                                            F[g >> 2] = h - 1;
                                        }
                                        d = d + 2 | 0;
                                        c = c + 2 | 0;
                                        if ((f | 0) != (c | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                if (!i) {
                                    break j;
                                }
                                d = e + (d << 2) | 0;
                                c = F[d >> 2];
                                if ((c | 0) <= (b | 0)) {
                                    break j;
                                }
                                F[d >> 2] = c - 1;
                            }
                            c = F[a + 72 >> 2];
                            a = F[a + 68 >> 2];
                            c = c - a | 0;
                            if (!c) {
                                break a;
                            }
                            d = c >> 2;
                            e = d >>> 0 > 1 ? d : 1;
                            f = e & 1;
                            d = 0;
                            if (c >>> 0 >= 8) {
                                e = e & -2;
                                c = 0;
                                while (1) {
                                    i = d << 2;
                                    g = i + a | 0;
                                    h = F[g >> 2];
                                    if ((h | 0) > (b | 0)) {
                                        F[g >> 2] = h - 1;
                                    }
                                    i = a + (i | 4) | 0;
                                    g = F[i >> 2];
                                    if ((g | 0) > (b | 0)) {
                                        F[i >> 2] = g - 1;
                                    }
                                    d = d + 2 | 0;
                                    c = c + 2 | 0;
                                    if ((e | 0) != (c | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            if (!f) {
                                break a;
                            }
                            c = b;
                            a = a + (d << 2) | 0;
                            b = F[a >> 2];
                            if ((c | 0) >= (b | 0)) {
                                break a;
                            }
                            F[a >> 2] = b - 1;
                        } }
                        function ra(a) { a = a | 0; var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0; a: {
                            if (!a) {
                                break a;
                            }
                            d = a - 8 | 0;
                            b = F[a - 4 >> 2];
                            a = b & -8;
                            f = d + a | 0;
                            b: {
                                if (b & 1) {
                                    break b;
                                }
                                if (!(b & 3)) {
                                    break a;
                                }
                                b = F[d >> 2];
                                d = d - b | 0;
                                if (d >>> 0 < I[4237]) {
                                    break a;
                                }
                                a = a + b | 0;
                                if (F[4238] != (d | 0)) {
                                    if (b >>> 0 <= 255) {
                                        e = F[d + 8 >> 2];
                                        b = b >>> 3 | 0;
                                        c = F[d + 12 >> 2];
                                        if ((c | 0) == (e | 0)) {
                                            i = 16932, j = F[4233] & Lj(b), F[i >> 2] = j;
                                            break b;
                                        }
                                        F[e + 12 >> 2] = c;
                                        F[c + 8 >> 2] = e;
                                        break b;
                                    }
                                    h = F[d + 24 >> 2];
                                    b = F[d + 12 >> 2];
                                    c: {
                                        if ((d | 0) != (b | 0)) {
                                            c = F[d + 8 >> 2];
                                            F[c + 12 >> 2] = b;
                                            F[b + 8 >> 2] = c;
                                            break c;
                                        }
                                        d: {
                                            e = d + 20 | 0;
                                            c = F[e >> 2];
                                            if (c) {
                                                break d;
                                            }
                                            e = d + 16 | 0;
                                            c = F[e >> 2];
                                            if (c) {
                                                break d;
                                            }
                                            b = 0;
                                            break c;
                                        }
                                        while (1) {
                                            g = e;
                                            b = c;
                                            e = b + 20 | 0;
                                            c = F[e >> 2];
                                            if (c) {
                                                continue;
                                            }
                                            e = b + 16 | 0;
                                            c = F[b + 16 >> 2];
                                            if (c) {
                                                continue;
                                            }
                                            break;
                                        }
                                        F[g >> 2] = 0;
                                    }
                                    if (!h) {
                                        break b;
                                    }
                                    e = F[d + 28 >> 2];
                                    c = (e << 2) + 17236 | 0;
                                    e: {
                                        if (F[c >> 2] == (d | 0)) {
                                            F[c >> 2] = b;
                                            if (b) {
                                                break e;
                                            }
                                            i = 16936, j = F[4234] & Lj(e), F[i >> 2] = j;
                                            break b;
                                        }
                                        F[h + (F[h + 16 >> 2] == (d | 0) ? 16 : 20) >> 2] = b;
                                        if (!b) {
                                            break b;
                                        }
                                    }
                                    F[b + 24 >> 2] = h;
                                    c = F[d + 16 >> 2];
                                    if (c) {
                                        F[b + 16 >> 2] = c;
                                        F[c + 24 >> 2] = b;
                                    }
                                    c = F[d + 20 >> 2];
                                    if (!c) {
                                        break b;
                                    }
                                    F[b + 20 >> 2] = c;
                                    F[c + 24 >> 2] = b;
                                    break b;
                                }
                                b = F[f + 4 >> 2];
                                if ((b & 3) != 3) {
                                    break b;
                                }
                                F[4235] = a;
                                F[f + 4 >> 2] = b & -2;
                                F[d + 4 >> 2] = a | 1;
                                F[a + d >> 2] = a;
                                return;
                            }
                            if (d >>> 0 >= f >>> 0) {
                                break a;
                            }
                            b = F[f + 4 >> 2];
                            if (!(b & 1)) {
                                break a;
                            }
                            f: {
                                if (!(b & 2)) {
                                    if (F[4239] == (f | 0)) {
                                        F[4239] = d;
                                        a = F[4236] + a | 0;
                                        F[4236] = a;
                                        F[d + 4 >> 2] = a | 1;
                                        if (F[4238] != (d | 0)) {
                                            break a;
                                        }
                                        F[4235] = 0;
                                        F[4238] = 0;
                                        return;
                                    }
                                    if (F[4238] == (f | 0)) {
                                        F[4238] = d;
                                        a = F[4235] + a | 0;
                                        F[4235] = a;
                                        F[d + 4 >> 2] = a | 1;
                                        F[a + d >> 2] = a;
                                        return;
                                    }
                                    a = (b & -8) + a | 0;
                                    g: {
                                        if (b >>> 0 <= 255) {
                                            e = F[f + 8 >> 2];
                                            b = b >>> 3 | 0;
                                            c = F[f + 12 >> 2];
                                            if ((c | 0) == (e | 0)) {
                                                i = 16932, j = F[4233] & Lj(b), F[i >> 2] = j;
                                                break g;
                                            }
                                            F[e + 12 >> 2] = c;
                                            F[c + 8 >> 2] = e;
                                            break g;
                                        }
                                        h = F[f + 24 >> 2];
                                        b = F[f + 12 >> 2];
                                        h: {
                                            if ((f | 0) != (b | 0)) {
                                                c = F[f + 8 >> 2];
                                                F[c + 12 >> 2] = b;
                                                F[b + 8 >> 2] = c;
                                                break h;
                                            }
                                            i: {
                                                e = f + 20 | 0;
                                                c = F[e >> 2];
                                                if (c) {
                                                    break i;
                                                }
                                                e = f + 16 | 0;
                                                c = F[e >> 2];
                                                if (c) {
                                                    break i;
                                                }
                                                b = 0;
                                                break h;
                                            }
                                            while (1) {
                                                g = e;
                                                b = c;
                                                e = b + 20 | 0;
                                                c = F[e >> 2];
                                                if (c) {
                                                    continue;
                                                }
                                                e = b + 16 | 0;
                                                c = F[b + 16 >> 2];
                                                if (c) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            F[g >> 2] = 0;
                                        }
                                        if (!h) {
                                            break g;
                                        }
                                        e = F[f + 28 >> 2];
                                        c = (e << 2) + 17236 | 0;
                                        j: {
                                            if (F[c >> 2] == (f | 0)) {
                                                F[c >> 2] = b;
                                                if (b) {
                                                    break j;
                                                }
                                                i = 16936, j = F[4234] & Lj(e), F[i >> 2] = j;
                                                break g;
                                            }
                                            F[h + (F[h + 16 >> 2] == (f | 0) ? 16 : 20) >> 2] = b;
                                            if (!b) {
                                                break g;
                                            }
                                        }
                                        F[b + 24 >> 2] = h;
                                        c = F[f + 16 >> 2];
                                        if (c) {
                                            F[b + 16 >> 2] = c;
                                            F[c + 24 >> 2] = b;
                                        }
                                        c = F[f + 20 >> 2];
                                        if (!c) {
                                            break g;
                                        }
                                        F[b + 20 >> 2] = c;
                                        F[c + 24 >> 2] = b;
                                    }
                                    F[d + 4 >> 2] = a | 1;
                                    F[a + d >> 2] = a;
                                    if (F[4238] != (d | 0)) {
                                        break f;
                                    }
                                    F[4235] = a;
                                    return;
                                }
                                F[f + 4 >> 2] = b & -2;
                                F[d + 4 >> 2] = a | 1;
                                F[a + d >> 2] = a;
                            }
                            if (a >>> 0 <= 255) {
                                a = a >>> 3 | 0;
                                b = (a << 3) + 16972 | 0;
                                c = F[4233];
                                a = 1 << a;
                                k: {
                                    if (!(c & a)) {
                                        F[4233] = a | c;
                                        a = b;
                                        break k;
                                    }
                                    a = F[b + 8 >> 2];
                                }
                                F[b + 8 >> 2] = d;
                                F[a + 12 >> 2] = d;
                                F[d + 12 >> 2] = b;
                                F[d + 8 >> 2] = a;
                                return;
                            }
                            e = 31;
                            F[d + 16 >> 2] = 0;
                            F[d + 20 >> 2] = 0;
                            if (a >>> 0 <= 16777215) {
                                b = a >>> 8 | 0;
                                g = b + 1048320 >>> 16 & 8;
                                b = b << g;
                                e = b + 520192 >>> 16 & 4;
                                b = b << e;
                                c = b + 245760 >>> 16 & 2;
                                b = (b << c >>> 15 | 0) - (c | (e | g)) | 0;
                                e = (b << 1 | a >>> b + 21 & 1) + 28 | 0;
                            }
                            F[d + 28 >> 2] = e;
                            g = (e << 2) + 17236 | 0;
                            l: {
                                m: {
                                    c = F[4234];
                                    b = 1 << e;
                                    n: {
                                        if (!(c & b)) {
                                            F[4234] = b | c;
                                            F[g >> 2] = d;
                                            F[d + 24 >> 2] = g;
                                            break n;
                                        }
                                        e = a << ((e | 0) == 31 ? 0 : 25 - (e >>> 1 | 0) | 0);
                                        b = F[g >> 2];
                                        while (1) {
                                            c = b;
                                            if ((F[b + 4 >> 2] & -8) == (a | 0)) {
                                                break m;
                                            }
                                            b = e >>> 29 | 0;
                                            e = e << 1;
                                            g = c + (b & 4) | 0;
                                            b = F[g + 16 >> 2];
                                            if (b) {
                                                continue;
                                            }
                                            break;
                                        }
                                        F[g + 16 >> 2] = d;
                                        F[d + 24 >> 2] = c;
                                    }
                                    F[d + 12 >> 2] = d;
                                    F[d + 8 >> 2] = d;
                                    break l;
                                }
                                a = F[c + 8 >> 2];
                                F[a + 12 >> 2] = d;
                                F[c + 8 >> 2] = d;
                                F[d + 24 >> 2] = 0;
                                F[d + 12 >> 2] = c;
                                F[d + 8 >> 2] = a;
                            }
                            a = F[4241] - 1 | 0;
                            F[4241] = a ? a : -1;
                        } }
                        function $c(a, b, c, d) { var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = M(0), l = 0, m = 0, n = M(0); j = F[c >> 2]; a: {
                            b: {
                                f = F[b + 4 >> 2];
                                if (!f) {
                                    break b;
                                }
                                g = Kj(f);
                                c: {
                                    if (g >>> 0 >= 2) {
                                        e = j;
                                        if (e >>> 0 >= f >>> 0) {
                                            e = (j >>> 0) % (f >>> 0) | 0;
                                        }
                                        c = F[F[b >> 2] + (e << 2) >> 2];
                                        if (!c) {
                                            break b;
                                        }
                                        if (g >>> 0 <= 1) {
                                            break c;
                                        }
                                        while (1) {
                                            c = F[c >> 2];
                                            if (!c) {
                                                break b;
                                            }
                                            g = F[c + 4 >> 2];
                                            if ((g | 0) != (j | 0)) {
                                                if (f >>> 0 <= g >>> 0) {
                                                    g = (g >>> 0) % (f >>> 0) | 0;
                                                }
                                                if ((e | 0) != (g | 0)) {
                                                    break b;
                                                }
                                            }
                                            if (F[c + 8 >> 2] != (j | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                        b = 0;
                                        break a;
                                    }
                                    e = f - 1 & j;
                                    c = F[F[b >> 2] + (e << 2) >> 2];
                                    if (!c) {
                                        break b;
                                    }
                                }
                                g = f - 1 | 0;
                                while (1) {
                                    c = F[c >> 2];
                                    if (!c) {
                                        break b;
                                    }
                                    h = F[c + 4 >> 2];
                                    if ((h | 0) != (j | 0) & (g & h) != (e | 0)) {
                                        break b;
                                    }
                                    if (F[c + 8 >> 2] != (j | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                b = 0;
                                break a;
                            }
                            c = sa(16);
                            d = F[F[d >> 2] >> 2];
                            F[c + 12 >> 2] = 0;
                            F[c + 8 >> 2] = d;
                            F[c + 4 >> 2] = j;
                            F[c >> 2] = 0;
                            n = M(F[b + 12 >> 2] + 1 >>> 0);
                            k = J[b + 16 >> 2];
                            d: {
                                if (n > M(k * M(f >>> 0)) ? 0 : f) {
                                    break d;
                                }
                                g = (f - 1 & f) != 0 | f >>> 0 < 3 | f << 1;
                                e = 2;
                                k = M(S(M(n / k)));
                                e: {
                                    if (k < M(4294967296) & k >= M(0)) {
                                        d = ~~k >>> 0;
                                        break e;
                                    }
                                    d = 0;
                                }
                                d = d >>> 0 > g >>> 0 ? d : g;
                                f: {
                                    if ((d | 0) == 1) {
                                        break f;
                                    }
                                    if (!(d & d - 1)) {
                                        e = d;
                                        break f;
                                    }
                                    e = Id(d);
                                    f = F[b + 4 >> 2];
                                }
                                g: {
                                    if (e >>> 0 <= f >>> 0) {
                                        if (e >>> 0 >= f >>> 0) {
                                            break g;
                                        }
                                        g = f >>> 0 < 3;
                                        k = M(S(M(M(I[b + 12 >> 2]) / J[b + 16 >> 2])));
                                        h: {
                                            if (k < M(4294967296) & k >= M(0)) {
                                                d = ~~k >>> 0;
                                                break h;
                                            }
                                            d = 0;
                                        }
                                        i: {
                                            j: {
                                                if (g) {
                                                    break j;
                                                }
                                                if (Kj(f) >>> 0 > 1) {
                                                    break j;
                                                }
                                                d = d >>> 0 < 2 ? d : 1 << 32 - O(d - 1 | 0);
                                                break i;
                                            }
                                            d = Id(d);
                                        }
                                        e = d >>> 0 > e >>> 0 ? d : e;
                                        if (e >>> 0 >= f >>> 0) {
                                            break g;
                                        }
                                    }
                                    f = 0;
                                    h = e;
                                    k: {
                                        l: {
                                            m: {
                                                n: {
                                                    if (e) {
                                                        if (h >>> 0 >= 1073741824) {
                                                            break n;
                                                        }
                                                        e = sa(h << 2);
                                                        d = F[b >> 2];
                                                        F[b >> 2] = e;
                                                        if (d) {
                                                            ra(d);
                                                        }
                                                        F[b + 4 >> 2] = h;
                                                        e = 0;
                                                        if (h - 1 >>> 0 >= 3) {
                                                            g = h & -4;
                                                            while (1) {
                                                                d = e << 2;
                                                                F[d + F[b >> 2] >> 2] = 0;
                                                                F[F[b >> 2] + (d | 4) >> 2] = 0;
                                                                F[F[b >> 2] + (d | 8) >> 2] = 0;
                                                                F[F[b >> 2] + (d | 12) >> 2] = 0;
                                                                e = e + 4 | 0;
                                                                f = f + 4 | 0;
                                                                if ((g | 0) != (f | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                        }
                                                        d = h & 3;
                                                        if (d) {
                                                            while (1) {
                                                                F[F[b >> 2] + (e << 2) >> 2] = 0;
                                                                e = e + 1 | 0;
                                                                i = i + 1 | 0;
                                                                if ((d | 0) != (i | 0)) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                        }
                                                        f = F[b + 8 >> 2];
                                                        if (!f) {
                                                            break k;
                                                        }
                                                        d = b + 8 | 0;
                                                        g = F[f + 4 >> 2];
                                                        e = Kj(h);
                                                        if (e >>> 0 < 2) {
                                                            break m;
                                                        }
                                                        g = g >>> 0 >= h >>> 0 ? (g >>> 0) % (h >>> 0) | 0 : g;
                                                        F[F[b >> 2] + (g << 2) >> 2] = d;
                                                        d = F[f >> 2];
                                                        if (!d) {
                                                            break k;
                                                        }
                                                        if (e >>> 0 <= 1) {
                                                            break l;
                                                        }
                                                        while (1) {
                                                            i = F[d + 4 >> 2];
                                                            if (h >>> 0 <= i >>> 0) {
                                                                i = (i >>> 0) % (h >>> 0) | 0;
                                                            }
                                                            o: {
                                                                if ((g | 0) == (i | 0)) {
                                                                    f = d;
                                                                    break o;
                                                                }
                                                                e = d;
                                                                l = i << 2;
                                                                m = l + F[b >> 2] | 0;
                                                                if (!F[m >> 2]) {
                                                                    F[m >> 2] = f;
                                                                    f = d;
                                                                    g = i;
                                                                    break o;
                                                                }
                                                                while (1) {
                                                                    i = e;
                                                                    e = F[e >> 2];
                                                                    if (F[d + 8 >> 2] == F[e + 8 >> 2] ? e : 0) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                F[f >> 2] = e;
                                                                F[i >> 2] = F[F[l + F[b >> 2] >> 2] >> 2];
                                                                F[F[l + F[b >> 2] >> 2] >> 2] = d;
                                                            }
                                                            d = F[f >> 2];
                                                            if (d) {
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        break k;
                                                    }
                                                    d = F[b >> 2];
                                                    F[b >> 2] = 0;
                                                    if (d) {
                                                        ra(d);
                                                    }
                                                    F[b + 4 >> 2] = 0;
                                                    break k;
                                                }
                                                wa(1336);
                                                V();
                                            }
                                            g = h - 1 & g;
                                            F[F[b >> 2] + (g << 2) >> 2] = d;
                                            d = F[f >> 2];
                                            if (!d) {
                                                break k;
                                            }
                                        }
                                        l = h - 1 | 0;
                                        while (1) {
                                            h = l & F[d + 4 >> 2];
                                            p: {
                                                if ((h | 0) == (g | 0)) {
                                                    f = d;
                                                    break p;
                                                }
                                                e = d;
                                                i = h << 2;
                                                m = i + F[b >> 2] | 0;
                                                if (F[m >> 2]) {
                                                    while (1) {
                                                        h = e;
                                                        e = F[e >> 2];
                                                        if (F[d + 8 >> 2] == F[e + 8 >> 2] ? e : 0) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    F[f >> 2] = e;
                                                    F[h >> 2] = F[F[i + F[b >> 2] >> 2] >> 2];
                                                    F[F[i + F[b >> 2] >> 2] >> 2] = d;
                                                    break p;
                                                }
                                                F[m >> 2] = f;
                                                f = d;
                                                g = h;
                                            }
                                            d = F[f >> 2];
                                            if (d) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                }
                                f = F[b + 4 >> 2];
                                d = f - 1 | 0;
                                if (!(d & f)) {
                                    e = d & j;
                                    break d;
                                }
                                if (f >>> 0 > j >>> 0) {
                                    e = j;
                                    break d;
                                }
                                e = (j >>> 0) % (f >>> 0) | 0;
                            }
                            e = F[b >> 2] + (e << 2) | 0;
                            d = F[e >> 2];
                            q: {
                                if (!d) {
                                    F[c >> 2] = F[b + 8 >> 2];
                                    F[b + 8 >> 2] = c;
                                    F[e >> 2] = b + 8;
                                    d = F[c >> 2];
                                    if (!d) {
                                        break q;
                                    }
                                    d = F[d + 4 >> 2];
                                    e = f - 1 | 0;
                                    r: {
                                        if (!(e & f)) {
                                            d = d & e;
                                            break r;
                                        }
                                        if (d >>> 0 < f >>> 0) {
                                            break r;
                                        }
                                        d = (d >>> 0) % (f >>> 0) | 0;
                                    }
                                    F[F[b >> 2] + (d << 2) >> 2] = c;
                                    break q;
                                }
                                F[c >> 2] = F[d >> 2];
                                F[d >> 2] = c;
                            }
                            F[b + 12 >> 2] = F[b + 12 >> 2] + 1;
                            b = 1;
                        } D[a + 4 | 0] = b; F[a >> 2] = c; }
                        function mj(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0; F[a + 8 >> 2] = e; d = a + 32 | 0; k = F[d >> 2]; f = F[a + 36 >> 2] - k >> 2; a: {
                            if (f >>> 0 < e >>> 0) {
                                Aa(d, e - f | 0);
                                k = F[d >> 2];
                                d = F[a + 8 >> 2];
                                break a;
                            }
                            if (e >>> 0 < f >>> 0) {
                                F[a + 36 >> 2] = (e << 2) + k;
                            }
                            d = e;
                        } q = F[a + 52 >> 2]; n = F[a + 48 >> 2]; f = 0; m = (e & 1073741823) != (e | 0) ? -1 : e << 2; m = ua(sa(m), 0, m); b: {
                            if ((d | 0) <= 0) {
                                break b;
                            }
                            while (1) {
                                d = f << 2;
                                g = F[d + m >> 2];
                                i = F[a + 16 >> 2];
                                c: {
                                    if ((g | 0) > (i | 0)) {
                                        F[d + k >> 2] = i;
                                        break c;
                                    }
                                    d = d + k | 0;
                                    i = F[a + 12 >> 2];
                                    if ((i | 0) > (g | 0)) {
                                        F[d >> 2] = i;
                                        break c;
                                    }
                                    F[d >> 2] = g;
                                }
                                d = F[a + 8 >> 2];
                                f = f + 1 | 0;
                                if ((d | 0) > (f | 0)) {
                                    continue;
                                }
                                break;
                            }
                            if ((d | 0) <= 0) {
                                break b;
                            }
                            f = 0;
                            while (1) {
                                g = f << 2;
                                d = g + c | 0;
                                g = F[b + g >> 2] + F[g + k >> 2] | 0;
                                F[d >> 2] = g;
                                d: {
                                    if ((g | 0) > F[a + 16 >> 2]) {
                                        h = g - F[a + 20 >> 2] | 0;
                                    }
                                    else {
                                        if ((g | 0) >= F[a + 12 >> 2]) {
                                            break d;
                                        }
                                        h = g + F[a + 20 >> 2] | 0;
                                    }
                                    F[d >> 2] = h;
                                }
                                d = F[a + 8 >> 2];
                                f = f + 1 | 0;
                                if ((d | 0) > (f | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } f = F[a + 56 >> 2]; o = F[f >> 2]; f = F[f + 4 >> 2] - o | 0; if ((f | 0) >= 5) {
                            f = f >> 2;
                            r = (f | 0) > 2 ? f : 2;
                            s = f >>> 0 > 1 ? f : 1;
                            t = e & -2;
                            u = e & 1;
                            k = 1;
                            while (1) {
                                e: {
                                    f: {
                                        if ((k | 0) != (s | 0)) {
                                            p = L(e, k);
                                            f = F[(k << 2) + o >> 2];
                                            if ((f | 0) == -1) {
                                                break f;
                                            }
                                            f = F[F[n + 12 >> 2] + (f << 2) >> 2];
                                            if ((f | 0) == -1) {
                                                break f;
                                            }
                                            i = F[q >> 2];
                                            g = F[n >> 2];
                                            j = F[i + (F[g + (f << 2) >> 2] << 2) >> 2];
                                            h = f + 1 | 0;
                                            h = (h >>> 0) % 3 | 0 ? h : f - 2 | 0;
                                            if ((h | 0) != -1) {
                                                h = F[g + (h << 2) >> 2];
                                            }
                                            else {
                                                h = -1;
                                            }
                                            g: {
                                                h: {
                                                    if ((f >>> 0) % 3 | 0) {
                                                        f = f - 1 | 0;
                                                        break h;
                                                    }
                                                    f = f + 2 | 0;
                                                    l = -1;
                                                    if ((f | 0) == -1) {
                                                        break g;
                                                    }
                                                }
                                                l = F[g + (f << 2) >> 2];
                                            }
                                            if ((j | 0) >= (k | 0)) {
                                                break f;
                                            }
                                            f = F[(h << 2) + i >> 2];
                                            if ((f | 0) >= (k | 0)) {
                                                break f;
                                            }
                                            g = F[i + (l << 2) >> 2];
                                            if ((g | 0) >= (k | 0)) {
                                                break f;
                                            }
                                            i: {
                                                if ((e | 0) <= 0) {
                                                    break i;
                                                }
                                                g = L(e, g);
                                                i = L(e, f);
                                                j = L(e, j);
                                                f = 0;
                                                l = 0;
                                                if ((e | 0) != 1) {
                                                    while (1) {
                                                        F[m + (f << 2) >> 2] = (F[(f + g << 2) + c >> 2] + F[(f + i << 2) + c >> 2] | 0) - F[(f + j << 2) + c >> 2];
                                                        h = f | 1;
                                                        F[m + (h << 2) >> 2] = (F[(g + h << 2) + c >> 2] + F[(i + h << 2) + c >> 2] | 0) - F[(h + j << 2) + c >> 2];
                                                        f = f + 2 | 0;
                                                        l = l + 2 | 0;
                                                        if ((t | 0) != (l | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if (!u) {
                                                    break i;
                                                }
                                                F[m + (f << 2) >> 2] = (F[(f + g << 2) + c >> 2] + F[(f + i << 2) + c >> 2] | 0) - F[(f + j << 2) + c >> 2];
                                            }
                                            if ((d | 0) <= 0) {
                                                break e;
                                            }
                                            i = F[a + 32 >> 2];
                                            f = 0;
                                            while (1) {
                                                d = f << 2;
                                                g = F[d + m >> 2];
                                                j = F[a + 16 >> 2];
                                                j: {
                                                    if ((g | 0) > (j | 0)) {
                                                        F[d + i >> 2] = j;
                                                        break j;
                                                    }
                                                    d = d + i | 0;
                                                    j = F[a + 12 >> 2];
                                                    if ((j | 0) > (g | 0)) {
                                                        F[d >> 2] = j;
                                                        break j;
                                                    }
                                                    F[d >> 2] = g;
                                                }
                                                d = F[a + 8 >> 2];
                                                f = f + 1 | 0;
                                                if ((d | 0) > (f | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            f = 0;
                                            if ((d | 0) <= 0) {
                                                break e;
                                            }
                                            d = p << 2;
                                            j = d + c | 0;
                                            h = b + d | 0;
                                            while (1) {
                                                g = f << 2;
                                                d = g + j | 0;
                                                g = F[g + h >> 2] + F[g + i >> 2] | 0;
                                                F[d >> 2] = g;
                                                k: {
                                                    if ((g | 0) > F[a + 16 >> 2]) {
                                                        l = g - F[a + 20 >> 2] | 0;
                                                    }
                                                    else {
                                                        if ((g | 0) >= F[a + 12 >> 2]) {
                                                            break k;
                                                        }
                                                        l = g + F[a + 20 >> 2] | 0;
                                                    }
                                                    F[d >> 2] = l;
                                                }
                                                d = F[a + 8 >> 2];
                                                f = f + 1 | 0;
                                                if ((d | 0) > (f | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            break e;
                                        }
                                        Da();
                                        V();
                                    }
                                    if ((d | 0) <= 0) {
                                        break e;
                                    }
                                    j = (L(k - 1 | 0, e) << 2) + c | 0;
                                    i = F[a + 32 >> 2];
                                    f = 0;
                                    while (1) {
                                        d = f << 2;
                                        g = F[d + j >> 2];
                                        h = F[a + 16 >> 2];
                                        l: {
                                            if ((g | 0) > (h | 0)) {
                                                F[d + i >> 2] = h;
                                                break l;
                                            }
                                            d = d + i | 0;
                                            h = F[a + 12 >> 2];
                                            if ((h | 0) > (g | 0)) {
                                                F[d >> 2] = h;
                                                break l;
                                            }
                                            F[d >> 2] = g;
                                        }
                                        d = F[a + 8 >> 2];
                                        f = f + 1 | 0;
                                        if ((d | 0) > (f | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                    f = 0;
                                    if ((d | 0) <= 0) {
                                        break e;
                                    }
                                    d = p << 2;
                                    j = d + c | 0;
                                    h = b + d | 0;
                                    while (1) {
                                        g = f << 2;
                                        d = g + j | 0;
                                        g = F[g + h >> 2] + F[g + i >> 2] | 0;
                                        F[d >> 2] = g;
                                        m: {
                                            if ((g | 0) > F[a + 16 >> 2]) {
                                                l = g - F[a + 20 >> 2] | 0;
                                            }
                                            else {
                                                if ((g | 0) >= F[a + 12 >> 2]) {
                                                    break m;
                                                }
                                                l = g + F[a + 20 >> 2] | 0;
                                            }
                                            F[d >> 2] = l;
                                        }
                                        d = F[a + 8 >> 2];
                                        f = f + 1 | 0;
                                        if ((d | 0) > (f | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                k = k + 1 | 0;
                                if ((r | 0) != (k | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } ra(m); return 1; }
                        function Hc(a) { var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0; F[a + 56 >> 2] = F[a + 52 >> 2]; F[a + 44 >> 2] = F[a + 40 >> 2]; a: {
                            b: {
                                c: {
                                    e = F[a + 64 >> 2];
                                    c = F[e + 24 >> 2];
                                    if ((c | 0) != F[e + 28 >> 2]) {
                                        while (1) {
                                            d = b;
                                            i = F[(j << 2) + c >> 2];
                                            d: {
                                                if ((i | 0) == -1) {
                                                    break d;
                                                }
                                                b = F[a + 56 >> 2];
                                                e: {
                                                    if ((b | 0) != F[a + 60 >> 2]) {
                                                        F[b >> 2] = d;
                                                        F[a + 56 >> 2] = b + 4;
                                                        break e;
                                                    }
                                                    e = F[a + 52 >> 2];
                                                    c = b - e | 0;
                                                    g = c >> 2;
                                                    b = g + 1 | 0;
                                                    if (b >>> 0 >= 1073741824) {
                                                        break c;
                                                    }
                                                    f = c >> 1;
                                                    f = c >>> 0 < 2147483644 ? b >>> 0 > f >>> 0 ? b : f : 1073741823;
                                                    if (f) {
                                                        if (f >>> 0 >= 1073741824) {
                                                            break a;
                                                        }
                                                        b = sa(f << 2);
                                                    }
                                                    else {
                                                        b = 0;
                                                    }
                                                    g = b + (g << 2) | 0;
                                                    F[g >> 2] = d;
                                                    if ((c | 0) > 0) {
                                                        ta(b, e, c);
                                                    }
                                                    F[a + 60 >> 2] = b + (f << 2);
                                                    F[a + 56 >> 2] = g + 4;
                                                    F[a + 52 >> 2] = b;
                                                    if (!e) {
                                                        break e;
                                                    }
                                                    ra(e);
                                                }
                                                f: {
                                                    if (!(F[F[a + 12 >> 2] + (j >>> 3 & 536870908) >> 2] >>> j & 1)) {
                                                        break f;
                                                    }
                                                    b = i + 1 | 0;
                                                    b = (b >>> 0) % 3 | 0 ? b : i - 2 | 0;
                                                    if ((b | 0) == -1) {
                                                        break f;
                                                    }
                                                    e = F[a >> 2];
                                                    if (F[e + (b >>> 3 & 536870908) >> 2] >>> b & 1) {
                                                        break f;
                                                    }
                                                    b = F[F[F[a + 64 >> 2] + 12 >> 2] + (b << 2) >> 2];
                                                    if ((b | 0) == -1) {
                                                        break f;
                                                    }
                                                    c = b + 1 | 0;
                                                    c = (c >>> 0) % 3 | 0 ? c : b - 2 | 0;
                                                    if ((c | 0) == -1) {
                                                        break f;
                                                    }
                                                    f = F[a + 64 >> 2];
                                                    while (1) {
                                                        i = c;
                                                        b = c + 1 | 0;
                                                        b = (b >>> 0) % 3 | 0 ? b : c - 2 | 0;
                                                        if ((b | 0) == -1 | F[e + (b >>> 3 & 536870908) >> 2] >>> b & 1) {
                                                            break f;
                                                        }
                                                        b = F[F[f + 12 >> 2] + (b << 2) >> 2];
                                                        if ((b | 0) == -1) {
                                                            break f;
                                                        }
                                                        c = b + 1 | 0;
                                                        c = (c >>> 0) % 3 | 0 ? c : b - 2 | 0;
                                                        if ((c | 0) != -1) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                F[F[a + 28 >> 2] + (i << 2) >> 2] = d;
                                                b = F[a + 44 >> 2];
                                                g: {
                                                    if ((b | 0) != F[a + 48 >> 2]) {
                                                        F[b >> 2] = i;
                                                        F[a + 44 >> 2] = b + 4;
                                                        break g;
                                                    }
                                                    e = F[a + 40 >> 2];
                                                    c = b - e | 0;
                                                    g = c >> 2;
                                                    b = g + 1 | 0;
                                                    if (b >>> 0 >= 1073741824) {
                                                        break b;
                                                    }
                                                    f = c >> 1;
                                                    f = c >>> 0 < 2147483644 ? b >>> 0 > f >>> 0 ? b : f : 1073741823;
                                                    if (f) {
                                                        if (f >>> 0 >= 1073741824) {
                                                            break a;
                                                        }
                                                        b = sa(f << 2);
                                                    }
                                                    else {
                                                        b = 0;
                                                    }
                                                    g = b + (g << 2) | 0;
                                                    F[g >> 2] = i;
                                                    if ((c | 0) > 0) {
                                                        ta(b, e, c);
                                                    }
                                                    F[a + 48 >> 2] = b + (f << 2);
                                                    F[a + 44 >> 2] = g + 4;
                                                    F[a + 40 >> 2] = b;
                                                    if (!e) {
                                                        break g;
                                                    }
                                                    ra(e);
                                                }
                                                b = d + 1 | 0;
                                                e = F[a + 64 >> 2];
                                                h: {
                                                    if ((i >>> 0) % 3 | 0) {
                                                        c = i - 1 | 0;
                                                        break h;
                                                    }
                                                    c = i + 2 | 0;
                                                    if ((c | 0) == -1) {
                                                        break d;
                                                    }
                                                }
                                                c = F[F[e + 12 >> 2] + (c << 2) >> 2];
                                                if ((c | 0) == -1) {
                                                    break d;
                                                }
                                                c = c + ((c >>> 0) % 3 | 0 ? -1 : 2) | 0;
                                                if ((c | 0) == -1 | (c | 0) == (i | 0)) {
                                                    break d;
                                                }
                                                while (1) {
                                                    e = c + 1 | 0;
                                                    e = (e >>> 0) % 3 | 0 ? e : c - 2 | 0;
                                                    if (F[F[a >> 2] + (e >>> 3 & 536870908) >> 2] >>> e & 1) {
                                                        d = F[a + 56 >> 2];
                                                        i: {
                                                            if ((d | 0) != F[a + 60 >> 2]) {
                                                                F[d >> 2] = b;
                                                                F[a + 56 >> 2] = d + 4;
                                                                break i;
                                                            }
                                                            f = F[a + 52 >> 2];
                                                            e = d - f | 0;
                                                            h = e >> 2;
                                                            d = h + 1 | 0;
                                                            if (d >>> 0 >= 1073741824) {
                                                                break c;
                                                            }
                                                            g = e >> 1;
                                                            g = e >>> 0 < 2147483644 ? d >>> 0 > g >>> 0 ? d : g : 1073741823;
                                                            if (g) {
                                                                if (g >>> 0 >= 1073741824) {
                                                                    break a;
                                                                }
                                                                d = sa(g << 2);
                                                            }
                                                            else {
                                                                d = 0;
                                                            }
                                                            h = d + (h << 2) | 0;
                                                            F[h >> 2] = b;
                                                            if ((e | 0) > 0) {
                                                                ta(d, f, e);
                                                            }
                                                            F[a + 60 >> 2] = d + (g << 2);
                                                            F[a + 56 >> 2] = h + 4;
                                                            F[a + 52 >> 2] = d;
                                                            if (!f) {
                                                                break i;
                                                            }
                                                            ra(f);
                                                        }
                                                        e = b + 1 | 0;
                                                        d = F[a + 44 >> 2];
                                                        j: {
                                                            if ((d | 0) != F[a + 48 >> 2]) {
                                                                F[d >> 2] = c;
                                                                F[a + 44 >> 2] = d + 4;
                                                                break j;
                                                            }
                                                            g = F[a + 40 >> 2];
                                                            f = d - g | 0;
                                                            k = f >> 2;
                                                            d = k + 1 | 0;
                                                            if (d >>> 0 >= 1073741824) {
                                                                break b;
                                                            }
                                                            h = f >> 1;
                                                            h = f >>> 0 < 2147483644 ? d >>> 0 > h >>> 0 ? d : h : 1073741823;
                                                            if (h) {
                                                                if (h >>> 0 >= 1073741824) {
                                                                    break a;
                                                                }
                                                                d = sa(h << 2);
                                                            }
                                                            else {
                                                                d = 0;
                                                            }
                                                            k = d + (k << 2) | 0;
                                                            F[k >> 2] = c;
                                                            if ((f | 0) > 0) {
                                                                ta(d, g, f);
                                                            }
                                                            F[a + 48 >> 2] = d + (h << 2);
                                                            F[a + 44 >> 2] = k + 4;
                                                            F[a + 40 >> 2] = d;
                                                            if (!g) {
                                                                break j;
                                                            }
                                                            ra(g);
                                                        }
                                                        d = b;
                                                        b = e;
                                                    }
                                                    F[F[a + 28 >> 2] + (c << 2) >> 2] = d;
                                                    e = F[a + 64 >> 2];
                                                    k: {
                                                        if ((c >>> 0) % 3 | 0) {
                                                            c = c - 1 | 0;
                                                            break k;
                                                        }
                                                        c = c + 2 | 0;
                                                        if ((c | 0) == -1) {
                                                            break d;
                                                        }
                                                    }
                                                    c = F[F[e + 12 >> 2] + (c << 2) >> 2];
                                                    if ((c | 0) == -1) {
                                                        break d;
                                                    }
                                                    c = c + ((c >>> 0) % 3 | 0 ? -1 : 2) | 0;
                                                    if ((c | 0) == -1) {
                                                        break d;
                                                    }
                                                    if ((c | 0) != (i | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            j = j + 1 | 0;
                                            c = F[e + 24 >> 2];
                                            if (j >>> 0 < F[e + 28 >> 2] - c >> 2 >>> 0) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    return;
                                }
                                va();
                                V();
                            }
                            va();
                            V();
                        } wa(1336); V(); }
                        function Cj(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0; F[a + 8 >> 2] = e; d = a + 32 | 0; k = F[d >> 2]; f = F[a + 36 >> 2] - k >> 2; a: {
                            if (f >>> 0 < e >>> 0) {
                                Aa(d, e - f | 0);
                                k = F[d >> 2];
                                d = F[a + 8 >> 2];
                                break a;
                            }
                            if (e >>> 0 < f >>> 0) {
                                F[a + 36 >> 2] = (e << 2) + k;
                            }
                            d = e;
                        } q = F[a + 52 >> 2]; m = F[a + 48 >> 2]; f = 0; l = (e & 1073741823) != (e | 0) ? -1 : e << 2; l = ua(sa(l), 0, l); b: {
                            if ((d | 0) <= 0) {
                                break b;
                            }
                            while (1) {
                                d = f << 2;
                                g = F[d + l >> 2];
                                h = F[a + 16 >> 2];
                                c: {
                                    if ((g | 0) > (h | 0)) {
                                        F[d + k >> 2] = h;
                                        break c;
                                    }
                                    d = d + k | 0;
                                    h = F[a + 12 >> 2];
                                    if ((h | 0) > (g | 0)) {
                                        F[d >> 2] = h;
                                        break c;
                                    }
                                    F[d >> 2] = g;
                                }
                                d = F[a + 8 >> 2];
                                f = f + 1 | 0;
                                if ((d | 0) > (f | 0)) {
                                    continue;
                                }
                                break;
                            }
                            if ((d | 0) <= 0) {
                                break b;
                            }
                            f = 0;
                            while (1) {
                                g = f << 2;
                                d = g + c | 0;
                                g = F[b + g >> 2] + F[g + k >> 2] | 0;
                                F[d >> 2] = g;
                                d: {
                                    if ((g | 0) > F[a + 16 >> 2]) {
                                        g = g - F[a + 20 >> 2] | 0;
                                    }
                                    else {
                                        if ((g | 0) >= F[a + 12 >> 2]) {
                                            break d;
                                        }
                                        g = g + F[a + 20 >> 2] | 0;
                                    }
                                    F[d >> 2] = g;
                                }
                                d = F[a + 8 >> 2];
                                f = f + 1 | 0;
                                if ((d | 0) > (f | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } f = F[a + 56 >> 2]; o = F[f >> 2]; f = F[f + 4 >> 2] - o | 0; if ((f | 0) >= 5) {
                            f = f >> 2;
                            r = (f | 0) > 2 ? f : 2;
                            s = f >>> 0 > 1 ? f : 1;
                            t = e & -2;
                            u = e & 1;
                            k = 1;
                            while (1) {
                                e: {
                                    f: {
                                        if ((k | 0) != (s | 0)) {
                                            p = L(e, k);
                                            f = F[(k << 2) + o >> 2];
                                            if ((f | 0) == -1 | F[F[m >> 2] + (f >>> 3 & 536870908) >> 2] >>> f & 1) {
                                                break f;
                                            }
                                            f = F[F[F[m + 64 >> 2] + 12 >> 2] + (f << 2) >> 2];
                                            if ((f | 0) == -1) {
                                                break f;
                                            }
                                            h = F[q >> 2];
                                            g = F[m + 28 >> 2];
                                            j = F[h + (F[g + (f << 2) >> 2] << 2) >> 2];
                                            if ((j | 0) >= (k | 0)) {
                                                break f;
                                            }
                                            i = f + 1 | 0;
                                            i = F[h + (F[g + (((i >>> 0) % 3 | 0 ? i : f - 2 | 0) << 2) >> 2] << 2) >> 2];
                                            if ((i | 0) >= (k | 0)) {
                                                break f;
                                            }
                                            f = F[h + (F[g + (f + ((f >>> 0) % 3 | 0 ? -1 : 2) << 2) >> 2] << 2) >> 2];
                                            if ((f | 0) >= (k | 0)) {
                                                break f;
                                            }
                                            g: {
                                                if ((e | 0) <= 0) {
                                                    break g;
                                                }
                                                g = L(e, f);
                                                h = L(e, i);
                                                j = L(e, j);
                                                f = 0;
                                                n = 0;
                                                if ((e | 0) != 1) {
                                                    while (1) {
                                                        F[l + (f << 2) >> 2] = (F[(f + g << 2) + c >> 2] + F[(f + h << 2) + c >> 2] | 0) - F[(f + j << 2) + c >> 2];
                                                        i = f | 1;
                                                        F[l + (i << 2) >> 2] = (F[(g + i << 2) + c >> 2] + F[(h + i << 2) + c >> 2] | 0) - F[(j + i << 2) + c >> 2];
                                                        f = f + 2 | 0;
                                                        n = n + 2 | 0;
                                                        if ((t | 0) != (n | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if (!u) {
                                                    break g;
                                                }
                                                F[l + (f << 2) >> 2] = (F[(f + g << 2) + c >> 2] + F[(f + h << 2) + c >> 2] | 0) - F[(f + j << 2) + c >> 2];
                                            }
                                            if ((d | 0) <= 0) {
                                                break e;
                                            }
                                            h = F[a + 32 >> 2];
                                            f = 0;
                                            while (1) {
                                                d = f << 2;
                                                g = F[d + l >> 2];
                                                j = F[a + 16 >> 2];
                                                h: {
                                                    if ((g | 0) > (j | 0)) {
                                                        F[d + h >> 2] = j;
                                                        break h;
                                                    }
                                                    d = d + h | 0;
                                                    j = F[a + 12 >> 2];
                                                    if ((j | 0) > (g | 0)) {
                                                        F[d >> 2] = j;
                                                        break h;
                                                    }
                                                    F[d >> 2] = g;
                                                }
                                                d = F[a + 8 >> 2];
                                                f = f + 1 | 0;
                                                if ((d | 0) > (f | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            f = 0;
                                            if ((d | 0) <= 0) {
                                                break e;
                                            }
                                            d = p << 2;
                                            j = d + c | 0;
                                            i = b + d | 0;
                                            while (1) {
                                                g = f << 2;
                                                d = g + j | 0;
                                                g = F[g + i >> 2] + F[g + h >> 2] | 0;
                                                F[d >> 2] = g;
                                                i: {
                                                    if ((g | 0) > F[a + 16 >> 2]) {
                                                        g = g - F[a + 20 >> 2] | 0;
                                                    }
                                                    else {
                                                        if ((g | 0) >= F[a + 12 >> 2]) {
                                                            break i;
                                                        }
                                                        g = g + F[a + 20 >> 2] | 0;
                                                    }
                                                    F[d >> 2] = g;
                                                }
                                                d = F[a + 8 >> 2];
                                                f = f + 1 | 0;
                                                if ((d | 0) > (f | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            break e;
                                        }
                                        Da();
                                        V();
                                    }
                                    if ((d | 0) <= 0) {
                                        break e;
                                    }
                                    j = (L(k - 1 | 0, e) << 2) + c | 0;
                                    h = F[a + 32 >> 2];
                                    f = 0;
                                    while (1) {
                                        d = f << 2;
                                        g = F[d + j >> 2];
                                        i = F[a + 16 >> 2];
                                        j: {
                                            if ((g | 0) > (i | 0)) {
                                                F[d + h >> 2] = i;
                                                break j;
                                            }
                                            d = d + h | 0;
                                            i = F[a + 12 >> 2];
                                            if ((i | 0) > (g | 0)) {
                                                F[d >> 2] = i;
                                                break j;
                                            }
                                            F[d >> 2] = g;
                                        }
                                        d = F[a + 8 >> 2];
                                        f = f + 1 | 0;
                                        if ((d | 0) > (f | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                    f = 0;
                                    if ((d | 0) <= 0) {
                                        break e;
                                    }
                                    d = p << 2;
                                    j = d + c | 0;
                                    i = b + d | 0;
                                    while (1) {
                                        g = f << 2;
                                        d = g + j | 0;
                                        g = F[g + i >> 2] + F[g + h >> 2] | 0;
                                        F[d >> 2] = g;
                                        k: {
                                            if ((g | 0) > F[a + 16 >> 2]) {
                                                g = g - F[a + 20 >> 2] | 0;
                                            }
                                            else {
                                                if ((g | 0) >= F[a + 12 >> 2]) {
                                                    break k;
                                                }
                                                g = g + F[a + 20 >> 2] | 0;
                                            }
                                            F[d >> 2] = g;
                                        }
                                        d = F[a + 8 >> 2];
                                        f = f + 1 | 0;
                                        if ((d | 0) > (f | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                k = k + 1 | 0;
                                if ((r | 0) != (k | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } ra(l); return 1; }
                        function te(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0; if ((b | 0) == -1) {
                            return 1;
                        } c = (b >>> 0) / 3 | 0; if (!(F[F[a + 24 >> 2] + (c >>> 3 & 268435452) >> 2] >>> c & 1)) {
                            d = F[a + 48 >> 2];
                            F[a + 52 >> 2] = d;
                            a: {
                                if ((d | 0) != F[a + 56 >> 2]) {
                                    F[d >> 2] = b;
                                    F[a + 52 >> 2] = d + 4;
                                    break a;
                                }
                                e = sa(4);
                                F[e >> 2] = b;
                                f = e + 4 | 0;
                                F[a + 56 >> 2] = f;
                                F[a + 52 >> 2] = f;
                                F[a + 48 >> 2] = e;
                                if (!d) {
                                    break a;
                                }
                                ra(d);
                            }
                            f = F[F[a + 4 >> 2] + 28 >> 2];
                            d = b + 1 | 0;
                            e = (d >>> 0) % 3 | 0 ? d : b - 2 | 0;
                            d = F[f + (e << 2) >> 2];
                            if ((d | 0) == -1) {
                                return 0;
                            }
                            g = (b - L(c, 3) | 0 ? -1 : 2) + b | 0;
                            c = F[f + (g << 2) >> 2];
                            if ((c | 0) == -1) {
                                return 0;
                            }
                            b = F[a + 36 >> 2];
                            f = b + (d >>> 3 & 536870908) | 0;
                            h = F[f >> 2];
                            i = 1 << d;
                            if (!(h & i)) {
                                F[f >> 2] = h | i;
                                Xa(a + 8 | 0, d, e);
                                b = F[a + 36 >> 2];
                            }
                            b = (c >>> 3 & 536870908) + b | 0;
                            d = F[b >> 2];
                            e = 1 << c;
                            if (!(d & e)) {
                                F[b >> 2] = d | e;
                                Xa(a + 8 | 0, c, g);
                            }
                            c = F[a + 52 >> 2];
                            if ((c | 0) == F[a + 48 >> 2]) {
                                return 1;
                            }
                            k = a + 8 | 0;
                            while (1) {
                                c = c - 4 | 0;
                                b = F[c >> 2];
                                d = (b >>> 0) / 3 | 0;
                                b: {
                                    c: {
                                        if ((b | 0) == -1) {
                                            break c;
                                        }
                                        e = F[a + 24 >> 2] + (d >>> 3 & 268435452) | 0;
                                        f = F[e >> 2];
                                        d = 1 << d;
                                        if (f & d) {
                                            break c;
                                        }
                                        F[e >> 2] = d | f;
                                        e = F[a + 4 >> 2];
                                        d = F[F[e + 28 >> 2] + (b << 2) >> 2];
                                        if ((d | 0) == -1) {
                                            return 0;
                                        }
                                        while (1) {
                                            c = b;
                                            d: {
                                                e: {
                                                    f = F[a + 36 >> 2] + (d >>> 3 & 536870908) | 0;
                                                    g = F[f >> 2];
                                                    h = 1 << d;
                                                    if (g & h) {
                                                        break e;
                                                    }
                                                    f: {
                                                        b = F[F[e + 40 >> 2] + (d << 2) >> 2];
                                                        g: {
                                                            if ((b | 0) == -1) {
                                                                break g;
                                                            }
                                                            i = b + 1 | 0;
                                                            b = (i >>> 0) % 3 | 0 ? i : b - 2 | 0;
                                                            if ((b | 0) == -1 | F[F[e >> 2] + (b >>> 3 & 536870908) >> 2] >>> b & 1) {
                                                                break g;
                                                            }
                                                            b = F[F[F[e + 64 >> 2] + 12 >> 2] + (b << 2) >> 2];
                                                            if ((b | 0) != -1) {
                                                                break f;
                                                            }
                                                        }
                                                        F[f >> 2] = g | h;
                                                        Xa(k, d, c);
                                                        break e;
                                                    }
                                                    F[f >> 2] = g | h;
                                                    Xa(k, d, c);
                                                    d = b + 1 | 0;
                                                    if ((((d >>> 0) % 3 | 0 ? d : b - 2 | 0) | 0) == -1) {
                                                        break e;
                                                    }
                                                    b = -1;
                                                    e = F[a + 4 >> 2];
                                                    h: {
                                                        if ((c | 0) == -1) {
                                                            break h;
                                                        }
                                                        d = c + 1 | 0;
                                                        d = (d >>> 0) % 3 | 0 ? d : c - 2 | 0;
                                                        if ((d | 0) == -1 | F[F[e >> 2] + (d >>> 3 & 536870908) >> 2] >>> d & 1) {
                                                            break h;
                                                        }
                                                        b = F[F[F[e + 64 >> 2] + 12 >> 2] + (d << 2) >> 2];
                                                    }
                                                    d = (b >>> 0) / 3 | 0;
                                                    h = 1 << d;
                                                    c = F[a + 24 >> 2];
                                                    i = d >>> 5 | 0;
                                                    f = F[c + (i << 2) >> 2];
                                                    break d;
                                                }
                                                i: {
                                                    j: {
                                                        if ((c | 0) == -1) {
                                                            break j;
                                                        }
                                                        d = -1;
                                                        b = c + 1 | 0;
                                                        b = (b >>> 0) % 3 | 0 ? b : c - 2 | 0;
                                                        e = F[a + 4 >> 2];
                                                        if (!((b | 0) == -1 | F[F[e >> 2] + (b >>> 3 & 536870908) >> 2] >>> b & 1)) {
                                                            d = F[F[F[e + 64 >> 2] + 12 >> 2] + (b << 2) >> 2];
                                                        }
                                                        k: {
                                                            l: {
                                                                if ((c >>> 0) % 3 | 0) {
                                                                    c = c - 1 | 0;
                                                                    break l;
                                                                }
                                                                c = c + 2 | 0;
                                                                b = -1;
                                                                if ((c | 0) == -1) {
                                                                    break k;
                                                                }
                                                            }
                                                            b = -1;
                                                            if (F[F[e >> 2] + (c >>> 3 & 536870908) >> 2] >>> c & 1) {
                                                                break k;
                                                            }
                                                            b = F[F[F[e + 64 >> 2] + 12 >> 2] + (c << 2) >> 2];
                                                        }
                                                        j = (b | 0) == -1;
                                                        g = j ? -1 : (b >>> 0) / 3 | 0;
                                                        f = (d >>> 0) / 3 | 0;
                                                        h = (d | 0) == -1;
                                                        if (!h) {
                                                            c = F[a + 24 >> 2];
                                                            h = h ? -1 : f;
                                                            i = h >>> 5 | 0;
                                                            f = F[c + (i << 2) >> 2];
                                                            h = 1 << h;
                                                            if (!(f & h)) {
                                                                break i;
                                                            }
                                                        }
                                                        if (j) {
                                                            break j;
                                                        }
                                                        h = 1 << g;
                                                        c = F[a + 24 >> 2];
                                                        i = g >>> 5 | 0;
                                                        f = F[c + (i << 2) >> 2];
                                                        if (!(h & f)) {
                                                            break d;
                                                        }
                                                    }
                                                    c = F[a + 52 >> 2] - 4 | 0;
                                                    F[a + 52 >> 2] = c;
                                                    break b;
                                                }
                                                if (j) {
                                                    b = d;
                                                    break d;
                                                }
                                                if (F[(g >>> 3 & 536870908) + c >> 2] >>> g & 1) {
                                                    b = d;
                                                    break d;
                                                }
                                                c = F[a + 52 >> 2];
                                                F[c - 4 >> 2] = b;
                                                if ((c | 0) != F[a + 56 >> 2]) {
                                                    F[c >> 2] = d;
                                                    c = c + 4 | 0;
                                                    break c;
                                                }
                                                m: {
                                                    f = F[a + 48 >> 2];
                                                    e = c - f | 0;
                                                    c = e >> 2;
                                                    b = c + 1 | 0;
                                                    if (b >>> 0 < 1073741824) {
                                                        g = e >> 1;
                                                        g = e >>> 0 < 2147483644 ? b >>> 0 > g >>> 0 ? b : g : 1073741823;
                                                        if (g) {
                                                            if (g >>> 0 >= 1073741824) {
                                                                break m;
                                                            }
                                                            b = sa(g << 2);
                                                        }
                                                        else {
                                                            b = 0;
                                                        }
                                                        c = b + (c << 2) | 0;
                                                        F[c >> 2] = d;
                                                        c = c + 4 | 0;
                                                        if ((e | 0) > 0) {
                                                            ta(b, f, e);
                                                        }
                                                        F[a + 56 >> 2] = b + (g << 2);
                                                        F[a + 52 >> 2] = c;
                                                        F[a + 48 >> 2] = b;
                                                        if (!f) {
                                                            break b;
                                                        }
                                                        ra(f);
                                                        c = F[a + 52 >> 2];
                                                        break b;
                                                    }
                                                    va();
                                                    V();
                                                }
                                                wa(1336);
                                                V();
                                            }
                                            F[(i << 2) + c >> 2] = f | h;
                                            d = F[F[e + 28 >> 2] + (b << 2) >> 2];
                                            if ((d | 0) != -1) {
                                                continue;
                                            }
                                            break;
                                        }
                                        return 0;
                                    }
                                    F[a + 52 >> 2] = c;
                                }
                                if (F[a + 48 >> 2] != (c | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } return 1; }
                        function Le(a, b, c, d) { var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0; f = ea - 80 | 0; ea = f; e = F[c + 36 >> 2]; F[f + 72 >> 2] = F[c + 32 >> 2]; F[f + 76 >> 2] = e; g = F[c + 28 >> 2]; e = f - -64 | 0; F[e >> 2] = F[c + 24 >> 2]; F[e + 4 >> 2] = g; e = F[c + 20 >> 2]; F[f + 56 >> 2] = F[c + 16 >> 2]; F[f + 60 >> 2] = e; e = F[c + 12 >> 2]; F[f + 48 >> 2] = F[c + 8 >> 2]; F[f + 52 >> 2] = e; e = F[c + 4 >> 2]; F[f + 40 >> 2] = F[c >> 2]; F[f + 44 >> 2] = e; oc(a, f + 40 | 0, f + 24 | 0); a: {
                            if (F[a >> 2]) {
                                break a;
                            }
                            j = a + 4 | 0;
                            if (D[a + 15 | 0] < 0) {
                                ra(F[j >> 2]);
                            }
                            if (G[f + 31 | 0] != 1) {
                                b = sa(32);
                                c = G[1592] | G[1593] << 8 | (G[1594] << 16 | G[1595] << 24);
                                D[b + 16 | 0] = c;
                                D[b + 17 | 0] = c >>> 8;
                                D[b + 18 | 0] = c >>> 16;
                                D[b + 19 | 0] = c >>> 24;
                                c = G[1588] | G[1589] << 8 | (G[1590] << 16 | G[1591] << 24);
                                d = G[1584] | G[1585] << 8 | (G[1586] << 16 | G[1587] << 24);
                                D[b + 8 | 0] = d;
                                D[b + 9 | 0] = d >>> 8;
                                D[b + 10 | 0] = d >>> 16;
                                D[b + 11 | 0] = d >>> 24;
                                D[b + 12 | 0] = c;
                                D[b + 13 | 0] = c >>> 8;
                                D[b + 14 | 0] = c >>> 16;
                                D[b + 15 | 0] = c >>> 24;
                                c = G[1580] | G[1581] << 8 | (G[1582] << 16 | G[1583] << 24);
                                d = G[1576] | G[1577] << 8 | (G[1578] << 16 | G[1579] << 24);
                                D[b | 0] = d;
                                D[b + 1 | 0] = d >>> 8;
                                D[b + 2 | 0] = d >>> 16;
                                D[b + 3 | 0] = d >>> 24;
                                D[b + 4 | 0] = c;
                                D[b + 5 | 0] = c >>> 8;
                                D[b + 6 | 0] = c >>> 16;
                                D[b + 7 | 0] = c >>> 24;
                                D[b + 20 | 0] = 0;
                                F[a >> 2] = -1;
                                Ba(j, b, 20);
                                ra(b);
                                break a;
                            }
                            i = ea - 16 | 0;
                            ea = i;
                            b: {
                                c: {
                                    switch (G[f + 32 | 0]) {
                                        case 0:
                                            e = sa(48);
                                            Ge(e);
                                            F[e >> 2] = 13144;
                                            F[f + 8 >> 2] = 0;
                                            F[f + 12 >> 2] = 0;
                                            F[f >> 2] = 0;
                                            F[f + 4 >> 2] = 0;
                                            F[f + 16 >> 2] = e;
                                            break b;
                                        case 1:
                                            e = sa(52);
                                            Ge(e);
                                            F[e + 48 >> 2] = 0;
                                            F[e >> 2] = 11304;
                                            F[f + 8 >> 2] = 0;
                                            F[f + 12 >> 2] = 0;
                                            F[f >> 2] = 0;
                                            F[f + 4 >> 2] = 0;
                                            F[f + 16 >> 2] = e;
                                            break b;
                                        default: break c;
                                    }
                                }
                                g = sa(32);
                                e = G[1694] | G[1695] << 8 | (G[1696] << 16 | G[1697] << 24);
                                D[g + 24 | 0] = e;
                                D[g + 25 | 0] = e >>> 8;
                                D[g + 26 | 0] = e >>> 16;
                                D[g + 27 | 0] = e >>> 24;
                                e = G[1690] | G[1691] << 8 | (G[1692] << 16 | G[1693] << 24);
                                h = G[1686] | G[1687] << 8 | (G[1688] << 16 | G[1689] << 24);
                                D[g + 16 | 0] = h;
                                D[g + 17 | 0] = h >>> 8;
                                D[g + 18 | 0] = h >>> 16;
                                D[g + 19 | 0] = h >>> 24;
                                D[g + 20 | 0] = e;
                                D[g + 21 | 0] = e >>> 8;
                                D[g + 22 | 0] = e >>> 16;
                                D[g + 23 | 0] = e >>> 24;
                                e = G[1682] | G[1683] << 8 | (G[1684] << 16 | G[1685] << 24);
                                h = G[1678] | G[1679] << 8 | (G[1680] << 16 | G[1681] << 24);
                                D[g + 8 | 0] = h;
                                D[g + 9 | 0] = h >>> 8;
                                D[g + 10 | 0] = h >>> 16;
                                D[g + 11 | 0] = h >>> 24;
                                D[g + 12 | 0] = e;
                                D[g + 13 | 0] = e >>> 8;
                                D[g + 14 | 0] = e >>> 16;
                                D[g + 15 | 0] = e >>> 24;
                                e = G[1674] | G[1675] << 8 | (G[1676] << 16 | G[1677] << 24);
                                h = G[1670] | G[1671] << 8 | (G[1672] << 16 | G[1673] << 24);
                                D[g | 0] = h;
                                D[g + 1 | 0] = h >>> 8;
                                D[g + 2 | 0] = h >>> 16;
                                D[g + 3 | 0] = h >>> 24;
                                D[g + 4 | 0] = e;
                                D[g + 5 | 0] = e >>> 8;
                                D[g + 6 | 0] = e >>> 16;
                                D[g + 7 | 0] = e >>> 24;
                                D[g + 28 | 0] = 0;
                                F[i >> 2] = -1;
                                e = i | 4;
                                Ba(e, g, 28);
                                k = D[i + 15 | 0];
                                F[f >> 2] = F[i >> 2];
                                h = f + 4 | 0;
                                d: {
                                    if ((k | 0) >= 0) {
                                        k = F[e + 4 >> 2];
                                        F[h >> 2] = F[e >> 2];
                                        F[h + 4 >> 2] = k;
                                        F[h + 8 >> 2] = F[e + 8 >> 2];
                                        break d;
                                    }
                                    Ba(h, F[i + 4 >> 2], F[i + 8 >> 2]);
                                }
                                F[f + 16 >> 2] = 0;
                                if (D[i + 15 | 0] < 0) {
                                    ra(F[i + 4 >> 2]);
                                }
                                ra(g);
                            }
                            ea = i + 16 | 0;
                            e = F[f >> 2];
                            e: {
                                if (e) {
                                    F[a >> 2] = e;
                                    if (D[f + 15 | 0] >= 0) {
                                        a = f | 4;
                                        b = F[a + 4 >> 2];
                                        F[j >> 2] = F[a >> 2];
                                        F[j + 4 >> 2] = b;
                                        F[j + 8 >> 2] = F[a + 8 >> 2];
                                        break e;
                                    }
                                    Ba(j, F[f + 4 >> 2], F[f + 8 >> 2]);
                                    break e;
                                }
                                e = F[f + 16 >> 2];
                                F[f + 16 >> 2] = 0;
                                F[e + 44 >> 2] = d;
                                re(a, e, b, c, d);
                                if (!F[a >> 2]) {
                                    if (D[j + 11 | 0] < 0) {
                                        ra(F[j >> 2]);
                                    }
                                    F[a >> 2] = 0;
                                    F[a + 4 >> 2] = 0;
                                    F[a + 8 >> 2] = 0;
                                    F[a + 12 >> 2] = 0;
                                }
                                ga[F[F[e >> 2] + 4 >> 2]](e);
                            }
                            a = F[f + 16 >> 2];
                            F[f + 16 >> 2] = 0;
                            if (a) {
                                ga[F[F[a >> 2] + 4 >> 2]](a);
                            }
                            if (D[f + 15 | 0] >= 0) {
                                break a;
                            }
                            ra(F[f + 4 >> 2]);
                        } ea = f + 80 | 0; }
                        function Fc(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0; i = L(b, 12) + a | 0; F[i + 12 >> 2] = F[i + 8 >> 2]; k = (c | 0) == -1 ? -1 : (c >>> 0) / 3 | 0; n = 1; j = c; a: {
                            b: {
                                c: {
                                    while (1) {
                                        d: {
                                            o = e & 1;
                                            if (o) {
                                                if ((j | 0) == -1) {
                                                    break d;
                                                }
                                                if ((ae(a, ((j >>> 0) % 3 | 0 ? -1 : 2) + j | 0) | 0) == -1) {
                                                    break a;
                                                }
                                                c = j + 1 | 0;
                                                d = (c >>> 0) % 3 | 0 ? c : j - 2 | 0;
                                                if ((d | 0) == -1) {
                                                    break a;
                                                }
                                                c = d + 1 | 0;
                                                c = (c >>> 0) % 3 | 0 ? c : d - 2 | 0;
                                                if ((c | 0) == -1) {
                                                    break a;
                                                }
                                                d = F[F[F[a + 4 >> 2] + 12 >> 2] + (c << 2) >> 2];
                                                if ((d | 0) == -1) {
                                                    break a;
                                                }
                                                c = d + 1 | 0;
                                                c = (c >>> 0) % 3 | 0 ? c : d - 2 | 0;
                                                if ((c | 0) == -1) {
                                                    break a;
                                                }
                                                k = (c >>> 0) / 3 | 0;
                                            }
                                            g = 1 << k;
                                            m = F[a + 56 >> 2] + (k >>> 3 & 536870908) | 0;
                                            l = F[m >> 2];
                                            e: {
                                                if (g & l) {
                                                    break e;
                                                }
                                                e = 0;
                                                while (1) {
                                                    F[m >> 2] = g | l;
                                                    d = F[i + 12 >> 2];
                                                    f: {
                                                        if ((d | 0) != F[i + 16 >> 2]) {
                                                            F[d >> 2] = k;
                                                            F[i + 12 >> 2] = d + 4;
                                                            break f;
                                                        }
                                                        l = F[i + 8 >> 2];
                                                        g = d - l | 0;
                                                        h = g >> 2;
                                                        f = h + 1 | 0;
                                                        if (f >>> 0 >= 1073741824) {
                                                            break c;
                                                        }
                                                        d = g >> 1;
                                                        f = g >>> 0 < 2147483644 ? d >>> 0 < f >>> 0 ? f : d : 1073741823;
                                                        if (f) {
                                                            if (f >>> 0 >= 1073741824) {
                                                                break b;
                                                            }
                                                            d = sa(f << 2);
                                                        }
                                                        else {
                                                            d = 0;
                                                        }
                                                        h = d + (h << 2) | 0;
                                                        F[h >> 2] = k;
                                                        if ((g | 0) > 0) {
                                                            ta(d, l, g);
                                                        }
                                                        F[i + 8 >> 2] = d;
                                                        F[i + 12 >> 2] = h + 4;
                                                        F[i + 16 >> 2] = d + (f << 2);
                                                        if (!l) {
                                                            break f;
                                                        }
                                                        ra(l);
                                                    }
                                                    h = e + 1 | 0;
                                                    g: {
                                                        h: {
                                                            i: {
                                                                if (!e) {
                                                                    break i;
                                                                }
                                                                if (h & 1) {
                                                                    if ((c | 0) == -1) {
                                                                        c = -1;
                                                                        break g;
                                                                    }
                                                                    d = c + 1 | 0;
                                                                    c = (d >>> 0) % 3 | 0 ? d : c - 2 | 0;
                                                                    break i;
                                                                }
                                                                j = o ? c : j;
                                                                if ((c | 0) == -1) {
                                                                    c = -1;
                                                                    break g;
                                                                }
                                                                if ((c >>> 0) % 3 | 0) {
                                                                    e = c - 1 | 0;
                                                                    break h;
                                                                }
                                                                c = c + 2 | 0;
                                                            }
                                                            d = c;
                                                            c = -1;
                                                            e = d;
                                                            if ((d | 0) == -1) {
                                                                break g;
                                                            }
                                                        }
                                                        c = F[F[F[a + 4 >> 2] + 12 >> 2] + (e << 2) >> 2];
                                                        m = -1;
                                                        l = -1;
                                                        d = e + 1 | 0;
                                                        f = (d >>> 0) % 3 | 0 ? d : e - 2 | 0;
                                                        if ((f | 0) >= 0) {
                                                            d = (f >>> 0) / 3 | 0;
                                                            l = F[(F[F[a >> 2] + 96 >> 2] + L(d, 12) | 0) + (f - L(d, 3) << 2) >> 2];
                                                        }
                                                        j: {
                                                            if ((c | 0) == -1) {
                                                                g = 1;
                                                                break j;
                                                            }
                                                            g = 0;
                                                            f = ((c >>> 0) % 3 | 0 ? -1 : 2) + c | 0;
                                                            if ((f | 0) < 0) {
                                                                break j;
                                                            }
                                                            d = (f >>> 0) / 3 | 0;
                                                            m = F[(F[F[a >> 2] + 96 >> 2] + L(d, 12) | 0) + (f - L(d, 3) << 2) >> 2];
                                                        }
                                                        if ((l | 0) != (m | 0)) {
                                                            c = -1;
                                                            break g;
                                                        }
                                                        k: {
                                                            l: {
                                                                e = ((e >>> 0) % 3 | 0 ? -1 : 2) + e | 0;
                                                                m: {
                                                                    n: {
                                                                        if ((e | 0) >= 0) {
                                                                            d = (e >>> 0) / 3 | 0;
                                                                            m = F[(F[F[a >> 2] + 96 >> 2] + L(d, 12) | 0) + (e - L(d, 3) << 2) >> 2];
                                                                            e = -1;
                                                                            if (!g) {
                                                                                break n;
                                                                            }
                                                                            break m;
                                                                        }
                                                                        m = -1;
                                                                        if (g) {
                                                                            break l;
                                                                        }
                                                                    }
                                                                    d = c + 1 | 0;
                                                                    e = (d >>> 0) % 3 | 0 ? d : c - 2 | 0;
                                                                    if ((e | 0) < 0) {
                                                                        e = -1;
                                                                        break m;
                                                                    }
                                                                    d = (e >>> 0) / 3 | 0;
                                                                    e = F[(F[F[a >> 2] + 96 >> 2] + L(d, 12) | 0) + (e - L(d, 3) << 2) >> 2];
                                                                }
                                                                if ((e | 0) != (m | 0)) {
                                                                    c = -1;
                                                                    break g;
                                                                }
                                                                if ((c | 0) != -1) {
                                                                    break k;
                                                                }
                                                                c = -1;
                                                                break g;
                                                            }
                                                            if ((c | 0) != -1) {
                                                                break k;
                                                            }
                                                            c = -1;
                                                            break g;
                                                        }
                                                        e = h;
                                                        k = (c >>> 0) / 3 | 0;
                                                        m = F[a + 56 >> 2] + (k >>> 3 & 268435452) | 0;
                                                        l = F[m >> 2];
                                                        g = 1 << k;
                                                        if (!(l & g)) {
                                                            continue;
                                                        }
                                                    }
                                                    break;
                                                }
                                                if (!o | !(h & 1)) {
                                                    break e;
                                                }
                                                f = F[i + 12 >> 2] - 4 | 0;
                                                h = F[f >> 2];
                                                e = F[a + 56 >> 2] + (h >>> 3 & 536870908) | 0;
                                                d = F[e >> 2];
                                                p = e, q = Lj(h) & d, F[p >> 2] = q;
                                                F[i + 12 >> 2] = f;
                                            }
                                            e = 1;
                                            d = n;
                                            n = 0;
                                            if (d) {
                                                continue;
                                            }
                                            break a;
                                        }
                                        break;
                                    }
                                    j = -1;
                                    ae(a, -1);
                                    break a;
                                }
                                va();
                                V();
                            }
                            wa(1336);
                            V();
                        } F[((b << 2) + a | 0) + 44 >> 2] = j; f = F[i + 8 >> 2]; b = F[i + 12 >> 2] - f | 0; o: {
                            if (!b) {
                                break o;
                            }
                            j = F[a + 56 >> 2];
                            a = b >> 2;
                            a = a >>> 0 > 1 ? a : 1;
                            h = a & 1;
                            c = 0;
                            if (b >>> 0 >= 8) {
                                n = a & -2;
                                k = 0;
                                while (1) {
                                    e = c << 2;
                                    d = F[e + f >> 2];
                                    b = j + (d >>> 3 & 536870908) | 0;
                                    a = F[b >> 2];
                                    p = b, q = Lj(d) & a, F[p >> 2] = q;
                                    d = F[f + (e | 4) >> 2];
                                    b = j + (d >>> 3 & 536870908) | 0;
                                    a = F[b >> 2];
                                    p = b, q = Lj(d) & a, F[p >> 2] = q;
                                    c = c + 2 | 0;
                                    k = k + 2 | 0;
                                    if ((n | 0) != (k | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            if (!h) {
                                break o;
                            }
                            c = F[f + (c << 2) >> 2];
                            b = j + (c >>> 3 & 536870908) | 0;
                            a = F[b >> 2];
                            p = b, q = Lj(c) & a, F[p >> 2] = q;
                        } }
                        function ue(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0; if ((b | 0) == -1) {
                            return 1;
                        } d = (b >>> 0) / 3 | 0; if (!(F[F[a + 24 >> 2] + (d >>> 3 & 268435452) >> 2] >>> d & 1)) {
                            c = F[a + 48 >> 2];
                            F[a + 52 >> 2] = c;
                            a: {
                                if ((c | 0) != F[a + 56 >> 2]) {
                                    F[c >> 2] = b;
                                    F[a + 52 >> 2] = c + 4;
                                    break a;
                                }
                                e = sa(4);
                                F[e >> 2] = b;
                                f = e + 4 | 0;
                                F[a + 56 >> 2] = f;
                                F[a + 52 >> 2] = f;
                                F[a + 48 >> 2] = e;
                                if (!c) {
                                    break a;
                                }
                                ra(c);
                            }
                            e = -1;
                            f = F[a + 4 >> 2];
                            c = b + 1 | 0;
                            g = (c >>> 0) % 3 | 0 ? c : b - 2 | 0;
                            if ((g | 0) != -1) {
                                e = F[F[f >> 2] + (g << 2) >> 2];
                            }
                            b: {
                                h = b - L(d, 3) | 0;
                                if (h) {
                                    c = b - 1 | 0;
                                    break b;
                                }
                                c = b + 2 | 0;
                                if ((c | 0) != -1) {
                                    break b;
                                }
                                return 0;
                            }
                            if ((e | 0) == -1) {
                                return 0;
                            }
                            d = F[F[f >> 2] + (c << 2) >> 2];
                            if ((d | 0) == -1) {
                                return 0;
                            }
                            c = F[a + 36 >> 2];
                            f = c + (e >>> 3 & 536870908) | 0;
                            i = F[f >> 2];
                            j = 1 << e;
                            if (!(i & j)) {
                                F[f >> 2] = i | j;
                                Xa(a + 8 | 0, e, g);
                                c = F[a + 36 >> 2];
                            }
                            c = (d >>> 3 & 536870908) + c | 0;
                            e = F[c >> 2];
                            f = 1 << d;
                            if (!(e & f)) {
                                F[c >> 2] = e | f;
                                Xa(a + 8 | 0, d, (h ? -1 : 2) + b | 0);
                            }
                            c = F[a + 52 >> 2];
                            if ((c | 0) == F[a + 48 >> 2]) {
                                return 1;
                            }
                            j = a + 8 | 0;
                            while (1) {
                                c = c - 4 | 0;
                                b = F[c >> 2];
                                d = (b >>> 0) / 3 | 0;
                                c: {
                                    d: {
                                        if ((b | 0) == -1) {
                                            break d;
                                        }
                                        e = F[a + 24 >> 2] + (d >>> 3 & 268435452) | 0;
                                        f = F[e >> 2];
                                        d = 1 << d;
                                        if (f & d) {
                                            break d;
                                        }
                                        F[e >> 2] = d | f;
                                        while (1) {
                                            d = F[a + 4 >> 2];
                                            c = F[F[d >> 2] + (b << 2) >> 2];
                                            if ((c | 0) == -1) {
                                                return 0;
                                            }
                                            e: {
                                                f: {
                                                    e = F[a + 36 >> 2] + (c >>> 3 & 536870908) | 0;
                                                    f = F[e >> 2];
                                                    g = 1 << c;
                                                    if (f & g) {
                                                        break f;
                                                    }
                                                    g: {
                                                        h = F[F[d + 24 >> 2] + (c << 2) >> 2];
                                                        h: {
                                                            if ((h | 0) == -1) {
                                                                break h;
                                                            }
                                                            i = h + 1 | 0;
                                                            h = (i >>> 0) % 3 | 0 ? i : h - 2 | 0;
                                                            if ((h | 0) == -1) {
                                                                break h;
                                                            }
                                                            d = F[F[d + 12 >> 2] + (h << 2) >> 2];
                                                            if ((d | 0) != -1) {
                                                                break g;
                                                            }
                                                        }
                                                        F[e >> 2] = f | g;
                                                        Xa(j, c, b);
                                                        break f;
                                                    }
                                                    F[e >> 2] = f | g;
                                                    Xa(j, c, b);
                                                    c = d + 1 | 0;
                                                    if ((((c >>> 0) % 3 | 0 ? c : d - 2 | 0) | 0) == -1) {
                                                        break f;
                                                    }
                                                    d = b - 2 | 0;
                                                    c = b + 1 | 0;
                                                    b = -1;
                                                    c = (c >>> 0) % 3 | 0 ? c : d;
                                                    if ((c | 0) != -1) {
                                                        b = F[F[F[a + 4 >> 2] + 12 >> 2] + (c << 2) >> 2];
                                                    }
                                                    c = (b >>> 0) / 3 | 0;
                                                    g = 1 << c;
                                                    e = F[a + 24 >> 2];
                                                    h = c >>> 5 | 0;
                                                    d = F[e + (h << 2) >> 2];
                                                    break e;
                                                }
                                                c = -1;
                                                f = F[a + 4 >> 2];
                                                d = b + 1 | 0;
                                                d = (d >>> 0) % 3 | 0 ? d : b - 2 | 0;
                                                if ((d | 0) != -1) {
                                                    c = F[F[f + 12 >> 2] + (d << 2) >> 2];
                                                }
                                                i: {
                                                    j: {
                                                        if ((b >>> 0) % 3 | 0) {
                                                            e = b - 1 | 0;
                                                            break j;
                                                        }
                                                        e = b + 2 | 0;
                                                        b = -1;
                                                        if ((e | 0) == -1) {
                                                            break i;
                                                        }
                                                    }
                                                    b = F[F[f + 12 >> 2] + (e << 2) >> 2];
                                                }
                                                i = (b | 0) == -1;
                                                f = i ? -1 : (b >>> 0) / 3 | 0;
                                                d = (c >>> 0) / 3 | 0;
                                                k: {
                                                    g = (c | 0) == -1;
                                                    if (!g) {
                                                        e = F[a + 24 >> 2];
                                                        g = g ? -1 : d;
                                                        h = g >>> 5 | 0;
                                                        d = F[e + (h << 2) >> 2];
                                                        g = 1 << g;
                                                        if (!(d & g)) {
                                                            break k;
                                                        }
                                                    }
                                                    if (!i) {
                                                        g = 1 << f;
                                                        e = F[a + 24 >> 2];
                                                        h = f >>> 5 | 0;
                                                        d = F[e + (h << 2) >> 2];
                                                        if (!(g & d)) {
                                                            break e;
                                                        }
                                                    }
                                                    c = F[a + 52 >> 2] - 4 | 0;
                                                    F[a + 52 >> 2] = c;
                                                    break c;
                                                }
                                                if (i) {
                                                    b = c;
                                                    break e;
                                                }
                                                if (F[(f >>> 3 & 536870908) + e >> 2] >>> f & 1) {
                                                    b = c;
                                                    break e;
                                                }
                                                d = F[a + 52 >> 2];
                                                F[d - 4 >> 2] = b;
                                                if ((d | 0) != F[a + 56 >> 2]) {
                                                    F[d >> 2] = c;
                                                    c = d + 4 | 0;
                                                    break d;
                                                }
                                                l: {
                                                    e = F[a + 48 >> 2];
                                                    d = d - e | 0;
                                                    g = d >> 2;
                                                    b = g + 1 | 0;
                                                    if (b >>> 0 < 1073741824) {
                                                        f = d >> 1;
                                                        f = d >>> 0 < 2147483644 ? b >>> 0 > f >>> 0 ? b : f : 1073741823;
                                                        if (f) {
                                                            if (f >>> 0 >= 1073741824) {
                                                                break l;
                                                            }
                                                            b = sa(f << 2);
                                                        }
                                                        else {
                                                            b = 0;
                                                        }
                                                        g = b + (g << 2) | 0;
                                                        F[g >> 2] = c;
                                                        c = g + 4 | 0;
                                                        if ((d | 0) > 0) {
                                                            ta(b, e, d);
                                                        }
                                                        F[a + 56 >> 2] = b + (f << 2);
                                                        F[a + 52 >> 2] = c;
                                                        F[a + 48 >> 2] = b;
                                                        if (!e) {
                                                            break c;
                                                        }
                                                        ra(e);
                                                        c = F[a + 52 >> 2];
                                                        break c;
                                                    }
                                                    va();
                                                    V();
                                                }
                                                wa(1336);
                                                V();
                                            }
                                            F[(h << 2) + e >> 2] = d | g;
                                            if ((b | 0) != -1) {
                                                continue;
                                            }
                                            break;
                                        }
                                        return 0;
                                    }
                                    F[a + 52 >> 2] = c;
                                }
                                if (F[a + 48 >> 2] != (c | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } return 1; }
                        function Ye(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0; i = ea - 32 | 0; ea = i; a: {
                            if (H[b + 38 >> 1] <= 513) {
                                c = F[b + 20 >> 2];
                                h = F[b + 12 >> 2];
                                d = F[b + 16 >> 2];
                                if ((c | 0) >= (h | 0) & d >>> 0 >= I[b + 8 >> 2] | (c | 0) > (h | 0)) {
                                    break a;
                                }
                                h = G[d + F[b >> 2] | 0];
                                d = d + 1 | 0;
                                c = d ? c : c + 1 | 0;
                                F[b + 16 >> 2] = d;
                                F[b + 20 >> 2] = c;
                                if (h) {
                                    break a;
                                }
                            }
                            b: {
                                if (!Pb(1, i + 28 | 0, b)) {
                                    break b;
                                }
                                c: {
                                    d = F[i + 28 >> 2];
                                    if (d) {
                                        Ob(a + 60 | 0, d);
                                        c = i + 8 | 0;
                                        F[c >> 2] = 0;
                                        F[c + 4 >> 2] = 0;
                                        D[c + 5 | 0] = 0;
                                        D[c + 6 | 0] = 0;
                                        D[c + 7 | 0] = 0;
                                        D[c + 8 | 0] = 0;
                                        D[c + 9 | 0] = 0;
                                        D[c + 10 | 0] = 0;
                                        D[c + 11 | 0] = 0;
                                        D[c + 12 | 0] = 0;
                                        if (!xa(c, b)) {
                                            break c;
                                        }
                                        while (1) {
                                            h = 1 << e;
                                            f = Ga(c);
                                            g = F[a + 60 >> 2] + (e >>> 3 & 536870908) | 0;
                                            if (f) {
                                                f = h | F[g >> 2];
                                            }
                                            else {
                                                f = F[g >> 2] & (h ^ -1);
                                            }
                                            F[g >> 2] = f;
                                            e = e + 1 | 0;
                                            if ((d | 0) != (e | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    if (!Pb(1, i + 28 | 0, b)) {
                                        break b;
                                    }
                                    d = F[i + 28 >> 2];
                                    if (d) {
                                        e = 0;
                                        Ob(a + 72 | 0, d);
                                        c = i + 8 | 0;
                                        F[c >> 2] = 0;
                                        F[c + 4 >> 2] = 0;
                                        D[c + 5 | 0] = 0;
                                        D[c + 6 | 0] = 0;
                                        D[c + 7 | 0] = 0;
                                        D[c + 8 | 0] = 0;
                                        D[c + 9 | 0] = 0;
                                        D[c + 10 | 0] = 0;
                                        D[c + 11 | 0] = 0;
                                        D[c + 12 | 0] = 0;
                                        if (!xa(c, b)) {
                                            break c;
                                        }
                                        while (1) {
                                            h = 1 << e;
                                            f = Ga(c);
                                            g = F[a + 72 >> 2] + (e >>> 3 & 536870908) | 0;
                                            if (f) {
                                                f = h | F[g >> 2];
                                            }
                                            else {
                                                f = F[g >> 2] & (h ^ -1);
                                            }
                                            F[g >> 2] = f;
                                            e = e + 1 | 0;
                                            if ((d | 0) != (e | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    if (!Pb(1, i + 28 | 0, b)) {
                                        break b;
                                    }
                                    d = F[i + 28 >> 2];
                                    if (d) {
                                        e = 0;
                                        Ob(a + 84 | 0, d);
                                        c = i + 8 | 0;
                                        F[c >> 2] = 0;
                                        F[c + 4 >> 2] = 0;
                                        D[c + 5 | 0] = 0;
                                        D[c + 6 | 0] = 0;
                                        D[c + 7 | 0] = 0;
                                        D[c + 8 | 0] = 0;
                                        D[c + 9 | 0] = 0;
                                        D[c + 10 | 0] = 0;
                                        D[c + 11 | 0] = 0;
                                        D[c + 12 | 0] = 0;
                                        if (!xa(c, b)) {
                                            break c;
                                        }
                                        while (1) {
                                            h = 1 << e;
                                            f = Ga(c);
                                            g = F[a + 84 >> 2] + (e >>> 3 & 536870908) | 0;
                                            if (f) {
                                                f = h | F[g >> 2];
                                            }
                                            else {
                                                f = F[g >> 2] & (h ^ -1);
                                            }
                                            F[g >> 2] = f;
                                            e = e + 1 | 0;
                                            if ((d | 0) != (e | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    if (!Pb(1, i + 28 | 0, b)) {
                                        break b;
                                    }
                                    d = F[i + 28 >> 2];
                                    if (d) {
                                        e = 0;
                                        Ob(a + 96 | 0, d);
                                        c = i + 8 | 0;
                                        F[c >> 2] = 0;
                                        F[c + 4 >> 2] = 0;
                                        D[c + 5 | 0] = 0;
                                        D[c + 6 | 0] = 0;
                                        D[c + 7 | 0] = 0;
                                        D[c + 8 | 0] = 0;
                                        D[c + 9 | 0] = 0;
                                        D[c + 10 | 0] = 0;
                                        D[c + 11 | 0] = 0;
                                        D[c + 12 | 0] = 0;
                                        if (!xa(c, b)) {
                                            break c;
                                        }
                                        while (1) {
                                            h = 1 << e;
                                            f = Ga(c);
                                            g = F[a + 96 >> 2] + (e >>> 3 & 536870908) | 0;
                                            if (f) {
                                                f = h | F[g >> 2];
                                            }
                                            else {
                                                f = F[g >> 2] & (h ^ -1);
                                            }
                                            F[g >> 2] = f;
                                            e = e + 1 | 0;
                                            if ((d | 0) != (e | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    e = 0;
                                    d = F[b + 12 >> 2];
                                    h = d;
                                    c = F[b + 20 >> 2];
                                    g = c;
                                    f = F[b + 16 >> 2];
                                    j = f + 4 | 0;
                                    c = j >>> 0 < 4 ? c + 1 | 0 : c;
                                    k = F[b + 8 >> 2];
                                    if (k >>> 0 < j >>> 0 & (c | 0) >= (d | 0) | (c | 0) > (d | 0)) {
                                        break a;
                                    }
                                    l = F[b >> 2];
                                    d = l + f | 0;
                                    d = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                    F[b + 16 >> 2] = j;
                                    F[b + 20 >> 2] = c;
                                    c = g;
                                    g = f + 8 | 0;
                                    c = g >>> 0 < 8 ? c + 1 | 0 : c;
                                    f = g;
                                    g = c;
                                    if (f >>> 0 > k >>> 0 & (c | 0) >= (h | 0) | (c | 0) > (h | 0)) {
                                        break a;
                                    }
                                    c = j + l | 0;
                                    c = G[c | 0] | G[c + 1 | 0] << 8 | (G[c + 2 | 0] << 16 | G[c + 3 | 0] << 24);
                                    F[b + 16 >> 2] = f;
                                    F[b + 20 >> 2] = g;
                                    if ((c | 0) < (d | 0)) {
                                        break a;
                                    }
                                    F[a + 16 >> 2] = c;
                                    F[a + 12 >> 2] = d;
                                    b = (c >> 31) - ((d >> 31) + (c >>> 0 < d >>> 0) | 0) | 0;
                                    c = c - d | 0;
                                    if (!b & c >>> 0 > 2147483646 | b) {
                                        break a;
                                    }
                                    e = 1;
                                    b = c + 1 | 0;
                                    F[a + 20 >> 2] = b;
                                    c = b >>> 1 | 0;
                                    F[a + 24 >> 2] = c;
                                    F[a + 28 >> 2] = 0 - c;
                                    if (b & 1) {
                                        break a;
                                    }
                                    F[a + 24 >> 2] = c - 1;
                                    break a;
                                }
                            }
                            e = 0;
                        } ea = i + 32 | 0; return e | 0; }
                        function od(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0; a: {
                            n = ga[F[F[a >> 2] + 44 >> 2]](a) | 0;
                            if ((n | 0) <= 0) {
                                break a;
                            }
                            e = F[b + 4 >> 2] - F[b >> 2] >> 2;
                            g = ea + -64 | 0;
                            ea = g;
                            d = Fb(g);
                            f = L(F[3408], n);
                            mc(d, F[F[a + 8 >> 2] + 56 >> 2], n << 24 >> 24, 5, 0, f, f >> 31);
                            f = sa(96);
                            d = kc(f, d);
                            D[d + 84 | 0] = 1;
                            F[d + 72 >> 2] = F[d + 68 >> 2];
                            qb(d, e);
                            F[d + 60 >> 2] = F[F[a + 8 >> 2] + 60 >> 2];
                            d = F[a + 16 >> 2];
                            F[a + 16 >> 2] = f;
                            if (d) {
                                Ja(d);
                            }
                            ea = g - -64 | 0;
                            g = F[a + 16 >> 2];
                            if (!F[g + 80 >> 2]) {
                                break a;
                            }
                            i = F[F[g >> 2] >> 2];
                            if (!i) {
                                break a;
                            }
                            h = F[c + 12 >> 2];
                            d = F[c + 20 >> 2];
                            j = F[c + 8 >> 2];
                            f = F[c + 16 >> 2];
                            if ((h | 0) <= (d | 0) & j >>> 0 <= f >>> 0 | (d | 0) > (h | 0)) {
                                break a;
                            }
                            k = L(e, n);
                            i = i + F[g + 48 >> 2] | 0;
                            l = F[c >> 2];
                            m = G[l + f | 0];
                            g = f + 1 | 0;
                            e = g ? d : d + 1 | 0;
                            F[c + 16 >> 2] = g;
                            F[c + 20 >> 2] = e;
                            b: {
                                c: {
                                    d: {
                                        if (m) {
                                            if (ld(k, n, c, i)) {
                                                break d;
                                            }
                                            break a;
                                        }
                                        if ((e | 0) >= (h | 0) & g >>> 0 >= j >>> 0 | (e | 0) > (h | 0)) {
                                            break a;
                                        }
                                        g = G[g + l | 0];
                                        e = f + 2 | 0;
                                        d = e >>> 0 < 2 ? d + 1 | 0 : d;
                                        F[c + 16 >> 2] = e;
                                        F[c + 20 >> 2] = d;
                                        d = F[F[a + 16 >> 2] + 64 >> 2];
                                        d = F[d + 4 >> 2] - F[d >> 2] | 0;
                                        e: {
                                            if ((g | 0) == F[3408]) {
                                                e = d;
                                                d = k << 2;
                                                if (e >>> 0 < d >>> 0) {
                                                    break a;
                                                }
                                                h = F[c + 8 >> 2];
                                                g = F[c + 12 >> 2];
                                                e = F[c + 20 >> 2];
                                                j = F[c + 16 >> 2];
                                                f = d + j | 0;
                                                e = f >>> 0 < d >>> 0 ? e + 1 | 0 : e;
                                                if ((e | 0) <= (g | 0) & f >>> 0 <= h >>> 0 | (e | 0) < (g | 0)) {
                                                    break e;
                                                }
                                                break a;
                                            }
                                            if (d >>> 0 < L(g, k) >>> 0) {
                                                break a;
                                            }
                                            h = F[c + 12 >> 2];
                                            e = F[c + 20 >> 2];
                                            l = F[c + 8 >> 2];
                                            f = l;
                                            j = F[c + 16 >> 2];
                                            d = g;
                                            p = f - j >>> 0 < Hj(d, 0, k, 0) >>> 0;
                                            f = h - (e + (f >>> 0 < j >>> 0) | 0) | 0;
                                            m = fa;
                                            if (p & (f | 0) <= (m | 0) | (f | 0) < (m | 0)) {
                                                break a;
                                            }
                                            f = 1;
                                            if (!k) {
                                                break c;
                                            }
                                            f = 0;
                                            m = l;
                                            l = d + j | 0;
                                            e = l >>> 0 < d >>> 0 ? e + 1 | 0 : e;
                                            if (m >>> 0 < l >>> 0 & (e | 0) >= (h | 0) | (e | 0) > (h | 0)) {
                                                break b;
                                            }
                                            while (1) {
                                                ta(i + (o << 2) | 0, j + F[c >> 2] | 0, g);
                                                e = F[c + 20 >> 2];
                                                h = d + F[c + 16 >> 2] | 0;
                                                e = h >>> 0 < d >>> 0 ? e + 1 | 0 : e;
                                                j = h;
                                                F[c + 16 >> 2] = h;
                                                F[c + 20 >> 2] = e;
                                                o = o + 1 | 0;
                                                if ((k | 0) == (o | 0)) {
                                                    break d;
                                                }
                                                m = F[c + 8 >> 2];
                                                h = F[c + 12 >> 2];
                                                l = d + j | 0;
                                                e = l >>> 0 < d >>> 0 ? e + 1 | 0 : e;
                                                if ((e | 0) <= (h | 0) & l >>> 0 <= m >>> 0 | (e | 0) < (h | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            break b;
                                        }
                                        ta(i, j + F[c >> 2] | 0, d);
                                        e = d;
                                        g = d + F[c + 16 >> 2] | 0;
                                        d = F[c + 20 >> 2];
                                        F[c + 16 >> 2] = g;
                                        F[c + 20 >> 2] = e >>> 0 > g >>> 0 ? d + 1 | 0 : d;
                                    }
                                    f = 1;
                                    if (!k) {
                                        break c;
                                    }
                                    d = F[a + 20 >> 2];
                                    if (d) {
                                        f = 0;
                                        if (ga[F[F[d >> 2] + 32 >> 2]](d) | 0) {
                                            break c;
                                        }
                                    }
                                    d = 0;
                                    f = 0;
                                    f: {
                                        if ((k | 0) <= 0) {
                                            break f;
                                        }
                                        if ((k | 0) != 1) {
                                            h = k & -2;
                                            while (1) {
                                                e = d << 2;
                                                g = F[e + i >> 2];
                                                F[e + i >> 2] = 0 - (g & 1) ^ g >>> 1;
                                                g = e | 4;
                                                e = F[g + i >> 2];
                                                F[g + i >> 2] = 0 - (e & 1) ^ e >>> 1;
                                                d = d + 2 | 0;
                                                f = f + 2 | 0;
                                                if ((h | 0) != (f | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        if (!(k & 1)) {
                                            break f;
                                        }
                                        e = d << 2;
                                        d = F[e + i >> 2];
                                        F[e + i >> 2] = 0 - (d & 1) ^ d >>> 1;
                                    }
                                    f = 0;
                                }
                                d = F[a + 20 >> 2];
                                g: {
                                    if (!d) {
                                        break g;
                                    }
                                    if (!(ga[F[F[d >> 2] + 40 >> 2]](d, c) | 0)) {
                                        break a;
                                    }
                                    if (f) {
                                        break g;
                                    }
                                    f = 0;
                                    a = F[a + 20 >> 2];
                                    if (!(ga[F[F[a >> 2] + 44 >> 2]](a, i, i, k, n, F[b >> 2]) | 0)) {
                                        break b;
                                    }
                                }
                                f = 1;
                            }
                            return f | 0;
                        } return 0; }
                        function db(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0; g = ea - 32 | 0; ea = g; a: {
                            b: {
                                if (F[a + 8 >> 2] << 5 >>> 0 >= b >>> 0) {
                                    break b;
                                }
                                F[g + 24 >> 2] = 0;
                                F[g + 16 >> 2] = 0;
                                F[g + 20 >> 2] = 0;
                                if ((b | 0) < 0) {
                                    break a;
                                }
                                b = (b - 1 >>> 5 | 0) + 1 | 0;
                                c = sa(b << 2);
                                F[g + 24 >> 2] = b;
                                F[g + 20 >> 2] = 0;
                                F[g + 16 >> 2] = c;
                                b = F[a >> 2];
                                F[g + 12 >> 2] = 0;
                                F[g + 8 >> 2] = b;
                                c = F[a + 4 >> 2];
                                F[g + 4 >> 2] = c & 31;
                                F[g >> 2] = b + (c >>> 3 & 536870908);
                                f = ea - 32 | 0;
                                ea = f;
                                j = F[g + 4 >> 2];
                                e = F[g + 12 >> 2];
                                k = F[g >> 2];
                                i = F[g + 8 >> 2];
                                b = (j - e | 0) + (k - i << 3) | 0;
                                d = F[g + 20 >> 2];
                                h = b + d | 0;
                                F[g + 20 >> 2] = h;
                                c: {
                                    if (!(!d | (h - 1 ^ d - 1) >>> 0 > 31)) {
                                        c = F[g + 16 >> 2];
                                        break c;
                                    }
                                    c = F[g + 16 >> 2];
                                    if (h >>> 0 <= 32) {
                                        F[c >> 2] = 0;
                                        break c;
                                    }
                                    F[(h - 1 >>> 3 & 536870908) + c >> 2] = 0;
                                }
                                c = (d >>> 3 & 536870908) + c | 0;
                                d = d & 31;
                                d: {
                                    if ((d | 0) == (e | 0)) {
                                        if ((b | 0) <= 0) {
                                            break d;
                                        }
                                        if (e) {
                                            h = 32 - e | 0;
                                            d = (b | 0) < (h | 0) ? b : h;
                                            h = -1 << e & -1 >>> h - d;
                                            F[c >> 2] = F[c >> 2] & (h ^ -1) | h & F[i >> 2];
                                            b = b - d | 0;
                                            i = i + 4 | 0;
                                            c = c + (d + e >>> 3 & 536870908) | 0;
                                        }
                                        j = c;
                                        e = (b | 0) / 32 | 0;
                                        c = e << 2;
                                        d = Wa(j, i, c);
                                        b = b - (e << 5) | 0;
                                        if ((b | 0) <= 0) {
                                            break d;
                                        }
                                        e = c + d | 0;
                                        b = -1 >>> 32 - b | 0;
                                        F[e >> 2] = F[e >> 2] & (b ^ -1) | b & F[c + i >> 2];
                                        break d;
                                    }
                                    F[f + 28 >> 2] = e;
                                    F[f + 24 >> 2] = i;
                                    F[f + 20 >> 2] = j;
                                    F[f + 16 >> 2] = k;
                                    F[f + 12 >> 2] = d;
                                    F[f + 8 >> 2] = c;
                                    b = F[f + 28 >> 2];
                                    c = F[f + 24 >> 2];
                                    i = (F[f + 20 >> 2] - b | 0) + (F[f + 16 >> 2] - c << 3) | 0;
                                    e: {
                                        if ((i | 0) <= 0) {
                                            b = F[f + 12 >> 2];
                                            break e;
                                        }
                                        f: {
                                            if (!b) {
                                                b = F[f + 12 >> 2];
                                                break f;
                                            }
                                            e = F[f + 12 >> 2];
                                            j = 32 - e | 0;
                                            k = 32 - b | 0;
                                            d = (i | 0) < (k | 0) ? i : k;
                                            h = d >>> 0 > j >>> 0 ? j : d;
                                            l = F[f + 8 >> 2];
                                            m = F[l >> 2] & (-1 << e & -1 >>> j - h ^ -1);
                                            j = F[c >> 2] & (-1 << b & -1 >>> k - d);
                                            F[l >> 2] = m | (b >>> 0 < e >>> 0 ? j << e - b : j >>> b - e | 0);
                                            c = e + h | 0;
                                            b = c & 31;
                                            F[f + 12 >> 2] = b;
                                            e = l + (c >>> 3 & 536870908) | 0;
                                            F[f + 8 >> 2] = e;
                                            c = d - h | 0;
                                            if ((c | 0) > 0) {
                                                F[e >> 2] = F[e >> 2] & (-1 >>> 32 - c ^ -1) | j >>> h + F[f + 28 >> 2];
                                                F[f + 12 >> 2] = c;
                                                b = c;
                                            }
                                            i = i - d | 0;
                                            c = F[f + 24 >> 2] + 4 | 0;
                                            F[f + 24 >> 2] = c;
                                        }
                                        e = 32 - b | 0;
                                        h = -1 << b;
                                        if ((i | 0) >= 32) {
                                            j = h ^ -1;
                                            while (1) {
                                                d = F[f + 8 >> 2];
                                                c = F[c >> 2];
                                                F[d >> 2] = j & F[d >> 2] | c << b;
                                                F[f + 8 >> 2] = d + 4;
                                                F[d + 4 >> 2] = h & F[d + 4 >> 2] | c >>> e;
                                                c = F[f + 24 >> 2] + 4 | 0;
                                                F[f + 24 >> 2] = c;
                                                d = i >>> 0 > 63;
                                                i = i - 32 | 0;
                                                if (d) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        if ((i | 0) <= 0) {
                                            break e;
                                        }
                                        d = F[f + 8 >> 2];
                                        j = e;
                                        e = (e | 0) < (i | 0) ? e : i;
                                        j = F[d >> 2] & (h & -1 >>> j - e ^ -1);
                                        h = F[c >> 2] & -1 >>> 32 - i;
                                        F[d >> 2] = j | h << b;
                                        c = b + e | 0;
                                        b = c & 31;
                                        F[f + 12 >> 2] = b;
                                        d = d + (c >>> 3 & 536870908) | 0;
                                        F[f + 8 >> 2] = d;
                                        c = i - e | 0;
                                        if ((c | 0) <= 0) {
                                            break e;
                                        }
                                        F[d >> 2] = F[d >> 2] & (-1 >>> 32 - c ^ -1) | h >>> e;
                                        F[f + 12 >> 2] = c;
                                        b = c;
                                    }
                                    c = F[f + 8 >> 2];
                                    F[f + 4 >> 2] = b;
                                    F[f >> 2] = c;
                                }
                                ea = f + 32 | 0;
                                b = F[a >> 2];
                                F[a >> 2] = F[g + 16 >> 2];
                                F[g + 16 >> 2] = b;
                                c = F[a + 4 >> 2];
                                F[a + 4 >> 2] = F[g + 20 >> 2];
                                F[g + 20 >> 2] = c;
                                c = F[a + 8 >> 2];
                                F[a + 8 >> 2] = F[g + 24 >> 2];
                                F[g + 24 >> 2] = c;
                                if (!b) {
                                    break b;
                                }
                                ra(b);
                            }
                            ea = g + 32 | 0;
                            return;
                        } Oa(); V(); }
                        function nj(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0; g = ea - 32 | 0; ea = g; F[a + 68 >> 2] = f; e = F[a + 56 >> 2]; d = F[e >> 2]; f = F[e + 4 >> 2]; F[g + 24 >> 2] = 0; F[g + 16 >> 2] = 0; F[g + 20 >> 2] = 0; a: {
                            f = f - d | 0;
                            if ((f | 0) <= 0) {
                                break a;
                            }
                            d = F[e >> 2];
                            if ((d | 0) != F[e + 4 >> 2]) {
                                m = a + 112 | 0;
                                n = a + 60 | 0;
                                e = f >>> 2 | 0;
                                o = e >>> 0 > 1 ? e : 1;
                                while (1) {
                                    Mb(n, F[(k << 2) + d >> 2], g + 16 | 0);
                                    e = F[g + 20 >> 2];
                                    d = e >> 31;
                                    f = F[g + 16 >> 2];
                                    h = f >> 31;
                                    j = F[g + 24 >> 2];
                                    i = j >> 31;
                                    i = i ^ i + j;
                                    h = i + ((d ^ d + e) + (h ^ f + h) | 0) | 0;
                                    d = 0;
                                    d = h >>> 0 < i >>> 0 ? 1 : d;
                                    b: {
                                        if (!(d | h)) {
                                            F[g + 16 >> 2] = F[a + 108 >> 2];
                                            break b;
                                        }
                                        i = F[a + 108 >> 2];
                                        l = i >> 31;
                                        f = Ij(Hj(i, l, f, f >> 31), fa, h, d);
                                        F[g + 16 >> 2] = f;
                                        d = Ij(Hj(i, l, e, e >> 31), fa, h, d);
                                        F[g + 20 >> 2] = d;
                                        e = d;
                                        d = d >> 31;
                                        e = e + d ^ d;
                                        d = f >> 31;
                                        d = e + (d + f ^ d) | 0;
                                        if ((j | 0) >= 0) {
                                            F[g + 24 >> 2] = i - d;
                                            break b;
                                        }
                                        F[g + 24 >> 2] = d - i;
                                    }
                                    d = Ga(m);
                                    f = F[g + 16 >> 2];
                                    c: {
                                        if (d) {
                                            F[g + 24 >> 2] = 0 - F[g + 24 >> 2];
                                            e = 0 - F[g + 20 >> 2] | 0;
                                            F[g + 20 >> 2] = e;
                                            f = 0 - f | 0;
                                            F[g + 16 >> 2] = f;
                                            break c;
                                        }
                                        e = F[g + 20 >> 2];
                                    }
                                    d: {
                                        if ((f | 0) >= 0) {
                                            d = F[a + 108 >> 2];
                                            f = d + F[g + 24 >> 2] | 0;
                                            d = d + e | 0;
                                            break d;
                                        }
                                        e: {
                                            if ((e | 0) < 0) {
                                                f = F[g + 24 >> 2];
                                                d = f >> 31;
                                                d = d ^ d + f;
                                                break e;
                                            }
                                            f = F[g + 24 >> 2];
                                            d = f >> 31;
                                            d = F[a + 100 >> 2] - (d ^ d + f) | 0;
                                        }
                                        if ((f | 0) < 0) {
                                            f = e;
                                            e = e >> 31;
                                            f = f + e ^ e;
                                            break d;
                                        }
                                        f = e;
                                        e = e >> 31;
                                        f = F[a + 100 >> 2] - (f + e ^ e) | 0;
                                    }
                                    e = F[a + 100 >> 2];
                                    f: {
                                        if (!(d | f)) {
                                            f = e;
                                            d = f;
                                            break f;
                                        }
                                        if (!((e | 0) != (f | 0) | d)) {
                                            d = f;
                                            break f;
                                        }
                                        if (!((d | 0) != (e | 0) | f)) {
                                            f = d;
                                            break f;
                                        }
                                        g: {
                                            if (d) {
                                                break g;
                                            }
                                            h = F[a + 108 >> 2];
                                            if ((h | 0) >= (f | 0)) {
                                                break g;
                                            }
                                            f = (h << 1) - f | 0;
                                            d = 0;
                                            break f;
                                        }
                                        h: {
                                            if ((d | 0) != (e | 0)) {
                                                break h;
                                            }
                                            h = F[a + 108 >> 2];
                                            if ((h | 0) <= (f | 0)) {
                                                break h;
                                            }
                                            f = (h << 1) - f | 0;
                                            break f;
                                        }
                                        i: {
                                            if ((e | 0) != (f | 0)) {
                                                break i;
                                            }
                                            e = F[a + 108 >> 2];
                                            if ((e | 0) <= (d | 0)) {
                                                break i;
                                            }
                                            d = (e << 1) - d | 0;
                                            break f;
                                        }
                                        if (f) {
                                            break f;
                                        }
                                        f = 0;
                                        e = F[a + 108 >> 2];
                                        if ((e | 0) >= (d | 0)) {
                                            break f;
                                        }
                                        d = (e << 1) - d | 0;
                                    }
                                    F[g + 12 >> 2] = f;
                                    F[g + 8 >> 2] = d;
                                    j: {
                                        if (F[a + 8 >> 2] <= 0) {
                                            break j;
                                        }
                                        h = F[a + 32 >> 2];
                                        f = 0;
                                        while (1) {
                                            e = F[a + 16 >> 2];
                                            k: {
                                                if ((e | 0) < (d | 0)) {
                                                    F[h + (f << 2) >> 2] = e;
                                                    break k;
                                                }
                                                e = h + (f << 2) | 0;
                                                j = F[a + 12 >> 2];
                                                if ((j | 0) > (d | 0)) {
                                                    F[e >> 2] = j;
                                                    break k;
                                                }
                                                F[e >> 2] = d;
                                            }
                                            f = f + 1 | 0;
                                            e = F[a + 8 >> 2];
                                            if ((f | 0) < (e | 0)) {
                                                d = F[(g + 8 | 0) + (f << 2) >> 2];
                                                continue;
                                            }
                                            break;
                                        }
                                        d = 0;
                                        if ((e | 0) <= 0) {
                                            break j;
                                        }
                                        e = k << 3;
                                        j = e + c | 0;
                                        i = b + e | 0;
                                        while (1) {
                                            f = d << 2;
                                            e = f + j | 0;
                                            f = F[f + i >> 2] + F[f + h >> 2] | 0;
                                            F[e >> 2] = f;
                                            l: {
                                                if ((f | 0) > F[a + 16 >> 2]) {
                                                    f = f - F[a + 20 >> 2] | 0;
                                                }
                                                else {
                                                    if ((f | 0) >= F[a + 12 >> 2]) {
                                                        break l;
                                                    }
                                                    f = f + F[a + 20 >> 2] | 0;
                                                }
                                                F[e >> 2] = f;
                                            }
                                            d = d + 1 | 0;
                                            if ((d | 0) < F[a + 8 >> 2]) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    k = k + 1 | 0;
                                    if ((o | 0) == (k | 0)) {
                                        break a;
                                    }
                                    e = F[a + 56 >> 2];
                                    d = F[e >> 2];
                                    if (F[e + 4 >> 2] - d >> 2 >>> 0 > k >>> 0) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            Da();
                            V();
                        } ea = g + 32 | 0; return 1; }
                        function _i(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0; g = ea - 32 | 0; ea = g; F[a + 68 >> 2] = f; e = F[a + 56 >> 2]; d = F[e >> 2]; f = F[e + 4 >> 2]; F[g + 24 >> 2] = 0; F[g + 16 >> 2] = 0; F[g + 20 >> 2] = 0; a: {
                            f = f - d | 0;
                            if ((f | 0) <= 0) {
                                break a;
                            }
                            d = F[e >> 2];
                            if ((d | 0) != F[e + 4 >> 2]) {
                                m = a + 112 | 0;
                                n = a + 60 | 0;
                                e = f >>> 2 | 0;
                                o = e >>> 0 > 1 ? e : 1;
                                while (1) {
                                    Kb(n, F[(k << 2) + d >> 2], g + 16 | 0);
                                    e = F[g + 20 >> 2];
                                    d = e >> 31;
                                    f = F[g + 16 >> 2];
                                    h = f >> 31;
                                    j = F[g + 24 >> 2];
                                    i = j >> 31;
                                    i = i ^ i + j;
                                    h = i + ((d ^ d + e) + (h ^ f + h) | 0) | 0;
                                    d = 0;
                                    d = h >>> 0 < i >>> 0 ? 1 : d;
                                    b: {
                                        if (!(d | h)) {
                                            F[g + 16 >> 2] = F[a + 108 >> 2];
                                            break b;
                                        }
                                        i = F[a + 108 >> 2];
                                        l = i >> 31;
                                        f = Ij(Hj(i, l, f, f >> 31), fa, h, d);
                                        F[g + 16 >> 2] = f;
                                        d = Ij(Hj(i, l, e, e >> 31), fa, h, d);
                                        F[g + 20 >> 2] = d;
                                        e = d;
                                        d = d >> 31;
                                        e = e + d ^ d;
                                        d = f >> 31;
                                        d = e + (d + f ^ d) | 0;
                                        if ((j | 0) >= 0) {
                                            F[g + 24 >> 2] = i - d;
                                            break b;
                                        }
                                        F[g + 24 >> 2] = d - i;
                                    }
                                    d = Ga(m);
                                    f = F[g + 16 >> 2];
                                    c: {
                                        if (d) {
                                            F[g + 24 >> 2] = 0 - F[g + 24 >> 2];
                                            e = 0 - F[g + 20 >> 2] | 0;
                                            F[g + 20 >> 2] = e;
                                            f = 0 - f | 0;
                                            F[g + 16 >> 2] = f;
                                            break c;
                                        }
                                        e = F[g + 20 >> 2];
                                    }
                                    d: {
                                        if ((f | 0) >= 0) {
                                            d = F[a + 108 >> 2];
                                            f = d + F[g + 24 >> 2] | 0;
                                            d = d + e | 0;
                                            break d;
                                        }
                                        e: {
                                            if ((e | 0) < 0) {
                                                f = F[g + 24 >> 2];
                                                d = f >> 31;
                                                d = d ^ d + f;
                                                break e;
                                            }
                                            f = F[g + 24 >> 2];
                                            d = f >> 31;
                                            d = F[a + 100 >> 2] - (d ^ d + f) | 0;
                                        }
                                        if ((f | 0) < 0) {
                                            f = e;
                                            e = e >> 31;
                                            f = f + e ^ e;
                                            break d;
                                        }
                                        f = e;
                                        e = e >> 31;
                                        f = F[a + 100 >> 2] - (f + e ^ e) | 0;
                                    }
                                    e = F[a + 100 >> 2];
                                    f: {
                                        if (!(d | f)) {
                                            f = e;
                                            d = f;
                                            break f;
                                        }
                                        if (!((e | 0) != (f | 0) | d)) {
                                            d = f;
                                            break f;
                                        }
                                        if (!((d | 0) != (e | 0) | f)) {
                                            f = d;
                                            break f;
                                        }
                                        g: {
                                            if (d) {
                                                break g;
                                            }
                                            h = F[a + 108 >> 2];
                                            if ((h | 0) >= (f | 0)) {
                                                break g;
                                            }
                                            f = (h << 1) - f | 0;
                                            d = 0;
                                            break f;
                                        }
                                        h: {
                                            if ((d | 0) != (e | 0)) {
                                                break h;
                                            }
                                            h = F[a + 108 >> 2];
                                            if ((h | 0) <= (f | 0)) {
                                                break h;
                                            }
                                            f = (h << 1) - f | 0;
                                            break f;
                                        }
                                        i: {
                                            if ((e | 0) != (f | 0)) {
                                                break i;
                                            }
                                            e = F[a + 108 >> 2];
                                            if ((e | 0) <= (d | 0)) {
                                                break i;
                                            }
                                            d = (e << 1) - d | 0;
                                            break f;
                                        }
                                        if (f) {
                                            break f;
                                        }
                                        f = 0;
                                        e = F[a + 108 >> 2];
                                        if ((e | 0) >= (d | 0)) {
                                            break f;
                                        }
                                        d = (e << 1) - d | 0;
                                    }
                                    F[g + 12 >> 2] = f;
                                    F[g + 8 >> 2] = d;
                                    j: {
                                        if (F[a + 8 >> 2] <= 0) {
                                            break j;
                                        }
                                        h = F[a + 32 >> 2];
                                        f = 0;
                                        while (1) {
                                            e = F[a + 16 >> 2];
                                            k: {
                                                if ((e | 0) < (d | 0)) {
                                                    F[h + (f << 2) >> 2] = e;
                                                    break k;
                                                }
                                                e = h + (f << 2) | 0;
                                                j = F[a + 12 >> 2];
                                                if ((j | 0) > (d | 0)) {
                                                    F[e >> 2] = j;
                                                    break k;
                                                }
                                                F[e >> 2] = d;
                                            }
                                            f = f + 1 | 0;
                                            e = F[a + 8 >> 2];
                                            if ((f | 0) < (e | 0)) {
                                                d = F[(g + 8 | 0) + (f << 2) >> 2];
                                                continue;
                                            }
                                            break;
                                        }
                                        d = 0;
                                        if ((e | 0) <= 0) {
                                            break j;
                                        }
                                        e = k << 3;
                                        j = e + c | 0;
                                        i = b + e | 0;
                                        while (1) {
                                            f = d << 2;
                                            e = f + j | 0;
                                            f = F[f + i >> 2] + F[f + h >> 2] | 0;
                                            F[e >> 2] = f;
                                            l: {
                                                if ((f | 0) > F[a + 16 >> 2]) {
                                                    f = f - F[a + 20 >> 2] | 0;
                                                }
                                                else {
                                                    if ((f | 0) >= F[a + 12 >> 2]) {
                                                        break l;
                                                    }
                                                    f = f + F[a + 20 >> 2] | 0;
                                                }
                                                F[e >> 2] = f;
                                            }
                                            d = d + 1 | 0;
                                            if ((d | 0) < F[a + 8 >> 2]) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    k = k + 1 | 0;
                                    if ((o | 0) == (k | 0)) {
                                        break a;
                                    }
                                    e = F[a + 56 >> 2];
                                    d = F[e >> 2];
                                    if (F[e + 4 >> 2] - d >> 2 >>> 0 > k >>> 0) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            Da();
                            V();
                        } ea = g + 32 | 0; return 1; }
                        function ge(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0; h = ea - 80 | 0; ea = h; a: {
                            b: {
                                if (G[F[a + 28 >> 2] + 36 | 0] <= 1) {
                                    d = F[b + 20 >> 2];
                                    c = F[b + 16 >> 2];
                                    e = c + 4 | 0;
                                    d = e >>> 0 < 4 ? d + 1 | 0 : d;
                                    k = F[b + 12 >> 2];
                                    if ((k | 0) <= (d | 0) & e >>> 0 > I[b + 8 >> 2] | (d | 0) > (k | 0)) {
                                        break a;
                                    }
                                    c = c + F[b >> 2] | 0;
                                    i = G[c | 0] | G[c + 1 | 0] << 8 | (G[c + 2 | 0] << 16 | G[c + 3 | 0] << 24);
                                    F[b + 16 >> 2] = e;
                                    F[b + 20 >> 2] = d;
                                    break b;
                                }
                                if (!Oc(1, h + 76 | 0, b)) {
                                    break a;
                                }
                                i = F[h + 76 >> 2];
                            }
                            if (!i) {
                                break a;
                            }
                            d = F[b + 8 >> 2];
                            c = F[b + 16 >> 2];
                            d = Hj(d - c | 0, F[b + 12 >> 2] - (F[b + 20 >> 2] + (c >>> 0 > d >>> 0) | 0) | 0, 5, 0);
                            c = fa;
                            if (d >>> 0 < i >>> 0 & (c | 0) <= 0 | (c | 0) < 0) {
                                break a;
                            }
                            c = F[a + 4 >> 2];
                            d = F[a + 8 >> 2] - c >> 2;
                            c: {
                                if (d >>> 0 < i >>> 0) {
                                    Aa(a + 4 | 0, i - d | 0);
                                    break c;
                                }
                                if (d >>> 0 <= i >>> 0) {
                                    break c;
                                }
                                F[a + 8 >> 2] = c + (i << 2);
                            }
                            r = a + 16 | 0;
                            m = F[a + 32 >> 2];
                            f = 1;
                            while (1) {
                                d: {
                                    g = F[b + 12 >> 2];
                                    c = g;
                                    d = F[b + 20 >> 2];
                                    o = F[b + 8 >> 2];
                                    j = F[b + 16 >> 2];
                                    if ((c | 0) <= (d | 0) & o >>> 0 <= j >>> 0 | (c | 0) < (d | 0)) {
                                        break d;
                                    }
                                    p = F[b >> 2];
                                    k = G[p + j | 0];
                                    c = d;
                                    e = j + 1 | 0;
                                    c = e ? c : c + 1 | 0;
                                    F[b + 16 >> 2] = e;
                                    F[b + 20 >> 2] = c;
                                    if ((c | 0) >= (g | 0) & e >>> 0 >= o >>> 0 | (c | 0) > (g | 0)) {
                                        break d;
                                    }
                                    e = G[e + p | 0];
                                    c = d;
                                    l = j + 2 | 0;
                                    c = l >>> 0 < 2 ? c + 1 | 0 : c;
                                    F[b + 16 >> 2] = l;
                                    F[b + 20 >> 2] = c;
                                    if ((c | 0) >= (g | 0) & l >>> 0 >= o >>> 0 | (c | 0) > (g | 0)) {
                                        break d;
                                    }
                                    l = G[l + p | 0];
                                    c = d;
                                    q = j + 3 | 0;
                                    c = q >>> 0 < 3 ? c + 1 | 0 : c;
                                    F[b + 16 >> 2] = q;
                                    F[b + 20 >> 2] = c;
                                    if ((c | 0) >= (g | 0) & q >>> 0 >= o >>> 0 | (c | 0) > (g | 0)) {
                                        break d;
                                    }
                                    g = G[q + p | 0];
                                    c = d;
                                    d = j + 4 | 0;
                                    c = d >>> 0 < 4 ? c + 1 | 0 : c;
                                    F[b + 16 >> 2] = d;
                                    F[b + 20 >> 2] = c;
                                    if (!l | ((e - 12 & 255) >>> 0 < 245 | k >>> 0 > 4)) {
                                        break d;
                                    }
                                    j = Fb(h + 8 | 0);
                                    o = l << 24 >> 24;
                                    g = (g | 0) != 0;
                                    d = e - 1 | 0;
                                    if (d >>> 0 <= 10) {
                                        c = F[(d << 2) + 13616 >> 2];
                                    }
                                    else {
                                        c = -1;
                                    }
                                    d = L(c, l);
                                    mc(j, k, o, e, g, d, d >> 31);
                                    d = H[F[a + 28 >> 2] + 36 >> 1];
                                    e: {
                                        if (((d << 8 | d >>> 8) & 65535) >>> 0 <= 258) {
                                            c = F[b + 20 >> 2];
                                            d = F[b + 16 >> 2];
                                            e = d + 2 | 0;
                                            c = e >>> 0 < 2 ? c + 1 | 0 : c;
                                            k = F[b + 12 >> 2];
                                            if ((k | 0) <= (c | 0) & e >>> 0 > I[b + 8 >> 2] | (c | 0) > (k | 0)) {
                                                break d;
                                            }
                                            d = d + F[b >> 2] | 0;
                                            f = G[d | 0] | G[d + 1 | 0] << 8;
                                            F[b + 16 >> 2] = e;
                                            F[b + 20 >> 2] = c;
                                            break e;
                                        }
                                        if (!Oc(1, h + 4 | 0, b)) {
                                            break d;
                                        }
                                        f = F[h + 4 >> 2];
                                    }
                                    F[h + 68 >> 2] = f;
                                    d = kc(sa(96), j);
                                    ga[F[F[m >> 2] + 8 >> 2]](m, F[m + 12 >> 2] - F[m + 8 >> 2] >> 2, d);
                                    d = (F[m + 12 >> 2] - F[m + 8 >> 2] >> 2) - 1 | 0;
                                    e = d << 2;
                                    F[F[e + F[m + 8 >> 2] >> 2] + 60 >> 2] = f;
                                    F[F[a + 4 >> 2] + (n << 2) >> 2] = d;
                                    f = F[a + 16 >> 2];
                                    c = F[a + 20 >> 2] - f >> 2;
                                    f: {
                                        if ((c | 0) > (d | 0)) {
                                            break f;
                                        }
                                        F[h >> 2] = -1;
                                        d = d + 1 | 0;
                                        if (d >>> 0 > c >>> 0) {
                                            Ia(r, d - c | 0, h);
                                            f = F[r >> 2];
                                            break f;
                                        }
                                        if (c >>> 0 <= d >>> 0) {
                                            break f;
                                        }
                                        F[a + 20 >> 2] = (d << 2) + f;
                                    }
                                    F[e + f >> 2] = n;
                                    n = n + 1 | 0;
                                    f = n >>> 0 < i >>> 0;
                                    if ((i | 0) != (n | 0)) {
                                        continue;
                                    }
                                }
                                break;
                            }
                            n = !f;
                        } ea = h + 80 | 0; return n & 1; }
                        function Je(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0; c = H[b + 38 >> 1]; a: {
                            if (!c) {
                                break a;
                            }
                            b: {
                                if (c >>> 0 <= 511) {
                                    d = F[b + 12 >> 2];
                                    c = F[b + 20 >> 2];
                                    g = F[b + 16 >> 2];
                                    e = g + 4 | 0;
                                    c = e >>> 0 < 4 ? c + 1 | 0 : c;
                                    if (e >>> 0 > I[b + 8 >> 2] & (c | 0) >= (d | 0) | (c | 0) > (d | 0)) {
                                        break a;
                                    }
                                    c = g + F[b >> 2] | 0;
                                    f = G[c | 0] | G[c + 1 | 0] << 8 | (G[c + 2 | 0] << 16 | G[c + 3 | 0] << 24);
                                    F[a + 12 >> 2] = f;
                                    c = F[b + 20 >> 2];
                                    d = F[b + 16 >> 2] + 4 | 0;
                                    c = d >>> 0 < 4 ? c + 1 | 0 : c;
                                    F[b + 16 >> 2] = d;
                                    F[b + 20 >> 2] = c;
                                    break b;
                                }
                                if (!jb(1, a + 12 | 0, b)) {
                                    break a;
                                }
                                f = F[a + 12 >> 2];
                            }
                            d = F[a >> 2];
                            c = F[a + 4 >> 2] - d >> 2;
                            c: {
                                if (c >>> 0 < f >>> 0) {
                                    Aa(a, f - c | 0);
                                    f = F[a + 12 >> 2];
                                    break c;
                                }
                                if (c >>> 0 <= f >>> 0) {
                                    break c;
                                }
                                F[a + 4 >> 2] = d + (f << 2);
                            }
                            if (!f) {
                                return 1;
                            }
                            j = F[b + 8 >> 2];
                            i = F[b + 12 >> 2];
                            l = F[a >> 2];
                            g = 0;
                            while (1) {
                                c = F[b + 20 >> 2];
                                d = F[b + 16 >> 2];
                                if ((i | 0) <= (c | 0) & j >>> 0 <= d >>> 0 | (c | 0) > (i | 0)) {
                                    return 0;
                                }
                                m = F[b >> 2];
                                k = G[m + d | 0];
                                d = d + 1 | 0;
                                c = d ? c : c + 1 | 0;
                                h = d;
                                F[b + 16 >> 2] = d;
                                F[b + 20 >> 2] = c;
                                d = k >>> 2 | 0;
                                e = 0;
                                d: {
                                    e: {
                                        f: {
                                            g: {
                                                n = k & 3;
                                                switch (n | 0) {
                                                    case 0: break e;
                                                    case 3: break g;
                                                    default: break f;
                                                }
                                            }
                                            c = d + g | 0;
                                            if (c >>> 0 >= f >>> 0) {
                                                return 0;
                                            }
                                            ua(l + (g << 2) | 0, 0, (k & 252) + 4 | 0);
                                            g = c;
                                            break d;
                                        }
                                        while (1) {
                                            if ((c | 0) >= (i | 0) & h >>> 0 >= j >>> 0 | (c | 0) > (i | 0)) {
                                                break a;
                                            }
                                            f = G[h + m | 0];
                                            h = h + 1 | 0;
                                            c = h ? c : c + 1 | 0;
                                            F[b + 16 >> 2] = h;
                                            F[b + 20 >> 2] = c;
                                            d = f << (e << 3 | 6) | d;
                                            e = e + 1 | 0;
                                            if ((n | 0) != (e | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    F[l + (g << 2) >> 2] = d;
                                }
                                f = F[a + 12 >> 2];
                                g = g + 1 | 0;
                                if (f >>> 0 > g >>> 0) {
                                    continue;
                                }
                                break;
                            }
                            c = a + 16 | 0;
                            k = F[a >> 2];
                            d = F[a + 16 >> 2];
                            b = F[a + 20 >> 2] - d | 0;
                            h: {
                                if (b >>> 0 <= 16383) {
                                    Aa(c, 4096 - (b >>> 2 | 0) | 0);
                                    break h;
                                }
                                if ((b | 0) == 16384) {
                                    break h;
                                }
                                F[a + 20 >> 2] = d + 16384;
                            }
                            b = a + 28 | 0;
                            g = F[b >> 2];
                            d = F[a + 32 >> 2] - g >> 3;
                            i: {
                                if (d >>> 0 < f >>> 0) {
                                    tb(b, f - d | 0);
                                    g = F[b >> 2];
                                    break i;
                                }
                                if (d >>> 0 > f >>> 0) {
                                    F[a + 32 >> 2] = (f << 3) + g;
                                }
                                if (!f) {
                                    break a;
                                }
                            }
                            e = 0;
                            a = 0;
                            while (1) {
                                b = k + (e << 2) | 0;
                                i = F[b >> 2];
                                d = a;
                                h = (e << 3) + g | 0;
                                F[h + 4 >> 2] = d;
                                F[h >> 2] = i;
                                i = F[b >> 2];
                                a = i + d | 0;
                                if (a >>> 0 > 4096) {
                                    break a;
                                }
                                j: {
                                    if (a >>> 0 <= d >>> 0) {
                                        break j;
                                    }
                                    h = F[c >> 2];
                                    b = 0;
                                    j = i & 7;
                                    if (j) {
                                        while (1) {
                                            F[h + (d << 2) >> 2] = e;
                                            d = d + 1 | 0;
                                            b = b + 1 | 0;
                                            if ((j | 0) != (b | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    if (i - 1 >>> 0 <= 6) {
                                        break j;
                                    }
                                    while (1) {
                                        b = h + (d << 2) | 0;
                                        F[b >> 2] = e;
                                        F[b + 28 >> 2] = e;
                                        F[b + 24 >> 2] = e;
                                        F[b + 20 >> 2] = e;
                                        F[b + 16 >> 2] = e;
                                        F[b + 12 >> 2] = e;
                                        F[b + 8 >> 2] = e;
                                        F[b + 4 >> 2] = e;
                                        d = d + 8 | 0;
                                        if ((d | 0) != (a | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                e = e + 1 | 0;
                                if ((e | 0) != (f | 0)) {
                                    continue;
                                }
                                break;
                            }
                            o = (a | 0) == 4096;
                        } return o; }
                        function Hi(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0; g = ea - 48 | 0; ea = g; d = F[a + 8 >> 2]; if (d - 31 >>> 0 >= 4294967267) {
                            F[a + 76 >> 2] = d;
                            e = -1 << d;
                            d = -2 - e | 0;
                            F[a + 84 >> 2] = d;
                            F[a + 80 >> 2] = e ^ -1;
                            F[a + 92 >> 2] = (d | 0) / 2;
                            J[a + 88 >> 2] = M(2) / M(d | 0);
                        } F[a + 52 >> 2] = f; e = F[a + 40 >> 2]; d = F[e >> 2]; f = F[e + 4 >> 2]; F[g + 16 >> 2] = 0; F[g + 8 >> 2] = 0; F[g + 12 >> 2] = 0; a: {
                            f = f - d | 0;
                            if ((f | 0) <= 0) {
                                break a;
                            }
                            d = F[e >> 2];
                            if ((d | 0) != F[e + 4 >> 2]) {
                                m = a + 8 | 0;
                                n = a + 96 | 0;
                                o = a + 44 | 0;
                                e = f >>> 2 | 0;
                                p = e >>> 0 > 1 ? e : 1;
                                while (1) {
                                    Mb(o, F[(j << 2) + d >> 2], g + 8 | 0);
                                    e = F[g + 12 >> 2];
                                    d = e >> 31;
                                    f = F[g + 8 >> 2];
                                    h = f >> 31;
                                    k = F[g + 16 >> 2];
                                    i = k >> 31;
                                    i = i ^ i + k;
                                    h = i + ((d ^ d + e) + (h ^ f + h) | 0) | 0;
                                    d = 0;
                                    d = h >>> 0 < i >>> 0 ? 1 : d;
                                    b: {
                                        if (!(d | h)) {
                                            F[g + 8 >> 2] = F[a + 92 >> 2];
                                            break b;
                                        }
                                        i = F[a + 92 >> 2];
                                        l = i >> 31;
                                        f = Ij(Hj(i, l, f, f >> 31), fa, h, d);
                                        F[g + 8 >> 2] = f;
                                        d = Ij(Hj(i, l, e, e >> 31), fa, h, d);
                                        F[g + 12 >> 2] = d;
                                        e = d >> 31;
                                        e = e ^ d + e;
                                        d = f >> 31;
                                        d = e + (d + f ^ d) | 0;
                                        if ((k | 0) >= 0) {
                                            F[g + 16 >> 2] = i - d;
                                            break b;
                                        }
                                        F[g + 16 >> 2] = d - i;
                                    }
                                    d = Ga(n);
                                    f = F[g + 8 >> 2];
                                    c: {
                                        if (d) {
                                            F[g + 16 >> 2] = 0 - F[g + 16 >> 2];
                                            e = 0 - F[g + 12 >> 2] | 0;
                                            F[g + 12 >> 2] = e;
                                            f = 0 - f | 0;
                                            F[g + 8 >> 2] = f;
                                            break c;
                                        }
                                        e = F[g + 12 >> 2];
                                    }
                                    d: {
                                        if ((f | 0) >= 0) {
                                            f = F[a + 92 >> 2];
                                            d = f + F[g + 16 >> 2] | 0;
                                            f = e + f | 0;
                                            break d;
                                        }
                                        e: {
                                            if ((e | 0) < 0) {
                                                d = F[g + 16 >> 2];
                                                f = d >> 31;
                                                f = f ^ d + f;
                                                break e;
                                            }
                                            d = F[g + 16 >> 2];
                                            f = d >> 31;
                                            f = F[a + 84 >> 2] - (f ^ d + f) | 0;
                                        }
                                        if ((d | 0) < 0) {
                                            d = e >> 31;
                                            d = d + e ^ d;
                                            break d;
                                        }
                                        d = e >> 31;
                                        d = F[a + 84 >> 2] - (d + e ^ d) | 0;
                                    }
                                    e = F[a + 84 >> 2];
                                    f: {
                                        if (!(d | f)) {
                                            d = e;
                                            f = d;
                                            break f;
                                        }
                                        if (!((d | 0) != (e | 0) | f)) {
                                            f = d;
                                            break f;
                                        }
                                        if (!((e | 0) != (f | 0) | d)) {
                                            d = f;
                                            break f;
                                        }
                                        g: {
                                            if (f) {
                                                break g;
                                            }
                                            h = F[a + 92 >> 2];
                                            if ((h | 0) >= (d | 0)) {
                                                break g;
                                            }
                                            d = (h << 1) - d | 0;
                                            f = 0;
                                            break f;
                                        }
                                        h: {
                                            if ((e | 0) != (f | 0)) {
                                                break h;
                                            }
                                            h = F[a + 92 >> 2];
                                            if ((h | 0) <= (d | 0)) {
                                                break h;
                                            }
                                            d = (h << 1) - d | 0;
                                            break f;
                                        }
                                        i: {
                                            if ((d | 0) != (e | 0)) {
                                                break i;
                                            }
                                            e = F[a + 92 >> 2];
                                            if ((e | 0) <= (f | 0)) {
                                                break i;
                                            }
                                            f = (e << 1) - f | 0;
                                            break f;
                                        }
                                        if (d) {
                                            break f;
                                        }
                                        d = 0;
                                        e = F[a + 92 >> 2];
                                        if ((e | 0) >= (f | 0)) {
                                            break f;
                                        }
                                        f = (e << 1) - f | 0;
                                    }
                                    e = j << 3;
                                    h = e + b | 0;
                                    k = F[h + 4 >> 2];
                                    h = F[h >> 2];
                                    F[g + 36 >> 2] = d;
                                    F[g + 32 >> 2] = f;
                                    F[g + 24 >> 2] = h;
                                    F[g + 28 >> 2] = k;
                                    rc(g + 40 | 0, m, g + 32 | 0, g + 24 | 0);
                                    d = c + e | 0;
                                    F[d >> 2] = F[g + 40 >> 2];
                                    F[d + 4 >> 2] = F[g + 44 >> 2];
                                    j = j + 1 | 0;
                                    if ((p | 0) == (j | 0)) {
                                        break a;
                                    }
                                    e = F[a + 40 >> 2];
                                    d = F[e >> 2];
                                    if (F[e + 4 >> 2] - d >> 2 >>> 0 > j >>> 0) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            Da();
                            V();
                        } ea = g + 48 | 0; return 1; }
                        function Di(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0; g = ea - 48 | 0; ea = g; d = F[a + 8 >> 2]; if (d - 31 >>> 0 >= 4294967267) {
                            F[a + 76 >> 2] = d;
                            e = -1 << d;
                            d = -2 - e | 0;
                            F[a + 84 >> 2] = d;
                            F[a + 80 >> 2] = e ^ -1;
                            F[a + 92 >> 2] = (d | 0) / 2;
                            J[a + 88 >> 2] = M(2) / M(d | 0);
                        } F[a + 52 >> 2] = f; e = F[a + 40 >> 2]; d = F[e >> 2]; f = F[e + 4 >> 2]; F[g + 16 >> 2] = 0; F[g + 8 >> 2] = 0; F[g + 12 >> 2] = 0; a: {
                            f = f - d | 0;
                            if ((f | 0) <= 0) {
                                break a;
                            }
                            d = F[e >> 2];
                            if ((d | 0) != F[e + 4 >> 2]) {
                                m = a + 8 | 0;
                                n = a + 96 | 0;
                                o = a + 44 | 0;
                                e = f >>> 2 | 0;
                                p = e >>> 0 > 1 ? e : 1;
                                while (1) {
                                    Kb(o, F[(j << 2) + d >> 2], g + 8 | 0);
                                    e = F[g + 12 >> 2];
                                    d = e >> 31;
                                    f = F[g + 8 >> 2];
                                    h = f >> 31;
                                    k = F[g + 16 >> 2];
                                    i = k >> 31;
                                    i = i ^ i + k;
                                    h = i + ((d ^ d + e) + (h ^ f + h) | 0) | 0;
                                    d = 0;
                                    d = h >>> 0 < i >>> 0 ? 1 : d;
                                    b: {
                                        if (!(d | h)) {
                                            F[g + 8 >> 2] = F[a + 92 >> 2];
                                            break b;
                                        }
                                        i = F[a + 92 >> 2];
                                        l = i >> 31;
                                        f = Ij(Hj(i, l, f, f >> 31), fa, h, d);
                                        F[g + 8 >> 2] = f;
                                        d = Ij(Hj(i, l, e, e >> 31), fa, h, d);
                                        F[g + 12 >> 2] = d;
                                        e = d >> 31;
                                        e = e ^ d + e;
                                        d = f >> 31;
                                        d = e + (d + f ^ d) | 0;
                                        if ((k | 0) >= 0) {
                                            F[g + 16 >> 2] = i - d;
                                            break b;
                                        }
                                        F[g + 16 >> 2] = d - i;
                                    }
                                    d = Ga(n);
                                    f = F[g + 8 >> 2];
                                    c: {
                                        if (d) {
                                            F[g + 16 >> 2] = 0 - F[g + 16 >> 2];
                                            e = 0 - F[g + 12 >> 2] | 0;
                                            F[g + 12 >> 2] = e;
                                            f = 0 - f | 0;
                                            F[g + 8 >> 2] = f;
                                            break c;
                                        }
                                        e = F[g + 12 >> 2];
                                    }
                                    d: {
                                        if ((f | 0) >= 0) {
                                            f = F[a + 92 >> 2];
                                            d = f + F[g + 16 >> 2] | 0;
                                            f = e + f | 0;
                                            break d;
                                        }
                                        e: {
                                            if ((e | 0) < 0) {
                                                d = F[g + 16 >> 2];
                                                f = d >> 31;
                                                f = f ^ d + f;
                                                break e;
                                            }
                                            d = F[g + 16 >> 2];
                                            f = d >> 31;
                                            f = F[a + 84 >> 2] - (f ^ d + f) | 0;
                                        }
                                        if ((d | 0) < 0) {
                                            d = e >> 31;
                                            d = d + e ^ d;
                                            break d;
                                        }
                                        d = e >> 31;
                                        d = F[a + 84 >> 2] - (d + e ^ d) | 0;
                                    }
                                    e = F[a + 84 >> 2];
                                    f: {
                                        if (!(d | f)) {
                                            d = e;
                                            f = d;
                                            break f;
                                        }
                                        if (!((d | 0) != (e | 0) | f)) {
                                            f = d;
                                            break f;
                                        }
                                        if (!((e | 0) != (f | 0) | d)) {
                                            d = f;
                                            break f;
                                        }
                                        g: {
                                            if (f) {
                                                break g;
                                            }
                                            h = F[a + 92 >> 2];
                                            if ((h | 0) >= (d | 0)) {
                                                break g;
                                            }
                                            d = (h << 1) - d | 0;
                                            f = 0;
                                            break f;
                                        }
                                        h: {
                                            if ((e | 0) != (f | 0)) {
                                                break h;
                                            }
                                            h = F[a + 92 >> 2];
                                            if ((h | 0) <= (d | 0)) {
                                                break h;
                                            }
                                            d = (h << 1) - d | 0;
                                            break f;
                                        }
                                        i: {
                                            if ((d | 0) != (e | 0)) {
                                                break i;
                                            }
                                            e = F[a + 92 >> 2];
                                            if ((e | 0) <= (f | 0)) {
                                                break i;
                                            }
                                            f = (e << 1) - f | 0;
                                            break f;
                                        }
                                        if (d) {
                                            break f;
                                        }
                                        d = 0;
                                        e = F[a + 92 >> 2];
                                        if ((e | 0) >= (f | 0)) {
                                            break f;
                                        }
                                        f = (e << 1) - f | 0;
                                    }
                                    e = j << 3;
                                    h = e + b | 0;
                                    k = F[h + 4 >> 2];
                                    h = F[h >> 2];
                                    F[g + 36 >> 2] = d;
                                    F[g + 32 >> 2] = f;
                                    F[g + 24 >> 2] = h;
                                    F[g + 28 >> 2] = k;
                                    rc(g + 40 | 0, m, g + 32 | 0, g + 24 | 0);
                                    d = c + e | 0;
                                    F[d >> 2] = F[g + 40 >> 2];
                                    F[d + 4 >> 2] = F[g + 44 >> 2];
                                    j = j + 1 | 0;
                                    if ((p | 0) == (j | 0)) {
                                        break a;
                                    }
                                    e = F[a + 40 >> 2];
                                    d = F[e >> 2];
                                    if (F[e + 4 >> 2] - d >> 2 >>> 0 > j >>> 0) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            Da();
                            V();
                        } ea = g + 48 | 0; return 1; }
                        function Qi(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0; g = ea - 48 | 0; ea = g; d = F[a + 8 >> 2]; if (d - 31 >>> 0 >= 4294967267) {
                            F[a + 76 >> 2] = d;
                            e = -1 << d;
                            d = -2 - e | 0;
                            F[a + 84 >> 2] = d;
                            F[a + 80 >> 2] = e ^ -1;
                            F[a + 92 >> 2] = (d | 0) / 2;
                            J[a + 88 >> 2] = M(2) / M(d | 0);
                        } F[a + 52 >> 2] = f; e = F[a + 40 >> 2]; d = F[e >> 2]; f = F[e + 4 >> 2]; F[g + 16 >> 2] = 0; F[g + 8 >> 2] = 0; F[g + 12 >> 2] = 0; a: {
                            f = f - d | 0;
                            if ((f | 0) <= 0) {
                                break a;
                            }
                            d = F[e >> 2];
                            if ((d | 0) != F[e + 4 >> 2]) {
                                m = a + 8 | 0;
                                n = a + 96 | 0;
                                o = a + 44 | 0;
                                e = f >>> 2 | 0;
                                p = e >>> 0 > 1 ? e : 1;
                                while (1) {
                                    Mb(o, F[(j << 2) + d >> 2], g + 8 | 0);
                                    e = F[g + 12 >> 2];
                                    d = e >> 31;
                                    f = F[g + 8 >> 2];
                                    h = f >> 31;
                                    k = F[g + 16 >> 2];
                                    i = k >> 31;
                                    i = i ^ i + k;
                                    h = i + ((d ^ d + e) + (h ^ f + h) | 0) | 0;
                                    d = 0;
                                    d = h >>> 0 < i >>> 0 ? 1 : d;
                                    b: {
                                        if (!(d | h)) {
                                            F[g + 8 >> 2] = F[a + 92 >> 2];
                                            break b;
                                        }
                                        i = F[a + 92 >> 2];
                                        l = i >> 31;
                                        f = Ij(Hj(i, l, f, f >> 31), fa, h, d);
                                        F[g + 8 >> 2] = f;
                                        d = Ij(Hj(i, l, e, e >> 31), fa, h, d);
                                        F[g + 12 >> 2] = d;
                                        e = d >> 31;
                                        e = e ^ d + e;
                                        d = f >> 31;
                                        d = e + (d + f ^ d) | 0;
                                        if ((k | 0) >= 0) {
                                            F[g + 16 >> 2] = i - d;
                                            break b;
                                        }
                                        F[g + 16 >> 2] = d - i;
                                    }
                                    d = Ga(n);
                                    f = F[g + 8 >> 2];
                                    c: {
                                        if (d) {
                                            F[g + 16 >> 2] = 0 - F[g + 16 >> 2];
                                            e = 0 - F[g + 12 >> 2] | 0;
                                            F[g + 12 >> 2] = e;
                                            f = 0 - f | 0;
                                            F[g + 8 >> 2] = f;
                                            break c;
                                        }
                                        e = F[g + 12 >> 2];
                                    }
                                    d: {
                                        if ((f | 0) >= 0) {
                                            f = F[a + 92 >> 2];
                                            d = f + F[g + 16 >> 2] | 0;
                                            f = e + f | 0;
                                            break d;
                                        }
                                        e: {
                                            if ((e | 0) < 0) {
                                                d = F[g + 16 >> 2];
                                                f = d >> 31;
                                                f = f ^ d + f;
                                                break e;
                                            }
                                            d = F[g + 16 >> 2];
                                            f = d >> 31;
                                            f = F[a + 84 >> 2] - (f ^ d + f) | 0;
                                        }
                                        if ((d | 0) < 0) {
                                            d = e >> 31;
                                            d = d + e ^ d;
                                            break d;
                                        }
                                        d = e >> 31;
                                        d = F[a + 84 >> 2] - (d + e ^ d) | 0;
                                    }
                                    e = F[a + 84 >> 2];
                                    f: {
                                        if (!(d | f)) {
                                            d = e;
                                            f = d;
                                            break f;
                                        }
                                        if (!((d | 0) != (e | 0) | f)) {
                                            f = d;
                                            break f;
                                        }
                                        if (!((e | 0) != (f | 0) | d)) {
                                            d = f;
                                            break f;
                                        }
                                        g: {
                                            if (f) {
                                                break g;
                                            }
                                            h = F[a + 92 >> 2];
                                            if ((h | 0) >= (d | 0)) {
                                                break g;
                                            }
                                            d = (h << 1) - d | 0;
                                            f = 0;
                                            break f;
                                        }
                                        h: {
                                            if ((e | 0) != (f | 0)) {
                                                break h;
                                            }
                                            h = F[a + 92 >> 2];
                                            if ((h | 0) <= (d | 0)) {
                                                break h;
                                            }
                                            d = (h << 1) - d | 0;
                                            break f;
                                        }
                                        i: {
                                            if ((d | 0) != (e | 0)) {
                                                break i;
                                            }
                                            e = F[a + 92 >> 2];
                                            if ((e | 0) <= (f | 0)) {
                                                break i;
                                            }
                                            f = (e << 1) - f | 0;
                                            break f;
                                        }
                                        if (d) {
                                            break f;
                                        }
                                        d = 0;
                                        e = F[a + 92 >> 2];
                                        if ((e | 0) >= (f | 0)) {
                                            break f;
                                        }
                                        f = (e << 1) - f | 0;
                                    }
                                    e = j << 3;
                                    h = e + b | 0;
                                    k = F[h + 4 >> 2];
                                    F[g + 40 >> 2] = F[h >> 2];
                                    F[g + 44 >> 2] = k;
                                    F[g + 28 >> 2] = d;
                                    F[g + 24 >> 2] = f;
                                    sc(g + 32 | 0, m, g + 24 | 0, g + 40 | 0);
                                    d = c + e | 0;
                                    F[d >> 2] = F[g + 32 >> 2];
                                    F[d + 4 >> 2] = F[g + 36 >> 2];
                                    j = j + 1 | 0;
                                    if ((p | 0) == (j | 0)) {
                                        break a;
                                    }
                                    e = F[a + 40 >> 2];
                                    d = F[e >> 2];
                                    if (F[e + 4 >> 2] - d >> 2 >>> 0 > j >>> 0) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            Da();
                            V();
                        } ea = g + 48 | 0; return 1; }
                        function Mi(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0; g = ea - 48 | 0; ea = g; d = F[a + 8 >> 2]; if (d - 31 >>> 0 >= 4294967267) {
                            F[a + 76 >> 2] = d;
                            e = -1 << d;
                            d = -2 - e | 0;
                            F[a + 84 >> 2] = d;
                            F[a + 80 >> 2] = e ^ -1;
                            F[a + 92 >> 2] = (d | 0) / 2;
                            J[a + 88 >> 2] = M(2) / M(d | 0);
                        } F[a + 52 >> 2] = f; e = F[a + 40 >> 2]; d = F[e >> 2]; f = F[e + 4 >> 2]; F[g + 16 >> 2] = 0; F[g + 8 >> 2] = 0; F[g + 12 >> 2] = 0; a: {
                            f = f - d | 0;
                            if ((f | 0) <= 0) {
                                break a;
                            }
                            d = F[e >> 2];
                            if ((d | 0) != F[e + 4 >> 2]) {
                                m = a + 8 | 0;
                                n = a + 96 | 0;
                                o = a + 44 | 0;
                                e = f >>> 2 | 0;
                                p = e >>> 0 > 1 ? e : 1;
                                while (1) {
                                    Kb(o, F[(j << 2) + d >> 2], g + 8 | 0);
                                    e = F[g + 12 >> 2];
                                    d = e >> 31;
                                    f = F[g + 8 >> 2];
                                    h = f >> 31;
                                    k = F[g + 16 >> 2];
                                    i = k >> 31;
                                    i = i ^ i + k;
                                    h = i + ((d ^ d + e) + (h ^ f + h) | 0) | 0;
                                    d = 0;
                                    d = h >>> 0 < i >>> 0 ? 1 : d;
                                    b: {
                                        if (!(d | h)) {
                                            F[g + 8 >> 2] = F[a + 92 >> 2];
                                            break b;
                                        }
                                        i = F[a + 92 >> 2];
                                        l = i >> 31;
                                        f = Ij(Hj(i, l, f, f >> 31), fa, h, d);
                                        F[g + 8 >> 2] = f;
                                        d = Ij(Hj(i, l, e, e >> 31), fa, h, d);
                                        F[g + 12 >> 2] = d;
                                        e = d >> 31;
                                        e = e ^ d + e;
                                        d = f >> 31;
                                        d = e + (d + f ^ d) | 0;
                                        if ((k | 0) >= 0) {
                                            F[g + 16 >> 2] = i - d;
                                            break b;
                                        }
                                        F[g + 16 >> 2] = d - i;
                                    }
                                    d = Ga(n);
                                    f = F[g + 8 >> 2];
                                    c: {
                                        if (d) {
                                            F[g + 16 >> 2] = 0 - F[g + 16 >> 2];
                                            e = 0 - F[g + 12 >> 2] | 0;
                                            F[g + 12 >> 2] = e;
                                            f = 0 - f | 0;
                                            F[g + 8 >> 2] = f;
                                            break c;
                                        }
                                        e = F[g + 12 >> 2];
                                    }
                                    d: {
                                        if ((f | 0) >= 0) {
                                            f = F[a + 92 >> 2];
                                            d = f + F[g + 16 >> 2] | 0;
                                            f = e + f | 0;
                                            break d;
                                        }
                                        e: {
                                            if ((e | 0) < 0) {
                                                d = F[g + 16 >> 2];
                                                f = d >> 31;
                                                f = f ^ d + f;
                                                break e;
                                            }
                                            d = F[g + 16 >> 2];
                                            f = d >> 31;
                                            f = F[a + 84 >> 2] - (f ^ d + f) | 0;
                                        }
                                        if ((d | 0) < 0) {
                                            d = e >> 31;
                                            d = d + e ^ d;
                                            break d;
                                        }
                                        d = e >> 31;
                                        d = F[a + 84 >> 2] - (d + e ^ d) | 0;
                                    }
                                    e = F[a + 84 >> 2];
                                    f: {
                                        if (!(d | f)) {
                                            d = e;
                                            f = d;
                                            break f;
                                        }
                                        if (!((d | 0) != (e | 0) | f)) {
                                            f = d;
                                            break f;
                                        }
                                        if (!((e | 0) != (f | 0) | d)) {
                                            d = f;
                                            break f;
                                        }
                                        g: {
                                            if (f) {
                                                break g;
                                            }
                                            h = F[a + 92 >> 2];
                                            if ((h | 0) >= (d | 0)) {
                                                break g;
                                            }
                                            d = (h << 1) - d | 0;
                                            f = 0;
                                            break f;
                                        }
                                        h: {
                                            if ((e | 0) != (f | 0)) {
                                                break h;
                                            }
                                            h = F[a + 92 >> 2];
                                            if ((h | 0) <= (d | 0)) {
                                                break h;
                                            }
                                            d = (h << 1) - d | 0;
                                            break f;
                                        }
                                        i: {
                                            if ((d | 0) != (e | 0)) {
                                                break i;
                                            }
                                            e = F[a + 92 >> 2];
                                            if ((e | 0) <= (f | 0)) {
                                                break i;
                                            }
                                            f = (e << 1) - f | 0;
                                            break f;
                                        }
                                        if (d) {
                                            break f;
                                        }
                                        d = 0;
                                        e = F[a + 92 >> 2];
                                        if ((e | 0) >= (f | 0)) {
                                            break f;
                                        }
                                        f = (e << 1) - f | 0;
                                    }
                                    e = j << 3;
                                    h = e + b | 0;
                                    k = F[h + 4 >> 2];
                                    F[g + 40 >> 2] = F[h >> 2];
                                    F[g + 44 >> 2] = k;
                                    F[g + 28 >> 2] = d;
                                    F[g + 24 >> 2] = f;
                                    sc(g + 32 | 0, m, g + 24 | 0, g + 40 | 0);
                                    d = c + e | 0;
                                    F[d >> 2] = F[g + 32 >> 2];
                                    F[d + 4 >> 2] = F[g + 36 >> 2];
                                    j = j + 1 | 0;
                                    if ((p | 0) == (j | 0)) {
                                        break a;
                                    }
                                    e = F[a + 40 >> 2];
                                    d = F[e >> 2];
                                    if (F[e + 4 >> 2] - d >> 2 >>> 0 > j >>> 0) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            Da();
                            V();
                        } ea = g + 48 | 0; return 1; }
                        function Ce(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0; f = ea - 16 | 0; ea = f; c = F[a + 4 >> 2]; F[a + 40 >> 2] = F[a >> 2]; F[a + 44 >> 2] = c; c = F[a + 36 >> 2]; F[a + 72 >> 2] = F[a + 32 >> 2]; F[a + 76 >> 2] = c; d = F[a + 28 >> 2]; c = a - -64 | 0; F[c >> 2] = F[a + 24 >> 2]; F[c + 4 >> 2] = d; c = F[a + 20 >> 2]; F[a + 56 >> 2] = F[a + 16 >> 2]; F[a + 60 >> 2] = c; c = F[a + 12 >> 2]; F[a + 48 >> 2] = F[a + 8 >> 2]; F[a + 52 >> 2] = c; a: {
                            b: {
                                if (Eb(a + 40 | 0, 1, f + 8 | 0)) {
                                    c = F[a + 44 >> 2];
                                    F[a >> 2] = F[a + 40 >> 2];
                                    F[a + 4 >> 2] = c;
                                    c = F[a + 76 >> 2];
                                    F[a + 32 >> 2] = F[a + 72 >> 2];
                                    F[a + 36 >> 2] = c;
                                    c = F[a + 68 >> 2];
                                    F[a + 24 >> 2] = F[a + 64 >> 2];
                                    F[a + 28 >> 2] = c;
                                    d = F[a + 60 >> 2];
                                    h = d;
                                    c = F[a + 56 >> 2];
                                    F[a + 16 >> 2] = c;
                                    F[a + 20 >> 2] = d;
                                    e = F[a + 52 >> 2];
                                    d = F[a + 48 >> 2];
                                    F[a + 8 >> 2] = d;
                                    F[a + 12 >> 2] = e;
                                    i = d - c | 0;
                                    g = F[f + 12 >> 2];
                                    e = e - ((c >>> 0 > d >>> 0) + h | 0) | 0;
                                    d = F[f + 8 >> 2];
                                    if ((g | 0) == (e | 0) & i >>> 0 >= d >>> 0 | e >>> 0 > g >>> 0) {
                                        break b;
                                    }
                                }
                                c = 0;
                                break a;
                            }
                            e = c + d | 0;
                            c = h + g | 0;
                            F[a + 16 >> 2] = e;
                            F[a + 20 >> 2] = d >>> 0 > e >>> 0 ? c + 1 | 0 : c;
                            c: {
                                if (H[a + 38 >> 1] <= 513) {
                                    c = F[a + 4 >> 2];
                                    F[a + 96 >> 2] = F[a >> 2];
                                    F[a + 100 >> 2] = c;
                                    c = F[a + 36 >> 2];
                                    F[a + 128 >> 2] = F[a + 32 >> 2];
                                    F[a + 132 >> 2] = c;
                                    c = F[a + 28 >> 2];
                                    F[a + 120 >> 2] = F[a + 24 >> 2];
                                    F[a + 124 >> 2] = c;
                                    c = F[a + 20 >> 2];
                                    F[a + 112 >> 2] = F[a + 16 >> 2];
                                    F[a + 116 >> 2] = c;
                                    c = F[a + 12 >> 2];
                                    F[a + 104 >> 2] = F[a + 8 >> 2];
                                    F[a + 108 >> 2] = c;
                                    d: {
                                        if (Eb(a + 96 | 0, 1, f + 8 | 0)) {
                                            c = F[a + 100 >> 2];
                                            F[a >> 2] = F[a + 96 >> 2];
                                            F[a + 4 >> 2] = c;
                                            c = F[a + 132 >> 2];
                                            F[a + 32 >> 2] = F[a + 128 >> 2];
                                            F[a + 36 >> 2] = c;
                                            c = F[a + 124 >> 2];
                                            F[a + 24 >> 2] = F[a + 120 >> 2];
                                            F[a + 28 >> 2] = c;
                                            d = F[a + 116 >> 2];
                                            h = d;
                                            c = F[a + 112 >> 2];
                                            F[a + 16 >> 2] = c;
                                            F[a + 20 >> 2] = d;
                                            e = F[a + 108 >> 2];
                                            d = F[a + 104 >> 2];
                                            F[a + 8 >> 2] = d;
                                            F[a + 12 >> 2] = e;
                                            i = d - c | 0;
                                            g = F[f + 12 >> 2];
                                            e = e - ((c >>> 0 > d >>> 0) + h | 0) | 0;
                                            d = F[f + 8 >> 2];
                                            if ((g | 0) == (e | 0) & i >>> 0 >= d >>> 0 | e >>> 0 > g >>> 0) {
                                                break d;
                                            }
                                        }
                                        c = 0;
                                        break a;
                                    }
                                    e = c + d | 0;
                                    c = h + g | 0;
                                    F[a + 16 >> 2] = e;
                                    F[a + 20 >> 2] = d >>> 0 > e >>> 0 ? c + 1 | 0 : c;
                                    break c;
                                }
                                c = 0;
                                if (!xa(a + 80 | 0, a)) {
                                    break a;
                                }
                            }
                            c = 0;
                            if (!Be(a)) {
                                break a;
                            }
                            c = F[a + 4 >> 2];
                            F[b >> 2] = F[a >> 2];
                            F[b + 4 >> 2] = c;
                            c = F[a + 36 >> 2];
                            F[b + 32 >> 2] = F[a + 32 >> 2];
                            F[b + 36 >> 2] = c;
                            c = F[a + 28 >> 2];
                            F[b + 24 >> 2] = F[a + 24 >> 2];
                            F[b + 28 >> 2] = c;
                            c = F[a + 20 >> 2];
                            F[b + 16 >> 2] = F[a + 16 >> 2];
                            F[b + 20 >> 2] = c;
                            c = F[a + 12 >> 2];
                            F[b + 8 >> 2] = F[a + 8 >> 2];
                            F[b + 12 >> 2] = c;
                            c = 1;
                        } ea = f + 16 | 0; return c; }
                        function jg(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0; f = ea - 32 | 0; ea = f; e = f + 8 | 0; c = ea - 80 | 0; ea = c; a = F[b + 36 >> 2]; F[c + 72 >> 2] = F[b + 32 >> 2]; F[c + 76 >> 2] = a; d = F[b + 28 >> 2]; a = c - -64 | 0; F[a >> 2] = F[b + 24 >> 2]; F[a + 4 >> 2] = d; a = F[b + 20 >> 2]; F[c + 56 >> 2] = F[b + 16 >> 2]; F[c + 60 >> 2] = a; a = F[b + 12 >> 2]; F[c + 48 >> 2] = F[b + 8 >> 2]; F[c + 52 >> 2] = a; a = F[b + 4 >> 2]; F[c + 40 >> 2] = F[b >> 2]; F[c + 44 >> 2] = a; oc(c + 8 | 0, c + 40 | 0, c + 24 | 0); a = F[c + 8 >> 2]; a: {
                            if (a) {
                                F[e >> 2] = a;
                                a = e + 4 | 0;
                                if (D[c + 23 | 0] >= 0) {
                                    b = c + 8 | 4;
                                    e = F[b + 4 >> 2];
                                    F[a >> 2] = F[b >> 2];
                                    F[a + 4 >> 2] = e;
                                    F[a + 8 >> 2] = F[b + 8 >> 2];
                                    break a;
                                }
                                Ba(a, F[c + 12 >> 2], F[c + 16 >> 2]);
                                if (D[c + 23 | 0] >= 0) {
                                    break a;
                                }
                                ra(F[c + 12 >> 2]);
                                break a;
                            }
                            if (D[c + 23 | 0] < 0) {
                                ra(F[c + 12 >> 2]);
                            }
                            a = G[c + 31 | 0];
                            if (a >>> 0 >= 2) {
                                a = sa(32);
                                b = G[1621] | G[1622] << 8;
                                D[a + 24 | 0] = b;
                                D[a + 25 | 0] = b >>> 8;
                                b = G[1617] | G[1618] << 8 | (G[1619] << 16 | G[1620] << 24);
                                d = G[1613] | G[1614] << 8 | (G[1615] << 16 | G[1616] << 24);
                                D[a + 16 | 0] = d;
                                D[a + 17 | 0] = d >>> 8;
                                D[a + 18 | 0] = d >>> 16;
                                D[a + 19 | 0] = d >>> 24;
                                D[a + 20 | 0] = b;
                                D[a + 21 | 0] = b >>> 8;
                                D[a + 22 | 0] = b >>> 16;
                                D[a + 23 | 0] = b >>> 24;
                                b = G[1609] | G[1610] << 8 | (G[1611] << 16 | G[1612] << 24);
                                d = G[1605] | G[1606] << 8 | (G[1607] << 16 | G[1608] << 24);
                                D[a + 8 | 0] = d;
                                D[a + 9 | 0] = d >>> 8;
                                D[a + 10 | 0] = d >>> 16;
                                D[a + 11 | 0] = d >>> 24;
                                D[a + 12 | 0] = b;
                                D[a + 13 | 0] = b >>> 8;
                                D[a + 14 | 0] = b >>> 16;
                                D[a + 15 | 0] = b >>> 24;
                                b = G[1601] | G[1602] << 8 | (G[1603] << 16 | G[1604] << 24);
                                d = G[1597] | G[1598] << 8 | (G[1599] << 16 | G[1600] << 24);
                                D[a | 0] = d;
                                D[a + 1 | 0] = d >>> 8;
                                D[a + 2 | 0] = d >>> 16;
                                D[a + 3 | 0] = d >>> 24;
                                D[a + 4 | 0] = b;
                                D[a + 5 | 0] = b >>> 8;
                                D[a + 6 | 0] = b >>> 16;
                                D[a + 7 | 0] = b >>> 24;
                                D[a + 26 | 0] = 0;
                                F[c + 8 >> 2] = -1;
                                b = c + 8 | 4;
                                Ba(b, a, 26);
                                d = D[c + 23 | 0];
                                F[e >> 2] = F[c + 8 >> 2];
                                e = e + 4 | 0;
                                b: {
                                    if ((d | 0) >= 0) {
                                        d = F[b + 4 >> 2];
                                        F[e >> 2] = F[b >> 2];
                                        F[e + 4 >> 2] = d;
                                        F[e + 8 >> 2] = F[b + 8 >> 2];
                                        break b;
                                    }
                                    Ba(e, F[c + 12 >> 2], F[c + 16 >> 2]);
                                }
                                if (D[c + 23 | 0] < 0) {
                                    ra(F[c + 12 >> 2]);
                                }
                                ra(a);
                                break a;
                            }
                            F[e >> 2] = 0;
                            F[e + 4 >> 2] = 0;
                            F[e + 16 >> 2] = a;
                            F[e + 8 >> 2] = 0;
                            F[e + 12 >> 2] = 0;
                        } ea = c + 80 | 0; a = F[f + 24 >> 2]; if (D[f + 23 | 0] < 0) {
                            ra(F[f + 12 >> 2]);
                        } ea = f + 32 | 0; return a | 0; }
                        function Jg(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0; i = c; a: {
                            d = a;
                            if (F[d + 12 >> 2] == (b | 0)) {
                                break a;
                            }
                            a = b;
                            b = F[d + 4 >> 2];
                            c = F[d >> 2];
                            if ((b | 0) != (c | 0)) {
                                while (1) {
                                    e = b - 12 | 0;
                                    if (D[b - 1 | 0] < 0) {
                                        ra(F[e >> 2]);
                                    }
                                    b = e;
                                    if ((c | 0) != (b | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            F[d + 12 >> 2] = a;
                            F[d + 4 >> 2] = c;
                            b = F[a >> 2];
                            j = a + 4 | 0;
                            if ((b | 0) == (j | 0)) {
                                break a;
                            }
                            while (1) {
                                b: {
                                    if (F[d + 8 >> 2] != (c | 0)) {
                                        c: {
                                            if (D[b + 27 | 0] >= 0) {
                                                a = F[b + 20 >> 2];
                                                F[c >> 2] = F[b + 16 >> 2];
                                                F[c + 4 >> 2] = a;
                                                F[c + 8 >> 2] = F[b + 24 >> 2];
                                                break c;
                                            }
                                            Ba(c, F[b + 16 >> 2], F[b + 20 >> 2]);
                                        }
                                        F[d + 4 >> 2] = c + 12;
                                        break b;
                                    }
                                    g = 0;
                                    d: {
                                        e: {
                                            f: {
                                                e = F[d + 4 >> 2];
                                                a = F[d >> 2];
                                                f = (e - a | 0) / 12 | 0;
                                                c = f + 1 | 0;
                                                if (c >>> 0 < 357913942) {
                                                    h = (F[d + 8 >> 2] - a | 0) / 12 | 0;
                                                    k = h << 1;
                                                    c = h >>> 0 < 178956970 ? c >>> 0 > k >>> 0 ? c : k : 357913941;
                                                    if (c) {
                                                        if (c >>> 0 >= 357913942) {
                                                            break f;
                                                        }
                                                        g = sa(L(c, 12));
                                                    }
                                                    h = L(c, 12);
                                                    c = L(f, 12) + g | 0;
                                                    g: {
                                                        if (D[b + 27 | 0] >= 0) {
                                                            f = F[b + 20 >> 2];
                                                            F[c >> 2] = F[b + 16 >> 2];
                                                            F[c + 4 >> 2] = f;
                                                            F[c + 8 >> 2] = F[b + 24 >> 2];
                                                            break g;
                                                        }
                                                        Ba(c, F[b + 16 >> 2], F[b + 20 >> 2]);
                                                        e = F[d + 4 >> 2];
                                                        a = F[d >> 2];
                                                    }
                                                    g = g + h | 0;
                                                    f = c + 12 | 0;
                                                    if ((a | 0) == (e | 0)) {
                                                        break e;
                                                    }
                                                    while (1) {
                                                        e = e - 12 | 0;
                                                        h = F[e + 4 >> 2];
                                                        c = c - 12 | 0;
                                                        F[c >> 2] = F[e >> 2];
                                                        F[c + 4 >> 2] = h;
                                                        F[c + 8 >> 2] = F[e + 8 >> 2];
                                                        F[e >> 2] = 0;
                                                        F[e + 4 >> 2] = 0;
                                                        F[e + 8 >> 2] = 0;
                                                        if ((a | 0) != (e | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    F[d + 8 >> 2] = g;
                                                    a = F[d + 4 >> 2];
                                                    F[d + 4 >> 2] = f;
                                                    e = F[d >> 2];
                                                    F[d >> 2] = c;
                                                    if ((a | 0) == (e | 0)) {
                                                        break d;
                                                    }
                                                    while (1) {
                                                        c = a - 12 | 0;
                                                        if (D[a - 1 | 0] < 0) {
                                                            ra(F[c >> 2]);
                                                        }
                                                        a = c;
                                                        if ((c | 0) != (e | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    break d;
                                                }
                                                va();
                                                V();
                                            }
                                            wa(1336);
                                            V();
                                        }
                                        F[d + 8 >> 2] = g;
                                        F[d + 4 >> 2] = f;
                                        F[d >> 2] = c;
                                    }
                                    if (e) {
                                        ra(e);
                                    }
                                }
                                c = F[b + 4 >> 2];
                                h: {
                                    if (!c) {
                                        a = F[b + 8 >> 2];
                                        if (F[a >> 2] == (b | 0)) {
                                            break h;
                                        }
                                        b = b + 8 | 0;
                                        while (1) {
                                            c = F[b >> 2];
                                            b = c + 8 | 0;
                                            a = F[c + 8 >> 2];
                                            if ((c | 0) != F[a >> 2]) {
                                                continue;
                                            }
                                            break;
                                        }
                                        break h;
                                    }
                                    while (1) {
                                        a = c;
                                        c = F[c >> 2];
                                        if (c) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                if ((a | 0) == (j | 0)) {
                                    break a;
                                }
                                c = F[d + 4 >> 2];
                                b = a;
                                continue;
                            }
                        } c = 0; i: {
                            if ((i | 0) < 0) {
                                break i;
                            }
                            a = F[d >> 2];
                            if ((F[d + 4 >> 2] - a | 0) / 12 >>> 0 <= i >>> 0) {
                                break i;
                            }
                            a = a + L(i, 12) | 0;
                            c = D[a + 11 | 0] < 0 ? F[a >> 2] : a;
                        } return c | 0; }
                        function Vd(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0; k = ea - 16 | 0; ea = k; F[k + 8 >> 2] = c; e = F[a + 12 >> 2]; d = F[a + 8 >> 2]; f = e - d >> 2; a: {
                            if ((f | 0) > (b | 0)) {
                                break a;
                            }
                            h = b + 1 | 0;
                            if (h >>> 0 > f >>> 0) {
                                f = h - f | 0;
                                g = F[a + 16 >> 2];
                                d = F[a + 12 >> 2];
                                if (f >>> 0 <= g - d >> 2 >>> 0) {
                                    if (f) {
                                        e = d;
                                        d = f << 2;
                                        d = ua(e, 0, d) + d | 0;
                                    }
                                    F[a + 12 >> 2] = d;
                                    break a;
                                }
                                b: {
                                    c: {
                                        d: {
                                            h = F[a + 8 >> 2];
                                            i = d - h >> 2;
                                            e = i + f | 0;
                                            if (e >>> 0 < 1073741824) {
                                                g = g - h | 0;
                                                l = g >> 1;
                                                g = g >>> 0 < 2147483644 ? e >>> 0 > l >>> 0 ? e : l : 1073741823;
                                                if (g) {
                                                    if (g >>> 0 >= 1073741824) {
                                                        break d;
                                                    }
                                                    j = sa(g << 2);
                                                }
                                                e = (i << 2) + j | 0;
                                                i = f << 2;
                                                f = ua(e, 0, i);
                                                i = f + i | 0;
                                                g = (g << 2) + j | 0;
                                                if ((d | 0) == (h | 0)) {
                                                    break c;
                                                }
                                                while (1) {
                                                    d = d - 4 | 0;
                                                    f = F[d >> 2];
                                                    F[d >> 2] = 0;
                                                    e = e - 4 | 0;
                                                    F[e >> 2] = f;
                                                    if ((d | 0) != (h | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                F[a + 16 >> 2] = g;
                                                f = F[a + 12 >> 2];
                                                F[a + 12 >> 2] = i;
                                                d = F[a + 8 >> 2];
                                                F[a + 8 >> 2] = e;
                                                if ((d | 0) == (f | 0)) {
                                                    break b;
                                                }
                                                while (1) {
                                                    f = f - 4 | 0;
                                                    e = F[f >> 2];
                                                    F[f >> 2] = 0;
                                                    if (e) {
                                                        Ja(e);
                                                    }
                                                    if ((d | 0) != (f | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break b;
                                            }
                                            va();
                                            V();
                                        }
                                        wa(1336);
                                        V();
                                    }
                                    F[a + 16 >> 2] = g;
                                    F[a + 12 >> 2] = i;
                                    F[a + 8 >> 2] = f;
                                }
                                if (d) {
                                    ra(d);
                                }
                                break a;
                            }
                            if (f >>> 0 <= h >>> 0) {
                                break a;
                            }
                            d = d + (h << 2) | 0;
                            if ((d | 0) != (e | 0)) {
                                while (1) {
                                    e = e - 4 | 0;
                                    c = F[e >> 2];
                                    F[e >> 2] = 0;
                                    if (c) {
                                        Ja(c);
                                    }
                                    if ((d | 0) != (e | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                c = F[k + 8 >> 2];
                            }
                            F[a + 12 >> 2] = d;
                        } e: {
                            f: {
                                d = F[c + 56 >> 2];
                                g: {
                                    if ((d | 0) > 4) {
                                        break g;
                                    }
                                    e = L(d, 12) + a | 0;
                                    d = F[e + 24 >> 2];
                                    if ((d | 0) != F[e + 28 >> 2]) {
                                        F[d >> 2] = b;
                                        F[e + 24 >> 2] = d + 4;
                                        break g;
                                    }
                                    h = F[e + 20 >> 2];
                                    f = d - h | 0;
                                    j = f >> 2;
                                    d = j + 1 | 0;
                                    if (d >>> 0 >= 1073741824) {
                                        break f;
                                    }
                                    g = f >> 1;
                                    g = f >>> 0 < 2147483644 ? d >>> 0 > g >>> 0 ? d : g : 1073741823;
                                    if (g) {
                                        if (g >>> 0 >= 1073741824) {
                                            break e;
                                        }
                                        d = sa(g << 2);
                                    }
                                    else {
                                        d = 0;
                                    }
                                    j = d + (j << 2) | 0;
                                    F[j >> 2] = b;
                                    if ((f | 0) > 0) {
                                        ta(d, h, f);
                                    }
                                    F[e + 20 >> 2] = d;
                                    F[e + 24 >> 2] = j + 4;
                                    F[e + 28 >> 2] = d + (g << 2);
                                    if (!h) {
                                        break g;
                                    }
                                    ra(h);
                                }
                                F[c + 60 >> 2] = b;
                                a = F[a + 8 >> 2];
                                F[k + 8 >> 2] = 0;
                                b = a + (b << 2) | 0;
                                a = F[b >> 2];
                                F[b >> 2] = c;
                                if (a) {
                                    Ja(a);
                                }
                                a = F[k + 8 >> 2];
                                F[k + 8 >> 2] = 0;
                                if (a) {
                                    Ja(a);
                                }
                                ea = k + 16 | 0;
                                return;
                            }
                            va();
                            V();
                        } wa(1336); V(); }
                        function cd(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0; i = ea - 16 | 0; ea = i; F[i >> 2] = b; g = -1; a: {
                            if ((b | 0) == -1) {
                                F[i + 4 >> 2] = -1;
                                break a;
                            }
                            c = b + 1 | 0;
                            F[i + 4 >> 2] = (c >>> 0) % 3 | 0 ? c : b - 2 | 0;
                            if ((b >>> 0) % 3 | 0) {
                                g = b - 1 | 0;
                                break a;
                            }
                            g = b + 2 | 0;
                        } F[i + 8 >> 2] = g; m = (b | 0) == -1 ? -1 : (b >>> 0) / 3 | 0; b: {
                            c: {
                                d: {
                                    e: {
                                        while (1) {
                                            f: {
                                                g: {
                                                    if ((b | 0) != -1) {
                                                        c = F[F[F[a + 8 >> 2] + 12 >> 2] + (b << 2) >> 2];
                                                        if ((c | 0) != -1) {
                                                            break g;
                                                        }
                                                    }
                                                    g = 0;
                                                    c = F[a + 216 >> 2];
                                                    if ((c | 0) == F[a + 220 >> 2]) {
                                                        break f;
                                                    }
                                                    while (1) {
                                                        f = L(g, 144) + c | 0;
                                                        c = F[f + 136 >> 2];
                                                        d = F[f + 140 >> 2];
                                                        h: {
                                                            if (c >>> 0 < d >>> 0) {
                                                                F[c >> 2] = b;
                                                                F[f + 136 >> 2] = c + 4;
                                                                break h;
                                                            }
                                                            h = F[f + 132 >> 2];
                                                            j = c - h | 0;
                                                            e = j >> 2;
                                                            c = e + 1 | 0;
                                                            if (c >>> 0 >= 1073741824) {
                                                                break e;
                                                            }
                                                            k = e << 2;
                                                            d = d - h | 0;
                                                            e = d >> 1;
                                                            d = d >>> 0 < 2147483644 ? c >>> 0 > e >>> 0 ? c : e : 1073741823;
                                                            if (d) {
                                                                if (d >>> 0 >= 1073741824) {
                                                                    break d;
                                                                }
                                                                c = sa(d << 2);
                                                            }
                                                            else {
                                                                c = 0;
                                                            }
                                                            e = k + c | 0;
                                                            F[e >> 2] = b;
                                                            if ((j | 0) > 0) {
                                                                ta(c, h, j);
                                                            }
                                                            F[f + 132 >> 2] = c;
                                                            F[f + 136 >> 2] = e + 4;
                                                            F[f + 140 >> 2] = c + (d << 2);
                                                            if (!h) {
                                                                break h;
                                                            }
                                                            ra(h);
                                                        }
                                                        g = g + 1 | 0;
                                                        c = F[a + 216 >> 2];
                                                        if (g >>> 0 < (F[a + 220 >> 2] - c | 0) / 144 >>> 0) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    break f;
                                                }
                                                if ((c >>> 0) / 3 >>> 0 < m >>> 0) {
                                                    break f;
                                                }
                                                g = 0;
                                                if (F[a + 220 >> 2] == F[a + 216 >> 2]) {
                                                    break f;
                                                }
                                                while (1) {
                                                    i: {
                                                        if (!Ga(F[a + 368 >> 2] + (g << 4) | 0)) {
                                                            break i;
                                                        }
                                                        f = F[a + 216 >> 2] + L(g, 144) | 0;
                                                        c = F[f + 136 >> 2];
                                                        d = F[f + 140 >> 2];
                                                        if (c >>> 0 < d >>> 0) {
                                                            F[c >> 2] = b;
                                                            F[f + 136 >> 2] = c + 4;
                                                            break i;
                                                        }
                                                        h = F[f + 132 >> 2];
                                                        j = c - h | 0;
                                                        e = j >> 2;
                                                        c = e + 1 | 0;
                                                        if (c >>> 0 >= 1073741824) {
                                                            break c;
                                                        }
                                                        k = e << 2;
                                                        d = d - h | 0;
                                                        e = d >> 1;
                                                        d = d >>> 0 < 2147483644 ? c >>> 0 > e >>> 0 ? c : e : 1073741823;
                                                        if (d) {
                                                            if (d >>> 0 >= 1073741824) {
                                                                break b;
                                                            }
                                                            c = sa(d << 2);
                                                        }
                                                        else {
                                                            c = 0;
                                                        }
                                                        e = k + c | 0;
                                                        F[e >> 2] = b;
                                                        if ((j | 0) > 0) {
                                                            ta(c, h, j);
                                                        }
                                                        F[f + 132 >> 2] = c;
                                                        F[f + 136 >> 2] = e + 4;
                                                        F[f + 140 >> 2] = c + (d << 2);
                                                        if (!h) {
                                                            break i;
                                                        }
                                                        ra(h);
                                                    }
                                                    g = g + 1 | 0;
                                                    if (g >>> 0 < (F[a + 220 >> 2] - F[a + 216 >> 2] | 0) / 144 >>> 0) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            l = l + 1 | 0;
                                            if ((l | 0) != 3) {
                                                b = F[(l << 2) + i >> 2];
                                                continue;
                                            }
                                            break;
                                        }
                                        ea = i + 16 | 0;
                                        return 1;
                                    }
                                    va();
                                    V();
                                }
                                wa(1336);
                                V();
                            }
                            va();
                            V();
                        } wa(1336); V(); }
                        function dd(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0; i = ea - 16 | 0; ea = i; F[i >> 2] = b; g = -1; a: {
                            if ((b | 0) == -1) {
                                F[i + 4 >> 2] = -1;
                                break a;
                            }
                            c = b + 1 | 0;
                            F[i + 4 >> 2] = (c >>> 0) % 3 | 0 ? c : b - 2 | 0;
                            if ((b >>> 0) % 3 | 0) {
                                g = b - 1 | 0;
                                break a;
                            }
                            g = b + 2 | 0;
                        } F[i + 8 >> 2] = g; b: {
                            c: {
                                while (1) {
                                    d: {
                                        if (!((b | 0) == -1 | F[F[F[a + 8 >> 2] + 12 >> 2] + (b << 2) >> 2] == -1)) {
                                            g = 0;
                                            if (F[a + 220 >> 2] == F[a + 216 >> 2]) {
                                                break d;
                                            }
                                            e: {
                                                while (1) {
                                                    f: {
                                                        g: {
                                                            if (!Ga(F[a + 368 >> 2] + (g << 4) | 0)) {
                                                                break g;
                                                            }
                                                            f = F[a + 216 >> 2] + L(g, 144) | 0;
                                                            c = F[f + 136 >> 2];
                                                            d = F[f + 140 >> 2];
                                                            if (c >>> 0 < d >>> 0) {
                                                                F[c >> 2] = b;
                                                                F[f + 136 >> 2] = c + 4;
                                                                break g;
                                                            }
                                                            h = F[f + 132 >> 2];
                                                            j = c - h | 0;
                                                            e = j >> 2;
                                                            c = e + 1 | 0;
                                                            if (c >>> 0 >= 1073741824) {
                                                                break f;
                                                            }
                                                            k = e << 2;
                                                            d = d - h | 0;
                                                            e = d >> 1;
                                                            d = d >>> 0 < 2147483644 ? c >>> 0 > e >>> 0 ? c : e : 1073741823;
                                                            if (d) {
                                                                if (d >>> 0 >= 1073741824) {
                                                                    break e;
                                                                }
                                                                c = sa(d << 2);
                                                            }
                                                            else {
                                                                c = 0;
                                                            }
                                                            e = k + c | 0;
                                                            F[e >> 2] = b;
                                                            if ((j | 0) > 0) {
                                                                ta(c, h, j);
                                                            }
                                                            F[f + 132 >> 2] = c;
                                                            F[f + 136 >> 2] = e + 4;
                                                            F[f + 140 >> 2] = c + (d << 2);
                                                            if (!h) {
                                                                break g;
                                                            }
                                                            ra(h);
                                                        }
                                                        g = g + 1 | 0;
                                                        if (g >>> 0 < (F[a + 220 >> 2] - F[a + 216 >> 2] | 0) / 144 >>> 0) {
                                                            continue;
                                                        }
                                                        break d;
                                                    }
                                                    break;
                                                }
                                                va();
                                                V();
                                            }
                                            wa(1336);
                                            V();
                                        }
                                        g = 0;
                                        c = F[a + 216 >> 2];
                                        if ((c | 0) == F[a + 220 >> 2]) {
                                            break d;
                                        }
                                        while (1) {
                                            f = L(g, 144) + c | 0;
                                            c = F[f + 136 >> 2];
                                            d = F[f + 140 >> 2];
                                            h: {
                                                if (c >>> 0 < d >>> 0) {
                                                    F[c >> 2] = b;
                                                    F[f + 136 >> 2] = c + 4;
                                                    break h;
                                                }
                                                h = F[f + 132 >> 2];
                                                j = c - h | 0;
                                                e = j >> 2;
                                                c = e + 1 | 0;
                                                if (c >>> 0 >= 1073741824) {
                                                    break c;
                                                }
                                                k = e << 2;
                                                d = d - h | 0;
                                                e = d >> 1;
                                                d = d >>> 0 < 2147483644 ? c >>> 0 > e >>> 0 ? c : e : 1073741823;
                                                if (d) {
                                                    if (d >>> 0 >= 1073741824) {
                                                        break b;
                                                    }
                                                    c = sa(d << 2);
                                                }
                                                else {
                                                    c = 0;
                                                }
                                                e = k + c | 0;
                                                F[e >> 2] = b;
                                                if ((j | 0) > 0) {
                                                    ta(c, h, j);
                                                }
                                                F[f + 132 >> 2] = c;
                                                F[f + 136 >> 2] = e + 4;
                                                F[f + 140 >> 2] = c + (d << 2);
                                                if (!h) {
                                                    break h;
                                                }
                                                ra(h);
                                            }
                                            g = g + 1 | 0;
                                            c = F[a + 216 >> 2];
                                            if (g >>> 0 < (F[a + 220 >> 2] - c | 0) / 144 >>> 0) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    l = l + 1 | 0;
                                    if ((l | 0) != 3) {
                                        b = F[(l << 2) + i >> 2];
                                        continue;
                                    }
                                    break;
                                }
                                ea = i + 16 | 0;
                                return 1;
                            }
                            va();
                            V();
                        } wa(1336); V(); }
                        function _c(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0; e = F[a + 8 >> 2]; g = F[a + 4 >> 2]; if ((e - g | 0) / 12 >>> 0 >= b >>> 0) {
                            a: {
                                if (!b) {
                                    break a;
                                }
                                d = g;
                                e = L(b, 12) - 12 | 0;
                                f = ((e >>> 0) / 12 | 0) + 1 & 3;
                                if (f) {
                                    while (1) {
                                        j = F[c + 4 >> 2];
                                        F[d >> 2] = F[c >> 2];
                                        F[d + 4 >> 2] = j;
                                        F[d + 8 >> 2] = F[c + 8 >> 2];
                                        d = d + 12 | 0;
                                        h = h + 1 | 0;
                                        if ((f | 0) != (h | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                g = L(b, 12) + g | 0;
                                if (e >>> 0 < 36) {
                                    break a;
                                }
                                while (1) {
                                    b = F[c + 4 >> 2];
                                    F[d >> 2] = F[c >> 2];
                                    F[d + 4 >> 2] = b;
                                    F[d + 8 >> 2] = F[c + 8 >> 2];
                                    F[d + 20 >> 2] = F[c + 8 >> 2];
                                    b = F[c + 4 >> 2];
                                    F[d + 12 >> 2] = F[c >> 2];
                                    F[d + 16 >> 2] = b;
                                    F[d + 32 >> 2] = F[c + 8 >> 2];
                                    b = F[c + 4 >> 2];
                                    F[d + 24 >> 2] = F[c >> 2];
                                    F[d + 28 >> 2] = b;
                                    b = F[c + 4 >> 2];
                                    F[d + 36 >> 2] = F[c >> 2];
                                    F[d + 40 >> 2] = b;
                                    F[d + 44 >> 2] = F[c + 8 >> 2];
                                    d = d + 48 | 0;
                                    if ((g | 0) != (d | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            F[a + 4 >> 2] = g;
                            return;
                        } b: {
                            f = F[a >> 2];
                            i = (g - f | 0) / 12 | 0;
                            d = i + b | 0;
                            if (d >>> 0 < 357913942) {
                                e = (e - f | 0) / 12 | 0;
                                f = e << 1;
                                f = e >>> 0 < 178956970 ? d >>> 0 > f >>> 0 ? d : f : 357913941;
                                if (f) {
                                    if (f >>> 0 >= 357913942) {
                                        break b;
                                    }
                                    j = sa(L(f, 12));
                                }
                                e = L(i, 12) + j | 0;
                                d = e;
                                b = L(b, 12);
                                i = b - 12 | 0;
                                k = ((i >>> 0) / 12 | 0) + 1 & 3;
                                if (k) {
                                    d = e;
                                    while (1) {
                                        l = F[c + 4 >> 2];
                                        F[d >> 2] = F[c >> 2];
                                        F[d + 4 >> 2] = l;
                                        F[d + 8 >> 2] = F[c + 8 >> 2];
                                        d = d + 12 | 0;
                                        h = h + 1 | 0;
                                        if ((k | 0) != (h | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                h = b + e | 0;
                                if (i >>> 0 >= 36) {
                                    while (1) {
                                        b = F[c + 4 >> 2];
                                        F[d >> 2] = F[c >> 2];
                                        F[d + 4 >> 2] = b;
                                        F[d + 8 >> 2] = F[c + 8 >> 2];
                                        F[d + 20 >> 2] = F[c + 8 >> 2];
                                        b = F[c + 4 >> 2];
                                        F[d + 12 >> 2] = F[c >> 2];
                                        F[d + 16 >> 2] = b;
                                        F[d + 32 >> 2] = F[c + 8 >> 2];
                                        b = F[c + 4 >> 2];
                                        F[d + 24 >> 2] = F[c >> 2];
                                        F[d + 28 >> 2] = b;
                                        b = F[c + 4 >> 2];
                                        F[d + 36 >> 2] = F[c >> 2];
                                        F[d + 40 >> 2] = b;
                                        F[d + 44 >> 2] = F[c + 8 >> 2];
                                        d = d + 48 | 0;
                                        if ((h | 0) != (d | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                b = F[a >> 2];
                                c = g - b | 0;
                                d = e + L((c | 0) / -12 | 0, 12) | 0;
                                if ((c | 0) > 0) {
                                    ta(d, b, c);
                                }
                                F[a + 8 >> 2] = L(f, 12) + j;
                                F[a + 4 >> 2] = h;
                                F[a >> 2] = d;
                                if (b) {
                                    ra(b);
                                }
                                return;
                            }
                            va();
                            V();
                        } wa(1336); V(); }
                        function sg(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0; a = 0; h = ea - 16 | 0; ea = h; j = F[b + 80 >> 2]; e = D[c + 24 | 0]; F[h + 8 >> 2] = 0; F[h >> 2] = 0; F[h + 4 >> 2] = 0; a: {
                            b: {
                                if (e) {
                                    if ((e | 0) < 0) {
                                        break b;
                                    }
                                    b = e << 2;
                                    a = sa(b);
                                    F[h >> 2] = a;
                                    g = a + b | 0;
                                    F[h + 8 >> 2] = g;
                                    k = e - 1 & 1073741823;
                                    l = e & 7;
                                    c: {
                                        if (!l) {
                                            b = a;
                                            break c;
                                        }
                                        b = a;
                                        while (1) {
                                            F[b >> 2] = -1073741824;
                                            b = b + 4 | 0;
                                            f = f + 1 | 0;
                                            if ((l | 0) != (f | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    if (k >>> 0 >= 7) {
                                        while (1) {
                                            F[b + 24 >> 2] = -1073741824;
                                            F[b + 28 >> 2] = -1073741824;
                                            F[b + 16 >> 2] = -1073741824;
                                            F[b + 20 >> 2] = -1073741824;
                                            F[b + 8 >> 2] = -1073741824;
                                            F[b + 12 >> 2] = -1073741824;
                                            F[b >> 2] = -1073741824;
                                            F[b + 4 >> 2] = -1073741824;
                                            b = b + 32 | 0;
                                            if ((g | 0) != (b | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    F[h + 4 >> 2] = g;
                                }
                                b = L(e, j);
                                g = F[d >> 2];
                                f = F[d + 4 >> 2] - g >> 2;
                                d: {
                                    if (b >>> 0 > f >>> 0) {
                                        Aa(d, b - f | 0);
                                        break d;
                                    }
                                    if (b >>> 0 >= f >>> 0) {
                                        break d;
                                    }
                                    F[d + 4 >> 2] = g + (b << 2);
                                }
                                e: {
                                    if (!j) {
                                        break e;
                                    }
                                    i = 1;
                                    if ((e | 0) <= 0) {
                                        b = 0;
                                        while (1) {
                                            if (!Ya(c, G[c + 84 | 0] ? b : F[F[c + 68 >> 2] + (b << 2) >> 2], D[c + 24 | 0], a)) {
                                                break e;
                                            }
                                            b = b + 1 | 0;
                                            i = j >>> 0 > b >>> 0;
                                            if ((b | 0) != (j | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                        break e;
                                    }
                                    p = e & -4;
                                    l = e & 3;
                                    f = 0;
                                    q = e - 1 >>> 0 < 3;
                                    while (1) {
                                        if (Ya(c, G[c + 84 | 0] ? m : F[F[c + 68 >> 2] + (m << 2) >> 2], D[c + 24 | 0], a)) {
                                            o = F[d >> 2];
                                            n = 0;
                                            e = F[h >> 2];
                                            b = 0;
                                            i = 0;
                                            if (!q) {
                                                while (1) {
                                                    g = o + (f << 2) | 0;
                                                    k = b << 2;
                                                    J[g >> 2] = J[k + e >> 2];
                                                    J[g + 4 >> 2] = J[(k | 4) + e >> 2];
                                                    J[g + 8 >> 2] = J[(k | 8) + e >> 2];
                                                    J[g + 12 >> 2] = J[(k | 12) + e >> 2];
                                                    b = b + 4 | 0;
                                                    f = f + 4 | 0;
                                                    i = i + 4 | 0;
                                                    if ((p | 0) != (i | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            if (l) {
                                                while (1) {
                                                    J[o + (f << 2) >> 2] = J[(b << 2) + e >> 2];
                                                    b = b + 1 | 0;
                                                    f = f + 1 | 0;
                                                    n = n + 1 | 0;
                                                    if ((l | 0) != (n | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            m = m + 1 | 0;
                                            i = m >>> 0 < j >>> 0;
                                            if ((j | 0) != (m | 0)) {
                                                continue;
                                            }
                                        }
                                        break;
                                    }
                                    a = F[h >> 2];
                                }
                                if (a) {
                                    ra(a);
                                }
                                ea = h + 16 | 0;
                                a = (i ^ -1) & 1;
                                break a;
                            }
                            va();
                            V();
                        } return a | 0; }
                        function rc(a, b, c, d) { var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0; k = F[b + 16 >> 2]; g = F[c + 4 >> 2] - k | 0; e = g; f = F[c >> 2] - k | 0; F[c >> 2] = f; F[c + 4 >> 2] = e; j = F[b + 16 >> 2]; e = e >> 31; h = e + g ^ e; e = f >> 31; l = (j | 0) >= (h + (e + f ^ e) | 0); a: {
                            if (l) {
                                e = g;
                                break a;
                            }
                            b: {
                                c: {
                                    if ((f | 0) >= 0) {
                                        i = 1;
                                        h = 1;
                                        if ((g | 0) >= 0) {
                                            break b;
                                        }
                                        e = 1;
                                        i = -1;
                                        h = -1;
                                        if (f) {
                                            break c;
                                        }
                                        break b;
                                    }
                                    e = -1;
                                    i = -1;
                                    h = -1;
                                    if ((g | 0) <= 0) {
                                        break b;
                                    }
                                }
                                i = (g | 0) <= 0 ? -1 : 1;
                                h = e;
                            }
                            e = f << 1;
                            f = L(h, j);
                            e = e - f | 0;
                            h = (L(i, h) | 0) >= 0;
                            i = L(i, j);
                            e = ((h ? 0 - e | 0 : e) + i | 0) / 2 | 0;
                            F[c + 4 >> 2] = e;
                            j = f;
                            f = (g << 1) - i | 0;
                            f = (j + (h ? 0 - f | 0 : f) | 0) / 2 | 0;
                            F[c >> 2] = f;
                        } d: {
                            e: {
                                f: {
                                    g: {
                                        h: {
                                            i: {
                                                j: {
                                                    if (f) {
                                                        if ((f | 0) < 0) {
                                                            break j;
                                                        }
                                                        if ((e | 0) >= 0) {
                                                            break i;
                                                        }
                                                        break f;
                                                    }
                                                    if (e) {
                                                        break h;
                                                    }
                                                    i = 1;
                                                    g = 0;
                                                    e = 0;
                                                    h = 0;
                                                    break d;
                                                }
                                                i = 1;
                                                if ((e | 0) > 0) {
                                                    break g;
                                                }
                                                h = (e | 0) > 0 ? 253 : 0;
                                                g = e;
                                                e = f;
                                                break d;
                                            }
                                            g = 0 - e | 0;
                                            e = 0 - f | 0;
                                            h = 254;
                                            break e;
                                        }
                                        if ((e | 0) <= 0) {
                                            break f;
                                        }
                                    }
                                    e = 0 - e | 0;
                                    g = f;
                                    h = 253;
                                    break e;
                                }
                                g = 0 - f | 0;
                                h = 255;
                            }
                            F[c >> 2] = e;
                            F[c + 4 >> 2] = g;
                            i = 0;
                        } c = F[d + 4 >> 2] + g | 0; f = F[d >> 2] + e | 0; g = F[b + 16 >> 2]; k: {
                            if ((f | 0) > (g | 0)) {
                                f = f - F[b + 4 >> 2] | 0;
                                break k;
                            }
                            if ((0 - g | 0) <= (f | 0)) {
                                break k;
                            }
                            f = F[b + 4 >> 2] + f | 0;
                        } l: {
                            if ((c | 0) > (g | 0)) {
                                c = c - F[b + 4 >> 2] | 0;
                                break l;
                            }
                            if ((0 - g | 0) <= (c | 0)) {
                                break l;
                            }
                            c = F[b + 4 >> 2] + c | 0;
                        } m: {
                            if (i) {
                                b = c;
                                break m;
                            }
                            b = c;
                            n: {
                                switch ((h & 3) - 1 | 0) {
                                    case 0:
                                        b = 0 - f | 0;
                                        f = c;
                                        break m;
                                    case 1:
                                        b = 0 - c | 0;
                                        f = 0 - f | 0;
                                        break m;
                                    case 2: break n;
                                    default: break m;
                                }
                            }
                            b = f;
                            f = 0 - c | 0;
                        } o: {
                            if (l) {
                                c = b;
                                break o;
                            }
                            p: {
                                q: {
                                    if ((f | 0) >= 0) {
                                        c = 1;
                                        e = 1;
                                        if ((b | 0) >= 0) {
                                            break p;
                                        }
                                        d = 1;
                                        c = -1;
                                        e = -1;
                                        if (f) {
                                            break q;
                                        }
                                        break p;
                                    }
                                    d = -1;
                                    c = -1;
                                    e = -1;
                                    if ((b | 0) <= 0) {
                                        break p;
                                    }
                                }
                                c = (b | 0) <= 0 ? -1 : 1;
                                e = d;
                            }
                            d = f << 1;
                            f = L(e, g);
                            d = d - f | 0;
                            F[a >> 2] = d;
                            j = 0 - d | 0;
                            h = d;
                            d = (L(c, e) | 0) >= 0;
                            e = L(c, g);
                            c = ((d ? j : h) + e | 0) / 2 | 0;
                            b = (b << 1) - e | 0;
                            f = (f + (d ? 0 - b | 0 : b) | 0) / 2 | 0;
                        } F[a >> 2] = f + k; F[a + 4 >> 2] = c + k; }
                        function me(a, b) { var c = 0, d = 0, e = 0, f = 0; if (!F[a + 64 >> 2]) {
                            c = sa(32);
                            F[c + 16 >> 2] = 0;
                            F[c + 20 >> 2] = 0;
                            F[c + 8 >> 2] = 0;
                            F[c >> 2] = 0;
                            F[c + 4 >> 2] = 0;
                            F[c + 24 >> 2] = 0;
                            F[c + 28 >> 2] = 0;
                            d = F[a + 64 >> 2];
                            F[a + 64 >> 2] = c;
                            if (d) {
                                c = F[d >> 2];
                                if (c) {
                                    F[d + 4 >> 2] = c;
                                    ra(c);
                                }
                                ra(d);
                                c = F[a + 64 >> 2];
                            }
                            F[a >> 2] = c;
                            d = F[c + 20 >> 2];
                            F[a + 8 >> 2] = F[c + 16 >> 2];
                            F[a + 12 >> 2] = d;
                            d = F[c + 24 >> 2];
                            c = F[c + 28 >> 2];
                            F[a + 48 >> 2] = 0;
                            F[a + 52 >> 2] = 0;
                            F[a + 40 >> 2] = 0;
                            F[a + 44 >> 2] = 0;
                            F[a + 16 >> 2] = d;
                            F[a + 20 >> 2] = c;
                        } a: {
                            D[a + 24 | 0] = G[b + 24 | 0];
                            F[a + 28 >> 2] = F[b + 28 >> 2];
                            D[a + 32 | 0] = G[b + 32 | 0];
                            c = F[b + 44 >> 2];
                            F[a + 40 >> 2] = F[b + 40 >> 2];
                            F[a + 44 >> 2] = c;
                            c = F[b + 52 >> 2];
                            F[a + 48 >> 2] = F[b + 48 >> 2];
                            F[a + 52 >> 2] = c;
                            F[a + 56 >> 2] = F[b + 56 >> 2];
                            c = F[b + 12 >> 2];
                            F[a + 8 >> 2] = F[b + 8 >> 2];
                            F[a + 12 >> 2] = c;
                            c = F[b + 20 >> 2];
                            F[a + 16 >> 2] = F[b + 16 >> 2];
                            F[a + 20 >> 2] = c;
                            F[a + 60 >> 2] = F[b + 60 >> 2];
                            d = F[b >> 2];
                            b: {
                                if (!d) {
                                    F[a >> 2] = 0;
                                    c = 1;
                                    break b;
                                }
                                e = F[a >> 2];
                                c = 0;
                                if (!e) {
                                    break b;
                                }
                                c = F[d >> 2];
                                qe(e, c, F[d + 4 >> 2] - c | 0, 0);
                                c = 1;
                            }
                            c: {
                                if (!c) {
                                    break c;
                                }
                                D[a + 84 | 0] = G[b + 84 | 0];
                                F[a + 80 >> 2] = F[b + 80 >> 2];
                                if ((a | 0) != (b | 0)) {
                                    Db(a + 68 | 0, F[b + 68 >> 2], F[b + 72 >> 2]);
                                }
                                d = F[b + 88 >> 2];
                                d: {
                                    if (d) {
                                        b = sa(40);
                                        c = F[d >> 2];
                                        F[b + 16 >> 2] = 0;
                                        F[b + 8 >> 2] = 0;
                                        F[b + 12 >> 2] = 0;
                                        F[b >> 2] = c;
                                        e = F[d + 12 >> 2] - F[d + 8 >> 2] | 0;
                                        if (e) {
                                            if ((e | 0) < 0) {
                                                break a;
                                            }
                                            c = sa(e);
                                            F[b + 8 >> 2] = c;
                                            F[b + 12 >> 2] = c;
                                            F[b + 16 >> 2] = c + e;
                                            f = F[d + 8 >> 2];
                                            e = F[d + 12 >> 2] - f | 0;
                                            if ((e | 0) > 0) {
                                                c = ta(c, f, e) + e | 0;
                                            }
                                            F[b + 12 >> 2] = c;
                                        }
                                        c = F[d + 36 >> 2];
                                        F[b + 32 >> 2] = F[d + 32 >> 2];
                                        F[b + 36 >> 2] = c;
                                        c = F[d + 28 >> 2];
                                        F[b + 24 >> 2] = F[d + 24 >> 2];
                                        F[b + 28 >> 2] = c;
                                        c = F[a + 88 >> 2];
                                        F[a + 88 >> 2] = b;
                                        if (c) {
                                            break d;
                                        }
                                        break c;
                                    }
                                    c = F[a + 88 >> 2];
                                    F[a + 88 >> 2] = 0;
                                    if (!c) {
                                        break c;
                                    }
                                }
                                a = F[c + 8 >> 2];
                                if (a) {
                                    F[c + 12 >> 2] = a;
                                    ra(a);
                                }
                                ra(c);
                            }
                            return;
                        } va(); V(); }
                        function Yb(a, b, c, d) { var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0; h = d - c | 0; if ((h | 0) <= 0) {
                            return;
                        } a: {
                            f = F[a + 8 >> 2];
                            i = F[a + 4 >> 2];
                            if ((h | 0) <= (f - i | 0)) {
                                j = i - b | 0;
                                if ((j | 0) >= (h | 0)) {
                                    g = i;
                                    f = d;
                                    break a;
                                }
                                g = i;
                                f = c + j | 0;
                                if ((f | 0) != (d | 0)) {
                                    e = f;
                                    while (1) {
                                        D[g | 0] = G[e | 0];
                                        g = g + 1 | 0;
                                        e = e + 1 | 0;
                                        if ((e | 0) != (d | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                F[a + 4 >> 2] = g;
                                if ((j | 0) > 0) {
                                    break a;
                                }
                                return;
                            }
                            e = F[a >> 2];
                            d = h + (i - e | 0) | 0;
                            if ((d | 0) >= 0) {
                                g = b - e | 0;
                                f = f - e | 0;
                                j = f << 1;
                                f = f >>> 0 < 1073741823 ? d >>> 0 > j >>> 0 ? d : j : 2147483647;
                                if (f) {
                                    d = sa(f);
                                }
                                else {
                                    d = 0;
                                }
                                c = ta(g + d | 0, c, h);
                                if ((g | 0) > 0) {
                                    ta(d, e, g);
                                }
                                c = c + h | 0;
                                if ((b | 0) != (i | 0)) {
                                    g = (b ^ -1) + i | 0;
                                    h = i - b & 7;
                                    if (h) {
                                        e = 0;
                                        while (1) {
                                            D[c | 0] = G[b | 0];
                                            c = c + 1 | 0;
                                            b = b + 1 | 0;
                                            e = e + 1 | 0;
                                            if ((h | 0) != (e | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    if (g >>> 0 >= 7) {
                                        while (1) {
                                            D[c | 0] = G[b | 0];
                                            D[c + 1 | 0] = G[b + 1 | 0];
                                            D[c + 2 | 0] = G[b + 2 | 0];
                                            D[c + 3 | 0] = G[b + 3 | 0];
                                            D[c + 4 | 0] = G[b + 4 | 0];
                                            D[c + 5 | 0] = G[b + 5 | 0];
                                            D[c + 6 | 0] = G[b + 6 | 0];
                                            D[c + 7 | 0] = G[b + 7 | 0];
                                            c = c + 8 | 0;
                                            b = b + 8 | 0;
                                            if ((i | 0) != (b | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    e = F[a >> 2];
                                }
                                F[a + 8 >> 2] = d + f;
                                F[a + 4 >> 2] = c;
                                F[a >> 2] = d;
                                if (e) {
                                    ra(e);
                                }
                                return;
                            }
                            va();
                            V();
                        } e = g; d = e - h | 0; if (i >>> 0 > d >>> 0) {
                            while (1) {
                                D[e | 0] = G[d | 0];
                                e = e + 1 | 0;
                                d = d + 1 | 0;
                                if (i >>> 0 > d >>> 0) {
                                    continue;
                                }
                                break;
                            }
                        } F[a + 4 >> 2] = e; a = g - (b + h | 0) | 0; if (a) {
                            Wa(g - a | 0, b, a);
                        } if ((c | 0) == (f | 0)) {
                            return;
                        } a = (c ^ -1) + f | 0; g = f - c & 7; b: {
                            if (!g) {
                                e = b;
                                break b;
                            }
                            d = 0;
                            e = b;
                            while (1) {
                                D[e | 0] = G[c | 0];
                                e = e + 1 | 0;
                                c = c + 1 | 0;
                                d = d + 1 | 0;
                                if ((g | 0) != (d | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } if (a >>> 0 < 7) {
                            return;
                        } while (1) {
                            D[e | 0] = G[c | 0];
                            D[e + 1 | 0] = G[c + 1 | 0];
                            D[e + 2 | 0] = G[c + 2 | 0];
                            D[e + 3 | 0] = G[c + 3 | 0];
                            D[e + 4 | 0] = G[c + 4 | 0];
                            D[e + 5 | 0] = G[c + 5 | 0];
                            D[e + 6 | 0] = G[c + 6 | 0];
                            D[e + 7 | 0] = G[c + 7 | 0];
                            e = e + 8 | 0;
                            c = c + 8 | 0;
                            if ((f | 0) != (c | 0)) {
                                continue;
                            }
                            break;
                        } }
                        function mg(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0; e = ea - 16 | 0; ea = e; i = F[b + 80 >> 2]; a = D[c + 24 | 0]; f = L(i, a); a: {
                            b: {
                                b = F[c + 28 >> 2];
                                c: {
                                    if (!(!G[c + 84 | 0] | (b | 0) != 5 & (b | 0) != 6)) {
                                        h = F[c + 48 >> 2];
                                        i = F[F[c >> 2] >> 2];
                                        b = 0;
                                        F[e + 8 >> 2] = 0;
                                        F[e >> 2] = 0;
                                        F[e + 4 >> 2] = 0;
                                        c = 0;
                                        a = f << 2;
                                        if (a) {
                                            if ((a | 0) < 0) {
                                                break b;
                                            }
                                            c = sa(a);
                                            b = ta(c, h + i | 0, a);
                                            j = b + a | 0;
                                            b = b + (a >> 2 << 2) | 0;
                                        }
                                        a = F[d >> 2];
                                        if (a) {
                                            F[d + 4 >> 2] = a;
                                            ra(a);
                                        }
                                        F[d + 8 >> 2] = b;
                                        F[d + 4 >> 2] = j;
                                        F[d >> 2] = c;
                                        a = 1;
                                        break c;
                                    }
                                    F[e + 8 >> 2] = 0;
                                    F[e >> 2] = 0;
                                    F[e + 4 >> 2] = 0;
                                    if (a) {
                                        if ((a | 0) < 0) {
                                            break b;
                                        }
                                        b = a << 2;
                                        h = sa(b);
                                        F[e >> 2] = h;
                                        g = b + h | 0;
                                        F[e + 8 >> 2] = g;
                                        ua(h, 0, b);
                                        F[e + 4 >> 2] = g;
                                    }
                                    g = F[d >> 2];
                                    b = F[d + 4 >> 2] - g >> 2;
                                    d: {
                                        if (b >>> 0 < f >>> 0) {
                                            Aa(d, f - b | 0);
                                            break d;
                                        }
                                        if (b >>> 0 <= f >>> 0) {
                                            break d;
                                        }
                                        F[d + 4 >> 2] = g + (f << 2);
                                    }
                                    e: {
                                        if (!i) {
                                            b = 0;
                                            break e;
                                        }
                                        if (!a) {
                                            a = 0;
                                            b = 1;
                                            while (1) {
                                                if (!ec(c, G[c + 84 | 0] ? a : F[F[c + 68 >> 2] + (a << 2) >> 2], D[c + 24 | 0], h)) {
                                                    break e;
                                                }
                                                a = a + 1 | 0;
                                                b = i >>> 0 > a >>> 0;
                                                if ((a | 0) != (i | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            break e;
                                        }
                                        p = a & -4;
                                        n = a & 3;
                                        q = a - 1 >>> 0 < 3;
                                        b = 1;
                                        f = 0;
                                        while (1) {
                                            if (ec(c, G[c + 84 | 0] ? f : F[F[c + 68 >> 2] + (f << 2) >> 2], D[c + 24 | 0], h)) {
                                                o = F[d >> 2];
                                                m = 0;
                                                g = F[e >> 2];
                                                a = 0;
                                                b = 0;
                                                if (!q) {
                                                    while (1) {
                                                        k = (j << 2) + o | 0;
                                                        l = a << 2;
                                                        F[k >> 2] = F[g + l >> 2];
                                                        F[k + 4 >> 2] = F[g + (l | 4) >> 2];
                                                        F[k + 8 >> 2] = F[g + (l | 8) >> 2];
                                                        F[k + 12 >> 2] = F[g + (l | 12) >> 2];
                                                        a = a + 4 | 0;
                                                        j = j + 4 | 0;
                                                        b = b + 4 | 0;
                                                        if ((p | 0) != (b | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if (n) {
                                                    while (1) {
                                                        F[(j << 2) + o >> 2] = F[g + (a << 2) >> 2];
                                                        a = a + 1 | 0;
                                                        j = j + 1 | 0;
                                                        m = m + 1 | 0;
                                                        if ((m | 0) != (n | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                f = f + 1 | 0;
                                                b = i >>> 0 > f >>> 0;
                                                if ((f | 0) != (i | 0)) {
                                                    continue;
                                                }
                                            }
                                            break;
                                        }
                                        h = F[e >> 2];
                                    }
                                    if (h) {
                                        ra(h);
                                    }
                                    a = b ^ 1;
                                }
                                ea = e + 16 | 0;
                                a = a & 1;
                                break a;
                            }
                            va();
                            V();
                        } return a | 0; }
                        function fe(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0; e = ea - 16 | 0; ea = e; i = F[b + 80 >> 2]; a = D[c + 24 | 0]; f = L(i, a); a: {
                            b: {
                                b = F[c + 28 >> 2];
                                c: {
                                    if (!(!G[c + 84 | 0] | (b | 0) != 5 & (b | 0) != 6)) {
                                        h = F[c + 48 >> 2];
                                        i = F[F[c >> 2] >> 2];
                                        b = 0;
                                        F[e + 8 >> 2] = 0;
                                        F[e >> 2] = 0;
                                        F[e + 4 >> 2] = 0;
                                        c = 0;
                                        a = f << 2;
                                        if (a) {
                                            if ((a | 0) < 0) {
                                                break b;
                                            }
                                            c = sa(a);
                                            b = ta(c, h + i | 0, a);
                                            j = b + a | 0;
                                            b = b + (a >> 2 << 2) | 0;
                                        }
                                        a = F[d >> 2];
                                        if (a) {
                                            F[d + 4 >> 2] = a;
                                            ra(a);
                                        }
                                        F[d + 8 >> 2] = b;
                                        F[d + 4 >> 2] = j;
                                        F[d >> 2] = c;
                                        a = 1;
                                        break c;
                                    }
                                    F[e + 8 >> 2] = 0;
                                    F[e >> 2] = 0;
                                    F[e + 4 >> 2] = 0;
                                    if (a) {
                                        if ((a | 0) < 0) {
                                            break b;
                                        }
                                        b = a << 2;
                                        h = sa(b);
                                        F[e >> 2] = h;
                                        g = b + h | 0;
                                        F[e + 8 >> 2] = g;
                                        ua(h, 0, b);
                                        F[e + 4 >> 2] = g;
                                    }
                                    g = F[d >> 2];
                                    b = F[d + 4 >> 2] - g >> 2;
                                    d: {
                                        if (b >>> 0 < f >>> 0) {
                                            Aa(d, f - b | 0);
                                            break d;
                                        }
                                        if (b >>> 0 <= f >>> 0) {
                                            break d;
                                        }
                                        F[d + 4 >> 2] = g + (f << 2);
                                    }
                                    e: {
                                        if (!i) {
                                            b = 0;
                                            break e;
                                        }
                                        if (!a) {
                                            a = 0;
                                            b = 1;
                                            while (1) {
                                                if (!fc(c, G[c + 84 | 0] ? a : F[F[c + 68 >> 2] + (a << 2) >> 2], D[c + 24 | 0], h)) {
                                                    break e;
                                                }
                                                a = a + 1 | 0;
                                                b = i >>> 0 > a >>> 0;
                                                if ((a | 0) != (i | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            break e;
                                        }
                                        p = a & -4;
                                        n = a & 3;
                                        q = a - 1 >>> 0 < 3;
                                        b = 1;
                                        f = 0;
                                        while (1) {
                                            if (fc(c, G[c + 84 | 0] ? f : F[F[c + 68 >> 2] + (f << 2) >> 2], D[c + 24 | 0], h)) {
                                                o = F[d >> 2];
                                                m = 0;
                                                g = F[e >> 2];
                                                a = 0;
                                                b = 0;
                                                if (!q) {
                                                    while (1) {
                                                        k = (j << 2) + o | 0;
                                                        l = a << 2;
                                                        F[k >> 2] = F[g + l >> 2];
                                                        F[k + 4 >> 2] = F[g + (l | 4) >> 2];
                                                        F[k + 8 >> 2] = F[g + (l | 8) >> 2];
                                                        F[k + 12 >> 2] = F[g + (l | 12) >> 2];
                                                        a = a + 4 | 0;
                                                        j = j + 4 | 0;
                                                        b = b + 4 | 0;
                                                        if ((p | 0) != (b | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if (n) {
                                                    while (1) {
                                                        F[(j << 2) + o >> 2] = F[g + (a << 2) >> 2];
                                                        a = a + 1 | 0;
                                                        j = j + 1 | 0;
                                                        m = m + 1 | 0;
                                                        if ((m | 0) != (n | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                f = f + 1 | 0;
                                                b = i >>> 0 > f >>> 0;
                                                if ((f | 0) != (i | 0)) {
                                                    continue;
                                                }
                                            }
                                            break;
                                        }
                                        h = F[e >> 2];
                                    }
                                    if (h) {
                                        ra(h);
                                    }
                                    a = b ^ 1;
                                }
                                ea = e + 16 | 0;
                                a = a & 1;
                                break a;
                            }
                            va();
                            V();
                        } return a | 0; }
                        function pg(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0; e = ea - 16 | 0; ea = e; i = F[b + 80 >> 2]; a = D[c + 24 | 0]; f = L(i, a); a: {
                            b: {
                                b = F[c + 28 >> 2];
                                c: {
                                    if (!(!G[c + 84 | 0] | (b | 0) != 3 & (b | 0) != 4)) {
                                        h = F[c + 48 >> 2];
                                        i = F[F[c >> 2] >> 2];
                                        b = 0;
                                        F[e + 8 >> 2] = 0;
                                        F[e >> 2] = 0;
                                        F[e + 4 >> 2] = 0;
                                        c = 0;
                                        a = f << 1;
                                        if (a) {
                                            if ((a | 0) < 0) {
                                                break b;
                                            }
                                            c = sa(a);
                                            b = ta(c, h + i | 0, a);
                                            j = b + a | 0;
                                            b = b + (a >> 1 << 1) | 0;
                                        }
                                        a = F[d >> 2];
                                        if (a) {
                                            F[d + 4 >> 2] = a;
                                            ra(a);
                                        }
                                        F[d + 8 >> 2] = b;
                                        F[d + 4 >> 2] = j;
                                        F[d >> 2] = c;
                                        a = 1;
                                        break c;
                                    }
                                    F[e + 8 >> 2] = 0;
                                    F[e >> 2] = 0;
                                    F[e + 4 >> 2] = 0;
                                    if (a) {
                                        if ((a | 0) < 0) {
                                            break b;
                                        }
                                        b = a << 1;
                                        h = sa(b);
                                        F[e >> 2] = h;
                                        g = b + h | 0;
                                        F[e + 8 >> 2] = g;
                                        ua(h, 0, b);
                                        F[e + 4 >> 2] = g;
                                    }
                                    g = F[d >> 2];
                                    b = F[d + 4 >> 2] - g >> 1;
                                    d: {
                                        if (b >>> 0 < f >>> 0) {
                                            oe(d, f - b | 0);
                                            break d;
                                        }
                                        if (b >>> 0 <= f >>> 0) {
                                            break d;
                                        }
                                        F[d + 4 >> 2] = g + (f << 1);
                                    }
                                    e: {
                                        if (!i) {
                                            b = 0;
                                            break e;
                                        }
                                        if (!a) {
                                            a = 0;
                                            b = 1;
                                            while (1) {
                                                if (!hc(c, G[c + 84 | 0] ? a : F[F[c + 68 >> 2] + (a << 2) >> 2], D[c + 24 | 0], h)) {
                                                    break e;
                                                }
                                                a = a + 1 | 0;
                                                b = i >>> 0 > a >>> 0;
                                                if ((a | 0) != (i | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            break e;
                                        }
                                        p = a & -4;
                                        n = a & 3;
                                        q = a - 1 >>> 0 < 3;
                                        b = 1;
                                        f = 0;
                                        while (1) {
                                            if (hc(c, G[c + 84 | 0] ? f : F[F[c + 68 >> 2] + (f << 2) >> 2], D[c + 24 | 0], h)) {
                                                o = F[d >> 2];
                                                m = 0;
                                                g = F[e >> 2];
                                                a = 0;
                                                b = 0;
                                                if (!q) {
                                                    while (1) {
                                                        k = (j << 1) + o | 0;
                                                        l = a << 1;
                                                        E[k >> 1] = H[g + l >> 1];
                                                        E[k + 2 >> 1] = H[g + (l | 2) >> 1];
                                                        E[k + 4 >> 1] = H[g + (l | 4) >> 1];
                                                        E[k + 6 >> 1] = H[g + (l | 6) >> 1];
                                                        a = a + 4 | 0;
                                                        j = j + 4 | 0;
                                                        b = b + 4 | 0;
                                                        if ((p | 0) != (b | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if (n) {
                                                    while (1) {
                                                        E[(j << 1) + o >> 1] = H[g + (a << 1) >> 1];
                                                        a = a + 1 | 0;
                                                        j = j + 1 | 0;
                                                        m = m + 1 | 0;
                                                        if ((m | 0) != (n | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                f = f + 1 | 0;
                                                b = i >>> 0 > f >>> 0;
                                                if ((f | 0) != (i | 0)) {
                                                    continue;
                                                }
                                            }
                                            break;
                                        }
                                        h = F[e >> 2];
                                    }
                                    if (h) {
                                        ra(h);
                                    }
                                    a = b ^ 1;
                                }
                                ea = e + 16 | 0;
                                a = a & 1;
                                break a;
                            }
                            va();
                            V();
                        } return a | 0; }
                        function og(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0; e = ea - 16 | 0; ea = e; i = F[b + 80 >> 2]; a = D[c + 24 | 0]; f = L(i, a); a: {
                            b: {
                                b = F[c + 28 >> 2];
                                c: {
                                    if (!(!G[c + 84 | 0] | (b | 0) != 3 & (b | 0) != 4)) {
                                        h = F[c + 48 >> 2];
                                        i = F[F[c >> 2] >> 2];
                                        b = 0;
                                        F[e + 8 >> 2] = 0;
                                        F[e >> 2] = 0;
                                        F[e + 4 >> 2] = 0;
                                        c = 0;
                                        a = f << 1;
                                        if (a) {
                                            if ((a | 0) < 0) {
                                                break b;
                                            }
                                            c = sa(a);
                                            b = ta(c, h + i | 0, a);
                                            j = b + a | 0;
                                            b = b + (a >> 1 << 1) | 0;
                                        }
                                        a = F[d >> 2];
                                        if (a) {
                                            F[d + 4 >> 2] = a;
                                            ra(a);
                                        }
                                        F[d + 8 >> 2] = b;
                                        F[d + 4 >> 2] = j;
                                        F[d >> 2] = c;
                                        a = 1;
                                        break c;
                                    }
                                    F[e + 8 >> 2] = 0;
                                    F[e >> 2] = 0;
                                    F[e + 4 >> 2] = 0;
                                    if (a) {
                                        if ((a | 0) < 0) {
                                            break b;
                                        }
                                        b = a << 1;
                                        h = sa(b);
                                        F[e >> 2] = h;
                                        g = b + h | 0;
                                        F[e + 8 >> 2] = g;
                                        ua(h, 0, b);
                                        F[e + 4 >> 2] = g;
                                    }
                                    g = F[d >> 2];
                                    b = F[d + 4 >> 2] - g >> 1;
                                    d: {
                                        if (b >>> 0 < f >>> 0) {
                                            oe(d, f - b | 0);
                                            break d;
                                        }
                                        if (b >>> 0 <= f >>> 0) {
                                            break d;
                                        }
                                        F[d + 4 >> 2] = g + (f << 1);
                                    }
                                    e: {
                                        if (!i) {
                                            b = 0;
                                            break e;
                                        }
                                        if (!a) {
                                            a = 0;
                                            b = 1;
                                            while (1) {
                                                if (!gc(c, G[c + 84 | 0] ? a : F[F[c + 68 >> 2] + (a << 2) >> 2], D[c + 24 | 0], h)) {
                                                    break e;
                                                }
                                                a = a + 1 | 0;
                                                b = i >>> 0 > a >>> 0;
                                                if ((a | 0) != (i | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            break e;
                                        }
                                        p = a & -4;
                                        n = a & 3;
                                        q = a - 1 >>> 0 < 3;
                                        b = 1;
                                        f = 0;
                                        while (1) {
                                            if (gc(c, G[c + 84 | 0] ? f : F[F[c + 68 >> 2] + (f << 2) >> 2], D[c + 24 | 0], h)) {
                                                o = F[d >> 2];
                                                m = 0;
                                                g = F[e >> 2];
                                                a = 0;
                                                b = 0;
                                                if (!q) {
                                                    while (1) {
                                                        k = (j << 1) + o | 0;
                                                        l = a << 1;
                                                        E[k >> 1] = H[g + l >> 1];
                                                        E[k + 2 >> 1] = H[g + (l | 2) >> 1];
                                                        E[k + 4 >> 1] = H[g + (l | 4) >> 1];
                                                        E[k + 6 >> 1] = H[g + (l | 6) >> 1];
                                                        a = a + 4 | 0;
                                                        j = j + 4 | 0;
                                                        b = b + 4 | 0;
                                                        if ((p | 0) != (b | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                if (n) {
                                                    while (1) {
                                                        E[(j << 1) + o >> 1] = H[g + (a << 1) >> 1];
                                                        a = a + 1 | 0;
                                                        j = j + 1 | 0;
                                                        m = m + 1 | 0;
                                                        if ((m | 0) != (n | 0)) {
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                }
                                                f = f + 1 | 0;
                                                b = i >>> 0 > f >>> 0;
                                                if ((f | 0) != (i | 0)) {
                                                    continue;
                                                }
                                            }
                                            break;
                                        }
                                        h = F[e >> 2];
                                    }
                                    if (h) {
                                        ra(h);
                                    }
                                    a = b ^ 1;
                                }
                                ea = e + 16 | 0;
                                a = a & 1;
                                break a;
                            }
                            va();
                            V();
                        } return a | 0; }
                        function Zi(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0; F[a + 8 >> 2] = e; f = a + 32 | 0; i = F[f >> 2]; h = F[a + 36 >> 2] - i >> 2; a: {
                            if (h >>> 0 < e >>> 0) {
                                Aa(f, e - h | 0);
                                i = F[f >> 2];
                                f = F[a + 8 >> 2];
                                break a;
                            }
                            if (e >>> 0 < h >>> 0) {
                                F[a + 36 >> 2] = (e << 2) + i;
                            }
                            f = e;
                        } h = 0; g = (e & 1073741823) != (e | 0) ? -1 : e << 2; m = ua(sa(g), 0, g); b: {
                            if ((f | 0) <= 0) {
                                break b;
                            }
                            while (1) {
                                f = h << 2;
                                g = F[f + m >> 2];
                                j = F[a + 16 >> 2];
                                c: {
                                    if ((g | 0) > (j | 0)) {
                                        F[f + i >> 2] = j;
                                        break c;
                                    }
                                    f = f + i | 0;
                                    j = F[a + 12 >> 2];
                                    if ((j | 0) > (g | 0)) {
                                        F[f >> 2] = j;
                                        break c;
                                    }
                                    F[f >> 2] = g;
                                }
                                f = F[a + 8 >> 2];
                                h = h + 1 | 0;
                                if ((f | 0) > (h | 0)) {
                                    continue;
                                }
                                break;
                            }
                            if ((f | 0) <= 0) {
                                break b;
                            }
                            h = 0;
                            while (1) {
                                g = h << 2;
                                f = g + c | 0;
                                g = F[b + g >> 2] + F[g + i >> 2] | 0;
                                F[f >> 2] = g;
                                d: {
                                    if ((g | 0) > F[a + 16 >> 2]) {
                                        g = g - F[a + 20 >> 2] | 0;
                                    }
                                    else {
                                        if ((g | 0) >= F[a + 12 >> 2]) {
                                            break d;
                                        }
                                        g = g + F[a + 20 >> 2] | 0;
                                    }
                                    F[f >> 2] = g;
                                }
                                f = F[a + 8 >> 2];
                                h = h + 1 | 0;
                                if ((f | 0) > (h | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } if (!((d | 0) <= (e | 0) | (f | 0) <= 0)) {
                            o = 0 - e << 2;
                            i = e;
                            while (1) {
                                e: {
                                    if ((f | 0) <= 0) {
                                        break e;
                                    }
                                    l = i << 2;
                                    n = l + c | 0;
                                    p = n + o | 0;
                                    j = F[a + 32 >> 2];
                                    h = 0;
                                    while (1) {
                                        f = h << 2;
                                        g = F[f + p >> 2];
                                        k = F[a + 16 >> 2];
                                        f: {
                                            if ((g | 0) > (k | 0)) {
                                                F[f + j >> 2] = k;
                                                break f;
                                            }
                                            f = f + j | 0;
                                            k = F[a + 12 >> 2];
                                            if ((k | 0) > (g | 0)) {
                                                F[f >> 2] = k;
                                                break f;
                                            }
                                            F[f >> 2] = g;
                                        }
                                        f = F[a + 8 >> 2];
                                        h = h + 1 | 0;
                                        if ((f | 0) > (h | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                    h = 0;
                                    if ((f | 0) <= 0) {
                                        break e;
                                    }
                                    l = b + l | 0;
                                    while (1) {
                                        g = h << 2;
                                        f = g + n | 0;
                                        g = F[g + l >> 2] + F[g + j >> 2] | 0;
                                        F[f >> 2] = g;
                                        g: {
                                            if ((g | 0) > F[a + 16 >> 2]) {
                                                g = g - F[a + 20 >> 2] | 0;
                                            }
                                            else {
                                                if ((g | 0) >= F[a + 12 >> 2]) {
                                                    break g;
                                                }
                                                g = g + F[a + 20 >> 2] | 0;
                                            }
                                            F[f >> 2] = g;
                                        }
                                        f = F[a + 8 >> 2];
                                        h = h + 1 | 0;
                                        if ((f | 0) > (h | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                i = e + i | 0;
                                if ((i | 0) < (d | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } ra(m); return 1; }
                        function We(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0; i = ea - 32 | 0; ea = i; F[i + 28 >> 2] = 0; a: {
                            b: {
                                if (H[b + 38 >> 1] <= 513) {
                                    c = F[b + 20 >> 2];
                                    d = F[b + 16 >> 2];
                                    g = d + 4 | 0;
                                    c = g >>> 0 < 4 ? c + 1 | 0 : c;
                                    e = F[b + 12 >> 2];
                                    if ((e | 0) <= (c | 0) & g >>> 0 > I[b + 8 >> 2] | (c | 0) > (e | 0)) {
                                        break a;
                                    }
                                    d = d + F[b >> 2] | 0;
                                    d = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                    F[b + 16 >> 2] = g;
                                    F[b + 20 >> 2] = c;
                                    break b;
                                }
                                if (!Pb(1, i + 28 | 0, b)) {
                                    break a;
                                }
                                d = F[i + 28 >> 2];
                            }
                            if (!d) {
                                break a;
                            }
                            Ob(a + 76 | 0, d);
                            c = i + 8 | 0;
                            F[c >> 2] = 0;
                            F[c + 4 >> 2] = 0;
                            D[c + 5 | 0] = 0;
                            D[c + 6 | 0] = 0;
                            D[c + 7 | 0] = 0;
                            D[c + 8 | 0] = 0;
                            D[c + 9 | 0] = 0;
                            D[c + 10 | 0] = 0;
                            D[c + 11 | 0] = 0;
                            D[c + 12 | 0] = 0;
                            c: {
                                if (!xa(c, b)) {
                                    break c;
                                }
                                e = 1;
                                while (1) {
                                    f = 1 << h;
                                    j = Ga(c);
                                    g = F[a + 76 >> 2] + (h >>> 3 & 536870908) | 0;
                                    e = e ^ j;
                                    if (e & 1) {
                                        f = F[g >> 2] & (f ^ -1);
                                    }
                                    else {
                                        f = f | F[g >> 2];
                                    }
                                    e = e ^ 1;
                                    F[g >> 2] = f;
                                    h = h + 1 | 0;
                                    if ((h | 0) != (d | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                h = 0;
                                d = F[b + 12 >> 2];
                                g = d;
                                c = F[b + 20 >> 2];
                                e = c;
                                f = F[b + 16 >> 2];
                                j = f + 4 | 0;
                                c = j >>> 0 < 4 ? c + 1 | 0 : c;
                                k = F[b + 8 >> 2];
                                if (k >>> 0 < j >>> 0 & (c | 0) >= (d | 0) | (c | 0) > (d | 0)) {
                                    break c;
                                }
                                l = F[b >> 2];
                                d = l + f | 0;
                                d = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                F[b + 16 >> 2] = j;
                                F[b + 20 >> 2] = c;
                                c = e;
                                e = f + 8 | 0;
                                c = e >>> 0 < 8 ? c + 1 | 0 : c;
                                f = e;
                                e = c;
                                if (f >>> 0 > k >>> 0 & (c | 0) >= (g | 0) | (c | 0) > (g | 0)) {
                                    break c;
                                }
                                c = j + l | 0;
                                c = G[c | 0] | G[c + 1 | 0] << 8 | (G[c + 2 | 0] << 16 | G[c + 3 | 0] << 24);
                                F[b + 16 >> 2] = f;
                                F[b + 20 >> 2] = e;
                                if ((c | 0) < (d | 0)) {
                                    break c;
                                }
                                F[a + 16 >> 2] = c;
                                F[a + 12 >> 2] = d;
                                b = (c >> 31) - ((d >> 31) + (c >>> 0 < d >>> 0) | 0) | 0;
                                c = c - d | 0;
                                if (!b & c >>> 0 > 2147483646 | b) {
                                    break c;
                                }
                                h = 1;
                                b = c + 1 | 0;
                                F[a + 20 >> 2] = b;
                                c = b >>> 1 | 0;
                                F[a + 24 >> 2] = c;
                                F[a + 28 >> 2] = 0 - c;
                                if (b & 1) {
                                    break c;
                                }
                                F[a + 24 >> 2] = c - 1;
                            }
                        } ea = i + 32 | 0; return h | 0; }
                        function Yc(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0; d = -1; f = -1; a: {
                            if ((b | 0) == -1) {
                                break a;
                            }
                            c = b + 1 | 0;
                            d = (c >>> 0) % 3 | 0 ? c : b - 2 | 0;
                            f = b - 1 | 0;
                            if ((b >>> 0) % 3 | 0) {
                                break a;
                            }
                            f = b + 2 | 0;
                        } b: {
                            c: {
                                d: {
                                    e: {
                                        f: {
                                            g: {
                                                e = F[a + 184 >> 2];
                                                switch (e | 0) {
                                                    case 7: break d;
                                                    case 3: break e;
                                                    case 5: break f;
                                                    case 0:
                                                    case 1: break g;
                                                    default: break b;
                                                }
                                            }
                                            g = F[a + 148 >> 2];
                                            c = -1;
                                            e = 1;
                                            d = ((d | 0) != -1 ? F[F[g >> 2] + (d << 2) >> 2] : c) << 2;
                                            c = F[a + 156 >> 2];
                                            d = d + c | 0;
                                            F[d >> 2] = F[d >> 2] + 1;
                                            c = (((f | 0) != -1 ? F[F[g >> 2] + (f << 2) >> 2] : -1) << 2) + c | 0;
                                            break c;
                                        }
                                        g = F[a + 148 >> 2];
                                        c = F[a + 156 >> 2];
                                        e = c + (((b | 0) != -1 ? F[F[g >> 2] + (b << 2) >> 2] : -1) << 2) | 0;
                                        F[e >> 2] = F[e >> 2] + 1;
                                        d = (((d | 0) != -1 ? F[F[g >> 2] + (d << 2) >> 2] : -1) << 2) + c | 0;
                                        F[d >> 2] = F[d >> 2] + 1;
                                        e = 2;
                                        c = (((f | 0) != -1 ? F[F[g >> 2] + (f << 2) >> 2] : -1) << 2) + c | 0;
                                        break c;
                                    }
                                    g = F[a + 148 >> 2];
                                    c = F[a + 156 >> 2];
                                    e = c + (((b | 0) != -1 ? F[F[g >> 2] + (b << 2) >> 2] : -1) << 2) | 0;
                                    F[e >> 2] = F[e >> 2] + 1;
                                    d = (((d | 0) != -1 ? F[F[g >> 2] + (d << 2) >> 2] : -1) << 2) + c | 0;
                                    F[d >> 2] = F[d >> 2] + 2;
                                    e = 1;
                                    c = (((f | 0) != -1 ? F[F[g >> 2] + (f << 2) >> 2] : -1) << 2) + c | 0;
                                    break c;
                                }
                                g = F[a + 148 >> 2];
                                c = F[a + 156 >> 2];
                                e = c + (((b | 0) != -1 ? F[F[g >> 2] + (b << 2) >> 2] : -1) << 2) | 0;
                                F[e >> 2] = F[e >> 2] + 2;
                                d = (((d | 0) != -1 ? F[F[g >> 2] + (d << 2) >> 2] : -1) << 2) + c | 0;
                                F[d >> 2] = F[d >> 2] + 2;
                                e = 2;
                                c = (((f | 0) != -1 ? F[F[g >> 2] + (f << 2) >> 2] : -1) << 2) + c | 0;
                            }
                            F[c >> 2] = F[c >> 2] + e;
                            e = F[a + 184 >> 2];
                        } h: {
                            switch (e | 0) {
                                case 0:
                                case 5:
                                    f = F[a + 156 >> 2];
                                    c = -1;
                                    i: {
                                        if ((b | 0) == -1) {
                                            break i;
                                        }
                                        d = b + 1 | 0;
                                        b = (d >>> 0) % 3 | 0 ? d : b - 2 | 0;
                                        c = -1;
                                        if ((b | 0) == -1) {
                                            break i;
                                        }
                                        c = F[F[F[a + 148 >> 2] >> 2] + (b << 2) >> 2];
                                    }
                                    if (F[f + (c << 2) >> 2] <= 5) {
                                        F[a + 188 >> 2] = 5;
                                        return;
                                    }
                                    F[a + 188 >> 2] = 0;
                                    return;
                                default: break h;
                            }
                        } F[a + 188 >> 2] = -1; }
                        function jf(a) { a = a | 0; var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0; e = ea - 16 | 0; ea = e; h = 1; i = ga[F[F[a >> 2] + 24 >> 2]](a) | 0; a: {
                            if ((i | 0) <= 0) {
                                h = 0;
                                break a;
                            }
                            l = a + 48 | 0;
                            while (1) {
                                b: {
                                    c: {
                                        if (!F[(ga[F[F[a >> 2] + 28 >> 2]](a) | 0) + 40 >> 2]) {
                                            break c;
                                        }
                                        j = f << 2;
                                        g = F[j + F[a + 36 >> 2] >> 2];
                                        b = F[g + 8 >> 2];
                                        k = ub(g);
                                        if (!k) {
                                            break c;
                                        }
                                        g = F[(ga[F[F[a >> 2] + 28 >> 2]](a) | 0) + 40 >> 2];
                                        F[e + 12 >> 2] = F[b + 56 >> 2];
                                        b = sa(32);
                                        F[e >> 2] = b;
                                        F[e + 4 >> 2] = 24;
                                        F[e + 8 >> 2] = -2147483616;
                                        D[b + 24 | 0] = 0;
                                        c = G[1318] | G[1319] << 8 | (G[1320] << 16 | G[1321] << 24);
                                        d = G[1314] | G[1315] << 8 | (G[1316] << 16 | G[1317] << 24);
                                        D[b + 16 | 0] = d;
                                        D[b + 17 | 0] = d >>> 8;
                                        D[b + 18 | 0] = d >>> 16;
                                        D[b + 19 | 0] = d >>> 24;
                                        D[b + 20 | 0] = c;
                                        D[b + 21 | 0] = c >>> 8;
                                        D[b + 22 | 0] = c >>> 16;
                                        D[b + 23 | 0] = c >>> 24;
                                        c = G[1310] | G[1311] << 8 | (G[1312] << 16 | G[1313] << 24);
                                        d = G[1306] | G[1307] << 8 | (G[1308] << 16 | G[1309] << 24);
                                        D[b + 8 | 0] = d;
                                        D[b + 9 | 0] = d >>> 8;
                                        D[b + 10 | 0] = d >>> 16;
                                        D[b + 11 | 0] = d >>> 24;
                                        D[b + 12 | 0] = c;
                                        D[b + 13 | 0] = c >>> 8;
                                        D[b + 14 | 0] = c >>> 16;
                                        D[b + 15 | 0] = c >>> 24;
                                        c = G[1302] | G[1303] << 8 | (G[1304] << 16 | G[1305] << 24);
                                        d = G[1298] | G[1299] << 8 | (G[1300] << 16 | G[1301] << 24);
                                        D[b | 0] = d;
                                        D[b + 1 | 0] = d >>> 8;
                                        D[b + 2 | 0] = d >>> 16;
                                        D[b + 3 | 0] = d >>> 24;
                                        D[b + 4 | 0] = c;
                                        D[b + 5 | 0] = c >>> 8;
                                        D[b + 6 | 0] = c >>> 16;
                                        D[b + 7 | 0] = c >>> 24;
                                        b = td(g, e + 12 | 0, e);
                                        if (D[e + 11 | 0] < 0) {
                                            ra(F[e >> 2]);
                                        }
                                        if (!b) {
                                            break c;
                                        }
                                        me(F[F[F[a + 36 >> 2] + j >> 2] + 8 >> 2], k);
                                        break b;
                                    }
                                    b = F[F[a + 36 >> 2] + (f << 2) >> 2];
                                    if (!(ga[F[F[b >> 2] + 24 >> 2]](b, l) | 0)) {
                                        break a;
                                    }
                                }
                                f = f + 1 | 0;
                                h = (i | 0) > (f | 0);
                                if ((f | 0) != (i | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } ea = e + 16 | 0; return (h ^ -1) & 1; }
                        function Ue(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0; j = ea - 16 | 0; ea = j; c = F[b + 20 >> 2]; d = F[b + 16 >> 2]; g = d + 4 | 0; c = g >>> 0 < 4 ? c + 1 | 0 : c; e = F[b + 12 >> 2]; a: {
                            if ((e | 0) <= (c | 0) & g >>> 0 > I[b + 8 >> 2] | (c | 0) > (e | 0)) {
                                break a;
                            }
                            d = d + F[b >> 2] | 0;
                            d = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                            F[b + 16 >> 2] = g;
                            F[b + 20 >> 2] = c;
                            if ((d | 0) < 0) {
                                break a;
                            }
                            Ob(a + 76 | 0, d);
                            c = j;
                            F[c >> 2] = 0;
                            F[c + 4 >> 2] = 0;
                            D[c + 5 | 0] = 0;
                            D[c + 6 | 0] = 0;
                            D[c + 7 | 0] = 0;
                            D[c + 8 | 0] = 0;
                            D[c + 9 | 0] = 0;
                            D[c + 10 | 0] = 0;
                            D[c + 11 | 0] = 0;
                            D[c + 12 | 0] = 0;
                            b: {
                                if (!xa(c, b)) {
                                    break b;
                                }
                                if (d) {
                                    e = 1;
                                    while (1) {
                                        f = 1 << h;
                                        i = Ga(c);
                                        g = F[a + 76 >> 2] + (h >>> 3 & 536870908) | 0;
                                        e = e ^ i;
                                        if (e & 1) {
                                            f = F[g >> 2] & (f ^ -1);
                                        }
                                        else {
                                            f = f | F[g >> 2];
                                        }
                                        e = e ^ 1;
                                        F[g >> 2] = f;
                                        h = h + 1 | 0;
                                        if ((d | 0) != (h | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                h = 0;
                                d = F[b + 12 >> 2];
                                g = d;
                                c = F[b + 20 >> 2];
                                e = c;
                                f = F[b + 16 >> 2];
                                i = f + 4 | 0;
                                c = i >>> 0 < 4 ? c + 1 | 0 : c;
                                k = F[b + 8 >> 2];
                                if (k >>> 0 < i >>> 0 & (c | 0) >= (d | 0) | (c | 0) > (d | 0)) {
                                    break b;
                                }
                                l = F[b >> 2];
                                d = l + f | 0;
                                d = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                F[b + 16 >> 2] = i;
                                F[b + 20 >> 2] = c;
                                c = e;
                                e = f + 8 | 0;
                                c = e >>> 0 < 8 ? c + 1 | 0 : c;
                                f = e;
                                e = c;
                                if (f >>> 0 > k >>> 0 & (c | 0) >= (g | 0) | (c | 0) > (g | 0)) {
                                    break b;
                                }
                                c = i + l | 0;
                                c = G[c | 0] | G[c + 1 | 0] << 8 | (G[c + 2 | 0] << 16 | G[c + 3 | 0] << 24);
                                F[b + 16 >> 2] = f;
                                F[b + 20 >> 2] = e;
                                if ((c | 0) < (d | 0)) {
                                    break b;
                                }
                                F[a + 16 >> 2] = c;
                                F[a + 12 >> 2] = d;
                                b = (c >> 31) - ((d >> 31) + (c >>> 0 < d >>> 0) | 0) | 0;
                                c = c - d | 0;
                                if (!b & c >>> 0 > 2147483646 | b) {
                                    break b;
                                }
                                h = 1;
                                b = c + 1 | 0;
                                F[a + 20 >> 2] = b;
                                c = b >>> 1 | 0;
                                F[a + 24 >> 2] = c;
                                F[a + 28 >> 2] = 0 - c;
                                if (b & 1) {
                                    break b;
                                }
                                F[a + 24 >> 2] = c - 1;
                            }
                        } ea = j + 16 | 0; return h | 0; }
                        function rg(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0; g = ea - 16 | 0; ea = g; h = F[b + 80 >> 2]; i = G[c + 24 | 0]; e = i << 24 >> 24; b = L(h, e); a: {
                            b: {
                                a = F[c + 28 >> 2];
                                c: {
                                    if (!(!G[c + 84 | 0] | (a | 0) != 1 & (a | 0) != 2)) {
                                        e = F[c + 48 >> 2];
                                        c = F[F[c >> 2] >> 2];
                                        a = 0;
                                        F[g + 8 >> 2] = 0;
                                        F[g >> 2] = 0;
                                        F[g + 4 >> 2] = 0;
                                        if (b) {
                                            if ((b | 0) < 0) {
                                                break b;
                                            }
                                            f = sa(b);
                                            a = ta(f, c + e | 0, b) + b | 0;
                                        }
                                        b = F[d >> 2];
                                        if (b) {
                                            F[d + 4 >> 2] = b;
                                            ra(b);
                                        }
                                        F[d + 8 >> 2] = a;
                                        F[d + 4 >> 2] = a;
                                        F[d >> 2] = f;
                                        b = 1;
                                        break c;
                                    }
                                    a = 0;
                                    F[g + 8 >> 2] = 0;
                                    F[g >> 2] = 0;
                                    F[g + 4 >> 2] = 0;
                                    d: {
                                        e: {
                                            if (e) {
                                                if ((e | 0) < 0) {
                                                    break b;
                                                }
                                                f = sa(e);
                                                F[g >> 2] = f;
                                                ua(f, 0, e);
                                                Va(d, b);
                                                if (h) {
                                                    break e;
                                                }
                                                b = 1;
                                                break d;
                                            }
                                            Va(d, b);
                                            b = 1;
                                            if (!h) {
                                                break c;
                                            }
                                            while (1) {
                                                if (jc(c, G[c + 84 | 0] ? a : F[F[c + 68 >> 2] + (a << 2) >> 2], D[c + 24 | 0], 0)) {
                                                    a = a + 1 | 0;
                                                    b = h >>> 0 > a >>> 0;
                                                    if ((a | 0) != (h | 0)) {
                                                        continue;
                                                    }
                                                }
                                                break;
                                            }
                                            b = b ^ 1;
                                            break c;
                                        }
                                        b = e - 1 | 0;
                                        j = b & -2;
                                        k = b & 1;
                                        b = 1;
                                        e = 0;
                                        f: {
                                            while (1) {
                                                f = F[g >> 2];
                                                if (!jc(c, G[c + 84 | 0] ? e : F[F[c + 68 >> 2] + (e << 2) >> 2], D[c + 24 | 0], f)) {
                                                    break f;
                                                }
                                                D[F[d >> 2] + a | 0] = G[f | 0];
                                                b = 1;
                                                a = a + 1 | 0;
                                                f = 0;
                                                g: {
                                                    h: {
                                                        switch (i - 1 | 0) {
                                                            default:
                                                                while (1) {
                                                                    D[F[d >> 2] + a | 0] = G[F[g >> 2] + b | 0];
                                                                    D[(F[d >> 2] + a | 0) + 1 | 0] = G[(F[g >> 2] + b | 0) + 1 | 0];
                                                                    b = b + 2 | 0;
                                                                    a = a + 2 | 0;
                                                                    f = f + 2 | 0;
                                                                    if ((j | 0) != (f | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                ;
                                                                break;
                                                            case 0: break g;
                                                            case 1: break h;
                                                        }
                                                    }
                                                    if (!k) {
                                                        break g;
                                                    }
                                                    D[F[d >> 2] + a | 0] = G[F[g >> 2] + b | 0];
                                                    a = a + 1 | 0;
                                                }
                                                e = e + 1 | 0;
                                                b = h >>> 0 > e >>> 0;
                                                if ((e | 0) != (h | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            f = F[g >> 2];
                                        }
                                        b = !b;
                                        if (!f) {
                                            break c;
                                        }
                                    }
                                    ra(f);
                                }
                                ea = g + 16 | 0;
                                a = b & 1;
                                break a;
                            }
                            va();
                            V();
                        } return a | 0; }
                        function qg(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0; g = ea - 16 | 0; ea = g; h = F[b + 80 >> 2]; i = G[c + 24 | 0]; e = i << 24 >> 24; b = L(h, e); a: {
                            b: {
                                a = F[c + 28 >> 2];
                                c: {
                                    if (!(!G[c + 84 | 0] | (a | 0) != 1 & (a | 0) != 2)) {
                                        e = F[c + 48 >> 2];
                                        c = F[F[c >> 2] >> 2];
                                        a = 0;
                                        F[g + 8 >> 2] = 0;
                                        F[g >> 2] = 0;
                                        F[g + 4 >> 2] = 0;
                                        if (b) {
                                            if ((b | 0) < 0) {
                                                break b;
                                            }
                                            f = sa(b);
                                            a = ta(f, c + e | 0, b) + b | 0;
                                        }
                                        b = F[d >> 2];
                                        if (b) {
                                            F[d + 4 >> 2] = b;
                                            ra(b);
                                        }
                                        F[d + 8 >> 2] = a;
                                        F[d + 4 >> 2] = a;
                                        F[d >> 2] = f;
                                        b = 1;
                                        break c;
                                    }
                                    a = 0;
                                    F[g + 8 >> 2] = 0;
                                    F[g >> 2] = 0;
                                    F[g + 4 >> 2] = 0;
                                    d: {
                                        e: {
                                            if (e) {
                                                if ((e | 0) < 0) {
                                                    break b;
                                                }
                                                f = sa(e);
                                                F[g >> 2] = f;
                                                ua(f, 0, e);
                                                Va(d, b);
                                                if (h) {
                                                    break e;
                                                }
                                                b = 1;
                                                break d;
                                            }
                                            Va(d, b);
                                            b = 1;
                                            if (!h) {
                                                break c;
                                            }
                                            while (1) {
                                                if (ic(c, G[c + 84 | 0] ? a : F[F[c + 68 >> 2] + (a << 2) >> 2], D[c + 24 | 0], 0)) {
                                                    a = a + 1 | 0;
                                                    b = h >>> 0 > a >>> 0;
                                                    if ((a | 0) != (h | 0)) {
                                                        continue;
                                                    }
                                                }
                                                break;
                                            }
                                            b = b ^ 1;
                                            break c;
                                        }
                                        b = e - 1 | 0;
                                        j = b & -2;
                                        k = b & 1;
                                        b = 1;
                                        e = 0;
                                        f: {
                                            while (1) {
                                                f = F[g >> 2];
                                                if (!ic(c, G[c + 84 | 0] ? e : F[F[c + 68 >> 2] + (e << 2) >> 2], D[c + 24 | 0], f)) {
                                                    break f;
                                                }
                                                D[F[d >> 2] + a | 0] = G[f | 0];
                                                b = 1;
                                                a = a + 1 | 0;
                                                f = 0;
                                                g: {
                                                    h: {
                                                        switch (i - 1 | 0) {
                                                            default:
                                                                while (1) {
                                                                    D[F[d >> 2] + a | 0] = G[F[g >> 2] + b | 0];
                                                                    D[(F[d >> 2] + a | 0) + 1 | 0] = G[(F[g >> 2] + b | 0) + 1 | 0];
                                                                    b = b + 2 | 0;
                                                                    a = a + 2 | 0;
                                                                    f = f + 2 | 0;
                                                                    if ((j | 0) != (f | 0)) {
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                ;
                                                                break;
                                                            case 0: break g;
                                                            case 1: break h;
                                                        }
                                                    }
                                                    if (!k) {
                                                        break g;
                                                    }
                                                    D[F[d >> 2] + a | 0] = G[F[g >> 2] + b | 0];
                                                    a = a + 1 | 0;
                                                }
                                                e = e + 1 | 0;
                                                b = h >>> 0 > e >>> 0;
                                                if ((e | 0) != (h | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            f = F[g >> 2];
                                        }
                                        b = !b;
                                        if (!f) {
                                            break c;
                                        }
                                    }
                                    ra(f);
                                }
                                ea = g + 16 | 0;
                                a = b & 1;
                                break a;
                            }
                            va();
                            V();
                        } return a | 0; }
                        function ze(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0; f = -1; d = -1; a: {
                            if ((b | 0) == -1) {
                                break a;
                            }
                            d = b + 1 | 0;
                            f = (d >>> 0) % 3 | 0 ? d : b - 2 | 0;
                            d = b - 1 | 0;
                            if ((b >>> 0) % 3 | 0) {
                                break a;
                            }
                            d = b + 2 | 0;
                        } b: {
                            c: {
                                d: {
                                    switch (F[a + 168 >> 2]) {
                                        case 0:
                                        case 1:
                                            e = F[a + 148 >> 2];
                                            c = 1;
                                            b = F[a + 156 >> 2];
                                            g = b + (((f | 0) != -1 ? F[F[e >> 2] + (f << 2) >> 2] : -1) << 2) | 0;
                                            F[g >> 2] = F[g >> 2] + 1;
                                            b = (((d | 0) != -1 ? F[F[e >> 2] + (d << 2) >> 2] : -1) << 2) + b | 0;
                                            break c;
                                        case 5:
                                            e = F[a + 148 >> 2];
                                            c = -1;
                                            c = ((b | 0) != -1 ? F[F[e >> 2] + (b << 2) >> 2] : c) << 2;
                                            b = F[a + 156 >> 2];
                                            c = c + b | 0;
                                            F[c >> 2] = F[c >> 2] + 1;
                                            c = (((f | 0) != -1 ? F[F[e >> 2] + (f << 2) >> 2] : -1) << 2) + b | 0;
                                            F[c >> 2] = F[c >> 2] + 1;
                                            c = 2;
                                            b = (((d | 0) != -1 ? F[F[e >> 2] + (d << 2) >> 2] : -1) << 2) + b | 0;
                                            break c;
                                        case 3:
                                            e = F[a + 148 >> 2];
                                            c = -1;
                                            c = ((b | 0) != -1 ? F[F[e >> 2] + (b << 2) >> 2] : c) << 2;
                                            b = F[a + 156 >> 2];
                                            c = c + b | 0;
                                            F[c >> 2] = F[c >> 2] + 1;
                                            c = (((f | 0) != -1 ? F[F[e >> 2] + (f << 2) >> 2] : -1) << 2) + b | 0;
                                            F[c >> 2] = F[c >> 2] + 2;
                                            c = 1;
                                            b = (((d | 0) != -1 ? F[F[e >> 2] + (d << 2) >> 2] : -1) << 2) + b | 0;
                                            break c;
                                        case 7: break d;
                                        default: break b;
                                    }
                                }
                                e = F[a + 148 >> 2];
                                c = -1;
                                c = ((b | 0) != -1 ? F[F[e >> 2] + (b << 2) >> 2] : c) << 2;
                                b = F[a + 156 >> 2];
                                c = c + b | 0;
                                F[c >> 2] = F[c >> 2] + 2;
                                c = (((f | 0) != -1 ? F[F[e >> 2] + (f << 2) >> 2] : -1) << 2) + b | 0;
                                F[c >> 2] = F[c >> 2] + 2;
                                c = 2;
                                b = (((d | 0) != -1 ? F[F[e >> 2] + (d << 2) >> 2] : -1) << 2) + b | 0;
                            }
                            F[b >> 2] = F[b >> 2] + c;
                        } c = a; d = F[a + 180 >> 2]; b = F[F[a + 156 >> 2] + (((f | 0) != -1 ? F[F[F[a + 148 >> 2] >> 2] + (f << 2) >> 2] : -1) << 2) >> 2]; a = F[a + 176 >> 2]; F[c + 172 >> 2] = (a | 0) > (b | 0) ? 0 : ((b | 0) > (d | 0) ? d : b) - a | 0; }
                        function Jc(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0; d = F[a + 8 >> 2]; e = F[a >> 2]; if (d - e >> 2 >>> 0 >= b >>> 0) {
                            g = F[a + 4 >> 2];
                            h = g - e >> 2;
                            f = b >>> 0 > h >>> 0 ? h : b;
                            a: {
                                if (!f) {
                                    break a;
                                }
                                k = f - 1 | 0;
                                i = f & 7;
                                b: {
                                    if (!i) {
                                        d = e;
                                        break b;
                                    }
                                    d = e;
                                    while (1) {
                                        F[d >> 2] = F[c >> 2];
                                        f = f - 1 | 0;
                                        d = d + 4 | 0;
                                        j = j + 1 | 0;
                                        if ((j | 0) != (i | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                if (k >>> 0 < 7) {
                                    break a;
                                }
                                while (1) {
                                    F[d >> 2] = F[c >> 2];
                                    F[d + 4 >> 2] = F[c >> 2];
                                    F[d + 8 >> 2] = F[c >> 2];
                                    F[d + 12 >> 2] = F[c >> 2];
                                    F[d + 16 >> 2] = F[c >> 2];
                                    F[d + 20 >> 2] = F[c >> 2];
                                    F[d + 24 >> 2] = F[c >> 2];
                                    F[d + 28 >> 2] = F[c >> 2];
                                    d = d + 32 | 0;
                                    f = f - 8 | 0;
                                    if (f) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            if (b >>> 0 > h >>> 0) {
                                d = a;
                                a = b - h | 0;
                                if (a) {
                                    a = (a << 2) + g | 0;
                                    while (1) {
                                        F[g >> 2] = F[c >> 2];
                                        g = g + 4 | 0;
                                        if ((a | 0) != (g | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                else {
                                    a = g;
                                }
                                F[d + 4 >> 2] = a;
                                return;
                            }
                            F[a + 4 >> 2] = e + (b << 2);
                            return;
                        } if (e) {
                            F[a + 4 >> 2] = e;
                            ra(e);
                            F[a + 8 >> 2] = 0;
                            F[a >> 2] = 0;
                            F[a + 4 >> 2] = 0;
                            d = 0;
                        } c: {
                            if (b >>> 0 >= 1073741824) {
                                break c;
                            }
                            e = d >> 1;
                            d = d >>> 0 < 2147483644 ? b >>> 0 > e >>> 0 ? b : e : 1073741823;
                            if (d >>> 0 >= 1073741824) {
                                break c;
                            }
                            d = d << 2;
                            e = sa(d);
                            F[a >> 2] = e;
                            F[a + 8 >> 2] = d + e;
                            c = F[c >> 2];
                            d = e;
                            g = b & 7;
                            if (g) {
                                while (1) {
                                    F[d >> 2] = c;
                                    d = d + 4 | 0;
                                    f = f + 1 | 0;
                                    if ((g | 0) != (f | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            e = e + (b << 2) | 0;
                            if ((b - 1 & 1073741823) >>> 0 >= 7) {
                                while (1) {
                                    F[d + 28 >> 2] = c;
                                    F[d + 24 >> 2] = c;
                                    F[d + 20 >> 2] = c;
                                    F[d + 16 >> 2] = c;
                                    F[d + 12 >> 2] = c;
                                    F[d + 8 >> 2] = c;
                                    F[d + 4 >> 2] = c;
                                    F[d >> 2] = c;
                                    d = d + 32 | 0;
                                    if ((e | 0) != (d | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            F[a + 4 >> 2] = e;
                            return;
                        } va(); V(); }
                        function yh(a) { a = a | 0; var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0; a: {
                            c = F[a + 32 >> 2];
                            e = F[c + 8 >> 2];
                            f = F[c + 12 >> 2];
                            d = F[c + 20 >> 2];
                            g = e;
                            e = F[c + 16 >> 2];
                            b = 0;
                            b: {
                                if ((f | 0) <= (d | 0) & g >>> 0 <= e >>> 0 | (d | 0) > (f | 0)) {
                                    break b;
                                }
                                g = G[e + F[c >> 2] | 0];
                                f = e + 1 | 0;
                                d = f ? d : d + 1 | 0;
                                F[c + 16 >> 2] = f;
                                F[c + 20 >> 2] = d;
                                c: {
                                    if (!g) {
                                        break c;
                                    }
                                    while (1) {
                                        if (ga[F[F[a >> 2] + 16 >> 2]](a, b) | 0) {
                                            b = b + 1 | 0;
                                            if ((g | 0) != (b | 0)) {
                                                continue;
                                            }
                                            break c;
                                        }
                                        break;
                                    }
                                    return 0;
                                }
                                b = F[a + 8 >> 2];
                                d = F[a + 12 >> 2];
                                if ((b | 0) != (d | 0)) {
                                    while (1) {
                                        c = F[b >> 2];
                                        if (!(ga[F[F[c >> 2] + 8 >> 2]](c, a, F[a + 4 >> 2]) | 0)) {
                                            break a;
                                        }
                                        b = b + 4 | 0;
                                        if ((d | 0) != (b | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                d: {
                                    if (!g) {
                                        break d;
                                    }
                                    b = 0;
                                    while (1) {
                                        c = F[F[a + 8 >> 2] + (b << 2) >> 2];
                                        if (!(ga[F[F[c >> 2] + 12 >> 2]](c, F[a + 32 >> 2]) | 0)) {
                                            break a;
                                        }
                                        b = b + 1 | 0;
                                        if ((g | 0) != (b | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                    if (!g) {
                                        break d;
                                    }
                                    e = a + 20 | 0;
                                    while (1) {
                                        b = 0;
                                        f = h << 2;
                                        c = F[f + F[a + 8 >> 2] >> 2];
                                        d = ga[F[F[c >> 2] + 24 >> 2]](c) | 0;
                                        if ((d | 0) > 0) {
                                            while (1) {
                                                c = F[F[a + 8 >> 2] + f >> 2];
                                                k = ga[F[F[c >> 2] + 20 >> 2]](c, b) | 0;
                                                i = F[a + 20 >> 2];
                                                j = F[a + 24 >> 2] - i >> 2;
                                                e: {
                                                    if (k >>> 0 < j >>> 0) {
                                                        break e;
                                                    }
                                                    c = k + 1 | 0;
                                                    if (c >>> 0 > j >>> 0) {
                                                        Aa(e, c - j | 0);
                                                        i = F[e >> 2];
                                                        break e;
                                                    }
                                                    if (c >>> 0 >= j >>> 0) {
                                                        break e;
                                                    }
                                                    F[a + 24 >> 2] = (c << 2) + i;
                                                }
                                                F[(k << 2) + i >> 2] = h;
                                                b = b + 1 | 0;
                                                if ((d | 0) != (b | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        h = h + 1 | 0;
                                        if ((g | 0) != (h | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                b = 0;
                                if (!(ga[F[F[a >> 2] + 28 >> 2]](a) | 0)) {
                                    break b;
                                }
                                b = ga[F[F[a >> 2] + 32 >> 2]](a) | 0;
                            }
                            return b | 0;
                        } return 0; }
                        function Rf(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0; Vd(a, b, c); c = F[a + 84 >> 2]; d = F[a + 88 >> 2] - c >> 2; a: {
                            if ((d | 0) > (b | 0)) {
                                break a;
                            }
                            b = b + 1 | 0;
                            if (b >>> 0 > d >>> 0) {
                                b: {
                                    d = b - d | 0;
                                    e = F[a + 92 >> 2];
                                    c = F[a + 88 >> 2];
                                    if (d >>> 0 <= e - c >> 2 >>> 0) {
                                        c: {
                                            if (!d) {
                                                break c;
                                            }
                                            b = c;
                                            f = d & 7;
                                            if (f) {
                                                while (1) {
                                                    F[b >> 2] = 1;
                                                    b = b + 4 | 0;
                                                    g = g + 1 | 0;
                                                    if ((f | 0) != (g | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            c = (d << 2) + c | 0;
                                            if ((d - 1 & 1073741823) >>> 0 < 7) {
                                                break c;
                                            }
                                            while (1) {
                                                F[b + 24 >> 2] = 1;
                                                F[b + 28 >> 2] = 1;
                                                F[b + 16 >> 2] = 1;
                                                F[b + 20 >> 2] = 1;
                                                F[b + 8 >> 2] = 1;
                                                F[b + 12 >> 2] = 1;
                                                F[b >> 2] = 1;
                                                F[b + 4 >> 2] = 1;
                                                b = b + 32 | 0;
                                                if ((c | 0) != (b | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        F[a + 88 >> 2] = c;
                                        break b;
                                    }
                                    d: {
                                        f = F[a + 84 >> 2];
                                        j = c - f | 0;
                                        c = j >> 2;
                                        b = c + d | 0;
                                        if (b >>> 0 < 1073741824) {
                                            e = e - f | 0;
                                            h = e >> 1;
                                            e = e >>> 0 < 2147483644 ? b >>> 0 > h >>> 0 ? b : h : 1073741823;
                                            if (e) {
                                                if (e >>> 0 >= 1073741824) {
                                                    break d;
                                                }
                                                i = sa(e << 2);
                                            }
                                            c = (c << 2) + i | 0;
                                            b = c;
                                            h = d & 7;
                                            if (h) {
                                                b = c;
                                                while (1) {
                                                    F[b >> 2] = 1;
                                                    b = b + 4 | 0;
                                                    g = g + 1 | 0;
                                                    if ((h | 0) != (g | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            c = c + (d << 2) | 0;
                                            if ((d - 1 & 1073741823) >>> 0 >= 7) {
                                                while (1) {
                                                    F[b + 24 >> 2] = 1;
                                                    F[b + 28 >> 2] = 1;
                                                    F[b + 16 >> 2] = 1;
                                                    F[b + 20 >> 2] = 1;
                                                    F[b + 8 >> 2] = 1;
                                                    F[b + 12 >> 2] = 1;
                                                    F[b >> 2] = 1;
                                                    F[b + 4 >> 2] = 1;
                                                    b = b + 32 | 0;
                                                    if ((c | 0) != (b | 0)) {
                                                        continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            if ((j | 0) > 0) {
                                                ta(i, f, j);
                                            }
                                            F[a + 92 >> 2] = (e << 2) + i;
                                            F[a + 88 >> 2] = c;
                                            F[a + 84 >> 2] = i;
                                            if (f) {
                                                ra(f);
                                            }
                                            break b;
                                        }
                                        va();
                                        V();
                                    }
                                    wa(1336);
                                    V();
                                }
                                return;
                            }
                            if (b >>> 0 >= d >>> 0) {
                                break a;
                            }
                            F[a + 88 >> 2] = c + (b << 2);
                        } }
                        function xa(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0; i = ea - 16 | 0; ea = i; e = F[b + 20 >> 2]; c = F[b + 12 >> 2]; f = F[b + 16 >> 2]; a: {
                            if ((e | 0) >= (c | 0) & f >>> 0 >= I[b + 8 >> 2] | (c | 0) < (e | 0)) {
                                break a;
                            }
                            D[a + 12 | 0] = G[f + F[b >> 2] | 0];
                            e = F[b + 20 >> 2];
                            c = e;
                            f = F[b + 16 >> 2];
                            d = f + 1 | 0;
                            e = d ? c : c + 1 | 0;
                            h = d;
                            F[b + 16 >> 2] = d;
                            F[b + 20 >> 2] = e;
                            b: {
                                if (H[b + 38 >> 1] <= 513) {
                                    g = F[b + 12 >> 2];
                                    e = c;
                                    c = f + 5 | 0;
                                    e = c >>> 0 < 5 ? e + 1 | 0 : e;
                                    d = F[b + 8 >> 2];
                                    f = c;
                                    if (d >>> 0 < c >>> 0 & (e | 0) >= (g | 0) | (e | 0) > (g | 0)) {
                                        break a;
                                    }
                                    c = h + F[b >> 2] | 0;
                                    c = G[c | 0] | G[c + 1 | 0] << 8 | (G[c + 2 | 0] << 16 | G[c + 3 | 0] << 24);
                                    F[b + 16 >> 2] = f;
                                    F[b + 20 >> 2] = e;
                                    break b;
                                }
                                if (!Ne(1, i + 12 | 0, b)) {
                                    break a;
                                }
                                f = F[b + 16 >> 2];
                                e = F[b + 20 >> 2];
                                d = F[b + 8 >> 2];
                                g = F[b + 12 >> 2];
                                c = F[i + 12 >> 2];
                            }
                            h = d - f | 0;
                            d = g - (e + (d >>> 0 < f >>> 0) | 0) | 0;
                            if ((d | 0) <= 0 & c >>> 0 > h >>> 0 | (d | 0) < 0 | (c | 0) <= 0) {
                                break a;
                            }
                            d = f + F[b >> 2] | 0;
                            F[a >> 2] = d;
                            k = a;
                            g = c - 1 | 0;
                            h = g + d | 0;
                            j = G[h | 0];
                            c: {
                                if (j >>> 0 <= 63) {
                                    F[a + 4 >> 2] = g;
                                    a = G[h | 0] & 63;
                                    break c;
                                }
                                d: {
                                    switch ((j >>> 6 | 0) - 1 | 0) {
                                        case 0:
                                            if (c >>> 0 < 2) {
                                                break a;
                                            }
                                            F[a + 4 >> 2] = c - 2;
                                            d = (c + d | 0) - 2 | 0;
                                            a = G[d + 1 | 0] << 8 & 16128 | G[d | 0];
                                            break c;
                                        case 1: break d;
                                        default: break a;
                                    }
                                }
                                if (c >>> 0 < 3) {
                                    break a;
                                }
                                F[a + 4 >> 2] = c - 3;
                                d = (c + d | 0) - 3 | 0;
                                a = G[d + 2 | 0] << 16 & 4128768 | G[d + 1 | 0] << 8 | G[d | 0];
                            }
                            a = a + 4096 | 0;
                            F[k + 8 >> 2] = a;
                            if (a >>> 0 > 1048575) {
                                break a;
                            }
                            a = c + f | 0;
                            e = a >>> 0 < c >>> 0 ? e + 1 | 0 : e;
                            F[b + 16 >> 2] = a;
                            F[b + 20 >> 2] = e;
                            l = 1;
                        } ea = i + 16 | 0; return l; }
                        function Ie(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0; h = ea - 16 | 0; ea = h; a: {
                            b: {
                                if (H[b + 38 >> 1] <= 511) {
                                    g = F[b + 12 >> 2];
                                    i = g;
                                    c = F[b + 20 >> 2];
                                    d = F[b + 16 >> 2];
                                    f = d + 8 | 0;
                                    c = f >>> 0 < 8 ? c + 1 | 0 : c;
                                    e = F[b + 8 >> 2];
                                    if (e >>> 0 < f >>> 0 & (c | 0) >= (g | 0) | (c | 0) > (g | 0)) {
                                        break a;
                                    }
                                    d = d + F[b >> 2] | 0;
                                    g = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                                    d = G[d + 4 | 0] | G[d + 5 | 0] << 8 | (G[d + 6 | 0] << 16 | G[d + 7 | 0] << 24);
                                    F[b + 16 >> 2] = f;
                                    F[b + 20 >> 2] = c;
                                    break b;
                                }
                                if (!ib(1, h + 8 | 0, b)) {
                                    break a;
                                }
                                f = F[b + 16 >> 2];
                                c = F[b + 20 >> 2];
                                e = F[b + 8 >> 2];
                                i = F[b + 12 >> 2];
                                g = F[h + 8 >> 2];
                                d = F[h + 12 >> 2];
                            }
                            j = e - f | 0;
                            e = i - (c + (f >>> 0 > e >>> 0) | 0) | 0;
                            if ((e | 0) == (d | 0) & g >>> 0 > j >>> 0 | d >>> 0 > e >>> 0) {
                                break a;
                            }
                            c = c + d | 0;
                            e = f + g | 0;
                            c = e >>> 0 < f >>> 0 ? c + 1 | 0 : c;
                            F[b + 16 >> 2] = e;
                            F[b + 20 >> 2] = c;
                            c = g;
                            if ((c | 0) <= 0) {
                                break a;
                            }
                            b = f + F[b >> 2] | 0;
                            F[a + 40 >> 2] = b;
                            i = a;
                            f = c - 1 | 0;
                            g = b + f | 0;
                            e = G[g | 0];
                            c: {
                                if (e >>> 0 <= 63) {
                                    F[a + 44 >> 2] = f;
                                    a = G[g | 0] & 63;
                                    break c;
                                }
                                d: {
                                    switch ((e >>> 6 | 0) - 1 | 0) {
                                        case 0:
                                            if (c >>> 0 < 2) {
                                                break a;
                                            }
                                            F[a + 44 >> 2] = c - 2;
                                            b = (b + c | 0) - 2 | 0;
                                            a = G[b + 1 | 0] << 8 & 16128 | G[b | 0];
                                            break c;
                                        case 1:
                                            if (c >>> 0 < 3) {
                                                break a;
                                            }
                                            F[a + 44 >> 2] = c - 3;
                                            b = (b + c | 0) - 3 | 0;
                                            a = G[b + 2 | 0] << 16 & 4128768 | G[b + 1 | 0] << 8 | G[b | 0];
                                            break c;
                                        default: break d;
                                    }
                                }
                                F[a + 44 >> 2] = c - 4;
                                b = (b + c | 0) - 4 | 0;
                                a = G[b + 2 | 0] << 16 | G[b + 3 | 0] << 24 & 1056964608 | G[b + 1 | 0] << 8 | G[b | 0];
                            }
                            a = a + 16384 | 0;
                            F[i + 48 >> 2] = a;
                            k = a >>> 0 < 4194304;
                        } ea = h + 16 | 0; return k; }
                        function ta(a, b, c) { var d = 0, e = 0, f = 0; if (c >>> 0 >= 512) {
                            ba(a | 0, b | 0, c | 0) | 0;
                            return a;
                        } e = a + c | 0; a: {
                            if (!((a ^ b) & 3)) {
                                b: {
                                    if (!(a & 3)) {
                                        c = a;
                                        break b;
                                    }
                                    if (!c) {
                                        c = a;
                                        break b;
                                    }
                                    c = a;
                                    while (1) {
                                        D[c | 0] = G[b | 0];
                                        b = b + 1 | 0;
                                        c = c + 1 | 0;
                                        if (!(c & 3)) {
                                            break b;
                                        }
                                        if (c >>> 0 < e >>> 0) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                d = e & -4;
                                c: {
                                    if (d >>> 0 < 64) {
                                        break c;
                                    }
                                    f = d + -64 | 0;
                                    if (f >>> 0 < c >>> 0) {
                                        break c;
                                    }
                                    while (1) {
                                        F[c >> 2] = F[b >> 2];
                                        F[c + 4 >> 2] = F[b + 4 >> 2];
                                        F[c + 8 >> 2] = F[b + 8 >> 2];
                                        F[c + 12 >> 2] = F[b + 12 >> 2];
                                        F[c + 16 >> 2] = F[b + 16 >> 2];
                                        F[c + 20 >> 2] = F[b + 20 >> 2];
                                        F[c + 24 >> 2] = F[b + 24 >> 2];
                                        F[c + 28 >> 2] = F[b + 28 >> 2];
                                        F[c + 32 >> 2] = F[b + 32 >> 2];
                                        F[c + 36 >> 2] = F[b + 36 >> 2];
                                        F[c + 40 >> 2] = F[b + 40 >> 2];
                                        F[c + 44 >> 2] = F[b + 44 >> 2];
                                        F[c + 48 >> 2] = F[b + 48 >> 2];
                                        F[c + 52 >> 2] = F[b + 52 >> 2];
                                        F[c + 56 >> 2] = F[b + 56 >> 2];
                                        F[c + 60 >> 2] = F[b + 60 >> 2];
                                        b = b - -64 | 0;
                                        c = c - -64 | 0;
                                        if (f >>> 0 >= c >>> 0) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                if (c >>> 0 >= d >>> 0) {
                                    break a;
                                }
                                while (1) {
                                    F[c >> 2] = F[b >> 2];
                                    b = b + 4 | 0;
                                    c = c + 4 | 0;
                                    if (d >>> 0 > c >>> 0) {
                                        continue;
                                    }
                                    break;
                                }
                                break a;
                            }
                            if (e >>> 0 < 4) {
                                c = a;
                                break a;
                            }
                            d = e - 4 | 0;
                            if (d >>> 0 < a >>> 0) {
                                c = a;
                                break a;
                            }
                            c = a;
                            while (1) {
                                D[c | 0] = G[b | 0];
                                D[c + 1 | 0] = G[b + 1 | 0];
                                D[c + 2 | 0] = G[b + 2 | 0];
                                D[c + 3 | 0] = G[b + 3 | 0];
                                b = b + 4 | 0;
                                c = c + 4 | 0;
                                if (d >>> 0 >= c >>> 0) {
                                    continue;
                                }
                                break;
                            }
                        } if (c >>> 0 < e >>> 0) {
                            while (1) {
                                D[c | 0] = G[b | 0];
                                b = b + 1 | 0;
                                c = c + 1 | 0;
                                if ((e | 0) != (c | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } return a; }
                        function Ia(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0; f = F[a + 8 >> 2]; e = F[a + 4 >> 2]; if (f - e >> 2 >>> 0 >= b >>> 0) {
                            a: {
                                if (!b) {
                                    break a;
                                }
                                d = e;
                                g = b & 7;
                                if (g) {
                                    while (1) {
                                        F[d >> 2] = F[c >> 2];
                                        d = d + 4 | 0;
                                        h = h + 1 | 0;
                                        if ((g | 0) != (h | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                e = (b << 2) + e | 0;
                                if ((b - 1 & 1073741823) >>> 0 < 7) {
                                    break a;
                                }
                                while (1) {
                                    F[d >> 2] = F[c >> 2];
                                    F[d + 4 >> 2] = F[c >> 2];
                                    F[d + 8 >> 2] = F[c >> 2];
                                    F[d + 12 >> 2] = F[c >> 2];
                                    F[d + 16 >> 2] = F[c >> 2];
                                    F[d + 20 >> 2] = F[c >> 2];
                                    F[d + 24 >> 2] = F[c >> 2];
                                    F[d + 28 >> 2] = F[c >> 2];
                                    d = d + 32 | 0;
                                    if ((e | 0) != (d | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            F[a + 4 >> 2] = e;
                            return;
                        } b: {
                            g = F[a >> 2];
                            k = e - g | 0;
                            e = k >> 2;
                            d = e + b | 0;
                            if (d >>> 0 < 1073741824) {
                                f = f - g | 0;
                                i = f >> 1;
                                f = f >>> 0 < 2147483644 ? d >>> 0 > i >>> 0 ? d : i : 1073741823;
                                if (f) {
                                    if (f >>> 0 >= 1073741824) {
                                        break b;
                                    }
                                    j = sa(f << 2);
                                }
                                e = (e << 2) + j | 0;
                                d = e;
                                i = b & 7;
                                if (i) {
                                    d = e;
                                    while (1) {
                                        F[d >> 2] = F[c >> 2];
                                        d = d + 4 | 0;
                                        h = h + 1 | 0;
                                        if ((i | 0) != (h | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                e = e + (b << 2) | 0;
                                if ((b - 1 & 1073741823) >>> 0 >= 7) {
                                    while (1) {
                                        F[d >> 2] = F[c >> 2];
                                        F[d + 4 >> 2] = F[c >> 2];
                                        F[d + 8 >> 2] = F[c >> 2];
                                        F[d + 12 >> 2] = F[c >> 2];
                                        F[d + 16 >> 2] = F[c >> 2];
                                        F[d + 20 >> 2] = F[c >> 2];
                                        F[d + 24 >> 2] = F[c >> 2];
                                        F[d + 28 >> 2] = F[c >> 2];
                                        d = d + 32 | 0;
                                        if ((e | 0) != (d | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                if ((k | 0) > 0) {
                                    ta(j, g, k);
                                }
                                F[a + 8 >> 2] = (f << 2) + j;
                                F[a + 4 >> 2] = e;
                                F[a >> 2] = j;
                                if (g) {
                                    ra(g);
                                }
                                return;
                            }
                            va();
                            V();
                        } wa(1336); V(); }
                        function we(a) { a = a | 0; var b = 0, c = 0, d = 0, e = 0, f = 0; F[a >> 2] = 11512; d = a + 232 | 0; b = F[d + 196 >> 2]; if (b) {
                            F[d + 200 >> 2] = b;
                            ra(b);
                        } c = F[d + 184 >> 2]; if (c) {
                            b = F[d + 188 >> 2];
                            if ((c | 0) == (b | 0)) {
                                b = c;
                            }
                            else {
                                while (1) {
                                    e = b - 12 | 0;
                                    f = F[e >> 2];
                                    if (f) {
                                        F[b - 8 >> 2] = f;
                                        ra(f);
                                    }
                                    b = e;
                                    if ((c | 0) != (b | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                b = F[d + 184 >> 2];
                            }
                            F[d + 188 >> 2] = c;
                            ra(b);
                        } b = F[d + 156 >> 2]; if (b) {
                            F[d + 160 >> 2] = b;
                            ra(b);
                        } c = F[d + 136 >> 2]; F[d + 136 >> 2] = 0; if (c) {
                            e = c - 4 | 0;
                            b = F[e >> 2];
                            if (b) {
                                b = c + (b << 4) | 0;
                                while (1) {
                                    b = b - 16 | 0;
                                    if ((c | 0) != (b | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            ra(e);
                        } Xc(a + 216 | 0); b = F[a + 196 >> 2]; if (b) {
                            F[a + 200 >> 2] = b;
                            ra(b);
                        } b = F[a + 184 >> 2]; if (b) {
                            F[a + 188 >> 2] = b;
                            ra(b);
                        } b = F[a + 172 >> 2]; if (b) {
                            F[a + 176 >> 2] = b;
                            ra(b);
                        } b = F[a + 160 >> 2]; if (b) {
                            F[a + 164 >> 2] = b;
                            ra(b);
                        } b = F[a + 144 >> 2]; if (b) {
                            while (1) {
                                c = F[b >> 2];
                                ra(b);
                                b = c;
                                if (b) {
                                    continue;
                                }
                                break;
                            }
                        } b = F[a + 136 >> 2]; F[a + 136 >> 2] = 0; if (b) {
                            ra(b);
                        } b = F[a + 120 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 108 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 96 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 72 >> 2]; if (b) {
                            F[a + 76 >> 2] = b;
                            ra(b);
                        } b = F[a + 60 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 48 >> 2]; if (b) {
                            F[a + 52 >> 2] = b;
                            ra(b);
                        } b = F[a + 36 >> 2]; if (b) {
                            F[a + 40 >> 2] = b;
                            ra(b);
                        } b = F[a + 24 >> 2]; if (b) {
                            F[a + 28 >> 2] = b;
                            ra(b);
                        } b = F[a + 12 >> 2]; if (b) {
                            F[a + 16 >> 2] = b;
                            ra(b);
                        } b = F[a + 8 >> 2]; F[a + 8 >> 2] = 0; if (b) {
                            cb(b);
                        } return a | 0; }
                        function xb(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0; d = ea - 16 | 0; ea = d; F[a + 12 >> 2] = b; F[a + 8 >> 2] = 0; F[a >> 2] = 0; F[a + 4 >> 2] = 0; c = a + 16 | 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; D[c + 5 | 0] = 0; D[c + 6 | 0] = 0; D[c + 7 | 0] = 0; D[c + 8 | 0] = 0; D[c + 9 | 0] = 0; D[c + 10 | 0] = 0; D[c + 11 | 0] = 0; D[c + 12 | 0] = 0; F[a + 32 >> 2] = 0; F[a + 36 >> 2] = 0; F[a + 48 >> 2] = 0; F[a + 40 >> 2] = 0; F[a + 44 >> 2] = 0; F[a + 52 >> 2] = 0; F[a + 56 >> 2] = 0; F[a + 68 >> 2] = 0; F[a + 60 >> 2] = 0; F[a + 64 >> 2] = 0; F[a + 72 >> 2] = 0; F[a + 76 >> 2] = 0; F[a + 88 >> 2] = 0; F[a + 80 >> 2] = 0; F[a + 84 >> 2] = 0; F[a + 100 >> 2] = 0; F[a + 92 >> 2] = 0; F[a + 96 >> 2] = 0; g = a + 116 | 0; a: {
                            b: {
                                if (b) {
                                    if (b >>> 0 < 1073741824) {
                                        break b;
                                    }
                                    va();
                                    V();
                                }
                                F[a + 104 >> 2] = 0;
                                F[a + 108 >> 2] = 0;
                                F[a + 112 >> 2] = 0;
                                F[d + 8 >> 2] = 0;
                                F[d >> 2] = 0;
                                F[d + 4 >> 2] = 0;
                                c = 1;
                                break a;
                            }
                            c = b << 2;
                            e = sa(c);
                            F[a + 92 >> 2] = e;
                            f = c + e | 0;
                            F[a + 100 >> 2] = f;
                            ua(e, 0, c);
                            F[a + 112 >> 2] = 0;
                            F[a + 104 >> 2] = 0;
                            F[a + 108 >> 2] = 0;
                            F[a + 96 >> 2] = f;
                            e = sa(c);
                            F[a + 104 >> 2] = e;
                            f = c + e | 0;
                            F[a + 112 >> 2] = f;
                            ua(e, 0, c);
                            F[a + 108 >> 2] = f;
                            e = sa(c);
                            F[d >> 2] = e;
                            f = c + e | 0;
                            F[d + 8 >> 2] = f;
                            ua(e, 0, c);
                            F[d + 4 >> 2] = f;
                            c = b << 5 | 1;
                        } wb(g, c, d); e = F[d >> 2]; if (e) {
                            F[d + 4 >> 2] = e;
                            ra(e);
                        } F[d + 8 >> 2] = 0; F[d >> 2] = 0; F[d + 4 >> 2] = 0; if (b) {
                            b = b << 2;
                            e = sa(b);
                            F[d >> 2] = e;
                            f = b + e | 0;
                            F[d + 8 >> 2] = f;
                            ua(e, 0, b);
                            F[d + 4 >> 2] = f;
                        } wb(a + 128 | 0, c, d); b = F[d >> 2]; if (b) {
                            F[d + 4 >> 2] = b;
                            ra(b);
                        } ea = d + 16 | 0; return a; }
                        function Jj(a, b, c, d) { var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0; g = c; a: {
                            b: {
                                c: {
                                    d: {
                                        e: {
                                            f: {
                                                g: {
                                                    h: {
                                                        i: {
                                                            j: {
                                                                k: {
                                                                    if (b) {
                                                                        if (!g) {
                                                                            break k;
                                                                        }
                                                                        if (!d) {
                                                                            break j;
                                                                        }
                                                                        c = O(d) - O(b) | 0;
                                                                        if (c >>> 0 <= 31) {
                                                                            break i;
                                                                        }
                                                                        break c;
                                                                    }
                                                                    if ((d | 0) == 1 | d >>> 0 > 1) {
                                                                        break c;
                                                                    }
                                                                    a = (a >>> 0) / (g >>> 0) | 0;
                                                                    fa = 0;
                                                                    break a;
                                                                }
                                                                if (!a) {
                                                                    break h;
                                                                }
                                                                if (!d) {
                                                                    break g;
                                                                }
                                                                if (d - 1 & d) {
                                                                    break g;
                                                                }
                                                                a = b >>> Mj(d) | 0;
                                                                fa = 0;
                                                                break a;
                                                            }
                                                            if (!(g - 1 & g)) {
                                                                break f;
                                                            }
                                                            h = (O(g) + 33 | 0) - O(b) | 0;
                                                            e = 0 - h | 0;
                                                            break d;
                                                        }
                                                        h = c + 1 | 0;
                                                        e = 63 - c | 0;
                                                        break d;
                                                    }
                                                    a = (b >>> 0) / (d >>> 0) | 0;
                                                    fa = 0;
                                                    break a;
                                                }
                                                c = O(d) - O(b) | 0;
                                                if (c >>> 0 < 31) {
                                                    break e;
                                                }
                                                break c;
                                            }
                                            if ((g | 0) == 1) {
                                                break b;
                                            }
                                            c = Mj(g);
                                            d = c & 31;
                                            if ((c & 63) >>> 0 >= 32) {
                                                c = 0;
                                                a = b >>> d | 0;
                                            }
                                            else {
                                                c = b >>> d | 0;
                                                a = ((1 << d) - 1 & b) << 32 - d | a >>> d;
                                            }
                                            fa = c;
                                            break a;
                                        }
                                        h = c + 1 | 0;
                                        e = 63 - c | 0;
                                    }
                                    c = h & 63;
                                    f = c & 31;
                                    if (c >>> 0 >= 32) {
                                        c = 0;
                                        i = b >>> f | 0;
                                    }
                                    else {
                                        c = b >>> f | 0;
                                        i = ((1 << f) - 1 & b) << 32 - f | a >>> f;
                                    }
                                    f = c;
                                    c = e & 63;
                                    e = c & 31;
                                    if (c >>> 0 >= 32) {
                                        c = a << e;
                                        a = 0;
                                    }
                                    else {
                                        c = (1 << e) - 1 & a >>> 32 - e | b << e;
                                        a = a << e;
                                    }
                                    b = c;
                                    if (h) {
                                        c = d - 1 | 0;
                                        e = g - 1 | 0;
                                        m = (e | 0) != -1 ? c + 1 | 0 : c;
                                        while (1) {
                                            c = i << 1 | b >>> 31;
                                            f = f << 1 | i >>> 31;
                                            j = m - (f + (c >>> 0 > e >>> 0) | 0) >> 31;
                                            k = g & j;
                                            i = c - k | 0;
                                            f = f - ((d & j) + (c >>> 0 < k >>> 0) | 0) | 0;
                                            b = b << 1 | a >>> 31;
                                            a = l | a << 1;
                                            l = j & 1;
                                            h = h - 1 | 0;
                                            if (h) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    fa = b << 1 | a >>> 31;
                                    a = l | a << 1;
                                    break a;
                                }
                                a = 0;
                                b = 0;
                            }
                            fa = b;
                        } return a; }
                        function zb(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0; c = ea - 16 | 0; ea = c; F[a + 12 >> 2] = b; F[a + 8 >> 2] = 0; F[a >> 2] = 0; F[a + 4 >> 2] = 0; F[a + 16 >> 2] = 0; F[a + 20 >> 2] = 0; F[a + 32 >> 2] = 0; F[a + 24 >> 2] = 0; F[a + 28 >> 2] = 0; F[a + 36 >> 2] = 0; F[a + 40 >> 2] = 0; F[a + 52 >> 2] = 0; F[a + 44 >> 2] = 0; F[a + 48 >> 2] = 0; F[a + 56 >> 2] = 0; F[a + 60 >> 2] = 0; F[a + 72 >> 2] = 0; F[a + 64 >> 2] = 0; F[a + 68 >> 2] = 0; F[a + 76 >> 2] = 0; F[a + 80 >> 2] = 0; F[a + 92 >> 2] = 0; F[a + 84 >> 2] = 0; F[a + 88 >> 2] = 0; F[a + 104 >> 2] = 0; F[a + 96 >> 2] = 0; F[a + 100 >> 2] = 0; g = a + 120 | 0; a: {
                            b: {
                                if (b) {
                                    if (b >>> 0 < 1073741824) {
                                        break b;
                                    }
                                    va();
                                    V();
                                }
                                F[a + 108 >> 2] = 0;
                                F[a + 112 >> 2] = 0;
                                F[a + 116 >> 2] = 0;
                                F[c + 8 >> 2] = 0;
                                F[c >> 2] = 0;
                                F[c + 4 >> 2] = 0;
                                e = 1;
                                break a;
                            }
                            e = b << 2;
                            d = sa(e);
                            F[a + 96 >> 2] = d;
                            f = d + e | 0;
                            F[a + 104 >> 2] = f;
                            ua(d, 0, e);
                            F[a + 116 >> 2] = 0;
                            F[a + 108 >> 2] = 0;
                            F[a + 112 >> 2] = 0;
                            F[a + 100 >> 2] = f;
                            d = sa(e);
                            F[a + 108 >> 2] = d;
                            f = d + e | 0;
                            F[a + 116 >> 2] = f;
                            ua(d, 0, e);
                            F[a + 112 >> 2] = f;
                            d = sa(e);
                            F[c >> 2] = d;
                            f = d + e | 0;
                            F[c + 8 >> 2] = f;
                            ua(d, 0, e);
                            F[c + 4 >> 2] = f;
                            e = b << 5 | 1;
                        } wb(g, e, c); d = F[c >> 2]; if (d) {
                            F[c + 4 >> 2] = d;
                            ra(d);
                        } F[c + 8 >> 2] = 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; if (b) {
                            b = b << 2;
                            d = sa(b);
                            F[c >> 2] = d;
                            f = b + d | 0;
                            F[c + 8 >> 2] = f;
                            ua(d, 0, b);
                            F[c + 4 >> 2] = f;
                        } wb(a + 132 | 0, e, c); b = F[c >> 2]; if (b) {
                            F[c + 4 >> 2] = b;
                            ra(b);
                        } ea = c + 16 | 0; return a; }
                        function Tb(a, b) { var c = 0, d = 0, e = 0; c = (a | 0) == (b | 0); D[b + 12 | 0] = c; a: {
                            if (c) {
                                break a;
                            }
                            while (1) {
                                d = F[b + 8 >> 2];
                                if (G[d + 12 | 0]) {
                                    break a;
                                }
                                b: {
                                    c = F[d + 8 >> 2];
                                    e = F[c >> 2];
                                    c: {
                                        if ((d | 0) == (e | 0)) {
                                            e = F[c + 4 >> 2];
                                            if (!(!e | G[e + 12 | 0])) {
                                                break b;
                                            }
                                            d: {
                                                if (F[d >> 2] == (b | 0)) {
                                                    b = d;
                                                    break d;
                                                }
                                                b = F[d + 4 >> 2];
                                                a = F[b >> 2];
                                                F[d + 4 >> 2] = a;
                                                if (a) {
                                                    F[a + 8 >> 2] = d;
                                                    c = F[d + 8 >> 2];
                                                }
                                                F[b + 8 >> 2] = c;
                                                a = F[d + 8 >> 2];
                                                F[(((d | 0) != F[a >> 2]) << 2) + a >> 2] = b;
                                                F[b >> 2] = d;
                                                F[d + 8 >> 2] = b;
                                                c = F[b + 8 >> 2];
                                            }
                                            D[b + 12 | 0] = 1;
                                            D[c + 12 | 0] = 0;
                                            a = F[c >> 2];
                                            b = F[a + 4 >> 2];
                                            F[c >> 2] = b;
                                            if (b) {
                                                F[b + 8 >> 2] = c;
                                            }
                                            F[a + 8 >> 2] = F[c + 8 >> 2];
                                            b = F[c + 8 >> 2];
                                            F[((F[b >> 2] != (c | 0)) << 2) + b >> 2] = a;
                                            F[a + 4 >> 2] = c;
                                            b = c + 8 | 0;
                                            break c;
                                        }
                                        if (!(G[e + 12 | 0] | !e)) {
                                            break b;
                                        }
                                        e: {
                                            if (F[d >> 2] != (b | 0)) {
                                                b = d;
                                                break e;
                                            }
                                            a = F[b + 4 >> 2];
                                            F[d >> 2] = a;
                                            if (a) {
                                                F[a + 8 >> 2] = d;
                                                c = F[d + 8 >> 2];
                                            }
                                            F[b + 8 >> 2] = c;
                                            a = F[d + 8 >> 2];
                                            F[(((d | 0) != F[a >> 2]) << 2) + a >> 2] = b;
                                            F[b + 4 >> 2] = d;
                                            F[d + 8 >> 2] = b;
                                            c = F[b + 8 >> 2];
                                        }
                                        D[b + 12 | 0] = 1;
                                        D[c + 12 | 0] = 0;
                                        a = F[c + 4 >> 2];
                                        b = F[a >> 2];
                                        F[c + 4 >> 2] = b;
                                        if (b) {
                                            F[b + 8 >> 2] = c;
                                        }
                                        F[a + 8 >> 2] = F[c + 8 >> 2];
                                        b = F[c + 8 >> 2];
                                        F[((F[b >> 2] != (c | 0)) << 2) + b >> 2] = a;
                                        F[a >> 2] = c;
                                        b = c + 8 | 0;
                                    }
                                    F[b >> 2] = a;
                                    break a;
                                }
                                D[d + 12 | 0] = 1;
                                d = (a | 0) == (c | 0);
                                D[c + 12 | 0] = d;
                                D[e + 12 | 0] = 1;
                                b = c;
                                if (!d) {
                                    continue;
                                }
                                break;
                            }
                        } }
                        function sc(a, b, c, d) { var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0; k = F[b + 16 >> 2]; i = F[c + 4 >> 2] - k | 0; e = i; f = F[c >> 2] - k | 0; F[c >> 2] = f; F[c + 4 >> 2] = e; g = F[b + 16 >> 2]; e = e >> 31; h = e + i ^ e; e = f >> 31; l = (g | 0) >= (h + (e + f ^ e) | 0); a: {
                            if (l) {
                                e = i;
                                break a;
                            }
                            b: {
                                c: {
                                    if ((f | 0) >= 0) {
                                        e = 1;
                                        h = 1;
                                        if ((i | 0) >= 0) {
                                            break b;
                                        }
                                        j = 1;
                                        e = -1;
                                        h = -1;
                                        if (f) {
                                            break c;
                                        }
                                        break b;
                                    }
                                    j = -1;
                                    e = -1;
                                    h = -1;
                                    if ((i | 0) <= 0) {
                                        break b;
                                    }
                                }
                                e = (i | 0) <= 0 ? -1 : 1;
                                h = j;
                            }
                            j = L(g, h);
                            f = (f << 1) - j | 0;
                            h = (L(e, h) | 0) >= 0;
                            g = L(e, g);
                            e = ((h ? 0 - f | 0 : f) + g | 0) / 2 | 0;
                            F[c + 4 >> 2] = e;
                            m = c;
                            c = (i << 1) - g | 0;
                            f = (j + (h ? 0 - c | 0 : c) | 0) / 2 | 0;
                            F[m >> 2] = f;
                            g = F[b + 16 >> 2];
                        } c = F[d + 4 >> 2] + e | 0; f = F[d >> 2] + f | 0; d: {
                            if ((g | 0) < (f | 0)) {
                                f = f - F[b + 4 >> 2] | 0;
                                break d;
                            }
                            if ((0 - g | 0) <= (f | 0)) {
                                break d;
                            }
                            f = F[b + 4 >> 2] + f | 0;
                        } e: {
                            if ((c | 0) > (g | 0)) {
                                c = c - F[b + 4 >> 2] | 0;
                                break e;
                            }
                            if ((0 - g | 0) <= (c | 0)) {
                                break e;
                            }
                            c = F[b + 4 >> 2] + c | 0;
                        } f: {
                            if (l) {
                                g = c;
                                break f;
                            }
                            g: {
                                h: {
                                    if ((f | 0) >= 0) {
                                        b = 1;
                                        e = 1;
                                        if ((c | 0) >= 0) {
                                            break g;
                                        }
                                        d = 1;
                                        b = -1;
                                        e = -1;
                                        if (f) {
                                            break h;
                                        }
                                        break g;
                                    }
                                    d = -1;
                                    b = -1;
                                    e = -1;
                                    if ((c | 0) <= 0) {
                                        break g;
                                    }
                                }
                                b = (c | 0) <= 0 ? -1 : 1;
                                e = d;
                            }
                            i = L(e, g);
                            d = (f << 1) - i | 0;
                            F[a >> 2] = d;
                            j = 0 - d | 0;
                            h = d;
                            d = (L(b, e) | 0) >= 0;
                            b = L(b, g);
                            g = ((d ? j : h) + b | 0) / 2 | 0;
                            b = (c << 1) - b | 0;
                            f = (i + (d ? 0 - b | 0 : b) | 0) / 2 | 0;
                        } F[a >> 2] = f + k; F[a + 4 >> 2] = g + k; }
                        function za(a) { var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0, h = 0; b = ea - 32 | 0; ea = b; c = F[a + 16 >> 2]; a: {
                            if (c >>> 0 >= 341) {
                                F[a + 16 >> 2] = c - 341;
                                c = F[a + 4 >> 2];
                                F[b + 8 >> 2] = F[c >> 2];
                                F[a + 4 >> 2] = c + 4;
                                Xb(a, b + 8 | 0);
                                break a;
                            }
                            b: {
                                c: {
                                    d: {
                                        e: {
                                            e = F[a + 8 >> 2];
                                            f = e - F[a + 4 >> 2] >> 2;
                                            d = F[a + 12 >> 2];
                                            c = d - F[a >> 2] | 0;
                                            if (f >>> 0 < c >> 2 >>> 0) {
                                                if ((d | 0) == (e | 0)) {
                                                    break e;
                                                }
                                                g = b, h = sa(4092), F[g + 8 >> 2] = h;
                                                Xb(a, b + 8 | 0);
                                                break a;
                                            }
                                            F[b + 24 >> 2] = a + 12;
                                            c = c ? c >> 1 : 1;
                                            if (c >>> 0 >= 1073741824) {
                                                break d;
                                            }
                                            d = c << 2;
                                            c = sa(d);
                                            F[b + 8 >> 2] = c;
                                            e = c + (f << 2) | 0;
                                            F[b + 16 >> 2] = e;
                                            F[b + 20 >> 2] = c + d;
                                            F[b + 12 >> 2] = e;
                                            g = b, h = sa(4092), F[g + 4 >> 2] = h;
                                            Xb(b + 8 | 0, b + 4 | 0);
                                            d = F[a + 8 >> 2];
                                            if ((d | 0) == F[a + 4 >> 2]) {
                                                c = d;
                                                break b;
                                            }
                                            while (1) {
                                                d = d - 4 | 0;
                                                rd(b + 8 | 0, d);
                                                if (F[a + 4 >> 2] != (d | 0)) {
                                                    continue;
                                                }
                                                break;
                                            }
                                            break c;
                                        }
                                        g = b, h = sa(4092), F[g + 8 >> 2] = h;
                                        c = b + 8 | 0;
                                        rd(a, c);
                                        d = F[a + 4 >> 2];
                                        F[b + 8 >> 2] = F[d >> 2];
                                        F[a + 4 >> 2] = d + 4;
                                        Xb(a, c);
                                        break a;
                                    }
                                    wa(1336);
                                    V();
                                }
                                c = F[a + 8 >> 2];
                            }
                            e = F[a >> 2];
                            F[a >> 2] = F[b + 8 >> 2];
                            F[b + 8 >> 2] = e;
                            F[a + 4 >> 2] = F[b + 12 >> 2];
                            F[b + 12 >> 2] = d;
                            F[a + 8 >> 2] = F[b + 16 >> 2];
                            F[b + 16 >> 2] = c;
                            f = F[a + 12 >> 2];
                            F[a + 12 >> 2] = F[b + 20 >> 2];
                            F[b + 20 >> 2] = f;
                            if ((c | 0) != (d | 0)) {
                                F[b + 16 >> 2] = c + (((c - d | 0) - 4 >>> 2 ^ -1) << 2);
                            }
                            if (!e) {
                                break a;
                            }
                            ra(e);
                        } ea = b + 32 | 0; }
                        function Oe(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0, h = 0, i = M(0), j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0; k = ea - 16 | 0; ea = k; if (F[c + 28 >> 2] == 9) {
                            d = F[a + 4 >> 2];
                            g = D[c + 24 | 0];
                            e = g << 2;
                            f = sa((g & 1073741823) != (g | 0) ? -1 : e);
                            l = k + 8 | 0;
                            F[l >> 2] = 1065353216;
                            i = J[a + 20 >> 2];
                            d = -1 << d ^ -1;
                            if ((d | 0) > 0) {
                                J[l >> 2] = i / M(d | 0);
                            }
                            o = (d | 0) > 0;
                            a: {
                                if (!o) {
                                    break a;
                                }
                                j = F[c + 80 >> 2];
                                if (!j) {
                                    break a;
                                }
                                d = 0;
                                if ((g | 0) <= 0) {
                                    if ((j | 0) != 1) {
                                        a = j & -2;
                                        b = 0;
                                        while (1) {
                                            ta(F[F[c + 64 >> 2] >> 2] + d | 0, f, e);
                                            d = d + e | 0;
                                            ta(d + F[F[c + 64 >> 2] >> 2] | 0, f, e);
                                            d = d + e | 0;
                                            b = b + 2 | 0;
                                            if ((a | 0) != (b | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    if (!(j & 1)) {
                                        break a;
                                    }
                                    ta(F[F[c + 64 >> 2] >> 2] + d | 0, f, e);
                                    break a;
                                }
                                p = F[F[b >> 2] >> 2] + F[b + 48 >> 2] | 0;
                                t = g & -2;
                                u = g & 1;
                                while (1) {
                                    m = F[a + 8 >> 2];
                                    i = J[l >> 2];
                                    b = 0;
                                    n = 0;
                                    if ((g | 0) != 1) {
                                        while (1) {
                                            h = b << 2;
                                            q = (d << 2) + p | 0;
                                            J[h + f >> 2] = M(i * M(F[q >> 2])) + J[h + m >> 2];
                                            h = h | 4;
                                            J[h + f >> 2] = M(i * M(F[q + 4 >> 2])) + J[h + m >> 2];
                                            b = b + 2 | 0;
                                            d = d + 2 | 0;
                                            n = n + 2 | 0;
                                            if ((t | 0) != (n | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    if (u) {
                                        b = b << 2;
                                        J[b + f >> 2] = M(i * M(F[(d << 2) + p >> 2])) + J[b + m >> 2];
                                        d = d + 1 | 0;
                                    }
                                    ta(F[F[c + 64 >> 2] >> 2] + r | 0, f, e);
                                    r = e + r | 0;
                                    s = s + 1 | 0;
                                    if ((s | 0) != (j | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            ra(f);
                        } ea = k + 16 | 0; return o | 0; }
                        function nf(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0; if (ge(a, b)) {
                            i = a + 36 | 0;
                            g = ga[F[F[a >> 2] + 24 >> 2]](a) | 0;
                            d = F[a + 40 >> 2];
                            e = F[a + 36 >> 2];
                            c = d - e >> 2;
                            a: {
                                if (g >>> 0 > c >>> 0) {
                                    Wb(i, g - c | 0);
                                    break a;
                                }
                                if (c >>> 0 <= g >>> 0) {
                                    break a;
                                }
                                e = e + (g << 2) | 0;
                                if ((e | 0) != (d | 0)) {
                                    while (1) {
                                        d = d - 4 | 0;
                                        c = F[d >> 2];
                                        F[d >> 2] = 0;
                                        if (c) {
                                            ga[F[F[c >> 2] + 4 >> 2]](c);
                                        }
                                        if ((d | 0) != (e | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                F[a + 40 >> 2] = e;
                            }
                            b: {
                                if ((g | 0) <= 0) {
                                    e = 0;
                                    break b;
                                }
                                e = 1;
                                c = F[b + 20 >> 2];
                                d = F[b + 12 >> 2];
                                f = F[b + 16 >> 2];
                                if ((c | 0) >= (d | 0) & f >>> 0 >= I[b + 8 >> 2] | (c | 0) > (d | 0)) {
                                    break b;
                                }
                                d = 0;
                                while (1) {
                                    h = G[f + F[b >> 2] | 0];
                                    f = f + 1 | 0;
                                    c = f ? c : c + 1 | 0;
                                    F[b + 16 >> 2] = f;
                                    F[b + 20 >> 2] = c;
                                    f = ga[F[F[a >> 2] + 48 >> 2]](a, h) | 0;
                                    h = d << 2;
                                    j = h + F[a + 36 >> 2] | 0;
                                    c = F[j >> 2];
                                    F[j >> 2] = f;
                                    if (c) {
                                        ga[F[F[c >> 2] + 4 >> 2]](c);
                                    }
                                    c = F[F[i >> 2] + h >> 2];
                                    if (!c) {
                                        break b;
                                    }
                                    if (!(l = c, m = ga[F[F[a >> 2] + 28 >> 2]](a) | 0, n = ga[F[F[a >> 2] + 20 >> 2]](a, d) | 0, k = F[F[c >> 2] + 8 >> 2], ga[k](l | 0, m | 0, n | 0) | 0)) {
                                        break b;
                                    }
                                    d = d + 1 | 0;
                                    e = (g | 0) > (d | 0);
                                    if ((d | 0) == (g | 0)) {
                                        break b;
                                    }
                                    f = F[b + 16 >> 2];
                                    c = F[b + 20 >> 2];
                                    h = F[b + 12 >> 2];
                                    if (f >>> 0 < I[b + 8 >> 2] & (c | 0) <= (h | 0) | (c | 0) < (h | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            a = !e;
                        }
                        else {
                            a = 0;
                        } return a | 0; }
                        function ij(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0; c = F[b + 88 >> 2]; if (!(!c | F[c >> 2] != 1)) {
                            d = F[c + 8 >> 2];
                            F[a + 4 >> 2] = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                            d = D[b + 24 | 0];
                            e = F[a + 8 >> 2];
                            f = F[a + 12 >> 2] - e >> 2;
                            a: {
                                if (d >>> 0 > f >>> 0) {
                                    Aa(a + 8 | 0, d - f | 0);
                                    d = D[b + 24 | 0];
                                    e = F[a + 8 >> 2];
                                    break a;
                                }
                                if (d >>> 0 >= f >>> 0) {
                                    break a;
                                }
                                F[a + 12 >> 2] = (d << 2) + e;
                            }
                            k = 1;
                            f = F[c + 8 >> 2];
                            b: {
                                if ((d | 0) <= 0) {
                                    b = 4;
                                    break b;
                                }
                                h = d & 3;
                                c: {
                                    if (d - 1 >>> 0 < 3) {
                                        b = 4;
                                        d = 0;
                                        break c;
                                    }
                                    l = d & -4;
                                    d = 0;
                                    b = 4;
                                    while (1) {
                                        g = d << 2;
                                        c = b + f | 0;
                                        F[g + e >> 2] = G[c | 0] | G[c + 1 | 0] << 8 | (G[c + 2 | 0] << 16 | G[c + 3 | 0] << 24);
                                        F[(g | 4) + e >> 2] = G[c + 4 | 0] | G[c + 5 | 0] << 8 | (G[c + 6 | 0] << 16 | G[c + 7 | 0] << 24);
                                        F[(g | 8) + e >> 2] = G[c + 8 | 0] | G[c + 9 | 0] << 8 | (G[c + 10 | 0] << 16 | G[c + 11 | 0] << 24);
                                        F[(g | 12) + e >> 2] = G[c + 12 | 0] | G[c + 13 | 0] << 8 | (G[c + 14 | 0] << 16 | G[c + 15 | 0] << 24);
                                        d = d + 4 | 0;
                                        b = b + 16 | 0;
                                        i = i + 4 | 0;
                                        if ((l | 0) != (i | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                if (!h) {
                                    break b;
                                }
                                while (1) {
                                    c = b + f | 0;
                                    F[(d << 2) + e >> 2] = G[c | 0] | G[c + 1 | 0] << 8 | (G[c + 2 | 0] << 16 | G[c + 3 | 0] << 24);
                                    d = d + 1 | 0;
                                    b = b + 4 | 0;
                                    j = j + 1 | 0;
                                    if ((j | 0) != (h | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            c = a;
                            a = b + f | 0;
                            F[c + 20 >> 2] = G[a | 0] | G[a + 1 | 0] << 8 | (G[a + 2 | 0] << 16 | G[a + 3 | 0] << 24);
                        } return k | 0; }
                        function Xa(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0; d = (c >>> 0) / 3 | 0; i = F[(F[F[a + 8 >> 2] + 96 >> 2] + L(d, 12) | 0) + (c - L(d, 3) << 2) >> 2]; e = F[F[a + 12 >> 2] + 4 >> 2]; d = F[e + 4 >> 2]; a: {
                            if ((d | 0) != F[e + 8 >> 2]) {
                                F[d >> 2] = i;
                                F[e + 4 >> 2] = d + 4;
                                break a;
                            }
                            b: {
                                h = F[e >> 2];
                                g = d - h | 0;
                                j = g >> 2;
                                d = j + 1 | 0;
                                if (d >>> 0 < 1073741824) {
                                    f = g >> 1;
                                    f = g >>> 0 < 2147483644 ? d >>> 0 > f >>> 0 ? d : f : 1073741823;
                                    if (f) {
                                        if (f >>> 0 >= 1073741824) {
                                            break b;
                                        }
                                        d = sa(f << 2);
                                    }
                                    else {
                                        d = 0;
                                    }
                                    j = d + (j << 2) | 0;
                                    F[j >> 2] = i;
                                    if ((g | 0) > 0) {
                                        ta(d, h, g);
                                    }
                                    F[e + 8 >> 2] = d + (f << 2);
                                    F[e + 4 >> 2] = j + 4;
                                    F[e >> 2] = d;
                                    if (h) {
                                        ra(h);
                                    }
                                    break a;
                                }
                                va();
                                V();
                            }
                            wa(1336);
                            V();
                        } e = F[a + 4 >> 2]; d = F[e + 4 >> 2]; c: {
                            d: {
                                e: {
                                    if ((d | 0) != F[e + 8 >> 2]) {
                                        F[d >> 2] = c;
                                        F[e + 4 >> 2] = d + 4;
                                        break e;
                                    }
                                    h = F[e >> 2];
                                    g = d - h | 0;
                                    i = g >> 2;
                                    d = i + 1 | 0;
                                    if (d >>> 0 >= 1073741824) {
                                        break d;
                                    }
                                    f = g >> 1;
                                    f = g >>> 0 < 2147483644 ? d >>> 0 > f >>> 0 ? d : f : 1073741823;
                                    if (f) {
                                        if (f >>> 0 >= 1073741824) {
                                            break c;
                                        }
                                        d = sa(f << 2);
                                    }
                                    else {
                                        d = 0;
                                    }
                                    i = d + (i << 2) | 0;
                                    F[i >> 2] = c;
                                    if ((g | 0) > 0) {
                                        ta(d, h, g);
                                    }
                                    F[e + 8 >> 2] = d + (f << 2);
                                    F[e + 4 >> 2] = i + 4;
                                    F[e >> 2] = d;
                                    if (!h) {
                                        break e;
                                    }
                                    ra(h);
                                }
                                a = F[a + 4 >> 2];
                                F[F[a + 12 >> 2] + (b << 2) >> 2] = F[a + 24 >> 2];
                                F[a + 24 >> 2] = F[a + 24 >> 2] + 1;
                                return;
                            }
                            va();
                            V();
                        } wa(1336); V(); }
                        function Ah(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0; h = F[d + 80 >> 2]; e = ea - 48 | 0; ea = e; a = F[a + 4 >> 2]; a: {
                            if (a - 31 >>> 0 < 4294967267) {
                                break a;
                            }
                            i = F[F[d >> 2] >> 2] + F[d + 48 >> 2] | 0;
                            F[e + 16 >> 2] = a;
                            a = -1 << a;
                            F[e + 20 >> 2] = a ^ -1;
                            a = -2 - a | 0;
                            F[e + 24 >> 2] = a;
                            F[e + 32 >> 2] = (a | 0) / 2;
                            J[e + 28 >> 2] = M(2) / M(a | 0);
                            g = F[c >> 2];
                            if ((g | 0) != F[c + 4 >> 2]) {
                                a = 0;
                                d = 0;
                                while (1) {
                                    f = F[(d << 2) + g >> 2];
                                    h = e + 36 | 0;
                                    j = F[F[b >> 2] >> 2];
                                    l = F[b + 48 >> 2];
                                    g = F[b + 44 >> 2];
                                    k = F[b + 40 >> 2];
                                    if (!G[b + 84 | 0]) {
                                        f = F[F[b + 68 >> 2] + (f << 2) >> 2];
                                    }
                                    f = Hj(k, g, f, 0) + l | 0;
                                    ta(h, f + j | 0, k);
                                    ee(e + 16 | 0, h, e + 12 | 0, e + 8 | 0);
                                    g = a << 2;
                                    F[g + i >> 2] = F[e + 12 >> 2];
                                    F[(g | 4) + i >> 2] = F[e + 8 >> 2];
                                    f = 1;
                                    a = a + 2 | 0;
                                    d = d + 1 | 0;
                                    g = F[c >> 2];
                                    if (d >>> 0 < F[c + 4 >> 2] - g >> 2 >>> 0) {
                                        continue;
                                    }
                                    break;
                                }
                                break a;
                            }
                            if (!h) {
                                f = 1;
                                break a;
                            }
                            d = 0;
                            a = 0;
                            while (1) {
                                j = e + 36 | 0;
                                c = F[F[b >> 2] >> 2];
                                f = F[b + 40 >> 2];
                                g = F[b + 48 >> 2] + Hj(f, F[b + 44 >> 2], G[b + 84 | 0] ? a : F[F[b + 68 >> 2] + (a << 2) >> 2], 0) | 0;
                                ta(j, c + g | 0, f);
                                ee(e + 16 | 0, j, e + 12 | 0, e + 8 | 0);
                                c = d << 2;
                                F[c + i >> 2] = F[e + 12 >> 2];
                                F[(c | 4) + i >> 2] = F[e + 8 >> 2];
                                d = d + 2 | 0;
                                f = 1;
                                a = a + 1 | 0;
                                if ((h | 0) != (a | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } ea = e + 48 | 0; return f | 0; }
                        function Cc(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0; d = G[a + 11 | 0] >>> 7 | 0 ? F[a + 4 >> 2] : G[a + 11 | 0]; if (d >>> 0 < b >>> 0) {
                            h = ea - 16 | 0;
                            ea = h;
                            f = b - d | 0;
                            if (f) {
                                b = G[a + 11 | 0] >>> 7 | 0;
                                g = b ? F[a + 4 >> 2] : G[a + 11 | 0];
                                i = g + f | 0;
                                b = b ? (F[a + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                if (b - g >>> 0 < f >>> 0) {
                                    a: {
                                        d = ea - 16 | 0;
                                        ea = d;
                                        c = i - b | 0;
                                        if (c >>> 0 <= -17 - b >>> 0) {
                                            j = G[a + 11 | 0] >>> 7 | 0 ? F[a >> 2] : a;
                                            b: {
                                                if (b >>> 0 < 2147483623) {
                                                    F[d + 8 >> 2] = b << 1;
                                                    F[d + 12 >> 2] = b + c;
                                                    c = ea - 16 | 0;
                                                    ea = c;
                                                    ea = c + 16 | 0;
                                                    c = d + 8 | 0;
                                                    e = d + 12 | 0;
                                                    c = F[(I[e >> 2] < I[c >> 2] ? c : e) >> 2];
                                                    if (c >>> 0 >= 11) {
                                                        e = c + 16 & -16;
                                                        c = e - 1 | 0;
                                                        c = (c | 0) == 11 ? e : c;
                                                    }
                                                    else {
                                                        c = 10;
                                                    }
                                                    break b;
                                                }
                                                c = -18;
                                            }
                                            e = c + 1 | 0;
                                            c = sa(e);
                                            if (g) {
                                                kb(c, j, g);
                                            }
                                            if ((b | 0) != 10) {
                                                ra(j);
                                            }
                                            F[a >> 2] = c;
                                            F[a + 8 >> 2] = e | -2147483648;
                                            ea = d + 16 | 0;
                                            break a;
                                        }
                                        Ma();
                                        V();
                                    }
                                }
                                b = G[a + 11 | 0] >>> 7 | 0 ? F[a >> 2] : a;
                                d = g + b | 0;
                                if (f) {
                                    ua(d, 0, f);
                                }
                                c: {
                                    if (G[a + 11 | 0] >>> 7 | 0) {
                                        F[a + 4 >> 2] = i;
                                        break c;
                                    }
                                    D[a + 11 | 0] = i;
                                }
                                D[h + 15 | 0] = 0;
                                D[b + i | 0] = G[h + 15 | 0];
                            }
                            ea = h + 16 | 0;
                            return;
                        } d = ea - 16 | 0; ea = d; d: {
                            if (G[a + 11 | 0] >>> 7 | 0) {
                                f = F[a >> 2];
                                D[d + 15 | 0] = 0;
                                D[b + f | 0] = G[d + 15 | 0];
                                F[a + 4 >> 2] = b;
                                break d;
                            }
                            D[d + 14 | 0] = 0;
                            D[a + b | 0] = G[d + 14 | 0];
                            D[a + 11 | 0] = b;
                        } ea = d + 16 | 0; }
                        function Re(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0; f = F[b + 12 >> 2]; c = f; d = F[b + 20 >> 2]; g = d; i = F[b + 16 >> 2]; e = i + 4 | 0; d = e >>> 0 < 4 ? d + 1 | 0 : d; j = F[b + 8 >> 2]; a: {
                            if (j >>> 0 < e >>> 0 & (c | 0) <= (d | 0) | (c | 0) < (d | 0)) {
                                break a;
                            }
                            k = F[b >> 2];
                            c = i + k | 0;
                            c = G[c | 0] | G[c + 1 | 0] << 8 | (G[c + 2 | 0] << 16 | G[c + 3 | 0] << 24);
                            F[b + 16 >> 2] = e;
                            F[b + 20 >> 2] = d;
                            d = g;
                            h = i + 8 | 0;
                            d = h >>> 0 < 8 ? d + 1 | 0 : d;
                            if (h >>> 0 > j >>> 0 & (d | 0) >= (f | 0) | (d | 0) > (f | 0)) {
                                break a;
                            }
                            e = e + k | 0;
                            e = G[e | 0] | G[e + 1 | 0] << 8 | (G[e + 2 | 0] << 16 | G[e + 3 | 0] << 24);
                            F[b + 16 >> 2] = h;
                            F[b + 20 >> 2] = d;
                            if ((c | 0) > (e | 0)) {
                                break a;
                            }
                            F[a + 16 >> 2] = e;
                            F[a + 12 >> 2] = c;
                            m = (e >> 31) - ((c >> 31) + (c >>> 0 > e >>> 0) | 0) | 0;
                            c = e - c | 0;
                            if (!m & c >>> 0 > 2147483646 | m) {
                                break a;
                            }
                            c = c + 1 | 0;
                            F[a + 20 >> 2] = c;
                            e = c >>> 1 | 0;
                            F[a + 24 >> 2] = e;
                            F[a + 28 >> 2] = 0 - e;
                            if (!(c & 1)) {
                                F[a + 24 >> 2] = e - 1;
                            }
                            if (H[b + 38 >> 1] <= 513) {
                                if ((d | 0) >= (f | 0) & h >>> 0 >= j >>> 0 | (d | 0) > (f | 0)) {
                                    break a;
                                }
                                c = G[h + k | 0];
                                d = g;
                                g = i + 9 | 0;
                                d = g >>> 0 < 9 ? d + 1 | 0 : d;
                                F[b + 16 >> 2] = g;
                                F[b + 20 >> 2] = d;
                                b: {
                                    switch (c | 0) {
                                        case 1:
                                            l = 1;
                                            break;
                                        case 0: break b;
                                        default: break a;
                                    }
                                }
                                F[a + 88 >> 2] = l;
                            }
                            l = xa(a + 112 | 0, b);
                        } return l | 0; }
                        function Ob(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0; d = ea - 16 | 0; ea = d; a: {
                            e = F[a + 4 >> 2];
                            b: {
                                if (e >>> 0 < b >>> 0) {
                                    f = b - e | 0;
                                    h = F[a + 8 >> 2];
                                    c = h << 5;
                                    c: {
                                        if (!(f >>> 0 > c >>> 0 | e >>> 0 > c - f >>> 0)) {
                                            F[a + 4 >> 2] = b;
                                            g = e & 31;
                                            b = F[a >> 2] + (e >>> 3 & 536870908) | 0;
                                            break c;
                                        }
                                        F[d + 8 >> 2] = 0;
                                        F[d >> 2] = 0;
                                        F[d + 4 >> 2] = 0;
                                        if ((b | 0) < 0) {
                                            break a;
                                        }
                                        if (c >>> 0 <= 1073741822) {
                                            c = b + 31 & -32;
                                            b = h << 6;
                                            b = b >>> 0 < c >>> 0 ? c : b;
                                        }
                                        else {
                                            b = 2147483647;
                                        }
                                        db(d, b);
                                        e = F[a + 4 >> 2];
                                        F[d + 4 >> 2] = e + f;
                                        i = F[a >> 2];
                                        b = F[d >> 2];
                                        d: {
                                            if ((e | 0) <= 0) {
                                                break d;
                                            }
                                            c = e >>> 5 | 0;
                                            h = c << 2;
                                            b = Wa(b, i, h) + h | 0;
                                            g = e - (c << 5) | 0;
                                            e: {
                                                if ((g | 0) <= 0) {
                                                    g = 0;
                                                    break e;
                                                }
                                                c = -1 >>> 32 - g | 0;
                                                F[b >> 2] = F[b >> 2] & (c ^ -1) | c & F[i + h >> 2];
                                            }
                                            i = F[a >> 2];
                                        }
                                        F[a >> 2] = F[d >> 2];
                                        F[d >> 2] = i;
                                        c = F[a + 4 >> 2];
                                        F[a + 4 >> 2] = F[d + 4 >> 2];
                                        F[d + 4 >> 2] = c;
                                        c = F[a + 8 >> 2];
                                        F[a + 8 >> 2] = F[d + 8 >> 2];
                                        F[d + 8 >> 2] = c;
                                        if (!i) {
                                            break c;
                                        }
                                        ra(i);
                                    }
                                    if (!f) {
                                        break b;
                                    }
                                    if (g) {
                                        c = 32 - g | 0;
                                        a = c >>> 0 > f >>> 0 ? f : c;
                                        F[b >> 2] = F[b >> 2] & (-1 << g & -1 >>> c - a ^ -1);
                                        f = f - a | 0;
                                        b = b + 4 | 0;
                                    }
                                    c = f >>> 5 << 2;
                                    a = ua(b, 0, c);
                                    b = f & 31;
                                    if (!b) {
                                        break b;
                                    }
                                    a = a + c | 0;
                                    F[a >> 2] = F[a >> 2] & (-1 >>> 32 - b ^ -1);
                                    break b;
                                }
                                F[a + 4 >> 2] = b;
                            }
                            ea = d + 16 | 0;
                            return;
                        } Oa(); V(); }
                        function Rh(a) { a = a | 0; var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0, h = 0; g = ea - 16 | 0; ea = g; b = F[a + 4 >> 2]; d = F[b >> 2]; a: {
                            c = F[a + 12 >> 2];
                            c = F[c + 28 >> 2] - F[c + 24 >> 2] | 0;
                            e = c >> 2;
                            b: {
                                if (e >>> 0 <= F[b + 8 >> 2] - d >> 2 >>> 0) {
                                    break b;
                                }
                                if ((c | 0) < 0) {
                                    break a;
                                }
                                f = F[b + 4 >> 2];
                                c = sa(c);
                                h = c + (e << 2) | 0;
                                e = f - d | 0;
                                f = e + c | 0;
                                if ((e | 0) > 0) {
                                    ta(c, d, e);
                                }
                                F[b + 8 >> 2] = h;
                                F[b + 4 >> 2] = f;
                                F[b >> 2] = c;
                                if (!d) {
                                    break b;
                                }
                                ra(d);
                            }
                            b = F[a + 12 >> 2];
                            d = F[b + 28 >> 2];
                            b = F[b + 24 >> 2];
                            F[g + 12 >> 2] = 0;
                            b = d - b >> 2;
                            c = a + 96 | 0;
                            e = F[c >> 2];
                            d = F[a + 100 >> 2] - e >> 2;
                            c: {
                                if (b >>> 0 > d >>> 0) {
                                    Ia(c, b - d | 0, g + 12 | 0);
                                    break c;
                                }
                                if (b >>> 0 >= d >>> 0) {
                                    break c;
                                }
                                F[a + 100 >> 2] = e + (b << 2);
                            }
                            e = a + 8 | 0;
                            b = F[a + 116 >> 2];
                            d: {
                                if (b) {
                                    c = F[b >> 2];
                                    if ((c | 0) == F[b + 4 >> 2]) {
                                        d = 1;
                                        break d;
                                    }
                                    b = 0;
                                    while (1) {
                                        d = ve(e, F[(b << 2) + c >> 2]);
                                        if (!d) {
                                            break d;
                                        }
                                        f = F[a + 116 >> 2];
                                        c = F[f >> 2];
                                        b = b + 1 | 0;
                                        if (b >>> 0 < F[f + 4 >> 2] - c >> 2 >>> 0) {
                                            continue;
                                        }
                                        break;
                                    }
                                    break d;
                                }
                                d = 1;
                                a = F[a + 12 >> 2];
                                a = F[a + 4 >> 2] - F[a >> 2] | 0;
                                if (a >>> 0 < 12) {
                                    break d;
                                }
                                a = (a >> 2 >>> 0) / 3 | 0;
                                b = 0;
                                while (1) {
                                    d = ve(e, L(b, 3));
                                    if (!d) {
                                        break d;
                                    }
                                    b = b + 1 | 0;
                                    if ((a | 0) != (b | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            ea = g + 16 | 0;
                            return d | 0;
                        } wa(1336); V(); }
                        function Sh(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0; l = F[a + 12 >> 2]; c = F[a + 108 >> 2]; e = F[c + 80 >> 2]; D[b + 84 | 0] = 0; f = F[b + 68 >> 2]; d = F[b + 72 >> 2] - f >> 2; a: {
                            if (d >>> 0 < e >>> 0) {
                                Ia(b + 68 | 0, e - d | 0, 12404);
                                c = F[a + 108 >> 2];
                                e = F[c + 80 >> 2];
                                break a;
                            }
                            if (e >>> 0 >= d >>> 0) {
                                break a;
                            }
                            F[b + 72 >> 2] = f + (e << 2);
                        } k = F[c + 96 >> 2]; c = F[c + 100 >> 2] - k | 0; if (!c) {
                            return 1;
                        } c = (c | 0) / 12 | 0; m = c >>> 0 > 1 ? c : 1; c = 0; b: {
                            while (1) {
                                if ((c | 0) == 1431655765) {
                                    break b;
                                }
                                d = F[l >> 2] + (L(c, 3) << 2) | 0;
                                h = F[d >> 2];
                                if ((h | 0) == -1) {
                                    break b;
                                }
                                f = L(c, 12) + k | 0;
                                g = F[f >> 2];
                                if (g >>> 0 >= e >>> 0) {
                                    break b;
                                }
                                j = F[F[a + 112 >> 2] + 12 >> 2];
                                i = F[j + (h << 2) >> 2];
                                if (i >>> 0 >= e >>> 0) {
                                    break b;
                                }
                                h = F[b + 68 >> 2];
                                F[h + (g << 2) >> 2] = i;
                                g = F[d + 4 >> 2];
                                if ((g | 0) == -1) {
                                    break b;
                                }
                                i = F[f + 4 >> 2];
                                if (i >>> 0 >= e >>> 0) {
                                    break b;
                                }
                                g = F[(g << 2) + j >> 2];
                                if (g >>> 0 >= e >>> 0) {
                                    break b;
                                }
                                F[h + (i << 2) >> 2] = g;
                                d = F[d + 8 >> 2];
                                if ((d | 0) == -1) {
                                    break b;
                                }
                                f = F[f + 8 >> 2];
                                if (f >>> 0 >= e >>> 0) {
                                    break b;
                                }
                                d = F[(d << 2) + j >> 2];
                                if (d >>> 0 >= e >>> 0) {
                                    break b;
                                }
                                F[h + (f << 2) >> 2] = d;
                                c = c + 1 | 0;
                                if ((m | 0) != (c | 0)) {
                                    continue;
                                }
                                break;
                            }
                            return 1;
                        } return 0; }
                        function Kh(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0; l = F[a + 12 >> 2]; c = F[a + 68 >> 2]; e = F[c + 80 >> 2]; D[b + 84 | 0] = 0; f = F[b + 68 >> 2]; d = F[b + 72 >> 2] - f >> 2; a: {
                            if (d >>> 0 < e >>> 0) {
                                Ia(b + 68 | 0, e - d | 0, 12404);
                                c = F[a + 68 >> 2];
                                e = F[c + 80 >> 2];
                                break a;
                            }
                            if (e >>> 0 >= d >>> 0) {
                                break a;
                            }
                            F[b + 72 >> 2] = f + (e << 2);
                        } k = F[c + 96 >> 2]; c = F[c + 100 >> 2] - k | 0; if (!c) {
                            return 1;
                        } c = (c | 0) / 12 | 0; m = c >>> 0 > 1 ? c : 1; c = 0; b: {
                            while (1) {
                                if ((c | 0) == 1431655765) {
                                    break b;
                                }
                                d = F[l >> 2] + (L(c, 3) << 2) | 0;
                                h = F[d >> 2];
                                if ((h | 0) == -1) {
                                    break b;
                                }
                                f = L(c, 12) + k | 0;
                                g = F[f >> 2];
                                if (g >>> 0 >= e >>> 0) {
                                    break b;
                                }
                                j = F[F[a + 72 >> 2] + 12 >> 2];
                                i = F[j + (h << 2) >> 2];
                                if (i >>> 0 >= e >>> 0) {
                                    break b;
                                }
                                h = F[b + 68 >> 2];
                                F[h + (g << 2) >> 2] = i;
                                g = F[d + 4 >> 2];
                                if ((g | 0) == -1) {
                                    break b;
                                }
                                i = F[f + 4 >> 2];
                                if (i >>> 0 >= e >>> 0) {
                                    break b;
                                }
                                g = F[(g << 2) + j >> 2];
                                if (g >>> 0 >= e >>> 0) {
                                    break b;
                                }
                                F[h + (i << 2) >> 2] = g;
                                d = F[d + 8 >> 2];
                                if ((d | 0) == -1) {
                                    break b;
                                }
                                f = F[f + 8 >> 2];
                                if (f >>> 0 >= e >>> 0) {
                                    break b;
                                }
                                d = F[(d << 2) + j >> 2];
                                if (d >>> 0 >= e >>> 0) {
                                    break b;
                                }
                                F[h + (f << 2) >> 2] = d;
                                c = c + 1 | 0;
                                if ((m | 0) != (c | 0)) {
                                    continue;
                                }
                                break;
                            }
                            return 1;
                        } return 0; }
                        function Fe(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0; f = F[a + 12 >> 2]; h = F[a + 8 >> 2]; d = f - h >> 2; b = D[b + 24 | 0]; a: {
                            if (d >>> 0 < b >>> 0) {
                                Aa(a + 8 | 0, b - d | 0);
                                h = F[a + 8 >> 2];
                                f = F[a + 12 >> 2];
                                break a;
                            }
                            if (b >>> 0 >= d >>> 0) {
                                break a;
                            }
                            f = (b << 2) + h | 0;
                            F[a + 12 >> 2] = f;
                        } b = 0; i = F[c + 20 >> 2]; e = F[c + 16 >> 2]; d = f - h | 0; f = d; g = e + d | 0; j = F[c + 12 >> 2]; i = d >>> 0 > g >>> 0 ? i + 1 | 0 : i; b: {
                            if (g >>> 0 > I[c + 8 >> 2] & (j | 0) <= (i | 0) | (i | 0) > (j | 0)) {
                                break b;
                            }
                            ta(h, e + F[c >> 2] | 0, d);
                            d = F[c + 20 >> 2];
                            e = f + F[c + 16 >> 2] | 0;
                            d = e >>> 0 < f >>> 0 ? d + 1 | 0 : d;
                            g = e;
                            F[c + 16 >> 2] = e;
                            F[c + 20 >> 2] = d;
                            e = F[c + 12 >> 2];
                            f = g + 4 | 0;
                            d = f >>> 0 < 4 ? d + 1 | 0 : d;
                            if (f >>> 0 > I[c + 8 >> 2] & (d | 0) >= (e | 0) | (d | 0) > (e | 0)) {
                                break b;
                            }
                            d = g + F[c >> 2] | 0;
                            F[a + 20 >> 2] = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                            d = F[c + 20 >> 2];
                            g = F[c + 16 >> 2];
                            e = g + 4 | 0;
                            f = e >>> 0 < 4 ? d + 1 | 0 : d;
                            j = e;
                            F[c + 16 >> 2] = e;
                            F[c + 20 >> 2] = f;
                            e = F[c + 12 >> 2];
                            if ((f | 0) >= (e | 0) & j >>> 0 >= I[c + 8 >> 2] | (f | 0) > (e | 0)) {
                                break b;
                            }
                            e = G[j + F[c >> 2] | 0];
                            f = g + 5 | 0;
                            d = f >>> 0 < 5 ? d + 1 | 0 : d;
                            F[c + 16 >> 2] = f;
                            F[c + 20 >> 2] = d;
                            if (e - 1 >>> 0 > 29) {
                                break b;
                            }
                            F[a + 4 >> 2] = e;
                            b = 1;
                        } return b | 0; }
                        function vb(a, b) { var c = 0; a: {
                            if (!xa(a, b)) {
                                break a;
                            }
                            if (!xa(a + 16 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 32 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 48 | 0, b)) {
                                break a;
                            }
                            if (!xa(a - -64 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 80 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 96 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 112 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 128 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 144 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 160 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 176 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 192 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 208 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 224 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 240 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 256 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 272 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 288 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 304 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 320 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 336 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 352 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 368 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 384 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 400 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 416 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 432 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 448 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 464 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 480 | 0, b)) {
                                break a;
                            }
                            if (!xa(a + 496 | 0, b)) {
                                break a;
                            }
                            c = xa(a + 512 | 0, b);
                        } return c; }
                        function Xb(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0; a: {
                            e = F[a + 8 >> 2];
                            b: {
                                if ((e | 0) != F[a + 12 >> 2]) {
                                    break b;
                                }
                                d = F[a + 4 >> 2];
                                g = F[a >> 2];
                                if (d >>> 0 > g >>> 0) {
                                    g = ((d - g >> 2) + 1 | 0) / -2 << 2;
                                    c = g + d | 0;
                                    f = e - d | 0;
                                    if (f) {
                                        Wa(c, d, f);
                                        d = F[a + 4 >> 2];
                                    }
                                    e = c + f | 0;
                                    F[a + 8 >> 2] = e;
                                    F[a + 4 >> 2] = d + g;
                                    break b;
                                }
                                c = e - g | 0;
                                f = c ? c >> 1 : 1;
                                if (f >>> 0 >= 1073741824) {
                                    break a;
                                }
                                c = f << 2;
                                h = sa(c);
                                k = h + c | 0;
                                c = e - d | 0;
                                f = (f & -4) + h | 0;
                                e = f;
                                c: {
                                    if (!c) {
                                        break c;
                                    }
                                    l = c & -4;
                                    i = c - 4 | 0;
                                    j = (i >>> 2 | 0) + 1 & 7;
                                    d: {
                                        if (!j) {
                                            c = f;
                                            break d;
                                        }
                                        e = 0;
                                        c = f;
                                        while (1) {
                                            F[c >> 2] = F[d >> 2];
                                            d = d + 4 | 0;
                                            c = c + 4 | 0;
                                            e = e + 1 | 0;
                                            if ((j | 0) != (e | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    e = f + l | 0;
                                    if (i >>> 0 < 28) {
                                        break c;
                                    }
                                    while (1) {
                                        F[c >> 2] = F[d >> 2];
                                        F[c + 4 >> 2] = F[d + 4 >> 2];
                                        F[c + 8 >> 2] = F[d + 8 >> 2];
                                        F[c + 12 >> 2] = F[d + 12 >> 2];
                                        F[c + 16 >> 2] = F[d + 16 >> 2];
                                        F[c + 20 >> 2] = F[d + 20 >> 2];
                                        F[c + 24 >> 2] = F[d + 24 >> 2];
                                        F[c + 28 >> 2] = F[d + 28 >> 2];
                                        d = d + 32 | 0;
                                        c = c + 32 | 0;
                                        if ((e | 0) != (c | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                F[a + 12 >> 2] = k;
                                F[a + 8 >> 2] = e;
                                F[a + 4 >> 2] = f;
                                F[a >> 2] = h;
                                if (!g) {
                                    break b;
                                }
                                ra(g);
                                e = F[a + 8 >> 2];
                            }
                            F[e >> 2] = F[b >> 2];
                            F[a + 8 >> 2] = F[a + 8 >> 2] + 4;
                            return;
                        } wa(1336); V(); }
                        function Ic(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0; g = ea - 16 | 0; ea = g; a: {
                            b: {
                                if (b) {
                                    F[a + 88 >> 2] = 0;
                                    F[a + 92 >> 2] = 0;
                                    c = F[a + 84 >> 2];
                                    F[a + 84 >> 2] = 0;
                                    if (c) {
                                        ra(c);
                                    }
                                    F[a + 76 >> 2] = 0;
                                    F[a + 80 >> 2] = 0;
                                    c = F[a + 72 >> 2];
                                    F[a + 72 >> 2] = 0;
                                    if (c) {
                                        ra(c);
                                    }
                                    c = F[b >> 2];
                                    d = F[b + 4 >> 2];
                                    D[g + 15 | 0] = 0;
                                    Na(a, d - c >> 2, g + 15 | 0);
                                    c = F[b + 28 >> 2];
                                    d = F[b + 24 >> 2];
                                    D[g + 14 | 0] = 0;
                                    Na(a + 12 | 0, c - d >> 2, g + 14 | 0);
                                    Jc(a + 28 | 0, F[b + 4 >> 2] - F[b >> 2] >> 2, 13740);
                                    d = F[b + 28 >> 2] - F[b + 24 >> 2] | 0;
                                    e = d >> 2;
                                    c = F[a + 52 >> 2];
                                    c: {
                                        if (e >>> 0 <= F[a + 60 >> 2] - c >> 2 >>> 0) {
                                            break c;
                                        }
                                        if ((d | 0) < 0) {
                                            break b;
                                        }
                                        f = F[a + 56 >> 2];
                                        d = sa(d);
                                        h = d + (e << 2) | 0;
                                        e = f - c | 0;
                                        f = e + d | 0;
                                        if ((e | 0) > 0) {
                                            ta(d, c, e);
                                        }
                                        F[a + 60 >> 2] = h;
                                        F[a + 56 >> 2] = f;
                                        F[a + 52 >> 2] = d;
                                        if (!c) {
                                            break c;
                                        }
                                        ra(c);
                                    }
                                    d = F[b + 28 >> 2] - F[b + 24 >> 2] | 0;
                                    e = d >> 2;
                                    c = F[a + 40 >> 2];
                                    d: {
                                        if (e >>> 0 <= F[a + 48 >> 2] - c >> 2 >>> 0) {
                                            break d;
                                        }
                                        if ((d | 0) < 0) {
                                            break a;
                                        }
                                        f = F[a + 44 >> 2];
                                        d = sa(d);
                                        h = d + (e << 2) | 0;
                                        e = f - c | 0;
                                        f = e + d | 0;
                                        if ((e | 0) > 0) {
                                            ta(d, c, e);
                                        }
                                        F[a + 48 >> 2] = h;
                                        F[a + 44 >> 2] = f;
                                        F[a + 40 >> 2] = d;
                                        if (!c) {
                                            break d;
                                        }
                                        ra(c);
                                    }
                                    D[a + 24 | 0] = 1;
                                    F[a + 64 >> 2] = b;
                                }
                                ea = g + 16 | 0;
                                return;
                            }
                            wa(1336);
                            V();
                        } wa(1336); V(); }
                        function rd(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0; a: {
                            g = F[a + 4 >> 2];
                            b: {
                                if ((g | 0) != F[a >> 2]) {
                                    c = g;
                                    break b;
                                }
                                d = F[a + 8 >> 2];
                                c = F[a + 12 >> 2];
                                if (d >>> 0 < c >>> 0) {
                                    f = ((c - d >> 2) + 1 | 0) / 2 << 2;
                                    c = f + d | 0;
                                    e = d - g | 0;
                                    if (e) {
                                        c = c - e | 0;
                                        Wa(c, g, e);
                                        d = F[a + 8 >> 2];
                                    }
                                    F[a + 4 >> 2] = c;
                                    F[a + 8 >> 2] = d + f;
                                    break b;
                                }
                                c = c - g | 0;
                                c = c ? c >> 1 : 1;
                                if (c >>> 0 >= 1073741824) {
                                    break a;
                                }
                                e = c << 2;
                                h = sa(e);
                                l = h + e | 0;
                                c = (c + 3 & -4) + h | 0;
                                f = c;
                                i = d - g | 0;
                                c: {
                                    if (!i) {
                                        break c;
                                    }
                                    d = c;
                                    e = g;
                                    j = i - 4 | 0;
                                    k = (j >>> 2 | 0) + 1 & 7;
                                    if (k) {
                                        f = 0;
                                        while (1) {
                                            F[d >> 2] = F[e >> 2];
                                            e = e + 4 | 0;
                                            d = d + 4 | 0;
                                            f = f + 1 | 0;
                                            if ((k | 0) != (f | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    f = (i & -4) + c | 0;
                                    if (j >>> 0 < 28) {
                                        break c;
                                    }
                                    while (1) {
                                        F[d >> 2] = F[e >> 2];
                                        F[d + 4 >> 2] = F[e + 4 >> 2];
                                        F[d + 8 >> 2] = F[e + 8 >> 2];
                                        F[d + 12 >> 2] = F[e + 12 >> 2];
                                        F[d + 16 >> 2] = F[e + 16 >> 2];
                                        F[d + 20 >> 2] = F[e + 20 >> 2];
                                        F[d + 24 >> 2] = F[e + 24 >> 2];
                                        F[d + 28 >> 2] = F[e + 28 >> 2];
                                        e = e + 32 | 0;
                                        d = d + 32 | 0;
                                        if ((f | 0) != (d | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                F[a + 12 >> 2] = l;
                                F[a + 8 >> 2] = f;
                                F[a + 4 >> 2] = c;
                                F[a >> 2] = h;
                                if (!g) {
                                    break b;
                                }
                                ra(g);
                                c = F[a + 4 >> 2];
                            }
                            F[c - 4 >> 2] = F[b >> 2];
                            F[a + 4 >> 2] = F[a + 4 >> 2] - 4;
                            return;
                        } wa(1336); V(); }
                        function Eh(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0; h = F[a + 12 >> 2]; c = F[a + 68 >> 2]; e = F[c + 80 >> 2]; D[b + 84 | 0] = 0; g = F[b + 68 >> 2]; d = F[b + 72 >> 2] - g >> 2; a: {
                            if (d >>> 0 < e >>> 0) {
                                Ia(b + 68 | 0, e - d | 0, 12404);
                                c = F[a + 68 >> 2];
                                e = F[c + 80 >> 2];
                                break a;
                            }
                            if (e >>> 0 >= d >>> 0) {
                                break a;
                            }
                            F[b + 72 >> 2] = g + (e << 2);
                        } k = F[c + 96 >> 2]; c = F[c + 100 >> 2] - k | 0; if (!c) {
                            return 1;
                        } c = (c | 0) / 12 | 0; l = c >>> 0 > 1 ? c : 1; m = F[h + 28 >> 2]; c = 0; b: {
                            while (1) {
                                d = (L(c, 3) << 2) + m | 0;
                                g = F[d >> 2];
                                if ((g | 0) == -1) {
                                    break b;
                                }
                                h = L(c, 12) + k | 0;
                                i = F[h >> 2];
                                if (i >>> 0 >= e >>> 0) {
                                    break b;
                                }
                                f = g << 2;
                                g = F[F[a + 72 >> 2] + 12 >> 2];
                                f = F[f + g >> 2];
                                if (f >>> 0 >= e >>> 0) {
                                    break b;
                                }
                                j = i << 2;
                                i = F[b + 68 >> 2];
                                F[j + i >> 2] = f;
                                f = F[d + 4 >> 2];
                                if ((f | 0) == -1) {
                                    break b;
                                }
                                j = F[h + 4 >> 2];
                                if (j >>> 0 >= e >>> 0) {
                                    break b;
                                }
                                f = F[g + (f << 2) >> 2];
                                if (f >>> 0 >= e >>> 0) {
                                    break b;
                                }
                                F[i + (j << 2) >> 2] = f;
                                d = F[d + 8 >> 2];
                                if ((d | 0) == -1) {
                                    break b;
                                }
                                h = F[h + 8 >> 2];
                                if (h >>> 0 >= e >>> 0) {
                                    break b;
                                }
                                d = F[g + (d << 2) >> 2];
                                if (d >>> 0 >= e >>> 0) {
                                    break b;
                                }
                                F[i + (h << 2) >> 2] = d;
                                c = c + 1 | 0;
                                if ((l | 0) != (c | 0)) {
                                    continue;
                                }
                                break;
                            }
                            return 1;
                        } return 0; }
                        function ee(a, b, c, d) { var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0; j = +J[b >> 2]; k = +J[b + 4 >> 2]; l = +J[b + 8 >> 2]; g = N(j) + N(k) + N(l); a: {
                            if (!(g > 1e-6)) {
                                j = 1;
                                k = 0;
                                e = 0;
                                break a;
                            }
                            g = 1 / g;
                            k = g * k;
                            j = g * j;
                            e = g * l < 0;
                        } h = F[a + 16 >> 2]; l = +(h | 0); g = R(j * l + .5); b: {
                            if (N(g) < 2147483648) {
                                m = ~~g;
                                break b;
                            }
                            m = -2147483648;
                        } f = m >> 31; i = f + m ^ f; g = R(k * l + .5); c: {
                            if (N(g) < 2147483648) {
                                f = ~~g;
                                break c;
                            }
                            f = -2147483648;
                        } b = f >> 31; b = h - (i + (f + b ^ b) | 0) | 0; i = (b | 0) < 0 ? 0 : b; e = e ? 0 - i | 0 : i; f = f + (b >> 31 & ((f | 0) > 0 ? b : 0 - b | 0)) | 0; d: {
                            if ((m | 0) >= 0) {
                                b = e + h | 0;
                                a = F[a + 8 >> 2];
                                e = h + f | 0;
                                break d;
                            }
                            b = f >> 31;
                            b = b + f ^ b;
                            a = F[a + 8 >> 2];
                            b = (e | 0) < 0 ? b : a - b | 0;
                            e = (f | 0) < 0 ? i : a - i | 0;
                        } e: {
                            if (!(b | e)) {
                                b = a;
                                break e;
                            }
                            if (!((a | 0) != (b | 0) | e)) {
                                b = a;
                                break e;
                            }
                            if (!((a | 0) != (e | 0) | b)) {
                                b = a;
                                break e;
                            }
                            if (!((b | 0) <= (h | 0) | e)) {
                                b = (h << 1) - b | 0;
                                a = 0;
                                break e;
                            }
                            if (!((a | 0) != (e | 0) | (b | 0) >= (h | 0))) {
                                b = (h << 1) - b | 0;
                                break e;
                            }
                            if (!((a | 0) != (b | 0) | (e | 0) >= (h | 0))) {
                                b = a;
                                a = (h << 1) - e | 0;
                                break e;
                            }
                            if (b) {
                                a = e;
                                break e;
                            }
                            b = 0;
                            if ((e | 0) <= (h | 0)) {
                                a = e;
                                break e;
                            }
                            a = (h << 1) - e | 0;
                        } F[c >> 2] = a; F[d >> 2] = b; }
                        function Cd(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = M(0), f = M(0), g = M(0), h = M(0), i = M(0), j = 0, k = M(0), l = M(0), m = M(0), n = M(0), o = 0; a: {
                            if (F[c + 28 >> 2] != 9 | G[c + 24 | 0] != 3) {
                                break a;
                            }
                            a = F[a + 4 >> 2];
                            if (a - 31 >>> 0 < 4294967267) {
                                break a;
                            }
                            o = 1;
                            j = F[c + 80 >> 2];
                            if (!j) {
                                break a;
                            }
                            k = M(M(2) / M((1 << a) - 2 | 0));
                            c = F[F[c >> 2] >> 2] + F[c + 48 >> 2] | 0;
                            a = F[F[b >> 2] >> 2] + F[b + 48 >> 2] | 0;
                            b = 0;
                            while (1) {
                                g = M(0);
                                l = M(0);
                                m = M(0);
                                e = M(M(M(F[a >> 2]) * k) + M(-1));
                                f = M(M(M(F[a + 4 >> 2]) * k) + M(-1));
                                i = M(M(M(1) - M(N(e))) - M(N(f)));
                                h = M(Q(M(-i), M(0)));
                                n = M(-h);
                                f = M(f + (f < M(0) ? h : n));
                                e = M(e + (e < M(0) ? h : n));
                                h = M(M(f * f) + M(M(i * i) + M(e * e)));
                                if (!(+h < 1e-6)) {
                                    g = M(M(1) / M(U(h)));
                                    m = M(f * g);
                                    l = M(e * g);
                                    g = M(i * g);
                                }
                                a = a + 8 | 0;
                                d = (v(m), x(2));
                                D[c + 8 | 0] = d;
                                D[c + 9 | 0] = d >>> 8;
                                D[c + 10 | 0] = d >>> 16;
                                D[c + 11 | 0] = d >>> 24;
                                d = (v(l), x(2));
                                D[c + 4 | 0] = d;
                                D[c + 5 | 0] = d >>> 8;
                                D[c + 6 | 0] = d >>> 16;
                                D[c + 7 | 0] = d >>> 24;
                                d = (v(g), x(2));
                                D[c | 0] = d;
                                D[c + 1 | 0] = d >>> 8;
                                D[c + 2 | 0] = d >>> 16;
                                D[c + 3 | 0] = d >>> 24;
                                c = c + 12 | 0;
                                b = b + 1 | 0;
                                if ((j | 0) != (b | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } return o | 0; }
                        function Gc(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0; g = F[a >> 2]; c = g + (b >>> 3 & 536870908) | 0; F[c >> 2] = F[c >> 2] | 1 << b; f = F[a + 64 >> 2]; e = (b | 0) == -1; d = -1; a: {
                            if (e) {
                                break a;
                            }
                            c = b + 1 | 0;
                            c = (c >>> 0) % 3 | 0 ? c : b - 2 | 0;
                            d = -1;
                            if ((c | 0) == -1) {
                                break a;
                            }
                            d = F[F[f >> 2] + (c << 2) >> 2];
                        } c = F[a + 12 >> 2]; h = (d >>> 3 & 536870908) + c | 0; F[h >> 2] = F[h >> 2] | 1 << d; b: {
                            c: {
                                if (!e) {
                                    d: {
                                        e: {
                                            if ((b >>> 0) % 3 | 0) {
                                                e = b - 1 | 0;
                                                break e;
                                            }
                                            e = b + 2 | 0;
                                            d = -1;
                                            if ((e | 0) == -1) {
                                                break d;
                                            }
                                        }
                                        d = F[F[f >> 2] + (e << 2) >> 2];
                                    }
                                    e = (d >>> 3 & 536870908) + c | 0;
                                    F[e >> 2] = F[e >> 2] | 1 << d;
                                    d = -1;
                                    b = F[F[f + 12 >> 2] + (b << 2) >> 2];
                                    if ((b | 0) == -1) {
                                        break b;
                                    }
                                    D[a + 24 | 0] = 0;
                                    a = (b >>> 3 & 536870908) + g | 0;
                                    F[a >> 2] = F[a >> 2] | 1 << b;
                                    a = b + 1 | 0;
                                    a = (a >>> 0) % 3 | 0 ? a : b - 2 | 0;
                                    if ((a | 0) != -1) {
                                        d = F[F[f >> 2] + (a << 2) >> 2];
                                    }
                                    a = c + (d >>> 3 & 536870908) | 0;
                                    F[a >> 2] = F[a >> 2] | 1 << d;
                                    f: {
                                        g: {
                                            if ((b >>> 0) % 3 | 0) {
                                                b = b - 1 | 0;
                                                break g;
                                            }
                                            b = b + 2 | 0;
                                            a = -1;
                                            if ((b | 0) == -1) {
                                                break f;
                                            }
                                        }
                                        a = F[F[f >> 2] + (b << 2) >> 2];
                                    }
                                    b = 1 << a;
                                    a = c + (a >>> 3 & 536870908) | 0;
                                    c = F[a >> 2];
                                    break c;
                                }
                                a = c + 536870908 | 0;
                                b = F[c + 536870908 >> 2];
                                c = -2147483648;
                            }
                            F[a >> 2] = b | c;
                        } }
                        function Td(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0; a: {
                            if (b >>> 0 <= 63) {
                                b = 0;
                                a = F[a + 12 >> 2];
                                if (a >>> 0 < 2) {
                                    break a;
                                }
                                d = F[c >> 2];
                                b = a - 1 | 0;
                                e = b & 3;
                                c = 0;
                                b: {
                                    if (a - 2 >>> 0 < 3) {
                                        a = 1;
                                        b = 0;
                                        break b;
                                    }
                                    f = b & -4;
                                    b = 0;
                                    a = 1;
                                    while (1) {
                                        g = a + 3 | 0;
                                        h = a + 2 | 0;
                                        i = a + 1 | 0;
                                        b = I[d + (b << 2) >> 2] > I[d + (a << 2) >> 2] ? a : b;
                                        b = I[d + (b << 2) >> 2] > I[d + (i << 2) >> 2] ? i : b;
                                        b = I[d + (b << 2) >> 2] > I[d + (h << 2) >> 2] ? h : b;
                                        b = I[d + (b << 2) >> 2] > I[d + (g << 2) >> 2] ? g : b;
                                        a = a + 4 | 0;
                                        j = j + 4 | 0;
                                        if ((f | 0) != (j | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                if (!e) {
                                    break a;
                                }
                                while (1) {
                                    b = I[d + (b << 2) >> 2] > I[d + (a << 2) >> 2] ? a : b;
                                    a = a + 1 | 0;
                                    c = c + 1 | 0;
                                    if ((e | 0) != (c | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                break a;
                            }
                            b = F[a + 580 >> 2];
                            d = 32 - b | 0;
                            if ((d | 0) >= 4) {
                                c = F[a + 576 >> 2];
                                if ((c | 0) == F[a + 568 >> 2]) {
                                    return 0;
                                }
                                d = F[c >> 2];
                                e = b + 4 | 0;
                                F[a + 580 >> 2] = e;
                                b = d << b >>> 28 | 0;
                                if ((e | 0) != 32) {
                                    break a;
                                }
                                F[a + 580 >> 2] = 0;
                                F[a + 576 >> 2] = c + 4;
                                return b;
                            }
                            c = F[a + 576 >> 2];
                            e = c + 4 | 0;
                            if ((e | 0) == F[a + 568 >> 2]) {
                                return 0;
                            }
                            f = F[c >> 2];
                            F[a + 576 >> 2] = e;
                            F[a + 580 >> 2] = b - 28;
                            a = 60 - b | 0;
                            b = F[c + 4 >> 2] >>> a | f << b >>> a - d;
                        } return b; }
                        function xe(a) { a = a | 0; var b = 0, c = 0, d = 0, e = 0; F[a >> 2] = 11464; b = F[a + 388 >> 2]; if (b) {
                            F[a + 392 >> 2] = b;
                            ra(b);
                        } d = F[a + 368 >> 2]; F[a + 368 >> 2] = 0; if (d) {
                            e = d - 4 | 0;
                            b = F[e >> 2];
                            if (b) {
                                c = (b << 4) + d | 0;
                                while (1) {
                                    c = c - 16 | 0;
                                    if ((d | 0) != (c | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            ra(e);
                        } Xc(a + 216 | 0); b = F[a + 196 >> 2]; if (b) {
                            F[a + 200 >> 2] = b;
                            ra(b);
                        } b = F[a + 184 >> 2]; if (b) {
                            F[a + 188 >> 2] = b;
                            ra(b);
                        } b = F[a + 172 >> 2]; if (b) {
                            F[a + 176 >> 2] = b;
                            ra(b);
                        } b = F[a + 160 >> 2]; if (b) {
                            F[a + 164 >> 2] = b;
                            ra(b);
                        } c = F[a + 144 >> 2]; if (c) {
                            while (1) {
                                b = F[c >> 2];
                                ra(c);
                                c = b;
                                if (b) {
                                    continue;
                                }
                                break;
                            }
                        } b = F[a + 136 >> 2]; F[a + 136 >> 2] = 0; if (b) {
                            ra(b);
                        } b = F[a + 120 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 108 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 96 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 72 >> 2]; if (b) {
                            F[a + 76 >> 2] = b;
                            ra(b);
                        } b = F[a + 60 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 48 >> 2]; if (b) {
                            F[a + 52 >> 2] = b;
                            ra(b);
                        } b = F[a + 36 >> 2]; if (b) {
                            F[a + 40 >> 2] = b;
                            ra(b);
                        } b = F[a + 24 >> 2]; if (b) {
                            F[a + 28 >> 2] = b;
                            ra(b);
                        } b = F[a + 12 >> 2]; if (b) {
                            F[a + 16 >> 2] = b;
                            ra(b);
                        } b = F[a + 8 >> 2]; F[a + 8 >> 2] = 0; if (b) {
                            cb(b);
                        } return a | 0; }
                        function gd(a, b) { var c = 0, d = 0; c = F[b + 8 >> 2]; F[a + 4 >> 2] = F[b + 4 >> 2]; F[a + 8 >> 2] = c; F[a + 20 >> 2] = F[b + 20 >> 2]; c = F[b + 16 >> 2]; F[a + 12 >> 2] = F[b + 12 >> 2]; F[a + 16 >> 2] = c; a: {
                            b: {
                                if ((a | 0) != (b | 0)) {
                                    c = F[b + 28 >> 2];
                                    if (c) {
                                        c: {
                                            if (F[a + 32 >> 2] << 5 >>> 0 >= c >>> 0) {
                                                d = F[a + 24 >> 2];
                                                break c;
                                            }
                                            d = F[a + 24 >> 2];
                                            if (d) {
                                                ra(d);
                                                F[a + 32 >> 2] = 0;
                                                F[a + 24 >> 2] = 0;
                                                F[a + 28 >> 2] = 0;
                                                c = F[b + 28 >> 2];
                                            }
                                            if ((c | 0) < 0) {
                                                break b;
                                            }
                                            c = (c - 1 >>> 5 | 0) + 1 | 0;
                                            d = sa(c << 2);
                                            F[a + 32 >> 2] = c;
                                            F[a + 28 >> 2] = 0;
                                            F[a + 24 >> 2] = d;
                                            c = F[b + 28 >> 2];
                                        }
                                        Wa(d, F[b + 24 >> 2], (c - 1 >>> 3 & 536870908) + 4 | 0);
                                        c = F[b + 28 >> 2];
                                    }
                                    else {
                                        c = 0;
                                    }
                                    F[a + 28 >> 2] = c;
                                    c = F[b + 40 >> 2];
                                    if (c) {
                                        d: {
                                            if (F[a + 44 >> 2] << 5 >>> 0 >= c >>> 0) {
                                                d = F[a + 36 >> 2];
                                                break d;
                                            }
                                            d = F[a + 36 >> 2];
                                            if (d) {
                                                ra(d);
                                                F[a + 44 >> 2] = 0;
                                                F[a + 36 >> 2] = 0;
                                                F[a + 40 >> 2] = 0;
                                                c = F[b + 40 >> 2];
                                            }
                                            if ((c | 0) < 0) {
                                                break a;
                                            }
                                            c = (c - 1 >>> 5 | 0) + 1 | 0;
                                            d = sa(c << 2);
                                            F[a + 44 >> 2] = c;
                                            F[a + 40 >> 2] = 0;
                                            F[a + 36 >> 2] = d;
                                            c = F[b + 40 >> 2];
                                        }
                                        Wa(d, F[b + 36 >> 2], (c - 1 >>> 3 & 536870908) + 4 | 0);
                                        b = F[b + 40 >> 2];
                                    }
                                    else {
                                        b = 0;
                                    }
                                    F[a + 40 >> 2] = b;
                                }
                                return;
                            }
                            Oa();
                            V();
                        } Oa(); V(); }
                        function If(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0, h = 0; f = ea + -64 | 0; ea = f; d = 1; a: {
                            if (Za(a, b, 0)) {
                                break a;
                            }
                            d = 0;
                            if (!b) {
                                break a;
                            }
                            d = ea + -64 | 0;
                            ea = d;
                            e = F[b >> 2];
                            g = F[e - 4 >> 2];
                            h = F[e - 8 >> 2];
                            F[d + 20 >> 2] = 0;
                            F[d + 16 >> 2] = 14956;
                            F[d + 12 >> 2] = b;
                            F[d + 8 >> 2] = 15004;
                            e = 0;
                            ua(d + 24 | 0, 0, 39);
                            b = b + h | 0;
                            b: {
                                if (Za(g, 15004, 0)) {
                                    F[d + 56 >> 2] = 1;
                                    ga[F[F[g >> 2] + 20 >> 2]](g, d + 8 | 0, b, b, 1, 0);
                                    e = F[d + 32 >> 2] == 1 ? b : 0;
                                    break b;
                                }
                                ga[F[F[g >> 2] + 24 >> 2]](g, d + 8 | 0, b, 1, 0);
                                c: {
                                    switch (F[d + 44 >> 2]) {
                                        case 0:
                                            e = F[d + 48 >> 2] == 1 ? F[d + 36 >> 2] == 1 ? F[d + 40 >> 2] == 1 ? F[d + 28 >> 2] : 0 : 0 : 0;
                                            break b;
                                        case 1: break c;
                                        default: break b;
                                    }
                                }
                                if (F[d + 32 >> 2] != 1) {
                                    if (F[d + 48 >> 2] | F[d + 36 >> 2] != 1 | F[d + 40 >> 2] != 1) {
                                        break b;
                                    }
                                }
                                e = F[d + 24 >> 2];
                            }
                            ea = d - -64 | 0;
                            d = 0;
                            if (!e) {
                                break a;
                            }
                            b = f + 8 | 0;
                            ua(b | 4, 0, 52);
                            F[f + 56 >> 2] = 1;
                            F[f + 20 >> 2] = -1;
                            F[f + 16 >> 2] = a;
                            F[f + 8 >> 2] = e;
                            ga[F[F[e >> 2] + 28 >> 2]](e, b, F[c >> 2], 1);
                            a = F[f + 32 >> 2];
                            if ((a | 0) == 1) {
                                F[c >> 2] = F[f + 24 >> 2];
                            }
                            d = (a | 0) == 1;
                        } ea = f - -64 | 0; return d | 0; }
                        function Qe(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0; f = F[b + 12 >> 2]; c = F[b + 20 >> 2]; d = c; i = F[b + 16 >> 2]; e = i + 4 | 0; c = e >>> 0 < 4 ? c + 1 | 0 : c; j = F[b + 8 >> 2]; g = e; a: {
                            if (j >>> 0 < e >>> 0 & (c | 0) >= (f | 0) | (c | 0) > (f | 0)) {
                                break a;
                            }
                            l = F[b >> 2];
                            e = i + l | 0;
                            h = G[e | 0] | G[e + 1 | 0] << 8 | (G[e + 2 | 0] << 16 | G[e + 3 | 0] << 24);
                            F[b + 16 >> 2] = g;
                            F[b + 20 >> 2] = c;
                            e = H[b + 38 >> 1];
                            if (e >>> 0 <= 513) {
                                c = d;
                                d = i + 8 | 0;
                                c = d >>> 0 < 8 ? c + 1 | 0 : c;
                                g = d;
                                if (d >>> 0 > j >>> 0 & (c | 0) >= (f | 0) | (c | 0) > (f | 0)) {
                                    break a;
                                }
                                F[b + 16 >> 2] = g;
                                F[b + 20 >> 2] = c;
                            }
                            if (!(h & 1)) {
                                break a;
                            }
                            d = O(h) ^ 31;
                            if (d - 30 >>> 0 < 4294967267) {
                                break a;
                            }
                            F[a + 8 >> 2] = d + 1;
                            d = -2 << d;
                            h = -2 - d | 0;
                            F[a + 16 >> 2] = h;
                            F[a + 12 >> 2] = d ^ -1;
                            F[a + 24 >> 2] = (h | 0) / 2;
                            J[a + 20 >> 2] = M(2) / M(h | 0);
                            if (e >>> 0 <= 513) {
                                if ((c | 0) >= (f | 0) & g >>> 0 >= j >>> 0 | (c | 0) > (f | 0)) {
                                    break a;
                                }
                                f = G[g + l | 0];
                                d = g + 1 | 0;
                                c = d ? c : c + 1 | 0;
                                F[b + 16 >> 2] = d;
                                F[b + 20 >> 2] = c;
                                b: {
                                    switch (f | 0) {
                                        case 1:
                                            k = 1;
                                            break;
                                        case 0: break b;
                                        default: break a;
                                    }
                                }
                                F[a + 72 >> 2] = k;
                            }
                            k = xa(a + 96 | 0, b);
                        } return k | 0; }
                        function Pe(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0; f = F[b + 12 >> 2]; c = F[b + 20 >> 2]; g = c; h = F[b + 16 >> 2]; d = h + 4 | 0; c = d >>> 0 < 4 ? c + 1 | 0 : c; i = F[b + 8 >> 2]; a: {
                            if (i >>> 0 < d >>> 0 & (c | 0) >= (f | 0) | (c | 0) > (f | 0)) {
                                break a;
                            }
                            l = F[b >> 2];
                            e = h + l | 0;
                            e = G[e | 0] | G[e + 1 | 0] << 8 | (G[e + 2 | 0] << 16 | G[e + 3 | 0] << 24);
                            F[b + 16 >> 2] = d;
                            F[b + 20 >> 2] = c;
                            c = g;
                            d = h + 8 | 0;
                            c = d >>> 0 < 8 ? c + 1 | 0 : c;
                            j = d;
                            if (d >>> 0 > i >>> 0 & (c | 0) >= (f | 0) | (c | 0) > (f | 0)) {
                                break a;
                            }
                            F[b + 16 >> 2] = j;
                            F[b + 20 >> 2] = c;
                            if (!(e & 1)) {
                                break a;
                            }
                            d = O(e) ^ 31;
                            if (d - 30 >>> 0 < 4294967267) {
                                break a;
                            }
                            F[a + 8 >> 2] = d + 1;
                            d = -2 << d;
                            e = -2 - d | 0;
                            F[a + 16 >> 2] = e;
                            F[a + 12 >> 2] = d ^ -1;
                            F[a + 24 >> 2] = (e | 0) / 2;
                            J[a + 20 >> 2] = M(2) / M(e | 0);
                            if (H[b + 38 >> 1] <= 513) {
                                if ((c | 0) >= (f | 0) & j >>> 0 >= i >>> 0 | (c | 0) > (f | 0)) {
                                    break a;
                                }
                                f = G[j + l | 0];
                                c = h + 9 | 0;
                                g = c >>> 0 < 9 ? g + 1 | 0 : g;
                                F[b + 16 >> 2] = c;
                                F[b + 20 >> 2] = g;
                                b: {
                                    switch (f | 0) {
                                        case 1:
                                            k = 1;
                                            break;
                                        case 0: break b;
                                        default: break a;
                                    }
                                }
                                F[a + 72 >> 2] = k;
                            }
                            k = xa(a + 96 | 0, b);
                        } return k | 0; }
                        function ye(a) { a = a | 0; var b = 0, c = 0, d = 0, e = 0; F[a >> 2] = 11412; d = F[a + 368 >> 2]; F[a + 368 >> 2] = 0; if (d) {
                            e = d - 4 | 0;
                            b = F[e >> 2];
                            if (b) {
                                c = (b << 4) + d | 0;
                                while (1) {
                                    c = c - 16 | 0;
                                    if ((d | 0) != (c | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            ra(e);
                        } Xc(a + 216 | 0); b = F[a + 196 >> 2]; if (b) {
                            F[a + 200 >> 2] = b;
                            ra(b);
                        } b = F[a + 184 >> 2]; if (b) {
                            F[a + 188 >> 2] = b;
                            ra(b);
                        } b = F[a + 172 >> 2]; if (b) {
                            F[a + 176 >> 2] = b;
                            ra(b);
                        } b = F[a + 160 >> 2]; if (b) {
                            F[a + 164 >> 2] = b;
                            ra(b);
                        } c = F[a + 144 >> 2]; if (c) {
                            while (1) {
                                b = F[c >> 2];
                                ra(c);
                                c = b;
                                if (b) {
                                    continue;
                                }
                                break;
                            }
                        } b = F[a + 136 >> 2]; F[a + 136 >> 2] = 0; if (b) {
                            ra(b);
                        } b = F[a + 120 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 108 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 96 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 72 >> 2]; if (b) {
                            F[a + 76 >> 2] = b;
                            ra(b);
                        } b = F[a + 60 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 48 >> 2]; if (b) {
                            F[a + 52 >> 2] = b;
                            ra(b);
                        } b = F[a + 36 >> 2]; if (b) {
                            F[a + 40 >> 2] = b;
                            ra(b);
                        } b = F[a + 24 >> 2]; if (b) {
                            F[a + 28 >> 2] = b;
                            ra(b);
                        } b = F[a + 12 >> 2]; if (b) {
                            F[a + 16 >> 2] = b;
                            ra(b);
                        } b = F[a + 8 >> 2]; F[a + 8 >> 2] = 0; if (b) {
                            cb(b);
                        } return a | 0; }
                        function Ng(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; var e = 0, f = 0, g = 0; a: {
                            a = ea - 32 | 0;
                            ea = a;
                            e = La(c);
                            if (e >>> 0 < 4294967280) {
                                b: {
                                    c: {
                                        if (e >>> 0 >= 11) {
                                            g = e + 16 & -16;
                                            f = sa(g);
                                            F[a + 24 >> 2] = g | -2147483648;
                                            F[a + 16 >> 2] = f;
                                            F[a + 20 >> 2] = e;
                                            break c;
                                        }
                                        D[a + 27 | 0] = e;
                                        f = a + 16 | 0;
                                        if (!e) {
                                            break b;
                                        }
                                    }
                                    ta(f, c, e);
                                }
                                D[e + f | 0] = 0;
                                F[a + 8 >> 2] = 0;
                                F[a >> 2] = 0;
                                F[a + 4 >> 2] = 0;
                                d: {
                                    c = rb(b, a + 16 | 0);
                                    if ((c | 0) == (b + 4 | 0)) {
                                        break d;
                                    }
                                    b = F[c + 28 >> 2];
                                    f = F[c + 32 >> 2];
                                    if ((b | 0) == (f | 0)) {
                                        break d;
                                    }
                                    b = f - b | 0;
                                    if (b & 3) {
                                        break d;
                                    }
                                    e = b >>> 2 | 0;
                                    f = F[a + 4 >> 2];
                                    b = F[a >> 2];
                                    g = f - b >> 2;
                                    e: {
                                        if (e >>> 0 > g >>> 0) {
                                            Aa(a, e - g | 0);
                                            b = F[a >> 2];
                                            f = F[a + 4 >> 2];
                                            break e;
                                        }
                                        if (e >>> 0 >= g >>> 0) {
                                            break e;
                                        }
                                        f = (e << 2) + b | 0;
                                        F[a + 4 >> 2] = f;
                                    }
                                    if ((b | 0) != (f | 0)) {
                                        e = b;
                                        b = F[c + 28 >> 2];
                                        ta(e, b, F[c + 32 >> 2] - b | 0);
                                        break d;
                                    }
                                    Da();
                                    V();
                                }
                                b = F[d >> 2];
                                if (b) {
                                    F[d + 4 >> 2] = b;
                                    ra(b);
                                }
                                F[d >> 2] = F[a >> 2];
                                F[d + 4 >> 2] = F[a + 4 >> 2];
                                F[d + 8 >> 2] = F[a + 8 >> 2];
                                if (D[a + 27 | 0] < 0) {
                                    ra(F[a + 16 >> 2]);
                                }
                                ea = a + 32 | 0;
                                break a;
                            }
                            Ma();
                            V();
                        } }
                        function vc(a) { var b = 0, c = 0, d = 0; b = F[a + 8 >> 2]; d = F[a >> 2]; a: {
                            if (G[a + 12 | 0]) {
                                b: {
                                    c: {
                                        d: {
                                            e: {
                                                if ((b | 0) == -1) {
                                                    break e;
                                                }
                                                c = b + 1 | 0;
                                                b = (c >>> 0) % 3 | 0 ? c : b - 2 | 0;
                                                if ((b | 0) == -1) {
                                                    break e;
                                                }
                                                b = F[F[d + 12 >> 2] + (b << 2) >> 2];
                                                if ((b | 0) != -1) {
                                                    break d;
                                                }
                                            }
                                            F[a + 8 >> 2] = -1;
                                            break c;
                                        }
                                        c = b + 1 | 0;
                                        b = (c >>> 0) % 3 | 0 ? c : b - 2 | 0;
                                        F[a + 8 >> 2] = b;
                                        if ((b | 0) != -1) {
                                            break b;
                                        }
                                    }
                                    c = F[a + 4 >> 2];
                                    b = -1;
                                    f: {
                                        if ((c | 0) == -1) {
                                            break f;
                                        }
                                        g: {
                                            if ((c >>> 0) % 3 | 0) {
                                                c = c - 1 | 0;
                                                break g;
                                            }
                                            c = c + 2 | 0;
                                            b = -1;
                                            if ((c | 0) == -1) {
                                                break f;
                                            }
                                        }
                                        c = F[F[d + 12 >> 2] + (c << 2) >> 2];
                                        b = -1;
                                        if ((c | 0) == -1) {
                                            break f;
                                        }
                                        b = c - 1 | 0;
                                        if ((c >>> 0) % 3 | 0) {
                                            break f;
                                        }
                                        b = c + 2 | 0;
                                    }
                                    D[a + 12 | 0] = 0;
                                    F[a + 8 >> 2] = b;
                                    return;
                                }
                                if ((b | 0) != F[a + 4 >> 2]) {
                                    break a;
                                }
                                F[a + 8 >> 2] = -1;
                                return;
                            }
                            c = -1;
                            h: {
                                if ((b | 0) == -1) {
                                    break h;
                                }
                                i: {
                                    if ((b >>> 0) % 3 | 0) {
                                        b = b - 1 | 0;
                                        break i;
                                    }
                                    b = b + 2 | 0;
                                    c = -1;
                                    if ((b | 0) == -1) {
                                        break h;
                                    }
                                }
                                b = F[F[d + 12 >> 2] + (b << 2) >> 2];
                                c = -1;
                                if ((b | 0) == -1) {
                                    break h;
                                }
                                c = b - 1 | 0;
                                if ((b >>> 0) % 3 | 0) {
                                    break h;
                                }
                                c = b + 2 | 0;
                            }
                            F[a + 8 >> 2] = c;
                        } }
                        function Mf(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0; e = ea - 32 | 0; ea = e; f = F[a + 28 >> 2]; F[e + 16 >> 2] = f; d = F[a + 20 >> 2]; F[e + 28 >> 2] = c; F[e + 24 >> 2] = b; b = d - f | 0; F[e + 20 >> 2] = b; f = b + c | 0; j = 2; a: {
                            b: {
                                b = e + 16 | 0;
                                d = Z(F[a + 60 >> 2], b | 0, 2, e + 12 | 0) | 0;
                                if (d) {
                                    F[4190] = d;
                                    d = -1;
                                }
                                else {
                                    d = 0;
                                }
                                c: {
                                    if (!d) {
                                        while (1) {
                                            d = F[e + 12 >> 2];
                                            if ((d | 0) == (f | 0)) {
                                                break c;
                                            }
                                            if ((d | 0) < 0) {
                                                break b;
                                            }
                                            g = F[b + 4 >> 2];
                                            h = g >>> 0 < d >>> 0;
                                            i = (h << 3) + b | 0;
                                            g = d - (h ? g : 0) | 0;
                                            F[i >> 2] = g + F[i >> 2];
                                            i = (h ? 12 : 4) + b | 0;
                                            F[i >> 2] = F[i >> 2] - g;
                                            f = f - d | 0;
                                            b = h ? b + 8 | 0 : b;
                                            j = j - h | 0;
                                            d = Z(F[a + 60 >> 2], b | 0, j | 0, e + 12 | 0) | 0;
                                            if (d) {
                                                F[4190] = d;
                                                d = -1;
                                            }
                                            else {
                                                d = 0;
                                            }
                                            if (!d) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    if ((f | 0) != -1) {
                                        break b;
                                    }
                                }
                                b = F[a + 44 >> 2];
                                F[a + 28 >> 2] = b;
                                F[a + 20 >> 2] = b;
                                F[a + 16 >> 2] = b + F[a + 48 >> 2];
                                a = c;
                                break a;
                            }
                            F[a + 28 >> 2] = 0;
                            F[a + 16 >> 2] = 0;
                            F[a + 20 >> 2] = 0;
                            F[a >> 2] = F[a >> 2] | 32;
                            a = 0;
                            if ((j | 0) == 2) {
                                break a;
                            }
                            a = c - F[b + 4 >> 2] | 0;
                        } ea = e + 32 | 0; return a | 0; }
                        function Pg(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0; d = ea - 16 | 0; ea = d; a: {
                            e = La(c);
                            if (e >>> 0 < 4294967280) {
                                b: {
                                    c: {
                                        if (e >>> 0 >= 11) {
                                            f = e + 16 & -16;
                                            a = sa(f);
                                            F[d + 8 >> 2] = f | -2147483648;
                                            F[d >> 2] = a;
                                            F[d + 4 >> 2] = e;
                                            break c;
                                        }
                                        D[d + 11 | 0] = e;
                                        a = d;
                                        if (!e) {
                                            break b;
                                        }
                                    }
                                    ta(a, c, e);
                                }
                                D[a + e | 0] = 0;
                                c = G[d + 11 | 0];
                                e = c << 24 >> 24;
                                f = F[d >> 2];
                                b = F[b + 4 >> 2];
                                a = 0;
                                d: {
                                    if (!b) {
                                        break d;
                                    }
                                    a = c;
                                    c = (e | 0) < 0;
                                    a = c ? F[d + 4 >> 2] : a;
                                    j = c ? f : d;
                                    while (1) {
                                        c = G[b + 27 | 0];
                                        g = c << 24 >> 24 < 0;
                                        c = g ? F[b + 20 >> 2] : c;
                                        k = c >>> 0 < a >>> 0;
                                        e: {
                                            f: {
                                                i = k ? c : a;
                                                g: {
                                                    if (i) {
                                                        h = b + 16 | 0;
                                                        g = g ? F[h >> 2] : h;
                                                        h = Ha(j, g, i);
                                                        h: {
                                                            if (!h) {
                                                                if (a >>> 0 >= c >>> 0) {
                                                                    break h;
                                                                }
                                                                break e;
                                                            }
                                                            if ((h | 0) < 0) {
                                                                break e;
                                                            }
                                                        }
                                                        c = Ha(g, j, i);
                                                        if (!c) {
                                                            break g;
                                                        }
                                                        if ((c | 0) < 0) {
                                                            break f;
                                                        }
                                                        a = 1;
                                                        break d;
                                                    }
                                                    if (a >>> 0 < c >>> 0) {
                                                        break e;
                                                    }
                                                }
                                                if (k) {
                                                    break f;
                                                }
                                                a = 1;
                                                break d;
                                            }
                                            b = b + 4 | 0;
                                        }
                                        b = F[b >> 2];
                                        if (b) {
                                            continue;
                                        }
                                        break;
                                    }
                                    a = 0;
                                }
                                if ((e | 0) < 0) {
                                    ra(f);
                                }
                                ea = d + 16 | 0;
                                break a;
                            }
                            Ma();
                            V();
                        } return a | 0; }
                        function Bc(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0; F[a + 16 >> 2] = 0; F[a + 20 >> 2] = 0; F[a + 8 >> 2] = 0; F[a >> 2] = 0; F[a + 4 >> 2] = 0; F[a + 24 >> 2] = 0; f = F[b + 4 >> 2] - F[b >> 2] | 0; i = (f | 0) / 20 | 0; a: {
                            b: {
                                c: {
                                    if (f) {
                                        if (i >>> 0 >= 214748365) {
                                            break c;
                                        }
                                        d = sa(f);
                                        F[a + 16 >> 2] = d;
                                        F[a + 20 >> 2] = d;
                                        F[a + 24 >> 2] = L(i, 20) + d;
                                        c = F[b >> 2];
                                        b = F[b + 4 >> 2] - c | 0;
                                        if ((b | 0) <= 0) {
                                            b = d;
                                        }
                                        else {
                                            b = ta(d, c, b) + L((b >>> 0) / 20 | 0, 20) | 0;
                                        }
                                        c = b;
                                        F[a + 20 >> 2] = c;
                                    }
                                    F[a + 28 >> 2] = 0;
                                    b = c - d | 0;
                                    if (!b) {
                                        break a;
                                    }
                                    b = (b | 0) / 20 | 0;
                                    c = b >>> 0 > 1 ? b : 1;
                                    f = c & 1;
                                    if (b >>> 0 < 2) {
                                        b = 0;
                                        break b;
                                    }
                                    i = c & -2;
                                    b = 0;
                                    c = 0;
                                    while (1) {
                                        g = L(b | 1, 20) + d | 0;
                                        g = L(F[g + 16 >> 2], F[g + 12 >> 2]);
                                        h = L(b, 20) + d | 0;
                                        h = L(F[h + 16 >> 2], F[h + 12 >> 2]);
                                        e = e >>> 0 < h >>> 0 ? h : e;
                                        e = e >>> 0 < g >>> 0 ? g : e;
                                        b = b + 2 | 0;
                                        c = c + 2 | 0;
                                        if ((i | 0) != (c | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                    break b;
                                }
                                va();
                                V();
                            }
                            if (!f) {
                                break a;
                            }
                            b = L(b, 20) + d | 0;
                            b = L(F[b + 16 >> 2], F[b + 12 >> 2]);
                            e = b >>> 0 > e >>> 0 ? b : e;
                        } Va(a, e); F[a + 12 >> 2] = F[a >> 2]; return a; }
                        function Wa(a, b, c) { var d = 0, e = 0; a: {
                            if ((a | 0) == (b | 0)) {
                                break a;
                            }
                            e = a + c | 0;
                            if (b - e >>> 0 <= 0 - (c << 1) >>> 0) {
                                return ta(a, b, c);
                            }
                            d = (a ^ b) & 3;
                            b: {
                                c: {
                                    if (a >>> 0 < b >>> 0) {
                                        if (d) {
                                            d = a;
                                            break b;
                                        }
                                        if (!(a & 3)) {
                                            d = a;
                                            break c;
                                        }
                                        d = a;
                                        while (1) {
                                            if (!c) {
                                                break a;
                                            }
                                            D[d | 0] = G[b | 0];
                                            b = b + 1 | 0;
                                            c = c - 1 | 0;
                                            d = d + 1 | 0;
                                            if (d & 3) {
                                                continue;
                                            }
                                            break;
                                        }
                                        break c;
                                    }
                                    d: {
                                        if (d) {
                                            break d;
                                        }
                                        if (e & 3) {
                                            while (1) {
                                                if (!c) {
                                                    break a;
                                                }
                                                c = c - 1 | 0;
                                                d = c + a | 0;
                                                D[d | 0] = G[b + c | 0];
                                                if (d & 3) {
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        if (c >>> 0 <= 3) {
                                            break d;
                                        }
                                        while (1) {
                                            c = c - 4 | 0;
                                            F[c + a >> 2] = F[b + c >> 2];
                                            if (c >>> 0 > 3) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    if (!c) {
                                        break a;
                                    }
                                    while (1) {
                                        c = c - 1 | 0;
                                        D[c + a | 0] = G[b + c | 0];
                                        if (c) {
                                            continue;
                                        }
                                        break;
                                    }
                                    break a;
                                }
                                if (c >>> 0 <= 3) {
                                    break b;
                                }
                                while (1) {
                                    F[d >> 2] = F[b >> 2];
                                    b = b + 4 | 0;
                                    d = d + 4 | 0;
                                    c = c - 4 | 0;
                                    if (c >>> 0 > 3) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            if (!c) {
                                break a;
                            }
                            while (1) {
                                D[d | 0] = G[b | 0];
                                d = d + 1 | 0;
                                b = b + 1 | 0;
                                c = c - 1 | 0;
                                if (c) {
                                    continue;
                                }
                                break;
                            }
                        } return a; }
                        function cf(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0; h = F[c + 12 >> 2]; d = h; e = F[c + 20 >> 2]; i = F[c + 8 >> 2]; f = F[c + 16 >> 2]; a: {
                            if ((d | 0) <= (e | 0) & i >>> 0 <= f >>> 0 | (d | 0) < (e | 0)) {
                                break a;
                            }
                            j = F[c >> 2];
                            k = D[j + f | 0];
                            d = e;
                            g = f + 1 | 0;
                            d = g ? d : d + 1 | 0;
                            F[c + 16 >> 2] = g;
                            F[c + 20 >> 2] = d;
                            b: {
                                if ((k | 0) == -2) {
                                    break b;
                                }
                                if ((d | 0) >= (h | 0) & g >>> 0 >= i >>> 0 | (d | 0) > (h | 0)) {
                                    break a;
                                }
                                d = D[g + j | 0];
                                f = f + 2 | 0;
                                e = f >>> 0 < 2 ? e + 1 | 0 : e;
                                F[c + 16 >> 2] = f;
                                F[c + 20 >> 2] = e;
                                if ((d - 4 & 255) >>> 0 < 251) {
                                    break a;
                                }
                                e = ga[F[F[a >> 2] + 40 >> 2]](a, k, d) | 0;
                                d = F[a + 20 >> 2];
                                F[a + 20 >> 2] = e;
                                if (!d) {
                                    break b;
                                }
                                ga[F[F[d >> 2] + 4 >> 2]](d);
                            }
                            d = F[a + 20 >> 2];
                            if (d) {
                                if (!(ga[F[F[a >> 2] + 28 >> 2]](a, d) | 0)) {
                                    break a;
                                }
                            }
                            if (!(ga[F[F[a >> 2] + 36 >> 2]](a, b, c) | 0)) {
                                break a;
                            }
                            c = F[a + 4 >> 2];
                            if (!(!c | G[c + 36 | 0] > 1)) {
                                if (!(ga[F[F[a >> 2] + 48 >> 2]](a, F[b + 4 >> 2] - F[b >> 2] >> 2) | 0)) {
                                    break a;
                                }
                            }
                            l = 1;
                        } return l | 0; }
                        function _d(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0; d = ea - 16 | 0; ea = d; g = F[a + 24 >> 2]; l = F[a + 28 >> 2]; a: {
                            if ((g | 0) != (l | 0)) {
                                while (1) {
                                    F[d + 8 >> 2] = 0;
                                    F[d >> 2] = 0;
                                    F[d + 4 >> 2] = 0;
                                    e = Zd(F[g >> 2], b, d);
                                    a = G[d + 11 | 0];
                                    i = a << 24 >> 24;
                                    j = 3;
                                    b: {
                                        c: {
                                            d: {
                                                e: {
                                                    if (!e) {
                                                        break e;
                                                    }
                                                    j = 0;
                                                    e = G[c + 11 | 0];
                                                    f = e << 24 >> 24;
                                                    k = (i | 0) < 0 ? F[d + 4 >> 2] : a;
                                                    if ((k | 0) != (((f | 0) < 0 ? F[c + 4 >> 2] : e) | 0)) {
                                                        break e;
                                                    }
                                                    h = (f | 0) < 0 ? F[c >> 2] : c;
                                                    f = F[d >> 2];
                                                    e = (i | 0) < 0;
                                                    f: {
                                                        if (!e) {
                                                            if (!i) {
                                                                break f;
                                                            }
                                                            e = d;
                                                            if (G[h | 0] != (f & 255)) {
                                                                break b;
                                                            }
                                                            while (1) {
                                                                a = a - 1 | 0;
                                                                if (!a) {
                                                                    break f;
                                                                }
                                                                f = G[h + 1 | 0];
                                                                h = h + 1 | 0;
                                                                e = e + 1 | 0;
                                                                if ((f | 0) == G[e | 0]) {
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                            break e;
                                                        }
                                                        if (!k) {
                                                            break f;
                                                        }
                                                        if (Ha(e ? f : d, h, k)) {
                                                            break d;
                                                        }
                                                    }
                                                    m = F[g >> 2];
                                                    j = 1;
                                                }
                                                if ((i | 0) >= 0) {
                                                    break c;
                                                }
                                            }
                                            ra(F[d >> 2]);
                                        }
                                        switch (j | 0) {
                                            case 0:
                                            case 3: break b;
                                            default: break a;
                                        }
                                    }
                                    g = g + 4 | 0;
                                    if ((l | 0) != (g | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            m = 0;
                        } ea = d + 16 | 0; return m; }
                        function Kd(a, b, c) { a: {
                            switch (b - 9 | 0) {
                                case 0:
                                    b = F[c >> 2];
                                    F[c >> 2] = b + 4;
                                    F[a >> 2] = F[b >> 2];
                                    return;
                                case 6:
                                    b = F[c >> 2];
                                    F[c >> 2] = b + 4;
                                    b = E[b >> 1];
                                    F[a >> 2] = b;
                                    F[a + 4 >> 2] = b >> 31;
                                    return;
                                case 7:
                                    b = F[c >> 2];
                                    F[c >> 2] = b + 4;
                                    F[a >> 2] = H[b >> 1];
                                    F[a + 4 >> 2] = 0;
                                    return;
                                case 8:
                                    b = F[c >> 2];
                                    F[c >> 2] = b + 4;
                                    b = D[b | 0];
                                    F[a >> 2] = b;
                                    F[a + 4 >> 2] = b >> 31;
                                    return;
                                case 9:
                                    b = F[c >> 2];
                                    F[c >> 2] = b + 4;
                                    F[a >> 2] = G[b | 0];
                                    F[a + 4 >> 2] = 0;
                                    return;
                                case 16:
                                    b = F[c >> 2] + 7 & -8;
                                    F[c >> 2] = b + 8;
                                    K[a >> 3] = K[b >> 3];
                                    return;
                                case 17: ga[0](a, c);
                                default: return;
                                case 1:
                                case 4:
                                case 14:
                                    b = F[c >> 2];
                                    F[c >> 2] = b + 4;
                                    b = F[b >> 2];
                                    F[a >> 2] = b;
                                    F[a + 4 >> 2] = b >> 31;
                                    return;
                                case 2:
                                case 5:
                                case 11:
                                case 15:
                                    b = F[c >> 2];
                                    F[c >> 2] = b + 4;
                                    F[a >> 2] = F[b >> 2];
                                    F[a + 4 >> 2] = 0;
                                    return;
                                case 3:
                                case 10:
                                case 12:
                                case 13: break a;
                            }
                        } b = F[c >> 2] + 7 & -8; F[c >> 2] = b + 8; c = F[b + 4 >> 2]; F[a >> 2] = F[b >> 2]; F[a + 4 >> 2] = c; }
                        function Wb(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0; d = F[a + 8 >> 2]; c = F[a + 4 >> 2]; if (d - c >> 2 >>> 0 >= b >>> 0) {
                            if (b) {
                                b = b << 2;
                                c = ua(c, 0, b) + b | 0;
                            }
                            F[a + 4 >> 2] = c;
                            return;
                        } a: {
                            b: {
                                c: {
                                    g = F[a >> 2];
                                    f = c - g >> 2;
                                    e = f + b | 0;
                                    if (e >>> 0 < 1073741824) {
                                        d = d - g | 0;
                                        h = d >> 1;
                                        e = d >>> 0 < 2147483644 ? e >>> 0 > h >>> 0 ? e : h : 1073741823;
                                        if (e) {
                                            if (e >>> 0 >= 1073741824) {
                                                break c;
                                            }
                                            i = sa(e << 2);
                                        }
                                        d = (f << 2) + i | 0;
                                        f = b << 2;
                                        b = ua(d, 0, f);
                                        f = b + f | 0;
                                        e = (e << 2) + i | 0;
                                        if ((c | 0) == (g | 0)) {
                                            break b;
                                        }
                                        while (1) {
                                            c = c - 4 | 0;
                                            b = F[c >> 2];
                                            F[c >> 2] = 0;
                                            d = d - 4 | 0;
                                            F[d >> 2] = b;
                                            if ((c | 0) != (g | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                        F[a + 8 >> 2] = e;
                                        b = F[a + 4 >> 2];
                                        F[a + 4 >> 2] = f;
                                        c = F[a >> 2];
                                        F[a >> 2] = d;
                                        if ((b | 0) == (c | 0)) {
                                            break a;
                                        }
                                        while (1) {
                                            b = b - 4 | 0;
                                            a = F[b >> 2];
                                            F[b >> 2] = 0;
                                            if (a) {
                                                ga[F[F[a >> 2] + 4 >> 2]](a);
                                            }
                                            if ((b | 0) != (c | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                        break a;
                                    }
                                    va();
                                    V();
                                }
                                wa(1336);
                                V();
                            }
                            F[a + 8 >> 2] = e;
                            F[a + 4 >> 2] = f;
                            F[a >> 2] = b;
                        } if (c) {
                            ra(c);
                        } }
                        function ya(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0; F[a + 16 >> 2] = 0; c = F[a >> 2]; F[a + 4 >> 2] = c; F[a + 12 >> 2] = c; g = F[b + 12 >> 2]; c = g; d = F[b + 20 >> 2]; f = F[b + 16 >> 2]; e = f + 4 | 0; d = e >>> 0 < 4 ? d + 1 | 0 : d; h = F[b + 8 >> 2]; a: {
                            if (h >>> 0 < e >>> 0 & (c | 0) <= (d | 0) | (c | 0) < (d | 0)) {
                                break a;
                            }
                            c = f + F[b >> 2] | 0;
                            c = G[c | 0] | G[c + 1 | 0] << 8 | (G[c + 2 | 0] << 16 | G[c + 3 | 0] << 24);
                            F[b + 16 >> 2] = e;
                            F[b + 20 >> 2] = d;
                            if (!c | c & 3) {
                                break a;
                            }
                            f = g - (d + (e >>> 0 > h >>> 0) | 0) | 0;
                            if (h - e >>> 0 < c >>> 0 & (f | 0) <= 0 | (f | 0) < 0) {
                                break a;
                            }
                            if (c >>> 0 >= 4) {
                                Aa(a, c >>> 2 | 0);
                                h = F[b + 8 >> 2];
                                g = F[b + 12 >> 2];
                                e = F[b + 16 >> 2];
                                d = F[b + 20 >> 2];
                            }
                            f = c + e | 0;
                            d = c >>> 0 > f >>> 0 ? d + 1 | 0 : d;
                            if (f >>> 0 > h >>> 0 & (d | 0) >= (g | 0) | (d | 0) > (g | 0)) {
                                break a;
                            }
                            ta(F[a >> 2], e + F[b >> 2] | 0, c);
                            d = F[b + 20 >> 2];
                            e = c + F[b + 16 >> 2] | 0;
                            d = e >>> 0 < c >>> 0 ? d + 1 | 0 : d;
                            F[b + 16 >> 2] = e;
                            F[b + 20 >> 2] = d;
                            F[a + 16 >> 2] = 0;
                            F[a + 12 >> 2] = F[a >> 2];
                            i = 1;
                        } return i; }
                        function vh(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0; c = sa(72); F[c + 4 >> 2] = 0; F[c + 8 >> 2] = 0; F[c >> 2] = 2012; F[c + 12 >> 2] = 0; F[c + 16 >> 2] = 0; F[c + 20 >> 2] = 0; F[c + 24 >> 2] = 0; F[c + 28 >> 2] = 0; F[c + 32 >> 2] = 0; F[c + 36 >> 2] = 0; F[c + 40 >> 2] = 0; F[c >> 2] = 2156; F[c + 44 >> 2] = 0; F[c + 48 >> 2] = 0; F[c + 52 >> 2] = 0; F[c + 56 >> 2] = 0; F[c + 60 >> 2] = 0; F[c + 64 >> 2] = 0; F[c + 68 >> 2] = 0; h = c; a: {
                            if ((b | 0) >= 0) {
                                g = a + 8 | 0;
                                c = F[a + 12 >> 2];
                                e = F[a + 8 >> 2];
                                f = c - e >> 2;
                                b: {
                                    if ((f | 0) > (b | 0)) {
                                        break b;
                                    }
                                    d = b + 1 | 0;
                                    if (b >>> 0 >= f >>> 0) {
                                        Wb(g, d - f | 0);
                                        break b;
                                    }
                                    if (d >>> 0 >= f >>> 0) {
                                        break b;
                                    }
                                    e = (d << 2) + e | 0;
                                    if ((e | 0) != (c | 0)) {
                                        while (1) {
                                            c = c - 4 | 0;
                                            d = F[c >> 2];
                                            F[c >> 2] = 0;
                                            if (d) {
                                                ga[F[F[d >> 2] + 4 >> 2]](d);
                                            }
                                            if ((c | 0) != (e | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    F[a + 12 >> 2] = e;
                                }
                                a = F[g >> 2] + (b << 2) | 0;
                                c = F[a >> 2];
                                F[a >> 2] = h;
                                if (!c) {
                                    break a;
                                }
                            }
                            ga[F[F[c >> 2] + 4 >> 2]](c);
                        } return (b ^ -1) >>> 31 | 0; }
                        function ua(a, b, c) { var d = 0, e = 0, f = 0; a: {
                            if (!c) {
                                break a;
                            }
                            D[a | 0] = b;
                            e = a + c | 0;
                            D[e - 1 | 0] = b;
                            if (c >>> 0 < 3) {
                                break a;
                            }
                            D[a + 2 | 0] = b;
                            D[a + 1 | 0] = b;
                            D[e - 3 | 0] = b;
                            D[e - 2 | 0] = b;
                            if (c >>> 0 < 7) {
                                break a;
                            }
                            D[a + 3 | 0] = b;
                            D[e - 4 | 0] = b;
                            if (c >>> 0 < 9) {
                                break a;
                            }
                            e = 0 - a & 3;
                            f = e + a | 0;
                            d = L(b & 255, 16843009);
                            F[f >> 2] = d;
                            b = c - e & -4;
                            c = b + f | 0;
                            F[c - 4 >> 2] = d;
                            if (b >>> 0 < 9) {
                                break a;
                            }
                            F[f + 8 >> 2] = d;
                            F[f + 4 >> 2] = d;
                            F[c - 8 >> 2] = d;
                            F[c - 12 >> 2] = d;
                            if (b >>> 0 < 25) {
                                break a;
                            }
                            F[f + 24 >> 2] = d;
                            F[f + 20 >> 2] = d;
                            F[f + 16 >> 2] = d;
                            F[f + 12 >> 2] = d;
                            F[c - 16 >> 2] = d;
                            F[c - 20 >> 2] = d;
                            F[c - 24 >> 2] = d;
                            F[c - 28 >> 2] = d;
                            c = b;
                            b = f & 4 | 24;
                            c = c - b | 0;
                            if (c >>> 0 < 32) {
                                break a;
                            }
                            d = Hj(d, 0, 1, 1);
                            e = fa;
                            b = b + f | 0;
                            while (1) {
                                F[b + 24 >> 2] = d;
                                F[b + 28 >> 2] = e;
                                F[b + 16 >> 2] = d;
                                F[b + 20 >> 2] = e;
                                F[b + 8 >> 2] = d;
                                F[b + 12 >> 2] = e;
                                F[b >> 2] = d;
                                F[b + 4 >> 2] = e;
                                b = b + 32 | 0;
                                c = c - 32 | 0;
                                if (c >>> 0 > 31) {
                                    continue;
                                }
                                break;
                            }
                        } return a; }
                        function ae(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0; d = -1; f = -1; e = -1; a: {
                            b: {
                                if ((b | 0) == -1) {
                                    break b;
                                }
                                g = 1;
                                f = F[F[F[a + 4 >> 2] + 12 >> 2] + (b << 2) >> 2];
                                c = b + 1 | 0;
                                c = (c >>> 0) % 3 | 0 ? c : b - 2 | 0;
                                if ((c | 0) >= 0) {
                                    e = (c >>> 0) / 3 | 0;
                                    e = F[(F[F[a >> 2] + 96 >> 2] + L(e, 12) | 0) + (c - L(e, 3) << 2) >> 2];
                                }
                                c: {
                                    if ((f | 0) == -1) {
                                        break c;
                                    }
                                    g = 0;
                                    c = ((f >>> 0) % 3 | 0 ? -1 : 2) + f | 0;
                                    if ((c | 0) < 0) {
                                        break c;
                                    }
                                    d = (c >>> 0) / 3 | 0;
                                    d = F[(F[F[a >> 2] + 96 >> 2] + L(d, 12) | 0) + (c - L(d, 3) << 2) >> 2];
                                }
                                c = -1;
                                if ((d | 0) != (e | 0)) {
                                    break a;
                                }
                                e = -1;
                                d: {
                                    b = ((b >>> 0) % 3 | 0 ? -1 : 2) + b | 0;
                                    if ((b | 0) >= 0) {
                                        d = (b >>> 0) / 3 | 0;
                                        d = F[(F[F[a >> 2] + 96 >> 2] + L(d, 12) | 0) + (b - L(d, 3) << 2) >> 2];
                                        if (g) {
                                            break b;
                                        }
                                        break d;
                                    }
                                    d = -1;
                                    if (!g) {
                                        break d;
                                    }
                                    break b;
                                }
                                b = f + 1 | 0;
                                b = (b >>> 0) % 3 | 0 ? b : f - 2 | 0;
                                if ((b | 0) < 0) {
                                    break b;
                                }
                                c = F[F[a >> 2] + 96 >> 2];
                                a = (b >>> 0) / 3 | 0;
                                e = F[(c + L(a, 12) | 0) + (b - L(a, 3) << 2) >> 2];
                            }
                            c = (d | 0) == (e | 0) ? f : -1;
                        } return c; }
                        function Dh(a) { a = a | 0; var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0; b = F[a + 4 >> 2]; d = F[b >> 2]; a: {
                            c = F[a + 12 >> 2];
                            c = F[c + 56 >> 2] - F[c + 52 >> 2] | 0;
                            e = c >> 2;
                            b: {
                                if (e >>> 0 <= F[b + 8 >> 2] - d >> 2 >>> 0) {
                                    break b;
                                }
                                if ((c | 0) < 0) {
                                    break a;
                                }
                                f = F[b + 4 >> 2];
                                c = sa(c);
                                g = c + (e << 2) | 0;
                                e = f - d | 0;
                                f = e + c | 0;
                                if ((e | 0) > 0) {
                                    ta(c, d, e);
                                }
                                F[b + 8 >> 2] = g;
                                F[b + 4 >> 2] = f;
                                F[b >> 2] = c;
                                if (!d) {
                                    break b;
                                }
                                ra(d);
                            }
                            e = a + 8 | 0;
                            b = F[a + 76 >> 2];
                            c: {
                                if (b) {
                                    d = F[b >> 2];
                                    if ((d | 0) == F[b + 4 >> 2]) {
                                        return 1;
                                    }
                                    b = 0;
                                    while (1) {
                                        c = te(e, F[(b << 2) + d >> 2]);
                                        if (!c) {
                                            break c;
                                        }
                                        f = F[a + 76 >> 2];
                                        d = F[f >> 2];
                                        b = b + 1 | 0;
                                        if (b >>> 0 < F[f + 4 >> 2] - d >> 2 >>> 0) {
                                            continue;
                                        }
                                        break;
                                    }
                                    break c;
                                }
                                c = 1;
                                a = F[F[a + 12 >> 2] + 64 >> 2];
                                a = F[a + 4 >> 2] - F[a >> 2] | 0;
                                if (a >>> 0 < 12) {
                                    break c;
                                }
                                a = (a >> 2 >>> 0) / 3 | 0;
                                b = 0;
                                while (1) {
                                    c = te(e, L(b, 3));
                                    if (!c) {
                                        break c;
                                    }
                                    b = b + 1 | 0;
                                    if ((a | 0) != (b | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            return c | 0;
                        } wa(1336); V(); }
                        function Dj(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0; d = F[b + 12 >> 2]; h = d; c = F[b + 20 >> 2]; e = c; f = F[b + 16 >> 2]; g = f + 4 | 0; c = g >>> 0 < 4 ? c + 1 | 0 : c; i = F[b + 8 >> 2]; a: {
                            if (i >>> 0 < g >>> 0 & (c | 0) >= (d | 0) | (c | 0) > (d | 0)) {
                                break a;
                            }
                            j = F[b >> 2];
                            d = j + f | 0;
                            d = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                            F[b + 16 >> 2] = g;
                            F[b + 20 >> 2] = c;
                            c = e;
                            e = f + 8 | 0;
                            c = e >>> 0 < 8 ? c + 1 | 0 : c;
                            f = e;
                            e = c;
                            if (f >>> 0 > i >>> 0 & (c | 0) >= (h | 0) | (c | 0) > (h | 0)) {
                                break a;
                            }
                            c = g + j | 0;
                            c = G[c | 0] | G[c + 1 | 0] << 8 | (G[c + 2 | 0] << 16 | G[c + 3 | 0] << 24);
                            F[b + 16 >> 2] = f;
                            F[b + 20 >> 2] = e;
                            if ((c | 0) < (d | 0)) {
                                break a;
                            }
                            F[a + 16 >> 2] = c;
                            F[a + 12 >> 2] = d;
                            b = (c >> 31) - ((d >> 31) + (c >>> 0 < d >>> 0) | 0) | 0;
                            c = c - d | 0;
                            if (!b & c >>> 0 > 2147483646 | b) {
                                break a;
                            }
                            k = 1;
                            b = c + 1 | 0;
                            F[a + 20 >> 2] = b;
                            c = b >>> 1 | 0;
                            F[a + 24 >> 2] = c;
                            F[a + 28 >> 2] = 0 - c;
                            if (b & 1) {
                                break a;
                            }
                            F[a + 24 >> 2] = c - 1;
                        } return k | 0; }
                        function Gg(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; var e = 0, f = 0, g = 0; f = ea + -64 | 0; ea = f; e = f + 8 | 0; E[e + 38 >> 1] = 0; F[e >> 2] = 0; F[e + 8 >> 2] = 0; F[e + 12 >> 2] = 0; F[e + 16 >> 2] = 0; F[e + 20 >> 2] = 0; F[e + 24 >> 2] = 0; F[e + 28 >> 2] = 0; D[e + 29 | 0] = 0; D[e + 30 | 0] = 0; D[e + 31 | 0] = 0; D[e + 32 | 0] = 0; D[e + 33 | 0] = 0; D[e + 34 | 0] = 0; D[e + 35 | 0] = 0; D[e + 36 | 0] = 0; F[e + 16 >> 2] = 0; F[e + 20 >> 2] = 0; F[e >> 2] = b; F[e + 8 >> 2] = c; F[e + 12 >> 2] = 0; b = f + 48 | 0; Me(b, a, e, d); F[a + 24 >> 2] = F[f + 48 >> 2]; c = a + 24 | 0; a: {
                            if ((c | 0) == (b | 0)) {
                                break a;
                            }
                            e = f + 48 | 4;
                            b = G[f + 63 | 0];
                            d = b << 24 >> 24;
                            g = a + 28 | 0;
                            if (D[g + 11 | 0] >= 0) {
                                if ((d | 0) >= 0) {
                                    a = F[e + 4 >> 2];
                                    F[g >> 2] = F[e >> 2];
                                    F[g + 4 >> 2] = a;
                                    F[g + 8 >> 2] = F[e + 8 >> 2];
                                    break a;
                                }
                                Zb(g, F[f + 52 >> 2], F[f + 56 >> 2]);
                                break a;
                            }
                            a = (d | 0) < 0;
                            _b(g, a ? F[f + 52 >> 2] : e, a ? F[f + 56 >> 2] : b);
                        } if (D[f + 63 | 0] < 0) {
                            ra(F[f + 52 >> 2]);
                        } ea = f - -64 | 0; return c | 0; }
                        function Fg(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; var e = 0, f = 0, g = 0; f = ea + -64 | 0; ea = f; e = f + 8 | 0; E[e + 38 >> 1] = 0; F[e >> 2] = 0; F[e + 8 >> 2] = 0; F[e + 12 >> 2] = 0; F[e + 16 >> 2] = 0; F[e + 20 >> 2] = 0; F[e + 24 >> 2] = 0; F[e + 28 >> 2] = 0; D[e + 29 | 0] = 0; D[e + 30 | 0] = 0; D[e + 31 | 0] = 0; D[e + 32 | 0] = 0; D[e + 33 | 0] = 0; D[e + 34 | 0] = 0; D[e + 35 | 0] = 0; D[e + 36 | 0] = 0; F[e + 16 >> 2] = 0; F[e + 20 >> 2] = 0; F[e >> 2] = b; F[e + 8 >> 2] = c; F[e + 12 >> 2] = 0; b = f + 48 | 0; Le(b, a, e, d); F[a + 24 >> 2] = F[f + 48 >> 2]; c = a + 24 | 0; a: {
                            if ((c | 0) == (b | 0)) {
                                break a;
                            }
                            e = f + 48 | 4;
                            b = G[f + 63 | 0];
                            d = b << 24 >> 24;
                            g = a + 28 | 0;
                            if (D[g + 11 | 0] >= 0) {
                                if ((d | 0) >= 0) {
                                    a = F[e + 4 >> 2];
                                    F[g >> 2] = F[e >> 2];
                                    F[g + 4 >> 2] = a;
                                    F[g + 8 >> 2] = F[e + 8 >> 2];
                                    break a;
                                }
                                Zb(g, F[f + 52 >> 2], F[f + 56 >> 2]);
                                break a;
                            }
                            a = (d | 0) < 0;
                            _b(g, a ? F[f + 52 >> 2] : e, a ? F[f + 56 >> 2] : b);
                        } if (D[f + 63 | 0] < 0) {
                            ra(F[f + 52 >> 2]);
                        } ea = f - -64 | 0; return c | 0; }
                        function Jh(a) { a = a | 0; var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0; b = F[a + 4 >> 2]; d = F[b >> 2]; a: {
                            c = F[a + 12 >> 2];
                            c = F[c + 28 >> 2] - F[c + 24 >> 2] | 0;
                            e = c >> 2;
                            b: {
                                if (e >>> 0 <= F[b + 8 >> 2] - d >> 2 >>> 0) {
                                    break b;
                                }
                                if ((c | 0) < 0) {
                                    break a;
                                }
                                f = F[b + 4 >> 2];
                                c = sa(c);
                                g = c + (e << 2) | 0;
                                e = f - d | 0;
                                f = e + c | 0;
                                if ((e | 0) > 0) {
                                    ta(c, d, e);
                                }
                                F[b + 8 >> 2] = g;
                                F[b + 4 >> 2] = f;
                                F[b >> 2] = c;
                                if (!d) {
                                    break b;
                                }
                                ra(d);
                            }
                            e = a + 8 | 0;
                            b = F[a + 76 >> 2];
                            c: {
                                if (b) {
                                    d = F[b >> 2];
                                    if ((d | 0) == F[b + 4 >> 2]) {
                                        return 1;
                                    }
                                    b = 0;
                                    while (1) {
                                        c = ue(e, F[(b << 2) + d >> 2]);
                                        if (!c) {
                                            break c;
                                        }
                                        f = F[a + 76 >> 2];
                                        d = F[f >> 2];
                                        b = b + 1 | 0;
                                        if (b >>> 0 < F[f + 4 >> 2] - d >> 2 >>> 0) {
                                            continue;
                                        }
                                        break;
                                    }
                                    break c;
                                }
                                c = 1;
                                a = F[a + 12 >> 2];
                                a = F[a + 4 >> 2] - F[a >> 2] | 0;
                                if (a >>> 0 < 12) {
                                    break c;
                                }
                                a = (a >> 2 >>> 0) / 3 | 0;
                                b = 0;
                                while (1) {
                                    c = ue(e, L(b, 3));
                                    if (!c) {
                                        break c;
                                    }
                                    b = b + 1 | 0;
                                    if ((a | 0) != (b | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            return c | 0;
                        } wa(1336); V(); }
                        function td(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0; e = a + 16 | 0; d = F[e >> 2]; a: {
                            if (!d) {
                                break a;
                            }
                            g = F[b >> 2];
                            b = e;
                            while (1) {
                                f = (g | 0) > F[d + 16 >> 2];
                                b = f ? b : d;
                                d = F[(f << 2) + d >> 2];
                                if (d) {
                                    continue;
                                }
                                break;
                            }
                            if ((b | 0) == (e | 0) | (g | 0) < F[b + 16 >> 2]) {
                                break a;
                            }
                            d = F[b + 24 >> 2];
                            if (!d) {
                                break a;
                            }
                            e = G[c + 11 | 0];
                            f = e << 24 >> 24 < 0;
                            g = f ? F[c >> 2] : c;
                            e = f ? F[c + 4 >> 2] : e;
                            f = b + 20 | 0;
                            while (1) {
                                b = G[d + 27 | 0];
                                h = b << 24 >> 24 < 0;
                                b = h ? F[d + 20 >> 2] : b;
                                k = b >>> 0 < e >>> 0;
                                b: {
                                    c: {
                                        j = k ? b : e;
                                        d: {
                                            if (j) {
                                                i = d + 16 | 0;
                                                h = h ? F[i >> 2] : i;
                                                i = Ha(g, h, j);
                                                e: {
                                                    if (!i) {
                                                        if (b >>> 0 <= e >>> 0) {
                                                            break e;
                                                        }
                                                        break b;
                                                    }
                                                    if ((i | 0) < 0) {
                                                        break b;
                                                    }
                                                }
                                                b = Ha(h, g, j);
                                                if (!b) {
                                                    break d;
                                                }
                                                if ((b | 0) < 0) {
                                                    break c;
                                                }
                                                return Sc(f, c);
                                            }
                                            if (b >>> 0 > e >>> 0) {
                                                break b;
                                            }
                                        }
                                        if (k) {
                                            break c;
                                        }
                                        return Sc(f, c);
                                    }
                                    d = d + 4 | 0;
                                }
                                d = F[d >> 2];
                                if (d) {
                                    continue;
                                }
                                break;
                            }
                        } return Sc(a, c); }
                        function qf(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0; d = F[b >> 2]; b = F[b + 4 >> 2]; f = F[F[a + 8 >> 2] + 40 >> 2]; m = sa((f | 0) >= 0 ? f : -1); g = 1; h = b - d | 0; a: {
                            if ((h | 0) <= 0) {
                                break a;
                            }
                            b = 0;
                            g = 0;
                            d = 0 + F[c + 20 >> 2] | 0;
                            i = F[c + 16 >> 2];
                            e = f + i | 0;
                            d = e >>> 0 < f >>> 0 ? d + 1 | 0 : d;
                            j = e;
                            e = F[c + 12 >> 2];
                            if (j >>> 0 > I[c + 8 >> 2] & (e | 0) <= (d | 0) | (d | 0) > (e | 0)) {
                                break a;
                            }
                            k = h >> 2;
                            g = (k | 0) > 1 ? k : 1;
                            while (1) {
                                b: {
                                    e = ta(m, i + F[c >> 2] | 0, f);
                                    F[c + 16 >> 2] = j;
                                    F[c + 20 >> 2] = d;
                                    ta(F[F[F[a + 8 >> 2] + 64 >> 2] >> 2] + b | 0, e, f);
                                    l = l + 1 | 0;
                                    if ((g | 0) == (l | 0)) {
                                        break b;
                                    }
                                    b = b + f | 0;
                                    d = n + F[c + 20 >> 2] | 0;
                                    i = F[c + 16 >> 2];
                                    e = f + i | 0;
                                    d = e >>> 0 < f >>> 0 ? d + 1 | 0 : d;
                                    j = e;
                                    h = e;
                                    e = F[c + 12 >> 2];
                                    if ((e | 0) >= (d | 0) & I[c + 8 >> 2] >= h >>> 0 | (d | 0) < (e | 0)) {
                                        continue;
                                    }
                                }
                                break;
                            }
                            g = (l | 0) >= (k | 0);
                        } ra(m); return g | 0; }
                        function hf(a, b) { a = a | 0; b = b | 0; a = 0; a: {
                            switch (b | 0) {
                                case 0:
                                    a = sa(20);
                                    F[a + 12 >> 2] = -1;
                                    F[a + 16 >> 2] = 0;
                                    F[a + 4 >> 2] = 0;
                                    F[a + 8 >> 2] = 0;
                                    F[a >> 2] = 2260;
                                    return a | 0;
                                case 1:
                                    a = sa(24);
                                    F[a + 12 >> 2] = -1;
                                    F[a + 16 >> 2] = 0;
                                    F[a + 4 >> 2] = 0;
                                    F[a + 8 >> 2] = 0;
                                    F[a >> 2] = 2260;
                                    F[a + 20 >> 2] = 0;
                                    F[a >> 2] = 2476;
                                    return a | 0;
                                case 2:
                                    a = sa(48);
                                    F[a + 12 >> 2] = -1;
                                    F[a + 16 >> 2] = 0;
                                    F[a + 4 >> 2] = 0;
                                    F[a + 8 >> 2] = 0;
                                    F[a >> 2] = 2260;
                                    F[a + 20 >> 2] = 0;
                                    F[a >> 2] = 2476;
                                    F[a + 32 >> 2] = 0;
                                    F[a + 36 >> 2] = 0;
                                    F[a + 28 >> 2] = -1;
                                    F[a + 24 >> 2] = 1140;
                                    F[a >> 2] = 11076;
                                    F[a + 40 >> 2] = 0;
                                    F[a + 44 >> 2] = 0;
                                    return a | 0;
                                case 3:
                                    a = sa(32);
                                    F[a + 12 >> 2] = -1;
                                    F[a + 16 >> 2] = 0;
                                    F[a + 4 >> 2] = 0;
                                    F[a + 8 >> 2] = 0;
                                    F[a >> 2] = 2260;
                                    F[a + 20 >> 2] = 0;
                                    F[a >> 2] = 2476;
                                    F[a + 28 >> 2] = -1;
                                    F[a + 24 >> 2] = 1032;
                                    F[a >> 2] = 7056;
                                    break;
                                default: break a;
                            }
                        } return a | 0; }
                        function Cg(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; var e = 0, f = 0, g = 0; e = ea - 32 | 0; ea = e; a: {
                            b: {
                                f = La(c);
                                if (f >>> 0 < 4294967280) {
                                    c: {
                                        d: {
                                            if (f >>> 0 >= 11) {
                                                g = f + 16 & -16;
                                                a = sa(g);
                                                F[e + 24 >> 2] = g | -2147483648;
                                                F[e + 16 >> 2] = a;
                                                F[e + 20 >> 2] = f;
                                                break d;
                                            }
                                            D[e + 27 | 0] = f;
                                            a = e + 16 | 0;
                                            if (!f) {
                                                break c;
                                            }
                                        }
                                        ta(a, c, f);
                                    }
                                    D[a + f | 0] = 0;
                                    c = La(d);
                                    if (c >>> 0 >= 4294967280) {
                                        break b;
                                    }
                                    e: {
                                        f: {
                                            if (c >>> 0 >= 11) {
                                                f = c + 16 & -16;
                                                a = sa(f);
                                                F[e + 8 >> 2] = f | -2147483648;
                                                F[e >> 2] = a;
                                                F[e + 4 >> 2] = c;
                                                break f;
                                            }
                                            D[e + 11 | 0] = c;
                                            a = e;
                                            if (!c) {
                                                break e;
                                            }
                                        }
                                        ta(a, d, c);
                                    }
                                    D[a + c | 0] = 0;
                                    c = F[b + 4 >> 2];
                                    a = -1;
                                    g: {
                                        if (!c) {
                                            break g;
                                        }
                                        c = _d(c, e + 16 | 0, e);
                                        a = -1;
                                        if (!c) {
                                            break g;
                                        }
                                        a = Wd(b, F[c + 24 >> 2]);
                                    }
                                    if (D[e + 11 | 0] < 0) {
                                        ra(F[e >> 2]);
                                    }
                                    if (D[e + 27 | 0] < 0) {
                                        ra(F[e + 16 >> 2]);
                                    }
                                    ea = e + 32 | 0;
                                    break a;
                                }
                                Ma();
                                V();
                            }
                            Ma();
                            V();
                        } return a | 0; }
                        function Ri(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0; F[b >> 2] = 1; f = b + 8 | 0; c = F[b + 8 >> 2]; d = F[b + 12 >> 2] - c | 0; if (d >>> 0 <= 4294967291) {
                            lc(f, d + 4 | 0);
                            c = F[f >> 2];
                        } c = c + d | 0; d = F[a + 4 >> 2]; D[c | 0] = d; D[c + 1 | 0] = d >>> 8; D[c + 2 | 0] = d >>> 16; D[c + 3 | 0] = d >>> 24; c = F[a + 8 >> 2]; if ((c | 0) != F[a + 12 >> 2]) {
                            d = 0;
                            while (1) {
                                g = (d << 2) + c | 0;
                                c = F[b + 8 >> 2];
                                e = F[b + 12 >> 2] - c | 0;
                                if (e >>> 0 <= 4294967291) {
                                    lc(f, e + 4 | 0);
                                    c = F[f >> 2];
                                }
                                c = c + e | 0;
                                e = F[g >> 2];
                                D[c | 0] = e;
                                D[c + 1 | 0] = e >>> 8;
                                D[c + 2 | 0] = e >>> 16;
                                D[c + 3 | 0] = e >>> 24;
                                d = d + 1 | 0;
                                c = F[a + 8 >> 2];
                                if (d >>> 0 < F[a + 12 >> 2] - c >> 2 >>> 0) {
                                    continue;
                                }
                                break;
                            }
                        } c = F[b + 12 >> 2]; b = F[b + 8 >> 2]; c = c - b | 0; if (c >>> 0 <= 4294967291) {
                            lc(f, c + 4 | 0);
                            b = F[f >> 2];
                        } b = b + c | 0; a = F[a + 20 >> 2]; D[b | 0] = a; D[b + 1 | 0] = a >>> 8; D[b + 2 | 0] = a >>> 16; D[b + 3 | 0] = a >>> 24; }
                        function Na(a, b, c) { var d = 0, e = 0, f = 0, g = 0; e = ea - 16 | 0; ea = e; F[a + 4 >> 2] = 0; a: {
                            b: {
                                if (!b) {
                                    break b;
                                }
                                g = F[a + 8 >> 2];
                                d = g << 5;
                                c: {
                                    if (d >>> 0 >= b >>> 0) {
                                        F[a + 4 >> 2] = b;
                                        break c;
                                    }
                                    F[e + 8 >> 2] = 0;
                                    F[e >> 2] = 0;
                                    F[e + 4 >> 2] = 0;
                                    if ((b | 0) < 0) {
                                        break a;
                                    }
                                    if (d >>> 0 <= 1073741822) {
                                        f = b + 31 & -32;
                                        d = g << 6;
                                        d = d >>> 0 < f >>> 0 ? f : d;
                                    }
                                    else {
                                        d = 2147483647;
                                    }
                                    db(e, d);
                                    f = F[a >> 2];
                                    F[a >> 2] = F[e >> 2];
                                    F[e >> 2] = f;
                                    d = F[a + 4 >> 2];
                                    F[a + 4 >> 2] = b;
                                    F[e + 4 >> 2] = d;
                                    d = F[a + 8 >> 2];
                                    F[a + 8 >> 2] = F[e + 8 >> 2];
                                    F[e + 8 >> 2] = d;
                                    if (!f) {
                                        break c;
                                    }
                                    ra(f);
                                }
                                f = b >>> 5 | 0;
                                d = f << 2;
                                a = F[a >> 2];
                                if (G[c | 0]) {
                                    a = ua(a, 255, d);
                                    b = b & 31;
                                    if (!b) {
                                        break b;
                                    }
                                    a = a + (f << 2) | 0;
                                    F[a >> 2] = F[a >> 2] | -1 >>> 32 - b;
                                    break b;
                                }
                                a = ua(a, 0, d);
                                b = b & 31;
                                if (!b) {
                                    break b;
                                }
                                a = a + (f << 2) | 0;
                                F[a >> 2] = F[a >> 2] & (-1 >>> 32 - b ^ -1);
                            }
                            ea = e + 16 | 0;
                            return;
                        } Oa(); V(); }
                        function nb(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0; d = F[a + 4 >> 2]; e = F[a + 8 >> 2]; if (d >>> 0 < e >>> 0) {
                            F[d >> 2] = F[b >> 2];
                            F[d + 4 >> 2] = F[b + 4 >> 2];
                            F[d + 8 >> 2] = F[b + 8 >> 2];
                            F[a + 4 >> 2] = d + 12;
                            return;
                        } a: {
                            f = F[a >> 2];
                            g = (d - f | 0) / 12 | 0;
                            c = g + 1 | 0;
                            if (c >>> 0 < 357913942) {
                                e = (e - f | 0) / 12 | 0;
                                h = e << 1;
                                c = e >>> 0 < 178956970 ? c >>> 0 > h >>> 0 ? c : h : 357913941;
                                if (c >>> 0 >= 357913942) {
                                    break a;
                                }
                                h = L(g, 12);
                                e = L(c, 12);
                                g = sa(e);
                                c = h + g | 0;
                                F[c >> 2] = F[b >> 2];
                                F[c + 4 >> 2] = F[b + 4 >> 2];
                                F[c + 8 >> 2] = F[b + 8 >> 2];
                                b = c + 12 | 0;
                                if ((d | 0) != (f | 0)) {
                                    while (1) {
                                        c = c - 12 | 0;
                                        d = d - 12 | 0;
                                        F[c >> 2] = F[d >> 2];
                                        F[c + 4 >> 2] = F[d + 4 >> 2];
                                        F[c + 8 >> 2] = F[d + 8 >> 2];
                                        if ((d | 0) != (f | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                F[a + 8 >> 2] = e + g;
                                F[a + 4 >> 2] = b;
                                F[a >> 2] = c;
                                if (f) {
                                    ra(f);
                                }
                                return;
                            }
                            va();
                            V();
                        } wa(1336); V(); }
                        function Li(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0; f = ea - 32 | 0; ea = f; g = (e & 1073741823) != (e | 0) ? -1 : e << 2; l = ua(sa(g), 0, g); g = l; i = F[g >> 2]; g = F[g + 4 >> 2]; k = F[b + 4 >> 2]; F[f + 24 >> 2] = F[b >> 2]; F[f + 28 >> 2] = k; F[f + 8 >> 2] = i; F[f + 12 >> 2] = g; i = a + 8 | 0; sc(f + 16 | 0, i, f + 8 | 0, f + 24 | 0); F[c >> 2] = F[f + 16 >> 2]; F[c + 4 >> 2] = F[f + 20 >> 2]; if ((d | 0) > (e | 0)) {
                            k = 0 - e << 2;
                            a = e;
                            while (1) {
                                h = a << 2;
                                g = h + c | 0;
                                j = g + k | 0;
                                m = F[j >> 2];
                                j = F[j + 4 >> 2];
                                h = b + h | 0;
                                n = F[h + 4 >> 2];
                                F[f + 24 >> 2] = F[h >> 2];
                                F[f + 28 >> 2] = n;
                                F[f + 8 >> 2] = m;
                                F[f + 12 >> 2] = j;
                                sc(f + 16 | 0, i, f + 8 | 0, f + 24 | 0);
                                F[g >> 2] = F[f + 16 >> 2];
                                F[g + 4 >> 2] = F[f + 20 >> 2];
                                a = a + e | 0;
                                if ((d | 0) > (a | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } ra(l); ea = f + 32 | 0; return 1; }
                        function Ci(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0; f = ea - 32 | 0; ea = f; h = (e & 1073741823) != (e | 0) ? -1 : e << 2; h = ua(sa(h), 0, h); g = F[b >> 2]; i = F[b + 4 >> 2]; k = F[h + 4 >> 2]; F[f + 16 >> 2] = F[h >> 2]; F[f + 20 >> 2] = k; F[f + 8 >> 2] = g; F[f + 12 >> 2] = i; i = a + 8 | 0; rc(f + 24 | 0, i, f + 16 | 0, f + 8 | 0); F[c >> 2] = F[f + 24 >> 2]; F[c + 4 >> 2] = F[f + 28 >> 2]; if ((d | 0) > (e | 0)) {
                            k = 0 - e << 2;
                            a = e;
                            while (1) {
                                g = a << 2;
                                j = g + b | 0;
                                m = F[j >> 2];
                                j = F[j + 4 >> 2];
                                g = c + g | 0;
                                l = g + k | 0;
                                n = F[l + 4 >> 2];
                                F[f + 16 >> 2] = F[l >> 2];
                                F[f + 20 >> 2] = n;
                                F[f + 8 >> 2] = m;
                                F[f + 12 >> 2] = j;
                                rc(f + 24 | 0, i, f + 16 | 0, f + 8 | 0);
                                F[g >> 2] = F[f + 24 >> 2];
                                F[g + 4 >> 2] = F[f + 28 >> 2];
                                a = a + e | 0;
                                if ((d | 0) > (a | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } ra(h); ea = f + 32 | 0; return 1; }
                        function Pi(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0; e = F[b + 12 >> 2]; c = F[b + 20 >> 2]; f = c; g = F[b + 16 >> 2]; d = g + 4 | 0; c = d >>> 0 < 4 ? c + 1 | 0 : c; h = F[b + 8 >> 2]; i = d; a: {
                            if (h >>> 0 < d >>> 0 & (c | 0) >= (e | 0) | (c | 0) > (e | 0)) {
                                break a;
                            }
                            d = g + F[b >> 2] | 0;
                            d = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                            F[b + 16 >> 2] = i;
                            F[b + 20 >> 2] = c;
                            if (H[b + 38 >> 1] <= 513) {
                                c = f;
                                f = g + 8 | 0;
                                c = f >>> 0 < 8 ? c + 1 | 0 : c;
                                if (f >>> 0 > h >>> 0 & (c | 0) >= (e | 0) | (c | 0) > (e | 0)) {
                                    break a;
                                }
                                F[b + 16 >> 2] = f;
                                F[b + 20 >> 2] = c;
                            }
                            if (!(d & 1)) {
                                break a;
                            }
                            b = O(d) ^ 31;
                            c = b - 30 | 0;
                            if (c >>> 0 >= 4294967267) {
                                F[a + 8 >> 2] = b + 1;
                                e = -2 << b;
                                b = -2 - e | 0;
                                F[a + 16 >> 2] = b;
                                F[a + 12 >> 2] = e ^ -1;
                                F[a + 24 >> 2] = (b | 0) / 2;
                                J[a + 20 >> 2] = M(2) / M(b | 0);
                            }
                            j = c >>> 0 > 4294967266;
                        } return j | 0; }
                        function Db(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0; f = c - b | 0; g = f >> 2; d = F[a + 8 >> 2]; e = F[a >> 2]; if (g >>> 0 <= d - e >> 2 >>> 0) {
                            f = F[a + 4 >> 2];
                            d = f - e | 0;
                            h = d >> 2;
                            d = g >>> 0 > h >>> 0 ? b + d | 0 : c;
                            if ((d | 0) != (b | 0)) {
                                while (1) {
                                    F[e >> 2] = F[b >> 2];
                                    e = e + 4 | 0;
                                    b = b + 4 | 0;
                                    if ((d | 0) != (b | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            if (g >>> 0 > h >>> 0) {
                                b = c - d | 0;
                                if ((b | 0) > 0) {
                                    f = ta(f, d, b) + b | 0;
                                }
                                F[a + 4 >> 2] = f;
                                return;
                            }
                            F[a + 4 >> 2] = e;
                            return;
                        } if (e) {
                            F[a + 4 >> 2] = e;
                            ra(e);
                            F[a + 8 >> 2] = 0;
                            F[a >> 2] = 0;
                            F[a + 4 >> 2] = 0;
                            d = 0;
                        } a: {
                            if ((f | 0) < 0) {
                                break a;
                            }
                            c = d >> 1;
                            c = d >>> 0 < 2147483644 ? c >>> 0 < g >>> 0 ? g : c : 1073741823;
                            if (c >>> 0 >= 1073741824) {
                                break a;
                            }
                            e = c << 2;
                            c = sa(e);
                            F[a >> 2] = c;
                            F[a + 4 >> 2] = c;
                            F[a + 8 >> 2] = c + e;
                            if (f) {
                                c = ta(c, b, f) + f | 0;
                            }
                            F[a + 4 >> 2] = c;
                            return;
                        } va(); V(); }
                        function rf(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0; f = 1; a: {
                            if ((ga[F[F[b >> 2] + 20 >> 2]](b) | 0) <= 0) {
                                break a;
                            }
                            while (1) {
                                f = 0;
                                c = Xd(F[F[a + 4 >> 2] + 4 >> 2], ga[F[F[b >> 2] + 24 >> 2]](b, g) | 0);
                                if ((c | 0) == -1) {
                                    break a;
                                }
                                e = F[a + 4 >> 2];
                                b: {
                                    if (G[e + 36 | 0] <= 1) {
                                        if (ga[F[F[b >> 2] + 28 >> 2]](b, F[F[F[e + 4 >> 2] + 8 >> 2] + (c << 2) >> 2]) | 0) {
                                            break b;
                                        }
                                        break a;
                                    }
                                    d = 0;
                                    c: {
                                        if ((c | 0) < 0) {
                                            break c;
                                        }
                                        h = F[e + 4 >> 2];
                                        if (F[h + 12 >> 2] - F[h + 8 >> 2] >> 2 <= (c | 0)) {
                                            break c;
                                        }
                                        d = F[F[e + 8 >> 2] + (F[F[e + 20 >> 2] + (c << 2) >> 2] << 2) >> 2];
                                        d = ga[F[F[d >> 2] + 32 >> 2]](d, c) | 0;
                                    }
                                    if (!d) {
                                        break a;
                                    }
                                    if (!(ga[F[F[b >> 2] + 28 >> 2]](b, d) | 0)) {
                                        break a;
                                    }
                                }
                                f = 1;
                                g = g + 1 | 0;
                                if ((ga[F[F[b >> 2] + 20 >> 2]](b) | 0) > (g | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } return f | 0; }
                        function Mg(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0; a = ea - 32 | 0; ea = a; F[a + 24 >> 2] = 0; F[a + 28 >> 2] = 0; a: {
                            d = La(c);
                            if (d >>> 0 < 4294967280) {
                                b: {
                                    c: {
                                        if (d >>> 0 >= 11) {
                                            f = d + 16 & -16;
                                            e = sa(f);
                                            F[a + 16 >> 2] = f | -2147483648;
                                            F[a + 8 >> 2] = e;
                                            F[a + 12 >> 2] = d;
                                            break c;
                                        }
                                        D[a + 19 | 0] = d;
                                        e = a + 8 | 0;
                                        if (!d) {
                                            break b;
                                        }
                                    }
                                    ta(e, c, d);
                                }
                                D[d + e | 0] = 0;
                                c = b + 4 | 0;
                                b = rb(b, a + 8 | 0);
                                d: {
                                    if ((c | 0) == (b | 0)) {
                                        break d;
                                    }
                                    c = F[b + 32 >> 2];
                                    b = F[b + 28 >> 2];
                                    if ((c - b | 0) != 8) {
                                        break d;
                                    }
                                    c = G[b + 4 | 0] | G[b + 5 | 0] << 8 | (G[b + 6 | 0] << 16 | G[b + 7 | 0] << 24);
                                    F[a + 24 >> 2] = G[b | 0] | G[b + 1 | 0] << 8 | (G[b + 2 | 0] << 16 | G[b + 3 | 0] << 24);
                                    F[a + 28 >> 2] = c;
                                }
                                g = K[a + 24 >> 3];
                                if (D[a + 19 | 0] < 0) {
                                    ra(F[a + 8 >> 2]);
                                }
                                ea = a + 32 | 0;
                                break a;
                            }
                            Ma();
                            V();
                        } return +g; }
                        function Be(a) { var b = 0, c = 0, d = 0, e = 0; c = 1; d = F[a + 140 >> 2]; a: {
                            if ((d | 0) <= 0) {
                                break a;
                            }
                            b = d << 4;
                            c = sa((d | 0) != (d & 268435455) ? -1 : b | 4);
                            F[c >> 2] = d;
                            c = c + 4 | 0;
                            d = c + b | 0;
                            b = c;
                            while (1) {
                                F[b >> 2] = 0;
                                F[b + 4 >> 2] = 0;
                                D[b + 5 | 0] = 0;
                                D[b + 6 | 0] = 0;
                                D[b + 7 | 0] = 0;
                                D[b + 8 | 0] = 0;
                                D[b + 9 | 0] = 0;
                                D[b + 10 | 0] = 0;
                                D[b + 11 | 0] = 0;
                                D[b + 12 | 0] = 0;
                                b = b + 16 | 0;
                                if ((d | 0) != (b | 0)) {
                                    continue;
                                }
                                break;
                            }
                            e = F[a + 136 >> 2];
                            F[a + 136 >> 2] = c;
                            if (e) {
                                d = e - 4 | 0;
                                c = F[d >> 2];
                                if (c) {
                                    b = (c << 4) + e | 0;
                                    while (1) {
                                        b = b - 16 | 0;
                                        if ((e | 0) != (b | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                ra(d);
                            }
                            c = 1;
                            if (F[a + 140 >> 2] <= 0) {
                                break a;
                            }
                            b = 0;
                            while (1) {
                                c = xa(F[a + 136 >> 2] + (b << 4) | 0, a);
                                if (!c) {
                                    break a;
                                }
                                b = b + 1 | 0;
                                if ((b | 0) < F[a + 140 >> 2]) {
                                    continue;
                                }
                                break;
                            }
                        } return c; }
                        function qb(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0; a: {
                            if (F[a + 64 >> 2]) {
                                break a;
                            }
                            c = sa(32);
                            F[c + 16 >> 2] = 0;
                            F[c + 20 >> 2] = 0;
                            F[c + 8 >> 2] = 0;
                            F[c >> 2] = 0;
                            F[c + 4 >> 2] = 0;
                            F[c + 24 >> 2] = 0;
                            F[c + 28 >> 2] = 0;
                            d = F[a + 64 >> 2];
                            F[a + 64 >> 2] = c;
                            if (!d) {
                                break a;
                            }
                            c = F[d >> 2];
                            if (c) {
                                F[d + 4 >> 2] = c;
                                ra(c);
                            }
                            ra(d);
                        } e = F[a + 64 >> 2]; c = F[a + 28 >> 2] - 1 | 0; if (c >>> 0 <= 10) {
                            d = F[(c << 2) + 13616 >> 2];
                        }
                        else {
                            d = -1;
                        } c = L(d, D[a + 24 | 0]); d = c; g = c >> 31; e = qe(e, 0, Hj(c, g, b, 0), fa); if (e) {
                            c = F[a + 64 >> 2];
                            F[a >> 2] = c;
                            f = F[c + 20 >> 2];
                            F[a + 8 >> 2] = F[c + 16 >> 2];
                            F[a + 12 >> 2] = f;
                            f = F[c + 24 >> 2];
                            c = F[c + 28 >> 2];
                            F[a + 48 >> 2] = 0;
                            F[a + 52 >> 2] = 0;
                            F[a + 40 >> 2] = d;
                            F[a + 44 >> 2] = g;
                            F[a + 16 >> 2] = f;
                            F[a + 20 >> 2] = c;
                            F[a + 80 >> 2] = b;
                        } return e; }
                        function Gi(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0; f = F[b + 12 >> 2]; c = F[b + 20 >> 2]; e = c; g = F[b + 16 >> 2]; d = g + 4 | 0; c = d >>> 0 < 4 ? c + 1 | 0 : c; h = F[b + 8 >> 2]; i = d; a: {
                            if (h >>> 0 < d >>> 0 & (c | 0) >= (f | 0) | (c | 0) > (f | 0)) {
                                break a;
                            }
                            d = g + F[b >> 2] | 0;
                            d = G[d | 0] | G[d + 1 | 0] << 8 | (G[d + 2 | 0] << 16 | G[d + 3 | 0] << 24);
                            F[b + 16 >> 2] = i;
                            F[b + 20 >> 2] = c;
                            c = e;
                            e = g + 8 | 0;
                            c = e >>> 0 < 8 ? c + 1 | 0 : c;
                            if (e >>> 0 > h >>> 0 & (c | 0) >= (f | 0) | (c | 0) > (f | 0)) {
                                break a;
                            }
                            F[b + 16 >> 2] = e;
                            F[b + 20 >> 2] = c;
                            if (!(d & 1)) {
                                break a;
                            }
                            b = O(d) ^ 31;
                            if (b - 30 >>> 0 < 4294967267) {
                                break a;
                            }
                            j = 1;
                            F[a + 8 >> 2] = b + 1;
                            c = -2 << b;
                            b = -2 - c | 0;
                            F[a + 16 >> 2] = b;
                            F[a + 12 >> 2] = c ^ -1;
                            F[a + 24 >> 2] = (b | 0) / 2;
                            J[a + 20 >> 2] = M(2) / M(b | 0);
                        } return j | 0; }
                        function Ke(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0; f = a + 4 | 0; a: {
                            a = F[a + 4 >> 2];
                            if (a) {
                                e = G[c + 11 | 0];
                                d = e << 24 >> 24 < 0;
                                i = d ? F[c >> 2] : c;
                                e = d ? F[c + 4 >> 2] : e;
                                while (1) {
                                    c = G[a + 27 | 0];
                                    d = c << 24 >> 24 < 0;
                                    c = d ? F[a + 20 >> 2] : c;
                                    j = c >>> 0 < e >>> 0;
                                    b: {
                                        c: {
                                            d: {
                                                e: {
                                                    f: {
                                                        h = j ? c : e;
                                                        g: {
                                                            if (h) {
                                                                g = a + 16 | 0;
                                                                d = d ? F[g >> 2] : g;
                                                                g = Ha(i, d, h);
                                                                if (!g) {
                                                                    if (c >>> 0 > e >>> 0) {
                                                                        break g;
                                                                    }
                                                                    break f;
                                                                }
                                                                if ((g | 0) >= 0) {
                                                                    break f;
                                                                }
                                                                break g;
                                                            }
                                                            if (c >>> 0 <= e >>> 0) {
                                                                break e;
                                                            }
                                                        }
                                                        c = F[a >> 2];
                                                        if (c) {
                                                            break b;
                                                        }
                                                        F[b >> 2] = a;
                                                        return a;
                                                    }
                                                    c = Ha(d, i, h);
                                                    if (c) {
                                                        break d;
                                                    }
                                                }
                                                if (j) {
                                                    break c;
                                                }
                                                break a;
                                            }
                                            if ((c | 0) >= 0) {
                                                break a;
                                            }
                                        }
                                        f = a + 4 | 0;
                                        c = F[a + 4 >> 2];
                                        if (!c) {
                                            break a;
                                        }
                                        a = f;
                                    }
                                    f = a;
                                    a = c;
                                    continue;
                                }
                            }
                            F[b >> 2] = f;
                            return f;
                        } F[b >> 2] = a; return f; }
                        function kc(a, b) { var c = 0; c = F[b + 4 >> 2]; F[a >> 2] = F[b >> 2]; F[a + 4 >> 2] = c; c = F[b + 60 >> 2]; F[a + 56 >> 2] = F[b + 56 >> 2]; F[a + 60 >> 2] = c; c = F[b + 52 >> 2]; F[a + 48 >> 2] = F[b + 48 >> 2]; F[a + 52 >> 2] = c; c = F[b + 44 >> 2]; F[a + 40 >> 2] = F[b + 40 >> 2]; F[a + 44 >> 2] = c; c = F[b + 36 >> 2]; F[a + 32 >> 2] = F[b + 32 >> 2]; F[a + 36 >> 2] = c; c = F[b + 28 >> 2]; F[a + 24 >> 2] = F[b + 24 >> 2]; F[a + 28 >> 2] = c; c = F[b + 20 >> 2]; F[a + 16 >> 2] = F[b + 16 >> 2]; F[a + 20 >> 2] = c; c = F[b + 12 >> 2]; F[a + 8 >> 2] = F[b + 8 >> 2]; F[a + 12 >> 2] = c; F[a + 88 >> 2] = 0; F[a + 64 >> 2] = 0; F[a + 68 >> 2] = 0; F[a + 72 >> 2] = 0; F[a + 76 >> 2] = 0; D[a + 77 | 0] = 0; D[a + 78 | 0] = 0; D[a + 79 | 0] = 0; D[a + 80 | 0] = 0; D[a + 81 | 0] = 0; D[a + 82 | 0] = 0; D[a + 83 | 0] = 0; D[a + 84 | 0] = 0; return a; }
                        function rb(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0; g = a + 4 | 0; a = F[a + 4 >> 2]; a: {
                            b: {
                                if (!a) {
                                    break b;
                                }
                                d = G[b + 11 | 0];
                                c = d << 24 >> 24 < 0;
                                i = c ? F[b >> 2] : b;
                                e = c ? F[b + 4 >> 2] : d;
                                c = g;
                                while (1) {
                                    b = G[a + 27 | 0];
                                    j = b << 24 >> 24 < 0;
                                    h = j ? F[a + 20 >> 2] : b;
                                    f = h >>> 0 > e >>> 0;
                                    d = f ? e : h;
                                    c: {
                                        if (d) {
                                            b = a + 16 | 0;
                                            b = Ha(j ? F[b >> 2] : b, i, d);
                                            if (b) {
                                                break c;
                                            }
                                        }
                                        b = e >>> 0 > h >>> 0 ? -1 : f;
                                    }
                                    c = (b | 0) < 0 ? c : a;
                                    a = F[(b >>> 29 & 4) + a >> 2];
                                    if (a) {
                                        continue;
                                    }
                                    break;
                                }
                                if ((c | 0) == (g | 0)) {
                                    break b;
                                }
                                a = G[c + 27 | 0];
                                f = a << 24 >> 24 < 0;
                                d: {
                                    d = f ? F[c + 20 >> 2] : a;
                                    b = d >>> 0 < e >>> 0 ? d : e;
                                    if (b) {
                                        a = c + 16 | 0;
                                        a = Ha(i, f ? F[a >> 2] : a, b);
                                        if (a) {
                                            break d;
                                        }
                                    }
                                    if (d >>> 0 > e >>> 0) {
                                        break b;
                                    }
                                    break a;
                                }
                                if ((a | 0) >= 0) {
                                    break a;
                                }
                            }
                            c = g;
                        } return c; }
                        function Ff(a, b, c, d, e) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; if (Za(a, F[b + 8 >> 2], e)) {
                            if (!(F[b + 28 >> 2] == 1 | F[b + 4 >> 2] != (c | 0))) {
                                F[b + 28 >> 2] = d;
                            }
                            return;
                        } a: {
                            if (Za(a, F[b >> 2], e)) {
                                if (!(F[b + 16 >> 2] != (c | 0) & F[b + 20 >> 2] != (c | 0))) {
                                    if ((d | 0) != 1) {
                                        break a;
                                    }
                                    F[b + 32 >> 2] = 1;
                                    return;
                                }
                                F[b + 32 >> 2] = d;
                                b: {
                                    if (F[b + 44 >> 2] == 4) {
                                        break b;
                                    }
                                    E[b + 52 >> 1] = 0;
                                    a = F[a + 8 >> 2];
                                    ga[F[F[a >> 2] + 20 >> 2]](a, b, c, c, 1, e);
                                    if (G[b + 53 | 0]) {
                                        F[b + 44 >> 2] = 3;
                                        if (!G[b + 52 | 0]) {
                                            break b;
                                        }
                                        break a;
                                    }
                                    F[b + 44 >> 2] = 4;
                                }
                                F[b + 20 >> 2] = c;
                                F[b + 40 >> 2] = F[b + 40 >> 2] + 1;
                                if (F[b + 36 >> 2] != 1 | F[b + 24 >> 2] != 2) {
                                    break a;
                                }
                                D[b + 54 | 0] = 1;
                                return;
                            }
                            a = F[a + 8 >> 2];
                            ga[F[F[a >> 2] + 24 >> 2]](a, b, c, d, e);
                        } }
                        function Eb(a, b, c) { var d = 0, e = 0, f = 0, g = 0; a: {
                            b: {
                                if (!b) {
                                    break b;
                                }
                                if (H[a + 38 >> 1] <= 513) {
                                    e = F[a + 12 >> 2];
                                    b = F[a + 20 >> 2];
                                    f = F[a + 16 >> 2];
                                    g = f + 8 | 0;
                                    b = g >>> 0 < 8 ? b + 1 | 0 : b;
                                    if (g >>> 0 > I[a + 8 >> 2] & (b | 0) >= (e | 0) | (b | 0) > (e | 0)) {
                                        break a;
                                    }
                                    b = f + F[a >> 2] | 0;
                                    d = G[b + 4 | 0] | G[b + 5 | 0] << 8 | (G[b + 6 | 0] << 16 | G[b + 7 | 0] << 24);
                                    F[c >> 2] = G[b | 0] | G[b + 1 | 0] << 8 | (G[b + 2 | 0] << 16 | G[b + 3 | 0] << 24);
                                    F[c + 4 >> 2] = d;
                                    b = F[a + 20 >> 2];
                                    c = F[a + 16 >> 2] + 8 | 0;
                                    b = c >>> 0 < 8 ? b + 1 | 0 : b;
                                    F[a + 16 >> 2] = c;
                                    F[a + 20 >> 2] = b;
                                    break b;
                                }
                                if (!pe(1, c, a)) {
                                    break a;
                                }
                            }
                            D[a + 36 | 0] = 1;
                            F[a + 32 >> 2] = 0;
                            b = F[a + 16 >> 2];
                            c = b + F[a >> 2] | 0;
                            F[a + 24 >> 2] = c;
                            d = a;
                            a = F[a + 8 >> 2];
                            F[d + 28 >> 2] = c + (a - b | 0);
                            d = 1;
                        } return d; }
                        function wb(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0; F[a + 8 >> 2] = 0; F[a >> 2] = 0; F[a + 4 >> 2] = 0; a: {
                            b: {
                                if (b) {
                                    if (b >>> 0 >= 357913942) {
                                        break b;
                                    }
                                    d = L(b, 12);
                                    b = sa(d);
                                    F[a >> 2] = b;
                                    F[a + 4 >> 2] = b;
                                    e = b + d | 0;
                                    F[a + 8 >> 2] = e;
                                    f = F[c >> 2];
                                    c = F[c + 4 >> 2] - f | 0;
                                    c: {
                                        if (!c) {
                                            c = b;
                                            b = d - 12 | 0;
                                            ua(c, 0, (b - ((b >>> 0) % 12 | 0) | 0) + 12 | 0);
                                            break c;
                                        }
                                        if ((c | 0) < 0) {
                                            break a;
                                        }
                                        g = c >> 2 << 2;
                                        h = c >>> 2 << 2;
                                        while (1) {
                                            F[b + 8 >> 2] = 0;
                                            F[b >> 2] = 0;
                                            F[b + 4 >> 2] = 0;
                                            d = sa(c);
                                            F[b >> 2] = d;
                                            F[b + 4 >> 2] = d;
                                            F[b + 8 >> 2] = d + g;
                                            i = b, j = ta(d, f, c) + h | 0, F[i + 4 >> 2] = j;
                                            b = b + 12 | 0;
                                            if ((e | 0) != (b | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    F[a + 4 >> 2] = e;
                                }
                                return;
                            }
                            va();
                            V();
                        } F[b + 8 >> 2] = 0; F[b >> 2] = 0; F[b + 4 >> 2] = 0; va(); V(); }
                        function se(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0; f = sa(64); c = sa(12); F[c + 8 >> 2] = F[F[a + 4 >> 2] + 80 >> 2]; F[c >> 2] = 13248; F[c + 4 >> 2] = 0; f = pd(f, c); a: {
                            b: {
                                if ((b | 0) < 0) {
                                    c = f;
                                    break b;
                                }
                                h = a + 8 | 0;
                                c = F[a + 12 >> 2];
                                e = F[a + 8 >> 2];
                                g = c - e >> 2;
                                c: {
                                    if ((g | 0) > (b | 0)) {
                                        break c;
                                    }
                                    d = b + 1 | 0;
                                    if (b >>> 0 >= g >>> 0) {
                                        Wb(h, d - g | 0);
                                        break c;
                                    }
                                    if (d >>> 0 >= g >>> 0) {
                                        break c;
                                    }
                                    e = e + (d << 2) | 0;
                                    if ((e | 0) != (c | 0)) {
                                        while (1) {
                                            c = c - 4 | 0;
                                            d = F[c >> 2];
                                            F[c >> 2] = 0;
                                            if (d) {
                                                ga[F[F[d >> 2] + 4 >> 2]](d);
                                            }
                                            if ((c | 0) != (e | 0)) {
                                                continue;
                                            }
                                            break;
                                        }
                                    }
                                    F[a + 12 >> 2] = e;
                                }
                                a = F[h >> 2] + (b << 2) | 0;
                                c = F[a >> 2];
                                F[a >> 2] = f;
                                if (!c) {
                                    break a;
                                }
                            }
                            ga[F[F[c >> 2] + 4 >> 2]](c);
                        } return (b ^ -1) >>> 31 | 0; }
                        function Od(a, b) { var c = 0, d = 0, e = 0, f = 0; d = ea - 16 | 0; ea = d; F[d + 12 >> 2] = b; c = ea - 208 | 0; ea = c; F[c + 204 >> 2] = b; b = c + 160 | 0; ua(b, 0, 40); F[c + 200 >> 2] = F[c + 204 >> 2]; a: {
                            if ((Nd(0, a, c + 200 | 0, c + 80 | 0, b) | 0) < 0) {
                                break a;
                            }
                            f = F[3885] >= 0;
                            b = F[3866];
                            if (F[3884] <= 0) {
                                F[3866] = b & -33;
                            }
                            b: {
                                c: {
                                    d: {
                                        if (!F[3878]) {
                                            F[3878] = 80;
                                            F[3873] = 0;
                                            F[3870] = 0;
                                            F[3871] = 0;
                                            e = F[3877];
                                            F[3877] = c;
                                            break d;
                                        }
                                        if (F[3870]) {
                                            break c;
                                        }
                                    }
                                    if (Qd(15464)) {
                                        break b;
                                    }
                                }
                                Nd(15464, a, c + 200 | 0, c + 80 | 0, c + 160 | 0);
                            }
                            if (e) {
                                ga[F[3875]](15464, 0, 0) | 0;
                                F[3878] = 0;
                                F[3877] = e;
                                F[3873] = 0;
                                F[3870] = 0;
                                F[3871] = 0;
                            }
                            F[3866] = F[3866] | b & 32;
                            if (!f) {
                                break a;
                            }
                        } ea = c + 208 | 0; ea = d + 16 | 0; }
                        function Ca(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0; f = c - b | 0; g = f >> 2; d = F[a + 8 >> 2]; e = F[a >> 2]; if (g >>> 0 <= d - e >> 2 >>> 0) {
                            d = F[a + 4 >> 2] - e | 0;
                            f = d >> 2;
                            d = f >>> 0 < g >>> 0 ? b + d | 0 : c;
                            h = d - b | 0;
                            if (h) {
                                Wa(e, b, h);
                            }
                            if (f >>> 0 < g >>> 0) {
                                b = F[a + 4 >> 2];
                                c = c - d | 0;
                                if ((c | 0) > 0) {
                                    b = ta(b, d, c) + c | 0;
                                }
                                F[a + 4 >> 2] = b;
                                return;
                            }
                            F[a + 4 >> 2] = e + h;
                            return;
                        } if (e) {
                            F[a + 4 >> 2] = e;
                            ra(e);
                            F[a + 8 >> 2] = 0;
                            F[a >> 2] = 0;
                            F[a + 4 >> 2] = 0;
                            d = 0;
                        } a: {
                            if ((f | 0) < 0) {
                                break a;
                            }
                            c = d >> 1;
                            c = d >>> 0 < 2147483644 ? c >>> 0 < g >>> 0 ? g : c : 1073741823;
                            if (c >>> 0 >= 1073741824) {
                                break a;
                            }
                            e = c << 2;
                            c = sa(e);
                            F[a >> 2] = c;
                            F[a + 4 >> 2] = c;
                            F[a + 8 >> 2] = c + e;
                            if (f) {
                                c = ta(c, b, f) + f | 0;
                            }
                            F[a + 4 >> 2] = c;
                            return;
                        } va(); V(); }
                        function Kc(a, b, c) { var d = 0, e = 0, f = 0, g = 0; a: {
                            if ((b | c) >= 0) {
                                b: {
                                    if (b >>> 0 > 1431655765) {
                                        break b;
                                    }
                                    d = L(b, 3);
                                    Jc(a, d, 13680);
                                    Jc(a + 12 | 0, d, 13684);
                                    d = F[a + 24 >> 2];
                                    c: {
                                        if (F[a + 32 >> 2] - d >> 2 >>> 0 >= c >>> 0) {
                                            break c;
                                        }
                                        if (c >>> 0 >= 1073741824) {
                                            break a;
                                        }
                                        e = F[a + 28 >> 2];
                                        f = c << 2;
                                        c = sa(f);
                                        f = c + f | 0;
                                        e = e - d | 0;
                                        g = e + c | 0;
                                        if ((e | 0) > 0) {
                                            ta(c, d, e);
                                        }
                                        F[a + 32 >> 2] = f;
                                        F[a + 28 >> 2] = g;
                                        F[a + 24 >> 2] = c;
                                        if (!d) {
                                            break c;
                                        }
                                        ra(d);
                                    }
                                    F[a + 80 >> 2] = 0;
                                    F[a + 84 >> 2] = 0;
                                    c = F[a + 76 >> 2];
                                    F[a + 76 >> 2] = 0;
                                    if (c) {
                                        ra(c);
                                    }
                                    F[a + 68 >> 2] = 0;
                                    F[a + 72 >> 2] = 0;
                                    c = a - -64 | 0;
                                    a = F[c >> 2];
                                    F[c >> 2] = 0;
                                    if (!a) {
                                        break b;
                                    }
                                    ra(a);
                                }
                                a = b >>> 0 < 1431655766;
                            }
                            else {
                                a = 0;
                            }
                            return a;
                        } wa(1336); V(); }
                        function ub(a) { var b = 0, c = 0, d = 0, e = 0, f = 0; d = F[a + 8 >> 2]; a: {
                            if (G[d + 84 | 0]) {
                                break a;
                            }
                            b = F[a + 16 >> 2];
                            if (!b | !G[b + 84 | 0]) {
                                break a;
                            }
                            c = F[d + 72 >> 2];
                            e = F[d + 68 >> 2];
                            D[b + 84 | 0] = 0;
                            c = c - e >> 2;
                            f = F[b + 68 >> 2];
                            e = F[b + 72 >> 2] - f >> 2;
                            b: {
                                if (c >>> 0 > e >>> 0) {
                                    Ia(b + 68 | 0, c - e | 0, 2344);
                                    d = F[a + 8 >> 2];
                                    break b;
                                }
                                if (c >>> 0 >= e >>> 0) {
                                    break b;
                                }
                                F[b + 72 >> 2] = f + (c << 2);
                            }
                            b = G[d + 84 | 0];
                            if (b) {
                                break a;
                            }
                            c = F[d + 68 >> 2];
                            if ((c | 0) == F[d + 72 >> 2]) {
                                break a;
                            }
                            e = F[F[a + 16 >> 2] + 68 >> 2];
                            if (!b) {
                                b = 0;
                                while (1) {
                                    f = b << 2;
                                    F[f + e >> 2] = F[c + f >> 2];
                                    b = b + 1 | 0;
                                    c = F[d + 68 >> 2];
                                    if (b >>> 0 < F[d + 72 >> 2] - c >> 2 >>> 0) {
                                        continue;
                                    }
                                    break;
                                }
                                break a;
                            }
                            F[e >> 2] = 0;
                        } return F[a + 16 >> 2]; }
                        function jd(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0; a: {
                            c = F[a + 216 >> 2];
                            if ((c | 0) == F[a + 220 >> 2]) {
                                break a;
                            }
                            while (1) {
                                b: {
                                    c = F[L(e, 144) + c >> 2];
                                    if ((c | 0) < 0) {
                                        break b;
                                    }
                                    d = F[a + 4 >> 2];
                                    f = F[d + 8 >> 2];
                                    if ((c | 0) >= F[d + 12 >> 2] - f >> 2) {
                                        break b;
                                    }
                                    d = 0;
                                    c = F[(c << 2) + f >> 2];
                                    if ((ga[F[F[c >> 2] + 24 >> 2]](c) | 0) <= 0) {
                                        break b;
                                    }
                                    while (1) {
                                        if ((ga[F[F[c >> 2] + 20 >> 2]](c, d) | 0) != (b | 0)) {
                                            d = d + 1 | 0;
                                            if ((ga[F[F[c >> 2] + 24 >> 2]](c) | 0) > (d | 0)) {
                                                continue;
                                            }
                                            break b;
                                        }
                                        break;
                                    }
                                    a = F[a + 216 >> 2] + L(e, 144) | 0;
                                    e = G[a + 100 | 0] ? a + 4 | 0 : 0;
                                    break a;
                                }
                                e = e + 1 | 0;
                                c = F[a + 216 >> 2];
                                if (e >>> 0 < (F[a + 220 >> 2] - c | 0) / 144 >>> 0) {
                                    continue;
                                }
                                break;
                            }
                            return 0;
                        } return e | 0; }
                        function Sb(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0; c = F[a + 4 >> 2]; if ((c | 0) != F[a + 8 >> 2]) {
                            d = F[b + 4 >> 2];
                            F[c >> 2] = F[b >> 2];
                            F[c + 4 >> 2] = d;
                            F[c + 8 >> 2] = F[b + 8 >> 2];
                            F[a + 4 >> 2] = c + 12;
                            return;
                        } a: {
                            f = F[a >> 2];
                            g = c - f | 0;
                            d = (g | 0) / 12 | 0;
                            c = d + 1 | 0;
                            if (c >>> 0 < 357913942) {
                                e = d << 1;
                                e = d >>> 0 < 178956970 ? c >>> 0 > e >>> 0 ? c : e : 357913941;
                                if (e) {
                                    if (e >>> 0 >= 357913942) {
                                        break a;
                                    }
                                    c = sa(L(e, 12));
                                }
                                else {
                                    c = 0;
                                }
                                d = c + L(d, 12) | 0;
                                h = F[b + 4 >> 2];
                                F[d >> 2] = F[b >> 2];
                                F[d + 4 >> 2] = h;
                                F[d + 8 >> 2] = F[b + 8 >> 2];
                                b = d + L((g | 0) / -12 | 0, 12) | 0;
                                if ((g | 0) > 0) {
                                    ta(b, f, g);
                                }
                                F[a + 8 >> 2] = c + L(e, 12);
                                F[a + 4 >> 2] = d + 12;
                                F[a >> 2] = b;
                                if (f) {
                                    ra(f);
                                }
                                return;
                            }
                            va();
                            V();
                        } wa(1336); V(); }
                        function mf(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0; c = F[a + 60 >> 2]; a: {
                            if (!c) {
                                break a;
                            }
                            F[c + 4 >> 2] = a + 48;
                            if (!(ga[F[F[c >> 2] + 12 >> 2]](c) | 0)) {
                                break a;
                            }
                            b: {
                                c = ga[F[F[a >> 2] + 24 >> 2]](a) | 0;
                                if ((c | 0) <= 0) {
                                    break b;
                                }
                                while (1) {
                                    c: {
                                        f = F[(ga[F[F[a >> 2] + 28 >> 2]](a) | 0) + 4 >> 2];
                                        g = ga[F[F[a >> 2] + 20 >> 2]](a, d) | 0;
                                        e = F[a + 60 >> 2];
                                        if (!(ga[F[F[e >> 2] + 8 >> 2]](e, F[F[f + 8 >> 2] + (g << 2) >> 2]) | 0)) {
                                            break c;
                                        }
                                        d = d + 1 | 0;
                                        if ((c | 0) != (d | 0)) {
                                            continue;
                                        }
                                        break b;
                                    }
                                    break;
                                }
                                return 0;
                            }
                            d = 0;
                            if (!(ga[F[F[a >> 2] + 36 >> 2]](a, b) | 0)) {
                                break a;
                            }
                            if (!(ga[F[F[a >> 2] + 40 >> 2]](a, b) | 0)) {
                                break a;
                            }
                            d = ga[F[F[a >> 2] + 44 >> 2]](a) | 0;
                        } return d | 0; }
                        function sd(a) { a = a | 0; var b = 0, c = 0, d = 0; F[a >> 2] = 2156; b = F[a + 60 >> 2]; if (b) {
                            c = F[a - -64 >> 2];
                            if ((b | 0) == (c | 0)) {
                                c = b;
                            }
                            else {
                                while (1) {
                                    c = c - 4 | 0;
                                    d = F[c >> 2];
                                    F[c >> 2] = 0;
                                    if (d) {
                                        Ja(d);
                                    }
                                    if ((b | 0) != (c | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                c = F[a + 60 >> 2];
                            }
                            F[a + 64 >> 2] = b;
                            ra(c);
                        } b = F[a + 48 >> 2]; if (b) {
                            F[a + 52 >> 2] = b;
                            ra(b);
                        } b = F[a + 36 >> 2]; if (b) {
                            c = F[a + 40 >> 2];
                            if ((b | 0) == (c | 0)) {
                                c = b;
                            }
                            else {
                                while (1) {
                                    c = c - 24 | 0;
                                    ga[F[F[c >> 2] >> 2]](c) | 0;
                                    if ((b | 0) != (c | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                c = F[a + 36 >> 2];
                            }
                            F[a + 40 >> 2] = b;
                            ra(c);
                        } F[a >> 2] = 2012; b = F[a + 16 >> 2]; if (b) {
                            F[a + 20 >> 2] = b;
                            ra(b);
                        } b = F[a + 4 >> 2]; if (b) {
                            F[a + 8 >> 2] = b;
                            ra(b);
                        } return a | 0; }
                        function Ab(a) { var b = 0, c = 0, d = 0, e = 0; c = F[a + 132 >> 2]; if (c) {
                            b = F[a + 136 >> 2];
                            if ((c | 0) == (b | 0)) {
                                b = c;
                            }
                            else {
                                while (1) {
                                    e = b - 12 | 0;
                                    d = F[e >> 2];
                                    if (d) {
                                        F[b - 8 >> 2] = d;
                                        ra(d);
                                    }
                                    b = e;
                                    if ((c | 0) != (b | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                b = F[a + 132 >> 2];
                            }
                            F[a + 136 >> 2] = c;
                            ra(b);
                        } c = F[a + 120 >> 2]; if (c) {
                            b = F[a + 124 >> 2];
                            if ((c | 0) == (b | 0)) {
                                b = c;
                            }
                            else {
                                while (1) {
                                    e = b - 12 | 0;
                                    d = F[e >> 2];
                                    if (d) {
                                        F[b - 8 >> 2] = d;
                                        ra(d);
                                    }
                                    b = e;
                                    if ((c | 0) != (b | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                b = F[a + 120 >> 2];
                            }
                            F[a + 124 >> 2] = c;
                            ra(b);
                        } b = F[a + 108 >> 2]; if (b) {
                            F[a + 112 >> 2] = b;
                            ra(b);
                        } b = F[a + 96 >> 2]; if (b) {
                            F[a + 100 >> 2] = b;
                            ra(b);
                        } _a(a + 76 | 0); _a(a + 56 | 0); _a(a + 36 | 0); _a(a + 16 | 0); }
                        function Fd(a, b, c, d, e, f, g) { var h = 0, i = 0, j = 0; h = ea - 16 | 0; ea = h; if ((b ^ -1) - 17 >>> 0 >= c >>> 0) {
                            if (G[a + 11 | 0] >>> 7 | 0) {
                                j = F[a >> 2];
                            }
                            else {
                                j = a;
                            }
                            a: {
                                if (b >>> 0 < 2147483623) {
                                    F[h + 8 >> 2] = b << 1;
                                    F[h + 12 >> 2] = b + c;
                                    c = ea - 16 | 0;
                                    ea = c;
                                    ea = c + 16 | 0;
                                    c = h + 8 | 0;
                                    i = h + 12 | 0;
                                    c = F[(I[i >> 2] < I[c >> 2] ? c : i) >> 2];
                                    if (c >>> 0 >= 11) {
                                        i = c + 16 & -16;
                                        c = i - 1 | 0;
                                        c = (c | 0) == 11 ? i : c;
                                    }
                                    else {
                                        c = 10;
                                    }
                                    break a;
                                }
                                c = -18;
                            }
                            i = c + 1 | 0;
                            c = sa(i);
                            if (f) {
                                kb(c, g, f);
                            }
                            d = d - e | 0;
                            if (d) {
                                kb(c + f | 0, e + j | 0, d);
                            }
                            if ((b | 0) != 10) {
                                ra(j);
                            }
                            F[a >> 2] = c;
                            F[a + 8 >> 2] = i | -2147483648;
                            b = a;
                            a = d + f | 0;
                            F[b + 4 >> 2] = a;
                            D[h + 7 | 0] = 0;
                            D[a + c | 0] = G[h + 7 | 0];
                            ea = h + 16 | 0;
                            return;
                        } Ma(); V(); }
                        function bb(a) { var b = 0, c = 0, d = 0, e = 0; c = F[a + 640 >> 2]; if (c) {
                            b = F[a + 644 >> 2];
                            if ((c | 0) == (b | 0)) {
                                b = c;
                            }
                            else {
                                while (1) {
                                    e = b - 12 | 0;
                                    d = F[e >> 2];
                                    if (d) {
                                        F[b - 8 >> 2] = d;
                                        ra(d);
                                    }
                                    b = e;
                                    if ((c | 0) != (b | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                b = F[a + 640 >> 2];
                            }
                            F[a + 644 >> 2] = c;
                            ra(b);
                        } c = F[a + 628 >> 2]; if (c) {
                            b = F[a + 632 >> 2];
                            if ((c | 0) == (b | 0)) {
                                b = c;
                            }
                            else {
                                while (1) {
                                    e = b - 12 | 0;
                                    d = F[e >> 2];
                                    if (d) {
                                        F[b - 8 >> 2] = d;
                                        ra(d);
                                    }
                                    b = e;
                                    if ((c | 0) != (b | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                b = F[a + 628 >> 2];
                            }
                            F[a + 632 >> 2] = c;
                            ra(b);
                        } b = F[a + 616 >> 2]; if (b) {
                            F[a + 620 >> 2] = b;
                            ra(b);
                        } b = F[a + 604 >> 2]; if (b) {
                            F[a + 608 >> 2] = b;
                            ra(b);
                        } _a(a + 584 | 0); _a(a + 564 | 0); _a(a + 544 | 0); }
                        function yb(a) { var b = 0, c = 0, d = 0, e = 0; c = F[a + 128 >> 2]; if (c) {
                            b = F[a + 132 >> 2];
                            if ((c | 0) == (b | 0)) {
                                b = c;
                            }
                            else {
                                while (1) {
                                    e = b - 12 | 0;
                                    d = F[e >> 2];
                                    if (d) {
                                        F[b - 8 >> 2] = d;
                                        ra(d);
                                    }
                                    b = e;
                                    if ((c | 0) != (b | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                b = F[a + 128 >> 2];
                            }
                            F[a + 132 >> 2] = c;
                            ra(b);
                        } c = F[a + 116 >> 2]; if (c) {
                            b = F[a + 120 >> 2];
                            if ((c | 0) == (b | 0)) {
                                b = c;
                            }
                            else {
                                while (1) {
                                    e = b - 12 | 0;
                                    d = F[e >> 2];
                                    if (d) {
                                        F[b - 8 >> 2] = d;
                                        ra(d);
                                    }
                                    b = e;
                                    if ((c | 0) != (b | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                b = F[a + 116 >> 2];
                            }
                            F[a + 120 >> 2] = c;
                            ra(b);
                        } b = F[a + 104 >> 2]; if (b) {
                            F[a + 108 >> 2] = b;
                            ra(b);
                        } b = F[a + 92 >> 2]; if (b) {
                            F[a + 96 >> 2] = b;
                            ra(b);
                        } _a(a + 72 | 0); _a(a + 52 | 0); _a(a + 32 | 0); }
                        function id(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0; c = F[a + 216 >> 2]; if ((c | 0) != F[a + 220 >> 2]) {
                            while (1) {
                                a: {
                                    c = F[L(e, 144) + c >> 2];
                                    if ((c | 0) < 0) {
                                        break a;
                                    }
                                    d = F[a + 4 >> 2];
                                    f = F[d + 8 >> 2];
                                    if ((c | 0) >= F[d + 12 >> 2] - f >> 2) {
                                        break a;
                                    }
                                    d = 0;
                                    c = F[(c << 2) + f >> 2];
                                    if ((ga[F[F[c >> 2] + 24 >> 2]](c) | 0) <= 0) {
                                        break a;
                                    }
                                    while (1) {
                                        if ((ga[F[F[c >> 2] + 20 >> 2]](c, d) | 0) != (b | 0)) {
                                            d = d + 1 | 0;
                                            if ((ga[F[F[c >> 2] + 24 >> 2]](c) | 0) > (d | 0)) {
                                                continue;
                                            }
                                            break a;
                                        }
                                        break;
                                    }
                                    return (F[a + 216 >> 2] + L(e, 144) | 0) + 104 | 0;
                                }
                                e = e + 1 | 0;
                                c = F[a + 216 >> 2];
                                if (e >>> 0 < (F[a + 220 >> 2] - c | 0) / 144 >>> 0) {
                                    continue;
                                }
                                break;
                            }
                        } return a + 184 | 0; }
                        function Dg(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0; a = ea - 32 | 0; ea = a; a: {
                            d = La(c);
                            if (d >>> 0 < 4294967280) {
                                b: {
                                    c: {
                                        if (d >>> 0 >= 11) {
                                            f = d + 16 & -16;
                                            e = sa(f);
                                            F[a + 24 >> 2] = f | -2147483648;
                                            F[a + 16 >> 2] = e;
                                            F[a + 20 >> 2] = d;
                                            break c;
                                        }
                                        D[a + 27 | 0] = d;
                                        e = a + 16 | 0;
                                        if (!d) {
                                            break b;
                                        }
                                    }
                                    ta(e, c, d);
                                }
                                D[d + e | 0] = 0;
                                D[a + 4 | 0] = 0;
                                F[a >> 2] = 1701667182;
                                D[a + 11 | 0] = 4;
                                d = F[b + 4 >> 2];
                                c = -1;
                                d: {
                                    if (!d) {
                                        break d;
                                    }
                                    d = _d(d, a, a + 16 | 0);
                                    c = -1;
                                    if (!d) {
                                        break d;
                                    }
                                    c = Wd(b, F[d + 24 >> 2]);
                                }
                                b = c;
                                if (D[a + 11 | 0] < 0) {
                                    ra(F[a >> 2]);
                                }
                                if (D[a + 27 | 0] < 0) {
                                    ra(F[a + 16 >> 2]);
                                }
                                ea = a + 32 | 0;
                                break a;
                            }
                            Ma();
                            V();
                        } return b | 0; }
                        function Og(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0; d = ea - 16 | 0; ea = d; F[d + 12 >> 2] = 0; a: {
                            e = La(c);
                            if (e >>> 0 < 4294967280) {
                                b: {
                                    c: {
                                        if (e >>> 0 >= 11) {
                                            f = e + 16 & -16;
                                            a = sa(f);
                                            F[d + 8 >> 2] = f | -2147483648;
                                            F[d >> 2] = a;
                                            F[d + 4 >> 2] = e;
                                            break c;
                                        }
                                        D[d + 11 | 0] = e;
                                        a = d;
                                        if (!e) {
                                            break b;
                                        }
                                    }
                                    ta(a, c, e);
                                }
                                D[a + e | 0] = 0;
                                a = rb(b, d);
                                d: {
                                    if ((a | 0) == (b + 4 | 0)) {
                                        break d;
                                    }
                                    b = F[a + 32 >> 2];
                                    a = F[a + 28 >> 2];
                                    if ((b - a | 0) != 4) {
                                        break d;
                                    }
                                    F[d + 12 >> 2] = G[a | 0] | G[a + 1 | 0] << 8 | (G[a + 2 | 0] << 16 | G[a + 3 | 0] << 24);
                                }
                                a = F[d + 12 >> 2];
                                if (D[d + 11 | 0] < 0) {
                                    ra(F[d >> 2]);
                                }
                                ea = d + 16 | 0;
                                break a;
                            }
                            Ma();
                            V();
                        } return a | 0; }
                        function Jd(a, b) { if (!a) {
                            return 0;
                        } a: {
                            b: {
                                if (a) {
                                    if (b >>> 0 <= 127) {
                                        break b;
                                    }
                                    c: {
                                        if (!F[F[4227] >> 2]) {
                                            if ((b & -128) == 57216) {
                                                break b;
                                            }
                                            break c;
                                        }
                                        if (b >>> 0 <= 2047) {
                                            D[a + 1 | 0] = b & 63 | 128;
                                            D[a | 0] = b >>> 6 | 192;
                                            a = 2;
                                            break a;
                                        }
                                        if (!((b & -8192) != 57344 & b >>> 0 >= 55296)) {
                                            D[a + 2 | 0] = b & 63 | 128;
                                            D[a | 0] = b >>> 12 | 224;
                                            D[a + 1 | 0] = b >>> 6 & 63 | 128;
                                            a = 3;
                                            break a;
                                        }
                                        if (b - 65536 >>> 0 <= 1048575) {
                                            D[a + 3 | 0] = b & 63 | 128;
                                            D[a | 0] = b >>> 18 | 240;
                                            D[a + 2 | 0] = b >>> 6 & 63 | 128;
                                            D[a + 1 | 0] = b >>> 12 & 63 | 128;
                                            a = 4;
                                            break a;
                                        }
                                    }
                                    F[4190] = 25;
                                    a = -1;
                                }
                                else {
                                    a = 1;
                                }
                                break a;
                            }
                            D[a | 0] = b;
                            a = 1;
                        } return a; }
                        function ac(a) { a = a | 0; var b = 0, c = 0, d = 0; F[a >> 2] = 13756; b = F[a + 68 >> 2]; if (b) {
                            F[a + 72 >> 2] = b;
                            ra(b);
                        } b = F[a + 56 >> 2]; if (b) {
                            F[a + 60 >> 2] = b;
                            ra(b);
                        } b = F[a + 44 >> 2]; if (b) {
                            F[a + 48 >> 2] = b;
                            ra(b);
                        } b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } b = F[a + 20 >> 2]; if (b) {
                            F[a + 24 >> 2] = b;
                            ra(b);
                        } d = F[a + 8 >> 2]; if (d) {
                            c = F[a + 12 >> 2];
                            if ((c | 0) == (d | 0)) {
                                b = d;
                            }
                            else {
                                while (1) {
                                    c = c - 4 | 0;
                                    b = F[c >> 2];
                                    F[c >> 2] = 0;
                                    if (b) {
                                        Ja(b);
                                    }
                                    if ((d | 0) != (c | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                b = F[a + 8 >> 2];
                            }
                            F[a + 12 >> 2] = d;
                            ra(b);
                        } b = F[a + 4 >> 2]; F[a + 4 >> 2] = 0; if (b) {
                            Tc(b);
                        } return a | 0; }
                        function Aa(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0; e = F[a + 8 >> 2]; c = F[a + 4 >> 2]; if (e - c >> 2 >>> 0 >= b >>> 0) {
                            if (b) {
                                b = b << 2;
                                c = ua(c, 0, b) + b | 0;
                            }
                            F[a + 4 >> 2] = c;
                            return;
                        } a: {
                            f = F[a >> 2];
                            g = c - f | 0;
                            h = g >> 2;
                            d = h + b | 0;
                            if (d >>> 0 < 1073741824) {
                                c = 0;
                                e = e - f | 0;
                                i = e >> 1;
                                d = e >>> 0 < 2147483644 ? d >>> 0 > i >>> 0 ? d : i : 1073741823;
                                if (d) {
                                    if (d >>> 0 >= 1073741824) {
                                        break a;
                                    }
                                    c = sa(d << 2);
                                }
                                b = b << 2;
                                b = ua((h << 2) + c | 0, 0, b) + b | 0;
                                if ((g | 0) > 0) {
                                    ta(c, f, g);
                                }
                                F[a + 8 >> 2] = (d << 2) + c;
                                F[a + 4 >> 2] = b;
                                F[a >> 2] = c;
                                if (f) {
                                    ra(f);
                                }
                                return;
                            }
                            va();
                            V();
                        } wa(1336); V(); }
                        function tb(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0; e = F[a + 8 >> 2]; c = F[a + 4 >> 2]; if (e - c >> 3 >>> 0 >= b >>> 0) {
                            if (b) {
                                b = b << 3;
                                c = ua(c, 0, b) + b | 0;
                            }
                            F[a + 4 >> 2] = c;
                            return;
                        } a: {
                            f = F[a >> 2];
                            g = c - f | 0;
                            h = g >> 3;
                            d = h + b | 0;
                            if (d >>> 0 < 536870912) {
                                c = 0;
                                e = e - f | 0;
                                i = e >> 2;
                                d = e >>> 0 < 2147483640 ? d >>> 0 > i >>> 0 ? d : i : 536870911;
                                if (d) {
                                    if (d >>> 0 >= 536870912) {
                                        break a;
                                    }
                                    c = sa(d << 3);
                                }
                                b = b << 3;
                                b = ua((h << 3) + c | 0, 0, b) + b | 0;
                                if ((g | 0) > 0) {
                                    ta(c, f, g);
                                }
                                F[a + 8 >> 2] = (d << 3) + c;
                                F[a + 4 >> 2] = b;
                                F[a >> 2] = c;
                                if (f) {
                                    ra(f);
                                }
                                return;
                            }
                            va();
                            V();
                        } wa(1336); V(); }
                        function hb(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0; e = F[a >> 2]; a = F[e + 4 >> 2]; c = F[e + 8 >> 2]; if (a >>> 0 < c >>> 0) {
                            F[a >> 2] = F[b >> 2];
                            F[e + 4 >> 2] = a + 4;
                            return;
                        } a: {
                            f = F[e >> 2];
                            g = a - f | 0;
                            d = g >> 2;
                            a = d + 1 | 0;
                            if (a >>> 0 < 1073741824) {
                                h = d << 2;
                                c = c - f | 0;
                                d = c >> 1;
                                c = c >>> 0 < 2147483644 ? a >>> 0 > d >>> 0 ? a : d : 1073741823;
                                if (c) {
                                    if (c >>> 0 >= 1073741824) {
                                        break a;
                                    }
                                    a = sa(c << 2);
                                }
                                else {
                                    a = 0;
                                }
                                d = h + a | 0;
                                F[d >> 2] = F[b >> 2];
                                if ((g | 0) > 0) {
                                    ta(a, f, g);
                                }
                                F[e + 8 >> 2] = a + (c << 2);
                                F[e + 4 >> 2] = d + 4;
                                F[e >> 2] = a;
                                if (f) {
                                    ra(f);
                                }
                                return;
                            }
                            va();
                            V();
                        } wa(1336); V(); }
                        function Sc(a, b) { var c = 0, d = 0, e = 0, f = 0; c = a + 4 | 0; a = rb(a, b); a: {
                            if ((c | 0) == (a | 0)) {
                                break a;
                            }
                            b = D[a + 39 | 0] < 0 ? F[a + 28 >> 2] : a + 28 | 0;
                            while (1) {
                                a = b;
                                b = a + 1 | 0;
                                c = D[a | 0];
                                if ((c | 0) == 32 | c - 9 >>> 0 < 5) {
                                    continue;
                                }
                                break;
                            }
                            b: {
                                c: {
                                    d: {
                                        c = D[a | 0];
                                        switch (c - 43 | 0) {
                                            case 0: break c;
                                            case 2: break d;
                                            default: break b;
                                        }
                                    }
                                    e = 1;
                                }
                                c = D[b | 0];
                                a = b;
                            }
                            if (c - 48 >>> 0 < 10) {
                                while (1) {
                                    d = (L(d, 10) - D[a | 0] | 0) + 48 | 0;
                                    b = D[a + 1 | 0];
                                    a = a + 1 | 0;
                                    if (b - 48 >>> 0 < 10) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            a = e ? d : 0 - d | 0;
                            if ((a | 0) == -1) {
                                break a;
                            }
                            f = (a | 0) != 0;
                        } return f; }
                        function gf(a) { a = a | 0; var b = 0, c = 0, d = 0; F[a >> 2] = 2356; b = F[a + 60 >> 2]; F[a + 60 >> 2] = 0; if (b) {
                            ga[F[F[b >> 2] + 4 >> 2]](b);
                        } b = F[a + 48 >> 2]; if (b) {
                            F[a + 52 >> 2] = b;
                            ra(b);
                        } d = F[a + 36 >> 2]; if (d) {
                            c = F[a + 40 >> 2];
                            if ((c | 0) == (d | 0)) {
                                b = d;
                            }
                            else {
                                while (1) {
                                    c = c - 4 | 0;
                                    b = F[c >> 2];
                                    F[c >> 2] = 0;
                                    if (b) {
                                        ga[F[F[b >> 2] + 4 >> 2]](b);
                                    }
                                    if ((d | 0) != (c | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                b = F[a + 36 >> 2];
                            }
                            F[a + 40 >> 2] = d;
                            ra(b);
                        } F[a >> 2] = 2012; b = F[a + 16 >> 2]; if (b) {
                            F[a + 20 >> 2] = b;
                            ra(b);
                        } b = F[a + 4 >> 2]; if (b) {
                            F[a + 8 >> 2] = b;
                            ra(b);
                        } return a | 0; }
                        function ff(a) { a = a | 0; var b = 0, c = 0, d = 0; F[a >> 2] = 2356; b = F[a + 60 >> 2]; F[a + 60 >> 2] = 0; if (b) {
                            ga[F[F[b >> 2] + 4 >> 2]](b);
                        } b = F[a + 48 >> 2]; if (b) {
                            F[a + 52 >> 2] = b;
                            ra(b);
                        } d = F[a + 36 >> 2]; if (d) {
                            c = F[a + 40 >> 2];
                            if ((c | 0) == (d | 0)) {
                                b = d;
                            }
                            else {
                                while (1) {
                                    c = c - 4 | 0;
                                    b = F[c >> 2];
                                    F[c >> 2] = 0;
                                    if (b) {
                                        ga[F[F[b >> 2] + 4 >> 2]](b);
                                    }
                                    if ((d | 0) != (c | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                b = F[a + 36 >> 2];
                            }
                            F[a + 40 >> 2] = d;
                            ra(b);
                        } F[a >> 2] = 2012; b = F[a + 16 >> 2]; if (b) {
                            F[a + 20 >> 2] = b;
                            ra(b);
                        } b = F[a + 4 >> 2]; if (b) {
                            F[a + 8 >> 2] = b;
                            ra(b);
                        } ra(a); }
                        function oe(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0; e = F[a + 8 >> 2]; c = F[a + 4 >> 2]; if (e - c >> 1 >>> 0 >= b >>> 0) {
                            if (b) {
                                b = b << 1;
                                c = ua(c, 0, b) + b | 0;
                            }
                            F[a + 4 >> 2] = c;
                            return;
                        } a: {
                            f = F[a >> 2];
                            g = c - f | 0;
                            h = g >> 1;
                            d = h + b | 0;
                            if ((d | 0) >= 0) {
                                c = 0;
                                e = e - f | 0;
                                d = e >>> 0 < 2147483646 ? d >>> 0 > e >>> 0 ? d : e : 2147483647;
                                if (d) {
                                    if ((d | 0) < 0) {
                                        break a;
                                    }
                                    c = sa(d << 1);
                                }
                                b = b << 1;
                                b = ua((h << 1) + c | 0, 0, b) + b | 0;
                                if ((g | 0) > 0) {
                                    ta(c, f, g);
                                }
                                F[a + 8 >> 2] = (d << 1) + c;
                                F[a + 4 >> 2] = b;
                                F[a >> 2] = c;
                                if (f) {
                                    ra(f);
                                }
                                return;
                            }
                            va();
                            V();
                        } wa(1336); V(); }
                        function Va(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0; a: {
                            c = F[a + 4 >> 2];
                            e = F[a >> 2];
                            f = c - e | 0;
                            b: {
                                if (f >>> 0 < b >>> 0) {
                                    g = b - f | 0;
                                    d = F[a + 8 >> 2];
                                    if (g >>> 0 <= d - c >>> 0) {
                                        if (g) {
                                            c = ua(c, 0, g) + g | 0;
                                        }
                                        F[a + 4 >> 2] = c;
                                        return;
                                    }
                                    if ((b | 0) < 0) {
                                        break a;
                                    }
                                    c = d - e | 0;
                                    d = c << 1;
                                    d = c >>> 0 < 1073741823 ? b >>> 0 > d >>> 0 ? b : d : 2147483647;
                                    c = sa(d);
                                    ua(c + f | 0, 0, g);
                                    if ((f | 0) > 0) {
                                        ta(c, e, f);
                                    }
                                    F[a + 8 >> 2] = c + d;
                                    F[a + 4 >> 2] = b + c;
                                    F[a >> 2] = c;
                                    if (!e) {
                                        break b;
                                    }
                                    ra(e);
                                    return;
                                }
                                if (b >>> 0 >= f >>> 0) {
                                    break b;
                                }
                                F[a + 4 >> 2] = b + e;
                            }
                            return;
                        } va(); V(); }
                        function si(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0; d = ea - 16 | 0; ea = d; e = F[a + 4 >> 2]; a: {
                            if ((e | 0) == -1) {
                                break a;
                            }
                            c = F[b + 20 >> 2];
                            if (!!F[b + 16 >> 2] & (c | 0) >= 0 | (c | 0) > 0) {
                                break a;
                            }
                            Yb(b, F[b + 4 >> 2], F[a + 8 >> 2], F[a + 12 >> 2]);
                            c = F[b + 20 >> 2];
                            if (!!F[b + 16 >> 2] & (c | 0) >= 0 | (c | 0) > 0) {
                                break a;
                            }
                            c = a + 20 | 0;
                            Yb(b, F[b + 4 >> 2], c, c + 4 | 0);
                            c = F[b + 20 >> 2];
                            f = F[b + 16 >> 2];
                            D[d + 15 | 0] = F[a + 4 >> 2];
                            if (!!f & (c | 0) >= 0 | (c | 0) > 0) {
                                break a;
                            }
                            Yb(b, F[b + 4 >> 2], d + 15 | 0, d + 16 | 0);
                        } ea = d + 16 | 0; return (e | 0) != -1 | 0; }
                        function zh(a) { a = a | 0; var b = 0, c = 0, d = 0, e = 0, f = 0; a: {
                            b = F[a + 8 >> 2];
                            b: {
                                if ((b | 0) < 0) {
                                    break b;
                                }
                                c = F[a + 4 >> 2];
                                e = F[c >> 2];
                                d = F[c + 4 >> 2] - e >> 2;
                                c: {
                                    if (d >>> 0 < b >>> 0) {
                                        Aa(c, b - d | 0);
                                        f = F[a + 8 >> 2];
                                        break c;
                                    }
                                    f = b;
                                    if (b >>> 0 >= d >>> 0) {
                                        break c;
                                    }
                                    F[c + 4 >> 2] = e + (b << 2);
                                    f = b;
                                }
                                d = f;
                                if ((d | 0) <= 0) {
                                    break b;
                                }
                                a = F[a + 4 >> 2];
                                c = F[a >> 2];
                                e = F[a + 4 >> 2] - c >> 2;
                                a = 0;
                                while (1) {
                                    if ((a | 0) == (e | 0)) {
                                        break a;
                                    }
                                    F[c + (a << 2) >> 2] = a;
                                    a = a + 1 | 0;
                                    if ((d | 0) != (a | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            return (b ^ -1) >>> 31 | 0;
                        } Da(); V(); }
                        function ig(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0; d = ea - 16 | 0; ea = d; Me(d, a, b, c); F[a + 24 >> 2] = F[d >> 2]; e = a + 24 | 0; a: {
                            if ((e | 0) == (d | 0)) {
                                break a;
                            }
                            b = d | 4;
                            f = G[d + 15 | 0];
                            c = f << 24 >> 24;
                            a = a + 28 | 0;
                            if (D[a + 11 | 0] >= 0) {
                                if ((c | 0) >= 0) {
                                    c = F[b + 4 >> 2];
                                    F[a >> 2] = F[b >> 2];
                                    F[a + 4 >> 2] = c;
                                    F[a + 8 >> 2] = F[b + 8 >> 2];
                                    break a;
                                }
                                Zb(a, F[d + 4 >> 2], F[d + 8 >> 2]);
                                break a;
                            }
                            g = a;
                            a = (c | 0) < 0;
                            _b(g, a ? F[d + 4 >> 2] : b, a ? F[d + 8 >> 2] : f);
                        } if (D[d + 15 | 0] < 0) {
                            ra(F[d + 4 >> 2]);
                        } ea = d + 16 | 0; return e | 0; }
                        function hg(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0; d = ea - 16 | 0; ea = d; Le(d, a, b, c); F[a + 24 >> 2] = F[d >> 2]; e = a + 24 | 0; a: {
                            if ((e | 0) == (d | 0)) {
                                break a;
                            }
                            b = d | 4;
                            f = G[d + 15 | 0];
                            c = f << 24 >> 24;
                            a = a + 28 | 0;
                            if (D[a + 11 | 0] >= 0) {
                                if ((c | 0) >= 0) {
                                    c = F[b + 4 >> 2];
                                    F[a >> 2] = F[b >> 2];
                                    F[a + 4 >> 2] = c;
                                    F[a + 8 >> 2] = F[b + 8 >> 2];
                                    break a;
                                }
                                Zb(a, F[d + 4 >> 2], F[d + 8 >> 2]);
                                break a;
                            }
                            g = a;
                            a = (c | 0) < 0;
                            _b(g, a ? F[d + 4 >> 2] : b, a ? F[d + 8 >> 2] : f);
                        } if (D[d + 15 | 0] < 0) {
                            ra(F[d + 4 >> 2]);
                        } ea = d + 16 | 0; return e | 0; }
                        function Sa(a) { var b = 0, c = 0, d = 0, e = 0, f = 0; b = F[a + 4 >> 2]; if ((b | 0) != F[a + 8 >> 2]) {
                            F[b >> 2] = F[2863];
                            F[a + 4 >> 2] = b + 4;
                            return;
                        } a: {
                            f = F[a >> 2];
                            d = b - f | 0;
                            e = d >> 2;
                            b = e + 1 | 0;
                            if (b >>> 0 < 1073741824) {
                                c = d >> 1;
                                c = d >>> 0 < 2147483644 ? b >>> 0 > c >>> 0 ? b : c : 1073741823;
                                if (c) {
                                    if (c >>> 0 >= 1073741824) {
                                        break a;
                                    }
                                    b = sa(c << 2);
                                }
                                else {
                                    b = 0;
                                }
                                e = b + (e << 2) | 0;
                                F[e >> 2] = F[2863];
                                if ((d | 0) > 0) {
                                    ta(b, f, d);
                                }
                                F[a + 8 >> 2] = b + (c << 2);
                                F[a + 4 >> 2] = e + 4;
                                F[a >> 2] = b;
                                if (f) {
                                    ra(f);
                                }
                                return;
                            }
                            va();
                            V();
                        } wa(1336); V(); }
                        function tg(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; var e = 0, f = 0, g = 0; a = ea - 32 | 0; ea = a; e = D[b + 24 | 0]; f = F[3419]; F[a + 24 >> 2] = F[3418]; F[a + 28 >> 2] = f; f = F[3417]; F[a + 16 >> 2] = F[3416]; F[a + 20 >> 2] = f; a: {
                            b: {
                                c = Ya(b, c, e, a + 16 | 0);
                                if (c) {
                                    F[a + 8 >> 2] = 0;
                                    F[a >> 2] = 0;
                                    F[a + 4 >> 2] = 0;
                                    b = 0;
                                    if (e) {
                                        if ((e | 0) < 0) {
                                            break b;
                                        }
                                        e = e << 2;
                                        b = sa(e);
                                        g = ta(b, a + 16 | 0, e) + e | 0;
                                    }
                                    e = F[d >> 2];
                                    if (e) {
                                        F[d + 4 >> 2] = e;
                                        ra(e);
                                    }
                                    F[d + 8 >> 2] = g;
                                    F[d + 4 >> 2] = g;
                                    F[d >> 2] = b;
                                }
                                ea = a + 32 | 0;
                                break a;
                            }
                            va();
                            V();
                        } return c | 0; }
                        function Gb(a, b) { var c = 0, d = 0, e = 0, f = 0; d = F[a + 12 >> 2]; c = F[a + 16 >> 2] - d >> 2; a: {
                            if (c >>> 0 < b >>> 0) {
                                Aa(a + 12 | 0, b - c | 0);
                                break a;
                            }
                            if (b >>> 0 >= c >>> 0) {
                                break a;
                            }
                            F[a + 16 >> 2] = d + (b << 2);
                        } b: {
                            c = F[a >> 2];
                            c: {
                                if (F[a + 8 >> 2] - c >> 2 >>> 0 >= b >>> 0) {
                                    break c;
                                }
                                if (b >>> 0 >= 1073741824) {
                                    break b;
                                }
                                d = F[a + 4 >> 2];
                                e = b << 2;
                                b = sa(e);
                                e = b + e | 0;
                                d = d - c | 0;
                                f = d + b | 0;
                                if ((d | 0) > 0) {
                                    ta(b, c, d);
                                }
                                F[a + 8 >> 2] = e;
                                F[a + 4 >> 2] = f;
                                F[a >> 2] = b;
                                if (!c) {
                                    break c;
                                }
                                ra(c);
                            }
                            return;
                        } wa(1336); V(); }
                        function Ec(a, b, c) { var d = 0, e = 0, f = 0; d = F[c + 16 >> 2]; a: {
                            if (!d) {
                                if (Qd(c)) {
                                    break a;
                                }
                                d = F[c + 16 >> 2];
                            }
                            f = F[c + 20 >> 2];
                            if (d - f >>> 0 < b >>> 0) {
                                return ga[F[c + 36 >> 2]](c, a, b) | 0;
                            }
                            b: {
                                if (F[c + 80 >> 2] < 0) {
                                    d = 0;
                                    break b;
                                }
                                e = b;
                                while (1) {
                                    d = e;
                                    if (!d) {
                                        d = 0;
                                        break b;
                                    }
                                    e = d - 1 | 0;
                                    if (G[e + a | 0] != 10) {
                                        continue;
                                    }
                                    break;
                                }
                                e = ga[F[c + 36 >> 2]](c, a, d) | 0;
                                if (e >>> 0 < d >>> 0) {
                                    break a;
                                }
                                a = a + d | 0;
                                b = b - d | 0;
                                f = F[c + 20 >> 2];
                            }
                            ta(f, a, b);
                            F[c + 20 >> 2] = F[c + 20 >> 2] + b;
                            e = b + d | 0;
                        } return e; }
                        function Lg(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0; d = ea - 16 | 0; ea = d; a: {
                            e = La(c);
                            if (e >>> 0 < 4294967280) {
                                b: {
                                    c: {
                                        if (e >>> 0 >= 11) {
                                            g = e + 16 & -16;
                                            f = sa(g);
                                            F[d + 8 >> 2] = g | -2147483648;
                                            F[d >> 2] = f;
                                            F[d + 4 >> 2] = e;
                                            break c;
                                        }
                                        D[d + 11 | 0] = e;
                                        f = d;
                                        if (!e) {
                                            break b;
                                        }
                                    }
                                    ta(f, c, e);
                                }
                                D[e + f | 0] = 0;
                                f = a + 16 | 0;
                                c = Zd(b, d, f);
                                b = D[a + 27 | 0];
                                a = F[a + 16 >> 2];
                                if (D[d + 11 | 0] < 0) {
                                    ra(F[d >> 2]);
                                }
                                ea = d + 16 | 0;
                                a = c ? (b | 0) < 0 ? a : f : 0;
                                break a;
                            }
                            Ma();
                            V();
                        } return a | 0; }
                        function bd(a) { var b = 0, c = 0, d = 0, e = 0; if (G[a + 76 | 0]) {
                            D[a + 76 | 0] = 0;
                            d = F[a + 60 >> 2];
                            c = F[a + 72 >> 2] + 7 | 0;
                            b = c >>> 0 < 7 ? 1 : b;
                            e = b >>> 3 | 0;
                            c = b << 29 | c >>> 3;
                            b = c + F[a + 56 >> 2] | 0;
                            d = d + e | 0;
                            F[a + 56 >> 2] = b;
                            F[a + 60 >> 2] = b >>> 0 < c >>> 0 ? d + 1 | 0 : d;
                        } if (H[a + 38 >> 1] <= 513) {
                            D[a + 132 | 0] = 0;
                            d = F[a + 116 >> 2];
                            b = 0;
                            c = F[a + 128 >> 2] + 7 | 0;
                            b = c >>> 0 < 7 ? 1 : b;
                            e = b >>> 3 | 0;
                            c = b << 29 | c >>> 3;
                            b = c + F[a + 112 >> 2] | 0;
                            d = d + e | 0;
                            F[a + 112 >> 2] = b;
                            F[a + 116 >> 2] = b >>> 0 < c >>> 0 ? d + 1 | 0 : d;
                        } }
                        function Gh(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0; d = ea + -64 | 0; ea = d; e = ga[F[F[a >> 2] + 44 >> 2]](a, b) | 0; a = ga[F[F[a >> 2] + 40 >> 2]](a, b) | 0; f = Fb(d); g = F[b + 56 >> 2]; h = e << 24 >> 24; i = a; a = a - 1 | 0; if (a >>> 0 <= 10) {
                            a = F[(a << 2) + 13616 >> 2];
                        }
                        else {
                            a = -1;
                        } a = L(a, e); mc(f, g, h, i, 0, a, a >> 31); a = kc(sa(96), f); qb(a, c); D[a + 84 | 0] = 1; F[a + 72 >> 2] = F[a + 68 >> 2]; F[a + 60 >> 2] = F[b + 60 >> 2]; ea = d - -64 | 0; return a | 0; }
                        function pe(a, b, c) { var d = 0, e = 0, f = 0, g = 0; a: {
                            if (a >>> 0 > 10) {
                                break a;
                            }
                            d = F[c + 20 >> 2];
                            e = F[c + 12 >> 2];
                            f = F[c + 16 >> 2];
                            if ((d | 0) >= (e | 0) & f >>> 0 >= I[c + 8 >> 2] | (d | 0) > (e | 0)) {
                                break a;
                            }
                            e = D[f + F[c >> 2] | 0];
                            f = f + 1 | 0;
                            d = f ? d : d + 1 | 0;
                            F[c + 16 >> 2] = f;
                            F[c + 20 >> 2] = d;
                            b: {
                                if ((e | 0) < 0) {
                                    if (!pe(a + 1 | 0, b, c)) {
                                        break a;
                                    }
                                    c = F[b >> 2];
                                    a = F[b + 4 >> 2] << 7 | c >>> 25;
                                    c = e & 127 | c << 7;
                                    break b;
                                }
                                a = 0;
                                c = e & 255;
                            }
                            F[b >> 2] = c;
                            F[b + 4 >> 2] = a;
                            g = 1;
                        } return g; }
                        function ib(a, b, c) { var d = 0, e = 0, f = 0, g = 0; a: {
                            if (a >>> 0 > 10) {
                                break a;
                            }
                            d = F[c + 20 >> 2];
                            e = F[c + 12 >> 2];
                            f = F[c + 16 >> 2];
                            if ((d | 0) >= (e | 0) & f >>> 0 >= I[c + 8 >> 2] | (d | 0) > (e | 0)) {
                                break a;
                            }
                            e = D[f + F[c >> 2] | 0];
                            f = f + 1 | 0;
                            d = f ? d : d + 1 | 0;
                            F[c + 16 >> 2] = f;
                            F[c + 20 >> 2] = d;
                            b: {
                                if ((e | 0) < 0) {
                                    if (!ib(a + 1 | 0, b, c)) {
                                        break a;
                                    }
                                    c = F[b >> 2];
                                    a = F[b + 4 >> 2] << 7 | c >>> 25;
                                    c = e & 127 | c << 7;
                                    break b;
                                }
                                a = 0;
                                c = e & 255;
                            }
                            F[b >> 2] = c;
                            F[b + 4 >> 2] = a;
                            g = 1;
                        } return g; }
                        function Ae(a, b) { var c = 0, d = 0, e = 0, f = 0, g = 0; F[a + 144 >> 2] = b; c = F[(ga[F[F[b >> 2] + 32 >> 2]](b) | 0) + 32 >> 2]; e = F[c >> 2] + F[c + 16 >> 2] | 0; d = F[(ga[F[F[b >> 2] + 32 >> 2]](b) | 0) + 32 >> 2]; c = F[d + 8 >> 2]; d = F[d + 16 >> 2]; c = c - d | 0; f = a, g = H[F[(ga[F[F[b >> 2] + 32 >> 2]](b) | 0) + 32 >> 2] + 38 >> 1], E[f + 38 >> 1] = g; F[a >> 2] = e; F[a + 16 >> 2] = 0; F[a + 20 >> 2] = 0; F[a + 8 >> 2] = c; F[a + 12 >> 2] = 0; f = a, g = ga[F[F[b >> 2] + 36 >> 2]](b) | 0, F[f + 148 >> 2] = g; }
                        function Ef(a, b, c, d, e) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; if (Za(a, F[b + 8 >> 2], e)) {
                            if (!(F[b + 28 >> 2] == 1 | F[b + 4 >> 2] != (c | 0))) {
                                F[b + 28 >> 2] = d;
                            }
                            return;
                        } a: {
                            if (!Za(a, F[b >> 2], e)) {
                                break a;
                            }
                            if (!(F[b + 16 >> 2] != (c | 0) & F[b + 20 >> 2] != (c | 0))) {
                                if ((d | 0) != 1) {
                                    break a;
                                }
                                F[b + 32 >> 2] = 1;
                                return;
                            }
                            F[b + 20 >> 2] = c;
                            F[b + 32 >> 2] = d;
                            F[b + 40 >> 2] = F[b + 40 >> 2] + 1;
                            if (!(F[b + 36 >> 2] != 1 | F[b + 24 >> 2] != 2)) {
                                D[b + 54 | 0] = 1;
                            }
                            F[b + 44 >> 2] = 4;
                        } }
                        function vg(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; var e = 0, f = 0, g = 0; a: {
                            if (I[b + 80 >> 2] > 65535) {
                                break a;
                            }
                            f = F[b + 96 >> 2];
                            b = F[b + 100 >> 2] - f | 0;
                            a = (b | 0) / 12 | 0;
                            e = L(a, 6);
                            g = (e | 0) == (c | 0);
                            if (!b | (c | 0) != (e | 0)) {
                                break a;
                            }
                            g = 1;
                            e = a >>> 0 > 1 ? a : 1;
                            a = 0;
                            while (1) {
                                b = L(a, 6) + d | 0;
                                c = L(a, 12) + f | 0;
                                E[b >> 1] = F[c >> 2];
                                E[b + 2 >> 1] = F[c + 4 >> 2];
                                E[b + 4 >> 1] = F[c + 8 >> 2];
                                a = a + 1 | 0;
                                if ((e | 0) != (a | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } return g | 0; }
                        function li(a) { a = a | 0; var b = 0, c = 0, d = 0; F[a >> 2] = 11304; b = F[a + 48 >> 2]; F[a + 48 >> 2] = 0; if (b) {
                            ga[F[F[b >> 2] + 4 >> 2]](b);
                        } F[a >> 2] = 13312; b = F[a + 20 >> 2]; if (b) {
                            F[a + 24 >> 2] = b;
                            ra(b);
                        } d = F[a + 8 >> 2]; if (d) {
                            c = F[a + 12 >> 2];
                            if ((c | 0) == (d | 0)) {
                                b = d;
                            }
                            else {
                                while (1) {
                                    c = c - 4 | 0;
                                    b = F[c >> 2];
                                    F[c >> 2] = 0;
                                    if (b) {
                                        ga[F[F[b >> 2] + 4 >> 2]](b);
                                    }
                                    if ((d | 0) != (c | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                b = F[a + 8 >> 2];
                            }
                            F[a + 12 >> 2] = d;
                            ra(b);
                        } return a | 0; }
                        function ki(a) { a = a | 0; var b = 0, c = 0, d = 0; F[a >> 2] = 11304; b = F[a + 48 >> 2]; F[a + 48 >> 2] = 0; if (b) {
                            ga[F[F[b >> 2] + 4 >> 2]](b);
                        } F[a >> 2] = 13312; b = F[a + 20 >> 2]; if (b) {
                            F[a + 24 >> 2] = b;
                            ra(b);
                        } d = F[a + 8 >> 2]; if (d) {
                            c = F[a + 12 >> 2];
                            if ((c | 0) == (d | 0)) {
                                b = d;
                            }
                            else {
                                while (1) {
                                    c = c - 4 | 0;
                                    b = F[c >> 2];
                                    F[c >> 2] = 0;
                                    if (b) {
                                        ga[F[F[b >> 2] + 4 >> 2]](b);
                                    }
                                    if ((d | 0) != (c | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                b = F[a + 8 >> 2];
                            }
                            F[a + 12 >> 2] = d;
                            ra(b);
                        } ra(a); }
                        function wh(a) { a = a | 0; var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0, h = 0; b = F[a + 32 >> 2]; f = F[b + 8 >> 2]; e = F[b + 12 >> 2]; d = F[b + 20 >> 2]; h = f; f = F[b + 16 >> 2]; g = f + 4 | 0; d = g >>> 0 < 4 ? d + 1 | 0 : d; a: {
                            if (h >>> 0 < g >>> 0 & (d | 0) >= (e | 0) | (d | 0) > (e | 0)) {
                                break a;
                            }
                            c = f + F[b >> 2] | 0;
                            e = G[c | 0] | G[c + 1 | 0] << 8 | (G[c + 2 | 0] << 16 | G[c + 3 | 0] << 24);
                            F[b + 16 >> 2] = g;
                            F[b + 20 >> 2] = d;
                            c = 0;
                            if ((e | 0) < 0) {
                                break a;
                            }
                            F[F[a + 4 >> 2] + 80 >> 2] = e;
                            c = 1;
                        } return c | 0; }
                        function Dd(a, b, c, d) { D[a + 53 | 0] = 1; a: {
                            if (F[a + 4 >> 2] != (c | 0)) {
                                break a;
                            }
                            D[a + 52 | 0] = 1;
                            c = F[a + 16 >> 2];
                            b: {
                                if (!c) {
                                    F[a + 36 >> 2] = 1;
                                    F[a + 24 >> 2] = d;
                                    F[a + 16 >> 2] = b;
                                    if ((d | 0) != 1) {
                                        break a;
                                    }
                                    if (F[a + 48 >> 2] == 1) {
                                        break b;
                                    }
                                    break a;
                                }
                                if ((b | 0) == (c | 0)) {
                                    c = F[a + 24 >> 2];
                                    if ((c | 0) == 2) {
                                        F[a + 24 >> 2] = d;
                                        c = d;
                                    }
                                    if (F[a + 48 >> 2] != 1) {
                                        break a;
                                    }
                                    if ((c | 0) == 1) {
                                        break b;
                                    }
                                    break a;
                                }
                                F[a + 36 >> 2] = F[a + 36 >> 2] + 1;
                            }
                            D[a + 54 | 0] = 1;
                        } }
                        function uh(a) { a = a | 0; var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0, h = 0; d = F[a + 32 >> 2]; e = F[d + 12 >> 2]; g = F[d + 8 >> 2]; b = g; c = F[d + 20 >> 2]; h = F[d + 16 >> 2]; f = h + 4 | 0; c = f >>> 0 < 4 ? c + 1 | 0 : c; if ((c | 0) <= (e | 0) & b >>> 0 >= f >>> 0 | (c | 0) < (e | 0)) {
                            b = h + F[d >> 2] | 0;
                            b = G[b | 0] | G[b + 1 | 0] << 8 | (G[b + 2 | 0] << 16 | G[b + 3 | 0] << 24);
                            F[d + 16 >> 2] = f;
                            F[d + 20 >> 2] = c;
                            F[F[a + 4 >> 2] + 80 >> 2] = b;
                        } return (c | 0) <= (e | 0) & f >>> 0 <= g >>> 0 | (c | 0) < (e | 0); }
                        function Ee(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0; d = ea - 16 | 0; ea = d; F[a + 4 >> 2] = b; b = F[b + 64 >> 2]; e = F[b >> 2]; b = F[b + 4 >> 2]; D[d + 15 | 0] = 0; Na(a + 24 | 0, (b - e >> 2 >>> 0) / 3 | 0, d + 15 | 0); b = F[a + 4 >> 2]; e = F[b + 56 >> 2]; b = F[b + 52 >> 2]; D[d + 14 | 0] = 0; Na(a + 36 | 0, e - b >> 2, d + 14 | 0); b = F[c + 12 >> 2]; F[a + 16 >> 2] = F[c + 8 >> 2]; F[a + 20 >> 2] = b; b = F[c + 4 >> 2]; F[a + 8 >> 2] = F[c >> 2]; F[a + 12 >> 2] = b; ea = d + 16 | 0; }
                        function lf(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0; e = ga[F[F[a >> 2] + 24 >> 2]](a) | 0; c = 1; a: {
                            if ((e | 0) <= 0) {
                                break a;
                            }
                            d = F[F[a + 36 >> 2] >> 2];
                            f = a + 48 | 0;
                            c = 0;
                            if (!(ga[F[F[d >> 2] + 16 >> 2]](d, f, b) | 0)) {
                                break a;
                            }
                            d = 1;
                            while (1) {
                                c = d;
                                if ((e | 0) != (c | 0)) {
                                    d = c + 1 | 0;
                                    g = F[F[a + 36 >> 2] + (c << 2) >> 2];
                                    if (ga[F[F[g >> 2] + 16 >> 2]](g, f, b) | 0) {
                                        continue;
                                    }
                                }
                                break;
                            }
                            c = (c | 0) >= (e | 0);
                        } return c | 0; }
                        function kf(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0, e = 0, f = 0, g = 0; e = ga[F[F[a >> 2] + 24 >> 2]](a) | 0; c = 1; a: {
                            if ((e | 0) <= 0) {
                                break a;
                            }
                            d = F[F[a + 36 >> 2] >> 2];
                            f = a + 48 | 0;
                            c = 0;
                            if (!(ga[F[F[d >> 2] + 20 >> 2]](d, f, b) | 0)) {
                                break a;
                            }
                            d = 1;
                            while (1) {
                                c = d;
                                if ((e | 0) != (c | 0)) {
                                    d = c + 1 | 0;
                                    g = F[F[a + 36 >> 2] + (c << 2) >> 2];
                                    if (ga[F[F[g >> 2] + 20 >> 2]](g, f, b) | 0) {
                                        continue;
                                    }
                                }
                                break;
                            }
                            c = (c | 0) >= (e | 0);
                        } return c | 0; }
                        function qc(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0; if (b) {
                            g = 0 - G[a + 12 | 0] & 255;
                            h = F[a >> 2];
                            e = F[a + 8 >> 2];
                            while (1) {
                                i = d << 1;
                                a: {
                                    if (e >>> 0 > 4095) {
                                        break a;
                                    }
                                    d = F[a + 4 >> 2];
                                    if ((d | 0) <= 0) {
                                        break a;
                                    }
                                    d = d - 1 | 0;
                                    F[a + 4 >> 2] = d;
                                    e = G[d + h | 0] | e << 8;
                                }
                                f = e & 255;
                                d = f >>> 0 < g >>> 0;
                                j = f;
                                f = L(e >>> 8 | 0, g);
                                e = d ? j + f | 0 : e - (g + f | 0) | 0;
                                F[a + 8 >> 2] = e;
                                d = d | i;
                                b = b - 1 | 0;
                                if (b) {
                                    continue;
                                }
                                break;
                            }
                        } F[c >> 2] = d; }
                        function be(a) { F[a >> 2] = 0; F[a + 4 >> 2] = 0; F[a + 28 >> 2] = 0; F[a + 32 >> 2] = 0; D[a + 24 | 0] = 1; F[a + 16 >> 2] = 0; F[a + 20 >> 2] = 0; F[a + 8 >> 2] = 0; F[a + 12 >> 2] = 0; F[a + 36 >> 2] = 0; F[a + 40 >> 2] = 0; F[a + 44 >> 2] = 0; F[a + 48 >> 2] = 0; F[a + 52 >> 2] = 0; F[a + 56 >> 2] = 0; F[a + 60 >> 2] = 0; F[a + 64 >> 2] = 0; F[a + 72 >> 2] = 0; F[a + 76 >> 2] = 0; F[a + 80 >> 2] = 0; F[a + 84 >> 2] = 0; F[a + 88 >> 2] = 0; F[a + 92 >> 2] = 0; F[a + 68 >> 2] = a; }
                        function Wh(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0; d = ea - 16 | 0; ea = d; F[a + 4 >> 2] = b; e = F[b >> 2]; b = F[b + 4 >> 2]; D[d + 15 | 0] = 0; Na(a + 24 | 0, (b - e >> 2 >>> 0) / 3 | 0, d + 15 | 0); b = F[a + 4 >> 2]; e = F[b + 28 >> 2]; b = F[b + 24 >> 2]; D[d + 14 | 0] = 0; Na(a + 36 | 0, e - b >> 2, d + 14 | 0); b = F[c + 12 >> 2]; F[a + 16 >> 2] = F[c + 8 >> 2]; F[a + 20 >> 2] = b; b = F[c + 4 >> 2]; F[a + 8 >> 2] = F[c >> 2]; F[a + 12 >> 2] = b; ea = d + 16 | 0; }
                        function Lc(a) { var b = 0; F[a >> 2] = 0; F[a + 4 >> 2] = 0; F[a + 56 >> 2] = 0; F[a + 48 >> 2] = 0; F[a + 52 >> 2] = 0; F[a + 40 >> 2] = 0; F[a + 44 >> 2] = 0; F[a + 32 >> 2] = 0; F[a + 36 >> 2] = 0; F[a + 24 >> 2] = 0; F[a + 28 >> 2] = 0; F[a + 16 >> 2] = 0; F[a + 20 >> 2] = 0; F[a + 8 >> 2] = 0; F[a + 12 >> 2] = 0; b = a - -64 | 0; F[b >> 2] = 0; F[b + 4 >> 2] = 0; F[a + 72 >> 2] = 0; F[a + 76 >> 2] = 0; F[a + 80 >> 2] = 0; F[a + 84 >> 2] = 0; F[a + 60 >> 2] = a; }
                        function ud(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0; a: {
                            if (a >>> 0 > 5) {
                                break a;
                            }
                            f = F[c + 20 >> 2];
                            d = f;
                            g = F[c + 12 >> 2];
                            e = F[c + 16 >> 2];
                            if ((d | 0) >= (g | 0) & e >>> 0 >= I[c + 8 >> 2] | (d | 0) > (g | 0)) {
                                break a;
                            }
                            d = G[e + F[c >> 2] | 0];
                            e = e + 1 | 0;
                            f = e ? f : f + 1 | 0;
                            F[c + 16 >> 2] = e;
                            F[c + 20 >> 2] = f;
                            if (d & 128) {
                                if (!ud(a + 1 | 0, b, c)) {
                                    break a;
                                }
                                d = d & 127 | F[b >> 2] << 7;
                            }
                            F[b >> 2] = d;
                            h = 1;
                        } return h; }
                        function sb(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0; a: {
                            if (a >>> 0 > 5) {
                                break a;
                            }
                            f = F[c + 20 >> 2];
                            d = f;
                            g = F[c + 12 >> 2];
                            e = F[c + 16 >> 2];
                            if ((d | 0) >= (g | 0) & e >>> 0 >= I[c + 8 >> 2] | (d | 0) > (g | 0)) {
                                break a;
                            }
                            d = G[e + F[c >> 2] | 0];
                            e = e + 1 | 0;
                            f = e ? f : f + 1 | 0;
                            F[c + 16 >> 2] = e;
                            F[c + 20 >> 2] = f;
                            if (d & 128) {
                                if (!sb(a + 1 | 0, b, c)) {
                                    break a;
                                }
                                d = d & 127 | F[b >> 2] << 7;
                            }
                            F[b >> 2] = d;
                            h = 1;
                        } return h; }
                        function jb(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0; a: {
                            if (a >>> 0 > 5) {
                                break a;
                            }
                            f = F[c + 20 >> 2];
                            d = f;
                            g = F[c + 12 >> 2];
                            e = F[c + 16 >> 2];
                            if ((d | 0) >= (g | 0) & e >>> 0 >= I[c + 8 >> 2] | (d | 0) > (g | 0)) {
                                break a;
                            }
                            d = G[e + F[c >> 2] | 0];
                            e = e + 1 | 0;
                            f = e ? f : f + 1 | 0;
                            F[c + 16 >> 2] = e;
                            F[c + 20 >> 2] = f;
                            if (d & 128) {
                                if (!jb(a + 1 | 0, b, c)) {
                                    break a;
                                }
                                d = d & 127 | F[b >> 2] << 7;
                            }
                            F[b >> 2] = d;
                            h = 1;
                        } return h; }
                        function Pb(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0; a: {
                            if (a >>> 0 > 5) {
                                break a;
                            }
                            f = F[c + 20 >> 2];
                            d = f;
                            g = F[c + 12 >> 2];
                            e = F[c + 16 >> 2];
                            if ((d | 0) >= (g | 0) & e >>> 0 >= I[c + 8 >> 2] | (d | 0) > (g | 0)) {
                                break a;
                            }
                            d = G[e + F[c >> 2] | 0];
                            e = e + 1 | 0;
                            f = e ? f : f + 1 | 0;
                            F[c + 16 >> 2] = e;
                            F[c + 20 >> 2] = f;
                            if (d & 128) {
                                if (!Pb(a + 1 | 0, b, c)) {
                                    break a;
                                }
                                d = d & 127 | F[b >> 2] << 7;
                            }
                            F[b >> 2] = d;
                            h = 1;
                        } return h; }
                        function Oc(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0; a: {
                            if (a >>> 0 > 5) {
                                break a;
                            }
                            f = F[c + 20 >> 2];
                            d = f;
                            g = F[c + 12 >> 2];
                            e = F[c + 16 >> 2];
                            if ((d | 0) >= (g | 0) & e >>> 0 >= I[c + 8 >> 2] | (d | 0) > (g | 0)) {
                                break a;
                            }
                            d = G[e + F[c >> 2] | 0];
                            e = e + 1 | 0;
                            f = e ? f : f + 1 | 0;
                            F[c + 16 >> 2] = e;
                            F[c + 20 >> 2] = f;
                            if (d & 128) {
                                if (!Oc(a + 1 | 0, b, c)) {
                                    break a;
                                }
                                d = d & 127 | F[b >> 2] << 7;
                            }
                            F[b >> 2] = d;
                            h = 1;
                        } return h; }
                        function Ne(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0; a: {
                            if (a >>> 0 > 5) {
                                break a;
                            }
                            f = F[c + 20 >> 2];
                            d = f;
                            g = F[c + 12 >> 2];
                            e = F[c + 16 >> 2];
                            if ((d | 0) >= (g | 0) & e >>> 0 >= I[c + 8 >> 2] | (d | 0) > (g | 0)) {
                                break a;
                            }
                            d = G[e + F[c >> 2] | 0];
                            e = e + 1 | 0;
                            f = e ? f : f + 1 | 0;
                            F[c + 16 >> 2] = e;
                            F[c + 20 >> 2] = f;
                            if (d & 128) {
                                if (!Ne(a + 1 | 0, b, c)) {
                                    break a;
                                }
                                d = d & 127 | F[b >> 2] << 7;
                            }
                            F[b >> 2] = d;
                            h = 1;
                        } return h; }
                        function Fa(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0; a: {
                            if (a >>> 0 > 5) {
                                break a;
                            }
                            f = F[c + 20 >> 2];
                            d = f;
                            g = F[c + 12 >> 2];
                            e = F[c + 16 >> 2];
                            if ((d | 0) >= (g | 0) & e >>> 0 >= I[c + 8 >> 2] | (d | 0) > (g | 0)) {
                                break a;
                            }
                            d = G[e + F[c >> 2] | 0];
                            e = e + 1 | 0;
                            f = e ? f : f + 1 | 0;
                            F[c + 16 >> 2] = e;
                            F[c + 20 >> 2] = f;
                            if (d & 128) {
                                if (!Fa(a + 1 | 0, b, c)) {
                                    break a;
                                }
                                d = d & 127 | F[b >> 2] << 7;
                            }
                            F[b >> 2] = d;
                            h = 1;
                        } return h; }
                        function Cb(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0; a: {
                            if (a >>> 0 > 5) {
                                break a;
                            }
                            f = F[c + 20 >> 2];
                            d = f;
                            g = F[c + 12 >> 2];
                            e = F[c + 16 >> 2];
                            if ((d | 0) >= (g | 0) & e >>> 0 >= I[c + 8 >> 2] | (d | 0) > (g | 0)) {
                                break a;
                            }
                            d = G[e + F[c >> 2] | 0];
                            e = e + 1 | 0;
                            f = e ? f : f + 1 | 0;
                            F[c + 16 >> 2] = e;
                            F[c + 20 >> 2] = f;
                            if (d & 128) {
                                if (!Cb(a + 1 | 0, b, c)) {
                                    break a;
                                }
                                d = d & 127 | F[b >> 2] << 7;
                            }
                            F[b >> 2] = d;
                            h = 1;
                        } return h; }
                        function ug(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; var e = 0, f = 0, g = 0, h = 0; g = F[b + 96 >> 2]; b = F[b + 100 >> 2] - g | 0; if (!((b | 0) != (c | 0) | !b)) {
                            a = (c | 0) / 12 | 0;
                            h = a >>> 0 > 1 ? a : 1;
                            a = 0;
                            while (1) {
                                e = L(a, 12);
                                f = e + d | 0;
                                e = e + g | 0;
                                F[f >> 2] = F[e >> 2];
                                F[f + 4 >> 2] = F[e + 4 >> 2];
                                F[f + 8 >> 2] = F[e + 8 >> 2];
                                a = a + 1 | 0;
                                if ((h | 0) != (a | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } return (b | 0) == (c | 0) | 0; }
                        function Ha(a, b, c) { var d = 0, e = 0; a: {
                            b: {
                                if (c >>> 0 >= 4) {
                                    if ((a | b) & 3) {
                                        break b;
                                    }
                                    while (1) {
                                        if (F[a >> 2] != F[b >> 2]) {
                                            break b;
                                        }
                                        b = b + 4 | 0;
                                        a = a + 4 | 0;
                                        c = c - 4 | 0;
                                        if (c >>> 0 > 3) {
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                if (!c) {
                                    break a;
                                }
                            }
                            while (1) {
                                d = G[a | 0];
                                e = G[b | 0];
                                if ((d | 0) == (e | 0)) {
                                    b = b + 1 | 0;
                                    a = a + 1 | 0;
                                    c = c - 1 | 0;
                                    if (c) {
                                        continue;
                                    }
                                    break a;
                                }
                                break;
                            }
                            return d - e | 0;
                        } return 0; }
                        function yg(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0; d = F[b + 4 >> 2]; a: {
                            if (!d) {
                                break a;
                            }
                            b = F[F[F[b + 8 >> 2] + (c << 2) >> 2] + 60 >> 2];
                            if ((b | 0) < 0) {
                                break a;
                            }
                            a = F[d + 24 >> 2];
                            c = F[d + 28 >> 2];
                            if ((a | 0) == (c | 0)) {
                                break a;
                            }
                            b: {
                                while (1) {
                                    e = F[a >> 2];
                                    if ((b | 0) == F[e + 24 >> 2]) {
                                        break b;
                                    }
                                    a = a + 4 | 0;
                                    if ((c | 0) != (a | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                e = 0;
                            }
                        } return e | 0; }
                        function Tc(a) { var b = 0, c = 0, d = 0; if (a) {
                            d = F[a + 24 >> 2];
                            if (d) {
                                c = F[a + 28 >> 2];
                                if ((c | 0) == (d | 0)) {
                                    b = d;
                                }
                                else {
                                    while (1) {
                                        c = c - 4 | 0;
                                        b = F[c >> 2];
                                        F[c >> 2] = 0;
                                        if (b) {
                                            Qa(b + 12 | 0, F[b + 16 >> 2]);
                                            Pa(b, F[b + 4 >> 2]);
                                            ra(b);
                                        }
                                        if ((d | 0) != (c | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                    b = F[a + 24 >> 2];
                                }
                                F[a + 28 >> 2] = d;
                                ra(b);
                            }
                            Qa(a + 12 | 0, F[a + 16 >> 2]);
                            Pa(a, F[a + 4 >> 2]);
                            ra(a);
                        } }
                        function Xc(a) { var b = 0, c = 0, d = 0; d = F[a >> 2]; if (d) {
                            b = F[a + 4 >> 2];
                            if ((d | 0) == (b | 0)) {
                                b = d;
                            }
                            else {
                                while (1) {
                                    c = F[b - 12 >> 2];
                                    if (c) {
                                        F[b - 8 >> 2] = c;
                                        ra(c);
                                    }
                                    c = F[b - 28 >> 2];
                                    if (c) {
                                        F[b - 24 >> 2] = c;
                                        ra(c);
                                    }
                                    c = F[b - 40 >> 2];
                                    if (c) {
                                        F[b - 36 >> 2] = c;
                                        ra(c);
                                    }
                                    pc(b - 140 | 0);
                                    b = b - 144 | 0;
                                    if ((d | 0) != (b | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                b = F[a >> 2];
                            }
                            F[a + 4 >> 2] = d;
                            ra(b);
                        } }
                        function Uh(a) { a = a | 0; var b = 0; F[a + 8 >> 2] = 12416; F[a >> 2] = 12204; b = F[a + 96 >> 2]; if (b) {
                            F[a + 100 >> 2] = b;
                            ra(b);
                        } b = F[a + 80 >> 2]; if (b) {
                            F[a + 84 >> 2] = b;
                            ra(b);
                        } b = F[a + 68 >> 2]; if (b) {
                            F[a + 72 >> 2] = b;
                            ra(b);
                        } b = F[a + 56 >> 2]; if (b) {
                            F[a + 60 >> 2] = b;
                            ra(b);
                        } F[a + 8 >> 2] = 12652; b = F[a + 44 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 32 >> 2]; if (b) {
                            ra(b);
                        } return a | 0; }
                        function qi(a) { a = a | 0; var b = 0, c = 0, d = 0; F[a >> 2] = 13312; b = F[a + 20 >> 2]; if (b) {
                            F[a + 24 >> 2] = b;
                            ra(b);
                        } d = F[a + 8 >> 2]; if (d) {
                            c = F[a + 12 >> 2];
                            if ((c | 0) == (d | 0)) {
                                b = d;
                            }
                            else {
                                while (1) {
                                    c = c - 4 | 0;
                                    b = F[c >> 2];
                                    F[c >> 2] = 0;
                                    if (b) {
                                        ga[F[F[b >> 2] + 4 >> 2]](b);
                                    }
                                    if ((d | 0) != (c | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                b = F[a + 8 >> 2];
                            }
                            F[a + 12 >> 2] = d;
                            ra(b);
                        } return a | 0; }
                        function Th(a) { a = a | 0; var b = 0; F[a + 8 >> 2] = 12416; F[a >> 2] = 12204; b = F[a + 96 >> 2]; if (b) {
                            F[a + 100 >> 2] = b;
                            ra(b);
                        } b = F[a + 80 >> 2]; if (b) {
                            F[a + 84 >> 2] = b;
                            ra(b);
                        } b = F[a + 68 >> 2]; if (b) {
                            F[a + 72 >> 2] = b;
                            ra(b);
                        } b = F[a + 56 >> 2]; if (b) {
                            F[a + 60 >> 2] = b;
                            ra(b);
                        } F[a + 8 >> 2] = 12652; b = F[a + 44 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 32 >> 2]; if (b) {
                            ra(b);
                        } ra(a); }
                        function La(a) { var b = 0, c = 0, d = 0; b = a; a: {
                            if (b & 3) {
                                while (1) {
                                    if (!G[b | 0]) {
                                        break a;
                                    }
                                    b = b + 1 | 0;
                                    if (b & 3) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            while (1) {
                                c = b;
                                b = b + 4 | 0;
                                d = F[c >> 2];
                                if (!((d ^ -1) & d - 16843009 & -2139062144)) {
                                    continue;
                                }
                                break;
                            }
                            if (!(d & 255)) {
                                return c - a | 0;
                            }
                            while (1) {
                                d = G[c + 1 | 0];
                                b = c + 1 | 0;
                                c = b;
                                if (d) {
                                    continue;
                                }
                                break;
                            }
                        } return b - a | 0; }
                        function Vc(a) { a = a | 0; var b = 0, c = 0, d = 0; F[a >> 2] = 13312; b = F[a + 20 >> 2]; if (b) {
                            F[a + 24 >> 2] = b;
                            ra(b);
                        } d = F[a + 8 >> 2]; if (d) {
                            c = F[a + 12 >> 2];
                            if ((c | 0) == (d | 0)) {
                                b = d;
                            }
                            else {
                                while (1) {
                                    c = c - 4 | 0;
                                    b = F[c >> 2];
                                    F[c >> 2] = 0;
                                    if (b) {
                                        ga[F[F[b >> 2] + 4 >> 2]](b);
                                    }
                                    if ((d | 0) != (c | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                b = F[a + 8 >> 2];
                            }
                            F[a + 12 >> 2] = d;
                            ra(b);
                        } ra(a); }
                        function yc(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0; h = F[c + 8 >> 2]; e = F[c + 16 >> 2]; g = F[c + 12 >> 2]; f = g; d = F[c + 20 >> 2]; if (h >>> 0 > e >>> 0 & (f | 0) >= (d | 0) | (d | 0) < (f | 0)) {
                            b = G[e + F[c >> 2] | 0];
                            i = e + 1 | 0;
                            f = i ? d : d + 1 | 0;
                            F[c + 16 >> 2] = i;
                            F[c + 20 >> 2] = f;
                            F[a + 4 >> 2] = b;
                        } return e >>> 0 < h >>> 0 & (d | 0) <= (g | 0) | (d | 0) < (g | 0); }
                        function Za(a, b, c) { var d = 0; if (!c) {
                            return F[a + 4 >> 2] == F[b + 4 >> 2];
                        } if ((a | 0) == (b | 0)) {
                            return 1;
                        } d = F[a + 4 >> 2]; a = G[d | 0]; c = F[b + 4 >> 2]; b = G[c | 0]; a: {
                            if (!a | (b | 0) != (a | 0)) {
                                break a;
                            }
                            while (1) {
                                b = G[c + 1 | 0];
                                a = G[d + 1 | 0];
                                if (!a) {
                                    break a;
                                }
                                c = c + 1 | 0;
                                d = d + 1 | 0;
                                if ((a | 0) == (b | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } return (a | 0) == (b | 0); }
                        function Vh(a) { a = a | 0; var b = 0; F[a >> 2] = 12416; b = F[a + 88 >> 2]; if (b) {
                            F[a + 92 >> 2] = b;
                            ra(b);
                        } b = F[a + 72 >> 2]; if (b) {
                            F[a + 76 >> 2] = b;
                            ra(b);
                        } b = F[a + 60 >> 2]; if (b) {
                            F[a - -64 >> 2] = b;
                            ra(b);
                        } b = F[a + 48 >> 2]; if (b) {
                            F[a + 52 >> 2] = b;
                            ra(b);
                        } F[a >> 2] = 12652; b = F[a + 36 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 24 >> 2]; if (b) {
                            ra(b);
                        } return a | 0; }
                        function Ib(a, b) { var c = 0, d = 0, e = 0, f = 0; a: {
                            c = F[a >> 2];
                            b: {
                                if (F[a + 8 >> 2] - c >> 2 >>> 0 >= b >>> 0) {
                                    break b;
                                }
                                if (b >>> 0 >= 1073741824) {
                                    break a;
                                }
                                d = F[a + 4 >> 2];
                                e = b << 2;
                                b = sa(e);
                                e = b + e | 0;
                                d = d - c | 0;
                                f = d + b | 0;
                                if ((d | 0) > 0) {
                                    ta(b, c, d);
                                }
                                F[a + 8 >> 2] = e;
                                F[a + 4 >> 2] = f;
                                F[a >> 2] = b;
                                if (!c) {
                                    break b;
                                }
                                ra(c);
                            }
                            return;
                        } wa(1336); V(); }
                        function Qh(a) { a = a | 0; var b = 0; F[a >> 2] = 12416; b = F[a + 88 >> 2]; if (b) {
                            F[a + 92 >> 2] = b;
                            ra(b);
                        } b = F[a + 72 >> 2]; if (b) {
                            F[a + 76 >> 2] = b;
                            ra(b);
                        } b = F[a + 60 >> 2]; if (b) {
                            F[a - -64 >> 2] = b;
                            ra(b);
                        } b = F[a + 48 >> 2]; if (b) {
                            F[a + 52 >> 2] = b;
                            ra(b);
                        } F[a >> 2] = 12652; b = F[a + 36 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 24 >> 2]; if (b) {
                            ra(b);
                        } ra(a); }
                        function Ag(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0; a = F[b + 12 >> 2]; b = F[b + 8 >> 2]; d = a - b | 0; a = 0; a: {
                            if (!d) {
                                break a;
                            }
                            a = d >> 2;
                            d = a >>> 0 > 1 ? a : 1;
                            a = 0;
                            b: {
                                while (1) {
                                    e = F[b + (a << 2) >> 2];
                                    if (F[e + 60 >> 2] == (c | 0)) {
                                        break b;
                                    }
                                    a = a + 1 | 0;
                                    if ((d | 0) != (a | 0)) {
                                        continue;
                                    }
                                    break;
                                }
                                a = 0;
                                break a;
                            }
                            a = (a | 0) == -1 ? 0 : e;
                        } return a | 0; }
                        function cb(a) { var b = 0; if (a) {
                            b = F[a + 76 >> 2];
                            if (b) {
                                F[a + 80 >> 2] = b;
                                ra(b);
                            }
                            b = F[a - -64 >> 2];
                            if (b) {
                                F[a + 68 >> 2] = b;
                                ra(b);
                            }
                            b = F[a + 48 >> 2];
                            if (b) {
                                F[a + 52 >> 2] = b;
                                ra(b);
                            }
                            b = F[a + 24 >> 2];
                            if (b) {
                                F[a + 28 >> 2] = b;
                                ra(b);
                            }
                            b = F[a + 12 >> 2];
                            if (b) {
                                F[a + 16 >> 2] = b;
                                ra(b);
                            }
                            b = F[a >> 2];
                            if (b) {
                                F[a + 4 >> 2] = b;
                                ra(b);
                            }
                            ra(a);
                        } }
                        function pc(a) { var b = 0; b = F[a + 84 >> 2]; if (b) {
                            F[a + 88 >> 2] = b;
                            ra(b);
                        } b = F[a + 72 >> 2]; if (b) {
                            F[a + 76 >> 2] = b;
                            ra(b);
                        } b = F[a + 52 >> 2]; if (b) {
                            F[a + 56 >> 2] = b;
                            ra(b);
                        } b = F[a + 40 >> 2]; if (b) {
                            F[a + 44 >> 2] = b;
                            ra(b);
                        } b = F[a + 28 >> 2]; if (b) {
                            F[a + 32 >> 2] = b;
                            ra(b);
                        } b = F[a + 12 >> 2]; if (b) {
                            ra(b);
                        } a = F[a >> 2]; if (a) {
                            ra(a);
                        } }
                        function Hd(a, b, c) { var d = 0, e = 0, f = 0, g = 0, h = 0; f = ea - 16 | 0; ea = f; d = ea - 16 | 0; ea = d; b = b - a >> 2; while (1) {
                            if (b) {
                                F[d + 12 >> 2] = a;
                                e = b >>> 1 | 0;
                                F[d + 12 >> 2] = F[d + 12 >> 2] + (e << 2);
                                h = (e ^ -1) + b | 0;
                                b = e;
                                e = F[d + 12 >> 2];
                                g = I[e >> 2] < I[c >> 2];
                                b = g ? h : b;
                                a = g ? e + 4 | 0 : a;
                                continue;
                            }
                            break;
                        } ea = d + 16 | 0; ea = f + 16 | 0; return a; }
                        function fd(a) { var b = 0, c = 0, d = 0; b = F[a + 4 >> 2]; d = F[a >> 2]; if ((b | 0) != (d | 0)) {
                            while (1) {
                                c = F[b - 12 >> 2];
                                if (c) {
                                    F[b - 8 >> 2] = c;
                                    ra(c);
                                }
                                c = F[b - 28 >> 2];
                                if (c) {
                                    F[b - 24 >> 2] = c;
                                    ra(c);
                                }
                                c = F[b - 40 >> 2];
                                if (c) {
                                    F[b - 36 >> 2] = c;
                                    ra(c);
                                }
                                pc(b - 140 | 0);
                                b = b - 144 | 0;
                                if ((d | 0) != (b | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } F[a + 4 >> 2] = d; }
                        function Ba(a, b, c) { var d = 0, e = 0; a: {
                            b: {
                                if (c >>> 0 <= 10) {
                                    d = a;
                                    D[d + 11 | 0] = c;
                                    break b;
                                }
                                if (c >>> 0 > 4294967279) {
                                    break a;
                                }
                                if (c >>> 0 >= 11) {
                                    e = c + 16 & -16;
                                    d = e - 1 | 0;
                                    d = (d | 0) == 11 ? e : d;
                                }
                                else {
                                    d = 10;
                                }
                                e = d + 1 | 0;
                                d = sa(e);
                                F[a >> 2] = d;
                                F[a + 8 >> 2] = e | -2147483648;
                                F[a + 4 >> 2] = c;
                            }
                            kb(d, b, c + 1 | 0);
                            return;
                        } Ma(); V(); }
                        function Wc(a, b) { var c = 0, d = 0; d = sa(40); F[d >> 2] = -1; c = d + 8 | 0; F[c + 16 >> 2] = 0; F[c + 20 >> 2] = 0; F[c + 8 >> 2] = 0; F[c >> 2] = 0; F[c + 4 >> 2] = 0; F[c + 24 >> 2] = 0; F[c + 28 >> 2] = 0; ga[F[F[a >> 2] + 16 >> 2]](a, d); a = F[b + 88 >> 2]; F[b + 88 >> 2] = d; if (a) {
                            b = F[a + 8 >> 2];
                            if (b) {
                                F[a + 12 >> 2] = b;
                                ra(b);
                            }
                            ra(a);
                        } return 1; }
                        function xg(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; var e = 0, f = 0; a = ea - 16 | 0; ea = a; b = F[b + 96 >> 2]; F[a + 8 >> 2] = 0; F[a >> 2] = 0; F[a + 4 >> 2] = 0; e = sa(12); c = ta(e, b + L(c, 12) | 0, 12); f = c + 12 | 0; b = F[d >> 2]; if (b) {
                            F[d + 4 >> 2] = b;
                            ra(b);
                        } F[d + 8 >> 2] = c + 12; F[d + 4 >> 2] = f; F[d >> 2] = e; ea = a + 16 | 0; return 1; }
                        function Ga(a) { var b = 0, c = 0, d = 0, e = 0, f = 0; d = G[a + 12 | 0]; c = F[a + 8 >> 2]; a: {
                            if (c >>> 0 > 4095) {
                                break a;
                            }
                            b = F[a + 4 >> 2];
                            if ((b | 0) <= 0) {
                                break a;
                            }
                            b = b - 1 | 0;
                            F[a + 4 >> 2] = b;
                            c = G[b + F[a >> 2] | 0] | c << 8;
                        } d = 0 - d & 255; b = L(d, c >>> 8 | 0); e = c & 255; f = e >>> 0 < d >>> 0; F[a + 8 >> 2] = f ? b + e | 0 : c - (b + d | 0) | 0; return f; }
                        function pd(a, b) { F[a + 4 >> 2] = 0; F[a + 8 >> 2] = 0; F[a >> 2] = 2012; F[a + 12 >> 2] = 0; F[a + 16 >> 2] = 0; F[a + 20 >> 2] = 0; F[a + 24 >> 2] = 0; F[a + 28 >> 2] = 0; F[a + 32 >> 2] = 0; F[a + 36 >> 2] = 0; F[a + 40 >> 2] = 0; F[a >> 2] = 2356; F[a + 44 >> 2] = 0; F[a + 48 >> 2] = 0; F[a + 52 >> 2] = 0; F[a + 56 >> 2] = 0; F[a + 60 >> 2] = b; return a; }
                        function qe(a, b, c, d) { a: {
                            if (!b) {
                                if ((d | 0) < 0) {
                                    return 0;
                                }
                                Va(a, c);
                                break a;
                            }
                            if ((d | 0) < 0) {
                                return 0;
                            }
                            if (!(!d & F[a + 4 >> 2] - F[a >> 2] >>> 0 >= c >>> 0)) {
                                Va(a, c);
                            }
                            if (!c) {
                                break a;
                            }
                            Wa(F[a >> 2], b, c);
                        } b = F[a + 28 >> 2]; c = F[a + 24 >> 2] + 1 | 0; b = c ? b : b + 1 | 0; F[a + 24 >> 2] = c; F[a + 28 >> 2] = b; return 1; }
                        function Ig(a) { a = a | 0; var b = 0, c = 0, d = 0; if (a) {
                            if (D[a + 27 | 0] < 0) {
                                ra(F[a + 16 >> 2]);
                            }
                            b = F[a >> 2];
                            if (b) {
                                c = F[a + 4 >> 2];
                                if ((c | 0) == (b | 0)) {
                                    d = b;
                                }
                                else {
                                    while (1) {
                                        d = c - 12 | 0;
                                        if (D[c - 1 | 0] < 0) {
                                            ra(F[d >> 2]);
                                        }
                                        c = d;
                                        if ((c | 0) != (b | 0)) {
                                            continue;
                                        }
                                        break;
                                    }
                                    d = F[a >> 2];
                                }
                                F[a + 4 >> 2] = b;
                                ra(d);
                            }
                            ra(a);
                        } }
                        function th() { var a = 0; a = sa(40); E[a + 38 >> 1] = 0; F[a >> 2] = 0; F[a + 8 >> 2] = 0; F[a + 12 >> 2] = 0; F[a + 16 >> 2] = 0; F[a + 20 >> 2] = 0; F[a + 24 >> 2] = 0; F[a + 28 >> 2] = 0; D[a + 29 | 0] = 0; D[a + 30 | 0] = 0; D[a + 31 | 0] = 0; D[a + 32 | 0] = 0; D[a + 33 | 0] = 0; D[a + 34 | 0] = 0; D[a + 35 | 0] = 0; D[a + 36 | 0] = 0; return a | 0; }
                        function Ld(a) { var b = 0, c = 0, d = 0; if (D[F[a >> 2]] - 48 >>> 0 >= 10) {
                            return 0;
                        } while (1) {
                            d = F[a >> 2];
                            c = -1;
                            if (b >>> 0 <= 214748364) {
                                c = D[d | 0] - 48 | 0;
                                b = L(b, 10);
                                c = (c | 0) > (2147483647 - b | 0) ? -1 : c + b | 0;
                            }
                            F[a >> 2] = d + 1;
                            b = c;
                            if (D[d + 1 | 0] - 48 >>> 0 < 10) {
                                continue;
                            }
                            break;
                        } return b; }
                        function Ja(a) { a = a | 0; var b = 0, c = 0; if (a) {
                            b = F[a + 88 >> 2];
                            F[a + 88 >> 2] = 0;
                            if (b) {
                                c = F[b + 8 >> 2];
                                if (c) {
                                    F[b + 12 >> 2] = c;
                                    ra(c);
                                }
                                ra(b);
                            }
                            b = F[a + 68 >> 2];
                            if (b) {
                                F[a + 72 >> 2] = b;
                                ra(b);
                            }
                            b = F[a + 64 >> 2];
                            F[a + 64 >> 2] = 0;
                            if (b) {
                                c = F[b >> 2];
                                if (c) {
                                    F[b + 4 >> 2] = c;
                                    ra(c);
                                }
                                ra(b);
                            }
                            ra(a);
                        } }
                        function vi(a) { a = a | 0; var b = 0; F[a + 24 >> 2] = 1140; F[a >> 2] = 11076; b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } F[a >> 2] = 2476; b = F[a + 20 >> 2]; F[a + 20 >> 2] = 0; if (b) {
                            ga[F[F[b >> 2] + 4 >> 2]](b);
                        } F[a >> 2] = 2260; b = F[a + 16 >> 2]; F[a + 16 >> 2] = 0; if (b) {
                            Ja(b);
                        } return a | 0; }
                        function nc(a, b) { var c = 0, d = 0, e = 0; c = La(b); if (c >>> 0 < 4294967280) {
                            a: {
                                b: {
                                    if (c >>> 0 >= 11) {
                                        e = c + 16 & -16;
                                        d = sa(e);
                                        F[a + 8 >> 2] = e | -2147483648;
                                        F[a >> 2] = d;
                                        F[a + 4 >> 2] = c;
                                        break b;
                                    }
                                    D[a + 11 | 0] = c;
                                    d = a;
                                    if (!c) {
                                        break a;
                                    }
                                }
                                ta(d, b, c);
                            }
                            D[c + d | 0] = 0;
                            return a;
                        } Ma(); V(); }
                        function Ij(a, b, c, d) { var e = 0, f = 0, g = 0, h = 0; f = b ^ d; g = f >> 31; e = b >> 31; a = a ^ e; h = a - e | 0; e = (b ^ e) - ((a >>> 0 < e >>> 0) + e | 0) | 0; a = d >> 31; b = c ^ a; f = f >> 31; a = Jj(h, e, b - a | 0, (a ^ d) - ((a >>> 0 > b >>> 0) + a | 0) | 0) ^ f; b = a - f | 0; fa = (g ^ fa) - ((a >>> 0 < f >>> 0) + g | 0) | 0; return b; }
                        function ui(a) { a = a | 0; var b = 0; F[a + 24 >> 2] = 1140; F[a >> 2] = 11076; b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } F[a >> 2] = 2476; b = F[a + 20 >> 2]; F[a + 20 >> 2] = 0; if (b) {
                            ga[F[F[b >> 2] + 4 >> 2]](b);
                        } F[a >> 2] = 2260; b = F[a + 16 >> 2]; F[a + 16 >> 2] = 0; if (b) {
                            Ja(b);
                        } ra(a); }
                        function _b(a, b, c) { var d = 0, e = 0, f = 0; e = ea - 16 | 0; ea = e; d = F[a + 8 >> 2] & 2147483647; a: {
                            if (d >>> 0 > c >>> 0) {
                                d = F[a >> 2];
                                F[a + 4 >> 2] = c;
                                kb(d, b, c);
                                D[e + 15 | 0] = 0;
                                D[c + d | 0] = G[e + 15 | 0];
                                break a;
                            }
                            f = a;
                            a = F[a + 4 >> 2];
                            Fd(f, d - 1 | 0, (c - d | 0) + 1 | 0, a, a, c, b);
                        } ea = e + 16 | 0; }
                        function yf(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0; c = ea - 16 | 0; ea = c; a = F[a + 4 >> 2]; a: {
                            if ((a | 0) == -1) {
                                break a;
                            }
                            D[c + 15 | 0] = a;
                            d = F[b + 20 >> 2];
                            if (!!F[b + 16 >> 2] & (d | 0) >= 0 | (d | 0) > 0) {
                                break a;
                            }
                            Yb(b, F[b + 4 >> 2], c + 15 | 0, c + 16 | 0);
                        } ea = c + 16 | 0; return (a | 0) != -1 | 0; }
                        function Hj(a, b, c, d) { var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0; e = c >>> 16 | 0; f = a >>> 16 | 0; j = L(e, f); g = c & 65535; h = a & 65535; i = L(g, h); f = (i >>> 16 | 0) + L(f, g) | 0; e = (f & 65535) + L(e, h) | 0; fa = (L(b, c) + j | 0) + L(a, d) + (f >>> 16) + (e >>> 16) | 0; return i & 65535 | e << 16; }
                        function oh() { var a = 0; a = sa(96); Fb(a); F[a + 64 >> 2] = 0; F[a + 68 >> 2] = 0; F[a + 88 >> 2] = 0; F[a + 72 >> 2] = 0; F[a + 76 >> 2] = 0; D[a + 77 | 0] = 0; D[a + 78 | 0] = 0; D[a + 79 | 0] = 0; D[a + 80 | 0] = 0; D[a + 81 | 0] = 0; D[a + 82 | 0] = 0; D[a + 83 | 0] = 0; D[a + 84 | 0] = 0; return a | 0; }
                        function Ed(a, b, c) { var d = 0; d = F[a + 16 >> 2]; if (!d) {
                            F[a + 36 >> 2] = 1;
                            F[a + 24 >> 2] = c;
                            F[a + 16 >> 2] = b;
                            return;
                        } a: {
                            if ((b | 0) == (d | 0)) {
                                if (F[a + 24 >> 2] != 2) {
                                    break a;
                                }
                                F[a + 24 >> 2] = c;
                                return;
                            }
                            D[a + 54 | 0] = 1;
                            F[a + 24 >> 2] = 2;
                            F[a + 36 >> 2] = F[a + 36 >> 2] + 1;
                        } }
                        function ti(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0; F[b >> 2] = 2; c = F[b + 8 >> 2]; d = F[b + 12 >> 2] - c | 0; if (d >>> 0 <= 4294967291) {
                            lc(b + 8 | 0, d + 4 | 0);
                            c = F[b + 8 >> 2];
                        } b = c + d | 0; a = F[a + 4 >> 2]; D[b | 0] = a; D[b + 1 | 0] = a >>> 8; D[b + 2 | 0] = a >>> 16; D[b + 3 | 0] = a >>> 24; }
                        function zj(a) { a = a | 0; var b = 0; F[a >> 2] = 3592; b = F[a + 96 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 84 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 72 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 60 >> 2]; if (b) {
                            ra(b);
                        } F[a >> 2] = 3300; b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } return a | 0; }
                        function xh(a) { a = a | 0; var b = 0, c = 0, d = 0; b = F[a + 8 >> 2]; d = F[a + 12 >> 2]; if ((b | 0) == (d | 0)) {
                            return 1;
                        } while (1) {
                            c = F[b >> 2];
                            c = ga[F[F[c >> 2] + 16 >> 2]](c, F[a + 32 >> 2]) | 0;
                            if (c) {
                                b = b + 4 | 0;
                                if ((d | 0) != (b | 0)) {
                                    continue;
                                }
                            }
                            break;
                        } return c | 0; }
                        function wa(a) { var b = 0, c = 0, d = 0, e = 0, f = 0; b = da(8) | 0; F[b >> 2] = 15156; F[b >> 2] = 15200; c = La(a); d = sa(c + 13 | 0); F[d + 8 >> 2] = 0; F[d + 4 >> 2] = c; F[d >> 2] = c; e = b, f = ta(d + 12 | 0, a, c + 1 | 0), F[e + 4 >> 2] = f; F[b >> 2] = 15248; ca(b | 0, 15280, 13); V(); }
                        function mb(a, b, c, d, e) { var f = 0; f = ea - 256 | 0; ea = f; if (!(e & 73728 | (c | 0) <= (d | 0))) {
                            c = c - d | 0;
                            d = c >>> 0 < 256;
                            ua(f, b & 255, d ? c : 256);
                            if (!d) {
                                while (1) {
                                    Bb(a, f, 256);
                                    c = c - 256 | 0;
                                    if (c >>> 0 > 255) {
                                        continue;
                                    }
                                    break;
                                }
                            }
                            Bb(a, f, c);
                        } ea = f + 256 | 0; }
                        function kj(a) { a = a | 0; var b = 0; F[a >> 2] = 5608; b = F[a + 96 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 84 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 72 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 60 >> 2]; if (b) {
                            ra(b);
                        } F[a >> 2] = 3300; b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } return a | 0; }
                        function yj(a) { a = a | 0; var b = 0; F[a >> 2] = 3592; b = F[a + 96 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 84 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 72 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 60 >> 2]; if (b) {
                            ra(b);
                        } F[a >> 2] = 3300; b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } ra(a); }
                        function jj(a) { a = a | 0; var b = 0; F[a >> 2] = 5608; b = F[a + 96 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 84 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 72 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 60 >> 2]; if (b) {
                            ra(b);
                        } F[a >> 2] = 3300; b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } ra(a); }
                        function Zd(a, b, c) { var d = 0, e = 0; d = a + 4 | 0; a = rb(a, b); if ((d | 0) == (a | 0)) {
                            return 0;
                        } b = F[a + 32 >> 2]; d = F[a + 28 >> 2]; if ((b | 0) != (d | 0)) {
                            Cc(c, b - d | 0);
                            e = Dc(c);
                            c = F[a + 28 >> 2];
                            ta(e, c, F[a + 32 >> 2] - c | 0);
                        } return (b | 0) != (d | 0); }
                        function Wd(a, b) { var c = 0, d = 0; c = F[a + 8 >> 2]; a = F[a + 12 >> 2] - c | 0; if (a) {
                            a = a >> 2;
                            d = a >>> 0 > 1 ? a : 1;
                            a = 0;
                            while (1) {
                                if (F[F[(a << 2) + c >> 2] + 60 >> 2] == (b | 0)) {
                                    return a;
                                }
                                a = a + 1 | 0;
                                if ((d | 0) != (a | 0)) {
                                    continue;
                                }
                                break;
                            }
                        } return -1; }
                        function Lf(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; var e = 0; e = ea - 16 | 0; ea = e; a = _(F[a + 60 >> 2], b | 0, c | 0, d & 255, e + 8 | 0) | 0; if (a) {
                            F[4190] = a;
                            a = -1;
                        }
                        else {
                            a = 0;
                        } ea = e + 16 | 0; fa = a ? -1 : F[e + 12 >> 2]; return (a ? -1 : F[e + 8 >> 2]) | 0; }
                        function Qd(a) { var b = 0; b = F[a + 72 >> 2]; F[a + 72 >> 2] = b - 1 | b; b = F[a >> 2]; if (b & 8) {
                            F[a >> 2] = b | 32;
                            return -1;
                        } F[a + 4 >> 2] = 0; F[a + 8 >> 2] = 0; b = F[a + 44 >> 2]; F[a + 28 >> 2] = b; F[a + 20 >> 2] = b; F[a + 16 >> 2] = b + F[a + 48 >> 2]; return 0; }
                        function Fb(a) { F[a + 8 >> 2] = 0; F[a + 12 >> 2] = 0; F[a >> 2] = 0; F[a + 40 >> 2] = 0; F[a + 44 >> 2] = 0; F[a + 28 >> 2] = 9; D[a + 24 | 0] = 1; F[a + 56 >> 2] = -1; F[a + 60 >> 2] = 0; F[a + 16 >> 2] = 0; F[a + 20 >> 2] = 0; F[a + 48 >> 2] = 0; F[a + 52 >> 2] = 0; return a; }
                        function Qf(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0; Ud(a, b); a: {
                            if ((b | 0) < 0) {
                                break a;
                            }
                            c = F[a + 88 >> 2];
                            d = F[a + 84 >> 2];
                            if (c - d >> 2 <= (b | 0)) {
                                break a;
                            }
                            b = d + (b << 2) | 0;
                            d = b + 4 | 0;
                            c = c - d | 0;
                            if (c) {
                                Wa(b, d, c);
                            }
                            F[a + 88 >> 2] = b + c;
                        } }
                        function ef(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0; d = F[a + 16 >> 2]; c = 0; a: {
                            if (F[a + 20 >> 2] - d >> 2 <= (b | 0)) {
                                break a;
                            }
                            b = F[(b << 2) + d >> 2];
                            c = 0;
                            if ((b | 0) < 0) {
                                break a;
                            }
                            c = ub(F[F[a + 36 >> 2] + (b << 2) >> 2]);
                        } return c | 0; }
                        function Hg() { var a = 0, b = 0; a = sa(40); F[a + 4 >> 2] = 0; F[a + 8 >> 2] = 0; F[a >> 2] = a + 4; b = a + 16 | 0; F[b >> 2] = 0; F[b + 4 >> 2] = 0; F[a + 24 >> 2] = 0; F[a + 28 >> 2] = 0; F[a + 12 >> 2] = b; F[a + 32 >> 2] = 0; F[a + 36 >> 2] = 0; return a | 0; }
                        function Zb(a, b, c) { var d = 0, e = 0; d = ea - 16 | 0; ea = d; a: {
                            if (c >>> 0 <= 10) {
                                D[a + 11 | 0] = c;
                                kb(a, b, c);
                                D[d + 15 | 0] = 0;
                                D[a + c | 0] = G[d + 15 | 0];
                                break a;
                            }
                            e = a;
                            a = G[a + 11 | 0];
                            Fd(e, 10, c - 10 | 0, a, a, c, b);
                        } ea = d + 16 | 0; }
                        function Mh(a) { a = a | 0; var b = 0; F[a + 8 >> 2] = 12836; F[a >> 2] = 12672; b = F[a + 56 >> 2]; if (b) {
                            F[a + 60 >> 2] = b;
                            ra(b);
                        } F[a + 8 >> 2] = 12652; b = F[a + 44 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 32 >> 2]; if (b) {
                            ra(b);
                        } return a | 0; }
                        function Hh(a) { a = a | 0; var b = 0; F[a + 8 >> 2] = 11900; F[a >> 2] = 12964; b = F[a + 56 >> 2]; if (b) {
                            F[a + 60 >> 2] = b;
                            ra(b);
                        } F[a + 8 >> 2] = 12152; b = F[a + 44 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 32 >> 2]; if (b) {
                            ra(b);
                        } return a | 0; }
                        function lb(a) { var b = 0, c = 0; b = F[3902]; c = a + 3 & -4; a = b + c | 0; a: {
                            if (a >>> 0 <= b >>> 0 ? c : 0) {
                                break a;
                            }
                            if (a >>> 0 > ha() << 16 >>> 0) {
                                if (!($(a | 0) | 0)) {
                                    break a;
                                }
                            }
                            F[3902] = a;
                            return b;
                        } F[4190] = 48; return -1; }
                        function tf(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0, e = 0; d = F[a + 8 >> 2]; a: {
                            if (D[d + 24 | 0] <= 0) {
                                break a;
                            }
                            if (!qb(d, F[b + 4 >> 2] - F[b >> 2] >> 2)) {
                                break a;
                            }
                            e = ga[F[F[a >> 2] + 32 >> 2]](a, b, c) | 0;
                        } return e | 0; }
                        function Yi(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0; F[a + 4 >> 2] = b; b = F[F[F[b + 4 >> 2] + 8 >> 2] + (c << 2) >> 2]; F[a + 12 >> 2] = c; F[a + 8 >> 2] = b; a = F[a + 8 >> 2]; if (G[a + 24 | 0] == 3) {
                            d = F[a + 28 >> 2] == 9;
                        } return d | 0; }
                        function Lh(a) { a = a | 0; var b = 0; F[a + 8 >> 2] = 12836; F[a >> 2] = 12672; b = F[a + 56 >> 2]; if (b) {
                            F[a + 60 >> 2] = b;
                            ra(b);
                        } F[a + 8 >> 2] = 12652; b = F[a + 44 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 32 >> 2]; if (b) {
                            ra(b);
                        } ra(a); }
                        function Fh(a) { a = a | 0; var b = 0; F[a + 8 >> 2] = 11900; F[a >> 2] = 12964; b = F[a + 56 >> 2]; if (b) {
                            F[a + 60 >> 2] = b;
                            ra(b);
                        } F[a + 8 >> 2] = 12152; b = F[a + 44 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 32 >> 2]; if (b) {
                            ra(b);
                        } ra(a); }
                        function wj(a) { a = a | 0; var b = 0; F[a >> 2] = 3840; b = F[a + 76 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 68 >> 2]; F[a + 68 >> 2] = 0; if (b) {
                            ra(b);
                        } F[a >> 2] = 3300; b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } return a | 0; }
                        function gj(a) { a = a | 0; var b = 0; F[a >> 2] = 5844; b = F[a + 76 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 68 >> 2]; F[a + 68 >> 2] = 0; if (b) {
                            ra(b);
                        } F[a >> 2] = 3300; b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } return a | 0; }
                        function Qa(a, b) { if (b) {
                            Qa(a, F[b >> 2]);
                            Qa(a, F[b + 4 >> 2]);
                            a = F[b + 28 >> 2];
                            F[b + 28 >> 2] = 0;
                            if (a) {
                                Qa(a + 12 | 0, F[a + 16 >> 2]);
                                Pa(a, F[a + 4 >> 2]);
                                ra(a);
                            }
                            if (D[b + 27 | 0] < 0) {
                                ra(F[b + 16 >> 2]);
                            }
                            ra(b);
                        } }
                        function Bi(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0; F[a + 4 >> 2] = b; d = F[F[F[b + 4 >> 2] + 8 >> 2] + (c << 2) >> 2]; F[a + 12 >> 2] = c; F[a + 8 >> 2] = d; return F[F[F[F[b + 4 >> 2] + 8 >> 2] + (c << 2) >> 2] + 28 >> 2] == 9 | 0; }
                        function Uc(a) { F[a + 40 >> 2] = 0; F[a + 4 >> 2] = 0; F[a + 8 >> 2] = 0; F[a >> 2] = 13312; F[a + 12 >> 2] = 0; F[a + 16 >> 2] = 0; F[a + 20 >> 2] = 0; F[a + 24 >> 2] = 0; F[a + 28 >> 2] = 0; F[a + 32 >> 2] = 0; E[a + 36 >> 1] = 0; return a; }
                        function $f(a, b) { a = a | 0; b = b | 0; var c = 0; a: {
                            if (!(ga[F[F[a >> 2] + 36 >> 2]](a, b) | 0)) {
                                break a;
                            }
                            if (!(ga[F[F[a >> 2] + 40 >> 2]](a, b) | 0)) {
                                break a;
                            }
                            c = ga[F[F[a >> 2] + 44 >> 2]](a) | 0;
                        } return c | 0; }
                        function vj(a) { a = a | 0; var b = 0; F[a >> 2] = 3840; b = F[a + 76 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 68 >> 2]; F[a + 68 >> 2] = 0; if (b) {
                            ra(b);
                        } F[a >> 2] = 3300; b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } ra(a); }
                        function fj(a) { a = a | 0; var b = 0; F[a >> 2] = 5844; b = F[a + 76 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 68 >> 2]; F[a + 68 >> 2] = 0; if (b) {
                            ra(b);
                        } F[a >> 2] = 3300; b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } ra(a); }
                        function Te(a) { a = a | 0; var b = 0; a: {
                            if (!F[a - -64 >> 2] | !F[a + 68 >> 2] | (!F[a + 44 >> 2] | !F[a + 48 >> 2])) {
                                break a;
                            }
                            if (!F[a + 52 >> 2] | !F[a + 56 >> 2]) {
                                break a;
                            }
                            b = F[a + 92 >> 2] != -1;
                        } return b | 0; }
                        function Gj(a, b) { a = a | 0; b = b | 0; var c = 0; b = F[b + 88 >> 2]; if (!(!b | F[b >> 2] != 2)) {
                            c = a;
                            a = F[b + 8 >> 2];
                            F[c + 4 >> 2] = G[a | 0] | G[a + 1 | 0] << 8 | (G[a + 2 | 0] << 16 | G[a + 3 | 0] << 24);
                            c = 1;
                        } return c | 0; }
                        function $e(a) { a = a | 0; var b = 0; F[a >> 2] = 2476; b = F[a + 20 >> 2]; F[a + 20 >> 2] = 0; if (b) {
                            ga[F[F[b >> 2] + 4 >> 2]](b);
                        } F[a >> 2] = 2260; b = F[a + 16 >> 2]; F[a + 16 >> 2] = 0; if (b) {
                            Ja(b);
                        } return a | 0; }
                        function uc(a) { a = a | 0; var b = 0; a: {
                            if (!F[a + 48 >> 2] | !F[a + 52 >> 2] | (!F[a + 28 >> 2] | !F[a + 32 >> 2])) {
                                break a;
                            }
                            if (!F[a + 36 >> 2] | !F[a + 40 >> 2]) {
                                break a;
                            }
                            b = F[a + 76 >> 2] != -1;
                        } return b | 0; }
                        function Nh(a) { a = a | 0; var b = 0; F[a >> 2] = 12836; b = F[a + 48 >> 2]; if (b) {
                            F[a + 52 >> 2] = b;
                            ra(b);
                        } F[a >> 2] = 12652; b = F[a + 36 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 24 >> 2]; if (b) {
                            ra(b);
                        } return a | 0; }
                        function De(a) { a = a | 0; var b = 0; F[a >> 2] = 11900; b = F[a + 48 >> 2]; if (b) {
                            F[a + 52 >> 2] = b;
                            ra(b);
                        } F[a >> 2] = 12152; b = F[a + 36 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 24 >> 2]; if (b) {
                            ra(b);
                        } return a | 0; }
                        function _e(a) { a = a | 0; var b = 0; F[a >> 2] = 2476; b = F[a + 20 >> 2]; F[a + 20 >> 2] = 0; if (b) {
                            ga[F[F[b >> 2] + 4 >> 2]](b);
                        } F[a >> 2] = 2260; b = F[a + 16 >> 2]; F[a + 16 >> 2] = 0; if (b) {
                            Ja(b);
                        } ra(a); }
                        function rh() { var a = 0, b = 0; b = sa(40); F[b >> 2] = -1; a = b + 8 | 0; F[a + 16 >> 2] = 0; F[a + 20 >> 2] = 0; F[a + 8 >> 2] = 0; F[a >> 2] = 0; F[a + 4 >> 2] = 0; F[a + 24 >> 2] = 0; F[a + 28 >> 2] = 0; return b | 0; }
                        function df(a, b) { a = a | 0; b = b | 0; var c = 0, d = 0; d = F[a + 4 >> 2]; a: {
                            if (d) {
                                c = 1;
                                if (G[d + 36 | 0] < 2) {
                                    break a;
                                }
                            }
                            c = ga[F[F[a >> 2] + 48 >> 2]](a, F[b + 4 >> 2] - F[b >> 2] >> 2) | 0;
                        } return c | 0; }
                        function Zh(a) { a = a | 0; var b = 0; F[a >> 2] = 11900; b = F[a + 48 >> 2]; if (b) {
                            F[a + 52 >> 2] = b;
                            ra(b);
                        } F[a >> 2] = 12152; b = F[a + 36 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 24 >> 2]; if (b) {
                            ra(b);
                        } ra(a); }
                        function Ih(a) { a = a | 0; var b = 0; F[a >> 2] = 12836; b = F[a + 48 >> 2]; if (b) {
                            F[a + 52 >> 2] = b;
                            ra(b);
                        } F[a >> 2] = 12652; b = F[a + 36 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 24 >> 2]; if (b) {
                            ra(b);
                        } ra(a); }
                        function Df(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; if (Za(a, F[b + 8 >> 2], f)) {
                            Dd(b, c, d, e);
                            return;
                        } a = F[a + 8 >> 2]; ga[F[F[a >> 2] + 20 >> 2]](a, b, c, d, e, f); }
                        function zi(a, b, c) { a = a | 0; b = b | 0; c = c | 0; a: {
                            if (G[F[a + 4 >> 2] + 36 | 0] >= 2) {
                                b = 0;
                                if (!(ga[F[F[a >> 2] + 52 >> 2]](a) | 0)) {
                                    break a;
                                }
                            }
                            b = Wc(a + 24 | 0, F[a + 16 >> 2]);
                        } return b | 0; }
                        function bh() { var a = 0; a = sa(108); Yd(a); F[a + 84 >> 2] = 0; F[a + 88 >> 2] = 0; F[a >> 2] = 13696; F[a + 92 >> 2] = 0; F[a + 96 >> 2] = 0; F[a + 100 >> 2] = 0; F[a + 104 >> 2] = 0; return a | 0; }
                        function Ai(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0; a: {
                            if (G[F[a + 4 >> 2] + 36 | 0] <= 1) {
                                d = 0;
                                if (!(ga[F[F[a >> 2] + 52 >> 2]](a) | 0)) {
                                    break a;
                                }
                            }
                            d = od(a, b, c);
                        } return d | 0; }
                        function Xd(a, b) { var c = 0; c = -1; a: {
                            if ((b | 0) == -1 | (b | 0) > 4) {
                                break a;
                            }
                            b = L(b, 12) + a | 0;
                            a = F[b + 20 >> 2];
                            if ((F[b + 24 >> 2] - a | 0) <= 0) {
                                break a;
                            }
                            c = F[a >> 2];
                        } return c; }
                        function mc(a, b, c, d, e, f, g) { F[a >> 2] = 0; F[a + 56 >> 2] = b; F[a + 48 >> 2] = 0; F[a + 52 >> 2] = 0; F[a + 40 >> 2] = f; F[a + 44 >> 2] = g; D[a + 32 | 0] = e; F[a + 28 >> 2] = d; D[a + 24 | 0] = c; }
                        function Xi(a, b, c) { a = a | 0; b = b | 0; c = c | 0; var d = 0; a: {
                            if (G[F[a + 4 >> 2] + 36 | 0] <= 1) {
                                d = 0;
                                if (!yc(a + 24 | 0, F[a + 8 >> 2], c)) {
                                    break a;
                                }
                            }
                            d = od(a, b, c);
                        } return d | 0; }
                        function Wi(a, b, c) { a = a | 0; b = b | 0; c = c | 0; a: {
                            if (G[F[a + 4 >> 2] + 36 | 0] >= 2) {
                                b = 0;
                                if (!yc(a + 24 | 0, ub(a), c)) {
                                    break a;
                                }
                            }
                            b = Wc(a + 24 | 0, F[a + 16 >> 2]);
                        } return b | 0; }
                        function Uf(a) { a = a | 0; var b = 0; F[a >> 2] = 13696; b = F[a + 96 >> 2]; if (b) {
                            F[a + 100 >> 2] = b;
                            ra(b);
                        } b = F[a + 84 >> 2]; if (b) {
                            F[a + 88 >> 2] = b;
                            ra(b);
                        } ac(a); return a | 0; }
                        function Sf(a) { a = a | 0; var b = 0; F[a >> 2] = 13696; b = F[a + 96 >> 2]; if (b) {
                            F[a + 100 >> 2] = b;
                            ra(b);
                        } b = F[a + 84 >> 2]; if (b) {
                            F[a + 88 >> 2] = b;
                            ra(b);
                        } ac(a); ra(a); }
                        function sj(a) { a = a | 0; var b = 0; F[a >> 2] = 4068; b = F[a + 76 >> 2]; if (b) {
                            ra(b);
                        } F[a >> 2] = 3300; b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } return a | 0; }
                        function dj(a) { a = a | 0; var b = 0; F[a >> 2] = 6060; b = F[a + 76 >> 2]; if (b) {
                            ra(b);
                        } F[a >> 2] = 3300; b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } return a | 0; }
                        function Pa(a, b) { if (b) {
                            Pa(a, F[b >> 2]);
                            Pa(a, F[b + 4 >> 2]);
                            a = F[b + 28 >> 2];
                            if (a) {
                                F[b + 32 >> 2] = a;
                                ra(a);
                            }
                            if (D[b + 27 | 0] < 0) {
                                ra(F[b + 16 >> 2]);
                            }
                            ra(b);
                        } }
                        function Qg() { var a = 0; a = sa(28); F[a >> 2] = 0; F[a + 4 >> 2] = 0; F[a + 24 >> 2] = 0; F[a + 16 >> 2] = 0; F[a + 20 >> 2] = 0; F[a + 8 >> 2] = 0; F[a + 12 >> 2] = 0; return a | 0; }
                        function ng(a) { a = a | 0; var b = 0; F[a >> 2] = 2012; b = F[a + 16 >> 2]; if (b) {
                            F[a + 20 >> 2] = b;
                            ra(b);
                        } b = F[a + 4 >> 2]; if (b) {
                            F[a + 8 >> 2] = b;
                            ra(b);
                        } return a | 0; }
                        function Dc(a) { var b = 0; if (G[a + 11 | 0] >>> 7 | 0) {
                            b = F[a + 4 >> 2];
                        }
                        else {
                            b = G[a + 11 | 0];
                        } if (!b) {
                            $b();
                            V();
                        } if (G[a + 11 | 0] >>> 7 | 0) {
                            a = F[a >> 2];
                        } return a; }
                        function Gf(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; if (Za(a, F[b + 8 >> 2], 0)) {
                            Ed(b, c, d);
                            return;
                        } a = F[a + 8 >> 2]; ga[F[F[a >> 2] + 28 >> 2]](a, b, c, d); }
                        function $g() { var a = 0, b = 0; a = sa(24); F[a + 4 >> 2] = 0; F[a + 8 >> 2] = 0; b = a + 16 | 0; F[b >> 2] = 0; F[b + 4 >> 2] = 0; F[a >> 2] = a + 4; F[a + 12 >> 2] = b; return a | 0; }
                        function rj(a) { a = a | 0; var b = 0; F[a >> 2] = 4068; b = F[a + 76 >> 2]; if (b) {
                            ra(b);
                        } F[a >> 2] = 3300; b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } ra(a); }
                        function cj(a) { a = a | 0; var b = 0; F[a >> 2] = 6060; b = F[a + 76 >> 2]; if (b) {
                            ra(b);
                        } F[a >> 2] = 3300; b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } ra(a); }
                        function sa(a) { var b = 0; a = a ? a : 1; a: {
                            while (1) {
                                b = Gd(a);
                                if (b) {
                                    break a;
                                }
                                b = F[4357];
                                if (b) {
                                    ga[b | 0]();
                                    continue;
                                }
                                break;
                            }
                            Y();
                            V();
                        } return b; }
                        function Jb(a, b) { if (b) {
                            Jb(a, F[b >> 2]);
                            Jb(a, F[b + 4 >> 2]);
                            if (D[b + 39 | 0] < 0) {
                                ra(F[b + 28 >> 2]);
                            }
                            if (D[b + 27 | 0] < 0) {
                                ra(F[b + 16 >> 2]);
                            }
                            ra(b);
                        } }
                        function Lb(a, b) { a = a | 0; b = b | 0; var c = 0; a: {
                            switch (b | 0) {
                                case 1: b = 1;
                                case 0:
                                    F[a + 28 >> 2] = b;
                                    c = 1;
                                    break;
                                default: break a;
                            }
                        } return c | 0; }
                        function Ac(a) { a = a | 0; var b = 0, c = 0; F[a >> 2] = 15200; b = F[a + 4 >> 2] - 12 | 0; c = F[b + 8 >> 2] - 1 | 0; F[b + 8 >> 2] = c; if ((c | 0) < 0) {
                            ra(b);
                        } return a | 0; }
                        function gh() { var a = 0; a = sa(24); F[a + 8 >> 2] = 0; F[a + 12 >> 2] = 0; F[a + 4 >> 2] = -1; F[a >> 2] = 1140; F[a + 16 >> 2] = 0; F[a + 20 >> 2] = 0; return a | 0; }
                        function qd(a, b, c) { a = a | 0; b = b | 0; c = c | 0; F[a + 4 >> 2] = b; b = F[F[F[b + 4 >> 2] + 8 >> 2] + (c << 2) >> 2]; F[a + 12 >> 2] = c; F[a + 8 >> 2] = b; return 1; }
                        function xc(a) { a = a | 0; var b = 0; if (!(!F[a + 60 >> 2] | !F[a + 44 >> 2] | (!F[a + 48 >> 2] | !F[a + 52 >> 2]))) {
                            b = F[a + 56 >> 2] != 0;
                        } return b | 0; }
                        function lc(a, b) { var c = 0, d = 0; Va(a, b); b = F[a + 28 >> 2]; c = b; d = b + 1 | 0; b = F[a + 24 >> 2] + 1 | 0; F[a + 24 >> 2] = b; F[a + 28 >> 2] = b ? c : d; }
                        function pj(a) { a = a | 0; var b = 0; F[a >> 2] = 4304; F[a >> 2] = 3300; b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } return a | 0; }
                        function aj(a) { a = a | 0; var b = 0; F[a >> 2] = 6284; F[a >> 2] = 3300; b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } return a | 0; }
                        function Yh(a) { a = a | 0; var b = 0; F[a >> 2] = 12152; b = F[a + 36 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 24 >> 2]; if (b) {
                            ra(b);
                        } return a | 0; }
                        function Ph(a) { a = a | 0; var b = 0; F[a >> 2] = 12652; b = F[a + 36 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 24 >> 2]; if (b) {
                            ra(b);
                        } return a | 0; }
                        function gg(a) { a = a | 0; if (a) {
                            if (D[a + 39 | 0] < 0) {
                                ra(F[a + 28 >> 2]);
                            }
                            Nc(a + 12 | 0, F[a + 16 >> 2]);
                            Jb(a, F[a + 4 >> 2]);
                            ra(a);
                        } }
                        function Qb(a) { a = a | 0; var b = 0; if (!(!F[a + 52 >> 2] | (!F[a + 44 >> 2] | !F[a + 48 >> 2]))) {
                            b = F[a + 56 >> 2] != 0;
                        } return b | 0; }
                        function wc(a, b) { a = a | 0; b = b | 0; var c = 0; if (!(F[b + 56 >> 2] | !b | G[b + 24 | 0] != 3)) {
                            F[a + 60 >> 2] = b;
                            c = 1;
                        } return c | 0; }
                        function oj(a) { a = a | 0; var b = 0; F[a >> 2] = 4304; F[a >> 2] = 3300; b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } ra(a); }
                        function Xh(a) { a = a | 0; var b = 0; F[a >> 2] = 12152; b = F[a + 36 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 24 >> 2]; if (b) {
                            ra(b);
                        } ra(a); }
                        function Oh(a) { a = a | 0; var b = 0; F[a >> 2] = 12652; b = F[a + 36 >> 2]; if (b) {
                            ra(b);
                        } b = F[a + 24 >> 2]; if (b) {
                            ra(b);
                        } ra(a); }
                        function $i(a) { a = a | 0; var b = 0; F[a >> 2] = 6284; F[a >> 2] = 3300; b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } ra(a); }
                        function sh(a, b, c) { a = a | 0; b = b | 0; c = c | 0; F[a + 16 >> 2] = 0; F[a + 20 >> 2] = 0; F[a >> 2] = b; F[a + 8 >> 2] = c; F[a + 12 >> 2] = 0; }
                        function Se(a, b) { a = a | 0; b = b | 0; var c = 0; if (!(F[b + 56 >> 2] | G[b + 24 | 0] != 3)) {
                            F[a - -64 >> 2] = b;
                            c = 1;
                        } return c | 0; }
                        function zc(a) { var b = 0; b = F[a + 16 >> 2]; if (b) {
                            F[a + 20 >> 2] = b;
                            ra(b);
                        } b = F[a >> 2]; if (b) {
                            F[a + 4 >> 2] = b;
                            ra(b);
                        } }
                        function tc(a, b) { a = a | 0; b = b | 0; var c = 0; if (!(F[b + 56 >> 2] | G[b + 24 | 0] != 3)) {
                            F[a + 48 >> 2] = b;
                            c = 1;
                        } return c | 0; }
                        function Cf(a, b, c, d, e, f) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; e = e | 0; f = f | 0; if (Za(a, F[b + 8 >> 2], f)) {
                            Dd(b, c, d, e);
                        } }
                        function pf(a) { a = a | 0; var b = 0; F[a >> 2] = 2260; b = F[a + 16 >> 2]; F[a + 16 >> 2] = 0; if (b) {
                            Ja(b);
                        } return a | 0; }
                        function Bj(a) { a = a | 0; var b = 0; F[a >> 2] = 3300; b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } return a | 0; }
                        function xi(a) { a = a | 0; var b = 0; b = ub(a); return Fe(a + 24 | 0, b ? b : F[a + 8 >> 2], F[F[a + 4 >> 2] + 32 >> 2]) | 0; }
                        function gi(a) { a = a | 0; var b = 0; F[a >> 2] = 1140; b = F[a + 8 >> 2]; if (b) {
                            F[a + 12 >> 2] = b;
                            ra(b);
                        } return a | 0; }
                        function of(a) { a = a | 0; var b = 0; F[a >> 2] = 2260; b = F[a + 16 >> 2]; F[a + 16 >> 2] = 0; if (b) {
                            Ja(b);
                        } ra(a); }
                        function ei(a) { a = a | 0; var b = 0; F[a >> 2] = 1140; b = F[a + 8 >> 2]; if (b) {
                            F[a + 12 >> 2] = b;
                            ra(b);
                        } ra(a); }
                        function Vb(a) { a = a | 0; var b = 0; F[a >> 2] = 3300; b = F[a + 32 >> 2]; if (b) {
                            F[a + 36 >> 2] = b;
                            ra(b);
                        } ra(a); }
                        function _a(a) { var b = 0; F[a + 16 >> 2] = 0; b = F[a >> 2]; F[a + 4 >> 2] = b; F[a + 12 >> 2] = b; if (b) {
                            ra(b);
                        } }
                        function Nc(a, b) { if (b) {
                            Nc(a, F[b >> 2]);
                            Nc(a, F[b + 4 >> 2]);
                            Jb(b + 20 | 0, F[b + 24 >> 2]);
                            ra(b);
                        } }
                        function ri(a) { a = a | 0; if (!F[a + 44 >> 2]) {
                            return 0;
                        } return ga[F[F[a >> 2] + 48 >> 2]](a) | 0; }
                        function qh(a) { a = a | 0; var b = 0; if (a) {
                            b = F[a + 8 >> 2];
                            if (b) {
                                F[a + 12 >> 2] = b;
                                ra(b);
                            }
                            ra(a);
                        } }
                        function Kj(a) { var b = 0; while (1) {
                            if (a) {
                                a = a - 1 & a;
                                b = b + 1 | 0;
                                continue;
                            }
                            break;
                        } return b; }
                        function Hf(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; if (Za(a, F[b + 8 >> 2], 0)) {
                            Ed(b, c, d);
                        } }
                        function pi(a, b) { a = a | 0; b = b | 0; a = F[a + 48 >> 2]; return ga[F[F[a >> 2] + 20 >> 2]](a, b) | 0; }
                        function ii(a, b) { a = a | 0; b = b | 0; a = F[a + 48 >> 2]; return ga[F[F[a >> 2] + 12 >> 2]](a, b) | 0; }
                        function hi(a, b) { a = a | 0; b = b | 0; a = F[a + 48 >> 2]; return ga[F[F[a >> 2] + 16 >> 2]](a, b) | 0; }
                        function pb() { var a = 0; a = sa(12); F[a >> 2] = 0; F[a + 4 >> 2] = 0; F[a + 8 >> 2] = 0; return a | 0; }
                        function ob(a) { a = a | 0; var b = 0; if (a) {
                            b = F[a >> 2];
                            if (b) {
                                F[a + 4 >> 2] = b;
                                ra(b);
                            }
                            ra(a);
                        } }
                        function Lj(a) { var b = 0; b = a & 31; a = 0 - a & 31; return (-1 >>> b & -2) << b | (-1 << a & -2) >>> a; }
                        function _g(a) { a = a | 0; if (a) {
                            Qa(a + 12 | 0, F[a + 16 >> 2]);
                            Pa(a, F[a + 4 >> 2]);
                            ra(a);
                        } }
                        function Wg(a, b, c) { a = a | 0; b = b | 0; c = c | 0; F[a + 32 >> 2] = c; F[a + 28 >> 2] = b; return 1; }
                        function Pd(a, b, c) { a: {
                            if (F[c + 76 >> 2] < 0) {
                                a = Ec(a, b, c);
                                break a;
                            }
                            a = Ec(a, b, c);
                        } }
                        function Bh(a, b) { a = a | 0; b = b | 0; D[b + 84 | 0] = 1; F[b + 72 >> 2] = F[b + 68 >> 2]; return 1; }
                        function ni(a) { a = a | 0; a = F[a + 48 >> 2]; return ga[F[F[a >> 2] + 24 >> 2]](a) | 0; }
                        function mi(a) { a = a | 0; a = F[a + 48 >> 2]; return ga[F[F[a >> 2] + 28 >> 2]](a) | 0; }
                        function ji(a) { a = a | 0; a = F[a + 48 >> 2]; return ga[F[F[a >> 2] + 36 >> 2]](a) | 0; }
                        function dh() { var a = 0; a = sa(8); F[a + 4 >> 2] = -1; F[a >> 2] = 1032; return a | 0; }
                        function Bg(a, b, c) { a = a | 0; b = b | 0; c = c | 0; return F[F[b + 8 >> 2] + (c << 2) >> 2]; }
                        function wi(a, b) { a = a | 0; b = b | 0; return Oe(a + 24 | 0, ub(a), F[a + 8 >> 2]) | 0; }
                        function Vi(a, b) { a = a | 0; b = b | 0; return Cd(a + 24 | 0, ub(a), F[a + 8 >> 2]) | 0; }
                        function yi(a, b) { a = a | 0; b = b | 0; return ga[F[F[a >> 2] + 56 >> 2]](a, b) | 0; }
                        function uf(a, b) { a = a | 0; b = b | 0; F[a + 12 >> 2] = -1; F[a + 8 >> 2] = b; return 1; }
                        function le(a, b) { a = a | 0; b = b | 0; return ga[F[F[a >> 2] + 12 >> 2]](a, b) | 0; }
                        function Xg(a) { a = a | 0; if (a) {
                            if (D[a + 15 | 0] < 0) {
                                ra(F[a + 4 >> 2]);
                            }
                            ra(a);
                        } }
                        function fh(a, b) { a = a | 0; b = b | 0; return M(J[F[a + 8 >> 2] + (b << 2) >> 2]); }
                        function Vg(a, b) { a = a | 0; b = b | 0; return M(J[F[a >> 2] + (b << 2) >> 2]); }
                        function ah(a) { a = a | 0; return (F[a + 100 >> 2] - F[a + 96 >> 2] | 0) / 12 | 0; }
                        function Yg(a) { a = a | 0; return (D[a + 15 | 0] < 0 ? F[a + 4 >> 2] : a + 4 | 0) | 0; }
                        function Tf(a, b) { a = a | 0; b = b | 0; return F[F[a + 4 >> 2] + (b << 2) >> 2]; }
                        function Kf(a, b, c, d) { a = a | 0; b = b | 0; c = c | 0; d = d | 0; fa = 0; return 0; }
                        function he(a, b) { a = a | 0; b = b | 0; return F[F[a >> 2] + (b << 2) >> 2]; }
                        function Sg(a, b) { a = a | 0; b = b | 0; return E[F[a >> 2] + (b << 1) >> 1]; }
                        function Rg(a, b) { a = a | 0; b = b | 0; return H[F[a >> 2] + (b << 1) >> 1]; }
                        function Eg(a, b, c) { a = a | 0; b = b | 0; c = c | 0; return Xd(b, c) | 0; }
                        function Yd(a) { F[a >> 2] = 13756; ua(a + 4 | 0, 0, 80); return a; }
                        function Mj(a) { if (a) {
                            return 31 - O(a - 1 ^ a) | 0;
                        } return 32; }
                        function ke(a) { a = a | 0; return F[a + 12 >> 2] - F[a + 8 >> 2] >> 2; }
                        function dc(a) { a = a | 0; if (a) {
                            ga[F[F[a >> 2] + 4 >> 2]](a);
                        } }
                        function Ug(a, b) { a = a | 0; b = b | 0; return D[F[a >> 2] + b | 0]; }
                        function Tg(a, b) { a = a | 0; b = b | 0; return G[F[a >> 2] + b | 0]; }
                        function Pf(a) { a = a | 0; return F[a + 8 >> 2] - F[a + 4 >> 2] >> 2; }
                        function kd(a, b) { a = a | 0; b = b | 0; F[a + 4 >> 2] = b; return 1; }
                        function ie(a) { a = a | 0; return F[a + 4 >> 2] - F[a >> 2] >> 1; }
                        function Pc(a) { a = a | 0; return F[a + 4 >> 2] - F[a >> 2] >> 2; }
                        function je(a) { a = a | 0; return F[a + 4 >> 2] - F[a >> 2] | 0; }
                        function Ge(a) { Uc(a); F[a + 44 >> 2] = 0; F[a >> 2] = 11208; }
                        function Bb(a, b, c) { if (!(G[a | 0] & 32)) {
                            Ec(b, c, a);
                        } }
                        function zg(a, b) { a = a | 0; b = b | 0; return F[b + 4 >> 2]; }
                        function sf(a, b, c) { a = a | 0; b = b | 0; c = c | 0; return 1; }
                        function bi(a, b) { a = a | 0; b = b | 0; return D[b + 24 | 0]; }
                        function Kg(a, b) { a = a | 0; b = b | 0; return F[b + 8 >> 2]; }
                        function Fi(a) { a = a | 0; F[a >> 2] = 10060; return a | 0; }
                        function Ej(a) { a = a | 0; return D[F[a + 8 >> 2] + 24 | 0]; }
                        function Ti(a) { a = a | 0; F[a >> 2] = 7172; return a | 0; }
                        function Oi(a) { a = a | 0; F[a >> 2] = 8108; return a | 0; }
                        function Nf(a) { a = a | 0; return aa(F[a + 60 >> 2]) | 0; }
                        function Ji(a) { a = a | 0; F[a >> 2] = 9056; return a | 0; }
                        function eh(a) { a = a | 0; return M(J[a + 20 >> 2]); }
                        function Ei(a) { a = a | 0; F[a >> 2] = 10060; ra(a); }
                        function af() { F[4227] = 16796; F[4209] = 42; }
                        function Si(a) { a = a | 0; F[a >> 2] = 7172; ra(a); }
                        function Ni(a) { a = a | 0; F[a >> 2] = 8108; ra(a); }
                        function Ii(a) { a = a | 0; F[a >> 2] = 9056; ra(a); }
                        function nh(a) { a = a | 0; return F[a + 88 >> 2]; }
                        function mh(a) { a = a | 0; return F[a + 56 >> 2]; }
                        function jh(a) { a = a | 0; return F[a + 40 >> 2]; }
                        function ih(a) { a = a | 0; return F[a + 48 >> 2]; }
                        function hh(a) { a = a | 0; return F[a + 60 >> 2]; }
                        function fb(a) { a = a | 0; return F[a + 28 >> 2]; }
                        function Qc(a) { a = a | 0; return F[a + 80 >> 2]; }
                        function tj(a, b) { a = a | 0; b = b | 0; return 2; }
                        function nd(a, b) { a = a | 0; b = b | 0; return -1; }
                        function lh(a) { a = a | 0; return D[a + 24 | 0]; }
                        function kh(a) { a = a | 0; return G[a + 32 | 0]; }
                        function eb(a) { a = a | 0; return F[a + 4 >> 2]; }
                        function Zg(a) { a = a | 0; return !F[a >> 2] | 0; }
                        function Zc(a) { a = a | 0; return F[a + 8 >> 2]; }
                        function Xe(a, b) { a = a | 0; b = b | 0; return 6; }
                        function Md(a, b) { a = a | 0; b = b | 0; return 1; }
                        function Ka(a, b) { a = a | 0; b = b | 0; return 0; }
                        function ne(a) { a = a | 0; return F[a >> 2]; }
                        function kb(a, b, c) { if (c) {
                            ta(a, b, c);
                        } }
                        function ph() { return Fb(sa(64)) | 0; }
                        function ch() { return Yd(sa(84)) | 0; }
                        function Rc(a) { a = a | 0; if (a) {
                            ra(a);
                        } }
                        function zf(a) { a = a | 0; Ac(a); ra(a); }
                        function Bf(a) { a = a | 0; return 1283; }
                        function Ua(a) { a = a | 0; return a | 0; }
                        function vf(a) { a = a | 0; ra(sd(a)); }
                        function ai(a) { a = a | 0; ra(ye(a)); }
                        function _h(a) { a = a | 0; ra(we(a)); }
                        function Of(a) { a = a | 0; ra(ac(a)); }
                        function Af(a) { a = a | 0; ra(Ac(a)); }
                        function $h(a) { a = a | 0; ra(xe(a)); }
                        function md(a) { a = a | 0; return 3; }
                        function Ze(a) { a = a | 0; return 4; }
                        function Ve(a) { a = a | 0; return 5; }
                        function Ub(a) { a = a | 0; return 2; }
                        function Nb(a) { a = a | 0; return 6; }
                        function Ea(a) { a = a | 0; return 1; }
                        function $a(a) { a = a | 0; return 0; }
                        function Ra(a) { a = a | 0; ra(a); }
                        function Oa() { wa(1276); V(); }
                        function Ma() { wa(1323); V(); }
                        function gb(a) { a = a | 0; V(); }
                        function ag() { return 10; }
                        function _f() { return 11; }
                        function Zf() { return 12; }
                        function va() { Oa(); V(); }
                        function fg() { return 5; }
                        function eg() { return 6; }
                        function dg() { return 7; }
                        function de() { return 3; }
                        function cg() { return 8; }
                        function ce() { return 4; }
                        function cc() { return -1; }
                        function bg() { return 9; }
                        function bc() { return 1; }
                        function Yf() { return -2; }
                        function Xf() { return -3; }
                        function Wf() { return -4; }
                        function Vf() { return -5; }
                        function Rb() { return 0; }
                        function Mc() { return 2; }
                        function Da() { $b(); V(); }
                        function $b() { Y(); V(); }
                        function Rd(a) { a = a | 0; }
                        // EMSCRIPTEN_END_FUNCS
                        e = G;
                        p(pa);
                        var ga = c([null, Ua, Ra, Ub, Gj, ti, Ah, Cd, yf, yc, Gh, Xe, tj, Ac, gi, ei, Ea, ij, Ri, Ki, Oe, si, Fe, Xe, bi, ng, gb, Wg, ge, $f, Tf, Pf, fb, Ka, $b, Md, Ea, sd, vf, Jf, xf, wf, pf, of, qd, uf, tf, sf, Md, rf, qf, gf, ff, nf, mf, ef, lf, kf, jf, hf, $e, _e, qd, df, cf, od, bf, Ej, Fj, Bj, Vb, Ea, eb, Qb, $a, nd, Ka, $a, Ea, Dj, Cj, gb, gb, Vb, Ub, Qb, Aj, zj, yj, Ze, Qb, Ye, xj, wj, vj, md, xc, Ea, Ka, wc, We, uj, sj, rj, Ve, xc, Ea, Ka, wc, Ue, qj, pj, oj, Nb, Te, Ea, Ka, Se, Re, nj, Ua, Ra, Lb, fb, Mb, gb, Vb, Ea, Qb, mj, gb, Vb, Ub, Qb, lj, kj, jj, Ze, Qb, Ye, hj, gj, fj, md, xc, Ea, Ka, wc, We, ej, dj, cj, Ve, xc, Ea, Ka, wc, Ue, bj, aj, $i, Nb, Te, Ea, Ka, Se, Re, _i, Ua, Ra, Lb, fb, Kb, gb, Vb, $a, Ea, Zi, $e, _e, Yi, Wi, Xi, Ui, Ub, Vi, Ti, Si, Nb, eb, uc, Ea, Ka, tc, Ea, Ub, Qe, Qi, Ua, Ra, Lb, fb, Mb, Oi, Ni, Nb, uc, Ea, Ka, tc, Qe, Mi, Ua, Ra, Lb, fb, Kb, Ua, Ra, $a, Ea, $a, nd, Ka, Pi, Li, Ji, Ii, Nb, eb, uc, Ea, Ka, tc, Ea, md, Pe, Hi, Ua, Ra, Lb, fb, Mb, Fi, Ei, Nb, uc, Ea, Ka, tc, Pe, Di, Ua, Ra, Lb, fb, Kb, Ra, $a, Ea, $a, nd, Ka, Gi, Ci, vi, ui, Bi, zi, Ai, yi, xi, wi, qi, gb, Ea, Ea, ri, yh, xh, Ea, $a, Ka, Ka, li, ki, oi, pi, mi, ji, ii, hi, ni, ye, ai, kd, jd, id, hd, fi, Ea, eb, Zc, xe, $h, kd, jd, id, hd, di, Ea, eb, Zc, we, _h, kd, jd, id, hd, ci, Ea, eb, Zc, De, Zh, Ee, Yh, Xh, Uh, Th, Sh, Rh, Vh, Qh, Wh, Ph, Oh, Mh, Lh, Kh, Jh, Nh, Ih, Hh, Fh, Eh, Dh, Vc, se, Ch, Ua, Ra, Bh, zh, gb, $a, Ea, Vc, vh, wh, Vc, se, uh, Uf, Sf, Rf, Qf, ac, Of, Vd, Ud, Nf, Mf, Lf, $a, Kf, Ua, Ra, Rd, Rd, If, Cf, Ef, Hf, Ra, Df, Ff, Gf, Ua, Ra, Bf, Af, eb, zf]);
                        function ha() { return C.byteLength / 65536 | 0; }
                        function ma(na) { na = na | 0; var ia = ha() | 0; var ja = ia + na | 0; if (ia < ja && ja < 65536) {
                            var ka = new ArrayBuffer(L(ja, 65536));
                            var la = new Int8Array(ka);
                            la.set(D);
                            D = new Int8Array(ka);
                            E = new Int16Array(ka);
                            F = new Int32Array(ka);
                            G = new Uint8Array(ka);
                            H = new Uint16Array(ka);
                            I = new Uint32Array(ka);
                            J = new Float32Array(ka);
                            K = new Float64Array(ka);
                            C = ka;
                            B.buffer = C;
                            e = G;
                        } return ia; }
                        return { "j": af, "k": ga, "l": Rc, "m": th, "n": sh, "o": Rc, "p": rh, "q": ne, "r": qh, "s": ph, "t": Rc, "u": oh, "v": Qc, "w": nh, "x": mh, "y": fb, "z": lh, "A": kh, "B": jh, "C": ih, "D": hh, "E": Ja, "F": gh, "G": le, "H": eb, "I": fh, "J": eh, "K": dc, "L": dh, "M": le, "N": eb, "O": dc, "P": ch, "Q": ke, "R": Qc, "S": dc, "T": bh, "U": ah, "V": ke, "W": Qc, "X": dc, "Y": $g, "Z": _g, "_": ne, "$": Zg, "aa": Yg, "ba": Xg, "ca": pb, "da": Vg, "ea": Pc, "fa": ob, "ga": pb, "ha": Ug, "ia": je, "ja": ob, "ka": pb, "la": Tg, "ma": je, "na": ob, "oa": pb, "pa": Sg, "qa": ie, "ra": ob, "sa": pb, "ta": Rg, "ua": ie, "va": ob, "wa": pb, "xa": he, "ya": Pc, "za": ob, "Aa": pb, "Ba": he, "Ca": Pc, "Da": ob, "Ea": Qg, "Fa": Pg, "Ga": Og, "Ha": Ng, "Ia": Mg, "Ja": Lg, "Ka": Kg, "La": Jg, "Ma": Ig, "Na": Hg, "Oa": Gg, "Pa": Fg, "Qa": Eg, "Ra": Dg, "Sa": Cg, "Ta": Bg, "Ua": Ag, "Va": zg, "Wa": yg, "Xa": xg, "Ya": wg, "Za": vg, "_a": ug, "$a": tg, "ab": sg, "bb": fe, "cb": rg, "db": qg, "eb": pg, "fb": og, "gb": fe, "hb": mg, "ib": lg, "jb": kg, "kb": jg, "lb": ig, "mb": hg, "nb": gg, "ob": cc, "pb": Rb, "qb": bc, "rb": Mc, "sb": cc, "tb": Rb, "ub": bc, "vb": Mc, "wb": de, "xb": ce, "yb": cc, "zb": Rb, "Ab": bc, "Bb": Rb, "Cb": bc, "Db": Mc, "Eb": de, "Fb": ce, "Gb": fg, "Hb": eg, "Ib": dg, "Jb": cg, "Kb": bg, "Lb": ag, "Mb": _f, "Nb": Zf, "Ob": Rb, "Pb": cc, "Qb": Yf, "Rb": Xf, "Sb": Wf, "Tb": Vf, "Ub": Gd, "Vb": ra };
                    }
                    return oa(qa);
                }
                // EMSCRIPTEN_END_ASM
                )(asmLibraryArg);
            }, instantiate: function (binary, info) { return { then: function (ok) { var module = new WebAssembly.Module(binary); ok({ "instance": new WebAssembly.Instance(module) }); } }; }, RuntimeError: Error };
        wasmBinary = [];
        if (typeof WebAssembly !== "object") {
            abort("no native wasm support detected");
        }
        var wasmMemory;
        var ABORT = false;
        var EXITSTATUS;
        function assert(condition, text) { if (!condition) {
            abort(text);
        } }
        var UTF8Decoder = typeof TextDecoder !== "undefined" ? new TextDecoder("utf8") : undefined;
        function UTF8ArrayToString(heap, idx, maxBytesToRead) { var endIdx = idx + maxBytesToRead; var endPtr = idx; while (heap[endPtr] && !(endPtr >= endIdx))
            ++endPtr; if (endPtr - idx > 16 && heap.subarray && UTF8Decoder) {
            return UTF8Decoder.decode(heap.subarray(idx, endPtr));
        }
        else {
            var str = "";
            while (idx < endPtr) {
                var u0 = heap[idx++];
                if (!(u0 & 128)) {
                    str += String.fromCharCode(u0);
                    continue;
                }
                var u1 = heap[idx++] & 63;
                if ((u0 & 224) == 192) {
                    str += String.fromCharCode((u0 & 31) << 6 | u1);
                    continue;
                }
                var u2 = heap[idx++] & 63;
                if ((u0 & 240) == 224) {
                    u0 = (u0 & 15) << 12 | u1 << 6 | u2;
                }
                else {
                    u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heap[idx++] & 63;
                }
                if (u0 < 65536) {
                    str += String.fromCharCode(u0);
                }
                else {
                    var ch = u0 - 65536;
                    str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
                }
            }
        } return str; }
        function UTF8ToString(ptr, maxBytesToRead) { return ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : ""; }
        function stringToUTF8Array(str, heap, outIdx, maxBytesToWrite) { if (!(maxBytesToWrite > 0))
            return 0; var startIdx = outIdx; var endIdx = outIdx + maxBytesToWrite - 1; for (var i = 0; i < str.length; ++i) {
            var u = str.charCodeAt(i);
            if (u >= 55296 && u <= 57343) {
                var u1 = str.charCodeAt(++i);
                u = 65536 + ((u & 1023) << 10) | u1 & 1023;
            }
            if (u <= 127) {
                if (outIdx >= endIdx)
                    break;
                heap[outIdx++] = u;
            }
            else if (u <= 2047) {
                if (outIdx + 1 >= endIdx)
                    break;
                heap[outIdx++] = 192 | u >> 6;
                heap[outIdx++] = 128 | u & 63;
            }
            else if (u <= 65535) {
                if (outIdx + 2 >= endIdx)
                    break;
                heap[outIdx++] = 224 | u >> 12;
                heap[outIdx++] = 128 | u >> 6 & 63;
                heap[outIdx++] = 128 | u & 63;
            }
            else {
                if (outIdx + 3 >= endIdx)
                    break;
                heap[outIdx++] = 240 | u >> 18;
                heap[outIdx++] = 128 | u >> 12 & 63;
                heap[outIdx++] = 128 | u >> 6 & 63;
                heap[outIdx++] = 128 | u & 63;
            }
        } heap[outIdx] = 0; return outIdx - startIdx; }
        function lengthBytesUTF8(str) { var len = 0; for (var i = 0; i < str.length; ++i) {
            var u = str.charCodeAt(i);
            if (u >= 55296 && u <= 57343)
                u = 65536 + ((u & 1023) << 10) | str.charCodeAt(++i) & 1023;
            if (u <= 127)
                ++len;
            else if (u <= 2047)
                len += 2;
            else if (u <= 65535)
                len += 3;
            else
                len += 4;
        } return len; }
        function alignUp(x, multiple) { if (x % multiple > 0) {
            x += multiple - x % multiple;
        } return x; }
        var buffer, HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
        function updateGlobalBufferAndViews(buf) { buffer = buf; Module["HEAP8"] = HEAP8 = new Int8Array(buf); Module["HEAP16"] = HEAP16 = new Int16Array(buf); Module["HEAP32"] = HEAP32 = new Int32Array(buf); Module["HEAPU8"] = HEAPU8 = new Uint8Array(buf); Module["HEAPU16"] = HEAPU16 = new Uint16Array(buf); Module["HEAPU32"] = HEAPU32 = new Uint32Array(buf); Module["HEAPF32"] = HEAPF32 = new Float32Array(buf); Module["HEAPF64"] = HEAPF64 = new Float64Array(buf); }
        var INITIAL_MEMORY = Module["INITIAL_MEMORY"] || 16777216;
        if (Module["wasmMemory"]) {
            wasmMemory = Module["wasmMemory"];
        }
        else {
            wasmMemory = new WebAssembly.Memory({ "initial": INITIAL_MEMORY / 65536, "maximum": 2147483648 / 65536 });
        }
        if (wasmMemory) {
            buffer = wasmMemory.buffer;
        }
        INITIAL_MEMORY = buffer.byteLength;
        updateGlobalBufferAndViews(buffer);
        var wasmTable;
        var __ATPRERUN__ = [];
        var __ATINIT__ = [];
        var __ATPOSTRUN__ = [];
        var runtimeInitialized = false;
        var runtimeKeepaliveCounter = 0;
        function keepRuntimeAlive() { return noExitRuntime || runtimeKeepaliveCounter > 0; }
        function preRun() { if (Module["preRun"]) {
            if (typeof Module["preRun"] == "function")
                Module["preRun"] = [Module["preRun"]];
            while (Module["preRun"].length) {
                addOnPreRun(Module["preRun"].shift());
            }
        } callRuntimeCallbacks(__ATPRERUN__); }
        function initRuntime() { runtimeInitialized = true; callRuntimeCallbacks(__ATINIT__); }
        function postRun() { if (Module["postRun"]) {
            if (typeof Module["postRun"] == "function")
                Module["postRun"] = [Module["postRun"]];
            while (Module["postRun"].length) {
                addOnPostRun(Module["postRun"].shift());
            }
        } callRuntimeCallbacks(__ATPOSTRUN__); }
        function addOnPreRun(cb) { __ATPRERUN__.unshift(cb); }
        function addOnInit(cb) { __ATINIT__.unshift(cb); }
        function addOnPostRun(cb) { __ATPOSTRUN__.unshift(cb); }
        var runDependencies = 0;
        var runDependencyWatcher = null;
        var dependenciesFulfilled = null;
        function addRunDependency(id) { runDependencies++; if (Module["monitorRunDependencies"]) {
            Module["monitorRunDependencies"](runDependencies);
        } }
        function removeRunDependency(id) { runDependencies--; if (Module["monitorRunDependencies"]) {
            Module["monitorRunDependencies"](runDependencies);
        } if (runDependencies == 0) {
            if (runDependencyWatcher !== null) {
                clearInterval(runDependencyWatcher);
                runDependencyWatcher = null;
            }
            if (dependenciesFulfilled) {
                var callback = dependenciesFulfilled;
                dependenciesFulfilled = null;
                callback();
            }
        } }
        Module["preloadedImages"] = {};
        Module["preloadedAudios"] = {};
        function abort(what) { {
            if (Module["onAbort"]) {
                Module["onAbort"](what);
            }
        } what = "Aborted(" + what + ")"; err(what); ABORT = true; EXITSTATUS = 1; what += ". Build with -s ASSERTIONS=1 for more info."; var e = new WebAssembly.RuntimeError(what); readyPromiseReject(e); throw e; }
        var dataURIPrefix = "data:application/octet-stream;base64,";
        function isDataURI(filename) { return filename.startsWith(dataURIPrefix); }
        function isFileURI(filename) { return filename.startsWith("file://"); }
        var wasmBinaryFile;
        wasmBinaryFile = "draco_decoder.wasm";
        if (!isDataURI(wasmBinaryFile)) {
            wasmBinaryFile = locateFile(wasmBinaryFile);
        }
        function getBinary(file) { try {
            if (file == wasmBinaryFile && wasmBinary) {
                return new Uint8Array(wasmBinary);
            }
            var binary = tryParseAsDataURI(file);
            if (binary) {
                return binary;
            }
            if (readBinary) {
                return readBinary(file);
            }
            else {
                throw "both async and sync fetching of the wasm failed";
            }
        }
        catch (err) {
            abort(err);
        } }
        function getBinaryPromise() { if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER)) {
            if (typeof fetch === "function" && !isFileURI(wasmBinaryFile)) {
                return fetch(wasmBinaryFile, { credentials: "same-origin" }).then(function (response) { if (!response["ok"]) {
                    throw "failed to load wasm binary file at '" + wasmBinaryFile + "'";
                } return response["arrayBuffer"](); }).catch(function () { return getBinary(wasmBinaryFile); });
            }
            else {
                if (readAsync) {
                    return new Promise(function (resolve, reject) { readAsync(wasmBinaryFile, function (response) { resolve(new Uint8Array(response)); }, reject); });
                }
            }
        } return Promise.resolve().then(function () { return getBinary(wasmBinaryFile); }); }
        function createWasm() { var info = { "a": asmLibraryArg }; function receiveInstance(instance, module) { var exports = instance.exports; Module["asm"] = exports; wasmTable = Module["asm"]["k"]; addOnInit(Module["asm"]["j"]); removeRunDependency("wasm-instantiate"); } addRunDependency("wasm-instantiate"); function receiveInstantiationResult(result) { receiveInstance(result["instance"]); } function instantiateArrayBuffer(receiver) { return getBinaryPromise().then(function (binary) { return WebAssembly.instantiate(binary, info); }).then(function (instance) { return instance; }).then(receiver, function (reason) { err("failed to asynchronously prepare wasm: " + reason); abort(reason); }); } function instantiateAsync() { if (!wasmBinary && typeof WebAssembly.instantiateStreaming === "function" && !isDataURI(wasmBinaryFile) && !isFileURI(wasmBinaryFile) && typeof fetch === "function") {
            return fetch(wasmBinaryFile, { credentials: "same-origin" }).then(function (response) { var result = WebAssembly.instantiateStreaming(response, info); return result.then(receiveInstantiationResult, function (reason) { err("wasm streaming compile failed: " + reason); err("falling back to ArrayBuffer instantiation"); return instantiateArrayBuffer(receiveInstantiationResult); }); });
        }
        else {
            return instantiateArrayBuffer(receiveInstantiationResult);
        } } if (Module["instantiateWasm"]) {
            try {
                var exports = Module["instantiateWasm"](info, receiveInstance);
                return exports;
            }
            catch (e) {
                err("Module.instantiateWasm callback failed with error: " + e);
                return false;
            }
        } instantiateAsync().catch(readyPromiseReject); return {}; }
        function callRuntimeCallbacks(callbacks) { while (callbacks.length > 0) {
            var callback = callbacks.shift();
            if (typeof callback == "function") {
                callback(Module);
                continue;
            }
            var func = callback.func;
            if (typeof func === "number") {
                if (callback.arg === undefined) {
                    getWasmTableEntry(func)();
                }
                else {
                    getWasmTableEntry(func)(callback.arg);
                }
            }
            else {
                func(callback.arg === undefined ? null : callback.arg);
            }
        } }
        var wasmTableMirror = [];
        function getWasmTableEntry(funcPtr) { var func = wasmTableMirror[funcPtr]; if (!func) {
            if (funcPtr >= wasmTableMirror.length)
                wasmTableMirror.length = funcPtr + 1;
            wasmTableMirror[funcPtr] = func = wasmTable.get(funcPtr);
        } return func; }
        function ___cxa_allocate_exception(size) { return _malloc(size + 16) + 16; }
        function ExceptionInfo(excPtr) { this.excPtr = excPtr; this.ptr = excPtr - 16; this.set_type = function (type) { HEAP32[this.ptr + 4 >> 2] = type; }; this.get_type = function () { return HEAP32[this.ptr + 4 >> 2]; }; this.set_destructor = function (destructor) { HEAP32[this.ptr + 8 >> 2] = destructor; }; this.get_destructor = function () { return HEAP32[this.ptr + 8 >> 2]; }; this.set_refcount = function (refcount) { HEAP32[this.ptr >> 2] = refcount; }; this.set_caught = function (caught) { caught = caught ? 1 : 0; HEAP8[this.ptr + 12 >> 0] = caught; }; this.get_caught = function () { return HEAP8[this.ptr + 12 >> 0] != 0; }; this.set_rethrown = function (rethrown) { rethrown = rethrown ? 1 : 0; HEAP8[this.ptr + 13 >> 0] = rethrown; }; this.get_rethrown = function () { return HEAP8[this.ptr + 13 >> 0] != 0; }; this.init = function (type, destructor) { this.set_type(type); this.set_destructor(destructor); this.set_refcount(0); this.set_caught(false); this.set_rethrown(false); }; this.add_ref = function () { var value = HEAP32[this.ptr >> 2]; HEAP32[this.ptr >> 2] = value + 1; }; this.release_ref = function () { var prev = HEAP32[this.ptr >> 2]; HEAP32[this.ptr >> 2] = prev - 1; return prev === 1; }; }
        var exceptionLast = 0;
        var uncaughtExceptionCount = 0;
        function ___cxa_throw(ptr, type, destructor) { var info = new ExceptionInfo(ptr); info.init(type, destructor); exceptionLast = ptr; uncaughtExceptionCount++; throw ptr; }
        function _abort() { abort(""); }
        function _emscripten_memcpy_big(dest, src, num) { HEAPU8.copyWithin(dest, src, src + num); }
        function emscripten_realloc_buffer(size) { try {
            wasmMemory.grow(size - buffer.byteLength + 65535 >>> 16);
            updateGlobalBufferAndViews(wasmMemory.buffer);
            return 1;
        }
        catch (e) { } }
        function _emscripten_resize_heap(requestedSize) { var oldSize = HEAPU8.length; requestedSize = requestedSize >>> 0; var maxHeapSize = 2147483648; if (requestedSize > maxHeapSize) {
            return false;
        } for (var cutDown = 1; cutDown <= 4; cutDown *= 2) {
            var overGrownHeapSize = oldSize * (1 + .2 / cutDown);
            overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
            var newSize = Math.min(maxHeapSize, alignUp(Math.max(requestedSize, overGrownHeapSize), 65536));
            var replacement = emscripten_realloc_buffer(newSize);
            if (replacement) {
                return true;
            }
        } return false; }
        var SYSCALLS = { mappings: {}, buffers: [null, [], []], printChar: function (stream, curr) { var buffer = SYSCALLS.buffers[stream]; if (curr === 0 || curr === 10) {
                (stream === 1 ? out : err)(UTF8ArrayToString(buffer, 0));
                buffer.length = 0;
            }
            else {
                buffer.push(curr);
            } }, varargs: undefined, get: function () { SYSCALLS.varargs += 4; var ret = HEAP32[SYSCALLS.varargs - 4 >> 2]; return ret; }, getStr: function (ptr) { var ret = UTF8ToString(ptr); return ret; }, get64: function (low, high) { return low; } };
        function _fd_close(fd) { return 0; }
        function _fd_seek(fd, offset_low, offset_high, whence, newOffset) { }
        function _fd_write(fd, iov, iovcnt, pnum) { var num = 0; for (var i = 0; i < iovcnt; i++) {
            var ptr = HEAP32[iov >> 2];
            var len = HEAP32[iov + 4 >> 2];
            iov += 8;
            for (var j = 0; j < len; j++) {
                SYSCALLS.printChar(fd, HEAPU8[ptr + j]);
            }
            num += len;
        } HEAP32[pnum >> 2] = num; return 0; }
        var ASSERTIONS = false;
        function intArrayFromString(stringy, dontAddNull, length) { var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1; var u8array = new Array(len); var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length); if (dontAddNull)
            u8array.length = numBytesWritten; return u8array; }
        function intArrayToString(array) { var ret = []; for (var i = 0; i < array.length; i++) {
            var chr = array[i];
            if (chr > 255) {
                if (ASSERTIONS) {
                    assert(false, "Character code " + chr + " (" + String.fromCharCode(chr) + ")  at offset " + i + " not in 0x00-0xFF.");
                }
                chr &= 255;
            }
            ret.push(String.fromCharCode(chr));
        } return ret.join(""); }
        var decodeBase64 = typeof atob === "function" ? atob : function (input) { var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="; var output = ""; var chr1, chr2, chr3; var enc1, enc2, enc3, enc4; var i = 0; input = input.replace(/[^A-Za-z0-9\+\/\=]/g, ""); do {
            enc1 = keyStr.indexOf(input.charAt(i++));
            enc2 = keyStr.indexOf(input.charAt(i++));
            enc3 = keyStr.indexOf(input.charAt(i++));
            enc4 = keyStr.indexOf(input.charAt(i++));
            chr1 = enc1 << 2 | enc2 >> 4;
            chr2 = (enc2 & 15) << 4 | enc3 >> 2;
            chr3 = (enc3 & 3) << 6 | enc4;
            output = output + String.fromCharCode(chr1);
            if (enc3 !== 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 !== 64) {
                output = output + String.fromCharCode(chr3);
            }
        } while (i < input.length); return output; };
        function intArrayFromBase64(s) { if (typeof ENVIRONMENT_IS_NODE === "boolean" && ENVIRONMENT_IS_NODE) {
            var buf = Buffer.from(s, "base64");
            return new Uint8Array(buf["buffer"], buf["byteOffset"], buf["byteLength"]);
        } try {
            var decoded = decodeBase64(s);
            var bytes = new Uint8Array(decoded.length);
            for (var i = 0; i < decoded.length; ++i) {
                bytes[i] = decoded.charCodeAt(i);
            }
            return bytes;
        }
        catch (_) {
            throw new Error("Converting base64 string to bytes failed.");
        } }
        function tryParseAsDataURI(filename) { if (!isDataURI(filename)) {
            return;
        } return intArrayFromBase64(filename.slice(dataURIPrefix.length)); }
        var asmLibraryArg = { "i": ___cxa_allocate_exception, "h": ___cxa_throw, "b": _abort, "g": _emscripten_memcpy_big, "e": _emscripten_resize_heap, "f": _fd_close, "d": _fd_seek, "c": _fd_write, "a": wasmMemory };
        var asm = createWasm();
        var ___wasm_call_ctors = Module["___wasm_call_ctors"] = function () { return (___wasm_call_ctors = Module["___wasm_call_ctors"] = Module["asm"]["j"]).apply(null, arguments); };
        var _emscripten_bind_VoidPtr___destroy___0 = Module["_emscripten_bind_VoidPtr___destroy___0"] = function () { return (_emscripten_bind_VoidPtr___destroy___0 = Module["_emscripten_bind_VoidPtr___destroy___0"] = Module["asm"]["l"]).apply(null, arguments); };
        var _emscripten_bind_DecoderBuffer_DecoderBuffer_0 = Module["_emscripten_bind_DecoderBuffer_DecoderBuffer_0"] = function () { return (_emscripten_bind_DecoderBuffer_DecoderBuffer_0 = Module["_emscripten_bind_DecoderBuffer_DecoderBuffer_0"] = Module["asm"]["m"]).apply(null, arguments); };
        var _emscripten_bind_DecoderBuffer_Init_2 = Module["_emscripten_bind_DecoderBuffer_Init_2"] = function () { return (_emscripten_bind_DecoderBuffer_Init_2 = Module["_emscripten_bind_DecoderBuffer_Init_2"] = Module["asm"]["n"]).apply(null, arguments); };
        var _emscripten_bind_DecoderBuffer___destroy___0 = Module["_emscripten_bind_DecoderBuffer___destroy___0"] = function () { return (_emscripten_bind_DecoderBuffer___destroy___0 = Module["_emscripten_bind_DecoderBuffer___destroy___0"] = Module["asm"]["o"]).apply(null, arguments); };
        var _emscripten_bind_AttributeTransformData_AttributeTransformData_0 = Module["_emscripten_bind_AttributeTransformData_AttributeTransformData_0"] = function () { return (_emscripten_bind_AttributeTransformData_AttributeTransformData_0 = Module["_emscripten_bind_AttributeTransformData_AttributeTransformData_0"] = Module["asm"]["p"]).apply(null, arguments); };
        var _emscripten_bind_AttributeTransformData_transform_type_0 = Module["_emscripten_bind_AttributeTransformData_transform_type_0"] = function () { return (_emscripten_bind_AttributeTransformData_transform_type_0 = Module["_emscripten_bind_AttributeTransformData_transform_type_0"] = Module["asm"]["q"]).apply(null, arguments); };
        var _emscripten_bind_AttributeTransformData___destroy___0 = Module["_emscripten_bind_AttributeTransformData___destroy___0"] = function () { return (_emscripten_bind_AttributeTransformData___destroy___0 = Module["_emscripten_bind_AttributeTransformData___destroy___0"] = Module["asm"]["r"]).apply(null, arguments); };
        var _emscripten_bind_GeometryAttribute_GeometryAttribute_0 = Module["_emscripten_bind_GeometryAttribute_GeometryAttribute_0"] = function () { return (_emscripten_bind_GeometryAttribute_GeometryAttribute_0 = Module["_emscripten_bind_GeometryAttribute_GeometryAttribute_0"] = Module["asm"]["s"]).apply(null, arguments); };
        var _emscripten_bind_GeometryAttribute___destroy___0 = Module["_emscripten_bind_GeometryAttribute___destroy___0"] = function () { return (_emscripten_bind_GeometryAttribute___destroy___0 = Module["_emscripten_bind_GeometryAttribute___destroy___0"] = Module["asm"]["t"]).apply(null, arguments); };
        var _emscripten_bind_PointAttribute_PointAttribute_0 = Module["_emscripten_bind_PointAttribute_PointAttribute_0"] = function () { return (_emscripten_bind_PointAttribute_PointAttribute_0 = Module["_emscripten_bind_PointAttribute_PointAttribute_0"] = Module["asm"]["u"]).apply(null, arguments); };
        var _emscripten_bind_PointAttribute_size_0 = Module["_emscripten_bind_PointAttribute_size_0"] = function () { return (_emscripten_bind_PointAttribute_size_0 = Module["_emscripten_bind_PointAttribute_size_0"] = Module["asm"]["v"]).apply(null, arguments); };
        var _emscripten_bind_PointAttribute_GetAttributeTransformData_0 = Module["_emscripten_bind_PointAttribute_GetAttributeTransformData_0"] = function () { return (_emscripten_bind_PointAttribute_GetAttributeTransformData_0 = Module["_emscripten_bind_PointAttribute_GetAttributeTransformData_0"] = Module["asm"]["w"]).apply(null, arguments); };
        var _emscripten_bind_PointAttribute_attribute_type_0 = Module["_emscripten_bind_PointAttribute_attribute_type_0"] = function () { return (_emscripten_bind_PointAttribute_attribute_type_0 = Module["_emscripten_bind_PointAttribute_attribute_type_0"] = Module["asm"]["x"]).apply(null, arguments); };
        var _emscripten_bind_PointAttribute_data_type_0 = Module["_emscripten_bind_PointAttribute_data_type_0"] = function () { return (_emscripten_bind_PointAttribute_data_type_0 = Module["_emscripten_bind_PointAttribute_data_type_0"] = Module["asm"]["y"]).apply(null, arguments); };
        var _emscripten_bind_PointAttribute_num_components_0 = Module["_emscripten_bind_PointAttribute_num_components_0"] = function () { return (_emscripten_bind_PointAttribute_num_components_0 = Module["_emscripten_bind_PointAttribute_num_components_0"] = Module["asm"]["z"]).apply(null, arguments); };
        var _emscripten_bind_PointAttribute_normalized_0 = Module["_emscripten_bind_PointAttribute_normalized_0"] = function () { return (_emscripten_bind_PointAttribute_normalized_0 = Module["_emscripten_bind_PointAttribute_normalized_0"] = Module["asm"]["A"]).apply(null, arguments); };
        var _emscripten_bind_PointAttribute_byte_stride_0 = Module["_emscripten_bind_PointAttribute_byte_stride_0"] = function () { return (_emscripten_bind_PointAttribute_byte_stride_0 = Module["_emscripten_bind_PointAttribute_byte_stride_0"] = Module["asm"]["B"]).apply(null, arguments); };
        var _emscripten_bind_PointAttribute_byte_offset_0 = Module["_emscripten_bind_PointAttribute_byte_offset_0"] = function () { return (_emscripten_bind_PointAttribute_byte_offset_0 = Module["_emscripten_bind_PointAttribute_byte_offset_0"] = Module["asm"]["C"]).apply(null, arguments); };
        var _emscripten_bind_PointAttribute_unique_id_0 = Module["_emscripten_bind_PointAttribute_unique_id_0"] = function () { return (_emscripten_bind_PointAttribute_unique_id_0 = Module["_emscripten_bind_PointAttribute_unique_id_0"] = Module["asm"]["D"]).apply(null, arguments); };
        var _emscripten_bind_PointAttribute___destroy___0 = Module["_emscripten_bind_PointAttribute___destroy___0"] = function () { return (_emscripten_bind_PointAttribute___destroy___0 = Module["_emscripten_bind_PointAttribute___destroy___0"] = Module["asm"]["E"]).apply(null, arguments); };
        var _emscripten_bind_AttributeQuantizationTransform_AttributeQuantizationTransform_0 = Module["_emscripten_bind_AttributeQuantizationTransform_AttributeQuantizationTransform_0"] = function () { return (_emscripten_bind_AttributeQuantizationTransform_AttributeQuantizationTransform_0 = Module["_emscripten_bind_AttributeQuantizationTransform_AttributeQuantizationTransform_0"] = Module["asm"]["F"]).apply(null, arguments); };
        var _emscripten_bind_AttributeQuantizationTransform_InitFromAttribute_1 = Module["_emscripten_bind_AttributeQuantizationTransform_InitFromAttribute_1"] = function () { return (_emscripten_bind_AttributeQuantizationTransform_InitFromAttribute_1 = Module["_emscripten_bind_AttributeQuantizationTransform_InitFromAttribute_1"] = Module["asm"]["G"]).apply(null, arguments); };
        var _emscripten_bind_AttributeQuantizationTransform_quantization_bits_0 = Module["_emscripten_bind_AttributeQuantizationTransform_quantization_bits_0"] = function () { return (_emscripten_bind_AttributeQuantizationTransform_quantization_bits_0 = Module["_emscripten_bind_AttributeQuantizationTransform_quantization_bits_0"] = Module["asm"]["H"]).apply(null, arguments); };
        var _emscripten_bind_AttributeQuantizationTransform_min_value_1 = Module["_emscripten_bind_AttributeQuantizationTransform_min_value_1"] = function () { return (_emscripten_bind_AttributeQuantizationTransform_min_value_1 = Module["_emscripten_bind_AttributeQuantizationTransform_min_value_1"] = Module["asm"]["I"]).apply(null, arguments); };
        var _emscripten_bind_AttributeQuantizationTransform_range_0 = Module["_emscripten_bind_AttributeQuantizationTransform_range_0"] = function () { return (_emscripten_bind_AttributeQuantizationTransform_range_0 = Module["_emscripten_bind_AttributeQuantizationTransform_range_0"] = Module["asm"]["J"]).apply(null, arguments); };
        var _emscripten_bind_AttributeQuantizationTransform___destroy___0 = Module["_emscripten_bind_AttributeQuantizationTransform___destroy___0"] = function () { return (_emscripten_bind_AttributeQuantizationTransform___destroy___0 = Module["_emscripten_bind_AttributeQuantizationTransform___destroy___0"] = Module["asm"]["K"]).apply(null, arguments); };
        var _emscripten_bind_AttributeOctahedronTransform_AttributeOctahedronTransform_0 = Module["_emscripten_bind_AttributeOctahedronTransform_AttributeOctahedronTransform_0"] = function () { return (_emscripten_bind_AttributeOctahedronTransform_AttributeOctahedronTransform_0 = Module["_emscripten_bind_AttributeOctahedronTransform_AttributeOctahedronTransform_0"] = Module["asm"]["L"]).apply(null, arguments); };
        var _emscripten_bind_AttributeOctahedronTransform_InitFromAttribute_1 = Module["_emscripten_bind_AttributeOctahedronTransform_InitFromAttribute_1"] = function () { return (_emscripten_bind_AttributeOctahedronTransform_InitFromAttribute_1 = Module["_emscripten_bind_AttributeOctahedronTransform_InitFromAttribute_1"] = Module["asm"]["M"]).apply(null, arguments); };
        var _emscripten_bind_AttributeOctahedronTransform_quantization_bits_0 = Module["_emscripten_bind_AttributeOctahedronTransform_quantization_bits_0"] = function () { return (_emscripten_bind_AttributeOctahedronTransform_quantization_bits_0 = Module["_emscripten_bind_AttributeOctahedronTransform_quantization_bits_0"] = Module["asm"]["N"]).apply(null, arguments); };
        var _emscripten_bind_AttributeOctahedronTransform___destroy___0 = Module["_emscripten_bind_AttributeOctahedronTransform___destroy___0"] = function () { return (_emscripten_bind_AttributeOctahedronTransform___destroy___0 = Module["_emscripten_bind_AttributeOctahedronTransform___destroy___0"] = Module["asm"]["O"]).apply(null, arguments); };
        var _emscripten_bind_PointCloud_PointCloud_0 = Module["_emscripten_bind_PointCloud_PointCloud_0"] = function () { return (_emscripten_bind_PointCloud_PointCloud_0 = Module["_emscripten_bind_PointCloud_PointCloud_0"] = Module["asm"]["P"]).apply(null, arguments); };
        var _emscripten_bind_PointCloud_num_attributes_0 = Module["_emscripten_bind_PointCloud_num_attributes_0"] = function () { return (_emscripten_bind_PointCloud_num_attributes_0 = Module["_emscripten_bind_PointCloud_num_attributes_0"] = Module["asm"]["Q"]).apply(null, arguments); };
        var _emscripten_bind_PointCloud_num_points_0 = Module["_emscripten_bind_PointCloud_num_points_0"] = function () { return (_emscripten_bind_PointCloud_num_points_0 = Module["_emscripten_bind_PointCloud_num_points_0"] = Module["asm"]["R"]).apply(null, arguments); };
        var _emscripten_bind_PointCloud___destroy___0 = Module["_emscripten_bind_PointCloud___destroy___0"] = function () { return (_emscripten_bind_PointCloud___destroy___0 = Module["_emscripten_bind_PointCloud___destroy___0"] = Module["asm"]["S"]).apply(null, arguments); };
        var _emscripten_bind_Mesh_Mesh_0 = Module["_emscripten_bind_Mesh_Mesh_0"] = function () { return (_emscripten_bind_Mesh_Mesh_0 = Module["_emscripten_bind_Mesh_Mesh_0"] = Module["asm"]["T"]).apply(null, arguments); };
        var _emscripten_bind_Mesh_num_faces_0 = Module["_emscripten_bind_Mesh_num_faces_0"] = function () { return (_emscripten_bind_Mesh_num_faces_0 = Module["_emscripten_bind_Mesh_num_faces_0"] = Module["asm"]["U"]).apply(null, arguments); };
        var _emscripten_bind_Mesh_num_attributes_0 = Module["_emscripten_bind_Mesh_num_attributes_0"] = function () { return (_emscripten_bind_Mesh_num_attributes_0 = Module["_emscripten_bind_Mesh_num_attributes_0"] = Module["asm"]["V"]).apply(null, arguments); };
        var _emscripten_bind_Mesh_num_points_0 = Module["_emscripten_bind_Mesh_num_points_0"] = function () { return (_emscripten_bind_Mesh_num_points_0 = Module["_emscripten_bind_Mesh_num_points_0"] = Module["asm"]["W"]).apply(null, arguments); };
        var _emscripten_bind_Mesh___destroy___0 = Module["_emscripten_bind_Mesh___destroy___0"] = function () { return (_emscripten_bind_Mesh___destroy___0 = Module["_emscripten_bind_Mesh___destroy___0"] = Module["asm"]["X"]).apply(null, arguments); };
        var _emscripten_bind_Metadata_Metadata_0 = Module["_emscripten_bind_Metadata_Metadata_0"] = function () { return (_emscripten_bind_Metadata_Metadata_0 = Module["_emscripten_bind_Metadata_Metadata_0"] = Module["asm"]["Y"]).apply(null, arguments); };
        var _emscripten_bind_Metadata___destroy___0 = Module["_emscripten_bind_Metadata___destroy___0"] = function () { return (_emscripten_bind_Metadata___destroy___0 = Module["_emscripten_bind_Metadata___destroy___0"] = Module["asm"]["Z"]).apply(null, arguments); };
        var _emscripten_bind_Status_code_0 = Module["_emscripten_bind_Status_code_0"] = function () { return (_emscripten_bind_Status_code_0 = Module["_emscripten_bind_Status_code_0"] = Module["asm"]["_"]).apply(null, arguments); };
        var _emscripten_bind_Status_ok_0 = Module["_emscripten_bind_Status_ok_0"] = function () { return (_emscripten_bind_Status_ok_0 = Module["_emscripten_bind_Status_ok_0"] = Module["asm"]["$"]).apply(null, arguments); };
        var _emscripten_bind_Status_error_msg_0 = Module["_emscripten_bind_Status_error_msg_0"] = function () { return (_emscripten_bind_Status_error_msg_0 = Module["_emscripten_bind_Status_error_msg_0"] = Module["asm"]["aa"]).apply(null, arguments); };
        var _emscripten_bind_Status___destroy___0 = Module["_emscripten_bind_Status___destroy___0"] = function () { return (_emscripten_bind_Status___destroy___0 = Module["_emscripten_bind_Status___destroy___0"] = Module["asm"]["ba"]).apply(null, arguments); };
        var _emscripten_bind_DracoFloat32Array_DracoFloat32Array_0 = Module["_emscripten_bind_DracoFloat32Array_DracoFloat32Array_0"] = function () { return (_emscripten_bind_DracoFloat32Array_DracoFloat32Array_0 = Module["_emscripten_bind_DracoFloat32Array_DracoFloat32Array_0"] = Module["asm"]["ca"]).apply(null, arguments); };
        var _emscripten_bind_DracoFloat32Array_GetValue_1 = Module["_emscripten_bind_DracoFloat32Array_GetValue_1"] = function () { return (_emscripten_bind_DracoFloat32Array_GetValue_1 = Module["_emscripten_bind_DracoFloat32Array_GetValue_1"] = Module["asm"]["da"]).apply(null, arguments); };
        var _emscripten_bind_DracoFloat32Array_size_0 = Module["_emscripten_bind_DracoFloat32Array_size_0"] = function () { return (_emscripten_bind_DracoFloat32Array_size_0 = Module["_emscripten_bind_DracoFloat32Array_size_0"] = Module["asm"]["ea"]).apply(null, arguments); };
        var _emscripten_bind_DracoFloat32Array___destroy___0 = Module["_emscripten_bind_DracoFloat32Array___destroy___0"] = function () { return (_emscripten_bind_DracoFloat32Array___destroy___0 = Module["_emscripten_bind_DracoFloat32Array___destroy___0"] = Module["asm"]["fa"]).apply(null, arguments); };
        var _emscripten_bind_DracoInt8Array_DracoInt8Array_0 = Module["_emscripten_bind_DracoInt8Array_DracoInt8Array_0"] = function () { return (_emscripten_bind_DracoInt8Array_DracoInt8Array_0 = Module["_emscripten_bind_DracoInt8Array_DracoInt8Array_0"] = Module["asm"]["ga"]).apply(null, arguments); };
        var _emscripten_bind_DracoInt8Array_GetValue_1 = Module["_emscripten_bind_DracoInt8Array_GetValue_1"] = function () { return (_emscripten_bind_DracoInt8Array_GetValue_1 = Module["_emscripten_bind_DracoInt8Array_GetValue_1"] = Module["asm"]["ha"]).apply(null, arguments); };
        var _emscripten_bind_DracoInt8Array_size_0 = Module["_emscripten_bind_DracoInt8Array_size_0"] = function () { return (_emscripten_bind_DracoInt8Array_size_0 = Module["_emscripten_bind_DracoInt8Array_size_0"] = Module["asm"]["ia"]).apply(null, arguments); };
        var _emscripten_bind_DracoInt8Array___destroy___0 = Module["_emscripten_bind_DracoInt8Array___destroy___0"] = function () { return (_emscripten_bind_DracoInt8Array___destroy___0 = Module["_emscripten_bind_DracoInt8Array___destroy___0"] = Module["asm"]["ja"]).apply(null, arguments); };
        var _emscripten_bind_DracoUInt8Array_DracoUInt8Array_0 = Module["_emscripten_bind_DracoUInt8Array_DracoUInt8Array_0"] = function () { return (_emscripten_bind_DracoUInt8Array_DracoUInt8Array_0 = Module["_emscripten_bind_DracoUInt8Array_DracoUInt8Array_0"] = Module["asm"]["ka"]).apply(null, arguments); };
        var _emscripten_bind_DracoUInt8Array_GetValue_1 = Module["_emscripten_bind_DracoUInt8Array_GetValue_1"] = function () { return (_emscripten_bind_DracoUInt8Array_GetValue_1 = Module["_emscripten_bind_DracoUInt8Array_GetValue_1"] = Module["asm"]["la"]).apply(null, arguments); };
        var _emscripten_bind_DracoUInt8Array_size_0 = Module["_emscripten_bind_DracoUInt8Array_size_0"] = function () { return (_emscripten_bind_DracoUInt8Array_size_0 = Module["_emscripten_bind_DracoUInt8Array_size_0"] = Module["asm"]["ma"]).apply(null, arguments); };
        var _emscripten_bind_DracoUInt8Array___destroy___0 = Module["_emscripten_bind_DracoUInt8Array___destroy___0"] = function () { return (_emscripten_bind_DracoUInt8Array___destroy___0 = Module["_emscripten_bind_DracoUInt8Array___destroy___0"] = Module["asm"]["na"]).apply(null, arguments); };
        var _emscripten_bind_DracoInt16Array_DracoInt16Array_0 = Module["_emscripten_bind_DracoInt16Array_DracoInt16Array_0"] = function () { return (_emscripten_bind_DracoInt16Array_DracoInt16Array_0 = Module["_emscripten_bind_DracoInt16Array_DracoInt16Array_0"] = Module["asm"]["oa"]).apply(null, arguments); };
        var _emscripten_bind_DracoInt16Array_GetValue_1 = Module["_emscripten_bind_DracoInt16Array_GetValue_1"] = function () { return (_emscripten_bind_DracoInt16Array_GetValue_1 = Module["_emscripten_bind_DracoInt16Array_GetValue_1"] = Module["asm"]["pa"]).apply(null, arguments); };
        var _emscripten_bind_DracoInt16Array_size_0 = Module["_emscripten_bind_DracoInt16Array_size_0"] = function () { return (_emscripten_bind_DracoInt16Array_size_0 = Module["_emscripten_bind_DracoInt16Array_size_0"] = Module["asm"]["qa"]).apply(null, arguments); };
        var _emscripten_bind_DracoInt16Array___destroy___0 = Module["_emscripten_bind_DracoInt16Array___destroy___0"] = function () { return (_emscripten_bind_DracoInt16Array___destroy___0 = Module["_emscripten_bind_DracoInt16Array___destroy___0"] = Module["asm"]["ra"]).apply(null, arguments); };
        var _emscripten_bind_DracoUInt16Array_DracoUInt16Array_0 = Module["_emscripten_bind_DracoUInt16Array_DracoUInt16Array_0"] = function () { return (_emscripten_bind_DracoUInt16Array_DracoUInt16Array_0 = Module["_emscripten_bind_DracoUInt16Array_DracoUInt16Array_0"] = Module["asm"]["sa"]).apply(null, arguments); };
        var _emscripten_bind_DracoUInt16Array_GetValue_1 = Module["_emscripten_bind_DracoUInt16Array_GetValue_1"] = function () { return (_emscripten_bind_DracoUInt16Array_GetValue_1 = Module["_emscripten_bind_DracoUInt16Array_GetValue_1"] = Module["asm"]["ta"]).apply(null, arguments); };
        var _emscripten_bind_DracoUInt16Array_size_0 = Module["_emscripten_bind_DracoUInt16Array_size_0"] = function () { return (_emscripten_bind_DracoUInt16Array_size_0 = Module["_emscripten_bind_DracoUInt16Array_size_0"] = Module["asm"]["ua"]).apply(null, arguments); };
        var _emscripten_bind_DracoUInt16Array___destroy___0 = Module["_emscripten_bind_DracoUInt16Array___destroy___0"] = function () { return (_emscripten_bind_DracoUInt16Array___destroy___0 = Module["_emscripten_bind_DracoUInt16Array___destroy___0"] = Module["asm"]["va"]).apply(null, arguments); };
        var _emscripten_bind_DracoInt32Array_DracoInt32Array_0 = Module["_emscripten_bind_DracoInt32Array_DracoInt32Array_0"] = function () { return (_emscripten_bind_DracoInt32Array_DracoInt32Array_0 = Module["_emscripten_bind_DracoInt32Array_DracoInt32Array_0"] = Module["asm"]["wa"]).apply(null, arguments); };
        var _emscripten_bind_DracoInt32Array_GetValue_1 = Module["_emscripten_bind_DracoInt32Array_GetValue_1"] = function () { return (_emscripten_bind_DracoInt32Array_GetValue_1 = Module["_emscripten_bind_DracoInt32Array_GetValue_1"] = Module["asm"]["xa"]).apply(null, arguments); };
        var _emscripten_bind_DracoInt32Array_size_0 = Module["_emscripten_bind_DracoInt32Array_size_0"] = function () { return (_emscripten_bind_DracoInt32Array_size_0 = Module["_emscripten_bind_DracoInt32Array_size_0"] = Module["asm"]["ya"]).apply(null, arguments); };
        var _emscripten_bind_DracoInt32Array___destroy___0 = Module["_emscripten_bind_DracoInt32Array___destroy___0"] = function () { return (_emscripten_bind_DracoInt32Array___destroy___0 = Module["_emscripten_bind_DracoInt32Array___destroy___0"] = Module["asm"]["za"]).apply(null, arguments); };
        var _emscripten_bind_DracoUInt32Array_DracoUInt32Array_0 = Module["_emscripten_bind_DracoUInt32Array_DracoUInt32Array_0"] = function () { return (_emscripten_bind_DracoUInt32Array_DracoUInt32Array_0 = Module["_emscripten_bind_DracoUInt32Array_DracoUInt32Array_0"] = Module["asm"]["Aa"]).apply(null, arguments); };
        var _emscripten_bind_DracoUInt32Array_GetValue_1 = Module["_emscripten_bind_DracoUInt32Array_GetValue_1"] = function () { return (_emscripten_bind_DracoUInt32Array_GetValue_1 = Module["_emscripten_bind_DracoUInt32Array_GetValue_1"] = Module["asm"]["Ba"]).apply(null, arguments); };
        var _emscripten_bind_DracoUInt32Array_size_0 = Module["_emscripten_bind_DracoUInt32Array_size_0"] = function () { return (_emscripten_bind_DracoUInt32Array_size_0 = Module["_emscripten_bind_DracoUInt32Array_size_0"] = Module["asm"]["Ca"]).apply(null, arguments); };
        var _emscripten_bind_DracoUInt32Array___destroy___0 = Module["_emscripten_bind_DracoUInt32Array___destroy___0"] = function () { return (_emscripten_bind_DracoUInt32Array___destroy___0 = Module["_emscripten_bind_DracoUInt32Array___destroy___0"] = Module["asm"]["Da"]).apply(null, arguments); };
        var _emscripten_bind_MetadataQuerier_MetadataQuerier_0 = Module["_emscripten_bind_MetadataQuerier_MetadataQuerier_0"] = function () { return (_emscripten_bind_MetadataQuerier_MetadataQuerier_0 = Module["_emscripten_bind_MetadataQuerier_MetadataQuerier_0"] = Module["asm"]["Ea"]).apply(null, arguments); };
        var _emscripten_bind_MetadataQuerier_HasEntry_2 = Module["_emscripten_bind_MetadataQuerier_HasEntry_2"] = function () { return (_emscripten_bind_MetadataQuerier_HasEntry_2 = Module["_emscripten_bind_MetadataQuerier_HasEntry_2"] = Module["asm"]["Fa"]).apply(null, arguments); };
        var _emscripten_bind_MetadataQuerier_GetIntEntry_2 = Module["_emscripten_bind_MetadataQuerier_GetIntEntry_2"] = function () { return (_emscripten_bind_MetadataQuerier_GetIntEntry_2 = Module["_emscripten_bind_MetadataQuerier_GetIntEntry_2"] = Module["asm"]["Ga"]).apply(null, arguments); };
        var _emscripten_bind_MetadataQuerier_GetIntEntryArray_3 = Module["_emscripten_bind_MetadataQuerier_GetIntEntryArray_3"] = function () { return (_emscripten_bind_MetadataQuerier_GetIntEntryArray_3 = Module["_emscripten_bind_MetadataQuerier_GetIntEntryArray_3"] = Module["asm"]["Ha"]).apply(null, arguments); };
        var _emscripten_bind_MetadataQuerier_GetDoubleEntry_2 = Module["_emscripten_bind_MetadataQuerier_GetDoubleEntry_2"] = function () { return (_emscripten_bind_MetadataQuerier_GetDoubleEntry_2 = Module["_emscripten_bind_MetadataQuerier_GetDoubleEntry_2"] = Module["asm"]["Ia"]).apply(null, arguments); };
        var _emscripten_bind_MetadataQuerier_GetStringEntry_2 = Module["_emscripten_bind_MetadataQuerier_GetStringEntry_2"] = function () { return (_emscripten_bind_MetadataQuerier_GetStringEntry_2 = Module["_emscripten_bind_MetadataQuerier_GetStringEntry_2"] = Module["asm"]["Ja"]).apply(null, arguments); };
        var _emscripten_bind_MetadataQuerier_NumEntries_1 = Module["_emscripten_bind_MetadataQuerier_NumEntries_1"] = function () { return (_emscripten_bind_MetadataQuerier_NumEntries_1 = Module["_emscripten_bind_MetadataQuerier_NumEntries_1"] = Module["asm"]["Ka"]).apply(null, arguments); };
        var _emscripten_bind_MetadataQuerier_GetEntryName_2 = Module["_emscripten_bind_MetadataQuerier_GetEntryName_2"] = function () { return (_emscripten_bind_MetadataQuerier_GetEntryName_2 = Module["_emscripten_bind_MetadataQuerier_GetEntryName_2"] = Module["asm"]["La"]).apply(null, arguments); };
        var _emscripten_bind_MetadataQuerier___destroy___0 = Module["_emscripten_bind_MetadataQuerier___destroy___0"] = function () { return (_emscripten_bind_MetadataQuerier___destroy___0 = Module["_emscripten_bind_MetadataQuerier___destroy___0"] = Module["asm"]["Ma"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_Decoder_0 = Module["_emscripten_bind_Decoder_Decoder_0"] = function () { return (_emscripten_bind_Decoder_Decoder_0 = Module["_emscripten_bind_Decoder_Decoder_0"] = Module["asm"]["Na"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_DecodeArrayToPointCloud_3 = Module["_emscripten_bind_Decoder_DecodeArrayToPointCloud_3"] = function () { return (_emscripten_bind_Decoder_DecodeArrayToPointCloud_3 = Module["_emscripten_bind_Decoder_DecodeArrayToPointCloud_3"] = Module["asm"]["Oa"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_DecodeArrayToMesh_3 = Module["_emscripten_bind_Decoder_DecodeArrayToMesh_3"] = function () { return (_emscripten_bind_Decoder_DecodeArrayToMesh_3 = Module["_emscripten_bind_Decoder_DecodeArrayToMesh_3"] = Module["asm"]["Pa"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetAttributeId_2 = Module["_emscripten_bind_Decoder_GetAttributeId_2"] = function () { return (_emscripten_bind_Decoder_GetAttributeId_2 = Module["_emscripten_bind_Decoder_GetAttributeId_2"] = Module["asm"]["Qa"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetAttributeIdByName_2 = Module["_emscripten_bind_Decoder_GetAttributeIdByName_2"] = function () { return (_emscripten_bind_Decoder_GetAttributeIdByName_2 = Module["_emscripten_bind_Decoder_GetAttributeIdByName_2"] = Module["asm"]["Ra"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetAttributeIdByMetadataEntry_3 = Module["_emscripten_bind_Decoder_GetAttributeIdByMetadataEntry_3"] = function () { return (_emscripten_bind_Decoder_GetAttributeIdByMetadataEntry_3 = Module["_emscripten_bind_Decoder_GetAttributeIdByMetadataEntry_3"] = Module["asm"]["Sa"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetAttribute_2 = Module["_emscripten_bind_Decoder_GetAttribute_2"] = function () { return (_emscripten_bind_Decoder_GetAttribute_2 = Module["_emscripten_bind_Decoder_GetAttribute_2"] = Module["asm"]["Ta"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetAttributeByUniqueId_2 = Module["_emscripten_bind_Decoder_GetAttributeByUniqueId_2"] = function () { return (_emscripten_bind_Decoder_GetAttributeByUniqueId_2 = Module["_emscripten_bind_Decoder_GetAttributeByUniqueId_2"] = Module["asm"]["Ua"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetMetadata_1 = Module["_emscripten_bind_Decoder_GetMetadata_1"] = function () { return (_emscripten_bind_Decoder_GetMetadata_1 = Module["_emscripten_bind_Decoder_GetMetadata_1"] = Module["asm"]["Va"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetAttributeMetadata_2 = Module["_emscripten_bind_Decoder_GetAttributeMetadata_2"] = function () { return (_emscripten_bind_Decoder_GetAttributeMetadata_2 = Module["_emscripten_bind_Decoder_GetAttributeMetadata_2"] = Module["asm"]["Wa"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetFaceFromMesh_3 = Module["_emscripten_bind_Decoder_GetFaceFromMesh_3"] = function () { return (_emscripten_bind_Decoder_GetFaceFromMesh_3 = Module["_emscripten_bind_Decoder_GetFaceFromMesh_3"] = Module["asm"]["Xa"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetTriangleStripsFromMesh_2 = Module["_emscripten_bind_Decoder_GetTriangleStripsFromMesh_2"] = function () { return (_emscripten_bind_Decoder_GetTriangleStripsFromMesh_2 = Module["_emscripten_bind_Decoder_GetTriangleStripsFromMesh_2"] = Module["asm"]["Ya"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetTrianglesUInt16Array_3 = Module["_emscripten_bind_Decoder_GetTrianglesUInt16Array_3"] = function () { return (_emscripten_bind_Decoder_GetTrianglesUInt16Array_3 = Module["_emscripten_bind_Decoder_GetTrianglesUInt16Array_3"] = Module["asm"]["Za"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetTrianglesUInt32Array_3 = Module["_emscripten_bind_Decoder_GetTrianglesUInt32Array_3"] = function () { return (_emscripten_bind_Decoder_GetTrianglesUInt32Array_3 = Module["_emscripten_bind_Decoder_GetTrianglesUInt32Array_3"] = Module["asm"]["_a"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetAttributeFloat_3 = Module["_emscripten_bind_Decoder_GetAttributeFloat_3"] = function () { return (_emscripten_bind_Decoder_GetAttributeFloat_3 = Module["_emscripten_bind_Decoder_GetAttributeFloat_3"] = Module["asm"]["$a"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetAttributeFloatForAllPoints_3 = Module["_emscripten_bind_Decoder_GetAttributeFloatForAllPoints_3"] = function () { return (_emscripten_bind_Decoder_GetAttributeFloatForAllPoints_3 = Module["_emscripten_bind_Decoder_GetAttributeFloatForAllPoints_3"] = Module["asm"]["ab"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetAttributeIntForAllPoints_3 = Module["_emscripten_bind_Decoder_GetAttributeIntForAllPoints_3"] = function () { return (_emscripten_bind_Decoder_GetAttributeIntForAllPoints_3 = Module["_emscripten_bind_Decoder_GetAttributeIntForAllPoints_3"] = Module["asm"]["bb"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetAttributeInt8ForAllPoints_3 = Module["_emscripten_bind_Decoder_GetAttributeInt8ForAllPoints_3"] = function () { return (_emscripten_bind_Decoder_GetAttributeInt8ForAllPoints_3 = Module["_emscripten_bind_Decoder_GetAttributeInt8ForAllPoints_3"] = Module["asm"]["cb"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetAttributeUInt8ForAllPoints_3 = Module["_emscripten_bind_Decoder_GetAttributeUInt8ForAllPoints_3"] = function () { return (_emscripten_bind_Decoder_GetAttributeUInt8ForAllPoints_3 = Module["_emscripten_bind_Decoder_GetAttributeUInt8ForAllPoints_3"] = Module["asm"]["db"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetAttributeInt16ForAllPoints_3 = Module["_emscripten_bind_Decoder_GetAttributeInt16ForAllPoints_3"] = function () { return (_emscripten_bind_Decoder_GetAttributeInt16ForAllPoints_3 = Module["_emscripten_bind_Decoder_GetAttributeInt16ForAllPoints_3"] = Module["asm"]["eb"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetAttributeUInt16ForAllPoints_3 = Module["_emscripten_bind_Decoder_GetAttributeUInt16ForAllPoints_3"] = function () { return (_emscripten_bind_Decoder_GetAttributeUInt16ForAllPoints_3 = Module["_emscripten_bind_Decoder_GetAttributeUInt16ForAllPoints_3"] = Module["asm"]["fb"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetAttributeInt32ForAllPoints_3 = Module["_emscripten_bind_Decoder_GetAttributeInt32ForAllPoints_3"] = function () { return (_emscripten_bind_Decoder_GetAttributeInt32ForAllPoints_3 = Module["_emscripten_bind_Decoder_GetAttributeInt32ForAllPoints_3"] = Module["asm"]["gb"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetAttributeUInt32ForAllPoints_3 = Module["_emscripten_bind_Decoder_GetAttributeUInt32ForAllPoints_3"] = function () { return (_emscripten_bind_Decoder_GetAttributeUInt32ForAllPoints_3 = Module["_emscripten_bind_Decoder_GetAttributeUInt32ForAllPoints_3"] = Module["asm"]["hb"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetAttributeDataArrayForAllPoints_5 = Module["_emscripten_bind_Decoder_GetAttributeDataArrayForAllPoints_5"] = function () { return (_emscripten_bind_Decoder_GetAttributeDataArrayForAllPoints_5 = Module["_emscripten_bind_Decoder_GetAttributeDataArrayForAllPoints_5"] = Module["asm"]["ib"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_SkipAttributeTransform_1 = Module["_emscripten_bind_Decoder_SkipAttributeTransform_1"] = function () { return (_emscripten_bind_Decoder_SkipAttributeTransform_1 = Module["_emscripten_bind_Decoder_SkipAttributeTransform_1"] = Module["asm"]["jb"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_GetEncodedGeometryType_Deprecated_1 = Module["_emscripten_bind_Decoder_GetEncodedGeometryType_Deprecated_1"] = function () { return (_emscripten_bind_Decoder_GetEncodedGeometryType_Deprecated_1 = Module["_emscripten_bind_Decoder_GetEncodedGeometryType_Deprecated_1"] = Module["asm"]["kb"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_DecodeBufferToPointCloud_2 = Module["_emscripten_bind_Decoder_DecodeBufferToPointCloud_2"] = function () { return (_emscripten_bind_Decoder_DecodeBufferToPointCloud_2 = Module["_emscripten_bind_Decoder_DecodeBufferToPointCloud_2"] = Module["asm"]["lb"]).apply(null, arguments); };
        var _emscripten_bind_Decoder_DecodeBufferToMesh_2 = Module["_emscripten_bind_Decoder_DecodeBufferToMesh_2"] = function () { return (_emscripten_bind_Decoder_DecodeBufferToMesh_2 = Module["_emscripten_bind_Decoder_DecodeBufferToMesh_2"] = Module["asm"]["mb"]).apply(null, arguments); };
        var _emscripten_bind_Decoder___destroy___0 = Module["_emscripten_bind_Decoder___destroy___0"] = function () { return (_emscripten_bind_Decoder___destroy___0 = Module["_emscripten_bind_Decoder___destroy___0"] = Module["asm"]["nb"]).apply(null, arguments); };
        var _emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_INVALID_TRANSFORM = Module["_emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_INVALID_TRANSFORM"] = function () { return (_emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_INVALID_TRANSFORM = Module["_emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_INVALID_TRANSFORM"] = Module["asm"]["ob"]).apply(null, arguments); };
        var _emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_NO_TRANSFORM = Module["_emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_NO_TRANSFORM"] = function () { return (_emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_NO_TRANSFORM = Module["_emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_NO_TRANSFORM"] = Module["asm"]["pb"]).apply(null, arguments); };
        var _emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_QUANTIZATION_TRANSFORM = Module["_emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_QUANTIZATION_TRANSFORM"] = function () { return (_emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_QUANTIZATION_TRANSFORM = Module["_emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_QUANTIZATION_TRANSFORM"] = Module["asm"]["qb"]).apply(null, arguments); };
        var _emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_OCTAHEDRON_TRANSFORM = Module["_emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_OCTAHEDRON_TRANSFORM"] = function () { return (_emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_OCTAHEDRON_TRANSFORM = Module["_emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_OCTAHEDRON_TRANSFORM"] = Module["asm"]["rb"]).apply(null, arguments); };
        var _emscripten_enum_draco_GeometryAttribute_Type_INVALID = Module["_emscripten_enum_draco_GeometryAttribute_Type_INVALID"] = function () { return (_emscripten_enum_draco_GeometryAttribute_Type_INVALID = Module["_emscripten_enum_draco_GeometryAttribute_Type_INVALID"] = Module["asm"]["sb"]).apply(null, arguments); };
        var _emscripten_enum_draco_GeometryAttribute_Type_POSITION = Module["_emscripten_enum_draco_GeometryAttribute_Type_POSITION"] = function () { return (_emscripten_enum_draco_GeometryAttribute_Type_POSITION = Module["_emscripten_enum_draco_GeometryAttribute_Type_POSITION"] = Module["asm"]["tb"]).apply(null, arguments); };
        var _emscripten_enum_draco_GeometryAttribute_Type_NORMAL = Module["_emscripten_enum_draco_GeometryAttribute_Type_NORMAL"] = function () { return (_emscripten_enum_draco_GeometryAttribute_Type_NORMAL = Module["_emscripten_enum_draco_GeometryAttribute_Type_NORMAL"] = Module["asm"]["ub"]).apply(null, arguments); };
        var _emscripten_enum_draco_GeometryAttribute_Type_COLOR = Module["_emscripten_enum_draco_GeometryAttribute_Type_COLOR"] = function () { return (_emscripten_enum_draco_GeometryAttribute_Type_COLOR = Module["_emscripten_enum_draco_GeometryAttribute_Type_COLOR"] = Module["asm"]["vb"]).apply(null, arguments); };
        var _emscripten_enum_draco_GeometryAttribute_Type_TEX_COORD = Module["_emscripten_enum_draco_GeometryAttribute_Type_TEX_COORD"] = function () { return (_emscripten_enum_draco_GeometryAttribute_Type_TEX_COORD = Module["_emscripten_enum_draco_GeometryAttribute_Type_TEX_COORD"] = Module["asm"]["wb"]).apply(null, arguments); };
        var _emscripten_enum_draco_GeometryAttribute_Type_GENERIC = Module["_emscripten_enum_draco_GeometryAttribute_Type_GENERIC"] = function () { return (_emscripten_enum_draco_GeometryAttribute_Type_GENERIC = Module["_emscripten_enum_draco_GeometryAttribute_Type_GENERIC"] = Module["asm"]["xb"]).apply(null, arguments); };
        var _emscripten_enum_draco_EncodedGeometryType_INVALID_GEOMETRY_TYPE = Module["_emscripten_enum_draco_EncodedGeometryType_INVALID_GEOMETRY_TYPE"] = function () { return (_emscripten_enum_draco_EncodedGeometryType_INVALID_GEOMETRY_TYPE = Module["_emscripten_enum_draco_EncodedGeometryType_INVALID_GEOMETRY_TYPE"] = Module["asm"]["yb"]).apply(null, arguments); };
        var _emscripten_enum_draco_EncodedGeometryType_POINT_CLOUD = Module["_emscripten_enum_draco_EncodedGeometryType_POINT_CLOUD"] = function () { return (_emscripten_enum_draco_EncodedGeometryType_POINT_CLOUD = Module["_emscripten_enum_draco_EncodedGeometryType_POINT_CLOUD"] = Module["asm"]["zb"]).apply(null, arguments); };
        var _emscripten_enum_draco_EncodedGeometryType_TRIANGULAR_MESH = Module["_emscripten_enum_draco_EncodedGeometryType_TRIANGULAR_MESH"] = function () { return (_emscripten_enum_draco_EncodedGeometryType_TRIANGULAR_MESH = Module["_emscripten_enum_draco_EncodedGeometryType_TRIANGULAR_MESH"] = Module["asm"]["Ab"]).apply(null, arguments); };
        var _emscripten_enum_draco_DataType_DT_INVALID = Module["_emscripten_enum_draco_DataType_DT_INVALID"] = function () { return (_emscripten_enum_draco_DataType_DT_INVALID = Module["_emscripten_enum_draco_DataType_DT_INVALID"] = Module["asm"]["Bb"]).apply(null, arguments); };
        var _emscripten_enum_draco_DataType_DT_INT8 = Module["_emscripten_enum_draco_DataType_DT_INT8"] = function () { return (_emscripten_enum_draco_DataType_DT_INT8 = Module["_emscripten_enum_draco_DataType_DT_INT8"] = Module["asm"]["Cb"]).apply(null, arguments); };
        var _emscripten_enum_draco_DataType_DT_UINT8 = Module["_emscripten_enum_draco_DataType_DT_UINT8"] = function () { return (_emscripten_enum_draco_DataType_DT_UINT8 = Module["_emscripten_enum_draco_DataType_DT_UINT8"] = Module["asm"]["Db"]).apply(null, arguments); };
        var _emscripten_enum_draco_DataType_DT_INT16 = Module["_emscripten_enum_draco_DataType_DT_INT16"] = function () { return (_emscripten_enum_draco_DataType_DT_INT16 = Module["_emscripten_enum_draco_DataType_DT_INT16"] = Module["asm"]["Eb"]).apply(null, arguments); };
        var _emscripten_enum_draco_DataType_DT_UINT16 = Module["_emscripten_enum_draco_DataType_DT_UINT16"] = function () { return (_emscripten_enum_draco_DataType_DT_UINT16 = Module["_emscripten_enum_draco_DataType_DT_UINT16"] = Module["asm"]["Fb"]).apply(null, arguments); };
        var _emscripten_enum_draco_DataType_DT_INT32 = Module["_emscripten_enum_draco_DataType_DT_INT32"] = function () { return (_emscripten_enum_draco_DataType_DT_INT32 = Module["_emscripten_enum_draco_DataType_DT_INT32"] = Module["asm"]["Gb"]).apply(null, arguments); };
        var _emscripten_enum_draco_DataType_DT_UINT32 = Module["_emscripten_enum_draco_DataType_DT_UINT32"] = function () { return (_emscripten_enum_draco_DataType_DT_UINT32 = Module["_emscripten_enum_draco_DataType_DT_UINT32"] = Module["asm"]["Hb"]).apply(null, arguments); };
        var _emscripten_enum_draco_DataType_DT_INT64 = Module["_emscripten_enum_draco_DataType_DT_INT64"] = function () { return (_emscripten_enum_draco_DataType_DT_INT64 = Module["_emscripten_enum_draco_DataType_DT_INT64"] = Module["asm"]["Ib"]).apply(null, arguments); };
        var _emscripten_enum_draco_DataType_DT_UINT64 = Module["_emscripten_enum_draco_DataType_DT_UINT64"] = function () { return (_emscripten_enum_draco_DataType_DT_UINT64 = Module["_emscripten_enum_draco_DataType_DT_UINT64"] = Module["asm"]["Jb"]).apply(null, arguments); };
        var _emscripten_enum_draco_DataType_DT_FLOAT32 = Module["_emscripten_enum_draco_DataType_DT_FLOAT32"] = function () { return (_emscripten_enum_draco_DataType_DT_FLOAT32 = Module["_emscripten_enum_draco_DataType_DT_FLOAT32"] = Module["asm"]["Kb"]).apply(null, arguments); };
        var _emscripten_enum_draco_DataType_DT_FLOAT64 = Module["_emscripten_enum_draco_DataType_DT_FLOAT64"] = function () { return (_emscripten_enum_draco_DataType_DT_FLOAT64 = Module["_emscripten_enum_draco_DataType_DT_FLOAT64"] = Module["asm"]["Lb"]).apply(null, arguments); };
        var _emscripten_enum_draco_DataType_DT_BOOL = Module["_emscripten_enum_draco_DataType_DT_BOOL"] = function () { return (_emscripten_enum_draco_DataType_DT_BOOL = Module["_emscripten_enum_draco_DataType_DT_BOOL"] = Module["asm"]["Mb"]).apply(null, arguments); };
        var _emscripten_enum_draco_DataType_DT_TYPES_COUNT = Module["_emscripten_enum_draco_DataType_DT_TYPES_COUNT"] = function () { return (_emscripten_enum_draco_DataType_DT_TYPES_COUNT = Module["_emscripten_enum_draco_DataType_DT_TYPES_COUNT"] = Module["asm"]["Nb"]).apply(null, arguments); };
        var _emscripten_enum_draco_StatusCode_OK = Module["_emscripten_enum_draco_StatusCode_OK"] = function () { return (_emscripten_enum_draco_StatusCode_OK = Module["_emscripten_enum_draco_StatusCode_OK"] = Module["asm"]["Ob"]).apply(null, arguments); };
        var _emscripten_enum_draco_StatusCode_DRACO_ERROR = Module["_emscripten_enum_draco_StatusCode_DRACO_ERROR"] = function () { return (_emscripten_enum_draco_StatusCode_DRACO_ERROR = Module["_emscripten_enum_draco_StatusCode_DRACO_ERROR"] = Module["asm"]["Pb"]).apply(null, arguments); };
        var _emscripten_enum_draco_StatusCode_IO_ERROR = Module["_emscripten_enum_draco_StatusCode_IO_ERROR"] = function () { return (_emscripten_enum_draco_StatusCode_IO_ERROR = Module["_emscripten_enum_draco_StatusCode_IO_ERROR"] = Module["asm"]["Qb"]).apply(null, arguments); };
        var _emscripten_enum_draco_StatusCode_INVALID_PARAMETER = Module["_emscripten_enum_draco_StatusCode_INVALID_PARAMETER"] = function () { return (_emscripten_enum_draco_StatusCode_INVALID_PARAMETER = Module["_emscripten_enum_draco_StatusCode_INVALID_PARAMETER"] = Module["asm"]["Rb"]).apply(null, arguments); };
        var _emscripten_enum_draco_StatusCode_UNSUPPORTED_VERSION = Module["_emscripten_enum_draco_StatusCode_UNSUPPORTED_VERSION"] = function () { return (_emscripten_enum_draco_StatusCode_UNSUPPORTED_VERSION = Module["_emscripten_enum_draco_StatusCode_UNSUPPORTED_VERSION"] = Module["asm"]["Sb"]).apply(null, arguments); };
        var _emscripten_enum_draco_StatusCode_UNKNOWN_VERSION = Module["_emscripten_enum_draco_StatusCode_UNKNOWN_VERSION"] = function () { return (_emscripten_enum_draco_StatusCode_UNKNOWN_VERSION = Module["_emscripten_enum_draco_StatusCode_UNKNOWN_VERSION"] = Module["asm"]["Tb"]).apply(null, arguments); };
        var _malloc = Module["_malloc"] = function () { return (_malloc = Module["_malloc"] = Module["asm"]["Ub"]).apply(null, arguments); };
        var _free = Module["_free"] = function () { return (_free = Module["_free"] = Module["asm"]["Vb"]).apply(null, arguments); };
        var calledRun;
        function ExitStatus(status) { this.name = "ExitStatus"; this.message = "Program terminated with exit(" + status + ")"; this.status = status; }
        dependenciesFulfilled = function runCaller() { if (!calledRun)
            run(); if (!calledRun)
            dependenciesFulfilled = runCaller; };
        function run(args) { args = args || arguments_; if (runDependencies > 0) {
            return;
        } preRun(); if (runDependencies > 0) {
            return;
        } function doRun() { if (calledRun)
            return; calledRun = true; Module["calledRun"] = true; if (ABORT)
            return; initRuntime(); readyPromiseResolve(Module); if (Module["onRuntimeInitialized"])
            Module["onRuntimeInitialized"](); postRun(); } if (Module["setStatus"]) {
            Module["setStatus"]("Running...");
            setTimeout(function () { setTimeout(function () { Module["setStatus"](""); }, 1); doRun(); }, 1);
        }
        else {
            doRun();
        } }
        Module["run"] = run;
        if (Module["preInit"]) {
            if (typeof Module["preInit"] == "function")
                Module["preInit"] = [Module["preInit"]];
            while (Module["preInit"].length > 0) {
                Module["preInit"].pop()();
            }
        }
        run();
        function WrapperObject() { }
        WrapperObject.prototype = Object.create(WrapperObject.prototype);
        WrapperObject.prototype.constructor = WrapperObject;
        WrapperObject.prototype.__class__ = WrapperObject;
        WrapperObject.__cache__ = {};
        Module["WrapperObject"] = WrapperObject;
        function getCache(__class__) { return (__class__ || WrapperObject).__cache__; }
        Module["getCache"] = getCache;
        function wrapPointer(ptr, __class__) { var cache = getCache(__class__); var ret = cache[ptr]; if (ret)
            return ret; ret = Object.create((__class__ || WrapperObject).prototype); ret.ptr = ptr; return cache[ptr] = ret; }
        Module["wrapPointer"] = wrapPointer;
        function castObject(obj, __class__) { return wrapPointer(obj.ptr, __class__); }
        Module["castObject"] = castObject;
        Module["NULL"] = wrapPointer(0);
        function destroy(obj) { if (!obj["__destroy__"])
            throw "Error: Cannot destroy object. (Did you create it yourself?)"; obj["__destroy__"](); delete getCache(obj.__class__)[obj.ptr]; }
        Module["destroy"] = destroy;
        function compare(obj1, obj2) { return obj1.ptr === obj2.ptr; }
        Module["compare"] = compare;
        function getPointer(obj) { return obj.ptr; }
        Module["getPointer"] = getPointer;
        function getClass(obj) { return obj.__class__; }
        Module["getClass"] = getClass;
        var ensureCache = { buffer: 0, size: 0, pos: 0, temps: [], needed: 0, prepare: function () { if (ensureCache.needed) {
                for (var i = 0; i < ensureCache.temps.length; i++) {
                    Module["_free"](ensureCache.temps[i]);
                }
                ensureCache.temps.length = 0;
                Module["_free"](ensureCache.buffer);
                ensureCache.buffer = 0;
                ensureCache.size += ensureCache.needed;
                ensureCache.needed = 0;
            } if (!ensureCache.buffer) {
                ensureCache.size += 128;
                ensureCache.buffer = Module["_malloc"](ensureCache.size);
                assert(ensureCache.buffer);
            } ensureCache.pos = 0; }, alloc: function (array, view) { assert(ensureCache.buffer); var bytes = view.BYTES_PER_ELEMENT; var len = array.length * bytes; len = len + 7 & -8; var ret; if (ensureCache.pos + len >= ensureCache.size) {
                assert(len > 0);
                ensureCache.needed += len;
                ret = Module["_malloc"](len);
                ensureCache.temps.push(ret);
            }
            else {
                ret = ensureCache.buffer + ensureCache.pos;
                ensureCache.pos += len;
            } return ret; }, copy: function (array, view, offset) { offset >>>= 0; var bytes = view.BYTES_PER_ELEMENT; switch (bytes) {
                case 2:
                    offset >>>= 1;
                    break;
                case 4:
                    offset >>>= 2;
                    break;
                case 8:
                    offset >>>= 3;
                    break;
            } for (var i = 0; i < array.length; i++) {
                view[offset + i] = array[i];
            } } };
        function ensureString(value) { if (typeof value === "string") {
            var intArray = intArrayFromString(value);
            var offset = ensureCache.alloc(intArray, HEAP8);
            ensureCache.copy(intArray, HEAP8, offset);
            return offset;
        } return value; }
        function ensureInt8(value) { if (typeof value === "object") {
            var offset = ensureCache.alloc(value, HEAP8);
            ensureCache.copy(value, HEAP8, offset);
            return offset;
        } return value; }
        function VoidPtr() { throw "cannot construct a VoidPtr, no constructor in IDL"; }
        VoidPtr.prototype = Object.create(WrapperObject.prototype);
        VoidPtr.prototype.constructor = VoidPtr;
        VoidPtr.prototype.__class__ = VoidPtr;
        VoidPtr.__cache__ = {};
        Module["VoidPtr"] = VoidPtr;
        VoidPtr.prototype["__destroy__"] = VoidPtr.prototype.__destroy__ = function () { var self = this.ptr; _emscripten_bind_VoidPtr___destroy___0(self); };
        function DecoderBuffer() { this.ptr = _emscripten_bind_DecoderBuffer_DecoderBuffer_0(); getCache(DecoderBuffer)[this.ptr] = this; }
        DecoderBuffer.prototype = Object.create(WrapperObject.prototype);
        DecoderBuffer.prototype.constructor = DecoderBuffer;
        DecoderBuffer.prototype.__class__ = DecoderBuffer;
        DecoderBuffer.__cache__ = {};
        Module["DecoderBuffer"] = DecoderBuffer;
        DecoderBuffer.prototype["Init"] = DecoderBuffer.prototype.Init = function (data, data_size) { var self = this.ptr; ensureCache.prepare(); if (typeof data == "object") {
            data = ensureInt8(data);
        } if (data_size && typeof data_size === "object")
            data_size = data_size.ptr; _emscripten_bind_DecoderBuffer_Init_2(self, data, data_size); };
        DecoderBuffer.prototype["__destroy__"] = DecoderBuffer.prototype.__destroy__ = function () { var self = this.ptr; _emscripten_bind_DecoderBuffer___destroy___0(self); };
        function AttributeTransformData() { this.ptr = _emscripten_bind_AttributeTransformData_AttributeTransformData_0(); getCache(AttributeTransformData)[this.ptr] = this; }
        AttributeTransformData.prototype = Object.create(WrapperObject.prototype);
        AttributeTransformData.prototype.constructor = AttributeTransformData;
        AttributeTransformData.prototype.__class__ = AttributeTransformData;
        AttributeTransformData.__cache__ = {};
        Module["AttributeTransformData"] = AttributeTransformData;
        AttributeTransformData.prototype["transform_type"] = AttributeTransformData.prototype.transform_type = function () { var self = this.ptr; return _emscripten_bind_AttributeTransformData_transform_type_0(self); };
        AttributeTransformData.prototype["__destroy__"] = AttributeTransformData.prototype.__destroy__ = function () { var self = this.ptr; _emscripten_bind_AttributeTransformData___destroy___0(self); };
        function GeometryAttribute() { this.ptr = _emscripten_bind_GeometryAttribute_GeometryAttribute_0(); getCache(GeometryAttribute)[this.ptr] = this; }
        GeometryAttribute.prototype = Object.create(WrapperObject.prototype);
        GeometryAttribute.prototype.constructor = GeometryAttribute;
        GeometryAttribute.prototype.__class__ = GeometryAttribute;
        GeometryAttribute.__cache__ = {};
        Module["GeometryAttribute"] = GeometryAttribute;
        GeometryAttribute.prototype["__destroy__"] = GeometryAttribute.prototype.__destroy__ = function () { var self = this.ptr; _emscripten_bind_GeometryAttribute___destroy___0(self); };
        function PointAttribute() { this.ptr = _emscripten_bind_PointAttribute_PointAttribute_0(); getCache(PointAttribute)[this.ptr] = this; }
        PointAttribute.prototype = Object.create(WrapperObject.prototype);
        PointAttribute.prototype.constructor = PointAttribute;
        PointAttribute.prototype.__class__ = PointAttribute;
        PointAttribute.__cache__ = {};
        Module["PointAttribute"] = PointAttribute;
        PointAttribute.prototype["size"] = PointAttribute.prototype.size = function () { var self = this.ptr; return _emscripten_bind_PointAttribute_size_0(self); };
        PointAttribute.prototype["GetAttributeTransformData"] = PointAttribute.prototype.GetAttributeTransformData = function () { var self = this.ptr; return wrapPointer(_emscripten_bind_PointAttribute_GetAttributeTransformData_0(self), AttributeTransformData); };
        PointAttribute.prototype["attribute_type"] = PointAttribute.prototype.attribute_type = function () { var self = this.ptr; return _emscripten_bind_PointAttribute_attribute_type_0(self); };
        PointAttribute.prototype["data_type"] = PointAttribute.prototype.data_type = function () { var self = this.ptr; return _emscripten_bind_PointAttribute_data_type_0(self); };
        PointAttribute.prototype["num_components"] = PointAttribute.prototype.num_components = function () { var self = this.ptr; return _emscripten_bind_PointAttribute_num_components_0(self); };
        PointAttribute.prototype["normalized"] = PointAttribute.prototype.normalized = function () { var self = this.ptr; return !!_emscripten_bind_PointAttribute_normalized_0(self); };
        PointAttribute.prototype["byte_stride"] = PointAttribute.prototype.byte_stride = function () { var self = this.ptr; return _emscripten_bind_PointAttribute_byte_stride_0(self); };
        PointAttribute.prototype["byte_offset"] = PointAttribute.prototype.byte_offset = function () { var self = this.ptr; return _emscripten_bind_PointAttribute_byte_offset_0(self); };
        PointAttribute.prototype["unique_id"] = PointAttribute.prototype.unique_id = function () { var self = this.ptr; return _emscripten_bind_PointAttribute_unique_id_0(self); };
        PointAttribute.prototype["__destroy__"] = PointAttribute.prototype.__destroy__ = function () { var self = this.ptr; _emscripten_bind_PointAttribute___destroy___0(self); };
        function AttributeQuantizationTransform() { this.ptr = _emscripten_bind_AttributeQuantizationTransform_AttributeQuantizationTransform_0(); getCache(AttributeQuantizationTransform)[this.ptr] = this; }
        AttributeQuantizationTransform.prototype = Object.create(WrapperObject.prototype);
        AttributeQuantizationTransform.prototype.constructor = AttributeQuantizationTransform;
        AttributeQuantizationTransform.prototype.__class__ = AttributeQuantizationTransform;
        AttributeQuantizationTransform.__cache__ = {};
        Module["AttributeQuantizationTransform"] = AttributeQuantizationTransform;
        AttributeQuantizationTransform.prototype["InitFromAttribute"] = AttributeQuantizationTransform.prototype.InitFromAttribute = function (att) { var self = this.ptr; if (att && typeof att === "object")
            att = att.ptr; return !!_emscripten_bind_AttributeQuantizationTransform_InitFromAttribute_1(self, att); };
        AttributeQuantizationTransform.prototype["quantization_bits"] = AttributeQuantizationTransform.prototype.quantization_bits = function () { var self = this.ptr; return _emscripten_bind_AttributeQuantizationTransform_quantization_bits_0(self); };
        AttributeQuantizationTransform.prototype["min_value"] = AttributeQuantizationTransform.prototype.min_value = function (axis) { var self = this.ptr; if (axis && typeof axis === "object")
            axis = axis.ptr; return _emscripten_bind_AttributeQuantizationTransform_min_value_1(self, axis); };
        AttributeQuantizationTransform.prototype["range"] = AttributeQuantizationTransform.prototype.range = function () { var self = this.ptr; return _emscripten_bind_AttributeQuantizationTransform_range_0(self); };
        AttributeQuantizationTransform.prototype["__destroy__"] = AttributeQuantizationTransform.prototype.__destroy__ = function () { var self = this.ptr; _emscripten_bind_AttributeQuantizationTransform___destroy___0(self); };
        function AttributeOctahedronTransform() { this.ptr = _emscripten_bind_AttributeOctahedronTransform_AttributeOctahedronTransform_0(); getCache(AttributeOctahedronTransform)[this.ptr] = this; }
        AttributeOctahedronTransform.prototype = Object.create(WrapperObject.prototype);
        AttributeOctahedronTransform.prototype.constructor = AttributeOctahedronTransform;
        AttributeOctahedronTransform.prototype.__class__ = AttributeOctahedronTransform;
        AttributeOctahedronTransform.__cache__ = {};
        Module["AttributeOctahedronTransform"] = AttributeOctahedronTransform;
        AttributeOctahedronTransform.prototype["InitFromAttribute"] = AttributeOctahedronTransform.prototype.InitFromAttribute = function (att) { var self = this.ptr; if (att && typeof att === "object")
            att = att.ptr; return !!_emscripten_bind_AttributeOctahedronTransform_InitFromAttribute_1(self, att); };
        AttributeOctahedronTransform.prototype["quantization_bits"] = AttributeOctahedronTransform.prototype.quantization_bits = function () { var self = this.ptr; return _emscripten_bind_AttributeOctahedronTransform_quantization_bits_0(self); };
        AttributeOctahedronTransform.prototype["__destroy__"] = AttributeOctahedronTransform.prototype.__destroy__ = function () { var self = this.ptr; _emscripten_bind_AttributeOctahedronTransform___destroy___0(self); };
        function PointCloud() { this.ptr = _emscripten_bind_PointCloud_PointCloud_0(); getCache(PointCloud)[this.ptr] = this; }
        PointCloud.prototype = Object.create(WrapperObject.prototype);
        PointCloud.prototype.constructor = PointCloud;
        PointCloud.prototype.__class__ = PointCloud;
        PointCloud.__cache__ = {};
        Module["PointCloud"] = PointCloud;
        PointCloud.prototype["num_attributes"] = PointCloud.prototype.num_attributes = function () { var self = this.ptr; return _emscripten_bind_PointCloud_num_attributes_0(self); };
        PointCloud.prototype["num_points"] = PointCloud.prototype.num_points = function () { var self = this.ptr; return _emscripten_bind_PointCloud_num_points_0(self); };
        PointCloud.prototype["__destroy__"] = PointCloud.prototype.__destroy__ = function () { var self = this.ptr; _emscripten_bind_PointCloud___destroy___0(self); };
        function Mesh() { this.ptr = _emscripten_bind_Mesh_Mesh_0(); getCache(Mesh)[this.ptr] = this; }
        Mesh.prototype = Object.create(WrapperObject.prototype);
        Mesh.prototype.constructor = Mesh;
        Mesh.prototype.__class__ = Mesh;
        Mesh.__cache__ = {};
        Module["Mesh"] = Mesh;
        Mesh.prototype["num_faces"] = Mesh.prototype.num_faces = function () { var self = this.ptr; return _emscripten_bind_Mesh_num_faces_0(self); };
        Mesh.prototype["num_attributes"] = Mesh.prototype.num_attributes = function () { var self = this.ptr; return _emscripten_bind_Mesh_num_attributes_0(self); };
        Mesh.prototype["num_points"] = Mesh.prototype.num_points = function () { var self = this.ptr; return _emscripten_bind_Mesh_num_points_0(self); };
        Mesh.prototype["__destroy__"] = Mesh.prototype.__destroy__ = function () { var self = this.ptr; _emscripten_bind_Mesh___destroy___0(self); };
        function Metadata() { this.ptr = _emscripten_bind_Metadata_Metadata_0(); getCache(Metadata)[this.ptr] = this; }
        Metadata.prototype = Object.create(WrapperObject.prototype);
        Metadata.prototype.constructor = Metadata;
        Metadata.prototype.__class__ = Metadata;
        Metadata.__cache__ = {};
        Module["Metadata"] = Metadata;
        Metadata.prototype["__destroy__"] = Metadata.prototype.__destroy__ = function () { var self = this.ptr; _emscripten_bind_Metadata___destroy___0(self); };
        function Status() { throw "cannot construct a Status, no constructor in IDL"; }
        Status.prototype = Object.create(WrapperObject.prototype);
        Status.prototype.constructor = Status;
        Status.prototype.__class__ = Status;
        Status.__cache__ = {};
        Module["Status"] = Status;
        Status.prototype["code"] = Status.prototype.code = function () { var self = this.ptr; return _emscripten_bind_Status_code_0(self); };
        Status.prototype["ok"] = Status.prototype.ok = function () { var self = this.ptr; return !!_emscripten_bind_Status_ok_0(self); };
        Status.prototype["error_msg"] = Status.prototype.error_msg = function () { var self = this.ptr; return UTF8ToString(_emscripten_bind_Status_error_msg_0(self)); };
        Status.prototype["__destroy__"] = Status.prototype.__destroy__ = function () { var self = this.ptr; _emscripten_bind_Status___destroy___0(self); };
        function DracoFloat32Array() { this.ptr = _emscripten_bind_DracoFloat32Array_DracoFloat32Array_0(); getCache(DracoFloat32Array)[this.ptr] = this; }
        DracoFloat32Array.prototype = Object.create(WrapperObject.prototype);
        DracoFloat32Array.prototype.constructor = DracoFloat32Array;
        DracoFloat32Array.prototype.__class__ = DracoFloat32Array;
        DracoFloat32Array.__cache__ = {};
        Module["DracoFloat32Array"] = DracoFloat32Array;
        DracoFloat32Array.prototype["GetValue"] = DracoFloat32Array.prototype.GetValue = function (index) { var self = this.ptr; if (index && typeof index === "object")
            index = index.ptr; return _emscripten_bind_DracoFloat32Array_GetValue_1(self, index); };
        DracoFloat32Array.prototype["size"] = DracoFloat32Array.prototype.size = function () { var self = this.ptr; return _emscripten_bind_DracoFloat32Array_size_0(self); };
        DracoFloat32Array.prototype["__destroy__"] = DracoFloat32Array.prototype.__destroy__ = function () { var self = this.ptr; _emscripten_bind_DracoFloat32Array___destroy___0(self); };
        function DracoInt8Array() { this.ptr = _emscripten_bind_DracoInt8Array_DracoInt8Array_0(); getCache(DracoInt8Array)[this.ptr] = this; }
        DracoInt8Array.prototype = Object.create(WrapperObject.prototype);
        DracoInt8Array.prototype.constructor = DracoInt8Array;
        DracoInt8Array.prototype.__class__ = DracoInt8Array;
        DracoInt8Array.__cache__ = {};
        Module["DracoInt8Array"] = DracoInt8Array;
        DracoInt8Array.prototype["GetValue"] = DracoInt8Array.prototype.GetValue = function (index) { var self = this.ptr; if (index && typeof index === "object")
            index = index.ptr; return _emscripten_bind_DracoInt8Array_GetValue_1(self, index); };
        DracoInt8Array.prototype["size"] = DracoInt8Array.prototype.size = function () { var self = this.ptr; return _emscripten_bind_DracoInt8Array_size_0(self); };
        DracoInt8Array.prototype["__destroy__"] = DracoInt8Array.prototype.__destroy__ = function () { var self = this.ptr; _emscripten_bind_DracoInt8Array___destroy___0(self); };
        function DracoUInt8Array() { this.ptr = _emscripten_bind_DracoUInt8Array_DracoUInt8Array_0(); getCache(DracoUInt8Array)[this.ptr] = this; }
        DracoUInt8Array.prototype = Object.create(WrapperObject.prototype);
        DracoUInt8Array.prototype.constructor = DracoUInt8Array;
        DracoUInt8Array.prototype.__class__ = DracoUInt8Array;
        DracoUInt8Array.__cache__ = {};
        Module["DracoUInt8Array"] = DracoUInt8Array;
        DracoUInt8Array.prototype["GetValue"] = DracoUInt8Array.prototype.GetValue = function (index) { var self = this.ptr; if (index && typeof index === "object")
            index = index.ptr; return _emscripten_bind_DracoUInt8Array_GetValue_1(self, index); };
        DracoUInt8Array.prototype["size"] = DracoUInt8Array.prototype.size = function () { var self = this.ptr; return _emscripten_bind_DracoUInt8Array_size_0(self); };
        DracoUInt8Array.prototype["__destroy__"] = DracoUInt8Array.prototype.__destroy__ = function () { var self = this.ptr; _emscripten_bind_DracoUInt8Array___destroy___0(self); };
        function DracoInt16Array() { this.ptr = _emscripten_bind_DracoInt16Array_DracoInt16Array_0(); getCache(DracoInt16Array)[this.ptr] = this; }
        DracoInt16Array.prototype = Object.create(WrapperObject.prototype);
        DracoInt16Array.prototype.constructor = DracoInt16Array;
        DracoInt16Array.prototype.__class__ = DracoInt16Array;
        DracoInt16Array.__cache__ = {};
        Module["DracoInt16Array"] = DracoInt16Array;
        DracoInt16Array.prototype["GetValue"] = DracoInt16Array.prototype.GetValue = function (index) { var self = this.ptr; if (index && typeof index === "object")
            index = index.ptr; return _emscripten_bind_DracoInt16Array_GetValue_1(self, index); };
        DracoInt16Array.prototype["size"] = DracoInt16Array.prototype.size = function () { var self = this.ptr; return _emscripten_bind_DracoInt16Array_size_0(self); };
        DracoInt16Array.prototype["__destroy__"] = DracoInt16Array.prototype.__destroy__ = function () { var self = this.ptr; _emscripten_bind_DracoInt16Array___destroy___0(self); };
        function DracoUInt16Array() { this.ptr = _emscripten_bind_DracoUInt16Array_DracoUInt16Array_0(); getCache(DracoUInt16Array)[this.ptr] = this; }
        DracoUInt16Array.prototype = Object.create(WrapperObject.prototype);
        DracoUInt16Array.prototype.constructor = DracoUInt16Array;
        DracoUInt16Array.prototype.__class__ = DracoUInt16Array;
        DracoUInt16Array.__cache__ = {};
        Module["DracoUInt16Array"] = DracoUInt16Array;
        DracoUInt16Array.prototype["GetValue"] = DracoUInt16Array.prototype.GetValue = function (index) { var self = this.ptr; if (index && typeof index === "object")
            index = index.ptr; return _emscripten_bind_DracoUInt16Array_GetValue_1(self, index); };
        DracoUInt16Array.prototype["size"] = DracoUInt16Array.prototype.size = function () { var self = this.ptr; return _emscripten_bind_DracoUInt16Array_size_0(self); };
        DracoUInt16Array.prototype["__destroy__"] = DracoUInt16Array.prototype.__destroy__ = function () { var self = this.ptr; _emscripten_bind_DracoUInt16Array___destroy___0(self); };
        function DracoInt32Array() { this.ptr = _emscripten_bind_DracoInt32Array_DracoInt32Array_0(); getCache(DracoInt32Array)[this.ptr] = this; }
        DracoInt32Array.prototype = Object.create(WrapperObject.prototype);
        DracoInt32Array.prototype.constructor = DracoInt32Array;
        DracoInt32Array.prototype.__class__ = DracoInt32Array;
        DracoInt32Array.__cache__ = {};
        Module["DracoInt32Array"] = DracoInt32Array;
        DracoInt32Array.prototype["GetValue"] = DracoInt32Array.prototype.GetValue = function (index) { var self = this.ptr; if (index && typeof index === "object")
            index = index.ptr; return _emscripten_bind_DracoInt32Array_GetValue_1(self, index); };
        DracoInt32Array.prototype["size"] = DracoInt32Array.prototype.size = function () { var self = this.ptr; return _emscripten_bind_DracoInt32Array_size_0(self); };
        DracoInt32Array.prototype["__destroy__"] = DracoInt32Array.prototype.__destroy__ = function () { var self = this.ptr; _emscripten_bind_DracoInt32Array___destroy___0(self); };
        function DracoUInt32Array() { this.ptr = _emscripten_bind_DracoUInt32Array_DracoUInt32Array_0(); getCache(DracoUInt32Array)[this.ptr] = this; }
        DracoUInt32Array.prototype = Object.create(WrapperObject.prototype);
        DracoUInt32Array.prototype.constructor = DracoUInt32Array;
        DracoUInt32Array.prototype.__class__ = DracoUInt32Array;
        DracoUInt32Array.__cache__ = {};
        Module["DracoUInt32Array"] = DracoUInt32Array;
        DracoUInt32Array.prototype["GetValue"] = DracoUInt32Array.prototype.GetValue = function (index) { var self = this.ptr; if (index && typeof index === "object")
            index = index.ptr; return _emscripten_bind_DracoUInt32Array_GetValue_1(self, index); };
        DracoUInt32Array.prototype["size"] = DracoUInt32Array.prototype.size = function () { var self = this.ptr; return _emscripten_bind_DracoUInt32Array_size_0(self); };
        DracoUInt32Array.prototype["__destroy__"] = DracoUInt32Array.prototype.__destroy__ = function () { var self = this.ptr; _emscripten_bind_DracoUInt32Array___destroy___0(self); };
        function MetadataQuerier() { this.ptr = _emscripten_bind_MetadataQuerier_MetadataQuerier_0(); getCache(MetadataQuerier)[this.ptr] = this; }
        MetadataQuerier.prototype = Object.create(WrapperObject.prototype);
        MetadataQuerier.prototype.constructor = MetadataQuerier;
        MetadataQuerier.prototype.__class__ = MetadataQuerier;
        MetadataQuerier.__cache__ = {};
        Module["MetadataQuerier"] = MetadataQuerier;
        MetadataQuerier.prototype["HasEntry"] = MetadataQuerier.prototype.HasEntry = function (metadata, entry_name) { var self = this.ptr; ensureCache.prepare(); if (metadata && typeof metadata === "object")
            metadata = metadata.ptr; if (entry_name && typeof entry_name === "object")
            entry_name = entry_name.ptr;
        else
            entry_name = ensureString(entry_name); return !!_emscripten_bind_MetadataQuerier_HasEntry_2(self, metadata, entry_name); };
        MetadataQuerier.prototype["GetIntEntry"] = MetadataQuerier.prototype.GetIntEntry = function (metadata, entry_name) { var self = this.ptr; ensureCache.prepare(); if (metadata && typeof metadata === "object")
            metadata = metadata.ptr; if (entry_name && typeof entry_name === "object")
            entry_name = entry_name.ptr;
        else
            entry_name = ensureString(entry_name); return _emscripten_bind_MetadataQuerier_GetIntEntry_2(self, metadata, entry_name); };
        MetadataQuerier.prototype["GetIntEntryArray"] = MetadataQuerier.prototype.GetIntEntryArray = function (metadata, entry_name, out_values) { var self = this.ptr; ensureCache.prepare(); if (metadata && typeof metadata === "object")
            metadata = metadata.ptr; if (entry_name && typeof entry_name === "object")
            entry_name = entry_name.ptr;
        else
            entry_name = ensureString(entry_name); if (out_values && typeof out_values === "object")
            out_values = out_values.ptr; _emscripten_bind_MetadataQuerier_GetIntEntryArray_3(self, metadata, entry_name, out_values); };
        MetadataQuerier.prototype["GetDoubleEntry"] = MetadataQuerier.prototype.GetDoubleEntry = function (metadata, entry_name) { var self = this.ptr; ensureCache.prepare(); if (metadata && typeof metadata === "object")
            metadata = metadata.ptr; if (entry_name && typeof entry_name === "object")
            entry_name = entry_name.ptr;
        else
            entry_name = ensureString(entry_name); return _emscripten_bind_MetadataQuerier_GetDoubleEntry_2(self, metadata, entry_name); };
        MetadataQuerier.prototype["GetStringEntry"] = MetadataQuerier.prototype.GetStringEntry = function (metadata, entry_name) { var self = this.ptr; ensureCache.prepare(); if (metadata && typeof metadata === "object")
            metadata = metadata.ptr; if (entry_name && typeof entry_name === "object")
            entry_name = entry_name.ptr;
        else
            entry_name = ensureString(entry_name); return UTF8ToString(_emscripten_bind_MetadataQuerier_GetStringEntry_2(self, metadata, entry_name)); };
        MetadataQuerier.prototype["NumEntries"] = MetadataQuerier.prototype.NumEntries = function (metadata) { var self = this.ptr; if (metadata && typeof metadata === "object")
            metadata = metadata.ptr; return _emscripten_bind_MetadataQuerier_NumEntries_1(self, metadata); };
        MetadataQuerier.prototype["GetEntryName"] = MetadataQuerier.prototype.GetEntryName = function (metadata, entry_id) { var self = this.ptr; if (metadata && typeof metadata === "object")
            metadata = metadata.ptr; if (entry_id && typeof entry_id === "object")
            entry_id = entry_id.ptr; return UTF8ToString(_emscripten_bind_MetadataQuerier_GetEntryName_2(self, metadata, entry_id)); };
        MetadataQuerier.prototype["__destroy__"] = MetadataQuerier.prototype.__destroy__ = function () { var self = this.ptr; _emscripten_bind_MetadataQuerier___destroy___0(self); };
        function Decoder() { this.ptr = _emscripten_bind_Decoder_Decoder_0(); getCache(Decoder)[this.ptr] = this; }
        Decoder.prototype = Object.create(WrapperObject.prototype);
        Decoder.prototype.constructor = Decoder;
        Decoder.prototype.__class__ = Decoder;
        Decoder.__cache__ = {};
        Module["Decoder"] = Decoder;
        Decoder.prototype["DecodeArrayToPointCloud"] = Decoder.prototype.DecodeArrayToPointCloud = function (data, data_size, out_point_cloud) { var self = this.ptr; ensureCache.prepare(); if (typeof data == "object") {
            data = ensureInt8(data);
        } if (data_size && typeof data_size === "object")
            data_size = data_size.ptr; if (out_point_cloud && typeof out_point_cloud === "object")
            out_point_cloud = out_point_cloud.ptr; return wrapPointer(_emscripten_bind_Decoder_DecodeArrayToPointCloud_3(self, data, data_size, out_point_cloud), Status); };
        Decoder.prototype["DecodeArrayToMesh"] = Decoder.prototype.DecodeArrayToMesh = function (data, data_size, out_mesh) { var self = this.ptr; ensureCache.prepare(); if (typeof data == "object") {
            data = ensureInt8(data);
        } if (data_size && typeof data_size === "object")
            data_size = data_size.ptr; if (out_mesh && typeof out_mesh === "object")
            out_mesh = out_mesh.ptr; return wrapPointer(_emscripten_bind_Decoder_DecodeArrayToMesh_3(self, data, data_size, out_mesh), Status); };
        Decoder.prototype["GetAttributeId"] = Decoder.prototype.GetAttributeId = function (pc, type) { var self = this.ptr; if (pc && typeof pc === "object")
            pc = pc.ptr; if (type && typeof type === "object")
            type = type.ptr; return _emscripten_bind_Decoder_GetAttributeId_2(self, pc, type); };
        Decoder.prototype["GetAttributeIdByName"] = Decoder.prototype.GetAttributeIdByName = function (pc, name) { var self = this.ptr; ensureCache.prepare(); if (pc && typeof pc === "object")
            pc = pc.ptr; if (name && typeof name === "object")
            name = name.ptr;
        else
            name = ensureString(name); return _emscripten_bind_Decoder_GetAttributeIdByName_2(self, pc, name); };
        Decoder.prototype["GetAttributeIdByMetadataEntry"] = Decoder.prototype.GetAttributeIdByMetadataEntry = function (pc, name, value) { var self = this.ptr; ensureCache.prepare(); if (pc && typeof pc === "object")
            pc = pc.ptr; if (name && typeof name === "object")
            name = name.ptr;
        else
            name = ensureString(name); if (value && typeof value === "object")
            value = value.ptr;
        else
            value = ensureString(value); return _emscripten_bind_Decoder_GetAttributeIdByMetadataEntry_3(self, pc, name, value); };
        Decoder.prototype["GetAttribute"] = Decoder.prototype.GetAttribute = function (pc, att_id) { var self = this.ptr; if (pc && typeof pc === "object")
            pc = pc.ptr; if (att_id && typeof att_id === "object")
            att_id = att_id.ptr; return wrapPointer(_emscripten_bind_Decoder_GetAttribute_2(self, pc, att_id), PointAttribute); };
        Decoder.prototype["GetAttributeByUniqueId"] = Decoder.prototype.GetAttributeByUniqueId = function (pc, unique_id) { var self = this.ptr; if (pc && typeof pc === "object")
            pc = pc.ptr; if (unique_id && typeof unique_id === "object")
            unique_id = unique_id.ptr; return wrapPointer(_emscripten_bind_Decoder_GetAttributeByUniqueId_2(self, pc, unique_id), PointAttribute); };
        Decoder.prototype["GetMetadata"] = Decoder.prototype.GetMetadata = function (pc) { var self = this.ptr; if (pc && typeof pc === "object")
            pc = pc.ptr; return wrapPointer(_emscripten_bind_Decoder_GetMetadata_1(self, pc), Metadata); };
        Decoder.prototype["GetAttributeMetadata"] = Decoder.prototype.GetAttributeMetadata = function (pc, att_id) { var self = this.ptr; if (pc && typeof pc === "object")
            pc = pc.ptr; if (att_id && typeof att_id === "object")
            att_id = att_id.ptr; return wrapPointer(_emscripten_bind_Decoder_GetAttributeMetadata_2(self, pc, att_id), Metadata); };
        Decoder.prototype["GetFaceFromMesh"] = Decoder.prototype.GetFaceFromMesh = function (m, face_id, out_values) { var self = this.ptr; if (m && typeof m === "object")
            m = m.ptr; if (face_id && typeof face_id === "object")
            face_id = face_id.ptr; if (out_values && typeof out_values === "object")
            out_values = out_values.ptr; return !!_emscripten_bind_Decoder_GetFaceFromMesh_3(self, m, face_id, out_values); };
        Decoder.prototype["GetTriangleStripsFromMesh"] = Decoder.prototype.GetTriangleStripsFromMesh = function (m, strip_values) { var self = this.ptr; if (m && typeof m === "object")
            m = m.ptr; if (strip_values && typeof strip_values === "object")
            strip_values = strip_values.ptr; return _emscripten_bind_Decoder_GetTriangleStripsFromMesh_2(self, m, strip_values); };
        Decoder.prototype["GetTrianglesUInt16Array"] = Decoder.prototype.GetTrianglesUInt16Array = function (m, out_size, out_values) { var self = this.ptr; if (m && typeof m === "object")
            m = m.ptr; if (out_size && typeof out_size === "object")
            out_size = out_size.ptr; if (out_values && typeof out_values === "object")
            out_values = out_values.ptr; return !!_emscripten_bind_Decoder_GetTrianglesUInt16Array_3(self, m, out_size, out_values); };
        Decoder.prototype["GetTrianglesUInt32Array"] = Decoder.prototype.GetTrianglesUInt32Array = function (m, out_size, out_values) { var self = this.ptr; if (m && typeof m === "object")
            m = m.ptr; if (out_size && typeof out_size === "object")
            out_size = out_size.ptr; if (out_values && typeof out_values === "object")
            out_values = out_values.ptr; return !!_emscripten_bind_Decoder_GetTrianglesUInt32Array_3(self, m, out_size, out_values); };
        Decoder.prototype["GetAttributeFloat"] = Decoder.prototype.GetAttributeFloat = function (pa, att_index, out_values) { var self = this.ptr; if (pa && typeof pa === "object")
            pa = pa.ptr; if (att_index && typeof att_index === "object")
            att_index = att_index.ptr; if (out_values && typeof out_values === "object")
            out_values = out_values.ptr; return !!_emscripten_bind_Decoder_GetAttributeFloat_3(self, pa, att_index, out_values); };
        Decoder.prototype["GetAttributeFloatForAllPoints"] = Decoder.prototype.GetAttributeFloatForAllPoints = function (pc, pa, out_values) { var self = this.ptr; if (pc && typeof pc === "object")
            pc = pc.ptr; if (pa && typeof pa === "object")
            pa = pa.ptr; if (out_values && typeof out_values === "object")
            out_values = out_values.ptr; return !!_emscripten_bind_Decoder_GetAttributeFloatForAllPoints_3(self, pc, pa, out_values); };
        Decoder.prototype["GetAttributeIntForAllPoints"] = Decoder.prototype.GetAttributeIntForAllPoints = function (pc, pa, out_values) { var self = this.ptr; if (pc && typeof pc === "object")
            pc = pc.ptr; if (pa && typeof pa === "object")
            pa = pa.ptr; if (out_values && typeof out_values === "object")
            out_values = out_values.ptr; return !!_emscripten_bind_Decoder_GetAttributeIntForAllPoints_3(self, pc, pa, out_values); };
        Decoder.prototype["GetAttributeInt8ForAllPoints"] = Decoder.prototype.GetAttributeInt8ForAllPoints = function (pc, pa, out_values) { var self = this.ptr; if (pc && typeof pc === "object")
            pc = pc.ptr; if (pa && typeof pa === "object")
            pa = pa.ptr; if (out_values && typeof out_values === "object")
            out_values = out_values.ptr; return !!_emscripten_bind_Decoder_GetAttributeInt8ForAllPoints_3(self, pc, pa, out_values); };
        Decoder.prototype["GetAttributeUInt8ForAllPoints"] = Decoder.prototype.GetAttributeUInt8ForAllPoints = function (pc, pa, out_values) { var self = this.ptr; if (pc && typeof pc === "object")
            pc = pc.ptr; if (pa && typeof pa === "object")
            pa = pa.ptr; if (out_values && typeof out_values === "object")
            out_values = out_values.ptr; return !!_emscripten_bind_Decoder_GetAttributeUInt8ForAllPoints_3(self, pc, pa, out_values); };
        Decoder.prototype["GetAttributeInt16ForAllPoints"] = Decoder.prototype.GetAttributeInt16ForAllPoints = function (pc, pa, out_values) { var self = this.ptr; if (pc && typeof pc === "object")
            pc = pc.ptr; if (pa && typeof pa === "object")
            pa = pa.ptr; if (out_values && typeof out_values === "object")
            out_values = out_values.ptr; return !!_emscripten_bind_Decoder_GetAttributeInt16ForAllPoints_3(self, pc, pa, out_values); };
        Decoder.prototype["GetAttributeUInt16ForAllPoints"] = Decoder.prototype.GetAttributeUInt16ForAllPoints = function (pc, pa, out_values) { var self = this.ptr; if (pc && typeof pc === "object")
            pc = pc.ptr; if (pa && typeof pa === "object")
            pa = pa.ptr; if (out_values && typeof out_values === "object")
            out_values = out_values.ptr; return !!_emscripten_bind_Decoder_GetAttributeUInt16ForAllPoints_3(self, pc, pa, out_values); };
        Decoder.prototype["GetAttributeInt32ForAllPoints"] = Decoder.prototype.GetAttributeInt32ForAllPoints = function (pc, pa, out_values) { var self = this.ptr; if (pc && typeof pc === "object")
            pc = pc.ptr; if (pa && typeof pa === "object")
            pa = pa.ptr; if (out_values && typeof out_values === "object")
            out_values = out_values.ptr; return !!_emscripten_bind_Decoder_GetAttributeInt32ForAllPoints_3(self, pc, pa, out_values); };
        Decoder.prototype["GetAttributeUInt32ForAllPoints"] = Decoder.prototype.GetAttributeUInt32ForAllPoints = function (pc, pa, out_values) { var self = this.ptr; if (pc && typeof pc === "object")
            pc = pc.ptr; if (pa && typeof pa === "object")
            pa = pa.ptr; if (out_values && typeof out_values === "object")
            out_values = out_values.ptr; return !!_emscripten_bind_Decoder_GetAttributeUInt32ForAllPoints_3(self, pc, pa, out_values); };
        Decoder.prototype["GetAttributeDataArrayForAllPoints"] = Decoder.prototype.GetAttributeDataArrayForAllPoints = function (pc, pa, data_type, out_size, out_values) { var self = this.ptr; if (pc && typeof pc === "object")
            pc = pc.ptr; if (pa && typeof pa === "object")
            pa = pa.ptr; if (data_type && typeof data_type === "object")
            data_type = data_type.ptr; if (out_size && typeof out_size === "object")
            out_size = out_size.ptr; if (out_values && typeof out_values === "object")
            out_values = out_values.ptr; return !!_emscripten_bind_Decoder_GetAttributeDataArrayForAllPoints_5(self, pc, pa, data_type, out_size, out_values); };
        Decoder.prototype["SkipAttributeTransform"] = Decoder.prototype.SkipAttributeTransform = function (att_type) { var self = this.ptr; if (att_type && typeof att_type === "object")
            att_type = att_type.ptr; _emscripten_bind_Decoder_SkipAttributeTransform_1(self, att_type); };
        Decoder.prototype["GetEncodedGeometryType_Deprecated"] = Decoder.prototype.GetEncodedGeometryType_Deprecated = function (in_buffer) { var self = this.ptr; if (in_buffer && typeof in_buffer === "object")
            in_buffer = in_buffer.ptr; return _emscripten_bind_Decoder_GetEncodedGeometryType_Deprecated_1(self, in_buffer); };
        Decoder.prototype["DecodeBufferToPointCloud"] = Decoder.prototype.DecodeBufferToPointCloud = function (in_buffer, out_point_cloud) { var self = this.ptr; if (in_buffer && typeof in_buffer === "object")
            in_buffer = in_buffer.ptr; if (out_point_cloud && typeof out_point_cloud === "object")
            out_point_cloud = out_point_cloud.ptr; return wrapPointer(_emscripten_bind_Decoder_DecodeBufferToPointCloud_2(self, in_buffer, out_point_cloud), Status); };
        Decoder.prototype["DecodeBufferToMesh"] = Decoder.prototype.DecodeBufferToMesh = function (in_buffer, out_mesh) { var self = this.ptr; if (in_buffer && typeof in_buffer === "object")
            in_buffer = in_buffer.ptr; if (out_mesh && typeof out_mesh === "object")
            out_mesh = out_mesh.ptr; return wrapPointer(_emscripten_bind_Decoder_DecodeBufferToMesh_2(self, in_buffer, out_mesh), Status); };
        Decoder.prototype["__destroy__"] = Decoder.prototype.__destroy__ = function () { var self = this.ptr; _emscripten_bind_Decoder___destroy___0(self); };
        (function () { function setupEnums() { Module["ATTRIBUTE_INVALID_TRANSFORM"] = _emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_INVALID_TRANSFORM(); Module["ATTRIBUTE_NO_TRANSFORM"] = _emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_NO_TRANSFORM(); Module["ATTRIBUTE_QUANTIZATION_TRANSFORM"] = _emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_QUANTIZATION_TRANSFORM(); Module["ATTRIBUTE_OCTAHEDRON_TRANSFORM"] = _emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_OCTAHEDRON_TRANSFORM(); Module["INVALID"] = _emscripten_enum_draco_GeometryAttribute_Type_INVALID(); Module["POSITION"] = _emscripten_enum_draco_GeometryAttribute_Type_POSITION(); Module["NORMAL"] = _emscripten_enum_draco_GeometryAttribute_Type_NORMAL(); Module["COLOR"] = _emscripten_enum_draco_GeometryAttribute_Type_COLOR(); Module["TEX_COORD"] = _emscripten_enum_draco_GeometryAttribute_Type_TEX_COORD(); Module["GENERIC"] = _emscripten_enum_draco_GeometryAttribute_Type_GENERIC(); Module["INVALID_GEOMETRY_TYPE"] = _emscripten_enum_draco_EncodedGeometryType_INVALID_GEOMETRY_TYPE(); Module["POINT_CLOUD"] = _emscripten_enum_draco_EncodedGeometryType_POINT_CLOUD(); Module["TRIANGULAR_MESH"] = _emscripten_enum_draco_EncodedGeometryType_TRIANGULAR_MESH(); Module["DT_INVALID"] = _emscripten_enum_draco_DataType_DT_INVALID(); Module["DT_INT8"] = _emscripten_enum_draco_DataType_DT_INT8(); Module["DT_UINT8"] = _emscripten_enum_draco_DataType_DT_UINT8(); Module["DT_INT16"] = _emscripten_enum_draco_DataType_DT_INT16(); Module["DT_UINT16"] = _emscripten_enum_draco_DataType_DT_UINT16(); Module["DT_INT32"] = _emscripten_enum_draco_DataType_DT_INT32(); Module["DT_UINT32"] = _emscripten_enum_draco_DataType_DT_UINT32(); Module["DT_INT64"] = _emscripten_enum_draco_DataType_DT_INT64(); Module["DT_UINT64"] = _emscripten_enum_draco_DataType_DT_UINT64(); Module["DT_FLOAT32"] = _emscripten_enum_draco_DataType_DT_FLOAT32(); Module["DT_FLOAT64"] = _emscripten_enum_draco_DataType_DT_FLOAT64(); Module["DT_BOOL"] = _emscripten_enum_draco_DataType_DT_BOOL(); Module["DT_TYPES_COUNT"] = _emscripten_enum_draco_DataType_DT_TYPES_COUNT(); Module["OK"] = _emscripten_enum_draco_StatusCode_OK(); Module["DRACO_ERROR"] = _emscripten_enum_draco_StatusCode_DRACO_ERROR(); Module["IO_ERROR"] = _emscripten_enum_draco_StatusCode_IO_ERROR(); Module["INVALID_PARAMETER"] = _emscripten_enum_draco_StatusCode_INVALID_PARAMETER(); Module["UNSUPPORTED_VERSION"] = _emscripten_enum_draco_StatusCode_UNSUPPORTED_VERSION(); Module["UNKNOWN_VERSION"] = _emscripten_enum_draco_StatusCode_UNKNOWN_VERSION(); } if (runtimeInitialized)
            setupEnums();
        else
            addOnInit(setupEnums); })();
        if (typeof Module["onModuleParsed"] === "function") {
            Module["onModuleParsed"]();
        }
        Module["Decoder"].prototype.GetEncodedGeometryType = function (array) { if (array.__class__ && array.__class__ === Module.DecoderBuffer) {
            return Module.Decoder.prototype.GetEncodedGeometryType_Deprecated(array);
        } if (array.byteLength < 8)
            return Module.INVALID_GEOMETRY_TYPE; switch (array[7]) {
            case 0: return Module.POINT_CLOUD;
            case 1: return Module.TRIANGULAR_MESH;
            default: return Module.INVALID_GEOMETRY_TYPE;
        } };
        return DracoDecoderModule.ready;
    });
})();
if (typeof exports === 'object' && typeof module === 'object')
    module.exports = DracoDecoderModule;
else if (typeof define === 'function' && define['amd'])
    define([], function () { return DracoDecoderModule; });
else if (typeof exports === 'object')
    exports["DracoDecoderModule"] = DracoDecoderModule;
//# sourceMappingURL=draco_decoder.js.map